
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireea69"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireea69"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dBs8J", function(module, exports) {
"use strict";
function $9e748f0e7cb702a5$var$Vnode(tag, key, attrs, children, text, dom) {
    return {
        tag: tag,
        key: key,
        attrs: attrs,
        children: children,
        text: text,
        dom: dom,
        domSize: undefined,
        state: undefined,
        events: undefined,
        instance: undefined
    };
}
$9e748f0e7cb702a5$var$Vnode.normalize = function(node) {
    if (Array.isArray(node)) return $9e748f0e7cb702a5$var$Vnode("[", undefined, undefined, $9e748f0e7cb702a5$var$Vnode.normalizeChildren(node), undefined, undefined);
    if (node == null || typeof node === "boolean") return null;
    if (typeof node === "object") return node;
    return $9e748f0e7cb702a5$var$Vnode("#", undefined, undefined, String(node), undefined, undefined);
};
$9e748f0e7cb702a5$var$Vnode.normalizeChildren = function(input) {
    var children = [];
    if (input.length) {
        var isKeyed = input[0] != null && input[0].key != null;
        // Note: this is a *very* perf-sensitive check.
        // Fun fact: merging the loop like this is somehow faster than splitting
        // it, noticeably so.
        for(var i = 1; i < input.length; i++){
            if ((input[i] != null && input[i].key != null) !== isKeyed) throw new TypeError(isKeyed && (input[i] != null || typeof input[i] === "boolean") ? "In fragments, vnodes must either all have keys or none have keys. You may wish to consider using an explicit keyed empty fragment, m.fragment({key: ...}), instead of a hole." : "In fragments, vnodes must either all have keys or none have keys.");
        }
        for(var i = 0; i < input.length; i++)children[i] = $9e748f0e7cb702a5$var$Vnode.normalize(input[i]);
    }
    return children;
};
module.exports = $9e748f0e7cb702a5$var$Vnode;

});

parcelRegister("e2F9W", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");
module.exports = function(html) {
    if (html == null) html = "";
    return $dBs8J("<", undefined, undefined, html, undefined, undefined);
};

});

parcelRegister("7PZrX", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");

var $5sRXF = parcelRequire("5sRXF");
module.exports = function() {
    var vnode = $5sRXF.apply(0, arguments);
    vnode.tag = "[";
    vnode.children = $dBs8J.normalizeChildren(vnode.children);
    return vnode;
};

});
parcelRegister("5sRXF", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");
// Call via `hyperscriptVnode.apply(startOffset, arguments)`
//
// The reason I do it this way, forwarding the arguments and passing the start
// offset in `this`, is so I don't have to create a temporary array in a
// performance-critical path.
//
// In native ES6, I'd instead add a final `...args` parameter to the
// `hyperscript` and `fragment` factories and define this as
// `hyperscriptVnode(...args)`, since modern engines do optimize that away. But
// ES5 (what Mithril.js requires thanks to IE support) doesn't give me that luxury,
// and engines aren't nearly intelligent enough to do either of these:
//
// 1. Elide the allocation for `[].slice.call(arguments, 1)` when it's passed to
//    another function only to be indexed.
// 2. Elide an `arguments` allocation when it's passed to any function other
//    than `Function.prototype.apply` or `Reflect.apply`.
//
// In ES6, it'd probably look closer to this (I'd need to profile it, though):
// module.exports = function(attrs, ...children) {
//     if (attrs == null || typeof attrs === "object" && attrs.tag == null && !Array.isArray(attrs)) {
//         if (children.length === 1 && Array.isArray(children[0])) children = children[0]
//     } else {
//         children = children.length === 0 && Array.isArray(attrs) ? attrs : [attrs, ...children]
//         attrs = undefined
//     }
//
//     if (attrs == null) attrs = {}
//     return Vnode("", attrs.key, attrs, children)
// }
module.exports = function() {
    var attrs = arguments[this], start = this + 1, children;
    if (attrs == null) attrs = {};
    else if (typeof attrs !== "object" || attrs.tag != null || Array.isArray(attrs)) {
        attrs = {};
        start = this;
    }
    if (arguments.length === start + 1) {
        children = arguments[start];
        if (!Array.isArray(children)) children = [
            children
        ];
    } else {
        children = [];
        while(start < arguments.length)children.push(arguments[start++]);
    }
    return $dBs8J("", attrs.key, attrs, children);
};

});


parcelRegister("k7iQv", function(module, exports) {
"use strict";
/** @constructor */ var $ea53147a45dc1bd2$var$PromisePolyfill = function(executor) {
    if (!(this instanceof $ea53147a45dc1bd2$var$PromisePolyfill)) throw new Error("Promise must be called with 'new'.");
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var self = this, resolvers = [], rejectors = [], resolveCurrent = handler(resolvers, true), rejectCurrent = handler(rejectors, false);
    var instance = self._instance = {
        resolvers: resolvers,
        rejectors: rejectors
    };
    var callAsync = typeof setImmediate === "function" ? setImmediate : setTimeout;
    function handler(list, shouldAbsorb) {
        return function execute(value) {
            var then;
            try {
                if (shouldAbsorb && value != null && (typeof value === "object" || typeof value === "function") && typeof (then = value.then) === "function") {
                    if (value === self) throw new TypeError("Promise can't be resolved with itself.");
                    executeOnce(then.bind(value));
                } else callAsync(function() {
                    if (!shouldAbsorb && list.length === 0) console.error("Possible unhandled promise rejection:", value);
                    for(var i = 0; i < list.length; i++)list[i](value);
                    resolvers.length = 0, rejectors.length = 0;
                    instance.state = shouldAbsorb;
                    instance.retry = function() {
                        execute(value);
                    };
                });
            } catch (e) {
                rejectCurrent(e);
            }
        };
    }
    function executeOnce(then) {
        var runs = 0;
        function run(fn) {
            return function(value) {
                if (runs++ > 0) return;
                fn(value);
            };
        }
        var onerror = run(rejectCurrent);
        try {
            then(run(resolveCurrent), onerror);
        } catch (e) {
            onerror(e);
        }
    }
    executeOnce(executor);
};
$ea53147a45dc1bd2$var$PromisePolyfill.prototype.then = function(onFulfilled, onRejection) {
    var self = this, instance = self._instance;
    function handle(callback, list, next, state) {
        list.push(function(value) {
            if (typeof callback !== "function") next(value);
            else try {
                resolveNext(callback(value));
            } catch (e) {
                if (rejectNext) rejectNext(e);
            }
        });
        if (typeof instance.retry === "function" && state === instance.state) instance.retry();
    }
    var resolveNext, rejectNext;
    var promise = new $ea53147a45dc1bd2$var$PromisePolyfill(function(resolve, reject) {
        resolveNext = resolve, rejectNext = reject;
    });
    handle(onFulfilled, instance.resolvers, resolveNext, true), handle(onRejection, instance.rejectors, rejectNext, false);
    return promise;
};
$ea53147a45dc1bd2$var$PromisePolyfill.prototype.catch = function(onRejection) {
    return this.then(null, onRejection);
};
$ea53147a45dc1bd2$var$PromisePolyfill.prototype.finally = function(callback) {
    return this.then(function(value) {
        return $ea53147a45dc1bd2$var$PromisePolyfill.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        return $ea53147a45dc1bd2$var$PromisePolyfill.resolve(callback()).then(function() {
            return $ea53147a45dc1bd2$var$PromisePolyfill.reject(reason);
        });
    });
};
$ea53147a45dc1bd2$var$PromisePolyfill.resolve = function(value) {
    if (value instanceof $ea53147a45dc1bd2$var$PromisePolyfill) return value;
    return new $ea53147a45dc1bd2$var$PromisePolyfill(function(resolve) {
        resolve(value);
    });
};
$ea53147a45dc1bd2$var$PromisePolyfill.reject = function(value) {
    return new $ea53147a45dc1bd2$var$PromisePolyfill(function(resolve, reject) {
        reject(value);
    });
};
$ea53147a45dc1bd2$var$PromisePolyfill.all = function(list) {
    return new $ea53147a45dc1bd2$var$PromisePolyfill(function(resolve, reject) {
        var total = list.length, count = 0, values = [];
        if (list.length === 0) resolve([]);
        else for(var i = 0; i < list.length; i++)(function(i) {
            function consume(value) {
                count++;
                values[i] = value;
                if (count === total) resolve(values);
            }
            if (list[i] != null && (typeof list[i] === "object" || typeof list[i] === "function") && typeof list[i].then === "function") list[i].then(consume, reject);
            else consume(list[i]);
        })(i);
    });
};
$ea53147a45dc1bd2$var$PromisePolyfill.race = function(list) {
    return new $ea53147a45dc1bd2$var$PromisePolyfill(function(resolve, reject) {
        for(var i = 0; i < list.length; i++)list[i].then(resolve, reject);
    });
};
module.exports = $ea53147a45dc1bd2$var$PromisePolyfill;

});

parcelRegister("j25vk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6JDlc"))(typeof window !== "undefined" ? window : null);

});
parcelRegister("6JDlc", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");
module.exports = function($window) {
    var $doc = $window && $window.document;
    var currentRedraw;
    var nameSpace = {
        svg: "http://www.w3.org/2000/svg",
        math: "http://www.w3.org/1998/Math/MathML"
    };
    function getNameSpace(vnode) {
        return vnode.attrs && vnode.attrs.xmlns || nameSpace[vnode.tag];
    }
    //sanity check to discourage people from doing `vnode.state = ...`
    function checkState(vnode, original) {
        if (vnode.state !== original) throw new Error("'vnode.state' must not be modified.");
    }
    //Note: the hook is passed as the `this` argument to allow proxying the
    //arguments without requiring a full array allocation to do so. It also
    //takes advantage of the fact the current `vnode` is the first argument in
    //all lifecycle methods.
    function callHook(vnode) {
        var original = vnode.state;
        try {
            return this.apply(original, arguments);
        } finally{
            checkState(vnode, original);
        }
    }
    // IE11 (at least) throws an UnspecifiedError when accessing document.activeElement when
    // inside an iframe. Catch and swallow this error, and heavy-handidly return null.
    function activeElement() {
        try {
            return $doc.activeElement;
        } catch (e) {
            return null;
        }
    }
    //create
    function createNodes(parent, vnodes, start, end, hooks, nextSibling, ns) {
        for(var i = start; i < end; i++){
            var vnode = vnodes[i];
            if (vnode != null) createNode(parent, vnode, hooks, ns, nextSibling);
        }
    }
    function createNode(parent, vnode, hooks, ns, nextSibling) {
        var tag = vnode.tag;
        if (typeof tag === "string") {
            vnode.state = {};
            if (vnode.attrs != null) initLifecycle(vnode.attrs, vnode, hooks);
            switch(tag){
                case "#":
                    createText(parent, vnode, nextSibling);
                    break;
                case "<":
                    createHTML(parent, vnode, ns, nextSibling);
                    break;
                case "[":
                    createFragment(parent, vnode, hooks, ns, nextSibling);
                    break;
                default:
                    createElement(parent, vnode, hooks, ns, nextSibling);
            }
        } else createComponent(parent, vnode, hooks, ns, nextSibling);
    }
    function createText(parent, vnode, nextSibling) {
        vnode.dom = $doc.createTextNode(vnode.children);
        insertNode(parent, vnode.dom, nextSibling);
    }
    var possibleParents = {
        caption: "table",
        thead: "table",
        tbody: "table",
        tfoot: "table",
        tr: "tbody",
        th: "tr",
        td: "tr",
        colgroup: "table",
        col: "colgroup"
    };
    function createHTML(parent, vnode, ns, nextSibling) {
        var match = vnode.children.match(/^\s*?<(\w+)/im) || [];
        // not using the proper parent makes the child element(s) vanish.
        //     var div = document.createElement("div")
        //     div.innerHTML = "<td>i</td><td>j</td>"
        //     console.log(div.innerHTML)
        // --> "ij", no <td> in sight.
        var temp = $doc.createElement(possibleParents[match[1]] || "div");
        if (ns === "http://www.w3.org/2000/svg") {
            temp.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg">' + vnode.children + "</svg>";
            temp = temp.firstChild;
        } else temp.innerHTML = vnode.children;
        vnode.dom = temp.firstChild;
        vnode.domSize = temp.childNodes.length;
        // Capture nodes to remove, so we don't confuse them.
        vnode.instance = [];
        var fragment = $doc.createDocumentFragment();
        var child;
        while(child = temp.firstChild){
            vnode.instance.push(child);
            fragment.appendChild(child);
        }
        insertNode(parent, fragment, nextSibling);
    }
    function createFragment(parent, vnode, hooks, ns, nextSibling) {
        var fragment = $doc.createDocumentFragment();
        if (vnode.children != null) {
            var children = vnode.children;
            createNodes(fragment, children, 0, children.length, hooks, null, ns);
        }
        vnode.dom = fragment.firstChild;
        vnode.domSize = fragment.childNodes.length;
        insertNode(parent, fragment, nextSibling);
    }
    function createElement(parent, vnode, hooks, ns, nextSibling) {
        var tag = vnode.tag;
        var attrs = vnode.attrs;
        var is = attrs && attrs.is;
        ns = getNameSpace(vnode) || ns;
        var element = ns ? is ? $doc.createElementNS(ns, tag, {
            is: is
        }) : $doc.createElementNS(ns, tag) : is ? $doc.createElement(tag, {
            is: is
        }) : $doc.createElement(tag);
        vnode.dom = element;
        if (attrs != null) setAttrs(vnode, attrs, ns);
        insertNode(parent, element, nextSibling);
        if (!maybeSetContentEditable(vnode)) {
            if (vnode.children != null) {
                var children = vnode.children;
                createNodes(element, children, 0, children.length, hooks, null, ns);
                if (vnode.tag === "select" && attrs != null) setLateSelectAttrs(vnode, attrs);
            }
        }
    }
    function initComponent(vnode, hooks) {
        var sentinel;
        if (typeof vnode.tag.view === "function") {
            vnode.state = Object.create(vnode.tag);
            sentinel = vnode.state.view;
            if (sentinel.$$reentrantLock$$ != null) return;
            sentinel.$$reentrantLock$$ = true;
        } else {
            vnode.state = void 0;
            sentinel = vnode.tag;
            if (sentinel.$$reentrantLock$$ != null) return;
            sentinel.$$reentrantLock$$ = true;
            vnode.state = vnode.tag.prototype != null && typeof vnode.tag.prototype.view === "function" ? new vnode.tag(vnode) : vnode.tag(vnode);
        }
        initLifecycle(vnode.state, vnode, hooks);
        if (vnode.attrs != null) initLifecycle(vnode.attrs, vnode, hooks);
        vnode.instance = $dBs8J.normalize(callHook.call(vnode.state.view, vnode));
        if (vnode.instance === vnode) throw Error("A view cannot return the vnode it received as argument");
        sentinel.$$reentrantLock$$ = null;
    }
    function createComponent(parent, vnode, hooks, ns, nextSibling) {
        initComponent(vnode, hooks);
        if (vnode.instance != null) {
            createNode(parent, vnode.instance, hooks, ns, nextSibling);
            vnode.dom = vnode.instance.dom;
            vnode.domSize = vnode.dom != null ? vnode.instance.domSize : 0;
        } else vnode.domSize = 0;
    }
    //update
    /**
	 * @param {Element|Fragment} parent - the parent element
	 * @param {Vnode[] | null} old - the list of vnodes of the last `render()` call for
	 *                               this part of the tree
	 * @param {Vnode[] | null} vnodes - as above, but for the current `render()` call.
	 * @param {Function[]} hooks - an accumulator of post-render hooks (oncreate/onupdate)
	 * @param {Element | null} nextSibling - the next DOM node if we're dealing with a
	 *                                       fragment that is not the last item in its
	 *                                       parent
	 * @param {'svg' | 'math' | String | null} ns) - the current XML namespace, if any
	 * @returns void
	 */ // This function diffs and patches lists of vnodes, both keyed and unkeyed.
    //
    // We will:
    //
    // 1. describe its general structure
    // 2. focus on the diff algorithm optimizations
    // 3. discuss DOM node operations.
    // ## Overview:
    //
    // The updateNodes() function:
    // - deals with trivial cases
    // - determines whether the lists are keyed or unkeyed based on the first non-null node
    //   of each list.
    // - diffs them and patches the DOM if needed (that's the brunt of the code)
    // - manages the leftovers: after diffing, are there:
    //   - old nodes left to remove?
    // 	 - new nodes to insert?
    // 	 deal with them!
    //
    // The lists are only iterated over once, with an exception for the nodes in `old` that
    // are visited in the fourth part of the diff and in the `removeNodes` loop.
    // ## Diffing
    //
    // Reading https://github.com/localvoid/ivi/blob/ddc09d06abaef45248e6133f7040d00d3c6be853/packages/ivi/src/vdom/implementation.ts#L617-L837
    // may be good for context on longest increasing subsequence-based logic for moving nodes.
    //
    // In order to diff keyed lists, one has to
    //
    // 1) match nodes in both lists, per key, and update them accordingly
    // 2) create the nodes present in the new list, but absent in the old one
    // 3) remove the nodes present in the old list, but absent in the new one
    // 4) figure out what nodes in 1) to move in order to minimize the DOM operations.
    //
    // To achieve 1) one can create a dictionary of keys => index (for the old list), then iterate
    // over the new list and for each new vnode, find the corresponding vnode in the old list using
    // the map.
    // 2) is achieved in the same step: if a new node has no corresponding entry in the map, it is new
    // and must be created.
    // For the removals, we actually remove the nodes that have been updated from the old list.
    // The nodes that remain in that list after 1) and 2) have been performed can be safely removed.
    // The fourth step is a bit more complex and relies on the longest increasing subsequence (LIS)
    // algorithm.
    //
    // the longest increasing subsequence is the list of nodes that can remain in place. Imagine going
    // from `1,2,3,4,5` to `4,5,1,2,3` where the numbers are not necessarily the keys, but the indices
    // corresponding to the keyed nodes in the old list (keyed nodes `e,d,c,b,a` => `b,a,e,d,c` would
    //  match the above lists, for example).
    //
    // In there are two increasing subsequences: `4,5` and `1,2,3`, the latter being the longest. We
    // can update those nodes without moving them, and only call `insertNode` on `4` and `5`.
    //
    // @localvoid adapted the algo to also support node deletions and insertions (the `lis` is actually
    // the longest increasing subsequence *of old nodes still present in the new list*).
    //
    // It is a general algorithm that is fireproof in all circumstances, but it requires the allocation
    // and the construction of a `key => oldIndex` map, and three arrays (one with `newIndex => oldIndex`,
    // the `LIS` and a temporary one to create the LIS).
    //
    // So we cheat where we can: if the tails of the lists are identical, they are guaranteed to be part of
    // the LIS and can be updated without moving them.
    //
    // If two nodes are swapped, they are guaranteed not to be part of the LIS, and must be moved (with
    // the exception of the last node if the list is fully reversed).
    //
    // ## Finding the next sibling.
    //
    // `updateNode()` and `createNode()` expect a nextSibling parameter to perform DOM operations.
    // When the list is being traversed top-down, at any index, the DOM nodes up to the previous
    // vnode reflect the content of the new list, whereas the rest of the DOM nodes reflect the old
    // list. The next sibling must be looked for in the old list using `getNextSibling(... oldStart + 1 ...)`.
    //
    // In the other scenarios (swaps, upwards traversal, map-based diff),
    // the new vnodes list is traversed upwards. The DOM nodes at the bottom of the list reflect the
    // bottom part of the new vnodes list, and we can use the `v.dom`  value of the previous node
    // as the next sibling (cached in the `nextSibling` variable).
    // ## DOM node moves
    //
    // In most scenarios `updateNode()` and `createNode()` perform the DOM operations. However,
    // this is not the case if the node moved (second and fourth part of the diff algo). We move
    // the old DOM nodes before updateNode runs because it enables us to use the cached `nextSibling`
    // variable rather than fetching it using `getNextSibling()`.
    //
    // The fourth part of the diff currently inserts nodes unconditionally, leading to issues
    // like #1791 and #1999. We need to be smarter about those situations where adjascent old
    // nodes remain together in the new list in a way that isn't covered by parts one and
    // three of the diff algo.
    function updateNodes(parent, old, vnodes, hooks, nextSibling, ns) {
        if (old === vnodes || old == null && vnodes == null) return;
        else if (old == null || old.length === 0) createNodes(parent, vnodes, 0, vnodes.length, hooks, nextSibling, ns);
        else if (vnodes == null || vnodes.length === 0) removeNodes(parent, old, 0, old.length);
        else {
            var isOldKeyed = old[0] != null && old[0].key != null;
            var isKeyed = vnodes[0] != null && vnodes[0].key != null;
            var start = 0, oldStart = 0;
            if (!isOldKeyed) while(oldStart < old.length && old[oldStart] == null)oldStart++;
            if (!isKeyed) while(start < vnodes.length && vnodes[start] == null)start++;
            if (isOldKeyed !== isKeyed) {
                removeNodes(parent, old, oldStart, old.length);
                createNodes(parent, vnodes, start, vnodes.length, hooks, nextSibling, ns);
            } else if (!isKeyed) {
                // Don't index past the end of either list (causes deopts).
                var commonLength = old.length < vnodes.length ? old.length : vnodes.length;
                // Rewind if necessary to the first non-null index on either side.
                // We could alternatively either explicitly create or remove nodes when `start !== oldStart`
                // but that would be optimizing for sparse lists which are more rare than dense ones.
                start = start < oldStart ? start : oldStart;
                for(; start < commonLength; start++){
                    o = old[start];
                    v = vnodes[start];
                    if (o === v || o == null && v == null) continue;
                    else if (o == null) createNode(parent, v, hooks, ns, getNextSibling(old, start + 1, nextSibling));
                    else if (v == null) removeNode(parent, o);
                    else updateNode(parent, o, v, hooks, getNextSibling(old, start + 1, nextSibling), ns);
                }
                if (old.length > commonLength) removeNodes(parent, old, start, old.length);
                if (vnodes.length > commonLength) createNodes(parent, vnodes, start, vnodes.length, hooks, nextSibling, ns);
            } else {
                // keyed diff
                var oldEnd = old.length - 1, end = vnodes.length - 1, map, o, v, oe, ve, topSibling;
                // bottom-up
                while(oldEnd >= oldStart && end >= start){
                    oe = old[oldEnd];
                    ve = vnodes[end];
                    if (oe.key !== ve.key) break;
                    if (oe !== ve) updateNode(parent, oe, ve, hooks, nextSibling, ns);
                    if (ve.dom != null) nextSibling = ve.dom;
                    oldEnd--, end--;
                }
                // top-down
                while(oldEnd >= oldStart && end >= start){
                    o = old[oldStart];
                    v = vnodes[start];
                    if (o.key !== v.key) break;
                    oldStart++, start++;
                    if (o !== v) updateNode(parent, o, v, hooks, getNextSibling(old, oldStart, nextSibling), ns);
                }
                // swaps and list reversals
                while(oldEnd >= oldStart && end >= start){
                    if (start === end) break;
                    if (o.key !== ve.key || oe.key !== v.key) break;
                    topSibling = getNextSibling(old, oldStart, nextSibling);
                    moveNodes(parent, oe, topSibling);
                    if (oe !== v) updateNode(parent, oe, v, hooks, topSibling, ns);
                    if (++start <= --end) moveNodes(parent, o, nextSibling);
                    if (o !== ve) updateNode(parent, o, ve, hooks, nextSibling, ns);
                    if (ve.dom != null) nextSibling = ve.dom;
                    oldStart++;
                    oldEnd--;
                    oe = old[oldEnd];
                    ve = vnodes[end];
                    o = old[oldStart];
                    v = vnodes[start];
                }
                // bottom up once again
                while(oldEnd >= oldStart && end >= start){
                    if (oe.key !== ve.key) break;
                    if (oe !== ve) updateNode(parent, oe, ve, hooks, nextSibling, ns);
                    if (ve.dom != null) nextSibling = ve.dom;
                    oldEnd--, end--;
                    oe = old[oldEnd];
                    ve = vnodes[end];
                }
                if (start > end) removeNodes(parent, old, oldStart, oldEnd + 1);
                else if (oldStart > oldEnd) createNodes(parent, vnodes, start, end + 1, hooks, nextSibling, ns);
                else {
                    // inspired by ivi https://github.com/ivijs/ivi/ by Boris Kaul
                    var originalNextSibling = nextSibling, vnodesLength = end - start + 1, oldIndices = new Array(vnodesLength), li = 0, i = 0, pos = 2147483647, matched = 0, map, lisIndices;
                    for(i = 0; i < vnodesLength; i++)oldIndices[i] = -1;
                    for(i = end; i >= start; i--){
                        if (map == null) map = getKeyMap(old, oldStart, oldEnd + 1);
                        ve = vnodes[i];
                        var oldIndex = map[ve.key];
                        if (oldIndex != null) {
                            pos = oldIndex < pos ? oldIndex : -1 // becomes -1 if nodes were re-ordered
                            ;
                            oldIndices[i - start] = oldIndex;
                            oe = old[oldIndex];
                            old[oldIndex] = null;
                            if (oe !== ve) updateNode(parent, oe, ve, hooks, nextSibling, ns);
                            if (ve.dom != null) nextSibling = ve.dom;
                            matched++;
                        }
                    }
                    nextSibling = originalNextSibling;
                    if (matched !== oldEnd - oldStart + 1) removeNodes(parent, old, oldStart, oldEnd + 1);
                    if (matched === 0) createNodes(parent, vnodes, start, end + 1, hooks, nextSibling, ns);
                    else {
                        if (pos === -1) {
                            // the indices of the indices of the items that are part of the
                            // longest increasing subsequence in the oldIndices list
                            lisIndices = makeLisIndices(oldIndices);
                            li = lisIndices.length - 1;
                            for(i = end; i >= start; i--){
                                v = vnodes[i];
                                if (oldIndices[i - start] === -1) createNode(parent, v, hooks, ns, nextSibling);
                                else if (lisIndices[li] === i - start) li--;
                                else moveNodes(parent, v, nextSibling);
                                if (v.dom != null) nextSibling = vnodes[i].dom;
                            }
                        } else for(i = end; i >= start; i--){
                            v = vnodes[i];
                            if (oldIndices[i - start] === -1) createNode(parent, v, hooks, ns, nextSibling);
                            if (v.dom != null) nextSibling = vnodes[i].dom;
                        }
                    }
                }
            }
        }
    }
    function updateNode(parent, old, vnode, hooks, nextSibling, ns) {
        var oldTag = old.tag, tag = vnode.tag;
        if (oldTag === tag) {
            vnode.state = old.state;
            vnode.events = old.events;
            if (shouldNotUpdate(vnode, old)) return;
            if (typeof oldTag === "string") {
                if (vnode.attrs != null) updateLifecycle(vnode.attrs, vnode, hooks);
                switch(oldTag){
                    case "#":
                        updateText(old, vnode);
                        break;
                    case "<":
                        updateHTML(parent, old, vnode, ns, nextSibling);
                        break;
                    case "[":
                        updateFragment(parent, old, vnode, hooks, nextSibling, ns);
                        break;
                    default:
                        updateElement(old, vnode, hooks, ns);
                }
            } else updateComponent(parent, old, vnode, hooks, nextSibling, ns);
        } else {
            removeNode(parent, old);
            createNode(parent, vnode, hooks, ns, nextSibling);
        }
    }
    function updateText(old, vnode) {
        if (old.children.toString() !== vnode.children.toString()) old.dom.nodeValue = vnode.children;
        vnode.dom = old.dom;
    }
    function updateHTML(parent, old, vnode, ns, nextSibling) {
        if (old.children !== vnode.children) {
            removeHTML(parent, old);
            createHTML(parent, vnode, ns, nextSibling);
        } else {
            vnode.dom = old.dom;
            vnode.domSize = old.domSize;
            vnode.instance = old.instance;
        }
    }
    function updateFragment(parent, old, vnode, hooks, nextSibling, ns) {
        updateNodes(parent, old.children, vnode.children, hooks, nextSibling, ns);
        var domSize = 0, children = vnode.children;
        vnode.dom = null;
        if (children != null) {
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child != null && child.dom != null) {
                    if (vnode.dom == null) vnode.dom = child.dom;
                    domSize += child.domSize || 1;
                }
            }
            if (domSize !== 1) vnode.domSize = domSize;
        }
    }
    function updateElement(old, vnode, hooks, ns) {
        var element = vnode.dom = old.dom;
        ns = getNameSpace(vnode) || ns;
        if (vnode.tag === "textarea") {
            if (vnode.attrs == null) vnode.attrs = {};
        }
        updateAttrs(vnode, old.attrs, vnode.attrs, ns);
        if (!maybeSetContentEditable(vnode)) updateNodes(element, old.children, vnode.children, hooks, null, ns);
    }
    function updateComponent(parent, old, vnode, hooks, nextSibling, ns) {
        vnode.instance = $dBs8J.normalize(callHook.call(vnode.state.view, vnode));
        if (vnode.instance === vnode) throw Error("A view cannot return the vnode it received as argument");
        updateLifecycle(vnode.state, vnode, hooks);
        if (vnode.attrs != null) updateLifecycle(vnode.attrs, vnode, hooks);
        if (vnode.instance != null) {
            if (old.instance == null) createNode(parent, vnode.instance, hooks, ns, nextSibling);
            else updateNode(parent, old.instance, vnode.instance, hooks, nextSibling, ns);
            vnode.dom = vnode.instance.dom;
            vnode.domSize = vnode.instance.domSize;
        } else if (old.instance != null) {
            removeNode(parent, old.instance);
            vnode.dom = undefined;
            vnode.domSize = 0;
        } else {
            vnode.dom = old.dom;
            vnode.domSize = old.domSize;
        }
    }
    function getKeyMap(vnodes, start, end) {
        var map = Object.create(null);
        for(; start < end; start++){
            var vnode = vnodes[start];
            if (vnode != null) {
                var key = vnode.key;
                if (key != null) map[key] = start;
            }
        }
        return map;
    }
    // Lifted from ivi https://github.com/ivijs/ivi/
    // takes a list of unique numbers (-1 is special and can
    // occur multiple times) and returns an array with the indices
    // of the items that are part of the longest increasing
    // subsequence
    var lisTemp = [];
    function makeLisIndices(a) {
        var result = [
            0
        ];
        var u = 0, v = 0, i = 0;
        var il = lisTemp.length = a.length;
        for(var i = 0; i < il; i++)lisTemp[i] = a[i];
        for(var i = 0; i < il; ++i){
            if (a[i] === -1) continue;
            var j = result[result.length - 1];
            if (a[j] < a[i]) {
                lisTemp[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v = result.length - 1;
            while(u < v){
                // Fast integer average without overflow.
                // eslint-disable-next-line no-bitwise
                var c = (u >>> 1) + (v >>> 1) + (u & v & 1);
                if (a[result[c]] < a[i]) u = c + 1;
                else v = c;
            }
            if (a[i] < a[result[u]]) {
                if (u > 0) lisTemp[i] = result[u - 1];
                result[u] = i;
            }
        }
        u = result.length;
        v = result[u - 1];
        while(u-- > 0){
            result[u] = v;
            v = lisTemp[v];
        }
        lisTemp.length = 0;
        return result;
    }
    function getNextSibling(vnodes, i, nextSibling) {
        for(; i < vnodes.length; i++){
            if (vnodes[i] != null && vnodes[i].dom != null) return vnodes[i].dom;
        }
        return nextSibling;
    }
    // This covers a really specific edge case:
    // - Parent node is keyed and contains child
    // - Child is removed, returns unresolved promise in `onbeforeremove`
    // - Parent node is moved in keyed diff
    // - Remaining children still need moved appropriately
    //
    // Ideally, I'd track removed nodes as well, but that introduces a lot more
    // complexity and I'm not exactly interested in doing that.
    function moveNodes(parent, vnode, nextSibling) {
        var frag = $doc.createDocumentFragment();
        moveChildToFrag(parent, frag, vnode);
        insertNode(parent, frag, nextSibling);
    }
    function moveChildToFrag(parent, frag, vnode) {
        // Dodge the recursion overhead in a few of the most common cases.
        while(vnode.dom != null && vnode.dom.parentNode === parent){
            if (typeof vnode.tag !== "string") {
                vnode = vnode.instance;
                if (vnode != null) continue;
            } else if (vnode.tag === "<") for(var i = 0; i < vnode.instance.length; i++)frag.appendChild(vnode.instance[i]);
            else if (vnode.tag !== "[") // Don't recurse for text nodes *or* elements, just fragments
            frag.appendChild(vnode.dom);
            else if (vnode.children.length === 1) {
                vnode = vnode.children[0];
                if (vnode != null) continue;
            } else for(var i = 0; i < vnode.children.length; i++){
                var child = vnode.children[i];
                if (child != null) moveChildToFrag(parent, frag, child);
            }
            break;
        }
    }
    function insertNode(parent, dom, nextSibling) {
        if (nextSibling != null) parent.insertBefore(dom, nextSibling);
        else parent.appendChild(dom);
    }
    function maybeSetContentEditable(vnode) {
        if (vnode.attrs == null || vnode.attrs.contenteditable == null && // attribute
        vnode.attrs.contentEditable == null // property
        ) return false;
        var children = vnode.children;
        if (children != null && children.length === 1 && children[0].tag === "<") {
            var content = children[0].children;
            if (vnode.dom.innerHTML !== content) vnode.dom.innerHTML = content;
        } else if (children != null && children.length !== 0) throw new Error("Child node of a contenteditable must be trusted.");
        return true;
    }
    //remove
    function removeNodes(parent, vnodes, start, end) {
        for(var i = start; i < end; i++){
            var vnode = vnodes[i];
            if (vnode != null) removeNode(parent, vnode);
        }
    }
    function removeNode(parent, vnode) {
        var mask = 0;
        var original = vnode.state;
        var stateResult, attrsResult;
        if (typeof vnode.tag !== "string" && typeof vnode.state.onbeforeremove === "function") {
            var result = callHook.call(vnode.state.onbeforeremove, vnode);
            if (result != null && typeof result.then === "function") {
                mask = 1;
                stateResult = result;
            }
        }
        if (vnode.attrs && typeof vnode.attrs.onbeforeremove === "function") {
            var result = callHook.call(vnode.attrs.onbeforeremove, vnode);
            if (result != null && typeof result.then === "function") {
                // eslint-disable-next-line no-bitwise
                mask |= 2;
                attrsResult = result;
            }
        }
        checkState(vnode, original);
        // If we can, try to fast-path it and avoid all the overhead of awaiting
        if (!mask) {
            onremove(vnode);
            removeChild(parent, vnode);
        } else {
            if (stateResult != null) {
                var next = function() {
                    // eslint-disable-next-line no-bitwise
                    if (mask & 1) {
                        mask &= 2;
                        if (!mask) reallyRemove();
                    }
                };
                stateResult.then(next, next);
            }
            if (attrsResult != null) {
                var next = function() {
                    // eslint-disable-next-line no-bitwise
                    if (mask & 2) {
                        mask &= 1;
                        if (!mask) reallyRemove();
                    }
                };
                attrsResult.then(next, next);
            }
        }
        function reallyRemove() {
            checkState(vnode, original);
            onremove(vnode);
            removeChild(parent, vnode);
        }
    }
    function removeHTML(parent, vnode) {
        for(var i = 0; i < vnode.instance.length; i++)parent.removeChild(vnode.instance[i]);
    }
    function removeChild(parent, vnode) {
        // Dodge the recursion overhead in a few of the most common cases.
        while(vnode.dom != null && vnode.dom.parentNode === parent){
            if (typeof vnode.tag !== "string") {
                vnode = vnode.instance;
                if (vnode != null) continue;
            } else if (vnode.tag === "<") removeHTML(parent, vnode);
            else {
                if (vnode.tag !== "[") {
                    parent.removeChild(vnode.dom);
                    if (!Array.isArray(vnode.children)) break;
                }
                if (vnode.children.length === 1) {
                    vnode = vnode.children[0];
                    if (vnode != null) continue;
                } else for(var i = 0; i < vnode.children.length; i++){
                    var child = vnode.children[i];
                    if (child != null) removeChild(parent, child);
                }
            }
            break;
        }
    }
    function onremove(vnode) {
        if (typeof vnode.tag !== "string" && typeof vnode.state.onremove === "function") callHook.call(vnode.state.onremove, vnode);
        if (vnode.attrs && typeof vnode.attrs.onremove === "function") callHook.call(vnode.attrs.onremove, vnode);
        if (typeof vnode.tag !== "string") {
            if (vnode.instance != null) onremove(vnode.instance);
        } else {
            var children = vnode.children;
            if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child != null) onremove(child);
            }
        }
    }
    //attrs
    function setAttrs(vnode, attrs, ns) {
        // If you assign an input type that is not supported by IE 11 with an assignment expression, an error will occur.
        //
        // Also, the DOM does things to inputs based on the value, so it needs set first.
        // See: https://github.com/MithrilJS/mithril.js/issues/2622
        if (vnode.tag === "input" && attrs.type != null) vnode.dom.setAttribute("type", attrs.type);
        var isFileInput = attrs != null && vnode.tag === "input" && attrs.type === "file";
        for(var key in attrs)setAttr(vnode, key, null, attrs[key], ns, isFileInput);
    }
    function setAttr(vnode, key, old, value, ns, isFileInput) {
        if (key === "key" || key === "is" || value == null || isLifecycleMethod(key) || old === value && !isFormAttribute(vnode, key) && typeof value !== "object" || key === "type" && vnode.tag === "input") return;
        if (key[0] === "o" && key[1] === "n") return updateEvent(vnode, key, value);
        if (key.slice(0, 6) === "xlink:") vnode.dom.setAttributeNS("http://www.w3.org/1999/xlink", key.slice(6), value);
        else if (key === "style") updateStyle(vnode.dom, old, value);
        else if (hasPropertyKey(vnode, key, ns)) {
            if (key === "value") {
                // Only do the coercion if we're actually going to check the value.
                /* eslint-disable no-implicit-coercion */ //setting input[value] to same value by typing on focused element moves cursor to end in Chrome
                //setting input[type=file][value] to same value causes an error to be generated if it's non-empty
                if ((vnode.tag === "input" || vnode.tag === "textarea") && vnode.dom.value === "" + value && (isFileInput || vnode.dom === activeElement())) return;
                //setting select[value] to same value while having select open blinks select dropdown in Chrome
                if (vnode.tag === "select" && old !== null && vnode.dom.value === "" + value) return;
                //setting option[value] to same value while having select open blinks select dropdown in Chrome
                if (vnode.tag === "option" && old !== null && vnode.dom.value === "" + value) return;
                //setting input[type=file][value] to different value is an error if it's non-empty
                // Not ideal, but it at least works around the most common source of uncaught exceptions for now.
                if (isFileInput && "" + value !== "") {
                    console.error("`value` is read-only on file inputs!");
                    return;
                }
            /* eslint-enable no-implicit-coercion */ }
            vnode.dom[key] = value;
        } else if (typeof value === "boolean") {
            if (value) vnode.dom.setAttribute(key, "");
            else vnode.dom.removeAttribute(key);
        } else vnode.dom.setAttribute(key === "className" ? "class" : key, value);
    }
    function removeAttr(vnode, key, old, ns) {
        if (key === "key" || key === "is" || old == null || isLifecycleMethod(key)) return;
        if (key[0] === "o" && key[1] === "n") updateEvent(vnode, key, undefined);
        else if (key === "style") updateStyle(vnode.dom, old, null);
        else if (hasPropertyKey(vnode, key, ns) && key !== "className" && key !== "title" // creates "null" as title
         && !(key === "value" && (vnode.tag === "option" || vnode.tag === "select" && vnode.dom.selectedIndex === -1 && vnode.dom === activeElement())) && !(vnode.tag === "input" && key === "type")) vnode.dom[key] = null;
        else {
            var nsLastIndex = key.indexOf(":");
            if (nsLastIndex !== -1) key = key.slice(nsLastIndex + 1);
            if (old !== false) vnode.dom.removeAttribute(key === "className" ? "class" : key);
        }
    }
    function setLateSelectAttrs(vnode, attrs) {
        if ("value" in attrs) {
            if (attrs.value === null) {
                if (vnode.dom.selectedIndex !== -1) vnode.dom.value = null;
            } else {
                var normalized = "" + attrs.value // eslint-disable-line no-implicit-coercion
                ;
                if (vnode.dom.value !== normalized || vnode.dom.selectedIndex === -1) vnode.dom.value = normalized;
            }
        }
        if ("selectedIndex" in attrs) setAttr(vnode, "selectedIndex", null, attrs.selectedIndex, undefined);
    }
    function updateAttrs(vnode, old, attrs, ns) {
        if (old && old === attrs) console.warn("Don't reuse attrs object, use new object for every redraw, this will throw in next major");
        if (attrs != null) {
            // If you assign an input type that is not supported by IE 11 with an assignment expression, an error will occur.
            //
            // Also, the DOM does things to inputs based on the value, so it needs set first.
            // See: https://github.com/MithrilJS/mithril.js/issues/2622
            if (vnode.tag === "input" && attrs.type != null) vnode.dom.setAttribute("type", attrs.type);
            var isFileInput = vnode.tag === "input" && attrs.type === "file";
            for(var key in attrs)setAttr(vnode, key, old && old[key], attrs[key], ns, isFileInput);
        }
        var val;
        if (old != null) {
            for(var key in old)if ((val = old[key]) != null && (attrs == null || attrs[key] == null)) removeAttr(vnode, key, val, ns);
        }
    }
    function isFormAttribute(vnode, attr) {
        return attr === "value" || attr === "checked" || attr === "selectedIndex" || attr === "selected" && vnode.dom === activeElement() || vnode.tag === "option" && vnode.dom.parentNode === $doc.activeElement;
    }
    function isLifecycleMethod(attr) {
        return attr === "oninit" || attr === "oncreate" || attr === "onupdate" || attr === "onremove" || attr === "onbeforeremove" || attr === "onbeforeupdate";
    }
    function hasPropertyKey(vnode, key, ns) {
        // Filter out namespaced keys
        return ns === undefined && // If it's a custom element, just keep it.
        (vnode.tag.indexOf("-") > -1 || vnode.attrs != null && vnode.attrs.is || // If it's a normal element, let's try to avoid a few browser bugs.
        key !== "href" && key !== "list" && key !== "form" && key !== "width" && key !== "height" // && key !== "type"
        ) && key in vnode.dom;
    }
    //style
    var uppercaseRegex = /[A-Z]/g;
    function toLowerCase(capital) {
        return "-" + capital.toLowerCase();
    }
    function normalizeKey(key) {
        return key[0] === "-" && key[1] === "-" ? key : key === "cssFloat" ? "float" : key.replace(uppercaseRegex, toLowerCase);
    }
    function updateStyle(element, old, style) {
        if (old === style) ;
        else if (style == null) // New style is missing, just clear it.
        element.style.cssText = "";
        else if (typeof style !== "object") // New style is a string, let engine deal with patching.
        element.style.cssText = style;
        else if (old == null || typeof old !== "object") {
            // `old` is missing or a string, `style` is an object.
            element.style.cssText = "";
            // Add new style properties
            for(var key in style){
                var value = style[key];
                if (value != null) element.style.setProperty(normalizeKey(key), String(value));
            }
        } else {
            // Both old & new are (different) objects.
            // Update style properties that have changed
            for(var key in style){
                var value = style[key];
                if (value != null && (value = String(value)) !== String(old[key])) element.style.setProperty(normalizeKey(key), value);
            }
            // Remove style properties that no longer exist
            for(var key in old)if (old[key] != null && style[key] == null) element.style.removeProperty(normalizeKey(key));
        }
    }
    // Here's an explanation of how this works:
    // 1. The event names are always (by design) prefixed by `on`.
    // 2. The EventListener interface accepts either a function or an object
    //    with a `handleEvent` method.
    // 3. The object does not inherit from `Object.prototype`, to avoid
    //    any potential interference with that (e.g. setters).
    // 4. The event name is remapped to the handler before calling it.
    // 5. In function-based event handlers, `ev.target === this`. We replicate
    //    that below.
    // 6. In function-based event handlers, `return false` prevents the default
    //    action and stops event propagation. We replicate that below.
    function EventDict() {
        // Save this, so the current redraw is correctly tracked.
        this._ = currentRedraw;
    }
    EventDict.prototype = Object.create(null);
    EventDict.prototype.handleEvent = function(ev) {
        var handler = this["on" + ev.type];
        var result;
        if (typeof handler === "function") result = handler.call(ev.currentTarget, ev);
        else if (typeof handler.handleEvent === "function") handler.handleEvent(ev);
        if (this._ && ev.redraw !== false) (0, this._)();
        if (result === false) {
            ev.preventDefault();
            ev.stopPropagation();
        }
    };
    //event
    function updateEvent(vnode, key, value) {
        if (vnode.events != null) {
            vnode.events._ = currentRedraw;
            if (vnode.events[key] === value) return;
            if (value != null && (typeof value === "function" || typeof value === "object")) {
                if (vnode.events[key] == null) vnode.dom.addEventListener(key.slice(2), vnode.events, false);
                vnode.events[key] = value;
            } else {
                if (vnode.events[key] != null) vnode.dom.removeEventListener(key.slice(2), vnode.events, false);
                vnode.events[key] = undefined;
            }
        } else if (value != null && (typeof value === "function" || typeof value === "object")) {
            vnode.events = new EventDict();
            vnode.dom.addEventListener(key.slice(2), vnode.events, false);
            vnode.events[key] = value;
        }
    }
    //lifecycle
    function initLifecycle(source, vnode, hooks) {
        if (typeof source.oninit === "function") callHook.call(source.oninit, vnode);
        if (typeof source.oncreate === "function") hooks.push(callHook.bind(source.oncreate, vnode));
    }
    function updateLifecycle(source, vnode, hooks) {
        if (typeof source.onupdate === "function") hooks.push(callHook.bind(source.onupdate, vnode));
    }
    function shouldNotUpdate(vnode, old) {
        do {
            if (vnode.attrs != null && typeof vnode.attrs.onbeforeupdate === "function") {
                var force = callHook.call(vnode.attrs.onbeforeupdate, vnode, old);
                if (force !== undefined && !force) break;
            }
            if (typeof vnode.tag !== "string" && typeof vnode.state.onbeforeupdate === "function") {
                var force = callHook.call(vnode.state.onbeforeupdate, vnode, old);
                if (force !== undefined && !force) break;
            }
            return false;
        }while (false); // eslint-disable-line no-constant-condition
        vnode.dom = old.dom;
        vnode.domSize = old.domSize;
        vnode.instance = old.instance;
        // One would think having the actual latest attributes would be ideal,
        // but it doesn't let us properly diff based on our current internal
        // representation. We have to save not only the old DOM info, but also
        // the attributes used to create it, as we diff *that*, not against the
        // DOM directly (with a few exceptions in `setAttr`). And, of course, we
        // need to save the children and text as they are conceptually not
        // unlike special "attributes" internally.
        vnode.attrs = old.attrs;
        vnode.children = old.children;
        vnode.text = old.text;
        return true;
    }
    var currentDOM;
    return function(dom, vnodes, redraw) {
        if (!dom) throw new TypeError("DOM element being rendered to does not exist.");
        if (currentDOM != null && dom.contains(currentDOM)) throw new TypeError("Node is currently being rendered to and thus is locked.");
        var prevRedraw = currentRedraw;
        var prevDOM = currentDOM;
        var hooks = [];
        var active = activeElement();
        var namespace = dom.namespaceURI;
        currentDOM = dom;
        currentRedraw = typeof redraw === "function" ? redraw : undefined;
        try {
            // First time rendering into a node clears it out
            if (dom.vnodes == null) dom.textContent = "";
            vnodes = $dBs8J.normalizeChildren(Array.isArray(vnodes) ? vnodes : [
                vnodes
            ]);
            updateNodes(dom, dom.vnodes, vnodes, hooks, null, namespace === "http://www.w3.org/1999/xhtml" ? undefined : namespace);
            dom.vnodes = vnodes;
            // `document.activeElement` can return null: https://html.spec.whatwg.org/multipage/interaction.html#dom-document-activeelement
            if (active != null && activeElement() !== active && typeof active.focus === "function") active.focus();
            for(var i = 0; i < hooks.length; i++)hooks[i]();
        } finally{
            currentRedraw = prevRedraw;
            currentDOM = prevDOM;
        }
    };
};

});


parcelRegister("iZais", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");
module.exports = function(render, schedule, console) {
    var subscriptions = [];
    var pending = false;
    var offset = -1;
    function sync() {
        for(offset = 0; offset < subscriptions.length; offset += 2)try {
            render(subscriptions[offset], $dBs8J(subscriptions[offset + 1]), redraw);
        } catch (e) {
            console.error(e);
        }
        offset = -1;
    }
    function redraw() {
        if (!pending) {
            pending = true;
            schedule(function() {
                pending = false;
                sync();
            });
        }
    }
    redraw.sync = sync;
    function mount(root, component) {
        if (component != null && component.view == null && typeof component !== "function") throw new TypeError("m.mount expects a component, not a vnode.");
        var index = subscriptions.indexOf(root);
        if (index >= 0) {
            subscriptions.splice(index, 2);
            if (index <= offset) offset -= 2;
            render(root, []);
        }
        if (component != null) {
            subscriptions.push(root, component);
            render(root, $dBs8J(component), redraw);
        }
    }
    return {
        mount: mount,
        redraw: redraw
    };
};

});

parcelRegister("5y2KI", function(module, exports) {
"use strict";

var $cITMw = parcelRequire("cITMw");

var $9eOch = parcelRequire("9eOch");
module.exports = function($window, Promise, oncompletion) {
    var callbackCount = 0;
    function PromiseProxy(executor) {
        return new Promise(executor);
    }
    // In case the global Promise is some userland library's where they rely on
    // `foo instanceof this.constructor`, `this.constructor.resolve(value)`, or
    // similar. Let's *not* break them.
    PromiseProxy.prototype = Promise.prototype;
    PromiseProxy.__proto__ = Promise // eslint-disable-line no-proto
    ;
    function makeRequest(factory) {
        return function(url, args) {
            if (typeof url !== "string") {
                args = url;
                url = url.url;
            } else if (args == null) args = {};
            var promise = new Promise(function(resolve, reject) {
                factory($cITMw(url, args.params), args, function(data) {
                    if (typeof args.type === "function") {
                        if (Array.isArray(data)) for(var i = 0; i < data.length; i++)data[i] = new args.type(data[i]);
                        else data = new args.type(data);
                    }
                    resolve(data);
                }, reject);
            });
            if (args.background === true) return promise;
            var count = 0;
            function complete() {
                if (--count === 0 && typeof oncompletion === "function") oncompletion();
            }
            return wrap(promise);
            function wrap(promise) {
                var then = promise.then;
                // Set the constructor, so engines know to not await or resolve
                // this as a native promise. At the time of writing, this is
                // only necessary for V8, but their behavior is the correct
                // behavior per spec. See this spec issue for more details:
                // https://github.com/tc39/ecma262/issues/1577. Also, see the
                // corresponding comment in `request/tests/test-request.js` for
                // a bit more background on the issue at hand.
                promise.constructor = PromiseProxy;
                promise.then = function() {
                    count++;
                    var next = then.apply(promise, arguments);
                    next.then(complete, function(e) {
                        complete();
                        if (count === 0) throw e;
                    });
                    return wrap(next);
                };
                return promise;
            }
        };
    }
    function hasHeader(args, name) {
        for(var key in args.headers){
            if ($9eOch.call(args.headers, key) && key.toLowerCase() === name) return true;
        }
        return false;
    }
    return {
        request: makeRequest(function(url, args, resolve, reject) {
            var method = args.method != null ? args.method.toUpperCase() : "GET";
            var body = args.body;
            var assumeJSON = (args.serialize == null || args.serialize === JSON.serialize) && !(body instanceof $window.FormData || body instanceof $window.URLSearchParams);
            var responseType = args.responseType || (typeof args.extract === "function" ? "" : "json");
            var xhr = new $window.XMLHttpRequest(), aborted = false, isTimeout = false;
            var original = xhr, replacedAbort;
            var abort = xhr.abort;
            xhr.abort = function() {
                aborted = true;
                abort.call(this);
            };
            xhr.open(method, url, args.async !== false, typeof args.user === "string" ? args.user : undefined, typeof args.password === "string" ? args.password : undefined);
            if (assumeJSON && body != null && !hasHeader(args, "content-type")) xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
            if (typeof args.deserialize !== "function" && !hasHeader(args, "accept")) xhr.setRequestHeader("Accept", "application/json, text/*");
            if (args.withCredentials) xhr.withCredentials = args.withCredentials;
            if (args.timeout) xhr.timeout = args.timeout;
            xhr.responseType = responseType;
            for(var key in args.headers)if ($9eOch.call(args.headers, key)) xhr.setRequestHeader(key, args.headers[key]);
            xhr.onreadystatechange = function(ev) {
                // Don't throw errors on xhr.abort().
                if (aborted) return;
                if (ev.target.readyState === 4) try {
                    var success = ev.target.status >= 200 && ev.target.status < 300 || ev.target.status === 304 || /^file:\/\//i.test(url);
                    // When the response type isn't "" or "text",
                    // `xhr.responseText` is the wrong thing to use.
                    // Browsers do the right thing and throw here, and we
                    // should honor that and do the right thing by
                    // preferring `xhr.response` where possible/practical.
                    var response = ev.target.response, message;
                    if (responseType === "json") {
                        // For IE and Edge, which don't implement
                        // `responseType: "json"`.
                        if (!ev.target.responseType && typeof args.extract !== "function") // Handle no-content which will not parse.
                        try {
                            response = JSON.parse(ev.target.responseText);
                        } catch (e) {
                            response = null;
                        }
                    } else if (!responseType || responseType === "text") // Only use this default if it's text. If a parsed
                    // document is needed on old IE and friends (all
                    // unsupported), the user should use a custom
                    // `config` instead. They're already using this at
                    // their own risk.
                    {
                        if (response == null) response = ev.target.responseText;
                    }
                    if (typeof args.extract === "function") {
                        response = args.extract(ev.target, args);
                        success = true;
                    } else if (typeof args.deserialize === "function") response = args.deserialize(response);
                    if (success) resolve(response);
                    else {
                        var completeErrorResponse = function() {
                            try {
                                message = ev.target.responseText;
                            } catch (e) {
                                message = response;
                            }
                            var error = new Error(message);
                            error.code = ev.target.status;
                            error.response = response;
                            reject(error);
                        };
                        if (xhr.status === 0) // Use setTimeout to push this code block onto the event queue
                        // This allows `xhr.ontimeout` to run in the case that there is a timeout
                        // Without this setTimeout, `xhr.ontimeout` doesn't have a chance to reject
                        // as `xhr.onreadystatechange` will run before it
                        setTimeout(function() {
                            if (isTimeout) return;
                            completeErrorResponse();
                        });
                        else completeErrorResponse();
                    }
                } catch (e) {
                    reject(e);
                }
            };
            xhr.ontimeout = function(ev) {
                isTimeout = true;
                var error = new Error("Request timed out");
                error.code = ev.target.status;
                reject(error);
            };
            if (typeof args.config === "function") {
                xhr = args.config(xhr, args, url) || xhr;
                // Propagate the `abort` to any replacement XHR as well.
                if (xhr !== original) {
                    replacedAbort = xhr.abort;
                    xhr.abort = function() {
                        aborted = true;
                        replacedAbort.call(this);
                    };
                }
            }
            if (body == null) xhr.send();
            else if (typeof args.serialize === "function") xhr.send(args.serialize(body));
            else if (body instanceof $window.FormData || body instanceof $window.URLSearchParams) xhr.send(body);
            else xhr.send(JSON.stringify(body));
        }),
        jsonp: makeRequest(function(url, args, resolve, reject) {
            var callbackName = args.callbackName || "_mithril_" + Math.round(Math.random() * 1e16) + "_" + callbackCount++;
            var script = $window.document.createElement("script");
            $window[callbackName] = function(data) {
                delete $window[callbackName];
                script.parentNode.removeChild(script);
                resolve(data);
            };
            script.onerror = function() {
                delete $window[callbackName];
                script.parentNode.removeChild(script);
                reject(new Error("JSONP request failed"));
            };
            script.src = url + (url.indexOf("?") < 0 ? "?" : "&") + encodeURIComponent(args.callbackKey || "callback") + "=" + encodeURIComponent(callbackName);
            $window.document.documentElement.appendChild(script);
        })
    };
};

});
parcelRegister("cITMw", function(module, exports) {
"use strict";

var $iRA82 = parcelRequire("iRA82");

var $enXzN = parcelRequire("enXzN");
// Returns `path` from `template` + `params`
module.exports = function(template, params) {
    if (/:([^\/\.-]+)(\.{3})?:/.test(template)) throw new SyntaxError("Template parameter names must be separated by either a '/', '-', or '.'.");
    if (params == null) return template;
    var queryIndex = template.indexOf("?");
    var hashIndex = template.indexOf("#");
    var queryEnd = hashIndex < 0 ? template.length : hashIndex;
    var pathEnd = queryIndex < 0 ? queryEnd : queryIndex;
    var path = template.slice(0, pathEnd);
    var query = {};
    $enXzN(query, params);
    var resolved = path.replace(/:([^\/\.-]+)(\.{3})?/g, function(m, key, variadic) {
        delete query[key];
        // If no such parameter exists, don't interpolate it.
        if (params[key] == null) return m;
        // Escape normal parameters, but not variadic ones.
        return variadic ? params[key] : encodeURIComponent(String(params[key]));
    });
    // In case the template substitution adds new query/hash parameters.
    var newQueryIndex = resolved.indexOf("?");
    var newHashIndex = resolved.indexOf("#");
    var newQueryEnd = newHashIndex < 0 ? resolved.length : newHashIndex;
    var newPathEnd = newQueryIndex < 0 ? newQueryEnd : newQueryIndex;
    var result = resolved.slice(0, newPathEnd);
    if (queryIndex >= 0) result += template.slice(queryIndex, queryEnd);
    if (newQueryIndex >= 0) result += (queryIndex < 0 ? "?" : "&") + resolved.slice(newQueryIndex, newQueryEnd);
    var querystring = $iRA82(query);
    if (querystring) result += (queryIndex < 0 && newQueryIndex < 0 ? "?" : "&") + querystring;
    if (hashIndex >= 0) result += template.slice(hashIndex);
    if (newHashIndex >= 0) result += (hashIndex < 0 ? "" : "&") + resolved.slice(newHashIndex);
    return result;
};

});
parcelRegister("iRA82", function(module, exports) {
"use strict";
module.exports = function(object) {
    if (Object.prototype.toString.call(object) !== "[object Object]") return "";
    var args = [];
    for(var key in object)destructure(key, object[key]);
    return args.join("&");
    function destructure(key, value) {
        if (Array.isArray(value)) for(var i = 0; i < value.length; i++)destructure(key + "[" + i + "]", value[i]);
        else if (Object.prototype.toString.call(value) === "[object Object]") for(var i in value)destructure(key + "[" + i + "]", value[i]);
        else args.push(encodeURIComponent(key) + (value != null && value !== "" ? "=" + encodeURIComponent(value) : ""));
    }
};

});

parcelRegister("enXzN", function(module, exports) {
// This exists so I'm only saving it once.
"use strict";

var $9eOch = parcelRequire("9eOch");
module.exports = Object.assign || function(target, source) {
    for(var key in source)if ($9eOch.call(source, key)) target[key] = source[key];
};

});
parcelRegister("9eOch", function(module, exports) {
// This exists so I'm only saving it once.
"use strict";
module.exports = ({}).hasOwnProperty;

});




parcelRegister("4Ppi2", function(module, exports) {
"use strict";

var $7EF0O = parcelRequire("7EF0O");

module.exports = (parcelRequire("eFHZ8"))(typeof window !== "undefined" ? window : null, $7EF0O);

});
parcelRegister("7EF0O", function(module, exports) {
"use strict";

var $j25vk = parcelRequire("j25vk");

module.exports = (parcelRequire("iZais"))($j25vk, typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : null, typeof console !== "undefined" ? console : null);

});

parcelRegister("eFHZ8", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");

var $iVcuU = parcelRequire("iVcuU");

var $2uPnQ = parcelRequire("2uPnQ");

var $cITMw = parcelRequire("cITMw");

var $7lWrV = parcelRequire("7lWrV");

var $8KlxE = parcelRequire("8KlxE");

var $enXzN = parcelRequire("enXzN");

var $e9o88 = parcelRequire("e9o88");
var $aae70388e69e8325$var$sentinel = {};
function $aae70388e69e8325$var$decodeURIComponentSave(component) {
    try {
        return decodeURIComponent(component);
    } catch (e) {
        return component;
    }
}
module.exports = function($window, mountRedraw) {
    var callAsync = $window == null ? null : typeof $window.setImmediate === "function" ? $window.setImmediate : $window.setTimeout;
    var p = $2uPnQ.resolve();
    var scheduled = false;
    // state === 0: init
    // state === 1: scheduled
    // state === 2: done
    var ready = false;
    var state = 0;
    var compiled, fallbackRoute;
    var currentResolver = $aae70388e69e8325$var$sentinel, component, attrs, currentPath, lastUpdate;
    var RouterRoot = {
        onbeforeupdate: function() {
            state = state ? 2 : 1;
            return !(!state || $aae70388e69e8325$var$sentinel === currentResolver);
        },
        onremove: function() {
            $window.removeEventListener("popstate", fireAsync, false);
            $window.removeEventListener("hashchange", resolveRoute, false);
        },
        view: function() {
            if (!state || $aae70388e69e8325$var$sentinel === currentResolver) return;
            // Wrap in a fragment to preserve existing key semantics
            var vnode = [
                $dBs8J(component, attrs.key, attrs)
            ];
            if (currentResolver) vnode = currentResolver.render(vnode[0]);
            return vnode;
        }
    };
    var SKIP = route.SKIP = {};
    function resolveRoute() {
        scheduled = false;
        // Consider the pathname holistically. The prefix might even be invalid,
        // but that's not our problem.
        var prefix = $window.location.hash;
        if (route.prefix[0] !== "#") {
            prefix = $window.location.search + prefix;
            if (route.prefix[0] !== "?") {
                prefix = $window.location.pathname + prefix;
                if (prefix[0] !== "/") prefix = "/" + prefix;
            }
        }
        // This seemingly useless `.concat()` speeds up the tests quite a bit,
        // since the representation is consistently a relatively poorly
        // optimized cons string.
        var path = prefix.concat().replace(/(?:%[a-f89][a-f0-9])+/gim, $aae70388e69e8325$var$decodeURIComponentSave).slice(route.prefix.length);
        var data = $7lWrV(path);
        $enXzN(data.params, $window.history.state);
        function reject(e) {
            console.error(e);
            setPath(fallbackRoute, null, {
                replace: true
            });
        }
        loop(0);
        function loop(i) {
            // state === 0: init
            // state === 1: scheduled
            // state === 2: done
            for(; i < compiled.length; i++)if (compiled[i].check(data)) {
                var payload = compiled[i].component;
                var matchedRoute = compiled[i].route;
                var localComp = payload;
                var update = lastUpdate = function(comp) {
                    if (update !== lastUpdate) return;
                    if (comp === SKIP) return loop(i + 1);
                    component = comp != null && (typeof comp.view === "function" || typeof comp === "function") ? comp : "div";
                    attrs = data.params, currentPath = path, lastUpdate = null;
                    currentResolver = payload.render ? payload : null;
                    if (state === 2) mountRedraw.redraw();
                    else {
                        state = 2;
                        mountRedraw.redraw.sync();
                    }
                };
                // There's no understating how much I *wish* I could
                // use `async`/`await` here...
                if (payload.view || typeof payload === "function") {
                    payload = {};
                    update(localComp);
                } else if (payload.onmatch) p.then(function() {
                    return payload.onmatch(data.params, path, matchedRoute);
                }).then(update, path === fallbackRoute ? null : reject);
                else update("div");
                return;
            }
            if (path === fallbackRoute) throw new Error("Could not resolve default route " + fallbackRoute + ".");
            setPath(fallbackRoute, null, {
                replace: true
            });
        }
    }
    // Set it unconditionally so `m.route.set` and `m.route.Link` both work,
    // even if neither `pushState` nor `hashchange` are supported. It's
    // cleared if `hashchange` is used, since that makes it automatically
    // async.
    function fireAsync() {
        if (!scheduled) {
            scheduled = true;
            // TODO: just do `mountRedraw.redraw()` here and elide the timer
            // dependency. Note that this will muck with tests a *lot*, so it's
            // not as easy of a change as it sounds.
            callAsync(resolveRoute);
        }
    }
    function setPath(path, data, options) {
        path = $cITMw(path, data);
        if (ready) {
            fireAsync();
            var state = options ? options.state : null;
            var title = options ? options.title : null;
            if (options && options.replace) $window.history.replaceState(state, title, route.prefix + path);
            else $window.history.pushState(state, title, route.prefix + path);
        } else $window.location.href = route.prefix + path;
    }
    function route(root, defaultRoute, routes) {
        if (!root) throw new TypeError("DOM element being rendered to does not exist.");
        compiled = Object.keys(routes).map(function(route) {
            if (route[0] !== "/") throw new SyntaxError("Routes must start with a '/'.");
            if (/:([^\/\.-]+)(\.{3})?:/.test(route)) throw new SyntaxError("Route parameter names must be separated with either '/', '.', or '-'.");
            return {
                route: route,
                component: routes[route],
                check: $8KlxE(route)
            };
        });
        fallbackRoute = defaultRoute;
        if (defaultRoute != null) {
            var defaultData = $7lWrV(defaultRoute);
            if (!compiled.some(function(i) {
                return i.check(defaultData);
            })) throw new ReferenceError("Default route doesn't match any known routes.");
        }
        if (typeof $window.history.pushState === "function") $window.addEventListener("popstate", fireAsync, false);
        else if (route.prefix[0] === "#") $window.addEventListener("hashchange", resolveRoute, false);
        ready = true;
        mountRedraw.mount(root, RouterRoot);
        resolveRoute();
    }
    route.set = function(path, data, options) {
        if (lastUpdate != null) {
            options = options || {};
            options.replace = true;
        }
        lastUpdate = null;
        setPath(path, data, options);
    };
    route.get = function() {
        return currentPath;
    };
    route.prefix = "#!";
    route.Link = {
        view: function(vnode) {
            // Omit the used parameters from the rendered element - they are
            // internal. Also, censor the various lifecycle methods.
            //
            // We don't strip the other parameters because for convenience we
            // let them be specified in the selector as well.
            var child = $iVcuU(vnode.attrs.selector || "a", $e9o88(vnode.attrs, [
                "options",
                "params",
                "selector",
                "onclick"
            ]), vnode.children);
            var options, onclick, href;
            // Let's provide a *right* way to disable a route link, rather than
            // letting people screw up accessibility on accident.
            //
            // The attribute is coerced so users don't get surprised over
            // `disabled: 0` resulting in a button that's somehow routable
            // despite being visibly disabled.
            if (child.attrs.disabled = Boolean(child.attrs.disabled)) {
                child.attrs.href = null;
                child.attrs["aria-disabled"] = "true";
            // If you *really* do want add `onclick` on a disabled link, use
            // an `oncreate` hook to add it.
            } else {
                options = vnode.attrs.options;
                onclick = vnode.attrs.onclick;
                // Easier to build it now to keep it isomorphic.
                href = $cITMw(child.attrs.href, vnode.attrs.params);
                child.attrs.href = route.prefix + href;
                child.attrs.onclick = function(e) {
                    var result;
                    if (typeof onclick === "function") result = onclick.call(e.currentTarget, e);
                    else if (onclick == null || typeof onclick !== "object") ;
                    else if (typeof onclick.handleEvent === "function") onclick.handleEvent(e);
                    // Adapted from React Router's implementation:
                    // https://github.com/ReactTraining/react-router/blob/520a0acd48ae1b066eb0b07d6d4d1790a1d02482/packages/react-router-dom/modules/Link.js
                    //
                    // Try to be flexible and intuitive in how we handle links.
                    // Fun fact: links aren't as obvious to get right as you
                    // would expect. There's a lot more valid ways to click a
                    // link than this, and one might want to not simply click a
                    // link, but right click or command-click it to copy the
                    // link target, etc. Nope, this isn't just for blind people.
                    if (// Skip if `onclick` prevented default
                    result !== false && !e.defaultPrevented && // Ignore everything but left clicks
                    (e.button === 0 || e.which === 0 || e.which === 1) && // Let the browser handle `target=_blank`, etc.
                    (!e.currentTarget.target || e.currentTarget.target === "_self") && // No modifier keys
                    !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey) {
                        e.preventDefault();
                        e.redraw = false;
                        route.set(href, null, options);
                    }
                };
            }
            return child;
        }
    };
    route.param = function(key) {
        return attrs && key != null ? attrs[key] : attrs;
    };
    return route;
};

});
parcelRegister("iVcuU", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");

var $5sRXF = parcelRequire("5sRXF");

var $9eOch = parcelRequire("9eOch");
var $dc673ea23ab51a3f$var$selectorParser = /(?:(^|#|\.)([^#\.\[\]]+))|(\[(.+?)(?:\s*=\s*("|'|)((?:\\["'\]]|.)*?)\5)?\])/g;
var $dc673ea23ab51a3f$var$selectorCache = {};
function $dc673ea23ab51a3f$var$isEmpty(object) {
    for(var key in object)if ($9eOch.call(object, key)) return false;
    return true;
}
function $dc673ea23ab51a3f$var$compileSelector(selector) {
    var match, tag = "div", classes = [], attrs = {};
    while(match = $dc673ea23ab51a3f$var$selectorParser.exec(selector)){
        var type = match[1], value = match[2];
        if (type === "" && value !== "") tag = value;
        else if (type === "#") attrs.id = value;
        else if (type === ".") classes.push(value);
        else if (match[3][0] === "[") {
            var attrValue = match[6];
            if (attrValue) attrValue = attrValue.replace(/\\(["'])/g, "$1").replace(/\\\\/g, "\\");
            if (match[4] === "class") classes.push(attrValue);
            else attrs[match[4]] = attrValue === "" ? attrValue : attrValue || true;
        }
    }
    if (classes.length > 0) attrs.className = classes.join(" ");
    return $dc673ea23ab51a3f$var$selectorCache[selector] = {
        tag: tag,
        attrs: attrs
    };
}
function $dc673ea23ab51a3f$var$execSelector(state, vnode) {
    var attrs = vnode.attrs;
    var hasClass = $9eOch.call(attrs, "class");
    var className = hasClass ? attrs.class : attrs.className;
    vnode.tag = state.tag;
    vnode.attrs = {};
    if (!$dc673ea23ab51a3f$var$isEmpty(state.attrs) && !$dc673ea23ab51a3f$var$isEmpty(attrs)) {
        var newAttrs = {};
        for(var key in attrs)if ($9eOch.call(attrs, key)) newAttrs[key] = attrs[key];
        attrs = newAttrs;
    }
    for(var key in state.attrs)if ($9eOch.call(state.attrs, key) && key !== "className" && !$9eOch.call(attrs, key)) attrs[key] = state.attrs[key];
    if (className != null || state.attrs.className != null) attrs.className = className != null ? state.attrs.className != null ? String(state.attrs.className) + " " + String(className) : className : state.attrs.className != null ? state.attrs.className : null;
    if (hasClass) attrs.class = null;
    for(var key in attrs)if ($9eOch.call(attrs, key) && key !== "key") {
        vnode.attrs = attrs;
        break;
    }
    return vnode;
}
function $dc673ea23ab51a3f$var$hyperscript(selector) {
    if (selector == null || typeof selector !== "string" && typeof selector !== "function" && typeof selector.view !== "function") throw Error("The selector must be either a string or a component.");
    var vnode = $5sRXF.apply(1, arguments);
    if (typeof selector === "string") {
        vnode.children = $dBs8J.normalizeChildren(vnode.children);
        if (selector !== "[") return $dc673ea23ab51a3f$var$execSelector($dc673ea23ab51a3f$var$selectorCache[selector] || $dc673ea23ab51a3f$var$compileSelector(selector), vnode);
    }
    vnode.tag = selector;
    return vnode;
}
module.exports = $dc673ea23ab51a3f$var$hyperscript;

});

parcelRegister("2uPnQ", function(module, exports) {
/* global window */ "use strict";

var $k7iQv = parcelRequire("k7iQv");
if (typeof window !== "undefined") {
    if (typeof window.Promise === "undefined") window.Promise = $k7iQv;
    else if (!window.Promise.prototype.finally) window.Promise.prototype.finally = $k7iQv.prototype.finally;
    module.exports = window.Promise;
} else if (typeof $parcel$global !== "undefined") {
    if (typeof $parcel$global.Promise === "undefined") $parcel$global.Promise = $k7iQv;
    else if (!$parcel$global.Promise.prototype.finally) $parcel$global.Promise.prototype.finally = $k7iQv.prototype.finally;
    module.exports = $parcel$global.Promise;
} else module.exports = $k7iQv;

});

parcelRegister("7lWrV", function(module, exports) {
"use strict";

var $gZZfO = parcelRequire("gZZfO");
// Returns `{path, params}` from `url`
module.exports = function(url) {
    var queryIndex = url.indexOf("?");
    var hashIndex = url.indexOf("#");
    var queryEnd = hashIndex < 0 ? url.length : hashIndex;
    var pathEnd = queryIndex < 0 ? queryEnd : queryIndex;
    var path = url.slice(0, pathEnd).replace(/\/{2,}/g, "/");
    if (!path) path = "/";
    else {
        if (path[0] !== "/") path = "/" + path;
        if (path.length > 1 && path[path.length - 1] === "/") path = path.slice(0, -1);
    }
    return {
        path: path,
        params: queryIndex < 0 ? {} : $gZZfO(url.slice(queryIndex + 1, queryEnd))
    };
};

});
parcelRegister("gZZfO", function(module, exports) {
"use strict";
function $c601dba597649f5e$var$decodeURIComponentSave(str) {
    try {
        return decodeURIComponent(str);
    } catch (err) {
        return str;
    }
}
module.exports = function(string) {
    if (string === "" || string == null) return {};
    if (string.charAt(0) === "?") string = string.slice(1);
    var entries = string.split("&"), counters = {}, data = {};
    for(var i = 0; i < entries.length; i++){
        var entry = entries[i].split("=");
        var key = $c601dba597649f5e$var$decodeURIComponentSave(entry[0]);
        var value = entry.length === 2 ? $c601dba597649f5e$var$decodeURIComponentSave(entry[1]) : "";
        if (value === "true") value = true;
        else if (value === "false") value = false;
        var levels = key.split(/\]\[?|\[/);
        var cursor = data;
        if (key.indexOf("[") > -1) levels.pop();
        for(var j = 0; j < levels.length; j++){
            var level = levels[j], nextLevel = levels[j + 1];
            var isNumber = nextLevel == "" || !isNaN(parseInt(nextLevel, 10));
            if (level === "") {
                var key = levels.slice(0, j).join();
                if (counters[key] == null) counters[key] = Array.isArray(cursor) ? cursor.length : 0;
                level = counters[key]++;
            } else if (level === "__proto__") break;
            if (j === levels.length - 1) cursor[level] = value;
            else {
                // Read own properties exclusively to disallow indirect
                // prototype pollution
                var desc = Object.getOwnPropertyDescriptor(cursor, level);
                if (desc != null) desc = desc.value;
                if (desc == null) cursor[level] = desc = isNumber ? [] : {};
                cursor = desc;
            }
        }
    }
    return data;
};

});


parcelRegister("8KlxE", function(module, exports) {
"use strict";

var $7lWrV = parcelRequire("7lWrV");
// Compiles a template into a function that takes a resolved path (without query
// strings) and returns an object containing the template parameters with their
// parsed values. This expects the input of the compiled template to be the
// output of `parsePathname`. Note that it does *not* remove query parameters
// specified in the template.
module.exports = function(template) {
    var templateData = $7lWrV(template);
    var templateKeys = Object.keys(templateData.params);
    var keys = [];
    var regexp = new RegExp("^" + templateData.path.replace(// I escape literal text so people can use things like `:file.:ext` or
    // `:lang-:locale` in routes. This is all merged into one pass so I
    // don't also accidentally escape `-` and make it harder to detect it to
    // ban it from template parameters.
    /:([^\/.-]+)(\.{3}|\.(?!\.)|-)?|[\\^$*+.()|\[\]{}]/g, function(m, key, extra) {
        if (key == null) return "\\" + m;
        keys.push({
            k: key,
            r: extra === "..."
        });
        if (extra === "...") return "(.*)";
        if (extra === ".") return "([^/]+)\\.";
        return "([^/]+)" + (extra || "");
    }) + "$");
    return function(data) {
        // First, check the params. Usually, there isn't any, and it's just
        // checking a static set.
        for(var i = 0; i < templateKeys.length; i++){
            if (templateData.params[templateKeys[i]] !== data.params[templateKeys[i]]) return false;
        }
        // If no interpolations exist, let's skip all the ceremony
        if (!keys.length) return regexp.test(data.path);
        var values = regexp.exec(data.path);
        if (values == null) return false;
        for(var i = 0; i < keys.length; i++)data.params[keys[i].k] = keys[i].r ? values[i + 1] : decodeURIComponent(values[i + 1]);
        return true;
    };
};

});

parcelRegister("e9o88", function(module, exports) {
"use strict";

var $9eOch = parcelRequire("9eOch");
// Words in RegExp literals are sometimes mangled incorrectly by the internal bundler, so use RegExp().
var $a4d49fb46380177c$var$magic = new RegExp("^(?:key|oninit|oncreate|onbeforeupdate|onupdate|onbeforeremove|onremove)$");
module.exports = function(attrs, extras) {
    var result = {};
    if (extras != null) {
        for(var key in attrs)if ($9eOch.call(attrs, key) && !$a4d49fb46380177c$var$magic.test(key) && extras.indexOf(key) < 0) result[key] = attrs[key];
    } else {
        for(var key in attrs)if ($9eOch.call(attrs, key) && !$a4d49fb46380177c$var$magic.test(key)) result[key] = attrs[key];
    }
    return result;
};

});



var $65d5daca13f5010c$exports = {};
"use strict";
var $20d57ad7857b7d5d$exports = {};
"use strict";

var $iVcuU = parcelRequire("iVcuU");

$iVcuU.trust = (parcelRequire("e2F9W"));

$iVcuU.fragment = (parcelRequire("7PZrX"));
$20d57ad7857b7d5d$exports = $iVcuU;


var $8fa9e1679f027da0$exports = {};
"use strict";

var $2uPnQ = parcelRequire("2uPnQ");

var $7EF0O = parcelRequire("7EF0O");

$8fa9e1679f027da0$exports = (parcelRequire("5y2KI"))(typeof window !== "undefined" ? window : null, $2uPnQ, $7EF0O.redraw);



var $7EF0O = parcelRequire("7EF0O");
var $65d5daca13f5010c$var$m = function m() {
    return $20d57ad7857b7d5d$exports.apply(this, arguments);
};
$65d5daca13f5010c$var$m.m = $20d57ad7857b7d5d$exports;
$65d5daca13f5010c$var$m.trust = $20d57ad7857b7d5d$exports.trust;
$65d5daca13f5010c$var$m.fragment = $20d57ad7857b7d5d$exports.fragment;
$65d5daca13f5010c$var$m.Fragment = "[";
$65d5daca13f5010c$var$m.mount = $7EF0O.mount;

$65d5daca13f5010c$var$m.route = (parcelRequire("4Ppi2"));

$65d5daca13f5010c$var$m.render = (parcelRequire("j25vk"));
$65d5daca13f5010c$var$m.redraw = $7EF0O.redraw;
$65d5daca13f5010c$var$m.request = $8fa9e1679f027da0$exports.request;
$65d5daca13f5010c$var$m.jsonp = $8fa9e1679f027da0$exports.jsonp;

$65d5daca13f5010c$var$m.parseQueryString = (parcelRequire("gZZfO"));

$65d5daca13f5010c$var$m.buildQueryString = (parcelRequire("iRA82"));

$65d5daca13f5010c$var$m.parsePathname = (parcelRequire("7lWrV"));

$65d5daca13f5010c$var$m.buildPathname = (parcelRequire("cITMw"));

$65d5daca13f5010c$var$m.vnode = (parcelRequire("dBs8J"));

$65d5daca13f5010c$var$m.PromisePolyfill = (parcelRequire("k7iQv"));

$65d5daca13f5010c$var$m.censor = (parcelRequire("e9o88"));
$65d5daca13f5010c$exports = $65d5daca13f5010c$var$m;





var $883ca2d90835a400$exports = {};
const $883ca2d90835a400$var$constants = Object.freeze({
    CURRENCY_CODE_EUR: "&#8364;",
    CURRENCY_CODE_GBP: "&#163;",
    CURRENCY_CODE_USD: "&#36;",
    CURRENCY_CODE_CAD: "&#36;",
    IMAGE_ECOM_PAY_BLACK: "https://space-live.ams3.cdn.digitaloceanspaces.com/ecompay/black-elockers-logo.svg",
    IMAGE_ECOM_PAY: "https://space-live.ams3.cdn.digitaloceanspaces.com/ecompay/elockers-logo.svg",
    IMAGE_CHRISTMAS_GARLAND: "https://space-live.ams3.cdn.digitaloceanspaces.com/ecompay/garland.png",
    THEME_DEFAULT: "default",
    THEME_CHIRSTMAS: "christmas"
});
$883ca2d90835a400$exports = $883ca2d90835a400$var$constants;


const $e73bf42412feb220$var$app = {
    apiRoot: "",
    live: true,
    locale: "nl_NL",
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($883ca2d90835a400$exports))).THEME_DEFAULT,
    paymentSession: {},
    adyen: {
        clientKey: false,
        countryCodes: {},
        paymentMethods: []
    },
    init: ()=>{
        $e73bf42412feb220$var$app.apiRoot = $e73bf42412feb220$var$app.getEnvParam("https://api-transactions.elockers.io/ecom");
        // If hosted on .es domain, adjust API root to also end with .es
        if (typeof window !== "undefined" && window.location.hostname.endsWith(".es")) $e73bf42412feb220$var$app.apiRoot = $e73bf42412feb220$var$app.adjustApiRootForDomain($e73bf42412feb220$var$app.apiRoot);
        $e73bf42412feb220$var$app.live = $e73bf42412feb220$var$app.getEnvParam("1") == 1 ? true : false;
        $e73bf42412feb220$var$app.locale = $e73bf42412feb220$var$app.getEnvParam("en-US");
        $e73bf42412feb220$var$app.adyen.clientKey = $e73bf42412feb220$var$app.getEnvParam("live_KTFHS2OSRFCGTMZ2CMWWTVIMLI3ZBQNI");
        $e73bf42412feb220$var$app.paymentSession = {};
        $e73bf42412feb220$var$app.theme = $e73bf42412feb220$var$app.loadTheme();
    },
    adjustApiRootForDomain: (apiRoot)=>{
        try {
            const url = new URL(apiRoot);
            // Replace the hostname's TLD with .es
            const hostnameParts = url.hostname.split(".");
            if (hostnameParts.length >= 2) {
                // Remove the last part (TLD) and add .es
                hostnameParts[hostnameParts.length - 1] = "es";
                url.hostname = hostnameParts.join(".");
            }
            return url.toString();
        } catch (e) {
            // If URL parsing fails, return original
            return apiRoot;
        }
    },
    loadTheme: ()=>{
        const date = new Date();
        // if december return christmas theme
        if (date.getMonth() === 11) return (0, (/*@__PURE__*/$parcel$interopDefault($883ca2d90835a400$exports))).THEME_CHIRSTMAS;
        return (0, (/*@__PURE__*/$parcel$interopDefault($883ca2d90835a400$exports))).THEME_DEFAULT;
    },
    getEnvParam: (value)=>{
        if (value == undefined) window.alert("Failed to load enviroment");
        return value;
    }
};
var $e73bf42412feb220$export$2e2bcd8739ae039 = $e73bf42412feb220$var$app;



var $c098f254fa0fe6fa$exports = {};
!function(e, t) {
    $c098f254fa0fe6fa$exports = t();
}($c098f254fa0fe6fa$exports, function() {
    "use strict";
    var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
    function t(e) {
        return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
    }
    var r = function(e) {
        return e && e.Math === Math && e;
    }, a = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof e && e) || r("object" == typeof e && e) || function() {
        return this;
    }() || Function("return this")(), n = function(e) {
        try {
            return !!e();
        } catch (e) {
            return !0;
        }
    }, o = !n(function() {
        var e = (function() {}).bind();
        return "function" != typeof e || e.hasOwnProperty("prototype");
    }), i = o, l = Function.prototype, s = l.apply, c = l.call, u = "object" == typeof Reflect && Reflect.apply || (i ? c.bind(s) : function() {
        return c.apply(s, arguments);
    }), d = o, p = Function.prototype, m = p.call, f = d && p.bind.bind(m, m), h = d ? f : function(e) {
        return function() {
            return m.apply(e, arguments);
        };
    }, v = h, y = v({}.toString), g = v("".slice), b = function(e) {
        return g(y(e), 8, -1);
    }, k = b, C = h, _ = function(e) {
        if ("Function" === k(e)) return C(e);
    }, N = "object" == typeof document && document.all, P = {
        all: N,
        IS_HTMLDDA: void 0 === N && void 0 !== N
    }, w = P.all, A = P.IS_HTMLDDA ? function(e) {
        return "function" == typeof e || e === w;
    } : function(e) {
        return "function" == typeof e;
    }, S = {}, I = !n(function() {
        return 7 !== Object.defineProperty({}, 1, {
            get: function() {
                return 7;
            }
        })[1];
    }), E = o, D = Function.prototype.call, R = E ? D.bind(D) : function() {
        return D.apply(D, arguments);
    }, F = {}, x = {}.propertyIsEnumerable, T = Object.getOwnPropertyDescriptor, z = T && !x.call({
        1: 2
    }, 1);
    F.f = z ? function(e) {
        var t = T(this, e);
        return !!t && t.enumerable;
    } : x;
    var O, j, B = function(e, t) {
        return {
            enumerable: !(1 & e),
            configurable: !(2 & e),
            writable: !(4 & e),
            value: t
        };
    }, M = n, L = b, V = Object, U = h("".split), K = M(function() {
        return !V("z").propertyIsEnumerable(0);
    }) ? function(e) {
        return "String" === L(e) ? U(e, "") : V(e);
    } : V, H = function(e) {
        return null == e;
    }, q = H, W = TypeError, G = function(e) {
        if (q(e)) throw new W("Can't call method on " + e);
        return e;
    }, Y = K, Q = G, Z = function(e) {
        return Y(Q(e));
    }, J = A, $ = P.all, X = P.IS_HTMLDDA ? function(e) {
        return "object" == typeof e ? null !== e : J(e) || e === $;
    } : function(e) {
        return "object" == typeof e ? null !== e : J(e);
    }, ee = {}, te = ee, re = a, ae = A, ne = function(e) {
        return ae(e) ? e : void 0;
    }, oe = function(e, t) {
        return arguments.length < 2 ? ne(te[e]) || ne(re[e]) : te[e] && te[e][t] || re[e] && re[e][t];
    }, ie = h({}.isPrototypeOf), le = "undefined" != typeof navigator && String(navigator.userAgent) || "", se = a, ce = le, ue = se.process, de = se.Deno, pe = ue && ue.versions || de && de.version, me = pe && pe.v8;
    me && (j = (O = me.split("."))[0] > 0 && O[0] < 4 ? 1 : +(O[0] + O[1])), !j && ce && (!(O = ce.match(/Edge\/(\d+)/)) || O[1] >= 74) && (O = ce.match(/Chrome\/(\d+)/)) && (j = +O[1]);
    var fe = j, he = fe, ve = n, ye = a.String, ge = !!Object.getOwnPropertySymbols && !ve(function() {
        var e = Symbol("symbol detection");
        return !ye(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && he && he < 41;
    }), be = ge && !Symbol.sham && "symbol" == typeof Symbol.iterator, ke = oe, Ce = A, _e = ie, Ne = Object, Pe = be ? function(e) {
        return "symbol" == typeof e;
    } : function(e) {
        var t = ke("Symbol");
        return Ce(t) && _e(t.prototype, Ne(e));
    }, we = String, Ae = function(e) {
        try {
            return we(e);
        } catch (e) {
            return "Object";
        }
    }, Se = A, Ie = Ae, Ee = TypeError, De = function(e) {
        if (Se(e)) return e;
        throw new Ee(Ie(e) + " is not a function");
    }, Re = De, Fe = H, xe = function(e, t) {
        var r = e[t];
        return Fe(r) ? void 0 : Re(r);
    }, Te = R, ze = A, Oe = X, je = TypeError, Be = {
        exports: {}
    }, Me = a, Le = Object.defineProperty, Ve = function(e, t) {
        try {
            Le(Me, e, {
                value: t,
                configurable: !0,
                writable: !0
            });
        } catch (r) {
            Me[e] = t;
        }
        return t;
    }, Ue = "__core-js_shared__", Ke = a[Ue] || Ve(Ue, {}), He = Ke;
    (Be.exports = function(e, t) {
        return He[e] || (He[e] = void 0 !== t ? t : {});
    })("versions", []).push({
        version: "3.33.3",
        mode: "pure",
        copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
        license: "https://github.com/zloirock/core-js/blob/v3.33.3/LICENSE",
        source: "https://github.com/zloirock/core-js"
    });
    var qe = Be.exports, We = G, Ge = Object, Ye = function(e) {
        return Ge(We(e));
    }, Qe = Ye, Ze = h({}.hasOwnProperty), Je = Object.hasOwn || function(e, t) {
        return Ze(Qe(e), t);
    }, $e = h, Xe = 0, et = Math.random(), tt = $e(1..toString), rt = function(e) {
        return "Symbol(" + (void 0 === e ? "" : e) + ")_" + tt(++Xe + et, 36);
    }, at = qe, nt = Je, ot = rt, it = ge, lt = be, st = a.Symbol, ct = at("wks"), ut = lt ? st.for || st : st && st.withoutSetter || ot, dt = function(e) {
        return nt(ct, e) || (ct[e] = it && nt(st, e) ? st[e] : ut("Symbol." + e)), ct[e];
    }, pt = R, mt = X, ft = Pe, ht = xe, vt = function(e, t) {
        var r, a;
        if ("string" === t && ze(r = e.toString) && !Oe(a = Te(r, e))) return a;
        if (ze(r = e.valueOf) && !Oe(a = Te(r, e))) return a;
        if ("string" !== t && ze(r = e.toString) && !Oe(a = Te(r, e))) return a;
        throw new je("Can't convert object to primitive value");
    }, yt = TypeError, gt = dt("toPrimitive"), bt = function(e, t) {
        if (!mt(e) || ft(e)) return e;
        var r, a = ht(e, gt);
        if (a) {
            if (void 0 === t && (t = "default"), r = pt(a, e, t), !mt(r) || ft(r)) return r;
            throw new yt("Can't convert object to primitive value");
        }
        return void 0 === t && (t = "number"), vt(e, t);
    }, kt = Pe, Ct = function(e) {
        var t = bt(e, "string");
        return kt(t) ? t : t + "";
    }, _t = X, Nt = a.document, Pt = _t(Nt) && _t(Nt.createElement), wt = function(e) {
        return Pt ? Nt.createElement(e) : {};
    }, At = wt, St = !I && !n(function() {
        return 7 !== Object.defineProperty(At("div"), "a", {
            get: function() {
                return 7;
            }
        }).a;
    }), It = I, Et = R, Dt = F, Rt = B, Ft = Z, xt = Ct, Tt = Je, zt = St, Ot = Object.getOwnPropertyDescriptor;
    S.f = It ? Ot : function(e, t) {
        if (e = Ft(e), t = xt(t), zt) try {
            return Ot(e, t);
        } catch (e) {}
        if (Tt(e, t)) return Rt(!Et(Dt.f, e, t), e[t]);
    };
    var jt = n, Bt = A, Mt = /#|\.prototype\./, Lt = function(e, t) {
        var r = Ut[Vt(e)];
        return r === Ht || r !== Kt && (Bt(t) ? jt(t) : !!t);
    }, Vt = Lt.normalize = function(e) {
        return String(e).replace(Mt, ".").toLowerCase();
    }, Ut = Lt.data = {}, Kt = Lt.NATIVE = "N", Ht = Lt.POLYFILL = "P", qt = Lt, Wt = De, Gt = o, Yt = _(_.bind), Qt = function(e, t) {
        return Wt(e), void 0 === t ? e : Gt ? Yt(e, t) : function() {
            return e.apply(t, arguments);
        };
    }, Zt = {}, Jt = I && n(function() {
        return 42 !== Object.defineProperty(function() {}, "prototype", {
            value: 42,
            writable: !1
        }).prototype;
    }), $t = X, Xt = String, er = TypeError, tr = function(e) {
        if ($t(e)) return e;
        throw new er(Xt(e) + " is not an object");
    }, rr = I, ar = St, nr = Jt, or = tr, ir = Ct, lr = TypeError, sr = Object.defineProperty, cr = Object.getOwnPropertyDescriptor, ur = "enumerable", dr = "configurable", pr = "writable";
    Zt.f = rr ? nr ? function(e, t, r) {
        if (or(e), t = ir(t), or(r), "function" == typeof e && "prototype" === t && "value" in r && pr in r && !r[pr]) {
            var a = cr(e, t);
            a && a[pr] && (e[t] = r.value, r = {
                configurable: dr in r ? r[dr] : a[dr],
                enumerable: ur in r ? r[ur] : a[ur],
                writable: !1
            });
        }
        return sr(e, t, r);
    } : sr : function(e, t, r) {
        if (or(e), t = ir(t), or(r), ar) try {
            return sr(e, t, r);
        } catch (e) {}
        if ("get" in r || "set" in r) throw new lr("Accessors not supported");
        return "value" in r && (e[t] = r.value), e;
    };
    var mr = Zt, fr = B, hr = I ? function(e, t, r) {
        return mr.f(e, t, fr(1, r));
    } : function(e, t, r) {
        return e[t] = r, e;
    }, vr = a, yr = u, gr = _, br = A, kr = S.f, Cr = qt, _r = ee, Nr = Qt, Pr = hr, wr = Je, Ar = function(e) {
        var t = function(r, a, n) {
            if (this instanceof t) {
                switch(arguments.length){
                    case 0:
                        return new e;
                    case 1:
                        return new e(r);
                    case 2:
                        return new e(r, a);
                }
                return new e(r, a, n);
            }
            return yr(e, this, arguments);
        };
        return t.prototype = e.prototype, t;
    }, Sr = function(e, t) {
        var r, a, n, o, i, l, s, c, u, d = e.target, p = e.global, m = e.stat, f = e.proto, h = p ? vr : m ? vr[d] : (vr[d] || {}).prototype, v = p ? _r : _r[d] || Pr(_r, d, {})[d], y = v.prototype;
        for(o in t)a = !(r = Cr(p ? o : d + (m ? "." : "#") + o, e.forced)) && h && wr(h, o), l = v[o], a && (s = e.dontCallGetSet ? (u = kr(h, o)) && u.value : h[o]), i = a && s ? s : t[o], a && typeof l == typeof i || (c = e.bind && a ? Nr(i, vr) : e.wrap && a ? Ar(i) : f && br(i) ? gr(i) : i, (e.sham || i && i.sham || l && l.sham) && Pr(c, "sham", !0), Pr(v, o, c), f && (wr(_r, n = d + "Prototype") || Pr(_r, n, {}), Pr(_r[n], o, i), e.real && y && (r || !y[o]) && Pr(y, o, i)));
    }, Ir = rt, Er = qe("keys"), Dr = function(e) {
        return Er[e] || (Er[e] = Ir(e));
    }, Rr = !n(function() {
        function e() {}
        return e.prototype.constructor = null, Object.getPrototypeOf(new e) !== e.prototype;
    }), Fr = Je, xr = A, Tr = Ye, zr = Rr, Or = Dr("IE_PROTO"), jr = Object, Br = jr.prototype, Mr = zr ? jr.getPrototypeOf : function(e) {
        var t = Tr(e);
        if (Fr(t, Or)) return t[Or];
        var r = t.constructor;
        return xr(r) && t instanceof r ? r.prototype : t instanceof jr ? Br : null;
    }, Lr = h, Vr = De, Ur = A, Kr = String, Hr = TypeError, qr = function(e, t, r) {
        try {
            return Lr(Vr(Object.getOwnPropertyDescriptor(e, t)[r]));
        } catch (e) {}
    }, Wr = tr, Gr = function(e) {
        if ("object" == typeof e || Ur(e)) return e;
        throw new Hr("Can't set " + Kr(e) + " as a prototype");
    }, Yr = Object.setPrototypeOf || ("__proto__" in {} ? function() {
        var e, t = !1, r = {};
        try {
            (e = qr(Object.prototype, "__proto__", "set"))(r, []), t = r instanceof Array;
        } catch (e) {}
        return function(r, a) {
            return Wr(r), Gr(a), t ? e(r, a) : r.__proto__ = a, r;
        };
    }() : void 0), Qr = {}, Zr = Math.ceil, Jr = Math.floor, $r = Math.trunc || function(e) {
        var t = +e;
        return (t > 0 ? Jr : Zr)(t);
    }, Xr = $r, ea = function(e) {
        var t = +e;
        return t != t || 0 === t ? 0 : Xr(t);
    }, ta = ea, ra = Math.max, aa = Math.min, na = function(e, t) {
        var r = ta(e);
        return r < 0 ? ra(r + t, 0) : aa(r, t);
    }, oa = ea, ia = Math.min, la = function(e) {
        return e > 0 ? ia(oa(e), 9007199254740991) : 0;
    }, sa = la, ca = function(e) {
        return sa(e.length);
    }, ua = Z, da = na, pa = ca, ma = function(e) {
        return function(t, r, a) {
            var n, o = ua(t), i = pa(o), l = da(a, i);
            if (e && r != r) {
                for(; i > l;)if ((n = o[l++]) != n) return !0;
            } else for(; i > l; l++)if ((e || l in o) && o[l] === r) return e || l || 0;
            return !e && -1;
        };
    }, fa = {
        includes: ma(!0),
        indexOf: ma(!1)
    }, ha = {}, va = Je, ya = Z, ga = fa.indexOf, ba = ha, ka = h([].push), Ca = function(e, t) {
        var r, a = ya(e), n = 0, o = [];
        for(r in a)!va(ba, r) && va(a, r) && ka(o, r);
        for(; t.length > n;)va(a, r = t[n++]) && (~ga(o, r) || ka(o, r));
        return o;
    }, _a = [
        "constructor",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "toLocaleString",
        "toString",
        "valueOf"
    ], Na = Ca, Pa = _a.concat("length", "prototype");
    Qr.f = Object.getOwnPropertyNames || function(e) {
        return Na(e, Pa);
    };
    var wa = {};
    wa.f = Object.getOwnPropertySymbols;
    var Aa = oe, Sa = Qr, Ia = wa, Ea = tr, Da = h([].concat), Ra = Aa("Reflect", "ownKeys") || function(e) {
        var t = Sa.f(Ea(e)), r = Ia.f;
        return r ? Da(t, r(e)) : t;
    }, Fa = Je, xa = Ra, Ta = S, za = Zt, Oa = {}, ja = Ca, Ba = _a, Ma = Object.keys || function(e) {
        return ja(e, Ba);
    }, La = I, Va = Jt, Ua = Zt, Ka = tr, Ha = Z, qa = Ma;
    Oa.f = La && !Va ? Object.defineProperties : function(e, t) {
        Ka(e);
        for(var r, a = Ha(t), n = qa(t), o = n.length, i = 0; o > i;)Ua.f(e, r = n[i++], a[r]);
        return e;
    };
    var Wa, Ga = oe("document", "documentElement"), Ya = tr, Qa = Oa, Za = _a, Ja = ha, $a = Ga, Xa = wt, en = "prototype", tn = "script", rn = Dr("IE_PROTO"), an = function() {}, nn = function(e) {
        return "<" + tn + ">" + e + "</" + tn + ">";
    }, on = function(e) {
        e.write(nn("")), e.close();
        var t = e.parentWindow.Object;
        return e = null, t;
    }, ln = function() {
        try {
            Wa = new ActiveXObject("htmlfile");
        } catch (e) {}
        var e, t, r;
        ln = "undefined" != typeof document ? document.domain && Wa ? on(Wa) : (t = Xa("iframe"), r = "java" + tn + ":", t.style.display = "none", $a.appendChild(t), t.src = String(r), (e = t.contentWindow.document).open(), e.write(nn("document.F=Object")), e.close(), e.F) : on(Wa);
        for(var a = Za.length; a--;)delete ln[en][Za[a]];
        return ln();
    };
    Ja[rn] = !0;
    var sn = Object.create || function(e, t) {
        var r;
        return null !== e ? (an[en] = Ya(e), r = new an, an[en] = null, r[rn] = e) : r = ln(), void 0 === t ? r : Qa.f(r, t);
    }, cn = X, un = hr, dn = Error, pn = h("".replace), mn = String(new dn("zxcasd").stack), fn = /\n\s*at [^:]*:[^\n]*/, hn = fn.test(mn), vn = B, yn = !n(function() {
        var e = new Error("a");
        return !("stack" in e) || (Object.defineProperty(e, "stack", vn(1, 7)), 7 !== e.stack);
    }), gn = hr, bn = function(e, t) {
        if (hn && "string" == typeof e && !dn.prepareStackTrace) for(; t--;)e = pn(e, fn, "");
        return e;
    }, kn = yn, Cn = Error.captureStackTrace, _n = {}, Nn = _n, Pn = dt("iterator"), wn = Array.prototype, An = function(e) {
        return void 0 !== e && (Nn.Array === e || wn[Pn] === e);
    }, Sn = {};
    Sn[dt("toStringTag")] = "z";
    var In = "[object z]" === String(Sn), En = In, Dn = A, Rn = b, Fn = dt("toStringTag"), xn = Object, Tn = "Arguments" === Rn(function() {
        return arguments;
    }()), zn = En ? Rn : function(e) {
        var t, r, a;
        return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = function(e, t) {
            try {
                return e[t];
            } catch (e) {}
        }(t = xn(e), Fn)) ? r : Tn ? Rn(t) : "Object" === (a = Rn(t)) && Dn(t.callee) ? "Arguments" : a;
    }, On = zn, jn = xe, Bn = H, Mn = _n, Ln = dt("iterator"), Vn = function(e) {
        if (!Bn(e)) return jn(e, Ln) || jn(e, "@@iterator") || Mn[On(e)];
    }, Un = R, Kn = De, Hn = tr, qn = Ae, Wn = Vn, Gn = TypeError, Yn = function(e, t) {
        var r = arguments.length < 2 ? Wn(e) : t;
        if (Kn(r)) return Hn(Un(r, e));
        throw new Gn(qn(e) + " is not iterable");
    }, Qn = R, Zn = tr, Jn = xe, $n = function(e, t, r) {
        var a, n;
        Zn(e);
        try {
            if (!(a = Jn(e, "return"))) {
                if ("throw" === t) throw r;
                return r;
            }
            a = Qn(a, e);
        } catch (e) {
            n = !0, a = e;
        }
        if ("throw" === t) throw r;
        if (n) throw a;
        return Zn(a), r;
    }, Xn = Qt, eo = R, to = tr, ro = Ae, ao = An, no = ca, oo = ie, io = Yn, lo = Vn, so = $n, co = TypeError, uo = function(e, t) {
        this.stopped = e, this.result = t;
    }, po = uo.prototype, mo = function(e, t, r) {
        var a, n, o, i, l, s, c, u = r && r.that, d = !(!r || !r.AS_ENTRIES), p = !(!r || !r.IS_RECORD), m = !(!r || !r.IS_ITERATOR), f = !(!r || !r.INTERRUPTED), h = Xn(t, u), v = function(e) {
            return a && so(a, "normal", e), new uo(!0, e);
        }, y = function(e) {
            return d ? (to(e), f ? h(e[0], e[1], v) : h(e[0], e[1])) : f ? h(e, v) : h(e);
        };
        if (p) a = e.iterator;
        else if (m) a = e;
        else {
            if (!(n = lo(e))) throw new co(ro(e) + " is not iterable");
            if (ao(n)) {
                for(o = 0, i = no(e); i > o; o++)if ((l = y(e[o])) && oo(po, l)) return l;
                return new uo(!1);
            }
            a = io(e, n);
        }
        for(s = p ? e.next : a.next; !(c = eo(s, a)).done;){
            try {
                l = y(c.value);
            } catch (e) {
                so(a, "throw", e);
            }
            if ("object" == typeof l && l && oo(po, l)) return l;
        }
        return new uo(!1);
    }, fo = zn, ho = String, vo = function(e) {
        if ("Symbol" === fo(e)) throw new TypeError("Cannot convert a Symbol value to a string");
        return ho(e);
    }, yo = vo, go = Sr, bo = ie, ko = Mr, Co = Yr, _o = function(e, t, r) {
        for(var a = xa(t), n = za.f, o = Ta.f, i = 0; i < a.length; i++){
            var l = a[i];
            Fa(e, l) || r && Fa(r, l) || n(e, l, o(t, l));
        }
    }, No = sn, Po = hr, wo = B, Ao = function(e, t) {
        cn(t) && "cause" in t && un(e, "cause", t.cause);
    }, So = function(e, t, r, a) {
        kn && (Cn ? Cn(e, t) : gn(e, "stack", bn(r, a)));
    }, Io = mo, Eo = function(e, t) {
        return void 0 === e ? arguments.length < 2 ? "" : t : yo(e);
    }, Do = dt("toStringTag"), Ro = Error, Fo = [].push, xo = function(e, t) {
        var r, a = bo(To, this);
        Co ? r = Co(new Ro, a ? ko(this) : To) : (r = a ? this : No(To), Po(r, Do, "Error")), void 0 !== t && Po(r, "message", Eo(t)), So(r, xo, r.stack, 1), arguments.length > 2 && Ao(r, arguments[2]);
        var n = [];
        return Io(e, Fo, {
            that: n
        }), Po(r, "errors", n), r;
    };
    Co ? Co(xo, Ro) : _o(xo, Ro, {
        name: !0
    });
    var To = xo.prototype = No(Ro.prototype, {
        constructor: wo(1, xo),
        message: wo(1, ""),
        name: wo(1, "AggregateError")
    });
    go({
        global: !0,
        constructor: !0,
        arity: 2
    }, {
        AggregateError: xo
    });
    var zo, Oo, jo, Bo = A, Mo = a.WeakMap, Lo = Bo(Mo) && /native code/.test(String(Mo)), Vo = a, Uo = X, Ko = hr, Ho = Je, qo = Ke, Wo = Dr, Go = ha, Yo = "Object already initialized", Qo = Vo.TypeError, Zo = Vo.WeakMap;
    if (Lo || qo.state) {
        var Jo = qo.state || (qo.state = new Zo);
        Jo.get = Jo.get, Jo.has = Jo.has, Jo.set = Jo.set, zo = function(e, t) {
            if (Jo.has(e)) throw new Qo(Yo);
            return t.facade = e, Jo.set(e, t), t;
        }, Oo = function(e) {
            return Jo.get(e) || {};
        }, jo = function(e) {
            return Jo.has(e);
        };
    } else {
        var $o = Wo("state");
        Go[$o] = !0, zo = function(e, t) {
            if (Ho(e, $o)) throw new Qo(Yo);
            return t.facade = e, Ko(e, $o, t), t;
        }, Oo = function(e) {
            return Ho(e, $o) ? e[$o] : {};
        }, jo = function(e) {
            return Ho(e, $o);
        };
    }
    var Xo, ei, ti, ri = {
        set: zo,
        get: Oo,
        has: jo,
        enforce: function(e) {
            return jo(e) ? Oo(e) : zo(e, {});
        },
        getterFor: function(e) {
            return function(t) {
                var r;
                if (!Uo(t) || (r = Oo(t)).type !== e) throw new Qo("Incompatible receiver, " + e + " required");
                return r;
            };
        }
    }, ai = I, ni = Je, oi = Function.prototype, ii = ai && Object.getOwnPropertyDescriptor, li = ni(oi, "name"), si = {
        EXISTS: li,
        PROPER: li && "something" === (function() {}).name,
        CONFIGURABLE: li && (!ai || ai && ii(oi, "name").configurable)
    }, ci = hr, ui = function(e, t, r, a) {
        return a && a.enumerable ? e[t] = r : ci(e, t, r), e;
    }, di = n, pi = A, mi = X, fi = sn, hi = Mr, vi = ui, yi = dt("iterator"), gi = !1;
    [].keys && ("next" in (ti = [].keys()) ? (ei = hi(hi(ti))) !== Object.prototype && (Xo = ei) : gi = !0);
    var bi = !mi(Xo) || di(function() {
        var e = {};
        return Xo[yi].call(e) !== e;
    });
    pi((Xo = bi ? {} : fi(Xo))[yi]) || vi(Xo, yi, function() {
        return this;
    });
    var ki = {
        IteratorPrototype: Xo,
        BUGGY_SAFARI_ITERATORS: gi
    }, Ci = zn, _i = In ? ({}).toString : function() {
        return "[object " + Ci(this) + "]";
    }, Ni = In, Pi = Zt.f, wi = hr, Ai = Je, Si = _i, Ii = dt("toStringTag"), Ei = function(e, t, r, a) {
        if (e) {
            var n = r ? e : e.prototype;
            Ai(n, Ii) || Pi(n, Ii, {
                configurable: !0,
                value: t
            }), a && !Ni && wi(n, "toString", Si);
        }
    }, Di = ki.IteratorPrototype, Ri = sn, Fi = B, xi = Ei, Ti = _n, zi = function() {
        return this;
    }, Oi = function(e, t, r, a) {
        var n = t + " Iterator";
        return e.prototype = Ri(Di, {
            next: Fi(+!a, r)
        }), xi(e, n, !1, !0), Ti[n] = zi, e;
    }, ji = Sr, Bi = R, Mi = si, Li = Oi, Vi = Mr, Ui = Ei, Ki = ui, Hi = _n, qi = ki, Wi = Mi.PROPER, Gi = qi.BUGGY_SAFARI_ITERATORS, Yi = dt("iterator"), Qi = "keys", Zi = "values", Ji = "entries", $i = function() {
        return this;
    }, Xi = function(e, t, r, a, n, o, i) {
        Li(r, t, a);
        var l, s, c, u = function(e) {
            if (e === n && h) return h;
            if (!Gi && e && e in m) return m[e];
            switch(e){
                case Qi:
                case Zi:
                case Ji:
                    return function() {
                        return new r(this, e);
                    };
            }
            return function() {
                return new r(this);
            };
        }, d = t + " Iterator", p = !1, m = e.prototype, f = m[Yi] || m["@@iterator"] || n && m[n], h = !Gi && f || u(n), v = "Array" === t && m.entries || f;
        if (v && (l = Vi(v.call(new e))) !== Object.prototype && l.next && (Ui(l, d, !0, !0), Hi[d] = $i), Wi && n === Zi && f && f.name !== Zi && (p = !0, h = function() {
            return Bi(f, this);
        }), n) {
            if (s = {
                values: u(Zi),
                keys: o ? h : u(Qi),
                entries: u(Ji)
            }, i) for(c in s)(Gi || p || !(c in m)) && Ki(m, c, s[c]);
            else ji({
                target: t,
                proto: !0,
                forced: Gi || p
            }, s);
        }
        return i && m[Yi] !== h && Ki(m, Yi, h, {
            name: n
        }), Hi[t] = h, s;
    }, el = function(e, t) {
        return {
            value: e,
            done: t
        };
    }, tl = Z, rl = function() {}, al = _n, nl = ri, ol = (Zt.f, Xi), il = el, ll = "Array Iterator", sl = nl.set, cl = nl.getterFor(ll);
    ol(Array, "Array", function(e, t) {
        sl(this, {
            type: ll,
            target: tl(e),
            index: 0,
            kind: t
        });
    }, function() {
        var e = cl(this), t = e.target, r = e.index++;
        if (!t || r >= t.length) return e.target = void 0, il(void 0, !0);
        switch(e.kind){
            case "keys":
                return il(r, !1);
            case "values":
                return il(t[r], !1);
        }
        return il([
            r,
            t[r]
        ], !1);
    }, "values");
    al.Arguments = al.Array;
    rl(), rl(), rl();
    var ul = "process" === b(a.process), dl = Zt, pl = function(e, t, r) {
        return dl.f(e, t, r);
    }, ml = oe, fl = pl, hl = I, vl = dt("species"), yl = function(e) {
        var t = ml(e);
        hl && t && !t[vl] && fl(t, vl, {
            configurable: !0,
            get: function() {
                return this;
            }
        });
    }, gl = ie, bl = TypeError, kl = function(e, t) {
        if (gl(t, e)) return e;
        throw new bl("Incorrect invocation");
    }, Cl = A, _l = Ke, Nl = h(Function.toString);
    Cl(_l.inspectSource) || (_l.inspectSource = function(e) {
        return Nl(e);
    });
    var Pl = _l.inspectSource, wl = h, Al = n, Sl = A, Il = zn, El = Pl, Dl = function() {}, Rl = [], Fl = oe("Reflect", "construct"), xl = /^\s*(?:class|function)\b/, Tl = wl(xl.exec), zl = !xl.test(Dl), Ol = function(e) {
        if (!Sl(e)) return !1;
        try {
            return Fl(Dl, Rl, e), !0;
        } catch (e) {
            return !1;
        }
    }, jl = function(e) {
        if (!Sl(e)) return !1;
        switch(Il(e)){
            case "AsyncFunction":
            case "GeneratorFunction":
            case "AsyncGeneratorFunction":
                return !1;
        }
        try {
            return zl || !!Tl(xl, El(e));
        } catch (e) {
            return !0;
        }
    };
    jl.sham = !0;
    var Bl, Ml, Ll, Vl, Ul = !Fl || Al(function() {
        var e;
        return Ol(Ol.call) || !Ol(Object) || !Ol(function() {
            e = !0;
        }) || e;
    }) ? jl : Ol, Kl = Ul, Hl = Ae, ql = TypeError, Wl = function(e) {
        if (Kl(e)) return e;
        throw new ql(Hl(e) + " is not a constructor");
    }, Gl = tr, Yl = Wl, Ql = H, Zl = dt("species"), Jl = function(e, t) {
        var r, a = Gl(e).constructor;
        return void 0 === a || Ql(r = Gl(a)[Zl]) ? t : Yl(r);
    }, $l = h([].slice), Xl = TypeError, es = function(e, t) {
        if (e < t) throw new Xl("Not enough arguments");
        return e;
    }, ts = /(?:ipad|iphone|ipod).*applewebkit/i.test(le), rs = a, as = u, ns = Qt, os = A, is = Je, ls = n, ss = Ga, cs = $l, us = wt, ds = es, ps = ts, ms = ul, fs = rs.setImmediate, hs = rs.clearImmediate, vs = rs.process, ys = rs.Dispatch, gs = rs.Function, bs = rs.MessageChannel, ks = rs.String, Cs = 0, _s = {}, Ns = "onreadystatechange";
    ls(function() {
        Bl = rs.location;
    });
    var Ps = function(e) {
        if (is(_s, e)) {
            var t = _s[e];
            delete _s[e], t();
        }
    }, ws = function(e) {
        return function() {
            Ps(e);
        };
    }, As = function(e) {
        Ps(e.data);
    }, Ss = function(e) {
        rs.postMessage(ks(e), Bl.protocol + "//" + Bl.host);
    };
    fs && hs || (fs = function(e) {
        ds(arguments.length, 1);
        var t = os(e) ? e : gs(e), r = cs(arguments, 1);
        return _s[++Cs] = function() {
            as(t, void 0, r);
        }, Ml(Cs), Cs;
    }, hs = function(e) {
        delete _s[e];
    }, ms ? Ml = function(e) {
        vs.nextTick(ws(e));
    } : ys && ys.now ? Ml = function(e) {
        ys.now(ws(e));
    } : bs && !ps ? (Vl = (Ll = new bs).port2, Ll.port1.onmessage = As, Ml = ns(Vl.postMessage, Vl)) : rs.addEventListener && os(rs.postMessage) && !rs.importScripts && Bl && "file:" !== Bl.protocol && !ls(Ss) ? (Ml = Ss, rs.addEventListener("message", As, !1)) : Ml = Ns in us("script") ? function(e) {
        ss.appendChild(us("script"))[Ns] = function() {
            ss.removeChild(this), Ps(e);
        };
    } : function(e) {
        setTimeout(ws(e), 0);
    });
    var Is = {
        set: fs,
        clear: hs
    }, Es = function() {
        this.head = null, this.tail = null;
    };
    Es.prototype = {
        add: function(e) {
            var t = {
                item: e,
                next: null
            }, r = this.tail;
            r ? r.next = t : this.head = t, this.tail = t;
        },
        get: function() {
            var e = this.head;
            if (e) return null === (this.head = e.next) && (this.tail = null), e.item;
        }
    };
    var Ds, Rs, Fs, xs, Ts, zs = Es, Os = /ipad|iphone|ipod/i.test(le) && "undefined" != typeof Pebble, js = /web0s(?!.*chrome)/i.test(le), Bs = a, Ms = Qt, Ls = S.f, Vs = Is.set, Us = zs, Ks = ts, Hs = Os, qs = js, Ws = ul, Gs = Bs.MutationObserver || Bs.WebKitMutationObserver, Ys = Bs.document, Qs = Bs.process, Zs = Bs.Promise, Js = Ls(Bs, "queueMicrotask"), $s = Js && Js.value;
    if (!$s) {
        var Xs = new Us, ec = function() {
            var e, t;
            for(Ws && (e = Qs.domain) && e.exit(); t = Xs.get();)try {
                t();
            } catch (e) {
                throw Xs.head && Ds(), e;
            }
            e && e.enter();
        };
        Ks || Ws || qs || !Gs || !Ys ? !Hs && Zs && Zs.resolve ? ((xs = Zs.resolve(void 0)).constructor = Zs, Ts = Ms(xs.then, xs), Ds = function() {
            Ts(ec);
        }) : Ws ? Ds = function() {
            Qs.nextTick(ec);
        } : (Vs = Ms(Vs, Bs), Ds = function() {
            Vs(ec);
        }) : (Rs = !0, Fs = Ys.createTextNode(""), new Gs(ec).observe(Fs, {
            characterData: !0
        }), Ds = function() {
            Fs.data = Rs = !Rs;
        }), $s = function(e) {
            Xs.head || Ds(), Xs.add(e);
        };
    }
    var tc = $s, rc = function(e) {
        try {
            return {
                error: !1,
                value: e()
            };
        } catch (e) {
            return {
                error: !0,
                value: e
            };
        }
    }, ac = a.Promise, nc = "object" == typeof Deno && Deno && "object" == typeof Deno.version, oc = !nc && !ul && "object" == typeof window && "object" == typeof document, ic = a, lc = ac, sc = A, cc = qt, uc = Pl, dc = dt, pc = oc, mc = nc, fc = fe, hc = lc && lc.prototype, vc = dc("species"), yc = !1, gc = sc(ic.PromiseRejectionEvent), bc = cc("Promise", function() {
        var e = uc(lc), t = e !== String(lc);
        if (!t && 66 === fc) return !0;
        if (!hc.catch || !hc.finally) return !0;
        if (!fc || fc < 51 || !/native code/.test(e)) {
            var r = new lc(function(e) {
                e(1);
            }), a = function(e) {
                e(function() {}, function() {});
            };
            if ((r.constructor = {})[vc] = a, !(yc = r.then(function() {}) instanceof a)) return !0;
        }
        return !t && (pc || mc) && !gc;
    }), kc = {
        CONSTRUCTOR: bc,
        REJECTION_EVENT: gc,
        SUBCLASSING: yc
    }, Cc = {}, _c = De, Nc = TypeError, Pc = function(e) {
        var t, r;
        this.promise = new e(function(e, a) {
            if (void 0 !== t || void 0 !== r) throw new Nc("Bad Promise constructor");
            t = e, r = a;
        }), this.resolve = _c(t), this.reject = _c(r);
    };
    Cc.f = function(e) {
        return new Pc(e);
    };
    var wc, Ac, Sc = Sr, Ic = ul, Ec = a, Dc = R, Rc = ui, Fc = Ei, xc = yl, Tc = De, zc = A, Oc = X, jc = kl, Bc = Jl, Mc = Is.set, Lc = tc, Vc = function(e, t) {
        try {
            1 === arguments.length ? console.error(e) : console.error(e, t);
        } catch (e) {}
    }, Uc = rc, Kc = zs, Hc = ri, qc = ac, Wc = kc, Gc = Cc, Yc = "Promise", Qc = Wc.CONSTRUCTOR, Zc = Wc.REJECTION_EVENT, Jc = Hc.getterFor(Yc), $c = Hc.set, Xc = qc && qc.prototype, eu = qc, tu = Xc, ru = Ec.TypeError, au = Ec.document, nu = Ec.process, ou = Gc.f, iu = ou, lu = !!(au && au.createEvent && Ec.dispatchEvent), su = "unhandledrejection", cu = function(e) {
        var t;
        return !(!Oc(e) || !zc(t = e.then)) && t;
    }, uu = function(e, t) {
        var r, a, n, o = t.value, i = 1 === t.state, l = i ? e.ok : e.fail, s = e.resolve, c = e.reject, u = e.domain;
        try {
            l ? (i || (2 === t.rejection && hu(t), t.rejection = 1), !0 === l ? r = o : (u && u.enter(), r = l(o), u && (u.exit(), n = !0)), r === e.promise ? c(new ru("Promise-chain cycle")) : (a = cu(r)) ? Dc(a, r, s, c) : s(r)) : c(o);
        } catch (e) {
            u && !n && u.exit(), c(e);
        }
    }, du = function(e, t) {
        e.notified || (e.notified = !0, Lc(function() {
            for(var r, a = e.reactions; r = a.get();)uu(r, e);
            e.notified = !1, t && !e.rejection && mu(e);
        }));
    }, pu = function(e, t, r) {
        var a, n;
        lu ? ((a = au.createEvent("Event")).promise = t, a.reason = r, a.initEvent(e, !1, !0), Ec.dispatchEvent(a)) : a = {
            promise: t,
            reason: r
        }, !Zc && (n = Ec["on" + e]) ? n(a) : e === su && Vc("Unhandled promise rejection", r);
    }, mu = function(e) {
        Dc(Mc, Ec, function() {
            var t, r = e.facade, a = e.value;
            if (fu(e) && (t = Uc(function() {
                Ic ? nu.emit("unhandledRejection", a, r) : pu(su, r, a);
            }), e.rejection = Ic || fu(e) ? 2 : 1, t.error)) throw t.value;
        });
    }, fu = function(e) {
        return 1 !== e.rejection && !e.parent;
    }, hu = function(e) {
        Dc(Mc, Ec, function() {
            var t = e.facade;
            Ic ? nu.emit("rejectionHandled", t) : pu("rejectionhandled", t, e.value);
        });
    }, vu = function(e, t, r) {
        return function(a) {
            e(t, a, r);
        };
    }, yu = function(e, t, r) {
        e.done || (e.done = !0, r && (e = r), e.value = t, e.state = 2, du(e, !0));
    }, gu = function(e, t, r) {
        if (!e.done) {
            e.done = !0, r && (e = r);
            try {
                if (e.facade === t) throw new ru("Promise can't be resolved itself");
                var a = cu(t);
                a ? Lc(function() {
                    var r = {
                        done: !1
                    };
                    try {
                        Dc(a, t, vu(gu, r, e), vu(yu, r, e));
                    } catch (t) {
                        yu(r, t, e);
                    }
                }) : (e.value = t, e.state = 1, du(e, !1));
            } catch (t) {
                yu({
                    done: !1
                }, t, e);
            }
        }
    };
    Qc && (eu = function(e) {
        jc(this, tu), Tc(e), Dc(wc, this);
        var t = Jc(this);
        try {
            e(vu(gu, t), vu(yu, t));
        } catch (e) {
            yu(t, e);
        }
    }, tu = eu.prototype, (wc = function(e) {
        $c(this, {
            type: Yc,
            done: !1,
            notified: !1,
            parent: !1,
            reactions: new Kc,
            rejection: !1,
            state: 0,
            value: void 0
        });
    }).prototype = Rc(tu, "then", function(e, t) {
        var r = Jc(this), a = ou(Bc(this, eu));
        return r.parent = !0, a.ok = !zc(e) || e, a.fail = zc(t) && t, a.domain = Ic ? nu.domain : void 0, 0 === r.state ? r.reactions.add(a) : Lc(function() {
            uu(a, r);
        }), a.promise;
    }), Ac = function() {
        var e = new wc, t = Jc(e);
        this.promise = e, this.resolve = vu(gu, t), this.reject = vu(yu, t);
    }, Gc.f = ou = function(e) {
        return e === eu || undefined === e ? new Ac(e) : iu(e);
    }), Sc({
        global: !0,
        constructor: !0,
        wrap: !0,
        forced: Qc
    }, {
        Promise: eu
    }), Fc(eu, Yc, !1, !0), xc(Yc);
    var bu = dt("iterator"), ku = !1;
    try {
        var Cu = 0, _u = {
            next: function() {
                return {
                    done: !!Cu++
                };
            },
            return: function() {
                ku = !0;
            }
        };
        _u[bu] = function() {
            return this;
        }, Array.from(_u, function() {
            throw 2;
        });
    } catch (RV) {}
    var Nu = function(e, t) {
        try {
            if (!t && !ku) return !1;
        } catch (e) {
            return !1;
        }
        var r = !1;
        try {
            var a = {};
            a[bu] = function() {
                return {
                    next: function() {
                        return {
                            done: r = !0
                        };
                    }
                };
            }, e(a);
        } catch (e) {}
        return r;
    }, Pu = ac, wu = kc.CONSTRUCTOR || !Nu(function(e) {
        Pu.all(e).then(void 0, function() {});
    }), Au = R, Su = De, Iu = Cc, Eu = rc, Du = mo;
    Sr({
        target: "Promise",
        stat: !0,
        forced: wu
    }, {
        all: function(e) {
            var t = this, r = Iu.f(t), a = r.resolve, n = r.reject, o = Eu(function() {
                var r = Su(t.resolve), o = [], i = 0, l = 1;
                Du(e, function(e) {
                    var s = i++, c = !1;
                    l++, Au(r, t, e).then(function(e) {
                        c || (c = !0, o[s] = e, --l || a(o));
                    }, n);
                }), --l || a(o);
            });
            return o.error && n(o.value), r.promise;
        }
    });
    var Ru = Sr, Fu = kc.CONSTRUCTOR;
    ac && ac.prototype, Ru({
        target: "Promise",
        proto: !0,
        forced: Fu,
        real: !0
    }, {
        catch: function(e) {
            return this.then(void 0, e);
        }
    });
    var xu = R, Tu = De, zu = Cc, Ou = rc, ju = mo;
    Sr({
        target: "Promise",
        stat: !0,
        forced: wu
    }, {
        race: function(e) {
            var t = this, r = zu.f(t), a = r.reject, n = Ou(function() {
                var n = Tu(t.resolve);
                ju(e, function(e) {
                    xu(n, t, e).then(r.resolve, a);
                });
            });
            return n.error && a(n.value), r.promise;
        }
    });
    var Bu = R, Mu = Cc;
    Sr({
        target: "Promise",
        stat: !0,
        forced: kc.CONSTRUCTOR
    }, {
        reject: function(e) {
            var t = Mu.f(this);
            return Bu(t.reject, void 0, e), t.promise;
        }
    });
    var Lu = tr, Vu = X, Uu = Cc, Ku = function(e, t) {
        if (Lu(e), Vu(t) && t.constructor === e) return t;
        var r = Uu.f(e);
        return (0, r.resolve)(t), r.promise;
    }, Hu = Sr, qu = ac, Wu = kc.CONSTRUCTOR, Gu = Ku, Yu = oe("Promise"), Qu = !Wu;
    Hu({
        target: "Promise",
        stat: !0,
        forced: true
    }, {
        resolve: function(e) {
            return Gu(Qu && this === Yu ? qu : this, e);
        }
    });
    var Zu = R, Ju = De, $u = Cc, Xu = rc, ed = mo;
    Sr({
        target: "Promise",
        stat: !0,
        forced: wu
    }, {
        allSettled: function(e) {
            var t = this, r = $u.f(t), a = r.resolve, n = r.reject, o = Xu(function() {
                var r = Ju(t.resolve), n = [], o = 0, i = 1;
                ed(e, function(e) {
                    var l = o++, s = !1;
                    i++, Zu(r, t, e).then(function(e) {
                        s || (s = !0, n[l] = {
                            status: "fulfilled",
                            value: e
                        }, --i || a(n));
                    }, function(e) {
                        s || (s = !0, n[l] = {
                            status: "rejected",
                            reason: e
                        }, --i || a(n));
                    });
                }), --i || a(n);
            });
            return o.error && n(o.value), r.promise;
        }
    });
    var td = R, rd = De, ad = oe, nd = Cc, od = rc, id = mo, ld = "No one promise resolved";
    Sr({
        target: "Promise",
        stat: !0,
        forced: wu
    }, {
        any: function(e) {
            var t = this, r = ad("AggregateError"), a = nd.f(t), n = a.resolve, o = a.reject, i = od(function() {
                var a = rd(t.resolve), i = [], l = 0, s = 1, c = !1;
                id(e, function(e) {
                    var u = l++, d = !1;
                    s++, td(a, t, e).then(function(e) {
                        d || c || (c = !0, n(e));
                    }, function(e) {
                        d || c || (d = !0, i[u] = e, --s || o(new r(i, ld)));
                    });
                }), --s || o(new r(i, ld));
            });
            return i.error && o(i.value), a.promise;
        }
    });
    var sd = Sr, cd = ac, ud = n, dd = oe, pd = A, md = Jl, fd = Ku, hd = cd && cd.prototype;
    sd({
        target: "Promise",
        proto: !0,
        real: !0,
        forced: !!cd && ud(function() {
            hd.finally.call({
                then: function() {}
            }, function() {});
        })
    }, {
        finally: function(e) {
            var t = md(this, dd("Promise")), r = pd(e);
            return this.then(r ? function(r) {
                return fd(t, e()).then(function() {
                    return r;
                });
            } : e, r ? function(r) {
                return fd(t, e()).then(function() {
                    throw r;
                });
            } : e);
        }
    });
    var vd = h, yd = ea, gd = vo, bd = G, kd = vd("".charAt), Cd = vd("".charCodeAt), _d = vd("".slice), Nd = function(e) {
        return function(t, r) {
            var a, n, o = gd(bd(t)), i = yd(r), l = o.length;
            return i < 0 || i >= l ? e ? "" : void 0 : (a = Cd(o, i)) < 55296 || a > 56319 || i + 1 === l || (n = Cd(o, i + 1)) < 56320 || n > 57343 ? e ? kd(o, i) : a : e ? _d(o, i, i + 2) : n - 56320 + (a - 55296 << 10) + 65536;
        };
    }, Pd = {
        codeAt: Nd(!1),
        charAt: Nd(!0)
    }, wd = Pd.charAt, Ad = vo, Sd = ri, Id = Xi, Ed = el, Dd = "String Iterator", Rd = Sd.set, Fd = Sd.getterFor(Dd);
    Id(String, "String", function(e) {
        Rd(this, {
            type: Dd,
            string: Ad(e),
            index: 0
        });
    }, function() {
        var e, t = Fd(this), r = t.string, a = t.index;
        return a >= r.length ? Ed(void 0, !0) : (e = wd(r, a), t.index += e.length, Ed(e, !1));
    });
    var xd = ee.Promise, Td = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
    }, zd = a, Od = zn, jd = hr, Bd = _n, Md = dt("toStringTag");
    for(var Ld in Td){
        var Vd = zd[Ld], Ud = Vd && Vd.prototype;
        Ud && Od(Ud) !== Md && jd(Ud, Md, Ld), Bd[Ld] = Bd.Array;
    }
    var Kd = xd, Hd = Cc;
    Sr({
        target: "Promise",
        stat: !0
    }, {
        withResolvers: function() {
            var e = Hd.f(this);
            return {
                promise: e.promise,
                resolve: e.resolve,
                reject: e.reject
            };
        }
    });
    var qd = Kd, Wd = Cc, Gd = rc;
    Sr({
        target: "Promise",
        stat: !0,
        forced: !0
    }, {
        try: function(e) {
            var t = Wd.f(this), r = Gd(e);
            return (r.error ? t.reject : t.resolve)(r.value), t.promise;
        }
    });
    var Yd = qd, Qd = t(Yd);
    function Zd(e, t, r, a, n, o, i) {
        try {
            var l = e[o](i), s = l.value;
        } catch (e) {
            return void r(e);
        }
        l.done ? t(s) : Qd.resolve(s).then(a, n);
    }
    function Jd(e) {
        return function() {
            var t = this, r = arguments;
            return new Qd(function(a, n) {
                var o = e.apply(t, r);
                function i(e) {
                    Zd(o, a, n, i, l, "next", e);
                }
                function l(e) {
                    Zd(o, a, n, i, l, "throw", e);
                }
                i(void 0);
            });
        };
    }
    var $d = {
        exports: {}
    }, Xd = {
        exports: {}
    }, ep = b, tp = Array.isArray || function(e) {
        return "Array" === ep(e);
    }, rp = TypeError, ap = function(e) {
        if (e > 9007199254740991) throw rp("Maximum allowed index exceeded");
        return e;
    }, np = Ct, op = Zt, ip = B, lp = function(e, t, r) {
        var a = np(t);
        a in e ? op.f(e, a, ip(0, r)) : e[a] = r;
    }, sp = tp, cp = Ul, up = X, dp = dt("species"), pp = Array, mp = function(e) {
        var t;
        return sp(e) && (t = e.constructor, (cp(t) && (t === pp || sp(t.prototype)) || up(t) && null === (t = t[dp])) && (t = void 0)), void 0 === t ? pp : t;
    }, fp = function(e, t) {
        return new (mp(e))(0 === t ? 0 : t);
    }, hp = n, vp = fe, yp = dt("species"), gp = function(e) {
        return vp >= 51 || !hp(function() {
            var t = [];
            return (t.constructor = {})[yp] = function() {
                return {
                    foo: 1
                };
            }, 1 !== t[e](Boolean).foo;
        });
    }, bp = Sr, kp = n, Cp = tp, _p = X, Np = Ye, Pp = ca, wp = ap, Ap = lp, Sp = fp, Ip = gp, Ep = fe, Dp = dt("isConcatSpreadable"), Rp = Ep >= 51 || !kp(function() {
        var e = [];
        return e[Dp] = !1, e.concat()[0] !== e;
    }), Fp = function(e) {
        if (!_p(e)) return !1;
        var t = e[Dp];
        return void 0 !== t ? !!t : Cp(e);
    };
    bp({
        target: "Array",
        proto: !0,
        arity: 1,
        forced: !Rp || !Ip("concat")
    }, {
        concat: function(e) {
            var t, r, a, n, o, i = Np(this), l = Sp(i, 0), s = 0;
            for(t = -1, a = arguments.length; t < a; t++)if (Fp(o = -1 === t ? i : arguments[t])) for(n = Pp(o), wp(s + n), r = 0; r < n; r++, s++)r in o && Ap(l, s, o[r]);
            else wp(s + 1), Ap(l, s++, o);
            return l.length = s, l;
        }
    });
    var xp = {}, Tp = na, zp = ca, Op = lp, jp = Array, Bp = Math.max, Mp = function(e, t, r) {
        for(var a = zp(e), n = Tp(t, a), o = Tp(void 0 === r ? a : r, a), i = jp(Bp(o - n, 0)), l = 0; n < o; n++, l++)Op(i, l, e[n]);
        return i.length = l, i;
    }, Lp = b, Vp = Z, Up = Qr.f, Kp = Mp, Hp = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
    xp.f = function(e) {
        return Hp && "Window" === Lp(e) ? function(e) {
            try {
                return Up(e);
            } catch (e) {
                return Kp(Hp);
            }
        }(e) : Up(Vp(e));
    };
    var qp = {}, Wp = dt;
    qp.f = Wp;
    var Gp = ee, Yp = Je, Qp = qp, Zp = Zt.f, Jp = function(e) {
        var t = Gp.Symbol || (Gp.Symbol = {});
        Yp(t, e) || Zp(t, e, {
            value: Qp.f(e)
        });
    }, $p = R, Xp = oe, em = dt, tm = ui, rm = function() {
        var e = Xp("Symbol"), t = e && e.prototype, r = t && t.valueOf, a = em("toPrimitive");
        t && !t[a] && tm(t, a, function(e) {
            return $p(r, this);
        }, {
            arity: 1
        });
    }, am = Qt, nm = K, om = Ye, im = ca, lm = fp, sm = h([].push), cm = function(e) {
        var t = 1 === e, r = 2 === e, a = 3 === e, n = 4 === e, o = 6 === e, i = 7 === e, l = 5 === e || o;
        return function(s, c, u, d) {
            for(var p, m, f = om(s), h = nm(f), v = am(c, u), y = im(h), g = 0, b = d || lm, k = t ? b(s, y) : r || i ? b(s, 0) : void 0; y > g; g++)if ((l || g in h) && (m = v(p = h[g], g, f), e)) {
                if (t) k[g] = m;
                else if (m) switch(e){
                    case 3:
                        return !0;
                    case 5:
                        return p;
                    case 6:
                        return g;
                    case 2:
                        sm(k, p);
                }
                else switch(e){
                    case 4:
                        return !1;
                    case 7:
                        sm(k, p);
                }
            }
            return o ? -1 : a || n ? n : k;
        };
    }, um = {
        forEach: cm(0),
        map: cm(1),
        filter: cm(2),
        some: cm(3),
        every: cm(4),
        find: cm(5),
        findIndex: cm(6),
        filterReject: cm(7)
    }, dm = Sr, pm = a, mm = R, fm = h, hm = I, vm = ge, ym = n, gm = Je, bm = ie, km = tr, Cm = Z, _m = Ct, Nm = vo, Pm = B, wm = sn, Am = Ma, Sm = Qr, Im = xp, Em = wa, Dm = S, Rm = Zt, Fm = Oa, xm = F, Tm = ui, zm = pl, Om = qe, jm = ha, Bm = rt, Mm = dt, Lm = qp, Vm = Jp, Um = rm, Km = Ei, Hm = ri, qm = um.forEach, Wm = Dr("hidden"), Gm = "Symbol", Ym = "prototype", Qm = Hm.set, Zm = Hm.getterFor(Gm), Jm = Object[Ym], $m = pm.Symbol, Xm = $m && $m[Ym], ef = pm.RangeError, tf = pm.TypeError, rf = pm.QObject, af = Dm.f, nf = Rm.f, of = Im.f, lf = xm.f, sf = fm([].push), cf = Om("symbols"), uf = Om("op-symbols"), df = Om("wks"), pf = !rf || !rf[Ym] || !rf[Ym].findChild, mf = function(e, t, r) {
        var a = af(Jm, t);
        a && delete Jm[t], nf(e, t, r), a && e !== Jm && nf(Jm, t, a);
    }, ff = hm && ym(function() {
        return 7 !== wm(nf({}, "a", {
            get: function() {
                return nf(this, "a", {
                    value: 7
                }).a;
            }
        })).a;
    }) ? mf : nf, hf = function(e, t) {
        var r = cf[e] = wm(Xm);
        return Qm(r, {
            type: Gm,
            tag: e,
            description: t
        }), hm || (r.description = t), r;
    }, vf = function(e, t, r) {
        e === Jm && vf(uf, t, r), km(e);
        var a = _m(t);
        return km(r), gm(cf, a) ? (r.enumerable ? (gm(e, Wm) && e[Wm][a] && (e[Wm][a] = !1), r = wm(r, {
            enumerable: Pm(0, !1)
        })) : (gm(e, Wm) || nf(e, Wm, Pm(1, {})), e[Wm][a] = !0), ff(e, a, r)) : nf(e, a, r);
    }, yf = function(e, t) {
        km(e);
        var r = Cm(t), a = Am(r).concat(Cf(r));
        return qm(a, function(t) {
            hm && !mm(gf, r, t) || vf(e, t, r[t]);
        }), e;
    }, gf = function(e) {
        var t = _m(e), r = mm(lf, this, t);
        return !(this === Jm && gm(cf, t) && !gm(uf, t)) && (!(r || !gm(this, t) || !gm(cf, t) || gm(this, Wm) && this[Wm][t]) || r);
    }, bf = function(e, t) {
        var r = Cm(e), a = _m(t);
        if (r !== Jm || !gm(cf, a) || gm(uf, a)) {
            var n = af(r, a);
            return !n || !gm(cf, a) || gm(r, Wm) && r[Wm][a] || (n.enumerable = !0), n;
        }
    }, kf = function(e) {
        var t = of(Cm(e)), r = [];
        return qm(t, function(e) {
            gm(cf, e) || gm(jm, e) || sf(r, e);
        }), r;
    }, Cf = function(e) {
        var t = e === Jm, r = of(t ? uf : Cm(e)), a = [];
        return qm(r, function(e) {
            !gm(cf, e) || t && !gm(Jm, e) || sf(a, cf[e]);
        }), a;
    };
    vm || ($m = function() {
        if (bm(Xm, this)) throw new tf("Symbol is not a constructor");
        var e = arguments.length && void 0 !== arguments[0] ? Nm(arguments[0]) : void 0, t = Bm(e), r = function(e) {
            var a = void 0 === this ? pm : this;
            a === Jm && mm(r, uf, e), gm(a, Wm) && gm(a[Wm], t) && (a[Wm][t] = !1);
            var n = Pm(1, e);
            try {
                ff(a, t, n);
            } catch (e) {
                if (!(e instanceof ef)) throw e;
                mf(a, t, n);
            }
        };
        return hm && pf && ff(Jm, t, {
            configurable: !0,
            set: r
        }), hf(t, e);
    }, Tm(Xm = $m[Ym], "toString", function() {
        return Zm(this).tag;
    }), Tm($m, "withoutSetter", function(e) {
        return hf(Bm(e), e);
    }), xm.f = gf, Rm.f = vf, Fm.f = yf, Dm.f = bf, Sm.f = Im.f = kf, Em.f = Cf, Lm.f = function(e) {
        return hf(Mm(e), e);
    }, hm && zm(Xm, "description", {
        configurable: !0,
        get: function() {
            return Zm(this).description;
        }
    })), dm({
        global: !0,
        constructor: !0,
        wrap: !0,
        forced: !vm,
        sham: !vm
    }, {
        Symbol: $m
    }), qm(Am(df), function(e) {
        Vm(e);
    }), dm({
        target: Gm,
        stat: !0,
        forced: !vm
    }, {
        useSetter: function() {
            pf = !0;
        },
        useSimple: function() {
            pf = !1;
        }
    }), dm({
        target: "Object",
        stat: !0,
        forced: !vm,
        sham: !hm
    }, {
        create: function(e, t) {
            return void 0 === t ? wm(e) : yf(wm(e), t);
        },
        defineProperty: vf,
        defineProperties: yf,
        getOwnPropertyDescriptor: bf
    }), dm({
        target: "Object",
        stat: !0,
        forced: !vm
    }, {
        getOwnPropertyNames: kf
    }), Um(), Km($m, Gm), jm[Wm] = !0;
    var _f = ge && !!Symbol.for && !!Symbol.keyFor, Nf = Sr, Pf = oe, wf = Je, Af = vo, Sf = qe, If = _f, Ef = Sf("string-to-symbol-registry"), Df = Sf("symbol-to-string-registry");
    Nf({
        target: "Symbol",
        stat: !0,
        forced: !If
    }, {
        for: function(e) {
            var t = Af(e);
            if (wf(Ef, t)) return Ef[t];
            var r = Pf("Symbol")(t);
            return Ef[t] = r, Df[r] = t, r;
        }
    });
    var Rf = Sr, Ff = Je, xf = Pe, Tf = Ae, zf = _f, Of = qe("symbol-to-string-registry");
    Rf({
        target: "Symbol",
        stat: !0,
        forced: !zf
    }, {
        keyFor: function(e) {
            if (!xf(e)) throw new TypeError(Tf(e) + " is not a symbol");
            if (Ff(Of, e)) return Of[e];
        }
    });
    var jf = tp, Bf = A, Mf = b, Lf = vo, Vf = h([].push), Uf = Sr, Kf = oe, Hf = u, qf = R, Wf = h, Gf = n, Yf = A, Qf = Pe, Zf = $l, Jf = function(e) {
        if (Bf(e)) return e;
        if (jf(e)) {
            for(var t = e.length, r = [], a = 0; a < t; a++){
                var n = e[a];
                "string" == typeof n ? Vf(r, n) : "number" != typeof n && "Number" !== Mf(n) && "String" !== Mf(n) || Vf(r, Lf(n));
            }
            var o = r.length, i = !0;
            return function(e, t) {
                if (i) return i = !1, t;
                if (jf(this)) return t;
                for(var a = 0; a < o; a++)if (r[a] === e) return t;
            };
        }
    }, $f = ge, Xf = String, eh = Kf("JSON", "stringify"), th = Wf(/./.exec), rh = Wf("".charAt), ah = Wf("".charCodeAt), nh = Wf("".replace), oh = Wf(1..toString), ih = /[\uD800-\uDFFF]/g, lh = /^[\uD800-\uDBFF]$/, sh = /^[\uDC00-\uDFFF]$/, ch = !$f || Gf(function() {
        var e = Kf("Symbol")("stringify detection");
        return "[null]" !== eh([
            e
        ]) || "{}" !== eh({
            a: e
        }) || "{}" !== eh(Object(e));
    }), uh = Gf(function() {
        return '"\udf06\ud834"' !== eh("\udf06\ud834") || '"\udead"' !== eh("\udead");
    }), dh = function(e, t) {
        var r = Zf(arguments), a = Jf(t);
        if (Yf(a) || void 0 !== e && !Qf(e)) return r[1] = function(e, t) {
            if (Yf(a) && (t = qf(a, this, Xf(e), t)), !Qf(t)) return t;
        }, Hf(eh, null, r);
    }, ph = function(e, t, r) {
        var a = rh(r, t - 1), n = rh(r, t + 1);
        return th(lh, e) && !th(sh, n) || th(sh, e) && !th(lh, a) ? "\\u" + oh(ah(e, 0), 16) : e;
    };
    eh && Uf({
        target: "JSON",
        stat: !0,
        arity: 3,
        forced: ch || uh
    }, {
        stringify: function(e, t, r) {
            var a = Zf(arguments), n = Hf(ch ? dh : eh, null, a);
            return uh && "string" == typeof n ? nh(n, ih, ph) : n;
        }
    });
    var mh = wa, fh = Ye;
    Sr({
        target: "Object",
        stat: !0,
        forced: !ge || n(function() {
            mh.f(1);
        })
    }, {
        getOwnPropertySymbols: function(e) {
            var t = mh.f;
            return t ? t(fh(e)) : [];
        }
    }), Jp("asyncIterator"), Jp("hasInstance"), Jp("isConcatSpreadable"), Jp("iterator"), Jp("match"), Jp("matchAll"), Jp("replace"), Jp("search"), Jp("species"), Jp("split");
    var hh = rm;
    Jp("toPrimitive"), hh();
    var vh = oe, yh = Ei;
    Jp("toStringTag"), yh(vh("Symbol"), "Symbol"), Jp("unscopables"), Ei(a.JSON, "JSON", !0);
    var gh = ee.Symbol, bh = dt, kh = Zt.f, Ch = bh("metadata"), _h = Function.prototype;
    void 0 === _h[Ch] && kh(_h, Ch, {
        value: null
    }), Jp("asyncDispose"), Jp("dispose"), Jp("metadata");
    var Nh = gh, Ph = h, wh = oe("Symbol"), Ah = wh.keyFor, Sh = Ph(wh.prototype.valueOf), Ih = wh.isRegisteredSymbol || function(e) {
        try {
            return void 0 !== Ah(Sh(e));
        } catch (e) {
            return !1;
        }
    };
    Sr({
        target: "Symbol",
        stat: !0
    }, {
        isRegisteredSymbol: Ih
    });
    for(var Eh = qe, Dh = oe, Rh = h, Fh = Pe, xh = dt, Th = Dh("Symbol"), zh = Th.isWellKnownSymbol, Oh = Dh("Object", "getOwnPropertyNames"), jh = Rh(Th.prototype.valueOf), Bh = Eh("wks"), Mh = 0, Lh = Oh(Th), Vh = Lh.length; Mh < Vh; Mh++)try {
        var Uh = Lh[Mh];
        Fh(Th[Uh]) && xh(Uh);
    } catch (RV) {}
    var Kh = function(e) {
        if (zh && zh(e)) return !0;
        try {
            for(var t = jh(e), r = 0, a = Oh(Bh), n = a.length; r < n; r++)if (Bh[a[r]] == t) return !0;
        } catch (e) {}
        return !1;
    };
    Sr({
        target: "Symbol",
        stat: !0,
        forced: !0
    }, {
        isWellKnownSymbol: Kh
    }), Jp("matcher"), Jp("observable"), Sr({
        target: "Symbol",
        stat: !0,
        name: "isRegisteredSymbol"
    }, {
        isRegistered: Ih
    }), Sr({
        target: "Symbol",
        stat: !0,
        name: "isWellKnownSymbol",
        forced: !0
    }, {
        isWellKnown: Kh
    }), Jp("metadataKey"), Jp("patternMatch"), Jp("replaceAll");
    var Hh = Nh, qh = t(Hh), Wh = qp.f("iterator"), Gh = Wh, Yh = t(Gh);
    !function(e) {
        var t = Hh, r = Gh;
        function a(n) {
            return e.exports = a = "function" == typeof t && "symbol" == typeof r ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof t && e.constructor === t && e !== t.prototype ? "symbol" : typeof e;
            }, e.exports.__esModule = !0, e.exports.default = e.exports, a(n);
        }
        e.exports = a, e.exports.__esModule = !0, e.exports.default = e.exports;
    }(Xd);
    var Qh = Xd.exports, Zh = {
        exports: {}
    }, Jh = Sr, $h = I, Xh = Zt.f;
    Jh({
        target: "Object",
        stat: !0,
        forced: Object.defineProperty !== Xh,
        sham: !$h
    }, {
        defineProperty: Xh
    });
    var ev = ee.Object, tv = Zh.exports = function(e, t, r) {
        return ev.defineProperty(e, t, r);
    };
    ev.defineProperty.sham && (tv.sham = !0);
    var rv = Zh.exports, av = rv, nv = t(av);
    Sr({
        target: "Object",
        stat: !0,
        sham: !I
    }, {
        create: sn
    });
    var ov = ee.Object, iv = function(e, t) {
        return ov.create(e, t);
    }, lv = iv, sv = lv, cv = t(sv), uv = Ye, dv = Mr, pv = Rr;
    Sr({
        target: "Object",
        stat: !0,
        forced: n(function() {
            dv(1);
        }),
        sham: !pv
    }, {
        getPrototypeOf: function(e) {
            return dv(uv(e));
        }
    });
    var mv = ee.Object.getPrototypeOf, fv = t(mv), hv = n, vv = function(e, t) {
        var r = [][e];
        return !!r && hv(function() {
            r.call(null, t || function() {
                return 1;
            }, 1);
        });
    }, yv = um.forEach, gv = vv("forEach") ? [].forEach : function(e) {
        return yv(this, e, arguments.length > 1 ? arguments[1] : void 0);
    };
    Sr({
        target: "Array",
        proto: !0,
        forced: [].forEach !== gv
    }, {
        forEach: gv
    });
    var bv = a, kv = ee, Cv = function(e, t) {
        var r = kv[e + "Prototype"], a = r && r[t];
        if (a) return a;
        var n = bv[e], o = n && n.prototype;
        return o && o[t];
    }, _v = Cv("Array", "forEach"), Nv = zn, Pv = Je, wv = ie, Av = _v, Sv = Array.prototype, Iv = {
        DOMTokenList: !0,
        NodeList: !0
    }, Ev = function(e) {
        var t = e.forEach;
        return e === Sv || wv(Sv, e) && t === Sv.forEach || Pv(Iv, Nv(e)) ? Av : t;
    }, Dv = Ev, Rv = I, Fv = tp, xv = TypeError, Tv = Object.getOwnPropertyDescriptor, zv = Rv && !function() {
        if (void 0 !== this) return !0;
        try {
            Object.defineProperty([], "length", {
                writable: !1
            }).length = 1;
        } catch (e) {
            return e instanceof TypeError;
        }
    }(), Ov = zv ? function(e, t) {
        if (Fv(e) && !Tv(e, "length").writable) throw new xv("Cannot set read only .length");
        return e.length = t;
    } : function(e, t) {
        return e.length = t;
    }, jv = Sr, Bv = Ye, Mv = ca, Lv = Ov, Vv = ap, Uv = n(function() {
        return 4294967297 !== [].push.call({
            length: 4294967296
        }, 1);
    }) || !function() {
        try {
            Object.defineProperty([], "length", {
                writable: !1
            }).push();
        } catch (e) {
            return e instanceof TypeError;
        }
    }();
    jv({
        target: "Array",
        proto: !0,
        arity: 1,
        forced: Uv
    }, {
        push: function(e) {
            var t = Bv(this), r = Mv(t), a = arguments.length;
            Vv(r + a);
            for(var n = 0; n < a; n++)t[r] = arguments[n], r++;
            return Lv(t, r), r;
        }
    });
    var Kv = Cv("Array", "push"), Hv = ie, qv = Kv, Wv = Array.prototype, Gv = function(e) {
        var t = e.push;
        return e === Wv || Hv(Wv, e) && t === Wv.push ? qv : t;
    }, Yv = t(Gv);
    Sr({
        target: "Object",
        stat: !0
    }, {
        setPrototypeOf: Yr
    });
    var Qv = ee.Object.setPrototypeOf, Zv = t(Qv), Jv = Sr, $v = tp, Xv = h([].reverse), ey = [
        1,
        2
    ];
    Jv({
        target: "Array",
        proto: !0,
        forced: String(ey) === String(ey.reverse())
    }, {
        reverse: function() {
            return $v(this) && (this.length = this.length), Xv(this);
        }
    });
    var ty = Cv("Array", "reverse"), ry = ie, ay = ty, ny = Array.prototype, oy = function(e) {
        var t = e.reverse;
        return e === ny || ry(ny, e) && t === ny.reverse ? ay : t;
    }, iy = oy, ly = Sr, sy = tp, cy = Ul, uy = X, dy = na, py = ca, my = Z, fy = lp, hy = dt, vy = $l, yy = gp("slice"), gy = hy("species"), by = Array, ky = Math.max;
    ly({
        target: "Array",
        proto: !0,
        forced: !yy
    }, {
        slice: function(e, t) {
            var r, a, n, o = my(this), i = py(o), l = dy(e, i), s = dy(void 0 === t ? i : t, i);
            if (sy(o) && (r = o.constructor, (cy(r) && (r === by || sy(r.prototype)) || uy(r) && null === (r = r[gy])) && (r = void 0), r === by || void 0 === r)) return vy(o, l, s);
            for(a = new (void 0 === r ? by : r)(ky(s - l, 0)), n = 0; l < s; l++, n++)l in o && fy(a, n, o[l]);
            return a.length = n, a;
        }
    });
    var Cy = Cv("Array", "slice"), _y = ie, Ny = Cy, Py = Array.prototype, wy = function(e) {
        var t = e.slice;
        return e === Py || _y(Py, e) && t === Py.slice ? Ny : t;
    }, Ay = wy, Sy = t(Ay);
    !function(e) {
        var t = Qh.default, r = av, a = Hh, n = sv, o = mv, i = Dv, l = Gv, s = Qv, c = Yd, u = iy, d = Ay;
        function p() {
            e.exports = p = function() {
                return f;
            }, e.exports.__esModule = !0, e.exports.default = e.exports;
            var m, f = {}, h = Object.prototype, v = h.hasOwnProperty, y = r || function(e, t, r) {
                e[t] = r.value;
            }, g = "function" == typeof a ? a : {}, b = g.iterator || "@@iterator", k = g.asyncIterator || "@@asyncIterator", C = g.toStringTag || "@@toStringTag";
            function _(e, t, a) {
                return r(e, t, {
                    value: a,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), e[t];
            }
            try {
                _({}, "");
            } catch (m) {
                _ = function(e, t, r) {
                    return e[t] = r;
                };
            }
            function N(e, t, r, a) {
                var o = t && t.prototype instanceof D ? t : D, i = n(o.prototype), l = new U(a || []);
                return y(i, "_invoke", {
                    value: B(e, r, l)
                }), i;
            }
            function P(e, t, r) {
                try {
                    return {
                        type: "normal",
                        arg: e.call(t, r)
                    };
                } catch (e) {
                    return {
                        type: "throw",
                        arg: e
                    };
                }
            }
            f.wrap = N;
            var w = "suspendedStart", A = "suspendedYield", S = "executing", I = "completed", E = {};
            function D() {}
            function R() {}
            function F() {}
            var x = {};
            _(x, b, function() {
                return this;
            });
            var T = o && o(o(K([])));
            T && T !== h && v.call(T, b) && (x = T);
            var z = F.prototype = D.prototype = n(x);
            function O(e) {
                var t;
                i(t = [
                    "next",
                    "throw",
                    "return"
                ]).call(t, function(t) {
                    _(e, t, function(e) {
                        return this._invoke(t, e);
                    });
                });
            }
            function j(e, r) {
                function a(n, o, i, l) {
                    var s = P(e[n], e, o);
                    if ("throw" !== s.type) {
                        var c = s.arg, u = c.value;
                        return u && "object" == t(u) && v.call(u, "__await") ? r.resolve(u.__await).then(function(e) {
                            a("next", e, i, l);
                        }, function(e) {
                            a("throw", e, i, l);
                        }) : r.resolve(u).then(function(e) {
                            c.value = e, i(c);
                        }, function(e) {
                            return a("throw", e, i, l);
                        });
                    }
                    l(s.arg);
                }
                var n;
                y(this, "_invoke", {
                    value: function(e, t) {
                        function o() {
                            return new r(function(r, n) {
                                a(e, t, r, n);
                            });
                        }
                        return n = n ? n.then(o, o) : o();
                    }
                });
            }
            function B(e, t, r) {
                var a = w;
                return function(n, o) {
                    if (a === S) throw new Error("Generator is already running");
                    if (a === I) {
                        if ("throw" === n) throw o;
                        return {
                            value: m,
                            done: !0
                        };
                    }
                    for(r.method = n, r.arg = o;;){
                        var i = r.delegate;
                        if (i) {
                            var l = M(i, r);
                            if (l) {
                                if (l === E) continue;
                                return l;
                            }
                        }
                        if ("next" === r.method) r.sent = r._sent = r.arg;
                        else if ("throw" === r.method) {
                            if (a === w) throw a = I, r.arg;
                            r.dispatchException(r.arg);
                        } else "return" === r.method && r.abrupt("return", r.arg);
                        a = S;
                        var s = P(e, t, r);
                        if ("normal" === s.type) {
                            if (a = r.done ? I : A, s.arg === E) continue;
                            return {
                                value: s.arg,
                                done: r.done
                            };
                        }
                        "throw" === s.type && (a = I, r.method = "throw", r.arg = s.arg);
                    }
                };
            }
            function M(e, t) {
                var r = t.method, a = e.iterator[r];
                if (a === m) return t.delegate = null, "throw" === r && e.iterator.return && (t.method = "return", t.arg = m, M(e, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), E;
                var n = P(a, e.iterator, t.arg);
                if ("throw" === n.type) return t.method = "throw", t.arg = n.arg, t.delegate = null, E;
                var o = n.arg;
                return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = m), t.delegate = null, E) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, E);
            }
            function L(e) {
                var t, r = {
                    tryLoc: e[0]
                };
                1 in e && (r.catchLoc = e[1]), 2 in e && (r.finallyLoc = e[2], r.afterLoc = e[3]), l(t = this.tryEntries).call(t, r);
            }
            function V(e) {
                var t = e.completion || {};
                t.type = "normal", delete t.arg, e.completion = t;
            }
            function U(e) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], i(e).call(e, L, this), this.reset(!0);
            }
            function K(e) {
                if (e || "" === e) {
                    var r = e[b];
                    if (r) return r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var a = -1, n = function t() {
                            for(; ++a < e.length;)if (v.call(e, a)) return t.value = e[a], t.done = !1, t;
                            return t.value = m, t.done = !0, t;
                        };
                        return n.next = n;
                    }
                }
                throw new TypeError(t(e) + " is not iterable");
            }
            return R.prototype = F, y(z, "constructor", {
                value: F,
                configurable: !0
            }), y(F, "constructor", {
                value: R,
                configurable: !0
            }), R.displayName = _(F, C, "GeneratorFunction"), f.isGeneratorFunction = function(e) {
                var t = "function" == typeof e && e.constructor;
                return !!t && (t === R || "GeneratorFunction" === (t.displayName || t.name));
            }, f.mark = function(e) {
                return s ? s(e, F) : (e.__proto__ = F, _(e, C, "GeneratorFunction")), e.prototype = n(z), e;
            }, f.awrap = function(e) {
                return {
                    __await: e
                };
            }, O(j.prototype), _(j.prototype, k, function() {
                return this;
            }), f.AsyncIterator = j, f.async = function(e, t, r, a, n) {
                void 0 === n && (n = c);
                var o = new j(N(e, t, r, a), n);
                return f.isGeneratorFunction(t) ? o : o.next().then(function(e) {
                    return e.done ? e.value : o.next();
                });
            }, O(z), _(z, C, "Generator"), _(z, b, function() {
                return this;
            }), _(z, "toString", function() {
                return "[object Generator]";
            }), f.keys = function(e) {
                var t = Object(e), r = [];
                for(var a in t)l(r).call(r, a);
                return u(r).call(r), function e() {
                    for(; r.length;){
                        var a = r.pop();
                        if (a in t) return e.value = a, e.done = !1, e;
                    }
                    return e.done = !0, e;
                };
            }, f.values = K, U.prototype = {
                constructor: U,
                reset: function(e) {
                    var t;
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = m, this.done = !1, this.delegate = null, this.method = "next", this.arg = m, i(t = this.tryEntries).call(t, V), !e) for(var r in this)"t" === r.charAt(0) && v.call(this, r) && !isNaN(+d(r).call(r, 1)) && (this[r] = m);
                },
                stop: function() {
                    this.done = !0;
                    var e = this.tryEntries[0].completion;
                    if ("throw" === e.type) throw e.arg;
                    return this.rval;
                },
                dispatchException: function(e) {
                    if (this.done) throw e;
                    var t = this;
                    function r(r, a) {
                        return o.type = "throw", o.arg = e, t.next = r, a && (t.method = "next", t.arg = m), !!a;
                    }
                    for(var a = this.tryEntries.length - 1; a >= 0; --a){
                        var n = this.tryEntries[a], o = n.completion;
                        if ("root" === n.tryLoc) return r("end");
                        if (n.tryLoc <= this.prev) {
                            var i = v.call(n, "catchLoc"), l = v.call(n, "finallyLoc");
                            if (i && l) {
                                if (this.prev < n.catchLoc) return r(n.catchLoc, !0);
                                if (this.prev < n.finallyLoc) return r(n.finallyLoc);
                            } else if (i) {
                                if (this.prev < n.catchLoc) return r(n.catchLoc, !0);
                            } else {
                                if (!l) throw new Error("try statement without catch or finally");
                                if (this.prev < n.finallyLoc) return r(n.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function(e, t) {
                    for(var r = this.tryEntries.length - 1; r >= 0; --r){
                        var a = this.tryEntries[r];
                        if (a.tryLoc <= this.prev && v.call(a, "finallyLoc") && this.prev < a.finallyLoc) {
                            var n = a;
                            break;
                        }
                    }
                    n && ("break" === e || "continue" === e) && n.tryLoc <= t && t <= n.finallyLoc && (n = null);
                    var o = n ? n.completion : {};
                    return o.type = e, o.arg = t, n ? (this.method = "next", this.next = n.finallyLoc, E) : this.complete(o);
                },
                complete: function(e, t) {
                    if ("throw" === e.type) throw e.arg;
                    return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), E;
                },
                finish: function(e) {
                    for(var t = this.tryEntries.length - 1; t >= 0; --t){
                        var r = this.tryEntries[t];
                        if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), V(r), E;
                    }
                },
                catch: function(e) {
                    for(var t = this.tryEntries.length - 1; t >= 0; --t){
                        var r = this.tryEntries[t];
                        if (r.tryLoc === e) {
                            var a = r.completion;
                            if ("throw" === a.type) {
                                var n = a.arg;
                                V(r);
                            }
                            return n;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function(e, t, r) {
                    return this.delegate = {
                        iterator: K(e),
                        resultName: t,
                        nextLoc: r
                    }, "next" === this.method && (this.arg = m), E;
                }
            }, f;
        }
        e.exports = p, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($d);
    var Iy = (0, $d.exports)(), Ey = Iy;
    try {
        regeneratorRuntime = Iy;
    } catch (e) {
        "object" == typeof globalThis ? globalThis.regeneratorRuntime = Iy : Function("r", "regeneratorRuntime = r")(Iy);
    }
    var Dy = t(Ey), Ry = Ye, Fy = Ma;
    Sr({
        target: "Object",
        stat: !0,
        forced: n(function() {
            Fy(1);
        })
    }, {
        keys: function(e) {
            return Fy(Ry(e));
        }
    });
    var xy = ee.Object.keys, Ty = t(xy), zy = ee.Object.getOwnPropertySymbols, Oy = t(zy), jy = {
        exports: {}
    }, By = Sr, My = n, Ly = Z, Vy = S.f, Uy = I;
    By({
        target: "Object",
        stat: !0,
        forced: !Uy || My(function() {
            Vy(1);
        }),
        sham: !Uy
    }, {
        getOwnPropertyDescriptor: function(e, t) {
            return Vy(Ly(e), t);
        }
    });
    var Ky = ee.Object, Hy = jy.exports = function(e, t) {
        return Ky.getOwnPropertyDescriptor(e, t);
    };
    Ky.getOwnPropertyDescriptor.sham && (Hy.sham = !0);
    var qy = jy.exports, Wy = t(qy), Gy = Ra, Yy = Z, Qy = S, Zy = lp;
    Sr({
        target: "Object",
        stat: !0,
        sham: !I
    }, {
        getOwnPropertyDescriptors: function(e) {
            for(var t, r, a = Yy(e), n = Qy.f, o = Gy(a), i = {}, l = 0; o.length > l;)void 0 !== (r = n(a, t = o[l++])) && Zy(i, t, r);
            return i;
        }
    });
    var Jy = t(ee.Object.getOwnPropertyDescriptors), $y = {
        exports: {}
    }, Xy = Sr, eg = I, tg = Oa.f;
    Xy({
        target: "Object",
        stat: !0,
        forced: Object.defineProperties !== tg,
        sham: !eg
    }, {
        defineProperties: tg
    });
    var rg = ee.Object, ag = $y.exports = function(e, t) {
        return rg.defineProperties(e, t);
    };
    rg.defineProperties.sham && (ag.sham = !0);
    var ng = t($y.exports), og = t(rv);
    function ig(e) {
        return ig = "function" == typeof qh && "symbol" == typeof Yh ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof qh && e.constructor === qh && e !== qh.prototype ? "symbol" : typeof e;
        }, ig(e);
    }
    var lg = t(zy), sg = Sr, cg = fa.indexOf, ug = vv, dg = _([].indexOf), pg = !!dg && 1 / dg([
        1
    ], 1, -0) < 0;
    sg({
        target: "Array",
        proto: !0,
        forced: pg || !ug("indexOf")
    }, {
        indexOf: function(e) {
            var t = arguments.length > 1 ? arguments[1] : void 0;
            return pg ? dg(this, e, t) || 0 : cg(this, e, t);
        }
    });
    var mg = Cv("Array", "indexOf"), fg = ie, hg = mg, vg = Array.prototype, yg = function(e) {
        var t = e.indexOf;
        return e === vg || fg(vg, e) && t === vg.indexOf ? hg : t;
    }, gg = t(yg), bg = t(xy);
    function kg(e, t) {
        if (null == e) return {};
        var r, a, n = function(e, t) {
            if (null == e) return {};
            var r, a, n = {}, o = bg(e);
            for(a = 0; a < o.length; a++)r = o[a], gg(t).call(t, r) >= 0 || (n[r] = e[r]);
            return n;
        }(e, t);
        if (lg) {
            var o = lg(e);
            for(a = 0; a < o.length; a++)r = o[a], gg(t).call(t, r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
        }
        return n;
    }
    function Cg(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    var _g = t(qp.f("toPrimitive"));
    function Ng(e) {
        var t = function(e, t) {
            if ("object" !== ig(e) || null === e) return e;
            var r = e[_g];
            if (void 0 !== r) {
                var a = r.call(e, t || "default");
                if ("object" !== ig(a)) return a;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" === ig(t) ? t : String(t);
    }
    function Pg(e, t) {
        for(var r = 0; r < t.length; r++){
            var a = t[r];
            a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), nv(e, Ng(a.key), a);
        }
    }
    function wg(e, t, r) {
        return t && Pg(e.prototype, t), r && Pg(e, r), nv(e, "prototype", {
            writable: !1
        }), e;
    }
    function Ag(e, t, r) {
        return (t = Ng(t)) in e ? nv(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    var Sg = t(Ev), Ig = um.filter;
    Sr({
        target: "Array",
        proto: !0,
        forced: !gp("filter")
    }, {
        filter: function(e) {
            return Ig(this, e, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var Eg = Cv("Array", "filter"), Dg = ie, Rg = Eg, Fg = Array.prototype, xg = t(function(e) {
        var t = e.filter;
        return e === Fg || Dg(Fg, e) && t === Fg.filter ? Rg : t;
    }), Tg = h, zg = De, Og = X, jg = Je, Bg = $l, Mg = o, Lg = Function, Vg = Tg([].concat), Ug = Tg([].join), Kg = {}, Hg = Mg ? Lg.bind : function(e) {
        var t = zg(this), r = t.prototype, a = Bg(arguments, 1), n = function() {
            var r = Vg(a, Bg(arguments));
            return this instanceof n ? function(e, t, r) {
                if (!jg(Kg, t)) {
                    for(var a = [], n = 0; n < t; n++)a[n] = "a[" + n + "]";
                    Kg[t] = Lg("C,a", "return new C(" + Ug(a, ",") + ")");
                }
                return Kg[t](e, r);
            }(t, r.length, r) : t.apply(e, r);
        };
        return Og(r) && (n.prototype = r), n;
    }, qg = Hg;
    Sr({
        target: "Function",
        proto: !0,
        forced: Function.bind !== qg
    }, {
        bind: qg
    });
    var Wg = Cv("Function", "bind"), Gg = ie, Yg = Wg, Qg = Function.prototype, Zg = function(e) {
        var t = e.bind;
        return e === Qg || Gg(Qg, e) && t === Qg.bind ? Yg : t;
    }, Jg = t(Zg), $g = fa.includes;
    Sr({
        target: "Array",
        proto: !0,
        forced: n(function() {
            return !Array(1).includes();
        })
    }, {
        includes: function(e) {
            return $g(this, e, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var Xg = Cv("Array", "includes"), eb = X, tb = b, rb = dt("match"), ab = function(e) {
        var t;
        return eb(e) && (void 0 !== (t = e[rb]) ? !!t : "RegExp" === tb(e));
    }, nb = TypeError, ob = function(e) {
        if (ab(e)) throw new nb("The method doesn't accept regular expressions");
        return e;
    }, ib = dt("match"), lb = function(e) {
        var t = /./;
        try {
            "/./"[e](t);
        } catch (r) {
            try {
                return t[ib] = !1, "/./"[e](t);
            } catch (e) {}
        }
        return !1;
    }, sb = Sr, cb = ob, ub = G, db = vo, pb = lb, mb = h("".indexOf);
    sb({
        target: "String",
        proto: !0,
        forced: !pb("includes")
    }, {
        includes: function(e) {
            return !!~mb(db(ub(this)), db(cb(e)), arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var fb = Cv("String", "includes"), hb = ie, vb = Xg, yb = fb, gb = Array.prototype, bb = String.prototype, kb = t(function(e) {
        var t = e.includes;
        return e === gb || hb(gb, e) && t === gb.includes ? vb : "string" == typeof e || e === bb || hb(bb, e) && t === bb.includes ? yb : t;
    }), Cb = Cv("Array", "concat"), _b = ie, Nb = Cb, Pb = Array.prototype, wb = t(function(e) {
        var t = e.concat;
        return e === Pb || _b(Pb, e) && t === Pb.concat ? Nb : t;
    }), Ab = t(Kd), Sb = Sr, Ib = um.find, Eb = "find", Db = !0;
    Eb in [] && Array(1)[Eb](function() {
        Db = !1;
    }), Sb({
        target: "Array",
        proto: !0,
        forced: Db
    }, {
        find: function(e) {
            return Ib(this, e, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var Rb = Cv("Array", "find"), Fb = ie, xb = Rb, Tb = Array.prototype, zb = t(function(e) {
        var t = e.find;
        return e === Tb || Fb(Tb, e) && t === Tb.find ? xb : t;
    }), Ob = ee, jb = u;
    Ob.JSON || (Ob.JSON = {
        stringify: JSON.stringify
    });
    var Bb = function(e, t, r) {
        return jb(Ob.JSON.stringify, null, arguments);
    }, Mb = t(Bb), Lb = !n(function() {
        return Object.isExtensible(Object.preventExtensions({}));
    }), Vb = {
        exports: {}
    }, Ub = n(function() {
        if ("function" == typeof ArrayBuffer) {
            var e = new ArrayBuffer(8);
            Object.isExtensible(e) && Object.defineProperty(e, "a", {
                value: 8
            });
        }
    }), Kb = n, Hb = X, qb = b, Wb = Ub, Gb = Object.isExtensible, Yb = Kb(function() {
        Gb(1);
    }) || Wb ? function(e) {
        return !!Hb(e) && (!Wb || "ArrayBuffer" !== qb(e)) && (!Gb || Gb(e));
    } : Gb, Qb = Sr, Zb = h, Jb = ha, $b = X, Xb = Je, ek = Zt.f, tk = Qr, rk = xp, ak = Yb, nk = Lb, ok = !1, ik = rt("meta"), lk = 0, sk = function(e) {
        ek(e, ik, {
            value: {
                objectID: "O" + lk++,
                weakData: {}
            }
        });
    }, ck = Vb.exports = {
        enable: function() {
            ck.enable = function() {}, ok = !0;
            var e = tk.f, t = Zb([].splice), r = {};
            r[ik] = 1, e(r).length && (tk.f = function(r) {
                for(var a = e(r), n = 0, o = a.length; n < o; n++)if (a[n] === ik) {
                    t(a, n, 1);
                    break;
                }
                return a;
            }, Qb({
                target: "Object",
                stat: !0,
                forced: !0
            }, {
                getOwnPropertyNames: rk.f
            }));
        },
        fastKey: function(e, t) {
            if (!$b(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;
            if (!Xb(e, ik)) {
                if (!ak(e)) return "F";
                if (!t) return "E";
                sk(e);
            }
            return e[ik].objectID;
        },
        getWeakData: function(e, t) {
            if (!Xb(e, ik)) {
                if (!ak(e)) return !0;
                if (!t) return !1;
                sk(e);
            }
            return e[ik].weakData;
        },
        onFreeze: function(e) {
            return nk && ok && ak(e) && !Xb(e, ik) && sk(e), e;
        }
    };
    Jb[ik] = !0;
    var uk = Vb.exports, dk = Sr, pk = Lb, mk = n, fk = X, hk = uk.onFreeze, vk = Object.freeze;
    dk({
        target: "Object",
        stat: !0,
        forced: mk(function() {
            vk(1);
        }),
        sham: !pk
    }, {
        freeze: function(e) {
            return vk && fk(e) ? vk(hk(e)) : e;
        }
    });
    var yk = t(ee.Object.freeze);
    Sr({
        target: "Array",
        stat: !0
    }, {
        isArray: tp
    });
    var gk = ee.Array.isArray, bk = t(gk);
    var kk = Vn, Ck = t(kk);
    var _k = tr, Nk = $n, Pk = Qt, wk = R, Ak = Ye, Sk = function(e, t, r, a) {
        try {
            return a ? t(_k(r)[0], r[1]) : t(r);
        } catch (t) {
            Nk(e, "throw", t);
        }
    }, Ik = An, Ek = Ul, Dk = ca, Rk = lp, Fk = Yn, xk = Vn, Tk = Array, zk = function(e) {
        var t = Ak(e), r = Ek(this), a = arguments.length, n = a > 1 ? arguments[1] : void 0, o = void 0 !== n;
        o && (n = Pk(n, a > 2 ? arguments[2] : void 0));
        var i, l, s, c, u, d, p = xk(t), m = 0;
        if (!p || this === Tk && Ik(p)) for(i = Dk(t), l = r ? new this(i) : Tk(i); i > m; m++)d = o ? n(t[m], m) : t[m], Rk(l, m, d);
        else for(u = (c = Fk(t, p)).next, l = r ? new this : []; !(s = wk(u, c)).done; m++)d = o ? Sk(c, n, [
            s.value,
            m
        ], !0) : s.value, Rk(l, m, d);
        return l.length = m, l;
    }, Ok = zk;
    Sr({
        target: "Array",
        stat: !0,
        forced: !Nu(function(e) {
            Array.from(e);
        })
    }, {
        from: Ok
    });
    var jk = ee.Array.from, Bk = t(jk);
    function Mk(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, a = new Array(t); r < t; r++)a[r] = e[r];
        return a;
    }
    function Lk(e, t) {
        var r;
        if (e) {
            if ("string" == typeof e) return Mk(e, t);
            var a = Sy(r = Object.prototype.toString.call(e)).call(r, 8, -1);
            return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Bk(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? Mk(e, t) : void 0;
        }
    }
    function Vk(e, t) {
        return function(e) {
            if (bk(e)) return e;
        }(e) || function(e, t) {
            var r = null == e ? null : void 0 !== qh && Ck(e) || e["@@iterator"];
            if (null != r) {
                var a, n, o, i, l = [], s = !0, c = !1;
                try {
                    if (o = (r = r.call(e)).next, 0 === t) {
                        if (Object(r) !== r) return;
                        s = !1;
                    } else for(; !(s = (a = o.call(r)).done) && (Yv(l).call(l, a.value), l.length !== t); s = !0);
                } catch (e) {
                    c = !0, n = e;
                } finally{
                    try {
                        if (!s && null != r.return && (i = r.return(), Object(i) !== i)) return;
                    } finally{
                        if (c) throw n;
                    }
                }
                return l;
            }
        }(e, t) || Lk(e, t) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function Uk(e) {
        return function(e) {
            if (bk(e)) return Mk(e);
        }(e) || function(e) {
            if (void 0 !== qh && null != Ck(e) || null != e["@@iterator"]) return Bk(e);
        }(e) || Lk(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    var Kk = t(yg), Hk = De, qk = Ye, Wk = K, Gk = ca, Yk = TypeError, Qk = function(e) {
        return function(t, r, a, n) {
            Hk(r);
            var o = qk(t), i = Wk(o), l = Gk(o), s = e ? l - 1 : 0, c = e ? -1 : 1;
            if (a < 2) for(;;){
                if (s in i) {
                    n = i[s], s += c;
                    break;
                }
                if (s += c, e ? s < 0 : l <= s) throw new Yk("Reduce of empty array with no initial value");
            }
            for(; e ? s >= 0 : l > s; s += c)s in i && (n = r(n, i[s], s, o));
            return n;
        };
    }, Zk = {
        left: Qk(!1),
        right: Qk(!0)
    }.left;
    Sr({
        target: "Array",
        proto: !0,
        forced: !ul && fe > 79 && fe < 83 || !vv("reduce")
    }, {
        reduce: function(e) {
            var t = arguments.length;
            return Zk(this, e, t, t > 1 ? arguments[1] : void 0);
        }
    });
    var Jk = Cv("Array", "reduce"), $k = ie, Xk = Jk, eC = Array.prototype, tC = t(function(e) {
        var t = e.reduce;
        return e === eC || $k(eC, e) && t === eC.reduce ? Xk : t;
    }), rC = Cv("Array", "values"), aC = zn, nC = Je, oC = ie, iC = rC, lC = Array.prototype, sC = {
        DOMTokenList: !0,
        NodeList: !0
    }, cC = t(function(e) {
        var t = e.values;
        return e === lC || oC(lC, e) && t === lC.values || nC(sC, aC(e)) ? iC : t;
    }), uC = um.map;
    Sr({
        target: "Array",
        proto: !0,
        forced: !gp("map")
    }, {
        map: function(e) {
            return uC(this, e, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var dC = Cv("Array", "map"), pC = ie, mC = dC, fC = Array.prototype, hC = t(function(e) {
        var t = e.map;
        return e === fC || pC(fC, e) && t === fC.map ? mC : t;
    }), vC = {
        payButton: "Pay",
        "payButton.redirecting": "Redirecting...",
        "payButton.with": "Pay %{value} with %{maskedData}",
        "payButton.saveDetails": "Save details",
        close: "Close",
        storeDetails: "Save for my next payment",
        readMore: "Read more",
        "creditCard.holderName": "Name on card",
        "creditCard.holderName.placeholder": "J. Smith",
        "creditCard.holderName.invalid": "Enter name as shown on card",
        "creditCard.numberField.title": "Card number",
        "creditCard.numberField.placeholder": "1234 5678 9012 3456",
        "creditCard.expiryDateField.title": "Expiry date",
        "creditCard.expiryDateField.placeholder": "MM/YY",
        "creditCard.expiryDateField.month": "Month",
        "creditCard.expiryDateField.month.placeholder": "MM",
        "creditCard.expiryDateField.year.placeholder": "YY",
        "creditCard.expiryDateField.year": "Year",
        "creditCard.cvcField.title": "Security code",
        "creditCard.cvcField.placeholder": "123",
        "creditCard.storeDetailsButton": "Remember for next time",
        "creditCard.cvcField.placeholder.4digits": "4 digits",
        "creditCard.cvcField.placeholder.3digits": "3 digits",
        "creditCard.taxNumber.placeholder": "YYMMDD / 0123456789",
        installments: "Number of installments",
        installmentOption: "%{times}x %{partialValue}",
        installmentOptionMonths: "%{times} months",
        "installments.oneTime": "One time payment",
        "installments.installments": "Installments payment",
        "installments.revolving": "Revolving payment",
        "sepaDirectDebit.ibanField.invalid": "Invalid account number",
        "sepaDirectDebit.nameField.placeholder": "J. Smith",
        "sepa.ownerName": "Holder Name",
        "sepa.ibanNumber": "Account Number (IBAN)",
        "error.title": "Error",
        "error.subtitle.redirect": "Redirect failed",
        "error.subtitle.payment": "Payment failed",
        "error.subtitle.refused": "Payment refused",
        "error.message.unknown": "An unknown error occurred",
        "errorPanel.title": "Existing errors",
        "idealIssuer.selectField.title": "Bank",
        "idealIssuer.selectField.placeholder": "Select your bank",
        "creditCard.success": "Payment Successful",
        loading: "Loading\u2026",
        continue: "Continue",
        continueTo: "Continue to",
        "wechatpay.timetopay": "You have %@ to pay",
        "sr.wechatpay.timetopay": "You have %#minutes%# %#seconds%# to pay",
        "wechatpay.scanqrcode": "Scan QR code",
        personalDetails: "Personal details",
        companyDetails: "Company details",
        "companyDetails.name": "Company name",
        "companyDetails.registrationNumber": "Registration number",
        socialSecurityNumber: "Social security number",
        firstName: "First name",
        "firstName.invalid": "Enter your first name",
        infix: "Prefix",
        lastName: "Last name",
        "lastName.invalid": "Enter your last name",
        mobileNumber: "Mobile number",
        "mobileNumber.invalid": "Invalid mobile number",
        city: "City",
        postalCode: "Postal code",
        "postalCode.optional": "Postal code (optional)",
        countryCode: "Country Code",
        telephoneNumber: "Telephone number",
        dateOfBirth: "Date of birth",
        shopperEmail: "Email address",
        gender: "Gender",
        "gender.notselected": "Select your gender",
        male: "Male",
        female: "Female",
        billingAddress: "Billing address",
        street: "Street",
        stateOrProvince: "State or province",
        country: "Country/Region",
        houseNumberOrName: "House number",
        separateDeliveryAddress: "Specify a separate delivery address",
        deliveryAddress: "Delivery Address",
        "deliveryAddress.firstName": "Recipient first name",
        "deliveryAddress.lastName": "Recipient last name",
        zipCode: "Zip code",
        apartmentSuite: "Apartment / Suite",
        provinceOrTerritory: "Province or Territory",
        cityTown: "City / Town",
        address: "Address",
        "address.placeholder": "Find your address",
        "address.errors.incomplete": "Enter an address to continue",
        "address.enterManually": "Enter address manually",
        state: "State",
        "field.title.optional": "(optional)",
        "creditCard.cvcField.title.optional": "Security code (optional)",
        "issuerList.wallet.placeholder": "Select your wallet",
        privacyPolicy: "Privacy policy",
        "afterPay.agreement": "I agree with the %@ of Riverty",
        paymentConditions: "payment conditions",
        openApp: "Open the app",
        "voucher.readInstructions": "Read instructions",
        "voucher.introduction": "Thank you for your purchase, please use the following coupon to complete your payment.",
        "voucher.expirationDate": "Expiration Date",
        "voucher.alternativeReference": "Alternative Reference",
        "dragonpay.voucher.non.bank.selectField.placeholder": "Select your provider",
        "dragonpay.voucher.bank.selectField.placeholder": "Select your bank",
        "voucher.paymentReferenceLabel": "Payment Reference",
        "voucher.surcharge": "Incl. %@ surcharge",
        "voucher.introduction.doku": "Thank you for your purchase, please use the following information to complete your payment.",
        "voucher.shopperName": "Shopper Name",
        "voucher.merchantName": "Merchant",
        "voucher.introduction.econtext": "Thank you for your purchase, please use the following information to complete your payment.",
        "voucher.telephoneNumber": "Phone Number",
        "voucher.shopperReference": "Shopper Reference",
        "voucher.collectionInstitutionNumber": "Collection Institution Number",
        "voucher.econtext.telephoneNumber.invalid": "Telephone number must be 10 or 11 digits long",
        "boletobancario.btnLabel": "Generate Boleto",
        "boleto.sendCopyToEmail": "Send a copy to my email",
        "button.copy": "Copy",
        "button.download": "Download",
        "boleto.socialSecurityNumber": "CPF/CNPJ",
        "boleto.socialSecurityNumber.invalid": "Enter a valid CPF/CNPJ number",
        "creditCard.storedCard.description.ariaLabel": "Stored card ends in %@",
        "voucher.entity": "Entity",
        donateButton: "Donate",
        notNowButton: "Not now",
        thanksForYourSupport: "Thanks for your support!",
        "resultMessages.preauthorized": "Details saved",
        preauthorizeWith: "Preauthorize with",
        confirmPreauthorization: "Confirm preauthorization",
        confirmPurchase: "Confirm purchase",
        applyGiftcard: "Redeem",
        giftcardBalance: "Gift card balance",
        deductedBalance: "Deducted balance",
        "creditCard.pin.title": "Pin",
        "creditCard.encryptedPassword.label": "First 2 digits of card password",
        "creditCard.encryptedPassword.placeholder": "12",
        "creditCard.encryptedPassword.invalid": "Invalid password",
        "creditCard.taxNumber": "Cardholder birthdate or Corporate registration number",
        "creditCard.taxNumber.label": "Cardholder birthdate (YYMMDD) or Corporate registration number (10 digits)",
        "creditCard.taxNumber.labelAlt": "Corporate registration number (10 digits)",
        "creditCard.taxNumber.invalid": "Invalid Cardholder birthdate or Corporate registration number",
        "storedPaymentMethod.disable.button": "Remove",
        "storedPaymentMethod.disable.confirmation": "Remove stored payment method",
        "storedPaymentMethod.disable.confirmButton": "Yes, remove",
        "storedPaymentMethod.disable.cancelButton": "Cancel",
        "ach.bankAccount": "Bank account",
        "ach.accountHolderNameField.title": "Account holder name",
        "ach.accountHolderNameField.placeholder": "J. Smith",
        "ach.accountHolderNameField.invalid": "Invalid account holder name",
        "ach.accountNumberField.title": "Account number",
        "ach.accountNumberField.invalid": "Invalid account number",
        "ach.accountLocationField.title": "ABA routing number",
        "ach.accountLocationField.invalid": "Invalid ABA routing number",
        "ach.savedBankAccount": "Saved bank account",
        "select.state": "Select state",
        "select.stateOrProvince": "Select state or province",
        "select.provinceOrTerritory": "Select province or territory",
        "select.country": "Select country/region",
        "select.noOptionsFound": "No options found",
        "select.filter.placeholder": "Search...",
        "telephoneNumber.invalid": "Invalid telephone number",
        qrCodeOrApp: "or",
        "paypal.processingPayment": "Processing payment...",
        generateQRCode: "Generate QR code",
        "await.waitForConfirmation": "Waiting for confirmation",
        "mbway.confirmPayment": "Confirm your payment on the MB WAY app",
        "shopperEmail.invalid": "Invalid email address",
        "dateOfBirth.format": "DD/MM/YYYY",
        "dateOfBirth.invalid": "Enter a valid date of birth that indicates you are at least 18 years old",
        "blik.confirmPayment": "Open your banking app to confirm the payment.",
        "blik.invalid": "Enter 6 numbers",
        "blik.code": "6-digit code",
        "blik.help": "Get the code from your banking app.",
        "swish.pendingMessage": "After you scan, the status can be pending for up to 10 minutes. Attempting to pay again within this time may result in multiple charges.",
        "field.valid": "Field valid",
        "field.invalid": "Field not valid",
        "error.va.gen.01": "Incomplete field",
        "error.va.gen.02": "Field not valid",
        "error.va.sf-cc-num.01": "Enter a valid card number",
        "error.va.sf-cc-num.02": "Enter the card number",
        "error.va.sf-cc-num.03": "Enter a supported card brand",
        "error.va.sf-cc-num.04": "Enter the complete card number",
        "error.va.sf-cc-dat.01": "Enter a valid expiry date",
        "error.va.sf-cc-dat.02": "Enter a valid expiry date",
        "error.va.sf-cc-dat.03": "Credit card about to expire",
        "error.va.sf-cc-dat.04": "Enter the expiry date",
        "error.va.sf-cc-dat.05": "Enter the complete expiry date",
        "error.va.sf-cc-mth.01": "Enter the expiry month",
        "error.va.sf-cc-yr.01": "Enter the expiry year",
        "error.va.sf-cc-yr.02": "Enter the complete expiry year",
        "error.va.sf-cc-cvc.01": "Enter the security code",
        "error.va.sf-cc-cvc.02": "Enter the complete security code",
        "error.va.sf-ach-num.01": "Bank account number field is empty",
        "error.va.sf-ach-num.02": "Bank account number is the wrong length",
        "error.va.sf-ach-loc.01": "Bank routing number field is empty",
        "error.va.sf-ach-loc.02": "Bank routing number is the wrong length",
        "error.va.sf-kcp-pwd.01": "Password field is empty",
        "error.va.sf-kcp-pwd.02": "Password is the wrong length",
        "error.giftcard.no-balance": "This gift card has zero balance",
        "error.giftcard.card-error": "In our records we have no gift card with this number",
        "error.giftcard.currency-error": "Gift cards are only valid in the currency they were issued in",
        "amazonpay.signout": "Sign out from Amazon",
        "amazonpay.changePaymentDetails": "Change payment details",
        "partialPayment.warning": "Select another payment method to pay the remaining",
        "partialPayment.remainingBalance": "Remaining balance will be %{amount}",
        "bankTransfer.beneficiary": "Beneficiary",
        "bankTransfer.iban": "IBAN",
        "bankTransfer.bic": "BIC",
        "bankTransfer.reference": "Reference",
        "bankTransfer.introduction": "Continue to create a new bank transfer payment. You can use the details in the following screen to finalize this payment.",
        "bankTransfer.instructions": "Thank you for your purchase, please use the following information to complete your payment.",
        "bacs.accountHolderName": "Bank account holder name",
        "bacs.accountHolderName.invalid": "Invalid bank account holder name",
        "bacs.accountNumber": "Bank account number",
        "bacs.accountNumber.invalid": "Invalid bank account number",
        "bacs.bankLocationId": "Sort code",
        "bacs.bankLocationId.invalid": "Invalid sort code",
        "bacs.consent.amount": "I agree that the above amount will be deducted from my bank account.",
        "bacs.consent.account": "I confirm the account is in my name and I am the only signatory required to authorise the Direct Debit on this account.",
        edit: "Edit",
        "bacs.confirm": "Confirm and pay",
        "bacs.result.introduction": "Download your Direct Debit Instruction (DDI / Mandate)",
        "download.pdf": "Download PDF",
        "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe for card number",
        "creditCard.encryptedCardNumber.aria.label": "Card number",
        "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe for expiry date",
        "creditCard.encryptedExpiryDate.aria.label": "Expiry date",
        "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe for expiry month",
        "creditCard.encryptedExpiryMonth.aria.label": "Expiry month",
        "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe for expiry year",
        "creditCard.encryptedExpiryYear.aria.label": "Expiry year",
        "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe for security code",
        "creditCard.encryptedSecurityCode.aria.label": "Security code",
        "creditCard.encryptedPassword.aria.iframeTitle": "Iframe for password",
        "creditCard.encryptedPassword.aria.label": "First 2 digits of card password",
        "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe for card number",
        "giftcard.encryptedCardNumber.aria.label": "Card number",
        "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe for pin",
        "giftcard.encryptedSecurityCode.aria.label": "Pin",
        giftcardTransactionLimit: "Max. %{amount} allowed per transaction on this gift card",
        "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe for bank account number",
        "ach.encryptedBankAccountNumber.aria.label": "Account number",
        "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe for bank routing number",
        "ach.encryptedBankLocationId.aria.label": "ABA routing number",
        "pix.instructions": "Open the app with the PIX registered key, choose Pay with PIX and scan the QR Code or copy and paste the code",
        "twint.saved": "saved",
        orPayWith: "or pay with",
        invalidFormatExpects: "Invalid format. Expected format: %{format}",
        "upi.qrCodeWaitingMessage": "Scan the QR code using your preferred UPI app to complete the payment",
        "upi.vpaWaitingMessage": "Open your UPI app to confirm the payment",
        "upi.modeSelection": "Make a selection on how you would like to use UPI.",
        "onlineBanking.termsAndConditions": "By continuing you agree with the %#terms and conditions%#",
        "onlineBankingPL.termsAndConditions": "By continuing you agree with the %#regulations%# and %#information obligation%# of Przelewy24",
        "ctp.loading.poweredByCtp": "Powered by Click to Pay",
        "ctp.loading.intro": "We are checking to see if you have any saved cards with Click to Pay...",
        "ctp.login.title": "Continue to Click to Pay",
        "ctp.login.subtitle": "Enter the email address that is connected to Click to Pay to continue.",
        "ctp.login.inputLabel": "Email",
        "ctp.logout.notYou": "Not you?",
        "ctp.logout.notYourCards": "Not your cards?",
        "ctp.logout.notYourCard": "Not your card?",
        "ctp.logout.notYourProfile": "Not your profile?",
        "ctp.otp.fieldLabel": "One time code",
        "ctp.otp.resendCode": "Resend code",
        "ctp.otp.codeResent": "Code resent",
        "ctp.otp.title": "Access your Click to Pay cards",
        "ctp.otp.subtitle": "Enter the code %@ sent to %@ to verify it\u2018s you.",
        "ctp.otp.saveCookiesCheckbox.label": "Skip verification next time",
        "ctp.otp.saveCookiesCheckbox.information": "Select to be remembered on your device and browser at participating stores for faster checkout. Not recommended for shared devices.",
        "ctp.otp.saveCookiesCheckbox.shorterInfo": "Select to be remembered on your device and browser",
        "ctp.emptyProfile.message": "No cards registered in this Click to Pay profile",
        "ctp.separatorText": "or use",
        "ctp.cards.title": "Complete payment with Click to Pay",
        "ctp.cards.subtitle": "Select a card to use.",
        "ctp.cards.expiredCard": "Expired",
        "ctp.manualCardEntry": "Manual card entry",
        "ctp.aria.infoModalButton": "What is Click to Pay",
        "ctp.infoPopup.title": "Click to Pay brings the ease of contactless, online",
        "ctp.infoPopup.subtitle": "A fast, secure payment method supported by Mastercard, Visa and other payment cards.",
        "ctp.infoPopup.benefit1": "Click to Pay uses encryption to keep your information safe and secure",
        "ctp.infoPopup.benefit2": "Use it with merchants worldwide",
        "ctp.infoPopup.benefit3": "Set up once for hassle-free payments in the future",
        "ctp.errors.AUTH_INVALID": "Authentication Invalid",
        "ctp.errors.NOT_FOUND": "No account found, enter a valid email or continue using manual card entry",
        "ctp.errors.ID_FORMAT_UNSUPPORTED": "Format not supported",
        "ctp.errors.FRAUD": "The user account was locked or disabled",
        "ctp.errors.CONSUMER_ID_MISSING": "Consumer identity is missing in the request",
        "ctp.errors.ACCT_INACCESSIBLE": "This account is currently not available, e.g it is locked",
        "ctp.errors.CODE_INVALID": "Incorrect verification code",
        "ctp.errors.CODE_EXPIRED": "This code has expired",
        "ctp.errors.RETRIES_EXCEEDED": "The limit for the number of retries for OTP generation was exceeded",
        "ctp.errors.OTP_SEND_FAILED": "The OTP could not be sent to the recipient",
        "ctp.errors.REQUEST_TIMEOUT": "Something went wrong, try again or use the manual card entry",
        "ctp.errors.UNKNOWN_ERROR": "Something went wrong, try again or use the manual card entry",
        "ctp.errors.SERVICE_ERROR": "Something went wrong, try again or use the manual card entry",
        "ctp.errors.SERVER_ERROR": "Something went wrong, try again or use the manual card entry",
        "ctp.errors.INVALID_PARAMETER": "Something went wrong, try again or use the manual card entry",
        "ctp.errors.AUTH_ERROR": "Something went wrong, try again or use the manual card entry",
        "paymentMethodsList.aria.label": "Choose a payment method",
        "companyDetails.name.invalid": "Enter the company name",
        "companyDetails.registrationNumber.invalid": "Enter the registration number",
        "consent.checkbox.invalid": "You must agree with the terms & conditions",
        "form.instruction": "All fields are required unless marked otherwise.",
        "trustly.descriptor": "Instant Bank Payment",
        "trustly.description1": "Pay directly from any of your bank accounts, backed by bank-level security",
        "trustly.description2": "No cards, no app download, no registration",
        "ancv.input.label": "Your ANCV identification",
        "ancv.confirmPayment": "Use your ANCV application to confirm the payment.",
        "ancv.form.instruction": "The Cheque-Vacances application is necessary to validate this payment.",
        "ancv.beneficiaryId.invalid": "Enter a valid email address or ANCV ID",
        "payme.openPayMeApp": "Complete your payment in the PayMe app by authorizing the payment in the app and wait for the confirmation.",
        "payme.redirectButtonLabel": "Open PayMe app",
        "payme.scanQrCode": "Complete your payment by QR code",
        "payme.timeToPay": "This QR code is valid for %@",
        "payme.instructions.steps": "Open the PayMe app.%@Scan the QR code to authorize the payment.%@Complete the payment in the app and wait for confirmation.",
        "payme.instructions.footnote": "Please do not close this page before the payment is completed"
    }, yC = Object.freeze({
        __proto__: null,
        default: vC
    }), gC = "en-US", bC = vC, kC = {
        ar: function() {
            return Promise.resolve().then(function() {
                return w2;
            });
        },
        "cs-CZ": function() {
            return Promise.resolve().then(function() {
                return A2;
            });
        },
        "da-DK": function() {
            return Promise.resolve().then(function() {
                return S2;
            });
        },
        "de-DE": function() {
            return Promise.resolve().then(function() {
                return I2;
            });
        },
        "el-GR": function() {
            return Promise.resolve().then(function() {
                return E2;
            });
        },
        "en-US": function() {
            return Promise.resolve().then(function() {
                return yC;
            });
        },
        "es-ES": function() {
            return Promise.resolve().then(function() {
                return D2;
            });
        },
        "fi-FI": function() {
            return Promise.resolve().then(function() {
                return R2;
            });
        },
        "fr-FR": function() {
            return Promise.resolve().then(function() {
                return F2;
            });
        },
        "hr-HR": function() {
            return Promise.resolve().then(function() {
                return x2;
            });
        },
        "hu-HU": function() {
            return Promise.resolve().then(function() {
                return T2;
            });
        },
        "it-IT": function() {
            return Promise.resolve().then(function() {
                return z2;
            });
        },
        "ja-JP": function() {
            return Promise.resolve().then(function() {
                return O2;
            });
        },
        "ko-KR": function() {
            return Promise.resolve().then(function() {
                return j2;
            });
        },
        "nl-NL": function() {
            return Promise.resolve().then(function() {
                return B2;
            });
        },
        "no-NO": function() {
            return Promise.resolve().then(function() {
                return M2;
            });
        },
        "pl-PL": function() {
            return Promise.resolve().then(function() {
                return L2;
            });
        },
        "pt-BR": function() {
            return Promise.resolve().then(function() {
                return V2;
            });
        },
        "pt-PT": function() {
            return Promise.resolve().then(function() {
                return U2;
            });
        },
        "ro-RO": function() {
            return Promise.resolve().then(function() {
                return K2;
            });
        },
        "ru-RU": function() {
            return Promise.resolve().then(function() {
                return H2;
            });
        },
        "sk-SK": function() {
            return Promise.resolve().then(function() {
                return q2;
            });
        },
        "sl-SI": function() {
            return Promise.resolve().then(function() {
                return W2;
            });
        },
        "sv-SE": function() {
            return Promise.resolve().then(function() {
                return G2;
            });
        },
        "zh-CN": function() {
            return Promise.resolve().then(function() {
                return Y2;
            });
        },
        "zh-TW": function() {
            return Promise.resolve().then(function() {
                return Q2;
            });
        }
    };
    function CC(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function _C(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = CC(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = CC(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var NC = function(e) {
        return e.toLowerCase().substring(0, 2);
    };
    function PC(e) {
        var t = e.replace("_", "-");
        if (new RegExp("([a-z]{2})([-])([A-Z]{2})").test(t)) return t;
        var r = Vk(t.split("-"), 2), a = r[0], n = r[1];
        if (!a || !n) return null;
        var o = [
            a.toLowerCase(),
            n.toUpperCase()
        ].join("-");
        return 5 === o.length ? o : null;
    }
    function wC(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
        if (!e || e.length < 1 || e.length > 5) return gC;
        var r = PC(e);
        return Kk(t).call(t, r) > -1 ? r : function(e, t) {
            return e && "string" == typeof e && zb(t).call(t, function(t) {
                return NC(t) === NC(e);
            }) || null;
        }(r || e, t);
    }
    var AC = function(e, t) {
        return e.replace(/%{(\w+)}/g, function(e, r) {
            return t[r] || "";
        });
    }, SC = function() {
        var e = Jd(Dy.mark(function e(t) {
            var r, a, n, o = arguments;
            return Dy.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return r = o.length > 1 && void 0 !== o[1] ? o[1] : {}, a = wC(t, Ty(kC)) || gC, e.next = 4, kC[a]();
                    case 4:
                        return n = e.sent, e.abrupt("return", _C(_C(_C({}, bC), n.default), !!r[t] && r[t]));
                    case 6:
                    case "end":
                        return e.stop();
                }
            }, e);
        }));
        return function(t) {
            return e.apply(this, arguments);
        };
    }(), IC = function(e, t) {
        var r = e.split(/%#(.*?)%#/gm);
        if (t.length !== Math.floor(r.length / 2)) throw Error("The number of functions provided does not match the number of elements in the translation string.");
        return hC(r).call(r, function(e, r) {
            var a = Math.floor(r / 2);
            return r % 2 == 0 ? e : t[a](e);
        });
    }, EC = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF", DC = G, RC = vo, FC = EC, xC = h("".replace), TC = RegExp("^[" + FC + "]+"), zC = RegExp("(^|[^" + FC + "])[" + FC + "]+$"), OC = function(e) {
        return function(t) {
            var r = RC(DC(t));
            return 1 & e && (r = xC(r, TC, "")), 2 & e && (r = xC(r, zC, "$1")), r;
        };
    }, jC = {
        start: OC(1),
        end: OC(2),
        trim: OC(3)
    }, BC = a, MC = n, LC = h, VC = vo, UC = jC.trim, KC = EC, HC = BC.parseInt, qC = BC.Symbol, WC = qC && qC.iterator, GC = /^[+-]?0x/i, YC = LC(GC.exec), QC = 8 !== HC(KC + "08") || 22 !== HC(KC + "0x16") || WC && !MC(function() {
        HC(Object(WC));
    }) ? function(e, t) {
        var r = UC(VC(e));
        return HC(r, t >>> 0 || (YC(GC, r) ? 16 : 10));
    } : HC;
    Sr({
        global: !0,
        forced: parseInt !== QC
    }, {
        parseInt: QC
    });
    var ZC = t(ee.parseInt), JC = {
        IDR: 1,
        JPY: 1,
        KRW: 1,
        VND: 1,
        BYR: 1,
        CVE: 1,
        DJF: 1,
        GHC: 1,
        GNF: 1,
        KMF: 1,
        PYG: 1,
        RWF: 1,
        UGX: 1,
        VUV: 1,
        XAF: 1,
        XOF: 1,
        XPF: 1,
        MRO: 10,
        BHD: 1e3,
        IQD: 1e3,
        JOD: 1e3,
        KWD: 1e3,
        OMR: 1e3,
        LYD: 1e3,
        TND: 1e3
    }, $C = {
        RSD: {
            minimumFractionDigits: 2
        },
        AFN: {
            minimumFractionDigits: 2
        },
        ALL: {
            minimumFractionDigits: 2
        },
        IRR: {
            minimumFractionDigits: 2
        },
        LAK: {
            minimumFractionDigits: 2
        },
        LBP: {
            minimumFractionDigits: 2
        },
        MMK: {
            minimumFractionDigits: 2
        },
        SOS: {
            minimumFractionDigits: 2
        },
        SYP: {
            minimumFractionDigits: 2
        },
        YER: {
            minimumFractionDigits: 2
        },
        IQD: {
            minimumFractionDigits: 3
        }
    };
    function XC(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function e_(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = XC(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = XC(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var t_ = function(e, t) {
        var r = function(e) {
            return JC[e] || 100;
        }(t);
        return ZC(String(e), 10) / r;
    };
    function r_(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function a_(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = r_(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = r_(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var n_ = Intl.DateTimeFormat, o_ = function() {
        function e() {
            var t, r, a = this, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : gC, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            Cg(this, e), Ag(this, "supportedLocales", void 0), Ag(this, "locale", void 0), Ag(this, "languageCode", void 0), Ag(this, "translations", bC), Ag(this, "customTranslations", void 0), Ag(this, "loaded", void 0), Ag(this, "timeFormatOptions", {
                hour: "numeric",
                minute: "numeric"
            }), Ag(this, "timeAndDateFormatOptions", a_({
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            }, this.timeFormatOptions)), Ag(this, "timeAndDateFormatter", void 0);
            var i = Ty(kC);
            this.customTranslations = function() {
                var e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
                return tC(e = Ty(t)).call(e, function(e, a) {
                    var n = PC(a) || wC(a, r);
                    return n && (e[n] = t[a]), e;
                }, {});
            }(o, i);
            var l = Ty(this.customTranslations);
            this.supportedLocales = xg(t = wb(r = []).call(r, Uk(i), Uk(l))).call(t, function(e, t, r) {
                return Kk(r).call(r, e) === t;
            }), this.locale = PC(n) || wC(n, this.supportedLocales) || gC;
            var s = Vk(this.locale.split("-"), 1)[0];
            this.languageCode = s, this.timeAndDateFormatter = n_(this.locale, this.timeAndDateFormatOptions), this.loaded = SC(this.locale, this.customTranslations).then(function(e) {
                a.translations = e;
            });
        }
        return wg(e, [
            {
                key: "get",
                value: function(e, t) {
                    var r = function(e, t) {
                        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                            values: {},
                            count: 0
                        }, a = "".concat(t, "__plural"), n = function(e) {
                            var r;
                            return wb(r = "".concat(t, "__")).call(r, e);
                        };
                        return Object.prototype.hasOwnProperty.call(e, n(r.count)) ? AC(e[n(r.count)], cC(r)) : Object.prototype.hasOwnProperty.call(e, a) && r.count > 1 ? AC(e[a], cC(r)) : Object.prototype.hasOwnProperty.call(e, t) ? AC(e[t], cC(r)) : null;
                    }(this.translations, e, t);
                    return null !== r ? r : e;
                }
            },
            {
                key: "amount",
                value: function(e, t, r) {
                    return function(e, t, r) {
                        var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, n = e.toString(), o = t_(n, r), i = t.replace("_", "-"), l = $C[r] ? e_(e_({}, a), $C[r]) : a, s = e_({
                            style: "currency",
                            currency: r,
                            currencyDisplay: "symbol"
                        }, l);
                        try {
                            return o.toLocaleString(i, s);
                        } catch (e) {
                            return n;
                        }
                    }(e, this.locale, t, r);
                }
            },
            {
                key: "date",
                value: function(e) {
                    if (void 0 === e) return "";
                    var t = a_({
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit"
                    }, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
                    return new Date(e).toLocaleDateString(this.locale, t);
                }
            },
            {
                key: "dateTime",
                value: function(e) {
                    return void 0 === e ? "" : this.timeAndDateFormatter.format(new Date(e));
                }
            }
        ]), e;
    }(), i_ = Sr, l_ = u, s_ = Hg, c_ = Wl, u_ = tr, d_ = X, p_ = sn, m_ = n, f_ = oe("Reflect", "construct"), h_ = Object.prototype, v_ = [].push, y_ = m_(function() {
        function e() {}
        return !(f_(function() {}, [], e) instanceof e);
    }), g_ = !m_(function() {
        f_(function() {});
    }), b_ = y_ || g_;
    i_({
        target: "Reflect",
        stat: !0,
        forced: b_,
        sham: b_
    }, {
        construct: function(e, t) {
            c_(e), u_(t);
            var r = arguments.length < 3 ? e : c_(arguments[2]);
            if (g_ && !y_) return f_(e, t, r);
            if (e === r) {
                switch(t.length){
                    case 0:
                        return new e;
                    case 1:
                        return new e(t[0]);
                    case 2:
                        return new e(t[0], t[1]);
                    case 3:
                        return new e(t[0], t[1], t[2]);
                    case 4:
                        return new e(t[0], t[1], t[2], t[3]);
                }
                var a = [
                    null
                ];
                return l_(v_, a, t), new (l_(s_, e, a));
            }
            var n = r.prototype, o = p_(d_(n) ? n : h_), i = l_(e, o, t);
            return d_(i) ? i : o;
        }
    });
    var k_ = ee.Reflect.construct, C_ = t(k_), __ = I, N_ = h, P_ = R, w_ = n, A_ = Ma, S_ = wa, I_ = F, E_ = Ye, D_ = K, R_ = Object.assign, F_ = Object.defineProperty, x_ = N_([].concat), T_ = !R_ || w_(function() {
        if (__ && 1 !== R_({
            b: 1
        }, R_(F_({}, "a", {
            enumerable: !0,
            get: function() {
                F_(this, "b", {
                    value: 3,
                    enumerable: !1
                });
            }
        }), {
            b: 2
        })).b) return !0;
        var e = {}, t = {}, r = Symbol("assign detection"), a = "abcdefghijklmnopqrst";
        return e[r] = 7, a.split("").forEach(function(e) {
            t[e] = e;
        }), 7 !== R_({}, e)[r] || A_(R_({}, t)).join("") !== a;
    }) ? function(e, t) {
        for(var r = E_(e), a = arguments.length, n = 1, o = S_.f, i = I_.f; a > n;)for(var l, s = D_(arguments[n++]), c = o ? x_(A_(s), o(s)) : A_(s), u = c.length, d = 0; u > d;)l = c[d++], __ && !P_(i, s, l) || (r[l] = s[l]);
        return r;
    } : R_, z_ = T_;
    Sr({
        target: "Object",
        stat: !0,
        arity: 2,
        forced: Object.assign !== z_
    }, {
        assign: z_
    });
    var O_ = ee.Object.assign, j_ = t(O_), B_ = t(Zg);
    function M_() {
        var e;
        return M_ = j_ ? B_(e = j_).call(e) : function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var a in r)Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
            }
            return e;
        }, M_.apply(this, arguments);
    }
    function L_(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function V_(e, t) {
        var r;
        return V_ = Zv ? B_(r = Zv).call(r) : function(e, t) {
            return e.__proto__ = t, e;
        }, V_(e, t);
    }
    function U_(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = cv(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), nv(e, "prototype", {
            writable: !1
        }), t && V_(e, t);
    }
    function K_(e, t) {
        if (t && ("object" === ig(t) || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return L_(e);
    }
    function H_(e) {
        var t;
        return H_ = Zv ? B_(t = fv).call(t) : function(e) {
            return e.__proto__ || fv(e);
        }, H_(e);
    }
    var q_, W_, G_, Y_, Q_, Z_, J_, $_, X_ = {}, eN = [], tN = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
    function rN(e, t) {
        for(var r in t)e[r] = t[r];
        return e;
    }
    function aN(e) {
        var t = e.parentNode;
        t && t.removeChild(e);
    }
    function nN(e, t, r) {
        var a, n, o, i = {};
        for(o in t)"key" == o ? a = t[o] : "ref" == o ? n = t[o] : i[o] = t[o];
        if (arguments.length > 2 && (i.children = arguments.length > 3 ? q_.call(arguments, 2) : r), "function" == typeof e && null != e.defaultProps) for(o in e.defaultProps)void 0 === i[o] && (i[o] = e.defaultProps[o]);
        return oN(e, i, a, n, null);
    }
    function oN(e, t, r, a, n) {
        var o = {
            type: e,
            props: t,
            key: r,
            ref: a,
            __k: null,
            __: null,
            __b: 0,
            __e: null,
            __d: void 0,
            __c: null,
            __h: null,
            constructor: void 0,
            __v: null == n ? ++G_ : n
        };
        return null == n && null != W_.vnode && W_.vnode(o), o;
    }
    function iN(e) {
        return e.children;
    }
    function lN(e, t) {
        this.props = e, this.context = t;
    }
    function sN(e, t) {
        if (null == t) return e.__ ? sN(e.__, e.__.__k.indexOf(e) + 1) : null;
        for(var r; t < e.__k.length; t++)if (null != (r = e.__k[t]) && null != r.__e) return r.__e;
        return "function" == typeof e.type ? sN(e) : null;
    }
    function cN(e) {
        var t, r;
        if (null != (e = e.__) && null != e.__c) {
            for(e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)if (null != (r = e.__k[t]) && null != r.__e) {
                e.__e = e.__c.base = r.__e;
                break;
            }
            return cN(e);
        }
    }
    function uN(e) {
        (!e.__d && (e.__d = !0) && Y_.push(e) && !dN.__r++ || Q_ !== W_.debounceRendering) && ((Q_ = W_.debounceRendering) || Z_)(dN);
    }
    function dN() {
        var e, t, r, a, n, o, i, l;
        for(Y_.sort(J_); e = Y_.shift();)e.__d && (t = Y_.length, a = void 0, n = void 0, i = (o = (r = e).__v).__e, (l = r.__P) && (a = [], (n = rN({}, o)).__v = o.__v + 1, CN(l, o, n, r.__n, void 0 !== l.ownerSVGElement, null != o.__h ? [
            i
        ] : null, a, null == i ? sN(o) : i, o.__h), _N(a, o), o.__e != i && cN(o)), Y_.length > t && Y_.sort(J_));
        dN.__r = 0;
    }
    function pN(e, t, r, a, n, o, i, l, s, c) {
        var u, d, p, m, f, h, v, y = a && a.__k || eN, g = y.length;
        for(r.__k = [], u = 0; u < t.length; u++)if (null != (m = r.__k[u] = null == (m = t[u]) || "boolean" == typeof m || "function" == typeof m ? null : "string" == typeof m || "number" == typeof m || "bigint" == typeof m ? oN(null, m, null, null, m) : Array.isArray(m) ? oN(iN, {
            children: m
        }, null, null, null) : m.__b > 0 ? oN(m.type, m.props, m.key, m.ref ? m.ref : null, m.__v) : m)) {
            if (m.__ = r, m.__b = r.__b + 1, null === (p = y[u]) || p && m.key == p.key && m.type === p.type) y[u] = void 0;
            else for(d = 0; d < g; d++){
                if ((p = y[d]) && m.key == p.key && m.type === p.type) {
                    y[d] = void 0;
                    break;
                }
                p = null;
            }
            CN(e, m, p = p || X_, n, o, i, l, s, c), f = m.__e, (d = m.ref) && p.ref != d && (v || (v = []), p.ref && v.push(p.ref, null, m), v.push(d, m.__c || f, m)), null != f ? (null == h && (h = f), "function" == typeof m.type && m.__k === p.__k ? m.__d = s = mN(m, s, e) : s = hN(e, m, p, y, f, s), "function" == typeof r.type && (r.__d = s)) : s && p.__e == s && s.parentNode != e && (s = sN(p));
        }
        for(r.__e = h, u = g; u--;)null != y[u] && ("function" == typeof r.type && null != y[u].__e && y[u].__e == r.__d && (r.__d = vN(a).nextSibling), wN(y[u], y[u]));
        if (v) for(u = 0; u < v.length; u++)PN(v[u], v[++u], v[++u]);
    }
    function mN(e, t, r) {
        for(var a, n = e.__k, o = 0; n && o < n.length; o++)(a = n[o]) && (a.__ = e, t = "function" == typeof a.type ? mN(a, t, r) : hN(r, a, a, n, a.__e, t));
        return t;
    }
    function fN(e, t) {
        return t = t || [], null == e || "boolean" == typeof e || (Array.isArray(e) ? e.some(function(e) {
            fN(e, t);
        }) : t.push(e)), t;
    }
    function hN(e, t, r, a, n, o) {
        var i, l, s;
        if (void 0 !== t.__d) i = t.__d, t.__d = void 0;
        else if (null == r || n != o || null == n.parentNode) e: if (null == o || o.parentNode !== e) e.appendChild(n), i = null;
        else {
            for(l = o, s = 0; (l = l.nextSibling) && s < a.length; s += 1)if (l == n) break e;
            e.insertBefore(n, o), i = o;
        }
        return void 0 !== i ? i : n.nextSibling;
    }
    function vN(e) {
        var t, r, a;
        if (null == e.type || "string" == typeof e.type) return e.__e;
        if (e.__k) {
            for(t = e.__k.length - 1; t >= 0; t--)if ((r = e.__k[t]) && (a = vN(r))) return a;
        }
        return null;
    }
    function yN(e, t, r) {
        "-" === t[0] ? e.setProperty(t, null == r ? "" : r) : e[t] = null == r ? "" : "number" != typeof r || tN.test(t) ? r : r + "px";
    }
    function gN(e, t, r, a, n) {
        var o;
        e: if ("style" === t) {
            if ("string" == typeof r) e.style.cssText = r;
            else {
                if ("string" == typeof a && (e.style.cssText = a = ""), a) for(t in a)r && t in r || yN(e.style, t, "");
                if (r) for(t in r)a && r[t] === a[t] || yN(e.style, t, r[t]);
            }
        } else if ("o" === t[0] && "n" === t[1]) o = t !== (t = t.replace(/Capture$/, "")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + o] = r, r ? a || e.addEventListener(t, o ? kN : bN, o) : e.removeEventListener(t, o ? kN : bN, o);
        else if ("dangerouslySetInnerHTML" !== t) {
            if (n) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
            else if ("width" !== t && "height" !== t && "href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && t in e) try {
                e[t] = null == r ? "" : r;
                break e;
            } catch (e) {}
            "function" == typeof r || (null == r || !1 === r && "-" !== t[4] ? e.removeAttribute(t) : e.setAttribute(t, r));
        }
    }
    function bN(e) {
        return this.l[e.type + !1](W_.event ? W_.event(e) : e);
    }
    function kN(e) {
        return this.l[e.type + !0](W_.event ? W_.event(e) : e);
    }
    function CN(e, t, r, a, n, o, i, l, s) {
        var c, u, d, p, m, f, h, v, y, g, b, k, C, _, N, P = t.type;
        if (void 0 !== t.constructor) return null;
        null != r.__h && (s = r.__h, l = t.__e = r.__e, t.__h = null, o = [
            l
        ]), (c = W_.__b) && c(t);
        try {
            e: if ("function" == typeof P) {
                if (v = t.props, y = (c = P.contextType) && a[c.__c], g = c ? y ? y.props.value : c.__ : a, r.__c ? h = (u = t.__c = r.__c).__ = u.__E : ("prototype" in P && P.prototype.render ? t.__c = u = new P(v, g) : (t.__c = u = new lN(v, g), u.constructor = P, u.render = AN), y && y.sub(u), u.props = v, u.state || (u.state = {}), u.context = g, u.__n = a, d = u.__d = !0, u.__h = [], u._sb = []), null == u.__s && (u.__s = u.state), null != P.getDerivedStateFromProps && (u.__s == u.state && (u.__s = rN({}, u.__s)), rN(u.__s, P.getDerivedStateFromProps(v, u.__s))), p = u.props, m = u.state, u.__v = t, d) null == P.getDerivedStateFromProps && null != u.componentWillMount && u.componentWillMount(), null != u.componentDidMount && u.__h.push(u.componentDidMount);
                else {
                    if (null == P.getDerivedStateFromProps && v !== p && null != u.componentWillReceiveProps && u.componentWillReceiveProps(v, g), !u.__e && null != u.shouldComponentUpdate && !1 === u.shouldComponentUpdate(v, u.__s, g) || t.__v === r.__v) {
                        for(t.__v !== r.__v && (u.props = v, u.state = u.__s, u.__d = !1), u.__e = !1, t.__e = r.__e, t.__k = r.__k, t.__k.forEach(function(e) {
                            e && (e.__ = t);
                        }), b = 0; b < u._sb.length; b++)u.__h.push(u._sb[b]);
                        u._sb = [], u.__h.length && i.push(u);
                        break e;
                    }
                    null != u.componentWillUpdate && u.componentWillUpdate(v, u.__s, g), null != u.componentDidUpdate && u.__h.push(function() {
                        u.componentDidUpdate(p, m, f);
                    });
                }
                if (u.context = g, u.props = v, u.__P = e, k = W_.__r, C = 0, "prototype" in P && P.prototype.render) {
                    for(u.state = u.__s, u.__d = !1, k && k(t), c = u.render(u.props, u.state, u.context), _ = 0; _ < u._sb.length; _++)u.__h.push(u._sb[_]);
                    u._sb = [];
                } else do u.__d = !1, k && k(t), c = u.render(u.props, u.state, u.context), u.state = u.__s;
                while (u.__d && ++C < 25);
                u.state = u.__s, null != u.getChildContext && (a = rN(rN({}, a), u.getChildContext())), d || null == u.getSnapshotBeforeUpdate || (f = u.getSnapshotBeforeUpdate(p, m)), N = null != c && c.type === iN && null == c.key ? c.props.children : c, pN(e, Array.isArray(N) ? N : [
                    N
                ], t, r, a, n, o, i, l, s), u.base = t.__e, t.__h = null, u.__h.length && i.push(u), h && (u.__E = u.__ = null), u.__e = !1;
            } else null == o && t.__v === r.__v ? (t.__k = r.__k, t.__e = r.__e) : t.__e = NN(r.__e, t, r, a, n, o, i, s);
            (c = W_.diffed) && c(t);
        } catch (e) {
            t.__v = null, (s || null != o) && (t.__e = l, t.__h = !!s, o[o.indexOf(l)] = null), W_.__e(e, t, r);
        }
    }
    function _N(e, t) {
        W_.__c && W_.__c(t, e), e.some(function(t) {
            try {
                e = t.__h, t.__h = [], e.some(function(e) {
                    e.call(t);
                });
            } catch (e) {
                W_.__e(e, t.__v);
            }
        });
    }
    function NN(e, t, r, a, n, o, i, l) {
        var s, c, u, d = r.props, p = t.props, m = t.type, f = 0;
        if ("svg" === m && (n = !0), null != o) {
            for(; f < o.length; f++)if ((s = o[f]) && "setAttribute" in s == !!m && (m ? s.localName === m : 3 === s.nodeType)) {
                e = s, o[f] = null;
                break;
            }
        }
        if (null == e) {
            if (null === m) return document.createTextNode(p);
            e = n ? document.createElementNS("http://www.w3.org/2000/svg", m) : document.createElement(m, p.is && p), o = null, l = !1;
        }
        if (null === m) d === p || l && e.data === p || (e.data = p);
        else {
            if (o = o && q_.call(e.childNodes), c = (d = r.props || X_).dangerouslySetInnerHTML, u = p.dangerouslySetInnerHTML, !l) {
                if (null != o) for(d = {}, f = 0; f < e.attributes.length; f++)d[e.attributes[f].name] = e.attributes[f].value;
                (u || c) && (u && (c && u.__html == c.__html || u.__html === e.innerHTML) || (e.innerHTML = u && u.__html || ""));
            }
            if (function(e, t, r, a, n) {
                var o;
                for(o in r)"children" === o || "key" === o || o in t || gN(e, o, null, r[o], a);
                for(o in t)n && "function" != typeof t[o] || "children" === o || "key" === o || "value" === o || "checked" === o || r[o] === t[o] || gN(e, o, t[o], r[o], a);
            }(e, p, d, n, l), u) t.__k = [];
            else if (f = t.props.children, pN(e, Array.isArray(f) ? f : [
                f
            ], t, r, a, n && "foreignObject" !== m, o, i, o ? o[0] : r.__k && sN(r, 0), l), null != o) for(f = o.length; f--;)null != o[f] && aN(o[f]);
            l || ("value" in p && void 0 !== (f = p.value) && (f !== e.value || "progress" === m && !f || "option" === m && f !== d.value) && gN(e, "value", f, d.value, !1), "checked" in p && void 0 !== (f = p.checked) && f !== e.checked && gN(e, "checked", f, d.checked, !1));
        }
        return e;
    }
    function PN(e, t, r) {
        try {
            "function" == typeof e ? e(t) : e.current = t;
        } catch (e) {
            W_.__e(e, r);
        }
    }
    function wN(e, t, r) {
        var a, n;
        if (W_.unmount && W_.unmount(e), (a = e.ref) && (a.current && a.current !== e.__e || PN(a, null, t)), null != (a = e.__c)) {
            if (a.componentWillUnmount) try {
                a.componentWillUnmount();
            } catch (e) {
                W_.__e(e, t);
            }
            a.base = a.__P = null, e.__c = void 0;
        }
        if (a = e.__k) for(n = 0; n < a.length; n++)a[n] && wN(a[n], t, r || "function" != typeof e.type);
        r || null == e.__e || aN(e.__e), e.__ = e.__e = e.__d = void 0;
    }
    function AN(e, t, r) {
        return this.constructor(e, r);
    }
    function SN(e, t, r) {
        var a, n, o;
        W_.__ && W_.__(e, t), n = (a = "function" == typeof r) ? null : r && r.__k || t.__k, o = [], CN(t, e = (!a && r || t).__k = nN(iN, null, [
            e
        ]), n || X_, X_, void 0 !== t.ownerSVGElement, !a && r ? [
            r
        ] : n ? null : t.firstChild ? q_.call(t.childNodes) : null, o, !a && r ? r : n ? n.__e : t.firstChild, a), _N(o, e);
    }
    function IN(e, t) {
        var r = {
            __c: t = "__cC" + $_++,
            __: e,
            Consumer: function(e, t) {
                return e.children(t);
            },
            Provider: function(e) {
                var r, a;
                return this.getChildContext || (r = [], (a = {})[t] = this, this.getChildContext = function() {
                    return a;
                }, this.shouldComponentUpdate = function(e) {
                    this.props.value !== e.value && r.some(function(e) {
                        e.__e = !0, uN(e);
                    });
                }, this.sub = function(e) {
                    r.push(e);
                    var t = e.componentWillUnmount;
                    e.componentWillUnmount = function() {
                        r.splice(r.indexOf(e), 1), t && t.call(e);
                    };
                }), e.children;
            }
        };
        return r.Provider.__ = r.Consumer.contextType = r;
    }
    q_ = eN.slice, W_ = {
        __e: function(e, t, r, a) {
            for(var n, o, i; t = t.__;)if ((n = t.__c) && !n.__) try {
                if ((o = n.constructor) && null != o.getDerivedStateFromError && (n.setState(o.getDerivedStateFromError(e)), i = n.__d), null != n.componentDidCatch && (n.componentDidCatch(e, a || {}), i = n.__d), i) return n.__E = n;
            } catch (t) {
                e = t;
            }
            throw e;
        }
    }, G_ = 0, lN.prototype.setState = function(e, t) {
        var r;
        r = null != this.__s && this.__s !== this.state ? this.__s : this.__s = rN({}, this.state), "function" == typeof e && (e = e(rN({}, r), this.props)), e && rN(r, e), null != e && this.__v && (t && this._sb.push(t), uN(this));
    }, lN.prototype.forceUpdate = function(e) {
        this.__v && (this.__e = !0, e && this.__h.push(e), uN(this));
    }, lN.prototype.render = iN, Y_ = [], Z_ = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, J_ = function(e, t) {
        return e.__v.__b - t.__v.__b;
    }, dN.__r = 0, $_ = 0;
    var EN, DN = function(e, t) {
        var r = t.split(".");
        return tC(r).call(r, function(e, t) {
            return e && e[t] ? e[t] : void 0;
        }, e);
    }, RN = wg(function e() {
        var t = this;
        Cg(this, e), Ag(this, "events", {}), Ag(this, "on", function(e, r) {
            t.events[e] = t.events[e] || [], t.events[e].push(r);
        }), Ag(this, "off", function(e, r) {
            var a;
            t.events[e] && (t.events[e] = tC(a = t.events[e]).call(a, function(e, t) {
                return t !== r && e.push(t), e;
            }, []));
        }), Ag(this, "emit", function(e, r) {
            var a;
            t.events[e] && Sg(a = t.events[e]).call(a, function(e) {
                e(r);
            });
        });
    });
    function FN() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
            var t = 16 * Math.random() | 0;
            return ("x" == e ? t : 3 & t | 8).toString(16);
        });
    }
    var xN = "v3/analytics", TN = "log", zN = "error", ON = "info", jN = "action", BN = "submit", MN = "selected", LN = "rendered", VN = "displayed", UN = "input", KN = "download", HN = "validationError", qN = "focus", WN = "unfocus", GN = "configured", YN = "instant_payment_button", QN = "list", ZN = "ApiError", JN = "web_700", $N = (Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(EN = {}, "error.va.sf-cc-num.02", "900"), "error.va.sf-cc-num.04", "901"), "error.va.sf-cc-num.01", "902"), "error.va.sf-cc-num.03", "903"), "error.va.sf-cc-dat.04", "910"), "error.va.sf-cc-dat.05", "911"), "error.va.sf-cc-dat.01", "912"), "error.va.sf-cc-dat.02", "913"), "error.va.sf-cc-dat.03", "914"), "error.va.sf-cc-mth.01", "915"), Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(EN, "error.va.sf-cc-yr.01", "917"), "error.va.sf-cc-yr.02", "918"), "error.va.sf-cc-cvc.01", "920"), "error.va.sf-cc-cvc.02", "921"), "creditCard.holderName.invalid", "925"), "boleto.socialSecurityNumber.invalid", "926"), "error.va.gen.01.country", "930"), "error.va.gen.01.street", "931"), "error.va.gen.01.house_number_or_name", "932"), "error.va.gen.01.postal_code", "933"), Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(EN, "invalidFormatExpects.postal_code", "934"), "error.va.gen.01.city", "935"), "error.va.gen.01.state_or_province", "936"), "error.va.sf-kcp-pwd.01", "940"), "error.va.sf-kcp-pwd.02", "941"), "creditCard.taxNumber.invalid", "942"), "error.va.sf-ach-num.01", "945"), "error.va.sf-ach-num.02", "946"), "error.va.sf-ach-loc.01", "947"), "error.va.sf-ach-loc.02", "948")), XN = [
        "cart",
        "minicart",
        "pdp",
        "checkout"
    ], eP = [
        "applicationInfo",
        "checkoutAttemptId"
    ], tP = function(e) {
        return e.FINGERPRINT_DATA_SENT = "fingerprintDataSentWeb", e.FINGERPRINT_IFRAME_LOADED = "fingerprintIframeLoaded", e.FINGERPRINT_COMPLETED = "fingerprintCompleted", e.CHALLENGE_DATA_SENT = "challengeDataSentWeb", e.CHALLENGE_IFRAME_LOADED = "challengeIframeLoaded", e.CHALLENGE_COMPLETED = "challengeCompleted", e;
    }({}), rP = [
        "firstName",
        "lastName"
    ];
    function aP(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function nP(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = aP(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = aP(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var oP = function() {
        function e(t) {
            var r;
            Cg(this, e), Ag(this, "_id", wb(r = "".concat(this.constructor.type, "-")).call(r, FN())), Ag(this, "props", void 0), Ag(this, "state", void 0), Ag(this, "_node", void 0), Ag(this, "_component", void 0), Ag(this, "eventEmitter", new RN), Ag(this, "_parentInstance", void 0), Ag(this, "resources", void 0), this.props = this.formatProps(nP(nP({}, this.constructor.defaultProps), {}, {
                setStatusAutomatically: !0
            }, t)), this._parentInstance = this.props._parentInstance, this._node = null, this.state = {}, this.resources = this.props.modules ? this.props.modules.resources : void 0;
        }
        return wg(e, [
            {
                key: "formatProps",
                value: function(e) {
                    return e;
                }
            },
            {
                key: "formatData",
                value: function() {
                    return {};
                }
            },
            {
                key: "setUpAnalytics",
                value: function(e) {
                    return null;
                }
            },
            {
                key: "submitAnalytics",
                value: function(e) {
                    return null;
                }
            },
            {
                key: "setState",
                value: function(e) {
                    this.state = nP(nP({}, this.state), e);
                }
            },
            {
                key: "data",
                get: function() {
                    var e, t, r = DN(this.props, "modules.risk.data"), a = !(null === (e = DN(this.props, "modules.analytics.getEnabled")) || void 0 === e || !e()) ? null === (t = DN(this.props, "modules.analytics.getCheckoutAttemptId")) || void 0 === t ? void 0 : t() : "do-not-track", n = this.state.order || this.props.order, o = this.formatData();
                    if (o.paymentMethod && a && (o.paymentMethod.checkoutAttemptId = a), "riverty" !== this.props.type && o.billingAddress) {
                        var i = o.billingAddress;
                        i.firstName, i.lastName;
                        var l = kg(i, rP);
                        o.billingAddress = nP({}, l);
                    }
                    return nP(nP(nP(nP({}, r && {
                        riskData: {
                            clientData: r
                        }
                    }), n && {
                        order: {
                            orderData: n.orderData,
                            pspReference: n.pspReference
                        }
                    }), o), {}, {
                        clientStateDataIndicator: !0
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    throw new Error("Payment method cannot be rendered.");
                }
            },
            {
                key: "mount",
                value: function(e) {
                    var t = this, r = "string" == typeof e ? document.querySelector(e) : e;
                    if (!r) throw new Error("Component could not mount. Root node was not found.");
                    var a, n = !this._node;
                    (this._node && this.unmount(), this._node = r, this._component = this.render(), SN(this._component, r), n) && this.props.modules && this.props.modules.analytics && this.setUpAnalytics({
                        containerWidth: r && r.offsetWidth,
                        component: this.props.isDropin ? "dropin" : null !== (a = this.constructor.analyticsType) && void 0 !== a ? a : this.constructor.type,
                        flavor: this.props.isDropin ? "dropin" : "components"
                    }).then(function() {
                        t.props.isDropin || t.submitAnalytics({
                            type: LN
                        });
                    });
                    return this;
                }
            },
            {
                key: "update",
                value: function(e) {
                    return this.props = this.formatProps(nP(nP({}, this.props), e)), this.state = {}, this.unmount().mount(this._node);
                }
            },
            {
                key: "remount",
                value: function(e) {
                    if (!this._node) throw new Error("Component is not mounted.");
                    return SN(e || this.render(), this._node, null), this;
                }
            },
            {
                key: "unmount",
                value: function() {
                    return this._node && SN(null, this._node), this;
                }
            },
            {
                key: "remove",
                value: function() {
                    this.unmount(), this._parentInstance && this._parentInstance.remove(this);
                }
            }
        ]), e;
    }();
    Ag(oP, "defaultProps", {});
    var iP = "function" == typeof Bun && Bun && "string" == typeof Bun.version, lP = a, sP = u, cP = A, uP = iP, dP = le, pP = $l, mP = es, fP = lP.Function, hP = /MSIE .\./.test(dP) || uP && function() {
        var e = lP.Bun.version.split(".");
        return e.length < 3 || "0" === e[0] && (e[1] < 3 || "3" === e[1] && "0" === e[2]);
    }(), vP = function(e, t) {
        var r = t ? 2 : 1;
        return hP ? function(a, n) {
            var o = mP(arguments.length, 1) > r, i = cP(a) ? a : fP(a), l = o ? pP(arguments, r) : [], s = o ? function() {
                sP(i, this, l);
            } : i;
            return t ? e(s, n) : e(s);
        } : e;
    }, yP = Sr, gP = a, bP = vP(gP.setInterval, !0);
    yP({
        global: !0,
        bind: !0,
        forced: gP.setInterval !== bP
    }, {
        setInterval: bP
    });
    var kP = Sr, CP = a, _P = vP(CP.setTimeout, !0);
    kP({
        global: !0,
        bind: !0,
        forced: CP.setTimeout !== _P
    }, {
        setTimeout: _P
    });
    var NP = t(ee.setTimeout), PP = t(gk), wP = {
        exports: {}
    };
    !function(e) {
        !function() {
            var t = {}.hasOwnProperty;
            function r() {
                for(var e = [], a = 0; a < arguments.length; a++){
                    var n = arguments[a];
                    if (n) {
                        var o = ig(n);
                        if ("string" === o || "number" === o) e.push(n);
                        else if (PP(n)) {
                            if (n.length) {
                                var i = r.apply(null, n);
                                i && e.push(i);
                            }
                        } else if ("object" === o) {
                            var l;
                            if (n.toString !== Object.prototype.toString && !kb(l = n.toString.toString()).call(l, "[native code]")) {
                                e.push(n.toString());
                                continue;
                            }
                            for(var s in n)t.call(n, s) && n[s] && e.push(s);
                        }
                    }
                }
                return e.join(" ");
            }
            e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
        }();
    }(wP);
    var AP, SP, IP, EP, DP = t(wP.exports), RP = function(e) {
        var t = e.inline, r = void 0 !== t && t, a = e.size, n = void 0 === a ? "large" : a;
        return nN("div", {
            "data-testid": "spinner",
            className: "adyen-checkout__spinner__wrapper ".concat(r ? "adyen-checkout__spinner__wrapper--inline" : "")
        }, nN("div", {
            className: "adyen-checkout__spinner adyen-checkout__spinner--".concat(n)
        }));
    }, FP = 0, xP = [], TP = [], zP = W_.__b, OP = W_.__r, jP = W_.diffed, BP = W_.__c, MP = W_.unmount;
    function LP(e, t) {
        W_.__h && W_.__h(SP, e, FP || t), FP = 0;
        var r = SP.__H || (SP.__H = {
            __: [],
            __h: []
        });
        return e >= r.__.length && r.__.push({
            __V: TP
        }), r.__[e];
    }
    function VP(e) {
        return FP = 1, UP(tw, e);
    }
    function UP(e, t, r) {
        var a = LP(AP++, 2);
        if (a.t = e, !a.__c && (a.__ = [
            r ? r(t) : tw(void 0, t),
            function(e) {
                var t = a.__N ? a.__N[0] : a.__[0], r = a.t(t, e);
                t !== r && (a.__N = [
                    r,
                    a.__[1]
                ], a.__c.setState({}));
            }
        ], a.__c = SP, !SP.u)) {
            var n = function(e, t, r) {
                if (!a.__c.__H) return !0;
                var n = a.__c.__H.__.filter(function(e) {
                    return e.__c;
                });
                if (n.every(function(e) {
                    return !e.__N;
                })) return !o || o.call(this, e, t, r);
                var i = !1;
                return n.forEach(function(e) {
                    if (e.__N) {
                        var t = e.__[0];
                        e.__ = e.__N, e.__N = void 0, t !== e.__[0] && (i = !0);
                    }
                }), !(!i && a.__c.props === e) && (!o || o.call(this, e, t, r));
            };
            SP.u = !0;
            var o = SP.shouldComponentUpdate, i = SP.componentWillUpdate;
            SP.componentWillUpdate = function(e, t, r) {
                if (this.__e) {
                    var a = o;
                    o = void 0, n(e, t, r), o = a;
                }
                i && i.call(this, e, t, r);
            }, SP.shouldComponentUpdate = n;
        }
        return a.__N || a.__;
    }
    function KP(e, t) {
        var r = LP(AP++, 3);
        !W_.__s && ew(r.__H, t) && (r.__ = e, r.i = t, SP.__H.__h.push(r));
    }
    function HP(e, t) {
        var r = LP(AP++, 4);
        !W_.__s && ew(r.__H, t) && (r.__ = e, r.i = t, SP.__h.push(r));
    }
    function qP(e) {
        return FP = 5, WP(function() {
            return {
                current: e
            };
        }, []);
    }
    function WP(e, t) {
        var r = LP(AP++, 7);
        return ew(r.__H, t) ? (r.__V = e(), r.i = t, r.__h = e, r.__V) : r.__;
    }
    function GP(e, t) {
        return FP = 8, WP(function() {
            return e;
        }, t);
    }
    function YP(e) {
        var t = SP.context[e.__c], r = LP(AP++, 9);
        return r.c = e, t ? (null == r.__ && (r.__ = !0, t.sub(SP)), t.props.value) : e.__;
    }
    function QP() {
        for(var e; e = xP.shift();)if (e.__P && e.__H) try {
            e.__H.__h.forEach($P), e.__H.__h.forEach(XP), e.__H.__h = [];
        } catch (t) {
            e.__H.__h = [], W_.__e(t, e.__v);
        }
    }
    W_.__b = function(e) {
        SP = null, zP && zP(e);
    }, W_.__r = function(e) {
        OP && OP(e), AP = 0;
        var t = (SP = e.__c).__H;
        t && (IP === SP ? (t.__h = [], SP.__h = [], t.__.forEach(function(e) {
            e.__N && (e.__ = e.__N), e.__V = TP, e.__N = e.i = void 0;
        })) : (t.__h.forEach($P), t.__h.forEach(XP), t.__h = [])), IP = SP;
    }, W_.diffed = function(e) {
        jP && jP(e);
        var t = e.__c;
        t && t.__H && (t.__H.__h.length && (1 !== xP.push(t) && EP === W_.requestAnimationFrame || ((EP = W_.requestAnimationFrame) || JP)(QP)), t.__H.__.forEach(function(e) {
            e.i && (e.__H = e.i), e.__V !== TP && (e.__ = e.__V), e.i = void 0, e.__V = TP;
        })), IP = SP = null;
    }, W_.__c = function(e, t) {
        t.some(function(e) {
            try {
                e.__h.forEach($P), e.__h = e.__h.filter(function(e) {
                    return !e.__ || XP(e);
                });
            } catch (r) {
                t.some(function(e) {
                    e.__h && (e.__h = []);
                }), t = [], W_.__e(r, e.__v);
            }
        }), BP && BP(e, t);
    }, W_.unmount = function(e) {
        MP && MP(e);
        var t, r = e.__c;
        r && r.__H && (r.__H.__.forEach(function(e) {
            try {
                $P(e);
            } catch (e) {
                t = e;
            }
        }), r.__H = void 0, t && W_.__e(t, r.__v));
    };
    var ZP = "function" == typeof requestAnimationFrame;
    function JP(e) {
        var t, r = function() {
            clearTimeout(a), ZP && cancelAnimationFrame(t), setTimeout(e);
        }, a = setTimeout(r, 100);
        ZP && (t = requestAnimationFrame(r));
    }
    function $P(e) {
        var t = SP, r = e.__c;
        "function" == typeof r && (e.__c = void 0, r()), SP = t;
    }
    function XP(e) {
        var t = SP;
        e.__c = e.__(), SP = t;
    }
    function ew(e, t) {
        return !e || e.length !== t.length || t.some(function(t, r) {
            return t !== e[r];
        });
    }
    function tw(e, t) {
        return "function" == typeof t ? t(e) : t;
    }
    var rw = "https://checkoutshopper-live.adyen.com/checkoutshopper/", aw = [
        "resourceContext",
        "extension"
    ];
    function nw(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function ow(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = nw(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = nw(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var iw = function() {
        function e() {
            var t = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : rw;
            Cg(this, e), Ag(this, "resourceContext", void 0), Ag(this, "returnImage", function(e) {
                var t, r, a, n, o, i, l = e.name, s = e.resourceContext, c = e.imageFolder, u = void 0 === c ? "" : c, d = e.parentFolder, p = void 0 === d ? "" : d, m = e.extension, f = e.size, h = void 0 === f ? "" : f, v = e.subFolder, y = void 0 === v ? "" : v;
                return wb(t = wb(r = wb(a = wb(n = wb(o = wb(i = "".concat(s, "images/")).call(i, u)).call(o, y)).call(n, p)).call(a, l)).call(r, h, ".")).call(t, m);
            }), Ag(this, "getImageUrl", function(e) {
                var r = e.resourceContext, a = void 0 === r ? rw : r, n = e.extension, o = void 0 === n ? "svg" : n, i = kg(e, aw);
                return function(e) {
                    var r = ow({
                        extension: o,
                        resourceContext: a,
                        imageFolder: "logos/",
                        parentFolder: "",
                        name: e
                    }, i);
                    return t.returnImage(r);
                };
            }), this.resourceContext = r;
        }
        return wg(e, [
            {
                key: "getImage",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    return this.getImageUrl(ow(ow({}, e), {}, {
                        resourceContext: this.resourceContext
                    }));
                }
            }
        ]), e;
    }(), lw = IN({
        i18n: new o_,
        loadingContext: "",
        commonProps: {},
        resources: new iw
    });
    function sw() {
        return YP(lw);
    }
    function cw(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var uw = function(e) {
        U_(r, e);
        var t = cw(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "onClick", function(e) {
                e.preventDefault(), a.props.disabled || a.props.onClick(e, {
                    complete: a.complete
                });
            }), Ag(L_(a), "complete", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1e3;
                a.setState({
                    completed: !0
                }), NP(function() {
                    a.setState({
                        completed: !1
                    });
                }, e);
            }), a;
        }
        return wg(r, [
            {
                key: "render",
                value: function(e, t) {
                    var r, a, n = e.classNameModifiers, o = void 0 === n ? [] : n, i = e.disabled, l = e.href, s = e.icon, c = e.inline, u = e.label, d = e.status, p = e.variant, m = t.completed, f = sw().i18n, h = s ? nN("img", {
                        className: "adyen-checkout__button__icon",
                        src: s,
                        alt: "",
                        "aria-hidden": "true"
                    }) : "", v = wb(r = []).call(r, Uk(o), Uk("primary" !== p ? [
                        p
                    ] : []), Uk(c ? [
                        "inline"
                    ] : []), Uk(m ? [
                        "completed"
                    ] : []), Uk("loading" === d || "redirect" === d ? [
                        "loading"
                    ] : [])), y = DP(wb(a = [
                        "adyen-checkout__button"
                    ]).call(a, Uk(hC(v).call(v, function(e) {
                        return "adyen-checkout__button--".concat(e);
                    })))), g = {
                        loading: nN(RP, {
                            size: "medium"
                        }),
                        redirect: nN("span", {
                            className: "adyen-checkout__button__content"
                        }, nN(RP, {
                            size: "medium",
                            inline: !0
                        }), f.get("payButton.redirecting")),
                        default: nN("span", {
                            className: "adyen-checkout__button__content"
                        }, h, nN("span", {
                            className: "adyen-checkout__button__text"
                        }, u))
                    }, b = g[d] || g.default;
                    return l ? nN("a", {
                        className: y,
                        href: l,
                        disabled: i,
                        target: this.props.target,
                        rel: this.props.rel
                    }, b) : nN("button", {
                        className: y,
                        type: "button",
                        disabled: i,
                        onClick: this.onClick
                    }, b, "loading" !== d && "redirect" !== d && this.props.children);
                }
            }
        ]), r;
    }(lN);
    Ag(uw, "defaultProps", {
        status: "default",
        variant: "primary",
        disabled: !1,
        label: "",
        inline: !1,
        target: "_self",
        onClick: function() {}
    });
    var dw = function(e, t) {
        return null != t && t.value && null != t && t.currency ? e.amount(t.value, t.currency, {
            currencyDisplay: t.currencyDisplay || "symbol"
        }) : "";
    }, pw = function(e, t) {
        var r;
        return wb(r = "".concat(e.get("payButton"), " ")).call(r, dw(e, t));
    }, mw = function(e) {
        return nN("span", {
            className: "checkout-secondary-button__text"
        }, e.label);
    }, fw = [
        "amount",
        "secondaryAmount",
        "classNameModifiers",
        "label"
    ], hw = function(e) {
        var t, r = e.amount, a = e.secondaryAmount, n = e.classNameModifiers, o = void 0 === n ? [] : n, i = e.label, l = kg(e, fw), s = sw().i18n, c = r && ({}).hasOwnProperty.call(r, "value") && 0 === r.value, u = c ? s.get("confirmPreauthorization") : pw(s, r), d = !c && !i && r && a && Ty(a).length ? function(e, t) {
            var r, a = t && null != t && t.value && null != t && t.currency ? e.amount(t.value, t.currency, {
                currencyDisplay: t.currencyDisplay || "symbol"
            }) : "", n = a.length ? "/ " : "";
            return wb(r = "".concat(n)).call(r, a);
        }(s, a) : null;
        return nN(uw, M_({}, l, {
            disabled: l.disabled || "loading" === l.status,
            classNameModifiers: wb(t = []).call(t, Uk(o), [
                "pay"
            ]),
            label: i || u
        }), d && nN(mw, {
            label: d
        }));
    }, vw = [
        "action",
        "resultCode",
        "sessionData",
        "order",
        "sessionResult"
    ];
    var yw = Sr, gw = a, bw = uk, kw = n, Cw = hr, _w = mo, Nw = kl, Pw = A, ww = X, Aw = H, Sw = Ei, Iw = Zt.f, Ew = um.forEach, Dw = I, Rw = ri.set, Fw = ri.getterFor, xw = function(e, t, r) {
        var a, n = -1 !== e.indexOf("Map"), o = -1 !== e.indexOf("Weak"), i = n ? "set" : "add", l = gw[e], s = l && l.prototype, c = {};
        if (Dw && Pw(l) && (o || s.forEach && !kw(function() {
            (new l).entries().next();
        }))) {
            var u = (a = t(function(t, r) {
                Rw(Nw(t, u), {
                    type: e,
                    collection: new l
                }), Aw(r) || _w(r, t[i], {
                    that: t,
                    AS_ENTRIES: n
                });
            })).prototype, d = Fw(e);
            Ew([
                "add",
                "clear",
                "delete",
                "forEach",
                "get",
                "has",
                "set",
                "keys",
                "values",
                "entries"
            ], function(e) {
                var t = "add" === e || "set" === e;
                !(e in s) || o && "clear" === e || Cw(u, e, function(r, a) {
                    var n = d(this).collection;
                    if (!t && o && !ww(r)) return "get" === e && void 0;
                    var i = n[e](0 === r ? 0 : r, a);
                    return t ? this : i;
                });
            }), o || Iw(u, "size", {
                configurable: !0,
                get: function() {
                    return d(this).collection.size;
                }
            });
        } else a = r.getConstructor(t, e, n, i), bw.enable();
        return Sw(a, e, !1, !0), c[e] = a, yw({
            global: !0,
            forced: !0
        }, c), o || r.setStrong(a, e, n), a;
    }, Tw = ui, zw = function(e, t, r) {
        for(var a in t)r && r.unsafe && e[a] ? e[a] = t[a] : Tw(e, a, t[a], r);
        return e;
    }, Ow = sn, jw = pl, Bw = zw, Mw = Qt, Lw = kl, Vw = H, Uw = mo, Kw = Xi, Hw = el, qw = yl, Ww = I, Gw = uk.fastKey, Yw = ri.set, Qw = ri.getterFor, Zw = {
        getConstructor: function(e, t, r, a) {
            var n = e(function(e, n) {
                Lw(e, o), Yw(e, {
                    type: t,
                    index: Ow(null),
                    first: void 0,
                    last: void 0,
                    size: 0
                }), Ww || (e.size = 0), Vw(n) || Uw(n, e[a], {
                    that: e,
                    AS_ENTRIES: r
                });
            }), o = n.prototype, i = Qw(t), l = function(e, t, r) {
                var a, n, o = i(e), l = s(e, t);
                return l ? l.value = r : (o.last = l = {
                    index: n = Gw(t, !0),
                    key: t,
                    value: r,
                    previous: a = o.last,
                    next: void 0,
                    removed: !1
                }, o.first || (o.first = l), a && (a.next = l), Ww ? o.size++ : e.size++, "F" !== n && (o.index[n] = l)), e;
            }, s = function(e, t) {
                var r, a = i(e), n = Gw(t);
                if ("F" !== n) return a.index[n];
                for(r = a.first; r; r = r.next)if (r.key === t) return r;
            };
            return Bw(o, {
                clear: function() {
                    for(var e = i(this), t = e.index, r = e.first; r;)r.removed = !0, r.previous && (r.previous = r.previous.next = void 0), delete t[r.index], r = r.next;
                    e.first = e.last = void 0, Ww ? e.size = 0 : this.size = 0;
                },
                delete: function(e) {
                    var t = this, r = i(t), a = s(t, e);
                    if (a) {
                        var n = a.next, o = a.previous;
                        delete r.index[a.index], a.removed = !0, o && (o.next = n), n && (n.previous = o), r.first === a && (r.first = n), r.last === a && (r.last = o), Ww ? r.size-- : t.size--;
                    }
                    return !!a;
                },
                forEach: function(e) {
                    for(var t, r = i(this), a = Mw(e, arguments.length > 1 ? arguments[1] : void 0); t = t ? t.next : r.first;)for(a(t.value, t.key, this); t && t.removed;)t = t.previous;
                },
                has: function(e) {
                    return !!s(this, e);
                }
            }), Bw(o, r ? {
                get: function(e) {
                    var t = s(this, e);
                    return t && t.value;
                },
                set: function(e, t) {
                    return l(this, 0 === e ? 0 : e, t);
                }
            } : {
                add: function(e) {
                    return l(this, e = 0 === e ? 0 : e, e);
                }
            }), Ww && jw(o, "size", {
                configurable: !0,
                get: function() {
                    return i(this).size;
                }
            }), n;
        },
        setStrong: function(e, t, r) {
            var a = t + " Iterator", n = Qw(t), o = Qw(a);
            Kw(e, t, function(e, t) {
                Yw(this, {
                    type: a,
                    target: e,
                    state: n(e),
                    kind: t,
                    last: void 0
                });
            }, function() {
                for(var e = o(this), t = e.kind, r = e.last; r && r.removed;)r = r.previous;
                return e.target && (e.last = r = r ? r.next : e.state.first) ? Hw("keys" === t ? r.key : "values" === t ? r.value : [
                    r.key,
                    r.value
                ], !1) : (e.target = void 0, Hw(void 0, !0));
            }, r ? "entries" : "values", !r, !0), qw(t);
        }
    };
    xw("Map", function(e) {
        return function() {
            return e(this, arguments.length ? arguments[0] : void 0);
        };
    }, Zw);
    var Jw = ee.Map, $w = function(e, t) {
        return 1 === t ? function(t, r) {
            return t[e](r);
        } : function(t, r, a) {
            return t[e](r, a);
        };
    }, Xw = oe("Map"), eA = {
        Map: Xw,
        set: $w("set", 2),
        get: $w("get", 1),
        has: $w("has", 1),
        remove: $w("delete", 1),
        proto: Xw.prototype
    }, tA = Sr, rA = De, aA = G, nA = mo, oA = eA.Map, iA = eA.has, lA = eA.get, sA = eA.set, cA = h([].push);
    tA({
        target: "Map",
        stat: !0,
        forced: true
    }, {
        groupBy: function(e, t) {
            aA(e), rA(t);
            var r = new oA, a = 0;
            return nA(e, function(e) {
                var n = t(e, a++);
                iA(r, n) ? cA(lA(r, n), e) : sA(r, n, [
                    e
                ]);
            }), r;
        }
    });
    var uA = Jw, dA = Qt, pA = R, mA = De, fA = Wl, hA = H, vA = mo, yA = [].push, gA = function(e) {
        var t, r, a, n, o = arguments.length, i = o > 1 ? arguments[1] : void 0;
        return fA(this), (t = void 0 !== i) && mA(i), hA(e) ? new this : (r = [], t ? (a = 0, n = dA(i, o > 2 ? arguments[2] : void 0), vA(e, function(e) {
            pA(yA, r, n(e, a++));
        })) : vA(e, yA, {
            that: r
        }), new this(r));
    };
    Sr({
        target: "Map",
        stat: !0,
        forced: !0
    }, {
        from: gA
    });
    var bA = $l, kA = function() {
        return new this(bA(arguments));
    };
    Sr({
        target: "Map",
        stat: !0,
        forced: !0
    }, {
        of: kA
    });
    var CA = Ae, _A = TypeError, NA = function(e) {
        if ("object" == typeof e && "size" in e && "has" in e && "get" in e && "set" in e && "delete" in e && "entries" in e) return e;
        throw new _A(CA(e) + " is not a map");
    }, PA = NA, wA = eA.remove;
    Sr({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        deleteAll: function() {
            for(var e, t = PA(this), r = !0, a = 0, n = arguments.length; a < n; a++)e = wA(t, arguments[a]), r = r && e;
            return !!r;
        }
    });
    var AA = NA, SA = eA.get, IA = eA.has, EA = eA.set;
    Sr({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        emplace: function(e, t) {
            var r, a, n = AA(this);
            return IA(n, e) ? (r = SA(n, e), "update" in t && (r = t.update(r, e, n), EA(n, e, r)), r) : (a = t.insert(e, n), EA(n, e, a), a);
        }
    });
    var DA = R, RA = function(e, t, r) {
        for(var a, n, o = r ? e : e.iterator, i = e.next; !(a = DA(i, o)).done;)if (void 0 !== (n = t(a.value))) return n;
    }, FA = function(e, t, r) {
        return r ? RA(e.entries(), function(e) {
            return t(e[1], e[0]);
        }, !0) : e.forEach(t);
    }, xA = Qt, TA = NA, zA = FA;
    Sr({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        every: function(e) {
            var t = TA(this), r = xA(e, arguments.length > 1 ? arguments[1] : void 0);
            return !1 !== zA(t, function(e, a) {
                if (!r(e, a, t)) return !1;
            }, !0);
        }
    });
    var OA = Qt, jA = NA, BA = FA, MA = eA.Map, LA = eA.set;
    Sr({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        filter: function(e) {
            var t = jA(this), r = OA(e, arguments.length > 1 ? arguments[1] : void 0), a = new MA;
            return BA(t, function(e, n) {
                r(e, n, t) && LA(a, n, e);
            }), a;
        }
    });
    var VA = Qt, UA = NA, KA = FA;
    Sr({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        find: function(e) {
            var t = UA(this), r = VA(e, arguments.length > 1 ? arguments[1] : void 0), a = KA(t, function(e, a) {
                if (r(e, a, t)) return {
                    value: e
                };
            }, !0);
            return a && a.value;
        }
    });
    var HA = Qt, qA = NA, WA = FA;
    Sr({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        findKey: function(e) {
            var t = qA(this), r = HA(e, arguments.length > 1 ? arguments[1] : void 0), a = WA(t, function(e, a) {
                if (r(e, a, t)) return {
                    key: a
                };
            }, !0);
            return a && a.key;
        }
    });
    var GA = function(e, t) {
        return e === t || e != e && t != t;
    }, YA = NA, QA = FA;
    Sr({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        includes: function(e) {
            return !0 === QA(YA(this), function(t) {
                if (GA(t, e)) return !0;
            }, !0);
        }
    });
    var ZA = R, JA = mo, $A = A, XA = De, eS = eA.Map;
    Sr({
        target: "Map",
        stat: !0,
        forced: !0
    }, {
        keyBy: function(e, t) {
            var r = new ($A(this) ? this : eS);
            XA(t);
            var a = XA(r.set);
            return JA(e, function(e) {
                ZA(a, r, t(e), e);
            }), r;
        }
    });
    var tS = NA, rS = FA;
    Sr({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        keyOf: function(e) {
            var t = rS(tS(this), function(t, r) {
                if (t === e) return {
                    key: r
                };
            }, !0);
            return t && t.key;
        }
    });
    var aS = Qt, nS = NA, oS = FA, iS = eA.Map, lS = eA.set;
    Sr({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        mapKeys: function(e) {
            var t = nS(this), r = aS(e, arguments.length > 1 ? arguments[1] : void 0), a = new iS;
            return oS(t, function(e, n) {
                lS(a, r(e, n, t), e);
            }), a;
        }
    });
    var sS = Qt, cS = NA, uS = FA, dS = eA.Map, pS = eA.set;
    Sr({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        mapValues: function(e) {
            var t = cS(this), r = sS(e, arguments.length > 1 ? arguments[1] : void 0), a = new dS;
            return uS(t, function(e, n) {
                pS(a, n, r(e, n, t));
            }), a;
        }
    });
    var mS = NA, fS = mo, hS = eA.set;
    Sr({
        target: "Map",
        proto: !0,
        real: !0,
        arity: 1,
        forced: !0
    }, {
        merge: function(e) {
            for(var t = mS(this), r = arguments.length, a = 0; a < r;)fS(arguments[a++], function(e, r) {
                hS(t, e, r);
            }, {
                AS_ENTRIES: !0
            });
            return t;
        }
    });
    var vS = De, yS = NA, gS = FA, bS = TypeError;
    Sr({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        reduce: function(e) {
            var t = yS(this), r = arguments.length < 2, a = r ? void 0 : arguments[1];
            if (vS(e), gS(t, function(n, o) {
                r ? (r = !1, a = n) : a = e(a, n, o, t);
            }), r) throw new bS("Reduce of empty map with no initial value");
            return a;
        }
    });
    var kS = Qt, CS = NA, _S = FA;
    Sr({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        some: function(e) {
            var t = CS(this), r = kS(e, arguments.length > 1 ? arguments[1] : void 0);
            return !0 === _S(t, function(e, a) {
                if (r(e, a, t)) return !0;
            }, !0);
        }
    });
    var NS = De, PS = NA, wS = TypeError, AS = eA.get, SS = eA.has, IS = eA.set;
    Sr({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        update: function(e, t) {
            var r = PS(this), a = arguments.length;
            NS(t);
            var n = SS(r, e);
            if (!n && a < 3) throw new wS("Updating absent value");
            var o = n ? AS(r, e) : NS(a > 2 ? arguments[2] : void 0)(e, r);
            return IS(r, e, t(o, e, r)), r;
        }
    });
    var ES = R, DS = De, RS = A, FS = tr, xS = TypeError, TS = function(e, t) {
        var r, a = FS(this), n = DS(a.get), o = DS(a.has), i = DS(a.set), l = arguments.length > 2 ? arguments[2] : void 0;
        if (!RS(t) && !RS(l)) throw new xS("At least one callback required");
        return ES(o, a, e) ? (r = ES(n, a, e), RS(t) && (r = t(r), ES(i, a, e, r))) : RS(l) && (r = l(), ES(i, a, e, r)), r;
    };
    Sr({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        upsert: TS
    }), Sr({
        target: "Map",
        proto: !0,
        real: !0,
        name: "upsert",
        forced: !0
    }, {
        updateOrInsert: TS
    });
    var zS = t(uA);
    var OS = t(k_);
    function jS(e, t, r) {
        var a;
        (function() {
            if ("undefined" == typeof Reflect || !OS) return !1;
            if (OS.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(OS(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        })() ? jS = B_(a = OS).call(a) : jS = function(e, t, r) {
            var a = [
                null
            ];
            Yv(a).apply(a, t);
            var n = new (B_(Function).apply(e, a));
            return r && V_(n, r.prototype), n;
        };
        return jS.apply(null, arguments);
    }
    function BS(e) {
        var t = "function" == typeof zS ? new zS : void 0;
        return BS = function(e) {
            if (null === e || !function(e) {
                try {
                    var t;
                    return -1 !== gg(t = Function.toString.call(e)).call(t, "[native code]");
                } catch (t) {
                    return "function" == typeof e;
                }
            }(e)) return e;
            if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== t) {
                if (t.has(e)) return t.get(e);
                t.set(e, r);
            }
            function r() {
                return jS(e, arguments, H_(this).constructor);
            }
            return r.prototype = cv(e.prototype, {
                constructor: {
                    value: r,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), V_(r, e);
        }, BS(e);
    }
    function MS(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var LS = function(e) {
        U_(r, e);
        var t = MS(r);
        function r(e, a, n) {
            var o;
            return Cg(this, r), Ag(L_(o = t.call(this, a)), "cause", void 0), o.name = r.errorTypes[e], o.cause = null == n ? void 0 : n.cause, o;
        }
        return wg(r);
    }(BS(Error));
    function VS() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
        return Object.prototype.hasOwnProperty.call(e, t);
    }
    function US(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function KS(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = US(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = US(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function HS(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(LS, "errorTypes", {
        NETWORK_ERROR: "NETWORK_ERROR",
        CANCEL: "CANCEL",
        IMPLEMENTATION_ERROR: "IMPLEMENTATION_ERROR",
        ERROR: "ERROR"
    });
    var qS = function(e) {
        U_(r, e);
        var t = HS(r);
        function r(e) {
            var a, n, o, i, l, s, c, u, d, p, m;
            return Cg(this, r), Ag(L_(m = t.call(this, e)), "componentRef", void 0), Ag(L_(m), "elementRef", void 0), Ag(L_(m), "handleError", function(e) {
                m.setElementStatus("ready"), m.props.onError && m.props.onError(e, m.elementRef);
            }), Ag(L_(m), "handleAdditionalDetails", function(e) {
                return m.props.onAdditionalDetails ? m.props.onAdditionalDetails(e, m.elementRef) : m.props.session && m.submitAdditionalDetails(e.data), e;
            }), Ag(L_(m), "handleOrder", function(e) {
                m.updateParent({
                    order: e.order
                }), m.props.onPaymentCompleted && m.props.onPaymentCompleted(e, m.elementRef);
            }), Ag(L_(m), "handleFinalResult", function(e) {
                if (m.props.setStatusAutomatically) {
                    var t = function(e) {
                        switch(e.resultCode){
                            case "Authorised":
                            case "Received":
                            case "Pending":
                                return [
                                    "success"
                                ];
                            case "Cancelled":
                            case "Error":
                            case "Refused":
                                return [
                                    "error"
                                ];
                        }
                    }(e), r = Vk(t, 2), a = r[0], n = r[1];
                    a && m.setElementStatus(a, n);
                }
                return m.props.onPaymentCompleted && m.props.onPaymentCompleted(e, m.elementRef), e;
            }), Ag(L_(m), "setComponentRef", function(e) {
                m.componentRef = e;
            }), Ag(L_(m), "payButton", function(e) {
                return nN(hw, M_({}, e, {
                    amount: m.props.amount,
                    secondaryAmount: m.props.secondaryAmount,
                    onClick: m.submit
                }));
            }), m.submit = Jg(a = m.submit).call(a, L_(m)), m.setState = Jg(n = m.setState).call(n, L_(m)), m.onValid = Jg(o = m.onValid).call(o, L_(m)), m.onComplete = Jg(i = m.onComplete).call(i, L_(m)), m.onSubmit = Jg(l = m.onSubmit).call(l, L_(m)), m.handleAction = Jg(s = m.handleAction).call(s, L_(m)), m.handleOrder = Jg(c = m.handleOrder).call(c, L_(m)), m.handleResponse = Jg(u = m.handleResponse).call(u, L_(m)), m.setElementStatus = Jg(d = m.setElementStatus).call(d, L_(m)), m.submitAnalytics = Jg(p = m.submitAnalytics).call(p, L_(m)), m.elementRef = e && e.elementRef || L_(m), m;
        }
        return wg(r, [
            {
                key: "setState",
                value: function(e) {
                    this.state = KS(KS({}, this.state), e), this.onChange();
                }
            },
            {
                key: "onChange",
                value: function() {
                    var e = this.isValid, t = {
                        data: this.data,
                        errors: this.state.errors,
                        valid: this.state.valid,
                        isValid: e
                    };
                    return this.props.onChange && this.props.onChange(t, this.elementRef), e && this.onValid(), t;
                }
            },
            {
                key: "setUpAnalytics",
                value: function(e) {
                    var t, r = null === (t = this.props.session) || void 0 === t ? void 0 : t.id;
                    return this.props.modules.analytics.setUp(KS(KS({}, e), r && {
                        sessionId: r
                    }));
                }
            },
            {
                key: "submitAnalytics",
                value: function(e, t) {
                    var r, a = this.constructor.analyticsType;
                    a || (a = "scheme" === this.constructor.type || "bcmc" === this.constructor.type ? this.constructor.type : this.props.type), null === (r = this.props.modules) || void 0 === r || r.analytics.sendAnalytics(a, e, t);
                }
            },
            {
                key: "onSubmit",
                value: function() {
                    var e = this;
                    this.props.isInstantPayment && this.elementRef.closeActivePaymentMethod();
                    if (this.props.setStatusAutomatically && this.setElementStatus("loading"), this.props.onSubmit) this.submitAnalytics({
                        type: BN
                    }), this.props.onSubmit({
                        data: this.data,
                        isValid: this.isValid
                    }, this.elementRef);
                    else if (this._parentInstance.session) {
                        var t = this.props.beforeSubmit ? new Ab(function(t, r) {
                            return e.props.beforeSubmit(e.data, e.elementRef, {
                                resolve: t,
                                reject: r
                            });
                        }) : Ab.resolve(this.data);
                        t.then(function(t) {
                            return e.submitAnalytics({
                                type: BN
                            }), e.submitPayment(t);
                        }).catch(function() {
                            e.elementRef.setStatus("ready");
                        });
                    } else this.handleError(new LS("IMPLEMENTATION_ERROR", "Could not submit the payment"));
                }
            },
            {
                key: "onValid",
                value: function() {
                    var e = {
                        data: this.data
                    };
                    return this.props.onValid && this.props.onValid(e, this.elementRef), e;
                }
            },
            {
                key: "onComplete",
                value: function(e) {
                    this.props.onComplete && this.props.onComplete(e, this.elementRef);
                }
            },
            {
                key: "submit",
                value: function() {
                    this.isValid ? this.onSubmit() : this.showValidation();
                }
            },
            {
                key: "showValidation",
                value: function() {
                    return this.componentRef && this.componentRef.showValidation && this.componentRef.showValidation(), this;
                }
            },
            {
                key: "setElementStatus",
                value: function(e, t) {
                    var r;
                    return null === (r = this.elementRef) || void 0 === r || r.setStatus(e, t), this;
                }
            },
            {
                key: "setStatus",
                value: function(e, t) {
                    var r;
                    return null !== (r = this.componentRef) && void 0 !== r && r.setStatus && this.componentRef.setStatus(e, t), this;
                }
            },
            {
                key: "submitPayment",
                value: function(e) {
                    var t = this;
                    return this._parentInstance.session.submitPayment(e).then(this.handleResponse).catch(function(e) {
                        return t.handleError(e);
                    });
                }
            },
            {
                key: "submitAdditionalDetails",
                value: function(e) {
                    return this._parentInstance.session.submitDetails(e).then(this.handleResponse).catch(this.handleError);
                }
            },
            {
                key: "handleAction",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (!e || !e.type) {
                        if (VS(e, "action") && VS(e, "resultCode")) throw new Error('handleAction::Invalid Action - the passed action object itself has an "action" property and a "resultCode": have you passed in the whole response object by mistake?');
                        throw new Error('handleAction::Invalid Action - the passed action object does not have a "type" property');
                    }
                    var r = this._parentInstance.createFromAction(e, KS(KS(KS({}, this.elementRef.props), t), {}, {
                        onAdditionalDetails: this.handleAdditionalDetails
                    }));
                    return r ? (this.unmount(), r.mount(this._node)) : null;
                }
            },
            {
                key: "handleResponse",
                value: function(e) {
                    var t, r = function(e) {
                        var t, r = [], a = tC(t = Ty(e)).call(t, function(t, a) {
                            return kb(vw).call(vw, a) ? t[a] = e[a] : r.push(a), t;
                        }, {});
                        return r.length && console.warn("The following properties should not be passed to the client: ".concat(r.join(", "))), a;
                    }(e);
                    r.action ? this.elementRef.handleAction(r.action) : (null === (t = r.order) || void 0 === t || null === (t = t.remainingAmount) || void 0 === t ? void 0 : t.value) > 0 ? this.handleOrder(r) : this.elementRef.handleFinalResult(r);
                }
            },
            {
                key: "updateParent",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    return this.elementRef._parentInstance.update(e);
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !1;
                }
            },
            {
                key: "icon",
                get: function() {
                    var e, t = this.props.paymentMethodType || this.type;
                    return null !== (e = this.props.icon) && void 0 !== e ? e : this.resources.getImage()(t);
                }
            },
            {
                key: "displayName",
                get: function() {
                    return this.props.name || this.constructor.type;
                }
            },
            {
                key: "additionalInfo",
                get: function() {
                    return null;
                }
            },
            {
                key: "accessibleName",
                get: function() {
                    return this.displayName;
                }
            },
            {
                key: "type",
                get: function() {
                    return this.props.type || this.constructor.type;
                }
            }
        ]), r;
    }(oP);
    function WS(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var GS = function(e) {
        U_(r, e);
        var t = WS(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "iframeEl", void 0), a;
        }
        return wg(r, [
            {
                key: "iframeOnLoad",
                value: function() {
                    this.props.callback && "function" == typeof this.props.callback && this.props.callback(this.iframeEl.contentWindow);
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e;
                    if (this.iframeEl.addEventListener) this.iframeEl.addEventListener("load", Jg(e = this.iframeOnLoad).call(e, this), !1);
                    else if (this.iframeEl.attachEvent) {
                        var t;
                        this.iframeEl.attachEvent("onload", Jg(t = this.iframeOnLoad).call(t, this));
                    } else {
                        var r;
                        this.iframeEl.onload = Jg(r = this.iframeOnLoad).call(r, this);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e;
                    if (this.iframeEl.removeEventListener) this.iframeEl.removeEventListener("load", Jg(e = this.iframeOnLoad).call(e, this), !1);
                    else if (this.iframeEl.detachEvent) {
                        var t;
                        this.iframeEl.detachEvent("onload", Jg(t = this.iframeOnLoad).call(t, this));
                    } else this.iframeEl.onload = null;
                }
            },
            {
                key: "render",
                value: function(e) {
                    var t = this, r = e.name, a = e.src, n = e.width, o = e.height, i = e.minWidth, l = e.minHeight, s = e.allow, c = e.title, u = e.classNameModifiers, d = xg(u).call(u, function(e) {
                        return !!e;
                    });
                    return nN("iframe", {
                        ref: function(e) {
                            t.iframeEl = e;
                        },
                        allow: s,
                        className: DP("adyen-checkout__iframe", "adyen-checkout__iframe--".concat(r), d.length && hC(u).call(u, function(e) {
                            var t;
                            return wb(t = "adyen-checkout__iframe--".concat(r, "-")).call(t, e);
                        })),
                        name: r,
                        src: a,
                        width: n,
                        height: o,
                        frameBorder: "0",
                        title: c,
                        referrerpolicy: "origin",
                        "min-width": i,
                        "min-height": l
                    });
                }
            }
        ]), r;
    }(lN);
    Ag(GS, "defaultProps", {
        width: "0",
        height: "0",
        minWidth: "0",
        minHeight: "0",
        src: null,
        allow: null,
        title: "components iframe",
        classNameModifiers: []
    });
    var YS = function(e, t, r) {
        var a, n = new Ab(function(n, o) {
            a = NP(function() {
                o(r);
            }, e), t.then(function(e) {
                clearTimeout(a), n(e);
            }).catch(function(e) {
                clearTimeout(a), o(e);
            });
        });
        return {
            promise: n,
            cancel: function() {
                clearTimeout(a);
            }
        };
    }, QS = "deviceFingerprint", ZS = {
        result: {
            type: QS,
            value: "df-timedOut"
        },
        errorCode: "timeout"
    }, JS = "unknownError", $S = {
        timeout: "iframe loading timed out",
        wrongOrigin: "Result did not come from the expected origin",
        wrongDataType: "Result data was not of the expected type",
        missingProperty: "Result data did not contain the expected properties",
        unknownError: "An unknown error occurred"
    }, XS = function(e, t, r, a) {
        return function(r) {
            var n = {};
            if ((r.origin || r.originalEvent.origin) !== e) return "Message was not sent from the expected domain";
            if ("string" != typeof r.data) return "Event data was not of type string";
            if (!r.data.length) return "Invalid event data string";
            try {
                var o = JSON.parse(r.data);
                if (!VS(o, "type") || o.type !== a) return "Event data was not of expected type";
                t(o);
            } catch (e) {
                return n.type = "".concat(a, "-JSON-parse-error"), n.comment = "failed to JSON parse event.data", n.extraInfo = "event.data = ".concat(r.data), n.eventDataRaw = r.data, console.debug("get-process-message-handler::CATCH::Un-parseable JSON:: parseErrorObj=", n), !1;
            }
            return !0;
        };
    }, eI = function(e) {
        var t, r, a, n = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/.exec(e);
        if (!n) return null;
        var o = Vk(n, 5), i = o[1], l = o[2], s = o[3], c = o[4];
        return i && l && s ? wb(t = wb(r = wb(a = "".concat(i, ":")).call(a, l)).call(r, s)).call(t, c ? ":".concat(c) : "") : null;
    };
    function tI(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var rI = function(e) {
        U_(r, e);
        var t = tI(r);
        function r(e) {
            var a;
            return Cg(this, r), Ag(L_(a = t.call(this, e)), "postMessageDomain", void 0), Ag(L_(a), "processMessageHandler", void 0), Ag(L_(a), "deviceFingerPrintPromise", void 0), a.postMessageDomain = eI(a.props.loadingContext) || a.props.loadingContext, a;
        }
        return wg(r, [
            {
                key: "getDfpPromise",
                value: function() {
                    var e = this;
                    return new Ab(function(t, r) {
                        e.processMessageHandler = XS(e.postMessageDomain, t, 0, QS), window.addEventListener("message", e.processMessageHandler);
                    });
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.deviceFingerPrintPromise = YS(2e4, this.getDfpPromise(), ZS), this.deviceFingerPrintPromise.promise.then(function(t) {
                        e.props.onCompleteFingerprint(t), window.removeEventListener("message", e.processMessageHandler);
                    }).catch(function(t) {
                        e.props.onErrorFingerprint(t), window.removeEventListener("message", e.processMessageHandler);
                    });
                }
            },
            {
                key: "render",
                value: function(e) {
                    var t = e.dfpURL;
                    return nN("div", {
                        className: "adyen-checkout-risk__device-fingerprint"
                    }, nN(GS, {
                        name: "dfIframe",
                        src: t,
                        allow: "geolocation; microphone; camera;",
                        title: "devicefingerprinting iframe"
                    }));
                }
            }
        ]), r;
    }(lN);
    function aI(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var nI = function(e) {
        U_(r, e);
        var t = aI(r);
        function r(e) {
            var a, n, o;
            (Cg(this, r), a = t.call(this, e), e.clientKey) && (a.state = {
                status: "retrievingFingerPrint",
                dfpURL: wb(n = wb(o = "".concat(a.props.loadingContext, "assets/html/")).call(o, e.clientKey, "/dfp.")).call(n, "1.0.0", ".html")
            });
            return a;
        }
        return wg(r, [
            {
                key: "setStatusComplete",
                value: function(e) {
                    var t = this;
                    this.setState({
                        status: "complete"
                    }, function() {
                        t.props.onComplete(e);
                    });
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r = this, a = e.loadingContext, n = t.dfpURL;
                    return "retrievingFingerPrint" === this.state.status ? nN("div", {
                        className: "adyen-checkout-risk__device-fingerprint--wrapper",
                        style: {
                            position: "absolute",
                            width: 0,
                            height: 0
                        }
                    }, nN(rI, {
                        loadingContext: a,
                        dfpURL: n,
                        onCompleteFingerprint: function(e) {
                            r.setStatusComplete(e);
                        },
                        onErrorFingerprint: function(e) {
                            var t;
                            r.props.onError({
                                errorCode: t = e.errorCode,
                                message: $S[t] || $S[JS],
                                type: QS
                            }), r.setStatusComplete(e.result);
                        }
                    })) : null;
                }
            }
        ]), r;
    }(lN);
    Ag(nI, "defaultProps", {
        onComplete: function() {},
        onError: function() {}
    });
    var oI = t(wy), iI = {
        decode: function(e) {
            if (!iI.isBase64(e)) return {
                success: !1,
                error: "not base64"
            };
            try {
                var t = (r = e, decodeURIComponent(hC(Array.prototype).call(window.atob(r), function(e) {
                    var t;
                    return "%".concat(oI(t = "00".concat(e.charCodeAt(0).toString(16))).call(t, -2));
                }).join("")));
                return {
                    success: !0,
                    data: t
                };
            } catch (e) {
                return {
                    success: !1,
                    error: "malformed URI sequence"
                };
            }
            var r;
        },
        encode: function(e) {
            return window.btoa(e);
        },
        isBase64: function(e) {
            if (!e) return !1;
            if (e.length % 4) return !1;
            try {
                return window.btoa(window.atob(e)) === e;
            } catch (e) {
                return !1;
            }
        }
    };
    function lI(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function sI(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = lI(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = lI(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function cI(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var uI = function(e) {
        U_(r, e);
        var t = cI(r);
        function r(e) {
            var a;
            Cg(this, r), Ag(L_(a = t.call(this, e)), "nodeRiskContainer", null), Ag(L_(a), "onComplete", function(e) {
                var t = sI(sI({}, a.state.data), {}, Ag(Ag(Ag({}, e.type, e.value), "persistentCookie", e.persistentCookie), "components", e.components));
                a.setState({
                    data: t,
                    isValid: !0
                }), a.props.risk.onComplete(a.data), a.cleanUp();
            }), Ag(L_(a), "onError", function(e) {
                a.props.risk.onError(e), a.cleanUp();
            }), Ag(L_(a), "cleanUp", function() {
                a.nodeRiskContainer && a.nodeRiskContainer.parentNode && a.nodeRiskContainer.parentNode.removeChild(a.nodeRiskContainer);
            });
            var n = Ag({}, QS, null);
            return a.setState({
                data: n
            }), !0 === a.props.risk.enabled && (document.querySelector(a.props.risk.node) ? (a.nodeRiskContainer = document.createElement("div"), document.querySelector(a.props.risk.node).appendChild(a.nodeRiskContainer), a.mount(a.nodeRiskContainer)) : a.onError({
                message: "RiskModule node was not found"
            })), a;
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return sI(sI({}, e), {}, {
                        risk: sI(sI({}, r.defaultProps.risk), e.risk)
                    });
                }
            },
            {
                key: "isValid",
                get: function() {
                    return this.state.isValid;
                }
            },
            {
                key: "data",
                get: function() {
                    if (this.isValid) {
                        var e = sI({
                            version: "1.0.0"
                        }, this.state.data);
                        return iI.encode(Mb(e));
                    }
                    return !1;
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.cleanUp();
                }
            },
            {
                key: "render",
                value: function() {
                    return nN(nI, M_({}, this.props, {
                        loadingContext: this.props.loadingContext,
                        onComplete: this.onComplete,
                        onError: this.onError
                    }));
                }
            }
        ]), r;
    }(oP);
    Ag(uI, "type", "risk"), Ag(uI, "defaultProps", {
        risk: {
            enabled: !0,
            onComplete: function() {},
            onError: function() {},
            node: "body"
        }
    });
    var dI = Je, pI = R, mI = X, fI = tr, hI = function(e) {
        return void 0 !== e && (dI(e, "value") || dI(e, "writable"));
    }, vI = S, yI = Mr;
    Sr({
        target: "Reflect",
        stat: !0
    }, {
        get: function e(t, r) {
            var a, n, o = arguments.length < 3 ? t : arguments[2];
            return fI(t) === o ? t[r] : (a = vI.f(t, r)) ? hI(a) ? a.value : void 0 === a.get ? void 0 : pI(a.get, o) : mI(n = yI(t)) ? e(n, r, o) : void 0;
        }
    });
    var gI = t(ee.Reflect.get), bI = t(qy);
    function kI() {
        var e;
        "undefined" != typeof Reflect && gI ? kI = B_(e = gI).call(e) : kI = function(e, t, r) {
            var a = function(e, t) {
                for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = H_(e)););
                return e;
            }(e, t);
            if (a) {
                var n = bI(a, t);
                return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
            }
        };
        return kI.apply(this, arguments);
    }
    var CI = um.every;
    Sr({
        target: "Array",
        proto: !0,
        forced: !vv("every")
    }, {
        every: function(e) {
            return CI(this, e, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var _I = Cv("Array", "every"), NI = ie, PI = _I, wI = Array.prototype, AI = t(function(e) {
        var t = e.every;
        return e === wI || NI(wI, e) && t === wI.every ? PI : t;
    });
    function SI(e) {
        var t, r = e.children, a = e.classNameModifiers, n = void 0 === a ? [] : a, o = e.label, i = e.readonly, l = void 0 !== i && i, s = sw().i18n;
        return nN("fieldset", {
            className: DP(wb(t = [
                "adyen-checkout__fieldset"
            ]).call(t, Uk(hC(n).call(n, function(e) {
                return "adyen-checkout__fieldset--".concat(e);
            })), [
                {
                    "adyen-checkout__fieldset--readonly": l
                }
            ]))
        }, o && nN("legend", {
            className: "adyen-checkout__fieldset__title"
        }, s.get(o)), nN("div", {
            className: "adyen-checkout__fieldset__fields"
        }, r));
    }
    function II() {
        var e = sw().resources;
        return GP(function(t) {
            return null == e ? void 0 : e.getImage(t);
        }, []);
    }
    var EI, DI = function(e) {
        var t, r = e.type, a = e.className, n = void 0 === a ? "" : a, o = e.alt, i = void 0 === o ? "" : o, l = e.height, s = e.width, c = null === (t = II()({
            imageFolder: "components/"
        })) || void 0 === t ? void 0 : t(r);
        return nN("img", {
            className: DP("adyen-checkout__icon", n),
            alt: i,
            src: c,
            height: l,
            width: s
        });
    }, RI = "encryptedCardNumber", FI = "encryptedExpiryDate", xI = "encryptedExpiryMonth", TI = "encryptedExpiryYear", zI = "encryptedSecurityCode", OI = "encryptedPassword", jI = "encryptedBankAccountNumber", BI = "encryptedBankLocationId", MI = "encryptedSecurityCode3digits", LI = "encryptedSecurityCode4digits", VI = "giftcard", UI = [
        "amex",
        "mc",
        "visa"
    ], KI = [
        "ach",
        VI
    ], HI = [
        RI,
        FI,
        xI,
        TI,
        zI,
        OI
    ], qI = [
        jI,
        BI
    ], WI = wb(HI).call(HI, qI), GI = [
        "bcmc"
    ], YI = "required", QI = "optional", ZI = "hidden", JI = YI, $I = QI, XI = ZI, eE = YI, tE = QI, rE = ZI, aE = "data-cse", nE = "data-info", oE = "data-uid", iE = [
        "accel",
        "pulse",
        "star",
        "nyce"
    ], lE = {
        visa: "VISA",
        mc: "MasterCard",
        amex: "American Express",
        discover: "Discover",
        cup: "China Union Pay",
        jcb: "JCB",
        diners: "Diners Club",
        maestro: "Maestro",
        bcmc: "Bancontact card",
        bijcard: "de Bijenkorf Card"
    }, sE = "-ariaError", cE = "incomplete field", uE = "Unsupported card entered", dE = "Card number field empty", pE = "Expiry date field empty", mE = "Expiry year field empty", fE = "Expiry month field empty", hE = "Security code field empty", vE = "KCP password field empty", yE = "ACH bank account field empty", gE = "ACH bank location field empty", bE = (Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(EI = {}, cE, "error.va.gen.01"), "field not valid", "error.va.gen.02"), "luhn check failed", "error.va.sf-cc-num.01"), dE, "error.va.sf-cc-num.02"), uE, "error.va.sf-cc-num.03"), "Card number not filled correctly", "error.va.sf-cc-num.04"), "Card too old", "error.va.sf-cc-dat.01"), "Date too far in future", "error.va.sf-cc-dat.02"), "Your card expires before check out date", "error.va.sf-cc-dat.03"), pE, "error.va.sf-cc-dat.04"), Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(EI, "Expiry date not filled correctly", "error.va.sf-cc-dat.05"), mE, "error.va.sf-cc-yr.01"), "Expiry year not filled correctly", "error.va.sf-cc-yr.02"), fE, "error.va.sf-cc-mth.01"), hE, "error.va.sf-cc-cvc.01"), "Security code not filled correctly", "error.va.sf-cc-cvc.02"), vE, "error.va.sf-kcp-pwd.01"), "KCP password not filled correctly", "error.va.sf-kcp-pwd.02"), yE, "error.va.sf-ach-num.01"), "ACH bank account not filled correctly", "error.va.sf-ach-num.02"), Ag(Ag(EI, gE, "error.va.sf-ach-loc.01"), "ACH bank location id not filled correctly", "error.va.sf-ach-loc.02")), kE = bE[cE], CE = Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag({}, RI, bE[dE]), FI, bE[pE]), xI, bE[fE]), TI, bE[mE]), zI, bE[hE]), OI, bE[vE]), jI, bE[yE]), BI, bE[gE]), _E = "focusField", NE = "notValidating:blurScenario", PE = Sr, wE = Date, AE = h(wE.prototype.getTime);
    PE({
        target: "Date",
        stat: !0
    }, {
        now: function() {
            return AE(new wE);
        }
    });
    var SE = t(ee.Date.now), IE = SE(), EE = function() {
        var e;
        return IE += 1, wb(e = "".concat(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "field", "-")).call(e, IE);
    };
    function DE(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function RE(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = DE(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = DE(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var FE = function(e) {
        var t = e.children, r = e.className, a = e.classNameModifiers, n = e.dir, o = e.disabled, i = e.errorMessage, l = e.helper, s = e.inputWrapperModifiers, c = e.isLoading, u = e.isValid, d = e.label, p = e.labelEndAdornment, m = e.name, f = e.onBlur, h = e.onFieldBlur, v = e.onFocus, y = e.onFocusField, g = e.showValidIcon, b = e.useLabelElement, k = e.addContextualElement, C = e.filled, _ = e.focused, N = e.i18n, P = e.errorVisibleToScreenReader, w = e.renderAlternativeToLabel, A = null == P || P, S = qP(EE("adyen-checkout-".concat(m))), I = Vk(VP(!1), 2), E = I[0], D = I[1], R = Vk(VP(!1), 2), F = R[0], x = R[1];
        null != _ && D(!!_), null != C && x(!!C);
        var T = GP(function(e) {
            D(!0), null == v || v(e);
        }, [
            v
        ]), z = GP(function(e) {
            D(!1), null == f || f(e), null == h || h(e);
        }, [
            f,
            h
        ]), O = GP(function() {
            return nN(iN, null, "string" == typeof d && nN("span", {
                className: DP({
                    "adyen-checkout__label__text": !0,
                    "adyen-checkout__label__text--error": i
                }),
                "data-id": m
            }, d), "function" == typeof d && d(), p && nN("span", {
                className: "adyen-checkout__label-adornment--end"
            }, p), l && nN("span", {
                className: "adyen-checkout__helper-text"
            }, l));
        }, [
            d,
            i,
            p,
            l
        ]), j = GP(function() {
            var e, r, a;
            return nN(iN, null, nN("div", {
                className: DP(wb(e = [
                    "adyen-checkout__input-wrapper"
                ]).call(e, Uk(hC(s).call(s, function(e) {
                    return "adyen-checkout__input-wrapper--".concat(e);
                })))),
                dir: n
            }, hC(r = fN(t)).call(r, function(e) {
                return function(e, t, r) {
                    var a, n, o, i = rN({}, e.props);
                    for(o in t)"key" == o ? a = t[o] : "ref" == o ? n = t[o] : i[o] = t[o];
                    return arguments.length > 2 && (i.children = arguments.length > 3 ? q_.call(arguments, 2) : r), oN(e.type, i, a || e.key, n || e.ref, null);
                }(e, RE(RE({
                    isValid: u,
                    onFocusHandler: T,
                    onBlurHandler: z,
                    isInvalid: !!i
                }, m && {
                    uniqueId: S.current
                }), {}, {
                    addContextualElement: k
                }));
            }), c && nN("span", {
                className: "adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--loading"
            }, nN(RP, {
                size: "small"
            })), u && !1 !== g && nN("span", {
                className: "adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--valid"
            }, nN(DI, {
                type: "checkmark",
                alt: null == N ? void 0 : N.get("field.valid")
            })), i && nN("span", {
                className: "adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--invalid"
            }, nN(DI, {
                type: "field_error",
                alt: null == N ? void 0 : N.get("error.title")
            }))), k && nN("span", M_({
                className: "adyen-checkout__error-text"
            }, A && {
                id: wb(a = "".concat(S.current)).call(a, sE)
            }, {
                "aria-hidden": A ? null : "true"
            }), i && "string" == typeof i && i.length ? i : null));
        }, [
            t,
            i,
            c,
            u,
            T,
            z
        ]), B = GP(function(e) {
            var t = e.onFocusField, r = e.focused, a = e.filled, n = e.disabled, o = e.name, i = e.uniqueId, l = e.useLabelElement, s = e.isSecuredField, c = e.children, u = e.renderAlternativeToLabel, d = {
                onClick: t,
                className: DP({
                    "adyen-checkout__label": !0,
                    "adyen-checkout__label--focused": r,
                    "adyen-checkout__label--filled": a,
                    "adyen-checkout__label--disabled": n
                })
            };
            return l ? nN("label", M_({}, d, !s && {
                htmlFor: o && i
            }), c) : u(d, c, i);
        }, []);
        return nN("div", {
            className: DP("adyen-checkout__field", r, hC(a).call(a, function(e) {
                return "adyen-checkout__field--".concat(e);
            }), {
                "adyen-checkout__field--error": i,
                "adyen-checkout__field--valid": u
            })
        }, nN(B, {
            onFocusField: y,
            name: m,
            disabled: o,
            filled: F,
            focused: E,
            useLabelElement: b,
            uniqueId: S.current,
            isSecuredField: !A,
            renderAlternativeToLabel: w
        }, O()), j());
    };
    FE.defaultProps = {
        className: "",
        classNameModifiers: [],
        inputWrapperModifiers: [],
        useLabelElement: !0,
        addContextualElement: !0,
        renderAlternativeToLabel: function() {
            return null;
        }
    };
    var xE = function(e) {
        var t = e.data, r = t.name, a = t.registrationNumber;
        return nN(SI, {
            classNameModifiers: [
                "companyDetails"
            ],
            label: "companyDetails",
            readonly: !0
        }, r && "".concat(r, " "), a && "".concat(a, " "));
    }, TE = si.PROPER, zE = n, OE = EC, jE = function(e) {
        return zE(function() {
            return !!OE[e]() || "\u200B\x85\u180E" !== "\u200B\x85\u180E"[e]() || TE && OE[e].name !== e;
        });
    }, BE = jC.start, ME = jE("trimStart") ? function() {
        return BE(this);
    } : "".trimStart;
    Sr({
        target: "String",
        proto: !0,
        name: "trimStart",
        forced: "".trimLeft !== ME
    }, {
        trimLeft: ME
    });
    Sr({
        target: "String",
        proto: !0,
        name: "trimStart",
        forced: "".trimStart !== ME
    }, {
        trimStart: ME
    });
    var LE = Cv("String", "trimLeft"), VE = ie, UE = LE, KE = String.prototype, HE = t(function(e) {
        var t = e.trimStart;
        return "string" == typeof e || e === KE || VE(KE, e) && t === KE.trimStart ? UE : t;
    }), qE = function(e, t, r, a) {
        var n, o;
        if (a && null !== (n = e[r]) && void 0 !== n && null !== (n = n[t]) && void 0 !== n && n.formatterFn) return null;
        var i = null === (o = e[r]) || void 0 === o || null === (o = o[t]) || void 0 === o ? void 0 : o.maxlength;
        return i || 30;
    }, WE = function(e) {
        return !(null != e && !/^[\s]*$/.test(e));
    }, GE = "?\\+_=!@#$%^&*(){}~<>\\[\\]\\\\", YE = function(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "g";
        return new RegExp("[".concat(e, "]"), t);
    };
    (function(e, t) {
        var r;
        new RegExp(wb(r = "^[".concat(t ? "^" : "")).call(r, e, "]+$"));
    })(GE, !0);
    var QE = {
        default: {
            validate: function(e) {
                return e && e.length > 0;
            },
            modes: [
                "blur"
            ],
            errorMessage: "error.va.gen.01"
        },
        name: {
            validate: function(e) {
                return !WE(e) || null;
            },
            errorMessage: "companyDetails.name.invalid",
            modes: [
                "blur"
            ]
        },
        registrationNumber: {
            validate: function(e) {
                return !WE(e) || null;
            },
            errorMessage: "companyDetails.registrationNumber.invalid",
            modes: [
                "blur"
            ]
        }
    };
    function ZE(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function JE(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = ZE(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = ZE(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var $E = function(e) {
        var t = e.name, r = e.registrationNumber;
        return JE({}, (t || r) && {
            company: JE(JE({}, t && {
                name: t
            }), r && {
                registrationNumber: r
            })
        });
    }, XE = function() {
        function e(t, r, a, n) {
            var o;
            Cg(this, e), Ag(this, "shouldValidate", void 0), Ag(this, "isValid", void 0), Ag(this, "errorMessage", void 0), this.shouldValidate = kb(o = t.modes).call(o, a), this.isValid = t.validate(r, n), this.errorMessage = t.errorMessage;
        }
        return wg(e, [
            {
                key: "hasError",
                value: function() {
                    return arguments.length > 0 && void 0 !== arguments[0] && arguments[0] ? !this.isValid && this.shouldValidate : null != this.isValid && !this.isValid && this.shouldValidate;
                }
            }
        ]), e;
    }();
    function eD(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function tD(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = eD(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = eD(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var rD = function() {
        function e(t) {
            Cg(this, e), Ag(this, "validationResults", void 0), this.validationResults = t;
        }
        return wg(e, [
            {
                key: "isValid",
                get: function() {
                    var e;
                    return tC(e = this.validationResults).call(e, function(e, t) {
                        return e && t.isValid;
                    }, !0);
                }
            },
            {
                key: "hasError",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    return Boolean(this.getError(e));
                }
            },
            {
                key: "getError",
                value: function() {
                    var e, t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    return zb(e = this.validationResults).call(e, function(e) {
                        return e.hasError(t);
                    });
                }
            },
            {
                key: "getAllErrors",
                value: function() {
                    var e;
                    return xg(e = this.validationResults).call(e, function(e) {
                        return e.hasError();
                    });
                }
            }
        ]), e;
    }(), aD = function() {
        function e(t) {
            Cg(this, e), Ag(this, "rules", {
                default: {
                    validate: function() {
                        return !0;
                    },
                    modes: [
                        "blur",
                        "input"
                    ]
                }
            }), this.setRules(t);
        }
        return wg(e, [
            {
                key: "setRules",
                value: function(e) {
                    this.rules = tD(tD({}, this.rules), e);
                }
            },
            {
                key: "getRulesFor",
                value: function(e) {
                    var t, r = null !== (t = this.rules[e]) && void 0 !== t ? t : this.rules.default;
                    return PP(r) || (r = [
                        r
                    ]), r;
                }
            },
            {
                key: "validate",
                value: function(e, t) {
                    var r = e.key, a = e.value, n = e.mode, o = void 0 === n ? "blur" : n, i = this.getRulesFor(r), l = hC(i).call(i, function(e) {
                        return new XE(e, a, o, t);
                    });
                    return new rD(l);
                }
            }
        ]), e;
    }(), nD = I, oD = n, iD = h, lD = Mr, sD = Ma, cD = Z, uD = iD(F.f), dD = iD([].push), pD = nD && oD(function() {
        var e = Object.create(null);
        return e[2] = 2, !uD(e, 2);
    }), mD = function(e) {
        return function(t) {
            for(var r, a = cD(t), n = sD(a), o = pD && null === lD(a), i = n.length, l = 0, s = []; i > l;)r = n[l++], nD && !(o ? r in a : uD(a, r)) || dD(s, e ? [
                r,
                a[r]
            ] : a[r]);
            return s;
        };
    }, fD = {
        entries: mD(!0),
        values: mD(!1)
    }, hD = fD.values;
    Sr({
        target: "Object",
        stat: !0
    }, {
        values: function(e) {
            return hD(e);
        }
    });
    var vD = t(ee.Object.values);
    function yD(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function gD(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = yD(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = yD(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var bD = function(e, t) {
        var r, a;
        return tC(r = xg(a = Ty(e)).call(a, function(e) {
            return !kb(t).call(t, e);
        })).call(r, function(t, r) {
            return t[r] = e[r], t;
        }, {});
    }, kD = function(e, t, r, a, n) {
        return tC(t).call(t, function(e, t) {
            var o, i, l;
            return gD(gD({}, e), {}, Ag({}, t, null !== (o = null !== (i = null !== (l = e[t]) && void 0 !== l ? l : null == n ? void 0 : n[t]) && void 0 !== i ? i : null == a ? void 0 : a[t]) && void 0 !== o ? o : r));
        }, e);
    };
    function CD(e) {
        var t = e.schema, r = e.defaultData, a = e.processField, n = e.fieldProblems, o = function(e) {
            var t, o;
            if (void 0 === r[e]) return {
                valid: !1,
                errors: null,
                data: null,
                fieldProblems: null !== (t = null == n ? void 0 : n[e]) && void 0 !== t ? t : null
            };
            var i = Vk(a({
                key: e,
                value: r[e],
                mode: "blur"
            }, {
                state: {
                    data: r
                }
            }), 2), l = i[0], s = i[1];
            return {
                valid: s.isValid && !(null != n && n[e]) || !1,
                errors: s.hasError() ? s.getError() : null,
                data: l,
                fieldProblems: null !== (o = null == n ? void 0 : n[e]) && void 0 !== o ? o : null
            };
        }, i = tC(t).call(t, function(e, t) {
            var r = o(t), a = r.valid, n = r.errors, i = r.data, l = r.fieldProblems;
            return {
                valid: gD(gD({}, e.valid), {}, Ag({}, t, a)),
                errors: gD(gD({}, e.errors), {}, Ag({}, t, n)),
                data: gD(gD({}, e.data), {}, Ag({}, t, i)),
                fieldProblems: gD(gD({}, e.fieldProblems), {}, Ag({}, t, l))
            };
        }, {
            data: {},
            valid: {},
            errors: {},
            fieldProblems: {}
        });
        return {
            schema: t,
            data: i.data,
            valid: i.valid,
            errors: i.errors,
            fieldProblems: i.fieldProblems
        };
    }
    function _D(e) {
        var t = e.rules, r = void 0 === t ? {} : t, a = e.formatters, n = void 0 === a ? {} : a, o = e.defaultData, i = void 0 === o ? {} : o, l = e.fieldProblems, s = void 0 === l ? {} : l, c = e.schema, u = void 0 === c ? [] : c, d = WP(function() {
            return new aD(r);
        }, [
            r
        ]), p = function(e, t) {
            var r = e.key, a = e.value, o = e.mode, i = null == n ? void 0 : n[r], l = function(e) {
                return e && "formatterFn" in e;
            }(i) ? i.formatterFn : i, s = l && "function" == typeof l ? l(null != a ? a : "", t) : a;
            return [
                s,
                d.validate({
                    key: r,
                    value: s,
                    mode: o
                }, t)
            ];
        }, m = UP(function(e) {
            return function(t, r) {
                var a = r.type, n = r.key, o = r.value, i = r.mode, l = r.schema, s = r.defaultData, c = r.formValue, u = r.selectedSchema, d = r.fieldProblems, p = u || t.schema;
                switch(a){
                    case "setData":
                        return gD(gD({}, t), {}, {
                            data: gD(gD({}, t.data), {}, Ag({}, n, o))
                        });
                    case "setValid":
                        return gD(gD({}, t), {}, {
                            valid: gD(gD({}, t.valid), {}, Ag({}, n, o))
                        });
                    case "setErrors":
                        return gD(gD({}, t), {}, {
                            errors: gD(gD({}, t.errors), {}, Ag({}, n, o))
                        });
                    case "setFieldProblems":
                        var m, f;
                        return null !== (m = null == t || null === (f = t.schema) || void 0 === f ? void 0 : tC(f).call(f, function(e, r) {
                            var a, n;
                            return gD(gD({}, e), {}, {
                                fieldProblems: gD(gD({}, t.fieldProblems), {}, Ag({}, r, null !== (a = null == d ? void 0 : d[r]) && void 0 !== a ? a : null)),
                                valid: gD(gD({}, t.valid), {}, Ag({}, r, (null === (n = t.valid) || void 0 === n ? void 0 : n[r]) && !d[r]))
                            });
                        }, t)) && void 0 !== m ? m : t;
                    case "updateField":
                        var h = Vk(e({
                            key: n,
                            value: o,
                            mode: i
                        }, {
                            state: t
                        }), 2), v = h[0], y = h[1], g = t.data[n], b = gD({}, t.fieldProblems);
                        return g !== v && (b[n] = null), gD(gD({}, t), {}, {
                            data: gD(gD({}, t.data), {}, Ag({}, n, v)),
                            errors: gD(gD({}, t.errors), {}, Ag({}, n, y.hasError() ? y.getError() : null)),
                            valid: gD(gD({}, t.valid), {}, Ag({}, n, y.isValid && !b[n] || !1)),
                            fieldProblems: b
                        });
                    case "mergeForm":
                        var k, C = gD(gD({}, t), {}, {
                            data: gD(gD({}, t.data), c.data),
                            errors: gD(gD({}, t.errors), c.errors),
                            valid: gD(gD({}, t.valid), c.valid),
                            fieldProblems: gD(gD({}, t.fieldProblems), c.fieldProblems)
                        });
                        return C.valid && (C.isValid = AI(k = vD(C.valid)).call(k, function(e) {
                            return e;
                        })), C;
                    case "setSchema":
                        var _, N, P, w, A = CD({
                            schema: l,
                            defaultData: s,
                            processField: e,
                            fieldProblems: d
                        }), S = xg(_ = t.schema).call(_, function(e) {
                            return !kb(l).call(l, e);
                        }), I = xg(l).call(l, function(e) {
                            var r;
                            return !kb(r = t.schema).call(r, e);
                        }), E = {
                            data: bD(t.data, I),
                            errors: bD(t.errors, I),
                            valid: bD(t.valid, I)
                        }, D = kD(bD(t.data, S), I, null, A.data, null === (N = t.local) || void 0 === N ? void 0 : N.data), R = kD(bD(t.valid, S), I, !1, A.valid, null === (P = t.local) || void 0 === P ? void 0 : P.valid), F = kD(bD(t.errors, S), I, null, A.errors, null === (w = t.local) || void 0 === w ? void 0 : w.errors);
                        return gD(gD({}, t), {}, {
                            schema: l,
                            data: D,
                            valid: R,
                            errors: F,
                            local: E
                        });
                    case "validateForm":
                        var x = tC(p).call(p, function(r, a) {
                            var n = Vk(e({
                                key: a,
                                value: t.data[a],
                                mode: "blur"
                            }, {
                                state: t
                            }), 2)[1];
                            return {
                                valid: gD(gD({}, r.valid), {}, Ag({}, a, n.isValid && !t.fieldProblems[a] || !1)),
                                errors: gD(gD({}, r.errors), {}, Ag({}, a, n.hasError(!0) ? n.getError(!0) : null))
                            };
                        }, {
                            valid: t.valid,
                            errors: t.errors
                        });
                        return gD(gD({}, t), {}, {
                            valid: x.valid,
                            errors: x.errors
                        });
                    default:
                        throw new Error("Undefined useForm action");
                }
            };
        }(p), {
            defaultData: i,
            schema: null != u ? u : [],
            processField: p,
            fieldProblems: s
        }, CD), f = Vk(m, 2), h = f[0], v = f[1], y = WP(function() {
            var e;
            return tC(e = h.schema).call(e, function(e, t) {
                return e && h.valid[t];
            }, !0);
        }, [
            h.schema,
            h.valid
        ]), g = GP(function() {
            v({
                type: "validateForm",
                selectedSchema: arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null
            });
        }, []), b = GP(function(e, t) {
            return v({
                type: "setErrors",
                key: e,
                value: t
            });
        }, []), k = GP(function(e, t) {
            return v({
                type: "setValid",
                key: e,
                value: t
            });
        }, []), C = GP(function(e, t) {
            return v({
                type: "setData",
                key: e,
                value: t
            });
        }, []), _ = GP(function(e) {
            return v({
                type: "setSchema",
                schema: e,
                defaultData: i
            });
        }, [
            h.schema
        ]), N = GP(function(e) {
            return v({
                type: "mergeForm",
                formValue: e
            });
        }, []), P = GP(function(e) {
            return v({
                type: "setFieldProblems",
                fieldProblems: e
            });
        }, [
            h.schema
        ]);
        return KP(function() {
            P(null != s ? s : {});
        }, [
            Mb(s)
        ]), {
            handleChangeFor: function(e, t) {
                return function(r) {
                    var a = function(e, t) {
                        return t.target ? "checkbox" === t.target.type ? !h.data[e] : t.target.value : t;
                    }(e, r);
                    v({
                        type: "updateField",
                        key: e,
                        value: a,
                        mode: t
                    });
                };
            },
            triggerValidation: g,
            setSchema: _,
            setData: C,
            setValid: k,
            setErrors: b,
            isValid: y,
            mergeForm: N,
            setFieldProblems: P,
            schema: h.schema,
            valid: h.valid,
            errors: h.errors,
            data: h.data,
            fieldProblems: h.fieldProblems
        };
    }
    var ND = jC.trim;
    Sr({
        target: "String",
        proto: !0,
        forced: jE("trim")
    }, {
        trim: function() {
            return ND(this);
        }
    });
    var PD = Cv("String", "trim"), wD = ie, AD = PD, SD = String.prototype, ID = t(function(e) {
        var t = e.trim;
        return "string" == typeof e || e === SD || wD(SD, e) && t === SD.trim ? AD : t;
    }), ED = [
        "setRef"
    ], DD = [
        "classNameModifiers",
        "uniqueId",
        "isInvalid",
        "isValid",
        "addContextualElement"
    ];
    function RD(e) {
        var t, r = e.setRef, a = kg(e, ED), n = a.autoCorrect, o = a.classNameModifiers, i = a.isInvalid, l = a.isValid, s = a.readonly, c = void 0 === s ? null : s, u = a.spellCheck, d = a.type, p = a.uniqueId, m = a.disabled, f = a.className;
        Object.prototype.hasOwnProperty.call(a, "onChange") && console.error("Error: Form fields that rely on InputBase may not have an onChange property");
        var h = GP(function(e) {
            a.onInput(e);
        }, [
            a.onInput
        ]), v = GP(function(e) {
            null != a && a.onKeyPress && a.onKeyPress(e);
        }, [
            null == a ? void 0 : a.onKeyPress
        ]), y = GP(function(e) {
            null != a && a.onKeyUp && a.onKeyUp(e);
        }, [
            null == a ? void 0 : a.onKeyUp
        ]), g = GP(function(e) {
            var t, r, n;
            (null == a || null === (t = a.onBlurHandler) || void 0 === t || t.call(a, e), a.trimOnBlur) && (e.target.value = ID(n = e.target.value).call(n));
            null == a || null === (r = a.onBlur) || void 0 === r || r.call(a, e);
        }, [
            a.onBlur,
            a.onBlurHandler
        ]), b = GP(function(e) {
            var t;
            null == a || null === (t = a.onFocusHandler) || void 0 === t || t.call(a, e);
        }, [
            a.onFocusHandler
        ]), k = DP("adyen-checkout__input", [
            "adyen-checkout__input--".concat(d)
        ], f, {
            "adyen-checkout__input--invalid": i,
            "adyen-checkout__input--valid": l
        }, hC(o).call(o, function(e) {
            return "adyen-checkout__input--".concat(e);
        }));
        a.classNameModifiers, a.uniqueId, a.isInvalid, a.isValid, a.addContextualElement;
        var C = kg(a, DD);
        return nN("input", M_({
            id: p
        }, C, {
            "aria-required": C.required,
            type: d,
            className: k,
            readOnly: c,
            spellCheck: u,
            autoCorrect: n,
            "aria-describedby": wb(t = "".concat(p)).call(t, sE),
            "aria-invalid": i,
            onInput: h,
            onBlur: g,
            onFocus: b,
            onKeyUp: y,
            onKeyPress: v,
            disabled: m,
            ref: r
        }));
    }
    function FD(e) {
        return nN(RD, M_({
            classNameModifiers: [
                "large"
            ]
        }, e, {
            "aria-required": e.required,
            type: "text"
        }));
    }
    function xD(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function TD(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = xD(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = xD(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    RD.defaultProps = {
        type: "text",
        classNameModifiers: []
    };
    var zD = [
        "name",
        "registrationNumber"
    ];
    function OD(e) {
        var t, r = e.label, a = void 0 === r ? "" : r, n = e.namePrefix, o = e.requiredFields, i = e.visibility, l = sw().i18n, s = _D({
            schema: o,
            rules: TD(TD({}, QE), e.validationRules),
            defaultData: e.data
        }), c = s.handleChangeFor, u = s.triggerValidation, d = s.data, p = s.valid, m = s.errors, f = s.isValid, h = qP({});
        Ty(h.current).length || null === (t = e.setComponentRef) || void 0 === t || t.call(e, h.current);
        h.current.showValidation = function() {
            u();
        };
        var v = function(e) {
            var t;
            return wb(t = "".concat(n ? "".concat(n, ".") : "")).call(t, e);
        }, y = function(e) {
            return function(t) {
                var r = t.target.name.split("".concat(n, ".")).pop();
                c(r, e)(t);
            };
        };
        return KP(function() {
            var t = $E(d);
            e.onChange({
                data: t,
                valid: p,
                errors: m,
                isValid: f
            });
        }, [
            d,
            p,
            m,
            f
        ]), "hidden" === i ? null : "readOnly" === i ? nN(xE, M_({}, e, {
            data: d
        })) : nN(SI, {
            classNameModifiers: [
                a
            ],
            label: a
        }, kb(o).call(o, "name") && nN(FE, {
            label: l.get("companyDetails.name"),
            classNameModifiers: [
                "name"
            ],
            errorMessage: !!m.name,
            i18n: l,
            name: v("companyName")
        }, nN(FD, {
            name: v("name"),
            value: d.name,
            classNameModifiers: [
                "name"
            ],
            onInput: y("input"),
            onBlur: y("blur"),
            spellCheck: !1
        })), kb(o).call(o, "registrationNumber") && nN(FE, {
            label: l.get("companyDetails.registrationNumber"),
            classNameModifiers: [
                "registrationNumber"
            ],
            errorMessage: !!m.registrationNumber,
            i18n: l,
            name: v("registrationNumber")
        }, nN(FD, {
            name: v("registrationNumber"),
            value: d.registrationNumber,
            classNameModifiers: [
                "registrationNumber"
            ],
            onInput: y("input"),
            onBlur: y("blur"),
            spellCheck: !1
        })));
    }
    OD.defaultProps = {
        data: {},
        onChange: function() {},
        visibility: "editable",
        requiredFields: zD,
        validationRules: QE
    };
    var jD = function(e) {
        var t = e.data, r = t.firstName, a = t.lastName, n = t.shopperEmail, o = t.telephoneNumber;
        return nN(SI, {
            classNameModifiers: [
                "personalDetails"
            ],
            label: "personalDetails",
            readonly: !0
        }, r && "".concat(r, " "), a && "".concat(a, " "), n && nN(iN, null, nN("br", null), n), o && nN(iN, null, nN("br", null), o));
    }, BD = /^(([a-z0-9!#$%&'*+\-/=?^_`{|}~]+(\.[a-z0-9!#$%&'*+\-/=?^_`{|}~]+)*)|(".+"))@((\[((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}])|([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?(\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*\.([a-z]{2,})))$/i, MD = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/, LD = function() {
        var e = document.createElement("input");
        return e.setAttribute("type", "date"), "date" === e.type;
    }, VD = function(e) {
        var t = e.replace(/\D|\s/g, "").replace(/^(00)(.*)?/, "01$2").replace(/^(3[2-9])(.*)?/, "0$1$2").replace(/^([4-9])(.*)?/, "0$1").replace(/^([0-9]{2})(00)(.*)?/, "$101").replace(/^(3[01])(02)(.*)?/, "29$2").replace(/^([0-9]{2})([2-9]|1[3-9])(.*)?/, "$10$2").replace(/^([0-9]{2})([0-9]{2})([0-9])/, "$1/$2/$3").replace(/^([0-9]{2})([0-9])/, "$1/$2"), r = Vk(t.split("/"), 3), a = r[0], n = void 0 === a ? "" : a, o = r[1], i = void 0 === o ? "" : o, l = r[2], s = void 0 === l ? "" : l;
        return 4 === s.length && "29" === n && "02" === i && (Number(s) % 4 != 0 || "00" === s.substr(2, 2) && Number(s) % 400 != 0) ? t.replace(/^29/, "28") : t;
    }, UD = function() {
        var e, t, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        if (-1 === Kk(r).call(r, "/")) return r;
        var a = Vk(r.split("/"), 3), n = a[0], o = void 0 === n ? "" : n, i = a[1], l = void 0 === i ? "" : i, s = a[2], c = void 0 === s ? "" : s;
        return o && l && c ? wb(e = wb(t = "".concat(c, "-")).call(t, l, "-")).call(e, o) : null;
    }, KD = function(e) {
        return WE(e) ? null : e.length >= 6 && e.length <= 320 && BD.test(e);
    }, HD = {
        default: {
            validate: function(e) {
                return e && e.length > 0;
            },
            errorMessage: "error.va.gen.02",
            modes: [
                "blur"
            ]
        },
        gender: {
            validate: function(e) {
                return e && e.length > 0;
            },
            errorMessage: "gender.notselected",
            modes: [
                "blur"
            ]
        },
        firstName: {
            validate: function(e) {
                return !WE(e) || null;
            },
            errorMessage: "firstName.invalid",
            modes: [
                "blur"
            ]
        },
        lastName: {
            validate: function(e) {
                return !WE(e) || null;
            },
            errorMessage: "lastName.invalid",
            modes: [
                "blur"
            ]
        },
        dateOfBirth: {
            validate: function(e) {
                return WE(e) ? null : function(e) {
                    if (!e) return !1;
                    var t = UD(e), r = SE() - Date.parse(t);
                    return new Date(r).getFullYear() - 1970 >= 18;
                }(e);
            },
            errorMessage: "dateOfBirth.invalid",
            modes: [
                "blur"
            ]
        },
        telephoneNumber: {
            validate: function(e) {
                return WE(e) ? null : MD.test(e);
            },
            errorMessage: "telephoneNumber.invalid",
            modes: [
                "blur"
            ]
        },
        shopperEmail: {
            validate: function(e) {
                return KD(e);
            },
            errorMessage: "shopperEmail.invalid",
            modes: [
                "blur"
            ]
        }
    };
    function qD(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function WD(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = qD(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = qD(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var GD = function(e) {
        var t = e.firstName, r = e.lastName, a = e.gender, n = e.dateOfBirth, o = e.shopperEmail, i = e.telephoneNumber;
        return WD(WD(WD(WD({}, (t || r) && {
            shopperName: WD(WD(WD({}, t && {
                firstName: t
            }), r && {
                lastName: r
            }), a && {
                gender: a
            })
        }), n && {
            dateOfBirth: UD(n)
        }), o && {
            shopperEmail: o
        }), i && {
            telephoneNumber: i
        });
    }, YD = u, QD = Z, ZD = ea, JD = ca, $D = vv, XD = Math.min, eR = [].lastIndexOf, tR = !!eR && 1 / [
        1
    ].lastIndexOf(1, -0) < 0, rR = $D("lastIndexOf"), aR = tR || !rR ? function(e) {
        if (tR) return YD(eR, this, arguments) || 0;
        var t = QD(this), r = JD(t), a = r - 1;
        for(arguments.length > 1 && (a = XD(a, ZD(arguments[1]))), a < 0 && (a = r + a); a >= 0; a--)if (a in t && t[a] === e) return a || 0;
        return -1;
    } : eR;
    Sr({
        target: "Array",
        proto: !0,
        forced: aR !== [].lastIndexOf
    }, {
        lastIndexOf: aR
    });
    var nR = Cv("Array", "lastIndexOf"), oR = ie, iR = nR, lR = Array.prototype, sR = t(function(e) {
        var t = e.lastIndexOf;
        return e === lR || oR(lR, e) && t === lR.lastIndexOf ? iR : t;
    });
    function cR(e) {
        var t = e.items, r = e.name, a = e.onChange, n = e.value, o = e.isInvalid, i = e.uniqueId, l = sw().i18n, s = null == i ? void 0 : i.replace(/[0-9]/g, "").substring(0, sR(i).call(i, "-"));
        return nN("div", {
            className: "adyen-checkout__radio_group"
        }, hC(t).call(t, function(t) {
            var i = EE(s);
            return nN("div", {
                key: t.id,
                className: "adyen-checkout__radio_group__input-wrapper"
            }, nN("input", {
                id: i,
                type: "radio",
                checked: n === t.id,
                className: "adyen-checkout__radio_group__input",
                name: r,
                onChange: a,
                onClick: a,
                value: t.id
            }), nN("label", {
                className: DP([
                    "adyen-checkout__label__text",
                    "adyen-checkout__radio_group__label",
                    e.className,
                    {
                        "adyen-checkout__radio_group__label--invalid": o
                    }
                ]),
                htmlFor: i
            }, l.get(t.name)));
        }));
    }
    function uR(e) {
        return nN(RD, WP(LD, []) ? M_({}, e, {
            type: "date"
        }) : M_({}, e, {
            onInput: function(t) {
                var r = t.target.value;
                t.target.value = VD(r), e.onInput(t);
            },
            maxLength: 10
        }));
    }
    function dR(e) {
        return nN(RD, M_({}, e, {
            type: "email",
            autoCapitalize: "off"
        }));
    }
    function pR(e) {
        return nN(RD, M_({}, e, {
            type: "tel"
        }));
    }
    function mR(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function fR(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = mR(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = mR(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    cR.defaultProps = {
        onChange: function() {},
        items: []
    };
    var hR = [
        "firstName",
        "lastName",
        "gender",
        "dateOfBirth",
        "shopperEmail",
        "telephoneNumber"
    ];
    function vR(e) {
        var t, r = e.label, a = void 0 === r ? "" : r, n = e.namePrefix, o = e.placeholders, i = e.requiredFields, l = e.visibility, s = sw().i18n, c = qP({});
        Ty(c.current).length || null === (t = e.setComponentRef) || void 0 === t || t.call(e, c.current);
        var u = WP(LD, []), d = _D({
            schema: i,
            rules: fR(fR({}, HD), e.validationRules),
            defaultData: e.data
        }), p = d.handleChangeFor, m = d.triggerValidation, f = d.data, h = d.valid, v = d.errors, y = d.isValid;
        c.current.showValidation = function() {
            m();
        };
        var g = function(e) {
            return function(t) {
                var r = t.target.name.split("".concat(n, ".")).pop();
                p(r, e)(t);
            };
        }, b = function(e) {
            var t;
            return wb(t = "".concat(n ? "".concat(n, ".") : "")).call(t, e);
        }, k = function(e) {
            return e && e.errorMessage ? s.get(e.errorMessage) : !!e;
        };
        return KP(function() {
            var t = GD(f);
            e.onChange({
                data: t,
                valid: h,
                errors: v,
                isValid: y
            });
        }, [
            f,
            h,
            v,
            y
        ]), "hidden" === l ? null : "readOnly" === l ? nN(jD, M_({}, e, {
            data: f
        })) : nN(iN, null, nN(SI, {
            classNameModifiers: [
                "personalDetails"
            ],
            label: a
        }, kb(i).call(i, "firstName") && nN(FE, {
            label: s.get("firstName"),
            classNameModifiers: [
                "col-50",
                "firstName"
            ],
            errorMessage: k(v.firstName),
            name: "firstName",
            i18n: s
        }, nN(FD, {
            name: b("firstName"),
            value: f.firstName,
            classNameModifiers: [
                "firstName"
            ],
            onInput: g("input"),
            onBlur: g("blur"),
            placeholder: o.firstName,
            spellCheck: !1,
            required: !0
        })), kb(i).call(i, "lastName") && nN(FE, {
            label: s.get("lastName"),
            classNameModifiers: [
                "col-50",
                "lastName"
            ],
            errorMessage: k(v.lastName),
            name: "lastName",
            i18n: s
        }, nN(FD, {
            name: b("lastName"),
            value: f.lastName,
            classNameModifiers: [
                "lastName"
            ],
            onInput: g("input"),
            onBlur: g("blur"),
            placeholder: o.lastName,
            spellCheck: !1,
            required: !0
        })), kb(i).call(i, "gender") && nN(FE, {
            errorMessage: k(v.gender),
            classNameModifiers: [
                "gender"
            ],
            name: "gender",
            useLabelElement: !1
        }, nN(cR, {
            name: b("gender"),
            value: f.gender,
            items: [
                {
                    id: "MALE",
                    name: "male"
                },
                {
                    id: "FEMALE",
                    name: "female"
                }
            ],
            classNameModifiers: [
                "gender"
            ],
            onInput: g("input"),
            onChange: g("blur"),
            required: !0
        })), kb(i).call(i, "dateOfBirth") && nN(FE, {
            label: s.get("dateOfBirth"),
            classNameModifiers: [
                "col-50",
                "dateOfBirth"
            ],
            errorMessage: k(v.dateOfBirth),
            helper: u ? null : s.get("dateOfBirth.format"),
            name: "dateOfBirth",
            i18n: s
        }, nN(uR, {
            name: b("dateOfBirth"),
            value: f.dateOfBirth,
            classNameModifiers: [
                "dateOfBirth"
            ],
            onInput: g("input"),
            onBlur: g("blur"),
            placeholder: o.dateOfBirth,
            required: !0
        })), kb(i).call(i, "shopperEmail") && nN(FE, {
            label: s.get("shopperEmail"),
            classNameModifiers: [
                "shopperEmail"
            ],
            errorMessage: k(v.shopperEmail),
            dir: "ltr",
            name: "emailAddress",
            i18n: s
        }, nN(dR, {
            name: b("shopperEmail"),
            value: f.shopperEmail,
            classNameModifiers: [
                "shopperEmail"
            ],
            onInput: g("input"),
            onBlur: g("blur"),
            placeholder: o.shopperEmail,
            required: !0
        })), kb(i).call(i, "telephoneNumber") && nN(FE, {
            label: s.get("telephoneNumber"),
            classNameModifiers: [
                "telephoneNumber"
            ],
            errorMessage: k(v.telephoneNumber),
            dir: "ltr",
            name: "telephoneNumber",
            i18n: s
        }, nN(pR, {
            name: b("telephoneNumber"),
            value: f.telephoneNumber,
            classNameModifiers: [
                "telephoneNumber"
            ],
            onInput: g("input"),
            onBlur: g("blur"),
            placeholder: o.telephoneNumber,
            required: !0
        }))), !1);
    }
    vR.defaultProps = {
        data: {},
        onChange: function() {},
        placeholders: {},
        requiredFields: hR,
        validationRules: HD,
        visibility: "editable"
    };
    var yR = "N/A", gR = [
        "street",
        "houseNumberOrName",
        "postalCode",
        "city",
        "stateOrProvince",
        "country",
        "firstName",
        "lastName"
    ], bR = gR[0], kR = gR[1], CR = gR[2], _R = gR[3], NR = gR[4], PR = gR[5], wR = gR[6], AR = gR[7], SR = {
        AU: {
            hasDataset: !0,
            labels: Ag(Ag(Ag({}, kR, "apartmentSuite"), NR, "state"), bR, "address"),
            optionalFields: [
                kR
            ],
            placeholders: Ag({}, NR, "select.state"),
            schema: [
                PR,
                bR,
                kR,
                _R,
                [
                    [
                        NR,
                        50
                    ],
                    [
                        CR,
                        50
                    ]
                ]
            ]
        },
        BR: {
            hasDataset: !0,
            labels: Ag({}, NR, "state"),
            placeholders: Ag({}, NR, "select.state")
        },
        CA: {
            hasDataset: !0,
            labels: Ag(Ag(Ag({}, kR, "apartmentSuite"), NR, "provinceOrTerritory"), bR, "address"),
            optionalFields: [
                kR
            ],
            schema: [
                PR,
                bR,
                kR,
                [
                    [
                        _R,
                        70
                    ],
                    [
                        CR,
                        30
                    ]
                ],
                NR
            ]
        },
        GB: {
            labels: Ag({}, _R, "cityTown"),
            schema: [
                PR,
                [
                    [
                        kR,
                        30
                    ],
                    [
                        bR,
                        70
                    ]
                ],
                [
                    [
                        _R,
                        70
                    ],
                    [
                        CR,
                        30
                    ]
                ],
                NR
            ]
        },
        US: {
            hasDataset: !0,
            labels: Ag(Ag(Ag(Ag({}, CR, "zipCode"), kR, "apartmentSuite"), NR, "state"), bR, "address"),
            optionalFields: [
                kR
            ],
            placeholders: Ag({}, NR, "select.state"),
            schema: [
                PR,
                bR,
                kR,
                _R,
                [
                    [
                        NR,
                        50
                    ],
                    [
                        CR,
                        50
                    ]
                ]
            ]
        },
        default: {
            optionalFields: [],
            placeholders: Ag({}, NR, "select.provinceOrTerritory"),
            schema: [
                PR,
                [
                    [
                        bR,
                        70
                    ],
                    [
                        kR,
                        30
                    ]
                ],
                [
                    [
                        CR,
                        30
                    ],
                    [
                        _R,
                        70
                    ]
                ],
                NR
            ]
        }
    }, IR = {
        default: {
            labels: Ag({}, CR, "zipCode"),
            schema: [
                CR
            ]
        }
    }, ER = Ty(SR), DR = function(e) {
        var t = e.firstName, r = e.lastName;
        return nN(iN, null, t && "".concat(t, " "), r && "".concat(r), nN("br", null));
    }, RR = function(e) {
        var t = e.data, r = e.label, a = t.street, n = t.houseNumberOrName, o = t.city, i = t.postalCode, l = t.stateOrProvince, s = t.country, c = t.firstName, u = t.lastName;
        return nN(SI, {
            classNameModifiers: [
                r
            ],
            label: r,
            readonly: !0
        }, (c || u) && nN(DR, {
            firstName: c,
            lastName: u
        }), !!a && a, n && ", ".concat(n, ","), nN("br", null), i && "".concat(i), o && ", ".concat(o), l && l !== yR && ", ".concat(l), s && ", ".concat(s, " "));
    }, FR = Ye, xR = na, TR = ca, zR = function(e) {
        for(var t = FR(this), r = TR(t), a = arguments.length, n = xR(a > 1 ? arguments[1] : void 0, r), o = a > 2 ? arguments[2] : void 0, i = void 0 === o ? r : xR(o, r); i > n;)t[n++] = e;
        return t;
    };
    Sr({
        target: "Array",
        proto: !0
    }, {
        fill: zR
    });
    var OR = Cv("Array", "fill"), jR = ie, BR = OR, MR = Array.prototype, LR = t(function(e) {
        var t = e.fill;
        return e === MR || jR(MR, e) && t === MR.fill ? BR : t;
    }), VR = function(e) {
        var t;
        return {
            formatterFn: function(t) {
                return t.replace(YE("^\\d", "g"), "").substring(0, e);
            },
            format: LR(t = new Array(e)).call(t, "9").join(""),
            maxlength: e
        };
    }, UR = YE(GE), KR = function(e) {
        return (function(e) {
            return HE(e).call(e).replace(/\s+/g, " ");
        })(e).replace(UR, "");
    }, HR = {
        postalCode: {
            formatterFn: function(e, t) {
                var r, a = t.state.data.country, n = null === (r = qR[a]) || void 0 === r ? void 0 : r.postalCode.formatterFn;
                return n ? n(e) : e;
            }
        },
        street: {
            formatterFn: KR
        },
        houseNumberOrName: {
            formatterFn: KR
        },
        city: {
            formatterFn: KR
        }
    }, qR = {
        AT: {
            postalCode: VR(4)
        },
        AU: {
            postalCode: VR(4)
        },
        BE: {
            postalCode: VR(4)
        },
        BG: {
            postalCode: VR(4)
        },
        BR: {
            postalCode: {
                formatterFn: function(e) {
                    var t = e.replace(YE("^\\d-", "g"), ""), r = Kk(t).call(t, "-") > -1 ? 9 : 8;
                    return t.substring(0, r);
                },
                format: "12345678 or 12345-678",
                maxlength: 9
            }
        },
        CA: {
            postalCode: {
                format: "A9A 9A9 or A9A9A9",
                maxlength: 7
            }
        },
        CH: {
            postalCode: VR(4)
        },
        CY: {
            postalCode: VR(4)
        },
        CZ: {
            postalCode: {
                format: "999 99",
                maxlength: 6
            }
        },
        DE: {
            postalCode: VR(5)
        },
        DK: {
            postalCode: {
                format: "9999",
                maxlength: 7
            }
        },
        EE: {
            postalCode: VR(5)
        },
        ES: {
            postalCode: VR(5)
        },
        FI: {
            postalCode: VR(5)
        },
        FR: {
            postalCode: VR(5)
        },
        GB: {
            postalCode: {
                formatterFn: function(e) {
                    return e.replace(YE(GE), "").substring(0, 8);
                },
                format: "AA99 9AA or A99 9AA or A9 9AA",
                maxlength: 8
            }
        },
        GR: {
            postalCode: {
                format: "999 99",
                maxlength: 6
            }
        },
        HR: {
            postalCode: {
                format: "[1-5]9999",
                maxlength: 5
            }
        },
        HU: {
            postalCode: VR(4)
        },
        IE: {
            postalCode: {
                format: "A99 A999",
                maxlength: 8
            }
        },
        IS: {
            postalCode: VR(3)
        },
        IT: {
            postalCode: VR(5)
        },
        LI: {
            postalCode: VR(4)
        },
        LT: {
            postalCode: {
                format: "9999 or 99999 or LT-99999",
                maxlength: 8
            }
        },
        LU: {
            postalCode: VR(4)
        },
        LV: {
            postalCode: {
                format: "9999 or LV-9999",
                maxlength: 7
            }
        },
        MC: {
            postalCode: {
                format: "980NN",
                maxlength: 5
            }
        },
        MT: {
            postalCode: {
                format: "AA99 or AAA99 or AA9999 or AAA9999",
                maxlength: 8
            }
        },
        MY: {
            postalCode: VR(5)
        },
        NL: {
            postalCode: {
                format: "9999AA",
                maxlength: 7
            }
        },
        NZ: {
            postalCode: VR(4)
        },
        NO: {
            postalCode: VR(4)
        },
        PL: {
            postalCode: {
                formatterFn: function(e) {
                    var t = e.replace(YE("^\\d-", "g"), ""), r = Kk(t).call(t, "-") > -1 ? 6 : 5;
                    return t.substring(0, r);
                },
                format: "99999 or 99-999",
                maxlength: 6
            }
        },
        PT: {
            postalCode: {
                formatterFn: function(e) {
                    return e.replace(YE("^\\d-", "g"), "").substring(0, 8);
                },
                format: "9999-999",
                maxlength: 8
            }
        },
        RO: {
            postalCode: VR(6)
        },
        SI: {
            postalCode: {
                format: "9999 or SI-9999",
                maxlength: 7
            }
        },
        SE: {
            postalCode: VR(5)
        },
        SG: {
            postalCode: VR(6)
        },
        SK: {
            postalCode: {
                format: "99999 or SK-99999",
                maxlength: 8
            }
        },
        JP: {
            postalCode: {
                format: "999-9999",
                maxlength: 8
            }
        },
        US: {
            postalCode: {
                formatterFn: function(e) {
                    var t = e.replace(YE("^\\d-", "g"), ""), r = Kk(t).call(t, "-") > -1 ? 10 : 5;
                    return t.substring(0, r);
                },
                format: "99999 or 99999-9999"
            }
        }
    }, WR = function(e) {
        return {
            pattern: new RegExp("\\d{".concat(e, "}"))
        };
    }, GR = function(e, t, r) {
        if (t) {
            var a, n;
            if (r.postalCode.errorMessage = {
                translationKey: "invalidFormatExpects",
                translationObject: {
                    values: {
                        format: (null === (a = qR[t]) || void 0 === a ? void 0 : a.postalCode.format) || null
                    }
                }
            }, WE(e)) return null;
            var o = null === (n = YR[t]) || void 0 === n ? void 0 : n.pattern;
            return o ? o.test(e) : !!e;
        }
        return !WE(e) || null;
    }, YR = {
        AT: WR(4),
        AU: WR(4),
        BE: {
            pattern: /(?:(?:[1-9])(?:\d{3}))/
        },
        BG: WR(4),
        BR: {
            pattern: /^\d{5}-?\d{3}$/
        },
        CA: {
            pattern: /(?:[ABCEGHJ-NPRSTVXY]\d[A-Z][ -]?\d[A-Z]\d)/
        },
        CH: {
            pattern: /[1-9]\d{3}/
        },
        CY: WR(4),
        CZ: {
            pattern: /\d{3}\s?\d{2}/
        },
        DE: WR(5),
        DK: WR(4),
        EE: WR(5),
        ES: {
            pattern: /(?:0[1-9]|[1-4]\d|5[0-2])\d{3}/
        },
        FI: WR(5),
        FR: WR(5),
        GB: {
            pattern: /^([A-Za-z][A-Ha-hK-Yk-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/
        },
        GE: WR(4),
        GR: {
            pattern: /^\d{3}\s{0,1}\d{2}$/
        },
        HR: {
            pattern: /^([1-5])[0-9]{4}$/
        },
        HU: WR(4),
        IE: {
            pattern: /(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}/
        },
        IS: WR(3),
        IT: WR(5),
        LI: WR(4),
        LT: {
            pattern: /^(LT-\d{5})$/
        },
        LU: WR(4),
        LV: {
            pattern: /^(LV-)[0-9]{4}$/
        },
        MC: {
            pattern: /^980\d{2}$/
        },
        MT: {
            pattern: /^[A-Za-z]{3}\d{4}$/
        },
        MY: WR(5),
        NL: {
            pattern: /(?:NL-)?(?:[1-9]\d{3} ?(?:[A-EGHJ-NPRTVWXZ][A-EGHJ-NPRSTVWXZ]|S[BCEGHJ-NPRTVWXZ]))/
        },
        NO: WR(4),
        PL: {
            pattern: /^\d{2}[-]{0,1}\d{3}$/
        },
        PT: {
            pattern: /^([1-9]\d{3})([- ]?(\d{3})? *)$/
        },
        RO: WR(6),
        SI: WR(4),
        SE: WR(5),
        SG: WR(6),
        SK: WR(5),
        US: WR(5)
    }, QR = function(e) {
        var t = {
            postalCode: {
                modes: [
                    "blur"
                ],
                validate: function(r) {
                    return GR(r, e, t);
                },
                errorMessage: bE[cE]
            }
        };
        return t;
    }, ZR = function(e) {
        var t = {
            postalCode: {
                modes: [
                    "blur"
                ],
                validate: function(e, r) {
                    var a = r.state.data.country;
                    return GR(e, a, t);
                },
                errorMessage: bE[cE]
            },
            houseNumberOrName: {
                validate: function(t, r) {
                    var a, n = null === (a = r.state) || void 0 === a || null === (a = a.data) || void 0 === a ? void 0 : a.country;
                    return n && e.countryHasOptionalField(n, "houseNumberOrName") || !WE(t) || null;
                },
                modes: [
                    "blur"
                ],
                errorMessage: bE[cE]
            },
            default: {
                validate: function(e) {
                    return !WE(e) || null;
                },
                modes: [
                    "blur"
                ],
                errorMessage: bE[cE]
            }
        };
        return t;
    }, JR = a;
    Sr({
        global: !0,
        forced: JR.globalThis !== JR
    }, {
        globalThis: JR
    });
    var $R = t(a), XR = t(gh), eF = t(Wh), tF = Sr, rF = n, aF = xp.f;
    tF({
        target: "Object",
        stat: !0,
        forced: rF(function() {
            return !Object.getOwnPropertyNames(1);
        })
    }, {
        getOwnPropertyNames: aF
    });
    var nF = ee.Object, oF = t(function(e) {
        return nF.getOwnPropertyNames(e);
    }), iF = Cv("Array", "entries"), lF = zn, sF = Je, cF = ie, uF = iF, dF = Array.prototype, pF = {
        DOMTokenList: !0,
        NodeList: !0
    }, mF = t(function(e) {
        var t = e.entries;
        return e === dF || cF(dF, e) && t === dF.entries || sF(pF, lF(e)) ? uF : t;
    }), fF = n, hF = dt("iterator"), vF = !fF(function() {
        var e = new URL("b?a=1&b=2&c=3", "http://a"), t = e.searchParams, r = new URLSearchParams("a=1&a=2&b=3"), a = "";
        return e.pathname = "c%20d", t.forEach(function(e, r) {
            t.delete("b"), a += r + e;
        }), r.delete("a", 2), r.delete("b", void 0), !e.toJSON || !r.has("a", 1) || r.has("a", 2) || !r.has("a", void 0) || r.has("b") || !t.size && true || !t.sort || "http://a/c%20d?a=1&c=3" !== e.href || "3" !== t.get("c") || "a=1" !== String(new URLSearchParams("?a=1")) || !t[hF] || "a" !== new URL("https://a@b").username || "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") || "xn--e1aybc" !== new URL("http://\u0442\u0435\u0441\u0442").host || "#%D0%B1" !== new URL("http://a#\u0431").hash || "a1c3" !== a || "x" !== new URL("http://x", void 0).host;
    }), yF = Mp, gF = Math.floor, bF = function(e, t) {
        var r = e.length, a = gF(r / 2);
        return r < 8 ? kF(e, t) : CF(e, bF(yF(e, 0, a), t), bF(yF(e, a), t), t);
    }, kF = function(e, t) {
        for(var r, a, n = e.length, o = 1; o < n;){
            for(a = o, r = e[o]; a && t(e[a - 1], r) > 0;)e[a] = e[--a];
            a !== o++ && (e[a] = r);
        }
        return e;
    }, CF = function(e, t, r, a) {
        for(var n = t.length, o = r.length, i = 0, l = 0; i < n || l < o;)e[i + l] = i < n && l < o ? a(t[i], r[l]) <= 0 ? t[i++] : r[l++] : i < n ? t[i++] : r[l++];
        return e;
    }, _F = bF, NF = Sr, PF = a, wF = R, AF = h, SF = I, IF = vF, EF = ui, DF = pl, RF = zw, FF = Ei, xF = Oi, TF = ri, zF = kl, OF = A, jF = Je, BF = Qt, MF = zn, LF = tr, VF = X, UF = vo, KF = sn, HF = B, qF = Yn, WF = Vn, GF = el, YF = es, QF = _F, ZF = dt("iterator"), JF = "URLSearchParams", $F = JF + "Iterator", XF = TF.set, ex = TF.getterFor(JF), tx = TF.getterFor($F), rx = Object.getOwnPropertyDescriptor, ax = function(e) {
        if (!SF) return PF[e];
        var t = rx(PF, e);
        return t && t.value;
    }, nx = ax("fetch"), ox = ax("Request"), ix = ax("Headers"), lx = ox && ox.prototype, sx = ix && ix.prototype, cx = PF.RegExp, ux = PF.TypeError, dx = PF.decodeURIComponent, px = PF.encodeURIComponent, mx = AF("".charAt), fx = AF([].join), hx = AF([].push), vx = AF("".replace), yx = AF([].shift), gx = AF([].splice), bx = AF("".split), kx = AF("".slice), Cx = /\+/g, _x = Array(4), Nx = function(e) {
        return _x[e - 1] || (_x[e - 1] = cx("((?:%[\\da-f]{2}){" + e + "})", "gi"));
    }, Px = function(e) {
        try {
            return dx(e);
        } catch (t) {
            return e;
        }
    }, wx = function(e) {
        var t = vx(e, Cx, " "), r = 4;
        try {
            return dx(t);
        } catch (e) {
            for(; r;)t = vx(t, Nx(r--), Px);
            return t;
        }
    }, Ax = /[!'()~]|%20/g, Sx = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+"
    }, Ix = function(e) {
        return Sx[e];
    }, Ex = function(e) {
        return vx(px(e), Ax, Ix);
    }, Dx = xF(function(e, t) {
        XF(this, {
            type: $F,
            target: ex(e).entries,
            index: 0,
            kind: t
        });
    }, JF, function() {
        var e = tx(this), t = e.target, r = e.index++;
        if (!t || r >= t.length) return e.target = void 0, GF(void 0, !0);
        var a = t[r];
        switch(e.kind){
            case "keys":
                return GF(a.key, !1);
            case "values":
                return GF(a.value, !1);
        }
        return GF([
            a.key,
            a.value
        ], !1);
    }, !0), Rx = function(e) {
        this.entries = [], this.url = null, void 0 !== e && (VF(e) ? this.parseObject(e) : this.parseQuery("string" == typeof e ? "?" === mx(e, 0) ? kx(e, 1) : e : UF(e)));
    };
    Rx.prototype = {
        type: JF,
        bindURL: function(e) {
            this.url = e, this.update();
        },
        parseObject: function(e) {
            var t, r, a, n, o, i, l, s = this.entries, c = WF(e);
            if (c) for(r = (t = qF(e, c)).next; !(a = wF(r, t)).done;){
                if (o = (n = qF(LF(a.value))).next, (i = wF(o, n)).done || (l = wF(o, n)).done || !wF(o, n).done) throw new ux("Expected sequence with length 2");
                hx(s, {
                    key: UF(i.value),
                    value: UF(l.value)
                });
            }
            else for(var u in e)jF(e, u) && hx(s, {
                key: u,
                value: UF(e[u])
            });
        },
        parseQuery: function(e) {
            if (e) for(var t, r, a = this.entries, n = bx(e, "&"), o = 0; o < n.length;)(t = n[o++]).length && (r = bx(t, "="), hx(a, {
                key: wx(yx(r)),
                value: wx(fx(r, "="))
            }));
        },
        serialize: function() {
            for(var e, t = this.entries, r = [], a = 0; a < t.length;)e = t[a++], hx(r, Ex(e.key) + "=" + Ex(e.value));
            return fx(r, "&");
        },
        update: function() {
            this.entries.length = 0, this.parseQuery(this.url.query);
        },
        updateURL: function() {
            this.url && this.url.update();
        }
    };
    var Fx = function() {
        zF(this, xx);
        var e = XF(this, new Rx(arguments.length > 0 ? arguments[0] : void 0));
        SF || (this.size = e.entries.length);
    }, xx = Fx.prototype;
    if (RF(xx, {
        append: function(e, t) {
            var r = ex(this);
            YF(arguments.length, 2), hx(r.entries, {
                key: UF(e),
                value: UF(t)
            }), SF || this.length++, r.updateURL();
        },
        delete: function(e) {
            for(var t = ex(this), r = YF(arguments.length, 1), a = t.entries, n = UF(e), o = r < 2 ? void 0 : arguments[1], i = void 0 === o ? o : UF(o), l = 0; l < a.length;){
                var s = a[l];
                if (s.key !== n || void 0 !== i && s.value !== i) l++;
                else if (gx(a, l, 1), void 0 !== i) break;
            }
            SF || (this.size = a.length), t.updateURL();
        },
        get: function(e) {
            var t = ex(this).entries;
            YF(arguments.length, 1);
            for(var r = UF(e), a = 0; a < t.length; a++)if (t[a].key === r) return t[a].value;
            return null;
        },
        getAll: function(e) {
            var t = ex(this).entries;
            YF(arguments.length, 1);
            for(var r = UF(e), a = [], n = 0; n < t.length; n++)t[n].key === r && hx(a, t[n].value);
            return a;
        },
        has: function(e) {
            for(var t = ex(this).entries, r = YF(arguments.length, 1), a = UF(e), n = r < 2 ? void 0 : arguments[1], o = void 0 === n ? n : UF(n), i = 0; i < t.length;){
                var l = t[i++];
                if (l.key === a && (void 0 === o || l.value === o)) return !0;
            }
            return !1;
        },
        set: function(e, t) {
            var r = ex(this);
            YF(arguments.length, 1);
            for(var a, n = r.entries, o = !1, i = UF(e), l = UF(t), s = 0; s < n.length; s++)(a = n[s]).key === i && (o ? gx(n, s--, 1) : (o = !0, a.value = l));
            o || hx(n, {
                key: i,
                value: l
            }), SF || (this.size = n.length), r.updateURL();
        },
        sort: function() {
            var e = ex(this);
            QF(e.entries, function(e, t) {
                return e.key > t.key ? 1 : -1;
            }), e.updateURL();
        },
        forEach: function(e) {
            for(var t, r = ex(this).entries, a = BF(e, arguments.length > 1 ? arguments[1] : void 0), n = 0; n < r.length;)a((t = r[n++]).value, t.key, this);
        },
        keys: function() {
            return new Dx(this, "keys");
        },
        values: function() {
            return new Dx(this, "values");
        },
        entries: function() {
            return new Dx(this, "entries");
        }
    }, {
        enumerable: !0
    }), EF(xx, ZF, xx.entries, {
        name: "entries"
    }), EF(xx, "toString", function() {
        return ex(this).serialize();
    }, {
        enumerable: !0
    }), SF && DF(xx, "size", {
        get: function() {
            return ex(this).entries.length;
        },
        configurable: !0,
        enumerable: !0
    }), FF(Fx, JF), NF({
        global: !0,
        constructor: !0,
        forced: !IF
    }, {
        URLSearchParams: Fx
    }), !IF && OF(ix)) {
        var Tx = AF(sx.has), zx = AF(sx.set), Ox = function(e) {
            if (VF(e)) {
                var t, r = e.body;
                if (MF(r) === JF) return t = e.headers ? new ix(e.headers) : new ix, Tx(t, "content-type") || zx(t, "content-type", "application/x-www-form-urlencoded;charset=UTF-8"), KF(e, {
                    body: HF(0, UF(r)),
                    headers: HF(0, t)
                });
            }
            return e;
        };
        if (OF(nx) && NF({
            global: !0,
            enumerable: !0,
            dontCallGetSet: !0,
            forced: !0
        }, {
            fetch: function(e) {
                return nx(e, arguments.length > 1 ? Ox(arguments[1]) : {});
            }
        }), OF(ox)) {
            var jx = function(e) {
                return zF(this, lx), new ox(e, arguments.length > 1 ? Ox(arguments[1]) : {});
            };
            lx.constructor = jx, jx.prototype = lx, NF({
                global: !0,
                constructor: !0,
                dontCallGetSet: !0,
                forced: !0
            }, {
                Request: jx
            });
        }
    }
    var Bx = {
        URLSearchParams: Fx,
        getState: ex
    }, Mx = t(ee.URLSearchParams), Lx = t(lv), Vx = Sr, Ux = _;
    S.f;
    var Kx = la, Hx = vo, qx = ob, Wx = G, Gx = lb, Yx = Ux("".startsWith), Qx = Ux("".slice), Zx = Math.min;
    Vx({
        target: "String",
        proto: !0,
        forced: !Gx("startsWith")
    }, {
        startsWith: function(e) {
            var t = Hx(Wx(this));
            qx(e);
            var r = Kx(Zx(arguments.length > 1 ? arguments[1] : void 0, t.length)), a = Hx(e);
            return Yx ? Yx(t, a, r) : Qx(t, r, r + a.length) === a;
        }
    });
    var Jx = Cv("String", "startsWith"), $x = ie, Xx = Jx, eT = String.prototype, tT = t(function(e) {
        var t = e.startsWith;
        return "string" == typeof e || e === eT || $x(eT, e) && t === eT.startsWith ? Xx : t;
    }), rT = void 0 !== $R && $R || "undefined" != typeof self && self || "undefined" != typeof $parcel$global && $parcel$global || {}, aT = "URLSearchParams" in rT, nT = "Symbol" in rT && "iterator" in XR, oT = "FileReader" in rT && "Blob" in rT && function() {
        try {
            return new Blob, !0;
        } catch (e) {
            return !1;
        }
    }(), iT = "FormData" in rT, lT = "ArrayBuffer" in rT;
    if (lT) var sT = [
        "[object Int8Array]",
        "[object Uint8Array]",
        "[object Uint8ClampedArray]",
        "[object Int16Array]",
        "[object Uint16Array]",
        "[object Int32Array]",
        "[object Uint32Array]",
        "[object Float32Array]",
        "[object Float64Array]"
    ], cT = ArrayBuffer.isView || function(e) {
        return e && Kk(sT).call(sT, Object.prototype.toString.call(e)) > -1;
    };
    function uT(e) {
        if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e) || "" === e) throw new TypeError('Invalid character in header field name: "' + e + '"');
        return e.toLowerCase();
    }
    function dT(e) {
        return "string" != typeof e && (e = String(e)), e;
    }
    function pT(e) {
        var t = {
            next: function() {
                var t = e.shift();
                return {
                    done: void 0 === t,
                    value: t
                };
            }
        };
        return nT && (t[eF] = function() {
            return t;
        }), t;
    }
    function mT(e) {
        if (this.map = {}, e instanceof mT) Sg(e).call(e, function(e, t) {
            this.append(t, e);
        }, this);
        else if (PP(e)) Sg(e).call(e, function(e) {
            if (2 != e.length) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + e.length);
            this.append(e[0], e[1]);
        }, this);
        else if (e) {
            var t;
            Sg(t = oF(e)).call(t, function(t) {
                this.append(t, e[t]);
            }, this);
        }
    }
    function fT(e) {
        if (!e._noBody) return e.bodyUsed ? Ab.reject(new TypeError("Already read")) : void (e.bodyUsed = !0);
    }
    function hT(e) {
        return new Ab(function(t, r) {
            e.onload = function() {
                t(e.result);
            }, e.onerror = function() {
                r(e.error);
            };
        });
    }
    function vT(e) {
        var t = new FileReader, r = hT(t);
        return t.readAsArrayBuffer(e), r;
    }
    function yT(e) {
        if (oI(e)) return oI(e).call(e, 0);
        var t = new Uint8Array(e.byteLength);
        return t.set(new Uint8Array(e)), t.buffer;
    }
    function gT() {
        return this.bodyUsed = !1, this._initBody = function(e) {
            var t;
            this.bodyUsed = this.bodyUsed, this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : oT && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : iT && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : aT && Mx.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : lT && oT && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = yT(e.buffer), this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ])) : lT && (ArrayBuffer.prototype.isPrototypeOf(e) || cT(e)) ? this._bodyArrayBuffer = yT(e) : this._bodyText = e = Object.prototype.toString.call(e) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : aT && Mx.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, oT && (this.blob = function() {
            var e = fT(this);
            if (e) return e;
            if (this._bodyBlob) return Ab.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer) return Ab.resolve(new Blob([
                this._bodyArrayBuffer
            ]));
            if (this._bodyFormData) throw new Error("could not read FormData body as blob");
            return Ab.resolve(new Blob([
                this._bodyText
            ]));
        }), this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
                var e, t = fT(this);
                return t || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Ab.resolve(oI(e = this._bodyArrayBuffer.buffer).call(e, this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Ab.resolve(this._bodyArrayBuffer));
            }
            if (oT) return this.blob().then(vT);
            throw new Error("could not read as ArrayBuffer");
        }, this.text = function() {
            var e = fT(this);
            if (e) return e;
            if (this._bodyBlob) return function(e) {
                var t = new FileReader, r = hT(t), a = /charset=([A-Za-z0-9_-]+)/.exec(e.type), n = a ? a[1] : "utf-8";
                return t.readAsText(e, n), r;
            }(this._bodyBlob);
            if (this._bodyArrayBuffer) return Ab.resolve(function(e) {
                for(var t = new Uint8Array(e), r = new Array(t.length), a = 0; a < t.length; a++)r[a] = String.fromCharCode(t[a]);
                return r.join("");
            }(this._bodyArrayBuffer));
            if (this._bodyFormData) throw new Error("could not read FormData body as text");
            return Ab.resolve(this._bodyText);
        }, iT && (this.formData = function() {
            return this.text().then(CT);
        }), this.json = function() {
            return this.text().then(JSON.parse);
        }, this;
    }
    mT.prototype.append = function(e, t) {
        e = uT(e), t = dT(t);
        var r = hC(this)[e];
        hC(this)[e] = r ? r + ", " + t : t;
    }, mT.prototype.delete = function(e) {
        delete hC(this)[uT(e)];
    }, mT.prototype.get = function(e) {
        return e = uT(e), this.has(e) ? hC(this)[e] : null;
    }, mT.prototype.has = function(e) {
        return hC(this).hasOwnProperty(uT(e));
    }, mT.prototype.set = function(e, t) {
        hC(this)[uT(e)] = dT(t);
    }, mT.prototype.forEach = function(e, t) {
        for(var r in hC(this))hC(this).hasOwnProperty(r) && e.call(t, hC(this)[r], r, this);
    }, mT.prototype.keys = function() {
        var e = [];
        return Sg(this).call(this, function(t, r) {
            e.push(r);
        }), pT(e);
    }, mT.prototype.values = function() {
        var e = [];
        return Sg(this).call(this, function(t) {
            e.push(t);
        }), pT(e);
    }, mT.prototype.entries = function() {
        var e = [];
        return Sg(this).call(this, function(t, r) {
            e.push([
                r,
                t
            ]);
        }), pT(e);
    }, nT && (mT.prototype[eF] = mF(mT.prototype));
    var bT = [
        "CONNECT",
        "DELETE",
        "GET",
        "HEAD",
        "OPTIONS",
        "PATCH",
        "POST",
        "PUT",
        "TRACE"
    ];
    function kT(e, t) {
        if (!(this instanceof kT)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        var r = (t = t || {}).body;
        if (e instanceof kT) {
            if (e.bodyUsed) throw new TypeError("Already read");
            this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new mT(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, r || null == e._bodyInit || (r = e._bodyInit, e.bodyUsed = !0);
        } else this.url = String(e);
        if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new mT(t.headers)), this.method = function(e) {
            var t = e.toUpperCase();
            return Kk(bT).call(bT, t) > -1 ? t : e;
        }(t.method || this.method || "GET"), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal || function() {
            if ("AbortController" in rT) return (new AbortController).signal;
        }(), this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && r) throw new TypeError("Body not allowed for GET or HEAD requests");
        if (this._initBody(r), !("GET" !== this.method && "HEAD" !== this.method || "no-store" !== t.cache && "no-cache" !== t.cache)) {
            var a = /([?&])_=[^&]*/;
            if (a.test(this.url)) this.url = this.url.replace(a, "$1_=" + (new Date).getTime());
            else this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + (new Date).getTime();
        }
    }
    function CT(e) {
        var t, r = new FormData;
        return Sg(t = ID(e).call(e).split("&")).call(t, function(e) {
            if (e) {
                var t = e.split("="), a = t.shift().replace(/\+/g, " "), n = t.join("=").replace(/\+/g, " ");
                r.append(decodeURIComponent(a), decodeURIComponent(n));
            }
        }), r;
    }
    function _T(e, t) {
        if (!(this instanceof _T)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        if (t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
        this.ok = this.status >= 200 && this.status < 300, this.statusText = void 0 === t.statusText ? "" : "" + t.statusText, this.headers = new mT(t.headers), this.url = t.url || "", this._initBody(e);
    }
    kT.prototype.clone = function() {
        return new kT(this, {
            body: this._bodyInit
        });
    }, gT.call(kT.prototype), gT.call(_T.prototype), _T.prototype.clone = function() {
        return new _T(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new mT(this.headers),
            url: this.url
        });
    }, _T.error = function() {
        var e = new _T(null, {
            status: 200,
            statusText: ""
        });
        return e.status = 0, e.type = "error", e;
    };
    var NT = [
        301,
        302,
        303,
        307,
        308
    ];
    _T.redirect = function(e, t) {
        if (-1 === Kk(NT).call(NT, t)) throw new RangeError("Invalid status code");
        return new _T(null, {
            status: t,
            headers: {
                location: e
            }
        });
    };
    var PT = rT.DOMException;
    try {
        new PT;
    } catch (e) {
        PT = function(e, t) {
            this.message = e, this.name = t;
            var r = Error(e);
            this.stack = r.stack;
        }, PT.prototype = Lx(Error.prototype), PT.prototype.constructor = PT;
    }
    function wT(e, t) {
        return new Ab(function(r, a) {
            var n = new kT(e, t);
            if (n.signal && n.signal.aborted) return a(new PT("Aborted", "AbortError"));
            var o = new XMLHttpRequest;
            function i() {
                o.abort();
            }
            if (o.onload = function() {
                var e, t, a, i, l, s, c = {
                    statusText: o.statusText,
                    headers: (t = o.getAllResponseHeaders() || "", l = new mT, s = t.replace(/\r?\n[\t ]+/g, " "), Sg(a = hC(i = s.split("\r")).call(i, function(e) {
                        return 0 === Kk(e).call(e, "\n") ? e.substr(1, e.length) : e;
                    })).call(a, function(e) {
                        var t, r = e.split(":"), a = ID(t = r.shift()).call(t);
                        if (a) {
                            var n, o = ID(n = r.join(":")).call(n);
                            try {
                                l.append(a, o);
                            } catch (e) {
                                console.warn("Response " + e.message);
                            }
                        }
                    }), l)
                };
                tT(e = n.url).call(e, "file://") && (o.status < 200 || o.status > 599) ? c.status = 200 : c.status = o.status, c.url = "responseURL" in o ? o.responseURL : c.headers.get("X-Request-URL");
                var u = "response" in o ? o.response : o.responseText;
                NP(function() {
                    r(new _T(u, c));
                }, 0);
            }, o.onerror = function() {
                NP(function() {
                    a(new TypeError("Network request failed"));
                }, 0);
            }, o.ontimeout = function() {
                NP(function() {
                    a(new TypeError("Network request timed out"));
                }, 0);
            }, o.onabort = function() {
                NP(function() {
                    a(new PT("Aborted", "AbortError"));
                }, 0);
            }, o.open(n.method, function(e) {
                try {
                    return "" === e && rT.location.href ? rT.location.href : e;
                } catch (t) {
                    return e;
                }
            }(n.url), !0), "include" === n.credentials ? o.withCredentials = !0 : "omit" === n.credentials && (o.withCredentials = !1), "responseType" in o && (oT ? o.responseType = "blob" : lT && (o.responseType = "arraybuffer")), t && "object" === ig(t.headers) && !(t.headers instanceof mT || rT.Headers && t.headers instanceof rT.Headers)) {
                var l, s, c = [];
                Sg(l = oF(t.headers)).call(l, function(e) {
                    c.push(uT(e)), o.setRequestHeader(e, dT(t.headers[e]));
                }), Sg(s = n.headers).call(s, function(e, t) {
                    -1 === Kk(c).call(c, t) && o.setRequestHeader(t, e);
                });
            } else {
                var u;
                Sg(u = n.headers).call(u, function(e, t) {
                    o.setRequestHeader(t, e);
                });
            }
            n.signal && (n.signal.addEventListener("abort", i), o.onreadystatechange = function() {
                4 === o.readyState && n.signal.removeEventListener("abort", i);
            }), o.send(void 0 === n._bodyInit ? null : n._bodyInit);
        });
    }
    wT.polyfill = !0, rT.fetch || (rT.fetch = wT, rT.Headers = mT, rT.Request = kT, rT.Response = _T);
    var AT = "undefined" != typeof window && "fetch" in window ? window.fetch : wT, ST = "https://checkoutshopper-live.adyen.com/checkoutshopper/", IT = [
        "amount",
        "secondaryAmount",
        "countryCode",
        "environment",
        "loadingContext",
        "i18n",
        "modules",
        "order",
        "session",
        "clientKey",
        "showPayButton",
        "redirectFromTopWhenInIframe",
        "installmentOptions",
        "onPaymentCompleted",
        "beforeRedirect",
        "beforeSubmit",
        "onSubmit",
        "onActionHandled",
        "onAdditionalDetails",
        "onCancel",
        "onChange",
        "onError",
        "onBalanceCheck",
        "onOrderRequest",
        "onOrderCreated",
        "setStatusAutomatically"
    ], ET = 6e4;
    function DT(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function RT(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = DT(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = DT(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function FT(e) {
        return e && e.errorCode && e.errorType && e.message && e.status;
    }
    function xT(e, t) {
        var r, a, n, o = e.headers, i = void 0 === o ? [] : o, l = e.errorLevel, s = void 0 === l ? "warn" : l, c = e.loadingContext, u = void 0 === c ? ST : c, d = e.method, p = void 0 === d ? "GET" : d, m = e.path, f = e.timeout, h = void 0 === f ? ET : f, v = RT(RT({
            method: p,
            mode: "cors",
            cache: "default",
            credentials: "same-origin",
            headers: RT({
                Accept: "application/json, text/plain, */*",
                "Content-Type": "POST" === p ? "application/json" : "text/plain"
            }, i),
            redirect: "follow",
            referrerPolicy: "no-referrer-when-downgrade"
        }, (null === (r = AbortSignal) || void 0 === r ? void 0 : r.timeout) && {
            signal: null === (a = AbortSignal) || void 0 === a ? void 0 : a.timeout(h)
        }), t && {
            body: Mb(t)
        }), y = wb(n = "".concat(u)).call(n, m);
        return AT(y, v).then(function() {
            var t = Jd(Dy.mark(function t(r) {
                var a;
                return Dy.wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            return t.next = 2, r.json();
                        case 2:
                            if (a = t.sent, !r.ok) {
                                t.next = 5;
                                break;
                            }
                            return t.abrupt("return", a);
                        case 5:
                            if (!FT(a)) {
                                t.next = 8;
                                break;
                            }
                            return TT(a.message, s), t.abrupt("return");
                        case 8:
                            return TT(e.errorMessage || "Service at ".concat(y, " is not available"), s), t.abrupt("return");
                        case 11:
                        case "end":
                            return t.stop();
                    }
                }, t);
            }));
            return function(e) {
                return t.apply(this, arguments);
            };
        }()).catch(function(t) {
            var r;
            if (t instanceof LS) throw t;
            TT(e.errorMessage || wb(r = "Call to ".concat(y, " failed. Error= ")).call(r, t), s);
        });
    }
    function TT(e, t) {
        switch(t){
            case "silent":
                break;
            case "info":
            case "warn":
            case "error":
                console[t](e);
                break;
            default:
                throw new LS("NETWORK_ERROR", e);
        }
    }
    function zT(e, t) {
        return xT(RT(RT({}, e), {}, {
            method: "POST"
        }), t);
    }
    function OT(e, t, r) {
        var a;
        return function(e, t) {
            return xT(RT(RT({}, e), {}, {
                method: "GET"
            }), t);
        }({
            loadingContext: t,
            errorLevel: "warn",
            errorMessage: "Dataset ".concat(e, " is not available"),
            path: r ? wb(a = "datasets/".concat(e, "/")).call(a, r, ".json") : "datasets/".concat(e, ".json")
        });
    }
    var jT = Sr, BT = um.findIndex, MT = "findIndex", LT = !0;
    MT in [] && Array(1)[MT](function() {
        LT = !1;
    }), jT({
        target: "Array",
        proto: !0,
        forced: LT
    }, {
        findIndex: function(e) {
            return BT(this, e, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var VT = Cv("Array", "findIndex"), UT = ie, KT = VT, HT = Array.prototype, qT = t(function(e) {
        var t = e.findIndex;
        return e === HT || UT(HT, e) && t === HT.findIndex ? KT : t;
    }), WT = um.some;
    Sr({
        target: "Array",
        proto: !0,
        forced: !vv("some")
    }, {
        some: function(e) {
            return WT(this, e, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var GT = Cv("Array", "some"), YT = ie, QT = GT, ZT = Array.prototype, JT = t(function(e) {
        var t = e.some;
        return e === ZT || YT(ZT, e) && t === ZT.some ? QT : t;
    }), $T = {
        "adyen-checkout__dropdown": "Select-module_adyen-checkout__dropdown__0Mj-n",
        "adyen-checkout__dropdown__button": "Select-module_adyen-checkout__dropdown__button__yTyqq",
        "adyen-checkout__dropdown__button--active": "Select-module_adyen-checkout__dropdown__button--active__Ej-JR",
        "adyen-checkout__filter-input": "Select-module_adyen-checkout__filter-input__CwPBS",
        "adyen-checkout__dropdown__list": "Select-module_adyen-checkout__dropdown__list__YtEzj",
        "adyen-checkout__dropdown__list--active": "Select-module_adyen-checkout__dropdown__list--active__Gegw2",
        "adyen-checkout__dropdown__element": "Select-module_adyen-checkout__dropdown__element__ORU4-"
    };
    function XT(e) {
        var t, r = e.backgroundUrl, a = void 0 === r ? "" : r, n = e.className, o = void 0 === n ? "" : n, i = e.classNameModifiers, l = void 0 === i ? [] : i, s = e.src, c = void 0 === s ? "" : s, u = e.alt, d = void 0 === u ? "" : u, p = e.showOnError, m = void 0 !== p && p, f = Vk(VP(!1), 2), h = f[0], v = f[1], y = qP(null), g = function() {
            v(!0);
        }, b = DP.apply(void 0, wb(t = [
            [
                o
            ],
            "adyen-checkout__image",
            {
                "adyen-checkout__image--loaded": h
            }
        ]).call(t, Uk(hC(l).call(l, function(e) {
            return "adyen-checkout__image--".concat(e);
        }))));
        return KP(function() {
            var e = a ? new Image : y.current;
            e.src = a || c, e.onload = g, v(!!e.complete);
        }, []), a ? nN("div", M_({
            "data-testid": "background",
            style: {
                backgroundUrl: a
            }
        }, e, {
            className: b
        })) : nN("img", M_({}, e, {
            alt: d,
            ref: y,
            className: b,
            onError: function() {
                v(m);
            }
        }));
    }
    var ez = [
        "filterable",
        "toggleButtonRef"
    ];
    function tz(e) {
        var t = e.filterable, r = e.toggleButtonRef, a = kg(e, ez);
        return t ? nN("div", M_({}, a, {
            ref: r
        })) : nN("button", M_({
            id: a.id,
            "aria-describedby": a.ariaDescribedBy,
            type: "button"
        }, a, {
            ref: r
        }));
    }
    function rz(e) {
        var t = sw().i18n, r = e.active, a = e.selected, n = e.inputText, o = e.readonly, i = e.showList, l = a.selectedOptionName || a.name || e.placeholder || "", s = i ? n : l, c = o ? null : e.filterable ? function(t) {
            t.preventDefault(), document.activeElement === e.filterInputRef.current ? e.showList || e.toggleList(t) : e.filterInputRef.current && e.filterInputRef.current.focus();
        } : e.toggleList, u = o ? null : e.onFocus, d = r.id ? "listItem-".concat(r.id) : "";
        return nN(tz, {
            className: DP(Ag(Ag(Ag(Ag(Ag(Ag(Ag({
                "adyen-checkout__dropdown__button": !0
            }, $T["adyen-checkout__dropdown__button"], !0), "adyen-checkout__dropdown__button--readonly", o), "adyen-checkout__dropdown__button--active", i), $T["adyen-checkout__dropdown__button--active"], i), "adyen-checkout__dropdown__button--invalid", e.isInvalid), "adyen-checkout__dropdown__button--valid", e.isValid), "adyen-checkout__dropdown__button--disabled", a.disabled)),
            disabled: e.disabled,
            filterable: e.filterable,
            onClick: c,
            onKeyDown: o ? null : e.onButtonKeyDown,
            toggleButtonRef: e.toggleButtonRef
        }, e.filterable ? nN(iN, null, !i && a.icon && nN(XT, {
            className: "adyen-checkout__dropdown__button__icon",
            src: a.icon,
            alt: a.name
        }), nN("input", {
            value: s,
            "aria-autocomplete": "list",
            "aria-controls": e.selectListId,
            "aria-expanded": i,
            "aria-owns": e.selectListId,
            autoComplete: "off",
            className: DP("adyen-checkout__filter-input", [
                $T["adyen-checkout__filter-input"]
            ]),
            onInput: e.onInput,
            onFocus: u,
            placeholder: t.get("select.filter.placeholder"),
            ref: e.filterInputRef,
            role: "combobox",
            "aria-activedescendant": d,
            type: "text",
            readOnly: e.readonly,
            id: e.id,
            "aria-describedby": e.ariaDescribedBy
        }), !i && a.secondaryText && nN("span", {
            className: "adyen-checkout__dropdown__button__secondary-text"
        }, a.secondaryText)) : nN(iN, null, a.icon && nN(XT, {
            className: "adyen-checkout__dropdown__button__icon",
            src: a.icon,
            alt: a.name
        }), nN("span", {
            className: "adyen-checkout__dropdown__button__text"
        }, l), a.secondaryText && nN("span", {
            className: "adyen-checkout__dropdown__button__secondary-text"
        }, a.secondaryText)));
    }
    var az = [
        "item",
        "active",
        "selected"
    ], nz = function(e) {
        var t = e.item, r = e.active, a = e.selected, n = kg(e, az);
        return nN("li", {
            "aria-disabled": !!t.disabled,
            "aria-selected": a,
            className: DP([
                "adyen-checkout__dropdown__element",
                $T["adyen-checkout__dropdown__element"],
                {
                    "adyen-checkout__dropdown__element--active": r,
                    "adyen-checkout__dropdown__element--disabled": !!t.disabled
                }
            ]),
            "data-disabled": !0 === t.disabled || null,
            "data-value": t.id,
            onClick: n.onSelect,
            onMouseEnter: n.onHover,
            role: "option",
            id: "listItem-".concat(t.id)
        }, t.icon && nN(XT, {
            className: "adyen-checkout__dropdown__element__icon",
            alt: t.name,
            src: t.icon
        }), nN("span", {
            className: "adyen-checkout__dropdown__element__text"
        }, t.name), t.secondaryText && nN("span", {
            className: "adyen-checkout__dropdown__element__secondary-text"
        }, t.secondaryText), a && nN(DI, {
            type: "checkmark",
            height: 14,
            width: 14
        }));
    }, oz = [
        "selected",
        "active",
        "filteredItems",
        "showList"
    ];
    function iz(e) {
        var t = e.selected, r = e.active, a = e.filteredItems, n = e.showList, o = kg(e, oz), i = sw().i18n;
        return nN("ul", {
            className: DP(Ag(Ag(Ag({
                "adyen-checkout__dropdown__list": !0
            }, $T["adyen-checkout__dropdown__list"], !0), "adyen-checkout__dropdown__list--active", n), $T["adyen-checkout__dropdown__list--active"], n)),
            id: o.selectListId,
            ref: o.selectListRef,
            role: "listbox"
        }, a.length ? hC(a).call(a, function(e) {
            return nN(nz, {
                active: e.id === r.id,
                item: e,
                key: e.id,
                onSelect: o.onSelect,
                onHover: o.onHover,
                selected: e.id === t.id
            });
        }) : nN("div", {
            className: "adyen-checkout__dropdown__element adyen-checkout__dropdown__element--no-options"
        }, i.get("select.noOptionsFound")));
    }
    var lz = {
        arrowDown: "ArrowDown",
        arrowUp: "ArrowUp",
        enter: "Enter",
        escape: "Escape",
        space: " ",
        tab: "Tab"
    }, sz = function(e) {
        var t = e.parentNode, r = window.getComputedStyle(t, null), a = ZC(r.getPropertyValue("border-top-width")), n = e.offsetTop - t.offsetTop < t.scrollTop, o = e.offsetTop - t.offsetTop + e.clientHeight - a > t.scrollTop + t.clientHeight;
        (n || o) && (t.scrollTop = e.offsetTop - t.offsetTop - t.clientHeight / 2 - a + e.clientHeight / 2);
    };
    function cz(e) {
        var t, r, a = e.items, n = void 0 === a ? [] : a, o = e.className, i = void 0 === o ? "" : o, l = e.classNameModifiers, s = void 0 === l ? [] : l, c = e.filterable, u = void 0 === c || c, d = e.readonly, p = void 0 !== d && d, m = e.onChange, f = void 0 === m ? function() {} : m, h = e.onInput, v = e.selectedValue, y = e.name, g = e.isInvalid, b = e.isValid, k = e.placeholder, C = e.uniqueId, _ = e.disabled, N = e.disableTextFilter, P = e.clearOnSelect, w = e.blurOnClose, A = e.onListToggle, S = qP(null), I = qP(null), E = qP(null), D = qP(null), R = Vk(VP(null), 2), F = R[0], x = R[1], T = Vk(VP(!1), 2), z = T[0], O = T[1], j = WP(function() {
            return "select-".concat(FN());
        }, []), B = zb(n).call(n, function(e) {
            return e.id === v;
        }) || {}, M = Vk(VP(), 2), L = M[0], V = M[1], U = Vk(VP(B), 2), K = U[0], H = U[1], q = B, W = N ? n : xg(n).call(n, function(e) {
            var t;
            return !F || kb(t = e.name.toLowerCase()).call(t, F.toLowerCase());
        }), G = function(e) {
            if (e) {
                var t = document.getElementById("listItem-".concat(e.id));
                sz(t);
            }
        }, Y = function() {
            w && S.current.blur(), O(!1);
        }, Q = function() {
            O(!0);
        }, Z = function(e) {
            var t = e.currentTarget.getAttribute("data-value");
            return zb(W).call(W, function(e) {
                return e.id == t;
            });
        }, J = function(e) {
            var t;
            e.preventDefault(), (t = e.currentTarget instanceof HTMLElement && "option" === e.currentTarget.getAttribute("role") ? Z(e) : K.id && JT(W).call(W, function(e) {
                return e.id === K.id;
            }) ? K : F ? W[0] : {
                id: v
            }) && !t.disabled && (f({
                target: {
                    value: t.id,
                    name: y
                }
            }), P && V(null), Y());
        }, $ = function(e) {
            switch(e.key){
                case lz.space:
                case lz.enter:
                    J(e);
                    break;
                case lz.arrowDown:
                    e.preventDefault(), function() {
                        if (W && !(W.length < 1)) {
                            var e = qT(W).call(W, function(e) {
                                return e === K;
                            }) + 1, t = e < W.length ? e : 0, r = W[t];
                            G(r), H(r);
                        }
                    }();
                    break;
                case lz.arrowUp:
                    e.preventDefault(), function() {
                        if (W && !(W.length < 1)) {
                            var e = qT(W).call(W, function(e) {
                                return e === K;
                            }) - 1, t = e < 0 ? W.length - 1 : e, r = W[t];
                            G(r), H(r);
                        }
                    }();
            }
        };
        return KP(function() {
            z ? V(null) : x(null);
        }, [
            z
        ]), KP(function() {
            z && u && S.current && S.current.focus(), null == A || A(z);
        }, [
            z
        ]), KP(function() {
            function e(e) {
                var t;
                (e.composedPath ? !kb(t = e.composedPath()).call(t, I.current) : !I.current.contains(e.target)) && Y();
            }
            return document.addEventListener("click", e, !1), function() {
                document.removeEventListener("click", e, !1);
            };
        }, [
            I
        ]), nN("div", {
            className: DP(wb(t = [
                "adyen-checkout__dropdown",
                $T["adyen-checkout__dropdown"],
                i
            ]).call(t, Uk(hC(s).call(s, function(e) {
                return "adyen-checkout__dropdown--".concat(e);
            })))),
            ref: I
        }, nN(rz, {
            inputText: L,
            id: null != C ? C : null,
            active: K,
            selected: q,
            filterInputRef: S,
            filterable: u,
            isInvalid: g,
            isValid: b,
            onButtonKeyDown: function(e) {
                var t;
                e.key === lz.enter && u && z && F ? J(e) : e.key === lz.escape ? Y() : !kb(t = [
                    lz.arrowUp,
                    lz.arrowDown,
                    lz.enter
                ]).call(t, e.key) && (e.key !== lz.space || u && z) ? (e.shiftKey && e.key === lz.tab || e.key === lz.tab) && Y() : (e.preventDefault(), z ? $(e) : Q());
            },
            onFocus: Q,
            onInput: function(e) {
                var t = e.target.value;
                V(t), x(t), h && h(t);
            },
            placeholder: k,
            readonly: p,
            selectListId: j,
            showList: z,
            toggleButtonRef: E,
            toggleList: function(e) {
                e.preventDefault(), z ? (V(q.name), Y()) : (V(null), Q());
            },
            disabled: _,
            ariaDescribedBy: C ? wb(r = "".concat(C)).call(r, sE) : null
        }), nN(iz, {
            active: K,
            filteredItems: W,
            onHover: function(e) {
                e.preventDefault();
                var t = Z(e);
                H(t);
            },
            onSelect: J,
            selected: q,
            selectListId: j,
            selectListRef: D,
            showList: z
        }));
    }
    function uz(e) {
        var t = e.classNameModifiers, r = e.label, a = e.onDropdownChange, n = e.readOnly, o = e.selectedCountry, i = e.specifications, l = e.value, s = sw(), c = s.i18n, u = s.loadingContext, d = Vk(VP([]), 2), p = d[0], m = d[1], f = Vk(VP(!1), 2), h = f[0], v = f[1], y = i.getPlaceholderKeyForField("stateOrProvince", o);
        return HP(function() {
            if (!o || !i.countryHasDataset(o)) return m([]), void v(!0);
            OT("states/".concat(o), u, c.locale).then(function(e) {
                var t = e && e.length ? e : [];
                m(t), v(!0);
            }).catch(function() {
                m([]), v(!0);
            });
        }, [
            o
        ]), h && p.length ? nN(FE, {
            label: r,
            classNameModifiers: t,
            errorMessage: e.errorMessage,
            isValid: !!l,
            showValidIcon: !1,
            name: "stateOrProvince",
            i18n: c
        }, nN(cz, {
            name: "stateOrProvince",
            onChange: a,
            selectedValue: l,
            placeholder: c.get(y),
            items: p,
            readonly: n && !!l
        })) : null;
    }
    function dz(e) {
        var t = e.allowedCountries, r = void 0 === t ? [] : t, a = e.classNameModifiers, n = void 0 === a ? [] : a, o = e.errorMessage, i = e.onDropdownChange, l = e.value, s = sw(), c = s.i18n, u = s.loadingContext, d = Vk(VP([]), 2), p = d[0], m = d[1], f = Vk(VP(!1), 2), h = f[0], v = f[1], y = Vk(VP(e.readOnly), 2), g = y[0], b = y[1];
        return HP(function() {
            OT("countries", u, c.locale).then(function(e) {
                var t = r.length ? xg(e).call(e, function(e) {
                    return kb(r).call(r, e.id);
                }) : e;
                m(t || []), b(1 === t.length || g), v(!0);
            }).catch(function(e) {
                console.error(e), m([]), v(!0);
            });
        }, []), h ? nN(FE, {
            name: "country",
            label: c.get("country"),
            errorMessage: o,
            classNameModifiers: n,
            isValid: !!l,
            showValidIcon: !1,
            i18n: c
        }, nN(cz, {
            onChange: i,
            name: "country",
            placeholder: c.get("select.country"),
            selectedValue: l,
            items: p,
            readonly: g && !!l
        })) : null;
    }
    function pz(e) {
        var t, r = sw().i18n, a = e.classNameModifiers, n = void 0 === a ? [] : a, o = e.data, i = e.errors, l = e.valid, s = e.fieldName, c = e.onInput, u = e.onBlur, d = e.trimOnBlur, p = e.maxLength, m = e.disabled, f = o[s], h = o.country, v = e.specifications.countryHasOptionalField(h, s), y = e.specifications.getKeyForField(s, h), g = v ? " ".concat(r.get("field.title.optional")) : "", b = wb(t = "".concat(r.get(y))).call(t, g), k = function(e, t, r) {
            var a, n;
            if ("object" === ig(null === (a = e[t]) || void 0 === a ? void 0 : a.errorMessage)) {
                var o = e[t].errorMessage, i = o.translationKey, l = o.translationObject;
                return r.get(i, l);
            }
            return r.get(null === (n = e[t]) || void 0 === n ? void 0 : n.errorMessage) || !!e[t];
        }(i, s, r);
        switch(s){
            case "country":
                return nN(dz, {
                    allowedCountries: e.allowedCountries,
                    classNameModifiers: n,
                    label: b,
                    errorMessage: k,
                    onDropdownChange: e.onDropdownChange,
                    value: f
                });
            case "stateOrProvince":
                return nN(uz, {
                    classNameModifiers: n,
                    label: b,
                    errorMessage: k,
                    onDropdownChange: e.onDropdownChange,
                    selectedCountry: h,
                    specifications: e.specifications,
                    value: f
                });
            default:
                return nN(FE, {
                    label: b,
                    classNameModifiers: n,
                    errorMessage: k,
                    isValid: l[s],
                    name: s,
                    i18n: r,
                    onFocus: function(t) {
                        return e.onFieldFocusAnalytics(s, t);
                    },
                    onBlur: function(t) {
                        return e.onFieldBlurAnalytics(s, t);
                    }
                }, nN(FD, {
                    name: s,
                    classNameModifiers: n,
                    value: f,
                    onInput: c,
                    onBlur: u,
                    maxlength: p,
                    trimOnBlur: d,
                    disabled: m,
                    required: !v
                }));
        }
    }
    cz.defaultProps = {
        className: "",
        classNameModifiers: [],
        filterable: !0,
        items: [],
        readonly: !1,
        onChange: function() {}
    };
    var mz = tp, fz = ca, hz = ap, vz = Qt, yz = function(e, t, r, a, n, o, i, l) {
        for(var s, c, u = n, d = 0, p = !!i && vz(i, l); d < a;)d in r && (s = p ? p(r[d], d, t) : r[d], o > 0 && mz(s) ? (c = fz(s), u = yz(e, t, s, c, u, o - 1) - 1) : (hz(u + 1), e[u] = s), u++), d++;
        return u;
    }, gz = yz, bz = Ye, kz = ca, Cz = ea, _z = fp;
    Sr({
        target: "Array",
        proto: !0
    }, {
        flat: function() {
            var e = arguments.length ? arguments[0] : void 0, t = bz(this), r = kz(t), a = _z(t, 0);
            return a.length = gz(a, t, t, r, 0, void 0 === e ? 1 : Cz(e)), a;
        }
    });
    var Nz = Cv("Array", "flat"), Pz = ie, wz = Nz, Az = Array.prototype, Sz = t(function(e) {
        var t = e.flat;
        return e === Az || Pz(Az, e) && t === Az.flat ? wz : t;
    });
    function Iz(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Ez(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = Iz(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = Iz(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var Dz = function() {
        function e(t) {
            Cg(this, e), Ag(this, "specifications", void 0), this.specifications = Ez(Ez({}, SR), t);
        }
        return wg(e, [
            {
                key: "countryHasDataset",
                value: function(e) {
                    var t;
                    return !(null === (t = this.specifications) || void 0 === t || null === (t = t[e]) || void 0 === t || !t.hasDataset);
                }
            },
            {
                key: "countryHasOptionalField",
                value: function(e, t) {
                    var r;
                    return !(null === (r = this.specifications) || void 0 === r || null === (r = r[e]) || void 0 === r || null === (r = r.optionalFields) || void 0 === r || !kb(r).call(r, t));
                }
            },
            {
                key: "getAddressSchemaForCountry",
                value: function(e) {
                    var t;
                    return (null === (t = this.specifications) || void 0 === t || null === (t = t[e]) || void 0 === t ? void 0 : t.schema) || this.specifications.default.schema;
                }
            },
            {
                key: "getAddressLabelsForCountry",
                value: function(e) {
                    var t;
                    return (null === (t = this.specifications) || void 0 === t || null === (t = t[e]) || void 0 === t ? void 0 : t.labels) || this.specifications.default.labels;
                }
            },
            {
                key: "getOptionalFieldsForCountry",
                value: function(e) {
                    var t, r;
                    return (null === (t = this.specifications) || void 0 === t || null === (t = t[e]) || void 0 === t ? void 0 : t.optionalFields) || (null === (r = this.specifications.default) || void 0 === r ? void 0 : r.optionalFields) || [];
                }
            },
            {
                key: "getKeyForField",
                value: function(e, t) {
                    var r, a;
                    return (null === (r = this.specifications) || void 0 === r || null === (r = r[t]) || void 0 === r || null === (r = r.labels) || void 0 === r ? void 0 : r[e]) || (null === (a = this.specifications) || void 0 === a || null === (a = a.default) || void 0 === a || null === (a = a.labels) || void 0 === a ? void 0 : a[e]) || e;
                }
            },
            {
                key: "getPlaceholderKeyForField",
                value: function(e, t) {
                    var r, a;
                    return (null === (r = this.specifications) || void 0 === r || null === (r = r[t]) || void 0 === r || null === (r = r.placeholders) || void 0 === r ? void 0 : r[e]) || (null === (a = this.specifications) || void 0 === a || null === (a = a.default) || void 0 === a || null === (a = a.placeholders) || void 0 === a ? void 0 : a[e]);
                }
            },
            {
                key: "getAddressSchemaForCountryFlat",
                value: function(e) {
                    var t, r;
                    return xg(t = Sz(r = this.getAddressSchemaForCountry(e)).call(r, 2)).call(t, function(e) {
                        return "string" == typeof e;
                    });
                }
            }
        ]), e;
    }(), Rz = function(e) {
        var t, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 300;
        return function() {
            for(var a = this, n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            clearTimeout(t), t = NP(function() {
                return e.apply(a, o);
            }, r);
        };
    };
    function Fz(e) {
        var t = e.onAddressLookup, r = e.onAddressSelected, a = e.onSelect, n = e.onManualAddress, o = e.externalErrorMessage, i = e.hideManualButton, l = e.addressSearchDebounceMs, s = Vk(VP([]), 2), c = s[0], u = s[1], d = Vk(VP([]), 2), p = d[0], m = d[1], f = Vk(VP(""), 2), h = f[0], v = f[1], y = sw().i18n, g = function(e) {
            return hC(e).call(e, function(e) {
                return {
                    id: e.id,
                    name: e.name
                };
            });
        }, b = GP(function(e) {
            null != e && e.errorMessage && v(e.errorMessage);
        }, []), k = GP(function() {
            var e = Jd(Dy.mark(function e(r) {
                return Dy.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            new Ab(function(e, a) {
                                t(r, {
                                    resolve: e,
                                    reject: a
                                });
                            }).then(function(e) {
                                m(e), u(g(e)), v("");
                            }).catch(function(e) {
                                return b(e);
                            });
                        case 1:
                        case "end":
                            return e.stop();
                    }
                }, e);
            }));
            return function(t) {
                return e.apply(this, arguments);
            };
        }(), [
            t
        ]);
        KP(function() {
            v(o);
        }, [
            o
        ]);
        var C = function() {
            var e = Jd(Dy.mark(function e(t) {
                var n;
                return Dy.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            if (t.target.value) {
                                e.next = 3;
                                break;
                            }
                            return v(y.get("address.errors.incomplete")), e.abrupt("return");
                        case 3:
                            if (n = zb(p).call(p, function(e) {
                                return e.id === t.target.value;
                            }), "function" == typeof r) {
                                e.next = 8;
                                break;
                            }
                            return a(n), u([]), e.abrupt("return");
                        case 8:
                            new Ab(function(e, t) {
                                r(n, {
                                    resolve: e,
                                    reject: t
                                });
                            }).then(function(e) {
                                a(e), u([]);
                            }).catch(function(e) {
                                return b(e);
                            });
                        case 9:
                        case "end":
                            return e.stop();
                    }
                }, e);
            }));
            return function(t) {
                return e.apply(this, arguments);
            };
        }(), _ = WP(function() {
            return Rz(k, l);
        }, []);
        return nN("div", {
            className: "adyen-checkout__address-search adyen-checkout__field-group"
        }, nN(FE, {
            label: y.get("address"),
            classNameModifiers: [
                "address-search"
            ],
            errorMessage: h,
            name: "address-search"
        }, nN(cz, {
            name: "address-search",
            className: "adyen-checkout__address-search__dropdown",
            onInput: _,
            items: c,
            onChange: C,
            disableTextFilter: !0,
            blurOnClose: !0
        })), !i && nN("span", {
            className: "adyen-checkout__address-search__manual-add"
        }, nN("button", {
            type: "button",
            className: "adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link adyen-checkout__address-search__manual-add__button",
            onClick: n
        }, "+ " + y.get("address.enterManually"))));
    }
    function xz(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Tz(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = xz(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = xz(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function zz(e) {
        var t, r, a = sw().i18n, n = e.label, o = void 0 === n ? "" : n, i = e.requiredFields, l = e.visibility, s = e.iOSFocusedField, c = void 0 === s ? null : s, u = qP({});
        Ty(u.current).length || null === (r = e.setComponentRef) || void 0 === r || r.call(e, u.current);
        var d = WP(function() {
            return new Dz(e.specifications);
        }, [
            e.specifications
        ]), p = xg(t = d.getAddressSchemaForCountryFlat(e.countryCode)).call(t, function(e) {
            return kb(i).call(i, e);
        }), m = Vk(VP(!1), 2), f = m[0], h = m[1], v = Vk(VP(!1), 2), y = v[0], g = v[1], b = Vk(VP(""), 2), k = b[0], C = b[1], _ = !!e.onAddressLookup, N = !e.onAddressLookup || f || y, P = _D({
            schema: p,
            defaultData: e.data,
            rules: Tz(Tz({}, ZR(d)), e.validationRules),
            formatters: HR
        }), w = P.data, A = P.errors, S = P.valid, I = P.isValid, E = P.handleChangeFor, D = P.triggerValidation, R = P.setData, F = GP(function(e) {
            var t = gR;
            Sg(t).call(t, function(t) {
                var r = e[t];
                null != r && R(t, String(r));
            }), D(), h(!0);
        }, [
            h,
            D,
            R
        ]), x = GP(function() {
            g(!0);
        }, []);
        u.current.showValidation = function() {
            D(), C(!_ || N || I ? "" : a.get("address.errors.incomplete"));
        };
        var T = xg(p).call(p, function(e) {
            return !c || e === c;
        });
        if (KP(function() {
            var e = d.countryHasDataset(w.country) ? "" : yR, t = Tz(Tz({}, w), {}, {
                stateOrProvince: e
            });
            Sg(i).call(i, function(e) {
                var r;
                E(e, "input")(null !== (r = t[e]) && void 0 !== r ? r : "");
            }), t.postalCode && E("postalCode", "blur")(w.postalCode);
        }, [
            w.country
        ]), KP(function() {
            var e = kb(i).call(i, "stateOrProvince"), t = w.country && d.countryHasDataset(w.country), r = e && t, a = w.stateOrProvince || (r ? "" : yR);
            E("stateOrProvince", "input")(a);
        }, []), KP(function() {
            var t = d.getOptionalFieldsForCountry(w.country), r = tC(gR).call(gR, function(r, a) {
                var n = kb(t).call(t, a), o = kb(i).call(i, a), l = w[a], s = e.data[a], c = n && !l || !o ? o || l || !s ? yR : s : l;
                return null != c && c.length && (r[a] = c), r;
            }, {});
            e.onChange({
                data: r,
                valid: S,
                errors: A,
                isValid: I
            });
        }, [
            w,
            S,
            A,
            I
        ]), "hidden" === l) return null;
        if ("readOnly" === l) return nN(RR, {
            data: w,
            label: o
        });
        var z = function(t, r) {
            var a, n = r.classNameModifiers, o = void 0 === n ? [] : n;
            return kb(i).call(i, t) ? nN(pz, {
                key: t,
                allowedCountries: e.allowedCountries,
                classNameModifiers: wb(a = []).call(a, Uk(o), [
                    t
                ]),
                data: w,
                errors: A,
                valid: S,
                fieldName: t,
                onInput: E(t, "input"),
                onBlur: E(t, "blur"),
                onDropdownChange: E(t, "blur"),
                specifications: d,
                maxLength: qE(qR, t, w.country, !0),
                trimOnBlur: !0,
                disabled: !kb(T).call(T, t),
                onFieldFocusAnalytics: e.onFieldFocusAnalytics,
                onFieldBlurAnalytics: e.onFieldBlurAnalytics
            }) : null;
        }, O = d.getAddressSchemaForCountry(w.country);
        return nN(iN, null, nN(SI, {
            classNameModifiers: [
                o || "address"
            ],
            label: o
        }, _ && nN(Fz, {
            onAddressLookup: e.onAddressLookup,
            onAddressSelected: e.onAddressSelected,
            onSelect: F,
            onManualAddress: x,
            externalErrorMessage: k,
            hideManualButton: N,
            addressSearchDebounceMs: e.addressSearchDebounceMs
        }), N && nN(iN, null, hC(O).call(O, function(e) {
            var t;
            return e instanceof Array ? nN("div", {
                className: "adyen-checkout__field-group"
            }, hC(t = e).call(t, function(e) {
                var t = Vk(e, 2), r = t[0], a = t[1];
                return z(r, {
                    classNameModifiers: [
                        "col-".concat(a)
                    ]
                });
            })) : z(e, {});
        }))), !1);
    }
    zz.defaultProps = {
        countryCode: null,
        validationRules: null,
        data: {},
        onChange: function() {},
        visibility: "editable",
        requiredFields: gR,
        specifications: {},
        onFieldFocusAnalytics: function() {},
        onFieldBlurAnalytics: function() {}
    };
    var Oz = [
        "classNameModifiers",
        "label",
        "isInvalid",
        "onChange"
    ], jz = [
        "uniqueId",
        "addContextualElement"
    ];
    function Bz(e) {
        var t, r = e.classNameModifiers, a = void 0 === r ? [] : r, n = e.label, o = e.isInvalid, i = e.onChange, l = kg(e, Oz), s = l.uniqueId, c = l.addContextualElement;
        return nN("label", {
            className: "adyen-checkout__checkbox",
            htmlFor: s
        }, nN("input", M_({
            id: s
        }, kg(l, jz), c && {
            "aria-describedby": wb(t = "".concat(s)).call(t, sE)
        }, {
            className: DP([
                "adyen-checkout__checkbox__input",
                [
                    l.className
                ],
                {
                    "adyen-checkout__checkbox__input--invalid": o
                },
                hC(a).call(a, function(e) {
                    return "adyen-checkout__input--".concat(e);
                })
            ]),
            type: "checkbox",
            onChange: i
        })), nN("span", {
            className: "adyen-checkout__checkbox__label"
        }, n));
    }
    Bz.defaultProps = {
        onChange: function() {}
    };
    var Mz = [
        "errorMessage",
        "label",
        "onChange",
        "i18n"
    ];
    function Lz(e) {
        var t, r, a, n = e.errorMessage, o = e.label, i = e.onChange, l = e.i18n, s = kg(e, Mz);
        return nN(FE, {
            classNameModifiers: [
                "consentCheckbox"
            ],
            errorMessage: n,
            i18n: l,
            name: "consentCheckbox",
            useLabelElement: !1,
            label: l.get("creditCard.holderName")
        }, nN(Bz, {
            name: "consentCheckbox",
            classNameModifiers: wb(t = []).call(t, Uk(null !== (r = s.classNameModifiers) && void 0 !== r ? r : s.classNameModifiers = []), [
                "consentCheckbox"
            ]),
            onInput: i,
            value: null == s || null === (a = s.data) || void 0 === a ? void 0 : a.consentCheckbox,
            label: o,
            checked: s.checked
        }));
    }
    var Vz = [
        "companyDetails",
        "personalDetails",
        "billingAddress",
        "deliveryAddress",
        "bankAccount"
    ], Uz = function(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return tC(Vz).call(Vz, function(r, a) {
            var n = "hidden" !== e[a], o = "deliveryAddress" === a, i = "hidden" === (null == e ? void 0 : e.billingAddress);
            return r[a] = n && (!o || i || function() {
                return Ty(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).length > 1;
            }(t[a])), r;
        }, {});
    }, Kz = function(e, t, r) {
        var a, n, o = e, i = o.split(":"), l = i.length > 1;
        l && (n = i[0], o = i[1]);
        var s = function(e, t, r) {
            return kb(gR).call(gR, e) ? null != r && r[e] ? t.get(null == r ? void 0 : r[e]) : t.get(e) : null;
        }(o, t, r);
        return s && n ? l ? wb(a = "".concat(t.get(n), " ")).call(a, s) : s : null;
    }, Hz = {
        AD: {
            length: 24,
            structure: "F04F04A12",
            example: "AD9912345678901234567890"
        },
        AE: {
            length: 23,
            structure: "F03F16",
            example: "AE993331234567890123456"
        },
        AL: {
            length: 28,
            structure: "F08A16",
            example: "AL47212110090000000235698741"
        },
        AT: {
            length: 20,
            structure: "F05F11",
            example: "AT611904300234573201"
        },
        AZ: {
            length: 28,
            structure: "U04A20",
            example: "AZ21NABZ00000000137010001944"
        },
        BA: {
            length: 20,
            structure: "F03F03F08F02",
            example: "BA391290079401028494"
        },
        BE: {
            length: 16,
            structure: "F03F07F02",
            example: "BE68 5390 0754 7034"
        },
        BG: {
            length: 22,
            structure: "U04F04F02A08",
            example: "BG80BNBG96611020345678"
        },
        BH: {
            length: 22,
            structure: "U04A14",
            example: "BH67BMAG00001299123456"
        },
        BR: {
            length: 29,
            structure: "F08F05F10U01A01",
            example: "BR9700360305000010009795493P1"
        },
        CH: {
            length: 21,
            structure: "F05A12",
            example: "CH9300762011623852957"
        },
        CR: {
            length: 22,
            structure: "F04F14",
            example: "CR72012300000171549015"
        },
        CY: {
            length: 28,
            structure: "F03F05A16",
            example: "CY17002001280000001200527600"
        },
        CZ: {
            length: 24,
            structure: "F04F06F10",
            example: "CZ6508000000192000145399"
        },
        DE: {
            length: 22,
            structure: "F08F10",
            example: "DE00123456789012345678"
        },
        DK: {
            length: 18,
            structure: "F04F09F01",
            example: "DK5000400440116243"
        },
        DO: {
            length: 28,
            structure: "U04F20",
            example: "DO28BAGR00000001212453611324"
        },
        EE: {
            length: 20,
            structure: "F02F02F11F01",
            example: "EE382200221020145685"
        },
        ES: {
            length: 24,
            structure: "F04F04F01F01F10",
            example: "ES9121000418450200051332"
        },
        FI: {
            length: 18,
            structure: "F06F07F01",
            example: "FI2112345600000785"
        },
        FO: {
            length: 18,
            structure: "F04F09F01",
            example: "FO6264600001631634"
        },
        FR: {
            length: 27,
            structure: "F05F05A11F02",
            example: "FR1420041010050500013M02606"
        },
        GB: {
            length: 22,
            structure: "U04F06F08",
            example: "GB29NWBK60161331926819"
        },
        GE: {
            length: 22,
            structure: "U02F16",
            example: "GE29NB0000000101904917"
        },
        GI: {
            length: 23,
            structure: "U04A15",
            example: "GI75NWBK000000007099453"
        },
        GL: {
            length: 18,
            structure: "F04F09F01",
            example: "GL8964710001000206"
        },
        GR: {
            length: 27,
            structure: "F03F04A16",
            example: "GR1601101250000000012300695"
        },
        GT: {
            length: 28,
            structure: "A04A20",
            example: "GT82TRAJ01020000001210029690"
        },
        HR: {
            length: 21,
            structure: "F07F10",
            example: "HR1210010051863000160"
        },
        HU: {
            length: 28,
            structure: "F03F04F01F15F01",
            example: "HU42117730161111101800000000"
        },
        IE: {
            length: 22,
            structure: "U04F06F08",
            example: "IE29AIBK93115212345678"
        },
        IL: {
            length: 23,
            structure: "F03F03F13",
            example: "IL620108000000099999999"
        },
        IS: {
            length: 26,
            structure: "F04F02F06F10",
            example: "IS140159260076545510730339"
        },
        IT: {
            length: 27,
            structure: "U01F05F05A12",
            example: "IT60X0542811101000000123456"
        },
        KW: {
            length: 30,
            structure: "U04A22",
            example: "KW81CBKU0000000000001234560101"
        },
        KZ: {
            length: 20,
            structure: "F03A13",
            example: "KZ86125KZT5004100100"
        },
        LB: {
            length: 28,
            structure: "F04A20",
            example: "LB62099900000001001901229114"
        },
        LC: {
            length: 32,
            structure: "U04F24",
            example: "LC07HEMM000100010012001200013015"
        },
        LI: {
            length: 21,
            structure: "F05A12",
            example: "LI21088100002324013AA"
        },
        LT: {
            length: 20,
            structure: "F05F11",
            example: "LT121000011101001000"
        },
        LU: {
            length: 20,
            structure: "F03A13",
            example: "LU280019400644750000"
        },
        LV: {
            length: 21,
            structure: "U04A13",
            example: "LV80BANK0000435195001"
        },
        MC: {
            length: 27,
            structure: "F05F05A11F02",
            example: "MC5811222000010123456789030"
        },
        MD: {
            length: 24,
            structure: "U02A18",
            example: "MD24AG000225100013104168"
        },
        ME: {
            length: 22,
            structure: "F03F13F02",
            example: "ME25505000012345678951"
        },
        MK: {
            length: 19,
            structure: "F03A10F02",
            example: "MK07250120000058984"
        },
        MR: {
            length: 27,
            structure: "F05F05F11F02",
            example: "MR1300020001010000123456753"
        },
        MT: {
            length: 31,
            structure: "U04F05A18",
            example: "MT84MALT011000012345MTLCAST001S"
        },
        MU: {
            length: 30,
            structure: "U04F02F02F12F03U03",
            example: "MU17BOMM0101101030300200000MUR"
        },
        NL: {
            length: 18,
            structure: "U04F10",
            example: "NL99BANK0123456789"
        },
        NO: {
            length: 15,
            structure: "F04F06F01",
            example: "NO9386011117947"
        },
        PK: {
            length: 24,
            structure: "U04A16",
            example: "PK36SCBL0000001123456702"
        },
        PL: {
            length: 28,
            structure: "F08F16",
            example: "PL00123456780912345678901234"
        },
        PS: {
            length: 29,
            structure: "U04A21",
            example: "PS92PALS000000000400123456702"
        },
        PT: {
            length: 25,
            structure: "F04F04F11F02",
            example: "PT50000201231234567890154"
        },
        RO: {
            length: 24,
            structure: "U04A16",
            example: "RO49AAAA1B31007593840000"
        },
        RS: {
            length: 22,
            structure: "F03F13F02",
            example: "RS35260005601001611379"
        },
        SA: {
            length: 24,
            structure: "F02A18",
            example: "SA0380000000608010167519"
        },
        SE: {
            length: 24,
            structure: "F03F16F01",
            example: "SE4550000000058398257466"
        },
        SI: {
            length: 19,
            structure: "F05F08F02",
            example: "SI56263300012039086"
        },
        SK: {
            length: 24,
            structure: "F04F06F10",
            example: "SK3112000000198742637541"
        },
        SM: {
            length: 27,
            structure: "U01F05F05A12",
            example: "SM86U0322509800000000270100"
        },
        ST: {
            length: 25,
            structure: "F08F11F02",
            example: "ST68000100010051845310112"
        },
        TL: {
            length: 23,
            structure: "F03F14F02",
            example: "TL380080012345678910157"
        },
        TN: {
            length: 24,
            structure: "F02F03F13F02",
            example: "TN5910006035183598478831"
        },
        TR: {
            length: 26,
            structure: "F05F01A16",
            example: "TR330006100519786457841326"
        },
        VG: {
            length: 24,
            structure: "U04F16",
            example: "VG96VPVG0000012345678901"
        },
        XK: {
            length: 20,
            structure: "F04F10F02",
            example: "XK051212012345678906"
        },
        AO: {
            length: 25,
            structure: "F21",
            example: "AO69123456789012345678901"
        },
        BF: {
            length: 27,
            structure: "F23",
            example: "BF2312345678901234567890123"
        },
        BI: {
            length: 16,
            structure: "F12",
            example: "BI41123456789012"
        },
        BJ: {
            length: 28,
            structure: "F24",
            example: "BJ39123456789012345678901234"
        },
        CI: {
            length: 28,
            structure: "U01F23",
            example: "CI17A12345678901234567890123"
        },
        CM: {
            length: 27,
            structure: "F23",
            example: "CM9012345678901234567890123"
        },
        CV: {
            length: 25,
            structure: "F21",
            example: "CV30123456789012345678901"
        },
        DZ: {
            length: 24,
            structure: "F20",
            example: "DZ8612345678901234567890"
        },
        IR: {
            length: 26,
            structure: "F22",
            example: "IR861234568790123456789012"
        },
        JO: {
            length: 30,
            structure: "A04F22",
            example: "JO15AAAA1234567890123456789012"
        },
        MG: {
            length: 27,
            structure: "F23",
            example: "MG1812345678901234567890123"
        },
        ML: {
            length: 28,
            structure: "U01F23",
            example: "ML15A12345678901234567890123"
        },
        MZ: {
            length: 25,
            structure: "F21",
            example: "MZ25123456789012345678901"
        },
        QA: {
            length: 29,
            structure: "U04A21",
            example: "QA30AAAA123456789012345678901"
        },
        SN: {
            length: 28,
            structure: "U01F23",
            example: "SN52A12345678901234567890123"
        },
        UA: {
            length: 29,
            structure: "F25",
            example: "UA511234567890123456789012345"
        }
    }, qz = function(e) {
        var t;
        return ID(t = e.replace(/\W/gi, "").replace(/(.{4})(?!$)/g, "$1 ")).call(t);
    }, Wz = function(e) {
        return e.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
    }, Gz = function(e, t) {
        return function(e, t) {
            var r;
            if (null === t || !Hz[t] || !Hz[t].structure) return !1;
            var a = Hz[t].structure, n = hC(r = a.match(/(.{3})/g)).call(r, function(e) {
                var t, r, a = oI(e).call(e, 0, 1), n = ZC(oI(e).call(e, 1), 10);
                switch(a){
                    case "A":
                        r = "0-9A-Za-z";
                        break;
                    case "B":
                        r = "0-9A-Z";
                        break;
                    case "C":
                        r = "A-Za-z";
                        break;
                    case "F":
                        r = "0-9";
                        break;
                    case "L":
                        r = "a-z";
                        break;
                    case "U":
                        r = "A-Z";
                        break;
                    case "W":
                        r = "0-9a-z";
                }
                return wb(t = "([".concat(r, "]{")).call(t, n, "})");
            });
            return new RegExp("^".concat(n.join(""), "$"));
        }(0, t);
    }, Yz = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
        return e && Hz[e] && Hz[e].example ? qz(Hz[e].example) : "AB00 1234 5678 9012 3456 7890";
    }, Qz = function(e) {
        return oI(e).call(e, 0, 2);
    };
    function Zz(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
        this.status = e, this.code = t;
    }
    var Jz = function(e) {
        var t = Wz(e), r = function(e) {
            var t, r = e, a = "A".charCodeAt(0), n = "Z".charCodeAt(0);
            return r = (r = r.toUpperCase()).substr(4) + r.substr(0, 4), hC(t = r.split("")).call(t, function(e) {
                var t = e.charCodeAt(0);
                return t >= a && t <= n ? t - a + 10 : e;
            }).join("");
        }(t), a = 1 === function(e) {
            for(var t, r = e; r.length > 2;)t = oI(r).call(r, 0, 9), r = ZC(t, 10) % 97 + oI(r).call(r, t.length);
            return ZC(r, 10) % 97;
        }(r);
        return a && function(e) {
            var t = oI(e).call(e, 0, 2), r = Gz(0, t);
            return r.test && r.test(oI(e).call(e, 4)) || !1;
        }(t);
    }, $z = function(e) {
        var t = Wz(e);
        if (e.length < 2) return new Zz("no-validate", "TOO_SHORT");
        var r = function(e) {
            return !(!e || !Hz[e]) && Hz[e];
        }(Qz(t));
        return r ? t.length > r.length ? new Zz("invalid", "TOO_LONG") : t.length === r.length ? Jz(e) ? new Zz("valid", "VALID") : new Zz("invalid", "INVALID_IBAN") : new Zz("no-validate", "UNKNOWN") : new Zz("invalid", "INVALID_COUNTRY");
    }, Xz = function(e) {
        return !WE(e) || null;
    };
    function eO(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function tO(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = eO(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = eO(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function rO(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var aO = {
        isValid: !1,
        errorMessage: "ach.accountHolderNameField.invalid",
        error: "ach.accountHolderNameField.invalid"
    }, nO = {
        isValid: !1,
        errorMessage: "sepaDirectDebit.ibanField.invalid",
        error: "sepaDirectDebit.ibanField.invalid"
    }, oO = function(e) {
        U_(r, e);
        var t = rO(r);
        function r(e) {
            var a, n, o, i;
            if (Cg(this, r), Ag(L_(i = t.call(this, e)), "ibanNumber", void 0), Ag(L_(i), "setData", function(e, t, r) {
                i.setState(function(r) {
                    return {
                        data: tO(tO({}, r.data), {}, Ag({}, e, t))
                    };
                }, r);
            }), Ag(L_(i), "setError", function(e, t, r) {
                i.setState(function(r) {
                    return {
                        errors: tO(tO({}, r.errors), {}, Ag({}, e, t))
                    };
                }, r);
            }), Ag(L_(i), "setValid", function(e, t, r) {
                i.setState(function(r) {
                    return {
                        valid: tO(tO({}, r.valid), {}, Ag({}, e, t))
                    };
                }, r);
            }), Ag(L_(i), "handleHolderInput", function(e) {
                i.setState(function(t) {
                    return {
                        data: tO(tO({}, t.data), {}, {
                            ownerName: e
                        })
                    };
                }, function() {
                    var e = Xz(i.state.data.ownerName), t = null == e || e ? null : aO;
                    i.setError("holder", t, i.onChange);
                });
            }), Ag(L_(i), "handleIbanInput", function(e) {
                var t = e.target.value, r = Wz(t), a = qz(r), n = $z(a).status, o = Qz(r), l = e.target.selectionStart, s = i.state.data.ibanNumber, c = function(e, t, r) {
                    if (0 === e || !t.length) return 0;
                    var a = t.length - r.length, n = a > 0, o = function(e, t) {
                        return /\s/.test(e.charAt(t));
                    }, i = e - a;
                    return n && (o(t, i + 1) || o(t, i)) ? e + 1 : !n && o(t, e - 1) ? e - 1 : e;
                }(l, a, s);
                i.setState(function(e) {
                    return {
                        data: tO(tO({}, e.data), {}, {
                            ibanNumber: a,
                            countryCode: o
                        }),
                        errors: tO(tO({}, e.errors), {}, {
                            iban: "invalid" === n ? nO : null
                        }),
                        valid: tO(tO({}, e.valid), {}, {
                            iban: "valid" === n
                        })
                    };
                }, function() {
                    e.target.setSelectionRange(c, c), i.onChange();
                });
            }), Ag(L_(i), "handleIbanBlur", function(e) {
                var t = e.target.value;
                if (t.length > 0) {
                    var r = $z(t).status;
                    i.setError("iban", "valid" !== r ? nO : null, i.onChange);
                } else i.setError("iban", null, i.onChange);
            }), i.state = {
                status: "ready",
                data: {
                    ownerName: (null == e || null === (a = e.data) || void 0 === a ? void 0 : a.ownerName) || "",
                    ibanNumber: (null == e || null === (n = e.data) || void 0 === n ? void 0 : n.ibanNumber) || "",
                    countryCode: (null == e || null === (o = e.data) || void 0 === o ? void 0 : o.countryCode) || ""
                },
                isValid: !1,
                cursor: 0,
                errors: {},
                valid: {}
            }, i.state.data.ibanNumber) {
                var l = Wz(i.state.data.ibanNumber);
                i.state.data.ibanNumber = qz(l);
            }
            if (i.state.data.ibanNumber || i.state.data.ownerName) {
                var s = i.props.holderName ? Xz(i.state.data.ownerName) : "", c = (i.state.data.ibanNumber ? "valid" === $z(i.state.data.ibanNumber).status : "") && s, u = {
                    data: i.state.data,
                    isValid: c
                };
                i.props.onChange(u);
            }
            return i;
        }
        return wg(r, [
            {
                key: "setStatus",
                value: function(e) {
                    this.setState({
                        status: e
                    });
                }
            },
            {
                key: "onChange",
                value: function() {
                    var e = !this.props.holderName || Xz(this.state.data.ownerName), t = "valid" === $z(this.state.data.ibanNumber).status && e, r = {
                        data: this.state.data,
                        isValid: t,
                        errors: this.state.errors
                    };
                    this.props.onChange(r);
                }
            },
            {
                key: "showValidation",
                value: function() {
                    var e = $z(this.state.data.ibanNumber).status, t = Xz(this.state.data.ownerName);
                    this.setError("iban", "valid" !== e ? nO : null);
                    var r = t ? null : aO;
                    this.setError("holder", r, this.onChange);
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r = this, a = e.placeholders, n = e.countryCode, o = t.data, i = t.errors, l = t.valid, s = sw().i18n;
                    return nN(SI, {
                        classNameModifiers: [
                            "iban-input"
                        ],
                        label: this.props.label
                    }, this.props.holderName && nN(FE, {
                        className: "adyen-checkout__field--owner-name",
                        label: s.get("sepa.ownerName"),
                        filled: o.ownerName && o.ownerName.length,
                        errorMessage: !!i.holder && s.get(i.holder.error),
                        dir: "ltr",
                        i18n: s,
                        name: "ownerName"
                    }, nN(FD, {
                        name: "ownerName",
                        className: "adyen-checkout__iban-input__owner-name",
                        placeholder: "ownerName" in a ? a.ownerName : s.get("sepaDirectDebit.nameField.placeholder"),
                        value: o.ownerName,
                        "aria-invalid": !!this.state.errors.holder,
                        "aria-label": s.get("sepa.ownerName"),
                        onInput: function(e) {
                            return r.handleHolderInput(e.target.value);
                        },
                        onBlur: function(e) {
                            return r.handleHolderInput(e.target.value);
                        }
                    })), nN(FE, {
                        className: "adyen-checkout__field--iban-number",
                        label: s.get("sepa.ibanNumber"),
                        errorMessage: !!i.iban && s.get(i.iban.error),
                        filled: o.ibanNumber && o.ibanNumber.length,
                        isValid: l.iban,
                        onBlur: this.handleIbanBlur,
                        dir: "ltr",
                        i18n: s,
                        name: "ibanNumber"
                    }, nN(FD, {
                        setRef: function(e) {
                            r.ibanNumber = e;
                        },
                        name: "ibanNumber",
                        className: "adyen-checkout__iban-input__iban-number",
                        classNameModifiers: [
                            "large"
                        ],
                        placeholder: "ibanNumber" in a ? a.ibanNumber : Yz(n),
                        value: o.ibanNumber,
                        onInput: this.handleIbanInput,
                        "aria-invalid": !!this.state.errors.iban,
                        "aria-label": s.get("sepa.ibanNumber"),
                        autocorrect: "off",
                        spellcheck: !1
                    })), this.props.showPayButton && this.props.payButton({
                        status: this.state.status
                    }));
                }
            }
        ]), r;
    }(lN);
    Ag(oO, "defaultProps", {
        onChange: function() {},
        countryCode: null,
        holderName: !0,
        placeholders: {},
        label: null
    });
    var iO = function() {
        return nN("p", {
            className: "adyen-checkout-form-instruction"
        }, sw().i18n.get("form.instruction"));
    }, lO = fD.entries;
    Sr({
        target: "Object",
        stat: !0
    }, {
        entries: function(e) {
            return lO(e);
        }
    });
    var sO = t(ee.Object.entries), cO = Ae, uO = TypeError, dO = le.match(/firefox\/(\d+)/i), pO = !!dO && +dO[1], mO = /MSIE|Trident/.test(le), fO = le.match(/AppleWebKit\/(\d+)\./), hO = !!fO && +fO[1], vO = Sr, yO = h, gO = De, bO = Ye, kO = ca, CO = function(e, t) {
        if (!delete e[t]) throw new uO("Cannot delete property " + cO(t) + " of " + cO(e));
    }, _O = vo, NO = n, PO = _F, wO = vv, AO = pO, SO = mO, IO = fe, EO = hO, DO = [], RO = yO(DO.sort), FO = yO(DO.push), xO = NO(function() {
        DO.sort(void 0);
    }), TO = NO(function() {
        DO.sort(null);
    }), zO = wO("sort"), OO = !NO(function() {
        if (IO) return IO < 70;
        if (!(AO && AO > 3)) {
            if (SO) return !0;
            if (EO) return EO < 603;
            var e, t, r, a, n = "";
            for(e = 65; e < 76; e++){
                switch(t = String.fromCharCode(e), e){
                    case 66:
                    case 69:
                    case 70:
                    case 72:
                        r = 3;
                        break;
                    case 68:
                    case 71:
                        r = 4;
                        break;
                    default:
                        r = 2;
                }
                for(a = 0; a < 47; a++)DO.push({
                    k: t + a,
                    v: r
                });
            }
            for(DO.sort(function(e, t) {
                return t.v - e.v;
            }), a = 0; a < DO.length; a++)t = DO[a].k.charAt(0), n.charAt(n.length - 1) !== t && (n += t);
            return "DGBEFHACIJK" !== n;
        }
    });
    vO({
        target: "Array",
        proto: !0,
        forced: xO || !TO || !zO || !OO
    }, {
        sort: function(e) {
            void 0 !== e && gO(e);
            var t = bO(this);
            if (OO) return void 0 === e ? RO(t) : RO(t, e);
            var r, a, n = [], o = kO(t);
            for(a = 0; a < o; a++)a in t && FO(n, t[a]);
            for(PO(n, function(e) {
                return function(t, r) {
                    return void 0 === r ? -1 : void 0 === t ? 1 : void 0 !== e ? +e(t, r) || 0 : _O(t) > _O(r) ? 1 : -1;
                };
            }(e)), r = kO(n), a = 0; a < r;)t[a] = n[a++];
            for(; a < o;)CO(t, a++);
            return t;
        }
    });
    var jO = Cv("Array", "sort"), BO = ie, MO = jO, LO = Array.prototype, VO = t(function(e) {
        var t = e.sort;
        return e === LO || BO(LO, e) && t === LO.sort ? MO : t;
    });
    function UO(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    var KO = function(e) {
        var t, r = bE[e];
        return r || (r = zb(t = Ty(bE)).call(t, function(t) {
            return bE[t] === e;
        })) || e;
    }, HO = function(e, t) {
        var r = function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Sg(r = UO(Object(n), !0)).call(r, function(t) {
                    Ag(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Sg(a = UO(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({}, e);
        return r.error = r.error ? r.error : function(e) {
            var t = Ty(bE);
            return tC(t).call(t, function(t, r) {
                var a = bE[r];
                return (Kk(a).call(a, "sf-") > -1 || Kk(a).call(a, "gen.01") > -1) && (t[a] = e.get(a)), t;
            }, {});
        }(t), r;
    }, qO = function(e, t) {
        for(var r, a = e, n = 0, o = sO(t); n < o.length; n++){
            var i = Vk(o[n], 2), l = i[0];
            if (i[1] === e) {
                a = l;
                break;
            }
        }
        return null === (r = a) || void 0 === r ? void 0 : r.toLowerCase().replace(/[_.\s]/g, "-");
    }, WO = function(e, t) {
        var r = e.i18n, a = e.fieldTypeMappingFn, n = e.SRPanelRef, o = t.errors, i = t.isValidating, l = t.layout, s = function(e) {
            var t, r = e.errors, a = e.i18n, n = e.layout, o = e.countrySpecificLabels, i = e.fieldTypeMappingFn, l = tC(t = sO(r)).call(t, function(e, t) {
                var l = Vk(t, 2), s = l[0];
                if (l[1]) {
                    var c, u, d, p, m = r[s];
                    c = m instanceof XE ? "object" === ig(m.errorMessage) ? m.errorMessage.translationKey : m.errorMessage : m.error;
                    var f = u = m instanceof XE || !("errorI18n" in m) ? "object" === ig(m.errorMessage) ? wb(d = wb(p = "".concat(a.get(m.errorMessage.translationKey), " ")).call(p, cC(m.errorMessage.translationObject).format)).call(d, "") : a.get(m.errorMessage) + "" : m.errorI18n + "";
                    if (i) {
                        var h, v = i(s, a, o);
                        v && (f = wb(h = "".concat(v, ": ")).call(h, u));
                    }
                    e.push({
                        field: s,
                        errorMessage: f,
                        errorCode: c
                    }), n && VO(e).call(e, function(e, t) {
                        return Kk(n).call(n, e.field) - Kk(n).call(n, t.field);
                    });
                }
                return e;
            }, []);
            return l;
        }({
            errors: o,
            i18n: r,
            fieldTypeMappingFn: a,
            countrySpecificLabels: t.countrySpecificLabels,
            layout: l
        });
        if (s.length) {
            if (i) {
                var c = hC(s).call(s, function(e) {
                    return e.errorMessage;
                });
                n.setMessages(c);
                var u = hC(s).call(s, function(e) {
                    return e.field;
                });
                return {
                    currentErrorsSortedByLayout: s,
                    action: _E,
                    fieldToFocus: u[0]
                };
            }
            return null == n || n.setMessages(null), {
                currentErrorsSortedByLayout: s,
                action: NE
            };
        }
        return null == n || n.setMessages(null), {
            currentErrorsSortedByLayout: s,
            action: "none"
        };
    }, GO = function(e, t) {
        var r;
        return e ? tC(r = sO(e)).call(r, function(e, r) {
            var a, n = Vk(r, 2), o = n[0], i = n[1];
            i && (e[wb(a = "".concat(t)).call(a, o)] = i);
            return e;
        }, {}) : null;
    }, YO = IN({
        srPanel: null,
        setSRMessagesFromObjects: null,
        setSRMessagesFromStrings: null,
        clearSRPanel: null,
        shouldMoveFocusSR: null
    });
    function QO() {
        return YP(YO);
    }
    var ZO = function(e, t) {
        var r = [];
        return e && "function" == typeof e.querySelectorAll && (r = oI([]).call(e.querySelectorAll(t))), r;
    }, JO = function(e, t) {
        if (e) return e.querySelector(t);
    }, $O = function(e, t) {
        if (e) return e.getAttribute(t);
    }, XO = function(e, t, r, a) {
        if ("function" != typeof e.addEventListener) {
            if (!e.attachEvent) throw new Error(": Unable to bind ".concat(t, "-event"));
            e.attachEvent("on".concat(t), r);
        } else e.addEventListener(t, r, a);
    }, ej = function(e, t, r, a) {
        if ("function" == typeof e.addEventListener) e.removeEventListener(t, r, a);
        else {
            if (!e.attachEvent) throw new Error(": Unable to unbind ".concat(t, "-event"));
            e.detachEvent("on".concat(t), r);
        }
    }, tj = function(e, t) {
        var r = JO(document, e), a = "issuer" === t ? "issuer-list" : t;
        if ("country" === a || "stateOrProvince" === a || "issuer-list" === a) {
            var n = JO(r, ".adyen-checkout__field--".concat(a, " .adyen-checkout__filter-input"));
            null == n || n.focus();
        } else {
            var o = JO(r, '[name="'.concat(a, '"]'));
            null == o || o.focus();
        }
    };
    function rj(e) {
        var t = qP();
        return KP(function() {
            t.current = e;
        }, [
            e
        ]), t.current;
    }
    function aj(e, t, r) {
        var a, n = r || "id";
        return 1 !== e.length || t || (a = e), e.length > (null == t ? void 0 : t.length) && (a = xg(e).call(e, function(e) {
            var r = e[n];
            return !JT(t).call(t, function(e) {
                return e[n] === r;
            });
        })), a;
    }
    var nj = [
        "companyDetails",
        "personalDetails",
        "bankAccount",
        "billingAddress",
        "deliveryAddress"
    ];
    function oj(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function ij(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = oj(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = oj(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function lj(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function sj(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = lj(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = lj(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var cj = {
        isValid: !1,
        errorMessage: "consent.checkbox.invalid",
        error: "consent.checkbox.invalid"
    };
    function uj(e) {
        var t, r, a, n, o, i, l = e.countryCode, s = e.visibility, c = sw().i18n, u = qP({});
        Ty(u.current).length || null === (i = e.setComponentRef) || void 0 === i || i.call(e, u.current);
        var d = qP(!1), p = Vk(VP(Uz(s, e.data)), 2), m = p[0], f = p[1], h = qP(tC(Vz).call(Vz, function(e, t) {
            return e[t] = function(e) {
                h[t].current = e;
            }, e;
        }, {})).current, v = !!e.consentCheckboxLabel, y = !v && AI(t = Ty(m)).call(t, function(e) {
            return !m[e];
        }), g = "editable" === s.deliveryAddress && "hidden" !== s.billingAddress, b = Vk(VP(sj(sj({}, e.data), v && {
            consentCheckbox: !1
        })), 2), k = b[0], C = b[1], _ = Vk(VP({}), 2), N = _[0], P = _[1], w = Vk(VP({}), 2), A = w[0], S = w[1], I = Vk(VP("ready"), 2), E = I[0], D = I[1];
        u.current.showValidation = function() {
            d.current = !0, Sg(Vz).call(Vz, function(e) {
                h[e].current && h[e].current.showValidation();
            }), P(sj({}, v && {
                consentCheckbox: k.consentCheckbox ? null : cj
            }));
        }, u.current.setStatus = D, function(e) {
            var t = e.errors, r = e.data, a = e.props, n = e.isValidating, o = Vk(VP(null), 2), i = o[0], l = o[1], s = rj(i), c = QO(), u = c.setSRMessagesFromObjects, d = c.setSRMessagesFromStrings, p = c.clearSRPanel, m = c.shouldMoveFocusSR, f = null == u ? void 0 : u({
                fieldTypeMappingFn: Kz
            }), h = WP(function() {
                return new Dz;
            }, []), v = WP(function() {
                return new Dz(a.deliveryAddressSpecification);
            }, []);
            KP(function() {
                try {
                    var e, o, i, c, u, y = "deliveryAddress:", g = "billingAddress:", b = t.companyDetails, k = t.personalDetails, C = t.bankAccount, _ = t.billingAddress, N = t.deliveryAddress, P = kg(t, nj), w = GO(_, g), A = GO(N, y), S = ij(ij(ij(ij(ij(ij({}, "object" === ig(b) && b), "object" === ig(k) && k), "object" === ig(C) && C), "object" === ig(w) && w), "object" === ig(A) && A), P), I = zD, E = null !== (e = a.personalDetailsRequiredFields) && void 0 !== e ? e : hR, D = xg(hR).call(hR, function(e) {
                        return null == E ? void 0 : kb(E).call(E, e);
                    }), R = h.getAddressSchemaForCountryFlat(null === (o = r.billingAddress) || void 0 === o ? void 0 : o.country), F = hC(R).call(R, function(e) {
                        var t;
                        return wb(t = "".concat(g)).call(t, e);
                    }), x = v.getAddressSchemaForCountryFlat(null === (i = r.deliveryAddress) || void 0 === i ? void 0 : i.country), T = hC(x).call(x, function(e) {
                        var t;
                        return wb(t = "".concat(y)).call(t, e);
                    }), z = wb(I).call(I, D, [
                        "holder",
                        "iban"
                    ], F, T, [
                        "consentCheckbox"
                    ]), O = h.getAddressLabelsForCountry(null === (c = r.billingAddress) || void 0 === c ? void 0 : c.country), j = v.getAddressLabelsForCountry(null === (u = r.deliveryAddress) || void 0 === u ? void 0 : u.country), B = null == f ? void 0 : f({
                        errors: S,
                        isValidating: n.current,
                        layout: z,
                        countrySpecificLabels: ij(ij({}, O), j)
                    }), M = null == B ? void 0 : B.currentErrorsSortedByLayout;
                    switch(l(M), null == B ? void 0 : B.action){
                        case _E:
                            m && tj(".adyen-checkout__open-invoice", B.fieldToFocus), NP(function() {
                                n.current = !1;
                            }, 300);
                            break;
                        case NE:
                            var L = aj(M, s, "field"), V = null == L ? void 0 : L[0];
                            if (V) {
                                var U = "shopperEmail.invalid" === V.errorCode ? V.errorMessage : null;
                                d(U);
                            } else p();
                    }
                } catch (e) {}
            }, [
                t,
                r
            ]);
        }({
            errors: N,
            data: k,
            props: e,
            isValidating: d
        }), KP(function() {
            var t = function() {
                var e;
                return AI(e = Ty(m)).call(e, function(e) {
                    return !m[e] || !!A[e];
                });
            }(), r = !v || !!A.consentCheckbox, a = t && r, n = function(e, t) {
                var r, a;
                return tC(r = xg(a = Ty(t)).call(a, function(t) {
                    return e[t];
                })).call(r, function(e, r) {
                    return e[r] = t[r], e;
                }, {});
            }(m, k);
            e.onChange({
                data: n,
                errors: N,
                valid: A,
                isValid: a
            });
        }, [
            k,
            m
        ]);
        var R = function(e) {
            return function(t) {
                C(function(r) {
                    return sj(sj({}, r), {}, Ag({}, e, t.data));
                }), S(function(r) {
                    return sj(sj({}, r), {}, Ag({}, e, t.isValid));
                }), P(function(r) {
                    return sj(sj({}, r), {}, Ag({}, e, t.errors));
                });
            };
        };
        return nN("div", {
            className: "adyen-checkout__open-invoice"
        }, e.showFormInstruction && nN(iO, null), m.companyDetails && nN(OD, {
            data: e.data.companyDetails,
            label: "companyDetails",
            onChange: R("companyDetails"),
            setComponentRef: h.companyDetails,
            visibility: s.companyDetails
        }), m.personalDetails && nN(vR, {
            data: e.data.personalDetails,
            requiredFields: e.personalDetailsRequiredFields,
            label: "personalDetails",
            onChange: R("personalDetails"),
            setComponentRef: h.personalDetails,
            visibility: s.personalDetails
        }), m.bankAccount && nN(oO, {
            holderName: !0,
            label: "bankAccount",
            data: k.bankAccount,
            onChange: R("bankAccount"),
            ref: h.bankAccount
        }), m.billingAddress && nN(zz, {
            allowedCountries: null !== (r = null == e || null === (a = e.billingAddressSpecification) || void 0 === a ? void 0 : a.allowedCountries) && void 0 !== r ? r : e.allowedCountries,
            countryCode: l,
            requiredFields: e.billingAddressRequiredFields,
            specifications: e.billingAddressSpecification,
            data: k.billingAddress,
            label: "billingAddress",
            onChange: R("billingAddress"),
            setComponentRef: h.billingAddress,
            visibility: s.billingAddress
        }), g && nN(FE, {
            name: "separateDeliveryAddress",
            useLabelElement: !1,
            addContextualElement: !1
        }, nN(Bz, {
            label: c.get("separateDeliveryAddress"),
            checked: m.deliveryAddress,
            classNameModifiers: [
                "separateDeliveryAddress"
            ],
            name: "separateDeliveryAddress",
            onChange: function() {
                f(function(e) {
                    return sj(sj({}, e), {}, {
                        deliveryAddress: !m.deliveryAddress
                    });
                });
            }
        })), m.deliveryAddress && nN(zz, {
            allowedCountries: null !== (n = null == e || null === (o = e.deliveryAddressSpecification) || void 0 === o ? void 0 : o.allowedCountries) && void 0 !== n ? n : e.allowedCountries,
            countryCode: l,
            requiredFields: e.deliveryAddressRequiredFields,
            specifications: e.deliveryAddressSpecification,
            data: k.deliveryAddress,
            label: "deliveryAddress",
            onChange: R("deliveryAddress"),
            setComponentRef: h.deliveryAddress,
            visibility: s.deliveryAddress
        }), v && nN(Lz, {
            data: k,
            errorMessage: !!N.consentCheckbox,
            label: e.consentCheckboxLabel,
            onChange: function(e) {
                var t = e.target.checked;
                C(function(e) {
                    return sj(sj({}, e), {}, {
                        consentCheckbox: t
                    });
                }), S(function(e) {
                    return sj(sj({}, e), {}, {
                        consentCheckbox: t
                    });
                }), P(function(e) {
                    return sj(sj({}, e), {
                        consentCheckbox: t ? null : cj
                    });
                });
            },
            i18n: c
        }), e.showPayButton && e.payButton({
            status: E,
            classNameModifiers: Uk(y ? [
                "standalone"
            ] : []),
            label: c.get("confirmPurchase")
        }));
    }
    function dj(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var pj = function(e) {
        U_(r, e);
        var t = dj(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "state", {
                loaded: !1
            }), a;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.i18n ? this.props.i18n.loaded.then(function() {
                        e.setState({
                            loaded: !0
                        });
                    }) : this.setState({
                        loaded: !0
                    }), this.props.i18n && this.props.loadingContext && this.props.resources || console.error("CoreProvider - WARNING core provider is missing one of the following: i18n, loadingContext or resources");
                }
            },
            {
                key: "render",
                value: function(e) {
                    var t = e.children;
                    return this.state.loaded ? nN(lw.Provider, {
                        value: {
                            i18n: this.props.i18n,
                            loadingContext: this.props.loadingContext,
                            commonProps: this.props.commonProps || {},
                            resources: this.props.resources
                        }
                    }, fN(t)) : null;
                }
            }
        ]), r;
    }(lN);
    Sr({
        target: "Number",
        stat: !0
    }, {
        isNaN: function(e) {
            return e != e;
        }
    });
    var mj = t(ee.Number.isNaN), fj = Object.prototype.toString;
    function hj(e) {
        return "object" === ig(e) && null !== e && "[object Array]" === Object.prototype.toString.call(e);
    }
    function vj(e) {
        return null != e;
    }
    function yj(e) {
        return !1 !== e && vj(e);
    }
    function gj(e) {
        return !!e && "object" === ig(e);
    }
    function bj(e, t) {
        var r, a = ig(e), n = ig(t);
        return e && t && "object" === a && a === n ? Ty(e).length === Ty(t).length && AI(r = Ty(e)).call(r, function(r) {
            return bj(e[r], t[r]);
        }) : e === t;
    }
    function kj(e) {
        var t;
        return !yj(e) || !(!("number" == typeof (t = e) || gj(t) && "[object Number]" === fj.call(t)) || 0 !== e && !mj(e)) || !(!hj(e) && !function(e) {
            return "string" == typeof e || gj(e) && "[object String]" === fj.call(e);
        }(e) || 0 !== e.length) || !(!gj(e) || 0 !== Ty(e).length);
    }
    function Cj() {
        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
        var a = t, n = a.shift();
        return function() {
            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
            return n.apply(this, wb(a).call(a, t));
        };
    }
    var _j = function(e) {
        var t = e.srPanel, r = e.children, a = sw().i18n, n = t.moveFocus;
        return nN(YO.Provider, {
            value: {
                srPanel: t,
                setSRMessagesFromObjects: function(e) {
                    var r = e.fieldTypeMappingFn;
                    return Cj(WO, {
                        SRPanelRef: t,
                        i18n: a,
                        fieldTypeMappingFn: r
                    });
                },
                setSRMessagesFromStrings: function(e) {
                    t.setMessages(e);
                },
                clearSRPanel: function() {
                    t.setMessages(null);
                },
                shouldMoveFocusSR: n
            }
        }, r);
    };
    function Nj(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Pj(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = Nj(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = Nj(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function wj(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var Aj = function(e) {
        U_(r, e);
        var t = wj(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    var t, a = e.countryCode || (null === (t = e.data) || void 0 === t || null === (t = t.billingAddress) || void 0 === t ? void 0 : t.countryCode);
                    return Pj(Pj({}, e), {}, {
                        allowedCountries: [
                            a
                        ],
                        visibility: Pj(Pj({}, r.defaultProps.visibility), e.visibility),
                        data: Pj(Pj({}, e.data), {}, {
                            billingAddress: Pj(Pj({}, e.data.billingAddress), {}, {
                                country: a
                            }),
                            deliveryAddress: Pj(Pj({}, e.data.deliveryAddress), {}, {
                                country: a
                            })
                        })
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.state.data, t = void 0 === e ? {} : e, r = t.companyDetails, a = void 0 === r ? {} : r, n = t.personalDetails, o = void 0 === n ? {} : n, i = t.billingAddress, l = t.deliveryAddress, s = t.bankAccount;
                    return Pj(Pj(Pj(Pj(Pj({
                        paymentMethod: {
                            type: this.constructor.type
                        }
                    }, o), a), s && {
                        bankAccount: {
                            iban: s.ibanNumber,
                            ownerName: s.ownerName,
                            countryCode: s.countryCode
                        }
                    }), i && {
                        billingAddress: i
                    }), (l || i) && {
                        deliveryAddress: l || i
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(_j, {
                        srPanel: this.props.modules.srPanel
                    }, nN(uj, M_({
                        setComponentRef: this.setComponentRef
                    }, this.props, this.state, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    }))));
                }
            }
        ]), r;
    }(qS);
    function Sj(e) {
        var t = sw().i18n, r = t.get("paymentConditions"), a = Vk(t.get("afterPay.agreement").split("%@"), 2), n = a[0], o = a[1];
        return n && o ? nN(iN, null, n, nN("a", {
            className: "adyen-checkout__link",
            target: "_blank",
            rel: "noopener noreferrer",
            href: e.url
        }, r), o) : nN("span", {
            className: "adyen-checkout__checkbox__label"
        }, t.get("privacyPolicy"));
    }
    Ag(Aj, "defaultProps", {
        onChange: function() {},
        data: {
            companyDetails: {},
            personalDetails: {},
            billingAddress: {},
            deliveryAddress: {},
            bankAccount: {}
        },
        visibility: {
            companyDetails: "hidden",
            personalDetails: "editable",
            billingAddress: "editable",
            deliveryAddress: "editable",
            bankAccount: "hidden"
        },
        showFormInstruction: !0
    });
    var Ij = [
        "BE",
        "NL"
    ], Ej = {
        be: {
            en: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/be_en",
            fr: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/be_fr",
            nl: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/be_nl"
        },
        nl: {
            en: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/nl_en",
            nl: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/nl_nl"
        }
    };
    function Dj(e, t, r) {
        var a, n, o, i = null == t ? void 0 : oI(a = t.toLowerCase()).call(a, 0, 2), l = null === (n = r[null == e ? void 0 : e.toLowerCase()]) || void 0 === n ? void 0 : n[i];
        if (l) return l;
        console.warn(wb(o = "Cannot find a consent url for the provided countryCode: ".concat(e, " and locale: ")).call(o, t));
    }
    function Rj(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Fj(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = Rj(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = Rj(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function xj(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var Tj = function(e) {
        U_(r, e);
        var t = xj(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t;
                    return Fj(Fj({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : Ij,
                        consentCheckboxLabel: nN(Sj, {
                            url: Dj(e.countryCode, null === (t = e.i18n) || void 0 === t ? void 0 : t.locale, Ej)
                        })
                    });
                }
            }
        ]), r;
    }(Aj);
    function zj(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Oj(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = zj(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = zj(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function jj(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(Tj, "type", "afterpay_default");
    var Bj = function(e) {
        U_(r, e);
        var t = jj(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return Oj(Oj({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : Ij
                    });
                }
            }
        ]), r;
    }(Aj);
    function Mj() {
        var e = DN(window, "screen.colorDepth") || "", t = !!DN(window, "navigator.javaEnabled") && window.navigator.javaEnabled(), r = DN(window, "screen.height") || "", a = DN(window, "screen.width") || "", n = DN(window, "navigator.userAgent") || "";
        return {
            acceptHeader: "*/*",
            colorDepth: e,
            language: DN(window, "navigator.language") || DN(window, "navigator.browserLanguage") || "en",
            javaEnabled: t,
            screenHeight: r,
            screenWidth: a,
            userAgent: n,
            timeZoneOffset: (new Date).getTimezoneOffset()
        };
    }
    Ag(Bj, "type", "afterpay_b2b"), Ag(Bj, "defaultProps", {
        onChange: function() {},
        data: {
            companyDetails: {},
            personalDetails: {},
            billingAddress: {},
            deliveryAddress: {}
        },
        visibility: {
            companyDetails: "editable",
            personalDetails: "editable",
            billingAddress: "editable",
            deliveryAddress: "editable"
        },
        showFormInstruction: !0
    });
    var Lj = "v1/AmazonPayUtility/signString", Vj = "v1/AmazonPayUtility/updateCheckoutSession", Uj = "https://static-eu.payments-amazon.com/checkout.js", Kj = "https://static-na.payments-amazon.com/checkout.js", Hj = "en_GB", qj = "en_US", Wj = {
        EU: "EUR",
        UK: "GBP",
        US: "USD"
    }, Gj = [
        "en_GB",
        "de_DE",
        "fr_FR",
        "it_IT",
        "es_ES"
    ], Yj = [
        "en_US"
    ];
    function Qj(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Zj(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = Qj(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = Qj(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function Jj(e, t) {
        var r = function(e) {
            return "US" === e ? Yj : Gj;
        }(t), a = kb(r).call(r, e) ? e : function(e) {
            return "US" === e ? qj : Hj;
        }(t);
        return a;
    }
    function $j(e) {
        return "noTagline" === e ? "C0001" : null;
    }
    function Xj(e) {
        var t = e.addressDetails, r = e.cancelUrl, a = e.checkoutMode, n = e.deliverySpecifications, o = e.returnUrl, i = e.merchantMetadata, l = e.chargePermissionType, s = e.recurringMetadata, c = e.configuration.storeId, u = "ProcessOrder" === a, d = u ? function(e) {
            return {
                amount: String(t_(e.value, e.currency)),
                currencyCode: e.currency
            };
        }(e.amount) : null;
        return Zj(Zj(Zj(Zj(Zj({
            storeId: c,
            chargePermissionType: l,
            webCheckoutDetails: Zj(Zj(Zj({}, u ? {
                checkoutResultReturnUrl: o
            } : {
                checkoutReviewReturnUrl: o
            }), r && {
                checkoutCancelUrl: r
            }), u && {
                checkoutMode: a
            })
        }, u && {
            paymentDetails: {
                chargeAmount: d,
                paymentIntent: "Confirm",
                presentmentCurrency: d.currencyCode,
                totalOrderAmount: d
            }
        }), s && {
            recurringMetadata: s
        }), i && {
            merchantMetadata: i
        }), n && {
            deliverySpecifications: n
        }), t && {
            addressDetails: t
        });
    }
    function eB(e, t, r) {
        var a;
        return zT({
            loadingContext: e,
            path: wb(a = "".concat("v1/AmazonPayUtility/getCheckoutDetails", "?clientKey=")).call(a, t)
        }, r);
    }
    function tB(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function rB(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = tB(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = tB(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function aB(e) {
        var t = this, r = sw().loadingContext, a = e.amazonRef, n = e.configuration, o = void 0 === n ? {} : n, i = Vk(VP(null), 2), l = i[0], s = i[1], c = Xj(e), u = function(e) {
            var t;
            return Zj(Zj(Zj({}, e.buttonColor && {
                buttonColor: e.buttonColor
            }), e.design && {
                design: $j(e.design)
            }), {}, {
                checkoutLanguage: Jj(e.locale, e.configuration.region),
                ledgerCurrency: Wj[e.configuration.region] || e.currency || (null === (t = e.amount) || void 0 === t ? void 0 : t.currency),
                merchantId: e.configuration.merchantId,
                productType: e.productType,
                placement: e.placement,
                sandbox: "TEST" === e.environment
            });
        }(e), d = function() {
            new Ab(e.onClick).then(t.initCheckout).catch(function(r) {
                e.onError && e.onError(r, t.componentRef);
            });
        };
        return this.initCheckout = function() {
            var e = {
                payloadJSON: Mb(c),
                publicKeyId: o.publicKeyId,
                signature: l
            };
            a.Pay.initCheckout(rB(rB({}, u), {}, {
                createCheckoutSessionConfig: e
            }));
        }, KP(function() {
            var n = e.clientKey;
            (function(e, t, r) {
                var a;
                return zT({
                    loadingContext: e,
                    path: wb(a = "".concat(Lj, "?clientKey=")).call(a, t)
                }, {
                    stringToSign: Mb(r)
                });
            })(r, n, c).then(function(t) {
                if (null == t || !t.signature) return console.error("Could not get AmazonPay signature");
                s(t.signature), e.showPayButton && a.Pay.renderButton("#amazonPayButton", u).onClick(d);
            }).catch(function(r) {
                console.error(r), e.onError && e.onError(r, t.componentRef);
            });
        }, []), e.showPayButton ? nN("div", {
            className: "adyen-checkout__amazonpay__button",
            id: "amazonPayButton"
        }) : null;
    }
    function nB(e) {
        var t = sw().i18n, r = e.amazonRef, a = e.amazonCheckoutSessionId;
        return KP(function() {
            var e = {
                amazonCheckoutSessionId: a,
                changeAction: "changeAddress"
            };
            r.Pay.bindChangeAction(".adyen-checkout__amazonpay__button--changeAddress", e);
        }, []), nN("button", {
            type: "button",
            className: "adyen-checkout__button adyen-checkout__button--ghost adyen-checkout__amazonpay__button--changeAddress"
        }, t.get("amazonpay.changePaymentDetails"));
    }
    function oB(e) {
        var t = this, r = sw(), a = r.i18n, n = r.loadingContext;
        return this.createOrder = function() {
            var r = e.amazonCheckoutSessionId, a = e.amount, o = e.clientKey, i = e.chargePermissionType, l = e.publicKeyId, s = e.region, c = e.recurringMetadata, u = e.returnUrl;
            (function(e, t, r) {
                var a;
                return zT({
                    loadingContext: e,
                    path: wb(a = "".concat(Vj, "?clientKey=")).call(a, t)
                }, r);
            })(n, o, {
                amount: a,
                chargePermissionType: i,
                checkoutResultReturnUrl: u,
                checkoutSessionId: r,
                publicKeyId: l,
                recurringMetadata: c,
                region: s
            }).then(function(e) {
                var t;
                if (null == e || null === (t = e.action) || void 0 === t || !t.type) return console.error(e.errorMessage || "Could not get the AmazonPay URL");
                "redirect" === e.action.type && window.location.assign(e.action.url);
            }).catch(function(r) {
                e.onError && e.onError(r, t.componentRef);
            });
        }, nN(uw, {
            classNameModifiers: [
                "standalone",
                "pay"
            ],
            label: a.get("confirmPurchase"),
            onClick: this.createOrder
        });
    }
    function iB(e) {
        return nN("button", {
            type: "button",
            className: "adyen-checkout__button  adyen-checkout__button--ghost adyen-checkout__amazonpay__button--signOut",
            onClick: function() {
                new Ab(e.onSignOut).then(function() {
                    e.amazonRef.Pay.signout();
                }).catch(console.error);
            }
        }, sw().i18n.get("amazonpay.signout"));
    }
    var lB = t(O_), sB = wg(function e(t) {
        var r = this, a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "body", n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        Cg(this, e), Ag(this, "src", void 0), Ag(this, "node", void 0), Ag(this, "attributes", void 0), Ag(this, "dataAttributes", void 0), Ag(this, "isScriptLoadCalled", !1), Ag(this, "script", void 0), Ag(this, "load", function() {
            if (!r.isScriptLoadCalled) return new Ab(function(e, t) {
                var a = function() {
                    r.script.setAttribute("data-script-loaded", "true"), e();
                }, n = function() {
                    r.remove(), t(new Error("Unable to load script ".concat(r.src)));
                };
                r.isScriptLoadCalled = !0;
                var o = document.querySelector(r.node);
                if (r.script = o.querySelector('script[src="'.concat(r.src, '"]')), r.script && r.script.getAttribute("data-script-loaded")) e();
                else {
                    if (r.script) return r.script.addEventListener("load", a), void r.script.addEventListener("error", n);
                    r.script = document.createElement("script"), lB(r.script, r.attributes), lB(r.script.dataset, r.dataAttributes), r.script.src = r.src, r.script.async = !0, r.script.addEventListener("load", a), r.script.addEventListener("error", n), o.appendChild(r.script);
                }
            });
        }), Ag(this, "remove", function() {
            return r.script.parentNode && r.script.parentNode.removeChild(r.script);
        }), this.src = t, this.node = a, this.attributes = n, this.dataAttributes = o;
    });
    function cB(e) {
        var t, r, a = Vk(VP("pending"), 2), n = a[0], o = a[1], i = qP(null), l = qP(null), s = function() {
            o("ready");
        };
        return this.submit = function() {
            return i.current && i.current.initCheckout ? i.current.initCheckout() : l.current && l.current.createOrder ? l.current.createOrder() : void 0;
        }, KP(function() {
            var t = "US" === e.configuration.region ? Kj : Uj, r = new sB(t);
            return window.amazon ? s() : r.load().then(s), function() {
                r.remove();
            };
        }, []), "pending" === n ? nN("div", {
            className: "adyen-checkout__amazonpay"
        }, nN("div", {
            className: "adyen-checkout__amazonpay__status adyen-checkout__amazonpay__status--pending"
        }, nN(RP, null))) : e.showSignOutButton ? nN("div", {
            className: "adyen-checkout__amazonpay"
        }, nN(iB, {
            amazonRef: window.amazon,
            onSignOut: e.onSignOut
        })) : e.amazonCheckoutSessionId ? nN("div", {
            className: "adyen-checkout__amazonpay"
        }, e.showOrderButton && nN(oB, {
            amazonCheckoutSessionId: e.amazonCheckoutSessionId,
            amount: e.amount,
            chargePermissionType: e.chargePermissionType,
            recurringMetadata: e.recurringMetadata,
            clientKey: e.clientKey,
            onError: e.onError,
            publicKeyId: null === (t = e.configuration) || void 0 === t ? void 0 : t.publicKeyId,
            region: null === (r = e.configuration) || void 0 === r ? void 0 : r.region,
            returnUrl: e.returnUrl,
            ref: l
        }), e.showChangePaymentDetailsButton && nN(nB, {
            amazonCheckoutSessionId: e.amazonCheckoutSessionId,
            amazonRef: window.amazon
        })) : nN("div", {
            className: "adyen-checkout__amazonpay"
        }, nN(aB, M_({}, e, {
            amazonRef: window.amazon,
            ref: i
        })));
    }
    var uB = {
        cancelUrl: "undefined" != typeof window ? window.location.href : "",
        configuration: {},
        environment: "TEST",
        locale: "en_GB",
        placement: "Cart",
        productType: "PayAndShip",
        returnUrl: "undefined" != typeof window ? window.location.href : "",
        showOrderButton: !0,
        showChangePaymentDetailsButton: !1,
        showSignOutButton: !1,
        showPayButton: !0,
        onClick: function(e) {
            return e();
        },
        onSignOut: function(e) {
            return e();
        },
        isExpress: !1
    };
    function dB(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function pB(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = dB(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = dB(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function mB(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var fB = function(e) {
        U_(r, e);
        var t = mB(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "submitAnalytics",
                value: function(e) {
                    kI(H_(r.prototype), "submitAnalytics", this).call(this, pB({}, e), this.props);
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    return pB(pB({}, e), {}, {
                        checkoutMode: e.isDropin ? "ProcessOrder" : e.checkoutMode,
                        environment: e.environment.toUpperCase(),
                        locale: e.locale.replace("-", "_"),
                        productType: e.isDropin && !e.addressDetails ? "PayOnly" : e.productType
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.props.amazonCheckoutSessionId;
                    return {
                        paymentMethod: pB({
                            type: r.type
                        }, e && {
                            checkoutSessionId: e
                        }),
                        browserInfo: this.browserInfo
                    };
                }
            },
            {
                key: "getShopperDetails",
                value: function() {
                    var e = this.props, t = e.amazonCheckoutSessionId, r = e.configuration, a = void 0 === r ? {} : r, n = e.loadingContext, o = e.clientKey;
                    return t ? eB(n, o, {
                        checkoutSessionId: t,
                        getDeliveryAddress: !0,
                        publicKeyId: a.publicKeyId,
                        region: a.region
                    }) : console.error("Could not shopper details. Missing checkoutSessionId.");
                }
            },
            {
                key: "handleDeclineFlow",
                value: function() {
                    var e = this, t = this.props, r = t.amazonCheckoutSessionId, a = t.configuration, n = void 0 === a ? {} : a, o = t.loadingContext, i = t.clientKey;
                    if (!r) return console.error("Could handle the decline flow. Missing checkoutSessionId.");
                    eB(o, i, {
                        checkoutSessionId: r,
                        getDeclineFlowUrl: !0,
                        publicKeyId: n.publicKeyId,
                        region: n.region
                    }).then(function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        if (null == e || !e.declineFlowUrl) throw e;
                        window.location.assign(e.declineFlowUrl);
                    }).catch(function(t) {
                        e.props.onError && e.props.onError(t, e.componentRef);
                    });
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "browserInfo",
                get: function() {
                    return Mj();
                }
            },
            {
                key: "submit",
                value: function() {
                    var e = this.data, t = this.isValid, r = this.props.onSubmit, a = void 0 === r ? function() {} : r;
                    return this.componentRef && this.componentRef.submit ? this.componentRef.submit() : a({
                        data: e,
                        isValid: t
                    }, this);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(cB, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props)));
                }
            }
        ]), r;
    }(qS);
    Ag(fB, "type", "amazonpay"), Ag(fB, "defaultProps", uB);
    var hB = {
        "apple-pay": "ApplePayButton-module_apple-pay__gYjuP",
        "apple-pay-button": "ApplePayButton-module_apple-pay-button__l5g-d",
        "apple-pay-button-black": "ApplePayButton-module_apple-pay-button-black__istwW",
        "apple-pay-button-white": "ApplePayButton-module_apple-pay-button-white__-wLaE",
        "apple-pay-button-white-with-line": "ApplePayButton-module_apple-pay-button-white-with-line__MlRq7",
        "apple-pay-button--type-plain": "ApplePayButton-module_apple-pay-button--type-plain__ycfNl",
        "apple-pay-button--type-buy": "ApplePayButton-module_apple-pay-button--type-buy__9m8AB",
        "apple-pay-button--type-donate": "ApplePayButton-module_apple-pay-button--type-donate__HmRdK",
        "apple-pay-button--type-check-out": "ApplePayButton-module_apple-pay-button--type-check-out__XdGWd",
        "apple-pay-button--type-book": "ApplePayButton-module_apple-pay-button--type-book__-v-VY",
        "apple-pay-button--type-subscribe": "ApplePayButton-module_apple-pay-button--type-subscribe__WxWIF",
        "apple-pay-button--type-add-money": "ApplePayButton-module_apple-pay-button--type-add-money__zeBA8",
        "apple-pay-button--type-contribute": "ApplePayButton-module_apple-pay-button--type-contribute__G3E8e",
        "apple-pay-button--type-order": "ApplePayButton-module_apple-pay-button--type-order__ggI6j",
        "apple-pay-button--type-reload": "ApplePayButton-module_apple-pay-button--type-reload__QbgLd",
        "apple-pay-button--type-rent": "ApplePayButton-module_apple-pay-button--type-rent__VzC-E",
        "apple-pay-button--type-support": "ApplePayButton-module_apple-pay-button--type-support__6EjmY",
        "apple-pay-button--type-tip": "ApplePayButton-module_apple-pay-button--type-tip__bdzGK",
        "apple-pay-button--type-top-up": "ApplePayButton-module_apple-pay-button--type-top-up__Eb3qR"
    };
    function vB(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var yB = function(e) {
        U_(r, e);
        var t = vB(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "render",
                value: function(e) {
                    var t = e.buttonColor, r = e.buttonType;
                    return nN("button", {
                        type: "button",
                        "aria-label": this.props.i18n.get("payButton"),
                        lang: this.props.i18n.languageCode,
                        className: DP("adyen-checkout__applepay__button", "adyen-checkout__applepay__button--".concat(t), "adyen-checkout__applepay__button--".concat(r), [
                            hB["apple-pay"]
                        ], [
                            hB["apple-pay-button"]
                        ], [
                            hB["apple-pay-button-".concat(t)]
                        ], [
                            hB["apple-pay-button--type-".concat(r)]
                        ]),
                        onClick: this.props.onClick
                    });
                }
            }
        ]), r;
    }(lN);
    function gB(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function bB(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = gB(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = gB(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    Ag(yB, "defaultProps", {
        onClick: function() {},
        buttonColor: "black",
        buttonType: "plain"
    });
    var kB = function() {
        function e(t, r) {
            var a = this;
            Cg(this, e), Ag(this, "session", void 0), Ag(this, "options", void 0), this.options = r, this.session = new ApplePaySession(r.version, t), this.session.onvalidatemerchant = function(e) {
                return a.onvalidatemerchant(e, r.onValidateMerchant);
            }, this.session.onpaymentauthorized = function(e) {
                return a.onpaymentauthorized(e, r.onPaymentAuthorized);
            }, this.session.oncancel = function(e) {
                return a.oncancel(e, r.onCancel);
            }, "function" == typeof r.onPaymentMethodSelected && (this.session.onpaymentmethodselected = function(e) {
                return a.onpaymentmethodselected(e, r.onPaymentMethodSelected);
            }), "function" == typeof r.onShippingContactSelected && (this.session.onshippingcontactselected = function(e) {
                return a.onshippingcontactselected(e, r.onShippingContactSelected);
            }), "function" == typeof r.onShippingMethodSelected && (this.session.onshippingmethodselected = function(e) {
                return a.onshippingmethodselected(e, r.onShippingMethodSelected);
            });
        }
        return wg(e, [
            {
                key: "begin",
                value: function() {
                    return this.session.begin();
                }
            },
            {
                key: "onvalidatemerchant",
                value: function(e, t) {
                    var r = this;
                    return new Ab(function(r, a) {
                        return t(r, a, e.validationURL);
                    }).then(function(e) {
                        r.session.completeMerchantValidation(e);
                    }).catch(function(e) {
                        console.error(e), r.session.abort(), r.options.onError(e);
                    });
                }
            },
            {
                key: "onpaymentauthorized",
                value: function(e, t) {
                    var r = this;
                    return new Ab(function(r, a) {
                        return t(r, a, e);
                    }).then(function(e) {
                        var t;
                        r.session.completePayment(bB(bB({}, e), {}, {
                            status: null !== (t = null == e ? void 0 : e.status) && void 0 !== t ? t : ApplePaySession.STATUS_SUCCESS
                        }));
                    }).catch(function(e) {
                        var t;
                        r.session.completePayment(bB(bB({}, e), {}, {
                            status: null !== (t = null == e ? void 0 : e.status) && void 0 !== t ? t : ApplePaySession.STATUS_FAILURE
                        }));
                    });
                }
            },
            {
                key: "onpaymentmethodselected",
                value: function(e, t) {
                    var r = this;
                    return new Ab(function(r, a) {
                        return t(r, a, e);
                    }).then(function(e) {
                        console.log("onpaymentmethodselected", e), r.session.completePaymentMethodSelection(e);
                    }).catch(function(e) {
                        r.session.completePaymentMethodSelection(e);
                    });
                }
            },
            {
                key: "onshippingcontactselected",
                value: function(e, t) {
                    var r = this;
                    return new Ab(function(r, a) {
                        return t(r, a, e);
                    }).then(function(e) {
                        r.session.completeShippingContactSelection(e);
                    }).catch(function(e) {
                        r.session.completeShippingContactSelection(e);
                    });
                }
            },
            {
                key: "onshippingmethodselected",
                value: function(e, t) {
                    var r = this;
                    return new Ab(function(r, a) {
                        return t(r, a, e);
                    }).then(function(e) {
                        r.session.completeShippingMethodSelection(e);
                    }).catch(function(e) {
                        r.session.completeShippingMethodSelection(e);
                    });
                }
            },
            {
                key: "oncancel",
                value: function(e, t) {
                    t(e);
                }
            }
        ]), e;
    }(), CB = {
        amount: {
            currency: "USD",
            value: 0
        },
        countryCode: "US",
        totalPriceStatus: "final",
        totalPriceLabel: void 0,
        configuration: {
            merchantName: "",
            merchantId: ""
        },
        initiative: "web",
        isExpress: !1,
        lineItems: void 0,
        merchantCapabilities: [
            "supports3DS"
        ],
        shippingMethods: void 0,
        shippingType: void 0,
        supportedCountries: void 0,
        supportedNetworks: [
            "amex",
            "discover",
            "masterCard",
            "visa"
        ],
        requiredBillingContactFields: void 0,
        requiredShippingContactFields: void 0,
        billingContact: void 0,
        shippingContact: void 0,
        applicationData: void 0,
        onClick: function(e) {
            return e();
        },
        onAuthorized: function(e) {
            return e();
        },
        onPaymentMethodSelected: null,
        onShippingContactSelected: null,
        onShippingMethodSelected: null,
        buttonType: "plain",
        buttonColor: "black",
        showPayButton: !0
    }, _B = [
        "countryCode",
        "companyName",
        "amount"
    ], NB = function(e) {
        var t = e.countryCode;
        e.companyName;
        var r = e.amount, a = kg(e, _B), n = function(e) {
            return String(t_(e.value, e.currency));
        }(r);
        return {
            countryCode: t,
            currencyCode: r.currency,
            total: {
                label: a.totalPriceLabel,
                amount: n,
                type: a.totalPriceStatus
            },
            lineItems: a.lineItems,
            shippingMethods: a.shippingMethods,
            shippingType: a.shippingType,
            recurringPaymentRequest: a.recurringPaymentRequest,
            merchantCapabilities: a.merchantCapabilities,
            supportedCountries: a.supportedCountries,
            supportedNetworks: a.supportedNetworks,
            requiredShippingContactFields: a.requiredShippingContactFields,
            requiredBillingContactFields: a.requiredBillingContactFields,
            billingContact: a.billingContact,
            shippingContact: a.shippingContact,
            applicationData: a.applicationData
        };
    };
    function PB(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function wB(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = PB(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = PB(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function AB(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var SB = function(e) {
        U_(a, e);
        var t, r = AB(a);
        function a(e) {
            var t, n, o, i;
            return Cg(this, a), (i = r.call(this, e)).startSession = Jg(t = i.startSession).call(t, L_(i)), i.submit = Jg(n = i.submit).call(n, L_(i)), i.validateMerchant = Jg(o = i.validateMerchant).call(o, L_(i)), i;
        }
        return wg(a, [
            {
                key: "submitAnalytics",
                value: function(e) {
                    kI(H_(a.prototype), "submitAnalytics", this).call(this, wB({}, e), this.props);
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    var t, r, a, n, o = e.version || function(e) {
                        for(var t = [], r = e; r > 0; r--)t.push(r);
                        try {
                            return zb(t).call(t, function(e) {
                                return e && window.ApplePaySession && ApplePaySession.supportsVersion(e);
                            });
                        } catch (e) {
                            return console.warn(e), null;
                        }
                    }(14), i = null !== (t = e.brands) && void 0 !== t && t.length ? (a = e.brands, n = {
                        mc: "masterCard",
                        amex: "amex",
                        visa: "visa",
                        elodebit: "elo",
                        elo: "elo",
                        interac: "interac",
                        discover: "discover",
                        jcb: "jcb",
                        electron: "electron",
                        maestro: "maestro",
                        girocard: "girocard",
                        cartebancaire: "cartesBancaires",
                        eftpos_australia: "eftpos"
                    }, tC(a).call(a, function(e, t) {
                        return n[t] && !kb(e).call(e, n[t]) && e.push(n[t]), e;
                    }, [])) : e.supportedNetworks;
                    return wB(wB({}, e), {}, {
                        configuration: e.configuration,
                        supportedNetworks: i,
                        version: o,
                        totalPriceLabel: e.totalPriceLabel || (null === (r = e.configuration) || void 0 === r ? void 0 : r.merchantName)
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    return {
                        paymentMethod: wB({
                            type: a.type
                        }, this.state)
                    };
                }
            },
            {
                key: "submit",
                value: function() {
                    return this.props.isInstantPayment && this.submitAnalytics({
                        type: MN,
                        target: YN
                    }), this.startSession(this.props.onAuthorized);
                }
            },
            {
                key: "startSession",
                value: function(e) {
                    var t = this, r = this.props, n = r.version, o = r.onValidateMerchant, i = r.onPaymentMethodSelected, l = r.onShippingMethodSelected, s = r.onShippingContactSelected, c = NB(wB({
                        companyName: this.props.configuration.merchantName
                    }, this.props)), u = new kB(c, {
                        version: n,
                        onError: function(e) {
                            t.handleError(new LS("ERROR", "ApplePay - Something went wrong on ApplePayService", {
                                cause: e
                            }));
                        },
                        onCancel: function(e) {
                            t.handleError(new LS("CANCEL", "ApplePay UI dismissed", {
                                cause: e
                            }));
                        },
                        onPaymentMethodSelected: i,
                        onShippingMethodSelected: l,
                        onShippingContactSelected: s,
                        onValidateMerchant: o || this.validateMerchant,
                        onPaymentAuthorized: function(r, n, o) {
                            var i;
                            null != o && null !== (i = o.payment) && void 0 !== i && null !== (i = i.token) && void 0 !== i && i.paymentData && t.setState({
                                applePayToken: btoa(Mb(o.payment.token.paymentData))
                            }), kI(H_(a.prototype), "submit", t).call(t), e(r, n, o);
                        }
                    });
                    return new Ab(function(e, r) {
                        return t.props.onClick(e, r);
                    }).then(function() {
                        u.begin();
                    }).catch(function() {
                        return {};
                    });
                }
            },
            {
                key: "validateMerchant",
                value: (t = Jd(Dy.mark(function e(t, r) {
                    var a, n, o, i, l, s, c, u, d, p, m, f, h, v, y;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return n = window.location.hostname, o = this.props, i = o.clientKey, l = o.configuration, s = o.loadingContext, c = o.initiative, u = l.merchantName, d = l.merchantId, p = wb(a = "".concat("v1/applePay/sessions", "?clientKey=")).call(a, i), m = {
                                    loadingContext: s,
                                    path: p
                                }, f = {
                                    displayName: u,
                                    domainName: n,
                                    initiative: c,
                                    merchantIdentifier: d
                                }, e.prev = 6, e.next = 9, zT(m, f);
                            case 9:
                                h = e.sent, (v = iI.decode(h.data)).success ? (y = JSON.parse(v.data), t(y)) : r("Could not decode Apple Pay session"), e.next = 17;
                                break;
                            case 14:
                                e.prev = 14, e.t0 = e.catch(6), r("Could not get Apple Pay session");
                            case 17:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            6,
                            14
                        ]
                    ]);
                })), function(e, r) {
                    return t.apply(this, arguments);
                })
            },
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "isAvailable",
                value: function() {
                    if ("https:" !== document.location.protocol) return Ab.reject(new LS("IMPLEMENTATION_ERROR", "Trying to start an Apple Pay session from an insecure document"));
                    if (!this.props.onValidateMerchant && !this.props.clientKey) return Ab.reject(new LS("IMPLEMENTATION_ERROR", "clientKey was not provided"));
                    try {
                        if (window.ApplePaySession && ApplePaySession.canMakePayments() && ApplePaySession.supportsVersion(this.props.version)) return Ab.resolve(!0);
                    } catch (e) {
                        console.warn(e);
                    }
                    return Ab.reject(new LS("ERROR", "Apple Pay is not available on this device"));
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.showPayButton ? nN(yB, {
                        i18n: this.props.i18n,
                        buttonColor: this.props.buttonColor,
                        buttonType: this.props.buttonType,
                        onClick: function(t) {
                            t.preventDefault(), e.submit();
                        }
                    }) : null;
                }
            }
        ]), a;
    }(qS);
    function IB(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function EB(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = IB(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = IB(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    Ag(SB, "type", "applepay"), Ag(SB, "defaultProps", CB);
    var DB = {
        labels: Ag({}, bR, "address"),
        schema: [
            bR,
            [
                [
                    PR,
                    70
                ],
                [
                    CR,
                    30
                ]
            ]
        ]
    }, RB = [
        "ID",
        "PH",
        "TH",
        "VN",
        "JP",
        "TW",
        "KR",
        "SG",
        "MY",
        "HK"
    ], FB = tC(ER).call(ER, function(e, t) {
        return EB(EB({}, e), {}, Ag({}, t, DB));
    }, {
        default: DB
    });
    function xB(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function TB(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = xB(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = xB(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function zB(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var OB = function(e) {
        U_(r, e);
        var t = zB(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return TB(TB({}, kI(H_(r.prototype), "formatProps", this).call(this, TB(TB({}, e), {
                        visibility: {
                            deliveryAddress: "hidden",
                            companyDetails: "hidden"
                        }
                    }))), {}, {
                        allowedCountries: RB,
                        personalDetailsRequiredFields: [
                            "firstName",
                            "lastName",
                            "telephoneNumber"
                        ],
                        billingAddressRequiredFields: [
                            "country",
                            "street",
                            "postalCode"
                        ],
                        billingAddressSpecification: FB
                    });
                }
            }
        ]), r;
    }(Aj);
    function jB(e) {
        var t = e.name, r = e.id, a = e.icon, n = e.onClick, o = e.selected, i = void 0 !== o && o;
        return nN("button", {
            type: "button",
            className: DP("adyen-checkout__issuer-button", {
                "adyen-checkout__issuer-button--selected": i
            }),
            "aria-label": t,
            "aria-pressed": i,
            onClick: n,
            value: r
        }, !!a && nN(XT, {
            className: "adyen-checkout__issuer-button-img",
            alt: t,
            src: a
        }), nN("span", {
            className: "adyen-checkout__issuer-button-text"
        }, t));
    }
    Ag(OB, "type", "atome");
    var BB = function(e) {
        var t = e.items, r = void 0 === t ? [] : t, a = e.selectedIssuerId, n = e.onChange, o = sw().i18n, i = GP(function(e) {
            var t = e.currentTarget.value;
            og(e.target, "value", {
                value: t
            }), n(e);
        }, [
            n
        ]);
        return nN("div", {
            className: "adyen-checkout__issuer-button-group",
            role: "group",
            "aria-label": o.get("idealIssuer.selectField.placeholder")
        }, hC(r).call(r, function(e) {
            return nN(jB, M_({
                key: e.id
            }, e, {
                selected: a === e.id,
                onClick: i
            }));
        }));
    };
    function MB(e) {
        var t, r = e.label, a = void 0 === r ? "qrCodeOrApp" : r, n = e.classNames, o = void 0 === n ? [] : n, i = sw().i18n;
        return nN("div", {
            className: DP.apply(void 0, wb(t = [
                "adyen-checkout__content-separator"
            ]).call(t, Uk(o)))
        }, i.get(a));
    }
    var LB, VB = h, UB = 2147483647, KB = /[^\0-\u007E]/, HB = /[.\u3002\uFF0E\uFF61]/g, qB = "Overflow: input needs wider integers to process", WB = RangeError, GB = VB(HB.exec), YB = Math.floor, QB = String.fromCharCode, ZB = VB("".charCodeAt), JB = VB([].join), $B = VB([].push), XB = VB("".replace), eM = VB("".split), tM = VB("".toLowerCase), rM = function(e) {
        return e + 22 + 75 * (e < 26);
    }, aM = function(e, t, r) {
        var a = 0;
        for(e = r ? YB(e / 700) : e >> 1, e += YB(e / t); e > 455;)e = YB(e / 35), a += 36;
        return YB(a + 36 * e / (e + 38));
    }, nM = function(e) {
        var t = [];
        e = function(e) {
            for(var t = [], r = 0, a = e.length; r < a;){
                var n = ZB(e, r++);
                if (n >= 55296 && n <= 56319 && r < a) {
                    var o = ZB(e, r++);
                    56320 == (64512 & o) ? $B(t, ((1023 & n) << 10) + (1023 & o) + 65536) : ($B(t, n), r--);
                } else $B(t, n);
            }
            return t;
        }(e);
        var r, a, n = e.length, o = 128, i = 0, l = 72;
        for(r = 0; r < e.length; r++)(a = e[r]) < 128 && $B(t, QB(a));
        var s = t.length, c = s;
        for(s && $B(t, "-"); c < n;){
            var u = UB;
            for(r = 0; r < e.length; r++)(a = e[r]) >= o && a < u && (u = a);
            var d = c + 1;
            if (u - o > YB((UB - i) / d)) throw new WB(qB);
            for(i += (u - o) * d, o = u, r = 0; r < e.length; r++){
                if ((a = e[r]) < o && ++i > UB) throw new WB(qB);
                if (a === o) {
                    for(var p = i, m = 36;;){
                        var f = m <= l ? 1 : m >= l + 26 ? 26 : m - l;
                        if (p < f) break;
                        var h = p - f, v = 36 - f;
                        $B(t, QB(rM(f + h % v))), p = YB(h / v), m += 36;
                    }
                    $B(t, QB(rM(p))), l = aM(i, d, c === s), i = 0, c++;
                }
            }
            i++, o++;
        }
        return JB(t, "");
    }, oM = Sr, iM = I, lM = vF, sM = a, cM = Qt, uM = h, dM = ui, pM = pl, mM = kl, fM = Je, hM = T_, vM = zk, yM = Mp, gM = Pd.codeAt, bM = function(e) {
        var t, r, a = [], n = eM(XB(tM(e), HB, "."), ".");
        for(t = 0; t < n.length; t++)r = n[t], $B(a, GB(KB, r) ? "xn--" + nM(r) : r);
        return JB(a, ".");
    }, kM = vo, CM = Ei, _M = es, NM = Bx, PM = ri, wM = PM.set, AM = PM.getterFor("URL"), SM = NM.URLSearchParams, IM = NM.getState, EM = sM.URL, DM = sM.TypeError, RM = sM.parseInt, FM = Math.floor, xM = Math.pow, TM = uM("".charAt), zM = uM(/./.exec), OM = uM([].join), jM = uM(1..toString), BM = uM([].pop), MM = uM([].push), LM = uM("".replace), VM = uM([].shift), UM = uM("".split), KM = uM("".slice), HM = uM("".toLowerCase), qM = uM([].unshift), WM = "Invalid scheme", GM = "Invalid host", YM = "Invalid port", QM = /[a-z]/i, ZM = /[\d+-.a-z]/i, JM = /\d/, $M = /^0x/i, XM = /^[0-7]+$/, eL = /^\d+$/, tL = /^[\da-f]+$/i, rL = /[\0\t\n\r #%/:<>?@[\\\]^|]/, aL = /[\0\t\n\r #/:<>?@[\\\]^|]/, nL = /^[\u0000-\u0020]+/, oL = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/, iL = /[\t\n\r]/g, lL = function(e) {
        var t, r, a, n;
        if ("number" == typeof e) {
            for(t = [], r = 0; r < 4; r++)qM(t, e % 256), e = FM(e / 256);
            return OM(t, ".");
        }
        if ("object" == typeof e) {
            for(t = "", a = function(e) {
                for(var t = null, r = 1, a = null, n = 0, o = 0; o < 8; o++)0 !== e[o] ? (n > r && (t = a, r = n), a = null, n = 0) : (null === a && (a = o), ++n);
                return n > r && (t = a, r = n), t;
            }(e), r = 0; r < 8; r++)n && 0 === e[r] || (n && (n = !1), a === r ? (t += r ? ":" : "::", n = !0) : (t += jM(e[r], 16), r < 7 && (t += ":")));
            return "[" + t + "]";
        }
        return e;
    }, sL = {}, cL = hM({}, sL, {
        " ": 1,
        '"': 1,
        "<": 1,
        ">": 1,
        "`": 1
    }), uL = hM({}, cL, {
        "#": 1,
        "?": 1,
        "{": 1,
        "}": 1
    }), dL = hM({}, uL, {
        "/": 1,
        ":": 1,
        ";": 1,
        "=": 1,
        "@": 1,
        "[": 1,
        "\\": 1,
        "]": 1,
        "^": 1,
        "|": 1
    }), pL = function(e, t) {
        var r = gM(e, 0);
        return r > 32 && r < 127 && !fM(t, e) ? e : encodeURIComponent(e);
    }, mL = {
        ftp: 21,
        file: null,
        http: 80,
        https: 443,
        ws: 80,
        wss: 443
    }, fL = function(e, t) {
        var r;
        return 2 === e.length && zM(QM, TM(e, 0)) && (":" === (r = TM(e, 1)) || !t && "|" === r);
    }, hL = function(e) {
        var t;
        return e.length > 1 && fL(KM(e, 0, 2)) && (2 === e.length || "/" === (t = TM(e, 2)) || "\\" === t || "?" === t || "#" === t);
    }, vL = function(e) {
        return "." === e || "%2e" === HM(e);
    }, yL = {}, gL = {}, bL = {}, kL = {}, CL = {}, _L = {}, NL = {}, PL = {}, wL = {}, AL = {}, SL = {}, IL = {}, EL = {}, DL = {}, RL = {}, FL = {}, xL = {}, TL = {}, zL = {}, OL = {}, jL = {}, BL = function(e, t, r) {
        var a, n, o, i = kM(e);
        if (t) {
            if (n = this.parse(i)) throw new DM(n);
            this.searchParams = null;
        } else {
            if (void 0 !== r && (a = new BL(r, !0)), n = this.parse(i, null, a)) throw new DM(n);
            (o = IM(new SM)).bindURL(this), this.searchParams = o;
        }
    };
    BL.prototype = {
        type: "URL",
        parse: function(e, t, r) {
            var a, n, o, i, l, s = this, c = t || yL, u = 0, d = "", p = !1, m = !1, f = !1;
            for(e = kM(e), t || (s.scheme = "", s.username = "", s.password = "", s.host = null, s.port = null, s.path = [], s.query = null, s.fragment = null, s.cannotBeABaseURL = !1, e = LM(e, nL, ""), e = LM(e, oL, "$1")), e = LM(e, iL, ""), a = vM(e); u <= a.length;){
                switch(n = a[u], c){
                    case yL:
                        if (!n || !zM(QM, n)) {
                            if (t) return WM;
                            c = bL;
                            continue;
                        }
                        d += HM(n), c = gL;
                        break;
                    case gL:
                        if (n && (zM(ZM, n) || "+" === n || "-" === n || "." === n)) d += HM(n);
                        else {
                            if (":" !== n) {
                                if (t) return WM;
                                d = "", c = bL, u = 0;
                                continue;
                            }
                            if (t && (s.isSpecial() !== fM(mL, d) || "file" === d && (s.includesCredentials() || null !== s.port) || "file" === s.scheme && !s.host)) return;
                            if (s.scheme = d, t) return void (s.isSpecial() && mL[s.scheme] === s.port && (s.port = null));
                            d = "", "file" === s.scheme ? c = DL : s.isSpecial() && r && r.scheme === s.scheme ? c = kL : s.isSpecial() ? c = PL : "/" === a[u + 1] ? (c = CL, u++) : (s.cannotBeABaseURL = !0, MM(s.path, ""), c = zL);
                        }
                        break;
                    case bL:
                        if (!r || r.cannotBeABaseURL && "#" !== n) return WM;
                        if (r.cannotBeABaseURL && "#" === n) {
                            s.scheme = r.scheme, s.path = yM(r.path), s.query = r.query, s.fragment = "", s.cannotBeABaseURL = !0, c = jL;
                            break;
                        }
                        c = "file" === r.scheme ? DL : _L;
                        continue;
                    case kL:
                        if ("/" !== n || "/" !== a[u + 1]) {
                            c = _L;
                            continue;
                        }
                        c = wL, u++;
                        break;
                    case CL:
                        if ("/" === n) {
                            c = AL;
                            break;
                        }
                        c = TL;
                        continue;
                    case _L:
                        if (s.scheme = r.scheme, n === LB) s.username = r.username, s.password = r.password, s.host = r.host, s.port = r.port, s.path = yM(r.path), s.query = r.query;
                        else if ("/" === n || "\\" === n && s.isSpecial()) c = NL;
                        else if ("?" === n) s.username = r.username, s.password = r.password, s.host = r.host, s.port = r.port, s.path = yM(r.path), s.query = "", c = OL;
                        else {
                            if ("#" !== n) {
                                s.username = r.username, s.password = r.password, s.host = r.host, s.port = r.port, s.path = yM(r.path), s.path.length--, c = TL;
                                continue;
                            }
                            s.username = r.username, s.password = r.password, s.host = r.host, s.port = r.port, s.path = yM(r.path), s.query = r.query, s.fragment = "", c = jL;
                        }
                        break;
                    case NL:
                        if (!s.isSpecial() || "/" !== n && "\\" !== n) {
                            if ("/" !== n) {
                                s.username = r.username, s.password = r.password, s.host = r.host, s.port = r.port, c = TL;
                                continue;
                            }
                            c = AL;
                        } else c = wL;
                        break;
                    case PL:
                        if (c = wL, "/" !== n || "/" !== TM(d, u + 1)) continue;
                        u++;
                        break;
                    case wL:
                        if ("/" !== n && "\\" !== n) {
                            c = AL;
                            continue;
                        }
                        break;
                    case AL:
                        if ("@" === n) {
                            p && (d = "%40" + d), p = !0, o = vM(d);
                            for(var h = 0; h < o.length; h++){
                                var v = o[h];
                                if (":" !== v || f) {
                                    var y = pL(v, dL);
                                    f ? s.password += y : s.username += y;
                                } else f = !0;
                            }
                            d = "";
                        } else if (n === LB || "/" === n || "?" === n || "#" === n || "\\" === n && s.isSpecial()) {
                            if (p && "" === d) return "Invalid authority";
                            u -= vM(d).length + 1, d = "", c = SL;
                        } else d += n;
                        break;
                    case SL:
                    case IL:
                        if (t && "file" === s.scheme) {
                            c = FL;
                            continue;
                        }
                        if (":" !== n || m) {
                            if (n === LB || "/" === n || "?" === n || "#" === n || "\\" === n && s.isSpecial()) {
                                if (s.isSpecial() && "" === d) return GM;
                                if (t && "" === d && (s.includesCredentials() || null !== s.port)) return;
                                if (i = s.parseHost(d)) return i;
                                if (d = "", c = xL, t) return;
                                continue;
                            }
                            "[" === n ? m = !0 : "]" === n && (m = !1), d += n;
                        } else {
                            if ("" === d) return GM;
                            if (i = s.parseHost(d)) return i;
                            if (d = "", c = EL, t === IL) return;
                        }
                        break;
                    case EL:
                        if (!zM(JM, n)) {
                            if (n === LB || "/" === n || "?" === n || "#" === n || "\\" === n && s.isSpecial() || t) {
                                if ("" !== d) {
                                    var g = RM(d, 10);
                                    if (g > 65535) return YM;
                                    s.port = s.isSpecial() && g === mL[s.scheme] ? null : g, d = "";
                                }
                                if (t) return;
                                c = xL;
                                continue;
                            }
                            return YM;
                        }
                        d += n;
                        break;
                    case DL:
                        if (s.scheme = "file", "/" === n || "\\" === n) c = RL;
                        else {
                            if (!r || "file" !== r.scheme) {
                                c = TL;
                                continue;
                            }
                            switch(n){
                                case LB:
                                    s.host = r.host, s.path = yM(r.path), s.query = r.query;
                                    break;
                                case "?":
                                    s.host = r.host, s.path = yM(r.path), s.query = "", c = OL;
                                    break;
                                case "#":
                                    s.host = r.host, s.path = yM(r.path), s.query = r.query, s.fragment = "", c = jL;
                                    break;
                                default:
                                    hL(OM(yM(a, u), "")) || (s.host = r.host, s.path = yM(r.path), s.shortenPath()), c = TL;
                                    continue;
                            }
                        }
                        break;
                    case RL:
                        if ("/" === n || "\\" === n) {
                            c = FL;
                            break;
                        }
                        r && "file" === r.scheme && !hL(OM(yM(a, u), "")) && (fL(r.path[0], !0) ? MM(s.path, r.path[0]) : s.host = r.host), c = TL;
                        continue;
                    case FL:
                        if (n === LB || "/" === n || "\\" === n || "?" === n || "#" === n) {
                            if (!t && fL(d)) c = TL;
                            else if ("" === d) {
                                if (s.host = "", t) return;
                                c = xL;
                            } else {
                                if (i = s.parseHost(d)) return i;
                                if ("localhost" === s.host && (s.host = ""), t) return;
                                d = "", c = xL;
                            }
                            continue;
                        }
                        d += n;
                        break;
                    case xL:
                        if (s.isSpecial()) {
                            if (c = TL, "/" !== n && "\\" !== n) continue;
                        } else if (t || "?" !== n) {
                            if (t || "#" !== n) {
                                if (n !== LB && (c = TL, "/" !== n)) continue;
                            } else s.fragment = "", c = jL;
                        } else s.query = "", c = OL;
                        break;
                    case TL:
                        if (n === LB || "/" === n || "\\" === n && s.isSpecial() || !t && ("?" === n || "#" === n)) {
                            if (".." === (l = HM(l = d)) || "%2e." === l || ".%2e" === l || "%2e%2e" === l ? (s.shortenPath(), "/" === n || "\\" === n && s.isSpecial() || MM(s.path, "")) : vL(d) ? "/" === n || "\\" === n && s.isSpecial() || MM(s.path, "") : ("file" === s.scheme && !s.path.length && fL(d) && (s.host && (s.host = ""), d = TM(d, 0) + ":"), MM(s.path, d)), d = "", "file" === s.scheme && (n === LB || "?" === n || "#" === n)) for(; s.path.length > 1 && "" === s.path[0];)VM(s.path);
                            "?" === n ? (s.query = "", c = OL) : "#" === n && (s.fragment = "", c = jL);
                        } else d += pL(n, uL);
                        break;
                    case zL:
                        "?" === n ? (s.query = "", c = OL) : "#" === n ? (s.fragment = "", c = jL) : n !== LB && (s.path[0] += pL(n, sL));
                        break;
                    case OL:
                        t || "#" !== n ? n !== LB && ("'" === n && s.isSpecial() ? s.query += "%27" : s.query += "#" === n ? "%23" : pL(n, sL)) : (s.fragment = "", c = jL);
                        break;
                    case jL:
                        n !== LB && (s.fragment += pL(n, cL));
                }
                u++;
            }
        },
        parseHost: function(e) {
            var t, r, a;
            if ("[" === TM(e, 0)) {
                if ("]" !== TM(e, e.length - 1)) return GM;
                if (t = function(e) {
                    var t, r, a, n, o, i, l, s = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ], c = 0, u = null, d = 0, p = function() {
                        return TM(e, d);
                    };
                    if (":" === p()) {
                        if (":" !== TM(e, 1)) return;
                        d += 2, u = ++c;
                    }
                    for(; p();){
                        if (8 === c) return;
                        if (":" !== p()) {
                            for(t = r = 0; r < 4 && zM(tL, p());)t = 16 * t + RM(p(), 16), d++, r++;
                            if ("." === p()) {
                                if (0 === r) return;
                                if (d -= r, c > 6) return;
                                for(a = 0; p();){
                                    if (n = null, a > 0) {
                                        if (!("." === p() && a < 4)) return;
                                        d++;
                                    }
                                    if (!zM(JM, p())) return;
                                    for(; zM(JM, p());){
                                        if (o = RM(p(), 10), null === n) n = o;
                                        else {
                                            if (0 === n) return;
                                            n = 10 * n + o;
                                        }
                                        if (n > 255) return;
                                        d++;
                                    }
                                    s[c] = 256 * s[c] + n, 2 != ++a && 4 !== a || c++;
                                }
                                if (4 !== a) return;
                                break;
                            }
                            if (":" === p()) {
                                if (d++, !p()) return;
                            } else if (p()) return;
                            s[c++] = t;
                        } else {
                            if (null !== u) return;
                            d++, u = ++c;
                        }
                    }
                    if (null !== u) for(i = c - u, c = 7; 0 !== c && i > 0;)l = s[c], s[c--] = s[u + i - 1], s[u + --i] = l;
                    else if (8 !== c) return;
                    return s;
                }(KM(e, 1, -1)), !t) return GM;
                this.host = t;
            } else if (this.isSpecial()) {
                if (e = bM(e), zM(rL, e)) return GM;
                if (t = function(e) {
                    var t, r, a, n, o, i, l, s = UM(e, ".");
                    if (s.length && "" === s[s.length - 1] && s.length--, (t = s.length) > 4) return e;
                    for(r = [], a = 0; a < t; a++){
                        if ("" === (n = s[a])) return e;
                        if (o = 10, n.length > 1 && "0" === TM(n, 0) && (o = zM($M, n) ? 16 : 8, n = KM(n, 8 === o ? 1 : 2)), "" === n) i = 0;
                        else {
                            if (!zM(10 === o ? eL : 8 === o ? XM : tL, n)) return e;
                            i = RM(n, o);
                        }
                        MM(r, i);
                    }
                    for(a = 0; a < t; a++)if (i = r[a], a === t - 1) {
                        if (i >= xM(256, 5 - t)) return null;
                    } else if (i > 255) return null;
                    for(l = BM(r), a = 0; a < r.length; a++)l += r[a] * xM(256, 3 - a);
                    return l;
                }(e), null === t) return GM;
                this.host = t;
            } else {
                if (zM(aL, e)) return GM;
                for(t = "", r = vM(e), a = 0; a < r.length; a++)t += pL(r[a], sL);
                this.host = t;
            }
        },
        cannotHaveUsernamePasswordPort: function() {
            return !this.host || this.cannotBeABaseURL || "file" === this.scheme;
        },
        includesCredentials: function() {
            return "" !== this.username || "" !== this.password;
        },
        isSpecial: function() {
            return fM(mL, this.scheme);
        },
        shortenPath: function() {
            var e = this.path, t = e.length;
            !t || "file" === this.scheme && 1 === t && fL(e[0], !0) || e.length--;
        },
        serialize: function() {
            var e = this, t = e.scheme, r = e.username, a = e.password, n = e.host, o = e.port, i = e.path, l = e.query, s = e.fragment, c = t + ":";
            return null !== n ? (c += "//", e.includesCredentials() && (c += r + (a ? ":" + a : "") + "@"), c += lL(n), null !== o && (c += ":" + o)) : "file" === t && (c += "//"), c += e.cannotBeABaseURL ? i[0] : i.length ? "/" + OM(i, "/") : "", null !== l && (c += "?" + l), null !== s && (c += "#" + s), c;
        },
        setHref: function(e) {
            var t = this.parse(e);
            if (t) throw new DM(t);
            this.searchParams.update();
        },
        getOrigin: function() {
            var e = this.scheme, t = this.port;
            if ("blob" === e) try {
                return new ML(e.path[0]).origin;
            } catch (e) {
                return "null";
            }
            return "file" !== e && this.isSpecial() ? e + "://" + lL(this.host) + (null !== t ? ":" + t : "") : "null";
        },
        getProtocol: function() {
            return this.scheme + ":";
        },
        setProtocol: function(e) {
            this.parse(kM(e) + ":", yL);
        },
        getUsername: function() {
            return this.username;
        },
        setUsername: function(e) {
            var t = vM(kM(e));
            if (!this.cannotHaveUsernamePasswordPort()) {
                this.username = "";
                for(var r = 0; r < t.length; r++)this.username += pL(t[r], dL);
            }
        },
        getPassword: function() {
            return this.password;
        },
        setPassword: function(e) {
            var t = vM(kM(e));
            if (!this.cannotHaveUsernamePasswordPort()) {
                this.password = "";
                for(var r = 0; r < t.length; r++)this.password += pL(t[r], dL);
            }
        },
        getHost: function() {
            var e = this.host, t = this.port;
            return null === e ? "" : null === t ? lL(e) : lL(e) + ":" + t;
        },
        setHost: function(e) {
            this.cannotBeABaseURL || this.parse(e, SL);
        },
        getHostname: function() {
            var e = this.host;
            return null === e ? "" : lL(e);
        },
        setHostname: function(e) {
            this.cannotBeABaseURL || this.parse(e, IL);
        },
        getPort: function() {
            var e = this.port;
            return null === e ? "" : kM(e);
        },
        setPort: function(e) {
            this.cannotHaveUsernamePasswordPort() || ("" === (e = kM(e)) ? this.port = null : this.parse(e, EL));
        },
        getPathname: function() {
            var e = this.path;
            return this.cannotBeABaseURL ? e[0] : e.length ? "/" + OM(e, "/") : "";
        },
        setPathname: function(e) {
            this.cannotBeABaseURL || (this.path = [], this.parse(e, xL));
        },
        getSearch: function() {
            var e = this.query;
            return e ? "?" + e : "";
        },
        setSearch: function(e) {
            "" === (e = kM(e)) ? this.query = null : ("?" === TM(e, 0) && (e = KM(e, 1)), this.query = "", this.parse(e, OL)), this.searchParams.update();
        },
        getSearchParams: function() {
            return this.searchParams.facade;
        },
        getHash: function() {
            var e = this.fragment;
            return e ? "#" + e : "";
        },
        setHash: function(e) {
            "" !== (e = kM(e)) ? ("#" === TM(e, 0) && (e = KM(e, 1)), this.fragment = "", this.parse(e, jL)) : this.fragment = null;
        },
        update: function() {
            this.query = this.searchParams.serialize() || null;
        }
    };
    var ML = function(e) {
        var t = mM(this, LL), r = _M(arguments.length, 1) > 1 ? arguments[1] : void 0, a = wM(t, new BL(e, !1, r));
        iM || (t.href = a.serialize(), t.origin = a.getOrigin(), t.protocol = a.getProtocol(), t.username = a.getUsername(), t.password = a.getPassword(), t.host = a.getHost(), t.hostname = a.getHostname(), t.port = a.getPort(), t.pathname = a.getPathname(), t.search = a.getSearch(), t.searchParams = a.getSearchParams(), t.hash = a.getHash());
    }, LL = ML.prototype, VL = function(e, t) {
        return {
            get: function() {
                return AM(this)[e]();
            },
            set: t && function(e) {
                return AM(this)[t](e);
            },
            configurable: !0,
            enumerable: !0
        };
    };
    if (iM && (pM(LL, "href", VL("serialize", "setHref")), pM(LL, "origin", VL("getOrigin")), pM(LL, "protocol", VL("getProtocol", "setProtocol")), pM(LL, "username", VL("getUsername", "setUsername")), pM(LL, "password", VL("getPassword", "setPassword")), pM(LL, "host", VL("getHost", "setHost")), pM(LL, "hostname", VL("getHostname", "setHostname")), pM(LL, "port", VL("getPort", "setPort")), pM(LL, "pathname", VL("getPathname", "setPathname")), pM(LL, "search", VL("getSearch", "setSearch")), pM(LL, "searchParams", VL("getSearchParams")), pM(LL, "hash", VL("getHash", "setHash"))), dM(LL, "toJSON", function() {
        return AM(this).serialize();
    }, {
        enumerable: !0
    }), dM(LL, "toString", function() {
        return AM(this).serialize();
    }, {
        enumerable: !0
    }), EM) {
        var UL = EM.createObjectURL, KL = EM.revokeObjectURL;
        UL && dM(ML, "createObjectURL", cM(UL, EM)), KL && dM(ML, "revokeObjectURL", cM(KL, EM));
    }
    CM(ML, "URL"), oM({
        global: !0,
        constructor: !0,
        forced: !lM,
        sham: !iM
    }, {
        URL: ML
    });
    var HL = Sr, qL = n, WL = es, GL = vo, YL = vF, QL = oe("URL");
    HL({
        target: "URL",
        stat: !0,
        forced: !(YL && qL(function() {
            QL.canParse();
        }))
    }, {
        canParse: function(e) {
            var t = WL(arguments.length, 1), r = GL(e), a = t < 2 || void 0 === arguments[1] ? void 0 : GL(arguments[1]);
            try {
                return new QL(r, a), true;
            } catch (e) {
                return !1;
            }
        }
    });
    var ZL = t(ee.URL), JL = function(e) {
        var t, r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        try {
            t = new ZL(e);
        } catch (e) {
            return !1;
        }
        return r && "http:" === t.protocol || "https:" === t.protocol;
    };
    function $L(e) {
        var t = e.message, r = e.urls, a = "string" == typeof t, n = AI(r).call(r, function(e) {
            return "string" == typeof e && JL(e);
        });
        return a && n ? function(e, t) {
            return nN("span", {
                className: "adyen-checkout-disclaimer__label"
            }, IC(e, hC(t).call(t, function(e) {
                return function(t) {
                    return nN("a", {
                        className: "adyen-checkout__link",
                        href: e,
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, t);
                };
            })));
        }(t, r) : null;
    }
    var XL = [
        "items",
        "placeholder",
        "issuer",
        "highlightedIds"
    ];
    function eV(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    var tV = function(e, t) {
        var r, a, n = e.issuer, o = e.items, i = null === (r = zb(o).call(o, function(e) {
            return e.id === n;
        })) || void 0 === r ? void 0 : r.name;
        return n && i ? wb(a = "".concat(t.get("continueTo"), " ")).call(a, i) : t.get("continue");
    }, rV = [
        "issuer"
    ], aV = {
        issuer: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "idealIssuer.selectField.placeholder",
            modes: [
                "blur"
            ]
        }
    }, nV = function(e) {
        return e[e.ButtonGroup = 0] = "ButtonGroup", e[e.Dropdown = 1] = "Dropdown", e;
    }(nV || {});
    function oV(e) {
        var t, r = e.items, a = e.placeholder, n = void 0 === a ? "idealIssuer.selectField.placeholder" : a, o = e.issuer, i = e.highlightedIds, l = void 0 === i ? [] : i, s = kg(e, XL), c = sw().i18n, u = _D({
            schema: rV,
            defaultData: {
                issuer: o
            },
            rules: aV
        }), d = u.handleChangeFor, p = u.triggerValidation, m = u.data, f = u.valid, h = u.errors, v = u.isValid, y = Vk(VP("ready"), 2), g = y[0], b = y[1], k = Vk(VP(nV.Dropdown), 2), C = k[0], _ = k[1], N = QO(), P = N.setSRMessagesFromObjects, w = N.shouldMoveFocusSR, A = null == P ? void 0 : P({});
        this.setStatus = function(e) {
            b(e);
        };
        var S = GP(function(e) {
            return function(t) {
                var a = e === nV.Dropdown ? QN : "featured_issuer", n = zb(r).call(r, function(e) {
                    return e.id === t.target.value;
                });
                s.onSubmitAnalytics({
                    type: MN,
                    target: a,
                    issuer: n.name
                }), _(e), d("issuer")(t);
            };
        }, [
            d
        ]), I = GP(function(e) {
            e && s.onSubmitAnalytics({
                type: VN,
                target: QN
            });
        }, []), E = qP(Rz(s.onSubmitAnalytics, 3e3)), D = GP(function() {
            E.current({
                type: UN,
                target: "list_search"
            });
        }, []);
        KP(function() {
            s.onChange({
                data: m,
                valid: f,
                errors: h,
                isValid: v
            });
            var e = null == A ? void 0 : A({
                errors: h,
                isValidating: !0
            });
            (null == e ? void 0 : e.action) === _E && w && tj(".adyen-checkout__issuer-list", e.fieldToFocus);
        }, [
            m,
            f,
            h,
            v
        ]), this.showValidation = function() {
            p();
        };
        var R = tC(r).call(r, function(e, t) {
            return kb(l).call(l, t.id) && e.highlightedItems.push(function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r, a, n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Sg(r = eV(Object(n), !0)).call(r, function(t) {
                        Ag(e, t, n[t]);
                    }) : Jy ? ng(e, Jy(n)) : Sg(a = eV(Object(n))).call(a, function(t) {
                        og(e, t, Wy(n, t));
                    });
                }
                return e;
            }({}, t)), e;
        }, {
            highlightedItems: []
        }), F = R.highlightedItems;
        return nN("div", {
            className: "adyen-checkout__issuer-list"
        }, !!F.length && nN(iN, null, nN(BB, {
            selectedIssuerId: C === nV.ButtonGroup ? m.issuer : null,
            items: F,
            onChange: S(nV.ButtonGroup)
        }), nN(MB, null)), nN(FE, {
            errorMessage: function(e) {
                return e && e.errorMessage ? c.get(e.errorMessage) : !!e;
            }(h.issuer),
            classNameModifiers: [
                "issuer-list"
            ],
            name: "issuer"
        }, nN(cz, {
            items: r,
            selectedValue: C === nV.Dropdown ? m.issuer : null,
            placeholder: c.get(n),
            name: "issuer",
            className: "adyen-checkout__issuer-list__dropdown",
            onChange: S(nV.Dropdown),
            onListToggle: I,
            onInput: D
        })), s.termsAndConditions && nN("div", {
            className: "adyen-checkout__issuer-list__termsAndConditions"
        }, nN($L, {
            message: c.get(s.termsAndConditions.translationKey),
            urls: s.termsAndConditions.urls
        })), s.showPayButton && s.payButton({
            status: g,
            label: tV({
                issuer: m.issuer,
                items: wb(t = []).call(t, Uk(r), Uk(F))
            }, c)
        }));
    }
    function iV(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    oV.defaultProps = {
        onChange: function() {}
    };
    var lV = function(e, t, r) {
        return function(a) {
            if (!a) return null;
            var n = function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r, a, n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Sg(r = iV(Object(n), !0)).call(r, function(t) {
                        Ag(e, t, n[t]);
                    }) : Jy ? ng(e, Jy(n)) : Sg(a = iV(Object(n))).call(a, function(t) {
                        og(e, t, Wy(n, t));
                    });
                }
                return e;
            }({
                parentFolder: a ? "".concat(t, "/") : "",
                type: a || t
            }, e);
            return r(n)(a);
        };
    }, sV = [
        "label",
        "icon",
        "payButton",
        "onSubmit",
        "amount",
        "name"
    ];
    function cV(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function uV(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = cV(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = cV(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function dV(e) {
        var t = e.label, r = void 0 === t ? null : t, a = e.icon, n = void 0 === a ? null : a, o = e.payButton, i = e.onSubmit, l = e.amount, s = void 0 === l ? null : l, c = e.name, u = kg(e, sV), d = sw().i18n, p = Vk(VP("ready"), 2), m = p[0], f = p[1];
        this.setStatus = function(e) {
            f(e);
        };
        return nN(iN, null, o(uV(uV({}, u), {}, {
            status: m,
            icon: n,
            classNameModifiers: [
                "standalone"
            ],
            label: r || function() {
                var e, t;
                return s && ({}).hasOwnProperty.call(s, "value") && 0 === s.value ? wb(e = "".concat(d.get("preauthorizeWith"), " ")).call(e, c) : wb(t = "".concat(d.get("continueTo"), " ")).call(t, c);
            }(),
            onClick: i
        })));
    }
    function pV(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function mV(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = pV(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = pV(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function fV(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var hV = function(e) {
        U_(r, e);
        var t = fV(r);
        function r(e) {
            var a;
            Cg(this, r);
            if ((a = t.call(this, e)).props.showImage) {
                var n, o = lV({
                    loadingContext: a.props.loadingContext
                }, a.constructor.type, function(e) {
                    return a.resources.getImage(e);
                });
                a.props.issuers = hC(n = a.props.issuers).call(n, function(e) {
                    return mV(mV({}, e), {}, {
                        icon: o(e.id)
                    });
                });
            }
            return a;
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t, r = e.details && e.details.length && (zb(t = e.details).call(t, function(e) {
                        return "issuer" === e.key;
                    }) || {}).items || e.issuers || [];
                    return mV(mV({}, e), {}, {
                        issuers: r
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e;
                    return {
                        paymentMethod: {
                            type: this.constructor.type,
                            issuer: null === (e = this.state) || void 0 === e || null === (e = e.data) || void 0 === e ? void 0 : e.issuer
                        }
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    var e;
                    return 0 === this.props.issuers.length || !(null === (e = this.state) || void 0 === e || !e.isValid);
                }
            },
            {
                key: "brands",
                get: function() {
                    var e;
                    return this.props.showPaymentMethodItemImages ? hC(e = this.props.issuers).call(e, function(e) {
                        return {
                            icon: e.icon,
                            name: e.id
                        };
                    }) : [];
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.issuers.length > 0 ? nN(_j, {
                        srPanel: this.props.modules.srPanel
                    }, nN(oV, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        },
                        items: this.props.issuers,
                        highlightedIds: this.props.highlightedIssuers
                    }, this.props, this.state, {
                        showImage: this.props.showImage,
                        type: this.constructor.type,
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton,
                        onSubmitAnalytics: this.submitAnalytics
                    }))) : this.props.showPayButton && nN(dV, M_({
                        name: this.props.name
                    }, this.props, {
                        onSubmit: this.submit,
                        payButton: this.payButton,
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    })));
                }
            }
        ]), r;
    }(qS);
    function vV(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function yV(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = vV(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = vV(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function gV(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(hV, "defaultProps", {
        showImage: !0,
        onValid: function() {},
        issuers: [],
        highlightedIssuers: [],
        loadingContext: ST,
        showPaymentMethodItemImages: !1,
        showPayButton: !0
    });
    var bV = function(e) {
        U_(r, e);
        var t = gV(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return yV(yV({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1
                    });
                }
            }
        ]), r;
    }(hV);
    function kV(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function CV(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = kV(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = kV(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function _V(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(bV, "type", "billdesk_online");
    var NV = function(e) {
        U_(r, e);
        var t = _V(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return CV(CV({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1,
                        placeholder: "issuerList.wallet.placeholder"
                    });
                }
            }
        ]), r;
    }(hV);
    Ag(NV, "type", "billdesk_wallet");
    var PV, wV, AV, SV, IV = function(e, t) {
        return t === FI ? (e[xI] = !1, e[TI] = !1) : e[t] = !1, e;
    }, EV = function(e, t) {
        return function(r, a) {
            var n = !0 !== t.valid[a] ? function(e, t) {
                return 1 !== t || e !== xI && e !== TI ? e : FI;
            }(a, e) : null;
            return n = function(e, t, r) {
                var a = tC(r).call(r, function(r, a) {
                    return r.isFieldOfType || (r.isFieldOfType = e === a, r.fieldIsValid = !t.errors[a]), r;
                }, {
                    isFieldOfType: !1,
                    fieldIsValid: !1
                }), n = a.isFieldOfType, o = a.fieldIsValid, i = e === zI ? "cvcPolicy" : "expiryDatePolicy", l = "cvcPolicy" === i ? $I : tE, s = "cvcPolicy" === i ? XI : rE;
                return (t[i] === l || t[i] === s) && o && n ? null : e;
            }(n, t, [
                zI,
                FI,
                xI,
                TI
            ]), n && !kb(r).call(r, n) && r.push(n), r;
        };
    }, DV = wg(function e(t) {
        Cg(this, e), Ag(this, "callbacks", void 0), Ag(this, "config", void 0), Ag(this, "props", void 0), Ag(this, "state", void 0), Ag(this, "validateForm", void 0), Ag(this, "handleBrandFromBinLookup", void 0), Ag(this, "callbacksHandler", void 0), Ag(this, "configHandler", void 0), Ag(this, "createCardSecuredFields", void 0), Ag(this, "createNonCardSecuredFields", void 0), Ag(this, "createSecuredFields", void 0), Ag(this, "destroySecuredFields", void 0), Ag(this, "handleIOSTouchEvents", void 0), Ag(this, "destroyTouchendListener", void 0), Ag(this, "destroyTouchstartListener", void 0), Ag(this, "handleBinValue", void 0), Ag(this, "handleEncryption", void 0), Ag(this, "handleFocus", void 0), Ag(this, "handleIframeConfigFeedback", void 0), Ag(this, "handleValidation", void 0), Ag(this, "handleSFShiftTab", void 0), Ag(this, "handleShiftTab", void 0), Ag(this, "isConfigured", void 0), Ag(this, "postMessageToAllIframes", void 0), Ag(this, "processAutoComplete", void 0), Ag(this, "processBrand", void 0), Ag(this, "sendBrandToCardSF", void 0), Ag(this, "sendExpiryDatePolicyToSF", void 0), Ag(this, "setFocusOnFrame", void 0), Ag(this, "setupSecuredField", void 0), Ag(this, "touchendListener", void 0), Ag(this, "touchstartListener", void 0), Ag(this, "hasGenuineTouchEvents", void 0), Ag(this, "encryptedAttrName", void 0), Ag(this, "hasRedundantCVCField", void 0), Ag(this, "isSingleBrandedCard", void 0), Ag(this, "securityCode", void 0), this.props = t, this.state = {}, this.config = {}, this.callbacks = {};
    }), RV = "undefined" != typeof window && window.console && window.console.error && Jg(PV = window.console.error).call(PV, window.console);
    "undefined" != typeof window && window.console && window.console.info && Jg(wV = window.console.info).call(wV, window.console);
    var FV = "undefined" != typeof window && window.console && window.console.log && Jg(AV = window.console.log).call(AV, window.console), xV = "undefined" != typeof window && window.console && window.console.warn && Jg(SV = window.console.warn).call(SV, window.console);
    function TV(e) {
        var t, r, a, n, o, i;
        this.config.cardGroupTypes = hj(i = e.cardGroupTypes) && i.length ? i : UI;
        var l = e.loadingContext;
        if (l) {
            var s;
            this.config.loadingContext = "/" === (s = l).charAt(s.length - 1) ? l : "".concat(l, "/"), this.config.isCreditCardType = !1 === kb(KI).call(KI, e.type), this.config.iframeUIConfig = e.iframeUIConfig, this.config.allowedDOMAccess = !(!1 === e.allowedDOMAccess || "false" === e.allowedDOMAccess), this.config.autoFocus = !(!1 === e.autoFocus || "false" === e.autoFocus), this.config.showWarnings = !0 === e.showWarnings || "true" === e.showWarnings, this.config.trimTrailingSeparator = !(!1 === e.trimTrailingSeparator || "false" === e.trimTrailingSeparator), this.config.keypadFix = !(!1 === e.keypadFix || "false" === e.keypadFix), this.config.legacyInputMode = e.legacyInputMode || null, this.config.minimumExpiryDate = e.minimumExpiryDate || null, this.config.implementationType = e.implementationType, this.config.sfLogAtStart = !0 === window._b$dl;
            var c = this.config.isCreditCardType ? "card" : e.type;
            Kk(c).call(c, "sepa") > -1 && (c = "iban");
            var u = btoa(window.location.origin), d = !!e.forceCompat || !("function" == typeof window.TextEncoder), p = wb(t = "".concat(c)).call(t, d ? "Compat" : "");
            this.config.iframeSrc = wb(r = wb(a = wb(n = wb(o = "".concat(this.config.loadingContext, "securedfields/")).call(o, e.clientKey, "/")).call(n, "4.9.0", "/securedFields.html?type=")).call(a, p, "&d=")).call(r, u), this.config.maskSecurityCode = e.maskSecurityCode, this.config.shouldDisableIOSArrowKeys = e.shouldDisableIOSArrowKeys;
        } else xV("WARNING Config :: no loadingContext has been specified!");
    }
    var zV = function() {};
    function OV() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        this.callbacks.onLoad = e.onLoad ? e.onLoad : zV, this.callbacks.onConfigSuccess = e.onConfigSuccess ? e.onConfigSuccess : zV, this.callbacks.onFieldValid = e.onFieldValid ? e.onFieldValid : zV, this.callbacks.onAllValid = e.onAllValid ? e.onAllValid : zV, this.callbacks.onBrand = e.onBrand ? e.onBrand : zV, this.callbacks.onError = e.onError ? e.onError : zV, this.callbacks.onFocus = e.onFocus ? e.onFocus : zV, this.callbacks.onBinValue = e.onBinValue ? e.onBinValue : zV, this.callbacks.onAutoComplete = e.onAutoComplete ? e.onAutoComplete : zV, this.callbacks.onAdditionalSFConfig = e.onAdditionalSFConfig ? e.onAdditionalSFConfig : zV, this.callbacks.onAdditionalSFRemoved = e.onAdditionalSFRemoved ? e.onAdditionalSFRemoved : zV, this.callbacks.onTouchstartIOS = e.onTouchstartIOS ? e.onTouchstartIOS : zV;
    }
    var jV = function(e) {
        return {
            fieldType: e.fieldType,
            encryptedFieldName: e.encryptedFieldName,
            uid: e.uuid,
            valid: e.isValid,
            type: e.txVariant,
            rootNode: e.rootNode
        };
    }, BV = function(e, t, r, a, n) {
        if (!VS(e, "error")) return null;
        var o = t, i = {
            rootNode: a,
            fieldType: e.fieldType,
            error: null,
            type: null
        }, l = "" !== e.error;
        return l || o.hasError ? o.errorType === bE[uE] ? null : (i.error = l ? e.error : "", i.type = r, o.hasError = l, o.errorType = i.error, n(i), i) : null;
    };
    function MV(e) {
        var t, r, a, n, o = e.fieldType;
        if ("card" === this.state.type && VS(e, "cvcPolicy") && vj(e.cvcPolicy) && VS(this.state.securedFields, zI) && (this.state.securedFields[zI].cvcPolicy = e.cvcPolicy), BV(e, this.state.securedFields[o], this.state.type, this.props.rootNode, this.callbacks.onError), this.state.securedFields[o].isEncrypted) {
            t = function(e) {
                var t, r, a, n = e.fieldType, o = e.txVariant, i = e.rootNode, l = n === FI, s = [], c = [
                    "encryptedExpiryMonth",
                    "encryptedExpiryYear"
                ], u = l ? 2 : 1;
                for(t = 0; t < u; t += 1){
                    var d;
                    a = l ? c[t] : n, r = wb(d = "".concat(o, "-encrypted-")).call(d, a);
                    var p = jV({
                        fieldType: n,
                        encryptedFieldName: l ? a : n,
                        uuid: r,
                        isValid: !1,
                        txVariant: o,
                        rootNode: i
                    });
                    s.push(p);
                }
                return s;
            }({
                fieldType: o,
                txVariant: this.state.type,
                rootNode: this.props.rootNode
            }), o === RI && (t[0].endDigits = "");
            for(var i = 0, l = t.length; i < l; i += 1)this.config.allowedDOMAccess && (r = this.props.rootNode, a = t[i].uid, n = void 0, (n = JO(r, "#".concat(a))) && r.removeChild(n)), this.callbacks.onFieldValid(t[i]);
            this.state.securedFields[o].isEncrypted = !1;
        }
        this.validateForm(), VS(e, "brand") && this.processBrand(e);
    }
    var LV, VV = function(e, t, r) {
        if (t) {
            var a = Mb(e);
            t.postMessage(a, r);
        }
    };
    function UV(e, t) {
        var r;
        return (null === (r = e.securedFields[t]) || void 0 === r ? void 0 : r.iframeContentWindow) || null;
    }
    function KV(e) {
        var t, r, a = e.fieldType;
        this.config.autoFocus && ("year" !== e.type && a !== TI || this.setFocusOnFrame(zI), a === xI && this.setFocusOnFrame(TI));
        var n = e[a];
        this.state.securedFields[a].isEncrypted = !0, this.config.allowedDOMAccess && function(e, t, r) {
            var a, n, o, i, l, s, c, u;
            for(a = 0; a < e.length; a += 1){
                var d, p = e[a];
                o = p.encryptedFieldName, n = wb(d = "".concat(t, "-encrypted-")).call(d, o), l = o, s = p.blob, u = void 0, (u = JO(i = r, "#".concat(c = n))) || ((u = document.createElement("input")).type = "hidden", u.name = l, u.id = c, i.appendChild(u)), u.setAttribute("value", s);
            }
        }(n, this.state.type, this.props.rootNode), BV({
            error: "",
            fieldType: a
        }, this.state.securedFields[a], this.state.type, this.props.rootNode, this.callbacks.onError);
        var o = function(e) {
            var t, r, a, n, o, i = e.fieldType, l = e.txVariant, s = e.rootNode, c = e.encryptedObjArr, u = [];
            for(t = 0; t < c.length; t += 1){
                var d;
                n = (a = c[t]).encryptedFieldName, r = wb(d = "".concat(l, "-encrypted-")).call(d, n), o = a.blob;
                var p = jV({
                    fieldType: i,
                    encryptedFieldName: n,
                    uuid: r,
                    isValid: !0,
                    txVariant: l,
                    rootNode: s
                });
                p.blob = o, u.push(p);
            }
            return u;
        }({
            fieldType: a,
            txVariant: this.state.type,
            rootNode: this.props.rootNode,
            encryptedObjArr: n
        });
        if (a === xI && VS(this.state.securedFields, TI)) {
            var i = {
                txVariant: this.state.type,
                code: e.code,
                blob: n[0].blob,
                fieldType: TI,
                numKey: this.state.securedFields[TI].numKey
            };
            VV(i, UV(this.state, TI), this.config.loadingContext);
        }
        for(a === RI && yj(e.endDigits) && (o[0].endDigits = e.endDigits), a === RI && yj(e.issuerBin) && (o[0].issuerBin = +e.issuerBin), a === FI && yj(e.expiryDate) && (o[1].expiryDate = e.expiryDate), t = 0, r = o.length; t < r; t += 1)this.callbacks.onFieldValid(o[t]);
        this.validateForm();
    }
    var HV = {
        __NO_BRAND: "noBrand",
        cards: []
    };
    HV.cards.push({
        cardType: "mc",
        startingRules: [
            51,
            52,
            53,
            54,
            55,
            22,
            23,
            24,
            25,
            26,
            27
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(5[1-5][0-9]{0,14}|2[2-7][0-9]{0,14})$/,
        securityCode: "CVC"
    }), HV.cards.push({
        cardType: "visadankort",
        startingRules: [
            4571
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(4571)[0-9]{0,12}$/
    }), HV.cards.push({
        cardType: "visa",
        startingRules: [
            4
        ],
        permittedLengths: [
            13,
            16,
            19
        ],
        pattern: /^4[0-9]{0,18}$/,
        securityCode: "CVV"
    }), HV.cards.push({
        cardType: "amex",
        startingRules: [
            34,
            37
        ],
        permittedLengths: [
            15
        ],
        pattern: /^3[47][0-9]{0,13}$/,
        securityCode: "CID"
    }), HV.cards.push({
        cardType: "diners",
        startingRules: [
            36
        ],
        permittedLengths: [
            14,
            16
        ],
        pattern: /^(36)[0-9]{0,12}$/
    }), HV.cards.push({
        cardType: "maestrouk",
        startingRules: [
            6759
        ],
        permittedLengths: [
            16,
            18,
            19
        ],
        pattern: /^(6759)[0-9]{0,15}$/
    }), HV.cards.push({
        cardType: "solo",
        startingRules: [
            6767
        ],
        permittedLengths: [
            16,
            18,
            19
        ],
        pattern: /^(6767)[0-9]{0,15}$/
    }), HV.cards.push({
        cardType: "laser",
        startingRules: [
            6304,
            6706,
            677117,
            677120
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^(6304|6706|6709|6771)[0-9]{0,15}$/,
        cvcPolicy: "optional"
    }), HV.cards.push({
        cardType: "discover",
        startingRules: [
            6011,
            644,
            645,
            646,
            647,
            648,
            649,
            65
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^(6011[0-9]{0,12}|(644|645|646|647|648|649)[0-9]{0,13}|65[0-9]{0,14})$/
    }), HV.cards.push({
        cardType: "jcb",
        startingRules: [
            3528,
            3529,
            353,
            354,
            355,
            356,
            357,
            358
        ],
        permittedLengths: [
            16,
            19
        ],
        pattern: /^(352[8,9]{1}[0-9]{0,15}|35[4-8]{1}[0-9]{0,16})$/,
        securityCode: "CAV"
    }), HV.cards.push({
        cardType: "bcmc",
        startingRules: [
            6703,
            479658,
            606005
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^((6703)[0-9]{0,15}|(479658|606005)[0-9]{0,13})$/,
        cvcPolicy: "hidden"
    }), HV.cards.push({
        cardType: "bijcard",
        startingRules: [
            5100081
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(5100081)[0-9]{0,9}$/
    }), HV.cards.push({
        cardType: "dankort",
        startingRules: [
            5019
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(5019)[0-9]{0,12}$/
    }), HV.cards.push({
        cardType: "hipercard",
        startingRules: [
            606282
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(606282)[0-9]{0,10}$/
    }), HV.cards.push({
        cardType: "cup",
        startingRules: [
            62,
            81
        ],
        permittedLengths: [
            14,
            15,
            16,
            17,
            18,
            19
        ],
        pattern: /^(62|81)[0-9]{0,17}$/
    }), HV.cards.push({
        cardType: "maestro",
        startingRules: [
            50,
            56,
            57,
            58,
            6
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^(5[0|6-8][0-9]{0,17}|6[0-9]{0,18})$/,
        cvcPolicy: "optional"
    }), HV.cards.push({
        cardType: "elo",
        startingRules: [
            506699,
            50670,
            50671,
            50672,
            50673,
            50674,
            50675,
            50676,
            506770,
            506771,
            506772,
            506773,
            506774,
            506775,
            506776,
            506777,
            506778,
            401178,
            438935,
            451416,
            457631,
            457632,
            504175,
            627780,
            636297,
            636368
        ],
        permittedLengths: [
            16
        ],
        pattern: /^((((506699)|(506770)|(506771)|(506772)|(506773)|(506774)|(506775)|(506776)|(506777)|(506778)|(401178)|(438935)|(451416)|(457631)|(457632)|(504175)|(627780)|(636368)|(636297))[0-9]{0,10})|((50676)|(50675)|(50674)|(50673)|(50672)|(50671)|(50670))[0-9]{0,11})$/
    }), HV.cards.push({
        cardType: "uatp",
        startingRules: [
            1
        ],
        permittedLengths: [
            15
        ],
        pattern: /^1[0-9]{0,14}$/,
        cvcPolicy: "optional"
    }), HV.cards.push({
        cardType: "cartebancaire",
        startingRules: [
            4,
            5,
            6
        ],
        permittedLengths: [
            16
        ],
        pattern: /^[4-6][0-9]{0,15}$/
    }), HV.cards.push({
        cardType: "visaalphabankbonus",
        startingRules: [
            450903
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(450903)[0-9]{0,10}$/
    }), HV.cards.push({
        cardType: "mcalphabankbonus",
        startingRules: [
            510099
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(510099)[0-9]{0,10}$/
    }), HV.cards.push({
        cardType: "hiper",
        startingRules: [
            637095,
            637568,
            637599,
            637609,
            637612
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(637095|637568|637599|637609|637612)[0-9]{0,10}$/
    }), HV.cards.push({
        cardType: "oasis",
        startingRules: [
            982616
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(982616)[0-9]{0,10}$/,
        cvcPolicy: "optional"
    }), HV.cards.push({
        cardType: "karenmillen",
        startingRules: [
            98261465
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(98261465)[0-9]{0,8}$/,
        cvcPolicy: "optional"
    }), HV.cards.push({
        cardType: "warehouse",
        startingRules: [
            982633
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(982633)[0-9]{0,10}$/,
        cvcPolicy: "optional"
    }), HV.cards.push({
        cardType: "mir",
        startingRules: [
            220
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^(220)[0-9]{0,16}$/
    }), HV.cards.push({
        cardType: "codensa",
        startingRules: [
            590712
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(590712)[0-9]{0,10}$/
    }), HV.cards.push({
        cardType: "naranja",
        startingRules: [
            377798,
            377799,
            402917,
            402918,
            527571,
            527572,
            589562
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^(37|40|5[28])([279])\d*$/
    }), HV.cards.push({
        cardType: "cabal",
        startingRules: [
            589657,
            600691,
            603522,
            6042,
            6043,
            636908
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^(58|6[03])([03469])\d*$/
    }), HV.cards.push({
        cardType: "shopping",
        startingRules: [
            2799,
            589407,
            603488
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^(27|58|60)([39])\d*$/
    }), HV.cards.push({
        cardType: "argencard",
        startingRules: [
            501
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^(50)(1)\d*$/
    }), HV.cards.push({
        cardType: "troy",
        startingRules: [
            9792
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(97)(9)\d*$/
    }), HV.cards.push({
        cardType: "forbrugsforeningen",
        startingRules: [
            600722
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(60)(0)\d*$/
    }), HV.cards.push({
        cardType: "vpay",
        startingRules: [
            401,
            408,
            413,
            434,
            435,
            437,
            439,
            441,
            442,
            443,
            444,
            446,
            447,
            455,
            458,
            460,
            461,
            463,
            466,
            471,
            479,
            482,
            483,
            487
        ],
        permittedLengths: [
            13,
            14,
            15,
            16,
            17,
            18,
            19
        ],
        pattern: /^(40[1,8]|413|43[4,5]|44[1,2,3,4,6,7]|45[5,8]|46[0,1,3,6]|47[1,9]|48[2,3,7])[0-9]{0,16}$/
    }), HV.cards.push({
        cardType: "rupay",
        startingRules: [
            508528
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(100003|508(2|[5-9])|60(69|[7-8])|652(1[5-9]|[2-5][0-9]|8[5-9])|65300[3-4]|8172([0-1]|[3-5]|7|9)|817(3[3-8]|40[6-9]|410)|35380([0-2]|[5-6]|9))[0-9]{0,12}$/
    }), HV.cards.push({
        cardType: "ticket",
        expiryDatePolicy: "hidden"
    });
    var qV = {
        detectCard: function(e, t) {
            var r, a, n;
            if (t) {
                var o, i;
                if ((r = xg(o = xg(i = HV.cards).call(i, function(e) {
                    return kb(t).call(t, e.cardType);
                })).call(o, function(t) {
                    return VS(t, "pattern") && e.match(t.pattern);
                })).length) {
                    if (1 === r.length) return r[0];
                    for(a = 0, n = r.length; a < n; a += 1)if (!r[a].longestRule) {
                        var l, s = tC(l = r[a].startingRules).call(l, function(e, t) {
                            return e > t ? e : t;
                        });
                        r[a].longestRule = String(s).length;
                    }
                    return tC(r).call(r, function(e, t) {
                        return e.longestRule >= t.longestRule ? e : t;
                    });
                }
                return {
                    cardType: HV.__NO_BRAND
                };
            }
            return {
                cardType: HV.__NO_BRAND
            };
        },
        detectCardLength: function(e, t) {
            var r, a, n, o = 0, i = !1, l = t, s = e.cardType !== HV.__NO_BRAND ? e.permittedLengths[e.permittedLengths.length - 1] : 0;
            if (s && l > s && (o = l.length - s) > 0 && (n = l = l.substring(0, l.length - o)), Sg(r = e.permittedLengths).call(r, function(e) {
                l.length === e && (i = !0);
            }), l.length === s) {
                var c = Math.floor(l.length / 4);
                a = s + (l.length % 4 > 0 ? c : c - 1), "amex" === e.cardType.toLowerCase() && (a = s + 2);
            }
            return {
                shortenedNewValue: n,
                maxLength: a,
                reachedValidLength: i
            };
        },
        getShortestPermittedCardLength: function() {
            if (!LV) {
                var e, t = [];
                Sg(e = HV.cards).call(e, function(e) {
                    var r;
                    t = wb(t).call(t, null !== (r = e.permittedLengths) && void 0 !== r ? r : []);
                }), LV = Math.min.apply(null, t);
            }
            return LV;
        },
        getCardByBrand: function(e) {
            var t;
            return xg(t = HV.cards).call(t, function(t) {
                return t.cardType === e;
            })[0];
        },
        isGenericCardType: function(e) {
            if (!e) throw new Error("Error: isGenericCardType: type param has not been specified");
            return "card" === e || "scheme" === e;
        },
        __NO_BRAND: HV.__NO_BRAND,
        allCards: HV.cards
    };
    function WV(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function GV(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = WV(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = WV(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var YV = function(e, t) {
        var r = "card" === e ? "nocard" : e || "nocard", a = {
            type: r,
            extension: "svg"
        };
        return t.getImage(a)(r);
    }, QV = function(e) {
        var t = e.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
        return kb(WI).call(WI, e) && (t = t.substring(10)), t;
    };
    function ZV() {
        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
        var a = hj(t[0]) ? t[0] : t;
        return {
            from: function(e) {
                var t;
                return tC(t = hC(a).call(a, function(t) {
                    return t in e ? Ag({}, t, e[t]) : {};
                })).call(t, function(e, t) {
                    return GV(GV({}, e), t);
                }, {});
            }
        };
    }
    function JV() {
        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
        var a = hj(t[0]) ? t[0] : t;
        return {
            from: function(e) {
                var t, r = xg(t = Ty(e)).call(t, function(e) {
                    return !kb(a).call(a, e);
                });
                return ZV.apply(void 0, Uk(r)).from(e);
            }
        };
    }
    function $V(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function XV(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = $V(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = $V(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function eU(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function tU(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = eU(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = eU(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function rU(e, t, r) {
        var a = e.txVariant, n = function(e) {
            var t = Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag({}, RI, e.get && e.get("creditCard.numberField.placeholder")), FI, e.get && e.get("creditCard.expiryDateField.placeholder")), xI, e.get && e.get("creditCard.expiryDateField.month.placeholder")), TI, e.get && e.get("creditCard.expiryDateField.year.placeholder")), zI, e.get && e.get("creditCard.cvcField.placeholder")), MI, e.get && e.get("creditCard.cvcField.placeholder.3digits")), LI, e.get && e.get("creditCard.cvcField.placeholder.4digits")), OI, e.get && e.get("creditCard.encryptedPassword.placeholder")), jI, e.get && e.get("ach.accountNumberField.placeholder")), BI, e.get && e.get("ach.accountLocationId.placeholder"));
            return "ach.accountNumberField.placeholder" === t[jI] && (t[jI] = ""), "ach.accountLocationId.placeholder" === t[BI] && (t[BI] = ""), t;
        }(r);
        return tU(tU(tU({}, t !== zI && Ag({}, t, n[t])), t === zI && a === VI && Ag({}, t, n[t])), t === zI && a !== VI && Ag(Ag({}, MI, n[MI]), LI, n[LI]));
    }
    function aU(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function nU(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = aU(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = aU(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function oU(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var iU = function(e) {
        U_(r, e);
        var t = oU(r);
        function r(e, a) {
            var n;
            Cg(this, r), n = t.call(this);
            var o = [
                "fieldType",
                "iframeSrc",
                "cvcPolicy",
                "expiryDatePolicy",
                "loadingContext",
                "holderEl"
            ], i = JV(o).from(e);
            n.sfConfig = nU(nU(nU({}, n.sfConfig), i), {}, {
                iframeUIConfig: nU({}, i.iframeUIConfig)
            });
            var l = ZV(o).from(e);
            return n.fieldType = l.fieldType, n.cvcPolicy = l.cvcPolicy, n.expiryDatePolicy = l.expiryDatePolicy, n.iframeSrc = l.iframeSrc, n.loadingContext = l.loadingContext, n.holderEl = l.holderEl, n.isValid = !1, n.iframeContentWindow = null, n.numKey = function() {
                if (!window.crypto) return 4294967296 * Math.random() | 0;
                var e = new Uint32Array(1);
                return window.crypto.getRandomValues(e), e[0];
            }(), n.isEncrypted = !1, n.hasError = !1, n.errorType = "", K_(n, n.init(a));
        }
        return wg(r, [
            {
                key: "init",
                value: function(e) {
                    var t = function(e, t, r) {
                        var a, n, o, i = kb(a = [
                            "ach",
                            "giftcard"
                        ]).call(a, e.txVariant) ? e.txVariant : "creditCard", l = r.get(wb(n = "".concat(i, ".")).call(n, t, ".aria.iframeTitle")), s = r.get(wb(o = "".concat(i, ".")).call(o, t, ".aria.label")), c = r.locale, u = HO({
                            iframeTitle: l,
                            label: s
                        }, r);
                        return XV(XV({}, c && {
                            lang: c
                        }), {}, Ag({}, t, u));
                    }(this.sfConfig, this.fieldType, e);
                    this.sfConfig.iframeUIConfig.ariaConfig = t;
                    var r = rU(this.sfConfig, this.fieldType, e);
                    this.sfConfig.iframeUIConfig.placeholders = r;
                    var a = function(e) {
                        var t = e.src, r = e.title, a = void 0 === r ? "iframe element" : r, n = e.policy, o = void 0 === n ? "origin" : n, i = document.createElement("iframe");
                        i.setAttribute("src", t), i.classList.add("js-iframe"), "" === a || 0 === ID(a).call(a).length || "none" === a ? i.setAttribute("role", "presentation") : i.setAttribute("title", a), i.setAttribute("allowtransparency", "true"), i.setAttribute("referrerpolicy", o);
                        var l = document.createTextNode("<p>Your browser does not support iframes.</p>");
                        return i.appendChild(l), i;
                    }({
                        src: this.iframeSrc,
                        title: t[this.fieldType].iframeTitle,
                        policy: "origin"
                    });
                    this.holderEl.appendChild(a);
                    var n = JO(this.holderEl, ".js-iframe");
                    return n && (this.iframeContentWindow = n.contentWindow, this.iframeOnLoadListener = this.iframeOnLoadListenerFn, XO(n, "load", this.iframeOnLoadListener, !1)), this.iframeRef = n, this;
                }
            },
            {
                key: "iframeOnLoadListenerFn",
                value: function() {
                    this.postMessageListener = this.postMessageListenerFn, XO(window, "message", this.postMessageListener, !1);
                    var e = {
                        fieldType: this.fieldType,
                        extraFieldData: this.sfConfig.extraFieldData,
                        uid: this.sfConfig.uid,
                        cvcPolicy: this.cvcPolicy,
                        expiryDatePolicy: this.expiryDatePolicy,
                        numKey: this.numKey,
                        txVariant: this.sfConfig.txVariant,
                        cardGroupTypes: this.sfConfig.cardGroupTypes,
                        iframeUIConfig: this.sfConfig.iframeUIConfig,
                        sfLogAtStart: this.sfConfig.sfLogAtStart,
                        trimTrailingSeparator: this.sfConfig.trimTrailingSeparator,
                        isCreditCardType: this.sfConfig.isCreditCardType,
                        showWarnings: this.sfConfig.showWarnings,
                        legacyInputMode: this.sfConfig.legacyInputMode,
                        minimumExpiryDate: this.sfConfig.minimumExpiryDate,
                        implementationType: this.sfConfig.implementationType,
                        maskSecurityCode: this.sfConfig.maskSecurityCode,
                        exposeExpiryDate: this.sfConfig.exposeExpiryDate,
                        disableIOSArrowKeys: this.sfConfig.disableIOSArrowKeys
                    };
                    window._b$dl && console.log("### SecuredField:::: onIframeLoaded:: created configObj=", e), VV(e, this.iframeContentWindow, this.loadingContext), this.onIframeLoadedCallback();
                }
            },
            {
                key: "postMessageListenerFn",
                value: function(e) {
                    if (function(e, t, r) {
                        var a = e.origin, n = Kk(t).call(t, "/checkoutshopper/"), o = n > -1 ? t.substring(0, n) : t, i = o.length - 1;
                        return "/" === o.charAt(i) && (o = o.substring(0, i)), a === o || (r && (xV("WARNING postMessageValidation: postMessage listener for iframe::origin mismatch!\n Received message with origin:", a, "but the only allowed origin for messages to CSF is", o), xV("### event.data=", e.data)), !1);
                    }(e, this.loadingContext, this.sfConfig.showWarnings)) {
                        var t;
                        try {
                            t = JSON.parse(e.data);
                        } catch (t) {
                            return function(e) {
                                var t;
                                return e.data && e.data.type && "string" == typeof e.data.type && Kk(t = e.data.type).call(t, "webpack") > -1;
                            }(e) ? void (this.sfConfig.showWarnings && FV("### SecuredField::postMessageListenerFn:: PARSE FAIL - WEBPACK")) : function(e) {
                                var t;
                                return e.data && "string" == typeof e.data && Kk(t = e.data).call(t, "cvox") > -1;
                            }(e) ? void (this.sfConfig.showWarnings && FV("### SecuredField::postMessageListenerFn:: PARSE FAIL - CHROMEVOX")) : void (this.sfConfig.showWarnings && FV("### SecuredField::postMessageListenerFn:: PARSE FAIL - UNKNOWN REASON: event.data=", e.data));
                        }
                        if (VS(t, "action") && VS(t, "numKey")) {
                            if (this.numKey === t.numKey) switch(t.action){
                                case "encryption":
                                    this.isValid = !0, this.onEncryptionCallback(t);
                                    break;
                                case "config":
                                    window._b$dl && console.log("### SecuredField::postMessageListenerFn:: configured - calling onConfigCallback", t.fieldType), this.onConfigCallback(t);
                                    break;
                                case "focus":
                                    this.onFocusCallback(t);
                                    break;
                                case "binValue":
                                    this.onBinValueCallback(t);
                                    break;
                                case "touch":
                                    this.onTouchstartCallback(t);
                                    break;
                                case "shifttab":
                                    this.onShiftTabCallback(t);
                                    break;
                                case "autoComplete":
                                    this.onAutoCompleteCallback(t);
                                    break;
                                default:
                                    this.isValid = !1, this.onValidationCallback(t);
                            }
                            else this.sfConfig.showWarnings && xV("WARNING SecuredField :: postMessage listener for iframe :: data mismatch! (Probably a message from an unrelated securedField)");
                        } else this.sfConfig.showWarnings && xV("WARNING SecuredField :: postMessage listener for iframe :: data mismatch!");
                    }
                }
            },
            {
                key: "destroy",
                value: function() {
                    ej(window, "message", this.postMessageListener, !1), ej(this.iframeRef, "load", this.iframeOnLoadListener, !1), this.iframeContentWindow = null, function(e) {
                        for(; e.firstChild;)e.removeChild(e.firstChild);
                    }(this.holderEl);
                }
            },
            {
                key: "isOptionalOrHidden",
                value: function() {
                    if (this.fieldType === FI || this.fieldType === xI || this.fieldType === TI) switch(this.expiryDatePolicy){
                        case rE:
                            return !0;
                        case tE:
                            return !this.hasError;
                        default:
                            return !1;
                    }
                    if (this.fieldType === zI) switch(this.cvcPolicy){
                        case XI:
                            return !0;
                        case $I:
                            return !this.hasError;
                        default:
                            return !1;
                    }
                    return !1;
                }
            },
            {
                key: "onIframeLoaded",
                value: function(e) {
                    return this.onIframeLoadedCallback = e, this;
                }
            },
            {
                key: "onEncryption",
                value: function(e) {
                    return this.onEncryptionCallback = e, this;
                }
            },
            {
                key: "onValidation",
                value: function(e) {
                    return this.onValidationCallback = e, this;
                }
            },
            {
                key: "onConfig",
                value: function(e) {
                    return this.onConfigCallback = e, this;
                }
            },
            {
                key: "onFocus",
                value: function(e) {
                    return this.onFocusCallback = e, this;
                }
            },
            {
                key: "onBinValue",
                value: function(e) {
                    return this.onBinValueCallback = e, this;
                }
            },
            {
                key: "onTouchstart",
                value: function(e) {
                    return this.onTouchstartCallback = e, this;
                }
            },
            {
                key: "onShiftTab",
                value: function(e) {
                    return this.onShiftTabCallback = e, this;
                }
            },
            {
                key: "onAutoComplete",
                value: function(e) {
                    return this.onAutoCompleteCallback = e, this;
                }
            },
            {
                key: "errorType",
                get: function() {
                    return this._errorType;
                },
                set: function(e) {
                    this._errorType = e;
                }
            },
            {
                key: "hasError",
                get: function() {
                    return this._hasError;
                },
                set: function(e) {
                    this._hasError = e;
                }
            },
            {
                key: "isValid",
                get: function() {
                    if (this.fieldType === zI) switch(this.cvcPolicy){
                        case XI:
                            return !0;
                        case $I:
                            return !this.hasError;
                        default:
                            return this._isValid;
                    }
                    if (this.fieldType === FI || this.fieldType === xI || this.fieldType === TI) switch(this.expiryDatePolicy){
                        case rE:
                            return !0;
                        case tE:
                            return !this.hasError;
                        default:
                            return this._isValid;
                    }
                    return this._isValid;
                },
                set: function(e) {
                    this._isValid = e;
                }
            },
            {
                key: "cvcPolicy",
                get: function() {
                    return this._cvcPolicy;
                },
                set: function(e) {
                    this.fieldType === zI && e !== this.cvcPolicy && (this._cvcPolicy = e, this.hasError && "isValidated" === this.errorType && (this.hasError = !1));
                }
            },
            {
                key: "expiryDatePolicy",
                get: function() {
                    return this._expiryDatePolicy;
                },
                set: function(e) {
                    this.fieldType !== FI && this.fieldType !== xI && this.fieldType !== TI || e !== this.expiryDatePolicy && (this._expiryDatePolicy = e, this.hasError && "isValidated" === this.errorType && (this.hasError = !1));
                }
            },
            {
                key: "iframeContentWindow",
                get: function() {
                    return this._iframeContentWindow;
                },
                set: function(e) {
                    this._iframeContentWindow = e;
                }
            },
            {
                key: "isEncrypted",
                get: function() {
                    return this._isEncrypted;
                },
                set: function(e) {
                    this._isEncrypted = e;
                }
            },
            {
                key: "numKey",
                get: function() {
                    return this._numKey;
                },
                set: function(e) {
                    this._numKey = e;
                }
            },
            {
                key: "iframeOnLoadListener",
                get: function() {
                    return this._iframeOnLoadListener;
                },
                set: function(e) {
                    this._iframeOnLoadListener = Jg(e).call(e, this);
                }
            },
            {
                key: "postMessageListener",
                get: function() {
                    return this._postMessageListener;
                },
                set: function(e) {
                    this._postMessageListener = Jg(e).call(e, this);
                }
            }
        ]), r;
    }(wg(function e() {
        Cg(this, e), Ag(this, "sfConfig", void 0), Ag(this, "fieldType", void 0), Ag(this, "iframeSrc", void 0), Ag(this, "loadingContext", void 0), Ag(this, "holderEl", void 0), Ag(this, "iframeRef", void 0), Ag(this, "loadToConfigTimeout", void 0), Ag(this, "_errorType", void 0), Ag(this, "_hasError", void 0), Ag(this, "_isValid", void 0), Ag(this, "_cvcPolicy", void 0), Ag(this, "_expiryDatePolicy", void 0), Ag(this, "_iframeContentWindow", void 0), Ag(this, "_isEncrypted", void 0), Ag(this, "_numKey", void 0), Ag(this, "_iframeOnLoadListener", void 0), Ag(this, "_postMessageListener", void 0), Ag(this, "onIframeLoadedCallback", void 0), Ag(this, "onConfigCallback", void 0), Ag(this, "onEncryptionCallback", void 0), Ag(this, "onValidationCallback", void 0), Ag(this, "onFocusCallback", void 0), Ag(this, "onBinValueCallback", void 0), Ag(this, "onTouchstartCallback", void 0), Ag(this, "onShiftTabCallback", void 0), Ag(this, "onAutoCompleteCallback", void 0), this.sfConfig = {};
    }));
    function lU() {
        var e, t = this;
        this.encryptedAttrName = aE;
        var r = xg(e = ZO(this.props.rootNode, "[".concat(this.encryptedAttrName, "]"))).call(e, function(e) {
            var r, a = $O(e, t.encryptedAttrName), n = kb(WI).call(WI, a);
            n || console.warn(wb(r = "WARNING: '".concat(a, "' is not a valid type for the '")).call(r, t.encryptedAttrName, "' attribute. A SecuredField will not be created for this element."));
            return n;
        }), a = JI, n = eE;
        return this.config.isCreditCardType ? (this.isSingleBrandedCard = !1, this.securityCode = "", this.createCardSecuredFields(r, a, n), r.length) : (this.createNonCardSecuredFields(r), r.length);
    }
    function sU(e) {
        return cU.apply(this, arguments);
    }
    function cU() {
        return cU = Jd(Dy.mark(function e(t) {
            var r, a;
            return Dy.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        r = 0;
                    case 1:
                        if (!(r < t.length)) {
                            e.next = 8;
                            break;
                        }
                        return a = t[r], e.next = 5, this.setupSecuredField(a).catch(function(e) {
                            window._b$dl && console.log("Secured fields setup failure. e=", e);
                        });
                    case 5:
                        r++, e.next = 1;
                        break;
                    case 8:
                    case "end":
                        return e.stop();
                }
            }, e, this);
        })), cU.apply(this, arguments);
    }
    function uU(e, t, r) {
        return dU.apply(this, arguments);
    }
    function dU() {
        return dU = Jd(Dy.mark(function e(t, r, a) {
            var n, o, i, l, s, c = this;
            return Dy.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        "card" === (n = this.state.type) && 1 === this.config.cardGroupTypes.length && (n = this.config.cardGroupTypes[0], this.state.type = n), this.isSingleBrandedCard = "card" !== n, this.isSingleBrandedCard && (vj(o = qV.getCardByBrand(n)) ? (r = o.cvcPolicy || JI, a = o.expiryDatePolicy || eE, this.securityCode = o.securityCode) : this.state.type = "unrecognised-single-brand"), i = 0;
                    case 5:
                        if (!(i < t.length)) {
                            e.next = 14;
                            break;
                        }
                        return l = t[i], window._b$dl && console.log("\nAbout to set up securedField:", l), e.next = 10, this.setupSecuredField(l, r, a).catch(function(e) {
                            window._b$dl && console.log("Secured fields setup failure. e=", e);
                        });
                    case 10:
                        window._b$dl && console.log("Finished setting up securedField:", l);
                    case 11:
                        i++, e.next = 5;
                        break;
                    case 14:
                        window._b$dl && console.log("Finished setting up all securedFields"), this.isSingleBrandedCard && (s = {
                            type: this.state.type,
                            rootNode: this.props.rootNode,
                            brand: n,
                            cvcPolicy: r,
                            expiryDatePolicy: a,
                            cvcText: this.securityCode
                        }, NP(function() {
                            c.callbacks.onBrand(s);
                        }, 0));
                    case 16:
                    case "end":
                        return e.stop();
                }
            }, e, this);
        })), dU.apply(this, arguments);
    }
    function pU(e, t, r) {
        var a = this;
        return new Ab(function(n, o) {
            var i = $O(e, a.encryptedAttrName);
            i === TI && (a.state.hasSeparateDateFields = !0);
            var l = {
                fieldType: i,
                extraFieldData: $O(e, nE),
                uid: $O(e, oE),
                cvcPolicy: t,
                holderEl: e,
                expiryDatePolicy: r,
                txVariant: a.state.type,
                cardGroupTypes: a.config.cardGroupTypes,
                iframeUIConfig: a.config.iframeUIConfig ? a.config.iframeUIConfig : {},
                sfLogAtStart: a.config.sfLogAtStart,
                trimTrailingSeparator: a.config.trimTrailingSeparator,
                isCreditCardType: a.config.isCreditCardType,
                iframeSrc: a.config.iframeSrc,
                loadingContext: a.config.loadingContext,
                showWarnings: a.config.showWarnings,
                legacyInputMode: a.config.legacyInputMode,
                minimumExpiryDate: a.config.minimumExpiryDate,
                implementationType: a.config.implementationType,
                maskSecurityCode: a.config.maskSecurityCode,
                exposeExpiryDate: a.props.exposeExpiryDate,
                disableIOSArrowKeys: a.config.shouldDisableIOSArrowKeys
            }, s = new iU(l, a.props.i18n).onIframeLoaded(function() {
                var e;
                if (a.state.iframeCount += 1, window._b$dl && console.log("### createSecuredFields::onIframeLoaded:: this.state.iframeCount=", a.state.iframeCount), a.state.iframeCount > a.state.numIframes) throw a.destroySecuredFields(), new LS("ERROR", wb(e = "One or more securedFields has just loaded new content. This should never happen. securedFields have been removed.\n                        iframe load count=".concat(a.state.iframeCount, ". Expected count:")).call(e, a.state.numIframes));
                if (s.loadToConfigTimeout = NP(function() {
                    o({
                        type: s.fieldType,
                        failReason: "sf took too long to config"
                    });
                }, 6e3), a.state.iframeCount === a.state.originalNumIframes) a.callbacks.onLoad({
                    iframesLoaded: !0
                });
            }).onConfig(function(e) {
                a.handleIframeConfigFeedback(e), clearTimeout(s.loadToConfigTimeout), s.loadToConfigTimeout = null, n(e);
            }).onFocus(function(e) {
                a.handleFocus(e);
            }).onBinValue(function(e) {
                a.handleBinValue(e);
            }).onTouchstart(function(e) {
                a.config.shouldDisableIOSArrowKeys && (a.hasGenuineTouchEvents || e.hasGenuineTouchEvents) && a.callbacks.onTouchstartIOS({
                    fieldType: e.fieldType
                }), (e.hasGenuineTouchEvents || a.hasGenuineTouchEvents) && a.postMessageToAllIframes({
                    fieldType: e.fieldType,
                    fieldClick: !0
                });
            }).onShiftTab(function(e) {
                a.handleSFShiftTab(e.fieldType);
            }).onEncryption(function(e) {
                a.handleEncryption(e);
            }).onValidation(function(e) {
                a.handleValidation(e);
            }).onAutoComplete(function(e) {
                a.processAutoComplete(e);
            });
            a.state.securedFields[i] = s;
        });
    }
    var mU = "undefined" != typeof navigator && /(android)/i.test(navigator.userAgent), fU = "undefined" != typeof navigator && function() {
        var e = navigator.userAgent, t = Kk(e).call(e, "MSIE ");
        if (t > 0) return ZC(e.substring(t + 5, Kk(e).call(e, ".", t)), 10);
        if (Kk(e).call(e, "Trident/") > 0) {
            var r = Kk(e).call(e, "rv:");
            return ZC(e.substring(r + 3, Kk(e).call(e, ".", r)), 10);
        }
        var a = Kk(e).call(e, "Edge/");
        return a > 0 && ZC(e.substring(a + 5, Kk(e).call(e, ".", a)), 10);
    }(), hU = {
        __IS_ANDROID: mU,
        __IS_IE: fU,
        __IS_IOS: "undefined" != typeof navigator && /iphone|ipod|ipad/i.test(navigator.userAgent),
        __IS_FIREFOX: "undefined" != typeof navigator && /(firefox)/i.test(navigator.userAgent),
        __IS_SAFARI: "undefined" != typeof navigator && /(safari)/i.test(navigator.userAgent) && !/(chrome)/i.test(navigator.userAgent)
    };
    var vU = function(e) {
        var t, r = e.target;
        if (r instanceof HTMLInputElement || HTMLTextAreaElement && r instanceof HTMLTextAreaElement) {
            var a = r.value, n = "selectionStart" in (t = r) ? t.selectionStart : 0, o = !1;
            n === a.length && (n -= 1, o = !0), r.value = a;
            try {
                r.setSelectionRange && (r.focus(), r.setSelectionRange(n, n), o && (n += 1, NP(function() {
                    r.setSelectionRange(n, n);
                }, 0)));
            } catch (e) {}
        } else if (this.config.keypadFix) {
            var i = this.props.rootNode, l = document.createElement("input");
            l.style.width = "1px", l.style.height = "1px", l.style.opacity = "0", l.style.fontSize = "18px", i.appendChild(l), l.focus(), i.removeChild(l);
        }
        this.destroyTouchendListener(), this.state.registerFieldForIos = !1, this.postMessageToAllIframes({
            fieldType: "webInternalElement",
            fieldClick: !0
        });
    }, yU = function(e) {
        this.hasGenuineTouchEvents = !0;
        var t = e.target;
        if (t instanceof HTMLInputElement || t instanceof HTMLSpanElement) {
            var r, a, n;
            this.postMessageToAllIframes({
                fieldType: "webInternalElement",
                checkoutTouchEvent: !0
            });
            var o = null !== (r = t.getAttribute("name")) && void 0 !== r ? r : t.getAttribute("data-id");
            null === (a = (n = this.callbacks).onTouchstartIOS) || void 0 === a || a.call(n, {
                fieldType: "webInternalElement",
                name: o
            });
        }
    }, gU = function() {
        var e = JO(document, "body");
        e.style.cursor = "pointer", XO(e, "touchend", this.touchendListener), this.state.registerFieldForIos = !0;
    }, bU = function() {
        if (!hU.__IS_IOS) return !1;
        var e = JO(document, "body");
        return e.style.cursor = "auto", ej(e, "touchend", this.touchendListener), !0;
    }, kU = function() {
        return !!hU.__IS_IOS && (ej(document, "touchstart", this.touchstartListener), !0);
    }, CU = function(e, t, r) {
        return function(e) {
            var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = oI(Array.prototype).call(ZO(document, "*[data-cse], a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[tabindex], *[contenteditable]")), a = [];
            Sg(r).call(r, function(e) {
                var t = e.getAttribute("tabindex"), r = !t || ZC(t, 10) >= 0, n = e.getBoundingClientRect(), o = n.width > 0 && n.height > 0;
                r && o && a.push(e);
            });
            var n = function(e, t) {
                for(var r = 0; r < e.length; r += 1)if (t(e[r])) return r;
                return -1;
            }(a, function(t) {
                return t === e || e.contains(t);
            });
            return a[n + (t ? -1 : 1)];
        }(JO(t, "[data-cse=".concat(e, "]")), r);
    };
    var _U = function(e) {
        var t;
        switch(this.state.type){
            case "ach":
                t = function(e) {
                    var t;
                    return e === BI && (t = jI), {
                        fieldToFocus: t,
                        additionalField: void 0
                    };
                }(e);
                break;
            case "giftcard":
                t = function(e, t) {
                    var r, a;
                    switch(e){
                        case RI:
                            r = CU(RI, t);
                            break;
                        case zI:
                            a = RI;
                    }
                    return {
                        fieldToFocus: a,
                        additionalField: r
                    };
                }(e, this.props.rootNode);
                break;
            default:
                t = this.state.isKCP ? function(e, t, r) {
                    var a, n;
                    switch(e){
                        case RI:
                            a = CU(RI, t);
                            break;
                        case FI:
                        case xI:
                            n = RI;
                            break;
                        case TI:
                            n = xI;
                            break;
                        case zI:
                            n = r ? TI : FI;
                            break;
                        case OI:
                            a = CU(e, t);
                    }
                    return {
                        fieldToFocus: n,
                        additionalField: a
                    };
                }(e, this.props.rootNode, this.state.hasSeparateDateFields) : function(e, t, r, a) {
                    var n, o;
                    switch(e){
                        case RI:
                            n = CU(RI, t);
                            break;
                        case FI:
                        case xI:
                            o = RI;
                            break;
                        case TI:
                            o = xI;
                            break;
                        case zI:
                            1 === a ? n = CU(zI, t) : o = r ? TI : FI;
                    }
                    return {
                        fieldToFocus: o,
                        additionalField: n
                    };
                }(e, this.props.rootNode, this.state.hasSeparateDateFields, this.state.numIframes);
        }
        var r, a = t.fieldToFocus, n = t.additionalField;
        a ? this.setFocusOnFrame(a, false) : n && (r = n) && (r.focus(), r.blur(), r.focus());
    }, NU = function(e) {
        (hU.__IS_FIREFOX || hU.__IS_IE && hU.__IS_IE <= 11) && this.handleShiftTab(e);
    };
    function PU(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function wU(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = PU(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = PU(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function AU(e) {
        if (VS(this.state.securedFields, RI)) {
            var t = wU(wU({
                txVariant: this.state.type
            }, e), {}, {
                fieldType: RI,
                numKey: this.state.securedFields[RI].numKey
            });
            VV(t, UV(this.state, RI), this.config.loadingContext);
        }
    }
    function SU(e) {
        var t = this, r = VS(this.state.securedFields, xI) && VS(this.state.securedFields, TI) ? [
            xI,
            TI
        ] : [
            FI
        ];
        Sg(r).call(r, function(r) {
            var a = wU(wU({
                txVariant: t.state.type
            }, e), {}, {
                fieldType: r,
                numKey: t.state.securedFields[r].numKey
            });
            VV(a, UV(t.state, r), t.config.loadingContext);
        });
    }
    function IU(e, t) {
        var r, a, n = "card" === this.state.type;
        if (!e || !Ty(e).length) return n ? (this.sendBrandToCardSF({
            brand: "reset"
        }), this.sendExpiryDatePolicyToSF({
            expiryDatePolicy: eE
        })) : t && this.processBrand(wU(wU({}, t), {}, {
            fieldType: RI
        })), void ("card" === this.state.type && VS(this.state.securedFields, FI) && (this.state.securedFields[FI].expiryDatePolicy = eE));
        var o = e.supportedBrands[0], i = o.brand, l = null !== (r = o.expiryDatePolicy) && void 0 !== r ? r : !0 === o.showExpiryDate ? eE : rE, s = {
            brand: i,
            cvcPolicy: o.cvcPolicy,
            expiryDatePolicy: l,
            cvcText: "Security code",
            showSocialSecurityNumber: null !== (a = o.showSocialSecurityNumber) && void 0 !== a && a,
            fieldType: RI
        };
        if (this.processBrand(s), n) {
            var c = wU({
                brand: i,
                enableLuhnCheck: !1 !== e.supportedBrands[0].enableLuhnCheck
            }, (null == o ? void 0 : o.panLength) && {
                panLength: null == o ? void 0 : o.panLength
            });
            this.sendBrandToCardSF(c), this.sendExpiryDatePolicyToSF({
                expiryDatePolicy: l
            });
        }
        VS(this.state.securedFields, zI) && (this.state.securedFields[zI].cvcPolicy = o.cvcPolicy), VS(this.state.securedFields, FI) ? this.state.securedFields[FI].expiryDatePolicy = l : VS(this.state.securedFields, xI) && VS(this.state.securedFields, TI) && (this.state.securedFields[xI].expiryDatePolicy = l, this.state.securedFields[TI].expiryDatePolicy = l), this.validateForm();
    }
    function EU(e, t, r) {
        var a = e.csfState, n = e.csfConfig;
        if (VS(a.securedFields, t)) {
            var o = {
                txVariant: a.type,
                fieldType: t,
                focus: !0,
                numKey: a.securedFields[t].numKey
            };
            VV(o, UV(a, t), n.loadingContext);
        }
    }
    function DU(e, t) {
        var r = e.csfState, a = e.csfConfig, n = Ty(t || {});
        if (!n.length) return !1;
        var o = Ty(r.securedFields);
        return Sg(o).call(o, function(e) {
            var o = {
                txVariant: r.type,
                fieldType: e,
                numKey: r.securedFields[e].numKey
            };
            Sg(n).call(n, function(e) {
                o[e] = t[e];
            }), VV(o, UV(r, e), a.loadingContext);
        }), !0;
    }
    var RU = function(e, t) {
        return !bj(e, t);
    };
    function FU(e, t) {
        var r = e.csfState, a = e.csfConfig, n = e.csfProps, o = e.csfCallbacks;
        if (t.fieldType === RI) {
            var i = {
                brand: t.brand,
                cvcPolicy: t.cvcPolicy,
                expiryDatePolicy: t.expiryDatePolicy,
                showSocialSecurityNumber: t.showSocialSecurityNumber
            }, l = RU(i, r.brand);
            if (!l) return null;
            var s = "card" === r.type || "bcmc" === r.type;
            if (s && l && (r.brand = i, VS(r.securedFields, zI))) {
                var c = {
                    txVariant: r.type,
                    brand: i.brand,
                    fieldType: zI,
                    cvcPolicy: t.cvcPolicy,
                    numKey: r.securedFields[zI].numKey
                };
                VV(c, UV(r, zI), a.loadingContext);
            }
            var u = s ? ZV([
                "brand",
                "cvcPolicy",
                "cvcText",
                "expiryDatePolicy",
                "showSocialSecurityNumber"
            ]).from(t) : null;
            if (u && u.brand) {
                var d = u;
                d.type = r.type, d.rootNode = n.rootNode, o.onBrand(d);
            }
            return !0;
        }
        return !1;
    }
    function xU(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function TU(e, t) {
        var r = e.csfState, a = e.csfConfig, n = e.csfCallbacks;
        if ("cc-name" === t.name) {
            var o = function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r, a, n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Sg(r = xU(Object(n), !0)).call(r, function(t) {
                        Ag(e, t, n[t]);
                    }) : Jy ? ng(e, Jy(n)) : Sg(a = xU(Object(n))).call(a, function(t) {
                        og(e, t, Wy(n, t));
                    });
                }
                return e;
            }({}, t);
            delete o.numKey;
            var i = o;
            return n.onAutoComplete(i), !0;
        }
        if ("cc-exp" === t.name) {
            var l, s = t.value.replace(/[^0-9]/gi, "/").split("/");
            if (2 !== s.length) return !1;
            1 === s[0].length && (s[0] = "0".concat(s[0]));
            var c = s[0], u = s[1];
            if (!((4 === (null == u ? void 0 : u.length) || 2 === (null == u ? void 0 : u.length)) && !isNaN(ZC(u)))) return !1;
            var d = oI(u).call(u, -2), p = wb(l = "".concat(c, "/")).call(l, d);
            if (VS(r.securedFields, FI)) {
                var m = {
                    txVariant: r.type,
                    fieldType: FI,
                    autoComplete: p,
                    numKey: r.securedFields[FI].numKey
                };
                return VV(m, UV(r, FI), a.loadingContext), !0;
            }
            if (VS(r.securedFields, xI)) {
                var f = {
                    txVariant: r.type,
                    fieldType: xI,
                    autoComplete: c,
                    numKey: r.securedFields[xI].numKey
                };
                VV(f, UV(r, xI), a.loadingContext);
            }
            return VS(r.securedFields, TI) && NP(function() {
                var e = {
                    txVariant: r.type,
                    fieldType: TI,
                    autoComplete: d,
                    numKey: r.securedFields[TI].numKey
                };
                VV(e, UV(r, TI), a.loadingContext);
            }, 0), !0;
        }
        return !1;
    }
    function zU(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function OU(e, t, r) {
        var a = e.csfState, n = e.csfProps, o = e.csfCallbacks, i = function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Sg(r = zU(Object(n), !0)).call(r, function(t) {
                    Ag(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Sg(a = zU(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({}, r);
        delete i.numKey, i.rootNode = n.rootNode, i.type = a.type;
        var l = i.fieldType;
        i.focus ? a.currentFocusObject !== l && (a.currentFocusObject = l, hU.__IS_IOS && !a.registerFieldForIos && t()) : a.currentFocusObject === l && (a.currentFocusObject = null);
        var s = i;
        s.currentFocusObject = a.currentFocusObject, o.onFocus(s);
    }
    function jU(e, t, r) {
        var a = e.csfState, n = e.csfCallbacks;
        if (a.iframeConfigCount += 1, window._b$dl && console.log("### handleIframeConfigFeedback::csfState.iframeConfigCount:: ", a.iframeConfigCount, "who=", r.fieldType), a.isConfigured) {
            var o = {
                additionalIframeConfigured: !0,
                fieldType: r.fieldType,
                type: a.type
            };
            n.onAdditionalSFConfig(o);
        } else if (a.iframeConfigCount === a.originalNumIframes) return t(), !0;
        return !1;
    }
    function BU(e, t) {
        var r = e.csfState, a = e.csfConfig, n = e.csfProps, o = e.csfCallbacks;
        r.isConfigured = !0;
        var i = {
            iframesConfigured: !0,
            type: r.type,
            rootNode: n.rootNode
        };
        if (o.onConfigSuccess(i), 1 === r.numIframes && a.isCreditCardType) {
            if ("card" === r.type) return RV("ERROR: Payment method with a single secured field - but 'type' has not been set to a specific card brand"), !1;
            var l, s = qV.getCardByBrand(r.type);
            if (s) (null !== (l = s.cvcPolicy) && void 0 !== l ? l : JI) !== JI && t();
        }
        return !0;
    }
    function MU(e) {
        var t = e.csfState, r = e.csfProps, a = e.csfCallbacks, n = function(e) {
            for(var t = Ty(e), r = 0, a = t.length; r < a; r += 1)if (!e[t[r]].isValid) return !1;
            return !0;
        }(t.securedFields), o = n !== t.allValid;
        if (t.allValid = n, n || o) {
            var i = {
                allValid: n,
                type: t.type,
                rootNode: r.rootNode
            };
            a.onAllValid(i);
        }
    }
    function LU(e, t) {
        var r = e.csfState, a = e.csfCallbacks, n = t.binValue, o = t.encryptedBin, i = t.uuid, l = {
            binValue: n,
            type: r.type
        };
        o && (l.encryptedBin = o, l.uuid = i), a.onBinValue(l);
    }
    function VU() {
        var e = this;
        this.postMessageToAllIframes({
            destroy: !0
        });
        var t = Ty(this.state.securedFields);
        Sg(t).call(t, function(t) {
            var r = e.state.securedFields[t];
            r && r.destroy(), e.state.securedFields[t] = null;
        }), this.destroyTouchendListener(), this.destroyTouchstartListener(), this.state.securedFields = {};
    }
    function UU(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var KU = function() {
        xV("".concat(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "You cannot use secured fields", " - they are not yet configured. Use the 'onConfigSuccess' callback to know when this has happened."));
    }, HU = function(e) {
        U_(r, e);
        var t = UU(r);
        function r(e) {
            var a, n, o, i, l, s;
            Cg(this, r), (s = t.call(this, e)).state = {
                type: s.props.type,
                brand: "card" !== s.props.type ? {
                    brand: s.props.type,
                    cvcPolicy: "required"
                } : {
                    brand: null,
                    cvcPolicy: "required"
                },
                allValid: void 0,
                numIframes: 0,
                originalNumIframes: 0,
                iframeCount: 0,
                iframeConfigCount: 0,
                isConfigured: !1,
                hasSeparateDateFields: !1,
                currentFocusObject: null,
                registerFieldForIos: !1,
                securedFields: {},
                isKCP: !1
            };
            var c = {
                csfState: s.state,
                csfConfig: s.config,
                csfProps: s.props,
                csfCallbacks: s.callbacks
            };
            return s.configHandler = TV, s.callbacksHandler = OV, s.validateForm = Cj(MU, c), s.isConfigured = Cj(BU, c, s.validateForm), s.handleIframeConfigFeedback = Cj(jU, c, s.isConfigured), s.processBrand = Cj(FU, c), s.handleValidation = MV, s.handleEncryption = KV, s.createSecuredFields = lU, s.createNonCardSecuredFields = sU, s.createCardSecuredFields = uU, s.setupSecuredField = pU, s.postMessageToAllIframes = Cj(DU, c), s.handleIOSTouchEvents = Jg(a = gU).call(a, L_(s)), s.touchendListener = Jg(n = vU).call(n, L_(s)), s.destroyTouchendListener = Jg(o = bU).call(o, L_(s)), s.touchstartListener = Jg(i = yU).call(i, L_(s)), s.destroyTouchstartListener = Jg(l = kU).call(l, L_(s)), s.setFocusOnFrame = Cj(EU, c), s.handleFocus = Cj(OU, c, s.handleIOSTouchEvents), s.handleSFShiftTab = NU, s.handleShiftTab = _U, s.destroySecuredFields = VU, s.processAutoComplete = Cj(TU, c), s.handleBinValue = Cj(LU, c), s.handleBrandFromBinLookup = IU, s.sendBrandToCardSF = AU, s.sendExpiryDatePolicyToSF = SU, s.init(), s;
        }
        return wg(r, [
            {
                key: "init",
                value: function() {
                    this.configHandler(this.props), this.callbacksHandler(this.props.callbacks);
                    var e = this.createSecuredFields();
                    this.state.numIframes = this.state.originalNumIframes = e, this.state.isKCP = !!this.props.isKCP, hU.__IS_IOS && this.config.shouldDisableIOSArrowKeys && (this.hasGenuineTouchEvents = !1, XO(document, "touchstart", this.touchstartListener));
                }
            },
            {
                key: "createReturnObject",
                value: function() {
                    var e = this;
                    return {
                        updateStyles: function(t) {
                            e.state.isConfigured ? e.postMessageToAllIframes({
                                styleObject: t
                            }) : xV("You cannot update the secured fields styling - they are not yet configured. Use the 'onConfigSuccess' callback to know when this has happened.");
                        },
                        setFocusOnFrame: function(t) {
                            e.state.isConfigured ? e.setFocusOnFrame(t) : KU("You cannot set focus on any secured field");
                        },
                        isValidated: function(t, r) {
                            if (e.state.isConfigured) {
                                if (VS(e.state.securedFields, t)) {
                                    e.state.securedFields[t].hasError = !0, "" === e.state.securedFields[t].errorType && (e.state.securedFields[t].errorType = "isValidated");
                                    var a = {
                                        txVariant: e.state.type,
                                        fieldType: t,
                                        externalValidation: !0,
                                        code: r,
                                        numKey: e.state.securedFields[t].numKey
                                    };
                                    VV(a, UV(e.state, t), e.config.loadingContext);
                                }
                            } else KU("You cannot set validated on any secured field");
                        },
                        hasUnsupportedCard: function(t, r) {
                            if (e.state.isConfigured) {
                                if (VS(e.state.securedFields, t)) {
                                    e.state.securedFields[t].hasError = !!r, e.state.securedFields[t].errorType = r;
                                    var a = {
                                        txVariant: e.state.type,
                                        fieldType: t,
                                        unsupportedCard: !!r,
                                        code: r,
                                        numKey: e.state.securedFields[t].numKey
                                    };
                                    VV(a, UV(e.state, t), e.config.loadingContext);
                                }
                            } else KU("You cannot set hasUnsupportedCard on any secured field");
                        },
                        destroy: function() {
                            e.state.isConfigured ? e.destroySecuredFields() : KU("You cannot destroy secured fields");
                        },
                        brandsFromBinLookup: function(t, r) {
                            if (!e.config.isCreditCardType) return null;
                            e.state.isConfigured ? e.handleBrandFromBinLookup(t, r) : KU("You cannot set pass brands to secured fields");
                        },
                        addSecuredField: function(t) {
                            var r = JO(e.props.rootNode, '[data-cse="'.concat(t, '"]'));
                            r && (e.state.numIframes += 1, e.setupSecuredField(r));
                        },
                        removeSecuredField: function(t) {
                            if (e.state.securedFields[t]) {
                                e.state.securedFields[t].destroy(), delete e.state.securedFields[t], e.state.numIframes -= 1, e.state.iframeCount -= 1;
                                var r = {
                                    additionalIframeRemoved: !0,
                                    fieldType: t,
                                    type: e.state.type
                                };
                                e.callbacks.onAdditionalSFRemoved(r);
                            }
                        },
                        setKCPStatus: function(t) {
                            e.state.isKCP = t;
                        },
                        sfIsOptionalOrHidden: function(t) {
                            return e.state.securedFields[t].isOptionalOrHidden();
                        }
                    };
                }
            }
        ]), r;
    }(DV);
    function qU(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    var WU = function(e) {
        if (!e) throw new Error("No securedFields configuration object defined");
        var t = function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Sg(r = qU(Object(n), !0)).call(r, function(t) {
                    Ag(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Sg(a = qU(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({}, e);
        try {
            var r = qV.isGenericCardType(t.type);
            t.type = r ? "card" : t.type;
        } catch (e) {
            t.type = "card";
        }
        if (!VS(t, "rootNode")) return RV('ERROR: SecuredFields configuration object is missing a "rootNode" property');
        if (kj(t.clientKey)) return xV('WARNING: AdyenCheckout configuration object is missing a "clientKey" property.');
        var a = GU(t.rootNode);
        return a ? (t.rootNode = a, new HU(t).createReturnObject()) : RV("ERROR: SecuredFields cannot find a valid rootNode element for ".concat(t.type));
    }, GU = function(e) {
        var t;
        return "object" === ig(e) && (t = e), "string" != typeof e || (t = JO(document, e)) ? t : null;
    };
    function YU(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function QU(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = YU(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = YU(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function ZU(e, t, r, a) {
        return (t !== QI && t !== ZI || 0 !== r[e]) && a[e];
    }
    var JU = function(e) {
        this.numCharsInField[e.fieldType] = e.numChars, this.props.onFocus(e);
    }, $U = function(e) {
        var t = this;
        return !this.state.detectedUnsupportedBrands && (this.setState({
            isSfpValid: e.allValid
        }, function() {
            t.props.onChange(t.state, {
                event: "handleOnAllValid"
            }), t.props.onAllValid(e);
        }), !0);
    }, XU = function(e) {
        var t = this;
        this.setState({
            autoCompleteName: e.value
        }, function() {
            t.props.onChange(t.state, {
                event: "handleOnAutoComplete",
                fieldType: e.fieldType
            }), t.setState({
                autoCompleteName: null
            });
        }), this.props.onAutoComplete(e);
    }, eK = function(e) {
        var t = this;
        return (!this.state.detectedUnsupportedBrands || e.fieldType !== RI) && (this.setState(function(t) {
            var r;
            return {
                data: QU(QU({}, t.data), {}, Ag({}, e.encryptedFieldName, e.blob)),
                valid: QU(QU({}, t.valid), {}, Ag({}, e.encryptedFieldName, e.valid)),
                errors: QU(QU({}, t.errors), {}, Ag({}, e.fieldType, null !== (r = t.errors[e.fieldType]) && void 0 !== r && r))
            };
        }, function() {
            t.props.onChange(t.state, {
                event: "handleOnFieldValid",
                fieldType: e.fieldType
            }), t.props.onFieldValid(e);
        }), !0);
    }, tK = function(e) {
        var t = this;
        clearTimeout(this.csfLoadFailTimeout), this.csfLoadFailTimeout = null, this.props.onLoad(e), this.csfConfigFailTimeout = NP(function() {
            "ready" !== t.state.status && (t.setState({
                status: "csfConfigFailure"
            }), t.props.onError(new LS("ERROR", "secured fields have failed to configure")));
        }, this.csfConfigFailTimeoutMS);
    }, rK = function(e) {
        var t = this;
        clearTimeout(this.csfConfigFailTimeout), this.csfConfigFailTimeout = null, this.setState({
            status: "ready"
        }, function() {
            t.props.onConfigSuccess(e);
        });
    }, aK = function(e) {
        var t = this;
        this.setState(function(r) {
            var a, n, o = ZU(zI, e.cvcPolicy, t.numCharsInField, r.errors), i = 1 === t.numDateFields ? ZU(FI, e.expiryDatePolicy, t.numCharsInField, r.errors) : null, l = 2 === t.numDateFields ? ZU(xI, e.expiryDatePolicy, t.numCharsInField, r.errors) : null, s = 2 === t.numDateFields ? ZU(TI, e.expiryDatePolicy, t.numCharsInField, r.errors) : null;
            return {
                brand: e.brand,
                cvcPolicy: null !== (a = e.cvcPolicy) && void 0 !== a ? a : JI,
                showSocialSecurityNumber: e.showSocialSecurityNumber,
                errors: QU(QU(QU(QU(QU({}, r.errors), vj(o) && Ag({}, zI, o)), vj(i) && Ag({}, FI, i)), vj(l) && Ag({}, xI, l)), vj(s) && Ag({}, TI, s)),
                expiryDatePolicy: null !== (n = e.expiryDatePolicy) && void 0 !== n ? n : eE
            };
        }, function() {
            var r, a;
            t.props.onChange(t.state, {
                event: "handleOnBrand"
            });
            var n = null !== (r = null === (a = t.props.brandsConfiguration[e.brand]) || void 0 === a ? void 0 : a.icon) && void 0 !== r ? r : YV(e.brand, t.props.resources);
            t.props.onBrand(QU(QU({}, e), {}, {
                brandImageUrl: n
            }));
        });
    }, nK = function(e) {
        var t = this, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, a = e.error;
        return this.setState(function(t) {
            return QU(QU(QU({
                errors: QU(QU({}, t.errors), {}, Ag({}, e.fieldType, a || !1))
            }, r && {
                data: QU(QU({}, t.data), {}, Ag({}, RI, void 0))
            }), r && {
                valid: QU(QU({}, t.valid), {}, Ag({}, RI, !1))
            }), r && {
                isSfpValid: !1
            });
        }, function() {
            t.props.onChange(t.state, {
                event: "handleOnError",
                fieldType: e.fieldType
            });
        }), !0;
    }, oK = function() {
        var e = this;
        this.setState({
            status: "ready"
        }, function() {
            return e.props.onChange({
                isSfpValid: !0
            });
        });
    }, iK = function(e) {
        var t, r;
        null === (t = (r = this.props).disableIOSArrowKeys) || void 0 === t || t.call(r, e);
    };
    function lK(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function sK(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = lK(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = lK(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function cK(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var uK = function(e) {
        U_(r, e);
        var t = cK(r);
        function r(e) {
            var a, n, o, i, l, s, c, u, d, p, m, f, h, v, y, g, b;
            Cg(this, r), Ag(L_(b = t.call(this, e)), "csfLoadFailTimeout", void 0), Ag(L_(b), "csfLoadFailTimeoutMS", void 0), Ag(L_(b), "csfConfigFailTimeout", void 0), Ag(L_(b), "csfConfigFailTimeoutMS", void 0), Ag(L_(b), "numCharsInField", void 0), Ag(L_(b), "rootNode", void 0), Ag(L_(b), "numDateFields", void 0), Ag(L_(b), "csf", void 0), Ag(L_(b), "handleOnLoad", void 0), Ag(L_(b), "handleOnConfigSuccess", void 0), Ag(L_(b), "handleOnFieldValid", void 0), Ag(L_(b), "handleOnAllValid", void 0), Ag(L_(b), "handleOnBrand", void 0), Ag(L_(b), "handleFocus", void 0), Ag(L_(b), "handleOnError", void 0), Ag(L_(b), "handleOnAutoComplete", void 0), Ag(L_(b), "handleOnNoDataRequired", void 0), Ag(L_(b), "handleOnTouchstartIOS", void 0), Ag(L_(b), "state", void 0), Ag(L_(b), "props", void 0), Ag(L_(b), "issuingCountryCode", void 0), Ag(L_(b), "setRootNode", function(e) {
                b.rootNode = e;
            });
            var k = {
                status: "loading",
                brand: e.type,
                errors: {},
                valid: {},
                data: {},
                cvcPolicy: JI,
                expiryDatePolicy: eE,
                isSfpValid: !1,
                hasKoreanFields: e.hasKoreanFields
            };
            return b.state = k, b.csfLoadFailTimeout = null, b.csfLoadFailTimeoutMS = 3e4, b.csfConfigFailTimeout = null, b.csfConfigFailTimeoutMS = 15e3, b.numCharsInField = {}, b.handleOnLoad = Jg(a = tK).call(a, L_(b)), b.handleOnConfigSuccess = Jg(n = rK).call(n, L_(b)), b.handleOnFieldValid = Jg(o = eK).call(o, L_(b)), b.handleOnAllValid = Jg(i = $U).call(i, L_(b)), b.handleOnBrand = Jg(l = aK).call(l, L_(b)), b.handleFocus = Jg(s = JU).call(s, L_(b)), b.handleOnError = Jg(c = nK).call(c, L_(b)), b.handleOnNoDataRequired = Jg(u = oK).call(u, L_(b)), b.handleOnAutoComplete = Jg(d = XU).call(d, L_(b)), b.handleOnTouchstartIOS = Jg(p = iK).call(p, L_(b)), b.processBinLookupResponse = Jg(m = b.processBinLookupResponse).call(m, L_(b)), b.setFocusOn = Jg(f = b.setFocusOn).call(f, L_(b)), b.updateStyles = Jg(h = b.updateStyles).call(h, L_(b)), b.handleUnsupportedCard = Jg(v = b.handleUnsupportedCard).call(v, L_(b)), b.showValidation = Jg(y = b.showValidation).call(y, L_(b)), b.destroy = Jg(g = b.destroy).call(g, L_(b)), b;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.rootNode && this.setRootNode(this.props.rootNode);
                    var t = function(e) {
                        var t;
                        return e ? hC(t = oI(Array.prototype).call(e.querySelectorAll('[data-cse*="encrypted"]'))).call(t, function(e) {
                            return e.getAttribute("data-cse");
                        }) : [];
                    }(this.rootNode), r = tC(t).call(t, IV, {});
                    this.setState({
                        valid: r
                    }), Sg(t).call(t, function(t) {
                        e.numCharsInField[t] = 0;
                    }), this.numDateFields = xg(t).call(t, function(e) {
                        return e.match(/Expiry/);
                    }).length, t.length ? (this.destroy(), this.initializeCSF(this.rootNode)) : this.handleOnNoDataRequired();
                }
            },
            {
                key: "componentDidUpdate",
                value: function() {
                    this.checkForKCPFields();
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.csf = null, clearTimeout(this.csfLoadFailTimeout), clearTimeout(this.csfConfigFailTimeout);
                }
            },
            {
                key: "initializeCSF",
                value: function(e) {
                    var t = this, r = this.props.loadingContext, a = {
                        rootNode: e,
                        type: this.props.type,
                        clientKey: this.props.clientKey,
                        cardGroupTypes: this.props.brands,
                        allowedDOMAccess: this.props.allowedDOMAccess,
                        autoFocus: this.props.autoFocus,
                        trimTrailingSeparator: this.props.trimTrailingSeparator,
                        loadingContext: r,
                        keypadFix: this.props.keypadFix,
                        showWarnings: this.props.showWarnings,
                        iframeUIConfig: {
                            sfStyles: this.props.styles
                        },
                        i18n: this.props.i18n,
                        callbacks: {
                            onLoad: this.handleOnLoad,
                            onConfigSuccess: this.handleOnConfigSuccess,
                            onFieldValid: this.handleOnFieldValid,
                            onAllValid: this.handleOnAllValid,
                            onBrand: this.handleOnBrand,
                            onError: this.handleOnError,
                            onFocus: this.handleFocus,
                            onBinValue: this.props.onBinValue,
                            onAutoComplete: this.handleOnAutoComplete,
                            onAdditionalSFConfig: this.props.onAdditionalSFConfig,
                            onAdditionalSFRemoved: this.props.onAdditionalSFRemoved,
                            onTouchstartIOS: this.handleOnTouchstartIOS
                        },
                        isKCP: this.state.hasKoreanFields,
                        legacyInputMode: this.props.legacyInputMode,
                        minimumExpiryDate: this.props.minimumExpiryDate,
                        implementationType: this.props.implementationType || "components",
                        forceCompat: this.props.forceCompat,
                        maskSecurityCode: this.props.maskSecurityCode,
                        exposeExpiryDate: this.props.exposeExpiryDate,
                        shouldDisableIOSArrowKeys: !!this.props.disableIOSArrowKeys
                    };
                    this.csf = WU(a), this.csfLoadFailTimeout = NP(function() {
                        "ready" !== t.state.status && (t.setState({
                            status: "csfLoadFailure"
                        }), t.props.onError(new LS("ERROR", "secured field iframes have failed to load")));
                    }, this.csfLoadFailTimeoutMS);
                }
            },
            {
                key: "checkForKCPFields",
                value: function() {
                    var e = this, t = !1;
                    if (this.props.koreanAuthenticationRequired && (t = this.issuingCountryCode ? "kr" === this.issuingCountryCode : "kr" === this.props.countryCode), this.state.hasKoreanFields && !t) this.setState(function(e) {
                        return {
                            data: sK(sK({}, e.data), {}, Ag({}, OI, void 0)),
                            valid: sK(sK({}, e.valid), {}, Ag({}, OI, !1)),
                            errors: sK(sK({}, e.errors), {}, Ag({}, OI, !1)),
                            hasKoreanFields: !1
                        };
                    }, function() {
                        e.props.onChange(e.state);
                    }), this.csf.removeSecuredField(OI), this.csf.setKCPStatus(!1);
                    if (!this.state.hasKoreanFields && t) this.setState(function(e) {
                        return {
                            valid: sK(sK({}, e.valid), {}, Ag({}, OI, !1)),
                            hasKoreanFields: !0,
                            isSfpValid: !1
                        };
                    }, function() {
                        e.props.onChange(e.state);
                    }), this.csf.addSecuredField(OI), this.csf.setKCPStatus(!0);
                }
            },
            {
                key: "getChildContext",
                value: function() {
                    return {
                        i18n: this.props.i18n
                    };
                }
            },
            {
                key: "handleUnsupportedCard",
                value: function(e) {
                    var t = !!e.error;
                    return t && this.setState({
                        detectedUnsupportedBrands: e.detectedBrands
                    }), e.rootNode = this.rootNode, this.handleOnError(e, t), this.csf && this.csf.hasUnsupportedCard(RI, e.error), t;
                }
            },
            {
                key: "setFocusOn",
                value: function(e) {
                    this.csf && this.csf.setFocusOnFrame(e);
                }
            },
            {
                key: "updateStyles",
                value: function(e) {
                    this.csf && this.csf.updateStyles(e);
                }
            },
            {
                key: "sfIsOptionalOrHidden",
                value: function(e) {
                    return this.csf.sfIsOptionalOrHidden(e);
                }
            },
            {
                key: "destroy",
                value: function() {
                    this.csf && this.csf.destroy();
                }
            },
            {
                key: "showValidation",
                value: function() {
                    var e, t, r = this, a = this.numDateFields, n = this.state;
                    Sg(e = tC(t = Ty(n.valid)).call(t, EV(a, n), [])).call(e, function(e) {
                        var t = function(e, t, r) {
                            return {
                                rootNode: t,
                                fieldType: e,
                                error: DN(r, "errors.".concat(e)) || CE[e] || kE,
                                type: "card"
                            };
                        }(e, r.rootNode, n);
                        r.handleOnError(t, !!n.detectedUnsupportedBrands), r.csf && r.csf.isValidated && r.csf.isValidated(e, t.error);
                    });
                }
            },
            {
                key: "mapErrorsToValidationRuleResult",
                value: function() {
                    var e = this, t = Ty(this.state.errors);
                    return tC(t).call(t, function(t, r) {
                        return e.state.errors[r] ? t[r] = sK({
                            isValid: !1,
                            errorMessage: KO(e.state.errors[r]),
                            errorI18n: e.props.i18n.get(e.state.errors[r]),
                            error: e.state.errors[r],
                            rootNode: e.rootNode
                        }, e.state.detectedUnsupportedBrands && {
                            detectedBrands: e.state.detectedUnsupportedBrands
                        }) : t[r] = null, t;
                    }, {});
                }
            },
            {
                key: "processBinLookupResponse",
                value: function(e, t) {
                    var r, a = this;
                    if (this.state.detectedUnsupportedBrands && (this.setState(function(e) {
                        return {
                            errors: sK(sK({}, e.errors), {}, Ag({}, RI, !1)),
                            detectedUnsupportedBrands: null
                        };
                    }), this.csf && e)) this.handleUnsupportedCard({
                        type: "card",
                        fieldType: "encryptedCardNumber",
                        error: ""
                    });
                    this.issuingCountryCode = null == e || null === (r = e.issuingCountryCode) || void 0 === r ? void 0 : r.toLowerCase();
                    var n = (null == t ? void 0 : t.brand) && kb(GI).call(GI, t.brand);
                    n && this.setState(t, function() {
                        a.props.onChange(a.state);
                    }), this.csf && this.csf.brandsFromBinLookup(e, n ? t : null);
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    return e.render({
                        setRootNode: this.setRootNode,
                        setFocusOn: this.setFocusOn
                    }, t);
                }
            }
        ]), r;
    }(lN);
    Ag(uK, "defaultProps", {
        type: "card",
        keypadFix: !0,
        rootNode: null,
        loadingContext: null,
        brands: [],
        allowedDOMAccess: !1,
        showWarnings: !1,
        autoFocus: !0,
        trimTrailingSeparator: !0,
        onChange: function() {},
        onLoad: function() {},
        onConfigSuccess: function() {},
        onAllValid: function() {},
        onFieldValid: function() {},
        onBrand: function() {},
        onError: function() {},
        onBinValue: function() {},
        onFocus: function() {},
        onAutoComplete: function() {},
        styles: {}
    });
    var dK = function(e) {
        return e.full = "full", e.partial = "partial", e.none = "none", e;
    }({}), pK = {
        type: "card",
        setComponentRef: function() {},
        hasHolderName: !1,
        holderNameRequired: !1,
        enableStoreDetails: !1,
        hasCVC: !0,
        showBrandIcon: !0,
        showBrandsUnderCardNumber: !0,
        positionHolderNameOnTop: !1,
        billingAddressRequired: !1,
        billingAddressMode: dK.full,
        billingAddressRequiredFields: [
            "street",
            "houseNumberOrName",
            "postalCode",
            "city",
            "stateOrProvince",
            "country"
        ],
        installmentOptions: {},
        configuration: {
            koreanAuthenticationRequired: !1,
            socialSecurityNumberMode: "auto"
        },
        autoFocus: !0,
        isPayButtonPrimaryVariant: !0,
        disableIOSArrowKeys: !0,
        exposeExpiryDate: !1,
        onLoad: function() {},
        onConfigSuccess: function() {},
        onAllValid: function() {},
        onFieldValid: function() {},
        onBrand: function() {},
        onError: function() {},
        onBinValue: function() {},
        onBlur: function() {},
        onFocus: function() {},
        onChange: function() {},
        data: {
            billingAddress: {}
        },
        styles: {},
        placeholders: {}
    }, mK = {
        base: {
            caretColor: "#0075FF"
        }
    };
    function fK(e) {
        var t;
        return ID(t = e.replace(/[^0-9]/g, "")).call(t);
    }
    function hK() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        if ("string" != typeof e) return "";
        var t = fK(e), r = t.length > 11 ? function(e) {
            return e.replace(/^(\d{2})(\d{3})(\d{3})?(\d{4})?(\d{1,2})?$/g, function(e, t, r, a) {
                var n, o, i, l, s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "", c = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "";
                return wb(n = wb(o = wb(i = wb(l = "".concat(t, ".")).call(l, r, ".")).call(i, a, "/")).call(o, s)).call(n, c.length ? "-".concat(c) : "");
            });
        }(t) : function(e) {
            return e.replace(/\W/gi, "").replace(/(\d{3})(?!$)/g, "$1.").replace(/(.{11}).(\d{1,2})$/g, "$1-$2");
        }(t);
        return r;
    }
    function vK(e) {
        return /(^\d{3}\.\d{3}\.\d{3}-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$)/.test(e);
    }
    var yK = {
        socialSecurityNumber: hK
    }, gK = {
        socialSecurityNumber: [
            {
                modes: [
                    "blur"
                ],
                validate: function(e) {
                    return WE(e) ? null : vK(e);
                },
                errorMessage: "boleto.socialSecurityNumber.invalid"
            }
        ],
        taxNumber: [
            {
                modes: [
                    "blur"
                ],
                validate: function(e) {
                    return WE(e) ? null : 6 === (null == e ? void 0 : e.length) || 10 === (null == e ? void 0 : e.length);
                },
                errorMessage: "creditCard.taxNumber.invalid"
            }
        ],
        holderName: [
            {
                modes: [
                    "blur"
                ],
                validate: function(e) {
                    return !WE(e) || null;
                },
                errorMessage: "creditCard.holderName.invalid"
            }
        ],
        default: [
            {
                modes: [
                    "blur"
                ],
                validate: function(e) {
                    return !!e && "string" == typeof e && ID(e).call(e).length > 0;
                }
            }
        ]
    }, bK = t(oy);
    function kK(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    var CK = function(e, t) {
        return tC(e).call(e, function(e, r) {
            return e || kb(t).call(t, r.brand);
        }, !1);
    }, _K = function(e) {
        return hC(e).call(e, function(e) {
            return function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r, a, n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Sg(r = kK(Object(n), !0)).call(r, function(t) {
                        Ag(e, t, n[t]);
                    }) : Jy ? ng(e, Jy(n)) : Sg(a = kK(Object(n))).call(a, function(t) {
                        og(e, t, Wy(n, t));
                    });
                }
                return e;
            }({}, e);
        });
    }, NK = function(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "mc", r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "visa", a = _K(e);
        return a[0].brand !== t && a[0].brand !== r && bK(a).call(a), a.length = 1, a;
    };
    function PK(e, t, r) {
        var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, n = e.type, o = e.cvcPolicy, i = t.sfp, l = r.dualBrandSelectElements, s = r.setDualBrandSelectElements, c = r.setSelectedBrandValue, u = r.issuingCountryCode, d = r.setIssuingCountryCode;
        return {
            processBinLookup: function(e, t) {
                var r, l, u, p, m = null != e && e.issuingCountryCode ? e.issuingCountryCode.toLowerCase() : null;
                if (d(m), !e || !Ty(e).length) {
                    s([]), c("");
                    var f = t && "card" !== n ? n : null;
                    return i.current.processBinLookupResponse(e, {
                        brand: f,
                        cvcPolicy: o
                    }), void (a.current = 0);
                }
                if (null !== (r = e.supportedBrands) && void 0 !== r && r.length) {
                    var h = CK(e.supportedBrands, iE), v = h ? NK(e.supportedBrands) : _K(e.supportedBrands);
                    if (v.length > 1) {
                        var y = (l = Vk(v, 2), u = l[0], p = l[1], {
                            dualBrandSelectElements: [
                                {
                                    id: u.brand,
                                    brandObject: u
                                },
                                {
                                    id: p.brand,
                                    brandObject: p
                                }
                            ],
                            selectedBrandValue: "",
                            leadBrand: u
                        });
                        s(y.dualBrandSelectElements), c(y.selectedBrandValue), i.current.processBinLookupResponse({
                            issuingCountryCode: e.issuingCountryCode,
                            supportedBrands: [
                                y.leadBrand
                            ]
                        }), y.leadBrand.panLength > 0 && (a.current = y.leadBrand.panLength);
                    } else s([]), c(""), h || c(v[0].brand), i.current.processBinLookupResponse({
                        issuingCountryCode: e.issuingCountryCode,
                        supportedBrands: v
                    }), v[0].panLength > 0 && (a.current = v[0].panLength);
                }
            },
            handleDualBrandSelection: function(e) {
                var t = e;
                if (e instanceof Event) {
                    var r = e.target;
                    t = r.getAttribute("data-value") || r.getAttribute("alt");
                }
                var a = [];
                t && (a = tC(l).call(l, function(e, r) {
                    return r.brandObject.brand === t && e.push(r.brandObject), e;
                }, [])).length && (c(t), i.current.processBinLookupResponse({
                    issuingCountryCode: u,
                    supportedBrands: a
                }));
            }
        };
    }
    var wK = "holderName", AK = "socialSecurityNumber", SK = [
        RI,
        FI,
        zI
    ], IK = [
        wK,
        RI,
        FI,
        zI
    ], EK = [
        RI,
        FI,
        zI,
        wK
    ], DK = [
        "taxNumber",
        OI
    ], RK = wb(SK).call(SK, DK), FK = wb(IK).call(IK, DK), xK = wb(EK).call(EK, DK), TK = wb(SK).call(SK, [
        AK
    ]), zK = wb(IK).call(IK, [
        AK
    ]), OK = wb(EK).call(EK, [
        AK
    ]), jK = function(e, t) {
        return t({
            type: "card" === e ? "nocard" : e || "nocard",
            extension: "svg"
        })(e);
    }, BK = function(e, t, r) {
        switch(e){
            case "socialSecurityNumber":
                return t.get("boleto.".concat(e));
            case "street":
            case "houseNumberOrName":
            case "postalCode":
            case "stateOrProvince":
            case "city":
            case "country":
                return null != r && r[e] ? t.get(null == r ? void 0 : r[e]) : t.get(e);
            default:
                return null;
        }
    };
    function MK(e) {
        var t;
        return null !== (t = lE[e]) && void 0 !== t ? t : e;
    }
    var LK = "LoadingWrapper-module_loading-input__form__ffCKa", VK = "LoadingWrapper-module_loading-input__form--loading__7GmVo", UK = "LoadingWrapper-module_loading-input__spinner__GxA51", KK = "LoadingWrapper-module_loading-input__spinner--active__ENNBS", HK = function(e) {
        var t = e.children, r = e.status, a = DP("adyen-checkout__loading-input__form", LK, Ag({}, VK, "loading" === r));
        return nN("div", {
            style: {
                position: "relative"
            }
        }, nN("div", {
            className: DP(Ag(Ag({}, UK, !0), KK, "loading" === r))
        }, nN(RP, null)), nN("div", {
            className: a
        }, t));
    };
    function qK(e) {
        var t = e.frontCVC, r = void 0 !== t && t, a = e.fieldLabel;
        return nN("span", {
            className: DP({
                "adyen-checkout__card__cvc__hint__wrapper": !0,
                "adyen-checkout__field__cvc--front-hint": !!r,
                "adyen-checkout__field__cvc--back-hint": !r
            })
        }, nN("svg", {
            className: "adyen-checkout__card__cvc__hint adyen-checkout__card__cvc__hint--front",
            width: "27",
            height: "18",
            viewBox: "0 0 27 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": !r,
            "aria-describedby": "adyen-checkout__cvc__front-hint-img",
            role: "img"
        }, nN("title", {
            id: "adyen-checkout__cvc__front-hint-img"
        }, a), nN("path", {
            d: "M0 3C0 1.34315 1.34315 0 3 0H24C25.6569 0 27 1.34315 27 3V15C27 16.6569 25.6569 18 24 18H3C1.34315 18 0 16.6569 0 15V3Z",
            fill: "#E6E9EB"
        }), nN("rect", {
            x: "4",
            y: "12",
            width: "19",
            height: "2",
            fill: "#B9C4C9"
        }), nN("rect", {
            x: "4",
            y: "4",
            width: "4",
            height: "4",
            rx: "1",
            fill: "white"
        }), nN("rect", {
            className: "adyen-checkout__card__cvc__hint__location",
            x: "16.5",
            y: "4.5",
            width: "7",
            height: "5",
            rx: "2.5",
            stroke: "#C12424"
        })), nN("svg", {
            className: "adyen-checkout__card__cvc__hint adyen-checkout__card__cvc__hint--back",
            width: "27",
            height: "18",
            viewBox: "0 0 27 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": !!r,
            "aria-describedby": "adyen-checkout__cvc__back-hint-img",
            role: "img"
        }, nN("title", {
            id: "adyen-checkout__cvc__back-hint-img"
        }, a), nN("path", {
            d: "M27 4.00001V3.37501C27 2.4799 26.6444 1.62146 26.0115 0.988518C25.3786 0.355581 24.5201 0 23.625 0H3.375C2.47989 0 1.62145 0.355581 0.988514 0.988518C0.355579 1.62146 0 2.4799 0 3.37501V4.00001H27Z",
            fill: "#E6E9EB"
        }), nN("path", {
            d: "M0 6.99994V14.6666C0 15.5507 0.355579 16.3985 0.988514 17.0237C1.62145 17.6488 2.47989 18 3.375 18H23.625C24.5201 18 25.3786 17.6488 26.0115 17.0237C26.6444 16.3985 27 15.5507 27 14.6666V6.99994H0Z",
            fill: "#E6E9EB"
        }), nN("rect", {
            y: "4.00012",
            width: "27",
            height: "3.00001",
            fill: "#687282"
        }), nN("path", {
            d: "M4 11C4 10.4477 4.44772 10 5 10H21C22.1046 10 23 10.8954 23 12C23 13.1046 22.1046 14 21 14H5C4.44771 14 4 13.5523 4 13V11Z",
            fill: "white"
        }), nN("rect", {
            className: "adyen-checkout__card__cvc__hint__location",
            x: "16.5",
            y: "9.5",
            width: "7",
            height: "5",
            rx: "2.5",
            stroke: "#C12424"
        })));
    }
    var WK = {
        "card-input__wrapper": "CardInput-module_card-input__wrapper__wXSCw",
        "card-input__icon": "CardInput-module_card-input__icon__3Cz5M",
        "card-input__form": "CardInput-module_card-input__form__fRo1r",
        "card-input__spinner": "CardInput-module_card-input__spinner__-j2Qi",
        "card-input__spinner--active": "CardInput-module_card-input__spinner--active__slD7w",
        "card-input__form--loading": "CardInput-module_card-input__form--loading__rrmdj",
        "adyen-checkout__input": "CardInput-module_adyen-checkout__input__11tlB",
        "adyen-checkout__card__cvc__input--hidden": "CardInput-module_adyen-checkout__card__cvc__input--hidden__VIlHV",
        "adyen-checkout__card__exp-date__input--hidden": "CardInput-module_adyen-checkout__card__exp-date__input--hidden__evi6-",
        "adyen-checkout__card__exp-cvc__exp-date__input--hidden": "CardInput-module_adyen-checkout__card__exp-cvc__exp-date__input--hidden__YC3VT",
        "revolving-plan-installments__disabled": "CardInput-module_revolving-plan-installments__disabled__VhNj2"
    };
    function GK(e) {
        return nN("span", Ag(Ag(Ag(Ag({}, aE, e.encryptedFieldType), nE, e["data-info"]), oE, e.uniqueId), "className", e.className), e.children);
    }
    var YK = function(e, t) {
        return nN("div", M_({}, e, {
            "aria-hidden": "true"
        }), t);
    };
    function QK(e) {
        var t, r = e.label, a = e.onFocusField, n = void 0 === a ? function() {} : a, o = e.error, i = void 0 === o ? "" : o, l = e.className, s = void 0 === l ? "" : l, c = e.classNameModifiers, u = void 0 === c ? [] : c, d = e.focused, p = e.filled, m = e.isValid, f = e.frontCVC, h = void 0 !== f && f, v = e.cvcPolicy, y = void 0 === v ? JI : v, g = sw().i18n, b = DP(s, Ag(Ag({
            "adyen-checkout__field__cvc": !0
        }, WK["adyen-checkout__card__cvc__input--hidden"], y === XI), "adyen-checkout__field__cvc--optional", y === $I)), k = DP(Ag({
            "adyen-checkout__input": !0,
            "adyen-checkout__input--small": !0,
            "adyen-checkout__card__cvc__input": !0,
            "adyen-checkout__input--error": i,
            "adyen-checkout__input--focus": d,
            "adyen-checkout__input--valid": m
        }, WK["adyen-checkout__input"], !0)), C = y !== $I ? r : g.get("creditCard.cvcField.title.optional");
        return nN(FE, {
            label: C,
            focused: d,
            filled: p,
            classNameModifiers: wb(t = []).call(t, Uk(u), [
                "securityCode"
            ]),
            onFocusField: function() {
                return n(zI);
            },
            className: b,
            errorMessage: i,
            isValid: m,
            dir: "ltr",
            name: zI,
            i18n: g,
            errorVisibleToScreenReader: !1,
            useLabelElement: !1,
            renderAlternativeToLabel: YK
        }, nN(GK, {
            encryptedFieldType: zI,
            className: k
        }), nN(qK, {
            frontCVC: h,
            fieldLabel: C
        }));
    }
    function ZK(e) {
        var t, r, a, n, o = e.brand, i = e.hasCVC, l = e.onFocusField, s = e.errors, c = e.valid, u = e.cvcPolicy, d = e.focusedElement, p = e.lastFour, m = e.expiryMonth, f = e.expiryYear, h = sw().i18n, v = h.get("creditCard.storedCard.description.ariaLabel").replace("%@", p), y = m && f ? wb(t = wb(r = " ".concat(h.get("creditCard.expiryDateField.title"), " ")).call(r, m, "/")).call(t, f) : "";
        return nN("div", {
            className: "adyen-checkout__card__form adyen-checkout__card__form--oneClick",
            "aria-label": wb(a = "".concat(v)).call(a, y)
        }, nN("div", {
            className: "adyen-checkout__card__exp-cvc adyen-checkout__field-wrapper"
        }, m && f && nN(FE, {
            label: h.get("creditCard.expiryDateField.title"),
            className: "adyen-checkout__field--50",
            classNameModifiers: [
                "storedCard"
            ],
            name: "expiryDateField",
            disabled: !0
        }, nN(FD, {
            name: "expiryDateField",
            className: "adyen-checkout__input adyen-checkout__input--disabled adyen-checkout__card__exp-date__input--oneclick",
            value: wb(n = "".concat(m, " / ")).call(n, f),
            readonly: !0,
            disabled: !0,
            dir: "ltr"
        })), i && nN(QK, M_({
            cvcPolicy: u,
            error: function(e, t) {
                return e[t] ? h.get(e[t]) : null;
            }(s, zI),
            focused: "encryptedSecurityCode" === d,
            filled: !!c.encryptedSecurityCode || !!s.encryptedSecurityCode,
            isValid: !!c.encryptedSecurityCode,
            label: h.get("creditCard.cvcField.title"),
            onFocusField: l
        }, m && f && {
            className: "adyen-checkout__field--50"
        }, {
            classNameModifiers: [
                "storedCard"
            ],
            frontCVC: "amex" === o
        }))));
    }
    function JK(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function $K(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = JK(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = JK(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function XK(e) {
        var t, r, a, n, o = sw().i18n, i = e.amount, l = e.brand, s = e.onChange, c = e.type, u = e.installmentOptions[l] || e.installmentOptions.card, d = Vk(VP((null == u ? void 0 : u.preselectedValue) || (null == u ? void 0 : cC(u)[0])), 2), p = d[0], m = d[1], f = Vk(VP("onetime"), 2), h = f[0], v = f[1], y = null == u || null === (t = u.plans) || void 0 === t ? void 0 : kb(t).call(t, "revolving"), g = function(e) {
            var t = e.target.value;
            m(Number(t));
        }, b = function(e) {
            var t, r, a;
            return "amount" === c ? (t = "installmentOption", r = {
                count: e,
                values: {
                    times: e,
                    partialValue: (a = e, o.amount(i.value / a, i.currency))
                }
            }) : (t = "installmentOptionMonths", r = {
                count: e,
                values: {
                    times: e
                }
            }), {
                id: e,
                name: i.value ? o.get(t, r) : "".concat(e)
            };
        };
        return KP(function() {
            var e, t;
            null != u && null !== (e = cC(u)) && void 0 !== e && kb(e).call(e, p) || m(null !== (t = null == u ? void 0 : u.preselectedValue) && void 0 !== t ? t : null == u ? void 0 : cC(u)[0]);
        }, [
            l
        ]), KP(function() {
            var e = $K($K({
                value: p
            }, y && "revolving" === h && {
                plan: h,
                value: 1
            }), y && "onetime" === h && {
                value: 1
            });
            s(u ? e : {
                value: null
            });
        }, [
            p,
            u,
            h
        ]), u ? 0 === i.value ? null : nN("div", {
            className: "adyen-checkout__installments"
        }, y ? nN(SI, {
            classNameModifiers: [
                "revolving-plan"
            ],
            label: ""
        }, nN(cR, {
            items: [
                {
                    id: "onetime",
                    name: "installments.oneTime"
                },
                {
                    id: "installments",
                    name: "installments.installments"
                },
                {
                    id: "revolving",
                    name: "installments.revolving"
                }
            ],
            onChange: function(e) {
                var t = e.currentTarget.getAttribute("value");
                v(t);
            },
            value: h
        }), nN(FE, {
            className: "".concat("installments" !== h ? WK["revolving-plan-installments__disabled"] : WK["revolving-plan-installments"]),
            classNameModifiers: [
                "revolving-plan-installments"
            ],
            name: "",
            useLabelElement: !1,
            addContextualElement: !1
        }, nN(cz, {
            filterable: !1,
            items: hC(n = cC(u)).call(n, b),
            selectedValue: p,
            onChange: g,
            name: "installments",
            disabled: "installments" !== h
        }))) : nN(FE, {
            label: o.get("installments"),
            classNameModifiers: [
                "installments"
            ],
            name: "",
            useLabelElement: !1,
            addContextualElement: !1
        }, nN(cz, {
            filterable: !1,
            items: hC(r = cC(u)).call(r, b),
            selectedValue: p,
            onChange: g,
            name: "installments",
            readonly: 1 === (null == u || null === (a = cC(u)) || void 0 === a ? void 0 : a.length)
        }))) : null;
    }
    XK.defaultProps = {
        brand: "",
        amount: {},
        onChange: function() {}
    };
    var eH = function(e) {
        var t = e.sfpState, r = e.setFocusOn, a = e.cvcPolicy, n = e.focusedElement, o = e.hasInstallments, i = e.handleInstallments, l = e.showAmountsInInstallments, s = e.amount, c = e.hasCVC, u = e.installmentOptions, d = e.lastFour, p = e.expiryMonth, m = e.expiryYear, f = e.disclaimerMessage;
        return nN(HK, {
            status: t.status
        }, nN(ZK, {
            errors: t.errors,
            brand: t.brand,
            hasCVC: c,
            cvcPolicy: a,
            onFocusField: r,
            focusedElement: n,
            valid: t.valid,
            lastFour: d,
            expiryMonth: p,
            expiryYear: m
        }), o && nN(XK, {
            amount: s,
            brand: t.brand,
            installmentOptions: u,
            onChange: i,
            type: l ? "amount" : "months"
        }), f && nN($L, {
            message: f.message.replace("%{linkText}", "%#".concat(f.linkText, "%#")),
            urls: [
                f.link
            ]
        }));
    };
    function tH(e) {
        var t, r, a = e.brand, n = e.brandsConfiguration, o = void 0 === n ? {} : n, i = II(), l = "card" === a ? "nocard" : a, s = null !== (t = null === (r = o[a]) || void 0 === r ? void 0 : r.icon) && void 0 !== t ? t : jK(l, i);
        return nN("img", {
            className: "".concat(WK["card-input__icon"], " adyen-checkout__card__cardNumber__brandIcon"),
            onError: function(e) {
                e.target.style.cssText = "display: none";
            },
            alt: MK(a),
            src: s
        });
    }
    var rH = function(e) {
        var t, r, a, n = e.brand, o = e.onClick, i = e.dataValue, l = e.notSelected, s = e.brandsConfiguration, c = void 0 === s ? {} : s, u = II(), d = "card" === n ? "nocard" : n, p = null !== (t = null === (r = c[n]) || void 0 === r ? void 0 : r.icon) && void 0 !== t ? t : jK(d, u);
        return nN("img", {
            className: wb(a = "".concat(WK["card-input__icon"], " ")).call(a, l ? "adyen-checkout__card__cardNumber__brandIcon--not-selected" : "", " adyen-checkout__card__cardNumber__brandIcon"),
            onError: function(e) {
                e.target.style.cssText = "display: none";
            },
            alt: MK(n),
            src: p,
            onClick: o,
            "data-value": i
        });
    };
    function aH(e) {
        var t = sw().i18n, r = e.error, a = void 0 === r ? "" : r, n = e.isValid, o = void 0 !== n && n, i = e.onFocusField, l = void 0 === i ? function() {} : i, s = e.dualBrandingElements, c = e.dualBrandingChangeHandler, u = e.dualBrandingSelected;
        return nN(FE, {
            label: e.label,
            focused: e.focused,
            filled: e.filled,
            classNameModifiers: [
                "cardNumber"
            ],
            onFocusField: function() {
                return l(RI);
            },
            errorMessage: a,
            isValid: o,
            dir: "ltr",
            name: RI,
            showValidIcon: !1,
            i18n: t,
            errorVisibleToScreenReader: !1,
            useLabelElement: !1,
            renderAlternativeToLabel: YK
        }, nN(GK, {
            encryptedFieldType: RI,
            className: DP(Ag(Ag(Ag(Ag(Ag({
                "adyen-checkout__input": !0,
                "adyen-checkout__input--large": !0,
                "adyen-checkout__card__cardNumber__input": !0
            }, WK["adyen-checkout__input"], !0), "adyen-checkout__input--error", a), "adyen-checkout__input--focus", e.focused), "adyen-checkout__input--valid", o), "adyen-checkout__card__cardNumber__input--noBrand", !e.showBrandIcon))
        }, e.showBrandIcon && !s && nN(tH, {
            brandsConfiguration: e.brandsConfiguration,
            brand: e.brand
        })), s && !a && nN("div", {
            className: DP([
                "adyen-checkout__card__dual-branding__buttons",
                {
                    "adyen-checkout__card__dual-branding__buttons--active": o
                }
            ])
        }, hC(s).call(s, function(t) {
            return nN(rH, {
                key: t.id,
                brand: t.id,
                brandsConfiguration: e.brandsConfiguration,
                onClick: c,
                dataValue: t.id,
                notSelected: "" !== u && u !== t.id
            });
        })));
    }
    function nH(e) {
        var t, r = e.label, a = e.focused, n = e.filled, o = e.onFocusField, i = e.className, l = void 0 === i ? "" : i, s = e.error, c = void 0 === s ? "" : s, u = e.isValid, d = void 0 !== u && u, p = e.expiryDatePolicy, m = void 0 === p ? eE : p, f = sw().i18n, h = II(), v = DP(l, Ag(Ag({
            "adyen-checkout__field__exp-date": !0
        }, WK["adyen-checkout__card__exp-date__input--hidden"], m === rE), "adyen-checkout__field__exp-date--optional", m === tE)), y = m !== tE ? r : wb(t = "".concat(r, " ")).call(t, f.get("field.title.optional"));
        return nN(FE, {
            label: y,
            classNameModifiers: [
                "expiryDate"
            ],
            className: v,
            focused: a,
            filled: n,
            onFocusField: function() {
                return o(FI);
            },
            errorMessage: c,
            isValid: d,
            dir: "ltr",
            name: "encryptedExpiryDate",
            i18n: f,
            errorVisibleToScreenReader: !1,
            useLabelElement: !1,
            renderAlternativeToLabel: YK
        }, nN(GK, {
            encryptedFieldType: FI,
            className: DP("adyen-checkout__input", "adyen-checkout__input--small", "adyen-checkout__card__exp-date__input", [
                WK["adyen-checkout__input"]
            ], {
                "adyen-checkout__input--error": c,
                "adyen-checkout__input--focus": a,
                "adyen-checkout__input--valid": d
            })
        }), nN("span", {
            className: DP("adyen-checkout__field__exp-date_hint_wrapper", [
                WK["checkout__field__exp-date_hint_wrapper"]
            ], {
                "adyen-checkout__field__exp-date_hint_wrapper--hidden": c || d
            })
        }, nN("img", {
            src: h({
                imageFolder: "components/"
            })("expiry_date_hint"),
            className: "adyen-checkout__field__exp-date_hint",
            alt: y
        })));
    }
    var oH = function(e) {
        var t = e.brands, r = e.activeBrand;
        return null != t && t.length ? nN("span", {
            className: DP("adyen-checkout__card__brands", {
                "adyen-checkout__card__brands--hidden": "card" !== r
            })
        }, hC(t).call(t, function(e) {
            var t = e.name;
            return nN("span", {
                key: t,
                className: "adyen-checkout__card__brands__brand-wrapper"
            }, nN(XT, {
                src: e.icon,
                alt: MK(t)
            }));
        })) : null;
    };
    function iH(e) {
        var t = e.brand, r = e.brandsIcons, a = e.brandsConfiguration, n = e.dualBrandingElements, o = e.dualBrandingChangeHandler, i = e.dualBrandingSelected, l = e.errors, s = e.focusedElement, c = e.hasCVC, u = e.cvcPolicy, d = e.expiryDatePolicy, p = e.onFocusField, m = e.showBrandIcon, f = e.showBrandsUnderCardNumber, h = e.valid, v = sw().i18n, y = function(e, t) {
            return e[t] ? v.get(e[t]) : null;
        }, g = null == r ? void 0 : xg(r).call(r, function(e) {
            return !(null != iE && kb(iE).call(iE, e.name));
        });
        return nN("div", {
            className: "adyen-checkout__card__form"
        }, nN(aH, {
            brand: t,
            brandsConfiguration: a,
            error: y(l, RI),
            focused: s === RI,
            isValid: !!h.encryptedCardNumber,
            label: v.get("creditCard.numberField.title"),
            onFocusField: p,
            filled: !!l.encryptedCardNumber || !!h.encryptedCardNumber,
            showBrandIcon: m,
            dualBrandingElements: n,
            dualBrandingChangeHandler: o,
            dualBrandingSelected: i
        }), f && nN(oH, {
            activeBrand: t,
            brands: g
        }), nN("div", {
            className: DP("adyen-checkout__card__exp-cvc adyen-checkout__field-wrapper", Ag({}, WK["adyen-checkout__card__exp-cvc__exp-date__input--hidden"], d === rE))
        }, nN(nH, {
            error: y(l, FI),
            focused: s === FI,
            isValid: !!h.encryptedExpiryMonth && !!h.encryptedExpiryYear,
            filled: !!l.encryptedExpiryDate || !!h.encryptedExpiryYear,
            label: v.get("creditCard.expiryDateField.title"),
            onFocusField: p,
            className: "adyen-checkout__field--50",
            expiryDatePolicy: d
        }), c && nN(QK, {
            error: y(l, zI),
            focused: s === zI,
            cvcPolicy: u,
            isValid: !!h.encryptedSecurityCode,
            filled: !!l.encryptedSecurityCode || !!h.encryptedSecurityCode,
            label: v.get("creditCard.cvcField.title"),
            onFocusField: p,
            className: "adyen-checkout__field--50",
            frontCVC: "amex" === t
        })));
    }
    function lH(e) {
        var t = sw().i18n, r = WP(function() {
            var r;
            return (null === (r = e.value) || void 0 === r ? void 0 : r.length) > 6 ? t.get("creditCard.taxNumber.labelAlt") : t.get("creditCard.taxNumber.label");
        }, [
            e.value
        ]);
        return nN("div", {
            className: "adyen-checkout__card__kcp-authentication"
        }, nN(FE, {
            label: r,
            filled: e.filled,
            classNameModifiers: [
                "kcp-taxNumber"
            ],
            errorMessage: e.error && t.get("creditCard.taxNumber.invalid"),
            isValid: e.isValid,
            dir: "ltr",
            name: "kcpTaxNumberOrDOB",
            onFocus: function(t) {
                return e.onFieldFocusAnalytics("taxNumber", t);
            },
            onBlur: function(t) {
                return e.onFieldBlurAnalytics("taxNumber", t);
            }
        }, nN(pR, {
            name: "kcpTaxNumberOrDOB",
            className: "adyen-checkout__card__kcp-taxNumber__input ".concat(WK["adyen-checkout__input"]),
            placeholder: t.get("creditCard.taxNumber.placeholder"),
            maxLength: 10,
            minLength: 6,
            autoComplete: "false",
            value: e.value,
            required: !0,
            onBlur: e.onBlur,
            onInput: e.onInput,
            disabled: e.disabled
        })), nN(FE, {
            label: t.get("creditCard.encryptedPassword.label"),
            focused: "encryptedPassword" === e.focusedElement,
            filled: e.filled,
            classNameModifiers: [
                "50",
                "koreanAuthentication-encryptedPassword"
            ],
            onFocusField: function() {
                return e.onFocusField("encryptedPassword");
            },
            errorMessage: e.encryptedPasswordState.errors && t.get(String(e.encryptedPasswordState.errors)),
            isValid: e.encryptedPasswordState.valid,
            dir: "ltr",
            name: "encryptedPassword"
        }, nN(GK, {
            encryptedFieldType: "encryptedPassword",
            className: DP(Ag(Ag(Ag(Ag({
                "adyen-checkout__input": !0,
                "adyen-checkout__input--large": !0
            }, WK["adyen-checkout__input"], !0), "adyen-checkout__input--error", e.encryptedPasswordState.errors), "adyen-checkout__input--valid", e.encryptedPasswordState.valid), "adyen-checkout__input--focus", "encryptedPassword" === e.focusedElement))
        })));
    }
    function sH(e) {
        var t = e.onBlur, r = e.onInput, a = e.valid, n = void 0 !== a && a, o = e.error, i = void 0 === o ? null : o, l = e.data, s = void 0 === l ? "" : l, c = e.required, u = void 0 !== c && c, d = e.disabled, p = void 0 !== d && d, m = e.onFieldFocusAnalytics, f = void 0 === m ? null : m, h = e.onFieldBlurAnalytics, v = void 0 === h ? null : h, y = sw().i18n;
        return nN(FE, {
            label: "".concat(y.get("boleto.socialSecurityNumber")),
            classNameModifiers: [
                "socialSecurityNumber"
            ],
            errorMessage: i && i.errorMessage ? y.get(i.errorMessage) : !!i,
            isValid: Boolean(n),
            name: "socialSecurityNumber",
            onFocus: function(e) {
                return null == f ? void 0 : f("socialSecurityNumber", e);
            },
            onBlur: function(e) {
                return null == v ? void 0 : v("socialSecurityNumber", e);
            }
        }, nN(FD, {
            name: "socialSecurityNumber",
            autocorrect: "off",
            spellcheck: !1,
            value: s,
            maxLength: 18,
            onInput: r,
            onBlur: t,
            required: u,
            disabled: p
        }));
    }
    var cH = [
        "storeDetails"
    ];
    function uH(e) {
        var t = e.storeDetails, r = void 0 !== t && t, a = kg(e, cH), n = sw().i18n, o = Vk(VP(r), 2), i = o[0], l = o[1];
        return KP(function() {
            a.onChange(i);
        }, [
            i
        ]), nN("div", {
            className: "adyen-checkout__store-details"
        }, nN(Bz, {
            onChange: function(e) {
                l(e.target.checked);
            },
            label: n.get("storeDetails"),
            name: "storeDetails"
        }));
    }
    function dH(e) {
        var t = e.onBlur, r = e.onInput, a = e.placeholder, n = e.value, o = e.required, i = e.error, l = void 0 !== i && i, s = e.isValid, c = e.disabled, u = e.onFieldFocusAnalytics, d = e.onFieldBlurAnalytics, p = sw().i18n;
        return nN(FE, {
            label: p.get("creditCard.holderName"),
            className: "adyen-checkout__card__holderName",
            errorMessage: l && p.get("creditCard.holderName.invalid"),
            isValid: !!s,
            name: "holderName",
            i18n: p,
            onFocus: function(e) {
                return u("holderName", e);
            },
            onBlur: function(e) {
                return d("holderName", e);
            }
        }, nN(FD, {
            name: "holderName",
            className: "adyen-checkout__card__holderName__input ".concat(WK["adyen-checkout__input"]),
            placeholder: a || p.get("creditCard.holderName.placeholder"),
            autocomplete: "cc-name",
            value: n,
            required: o,
            onBlur: t,
            onInput: r,
            disabled: c
        }));
    }
    var pH = function(e) {
        var t = e.data, r = e.valid, a = e.errors, n = e.handleChangeFor, o = e.sfpState, i = e.setFocusOn, l = e.cvcPolicy, s = e.focusedElement, c = e.hasInstallments, u = e.handleInstallments, d = e.showAmountsInInstallments, p = e.brandsIcons, m = e.formData, f = e.formErrors, h = e.formValid, v = e.expiryDatePolicy, y = e.dualBrandSelectElements, g = e.extensions, b = e.selectedBrandValue, k = e.showKCP, C = e.showBrazilianSSN, _ = e.socialSecurityNumber, N = e.handleOnStoreDetails, P = e.billingAddress, w = e.handleAddress, A = e.setAddressRef, S = e.partialAddressSchema, I = e.onAddressLookup, E = e.onAddressSelected, D = e.addressSearchDebounceMs, R = e.amount, F = e.billingAddressRequired, x = e.billingAddressRequiredFields, T = e.billingAddressAllowedCountries, z = e.billingAddressValidationRules, O = void 0 === z ? null : z, j = e.brandsConfiguration, B = e.showStoreDetailsCheckbox, M = e.hasCVC, L = e.hasHolderName, V = e.holderNameRequired, U = e.installmentOptions, K = e.placeholders, H = e.positionHolderNameOnTop, q = e.showBrandIcon, W = e.showBrandsUnderCardNumber, G = e.iOSFocusedField, Y = e.disclaimerMessage, Q = e.onFieldFocusAnalytics, Z = e.onFieldBlurAnalytics, J = nN(dH, {
            required: V,
            placeholder: K.holderName,
            value: m.holderName,
            error: !!f.holderName && V,
            isValid: !!h.holderName,
            onBlur: n("holderName", "blur"),
            onInput: n("holderName", "input"),
            disabled: G && "holderName" !== G,
            onFieldFocusAnalytics: Q,
            onFieldBlurAnalytics: Z
        });
        return nN(HK, {
            status: o.status
        }, L && H && J, nN(iH, {
            showBrandIcon: q,
            showBrandsUnderCardNumber: W,
            brand: o.brand,
            brandsIcons: p,
            brandsConfiguration: j,
            focusedElement: s,
            onFocusField: i,
            hasCVC: M,
            cvcPolicy: l,
            expiryDatePolicy: v,
            errors: o.errors,
            valid: o.valid,
            dualBrandingElements: y.length > 0 && y,
            dualBrandingChangeHandler: g.handleDualBrandSelection,
            dualBrandingSelected: b
        }), L && !H && J, k && nN(lH, {
            onFocusField: i,
            focusedElement: s,
            encryptedPasswordState: {
                data: o.encryptedPassword,
                valid: !!o.valid && o.valid.encryptedPassword,
                errors: !!o.errors && o.errors.encryptedPassword
            },
            value: t.taxNumber,
            error: !!a.taxNumber,
            isValid: !!r.taxNumber,
            onBlur: n("taxNumber", "blur"),
            onInput: n("taxNumber", "input"),
            disabled: G && "kcpTaxNumberOrDOB" !== G,
            onFieldFocusAnalytics: Q,
            onFieldBlurAnalytics: Z
        }), C && nN("div", {
            className: "adyen-checkout__card__socialSecurityNumber"
        }, nN(sH, {
            onBlur: n("socialSecurityNumber", "blur"),
            onInput: n("socialSecurityNumber", "input"),
            error: null == a ? void 0 : a.socialSecurityNumber,
            valid: null == r ? void 0 : r.socialSecurityNumber,
            data: _,
            required: !0,
            disabled: G && "socialSecurityNumber" !== G,
            onFieldFocusAnalytics: Q,
            onFieldBlurAnalytics: Z
        })), B && nN(uH, {
            onChange: N
        }), c && nN(XK, {
            amount: R,
            brand: o.brand,
            installmentOptions: U,
            onChange: u,
            type: d ? "amount" : "months"
        }), F && nN(zz, {
            label: "billingAddress",
            data: P,
            onChange: w,
            allowedCountries: T,
            requiredFields: x,
            setComponentRef: A,
            validationRules: O,
            specifications: S,
            iOSFocusedField: G,
            onAddressLookup: I,
            onAddressSelected: E,
            addressSearchDebounceMs: D,
            onFieldFocusAnalytics: Q,
            onFieldBlurAnalytics: Z
        }), Y && nN($L, {
            message: Y.message.replace("%{linkText}", "%#".concat(Y.linkText, "%#")),
            urls: [
                Y.link
            ]
        }));
    }, mH = t(jk), fH = t(kk);
    function hH(e, t) {
        var r = void 0 !== XR && fH(e) || e["@@iterator"];
        if (!r) {
            if (PP(e) || (r = function(e, t) {
                var r;
                if (!e) return;
                if ("string" == typeof e) return vH(e, t);
                var a = oI(r = Object.prototype.toString.call(e)).call(r, 8, -1);
                "Object" === a && e.constructor && (a = e.constructor.name);
                if ("Map" === a || "Set" === a) return mH(e);
                if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return vH(e, t);
            }(e)) || t && e && "number" == typeof e.length) {
                r && (e = r);
                var a = 0, n = function() {};
                return {
                    s: n,
                    n: function() {
                        return a >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[a++]
                        };
                    },
                    e: function(e) {
                        throw e;
                    },
                    f: n
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var o, i = !0, l = !1;
        return {
            s: function() {
                r = r.call(e);
            },
            n: function() {
                var e = r.next();
                return i = e.done, e;
            },
            e: function(e) {
                l = !0, o = e;
            },
            f: function() {
                try {
                    i || null == r.return || r.return();
                } finally{
                    if (l) throw o;
                }
            }
        };
    }
    function vH(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, a = new Array(t); r < t; r++)a[r] = e[r];
        return a;
    }
    var yH = function(e, t) {
        var r = e;
        if ("taxNumber" === r && (r = "kcpTaxNumberOrDOB"), "country" === r || "stateOrProvince" === r) {
            var a = JO(t.current.rootNode, ".adyen-checkout__field--".concat(r, " .adyen-checkout__filter-input"));
            null == a || a.focus();
        } else {
            var n = JO(t.current.rootNode, '[name="'.concat(r, '"]'));
            null == n || n.focus();
        }
    }, gH = [
        "billingAddress"
    ];
    function bH(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function kH(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = bH(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = bH(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var CH = function(e) {
        var t, r, a, n = qP(null), o = qP(!1), i = II(), l = QO(), s = l.setSRMessagesFromObjects, c = l.setSRMessagesFromStrings, u = l.clearSRPanel, d = l.shouldMoveFocusSR, p = null == s ? void 0 : s({
            fieldTypeMappingFn: BK
        }), m = qP(null), f = function(e) {
            m.current = e;
        }, h = qP({});
        Ty(h.current).length || e.setComponentRef(h.current);
        var v = qP(0), y = qP(!1), g = WP(function() {
            return new Dz(e.specifications);
        }, [
            e.specifications
        ]);
        h.current.sfp = n;
        var b = Vk(VP("ready"), 2), k = b[0], C = b[1], _ = Vk(VP({}), 2), N = _[0], P = _[1], w = Vk(VP(kH({}, e.holderNameRequired && {
            holderName: !1
        })), 2), A = w[0], S = w[1], I = Vk(VP(kH({}, e.hasHolderName && {
            holderName: null !== (t = e.data.holderName) && void 0 !== t ? t : ""
        })), 2), E = I[0], D = I[1], R = Vk(VP(null), 2), F = R[0], x = R[1], T = Vk(VP(""), 2), z = T[0], O = T[1], j = Vk(VP(!1), 2), B = j[0], M = j[1], L = Vk(VP(eE), 2), V = L[0], U = L[1], K = Vk(VP(JI), 2), H = K[0], q = K[1], W = Vk(VP(null), 2), G = W[0], Y = W[1], Q = Vk(VP([]), 2), Z = Q[0], J = Q[1], $ = Vk(VP(""), 2), X = $[0], ee = $[1], te = e.billingAddressMode !== dK.none && e.billingAddressRequired, re = e.billingAddressMode == dK.partial ? IR : null, ae = qP(re && (null === (r = e.data) || void 0 === r || null === (r = r.billingAddress) || void 0 === r ? void 0 : r.country)), ne = Vk(VP(!1), 2), oe = ne[0], ie = ne[1], le = Vk(VP(te ? e.data.billingAddress : null), 2), se = le[0], ce = le[1], ue = Vk(VP(!1), 2), de = ue[0], pe = ue[1], me = Vk(VP(""), 2), fe = me[0], he = me[1], ve = Vk(VP({
            value: null
        }), 2), ye = ve[0], ge = ve[1], be = Vk(VP(null), 2), ke = be[0], Ce = be[1], _e = _D({
            schema: [],
            defaultData: e.data,
            formatters: yK,
            rules: gK
        }), Ne = _e.handleChangeFor, Pe = _e.triggerValidation, we = _e.data, Ae = _e.valid, Se = _e.errors, Ie = _e.setSchema, Ee = _e.setData, De = _e.setValid, Re = _e.setErrors, Fe = !!Ty(e.installmentOptions).length && "debit" !== e.fundingSource, xe = null === (a = e.showInstallmentAmounts) || void 0 === a || a, Te = "kr" === (null != G ? G : e.countryCode), ze = e.configuration.koreanAuthenticationRequired && Te, Oe = de && "auto" === e.configuration.socialSecurityNumberMode || "show" === e.configuration.socialSecurityNumberMode, je = function(t, r) {
            e.onFocus({
                fieldType: t,
                event: r
            });
        }, Be = function(t, r) {
            e.onBlur({
                fieldType: t,
                event: r
            });
        }, Me = function(e, t, r) {
            return function(a) {
                e(a.currentFocusObject), !0 === a.focus ? t(a.fieldType, a) : r(a.fieldType, a);
            };
        }(O, je, Be), Le = function() {
            return function(e) {
                var t = e.props, r = e.showKCP, a = e.showBrazilianSSN, n = e.countrySpecificSchemas, o = void 0 === n ? null : n, i = e.billingAddressRequiredFields, l = void 0 === i ? null : i, s = SK, c = t.hasHolderName && t.holderNameRequired;
                if (c && (s = t.positionHolderNameOnTop ? IK : EK), r && (s = RK, c && (s = t.positionHolderNameOnTop ? FK : xK)), a && (s = TK, c && (s = t.positionHolderNameOnTop ? zK : OK)), o) {
                    var u, d = xg(u = Sz(o).call(o, 2)).call(u, function(e) {
                        return "number" != typeof e;
                    }), p = d;
                    l && (p = xg(d).call(d, function(e) {
                        return kb(l).call(l, e);
                    })), s = wb(SK).call(SK, p), c && (s = t.positionHolderNameOnTop ? wb(IK).call(IK, p) : wb(EK).call(EK, p));
                }
                return s;
            }(kH({
                props: e,
                showKCP: ze,
                showBrazilianSSN: Oe
            }, e.billingAddressRequired && {
                countrySpecificSchemas: g.getAddressSchemaForCountry(null == se ? void 0 : se.country),
                billingAddressRequiredFields: e.billingAddressRequiredFields
            }));
        }, Ve = GP(function(e) {
            var t = "webInternalElement" !== e.fieldType ? e.fieldType : e.name;
            Ce(t);
        }, []), Ue = function(e, t, r) {
            return function(a) {
                e("billingAddress", a.data), t("billingAddress", a.isValid), r("billingAddress", a.errors);
            };
        }(Ee, De, Re), Ke = function(e, t, r) {
            return function() {
                e.current || (e.current = !0, Ab.resolve().then(function() {
                    var a, n = qT(r).call(r, function(e) {
                        return e === RI;
                    }), o = hH(oI(r).call(r, n + 1));
                    try {
                        for(o.s(); !(a = o.n()).done;){
                            var i = a.value;
                            if (!kb(HI).call(HI, i)) {
                                yH(i, t);
                                break;
                            }
                            if (!t.current.sfIsOptionalOrHidden(i)) {
                                t.current.setFocusOn(i);
                                break;
                            }
                        }
                    } catch (e) {
                        o.e(e);
                    } finally{
                        o.f();
                    }
                    e.current = !1;
                }));
            };
        }(y, n, Le()), He = WP(function() {
            return PK(e, {
                sfp: n
            }, {
                dualBrandSelectElements: Z,
                setDualBrandSelectElements: J,
                setSelectedBrandValue: ee,
                issuingCountryCode: G,
                setIssuingCountryCode: Y
            }, v);
        }, [
            Z,
            G
        ]);
        h.current.showValidation = function() {
            o.current = !0, null == u || u(), n.current.showValidation(), Pe([
                "holderName",
                "socialSecurityNumber",
                "taxNumber"
            ]), null != m && m.current && m.current.showValidation();
        }, h.current.processBinLookupResponse = function(e, t) {
            He.processBinLookup(e, t);
        }, h.current.setStatus = C, KP(function() {
            return h.current.setFocusOn = n.current.setFocusOn, h.current.updateStyles = n.current.updateStyles, h.current.handleUnsupportedCard = n.current.handleUnsupportedCard, function() {
                n.current.destroy();
            };
        }, []), KP(function() {
            var t, r = wb(t = []).call(t, Uk(e.hasHolderName ? [
                "holderName"
            ] : []), Uk(Oe ? [
                "socialSecurityNumber"
            ] : []), Uk(ze ? [
                "taxNumber"
            ] : []), Uk(te ? [
                "billingAddress"
            ] : []));
            Ie(r);
        }, [
            e.hasHolderName,
            Oe,
            ze
        ]), KP(function() {
            var t, r;
            D(kH(kH({}, E), {}, {
                holderName: null !== (t = we.holderName) && void 0 !== t ? t : "",
                taxNumber: we.taxNumber
            })), he(we.socialSecurityNumber), te && ce(kH({}, we.billingAddress)), S(kH(kH({}, A), {}, {
                holderName: !e.holderNameRequired || Ae.holderName,
                socialSecurityNumber: !!Ae.socialSecurityNumber && Ae.socialSecurityNumber,
                taxNumber: !!Ae.taxNumber && Ae.taxNumber,
                billingAddress: !!Ae.billingAddress && Ae.billingAddress
            }));
            var a = !!Se.billingAddress && tC(r = sO(Se.billingAddress)).call(r, function(e, t) {
                var r = Vk(t, 2)[1];
                return e || null != r;
            }, !1);
            P(kH(kH({}, N), {}, {
                holderName: e.holderNameRequired && Se.holderName ? Se.holderName : null,
                socialSecurityNumber: Oe && Se.socialSecurityNumber ? Se.socialSecurityNumber : null,
                taxNumber: ze && Se.taxNumber ? Se.taxNumber : null,
                billingAddress: te && a ? Se.billingAddress : null
            }));
        }, [
            we,
            Ae,
            Se
        ]);
        var qe = rj(F);
        KP(function() {
            var t, r, a = A.holderName, i = B, l = !te || A.billingAddress, s = !ze || !!A.taxNumber && !!A.encryptedPassword, m = !Oe || !!A.socialSecurityNumber, f = i && a && l && s && m, h = n.current.mapErrorsToValidationRuleResult(), v = kH(kH({}, N), h), y = v.billingAddress, b = kH(kH({}, kg(v, gH)), y), k = null == p ? void 0 : p({
                errors: b,
                isValidating: o.current,
                layout: Le(),
                countrySpecificLabels: null !== (t = g.getAddressLabelsForCountry(null == se ? void 0 : se.country)) && void 0 !== t ? t : null == re || null === (r = re.default) || void 0 === r ? void 0 : r.labels
            }), C = null == k ? void 0 : k.currentErrorsSortedByLayout;
            switch(x(C), null == k ? void 0 : k.action){
                case _E:
                    d && function(e, t, r) {
                        e && (kb(HI).call(HI, r) ? t.current.setFocusOn(r) : yH(r, t));
                    }(o.current, n, null == k ? void 0 : k.fieldToFocus), NP(function() {
                        o.current = !1;
                    }, 300);
                    break;
                case NE:
                    var _ = aj(C, qe, "field"), P = null == _ ? void 0 : _[0];
                    if (P) {
                        var w = function(e) {
                            var t;
                            return !kb(t = [
                                "error.va.sf-cc-num.03",
                                "error.va.sf-cc-dat.01",
                                "error.va.sf-cc-dat.02",
                                "error.va.sf-cc-dat.03"
                            ]).call(t, e);
                        }(P.errorCode), S = w ? P.errorMessage : null;
                        c(S);
                    } else u();
            }
            if (C) {
                var I = aj(C, qe, "field");
                null == I || Sg(I).call(I, function(t) {
                    var r = {
                        fieldType: t.field,
                        errorCode: t.errorCode
                    };
                    e.onErrorAnalytics(r);
                });
            }
            e.onChange({
                data: E,
                valid: A,
                errors: v,
                isValid: f,
                billingAddress: se,
                selectedBrandValue: X,
                storePaymentMethod: oe,
                socialSecurityNumber: fe,
                installments: ye
            });
        }, [
            E,
            A,
            N,
            X,
            oe,
            ye
        ]);
        var We = e.storedPaymentMethodId ? eH : pH;
        return nN(iN, null, nN(uK, M_({
            ref: n
        }, function(e) {
            return {
                allowedDOMAccess: e.allowedDOMAccess,
                autoFocus: e.autoFocus,
                brands: e.brands,
                brandsConfiguration: e.brandsConfiguration,
                clientKey: e.clientKey,
                countryCode: e.countryCode,
                forceCompat: e.forceCompat,
                i18n: e.i18n,
                implementationType: e.implementationType,
                keypadFix: e.keypadFix,
                legacyInputMode: e.legacyInputMode,
                loadingContext: e.loadingContext,
                minimumExpiryDate: e.minimumExpiryDate,
                onAdditionalSFConfig: e.onAdditionalSFConfig,
                onAdditionalSFRemoved: e.onAdditionalSFRemoved,
                onAllValid: e.onAllValid,
                onAutoComplete: e.onAutoComplete,
                onBinValue: e.onBinValue,
                onConfigSuccess: e.onConfigSuccess,
                onError: e.onError,
                onFieldValid: e.onFieldValid,
                onLoad: e.onLoad,
                showWarnings: e.showWarnings,
                trimTrailingSeparator: e.trimTrailingSeparator,
                maskSecurityCode: e.maskSecurityCode,
                exposeExpiryDate: e.exposeExpiryDate,
                resources: e.resources
            };
        }(e), {
            styles: kH(kH({}, mK), e.styles),
            koreanAuthenticationRequired: e.configuration.koreanAuthenticationRequired,
            hasKoreanFields: !(!e.configuration.koreanAuthenticationRequired || "kr" !== e.countryCode),
            onChange: function(t, r) {
                if (t.autoCompleteName) {
                    if (!e.hasHolderName) return;
                    var a = (o = "blur", l = tC(i = gK["holderName"]).call(i, function(e, t) {
                        var r;
                        return e.length || kb(r = t.modes).call(r, o) && e.push(t.validate), e;
                    }, []), l[0]), n = a(t.autoCompleteName) ? t.autoCompleteName : null;
                    n && (Ee("holderName", n), De("holderName", !0), Re("holderName", null));
                } else {
                    var o, i, l;
                    e.autoFocus && v.current > 0 && "handleOnFieldValid" === (null == r ? void 0 : r.event) && (null == r ? void 0 : r.fieldType) === RI && t.valid.encryptedCardNumber && Ke(), D(kH(kH({}, E), t.data)), P(kH(kH({}, N), t.errors)), S(kH(kH({}, A), t.valid)), M(t.isSfpValid), q(t.cvcPolicy), pe(t.showSocialSecurityNumber), U(t.expiryDatePolicy);
                }
            },
            onBrand: e.onBrand,
            onFocus: Me,
            type: e.brand,
            disableIOSArrowKeys: e.disableIOSArrowKeys ? Ve : null,
            render: function(t, r) {
                var a, n = t.setRootNode, o = t.setFocusOn;
                return nN("div", {
                    ref: n,
                    className: DP(Ag(Ag(Ag({
                        "adyen-checkout__card-input": !0
                    }, WK["card-input__wrapper"], !0), "adyen-checkout__card-input--".concat(null !== (a = e.fundingSource) && void 0 !== a ? a : "credit"), !0), "adyen-checkout__card-input--loading", "loading" === k)),
                    role: "form"
                }, e.showFormInstruction && nN(iO, null), nN(We, M_({}, function(e) {
                    return {
                        amount: e.amount,
                        billingAddressRequired: e.billingAddressRequired,
                        billingAddressRequiredFields: e.billingAddressRequiredFields,
                        billingAddressAllowedCountries: e.billingAddressAllowedCountries,
                        brandsConfiguration: e.brandsConfiguration,
                        showStoreDetailsCheckbox: e.showStoreDetailsCheckbox,
                        hasCVC: e.hasCVC,
                        hasHolderName: e.hasHolderName,
                        holderNameRequired: e.holderNameRequired,
                        installmentOptions: e.installmentOptions,
                        placeholders: e.placeholders,
                        positionHolderNameOnTop: e.positionHolderNameOnTop,
                        showBrandIcon: e.showBrandIcon,
                        showBrandsUnderCardNumber: e.showBrandsUnderCardNumber,
                        lastFour: e.lastFour,
                        expiryMonth: e.expiryMonth,
                        expiryYear: e.expiryYear,
                        disclaimerMessage: e.disclaimerMessage
                    };
                }(e), {
                    data: E,
                    valid: A,
                    errors: N,
                    handleChangeFor: Ne,
                    focusedElement: z,
                    setFocusOn: o,
                    sfpState: r,
                    cvcPolicy: H,
                    hasInstallments: Fe,
                    showAmountsInInstallments: xe,
                    handleInstallments: ge,
                    brandsIcons: e.brandsIcons,
                    formData: we,
                    formErrors: Se,
                    formValid: Ae,
                    expiryDatePolicy: V,
                    dualBrandSelectElements: Z,
                    extensions: He,
                    selectedBrandValue: X,
                    showKCP: ze,
                    showBrazilianSSN: Oe,
                    socialSecurityNumber: fe,
                    handleOnStoreDetails: ie,
                    setAddressRef: f,
                    billingAddress: se,
                    billingAddressValidationRules: re && QR(ae.current),
                    partialAddressSchema: re,
                    handleAddress: Ue,
                    onAddressLookup: e.onAddressLookup,
                    onAddressSelected: e.onAddressSelected,
                    addressSearchDebounceMs: e.addressSearchDebounceMs,
                    iOSFocusedField: ke,
                    onFieldFocusAnalytics: je,
                    onFieldBlurAnalytics: Be
                })));
            }
        })), e.showPayButton && e.payButton({
            status: k,
            variant: e.isPayButtonPrimaryVariant ? "primary" : "secondary",
            icon: i({
                imageFolder: "components/"
            })("lock")
        }));
    };
    function _H(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    CH.defaultProps = pK;
    var NH = function(e) {
        var t = null;
        return function(r) {
            if (!1 !== e.props.doBinLookup) {
                if (r.encryptedBin && e.props.clientKey) t = r.uuid, zT({
                    loadingContext: e.props.loadingContext,
                    path: "v3/bin/binLookup?token=".concat(e.props.clientKey)
                }, {
                    type: e.props.type,
                    supportedBrands: e.props.brands || UI,
                    encryptedBin: r.encryptedBin,
                    requestId: r.uuid
                }).then(function(a) {
                    var n;
                    if ((null == a ? void 0 : a.requestId) === t) {
                        if (null !== (n = a.brands) && void 0 !== n && n.length) {
                            var o, i, l = tC(o = a.brands).call(o, function(e, t) {
                                return e.detectedBrands.push(t.brand), e.paymentMethodVariants.push(t.paymentMethodVariant), !0 === t.supported ? (e.supportedBrands.push(t), e) : e;
                            }, {
                                supportedBrands: [],
                                detectedBrands: [],
                                paymentMethodVariants: []
                            });
                            if (l.supportedBrands.length) return e.processBinLookupResponse(function(e) {
                                for(var t = 1; t < arguments.length; t++){
                                    var r, a, n = null != arguments[t] ? arguments[t] : {};
                                    t % 2 ? Sg(r = _H(Object(n), !0)).call(r, function(t) {
                                        Ag(e, t, n[t]);
                                    }) : Jy ? ng(e, Jy(n)) : Sg(a = _H(Object(n))).call(a, function(t) {
                                        og(e, t, Wy(n, t));
                                    });
                                }
                                return e;
                            }({
                                issuingCountryCode: a.issuingCountryCode,
                                supportedBrands: l.supportedBrands
                            }, a.showSocialSecurityNumber ? {
                                showSocialSecurityNumber: a.showSocialSecurityNumber
                            } : {})), void e.onBinLookup({
                                type: r.type,
                                detectedBrands: l.detectedBrands,
                                supportedBrands: hC(i = l.supportedBrands).call(i, function(e) {
                                    return e.brand;
                                }),
                                paymentMethodVariants: l.paymentMethodVariants,
                                supportedBrandsRaw: l.supportedBrands,
                                brands: e.props.brands || UI,
                                issuingCountryCode: a.issuingCountryCode
                            });
                            if (l.detectedBrands.length) {
                                var s = {
                                    type: "card",
                                    fieldType: "encryptedCardNumber",
                                    error: KO(uE),
                                    detectedBrands: l.detectedBrands
                                };
                                return e.handleUnsupportedCard(s), void e.onBinLookup({
                                    type: r.type,
                                    detectedBrands: l.detectedBrands,
                                    supportedBrands: null,
                                    paymentMethodVariants: l.paymentMethodVariants,
                                    brands: e.props.brands || UI
                                });
                            }
                        } else e.onBinLookup({
                            type: r.type,
                            detectedBrands: null,
                            supportedBrands: null,
                            paymentMethodVariants: null,
                            brands: e.props.brands || UI
                        }), e.processBinLookupResponse({}, !0);
                    } else null != a && a.requestId || e.props.onError(a || {
                        errorType: "binLookup",
                        message: "unknownError"
                    });
                });
                else if (t) {
                    e.processBinLookupResponse(null, !0), t = null;
                    e.handleUnsupportedCard({
                        type: "card",
                        fieldType: "encryptedCardNumber",
                        error: ""
                    }), e.onBinLookup({
                        isReset: !0
                    });
                }
                e.props.onBinValue && e.props.onBinValue(r);
            } else e.props.onBinValue && e.props.onBinValue(r);
        };
    };
    function PH(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var wH = function(e) {
        U_(r, e);
        var t = PH(r);
        function r(e, a, n) {
            var o, i, l;
            Cg(this, r), Ag(L_(l = t.call(this)), "reason", void 0), Ag(L_(l), "message", void 0), Ag(L_(l), "source", void 0), Ag(L_(l), "scheme", void 0);
            var s = "error" in e ? null == e || null === (o = e.error) || void 0 === o ? void 0 : o.message : null == e ? void 0 : e.message, c = "error" in e ? null == e || null === (i = e.error) || void 0 === i ? void 0 : i.reason : null == e ? void 0 : e.reason;
            return l.message = s, l.reason = c, l.source = a, l.scheme = n, l;
        }
        return wg(r, [
            {
                key: "toString",
                value: function() {
                    var e, t, r;
                    return wb(e = wb(t = wb(r = "Reason: ".concat(this.reason, " / Source: ")).call(r, this.source, " / Scheme: ")).call(t, this.scheme, " / Message: ")).call(e, this.message);
                }
            }
        ]), r;
    }(BS(Error)), AH = function() {
        function e(t, r) {
            if (Cg(this, e), Ag(this, "schemeSdk", void 0), Ag(this, "schemeName", void 0), Ag(this, "customSdkConfiguration", void 0), Ag(this, "sdkUrl", void 0), Ag(this, "scriptElement", null), !t) throw Error("AbstractSrcInitiator: Invalid SDK URL");
            this.sdkUrl = t, this.customSdkConfiguration = r;
        }
        var t, r, a, n, o, i;
        return wg(e, [
            {
                key: "loadSdkScript",
                value: (i = Jd(Dy.mark(function e() {
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (this.isSdkIsAvailableOnWindow()) {
                                    e.next = 4;
                                    break;
                                }
                                return this.scriptElement = new sB(this.sdkUrl), e.next = 4, this.scriptElement.load();
                            case 4:
                                this.assignSdkReference();
                            case 5:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function() {
                    return i.apply(this, arguments);
                })
            },
            {
                key: "removeSdkScript",
                value: function() {
                    this.scriptElement.remove();
                }
            },
            {
                key: "checkout",
                value: (o = Jd(Dy.mark(function e(t) {
                    var r;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, e.next = 3, this.schemeSdk.checkout(t);
                            case 3:
                                return r = e.sent, e.abrupt("return", r);
                            case 7:
                                throw e.prev = 7, e.t0 = e.catch(0), new wH(e.t0, "checkout", this.schemeName);
                            case 11:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                })), function(e) {
                    return o.apply(this, arguments);
                })
            },
            {
                key: "unbindAppInstance",
                value: (n = Jd(Dy.mark(function e() {
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, e.next = 3, this.schemeSdk.unbindAppInstance();
                            case 3:
                                e.next = 9;
                                break;
                            case 5:
                                throw e.prev = 5, e.t0 = e.catch(0), new wH(e.t0, "unbindAppInstance", this.schemeName);
                            case 9:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            5
                        ]
                    ]);
                })), function() {
                    return n.apply(this, arguments);
                })
            },
            {
                key: "isRecognized",
                value: (a = Jd(Dy.mark(function e() {
                    var t;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, e.next = 3, this.schemeSdk.isRecognized();
                            case 3:
                                return t = e.sent, e.abrupt("return", t);
                            case 7:
                                throw e.prev = 7, e.t0 = e.catch(0), new wH(e.t0, "isRecognized", this.schemeName);
                            case 11:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                })), function() {
                    return a.apply(this, arguments);
                })
            },
            {
                key: "initiateIdentityValidation",
                value: (r = Jd(Dy.mark(function e() {
                    var t;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, e.next = 3, this.schemeSdk.initiateIdentityValidation();
                            case 3:
                                return t = e.sent, e.abrupt("return", t);
                            case 7:
                                throw e.prev = 7, e.t0 = e.catch(0), new wH(e.t0, "initiateIdentityValidation", this.schemeName);
                            case 11:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                })), function() {
                    return r.apply(this, arguments);
                })
            },
            {
                key: "getSrcProfile",
                value: (t = Jd(Dy.mark(function e(t) {
                    var r;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, e.next = 3, this.schemeSdk.getSrcProfile({
                                    idTokens: t
                                });
                            case 3:
                                return r = e.sent, e.abrupt("return", r);
                            case 7:
                                throw e.prev = 7, e.t0 = e.catch(0), new wH(e.t0, "getSrcProfile", this.schemeName);
                            case 11:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                })), function(e) {
                    return t.apply(this, arguments);
                })
            }
        ]), e;
    }();
    function SH(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function IH(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = SH(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = SH(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function EH(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var DH = {
        email: "EMAIL",
        telephoneNumber: "MOBILE_NUMBER"
    }, RH = function(e) {
        U_(o, e);
        var t, r, a, n = EH(o);
        function o(e, t) {
            var r, a;
            return Cg(this, o), Ag(L_(a = n.call(this, kb(r = e.toLowerCase()).call(r, "live") ? "https://assets.secure.checkout.visa.com/checkout-widget/resources/js/src-i-adapter/visa-sdk.js?v2" : "https://sandbox-assets.secure.checkout.visa.com/checkout-widget/resources/js/src-i-adapter/visa-sdk.js?v2", t)), "schemeName", "visa"), a;
        }
        return wg(o, [
            {
                key: "isSdkIsAvailableOnWindow",
                value: function() {
                    var e;
                    return !(null === (e = window.vAdapters) || void 0 === e || !e.VisaSRCI);
                }
            },
            {
                key: "assignSdkReference",
                value: function() {
                    this.schemeSdk = new window.vAdapters.VisaSRCI;
                }
            },
            {
                key: "init",
                value: (a = Jd(Dy.mark(function e(t, r) {
                    var a;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, a = IH(IH(IH({}, t), (n = this.customSdkConfiguration, o = void 0, i = void 0, l = void 0, o = n.dpaLocale, i = void 0 === o ? "en_US" : o, l = n.dpaPresentationName, {
                                    dpaTransactionOptions: {
                                        dpaLocale: i,
                                        payloadTypeIndicator: "NON_PAYMENT",
                                        customInputData: {
                                            checkoutOrchestrator: "merchant"
                                        }
                                    },
                                    dpaData: {
                                        dpaPresentationName: void 0 === l ? "" : l
                                    }
                                })), {}, {
                                    srciTransactionId: r
                                }), e.next = 4, this.schemeSdk.init(a);
                            case 4:
                                e.next = 10;
                                break;
                            case 6:
                                throw e.prev = 6, e.t0 = e.catch(0), new wH(e.t0, "init", this.schemeName);
                            case 10:
                            case "end":
                                return e.stop();
                        }
                        var n, o, i, l;
                    }, e, this, [
                        [
                            0,
                            6
                        ]
                    ]);
                })), function(e, t) {
                    return a.apply(this, arguments);
                })
            },
            {
                key: "identityLookup",
                value: (r = Jd(Dy.mark(function e(t) {
                    var r, a, n, o;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return r = t.identityValue, a = t.type, e.prev = 1, n = {
                                    identityValue: r,
                                    type: DH[a]
                                }, e.next = 5, this.schemeSdk.identityLookup(n);
                            case 5:
                                return o = e.sent, e.abrupt("return", o);
                            case 9:
                                throw e.prev = 9, e.t0 = e.catch(1), new wH(e.t0, "identityLookup", this.schemeName);
                            case 13:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            1,
                            9
                        ]
                    ]);
                })), function(e) {
                    return r.apply(this, arguments);
                })
            },
            {
                key: "completeIdentityValidation",
                value: (t = Jd(Dy.mark(function e(t) {
                    var r;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, e.next = 3, this.schemeSdk.completeIdentityValidation(t);
                            case 3:
                                return r = e.sent, e.abrupt("return", r);
                            case 7:
                                throw e.prev = 7, e.t0 = e.catch(0), new wH(e.t0, "completeIdentityValidation", this.schemeName);
                            case 11:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                })), function(e) {
                    return t.apply(this, arguments);
                })
            }
        ]), o;
    }(AH);
    function FH(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function xH(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = FH(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = FH(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function TH(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var zH = {
        email: "EMAIL_ADDRESS",
        telephoneNumber: "MOBILE_PHONE_NUMBER"
    }, OH = function(e) {
        U_(o, e);
        var t, r, a, n = TH(o);
        function o(e, t) {
            var r, a;
            return Cg(this, o), Ag(L_(a = n.call(this, kb(r = e.toLowerCase()).call(r, "live") ? "https://src.mastercard.com/sdk/srcsdk.mastercard.js" : "https://sandbox.src.mastercard.com/sdk/srcsdk.mastercard.js", t)), "schemeName", "mc"), a;
        }
        return wg(o, [
            {
                key: "isSdkIsAvailableOnWindow",
                value: function() {
                    return !!window.SRCSDK_MASTERCARD;
                }
            },
            {
                key: "assignSdkReference",
                value: function() {
                    this.schemeSdk = window.SRCSDK_MASTERCARD;
                }
            },
            {
                key: "init",
                value: (a = Jd(Dy.mark(function e(t, r) {
                    var a;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, a = xH(xH(xH({}, t), (n = this.customSdkConfiguration, o = void 0, i = void 0, l = void 0, o = n.dpaLocale, i = void 0 === o ? "en_US" : o, l = n.dpaPresentationName, {
                                    dpaTransactionOptions: {
                                        dpaLocale: i,
                                        paymentOptions: {
                                            dynamicDataType: "CARD_APPLICATION_CRYPTOGRAM_SHORT_FORM"
                                        },
                                        consumerNameRequested: !0,
                                        customInputData: {
                                            "com.mastercard.dcfExperience": "PAYMENT_SETTINGS"
                                        },
                                        confirmPayment: !1
                                    },
                                    dpaData: {
                                        dpaPresentationName: void 0 === l ? "" : l
                                    }
                                })), {}, {
                                    srciTransactionId: r
                                }), e.next = 4, this.schemeSdk.init(a);
                            case 4:
                                e.next = 10;
                                break;
                            case 6:
                                throw e.prev = 6, e.t0 = e.catch(0), new wH(e.t0, "init", this.schemeName);
                            case 10:
                            case "end":
                                return e.stop();
                        }
                        var n, o, i, l;
                    }, e, this, [
                        [
                            0,
                            6
                        ]
                    ]);
                })), function(e, t) {
                    return a.apply(this, arguments);
                })
            },
            {
                key: "identityLookup",
                value: (r = Jd(Dy.mark(function e(t) {
                    var r, a, n, o;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return r = t.identityValue, a = t.type, e.prev = 1, n = {
                                    identityValue: r,
                                    identityType: zH[a]
                                }, e.next = 5, this.schemeSdk.identityLookup({
                                    consumerIdentity: n
                                });
                            case 5:
                                return o = e.sent, e.abrupt("return", o);
                            case 9:
                                throw e.prev = 9, e.t0 = e.catch(1), new wH(e.t0, "identityLookup", this.schemeName);
                            case 13:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            1,
                            9
                        ]
                    ]);
                })), function(e) {
                    return r.apply(this, arguments);
                })
            },
            {
                key: "completeIdentityValidation",
                value: (t = Jd(Dy.mark(function e(t) {
                    var r;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, e.next = 3, this.schemeSdk.completeIdentityValidation({
                                    validationData: t
                                });
                            case 3:
                                return r = e.sent, e.abrupt("return", r);
                            case 7:
                                throw e.prev = 7, e.t0 = e.catch(0), new wH(e.t0, "completeIdentityValidation", this.schemeName);
                            case 11:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                })), function(e) {
                    return t.apply(this, arguments);
                })
            }
        ]), o;
    }(AH), jH = function(e) {
        return "fulfilled" === e.status;
    }, BH = function(e) {
        return "rejected" === e.status;
    }, MH = {
        visa: RH,
        mc: OH,
        default: null
    }, LH = function(e, t, r) {
        var a = MH[e] || MH.default;
        return a ? new a(t, r) : null;
    }, VH = function() {
        function e(t, r) {
            var a = r.dpaLocale, n = void 0 === a ? "en_US" : a, o = r.dpaPresentationName, i = void 0 === o ? "" : o;
            Cg(this, e), Ag(this, "schemes", void 0), Ag(this, "customSdkConfiguration", void 0), this.schemes = t, this.customSdkConfiguration = {
                dpaLocale: n,
                dpaPresentationName: i
            };
        }
        var t;
        return wg(e, [
            {
                key: "load",
                value: (t = Jd(Dy.mark(function e(t) {
                    var r = this;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (this.schemes && 0 !== this.schemes.length) {
                                    e.next = 2;
                                    break;
                                }
                                throw new LS("ERROR", "ClickToPay -> SrcSdkLoader: There are no schemes set to be loaded");
                            case 2:
                                return e.abrupt("return", new Ab(function(e, a) {
                                    var n, o = hC(n = r.schemes).call(n, function(e) {
                                        return LH(e, t, r.customSdkConfiguration);
                                    }), i = hC(o).call(o, function(e) {
                                        return e.loadSdkScript();
                                    });
                                    Ab.allSettled(i).then(function(t) {
                                        AI(t).call(t, BH) && a(new LS("ERROR", "ClickToPay -> SrcSdkLoader # Unable to load network schemes: ".concat(r.schemes.toString())));
                                        var n = xg(o).call(o, function(e, r) {
                                            return jH(t[r]);
                                        });
                                        e(n);
                                    });
                                }));
                            case 3:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function(e) {
                    return t.apply(this, arguments);
                })
            }
        ]), e;
    }(), UH = {
        mc: "Mastercard",
        visa: "Visa"
    }, KH = function() {
        function e(t, r, a) {
            Cg(this, e), Ag(this, "dateOfCardLastUsed", void 0), Ag(this, "panLastFour", void 0), Ag(this, "srcDigitalCardId", void 0), Ag(this, "scheme", void 0), Ag(this, "artUri", void 0), Ag(this, "srcCorrelationId", void 0), Ag(this, "tokenId", void 0), Ag(this, "isExpired", void 0), Ag(this, "panExpirationMonth", void 0), Ag(this, "panExpirationYear", void 0), Ag(this, "descriptorName", void 0), Ag(this, "status", null), this.dateOfCardLastUsed = t.dateOfCardLastUsed, this.panLastFour = t.panLastFour, this.srcDigitalCardId = t.srcDigitalCardId, this.descriptorName = t.digitalCardData.descriptorName, this.tokenId = t.tokenId, this.scheme = r, this.artUri = t.digitalCardData.artUri, this.srcCorrelationId = a, this.panExpirationMonth = t.panExpirationMonth, this.panExpirationYear = t.panExpirationYear, this.status = t.digitalCardData.status, this.isExpired = this.confirmCardIsExpired();
        }
        return wg(e, [
            {
                key: "title",
                get: function() {
                    return "visa" === this.scheme ? UH[this.scheme] : this.descriptorName || UH[this.scheme];
                }
            },
            {
                key: "isDcfPopupEmbedded",
                get: function() {
                    return "mc" === this.scheme;
                }
            },
            {
                key: "confirmCardIsExpired",
                value: function() {
                    if ("ACTIVE" !== this.status) return !0;
                    if (!this.panExpirationYear && !this.panExpirationMonth) return !1;
                    var e = [
                        (new Date).getMonth() + 1,
                        (new Date).getFullYear()
                    ], t = e[0], r = e[1];
                    return !(Number(this.panExpirationYear) > r) && !(Number(this.panExpirationYear) === r && Number(this.panExpirationMonth) >= t);
                }
            }
        ]), e;
    }(), HH = "ctpIframe";
    function qH(e, t, r) {
        var a, n = e.scheme, o = e.tokenId, i = e.srcDigitalCardId, l = e.srcCorrelationId;
        return "visa" === n ? o ? {
            srcScheme: n,
            srcCorrelationId: l,
            srcTokenReference: kb(a = r.toLowerCase()).call(a, "live") ? o : "987654321"
        } : {
            srcScheme: n,
            srcCheckoutPayload: t.checkoutResponse,
            srcCorrelationId: l
        } : {
            srcScheme: n,
            srcDigitalCardId: i,
            srcCorrelationId: l
        };
    }
    function WH(e, t) {
        var r, a = t.profiles, n = t.srcCorrelationId, o = tC(a).call(a, function(e, r) {
            var a, o, i = hC(a = r.maskedCards).call(a, function(e) {
                return new KH(e, t.scheme, n);
            });
            return wb(o = []).call(o, Uk(e), Uk(i));
        }, []);
        return wb(r = []).call(r, Uk(e), Uk(o));
    }
    function GH(e, t) {
        return new Date(t.dateOfCardLastUsed).getTime() - new Date(e.dateOfCardLastUsed).getTime();
    }
    function YH(e, t) {
        return t.isExpired ? e.expiredCards.push(t) : e.availableCards.push(t), e;
    }
    function QH(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var ZH = function(e) {
        U_(r, e);
        var t = QH(r);
        function r(e) {
            var a;
            return Cg(this, r), (a = t.call(this, e)).name = "TimeoutError", a;
        }
        return wg(r);
    }(BS(Error));
    function JH(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function $H(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = JH(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = JH(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var XH = function(e) {
        return e.Idle = "Idle", e.Loading = "Loading", e.ShopperIdentified = "ShopperIdentified", e.OneTimePassword = "OneTimePassword", e.Ready = "Ready", e.Login = "Login", e.NotAvailable = "NotAvailable", e;
    }({});
    function eq(e, t, r) {
        var a = new Ab(function(e, a) {
            return NP(function() {
                return a(r);
            }, t);
        });
        return Ab.race([
            e(),
            a
        ]);
    }
    var tq = function() {
        function e(t, r, a, n, o) {
            Cg(this, e), Ag(this, "sdkLoader", void 0), Ag(this, "schemesConfig", void 0), Ag(this, "shopperIdentity", void 0), Ag(this, "environment", void 0), Ag(this, "onTimeout", void 0), Ag(this, "srciTransactionId", FN()), Ag(this, "sdks", void 0), Ag(this, "validationSchemeSdk", null), Ag(this, "stateSubscriber", void 0), Ag(this, "state", XH.Idle), Ag(this, "shopperCards", null), Ag(this, "identityValidationData", null), Ag(this, "storeCookies", !1), this.sdkLoader = r, this.schemesConfig = t, this.shopperIdentity = n, this.environment = a, this.onTimeout = o;
        }
        var t, r, a, n, o, i, l, s, c;
        return wg(e, [
            {
                key: "shopperAccountFound",
                get: function() {
                    var e;
                    return kb(e = [
                        XH.Ready,
                        XH.ShopperIdentified
                    ]).call(e, this.state);
                }
            },
            {
                key: "schemes",
                get: function() {
                    return this.sdkLoader.schemes;
                }
            },
            {
                key: "updateStoreCookiesConsent",
                value: function(e) {
                    this.storeCookies = e;
                }
            },
            {
                key: "initialize",
                value: (c = Jd(Dy.mark(function e() {
                    var t, r, a, n, o, i, l, s, c;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return this.setState(XH.Loading), e.prev = 1, e.next = 4, this.sdkLoader.load(this.environment);
                            case 4:
                                return this.sdks = e.sent, e.next = 7, this.initiateSdks();
                            case 7:
                                return e.next = 9, this.verifyIfShopperIsRecognized();
                            case 9:
                                if (t = e.sent, r = t.recognized, a = void 0 !== r && r, n = t.idTokens, o = void 0 === n ? null : n, !a) {
                                    e.next = 19;
                                    break;
                                }
                                return e.next = 17, this.getShopperProfile(o);
                            case 17:
                                return this.setState(XH.Ready), e.abrupt("return");
                            case 19:
                                if (this.shopperIdentity) {
                                    e.next = 22;
                                    break;
                                }
                                return this.setState(XH.NotAvailable), e.abrupt("return");
                            case 22:
                                return e.next = 24, this.verifyIfShopperIsEnrolled(this.shopperIdentity);
                            case 24:
                                if (!e.sent.isEnrolled) {
                                    e.next = 29;
                                    break;
                                }
                                return this.setState(XH.ShopperIdentified), e.abrupt("return");
                            case 29:
                                this.setState(XH.NotAvailable), e.next = 36;
                                break;
                            case 32:
                                e.prev = 32, e.t0 = e.catch(1), e.t0 instanceof wH && "REQUEST_TIMEOUT" === (null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.reason) ? (s = new ZH(wb(i = "ClickToPayService - Timeout during ".concat(e.t0.source, "() of the scheme '")).call(i, e.t0.scheme, "'")), null === (l = this.onTimeout) || void 0 === l || l.call(this, s)) : e.t0 instanceof ZH ? (console.warn(e.t0.toString()), null === (c = this.onTimeout) || void 0 === c || c.call(this, e.t0)) : e.t0 instanceof wH ? console.warn("Error at ClickToPayService # init: ".concat(e.t0.toString())) : console.warn(e.t0), this.setState(XH.NotAvailable);
                            case 36:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            1,
                            32
                        ]
                    ]);
                })), function() {
                    return c.apply(this, arguments);
                })
            },
            {
                key: "subscribeOnStateChange",
                value: function(e) {
                    this.stateSubscriber = e;
                }
            },
            {
                key: "startIdentityValidation",
                value: (s = Jd(Dy.mark(function e() {
                    var t, r;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (this.validationSchemeSdk) {
                                    e.next = 2;
                                    break;
                                }
                                throw Error("startIdentityValidation: No ValidationSDK set for the validation process");
                            case 2:
                                return e.next = 4, this.validationSchemeSdk.initiateIdentityValidation();
                            case 4:
                                t = e.sent, r = t.maskedValidationChannel, this.identityValidationData = {
                                    maskedShopperContact: r.replace(/\*/g, "\u2022"),
                                    selectedNetwork: UH[this.validationSchemeSdk.schemeName]
                                }, this.setState(XH.OneTimePassword);
                            case 8:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function() {
                    return s.apply(this, arguments);
                })
            },
            {
                key: "finishIdentityValidation",
                value: (l = Jd(Dy.mark(function e(t) {
                    var r;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (this.validationSchemeSdk) {
                                    e.next = 2;
                                    break;
                                }
                                throw Error("finishIdentityValidation: No ValidationSDK set for the validation process");
                            case 2:
                                return e.next = 4, this.validationSchemeSdk.completeIdentityValidation(t);
                            case 4:
                                return r = e.sent, e.next = 7, this.getShopperProfile([
                                    r.idToken
                                ]);
                            case 7:
                                this.setState(XH.Ready), this.validationSchemeSdk = null;
                            case 9:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function(e) {
                    return l.apply(this, arguments);
                })
            },
            {
                key: "checkout",
                value: (i = Jd(Dy.mark(function e(t) {
                    var r, a, n;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (t) {
                                    e.next = 2;
                                    break;
                                }
                                throw Error("ClickToPayService # checkout: Missing card data");
                            case 2:
                                return a = zb(r = this.sdks).call(r, function(e) {
                                    return e.schemeName === t.scheme;
                                }), e.next = 5, a.checkout($H($H({
                                    srcDigitalCardId: t.srcDigitalCardId,
                                    srcCorrelationId: t.srcCorrelationId
                                }, t.isDcfPopupEmbedded && {
                                    windowRef: window.frames[HH]
                                }), this.storeCookies && {
                                    complianceSettings: {
                                        complianceResources: [
                                            {
                                                complianceType: "REMEMBER_ME",
                                                uri: ""
                                            }
                                        ]
                                    }
                                }));
                            case 5:
                                if ("COMPLETE" === (n = e.sent).dcfActionCode) {
                                    e.next = 8;
                                    break;
                                }
                                throw new LS("ERROR", "Checkout through Scheme DCF did not complete. DCF Action code received: ".concat(n.dcfActionCode));
                            case 8:
                                return e.abrupt("return", qH(t, n, this.environment));
                            case 9:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function(e) {
                    return i.apply(this, arguments);
                })
            },
            {
                key: "logout",
                value: (o = Jd(Dy.mark(function e() {
                    var t, r;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (this.sdks) {
                                    e.next = 2;
                                    break;
                                }
                                throw new LS("ERROR", "ClickToPayService is not initialized");
                            case 2:
                                return e.prev = 2, r = hC(t = this.sdks).call(t, function(e) {
                                    return e.unbindAppInstance();
                                }), e.next = 6, Ab.all(r);
                            case 6:
                                e.next = 11;
                                break;
                            case 8:
                                e.prev = 8, e.t0 = e.catch(2), e.t0 instanceof wH ? console.warn("Error at ClickToPayService # logout: ".concat(e.t0.toString())) : console.warn(e.t0);
                            case 11:
                                this.shopperCards = null, this.identityValidationData = null, this.validationSchemeSdk = null, this.setState(XH.Login);
                            case 15:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                })), function() {
                    return o.apply(this, arguments);
                })
            },
            {
                key: "verifyIfShopperIsEnrolled",
                value: (n = Jd(Dy.mark(function e(t) {
                    var r, a = this;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return r = t.shopperEmail, e.abrupt("return", new Ab(function(e, t) {
                                    var n, o = hC(n = a.sdks).call(n, function(n) {
                                        var o = eq(function() {
                                            return n.identityLookup({
                                                identityValue: r,
                                                type: "email"
                                            });
                                        }, 5e3, new ZH("ClickToPayService - Timeout during identityLookup() of the scheme '".concat(n.schemeName, "'")));
                                        return o.then(function(t) {
                                            t.consumerPresent && !a.validationSchemeSdk && (a.setSdkForPerformingShopperIdentityValidation(n), e({
                                                isEnrolled: !0
                                            }));
                                        }).catch(function(e) {
                                            t(e);
                                        }), o;
                                    });
                                    Ab.allSettled(o).then(function() {
                                        e({
                                            isEnrolled: !1
                                        });
                                    });
                                }));
                            case 2:
                            case "end":
                                return e.stop();
                        }
                    }, e);
                })), function(e) {
                    return n.apply(this, arguments);
                })
            },
            {
                key: "setState",
                value: function(e) {
                    var t;
                    this.state = e, null === (t = this.stateSubscriber) || void 0 === t || t.call(this, this.state);
                }
            },
            {
                key: "setSdkForPerformingShopperIdentityValidation",
                value: function(e) {
                    this.validationSchemeSdk = e;
                }
            },
            {
                key: "getShopperProfile",
                value: (a = Jd(Dy.mark(function e(t) {
                    var r = this;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.abrupt("return", new Ab(function(e, a) {
                                    var n, o = hC(n = r.sdks).call(n, function(e) {
                                        return e.getSrcProfile(t);
                                    });
                                    Ab.allSettled(o).then(function(t) {
                                        var n;
                                        AI(t).call(t, BH) && a(t[0].reason);
                                        var o, i, l, s, c, u, d = xg(n = hC(t).call(t, function(e, t) {
                                            return jH(e) && $H($H({}, e.value), {}, {
                                                scheme: r.sdks[t].schemeName
                                            });
                                        })).call(n, function(e) {
                                            return !!e;
                                        });
                                        r.shopperCards = (s = tC(i = tC(o = d).call(o, WH, [])).call(i, YH, {
                                            availableCards: [],
                                            expiredCards: []
                                        }), c = s.availableCards, u = s.expiredCards, wb(l = []).call(l, Uk(VO(c).call(c, GH)), Uk(VO(u).call(u, GH)))), e();
                                    });
                                }));
                            case 1:
                            case "end":
                                return e.stop();
                        }
                    }, e);
                })), function(e) {
                    return a.apply(this, arguments);
                })
            },
            {
                key: "verifyIfShopperIsRecognized",
                value: (r = Jd(Dy.mark(function e() {
                    var t = this;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.abrupt("return", new Ab(function(e, r) {
                                    var a, n = hC(a = t.sdks).call(a, function(t) {
                                        var a = eq(function() {
                                            return t.isRecognized();
                                        }, 5e3, new ZH("ClickToPayService - Timeout during isRecognized() of the scheme '".concat(t.schemeName, "'")));
                                        return a.then(function(t) {
                                            return t.recognized && e(t);
                                        }).catch(function(e) {
                                            return r(e);
                                        }), a;
                                    });
                                    Ab.allSettled(n).then(function() {
                                        return e({
                                            recognized: !1
                                        });
                                    });
                                }));
                            case 1:
                            case "end":
                                return e.stop();
                        }
                    }, e);
                })), function() {
                    return r.apply(this, arguments);
                })
            },
            {
                key: "initiateSdks",
                value: (t = Jd(Dy.mark(function e() {
                    var t, r, a = this;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return r = hC(t = this.sdks).call(t, function(e) {
                                    var t = a.schemesConfig[e.schemeName];
                                    return eq(function() {
                                        return e.init(t, a.srciTransactionId);
                                    }, 5e3, new ZH("ClickToPayService - Timeout during init() of the scheme '".concat(e.schemeName, "'")));
                                }), e.next = 3, Ab.all(r);
                            case 3:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function() {
                    return t.apply(this, arguments);
                })
            }
        ]), e;
    }();
    function rq(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function aq(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = rq(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = rq(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function nq(e, t, r) {
        var a = iq(e);
        if (!a) return null;
        var n = oq(null == t ? void 0 : t.shopperEmail, null == t ? void 0 : t.telephoneNumber), o = Ty(a), i = new VH(o, {
            dpaLocale: null == t ? void 0 : t.locale,
            dpaPresentationName: null == t ? void 0 : t.merchantDisplayName
        });
        return new tq(a, i, r, n, null == t ? void 0 : t.onTimeout);
    }
    var oq = function(e, t) {
        var r = aq({}, e && {
            shopperEmail: e
        });
        return Ty(r).length > 0 ? r : null;
    }, iq = function(e) {
        if (!e) return null;
        var t = e.visaSrciDpaId, r = e.visaSrcInitiatorId, a = e.mcDpaId, n = e.mcSrcClientId, o = aq(aq({}, a && n && {
            mc: {
                srciDpaId: a,
                srcInitiatorId: n
            }
        }), t && r && {
            visa: {
                srciDpaId: t,
                srcInitiatorId: r
            }
        });
        return 0 === Ty(o).length ? null : o;
    }, lq = IN({
        status: null,
        onSubmit: null,
        onSetStatus: null,
        onError: null,
        onReady: null,
        amount: null,
        configuration: null,
        isStandaloneComponent: null,
        isCtpPrimaryPaymentMethod: null,
        isStoringCookies: !1,
        setIsCtpPrimaryPaymentMethod: null,
        logoutShopper: null,
        updateStoreCookiesConsent: null,
        ctpState: null,
        cards: [],
        schemes: [],
        otpMaskedContact: null,
        otpNetwork: null,
        checkout: null,
        verifyIfShopperIsEnrolled: null,
        startIdentityValidation: null,
        finishIdentityValidation: null
    }), sq = function(e) {
        var t, r, a = e.isStandaloneComponent, n = void 0 !== a && a, o = e.clickToPayService, i = e.amount, l = e.configuration, s = e.children, c = e.setClickToPayRef, u = e.onSubmit, d = e.onSetStatus, p = e.onError, m = Vk(VP(o), 1)[0], f = Vk(VP((null == o ? void 0 : o.state) || XH.NotAvailable), 2), h = f[0], v = f[1], y = Vk(VP(!0), 2), g = y[0], b = y[1], k = Vk(VP("ready"), 2), C = k[0], _ = k[1], N = qP({}), P = qP(!1);
        KP(function() {
            c(N.current), N.current.setStatus = _;
        }, []), KP(function() {
            null == m || m.subscribeOnStateChange(function(e) {
                return v(e);
            });
        }, [
            m
        ]);
        var w = GP(function() {
            var e;
            P.current || (null === (e = l.onReady) || void 0 === e || e.call(l), P.current = !0);
        }, [
            l.onReady
        ]), A = GP(function() {
            var e = Jd(Dy.mark(function e(t) {
                return Dy.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            return e.next = 2, null == m ? void 0 : m.finishIdentityValidation(t);
                        case 2:
                        case "end":
                            return e.stop();
                    }
                }, e);
            }));
            return function(t) {
                return e.apply(this, arguments);
            };
        }(), [
            m
        ]), S = GP(Jd(Dy.mark(function e() {
            var t;
            return Dy.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return e.next = 2, null == m ? void 0 : m.startIdentityValidation();
                    case 2:
                        return t = e.sent, e.abrupt("return", t);
                    case 4:
                    case "end":
                        return e.stop();
                }
            }, e);
        })), [
            m
        ]), I = GP(function() {
            var e = Jd(Dy.mark(function e(t) {
                return Dy.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            return e.next = 2, null == m ? void 0 : m.checkout(t);
                        case 2:
                            return e.abrupt("return", e.sent);
                        case 3:
                        case "end":
                            return e.stop();
                    }
                }, e);
            }));
            return function(t) {
                return e.apply(this, arguments);
            };
        }(), [
            m
        ]), E = GP(function() {
            var e = Jd(Dy.mark(function e(t) {
                return Dy.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            return e.next = 2, null == m ? void 0 : m.verifyIfShopperIsEnrolled(t);
                        case 2:
                            return e.abrupt("return", e.sent);
                        case 3:
                        case "end":
                            return e.stop();
                    }
                }, e);
            }));
            return function(t) {
                return e.apply(this, arguments);
            };
        }(), [
            m
        ]), D = GP(Jd(Dy.mark(function e() {
            return Dy.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return e.next = 2, null == m ? void 0 : m.logout();
                    case 2:
                    case "end":
                        return e.stop();
                }
            }, e);
        })), [
            m
        ]), R = GP(function(e) {
            m.updateStoreCookiesConsent(e);
        }, [
            m
        ]);
        return nN(lq.Provider, {
            value: {
                status: C,
                onSubmit: u,
                onError: p,
                onSetStatus: d,
                amount: i,
                configuration: l,
                isStoringCookies: null == m ? void 0 : m.storeCookies,
                isStandaloneComponent: n,
                isCtpPrimaryPaymentMethod: g,
                setIsCtpPrimaryPaymentMethod: b,
                ctpState: h,
                verifyIfShopperIsEnrolled: E,
                cards: null == m ? void 0 : m.shopperCards,
                schemes: null == m ? void 0 : m.schemes,
                otpMaskedContact: null == m || null === (t = m.identityValidationData) || void 0 === t ? void 0 : t.maskedShopperContact,
                otpNetwork: null == m || null === (r = m.identityValidationData) || void 0 === r ? void 0 : r.selectedNetwork,
                checkout: I,
                logoutShopper: D,
                startIdentityValidation: S,
                finishIdentityValidation: A,
                updateStoreCookiesConsent: R,
                onReady: w
            }
        }, s);
    };
    function cq() {
        return YP(lq);
    }
    var uq = {
        otp: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "",
            modes: [
                "blur"
            ]
        },
        default: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "",
            modes: [
                "blur"
            ]
        }
    }, dq = function(e) {
        var t = e.onError, r = e.onResendCode, a = e.disabled, n = Vk(VP(null), 2), o = n[0], i = n[1], l = Vk(VP(!1), 2), s = l[0], c = l[1], u = sw().i18n, d = cq().startIdentityValidation;
        KP(function() {
            var e = null;
            return o > 0 && (e = NP(function() {
                return i(o - 1);
            }, 1e3)), function() {
                return clearTimeout(e);
            };
        }, [
            o
        ]), KP(function() {
            var e = null;
            return s && (e = NP(function() {
                c(!1), i(60);
            }, 2e3)), function() {
                return clearTimeout(e);
            };
        }, [
            s
        ]);
        var p = GP(function() {
            var e = Jd(Dy.mark(function e(a) {
                return Dy.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            return a.preventDefault(), e.prev = 1, r(), c(!0), e.next = 6, d();
                        case 6:
                            e.next = 13;
                            break;
                        case 8:
                            e.prev = 8, e.t0 = e.catch(1), t(e.t0.reason), i(0), c(!1);
                        case 13:
                        case "end":
                            return e.stop();
                    }
                }, e, null, [
                    [
                        1,
                        8
                    ]
                ]);
            }));
            return function(t) {
                return e.apply(this, arguments);
            };
        }(), [
            d,
            t,
            r
        ]);
        return s ? nN("div", {
            className: "adyen-checkout-ctp__otp-resend-code--confirmation"
        }, u.get("ctp.otp.codeResent"), nN(DI, {
            type: "checkmark",
            height: 14,
            width: 14
        })) : o > 0 ? nN("div", {
            className: "adyen-checkout-ctp__otp-resend-code--disabled"
        }, u.get("ctp.otp.resendCode"), " -", " ", nN("span", {
            className: "adyen-checkout-ctp__otp-resend-code-counter"
        }, " ", o > 0 && "".concat(o, "s"), " ")) : nN("div", {
            role: "link",
            tabIndex: 0,
            className: DP("adyen-checkout-ctp__otp-resend-code", {
                "adyen-checkout-ctp__otp-resend-code--disabled": a
            }),
            onClick: p
        }, u.get("ctp.otp.resendCode"));
    }, pq = function(e) {
        var t = sw().i18n, r = cq().configuration.disableOtpAutoFocus, a = Vk(VP(null), 2), n = a[0], o = a[1], i = _D({
            schema: [
                "otp"
            ],
            rules: uq
        }), l = i.handleChangeFor, s = i.data, c = i.triggerValidation, u = i.valid, d = i.errors, p = i.isValid, m = i.setData, f = qP({
            validateInput: null
        }), h = qP(null), v = Vk(VP(!1), 2), y = v[0], g = v[1], b = GP(function() {
            g(!0), c();
        }, [
            c
        ]);
        KP(function() {
            s.otp && g(!0);
        }, [
            s.otp
        ]), KP(function() {
            !r && h.current && h.current.focus();
        }, [
            h.current,
            r
        ]), KP(function() {
            f.current.validateInput = b, e.onSetInputHandlers(f.current);
        }, [
            b,
            e.onSetInputHandlers
        ]);
        var k = GP(function() {
            m("otp", ""), o(null), r || h.current.focus(), e.onResendCode();
        }, [
            e.onResendCode,
            h.current,
            r
        ]), C = GP(function(e) {
            var r = t.get("ctp.errors.".concat(e));
            r && o(r);
        }, [
            t
        ]), _ = GP(function(t) {
            "Enter" === t.key && e.onPressEnter();
        }, [
            e.onPressEnter
        ]), N = GP(function(e) {
            "Enter" === e.key && e.preventDefault();
        }, []);
        return KP(function() {
            e.onChange({
                data: s,
                valid: u,
                errors: d,
                isValid: p
            });
        }, [
            s,
            u,
            d
        ]), nN(FE, {
            name: "oneTimePassword",
            label: t.get("ctp.otp.fieldLabel"),
            labelEndAdornment: !e.hideResendOtpButton && nN(dq, {
                disabled: e.isValidatingOtp,
                onError: C,
                onResendCode: k
            }),
            errorMessage: y ? n || e.errorMessage || !!d.otp : null,
            classNameModifiers: [
                "otp"
            ]
        }, nN(FD, {
            name: "otp",
            autocorrect: "off",
            spellcheck: !1,
            value: s.otp,
            disabled: e.disabled,
            onInput: l("otp", "input"),
            onBlur: l("otp", "blur"),
            onKeyUp: _,
            onKeyPress: N,
            setRef: function(e) {
                h.current = e;
            }
        }));
    }, mq = function(e) {
        var t = e.classNameModifiers, r = void 0 === t ? [] : t, a = II(), n = cq().schemes, o = a()("ctp"), i = a({
            imageFolder: "components/"
        })("pipe");
        return nN("div", {
            className: DP("adyen_checkout-ctp__brand-wrapper", hC(r).call(r, function(e) {
                return "adyen_checkout-ctp__brand-wrapper--".concat(e);
            }))
        }, nN(XT, {
            className: "adyen_checkout-ctp__brand-logo",
            src: o,
            alt: "Logo of Click to Pay"
        }), nN(XT, {
            className: "adyen_checkout-ctp__brand-pipe",
            src: i,
            alt: ""
        }), hC(n).call(n, function(e) {
            return nN(XT, {
                key: e,
                className: DP("adyen_checkout-ctp__brand-scheme", "adyen_checkout-ctp__brand-scheme-".concat(e)),
                src: a()(e),
                alt: "Logo of ".concat(UH[e])
            });
        }));
    }, fq = function(e) {
        var t = e.modalElement, r = e.isOpen, a = e.isDismissible, n = e.focusFirst, o = e.focusAfterClose, i = e.onClose;
        !function(e) {
            var t = e.rootElement, r = e.focusFirst, a = e.shouldTrap, n = void 0 === a || a, o = Vk(VP(r), 2), i = o[0], l = o[1];
            KP(function() {
                n && (null == i || i.focus());
            }, [
                i,
                n
            ]), KP(function() {
                if (n) {
                    var e = t.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'), a = e[0], o = e[e.length - 1];
                    l(r || a);
                    var i = function(e) {
                        if ("Tab" === e.key || 9 === e.keyCode) return e.shiftKey && document.activeElement === a ? (o.focus(), void e.preventDefault()) : document.activeElement === o ? (a.focus(), void e.preventDefault()) : void 0;
                    };
                    return t.addEventListener("keydown", i), function() {
                        l(null), t.removeEventListener("keydown", i);
                    };
                }
            }, [
                t,
                r,
                n
            ]);
        }({
            rootElement: t,
            shouldTrap: r,
            focusFirst: n
        });
        var l = GP(function() {
            o.focus(), i();
        }, [
            i,
            o
        ]), s = GP(function(e) {
            a && e.target instanceof HTMLElement && !t.contains(e.target) && l();
        }, [
            l,
            a,
            t
        ]);
        return KP(function() {
            if (r && t) {
                var e = function(e) {
                    ("Escape" === e.key || "Esc" === e.key || 27 === e.keyCode) && l();
                };
                return t.addEventListener("keydown", e), function() {
                    return t.removeEventListener("keydown", e);
                };
            }
        }, [
            r,
            t,
            l
        ]), {
            closeModal: l,
            handleClickOutside: s
        };
    }, hq = [
        "children",
        "classNameModifiers",
        "isOpen",
        "onClose",
        "isDismissible",
        "labelledBy",
        "describedBy",
        "focusFirst",
        "focusAfterClose"
    ], vq = function(e) {
        var t = e.children, r = e.classNameModifiers, a = void 0 === r ? [] : r, n = e.isOpen, o = e.onClose, i = e.isDismissible, l = void 0 === i || i, s = e.labelledBy, c = e.describedBy, u = e.focusFirst, d = e.focusAfterClose, p = kg(e, hq), m = qP(), f = fq({
            modalElement: m.current,
            isOpen: n,
            isDismissible: l,
            focusFirst: u,
            focusAfterClose: d,
            onClose: o
        }), h = f.closeModal, v = f.handleClickOutside;
        return nN("div", M_({
            className: DP("adyen-checkout__modal-wrapper", hC(a).call(a, function(e) {
                return "adyen-checkout__modal-wrapper--".concat(e);
            }), {
                "adyen-checkout__modal-wrapper--open": n
            }),
            role: "dialog",
            "aria-labelledby": s,
            "aria-describedby": c,
            "aria-modal": "true",
            "aria-hidden": !n,
            onClick: v
        }, p), nN("div", {
            className: "adyen-checkout__modal",
            ref: m
        }, t({
            onCloseModal: h
        })));
    }, yq = SE();
    function gq() {
        return "adyen-".concat(yq += 1);
    }
    var bq = function(e) {
        var t = e.isOpen, r = e.onClose, a = e.focusAfterClose, n = qP(), o = sw().i18n, i = II(), l = gq(), s = gq();
        return nN(vq, {
            onClose: r,
            isOpen: t,
            classNameModifiers: [
                "ctp"
            ],
            labelledBy: l,
            describedBy: s,
            focusFirst: n.current,
            focusAfterClose: a
        }, function(e) {
            var t = e.onCloseModal;
            return nN(iN, null, nN(XT, {
                className: "adyen-checkout__ctp-modal-header-image",
                src: i({
                    imageFolder: "components/"
                })("ctp_landscape"),
                alt: ""
            }), nN("h1", {
                id: l,
                className: "adyen-checkout__ctp-modal-title"
            }, o.get("ctp.infoPopup.title")), nN("div", {
                id: s
            }, nN("p", {
                tabIndex: -1,
                ref: n,
                className: "adyen-checkout__ctp-modal-text"
            }, o.get("ctp.infoPopup.subtitle")), nN("ul", {
                className: "adyen-checkout__ctp-modal-text adyen-checkout__ctp-modal-benefits",
                type: "disc"
            }, nN("li", null, o.get("ctp.infoPopup.benefit1")), nN("li", null, o.get("ctp.infoPopup.benefit2")), nN("li", null, o.get("ctp.infoPopup.benefit3"))), nN(mq, {
                classNameModifiers: [
                    "popup"
                ]
            })), nN(uw, {
                onClick: t,
                label: o.get("close")
            }));
        });
    }, kq = function() {
        var e = Vk(VP(!1), 2), t = e[0], r = e[1], a = qP(), n = sw().i18n, o = II()({
            imageFolder: "components/"
        })("info"), i = GP(function() {
            r(!1);
        }, []);
        return nN(iN, null, nN("button", {
            ref: a,
            onClick: GP(function() {
                r(!0);
            }, []),
            className: "adyen-web__ctp-info-button",
            "aria-label": n.get("ctp.aria.infoModalButton"),
            type: "button"
        }, nN(XT, {
            height: "15",
            src: o,
            ariaHidden: !0
        })), nN(bq, {
            isOpen: t,
            onClose: i,
            focusAfterClose: a.current
        }));
    }, Cq = function() {
        var e, t = cq(), r = t.ctpState, a = t.logoutShopper, n = t.status, o = t.cards, i = sw().i18n;
        if (!1 === kb(e = [
            XH.Ready,
            XH.OneTimePassword
        ]).call(e, r)) return null;
        var l = WP(function() {
            return r === XH.Ready && o.length > 1 ? i.get("ctp.logout.notYourCards") : r === XH.Ready && 1 === o.length ? i.get("ctp.logout.notYourCard") : r === XH.Ready && 0 === o.length ? i.get("ctp.logout.notYourProfile") : i.get("ctp.logout.notYou");
        }, [
            i,
            r
        ]);
        return nN("span", {
            role: "button",
            tabIndex: 0,
            className: DP("adyen-checkout-ctp__section-logout-button", {
                "adyen-checkout-ctp__section-logout-button--disabled": "loading" === n
            }),
            onClick: a
        }, l);
    }, _q = function(e) {
        var t = e.children, r = cq().isStandaloneComponent;
        return nN("div", {
            className: DP("adyen-checkout-ctp__section", {
                "adyen-checkout-ctp__section--standalone": r
            })
        }, nN("div", {
            className: "adyen-checkout-ctp__section-brand"
        }, nN(mq, null), nN(Cq, null)), t);
    };
    _q.Title = function(e) {
        var t = e.endAdornment;
        return nN("div", {
            className: "adyen-checkout-ctp__section-header"
        }, nN("h1", {
            className: "adyen-checkout-ctp__section-header-title"
        }, e.children), t && nN("span", {
            className: "adyen-checkout-ctp__section-header-adornment"
        }, t));
    }, _q.Text = function(e) {
        return nN("p", {
            className: "adyen-checkout-ctp__section-text"
        }, e.children);
    };
    function Nq() {
        var e = sw().i18n, t = cq(), r = t.updateStoreCookiesConsent, a = Vk(VP(t.isStoringCookies), 2), n = a[0], o = a[1], i = Vk(VP(window.matchMedia("(max-width: 480px)").matches), 2), l = i[0], s = i[1], c = GP(function() {
            var e = !n;
            o(e), r(e);
        }, [
            r,
            o,
            n
        ]);
        return nN("div", {
            className: DP("adyen-checkout-ctp__otp-checkbox-container", {
                "adyen-checkout-ctp__otp-checkbox-container--checked": n
            })
        }, nN(FE, {
            name: "clickToPayCookiesCheckbox",
            addContextualElement: !1,
            useLabelElement: !1,
            i18n: e
        }, nN(Bz, {
            name: "clickToPayCookiesCheckbox",
            onInput: c,
            label: e.get("ctp.otp.saveCookiesCheckbox.label"),
            checked: n,
            "aria-describedby": "adyen-ctp-cookies-info"
        })), nN("p", {
            className: "adyen-checkout-ctp__otp-checkbox-info"
        }, l ? nN(iN, null, nN("span", {
            id: "adyen-ctp-cookies-info"
        }, e.get("ctp.otp.saveCookiesCheckbox.shorterInfo"), " "), nN("button", {
            className: "adyen-checkout-ctp__otp-readmore-button",
            onClick: function() {
                return s(!1);
            }
        }, e.get("readMore"), "..")) : nN("span", {
            id: "adyen-ctp-cookies-info"
        }, e.get("ctp.otp.saveCookiesCheckbox.information"))));
    }
    var Pq = function(e) {
        var t = e.onDisplayCardComponent, r = sw().i18n, a = cq(), n = a.finishIdentityValidation, o = a.otpMaskedContact, i = a.otpNetwork, l = a.isCtpPrimaryPaymentMethod, s = Vk(VP(null), 2), c = s[0], u = s[1], d = Vk(VP(!1), 2), p = d[0], m = d[1], f = Vk(VP(!1), 2), h = f[0], v = f[1], y = Vk(VP(null), 2), g = y[0], b = y[1], k = Vk(VP(null), 2), C = k[0], _ = k[1], N = Vk(VP(!1), 2), P = N[0], w = N[1], A = GP(function(e) {
            _(e);
        }, []), S = GP(function(e) {
            var t = e.data, r = e.isValid;
            u(t.otp), m(r);
        }, []), I = GP(function() {
            b(null);
        }, []), E = GP(Jd(Dy.mark(function e() {
            return Dy.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (b(null), p) {
                            e.next = 4;
                            break;
                        }
                        return C.validateInput(), e.abrupt("return");
                    case 4:
                        return v(!0), e.prev = 5, e.next = 8, n(c);
                    case 8:
                        e.next = 15;
                        break;
                    case 10:
                        e.prev = 10, e.t0 = e.catch(5), b(null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.reason), v(!1), "ACCT_INACCESSIBLE" === (null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.reason) && (w(!0), null == t || t());
                    case 15:
                    case "end":
                        return e.stop();
                }
            }, e, null, [
                [
                    5,
                    10
                ]
            ]);
        })), [
            c,
            p,
            C,
            t
        ]), D = r.get("ctp.otp.subtitle").split("%@");
        return nN(iN, null, nN(_q.Title, {
            endAdornment: nN(kq, null)
        }, r.get("ctp.otp.title")), nN(_q.Text, null, D[0], " ", i, " ", D[1], nN("span", {
            className: "adyen-checkout-ctp__otp-subtitle--highlighted"
        }, o), D[2]), nN(pq, {
            hideResendOtpButton: P,
            onChange: S,
            onSetInputHandlers: A,
            disabled: h,
            errorMessage: g && r.get("ctp.errors.".concat(g)),
            onPressEnter: E,
            onResendCode: I,
            isValidatingOtp: h
        }), nN(Nq, null), nN(uw, {
            disabled: P,
            label: r.get("continue"),
            variant: l ? "primary" : "secondary",
            onClick: E,
            status: h && "loading"
        }));
    }, wq = function(e) {
        var t = e.card, r = e.errorMessage, a = sw().i18n, n = II();
        return nN(iN, null, nN("div", {
            className: "adyen-checkout-ctp__card-list-single-card"
        }, nN(XT, {
            src: t.artUri || n()(t.scheme),
            height: 24,
            className: "adyen-checkout-ctp__card-image"
        }), nN("span", {
            className: DP({
                "adyen-checkout-ctp__card-list-single-card-expired": t.isExpired
            })
        }, t.title, " ", "\u2022\u2022\u2022\u2022 ".concat(t.panLastFour)), t.isExpired && nN("span", {
            className: "adyen-checkout-ctp__expired-label"
        }, a.get("ctp.cards.expiredCard"))), r && nN("div", {
            className: "adyen-checkout__error-text"
        }, r));
    }, Aq = function() {
        return window.matchMedia("(max-width: 768px)").matches && /Android|iPhone|iPod/.test(navigator.userAgent);
    }, Sq = [
        "srcDigitalCardId"
    ], Iq = function(e) {
        var t = e.cardSelected, r = e.cards, a = e.errorMessage, n = e.onChangeCard, o = sw().i18n, i = II(), l = cq().status, s = _D({
            schema: Sq,
            defaultData: {
                srcDigitalCardId: t.srcDigitalCardId
            }
        }), c = s.handleChangeFor, u = s.data, d = WP(function() {
            return hC(r).call(r, function(e) {
                var t;
                return {
                    icon: e.artUri || i()(e.scheme),
                    name: wb(t = "".concat(Aq() ? "" : e.title, " \u2022\u2022\u2022\u2022 ")).call(t, e.panLastFour, " "),
                    secondaryText: e.isExpired && o.get("ctp.cards.expiredCard"),
                    id: e.srcDigitalCardId,
                    disabled: e.isExpired
                };
            });
        }, [
            r
        ]);
        return KP(function() {
            var e = u.srcDigitalCardId, t = zb(r).call(r, function(t) {
                return t.srcDigitalCardId === e;
            });
            n(t);
        }, [
            u,
            n
        ]), nN(FE, {
            name: "clickToPayCards",
            errorMessage: a
        }, nN(cz, {
            items: d,
            selectedValue: u.srcDigitalCardId,
            name: "cards",
            filterable: !1,
            className: "adyen-checkout-ctp__cards-list-dropdown",
            readonly: "loading" === l,
            onChange: c("srcDigitalCardId")
        }));
    };
    function Eq(e, t) {
        if (!e) return null;
        var r = t.get("ctp.errors.".concat(e));
        return kb(r).call(r, "ctp.errors") ? t.get("ctp.errors.UNKNOWN_ERROR") : r;
    }
    function Dq(e, t, r) {
        return r ? Aq() ? null : e.get("payButton.with", {
            values: {
                value: dw(e, t),
                maskedData: "\u2022\u2022\u2022\u2022 ".concat(null == r ? void 0 : r.panLastFour)
            }
        }) : e.get("payButton");
    }
    var Rq = function(e) {
        var t = e.onDisplayCardComponent, r = sw().i18n, a = II(), n = cq(), o = n.amount, i = n.cards, l = n.checkout, s = n.isCtpPrimaryPaymentMethod, c = n.status, u = n.onSubmit, d = n.onSetStatus, p = n.onError, m = Vk(VP(zb(i).call(i, function(e) {
            return !e.isExpired;
        }) || i[0]), 2), f = m[0], h = m[1], v = Vk(VP(null), 2), y = v[0], g = v[1], b = AI(i).call(i, function(e) {
            return e.isExpired;
        }), k = Vk(VP(!1), 2), C = k[0], _ = k[1];
        KP(function() {
            (0 === i.length || b) && (null == t || t());
        }, [
            t,
            b,
            i
        ]);
        var N = GP(Jd(Dy.mark(function e() {
            var t, r, a;
            return Dy.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (f) {
                            e.next = 2;
                            break;
                        }
                        return e.abrupt("return");
                    case 2:
                        return e.prev = 2, _(!0), g(null), d("loading"), e.next = 8, l(f);
                    case 8:
                        t = e.sent, u(t), e.next = 17;
                        break;
                    case 12:
                        e.prev = 12, e.t0 = e.catch(2), e.t0 instanceof wH && (g(null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.reason), console.warn(wb(r = wb(a = "CtP - Checkout: Reason: ".concat(null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.reason, " / Source: ")).call(a, null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.source, " / Scheme: ")).call(r, null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.scheme))), _(!1), p(e.t0);
                    case 17:
                    case "end":
                        return e.stop();
                }
            }, e, null, [
                [
                    2,
                    12
                ]
            ]);
        })), [
            l,
            f
        ]), P = GP(function(e) {
            h(e);
        }, []), w = C && "loading" === c && (null == f ? void 0 : f.isDcfPopupEmbedded), A = "loading" !== c || !w;
        return nN(iN, null, nN(GS, {
            name: HH,
            height: "380",
            width: "100%",
            classNameModifiers: [
                w ? "" : "hidden"
            ]
        }), A && nN(iN, null, nN(_q.Title, null, r.get("ctp.cards.title")), nN(_q.Text, null, r.get("ctp.cards.subtitle")), 0 === i.length && nN("div", {
            className: "adyen-checkout-ctp__empty-cards"
        }, r.get("ctp.emptyProfile.message")), 1 === i.length && nN(wq, {
            card: i[0],
            errorMessage: Eq(y, r)
        }), i.length > 1 && nN(Iq, {
            cardSelected: f,
            cards: i,
            onChangeCard: P,
            errorMessage: Eq(y, r)
        }), nN(hw, {
            disabled: b,
            amount: o,
            label: Dq(r, o, f),
            status: c,
            variant: s ? "primary" : "secondary",
            icon: 0 !== i.length && a({
                imageFolder: "components/"
            })(s ? "lock" : "lock_black"),
            onClick: N
        })));
    }, Fq = function() {
        var e = sw().i18n;
        return nN(iN, null, nN("div", {
            className: "adyen-checkout-ctp__card-animation"
        }, nN("div", {
            className: "adyen-checkout-ctp__card-animation-layer"
        }), nN("div", {
            className: "adyen-checkout-ctp__card-animation-layer"
        }), nN("div", {
            className: "adyen-checkout-ctp__card-animation-layer"
        })), nN("div", {
            className: "adyen-checkout-ctp__loading-subtitle"
        }, e.get("ctp.loading.intro")));
    }, xq = {
        shopperLogin: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "",
            modes: [
                "blur"
            ]
        },
        default: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "",
            modes: [
                "blur"
            ]
        }
    }, Tq = function(e) {
        var t = sw().i18n, r = _D({
            schema: [
                "shopperLogin"
            ],
            rules: xq
        }), a = r.handleChangeFor, n = r.data, o = r.triggerValidation, i = r.valid, l = r.errors, s = r.isValid, c = qP({
            validateInput: null
        }), u = Vk(VP(!1), 2), d = u[0], p = u[1], m = GP(function() {
            p(!0), o();
        }, [
            o
        ]);
        KP(function() {
            n.shopperLogin && p(!0);
        }, [
            n.shopperLogin
        ]), KP(function() {
            c.current.validateInput = m, e.onSetInputHandlers(c.current);
        }, [
            m,
            e.onSetInputHandlers
        ]);
        var f = GP(function(t) {
            "Enter" === t.key && e.onPressEnter();
        }, [
            e.onPressEnter
        ]), h = GP(function(e) {
            "Enter" === e.key && e.preventDefault();
        }, []);
        return KP(function() {
            e.onChange({
                data: n,
                valid: i,
                errors: l,
                isValid: s
            });
        }, [
            n,
            i,
            l
        ]), nN(FE, {
            name: "shopperLogin",
            label: t.get("ctp.login.inputLabel"),
            errorMessage: d ? e.errorMessage || !!l.shopperLogin : null,
            classNameModifiers: [
                "shopperLogin"
            ]
        }, nN(dR, {
            name: "shopperLogin",
            autocorrect: "off",
            spellcheck: !1,
            value: n.shopperLogin,
            disabled: e.disabled,
            onInput: a("shopperLogin", "input"),
            onBlur: a("shopperLogin", "blur"),
            onKeyPress: h,
            onKeyUp: f
        }));
    }, zq = function() {
        var e = sw().i18n, t = cq(), r = t.isCtpPrimaryPaymentMethod, a = t.setIsCtpPrimaryPaymentMethod, n = t.verifyIfShopperIsEnrolled, o = t.startIdentityValidation, i = Vk(VP(null), 2), l = i[0], s = i[1], c = Vk(VP(!1), 2), u = c[0], d = c[1], p = Vk(VP(null), 2), m = p[0], f = p[1], h = Vk(VP(!1), 2), v = h[0], y = h[1], g = Vk(VP(null), 2), b = g[0], k = g[1], C = GP(function(e) {
            k(e);
        }, []), _ = GP(function(e) {
            var t, r = e.data, n = e.isValid;
            s(r.shopperLogin), d(n), (null == r || null === (t = r.shopperLogin) || void 0 === t ? void 0 : t.length) > 0 && a(!0);
        }, []), N = GP(Jd(Dy.mark(function e() {
            var t;
            return Dy.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (f(null), u) {
                            e.next = 4;
                            break;
                        }
                        return b.validateInput(), e.abrupt("return");
                    case 4:
                        return y(!0), e.prev = 5, e.next = 8, n({
                            shopperEmail: l
                        });
                    case 8:
                        if (t = e.sent, !t.isEnrolled) {
                            e.next = 15;
                            break;
                        }
                        return e.next = 13, o();
                    case 13:
                        e.next = 17;
                        break;
                    case 15:
                        f("NOT_FOUND"), y(!1);
                    case 17:
                        e.next = 25;
                        break;
                    case 19:
                        e.prev = 19, e.t0 = e.catch(5), e.t0 instanceof wH && console.warn("CtP - Login error: ".concat(e.t0.toString())), e.t0 instanceof ZH && console.warn(e.t0.toString()), f(null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.reason), y(!1);
                    case 25:
                    case "end":
                        return e.stop();
                }
            }, e, null, [
                [
                    5,
                    19
                ]
            ]);
        })), [
            n,
            o,
            l,
            u,
            b
        ]);
        return nN(iN, null, nN(_q.Title, {
            endAdornment: nN(kq, null)
        }, e.get("ctp.login.title")), nN(_q.Text, null, e.get("ctp.login.subtitle")), nN(Tq, {
            onChange: _,
            onSetInputHandlers: C,
            disabled: v,
            errorMessage: m && e.get("ctp.errors.".concat(m)),
            onPressEnter: N
        }), nN(uw, {
            label: e.get("continue"),
            variant: r ? "primary" : "secondary",
            status: v && "loading",
            onClick: function() {
                N();
            }
        }));
    }, Oq = function(e) {
        var t, r = e.onDisplayCardComponent, a = cq(), n = a.ctpState, o = a.onReady, i = a.startIdentityValidation, l = a.logoutShopper;
        return KP(function() {
            var e;
            kb(e = [
                XH.OneTimePassword,
                XH.Login,
                XH.Ready
            ]).call(e, n) && o();
        }, [
            n,
            o
        ]), KP(function() {
            function e() {
                return e = Jd(Dy.mark(function e() {
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, e.next = 3, i();
                            case 3:
                                e.next = 10;
                                break;
                            case 5:
                                return e.prev = 5, e.t0 = e.catch(0), e.t0 instanceof wH && console.warn("CtP - Identity Validation error: ".concat(e.t0.toString())), e.next = 10, l();
                            case 10:
                            case "end":
                                return e.stop();
                        }
                    }, e, null, [
                        [
                            0,
                            5
                        ]
                    ]);
                })), e.apply(this, arguments);
            }
            n === XH.ShopperIdentified && function() {
                e.apply(this, arguments);
            }();
        }, [
            n
        ]), n === XH.NotAvailable ? null : nN(_q, null, kb(t = [
            XH.Loading,
            XH.ShopperIdentified
        ]).call(t, n) && nN(Fq, null), n === XH.OneTimePassword && nN(Pq, {
            onDisplayCardComponent: r
        }), n === XH.Ready && nN(Rq, {
            onDisplayCardComponent: r
        }), n === XH.Login && nN(zq, null));
    }, jq = function(e) {
        var t = e.children, r = sw().i18n, a = Vk(VP(null), 2), n = a[0], o = a[1], i = cq(), l = i.ctpState, s = i.isCtpPrimaryPaymentMethod, c = i.setIsCtpPrimaryPaymentMethod, u = i.status, d = null === n && null === s;
        KP(function() {
            if (d) {
                if (l === XH.ShopperIdentified || l === XH.Ready) return o(!1), void c(!0);
                l === XH.NotAvailable && (o(!0), c(!1));
            }
        }, [
            l,
            d
        ]);
        var p = GP(function() {
            o(!0), c(!1);
        }, []);
        return l === XH.NotAvailable ? t() : l === XH.Loading || l === XH.ShopperIdentified ? nN(Oq, null) : nN(iN, null, nN(Oq, {
            onDisplayCardComponent: p
        }), nN(MB, {
            classNames: [
                "adyen-checkout-ctp__separator"
            ],
            label: r.get("ctp.separatorText")
        }), n ? t(!s) : nN(uw, {
            variant: "secondary",
            disabled: "loading" === u,
            label: r.get("ctp.manualCardEntry"),
            onClick: p
        }));
    }, Bq = [
        "amount",
        "configuration",
        "clickToPayService",
        "setClickToPayRef",
        "onSetStatus",
        "onSubmit",
        "onError",
        "isStandaloneComponent"
    ], Mq = function(e) {
        var t = e.amount, r = e.configuration, a = e.clickToPayService, n = e.setClickToPayRef, o = e.onSetStatus, i = e.onSubmit, l = e.onError, s = e.isStandaloneComponent, c = kg(e, Bq);
        return nN(sq, {
            isStandaloneComponent: s,
            configuration: r,
            amount: t,
            clickToPayService: a,
            setClickToPayRef: n,
            onSetStatus: o,
            onSubmit: i,
            onError: l
        }, nN(jq, null, c.children));
    };
    function Lq(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Vq(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = Lq(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = Lq(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function Uq(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var Kq = function(e) {
        U_(r, e);
        var t = Uq(r);
        function r(e) {
            var a, n;
            (Cg(this, r), Ag(L_(a = t.call(this, e)), "clickToPayService", void 0), Ag(L_(a), "clickToPayRef", null), Ag(L_(a), "setClickToPayRef", function(e) {
                a.clickToPayRef = e;
            }), Ag(L_(a), "onBrand", function(e) {
                a.eventEmitter.emit("brand", Vq(Vq({}, e), {}, {
                    brand: "card" === e.brand ? null : e.brand
                })), a.props.onBrand && a.props.onBrand(e);
            }), Ag(L_(a), "handleClickToPaySubmit", function(e) {
                a.setState({
                    data: Vq({}, e),
                    valid: {},
                    errors: {},
                    isValid: !0
                }), a.submit();
            }), Ag(L_(a), "onConfigSuccess", function(e) {
                var t, r;
                a.submitAnalytics({
                    type: GN
                }), null === (t = (r = a.props).onConfigSuccess) || void 0 === t || t.call(r, e);
            }), Ag(L_(a), "onFocus", function(e) {
                var t, r, n, o;
                (a.submitAnalytics({
                    type: qN,
                    target: QV(e.fieldType)
                }), kb(WI).call(WI, e.fieldType)) ? null === (t = (r = a.props).onFocus) || void 0 === t || t.call(r, e.event) : null === (n = (o = a.props).onFocus) || void 0 === n || n.call(o, e);
            }), Ag(L_(a), "onBlur", function(e) {
                var t, r, n, o;
                (a.submitAnalytics({
                    type: WN,
                    target: QV(e.fieldType)
                }), kb(WI).call(WI, e.fieldType)) ? null === (t = (r = a.props).onBlur) || void 0 === t || t.call(r, e.event) : null === (n = (o = a.props).onBlur) || void 0 === n || n.call(o, e);
            }), Ag(L_(a), "onErrorAnalytics", function(e) {
                a.submitAnalytics({
                    type: HN,
                    target: QV(e.fieldType),
                    validationErrorCode: e.errorCode,
                    validationErrorMessage: qO(e.errorCode, bE)
                });
            }), Ag(L_(a), "onBinValue", NH(L_(a))), Ag(L_(a), "payButton", function(e) {
                var t, r, n = 0 === (null === (t = a.props.amount) || void 0 === t ? void 0 : t.value), o = (null === (r = a.props.storedPaymentMethodId) || void 0 === r ? void 0 : r.length) > 0;
                return nN(hw, M_({}, e, {
                    amount: a.props.amount,
                    secondaryAmount: a.props.secondaryAmount,
                    label: n && !o ? a.props.i18n.get("payButton.saveDetails") : "",
                    onClick: a.submit
                }));
            }), e._disableClickToPay) || (a.clickToPayService = nq(a.props.configuration, a.props.clickToPayConfiguration, a.props.environment), null === (n = a.clickToPayService) || void 0 === n || n.initialize());
            return a;
        }
        return wg(r, [
            {
                key: "setStatus",
                value: function(e, t) {
                    var r, a;
                    return null !== (r = this.componentRef) && void 0 !== r && r.setStatus && this.componentRef.setStatus(e, t), null !== (a = this.clickToPayRef) && void 0 !== a && a.setStatus && this.clickToPayRef.setStatus(e, t), this;
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    var t, r, a, n, o, i, l, s, c, u, d, p, m, f, h, v = null !== (t = null === (r = e.session) || void 0 === r || null === (r = r.configuration) || void 0 === r ? void 0 : r.enableStoreDetails) && void 0 !== t ? t : e.enableStoreDetails, y = !(0 === (null === (a = e.amount) || void 0 === a ? void 0 : a.value)) && v;
                    return Vq(Vq({}, e), {}, {
                        holderNameRequired: !!e.hasHolderName && e.holderNameRequired,
                        hasCVC: !(e.brand && "bcmc" === e.brand || e.hideCVC),
                        billingAddressRequired: !e.storedPaymentMethodId && e.billingAddressRequired,
                        type: "scheme" === e.type ? "card" : e.type,
                        countryCode: e.countryCode ? e.countryCode.toLowerCase() : null,
                        configuration: Vq(Vq({}, e.configuration), {}, {
                            socialSecurityNumberMode: null !== (n = null === (o = e.configuration) || void 0 === o ? void 0 : o.socialSecurityNumberMode) && void 0 !== n ? n : "auto"
                        }),
                        brandsConfiguration: e.brandsConfiguration || (null === (i = e.configuration) || void 0 === i ? void 0 : i.brandsConfiguration) || {},
                        icon: e.icon || (null === (l = e.configuration) || void 0 === l ? void 0 : l.icon),
                        installmentOptions: (null === (s = e.session) || void 0 === s || null === (s = s.configuration) || void 0 === s ? void 0 : s.installmentOptions) || e.installmentOptions,
                        enableStoreDetails: v,
                        showStoreDetailsCheckbox: y,
                        clickToPayConfiguration: Vq(Vq({}, e.clickToPayConfiguration), {}, {
                            disableOtpAutoFocus: (null === (c = e.clickToPayConfiguration) || void 0 === c ? void 0 : c.disableOtpAutoFocus) || !1,
                            shopperEmail: (null === (u = e.clickToPayConfiguration) || void 0 === u ? void 0 : u.shopperEmail) || (null == e || null === (d = e._parentInstance) || void 0 === d || null === (d = d.options) || void 0 === d || null === (d = d.session) || void 0 === d ? void 0 : d.shopperEmail),
                            telephoneNumber: (null === (p = e.clickToPayConfiguration) || void 0 === p ? void 0 : p.telephoneNumber) || (null == e || null === (m = e._parentInstance) || void 0 === m || null === (m = m.options) || void 0 === m || null === (m = m.session) || void 0 === m ? void 0 : m.telephoneNumber),
                            locale: (null === (f = e.clickToPayConfiguration) || void 0 === f ? void 0 : f.locale) || (null === (h = e.i18n) || void 0 === h || null === (h = h.locale) || void 0 === h ? void 0 : h.replace("-", "_"))
                        })
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e, t = this.state.selectedBrandValue || this.props.brand;
                    return Vq(Vq(Vq(Vq(Vq({
                        paymentMethod: Vq(Vq(Vq(Vq({
                            type: r.type
                        }, this.state.data), this.props.storedPaymentMethodId && {
                            storedPaymentMethodId: this.props.storedPaymentMethodId
                        }), t && {
                            brand: t
                        }), this.props.fundingSource && {
                            fundingSource: this.props.fundingSource
                        })
                    }, this.state.billingAddress && {
                        billingAddress: this.state.billingAddress
                    }), this.state.socialSecurityNumber && {
                        socialSecurityNumber: this.state.socialSecurityNumber
                    }), this.storePaymentMethodPayload), ("revolving" === (null == (e = this.state.installments) ? void 0 : e.plan) || (null == e ? void 0 : e.value) > 1) && {
                        installments: this.state.installments
                    }), {}, {
                        browserInfo: this.browserInfo,
                        origin: !!window && window.location.origin
                    });
                }
            },
            {
                key: "updateStyles",
                value: function(e) {
                    var t;
                    return null !== (t = this.componentRef) && void 0 !== t && t.updateStyles && this.componentRef.updateStyles(e), this;
                }
            },
            {
                key: "setFocusOn",
                value: function(e) {
                    var t;
                    return null !== (t = this.componentRef) && void 0 !== t && t.setFocusOn && this.componentRef.setFocusOn(e), this;
                }
            },
            {
                key: "processBinLookupResponse",
                value: function(e) {
                    var t, r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    return null !== (t = this.componentRef) && void 0 !== t && t.processBinLookupResponse && this.componentRef.processBinLookupResponse(e, r), this;
                }
            },
            {
                key: "handleUnsupportedCard",
                value: function(e) {
                    var t;
                    return null !== (t = this.componentRef) && void 0 !== t && t.handleUnsupportedCard && this.componentRef.handleUnsupportedCard(e), this;
                }
            },
            {
                key: "onBinLookup",
                value: function(e) {
                    if (!e.isReset) {
                        var t = JV("supportedBrandsRaw").from(e);
                        this.props.onBinLookup(t);
                    }
                }
            },
            {
                key: "submitAnalytics",
                value: function(e) {
                    var t = e.type;
                    t !== LN && t !== GN || "scheme" === this.constructor.type && VS(this.props, "supportedShopperInteractions") && (e.isStoredPaymentMethod = !0, e.brand = this.props.brand), kI(H_(r.prototype), "submitAnalytics", this).call(this, e);
                }
            },
            {
                key: "storePaymentMethodPayload",
                get: function() {
                    var e, t;
                    return (null === (e = this.props.storedPaymentMethodId) || void 0 === e ? void 0 : e.length) > 0 ? {} : 0 === (null === (t = this.props.amount) || void 0 === t ? void 0 : t.value) ? this.props.enableStoreDetails ? {
                        storePaymentMethod: !0
                    } : {} : this.props.showStoreDetailsCheckbox && void 0 !== this.state.storePaymentMethod ? {
                        storePaymentMethod: Boolean(this.state.storePaymentMethod)
                    } : {};
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "icon",
                get: function() {
                    var e;
                    return null !== (e = this.props.icon) && void 0 !== e ? e : this.resources.getImage()(this.brand);
                }
            },
            {
                key: "brands",
                get: function() {
                    var e = this, t = this.props, r = t.brands, a = t.brandsConfiguration;
                    return r ? hC(r).call(r, function(t) {
                        var r, n;
                        return {
                            icon: null !== (r = null === (n = a[t]) || void 0 === n ? void 0 : n.icon) && void 0 !== r ? r : e.props.modules.resources.getImage()(t),
                            name: t
                        };
                    }) : [];
                }
            },
            {
                key: "brand",
                get: function() {
                    return this.props.brand || this.props.type;
                }
            },
            {
                key: "displayName",
                get: function() {
                    return this.props.storedPaymentMethodId ? "\u2022\u2022\u2022\u2022 ".concat(this.props.lastFour) : this.props.name || r.type;
                }
            },
            {
                key: "accessibleName",
                get: function() {
                    return (this.props.name || r.type) + (this.props.storedPaymentMethodId ? " " + this.props.i18n.get("creditCard.storedCard.description.ariaLabel").replace("%@", this.props.lastFour) : "");
                }
            },
            {
                key: "browserInfo",
                get: function() {
                    return Mj();
                }
            },
            {
                key: "renderCardInput",
                value: function() {
                    var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                    return nN(CH, M_({
                        setComponentRef: this.setComponentRef
                    }, this.props, this.state, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton,
                        onBrand: this.onBrand,
                        onBinValue: this.onBinValue,
                        brand: this.brand,
                        brandsIcons: this.brands,
                        isPayButtonPrimaryVariant: e,
                        resources: this.resources,
                        onFocus: this.onFocus,
                        onBlur: this.onBlur,
                        onErrorAnalytics: this.onErrorAnalytics,
                        onConfigSuccess: this.onConfigSuccess
                    }));
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(_j, {
                        srPanel: this.props.modules.srPanel
                    }, nN(Mq, {
                        amount: this.props.amount,
                        configuration: this.props.clickToPayConfiguration,
                        clickToPayService: this.clickToPayService,
                        isStandaloneComponent: !1,
                        setClickToPayRef: this.setClickToPayRef,
                        onSetStatus: this.setElementStatus,
                        onSubmit: this.handleClickToPaySubmit,
                        onError: this.handleError
                    }, function(t) {
                        return e.renderCardInput(t);
                    })));
                }
            }
        ]), r;
    }(qS);
    Ag(Kq, "type", "scheme"), Ag(Kq, "defaultProps", {
        onBinLookup: function() {},
        showBrandsUnderCardNumber: !0,
        showFormInstruction: !0,
        _disableClickToPay: !1
    });
    var Hq = function(e) {
        return e.CustomerDismissed = "CUSTOMER_DISMISSED", e.CustomerRequestApproved = "CUSTOMER_REQUEST_APPROVED", e.CustomerRequestDeclined = "CUSTOMER_REQUEST_DECLINED", e.CustomerRequestFailed = "CUSTOMER_REQUEST_FAILED", e;
    }({});
    function qq(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Wq(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = qq(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = qq(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function Gq(e) {
        var t = e.enableStoreDetails, r = e.cashAppService, a = e.onClick, n = e.onChangeStoreDetails, o = e.onAuthorize, i = e.onError, l = qP(null), s = Vk(VP("loading"), 2), c = s[0], u = s[1], d = qP([]), p = Vk(VP(!1), 2), m = p[0], f = p[1];
        this.setStatus = u;
        var h = GP(Jd(Dy.mark(function e() {
            return Dy.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return e.prev = 0, e.next = 3, r.initialize();
                    case 3:
                        return d.current = [
                            r.subscribeToEvent(Hq.CustomerDismissed, function() {
                                i(new LS("CANCEL", "Customer dismissed the modal"));
                            }),
                            r.subscribeToEvent(Hq.CustomerRequestDeclined, Jd(Dy.mark(function e() {
                                return Dy.wrap(function(e) {
                                    for(;;)switch(e.prev = e.next){
                                        case 0:
                                            return i(new LS("ERROR", "Payment declined by CashAppPay")), e.next = 3, r.restart();
                                        case 3:
                                            return e.next = 5, r.renderButton(l.current);
                                        case 5:
                                        case "end":
                                            return e.stop();
                                    }
                                }, e);
                            }))),
                            r.subscribeToEvent(Hq.CustomerRequestApproved, function(e) {
                                var t, r, a = e.customerProfile, n = e.grants, i = Wq(Wq(Wq(Wq({}, (null == a ? void 0 : a.id) && {
                                    customerId: a.id
                                }), (null == a ? void 0 : a.cashtag) && {
                                    cashTag: a.cashtag
                                }), (null == n || null === (t = n.payment) || void 0 === t ? void 0 : t.grantId) && {
                                    grantId: n.payment.grantId
                                }), (null == n || null === (r = n.onFile) || void 0 === r ? void 0 : r.grantId) && {
                                    onFileGrantId: n.onFile.grantId
                                });
                                o(i);
                            }),
                            r.subscribeToEvent(Hq.CustomerRequestFailed, function() {
                                i(new LS("ERROR", "Customer request failed"));
                            })
                        ], e.next = 6, r.renderButton(l.current);
                    case 6:
                        u("ready"), e.next = 12;
                        break;
                    case 9:
                        e.prev = 9, e.t0 = e.catch(0), i(e.t0);
                    case 12:
                    case "end":
                        return e.stop();
                }
            }, e, null, [
                [
                    0,
                    9
                ]
            ]);
        })), [
            r,
            i,
            o
        ]);
        return KP(function() {
            t && (r.setStorePaymentMethod(m), n(m));
        }, [
            t,
            m
        ]), KP(function() {
            return h(), function() {
                var e;
                r.restart(), Sg(e = d.current).call(e, function(e) {
                    return e();
                });
            };
        }, [
            r,
            h
        ]), nN("div", {
            className: "adyen-checkout__cashapp"
        }, "loading" === c && nN(RP, null), "loading" !== c && t && nN(uH, {
            storeDetails: m,
            onChange: f
        }), nN("div", {
            onClick: a,
            className: "adyen-checkout__cashapp-button",
            ref: l
        }));
    }
    function Yq(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Qq(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = Yq(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = Yq(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var Zq = function() {
        function e(t, r) {
            Cg(this, e), Ag(this, "sdkLoader", void 0), Ag(this, "configuration", void 0), Ag(this, "pay", void 0), Ag(this, "startAuthorization", void 0), this.configuration = r, this.sdkLoader = t, r.clientId || console.warn("CashAppService: clientId is missing");
        }
        var t, r, a, n;
        return wg(e, [
            {
                key: "hasOneTimePayment",
                get: function() {
                    var e = this.configuration.amount;
                    return (null == e ? void 0 : e.value) > 0;
                }
            },
            {
                key: "hasOnFilePayment",
                get: function() {
                    return this.configuration.storePaymentMethod;
                }
            },
            {
                key: "setStorePaymentMethod",
                value: function(e) {
                    this.configuration.storePaymentMethod = e;
                }
            },
            {
                key: "initialize",
                value: (n = Jd(Dy.mark(function e() {
                    var t, r, a, n;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, t = this.configuration, r = t.environment, a = t.clientId, e.next = 4, this.sdkLoader.load(r);
                            case 4:
                                return n = e.sent, e.next = 7, n.pay({
                                    clientId: a
                                });
                            case 7:
                                this.pay = e.sent, e.next = 13;
                                break;
                            case 10:
                                throw e.prev = 10, e.t0 = e.catch(0), new LS("ERROR", "Error during initialization", {
                                    cause: e.t0
                                });
                            case 13:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            10
                        ]
                    ]);
                })), function() {
                    return n.apply(this, arguments);
                })
            },
            {
                key: "renderButton",
                value: (a = Jd(Dy.mark(function e(t) {
                    var r, a, n, o, i;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, r = this.configuration, a = r.button, n = r.useCashAppButtonUi, e.next = 4, this.pay.render(t, {
                                    manage: !1,
                                    button: !!n && Qq({
                                        width: "full",
                                        shape: "semiround"
                                    }, a)
                                });
                            case 4:
                                o = e.sent, i = o.begin, this.startAuthorization = i, e.next = 12;
                                break;
                            case 9:
                                throw e.prev = 9, e.t0 = e.catch(0), new LS("ERROR", "Error rendering CashAppPay button", {
                                    cause: e.t0
                                });
                            case 12:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            9
                        ]
                    ]);
                })), function(e) {
                    return a.apply(this, arguments);
                })
            },
            {
                key: "begin",
                value: function() {
                    this.startAuthorization ? this.startAuthorization() : console.warn("CashAppService - begin() not available");
                }
            },
            {
                key: "subscribeToEvent",
                value: function(e, t) {
                    var r = this;
                    return this.pay.addEventListener(e, t), function() {
                        r.pay.removeEventListener(e, t);
                    };
                }
            },
            {
                key: "createCustomerRequest",
                value: (r = Jd(Dy.mark(function e() {
                    var t, r, a, n, o, i, l;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, t = this.configuration, r = t.referenceId, a = t.amount, n = t.scopeId, o = t.redirectURL, i = void 0 === o ? window.location.href : o, l = {
                                    referenceId: r,
                                    redirectURL: i,
                                    actions: Qq(Qq({}, this.hasOneTimePayment && {
                                        payment: {
                                            amount: a,
                                            scopeId: n
                                        }
                                    }), this.hasOnFilePayment && {
                                        onFile: {
                                            scopeId: n
                                        }
                                    })
                                }, e.next = 5, this.pay.customerRequest(l);
                            case 5:
                                e.next = 10;
                                break;
                            case 7:
                                throw e.prev = 7, e.t0 = e.catch(0), new LS("ERROR", "Something went wrong during customerRequest creation", {
                                    cause: e.t0
                                });
                            case 10:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                })), function() {
                    return r.apply(this, arguments);
                })
            },
            {
                key: "restart",
                value: (t = Jd(Dy.mark(function e() {
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.next = 2, this.pay.restart();
                            case 2:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function() {
                    return t.apply(this, arguments);
                })
            }
        ]), e;
    }(), Jq = function() {
        function e() {
            Cg(this, e);
        }
        var t;
        return wg(e, [
            {
                key: "isSdkIsAvailableOnWindow",
                value: function() {
                    return !!window.CashApp;
                }
            },
            {
                key: "load",
                value: (t = Jd(Dy.mark(function e(t) {
                    var r, a, n;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (a = kb(r = t.toLowerCase()).call(r, "live") ? "https://kit.cash.app/v1/pay.js" : "https://sandbox.kit.cash.app/v1/pay.js", this.isSdkIsAvailableOnWindow()) {
                                    e.next = 5;
                                    break;
                                }
                                return n = new sB(a), e.next = 5, n.load();
                            case 5:
                                return e.abrupt("return", window.CashApp);
                            case 6:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function(e) {
                    return t.apply(this, arguments);
                })
            }
        ]), e;
    }();
    function $q(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Xq(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = $q(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = $q(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function eW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var tW = function(e) {
        U_(r, e);
        var t = eW(r);
        function r(e) {
            var a, n, o, i, l;
            return Cg(this, r), Ag(L_(l = t.call(this, e)), "cashAppService", void 0), Ag(L_(l), "submit", function() {
                var e = l.props, t = e.onClick;
                if (e.storedPaymentMethodId) kI((o = L_(l), H_(r.prototype)), "submit", o).call(o);
                else {
                    var a = !1;
                    new Ab(function(e, r) {
                        return t({
                            resolve: e,
                            reject: r
                        });
                    }).catch(function() {
                        throw a = !0, Error("onClick rejected");
                    }).then(function() {
                        return l.cashAppService.createCustomerRequest();
                    }).then(function() {
                        l.cashAppService.begin();
                    }).catch(function(e) {
                        a || l.handleError(e);
                    });
                }
            }), Ag(L_(l), "handleOnChangeStoreDetails", function(e) {
                var t = Xq(Xq({}, l.state.data), {}, {
                    shopperWantsToStore: e
                });
                l.setState({
                    data: t
                });
            }), Ag(L_(l), "handleAuthorize", function(e) {
                var t = Xq(Xq({}, l.state.data), e);
                l.setState({
                    data: t,
                    valid: {},
                    errors: {},
                    isValid: !0
                }), kI((i = L_(l), H_(r.prototype)), "submit", i).call(i);
            }), l.props.enableStoreDetails && l.props.storePaymentMethod && console.warn("CashAppPay: enableStoreDetails AND storePaymentMethod configuration properties should not be used together. That can lead to undesired behavior."), l.props.storedPaymentMethodId ? K_(l) : (l.cashAppService = new Zq(new Jq, {
                storePaymentMethod: l.props.storePaymentMethod,
                useCashAppButtonUi: l.props.showPayButton,
                environment: l.props.environment,
                amount: l.props.amount,
                redirectURL: l.props.redirectURL,
                clientId: null === (a = l.props.configuration) || void 0 === a ? void 0 : a.clientId,
                scopeId: null === (n = l.props.configuration) || void 0 === n ? void 0 : n.scopeId,
                button: l.props.button,
                referenceId: l.props.referenceId
            }), l);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t;
                    return Xq(Xq({}, e), {}, {
                        enableStoreDetails: (null === (t = e.session) || void 0 === t || null === (t = t.configuration) || void 0 === t ? void 0 : t.enableStoreDetails) || e.enableStoreDetails
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.state.data || {}, t = e.shopperWantsToStore, a = e.grantId, n = e.onFileGrantId, o = e.cashTag, i = e.customerId, l = this.props, s = l.storePaymentMethod, c = l.storedPaymentMethodId, u = this.props.enableStoreDetails || !this.props.session && s;
                    if (c) return {
                        paymentMethod: {
                            type: r.type,
                            storedPaymentMethodId: c
                        }
                    };
                    var d = n && o;
                    return Xq({
                        paymentMethod: Xq(Xq(Xq({
                            type: r.type
                        }, a && {
                            grantId: a
                        }), i && {
                            customerId: i
                        }), d && {
                            onFileGrantId: n,
                            cashtag: o
                        })
                    }, u && {
                        storePaymentMethod: s || t
                    });
                }
            },
            {
                key: "displayName",
                get: function() {
                    return this.props.storedPaymentMethodId && this.props.cashtag ? this.props.cashtag : this.props.name;
                }
            },
            {
                key: "additionalInfo",
                get: function() {
                    return this.props.storedPaymentMethodId ? "Cash App Pay" : "";
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "render",
                value: function() {
                    var e, t = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        resources: this.resources,
                        loadingContext: this.props.loadingContext
                    }, this.props.storedPaymentMethodId ? nN(dV, {
                        label: pw(this.props.i18n, this.props.amount),
                        icon: null === (e = this.resources) || void 0 === e ? void 0 : e.getImage({
                            imageFolder: "components/"
                        })("lock"),
                        name: this.displayName,
                        amount: this.props.amount,
                        payButton: this.payButton,
                        onSubmit: this.submit,
                        ref: function(e) {
                            t.componentRef = e;
                        }
                    }) : nN(Gq, {
                        ref: function(e) {
                            t.componentRef = e;
                        },
                        enableStoreDetails: this.props.enableStoreDetails,
                        cashAppService: this.cashAppService,
                        onChangeStoreDetails: this.handleOnChangeStoreDetails,
                        onError: this.handleError,
                        onClick: this.submit,
                        onAuthorize: this.handleAuthorize
                    }));
                }
            }
        ]), r;
    }(qS);
    function rW(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function aW(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = rW(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = rW(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function nW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(tW, "type", "cashapp"), Ag(tW, "defaultProps", {
        onClick: function(e) {
            e.resolve();
        },
        showPayButton: !0,
        enableStoreDetails: !1,
        storePaymentMethod: !1
    });
    var oW = function(e) {
        U_(a, e);
        var t, r = nW(a);
        function a(e) {
            var t, n;
            return Cg(this, a), Ag(L_(n = r.call(this, e)), "clickToPayService", void 0), Ag(L_(n), "ctpConfiguration", void 0), Ag(L_(n), "handleClickToPaySubmit", function(e) {
                n.setState({
                    data: aW({}, e),
                    valid: {},
                    errors: {},
                    isValid: !0
                }), n.submit();
            }), n.ctpConfiguration = {
                shopperEmail: n.props.shopperEmail,
                telephoneNumber: n.props.telephoneNumber,
                merchantDisplayName: n.props.merchantDisplayName,
                locale: n.props.locale,
                onReady: n.props.onReady,
                onTimeout: n.props.onTimeout
            }, n.clickToPayService = nq(n.props.configuration, n.ctpConfiguration, n.props.environment), null === (t = n.clickToPayService) || void 0 === t || t.initialize().catch(function(e) {
                n.handleError(new LS("ERROR", e.toString(), {
                    cause: e
                }));
            }), n.clickToPayService || console.warn("ClickToPay not initialized - Likely the payment method is not configured or its configuration is missing"), n;
        }
        return wg(a, [
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "browserInfo",
                get: function() {
                    return Mj();
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e, t = this.state.data, r = t.srcScheme, n = t.srcCorrelationId, o = t.srcTokenReference, i = t.srcCheckoutPayload, l = t.srcDigitalCardId;
                    return {
                        paymentMethod: aW(aW(aW(aW(aW({
                            type: a.type
                        }, r && {
                            srcScheme: r
                        }), n && {
                            srcCorrelationId: n
                        }), o && {
                            srcTokenReference: o
                        }), i && {
                            srcCheckoutPayload: i
                        }), l && {
                            srcDigitalCardId: l
                        }),
                        browserInfo: this.browserInfo,
                        origin: null === (e = window) || void 0 === e || null === (e = e.location) || void 0 === e ? void 0 : e.origin
                    };
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    var t, r, a;
                    return aW(aW({}, e), {}, {
                        disableOtpAutoFocus: e.disableOtpAutoFocus || !1,
                        shopperEmail: e.shopperEmail || (null == e || null === (t = e._parentInstance) || void 0 === t || null === (t = t.options) || void 0 === t || null === (t = t.session) || void 0 === t ? void 0 : t.shopperEmail),
                        telephoneNumber: e.telephoneNumber || (null == e || null === (r = e._parentInstance) || void 0 === r || null === (r = r.options) || void 0 === r || null === (r = r.session) || void 0 === r ? void 0 : r.telephoneNumber),
                        locale: e.locale || (null === (a = e.i18n) || void 0 === a || null === (a = a.locale) || void 0 === a ? void 0 : a.replace("-", "_"))
                    });
                }
            },
            {
                key: "isAvailable",
                value: (t = Jd(Dy.mark(function e() {
                    var t = this;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (this.clickToPayService) {
                                    e.next = 2;
                                    break;
                                }
                                return e.abrupt("return", Ab.reject());
                            case 2:
                                if (!this.clickToPayService.shopperAccountFound) {
                                    e.next = 4;
                                    break;
                                }
                                return e.abrupt("return", Ab.resolve());
                            case 4:
                                return e.abrupt("return", new Ab(function(e, r) {
                                    t.clickToPayService.subscribeOnStateChange(function(a) {
                                        t.clickToPayService.shopperAccountFound && e(), a !== XH.NotAvailable && a !== XH.Login && a !== XH.Idle || r();
                                    });
                                }));
                            case 5:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function() {
                    return t.apply(this, arguments);
                })
            },
            {
                key: "render",
                value: function() {
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(sq, {
                        isStandaloneComponent: !0,
                        configuration: this.ctpConfiguration,
                        amount: this.props.amount,
                        clickToPayService: this.clickToPayService,
                        setClickToPayRef: this.setComponentRef,
                        onSetStatus: this.setElementStatus,
                        onSubmit: this.handleClickToPaySubmit,
                        onError: this.handleError
                    }, nN(Oq, null)));
                }
            }
        ]), a;
    }(qS);
    function iW(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function lW(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = iW(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = iW(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function sW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(oW, "type", "clicktopay");
    var cW = function(e) {
        U_(r, e);
        var t = sW(r);
        function r(e) {
            var a;
            return Cg(this, r), Ag(L_(a = t.call(this, e)), "onBrand", function(e) {
                a.props.onBrand && a.props.onBrand(e);
            }), a;
        }
        return wg(r, [
            {
                key: "formatData",
                value: function() {
                    var e = kI(H_(r.prototype), "formatData", this).call(this);
                    return e.paymentMethod.type = this.constructor.type, e;
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    return lW(lW({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        type: "bcmc",
                        cvcPolicy: XI
                    });
                }
            }
        ]), r;
    }(Kq);
    function uW(e) {
        var t = e.description, r = void 0 === t ? "" : t, a = e.name, n = void 0 === a ? "" : a, o = e.logoUrl, i = void 0 === o ? "" : o, l = e.url, s = void 0 === l ? "" : l, c = e.backgroundUrl, u = void 0 === c ? "" : c;
        return nN("div", {
            className: "adyen-checkout__campaign-container"
        }, nN(XT, {
            className: "adyen-checkout__campaign-background-image",
            style: {
                backgroundImage: "linear-gradient(0, #000, #0003), url(".concat(u, ")")
            },
            backgroundUrl: u
        }), nN("div", {
            className: "adyen-checkout__campaign-content"
        }, i && nN("img", {
            src: i,
            className: "adyen-checkout__campaign-logo",
            alt: n
        }), n && nN("div", {
            className: "adyen-checkout__campaign-title"
        }, n), r && nN("div", {
            className: "adyen-checkout__campaign-description"
        }, r, s && " \u203A")));
    }
    function dW(e) {
        var t = e.url;
        return nN("div", {
            className: "adyen-checkout__campaign"
        }, !t && nN(uW, e), t && nN("a", {
            href: t,
            className: "adyen-checkout__campaign-link",
            target: "_blank",
            rel: "noopener noreferrer"
        }, nN(uW, e)));
    }
    Ag(cW, "type", "bcmc"), Ag(cW, "defaultProps", lW(lW({}, Kq.defaultProps), {}, {
        brands: [
            "bcmc",
            "maestro",
            "visa"
        ]
    }));
    var pW = function(e) {
        var t = e.options, r = void 0 === t ? [] : t, a = e.name, n = e.onChange;
        return nN("div", {
            className: "adyen-checkout__button-group"
        }, hC(r).call(r, function(e, t) {
            var r, o = e.label, i = e.selected, l = e.value, s = e.disabled;
            return nN("label", {
                key: wb(r = "".concat(a)).call(r, t),
                className: DP({
                    "adyen-checkout__button": !0,
                    "adyen-checkout__button--selected": i,
                    "adyen-checkout__button--disabled": s
                })
            }, nN("input", {
                type: "radio",
                className: "adyen-checkout__button-group__input",
                value: l,
                checked: i,
                onChange: n,
                disabled: s
            }), nN("span", {
                className: "adyen-checkout__button-text"
            }, o));
        }));
    };
    function mW(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function fW(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = mW(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = mW(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function hW(e) {
        var t, r = e.amounts, a = e.onCancel, n = e.onDonate, o = e.showCancelButton, i = void 0 === o || o, l = e.disclaimerMessage, s = sw().i18n, c = II(), u = r.currency, d = Vk(VP("ready"), 2), p = d[0], m = d[1], f = Vk(VP(!1), 2), h = f[0], v = f[1], y = Vk(VP({
            currency: u,
            value: null
        }), 2), g = y[0], b = y[1];
        this.setStatus = function(e) {
            m(e);
        };
        var k = GP(function(e, t) {
            return s.amount(e, t);
        }, [
            s
        ]);
        return KP(function() {
            e.onChange({
                data: {
                    amount: g
                },
                isValid: h
            });
        }, [
            g,
            h
        ]), "error" === p ? nN("div", {
            className: "adyen-checkout__adyen-giving"
        }, nN(XT, {
            className: "adyen-checkout__status__icon adyen-checkout__status__icon--error",
            src: c({
                imageFolder: "components/"
            })("error"),
            alt: s.get("error.message.unknown")
        }), nN("div", {
            className: "adyen-checkout__status__text"
        }, s.get("error.message.unknown"))) : "success" === p ? nN("div", {
            className: "adyen-checkout__adyen-giving"
        }, nN(XT, {
            className: "adyen-checkout__status__icon adyen-checkout__status__icon--success",
            src: c({
                imageFolder: "components/"
            })("heart"),
            alt: s.get("thanksForYourSupport")
        }), nN("div", {
            className: "adyen-checkout__status__text"
        }, s.get("thanksForYourSupport"))) : nN("div", {
            className: "adyen-checkout__adyen-giving"
        }, nN(dW, e), nN("div", {
            className: "adyen-checkout__adyen-giving-actions"
        }, nN("div", {
            className: "adyen-checkout__amounts"
        }, nN(pW, {
            options: hC(t = cC(r)).call(t, function(e) {
                return {
                    value: e,
                    label: k(e, u),
                    disabled: "loading" === p,
                    selected: e === g.value
                };
            }),
            name: "amount",
            onChange: function(e) {
                var t = e.target, r = ZC(t.value, 10);
                v(!0), b(function(e) {
                    return fW(fW({}, e), {}, {
                        value: r
                    });
                });
            }
        })), l && nN($L, {
            message: l.message.replace("%{linkText}", "%#".concat(l.linkText, "%#")),
            urls: [
                l.link
            ]
        }), nN(uw, {
            classNameModifiers: [
                "donate"
            ],
            onClick: function() {
                m("loading"), n({
                    data: {
                        amount: g
                    }
                });
            },
            label: s.get("donateButton"),
            disabled: !g.value,
            status: p
        }), i && nN(uw, {
            classNameModifiers: [
                "decline"
            ],
            variant: "ghost",
            onClick: function() {
                m("loading"), a({
                    data: {
                        amount: g
                    },
                    isValid: h
                });
            },
            disabled: "loading" === p,
            label: "".concat(s.get("notNowButton"), " \u203A")
        })));
    }
    hW.defaultProps = {
        onCancel: function() {},
        onChange: function() {},
        onDonate: function() {},
        amounts: {},
        showCancelButton: !0
    };
    var vW = [
        "bannerUrl",
        "nonprofitDescription",
        "nonprofitName",
        "nonprofitUrl",
        "termsAndConditionsUrl"
    ];
    function yW(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function gW(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = yW(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = yW(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function bW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var kW = function(e) {
        U_(r, e);
        var t = bW(r);
        function r(e) {
            var a, n;
            return Cg(this, r), Ag(L_(n = t.call(this, e)), "handleRef", function(e) {
                n.componentRef = e;
            }), n.donate = Jg(a = n.donate).call(a, L_(n)), n;
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    if (this.isNewDonation(e)) {
                        var t = e, r = t.bannerUrl, a = t.nonprofitDescription, n = t.nonprofitName, o = t.nonprofitUrl, i = t.termsAndConditionsUrl;
                        return gW(gW({}, kg(t, vW)), {}, {
                            backgroundUrl: r,
                            description: a,
                            name: n,
                            url: o,
                            disclaimerMessage: {
                                message: "By donating you agree to the %{linkText} ",
                                linkText: "terms and conditions",
                                link: i
                            }
                        });
                    }
                    return e;
                }
            },
            {
                key: "isNewDonation",
                value: function(e) {
                    var t;
                    return JT(t = Ty(e)).call(t, function(t) {
                        return kb(t).call(t, "nonprofit") && e[t];
                    });
                }
            },
            {
                key: "data",
                get: function() {
                    return this.state.data;
                }
            },
            {
                key: "isValid",
                get: function() {
                    return this.state.isValid;
                }
            },
            {
                key: "setState",
                value: function(e) {
                    this.state = gW(gW({}, this.state), e);
                }
            },
            {
                key: "donate",
                value: function() {
                    var e = this.data, t = this.isValid;
                    this.props.onDonate({
                        data: e,
                        isValid: t
                    }, this);
                }
            },
            {
                key: "render",
                value: function() {
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(hW, M_({}, this.props, {
                        ref: this.handleRef,
                        onChange: this.setState,
                        onDonate: this.donate
                    })));
                }
            }
        ]), r;
    }(qS);
    Ag(kW, "type", "donation"), Ag(kW, "defaultProps", {
        onCancel: function() {},
        onDonate: function() {}
    });
    var CW = function() {
        try {
            if (window.parent.location.href) return window.location !== window.parent.location;
        } catch (e) {
            return !1;
        }
    };
    function _W(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function NW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var PW, wW = function(e) {
        U_(r, e);
        var t = NW(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "postForm", void 0), a;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this, t = new Ab(function(t, r) {
                        return e.props.beforeRedirect(t, r, function(e) {
                            for(var t = 1; t < arguments.length; t++){
                                var r, a, n = null != arguments[t] ? arguments[t] : {};
                                t % 2 ? Sg(r = _W(Object(n), !0)).call(r, function(t) {
                                    Ag(e, t, n[t]);
                                }) : Jy ? ng(e, Jy(n)) : Sg(a = _W(Object(n))).call(a, function(t) {
                                    og(e, t, Wy(n, t));
                                });
                            }
                            return e;
                        }({
                            url: e.props.url,
                            method: e.props.method
                        }, e.props.data ? {
                            data: e.props.data
                        } : {}));
                    });
                    t.then(function() {
                        var t, r;
                        e.postForm ? e.postForm.submit() : e.props.redirectFromTopWhenInIframe && CW() ? null === (t = (r = window.top.location).assign) || void 0 === t || t.call(r, e.props.url) : window.location.assign(e.props.url);
                    }).catch(function() {});
                }
            },
            {
                key: "render",
                value: function(e) {
                    var t, r = this, a = e.url, n = e.method, o = e.data, i = void 0 === o ? {} : o;
                    return "POST" === n ? nN("form", M_({
                        method: "post",
                        action: a,
                        style: {
                            display: "none"
                        },
                        ref: function(e) {
                            r.postForm = e;
                        }
                    }, this.props.redirectFromTopWhenInIframe && CW() && {
                        target: "_top"
                    }), hC(t = Ty(i)).call(t, function(e) {
                        return nN("input", {
                            type: "hidden",
                            name: e,
                            key: e,
                            value: i[e]
                        });
                    })) : null;
                }
            }
        ]), r;
    }(lN);
    function AW(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function SW(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = AW(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = AW(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function IW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(wW, "defaultProps", {
        beforeRedirect: function(e) {
            return e();
        },
        method: "GET"
    });
    var EW = function(e) {
        U_(r, e);
        var t = IW(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return SW(SW({}, e), {}, {
                        showButton: !!e.showPayButton
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    return {
                        paymentMethod: {
                            type: this.props.type
                        },
                        browserInfo: this.browserInfo
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "browserInfo",
                get: function() {
                    return Mj();
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.url && this.props.method ? nN(wW, this.props) : this.props.showButton ? nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(dV, M_({}, this.props, {
                        onSubmit: this.submit,
                        payButton: this.payButton,
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }))) : null;
                }
            }
        ]), r;
    }(qS);
    function DW(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function RW(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = DW(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = DW(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function FW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    PW = EW, Ag(EW, "type", "redirect"), Ag(EW, "defaultProps", {
        type: PW.type,
        showPayButton: !0
    });
    var xW = function(e) {
        U_(r, e);
        var t = FW(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t;
                    return RW(RW({}, e), {}, {
                        showPayButton: null !== (t = e.showButton) && void 0 !== t ? t : e.showPayButton
                    });
                }
            },
            {
                key: "displayName",
                get: function() {
                    return this.props.name || this.constructor.type;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.showPayButton ? nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(dV, M_({}, this.props, {
                        name: this.displayName,
                        onSubmit: this.submit,
                        payButton: this.payButton,
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }))) : null;
                }
            }
        ]), r;
    }(EW);
    Ag(xW, "type", "giropay");
    var TW = 2, zW = 0, OW = "adyen", jW = "https://pay.google.com/gp/p/js/pay.js", BW = [
        "amount",
        "countryCode",
        "totalPriceStatus"
    ], MW = [
        "configuration"
    ];
    function LW(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function VW(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = LW(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = LW(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function UW(e) {
        var t = e.amount, r = e.countryCode, a = void 0 === r ? "US" : r, n = e.totalPriceStatus, o = void 0 === n ? "FINAL" : n, i = kg(e, BW), l = String(t_(t.value, t.currency));
        return VW({
            countryCode: a,
            currencyCode: t.currency,
            totalPrice: l,
            totalPriceStatus: o
        }, i.transactionInfo);
    }
    function KW(e) {
        var t = e.configuration, r = kg(e, MW);
        return {
            apiVersion: TW,
            apiVersionMinor: zW,
            transactionInfo: UW(r),
            merchantInfo: VW(VW({
                merchantId: t.merchantId,
                merchantName: t.merchantName
            }, t.merchantOrigin ? {
                merchantOrigin: t.merchantOrigin
            } : {}), t.authJwt ? {
                authJwt: t.authJwt
            } : {}),
            allowedPaymentMethods: [
                {
                    type: "CARD",
                    tokenizationSpecification: {
                        type: "PAYMENT_GATEWAY",
                        parameters: {
                            gateway: OW,
                            gatewayMerchantId: t.gatewayMerchantId
                        }
                    },
                    parameters: {
                        allowedAuthMethods: r.allowedAuthMethods,
                        allowedCardNetworks: r.allowedCardNetworks,
                        assuranceDetailsRequired: r.assuranceDetailsRequired,
                        allowPrepaidCards: r.allowPrepaidCards,
                        allowCreditCards: r.allowCreditCards,
                        billingAddressRequired: r.billingAddressRequired,
                        billingAddressParameters: r.billingAddressParameters
                    }
                }
            ],
            emailRequired: r.emailRequired,
            shippingAddressRequired: r.shippingAddressRequired,
            shippingAddressParameters: r.shippingAddressParameters,
            shippingOptionRequired: r.shippingOptionRequired,
            shippingOptionParameters: r.shippingOptionParameters,
            callbackIntents: r.callbackIntents
        };
    }
    var HW = [
        "en",
        "ar",
        "bg",
        "ca",
        "cs",
        "da",
        "de",
        "el",
        "es",
        "et",
        "fi",
        "fr",
        "hr",
        "id",
        "it",
        "ja",
        "ko",
        "ms",
        "nl",
        "no",
        "pl",
        "pt",
        "ru",
        "sk",
        "sl",
        "sr",
        "sv",
        "th",
        "tr",
        "uk",
        "zh"
    ];
    var qW = function() {
        function e(t) {
            Cg(this, e), Ag(this, "paymentsClient", void 0);
            var r = function() {
                switch((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "TEST").toLowerCase()){
                    case "production":
                    case "live":
                    case "live-au":
                    case "live-apse":
                    case "live-us":
                    case "live-in":
                        return "PRODUCTION";
                    default:
                        return "TEST";
                }
            }(t.environment);
            this.paymentsClient = this.getGooglePaymentsClient({
                environment: r,
                paymentDataCallbacks: t.paymentDataCallbacks
            });
        }
        var t;
        return wg(e, [
            {
                key: "getGooglePaymentsClient",
                value: (t = Jd(Dy.mark(function e(t) {
                    var r, a;
                    return Dy.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (null !== (r = window.google) && void 0 !== r && r.payments) {
                                    e.next = 4;
                                    break;
                                }
                                return a = new sB(jW), e.next = 4, a.load();
                            case 4:
                                return e.abrupt("return", new google.payments.api.PaymentsClient(t));
                            case 5:
                            case "end":
                                return e.stop();
                        }
                    }, e);
                })), function(e) {
                    return t.apply(this, arguments);
                })
            },
            {
                key: "isReadyToPay",
                value: function(e) {
                    return this.paymentsClient ? this.paymentsClient.then(function(t) {
                        var r, a, n, o;
                        return t.isReadyToPay((a = (r = e).allowedAuthMethods, n = r.allowedCardNetworks, o = r.existingPaymentMethodRequired, {
                            apiVersion: TW,
                            apiVersionMinor: zW,
                            allowedPaymentMethods: [
                                {
                                    type: "CARD",
                                    parameters: {
                                        allowedAuthMethods: a,
                                        allowedCardNetworks: n
                                    },
                                    tokenizationSpecification: {
                                        type: "PAYMENT_GATEWAY",
                                        parameters: {}
                                    }
                                }
                            ],
                            existingPaymentMethodRequired: void 0 !== o && o
                        }));
                    }) : Ab.reject(new Error("Google Pay is not available"));
                }
            },
            {
                key: "prefetchPaymentData",
                value: function(e) {
                    if (!this.paymentsClient) throw new Error("Google Pay is not available");
                    var t = KW(e);
                    this.paymentsClient.then(function(e) {
                        return e.prefetchPaymentData(t);
                    });
                }
            },
            {
                key: "initiatePayment",
                value: function(e) {
                    if (!this.paymentsClient) throw new Error("Google Pay is not available");
                    var t = KW(e);
                    return this.paymentsClient.then(function(e) {
                        return e.loadPaymentData(t);
                    });
                }
            }
        ]), e;
    }();
    function WW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var GW = function(e) {
        U_(r, e);
        var t = WW(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "paywithgoogleWrapper", void 0), Ag(L_(a), "clicked", !1), Ag(L_(a), "handleClick", function(e) {
                e.preventDefault(), e.stopPropagation(), a.clicked || (a.props.onClick(e), a.clicked = !0, NP(function() {
                    a.clicked = !1;
                }, 300));
            }), a;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this, t = this.props, r = t.buttonColor, a = t.buttonType, n = t.buttonLocale, o = t.buttonSizeMode, i = t.buttonRootNode;
                    t.paymentsClient.then(function(t) {
                        return t.createButton({
                            onClick: e.handleClick,
                            buttonType: a,
                            buttonColor: r,
                            buttonLocale: n,
                            buttonSizeMode: o,
                            buttonRootNode: i
                        });
                    }).then(function(t) {
                        e.paywithgoogleWrapper.appendChild(t);
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return nN("span", {
                        className: "adyen-checkout__paywithgoogle",
                        ref: function(t) {
                            e.paywithgoogleWrapper = t;
                        }
                    });
                }
            }
        ]), r;
    }(lN);
    Ag(GW, "defaultProps", {
        buttonColor: "default",
        buttonType: "long",
        buttonSizeMode: "static"
    });
    var YW = {
        environment: "TEST",
        isExpress: !1,
        existingPaymentMethodRequired: !1,
        buttonColor: "default",
        buttonType: "long",
        buttonSizeMode: void 0,
        showPayButton: !0,
        configuration: {
            gatewayMerchantId: "",
            merchantId: "",
            merchantName: ""
        },
        amount: {
            value: 0,
            currency: "USD"
        },
        countryCode: "US",
        totalPriceStatus: "FINAL",
        onAuthorized: function(e) {
            return e;
        },
        onClick: function(e) {
            return e();
        },
        allowedAuthMethods: [
            "PAN_ONLY",
            "CRYPTOGRAM_3DS"
        ],
        allowedCardNetworks: [
            "AMEX",
            "DISCOVER",
            "JCB",
            "MASTERCARD",
            "VISA"
        ],
        allowCreditCards: !0,
        allowPrepaidCards: !0,
        billingAddressRequired: !1,
        billingAddressParameters: void 0,
        assuranceDetailsRequired: !1,
        emailRequired: !1,
        shippingAddressRequired: !1,
        shippingAddressParameters: void 0,
        shippingOptionRequired: !1,
        shippingOptionParameters: void 0,
        paymentMethods: []
    };
    function QW(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function ZW(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = QW(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = QW(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function JW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var $W = function(e) {
        U_(r, e);
        var t = JW(r);
        function r() {
            var e, a, n;
            Cg(this, r);
            for(var o = arguments.length, i = new Array(o), l = 0; l < o; l++)i[l] = arguments[l];
            return Ag(L_(n = t.call.apply(t, wb(e = [
                this
            ]).call(e, i))), "googlePay", new qW(n.props)), Ag(L_(n), "submit", function() {
                n.props.isInstantPayment && n.submitAnalytics({
                    type: MN,
                    target: YN
                });
                var e = n.props.onAuthorized, t = void 0 === e ? function() {} : e;
                return new Ab(function(e, t) {
                    return n.props.onClick(e, t);
                }).then(function() {
                    return n.googlePay.initiatePayment(n.props);
                }).then(function(e) {
                    return n.setState({
                        googlePayToken: e.paymentMethodData.tokenizationData.token,
                        googlePayCardNetwork: e.paymentMethodData.info.cardNetwork
                    }), kI((a = L_(n), H_(r.prototype)), "submit", a).call(a), t(e);
                }).catch(function(e) {
                    "CANCELED" === e.statusCode ? n.handleError(new LS("CANCEL", e.toString(), {
                        cause: e
                    })) : n.handleError(new LS("ERROR", e.toString(), {
                        cause: e
                    }));
                });
            }), Ag(L_(n), "isAvailable", function() {
                return n.isReadyToPay().then(function(e) {
                    if (!e.result) throw new Error("Google Pay is not available");
                    if (!1 === e.paymentMethodPresent) throw new Error("Google Pay - No paymentMethodPresent");
                    return !0;
                }).catch(function() {
                    return !1;
                });
            }), Ag(L_(n), "isReadyToPay", function() {
                return n.googlePay.isReadyToPay(n.props);
            }), Ag(L_(n), "prefetch", function() {
                return n.googlePay.prefetchPaymentData(n.props);
            }), n;
        }
        return wg(r, [
            {
                key: "submitAnalytics",
                value: function(e) {
                    kI(H_(r.prototype), "submitAnalytics", this).call(this, ZW({}, e), this.props);
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    var t, r, a, n, o, i, l = null !== (t = e.brands) && void 0 !== t && t.length ? (o = e.brands, i = {
                        mc: "MASTERCARD",
                        amex: "AMEX",
                        visa: "VISA",
                        interac: "INTERAC",
                        discover: "DISCOVER"
                    }, tC(o).call(o, function(e, t) {
                        return i[t] && !kb(e).call(e, i[t]) && e.push(i[t]), e;
                    }, [])) : e.allowedCardNetworks, s = null !== (r = e.buttonSizeMode) && void 0 !== r ? r : e.isDropin ? "fill" : "static", c = function() {
                        var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").toLowerCase().substring(0, 2);
                        return kb(HW).call(HW, e) ? e : null;
                    }(null !== (a = e.buttonLocale) && void 0 !== a ? a : null === (n = e.i18n) || void 0 === n ? void 0 : n.locale);
                    return ZW(ZW({}, e), {}, {
                        showButton: !0 === e.showPayButton,
                        configuration: e.configuration,
                        allowedCardNetworks: l,
                        buttonSizeMode: s,
                        buttonLocale: c
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e;
                    return {
                        paymentMethod: ZW({
                            type: null !== (e = this.props.type) && void 0 !== e ? e : r.type
                        }, this.state),
                        browserInfo: this.browserInfo,
                        origin: !!window && window.location.origin
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.googlePayToken;
                }
            },
            {
                key: "browserInfo",
                get: function() {
                    return Mj();
                }
            },
            {
                key: "icon",
                get: function() {
                    var e;
                    return null !== (e = this.props.icon) && void 0 !== e ? e : this.resources.getImage()("googlepay");
                }
            },
            {
                key: "render",
                value: function() {
                    return this.props.showPayButton ? nN(GW, {
                        buttonColor: this.props.buttonColor,
                        buttonType: this.props.buttonType,
                        buttonSizeMode: this.props.buttonSizeMode,
                        buttonLocale: this.props.buttonLocale,
                        buttonRootNode: this.props.buttonRootNode,
                        paymentsClient: this.googlePay.paymentsClient,
                        onClick: this.submit
                    }) : null;
                }
            }
        ]), r;
    }(qS);
    function XW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag($W, "type", "paywithgoogle"), Ag($W, "defaultProps", YW);
    var eG = function(e) {
        U_(r, e);
        var t = XW(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r);
    }(hV);
    Ag(eG, "type", "entercash");
    var tG = {
        telephoneNumber: [
            {
                validate: function(e) {
                    return !!e && e.length <= 11;
                },
                errorMessage: "voucher.econtext.telephoneNumber.invalid",
                modes: [
                    "input",
                    "blur"
                ]
            },
            {
                validate: function(e) {
                    return !!e && MD.test(e) && (10 === e.length || 11 === e.length);
                },
                errorMessage: "voucher.econtext.telephoneNumber.invalid",
                modes: [
                    "blur"
                ]
            }
        ]
    }, rG = [
        "personalDetailsRequired",
        "data",
        "onChange",
        "showPayButton",
        "payButton"
    ];
    function aG(e) {
        var t, r = e.personalDetailsRequired, a = void 0 === r || r, n = e.data, o = e.onChange, i = e.showPayButton, l = e.payButton, s = kg(e, rG), c = qP(null), u = sw().i18n, d = Vk(VP("ready"), 2), p = d[0], m = d[1], f = qP({});
        Ty(f.current).length || null === (t = s.setComponentRef) || void 0 === t || t.call(s, f.current);
        return f.current.showValidation = function() {
            var e;
            null === (e = c.current) || void 0 === e || e.showValidation();
        }, f.current.setStatus = m, nN("div", {
            className: "adyen-checkout__econtext-input__field"
        }, a && s.showFormInstruction && nN(iO, null), a && nN(vR, {
            data: n,
            requiredFields: [
                "firstName",
                "lastName",
                "telephoneNumber",
                "shopperEmail"
            ],
            onChange: o,
            namePrefix: "econtext",
            setComponentRef: function(e) {
                c.current = e;
            },
            validationRules: tG
        }), i && l({
            status: p,
            label: u.get("confirmPurchase")
        }));
    }
    function nG(e) {
        var t, r, a = (t = e, (r = document.createElement("textArea")).readOnly = !0, r.value = t, document.body.appendChild(r), r);
        if (window.navigator.userAgent.match(/ipad|iphone/i)) {
            var n = document.createRange();
            n.selectNodeContents(a);
            var o = window.getSelection();
            o.removeAllRanges(), o.addRange(n), a.setSelectionRange(0, 999999);
        } else a.select();
        document.execCommand("copy"), document.body.removeChild(a);
    }
    var oG = [
        "voucherDetails",
        "className"
    ];
    function iG(e) {
        var t, r = e.voucherDetails, a = void 0 === r ? [] : r, n = e.className, o = void 0 === n ? "" : n, i = kg(e, oG), l = sw().i18n, s = II();
        return nN("div", {
            className: DP("adyen-checkout__voucher-result", "adyen-checkout__voucher-result--".concat(i.paymentMethodType), o)
        }, nN("div", {
            className: "adyen-checkout__voucher-result__top"
        }, nN("div", {
            className: "adyen-checkout__voucher-result__image"
        }, !!i.imageUrl && nN("span", {
            className: "adyen-checkout__voucher-result__image__wrapper"
        }, nN("img", {
            alt: i.paymentMethodType,
            className: "adyen-checkout__voucher-result__image__brand",
            src: i.imageUrl
        })), !!i.issuerImageUrl && nN("span", {
            className: "adyen-checkout__voucher-result__image__wrapper"
        }, nN("img", {
            alt: i.paymentMethodType,
            className: "adyen-checkout__voucher-result__image__issuer",
            src: i.issuerImageUrl
        }))), nN("div", {
            className: "adyen-checkout__voucher-result__introduction"
        }, i.introduction, " ", i.instructionsUrl && nN("a", {
            className: "adyen-checkout__link adyen-checkout__link--voucher-result-instructions",
            href: i.instructionsUrl,
            target: "_blank",
            rel: "noopener noreferrer"
        }, l.get("voucher.readInstructions"), " \u203A")), i.amount && nN("div", {
            className: "adyen-checkout__voucher-result__amount"
        }, i.amount, i.surcharge && nN("span", {
            className: "adyen-checkout__voucher-result__surcharge"
        }, "(", l.get("voucher.surcharge").replace("%@", i.surcharge), ")"))), i.reference && nN("div", {
            className: "adyen-checkout__voucher-result__separator"
        }, nN("div", {
            className: "adyen-checkout__voucher-result__separator__inner"
        }), nN("div", {
            className: "adyen-checkout__voucher-result__code__label"
        }, nN("span", {
            className: "adyen-checkout__voucher-result__code__label__text"
        }, l.get("voucher.paymentReferenceLabel")))), nN("div", {
            className: "adyen-checkout__voucher-result__bottom"
        }, i.reference && nN("div", {
            className: "adyen-checkout__voucher-result__code"
        }, i.barcode && nN("img", {
            alt: l.get("voucher.paymentReferenceLabel"),
            className: "adyen-checkout__voucher-result__code__barcode",
            src: i.barcode
        }), nN("span", null, i.reference)), (!!i.downloadUrl || !!i.copyBtn) && nN("ul", {
            className: "adyen-checkout__voucher-result__actions"
        }, !!i.copyBtn && nN("li", {
            className: "adyen-checkout__voucher-result__actions__item"
        }, nN(uw, {
            inline: !0,
            variant: "action",
            onClick: function(e, t) {
                var r = t.complete;
                nG(i.reference), r();
            },
            icon: s({
                imageFolder: "components/"
            })("copy"),
            label: l.get("button.copy")
        })), !!i.downloadUrl && nN("li", {
            className: "adyen-checkout__voucher-result__actions__item"
        }, nN(uw, {
            inline: !0,
            variant: "action",
            href: i.downloadUrl,
            icon: s({
                imageFolder: "components/"
            })("download"),
            label: i.downloadButtonText || l.get("button.download"),
            target: "_blank",
            rel: "noopener noreferrer"
        }))), nN("ul", {
            className: "adyen-checkout__voucher-result__details"
        }, hC(t = xg(a).call(a, function(e) {
            var t = e.label, r = e.value;
            return !!t && !!r;
        })).call(t, function(e, t) {
            var r = e.label, a = e.value;
            return nN("li", {
                key: t,
                className: "adyen-checkout__voucher-result__details__item"
            }, nN("span", {
                className: "adyen-checkout__voucher-result__details__label"
            }, r), nN("span", {
                className: "adyen-checkout__voucher-result__details__value"
            }, a));
        }))));
    }
    var lG = function(e) {
        var t = e.reference, r = e.totalAmount, a = e.expiresAt, n = e.paymentMethodType, o = e.maskedTelephoneNumber, i = e.instructionsUrl, l = e.collectionInstitutionNumber, s = sw().i18n, c = II();
        return nN(iG, {
            paymentMethodType: n,
            reference: t,
            introduction: s.get("voucher.introduction.econtext"),
            imageUrl: c()(n),
            instructionsUrl: i,
            amount: r && s.amount(r.value, r.currency),
            voucherDetails: [
                {
                    label: s.get("voucher.collectionInstitutionNumber"),
                    value: l
                },
                {
                    label: s.get("voucher.expirationDate"),
                    value: s.dateTime(a)
                },
                {
                    label: s.get("voucher.telephoneNumber"),
                    value: o
                }
            ],
            copyBtn: !0
        });
    };
    function sG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function cG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = sG(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = sG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function uG(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var dG = function(e) {
        U_(r, e);
        var t = uG(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !this.props.personalDetailsRequired || !!this.state.isValid;
                }
            },
            {
                key: "formatData",
                value: function() {
                    return cG(cG({}, this.state.data), {}, {
                        paymentMethod: {
                            type: this.props.type || r.type
                        }
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.reference ? nN(lG, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props)) : nN(aG, M_({
                        setComponentRef: this.setComponentRef
                    }, this.props, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(qS);
    Ag(dG, "type", "econtext"), Ag(dG, "defaultProps", {
        personalDetailsRequired: !0,
        showFormInstruction: !0
    });
    var pG = [
        "ES",
        "FR"
    ];
    function mG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function fG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = mG(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = mG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function hG(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var vG = function(e) {
        U_(r, e);
        var t = hG(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return fG(fG({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : pG
                    });
                }
            }
        ]), r;
    }(Aj);
    function yG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function gG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = yG(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = yG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function bG(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(vG, "type", "facilypay_3x");
    var kG = function(e) {
        U_(r, e);
        var t = bG(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return gG(gG({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : pG
                    });
                }
            }
        ]), r;
    }(Aj);
    function CG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function _G(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = CG(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = CG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function NG(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(kG, "type", "facilypay_4x");
    var PG = function(e) {
        U_(r, e);
        var t = NG(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return _G(_G({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : pG
                    });
                }
            }
        ]), r;
    }(Aj);
    function wG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function AG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = wG(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = wG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function SG(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(PG, "type", "facilypay_6x");
    var IG = function(e) {
        U_(r, e);
        var t = SG(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return AG(AG({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : pG
                    });
                }
            }
        ]), r;
    }(Aj);
    function EG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function DG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = EG(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = EG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function RG(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(IG, "type", "facilypay_10x");
    var FG = function(e) {
        U_(r, e);
        var t = RG(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return DG(DG({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : pG
                    });
                }
            }
        ]), r;
    }(Aj);
    Ag(FG, "type", "facilypay_12x");
    var xG = [
        "black",
        "white"
    ], TG = [
        "en_US",
        "en_AU",
        "en_GB",
        "fr_CA",
        "es_ES",
        "it_IT",
        "fr_FR",
        "de_DE",
        "pt_BR",
        "zh_CN",
        "da_DK",
        "zh_HK",
        "id_ID",
        "he_IL",
        "ja_JP",
        "ko_KR",
        "nl_NL",
        "no_NO",
        "pl_PL",
        "pt_PT",
        "ru_RU",
        "sv_SE",
        "th_TH",
        "zh_TW"
    ];
    function zG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function OG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = zG(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = zG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var jG = function(e) {
        var t, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return "paypal" === e ? OG({}, r) : tC(t = Ty(r)).call(t, function(e, t) {
            var a = r[t];
            return ("color" !== t || kb(xG).call(xG, a)) && (e[t] = a), e;
        }, {});
    }, BG = function(e) {
        var t = e.amount, r = e.countryCode, a = e.debug, n = e.environment, o = void 0 === n ? "" : n, i = e.locale, l = e.configuration, s = e.commit, c = e.vault, u = e.enableMessages, d = function(e) {
            var t = e ? e.replace("-", "_") : null;
            return kb(TG).call(TG, t) ? t : null;
        }(i), p = t ? t.currency : null, m = "test" === o.toLowerCase(), f = m ? "AXy9hIzWB6h_LjZUHjHmsbsiicSIbL4GKOrcgomEedVjduUinIU4C2llxkW5p0OG0zTNgviYFceaXEnj" : "AU0Z-TP9t5_9196agaBN6ZD3UAwypdP1IX8ZYH3PcNNAQMXUTDQlChruXqQEhyI6-NKBKowN6ydkj477", h = l.merchantId, v = l.intent, y = "buttons,funding-eligibility".concat(u ? ",messages" : "");
        return OG(OG(OG(OG(OG(OG(OG({}, h && {
            "merchant-id": h
        }), d && {
            locale: d
        }), r && m && {
            "buyer-country": r
        }), a && m && {
            debug: a
        }), p && {
            currency: p
        }), v && {
            intent: v
        }), {}, {
            commit: s,
            vault: c,
            "client-id": f,
            "integration-date": "2020-02-01",
            "enable-funding": "paylater,venmo",
            components: y
        });
    }, MG = [
        "onInit",
        "onApprove",
        "onClick",
        "onCancel",
        "onError",
        "onShippingChange",
        "onShippingAddressChange",
        "onShippingOptionsChange",
        "onSubmit",
        "isProcessingPayment",
        "paypalRef",
        "style"
    ];
    function LG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function VG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = LG(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = LG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function UG(e) {
        var t, r = e.onInit, a = e.onApprove, n = e.onClick, o = e.onCancel, i = e.onError, l = e.onShippingChange, s = e.onShippingAddressChange, c = e.onShippingOptionsChange, u = e.onSubmit, d = e.isProcessingPayment, p = e.paypalRef, m = e.style, f = kg(e, MG), h = sw().i18n, v = "tokenize" === (null === (t = f.configuration) || void 0 === t ? void 0 : t.intent), y = qP(null), g = qP(null), b = qP(null), k = qP(null), C = function(e, t) {
            var d = VG(VG(VG(VG(VG(VG({}, v && {
                createBillingAgreement: u
            }), !v && {
                createOrder: u
            }), !v && "venmo" !== e && l && {
                onShippingChange: l
            }), !v && "venmo" !== e && s && {
                onShippingAddressChange: s
            }), !v && "venmo" !== e && c && {
                onShippingOptionsChange: c
            }), {}, {
                fundingSource: e,
                style: jG(e, m),
                onInit: r,
                onClick: n,
                onCancel: o,
                onError: i,
                onApprove: a
            }), f = p.Buttons(d);
            f.isEligible() && f.render(t.current);
        };
        KP(function() {
            l && s && console.warn('PayPal - "onShippingChange" and "onShippingAddressChange" are defined. It is recommended to only use "onShippingAddressChange", as "onShippingChange" is getting deprecated');
        }, [
            l,
            s
        ]), KP(function() {
            var e = p.FUNDING, t = e.PAYPAL, r = e.CREDIT, a = e.PAYLATER, n = e.VENMO;
            C(t, y), f.blockPayPalCreditButton || C(r, g), f.blockPayPalPayLaterButton || C(a, b), f.blockPayPalVenmoButton || C(n, k);
        }, []);
        var _ = !0 === f.commit;
        return nN("div", {
            className: DP("adyen-checkout__paypal__buttons", {
                "adyen-checkout__paypal-processing": d
            })
        }, nN("div", {
            className: "adyen-checkout__paypal__button adyen-checkout__paypal__button--paypal",
            ref: y
        }), nN("div", {
            className: "adyen-checkout__paypal__button adyen-checkout__paypal__button--credit",
            ref: g
        }), nN("div", {
            className: "adyen-checkout__paypal__button adyen-checkout__paypal__button--pay-later",
            ref: b
        }), nN("div", {
            className: "adyen-checkout__paypal__button adyen-checkout__paypal__button--venmo",
            ref: k
        }), d && nN("div", {
            className: "adyen-checkout__paypal"
        }, nN("div", {
            className: "adyen-checkout__paypal__status adyen-checkout__paypal__status--processing"
        }, nN(RP, {
            size: "medium",
            inline: !0
        }), _ && h.get("paypal.processingPayment"))));
    }
    var KG = [
        "onApprove",
        "onCancel",
        "onChange",
        "onError",
        "onSubmit"
    ];
    function HG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function qG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = HG(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = HG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function WG(e) {
        var t = e.onApprove, r = e.onCancel, a = e.onChange, n = e.onError, o = e.onSubmit, i = kg(e, KG), l = Vk(VP("pending"), 2), s = l[0], c = l[1];
        this.setStatus = c;
        var u = GP(function(e, r) {
            c("processing"), t(e, r);
        }, [
            t
        ]), d = function() {
            c("ready");
        };
        return KP(function() {
            var e = function(e) {
                var t, r, a = BG(e), n = decodeURIComponent(hC(t = Ty(a)).call(t, function(e) {
                    var t;
                    return wb(t = "".concat(e, "=")).call(t, a[e]);
                }).join("&"));
                return wb(r = "".concat("https://www.paypal.com/sdk/js", "?")).call(r, n);
            }(i), t = qG({}, i.cspNonce && {
                nonce: i.cspNonce
            }), r = qG({}, i.cspNonce && {
                cspNonce: i.cspNonce
            }), a = new sB(e, "body", t, r);
            return a.load().then(d), function() {
                a.remove();
            };
        }, []), nN("div", {
            className: "adyen-checkout__paypal"
        }, "pending" === s ? nN("div", {
            className: "adyen-checkout__paypal__status adyen-checkout__paypal__status--pending"
        }, nN(RP, null)) : nN(UG, M_({}, i, {
            onCancel: r,
            onChange: a,
            onError: n,
            onSubmit: o,
            onApprove: u,
            isProcessingPayment: "processing" === s,
            paypalRef: window.paypal
        })));
    }
    var GG = "No token was provided", YG = "Calling submit() is not supported for this payment method", QG = "The instance of the PayPal component being used is not the same which started the payment";
    function ZG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function JG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = ZG(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = ZG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var $G = function(e) {
        var t = e.paypalAddressObject;
        if (!t) return null;
        var r = function() {
            var e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
            return t && r ? wb(e = "".concat(t, ", ")).call(e, r) : t || r || null;
        }(t.address_line_1, t.address_line_2), a = JG(JG(JG(JG(JG({}, r && {
            street: r
        }), t.admin_area_1 && {
            stateOrProvince: t.admin_area_1
        }), t.admin_area_2 && {
            city: t.admin_area_2
        }), t.postal_code && {
            postalCode: t.postal_code
        }), t.country_code && {
            country: t.country_code
        });
        return Ty(a).length > 0 ? a : null;
    }, XG = [
        "onShippingAddressChange",
        "onShippingOptionsChange"
    ];
    function eY(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function tY(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = eY(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = eY(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function rY(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var aY = function(e) {
        U_(r, e);
        var t = rY(r);
        function r(e) {
            var a, n, o, i;
            return Cg(this, r), Ag(L_(i = t.call(this, e)), "paymentData", null), Ag(L_(i), "resolve", null), Ag(L_(i), "reject", null), Ag(L_(i), "submit", function() {
                i.handleError(new LS("IMPLEMENTATION_ERROR", YG));
            }), Ag(L_(i), "handleAction", function(e) {
                return i.updateWithAction(e);
            }), Ag(L_(i), "updateWithAction", function(e) {
                if (e.paymentMethodType !== i.type) throw new Error("Invalid Action");
                return e.paymentData && (i.paymentData = e.paymentData), e.sdkData && e.sdkData.token ? i.handleResolve(e.sdkData.token) : i.handleReject(GG), null;
            }), Ag(L_(i), "handleCancel", function() {
                i.handleError(new LS("CANCEL"));
            }), Ag(L_(i), "handleOnApprove", function(e, t) {
                var r = i.props.onShopperDetails, a = {
                    data: {
                        details: e,
                        paymentData: i.paymentData
                    }
                };
                if (r) return t.order.get().then(function(e) {
                    var t = function(e) {
                        var t, r, a, n, o, i, l, s;
                        if (!e) return null;
                        var c = {
                            firstName: null == e || null === (t = e.payer) || void 0 === t || null === (t = t.name) || void 0 === t ? void 0 : t.given_name,
                            lastName: null == e || null === (r = e.payer) || void 0 === r || null === (r = r.name) || void 0 === r ? void 0 : r.surname
                        }, u = null == e || null === (a = e.payer) || void 0 === a ? void 0 : a.email_address, d = null == e || null === (n = e.payer) || void 0 === n || null === (n = n.address) || void 0 === n ? void 0 : n.country_code, p = null == e || null === (o = e.payer) || void 0 === o || null === (o = o.phone) || void 0 === o || null === (o = o.phone_number) || void 0 === o ? void 0 : o.national_number, m = null == e || null === (i = e.payer) || void 0 === i ? void 0 : i.birth_date, f = $G({
                            paypalAddressObject: null == e || null === (l = e.payer) || void 0 === l ? void 0 : l.address
                        }), h = $G({
                            paypalAddressObject: null == e || null === (s = e.purchase_units) || void 0 === s || null === (s = s[0].shipping) || void 0 === s ? void 0 : s.address
                        }), v = JG(JG(JG(JG(JG(JG(JG({}, c.firstName && {
                            shopperName: c
                        }), u && {
                            shopperEmail: u
                        }), m && {
                            dateOfBirth: m
                        }), p && {
                            telephoneNumber: p
                        }), d && {
                            countryCode: d
                        }), f && {
                            billingAddress: f
                        }), h && {
                            shippingAddress: h
                        });
                        return Ty(v).length > 0 ? v : null;
                    }(e);
                    return new Ab(function(a, n) {
                        return r(t, e, {
                            resolve: a,
                            reject: n
                        });
                    });
                }).then(function() {
                    return i.handleAdditionalDetails(a);
                }).catch(function(e) {
                    return i.handleError(new LS("ERROR", "Something went wrong while parsing PayPal Order", {
                        cause: e
                    }));
                });
                i.handleAdditionalDetails(a);
            }), i.handleSubmit = Jg(a = i.handleSubmit).call(a, L_(i)), i.handleOnShippingAddressChange = Jg(n = i.handleOnShippingAddressChange).call(n, L_(i)), i.handleOnShippingOptionsChange = Jg(o = i.handleOnShippingOptionsChange).call(o, L_(i)), i;
        }
        return wg(r, [
            {
                key: "submitAnalytics",
                value: function(e) {
                    kI(H_(r.prototype), "submitAnalytics", this).call(this, tY({}, e), this.props);
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    var t, r = e.configuration, a = r.merchantId, n = r.intent, o = 0 === (null === (t = e.amount) || void 0 === t ? void 0 : t.value) ? "tokenize" : e.intent || n, i = "tokenize" === o || e.vault, l = "continue" === e.userAction;
                    return tY(tY({}, e), {}, {
                        commit: !l && e.commit,
                        vault: i,
                        configuration: {
                            intent: o,
                            merchantId: a
                        }
                    });
                }
            },
            {
                key: "updatePaymentData",
                value: function(e) {
                    e || console.warn("PayPal - Updating payment data with an invalid value"), this.paymentData = e;
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.props, t = e.isExpress, a = e.userAction;
                    return {
                        paymentMethod: {
                            type: r.type,
                            userAction: a,
                            subtype: t ? "express" : r.subtype
                        }
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "handleResolve",
                value: function(e) {
                    if (!this.resolve) return this.handleError(new LS("ERROR", QG));
                    this.resolve(e);
                }
            },
            {
                key: "handleReject",
                value: function(e) {
                    if (!this.reject) return this.handleError(new LS("ERROR", QG));
                    this.reject(new Error(e));
                }
            },
            {
                key: "handleSubmit",
                value: function() {
                    var e = this;
                    return kI(H_(r.prototype), "submit", this).call(this), new Ab(function(t, r) {
                        e.resolve = t, e.reject = r;
                    });
                }
            },
            {
                key: "handleOnShippingAddressChange",
                value: function(e, t) {
                    return this.props.onShippingAddressChange(e, t, this);
                }
            },
            {
                key: "handleOnShippingOptionsChange",
                value: function(e, t) {
                    return this.props.onShippingOptionsChange(e, t, this);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    if (!this.props.showPayButton) return null;
                    var t = this.props, r = t.onShippingAddressChange, a = t.onShippingOptionsChange, n = kg(t, XG);
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(WG, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, n, r && {
                        onShippingAddressChange: this.handleOnShippingAddressChange
                    }, a && {
                        onShippingOptionsChange: this.handleOnShippingOptionsChange
                    }, {
                        onCancel: this.handleCancel,
                        onChange: this.setState,
                        onApprove: this.handleOnApprove,
                        onError: function(t) {
                            e.handleError(new LS("ERROR", t.toString(), {
                                cause: t
                            }));
                        },
                        onSubmit: this.handleSubmit
                    })));
                }
            }
        ]), r;
    }(qS);
    function nY(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function oY(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = nY(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = nY(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function iY(e) {
        var t, r, a = sw().i18n, n = Vk(VP("ready"), 2), o = n[0], i = n[1], l = !(null == e || null === (t = e.items) || void 0 === t || !t.length), s = _D({
            schema: wb(r = []).call(r, Uk(l ? [
                "phonePrefix"
            ] : []), [
                "phoneNumber"
            ]),
            defaultData: oY({}, l ? {
                phonePrefix: e.selected
            } : {}),
            rules: {
                phoneNumber: {
                    modes: [
                        "blur"
                    ],
                    errorMessage: "error.va.gen.01",
                    validate: function(e) {
                        return (null == e ? void 0 : e.length) > 6;
                    }
                }
            }
        }), c = s.handleChangeFor, u = s.triggerValidation, d = s.data, p = s.valid, m = s.errors, f = s.isValid;
        return KP(function() {
            e.onChange({
                data: d,
                valid: p,
                errors: m,
                isValid: f
            });
        }, [
            d,
            p,
            m,
            f
        ]), this.showValidation = u, this.setStatus = i, nN("div", {
            className: "adyen-checkout__phone-input"
        }, nN(FE, {
            errorMessage: !!m.phoneNumber,
            label: a.get(e.phoneLabel),
            className: DP({
                "adyen-checkout__input--phone-number": !0
            }),
            inputWrapperModifiers: [
                "phoneInput"
            ],
            name: ""
        }, nN("div", {
            className: "adyen-checkout__input-wrapper"
        }, nN("div", {
            className: DP({
                "adyen-checkout__input": !0,
                "adyen-checkout__input--invalid": !!m.phoneNumber
            })
        }, !!l && nN(FE, {
            inputWrapperModifiers: [
                "phoneInput"
            ],
            name: e.prefixName
        }, nN(cz, {
            className: "adyen-checkout__dropdown--small adyen-checkout__countryFlag",
            filterable: !1,
            items: e.items,
            name: e.prefixName,
            onChange: c("phonePrefix"),
            placeholder: a.get("infix"),
            selectedValue: d.phonePrefix
        }), nN("div", {
            className: "adyen-checkout__phoneNumber"
        }, nN("input", {
            type: "tel",
            name: e.phoneName,
            value: d.phoneNumber,
            onInput: c("phoneNumber", "input"),
            onBlur: c("phoneNumber", "blur"),
            placeholder: "123 456 789",
            className: "adyen-checkout__input adyen-checkout__input--phoneNumber",
            autoCorrect: "off"
        })))))), this.props.showPayButton && this.props.payButton({
            status: o
        }));
    }
    function lY(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function sY(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = lY(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = lY(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    Ag(aY, "type", "paypal"), Ag(aY, "subtype", "sdk"), Ag(aY, "defaultProps", {
        environment: "TEST",
        status: "loading",
        showPayButton: !0,
        userAction: "pay",
        merchantId: "",
        cspNonce: null,
        intent: null,
        commit: !0,
        vault: !1,
        style: {
            height: 48
        },
        blockPayPalCreditButton: !1,
        blockPayPalPayLaterButton: !1,
        enableMessages: !1,
        blockPayPalVenmoButton: !1,
        isExpress: !1,
        configuration: {
            merchantId: "",
            intent: null
        },
        onInit: function() {},
        onClick: function() {},
        onCancel: function() {},
        onError: function() {}
    }), iY.defaultProps = {
        phoneLabel: "telephoneNumber"
    };
    var cY, uY = function(e, t) {
        if (e && t) {
            var r = zb(e).call(e, function(e) {
                return e.code === t;
            });
            return !!r && r.id;
        }
        return !1;
    }, dY = [
        {
            id: "+7",
            name: "Russian Federation",
            code: "RU"
        },
        {
            id: "+9955",
            name: "Georgia",
            code: "GE"
        },
        {
            id: "+507",
            name: "Panama",
            code: "PA"
        },
        {
            id: "+44",
            name: "United Kingdom",
            code: "GB"
        },
        {
            id: "+992",
            name: "Tajikistan",
            code: "TJ"
        },
        {
            id: "+370",
            name: "Lithuania",
            code: "LT"
        },
        {
            id: "+972",
            name: "Israel",
            code: "IL"
        },
        {
            id: "+996",
            name: "Kyrgyzstan",
            code: "KG"
        },
        {
            id: "+380",
            name: "Ukraine",
            code: "UA"
        },
        {
            id: "+84",
            name: "Viet Nam",
            code: "VN"
        },
        {
            id: "+90",
            name: "Turkey",
            code: "TR"
        },
        {
            id: "+994",
            name: "Azerbaijan",
            code: "AZ"
        },
        {
            id: "+374",
            name: "Armenia",
            code: "AM"
        },
        {
            id: "+371",
            name: "Latvia",
            code: "LV"
        },
        {
            id: "+91",
            name: "India",
            code: "IN"
        },
        {
            id: "+66",
            name: "Thailand",
            code: "TH"
        },
        {
            id: "+373",
            name: "Moldova",
            code: "MD"
        },
        {
            id: "+1",
            name: "United States",
            code: "US"
        },
        {
            id: "+81",
            name: "Japan",
            code: "JP"
        },
        {
            id: "+998",
            name: "Uzbekistan",
            code: "UZ"
        },
        {
            id: "+77",
            name: "Kazakhstan",
            code: "KZ"
        },
        {
            id: "+375",
            name: "Belarus",
            code: "BY"
        },
        {
            id: "+372",
            name: "Estonia",
            code: "EE"
        },
        {
            id: "+40",
            name: "Romania",
            code: "RO"
        },
        {
            id: "+82",
            name: "Korea",
            code: "KR"
        }
    ];
    function pY(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function mY(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = pY(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = pY(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function fY(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var hY = function(e) {
        U_(r, e);
        var t = fY(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    return mY(mY({
                        onValid: function() {}
                    }, e), {}, {
                        selected: uY(e.items, e.countryCode)
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    return {
                        paymentMethod: {
                            type: r.type,
                            "qiwiwallet.telephoneNumberPrefix": this.state.data ? this.state.data.phonePrefix : "",
                            "qiwiwallet.telephoneNumber": this.state.data ? this.state.data.phoneNumber : ""
                        }
                    };
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(iY, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, this.state, {
                        phoneLabel: "mobileNumber",
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(qS);
    function vY(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function yY(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = vY(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = vY(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    Ag(hY, "type", "qiwiwallet"), Ag(hY, "defaultProps", {
        items: xg(cY = hC(dY).call(dY, function(e) {
            var t;
            if (!e) throw new Error("No item passed");
            return !(!e.code || !e.id) && sY(sY({}, e), {}, {
                name: wb(t = "".concat(e.name, " (")).call(t, e.id, ")"),
                selectedOptionName: e.id
            });
        })).call(cY, function(e) {
            return !1 !== e;
        }),
        countryCode: dY[0].code,
        prefixName: "qiwiwallet.telephoneNumberPrefix",
        phoneName: "qiwiwallet.telephoneNumber"
    });
    function gY(e) {
        var t = this, r = qP(null), a = Vk(VP({}), 2), n = a[0], o = a[1], i = Vk(VP({}), 2), l = i[0], s = i[1], c = Vk(VP({}), 2), u = c[0], d = c[1], p = Vk(VP(!1), 2), m = p[0], f = p[1], h = Vk(VP(null), 2), v = h[0], y = h[1], g = Vk(VP([]), 2), b = g[0], k = g[1], C = Vk(VP(""), 2), _ = C[0], N = C[1], P = WP(function() {
            return PK(e, {
                sfp: r
            }, {
                dualBrandSelectElements: b,
                setDualBrandSelectElements: k,
                setSelectedBrandValue: N,
                issuingCountryCode: v,
                setIssuingCountryCode: y
            });
        }, [
            b,
            v
        ]);
        return this.processBinLookupResponse = function(e, t) {
            P.processBinLookup(e, t);
        }, this.dualBrandingChangeHandler = P.handleDualBrandSelection, KP(function() {
            return t.setFocusOn = r.current.setFocusOn, t.updateStyles = r.current.updateStyles, t.showValidation = r.current.showValidation, t.handleUnsupportedCard = r.current.handleUnsupportedCard, function() {
                r.current.destroy();
            };
        }, []), KP(function() {
            var t = r.current.mapErrorsToValidationRuleResult();
            e.onChange({
                data: u,
                valid: l,
                errors: yY(yY({}, n), t),
                isValid: m,
                selectedBrandValue: _
            });
        }, [
            u,
            l,
            n,
            _
        ]), nN(uK, M_({
            ref: r
        }, bY(e), {
            onChange: function(e) {
                d(yY(yY({}, u), e.data)), o(yY(yY({}, n), e.errors)), s(yY(yY({}, l), e.valid)), f(e.isSfpValid);
            },
            render: function() {
                return null;
            }
        }));
    }
    gY.defaultProps = {
        onChange: function() {},
        onError: function() {}
    };
    var bY = function(e) {
        return {
            allowedDOMAccess: e.allowedDOMAccess,
            autoFocus: e.autoFocus,
            brands: e.brands,
            brandsConfiguration: e.brandsConfiguration,
            clientKey: e.clientKey,
            i18n: e.i18n,
            implementationType: e.implementationType,
            keypadFix: e.keypadFix,
            legacyInputMode: e.legacyInputMode,
            loadingContext: e.loadingContext,
            minimumExpiryDate: e.minimumExpiryDate,
            onAdditionalSFConfig: e.onAdditionalSFConfig,
            onAdditionalSFRemoved: e.onAdditionalSFRemoved,
            onAllValid: e.onAllValid,
            onAutoComplete: e.onAutoComplete,
            onBinValue: e.onBinValue,
            onBrand: e.onBrand,
            onConfigSuccess: e.onConfigSuccess,
            onError: e.onError,
            onFieldValid: e.onFieldValid,
            onFocus: e.onFocus,
            onLoad: e.onLoad,
            rootNode: e.rootNode,
            showWarnings: e.showWarnings,
            styles: e.styles,
            trimTrailingSeparator: e.trimTrailingSeparator,
            type: e.type,
            resources: e.resources
        };
    };
    function kY(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function CY(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = kY(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = kY(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function _Y(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var NY = function(e) {
        U_(r, e);
        var t = _Y(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "onBinValue", NH(L_(a))), Ag(L_(a), "onFocus", function(e) {
                var t, r;
                a.submitAnalytics({
                    type: !0 === e.focus ? qN : WN,
                    target: QV(e.fieldType)
                }), null === (t = (r = a.props).onFocus) || void 0 === t || t.call(r, e);
            }), a;
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return CY(CY({}, e), {}, {
                        type: "scheme" === e.type || "securedfields" === e.type ? "card" : e.type
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.state.selectedBrandValue || this.props.brand;
                    return {
                        paymentMethod: CY(CY({
                            type: r.type
                        }, this.state.data), e && {
                            brand: e
                        }),
                        browserInfo: this.browserInfo
                    };
                }
            },
            {
                key: "updateStyles",
                value: function(e) {
                    var t;
                    return null !== (t = this.componentRef) && void 0 !== t && t.updateStyles && this.componentRef.updateStyles(e), this;
                }
            },
            {
                key: "setFocusOn",
                value: function(e) {
                    var t;
                    return null !== (t = this.componentRef) && void 0 !== t && t.setFocusOn && this.componentRef.setFocusOn(e), this;
                }
            },
            {
                key: "processBinLookupResponse",
                value: function(e) {
                    var t;
                    return null !== (t = this.componentRef) && void 0 !== t && t.processBinLookupResponse && this.componentRef.processBinLookupResponse(e), this;
                }
            },
            {
                key: "dualBrandingChangeHandler",
                value: function(e) {
                    var t;
                    return null !== (t = this.componentRef) && void 0 !== t && t.dualBrandingChangeHandler && this.componentRef.dualBrandingChangeHandler(e), this;
                }
            },
            {
                key: "handleUnsupportedCard",
                value: function(e) {
                    var t;
                    return null !== (t = this.componentRef) && void 0 !== t && t.handleUnsupportedCard && this.componentRef.handleUnsupportedCard(e), this;
                }
            },
            {
                key: "onBinLookup",
                value: function(e) {
                    var t, r = this, a = CY({}, e);
                    (a.rootNode = this._node, a.isReset) || (a.supportedBrandsRaw = null === (t = e.supportedBrandsRaw) || void 0 === t ? void 0 : hC(t).call(t, function(e) {
                        var t, a;
                        return e.brandImageUrl = null !== (t = null === (a = r.props.brandsConfiguration[e.brand]) || void 0 === a ? void 0 : a.icon) && void 0 !== t ? t : YV(e.brand, r.resources), e;
                    }));
                    this.props.onBinLookup(a);
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "browserInfo",
                get: function() {
                    return Mj();
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(gY, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, this.state, {
                        rootNode: this._node,
                        onChange: this.setState,
                        onBinValue: this.onBinValue,
                        implementationType: "custom",
                        resources: this.resources,
                        onFocus: this.onFocus
                    })));
                }
            }
        ]), r;
    }(qS);
    function PY(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function wY(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = PY(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = PY(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function AY(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(NY, "type", "scheme"), Ag(NY, "analyticsType", "custom-scheme"), Ag(NY, "defaultProps", {
        onBinLookup: function() {},
        brandsConfiguration: {}
    });
    var SY = function(e) {
        U_(r, e);
        var t = AY(r);
        function r(e) {
            var a;
            return Cg(this, r), (a = t.call(this, e)).state = wY(wY({}, a.state), {
                data: {
                    ibanNumber: "",
                    ownerName: ""
                }
            }), a;
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return wY({
                        holderName: !0
                    }, e);
                }
            },
            {
                key: "formatData",
                value: function() {
                    return {
                        paymentMethod: {
                            type: r.type,
                            iban: this.state.data.ibanNumber,
                            ownerName: this.state.data.ownerName
                        }
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.showFormInstruction && nN(iO, null), nN(oO, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(qS);
    function IY(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(SY, "type", "sepadirectdebit"), Ag(SY, "defaultProps", {
        showFormInstruction: !0
    });
    var EY = function(e) {
        U_(r, e);
        var t = IY(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "formEl", void 0), a;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.formEl.submit(), this.props.onFormSubmit("".concat(this.props.inputName, " sent"));
                }
            },
            {
                key: "render",
                value: function(e) {
                    var t = this, r = e.name, a = e.action, n = e.target, o = e.inputName, i = e.inputValue;
                    return nN("form", {
                        ref: function(e) {
                            t.formEl = e;
                        },
                        method: "POST",
                        className: DP([
                            "adyen-checkout__threeds2__form",
                            "adyen-checkout__threeds2__form--".concat(r)
                        ]),
                        name: r,
                        action: a,
                        target: n,
                        style: {
                            display: "none"
                        }
                    }, nN("input", {
                        name: o,
                        value: i
                    }));
                }
            }
        ]), r;
    }(lN), DY = "threeDS2Error", RY = "threeDS2", FY = "3DS2", xY = {
        result: {
            transStatus: "U"
        },
        type: "challengeResult",
        errorCode: "timeout"
    }, TY = {
        result: {
            threeDSCompInd: "N"
        },
        type: "fingerPrintResult",
        errorCode: "timeout"
    }, zY = "unknownError", OY = {
        timeout: "ThreeDS2 timed out",
        wrongOrigin: "Result came in the right format but not from the expected origin",
        HTMLElementError: "No proper HTML element was passed",
        wrongDataType: "Result data was not of the expected type",
        missingProperty: "Result data did not contain the expected properties",
        unknownError: "An unknown error occurred"
    }, jY = {
        "01": [
            "250px",
            "400px"
        ],
        "02": [
            "390px",
            "400px"
        ],
        "03": [
            "500px",
            "600px"
        ],
        "04": [
            "600px",
            "400px"
        ],
        "05": [
            "100%",
            "100%"
        ]
    }, BY = function(e) {
        return "success" in e && !e.success;
    }, MY = function(e) {
        var t = iI.decode(e);
        if (t.success) try {
            return JSON.parse(t.data);
        } catch (e) {
            return {
                success: !1,
                error: "Could not JSON parse token"
            };
        }
        return t;
    }, LY = function(e) {
        if (!e || !Ty(e).length) throw new Error("No (populated) data object to encode");
        return iI.encode(Mb(e));
    }, VY = function(e) {
        var t = 1 === e.length ? "0".concat(e) : e;
        return Object.prototype.hasOwnProperty.call(jY, t) ? t : "02";
    }, UY = function(e, t, r) {
        return {
            data: Ag(Ag({}, e, LY({
                threeDSCompInd: t.threeDSCompInd
            })), "paymentData", r)
        };
    }, KY = function(e, t, r) {
        return {
            data: {
                details: {
                    "threeds2.fingerprint": LY(t)
                },
                paymentData: r
            }
        };
    }, HY = function(e, t, r) {
        return {
            data: {
                details: Ag({}, e, LY({
                    transStatus: t,
                    authorisationToken: r
                }))
            }
        };
    }, qY = function(e, t, r) {
        return {
            data: {
                details: {
                    "threeds2.challengeResult": LY({
                        transStatus: t
                    })
                },
                paymentData: r
            }
        };
    }, WY = function(e, t) {
        return {
            errorCode: e,
            message: OY[e] || t || OY[zY]
        };
    }, GY = function(e) {
        var t = window.btoa(e).split("=")[0];
        return t = (t = t.replace(/\+/g, "-")).replace(/\//g, "_");
    }, YY = [
        "elementRef"
    ], QY = [
        "createFromAction",
        "onAdditionalDetails"
    ];
    function ZY(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var JY = "threeDSIframe", $Y = function(e) {
        U_(r, e);
        var t = ZY(r);
        function r(e) {
            var a;
            Cg(this, r), Ag(L_(a = t.call(this, e)), "processMessageHandler", void 0), Ag(L_(a), "challengePromise", void 0), Ag(L_(a), "iframeCallback", function() {
                a.setState({
                    status: "iframeLoaded"
                }), "init" === a.state.status && a.props.onActionHandled({
                    componentType: "3DS2Challenge",
                    actionDescription: "".concat(FY, " challenge iframe loaded")
                });
            });
            var n = Mb(a.props.cReqData), o = GY(n);
            return a.state = {
                base64URLencodedData: o,
                status: "init"
            }, a;
        }
        return wg(r, [
            {
                key: "get3DS2ChallengePromise",
                value: function() {
                    var e = this;
                    return new Ab(function(t, r) {
                        e.processMessageHandler = XS(e.props.postMessageDomain, t, 0, "challengeResult"), window.addEventListener("message", e.processMessageHandler);
                    });
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.challengePromise = YS(6e5, this.get3DS2ChallengePromise(), xY), this.challengePromise.promise.then(function(t) {
                        window.removeEventListener("message", e.processMessageHandler), e.props.onCompleteChallenge(t);
                    }).catch(function(t) {
                        window.removeEventListener("message", e.processMessageHandler), e.props.onErrorChallenge(t);
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.challengePromise && this.challengePromise.cancel(), window.removeEventListener("message", this.processMessageHandler);
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r = e.acsURL, a = e.cReqData, n = e.iframeSizeArr, o = e.onFormSubmit, i = t.base64URLencodedData, l = t.status, s = Vk(n, 2), c = s[0], u = s[1];
                    return nN("div", {
                        className: DP([
                            "adyen-checkout__threeds2__challenge",
                            "adyen-checkout__threeds2__challenge--".concat(a.challengeWindowSize)
                        ])
                    }, "iframeLoaded" !== l && nN(RP, null), nN(GS, {
                        name: JY,
                        width: c,
                        height: u,
                        callback: this.iframeCallback
                    }), nN(EY, {
                        name: "cReqForm",
                        action: r,
                        target: JY,
                        inputName: "creq",
                        inputValue: i,
                        onFormSubmit: o
                    }));
                }
            }
        ]), r;
    }(lN);
    function XY(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var eQ = function(e) {
        U_(r, e);
        var t = XY(r);
        function r(e) {
            var a;
            if (Cg(this, r), Ag(L_(a = t.call(this, e)), "onActionHandled", function(e) {
                a.props.onSubmitAnalytics({
                    type: RY,
                    message: e.actionDescription,
                    subtype: tP.CHALLENGE_IFRAME_LOADED
                }), a.props.onActionHandled(e);
            }), Ag(L_(a), "onFormSubmit", function(e) {
                a.props.onSubmitAnalytics({
                    type: RY,
                    message: e,
                    subtype: tP.CHALLENGE_DATA_SENT
                });
            }), a.props.token) {
                var n = function(e) {
                    var t = e.token, r = e.size, a = MY(t);
                    if (BY(a)) return a;
                    var n, o = a, i = o.acsTransID, l = o.acsURL, s = o.messageVersion, c = o.threeDSNotificationURL, u = o.threeDSServerTransID, d = eI(c);
                    return {
                        acsURL: l,
                        cReqData: {
                            acsTransID: i,
                            messageVersion: s,
                            threeDSServerTransID: u,
                            messageType: "CReq",
                            challengeWindowSize: VY(r)
                        },
                        iframeSizeArr: (n = r, jY[VY(n)]),
                        postMessageDomain: d
                    };
                }({
                    token: a.props.token,
                    size: a.props.challengeWindowSize || a.props.size
                }), o = n.cReqData, i = o.acsTransID, l = o.messageVersion, s = o.threeDSServerTransID;
                if (!(n.acsURL && i && l && s)) return a.setStatusError({
                    errorInfo: "Challenge Data missing one or more of the following properties (acsURL | acsTransID | messageVersion | threeDSServerTransID)"
                }), K_(a);
                a.state = {
                    status: "retrievingChallengeToken",
                    challengeData: n,
                    errorInfo: null
                };
            } else a.setStatusError({
                errorInfo: "Missing challengeToken parameter"
            });
            return a;
        }
        return wg(r, [
            {
                key: "setStatusComplete",
                value: function(e) {
                    var t = this, r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    this.setState({
                        status: "complete"
                    }, function() {
                        var a, n = (t.props.useOriginalFlow ? qY : HY)(t.props.dataKey, e.transStatus, t.props.paymentData);
                        switch(null == e ? void 0 : e.transStatus){
                            case "Y":
                                a = "success";
                                break;
                            case "N":
                                a = "failed";
                                break;
                            case "U":
                                a = r ? "timeout" : "cancelled";
                        }
                        null != e && e.errorCode && (a = "noTransStatus");
                        var o = {
                            type: RY,
                            message: "".concat(FY, " challenge has completed"),
                            subtype: tP.CHALLENGE_COMPLETED,
                            result: a
                        };
                        t.props.onSubmitAnalytics(o), t.props.onComplete(n);
                    });
                }
            },
            {
                key: "setStatusError",
                value: function(e) {
                    this.setState({
                        status: "error",
                        errorInfo: e.errorInfo
                    }), this.props.onError(e);
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r = this, a = t.challengeData, n = II();
                    return "retrievingChallengeToken" === this.state.status ? nN($Y, M_({
                        onCompleteChallenge: function(e) {
                            if (VS(e.result, "errorCode") && e.result.errorCode.length) {
                                var t = WY(e.result.errorCode, e.result.errorDescription);
                                r.props.onError(t);
                            }
                            r.setStatusComplete(e.result);
                        },
                        onErrorChallenge: function(e) {
                            if (VS(e, "errorCode")) {
                                var t = WY(e.errorCode);
                                return r.props.onError(t), void r.setStatusComplete(e.result);
                            }
                        }
                    }, a, {
                        onActionHandled: this.onActionHandled,
                        onFormSubmit: this.onFormSubmit
                    })) : "error" === this.state.status ? nN("div", {
                        className: "adyen-checkout__threeds2-challenge-error"
                    }, nN(XT, {
                        className: "adyen-checkout__status__icon adyen-checkout__status__icon--error",
                        src: n({
                            imageFolder: "components/"
                        })("error"),
                        alt: ""
                    }), nN("div", {
                        className: "adyen-checkout__status__text"
                    }, this.state.errorInfo ? this.state.errorInfo : this.props.i18n.get("error.message.unknown"))) : null;
                }
            }
        ]), r;
    }(lN);
    function tQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(eQ, "defaultProps", {
        onComplete: function() {},
        onError: function() {},
        onActionHandled: function() {}
    });
    var rQ = function(e) {
        U_(r, e);
        var t = tQ(r);
        function r() {
            var e, a, n;
            Cg(this, r);
            for(var o = arguments.length, i = new Array(o), l = 0; l < o; l++)i[l] = arguments[l];
            return Ag(L_(n = t.call.apply(t, wb(e = [
                this
            ]).call(e, i))), "submitAnalytics", function(e) {
                e.type !== LN && kI((a = L_(n), H_(r.prototype)), "submitAnalytics", a).call(a, e);
            }), n;
        }
        return wg(r, [
            {
                key: "onComplete",
                value: function(e) {
                    e && kI(H_(r.prototype), "onComplete", this).call(this, e), this.unmount();
                }
            },
            {
                key: "render",
                value: function() {
                    if (!vj(this.props.paymentData)) {
                        var e = VS(this.props, "useOriginalFlow") ? "paymentData" : "authorisationToken";
                        return this.props.onError({
                            errorCode: "threeds2.challenge",
                            message: "No ".concat(e, " received. Challenge cannot proceed")
                        }), this.submitAnalytics({
                            type: DY,
                            code: JN,
                            errorType: ZN,
                            message: "".concat("3DS2Challenge_Error", ": Missing 'paymentData' property from threeDS2 action")
                        }), null;
                    }
                    return nN(eQ, M_({}, this.props, {
                        onComplete: this.onComplete,
                        onSubmitAnalytics: this.submitAnalytics
                    }));
                }
            }
        ]), r;
    }(qS);
    function aQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(rQ, "type", "threeDS2Challenge"), Ag(rQ, "defaultProps", {
        dataKey: "threeDSResult",
        size: "02",
        type: "threeDS2Challenge"
    });
    var nQ = "threeDSMethodIframe", oQ = function(e) {
        U_(r, e);
        var t = aQ(r);
        function r(e) {
            var a;
            Cg(this, r), Ag(L_(a = t.call(this, e)), "processMessageHandler", void 0), Ag(L_(a), "fingerPrintPromise", void 0);
            var n = a.props, o = n.threeDSServerTransID, i = n.threeDSMethodNotificationURL, l = Mb({
                threeDSServerTransID: o,
                threeDSMethodNotificationURL: i
            }), s = GY(l);
            return a.state = {
                base64URLencodedData: s
            }, a;
        }
        return wg(r, [
            {
                key: "get3DS2MethodPromise",
                value: function() {
                    var e = this;
                    return new Ab(function(t, r) {
                        e.processMessageHandler = XS(e.props.postMessageDomain, t, 0, "fingerPrintResult"), window.addEventListener("message", e.processMessageHandler);
                    });
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.fingerPrintPromise = YS(1e4, this.get3DS2MethodPromise(), TY), this.fingerPrintPromise.promise.then(function(t) {
                        window.removeEventListener("message", e.processMessageHandler), e.props.onCompleteFingerprint(t);
                    }).catch(function(t) {
                        window.removeEventListener("message", e.processMessageHandler), e.props.onErrorFingerprint(t);
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.fingerPrintPromise && this.fingerPrintPromise.cancel(), window.removeEventListener("message", this.processMessageHandler);
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r = e.threeDSMethodURL, a = e.onActionHandled, n = e.onFormSubmit, o = t.base64URLencodedData;
                    return nN("div", {
                        className: "adyen-checkout__3ds2-device-fingerprint"
                    }, this.props.showSpinner && nN(RP, null), nN("div", {
                        style: {
                            display: "none"
                        }
                    }, nN(GS, {
                        name: nQ,
                        callback: function() {
                            a({
                                componentType: "3DS2Fingerprint",
                                actionDescription: "".concat(FY, " fingerprint iframe loaded")
                            });
                        }
                    }), nN(EY, {
                        name: "threeDSMethodForm",
                        action: r,
                        target: nQ,
                        inputName: "threeDSMethodData",
                        inputValue: o,
                        onFormSubmit: n
                    })));
                }
            }
        ]), r;
    }(lN);
    function iQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(oQ, "defaultProps", {
        showSpinner: !0
    });
    var lQ = function(e) {
        U_(r, e);
        var t = iQ(r);
        function r(e) {
            var a;
            Cg(this, r), Ag(L_(a = t.call(this, e)), "onActionHandled", function(e) {
                a.props.onSubmitAnalytics({
                    type: RY,
                    message: e.actionDescription,
                    subtype: tP.FINGERPRINT_IFRAME_LOADED
                }), a.props.onActionHandled(e);
            }), Ag(L_(a), "onFormSubmit", function(e) {
                a.props.onSubmitAnalytics({
                    type: RY,
                    message: e,
                    subtype: tP.FINGERPRINT_DATA_SENT
                });
            });
            var n = a.props, o = n.token, i = n.notificationURL;
            if (o) {
                var l = function(e) {
                    var t = e.token, r = e.notificationURL, a = MY(t);
                    if (BY(a)) return a;
                    var n = a, o = n.threeDSMethodNotificationURL, i = n.threeDSMethodUrl, l = r || o;
                    return {
                        threeDSServerTransID: n.threeDSServerTransID,
                        threeDSMethodURL: i,
                        threeDSMethodNotificationURL: l,
                        postMessageDomain: eI(l)
                    };
                }({
                    token: o,
                    notificationURL: i
                });
                a.state = {
                    status: "init",
                    fingerPrintData: l
                };
            } else a.state = {
                status: "error"
            }, a.props.onError({
                errorCode: a.props.dataKey,
                message: "Missing fingerprintToken parameter"
            });
            return a;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    if (!this.state.fingerPrintData || !this.state.fingerPrintData.threeDSMethodURL) return this.setStatusComplete({
                        threeDSCompInd: "U"
                    }), void console.debug("### PrepareFingerprint3DS2::exiting:: no fingerPrintData or no threeDSMethodURL");
                    this.setState({
                        status: "retrievingFingerPrint"
                    });
                }
            },
            {
                key: "setStatusComplete",
                value: function(e) {
                    var t = this, r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    this.setState({
                        status: "complete"
                    }, function() {
                        var a, n = (t.props.useOriginalFlow ? KY : UY)(t.props.dataKey, e, t.props.paymentData);
                        switch(null == e ? void 0 : e.threeDSCompInd){
                            case "Y":
                                a = "success";
                                break;
                            case "N":
                                a = r ? "timeout" : "failed";
                                break;
                            case "U":
                                a = "noThreeDSMethodURL";
                        }
                        var o = {
                            type: RY,
                            message: "".concat(FY, " fingerprinting has completed"),
                            subtype: tP.FINGERPRINT_COMPLETED,
                            result: a
                        };
                        t.props.onSubmitAnalytics(o), t.props.onComplete(n);
                    });
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r = this, a = e.showSpinner, n = t.status, o = t.fingerPrintData;
                    return "retrievingFingerPrint" === n ? nN(oQ, M_({
                        onCompleteFingerprint: function(e) {
                            r.setStatusComplete(e.result);
                        },
                        onErrorFingerprint: function(e) {
                            var t = WY(e.errorCode);
                            console.debug("### PrepareFingerprint3DS2::fingerprint timed-out:: errorCodeObject=", t), r.setStatusComplete(e.result, !0);
                        },
                        showSpinner: a
                    }, o, {
                        onActionHandled: this.onActionHandled,
                        onFormSubmit: this.onFormSubmit
                    })) : null;
                }
            }
        ]), r;
    }(lN);
    function sQ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function cQ(e) {
        var t = this, r = e.data;
        zT({
            path: "v1/submitThreeDS2Fingerprint?token=".concat(this.props.clientKey),
            loadingContext: this.props.loadingContext,
            errorLevel: "fatal"
        }, function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Sg(r = sQ(Object(n), !0)).call(r, function(t) {
                    Ag(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Sg(a = sQ(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({}, r)).then(function(e) {
            var r, a, n, o = null !== (r = t.props.elementRef) && void 0 !== r ? r : t;
            if (o) {
                if (e.action || e.details) {
                    if ("completed" === e.type) {
                        var i = e.details;
                        return t.onComplete({
                            data: {
                                details: i
                            }
                        });
                    }
                    return "threeDS2" === (null === (a = e.action) || void 0 === a ? void 0 : a.type) ? o.handleAction(e.action, ZV("challengeWindowSize").from(t.props)) : "redirect" === (null === (n = e.action) || void 0 === n ? void 0 : n.type) ? o.handleAction(e.action) : void 0;
                }
                console.error("Handled Error::callSubmit3DS2Fingerprint::FAILED:: resData=", e);
            } else console.error("Handled Error::callSubmit3DS2Fingerprint::FAILED:: actionHandler=", o);
        }).catch(function(e) {
            t.handleError(e);
        });
    }
    function uQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(lQ, "type", "scheme"), Ag(lQ, "defaultProps", {
        onComplete: function() {},
        onError: function() {},
        paymentData: "",
        showSpinner: !0,
        onActionHandled: function() {}
    });
    var dQ = function(e) {
        U_(r, e);
        var t = uQ(r);
        function r() {
            var e, a, n;
            Cg(this, r);
            for(var o = arguments.length, i = new Array(o), l = 0; l < o; l++)i[l] = arguments[l];
            return Ag(L_(n = t.call.apply(t, wb(e = [
                this
            ]).call(e, i))), "callSubmit3DS2Fingerprint", Jg(cQ).call(cQ, L_(n))), Ag(L_(n), "submitAnalytics", function(e) {
                e.type !== LN && kI((a = L_(n), H_(r.prototype)), "submitAnalytics", a).call(a, e);
            }), n;
        }
        return wg(r, [
            {
                key: "onComplete",
                value: function(e) {
                    kI(H_(r.prototype), "onComplete", this).call(this, e), this.unmount();
                }
            },
            {
                key: "render",
                value: function() {
                    return vj(this.props.paymentData) ? nN(lQ, M_({}, this.props, {
                        onComplete: this.props.useOriginalFlow ? this.onComplete : this.callSubmit3DS2Fingerprint,
                        onSubmitAnalytics: this.submitAnalytics,
                        isMDFlow: this.props.paymentData.length < 15
                    })) : (this.props.onError({
                        errorCode: r.defaultProps.dataKey,
                        message: "No paymentData received. Fingerprinting cannot proceed"
                    }), this.submitAnalytics({
                        type: DY,
                        code: JN,
                        errorType: ZN,
                        message: "".concat("3DS2Fingerprint_Error", ": Missing 'paymentData' property from threeDS2 action")
                    }), null);
                }
            }
        ]), r;
    }(qS);
    Ag(dQ, "type", "threeDS2Fingerprint"), Ag(dQ, "defaultProps", {
        dataKey: "fingerprintResult",
        type: "threeDS2Fingerprint"
    });
    var pQ = t(ee.setInterval), mQ = ea, fQ = vo, hQ = G, vQ = RangeError, yQ = function(e) {
        var t = fQ(hQ(this)), r = "", a = mQ(e);
        if (a < 0 || a === 1 / 0) throw new vQ("Wrong number of repetitions");
        for(; a > 0; (a >>>= 1) && (t += t))1 & a && (r += t);
        return r;
    };
    Sr({
        target: "String",
        proto: !0
    }, {
        repeat: yQ
    });
    var gQ = Cv("String", "repeat"), bQ = ie, kQ = gQ, CQ = String.prototype, _Q = t(function(e) {
        var t = e.repeat;
        return "string" == typeof e || e === CQ || bQ(CQ, e) && t === CQ.repeat ? kQ : t;
    }), NQ = function(e) {
        var t, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2;
        if (0 === r) return e;
        var a = String(e);
        return a.length >= r ? a : oI(t = _Q("0").call("0", r) + a).call(t, -1 * r);
    }, PQ = function(e, t) {
        var r = new Date, a = t.getTime() - r.getTime(), n = a / 1e3, o = function(e, t, r) {
            var a = r.getTime() - e.getTime();
            return 100 - Math.round(100 * (t.getTime() - e.getTime()) / a);
        }(e, r, t);
        return {
            total: a,
            minutes: NQ(Math.floor(n / 60 % 60)),
            seconds: NQ(Math.floor(n % 60)),
            completed: a <= 0,
            percentage: o
        };
    }, wQ = function() {
        function e(t) {
            Cg(this, e), Ag(this, "TRANSLATION_KEY", "sr.wechatpay.timetopay"), Ag(this, "LONG_TIMEOUT", 18e4), Ag(this, "MID_TIMEOUT", 6e4), Ag(this, "SHORT_TIMEOUT", 3e4), Ag(this, "srPanel", void 0), Ag(this, "i18n", void 0), Ag(this, "srInterval", void 0), Ag(this, "timeout", void 0), Ag(this, "timeLeft", void 0);
            var r = t.srPanel, a = t.i18n;
            this.srPanel = r, this.i18n = a, this.srPanel.setAriaProps({
                "aria-relevant": "additions text"
            });
        }
        return wg(e, [
            {
                key: "update",
                value: function(e) {
                    var t = e.minutes, r = e.seconds;
                    if ("-" !== t && "-" !== r) {
                        var a = "string" == typeof t ? ZC(t, 10) : t, n = "string" == typeof r ? ZC(r, 10) : r;
                        this.timeLeft = {
                            minutes: a,
                            seconds: n
                        }, a > 5 && this.timeout !== this.LONG_TIMEOUT && (this.timeout = this.LONG_TIMEOUT, this.setInterval(this.timeout)), a >= 1 && a <= 5 && this.timeout !== this.MID_TIMEOUT && (this.timeout = this.MID_TIMEOUT, this.setInterval(this.timeout)), a < 1 && n > 0 && this.timeout !== this.SHORT_TIMEOUT && (this.timeout = this.SHORT_TIMEOUT, this.setInterval(this.timeout));
                    }
                }
            },
            {
                key: "tearDown",
                value: function() {
                    this.clearInterval(), this.srPanel.setAriaProps({
                        "aria-relevant": this.srPanel.constructor.defaultProps.ariaAttributes["aria-relevant"]
                    }), this.srPanel.setMessages(null);
                }
            },
            {
                key: "setInterval",
                value: function(e) {
                    function t(t) {
                        return e.apply(this, arguments);
                    }
                    return t.toString = function() {
                        return e.toString();
                    }, t;
                }(function(e) {
                    var t = this;
                    this.clearInterval();
                    var r = function() {
                        t.srPanel.setMessages(null), t.srPanel.setMessages(t.getSrMessages(t.timeLeft));
                    };
                    r(), this.srInterval = pQ(r, e);
                })
            },
            {
                key: "getSrMessages",
                value: function(e) {
                    var t, r = e.minutes, a = e.seconds, n = this.i18n.get(this.TRANSLATION_KEY), o = hC(t = [
                        r,
                        a
                    ]).call(t, function(e) {
                        return 0 !== e ? function(t) {
                            var r;
                            return wb(r = "".concat(e, " ")).call(r, t);
                        } : function() {
                            return "";
                        };
                    });
                    return [
                        IC(n, o).join("")
                    ];
                }
            },
            {
                key: "clearInterval",
                value: function(e) {
                    function t() {
                        return e.apply(this, arguments);
                    }
                    return t.toString = function() {
                        return e.toString();
                    }, t;
                }(function() {
                    this.srInterval && clearInterval(this.srInterval);
                })
            }
        ]), e;
    }(), AQ = function(e) {
        var t = sw().i18n, r = QO().srPanel, a = qP(null);
        KP(function() {
            return a.current = new wQ({
                i18n: t,
                srPanel: r
            }), function() {
                a.current.tearDown();
            };
        }, []), KP(function() {
            try {
                if (!a.current) return;
                a.current.update(e);
            } catch (e) {
                throw a.current.tearDown(), a.current = null, e;
            }
        }, [
            e
        ]);
    }, SQ = function(e) {
        var t = 6e4 * e, r = (new Date).getTime();
        return {
            startTime: new Date(r),
            endTime: new Date(r + t)
        };
    };
    function IQ(e) {
        var t = e.minutesFromNow, r = e.onTick, a = void 0 === r ? function() {} : r, n = e.onCompleted, o = void 0 === n ? function() {} : n, i = qP(SQ(t)).current, l = i.startTime, s = i.endTime, c = Vk(VP({
            minutes: "-",
            seconds: "-"
        }), 2), u = c[0], d = c[1];
        return AQ(u), KP(function() {
            var e = pQ(function() {
                var e = PQ(l, s), t = e.minutes, r = e.seconds, n = e.percentage;
                if (e.completed) o();
                else {
                    var i = {
                        minutes: t,
                        seconds: r,
                        percentage: n
                    };
                    d(i), a(i);
                }
            }, 1e3);
            return function() {
                clearInterval(e);
            };
        }, []), nN("span", {
            className: "adyen-checkout__countdown",
            role: "timer"
        }, nN("span", {
            className: "countdown__minutes"
        }, u.minutes), nN("span", {
            className: "countdown__separator"
        }, ":"), nN("span", {
            className: "countdown__seconds"
        }, u.seconds));
    }
    function EQ(e, t, r, a) {
        if (!e || !t) throw new Error("Could not check the payment status");
        return zT({
            loadingContext: r,
            path: "services/PaymentInitiation/v1/status?clientKey=".concat(t),
            timeout: a
        }, {
            paymentData: e
        });
    }
    function DQ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function RQ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = DQ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = DQ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var FQ = function(e) {
        switch(e.resultCode.toLowerCase()){
            case "refused":
            case "error":
            case "cancelled":
                return {
                    type: "error",
                    props: RQ(RQ({}, e), {}, {
                        message: "error.subtitle.refused"
                    })
                };
            case "unknown":
                return {
                    type: "error",
                    props: RQ(RQ({}, e), {}, {
                        message: "error.message.unknown"
                    })
                };
            case "pending":
            case "received":
                return {
                    type: e.resultCode.toLowerCase(),
                    props: e
                };
            default:
                return {
                    type: "success",
                    props: e
                };
        }
    }, xQ = function(e) {
        if (!e.type && e.resultCode) return FQ(e);
        if (!e.type) return {
            type: "error",
            props: e
        };
        switch(e.type.toLowerCase()){
            case "pending":
                return {
                    type: "pending",
                    props: e
                };
            case "complete":
                return FQ(e);
            default:
                return {
                    type: "error",
                    props: e
                };
        }
    }, TQ = function(e) {
        var t = QO().srPanel;
        KP(function() {
            return t.setAriaProps({
                "aria-relevant": "additions text"
            }), function() {
                t.setMessages(null), t.setAriaProps({
                    "aria-relevant": t.constructor.defaultProps.ariaAttributes["aria-relevant"]
                });
            };
        }, []), KP(function() {
            t.setMessages(e);
        }, [
            e
        ]);
    };
    function zQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var OQ = function(e) {
        U_(r, e);
        var t = zQ(r);
        function r(e) {
            var a;
            return Cg(this, r), Ag(L_(a = t.call(this, e)), "timeoutId", void 0), Ag(L_(a), "redirectToApp", function(e) {
                window.location.assign(e);
            }), Ag(L_(a), "statusInterval", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                if (!a.state.expired && !a.state.completed) {
                    a.setState(function(t) {
                        return {
                            timePassed: t.timePassed + a.props.delay + e
                        };
                    });
                    var t = a.state.timePassed >= a.props.throttleTime ? a.props.throttledInterval : a.state.delay;
                    a.pollStatus(t);
                }
            }), Ag(L_(a), "onTick", function(e) {
                a.setState({
                    percentage: e.percentage
                });
            }), Ag(L_(a), "onTimeUp", function() {
                a.setState({
                    expired: !0
                }), clearTimeout(a.timeoutId), a.props.onError(new LS("ERROR", "Payment Expired"));
            }), Ag(L_(a), "onComplete", function(e) {
                clearTimeout(a.timeoutId), a.setState({
                    completed: !0,
                    loading: !1
                });
                var t = {
                    data: {
                        details: {
                            payload: e.props.payload
                        },
                        paymentData: a.props.paymentData
                    }
                };
                a.props.onComplete(t, L_(a));
            }), Ag(L_(a), "onError", function(e) {
                if (clearTimeout(a.timeoutId), a.setState({
                    expired: !0,
                    loading: !1
                }), e.props.payload) {
                    var t = {
                        data: {
                            details: {
                                payload: e.props.payload
                            },
                            paymentData: a.props.paymentData
                        }
                    };
                    a.props.onComplete(t, L_(a));
                }
                var r = new LS("ERROR", "error result with no payload in response");
                return a.props.onError(r);
            }), Ag(L_(a), "checkStatus", function() {
                var e = a.props;
                return EQ(e.paymentData, e.clientKey, e.loadingContext, e.throttledInterval).then(xQ).catch(function(e) {
                    return {
                        type: "network-error",
                        props: e
                    };
                }).then(function(e) {
                    switch(e.type){
                        case "success":
                            a.onComplete(e);
                            break;
                        case "error":
                            a.onError(e);
                            break;
                        default:
                            a.setState({
                                loading: !1
                            });
                    }
                    return e;
                });
            }), a.state = {
                buttonStatus: "default",
                completed: !1,
                delay: e.delay,
                expired: !1,
                loading: !0,
                percentage: 100,
                timePassed: 0
            }, a;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.statusInterval();
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    clearTimeout(this.timeoutId);
                }
            },
            {
                key: "pollStatus",
                value: function(e) {
                    var t = this;
                    clearTimeout(this.timeoutId), this.timeoutId = NP(Jd(Dy.mark(function e() {
                        var r, a;
                        return Dy.wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    return r = performance.now(), e.next = 3, t.checkStatus();
                                case 3:
                                    a = performance.now(), t.statusInterval(Math.round(a - r));
                                case 5:
                                case "end":
                                    return e.stop();
                            }
                        }, e);
                    })), e);
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r, a, n, o, i, l, s = this, c = e.amount, u = e.url, d = e.brandLogo, p = e.brandName, m = e.countdownTime, f = e.type, h = e.onActionHandled, v = t.expired, y = t.completed, g = t.loading, b = sw(), k = b.i18n, C = b.loadingContext, _ = II(), N = this.props.qrCodeData ? wb(r = wb(a = "".concat(C)).call(a, "barcode.shtml?barcodeType=qrCode&fileType=png&data=")).call(r, this.props.qrCodeData) : this.props.qrCodeImage, P = function(e, t) {
                        var r = k.get(t);
                        return TQ(r), nN("div", {
                            className: "adyen-checkout__qr-loader adyen-checkout__qr-loader--result"
                        }, nN("img", {
                            className: "adyen-checkout__qr-loader__icon adyen-checkout__qr-loader__icon--result",
                            src: _({
                                imageFolder: "components/"
                            })(e),
                            alt: r
                        }), nN("div", {
                            className: "adyen-checkout__qr-loader__subtitle adyen-checkout__qr-loader__subtitle--result"
                        }, r));
                    };
                    if (v) return P("error", "error.subtitle.payment");
                    if (y) return P("success", "creditCard.success");
                    if (g) return nN("div", {
                        className: "adyen-checkout__qr-loader"
                    }, d && nN("img", {
                        alt: p,
                        src: d,
                        className: "adyen-checkout__qr-loader__brand-logo"
                    }), nN(RP, null));
                    var w, A = k.get(this.props.timeToPay).split("%@"), S = (w = qP(null), KP(function() {
                        var e;
                        null === (e = w.current) || void 0 === e || e.focus();
                    }, []), w);
                    return nN("div", {
                        className: wb(n = "\n                    adyen-checkout__qr-loader\n                    adyen-checkout__qr-loader--".concat(f, "\n                    ")).call(n, hC(o = this.props.classNameModifiers).call(o, function(e) {
                            return "adyen-checkout__qr-loader--".concat(e);
                        }), "\n                ")
                    }, d && nN("img", {
                        src: d,
                        alt: p,
                        className: "adyen-checkout__qr-loader__brand-logo"
                    }), c && c.value && c.currency && nN("div", {
                        className: "adyen-checkout__qr-loader__payment_amount"
                    }, k.amount(c.value, c.currency)), u && nN("div", {
                        className: "adyen-checkout__qr-loader__app-link"
                    }, this.props.redirectIntroduction && nN("div", {
                        className: "adyen-checkout__qr-loader__subtitle"
                    }, k.get(this.props.redirectIntroduction)), nN(uw, {
                        classNameModifiers: [
                            "qr-loader"
                        ],
                        onClick: function() {
                            return s.redirectToApp(u);
                        },
                        label: k.get(this.props.buttonLabel)
                    }), nN(MB, null)), nN("div", {
                        ref: S,
                        tabIndex: 0,
                        className: "adyen-checkout__qr-loader__subtitle"
                    }, k.get(this.props.introduction)), nN("img", {
                        src: N,
                        alt: k.get("wechatpay.scanqrcode"),
                        onLoad: function() {
                            null == h || h({
                                componentType: s.props.type,
                                actionDescription: "qr-code-loaded"
                            });
                        }
                    }), nN("div", {
                        className: "adyen-checkout__qr-loader__progress"
                    }, nN("span", {
                        className: "adyen-checkout__qr-loader__percentage",
                        style: {
                            width: "".concat(this.state.percentage, "%")
                        }
                    })), nN("div", {
                        className: "adyen-checkout__qr-loader__countdown"
                    }, A[0], "\xa0", nN(IQ, {
                        minutesFromNow: m,
                        onTick: this.onTick,
                        onCompleted: this.onTimeUp
                    }), "\xa0", A[1]), "string" == typeof this.props.instructions ? nN("div", {
                        className: "adyen-checkout__qr-loader__instructions"
                    }, k.get(this.props.instructions)) : null === (i = (l = this.props).instructions) || void 0 === i ? void 0 : i.call(l), this.props.copyBtn && nN("div", {
                        className: "adyen-checkout__qr-loader__actions"
                    }, nN(uw, {
                        inline: !0,
                        variant: "action",
                        onClick: function(e, t) {
                            var r = t.complete;
                            nG(s.props.qrCodeData), s.props.onSubmitAnalytics({
                                type: KN,
                                target: "qr_download_button"
                            }), r();
                        },
                        icon: _({
                            imageFolder: "components/"
                        })("copy"),
                        label: k.get("button.copy")
                    })));
                }
            }
        ]), r;
    }(lN);
    function jQ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function BQ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = jQ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = jQ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function MQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(OQ, "defaultProps", {
        delay: 2e3,
        countdownTime: 15,
        onError: function() {},
        onComplete: function() {},
        throttleTime: 6e4,
        classNameModifiers: [],
        throttledInterval: 1e4,
        introduction: "wechatpay.scanqrcode",
        timeToPay: "wechatpay.timetopay",
        buttonLabel: "openApp"
    });
    var LQ = function(e) {
        U_(r, e);
        var t = MQ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatData",
                value: function() {
                    return {
                        paymentMethod: BQ({
                            type: this.props.type || this.constructor.type
                        }, this.state.data)
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "renderQRCode",
                value: function() {
                    var e = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(_j, {
                        srPanel: this.props.modules.srPanel
                    }, nN(OQ, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, {
                        type: this.constructor.type,
                        brandLogo: this.props.brandLogo || this.icon,
                        delay: this.props.delay,
                        onComplete: this.onComplete,
                        countdownTime: this.props.countdownTime,
                        instructions: this.props.instructions,
                        onActionHandled: this.props.onActionHandled,
                        brandName: this.displayName,
                        onSubmitAnalytics: this.submitAnalytics
                    }))));
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.paymentData ? this.renderQRCode() : this.props.showPayButton ? nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(dV, {
                        name: this.displayName,
                        onSubmit: this.submit,
                        payButton: this.payButton,
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    })) : null;
                }
            }
        ]), r;
    }(qS);
    Ag(LQ, "defaultProps", {
        qrCodeImage: "",
        amount: null,
        paymentData: null,
        onError: function() {},
        onComplete: function() {},
        onActionHandled: function() {}
    });
    function VQ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function UQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var KQ = function(e) {
        U_(r, e);
        var t = UQ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Sg(r = VQ(Object(n), !0)).call(r, function(t) {
                                Ag(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Sg(a = VQ(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        delay: 2e3,
                        countdownTime: 15
                    }, kI(H_(r.prototype), "formatProps", this).call(this, e));
                }
            }
        ]), r;
    }(LQ);
    Ag(KQ, "type", "wechatpayQR"), Ag(KQ, "analyticsType", "wechatpayQR");
    function HQ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function qQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var WQ = function(e) {
        U_(r, e);
        var t = qQ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Sg(r = HQ(Object(n), !0)).call(r, function(t) {
                                Ag(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Sg(a = HQ(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        delay: 2e3,
                        countdownTime: 3
                    }, kI(H_(r.prototype), "formatProps", this).call(this, e));
                }
            }
        ]), r;
    }(LQ);
    Ag(WQ, "type", "paynow");
    function GQ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function YQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var QQ = function(e) {
        U_(r, e);
        var t = YQ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Sg(r = GQ(Object(n), !0)).call(r, function(t) {
                                Ag(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Sg(a = GQ(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        delay: 2e3,
                        countdownTime: 15,
                        buttonLabel: window.matchMedia("(max-width: 768px)").matches && /Android|iPhone|iPod/.test(navigator.userAgent) ? "openApp" : "generateQRCode"
                    }, kI(H_(r.prototype), "formatProps", this).call(this, e));
                }
            }
        ]), r;
    }(LQ);
    function ZQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(QQ, "type", "bcmc_mobile");
    var JQ = function(e) {
        U_(r, e);
        var t = ZQ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r);
    }(hV);
    function $Q(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(JQ, "type", "molpay_ebanking_fpx_MY");
    var XQ = function(e) {
        U_(r, e);
        var t = $Q(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r);
    }(hV);
    function eZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(XQ, "type", "molpay_ebanking_TH");
    var tZ = function(e) {
        U_(r, e);
        var t = eZ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r);
    }(hV);
    function rZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function aZ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = rZ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = rZ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function nZ(e) {
        var t, r, a = sw().i18n, n = II(), o = function() {
            var t = [
                "dragonpay_ebanking",
                "dragonpay_otc_banking",
                "dragonpay_otc_non_banking"
            ];
            return Kk(t).call(t, e.type) > -1;
        }, i = _D({
            schema: wb(t = []).call(t, Uk(o() ? [
                "issuer"
            ] : []), [
                "shopperEmail"
            ]),
            rules: {
                issuer: {
                    validate: function(e) {
                        return o() && !!e;
                    },
                    modes: [
                        "input",
                        "blur"
                    ]
                },
                shopperEmail: HD.shopperEmail
            }
        }), l = i.handleChangeFor, s = i.triggerValidation, c = i.data, u = i.valid, d = i.errors, p = i.isValid, m = lV({}, e.type, n), f = hC(r = e.items).call(r, function(e) {
            return aZ(aZ({}, e), {}, {
                icon: m(e.id && e.id.toLowerCase())
            });
        }), h = function(e) {
            return "dragonpay_otc_non_banking" === e ? "dragonpay.voucher.non.bank.selectField.placeholder" : "dragonpay.voucher.bank.selectField.placeholder";
        };
        KP(function() {
            e.onChange({
                isValid: p,
                data: c,
                valid: u,
                errors: d
            });
        }, [
            p,
            c,
            u,
            d
        ]);
        var v = Vk(VP("ready"), 2), y = v[0], g = v[1];
        return this.setStatus = g, this.showValidation = s, nN("div", {
            className: "adyen-checkout__dragonpay-input__field"
        }, nN(FE, {
            label: a.get("shopperEmail"),
            errorMessage: !!d.shopperEmail,
            name: "dragonpay-shopperEmail"
        }, nN(dR, {
            name: "dragonpay-shopperEmail",
            autoCorrect: "off",
            value: c.shopperEmail,
            className: "adyen-checkout__input--large",
            spellCheck: !1,
            onInput: l("shopperEmail", "input"),
            onBlur: l("shopperEmail", "blur")
        })), o() && nN(FE, {
            label: a.get(h(e.type)),
            errorMessage: !!d.issuer,
            name: "issuer"
        }, nN(cz, {
            items: f,
            selectedValue: c.issuer,
            placeholder: a.get(h(e.type)),
            name: "issuer",
            className: "adyen-checkout__dropdown--large adyen-checkout__issuer-list__dropdown",
            onChange: l("issuer")
        })), e.showPayButton && e.payButton({
            status: y,
            label: a.get("confirmPurchase")
        }));
    }
    function oZ(e) {
        var t = e.reference, r = e.totalAmount, a = e.surcharge, n = e.expiresAt, o = e.alternativeReference, i = e.instructionsUrl, l = e.icon, s = e.issuer, c = e.paymentMethodType, u = sw().i18n, d = II(), p = "dragonpay_otc_philippines" !== c ? lV({}, c, d)(s.toLowerCase()) : null;
        return nN(iG, {
            reference: t,
            paymentMethodType: c,
            introduction: u.get("voucher.introduction"),
            imageUrl: l,
            issuerImageUrl: p,
            instructionsUrl: i,
            amount: r && u.amount(r.value, r.currency),
            surcharge: a && u.amount(a.value, a.currency),
            voucherDetails: [
                {
                    label: u.get("voucher.expirationDate"),
                    value: u.dateTime(n)
                },
                {
                    label: u.get("voucher.alternativeReference"),
                    value: o
                }
            ],
            copyBtn: !0
        });
    }
    function iZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function lZ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = iZ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = iZ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function sZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(tZ, "type", "molpay_ebanking_VN"), nZ.defaultProps = {
        data: {},
        items: [],
        onChange: function() {}
    };
    var cZ = function(e) {
        U_(r, e);
        var t = sZ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.state.data, t = e.issuer, a = e.shopperEmail;
                    return lZ(lZ({}, a && {
                        shopperEmail: a
                    }), {}, {
                        paymentMethod: lZ(lZ({}, t && {
                            issuer: t
                        }), {}, {
                            type: this.props.type || r.type
                        })
                    });
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    var t, r;
                    return lZ(lZ({}, e), {}, {
                        issuers: null !== (t = null === (r = e.details) || void 0 === r || null === (r = zb(r).call(r, function(e) {
                            return "issuer" === e.key;
                        })) || void 0 === r ? void 0 : r.items) && void 0 !== t ? t : e.issuers
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.reference ? nN(oZ, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        },
                        icon: this.icon
                    }, this.props)) : nN(nZ, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        },
                        items: this.props.issuers
                    }, this.props, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(qS);
    function uZ(e) {
        var t, r = qP(null), a = sw().i18n, n = Vk(VP("ready"), 2), o = n[0], i = n[1], l = qP({});
        Ty(l.current).length || null === (t = e.setComponentRef) || void 0 === t || t.call(e, l.current);
        return l.current.showValidation = function() {
            var e;
            null === (e = r.current) || void 0 === e || e.showValidation();
        }, l.current.setStatus = i, nN("div", {
            className: "adyen-checkout__doku-input__field"
        }, e.showFormInstruction && nN(iO, null), nN(vR, {
            data: e.data,
            requiredFields: [
                "firstName",
                "lastName",
                "shopperEmail"
            ],
            onChange: e.onChange,
            namePrefix: "doku",
            setComponentRef: function(e) {
                r.current = e;
            }
        }), e.showPayButton && e.payButton({
            status: o,
            label: a.get("confirmPurchase")
        }));
    }
    Ag(cZ, "type", "dragonpay");
    var dZ = function(e) {
        var t = e.reference, r = e.expiresAt, a = e.instructionsUrl, n = e.shopperName, o = e.merchantName, i = e.totalAmount, l = e.paymentMethodType, s = sw().i18n, c = II();
        return nN(iG, {
            paymentMethodType: l,
            reference: t,
            introduction: s.get("voucher.introduction.doku"),
            imageUrl: c()(l),
            instructionsUrl: a,
            amount: i && s.amount(i.value, i.currency),
            voucherDetails: [
                {
                    label: s.get("voucher.expirationDate"),
                    value: s.date(r)
                },
                {
                    label: s.get("voucher.shopperName"),
                    value: n
                },
                {
                    label: s.get("voucher.merchantName"),
                    value: o
                }
            ],
            copyBtn: !0
        });
    };
    function pZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function mZ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = pZ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = pZ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function fZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var hZ = function(e) {
        U_(r, e);
        var t = fZ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "formatData",
                value: function() {
                    return mZ(mZ({}, this.state.data), {}, {
                        paymentMethod: {
                            type: this.props.type || r.type
                        }
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.reference ? nN(dZ, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props)) : nN(uZ, M_({
                        setComponentRef: this.setComponentRef
                    }, this.props, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(qS);
    Ag(hZ, "type", "doku"), Ag(hZ, "defaultProps", {
        showFormInstruction: !0
    });
    var vZ = {
        socialSecurityNumber: {
            validate: vK,
            errorMessage: "error.va.gen.02",
            modes: [
                "blur"
            ]
        },
        shopperEmail: HD.shopperEmail,
        default: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "error.va.gen.02",
            modes: [
                "blur"
            ]
        },
        firstName: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "firstName.invalid",
            modes: [
                "blur"
            ]
        },
        lastName: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "lastName.invalid",
            modes: [
                "blur"
            ]
        }
    }, yZ = {
        socialSecurityNumber: function(e) {
            return hK(e);
        }
    };
    function gZ(e) {
        var t = e.errors, r = e.value, a = e.onInput, n = e.onBlur, o = sw().i18n, i = Vk(VP(!1), 2), l = i[0], s = i[1];
        return nN("div", {
            className: DP("adyen-checkout__fieldset", "adyen-checkout__fieldset--sendCopyToEmail", e.classNames)
        }, nN(FE, {
            classNameModifiers: [
                "sendCopyToEmail"
            ],
            name: "sendCopyToEmail",
            useLabelElement: !1,
            addContextualElement: !1
        }, nN(Bz, {
            onChange: function(t) {
                s(t.target.checked), e.onToggle(l);
            },
            label: o.get("boleto.sendCopyToEmail"),
            name: "sendCopyToEmail"
        })), l && nN(FE, {
            label: o.get("shopperEmail"),
            classNameModifiers: [
                "shopperEmail"
            ],
            errorMessage: t && t.errorMessage ? o.get(t.errorMessage) : !!t,
            name: "shopperEmail"
        }, nN(dR, {
            name: "shopperEmail",
            autoCorrect: "off",
            spellCheck: !1,
            value: r,
            onInput: a,
            onBlur: n
        })));
    }
    function bZ(e) {
        var t = e.i18n, r = e.data, a = e.handleChangeFor, n = e.errors, o = e.valid, i = function(e) {
            return e && e.errorMessage ? t.get(e.errorMessage) : !!e;
        };
        return nN("div", {
            className: "adyen-checkout__fieldset adyen-checkout__fieldset--address adyen-checkout__fieldset--personalDetails"
        }, nN("div", {
            className: "adyen-checkout__fieldset__title"
        }, t.get("personalDetails")), nN("div", {
            className: "adyen-checkout__fieldset__fields"
        }, nN(FE, {
            label: t.get("firstName"),
            classNameModifiers: [
                "firstName",
                "col-50"
            ],
            errorMessage: i(n.firstName),
            name: "firstName"
        }, nN(FD, {
            name: "firstName",
            autocorrect: "off",
            spellcheck: !1,
            value: r.firstName,
            onInput: a("firstName", "input"),
            onBlur: a("firstName", "blur")
        })), nN(FE, {
            label: t.get("lastName"),
            classNameModifiers: [
                "lastName",
                "col-50"
            ],
            errorMessage: i(n.lastName),
            name: "lastName"
        }, nN(FD, {
            name: "lastName",
            autocorrect: "off",
            spellcheck: !1,
            value: r.lastName,
            onInput: a("lastName", "input"),
            onBlur: a("lastName", "blur")
        })), nN(sH, {
            data: r.socialSecurityNumber,
            error: n.socialSecurityNumber,
            valid: o.socialSecurityNumber,
            onInput: a("socialSecurityNumber", "input"),
            onBlur: a("socialSecurityNumber", "blur")
        })));
    }
    function kZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function CZ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = kZ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = kZ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function _Z(e) {
        var t = sw().i18n, r = qP(null), a = _D({
            schema: [
                "firstName",
                "lastName",
                "socialSecurityNumber",
                "billingAddress",
                "shopperEmail"
            ],
            defaultData: e.data,
            rules: vZ,
            formatters: yZ
        }), n = a.handleChangeFor, o = a.triggerValidation, i = a.setSchema, l = a.setData, s = a.setValid, c = a.setErrors, u = a.data, d = a.valid, p = a.errors, m = a.isValid, f = Vk(VP(!1), 2), h = f[0], v = f[1];
        KP(function() {
            var t, r = wb(t = []).call(t, Uk(e.personalDetailsRequired ? [
                "firstName",
                "lastName",
                "socialSecurityNumber"
            ] : []), Uk(e.billingAddressRequired ? [
                "billingAddress"
            ] : []), Uk(h ? [
                "shopperEmail"
            ] : []));
            i(r);
        }, [
            h,
            e.personalDetailsRequired,
            e.billingAddressRequired
        ]);
        var y, g = Vk(VP("ready"), 2), b = g[0], k = g[1], C = qP({});
        Ty(C.current).length || null === (y = e.setComponentRef) || void 0 === y || y.call(e, C.current);
        C.current.showValidation = function() {
            o(), e.billingAddressRequired && r.current.showValidation();
        }, C.current.setStatus = k, KP(function() {
            var t = !e.billingAddressRequired || Boolean(d.billingAddress);
            e.onChange({
                data: u,
                valid: d,
                errors: p,
                isValid: m && t
            });
        }, [
            u,
            d,
            p
        ]);
        var _ = Uk(e.personalDetailsRequired || e.billingAddressRequired || e.showEmailAddress ? [] : [
            "standalone"
        ]);
        return nN("div", {
            className: "adyen-checkout__boleto-input__field"
        }, e.showFormInstruction && (e.personalDetailsRequired || e.billingAddressRequired) && nN(iO, null), e.personalDetailsRequired && nN(bZ, {
            i18n: t,
            data: u,
            handleChangeFor: n,
            errors: p,
            valid: d
        }), e.billingAddressRequired && nN(zz, {
            allowedCountries: [
                "BR"
            ],
            label: "billingAddress",
            data: CZ(CZ({}, e.data.billingAddress), {}, {
                country: "BR"
            }),
            onChange: function(e) {
                l("billingAddress", e.data), s("billingAddress", e.isValid), c("billingAddress", e.errors);
            },
            requiredFields: [
                "country",
                "street",
                "houseNumberOrName",
                "postalCode",
                "city",
                "stateOrProvince"
            ],
            setComponentRef: function(e) {
                r.current = e;
            }
        }), e.showEmailAddress && nN(gZ, {
            value: u.shopperEmail,
            errors: p.shopperEmail,
            onToggle: function() {
                return v(!h);
            },
            onInput: n("shopperEmail", "input"),
            onBlur: n("shopperEmail", "blur")
        }), e.showPayButton && e.payButton({
            status: b,
            label: t.get("boletobancario.btnLabel"),
            classNameModifiers: _
        }));
    }
    _Z.defaultProps = {
        data: {},
        showEmailAddress: !0,
        personalDetailsRequired: !0,
        billingAddressRequired: !0,
        showFormInstruction: !0
    };
    var NZ = function(e) {
        var t, r = sw(), a = r.i18n, n = r.loadingContext, o = II(), i = e.reference, l = e.expiresAt, s = e.totalAmount, c = e.paymentMethodType, u = e.downloadUrl, d = i.replace(/[^\d]/g, "").replace(/^(\d{4})(\d{5})\d{1}(\d{10})\d{1}(\d{10})\d{1}(\d{15})$/, "$1$5$2$3$4");
        return nN(iG, {
            reference: i,
            paymentMethodType: "boletobancario",
            barcode: wb(t = "".concat(n, "barcode.shtml?data=")).call(t, d, "&barcodeType=BT_Int2of5A&fileType=png"),
            introduction: a.get("voucher.introduction"),
            imageUrl: o()(c),
            amount: s && a.amount(s.value, s.currency),
            voucherDetails: [
                {
                    label: a.get("voucher.expirationDate"),
                    value: a.date(l)
                }
            ],
            downloadUrl: u,
            copyBtn: !0
        });
    };
    function PZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function wZ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = PZ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = PZ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function AZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var SZ = function(e) {
        U_(r, e);
        var t = AZ(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "handleRef", function(e) {
                a.componentRef = e;
            }), a;
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.state.data, t = void 0 === e ? {} : e, a = t.billingAddress, n = t.shopperEmail, o = t.firstName, i = t.lastName, l = t.socialSecurityNumber, s = void 0 === l ? "" : l;
                    return wZ(wZ(wZ(wZ({
                        paymentMethod: {
                            type: this.props.type || r.type
                        }
                    }, a && {
                        billingAddress: a
                    }), n && {
                        shopperEmail: n
                    }), o && i && {
                        shopperName: {
                            firstName: o,
                            lastName: i
                        }
                    }), s && {
                        socialSecurityNumber: fK(s)
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.reference ? nN(NZ, M_({
                        ref: this.handleRef,
                        icon: this.icon
                    }, this.props)) : nN(_Z, M_({
                        setComponentRef: this.handleRef
                    }, this.props, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(qS);
    Ag(SZ, "type", "boletobancario");
    var IZ = function(e) {
        var t, r, a = sw(), n = a.i18n, o = a.loadingContext, i = II(), l = e.alternativeReference, s = e.reference, c = e.expiresAt, u = e.merchantReference, d = e.totalAmount, p = e.paymentMethodType, m = e.downloadUrl, f = wb(t = "".concat(o, "barcode.shtml?data=")).call(t, s, "&barcodeType=BT_Code128C&fileType=png"), h = wb(r = []).call(r, Uk(c ? [
            {
                label: n.get("voucher.expirationDate"),
                value: n.date(c)
            }
        ] : []), Uk(u ? [
            {
                label: n.get("voucher.shopperReference"),
                value: u
            }
        ] : []), Uk(l ? [
            {
                label: n.get("voucher.alternativeReference"),
                value: l
            }
        ] : []));
        return nN(iG, {
            amount: d && n.amount(d.value, d.currency),
            barcode: f,
            copyBtn: !0,
            downloadUrl: m,
            imageUrl: i()(p),
            introduction: n.get("voucher.introduction"),
            paymentMethodType: "oxxo",
            reference: s,
            voucherDetails: h
        });
    };
    function EZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function DZ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = EZ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = EZ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function RZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var FZ = function(e) {
        U_(r, e);
        var t = RZ(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "handleRef", function(e) {
                a.componentRef = e;
            }), a;
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "formatData",
                value: function() {
                    return {
                        paymentMethod: {
                            type: this.props.type || r.type
                        }
                    };
                }
            },
            {
                key: "render",
                value: function() {
                    var e;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.reference ? nN(IZ, M_({
                        ref: this.handleRef
                    }, this.props)) : this.props.showPayButton && this.payButton(DZ(DZ({}, this.props), {}, {
                        classNameModifiers: [
                            "standalone"
                        ],
                        label: wb(e = "".concat(this.props.i18n.get("continueTo"), " ")).call(e, this.props.name),
                        onClick: this.submit
                    })));
                }
            }
        ]), r;
    }(qS);
    Ag(FZ, "type", "oxxo"), Ag(FZ, "defaultProps", {
        showPayButton: !1,
        name: "Oxxo"
    });
    var xZ = function(e) {
        var t, r = sw().i18n, a = II(), n = e.entity, o = e.reference, i = e.expiresAt, l = e.merchantReference, s = e.totalAmount, c = e.paymentMethodType, u = e.downloadUrl, d = wb(t = []).call(t, Uk(n ? [
            {
                label: r.get("voucher.entity"),
                value: n
            }
        ] : []), Uk(i ? [
            {
                label: r.get("voucher.expirationDate"),
                value: r.date(i)
            }
        ] : []), Uk(l ? [
            {
                label: r.get("voucher.shopperReference"),
                value: l
            }
        ] : []));
        return nN(iG, {
            amount: s && r.amount(s.value, s.currency),
            barcode: null,
            copyBtn: !0,
            downloadUrl: u,
            imageUrl: a()(c),
            introduction: r.get("voucher.introduction"),
            paymentMethodType: "multibanco",
            reference: o,
            voucherDetails: d
        });
    };
    function TZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function zZ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = TZ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = TZ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function OZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var jZ = function(e) {
        U_(r, e);
        var t = OZ(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "handleRef", function(e) {
                a.componentRef = e;
            }), a;
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    return zZ(zZ({}, e), {}, {
                        name: e.name || "Multibanco"
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    return {
                        paymentMethod: {
                            type: this.props.type || r.type
                        }
                    };
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.reference ? nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(xZ, M_({
                        ref: this.handleRef
                    }, this.props))) : this.props.showPayButton ? nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(dV, {
                        name: this.displayName,
                        amount: this.props.amount,
                        payButton: this.payButton,
                        onSubmit: this.submit,
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    })) : null;
                }
            }
        ]), r;
    }(qS);
    function BZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(jZ, "type", "multibanco"), Ag(jZ, "defaultProps", {
        showPayButton: !0
    });
    var MZ = function(e) {
        U_(r, e);
        var t = BZ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r);
    }(hV);
    function LZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function VZ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = LZ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = LZ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function UZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(MZ, "type", "dotpay");
    var KZ = function(e) {
        U_(r, e);
        var t = UZ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return VZ(VZ({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1
                    });
                }
            }
        ]), r;
    }(hV);
    function HZ(e) {
        var t = e.children, r = e.classNames, a = void 0 === r ? [] : r, n = e.type, o = void 0 === n ? "error" : n, i = e.icon;
        return nN("div", {
            className: DP("adyen-checkout__alert-message", "adyen-checkout__alert-message--".concat(o), a)
        }, i && nN(DI, {
            className: "adyen-checkout__alert-message__icon",
            type: i
        }), t);
    }
    Ag(KZ, "type", "eps");
    var qZ = [
        "brand",
        "amount",
        "balance",
        "transactionLimit"
    ];
    function WZ(e) {
        e.brand;
        var t = e.amount, r = e.balance, a = e.transactionLimit, n = kg(e, qZ), o = sw().i18n, i = t.value > (null == a ? void 0 : a.value) ? a : t, l = (null == r ? void 0 : r.value) - (null == i ? void 0 : i.value);
        return nN("div", {
            className: "adyen-checkout__giftcard-result"
        }, nN("ul", {
            className: "adyen-checkout__giftcard-result__balance"
        }, nN("li", {
            className: "adyen-checkout__giftcard-result__balance__item"
        }, nN("span", {
            className: "adyen-checkout__giftcard-result__balance__title"
        }, o.get("giftcardBalance")), nN("span", {
            className: "adyen-checkout__giftcard-result__balance__value adyen-checkout__giftcard-result__balance__value--amount"
        }, o.amount(r.value, r.currency))), a && a.value && nN("li", {
            className: "adyen-checkout__giftcard-result__balance__item"
        }, nN("span", {
            className: "adyen-checkout__giftcard-result__balance__title adyen-checkout__giftcard-result__balance__title--transactionLimit"
        }, o.get("giftcardTransactionLimit", {
            values: {
                amount: o.amount(a.value, a.currency)
            }
        })))), this.props.showPayButton && this.props.payButton({
            amount: i,
            status: n.status,
            onClick: n.onSubmit
        }), nN("p", {
            className: "adyen-checkout__giftcard-result__remaining-balance"
        }, o.get("partialPayment.remainingBalance", {
            values: {
                amount: o.amount(l, r.currency)
            }
        })));
    }
    var GZ = function(e) {
        var t, r = e.i18n, a = e.classNameModifiers, n = e.sfpState, o = e.getCardErrorMessage, i = e.focusedElement, l = e.setFocusOn;
        return nN(FE, {
            label: r.get("creditCard.numberField.title"),
            classNameModifiers: wb(t = [
                "number"
            ]).call(t, Uk(a)),
            errorMessage: o(n),
            focused: "encryptedCardNumber" === i,
            onFocusField: function() {
                return l("encryptedCardNumber");
            },
            dir: "ltr",
            name: "encryptedCardNumber",
            errorVisibleToScreenReader: !1
        }, nN(GK, {
            encryptedFieldType: "encryptedCardNumber",
            "data-info": '{"length":"15-32", "maskInterval":4}',
            className: DP({
                "adyen-checkout__input": !0,
                "adyen-checkout__input--large": !0,
                "adyen-checkout__card__cardNumber__input": !0,
                "adyen-checkout__input--error": o(n),
                "adyen-checkout__input--focus": "encryptedCardNumber" === i
            })
        }));
    }, YZ = function(e) {
        var t, r = e.i18n, a = e.classNameModifiers, n = e.sfpState, o = e.focusedElement, i = e.setFocusOn, l = e.label, s = void 0 === l ? r.get("creditCard.pin.title") : l;
        return nN(FE, {
            label: s,
            classNameModifiers: wb(t = [
                "pin"
            ]).call(t, Uk(a)),
            errorMessage: n.errors.encryptedSecurityCode && r.get(n.errors.encryptedSecurityCode),
            focused: "encryptedSecurityCode" === o,
            onFocusField: function() {
                return i("encryptedSecurityCode");
            },
            dir: "ltr",
            name: "encryptedSecurityCode",
            errorVisibleToScreenReader: !1
        }, nN(GK, {
            encryptedFieldType: "encryptedSecurityCode",
            "data-info": '{"length":"3-10", "maskInterval": 0}',
            className: DP({
                "adyen-checkout__input": !0,
                "adyen-checkout__input--large": !0,
                "adyen-checkout__card__cvc__input": !0,
                "adyen-checkout__input--error": n.errors.encryptedSecurityCode,
                "adyen-checkout__input--focus": "encryptedSecurityCode" === o
            })
        }));
    };
    function QZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var ZZ = function(e) {
        U_(r, e);
        var t = QZ(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "state", {
                status: "ready",
                data: {},
                balance: null,
                transactionLimit: null,
                focusedElement: !1,
                isValid: !1
            }), Ag(L_(a), "sfp", void 0), Ag(L_(a), "onChange", function(e) {
                a.props.onChange({
                    data: e.data,
                    isValid: e.isSfpValid
                });
            }), Ag(L_(a), "showValidation", function() {
                a.sfp.showValidation();
            }), Ag(L_(a), "handleFocus", function(e) {
                a.setState({
                    focusedElement: e.currentFocusObject
                }), !0 === e.focus ? a.props.onFocus(e) : a.props.onBlur(e);
            }), Ag(L_(a), "setBalance", function(e) {
                var t = e.balance, r = e.transactionLimit;
                a.setState({
                    balance: t,
                    transactionLimit: r
                });
            }), a;
        }
        return wg(r, [
            {
                key: "setStatus",
                value: function(e) {
                    this.setState({
                        status: e
                    });
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r, a = this, n = t.focusedElement, o = t.balance, i = t.transactionLimit, l = sw().i18n, s = (null == i ? void 0 : i.value) < (null == o ? void 0 : o.value) ? i : o, c = (null == s ? void 0 : s.value) >= (null === (r = this.props.amount) || void 0 === r ? void 0 : r.value);
                    if (s && c) return nN(WZ, M_({
                        balance: o,
                        transactionLimit: i,
                        onSubmit: e.onSubmit
                    }, e));
                    var u = function(e) {
                        if (e.errors.encryptedCardNumber) return l.get(e.errors.encryptedCardNumber);
                        switch(a.state.status){
                            case "no-balance":
                                return l.get("error.giftcard.no-balance");
                            case "card-error":
                                return l.get("error.giftcard.card-error");
                            case "currency-error":
                                return l.get("error.giftcard.currency-error");
                            default:
                                return null;
                        }
                    };
                    return nN("div", {
                        className: "adyen-checkout__giftcard"
                    }, "error" === this.state.status && nN(HZ, {
                        icon: "cross"
                    }, l.get("error.message.unknown")), nN(uK, M_({}, this.props, {
                        ref: function(e) {
                            a.sfp = e;
                        },
                        onChange: this.onChange,
                        onFocus: this.handleFocus,
                        type: VI,
                        render: function(e, t) {
                            var r = e.setRootNode, o = e.setFocusOn;
                            return a.props.fieldsLayoutComponent({
                                i18n: l,
                                pinRequired: a.props.pinRequired,
                                focusedElement: n,
                                getCardErrorMessage: u,
                                setRootNode: r,
                                setFocusOn: o,
                                sfpState: t
                            });
                        }
                    })), this.props.showPayButton && this.props.payButton({
                        status: this.state.status,
                        onClick: this.props.onBalanceCheck,
                        label: l.get("applyGiftcard")
                    }));
                }
            }
        ]), r;
    }(lN);
    function JZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function $Z(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = JZ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = JZ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function XZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(ZZ, "defaultProps", {
        pinRequired: !0,
        expiryDateRequired: !1,
        onChange: function() {},
        onFocus: function() {},
        onBlur: function() {},
        fieldsLayoutComponent: function(e) {
            var t = e.setRootNode, r = e.pinRequired;
            return nN("div", {
                ref: t,
                className: "adyen-checkout__field-wrapper"
            }, nN(GZ, M_({}, e, {
                classNameModifiers: r ? [
                    "70"
                ] : [
                    "100"
                ]
            })), r && nN(YZ, M_({}, e, {
                classNameModifiers: [
                    "30"
                ]
            })));
        }
    });
    var eJ, tJ = function(e) {
        U_(r, e);
        var t = XZ(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "handleBalanceCheck", function(e) {
                return a.props.onBalanceCheck ? new Ab(function(t, r) {
                    a.props.onBalanceCheck(t, r, e);
                }) : a.props.session ? a.props.session.checkBalance(e) : void 0;
            }), Ag(L_(a), "onOrderRequest", function(e) {
                return a.props.onOrderRequest ? new Ab(function(t, r) {
                    a.props.onOrderRequest(t, r, e);
                }) : a.props.session ? a.props.session.createOrder() : void 0;
            }), Ag(L_(a), "handleOrder", function(e) {
                var t = e.order;
                if (a.updateParent({
                    order: t
                }), a.props.session && a.props.onOrderCreated) return a.props.onOrderCreated(t);
            }), Ag(L_(a), "onBalanceCheck", function() {
                return a.props.session || a.props.onBalanceCheck ? a.isValid ? (a.setStatus("loading"), void a.handleBalanceCheck(a.formatData()).then(function(e) {
                    var t, r = e.balance, n = e.transactionLimit, o = void 0 === n ? {} : n;
                    if (!r) throw new Error("card-error");
                    if ((null == r ? void 0 : r.currency) !== (null === (t = a.props.amount) || void 0 === t ? void 0 : t.currency)) throw new Error("currency-error");
                    if ((null == r ? void 0 : r.value) <= 0) throw new Error("no-balance");
                    if (a.componentRef.setBalance({
                        balance: r,
                        transactionLimit: o
                    }), a.props.amount.value > r.value || a.props.amount.value > o.value) return a.props.order ? a.submit() : a.onOrderRequest(a.data).then(function(e) {
                        a.setState({
                            order: {
                                orderData: e.orderData,
                                pspReference: e.pspReference
                            }
                        }), a.submit();
                    });
                    a.props.onRequiringConfirmation && a.props.onRequiringConfirmation();
                }).catch(function(e) {
                    a.setStatus((null == e ? void 0 : e.message) || "error"), a.props.onError && a.handleError(new LS("ERROR", e));
                })) : (a.showValidation(), !1) : a.submit();
            }), Ag(L_(a), "payButton", function(e) {
                return nN(hw, e);
            }), a;
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return $Z($Z({}, null == e ? void 0 : e.configuration), e);
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e, t;
                    return {
                        paymentMethod: {
                            type: this.constructor.type,
                            brand: this.props.brand,
                            encryptedCardNumber: null === (e = this.state.data) || void 0 === e ? void 0 : e.encryptedCardNumber,
                            encryptedSecurityCode: null === (t = this.state.data) || void 0 === t ? void 0 : t.encryptedSecurityCode
                        }
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "icon",
                get: function() {
                    var e;
                    return (null === (e = this.props.brandsConfiguration[this.props.brand]) || void 0 === e ? void 0 : e.icon) || this.props.icon || this.resources.getImage()(this.props.brand);
                }
            },
            {
                key: "displayName",
                get: function() {
                    var e;
                    return (null === (e = this.props.brandsConfiguration[this.props.brand]) || void 0 === e ? void 0 : e.name) || this.props.name;
                }
            },
            {
                key: "balanceCheck",
                value: function() {
                    return this.onBalanceCheck();
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(ZZ, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, {
                        onChange: this.setState,
                        onBalanceCheck: this.onBalanceCheck,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(qS);
    function rJ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(tJ, "type", "giftcard"), Ag(tJ, "defaultProps", {
        brandsConfiguration: {}
    });
    var aJ = function(e) {
        U_(r, e);
        var t = rJ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r);
    }(EW);
    function nJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function oJ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = nJ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = nJ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function iJ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    eJ = aJ, Ag(aJ, "type", "vipps"), Ag(aJ, "defaultProps", {
        type: eJ.type,
        showPayButton: !0,
        name: "Vipps"
    });
    var lJ = function(e) {
        U_(r, e);
        var t = iJ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return oJ(oJ({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1
                    });
                }
            }
        ]), r;
    }(hV);
    function sJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function cJ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = sJ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = sJ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function uJ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(lJ, "type", "payu_IN_cashcard");
    var dJ = function(e) {
        U_(r, e);
        var t = uJ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return cJ(cJ({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1
                    });
                }
            }
        ]), r;
    }(hV);
    Ag(dJ, "type", "payu_IN_nb");
    var pJ = [
        "AT",
        "CH",
        "DE",
        "NL"
    ];
    function mJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function fJ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = mJ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = mJ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function hJ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var vJ = function(e) {
        U_(r, e);
        var t = hJ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return fJ(fJ({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : pJ
                    });
                }
            }
        ]), r;
    }(Aj);
    function yJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function gJ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(vJ, "type", "ratepay");
    var bJ = function(e) {
        U_(r, e);
        var t = gJ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Sg(r = yJ(Object(n), !0)).call(r, function(t) {
                                Ag(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Sg(a = yJ(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        delay: 2e3,
                        countdownTime: 3,
                        instructions: "swish.pendingMessage"
                    }, kI(H_(r.prototype), "formatProps", this).call(this, e));
                }
            }
        ]), r;
    }(LQ);
    Ag(bJ, "type", "swish"), xw("Set", function(e) {
        return function() {
            return e(this, arguments.length ? arguments[0] : void 0);
        };
    }, Zw);
    var kJ = t(ee.Set), CJ = function(e) {
        var t = e.paymentMethodComponent, r = e.isLoaded;
        return t && r ? nN("div", {
            className: "adyen-checkout__payment-method__details__content"
        }, t) : null;
    }, _J = {
        "adyen-checkout__payment-methods-list": "DropinComponent-module_adyen-checkout__payment-methods-list__mAjAm",
        "adyen-checkout__payment-method": "DropinComponent-module_adyen-checkout__payment-method__nWdwg",
        "adyen-checkout__payment-method__details": "DropinComponent-module_adyen-checkout__payment-method__details__-rsW7",
        "adyen-checkout__payment-method__image": "DropinComponent-module_adyen-checkout__payment-method__image__nB80V",
        "adyen-checkout__payment-method__image__wrapper": "DropinComponent-module_adyen-checkout__payment-method__image__wrapper__6NWzA",
        "adyen-checkout__payment-method--selected": "DropinComponent-module_adyen-checkout__payment-method--selected__6egZF"
    }, NJ = [
        "googlepay",
        "paywithgoogle"
    ], PJ = function(e) {
        var t = e.src, r = e.altDescription, a = e.type, n = e.disabled, o = void 0 !== n && n;
        return nN("span", {
            className: DP("adyen-checkout__payment-method__image__wrapper", _J["adyen-checkout__payment-method__image__wrapper"], {
                "adyen-checkout__payment-method__image__wrapper--outline": !kb(NJ).call(NJ, a),
                "adyen-checkout__payment-method__image__wrapper--disabled": !!o
            })
        }, nN(XT, {
            className: "adyen-checkout__payment-method__image ".concat(_J["adyen-checkout__payment-method__image"]),
            src: t,
            alt: r
        }));
    }, wJ = function(e) {
        var t = e.id, r = e.open, a = e.onDisable, n = e.onCancel, o = sw().i18n;
        return nN("div", {
            id: t,
            "aria-hidden": !r,
            className: DP({
                "adyen-checkout__payment-method__disable-confirmation": !0,
                "adyen-checkout__payment-method__disable-confirmation--open": r
            })
        }, nN("div", {
            className: "adyen-checkout__payment-method__disable-confirmation__content"
        }, o.get("storedPaymentMethod.disable.confirmation"), nN("div", {
            className: "adyen-checkout__payment-method__disable-confirmation__buttons"
        }, nN("button", {
            type: "button",
            className: DP("adyen-checkout__button", "adyen-checkout__payment-method__disable-confirmation__button", "adyen-checkout__payment-method__disable-confirmation__button--remove"),
            disabled: !r,
            onClick: a
        }, o.get("storedPaymentMethod.disable.confirmButton")), nN("button", {
            type: "button",
            className: DP("adyen-checkout__button", "adyen-checkout__payment-method__disable-confirmation__button", "adyen-checkout__payment-method__disable-confirmation__button--cancel"),
            disabled: !r,
            onClick: n
        }, o.get("storedPaymentMethod.disable.cancelButton")))));
    }, AJ = function(e) {
        var t = e.allowedBrands;
        if (e.isPaymentMethodSelected) return null;
        var r = function(e) {
            var t = e.length <= 4 ? e : oI(e).call(e, 0, 3);
            return {
                visibleBrands: t,
                leftBrandsAmount: e.length - t.length
            };
        }(t), a = r.visibleBrands, n = r.leftBrandsAmount;
        return nN("span", {
            className: "adyen-checkout__payment-method__brands"
        }, hC(a).call(a, function(e) {
            return nN(PJ, {
                key: e.name,
                altDescription: MK(e.name),
                type: e.name,
                src: e.icon
            });
        }), 0 !== n && nN("span", {
            className: "adyen-checkout__payment-method__brand-number"
        }, "+", n));
    }, SJ = function(e) {
        var t = e.activeBrand, r = e.brands, a = e.excludedUIBrands, n = e.isPaymentMethodSelected, o = e.isCompactView, i = void 0 === o || o, l = xg(r).call(r, function(e) {
            return !(null != a && kb(a).call(a, e.name));
        });
        return i ? nN(AJ, {
            allowedBrands: l,
            isPaymentMethodSelected: n
        }) : nN("span", {
            className: "adyen-checkout__payment-method__brands"
        }, hC(l).call(l, function(e) {
            return nN(PJ, {
                key: e.name,
                altDescription: MK(e.name),
                type: e.name,
                src: e.icon,
                disabled: t && t !== e.name
            });
        }));
    }, IJ = function(e) {
        var t = e.displayName, r = e.additionalInfo, a = e.isSelected;
        return nN("span", {
            className: "adyen-checkout__payment-method__name_wrapper"
        }, nN("span", {
            className: DP({
                "adyen-checkout__payment-method__name": !0,
                "adyen-checkout__payment-method__name--selected": a
            })
        }, t), r && nN("span", {
            className: DP({
                "adyen-checkout__payment-method__additional-info": !0,
                "adyen-checkout__payment-method__additional-info--selected": a
            })
        }, r));
    };
    function EJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function DJ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = EJ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = EJ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function RJ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var FJ = function(e) {
        U_(r, e);
        var t = RJ(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "state", {
                showDisableStoredPaymentMethodConfirmation: !1,
                activeBrand: null
            }), Ag(L_(a), "toggleDisableConfirmation", function() {
                a.setState({
                    showDisableStoredPaymentMethodConfirmation: !a.state.showDisableStoredPaymentMethodConfirmation
                });
            }), Ag(L_(a), "onDisableStoredPaymentMethod", function() {
                a.props.onDisableStoredPaymentMethod(a.props.paymentMethod), a.toggleDisableConfirmation();
            }), Ag(L_(a), "handleOnListItemClick", function() {
                var e = a.props;
                (0, e.onSelect)(e.paymentMethod);
            }), a;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.paymentMethod.eventEmitter.on("brand", function(t) {
                        e.setState({
                            activeBrand: t.brand
                        });
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e = this;
                    this.props.paymentMethod.eventEmitter.off("brand", function(t) {
                        e.setState({
                            activeBrand: t.brand
                        });
                    });
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r, a = e.paymentMethod, n = e.isSelected, o = e.isDisablingPaymentMethod, i = e.isLoaded, l = e.isLoading, s = e.standalone, c = t.activeBrand, u = sw().i18n;
                    if (!a) return null;
                    var d = "card" === a.props.type || "scheme" === a.props.type, p = DP(DJ(DJ(Ag(Ag({
                        "adyen-checkout__payment-method": !0
                    }, _J["adyen-checkout__payment-method"], !0), "adyen-checkout__payment-method--".concat(a.props.type), !0), d && Ag({}, "adyen-checkout__payment-method--".concat(null !== (r = a.props.fundingSource) && void 0 !== r ? r : "credit"), !0)), {}, Ag(Ag(Ag(Ag(Ag(Ag(Ag(Ag({
                        "adyen-checkout__payment-method--selected": n
                    }, _J["adyen-checkout__payment-method--selected"], n), "adyen-checkout__payment-method--loading", l), "adyen-checkout__payment-method--disabling", o), "adyen-checkout__payment-method--confirming", this.state.showDisableStoredPaymentMethodConfirmation), "adyen-checkout__payment-method--standalone", s), _J["adyen-checkout__payment-method--loading"], l), a._id, !0), this.props.className, !0))), m = this.props.showRemovePaymentMethodButton && a.props.oneClick && n, f = "remove-".concat(a._id), h = "container-".concat(a._id), v = "button-".concat(a._id), y = !a.props.oneClick && a.brands && a.brands.length > 0;
                    return nN("li", {
                        key: a._id,
                        className: p,
                        onClick: this.handleOnListItemClick
                    }, nN("div", {
                        className: "adyen-checkout__payment-method__header"
                    }, nN("button", {
                        className: "adyen-checkout__payment-method__header__title",
                        id: v,
                        role: "radio",
                        "aria-checked": n,
                        type: "button"
                    }, nN("span", {
                        className: DP({
                            "adyen-checkout__payment-method__radio": !0,
                            "adyen-checkout__payment-method__radio--selected": n
                        }),
                        "aria-hidden": "true"
                    }), nN(PJ, M_({}, a.props.oneClick && {
                        altDescription: a.props.name
                    }, {
                        type: a.type,
                        src: a.icon
                    })), nN(IJ, {
                        displayName: a.displayName,
                        isSelected: n,
                        additionalInfo: a.additionalInfo
                    })), m && nN("button", {
                        type: "button",
                        className: "adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link",
                        onClick: this.toggleDisableConfirmation,
                        "aria-expanded": this.state.showDisableStoredPaymentMethodConfirmation,
                        "aria-controls": f
                    }, u.get("storedPaymentMethod.disable.button")), y && nN(SJ, {
                        activeBrand: c,
                        brands: a.brands,
                        excludedUIBrands: iE,
                        isPaymentMethodSelected: n,
                        isCompactView: a.props.showBrandsUnderCardNumber
                    })), nN("div", {
                        className: "adyen-checkout__payment-method__details ".concat(_J["adyen-checkout__payment-method__details"]),
                        id: h,
                        role: "region"
                    }, m && nN(wJ, {
                        id: f,
                        open: this.state.showDisableStoredPaymentMethodConfirmation,
                        onDisable: this.onDisableStoredPaymentMethod,
                        onCancel: this.toggleDisableConfirmation
                    }), nN(CJ, {
                        paymentMethodComponent: a.render(),
                        isLoaded: i
                    })));
                }
            }
        ]), r;
    }(lN);
    Ag(FJ, "defaultProps", {
        paymentMethod: null,
        isSelected: !1,
        isLoaded: !1,
        isLoading: !1,
        showDisableStoredPaymentMethodConfirmation: !1
    });
    var xJ = function(e) {
        var t, r = e.order, a = e.orderStatus, n = e.onOrderCancel, o = e.brandLogoConfiguration, i = sw().i18n, l = II();
        return nN("div", null, nN("ul", {
            className: "adyen-checkout__order-payment-methods-list"
        }, null == a || null === (t = a.paymentMethods) || void 0 === t ? void 0 : hC(t).call(t, function(e, t) {
            var a;
            return nN("li", {
                key: wb(a = "".concat(e.type, "-")).call(a, t),
                className: "adyen-checkout__order-payment-method"
            }, nN("div", {
                className: "adyen-checkout__order-payment-method__header"
            }, nN("div", {
                className: "adyen-checkout__payment-method__header__title"
            }, nN(PJ, {
                altDescription: e.name,
                type: e.type,
                src: o[e.type] || l()(e.type)
            }), "\u2022\u2022\u2022\u2022 ", e.lastFour), n && nN("button", {
                type: "button",
                className: "adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link",
                onClick: function() {
                    n({
                        order: r
                    });
                }
            }, i.get("storedPaymentMethod.disable.button"))), nN("div", {
                className: "adyen-checkout__order-payment-method__details"
            }, nN("div", {
                className: "adyen-checkout__order-payment-method__deducted-amount"
            }, nN("div", {
                className: "adyen-checkout__order-payment-method__deducted-amount__label"
            }, i.get("deductedBalance")), nN("div", {
                className: "adyen-checkout__order-payment-method__deducted-amount__value"
            }, i.amount(e.amount.value, e.amount.currency)))));
        })), a.remainingAmount && nN("div", {
            className: "adyen-checkout__order-remaining-amount"
        }, i.get("partialPayment.warning"), " ", nN("strong", null, i.amount(a.remainingAmount.value, a.remainingAmount.currency))));
    };
    function TJ(e) {
        var t = e.paymentMethods, r = e.showContentSeparator, a = sw().i18n;
        return nN(iN, null, nN("ul", {
            className: "adyen-checkout__instant-payment-methods-list"
        }, hC(t).call(t, function(e) {
            return nN("li", {
                key: e.type
            }, e.render());
        })), r && nN(MB, {
            label: a.get("orPayWith")
        }));
    }
    function zJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function OJ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = zJ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = zJ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function jJ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var BJ = function(e) {
        U_(r, e);
        var t = jJ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    if (this.props.paymentMethods[0]) {
                        var e = this.props.paymentMethods[0];
                        (this.props.openFirstStoredPaymentMethod && !0 === DN(e, "props.oneClick") || this.props.openFirstPaymentMethod) && this.props.onSelect(e);
                    }
                }
            },
            {
                key: "render",
                value: function(e) {
                    var t = this, r = e.paymentMethods, a = e.instantPaymentMethods, n = e.activePaymentMethod, o = e.cachedPaymentMethods, i = e.isLoading, l = e.isDisablingPaymentMethod, s = sw().i18n, c = DP(Ag(Ag(Ag({}, _J["adyen-checkout__payment-methods-list"], !0), "adyen-checkout__payment-methods-list", !0), "adyen-checkout__payment-methods-list--loading", i)), u = function(e) {
                        var t = Vk(VP({}), 2), r = t[0], a = t[1];
                        return KP(function() {
                            a(tC(e).call(e, function(e, t) {
                                return OJ(OJ({}, e), t.props.brand && t.icon && Ag({}, t.props.brand, t.icon));
                            }, {}));
                        }, [
                            e
                        ]), r;
                    }(r), d = (null == r ? void 0 : r.length) > 0;
                    return nN(iN, null, this.props.orderStatus && nN(xJ, {
                        order: this.props.order,
                        orderStatus: this.props.orderStatus,
                        onOrderCancel: this.props.onOrderCancel,
                        brandLogoConfiguration: u
                    }), !!a.length && nN(TJ, {
                        showContentSeparator: d,
                        paymentMethods: a
                    }), nN("ul", {
                        className: c,
                        role: "radiogroup",
                        "aria-label": s.get("paymentMethodsList.aria.label"),
                        required: !0
                    }, hC(r).call(r, function(e, a, s) {
                        var c = n && n._id === e._id, u = e._id in o, d = n && s[a + 1] && n._id === s[a + 1]._id;
                        return nN(FJ, {
                            className: DP({
                                "adyen-checkout__payment-method--next-selected": d
                            }),
                            standalone: 1 === r.length,
                            paymentMethod: e,
                            isSelected: c,
                            isDisablingPaymentMethod: c && l,
                            isLoaded: u,
                            isLoading: i,
                            onSelect: t.props.onSelect,
                            key: e._id,
                            showRemovePaymentMethodButton: t.props.showRemovePaymentMethodButton,
                            onDisableStoredPaymentMethod: t.props.onDisableStoredPaymentMethod
                        });
                    })));
                }
            }
        ]), r;
    }(lN);
    Ag(BJ, "defaultProps", {
        instantPaymentMethods: [],
        paymentMethods: [],
        activePaymentMethod: null,
        cachedPaymentMethods: {},
        orderStatus: null,
        onSelect: function() {},
        onDisableStoredPaymentMethod: function() {},
        isDisablingPaymentMethod: !1,
        isLoading: !1
    });
    var MJ = function(e) {
        var t = e.message, r = sw().i18n, a = II(), n = r.get(t || "creditCard.success");
        return TQ(n), nN("div", {
            className: "adyen-checkout__status adyen-checkout__status--success"
        }, nN(XT, {
            height: "88",
            className: "adyen-checkout__status__icon",
            src: a({
                extension: "gif",
                imageFolder: "components/"
            })("success"),
            alt: r.get(t || "creditCard.success")
        }), nN("span", {
            className: "adyen-checkout__status__text"
        }, n));
    }, LJ = function(e) {
        var t = e.message, r = sw().i18n, a = II(), n = r.get(t || "error.message.unknown");
        return TQ(n), nN("div", {
            className: "adyen-checkout__status adyen-checkout__status--error"
        }, nN(XT, {
            className: "adyen-checkout__status__icon",
            src: a({
                extension: "gif",
                imageFolder: "components/"
            })("error"),
            alt: r.get(t || "error.message.unknown"),
            height: "88"
        }), nN("span", {
            className: "adyen-checkout__status__text"
        }, n));
    };
    function VJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function UJ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = VJ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = VJ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function KJ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var HJ = function(e) {
        U_(r, e);
        var t = KJ(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "state", {
                elements: [],
                instantPaymentElements: [],
                orderStatus: null,
                isDisabling: !1,
                status: {
                    type: "loading",
                    props: void 0
                },
                activePaymentMethod: null,
                cachedPaymentMethods: {}
            }), Ag(L_(a), "prepareDropinData", function() {
                var e = a.props, t = e.order, r = e.clientKey, n = e.loadingContext, o = Vk(a.props.onCreateElements(), 3), i = o[0], l = o[1], s = o[2], c = t ? function(e, t) {
                    return zT({
                        path: "v1/order/status?clientKey=".concat(e.clientKey),
                        loadingContext: e.loadingContext
                    }, {
                        orderData: t.orderData
                    });
                }({
                    clientKey: r,
                    loadingContext: n
                }, t) : null;
                Ab.all([
                    i,
                    l,
                    s,
                    c
                ]).then(function(e) {
                    var t, r, n = Vk(e, 4), o = n[0], i = n[1], l = n[2], s = n[3];
                    a.setState({
                        instantPaymentElements: l,
                        elements: wb(t = []).call(t, Uk(o), Uk(i)),
                        orderStatus: s
                    }), a.setStatus("ready"), null === (r = a.props.modules) || void 0 === r || r.analytics.sendAnalytics("dropin", {
                        type: LN
                    });
                }), a.onOrderCancel = a.getOnOrderCancel();
            }), Ag(L_(a), "setStatus", function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                a.setState({
                    status: {
                        type: e,
                        props: t
                    }
                });
            }), Ag(L_(a), "setActivePaymentMethod", function(e) {
                a.setState(function(t) {
                    return {
                        activePaymentMethod: e,
                        cachedPaymentMethods: UJ(UJ({}, t.cachedPaymentMethods), {}, Ag({}, e._id, !0))
                    };
                });
            }), Ag(L_(a), "handleOnSelectPaymentMethod", function(e) {
                var t = a.state.activePaymentMethod;
                a.setActivePaymentMethod(e), (t && t._id !== e._id || !t) && (a.props.onSelect(e), e.submitAnalytics({
                    type: LN
                }));
            }), Ag(L_(a), "handleDisableStoredPaymentMethod", function(e) {
                a.setState({
                    isDisabling: !0
                }), new Ab(function(t, r) {
                    return a.props.onDisableStoredPaymentMethod(e.props.storedPaymentMethodId, t, r);
                }).then(function() {
                    a.setState(function(t) {
                        var r;
                        return {
                            elements: xg(r = t.elements).call(r, function(t) {
                                return t._id !== e._id;
                            })
                        };
                    }), a.setState({
                        isDisabling: !1
                    });
                }).catch(function() {
                    a.setState({
                        isDisabling: !1
                    });
                });
            }), Ag(L_(a), "getOnOrderCancel", function() {
                return a.props.onOrderCancel ? function(e) {
                    a.props.onOrderCancel(e);
                } : a.props.session ? function(e) {
                    return a.props.session.cancelOrder(e).then(function() {
                        return a.props._parentInstance.update({
                            order: null
                        });
                    }).catch(function(e) {
                        return a.setStatus((null == e ? void 0 : e.message) || "error");
                    });
                } : null;
            }), Ag(L_(a), "onOrderCancel", void 0), a;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.prepareDropinData();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, t) {
                    t.status.type !== this.state.status.type && this.state.activePaymentMethod && this.state.activePaymentMethod.setStatus(this.state.status.type), "ready" === this.state.status.type && "ready" !== t.status.type && this.props.onReady && this.props.onReady();
                }
            },
            {
                key: "closeActivePaymentMethod",
                value: function() {
                    this.setState({
                        activePaymentMethod: null
                    });
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r, a, n, o, i = t.elements, l = t.instantPaymentElements, s = t.status, c = t.activePaymentMethod, u = t.cachedPaymentMethods, d = "loading" === s.type, p = "redirect" === s.type, m = (null == i ? void 0 : i.length) > 0 || (null == l ? void 0 : l.length) > 0;
                    switch(s.type){
                        case "success":
                            return nN(MJ, {
                                message: 0 === (null == e || null === (r = e.amount) || void 0 === r ? void 0 : r.value) ? "resultMessages.preauthorized" : null === (a = s.props) || void 0 === a ? void 0 : a.message
                            });
                        case "error":
                            return nN(LJ, {
                                message: null === (n = s.props) || void 0 === n ? void 0 : n.message
                            });
                        case "custom":
                            return null === (o = s.props) || void 0 === o || null === (o = o.component) || void 0 === o ? void 0 : o.render();
                        default:
                            return nN("div", {
                                className: "adyen-checkout__dropin adyen-checkout__dropin--".concat(s.type)
                            }, p && s.props.component && s.props.component.render(), d && s.props && s.props.component && s.props.component.render(), m && nN(BJ, {
                                isLoading: d || p,
                                isDisablingPaymentMethod: this.state.isDisabling,
                                paymentMethods: i,
                                instantPaymentMethods: l,
                                activePaymentMethod: c,
                                cachedPaymentMethods: u,
                                order: this.props.order,
                                orderStatus: this.state.orderStatus,
                                onOrderCancel: this.onOrderCancel,
                                onSelect: this.handleOnSelectPaymentMethod,
                                openFirstPaymentMethod: this.props.openFirstPaymentMethod,
                                openFirstStoredPaymentMethod: this.props.openFirstStoredPaymentMethod,
                                onDisableStoredPaymentMethod: this.handleDisableStoredPaymentMethod,
                                showRemovePaymentMethodButton: this.props.showRemovePaymentMethodButton
                            }));
                    }
                }
            }
        ]), r;
    }(lN);
    var qJ = [
        "androidpay",
        "samsungpay",
        "clicktopay"
    ], WJ = function(e) {
        return !kb(qJ).call(qJ, e.constructor.type);
    }, GJ = function(e) {
        return !!e;
    }, YJ = function(e) {
        if (e.isAvailable) {
            var t = new Ab(function(e, t) {
                return NP(t, 5e3);
            });
            return Ab.race([
                e.isAvailable(),
                t
            ]);
        }
        return Ab.resolve(!!e);
    }, QJ = function() {
        var e, t, r, a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], n = arguments.length > 1 ? arguments[1] : void 0, o = arguments.length > 2 ? arguments[2] : void 0, i = xg(e = xg(t = hC(a).call(a, function(e) {
            return o(e, n);
        })).call(t, GJ)).call(e, WJ), l = hC(r = hC(i).call(i, YJ)).call(r, function(e) {
            return e.catch(function(e) {
                return e;
            });
        });
        return Ab.all(l).then(function(e) {
            return xg(i).call(i, function(t, r) {
                return !0 === e[r];
            });
        });
    };
    function ZJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function JJ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = ZJ(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = ZJ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function $J(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function XJ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = $J(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = $J(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function e$(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function t$(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = e$(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = e$(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function r$(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var a$ = [
        "paywithgoogle",
        "googlepay",
        "applepay"
    ], n$ = function(e) {
        U_(r, e);
        var t = r$(r);
        function r(e) {
            var a, n, o;
            return Cg(this, r), Ag(L_(o = t.call(this, e)), "dropinRef", null), Ag(L_(o), "componentFromAction", void 0), Ag(L_(o), "handleCreate", function() {
                var e = o.props, t = e.paymentMethods, r = e.storedPaymentMethods, a = e.showStoredPaymentMethods, n = e.showPaymentMethods, i = e.instantPaymentMethods, l = function(e) {
                    return {
                        beforeSubmit: e.beforeSubmit,
                        onSubmit: e.onSubmit,
                        elementRef: e.elementRef,
                        showPayButton: e.showPayButton,
                        isDropin: !0
                    };
                }(t$(t$({}, o.props), {}, {
                    elementRef: o.elementRef
                })), s = a ? function() {
                    var e = arguments.length > 2 ? arguments[2] : void 0;
                    return QJ(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], JJ(JJ({}, arguments.length > 1 ? arguments[1] : void 0), {}, {
                        oneClick: !0
                    }), e);
                }(r, l, o._parentInstance.create) : [], c = n ? QJ(t, l, o._parentInstance.create) : [], u = function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 ? arguments[2] : void 0;
                    return e.length ? QJ(e, XJ(XJ({}, t), {}, {
                        isInstantPayment: !0,
                        showPayButton: !0
                    }), r) : [];
                }(i, l, o._parentInstance.create);
                return [
                    s,
                    c,
                    u
                ];
            }), Ag(L_(o), "handleOrder", function(e) {
                var t = e.order;
                o.updateParent({
                    order: t
                });
            }), o.submit = Jg(a = o.submit).call(a, L_(o)), o.handleAction = Jg(n = o.handleAction).call(n, L_(o)), o;
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t, a, n = xg(t = mH(new kJ(e.instantPaymentTypes))).call(t, function(e) {
                        return kb(a$).call(a$, e);
                    }), o = tC(n).call(n, function(t, r) {
                        var a, n, o = zb(a = e.paymentMethods).call(a, function(e) {
                            return e.type === r;
                        });
                        return o ? wb(n = []).call(n, Uk(t), [
                            o
                        ]) : t;
                    }, []), i = xg(a = e.paymentMethods).call(a, function(e) {
                        var t = e.type;
                        return !kb(n).call(n, t);
                    });
                    return t$(t$({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        instantPaymentTypes: n,
                        instantPaymentMethods: o,
                        paymentMethods: i
                    });
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.dropinRef && !!this.dropinRef.state.activePaymentMethod && !!this.dropinRef.state.activePaymentMethod.isValid;
                }
            },
            {
                key: "showValidation",
                value: function() {
                    return this.dropinRef.state.activePaymentMethod && this.dropinRef.state.activePaymentMethod.showValidation(), this;
                }
            },
            {
                key: "setStatus",
                value: function(e) {
                    var t, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return null === (t = this.dropinRef) || void 0 === t || t.setStatus(e, r), this;
                }
            },
            {
                key: "activePaymentMethod",
                get: function() {
                    var e, t;
                    return null !== (e = this.dropinRef) && void 0 !== e && e.state || null !== (t = this.dropinRef) && void 0 !== t && t.state.activePaymentMethod ? this.dropinRef.state.activePaymentMethod : null;
                }
            },
            {
                key: "data",
                get: function() {
                    return this.activePaymentMethod ? this.dropinRef.state.activePaymentMethod.data : null;
                }
            },
            {
                key: "submit",
                value: function() {
                    if (!this.activePaymentMethod) throw new Error("No active payment method.");
                    this.activePaymentMethod.submit();
                }
            },
            {
                key: "handleAction",
                value: function(e) {
                    var t, a, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (!e || !e.type) {
                        if (VS(e, "action") && VS(e, "resultCode")) throw new Error('handleAction::Invalid Action - the passed action object itself has an "action" property and a "resultCode": have you passed in the whole response object by mistake?');
                        throw new Error('handleAction::Invalid Action - the passed action object does not have a "type" property');
                    }
                    if ("redirect" !== e.type && null !== (t = this.activePaymentMethod) && void 0 !== t && t.updateWithAction) return this.activePaymentMethod.updateWithAction(e);
                    this.elementRef instanceof r && (n = t$(t$({}, null === (a = this.elementRef.activePaymentMethod) || void 0 === a ? void 0 : a.props), n));
                    var o = this._parentInstance.createFromAction(e, t$(t$({}, n), {}, {
                        elementRef: this.elementRef,
                        onAdditionalDetails: this.handleAdditionalDetails,
                        isDropin: !0
                    }));
                    return o ? (this.setStatus(o.props.statusType, {
                        component: o
                    }), this.componentFromAction = o, this) : null;
                }
            },
            {
                key: "closeActivePaymentMethod",
                value: function() {
                    this.dropinRef.closeActivePaymentMethod();
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(_j, {
                        srPanel: this.props.modules.srPanel
                    }, nN(HJ, M_({}, this.props, {
                        onChange: this.setState,
                        elementRef: this.elementRef,
                        onCreateElements: this.handleCreate,
                        ref: function(t) {
                            e.dropinRef = t;
                        }
                    }))));
                }
            }
        ]), r;
    }(qS);
    Ag(n$, "type", "dropin"), Ag(n$, "defaultProps", {
        isDropin: !0,
        onReady: function() {},
        onComplete: function() {},
        onError: function() {},
        onSelect: function() {},
        onDisableStoredPaymentMethod: null,
        onChange: function() {},
        instantPaymentMethods: [],
        amount: {},
        installmentOptions: {},
        paymentMethodsConfiguration: {},
        openFirstPaymentMethod: !0,
        openFirstStoredPaymentMethod: !0,
        showStoredPaymentMethods: !0,
        showPaymentMethods: !0,
        showRemoveStoredPaymentMethodButton: !1,
        showPayButton: !0
    });
    var o$ = "AchInput-module_sf-input__wrapper__lfdiv", i$ = "AchInput-module_adyen-checkout__input__8WwCR", l$ = function(e) {
        return e.replace(/[^0-9]/g, "");
    }, s$ = function(e) {
        var t, r = e.id, a = e.dataInfo, n = e.className, o = void 0 === n ? "" : n, i = e.label, l = e.focused, s = e.filled, c = e.errorMessage, u = void 0 === c ? "" : c, d = e.isValid, p = void 0 !== d && d, m = e.onFocusField, f = e.dir, h = (t = r).charAt(0).toUpperCase() + oI(t).call(t, 1), v = "encrypted".concat(h);
        return nN(FE, {
            label: i,
            focused: l,
            filled: s,
            classNameModifiers: [
                r
            ],
            onFocusField: function() {
                return m(v);
            },
            errorMessage: u,
            isValid: p,
            className: o,
            dir: f,
            name: r,
            errorVisibleToScreenReader: !1
        }, nN(GK, {
            encryptedFieldType: v,
            "data-info": a,
            className: DP(Ag(Ag(Ag(Ag({
                "adyen-checkout__input": !0,
                "adyen-checkout__input--large": !0
            }, i$, !0), "adyen-checkout__input--error", u.length), "adyen-checkout__input--focus", l), "adyen-checkout__input--valid", p))
        }));
    }, c$ = function(e) {
        var t = e.focusedElement, r = e.onFocusField, a = e.errors, n = e.valid, o = sw().i18n;
        return nN("div", {
            className: "adyen-checkout__ach-sf__form adyen-checkout__field-wrapper"
        }, nN(s$, {
            id: "bankAccountNumber",
            focused: "encryptedBankAccountNumber" === t,
            isValid: !!n.encryptedBankAccountNumber,
            label: o.get("ach.accountNumberField.title"),
            onFocusField: r,
            filled: !!a.encryptedBankAccountNumber || !!n.encryptedBankAccountNumber,
            errorMessage: !!a.encryptedBankAccountNumber && o.get(a.encryptedBankAccountNumber),
            dataInfo: '{"length":"4-17"}',
            className: "adyen-checkout__field--50",
            dir: "ltr"
        }), nN(s$, {
            id: "bankLocationId",
            focused: "encryptedBankLocationId" === t,
            isValid: !!n.encryptedBankLocationId,
            label: o.get("ach.accountLocationField.title"),
            onFocusField: r,
            filled: !!a.encryptedBankLocationId || !!n.encryptedBankLocationId,
            errorMessage: !!a.encryptedBankLocationId && o.get(a.encryptedBankLocationId),
            dataInfo: '{"length":9}',
            className: "adyen-checkout__field--50",
            dir: "ltr"
        }));
    }, u$ = {
        base: {
            caretColor: "#0075FF"
        }
    };
    function d$(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function p$(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = d$(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = d$(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function m$(e) {
        return !(arguments.length > 1 && void 0 !== arguments[1] && arguments[1]) || !!e && "string" == typeof e && ID(e).call(e).length > 0;
    }
    function f$(e) {
        var t, r = this, a = sw().i18n, n = e.hasHolderName && (!!e.holderName || !!e.data.holderName), o = Vk(VP({}), 2), i = o[0], l = o[1], s = Vk(VP(p$({}, e.holderNameRequired && {
            holderName: n
        })), 2), c = s[0], u = s[1], d = Vk(VP(p$({}, e.hasHolderName && {
            holderName: e.holderName || e.data.holderName
        })), 2), p = d[0], m = d[1], f = Vk(VP(e.billingAddressRequired ? e.data.billingAddress : null), 2), h = f[0], v = f[1], y = Vk(VP(!1), 2), g = y[0], b = y[1], k = Vk(VP(""), 2), C = k[0], _ = k[1], N = Vk(VP(!1), 2), P = N[0], w = N[1], A = function(e) {
            v(p$(p$({}, h), e.data)), u(p$(p$({}, c), {}, {
                billingAddress: e.isValid
            }));
        }, S = function(t) {
            var r = t.target.value;
            m(p$(p$({}, p), {}, {
                holderName: r
            })), l(p$(p$({}, i), {}, {
                holderName: !!e.holderNameRequired && !m$(r)
            })), u(p$(p$({}, c), {}, {
                holderName: !e.holderNameRequired || m$(r, e.holderNameRequired)
            }));
        }, I = qP(null), E = qP(null), D = function(e) {
            E.current = e;
        }, R = Vk(VP("ready"), 2), F = R[0], x = R[1], T = qP({});
        Ty(T.current).length || null === (t = e.setComponentRef) || void 0 === t || t.call(e, T.current);
        return T.current.showValidation = function() {
            I.current.showValidation(), e.holderNameRequired && !c.holderName && l(p$(p$({}, i), {}, {
                holderName: !0
            })), E.current && E.current.showValidation();
        }, T.current.setStatus = x, KP(function() {
            return r.setFocusOn = I.current.setFocusOn, r.updateStyles = I.current.updateStyles, function() {
                I.current.destroy();
            };
        }, []), KP(function() {
            var t = m$(p.holderName, e.holderNameRequired), r = g, a = !e.billingAddressRequired || Boolean(c.billingAddress), n = r && t && a;
            e.onChange({
                data: p,
                isValid: n,
                billingAddress: h,
                storePaymentMethod: P
            });
        }, [
            p,
            c,
            i,
            P
        ]), nN("div", {
            className: "adyen-checkout__ach"
        }, e.showFormInstruction && nN(iO, null), nN(uK, M_({
            ref: I
        }, h$(e), {
            styles: p$(p$({}, u$), e.styles),
            onChange: function(t) {
                var r = t, a = r.autoCompleteName ? r.autoCompleteName : p.holderName;
                m(p$(p$(p$({}, p), r.data), {}, {
                    holderName: a
                })), l(p$(p$({}, i), r.errors)), u(p$(p$(p$({}, c), r.valid), {}, {
                    holderName: !e.holderNameRequired || m$(a, e.holderNameRequired)
                })), b(r.isSfpValid);
            },
            onFocus: function(t) {
                var r = !0 === t.focus;
                _(t.currentFocusObject), r ? e.onFocus(t) : e.onBlur(t);
            },
            render: function(t, r) {
                var n = t.setRootNode, o = t.setFocusOn;
                return nN("div", {
                    ref: n,
                    className: "adyen-checkout__ach-input ".concat(o$)
                }, nN(HK, {
                    status: r.status
                }, nN("div", {
                    className: DP([
                        "adyen-checkout__fieldset",
                        "adyen-checkout__fieldset--ach"
                    ])
                }, nN("div", {
                    className: "adyen-checkout__fieldset__title"
                }, a.get("ach.bankAccount")), e.hasHolderName && nN(FE, {
                    label: a.get("ach.accountHolderNameField.title"),
                    className: "adyen-checkout__pm__holderName",
                    errorMessage: !!i.holderName && a.get("ach.accountHolderNameField.invalid"),
                    isValid: !!c.holderName,
                    name: "holderName"
                }, nN(FD, {
                    className: "adyen-checkout__pm__holderName__input ".concat(i$),
                    placeholder: e.placeholders.holderName || a.get("ach.accountHolderNameField.placeholder"),
                    value: p.holderName,
                    required: e.holderNameRequired,
                    onInput: S
                })), nN(c$, {
                    focusedElement: C,
                    onFocusField: o,
                    errors: r.errors,
                    valid: r.valid
                })), e.billingAddressRequired && nN(zz, {
                    label: "billingAddress",
                    data: h,
                    onChange: A,
                    allowedCountries: e.billingAddressAllowedCountries,
                    requiredFields: e.billingAddressRequiredFields,
                    setComponentRef: D
                }), e.enableStoreDetails && nN(uH, {
                    onChange: w
                })));
            }
        })), e.showPayButton && e.payButton({
            status: F,
            label: a.get("confirmPurchase")
        }));
    }
    f$.defaultProps = {
        type: "ach",
        hasHolderName: !0,
        holderNameRequired: !0,
        billingAddressRequired: !0,
        billingAddressAllowedCountries: [
            "US",
            "PR"
        ],
        showFormInstruction: !0,
        onLoad: function() {},
        onConfigSuccess: function() {},
        onAllValid: function() {},
        onFieldValid: function() {},
        onError: function() {},
        onBlur: function() {},
        onFocus: function() {},
        onChange: function() {},
        holderName: "",
        data: {
            holderName: "",
            billingAddress: {}
        },
        styles: {},
        placeholders: {}
    };
    var h$ = function(e) {
        return {
            allowedDOMAccess: e.allowedDOMAccess,
            autoFocus: e.autoFocus,
            clientKey: e.clientKey,
            i18n: e.i18n,
            keypadFix: e.keypadFix,
            legacyInputMode: e.legacyInputMode,
            loadingContext: e.loadingContext,
            onAllValid: e.onAllValid,
            onConfigSuccess: e.onConfigSuccess,
            onError: e.onError,
            onFieldValid: e.onFieldValid,
            onFocus: e.onFocus,
            onLoad: e.onLoad,
            showWarnings: e.showWarnings,
            styles: e.styles,
            type: e.type,
            forceCompat: e.forceCompat,
            resources: e.resources
        };
    };
    function v$(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function y$(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = v$(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = v$(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function g$(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var b$ = function(e) {
        U_(r, e);
        var t = g$(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t;
                    return y$(y$({}, e), {}, {
                        holderNameRequired: null !== (t = e.hasHolderName) && void 0 !== t ? t : e.holderNameRequired
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e, t = !!this.props.storedPaymentMethodId, a = y$(y$({
                        type: r.type
                    }, this.state.data), {}, {
                        ownerName: null === (e = this.state.data) || void 0 === e ? void 0 : e.holderName
                    }, t && {
                        storedPaymentMethodId: this.props.storedPaymentMethodId
                    });
                    return delete a.holderName, y$(y$({
                        paymentMethod: a
                    }, this.state.billingAddress && {
                        billingAddress: this.state.billingAddress
                    }), this.state.storePaymentMethod && {
                        storePaymentMethod: this.state.storePaymentMethod
                    });
                }
            },
            {
                key: "updateStyles",
                value: function(e) {
                    return this.componentRef && this.componentRef.updateStyles && this.componentRef.updateStyles(e), this;
                }
            },
            {
                key: "setFocusOn",
                value: function(e) {
                    return this.componentRef && this.componentRef.setFocusOn && this.componentRef.setFocusOn(e), this;
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.props.storedPaymentMethodId || !!this.state.isValid;
                }
            },
            {
                key: "displayName",
                get: function() {
                    var e;
                    return this.props.storedPaymentMethodId && this.props.bankAccountNumber ? "\u2022\u2022\u2022\u2022 ".concat(oI(e = this.props.bankAccountNumber).call(e, -4)) : this.props.name;
                }
            },
            {
                key: "additionalInfo",
                get: function() {
                    return this.props.storedPaymentMethodId ? this.props.i18n.get("ach.savedBankAccount") : "";
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.storedPaymentMethodId ? nN(dV, {
                        name: this.displayName,
                        amount: this.props.amount,
                        payButton: this.payButton,
                        onSubmit: this.submit,
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }) : nN(f$, M_({
                        setComponentRef: this.setComponentRef
                    }, this.props, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton,
                        resources: this.resources
                    })));
                }
            }
        ]), r;
    }(qS);
    Ag(b$, "type", "ach");
    var k$ = /\b(2\d{1}|(9(3|6|2|1)))\d{7}\b/, C$ = /^(\d){4,}$/, _$ = {
        phoneNumber: {
            modes: [
                "blur"
            ],
            validate: function(e, t) {
                var r = "+351" === t.state.data.phonePrefix ? k$ : C$;
                return WE(e) ? null : r.test(e);
            },
            errorMessage: "invalidPhoneNumber"
        },
        phonePrefix: {
            modes: [
                "blur"
            ],
            validate: function(e) {
                return !!e;
            },
            errorMessage: "invalidCountryCode"
        }
    }, N$ = {
        phoneNumber: {
            formatterFn: function(e) {
                return e.replace(YE("^\\d", "g"), "");
            }
        }
    };
    function P$(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function w$(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = P$(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = P$(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function A$(e) {
        var t, r, a, n, o, i, l = sw().i18n, s = e.requiredFields || wb(t = []).call(t, Uk(null != e && null !== (r = e.items) && void 0 !== r && r.length ? [
            "phonePrefix"
        ] : []), [
            "phoneNumber"
        ]), c = kb(s).call(s, "phonePrefix") && !(null == e || null === (a = e.items) || void 0 === a || !a.length), u = kb(s).call(s, "phoneNumber"), d = _D(w$(w$({
            i18n: l
        }, e), {}, {
            schema: s,
            defaultData: e.data,
            rules: _$,
            formatters: N$
        })), p = d.handleChangeFor, m = d.data, f = d.valid, h = d.errors, v = d.isValid, y = d.triggerValidation, g = d.setSchema;
        KP(function() {
            g(s);
        }, [
            s.toString()
        ]), KP(function() {
            m.phoneNumber && p("phoneNumber", "blur")(m.phoneNumber);
        }, [
            m.phonePrefix
        ]), KP(function() {
            e.onChange({
                data: m,
                valid: f,
                errors: h,
                isValid: v
            });
        }, [
            m,
            f,
            h,
            v
        ]), this.triggerValidation = y;
        var b = function() {
            var e = document.querySelector(".adyen-checkout-phone-input--new [uniqueid]");
            return e ? e.getAttribute("uniqueid") : null;
        }, k = GP(function(t) {
            if (h[t]) {
                var r = "phoneNumber" === t ? "phoneNumberErrorKey" : "phonePrefixErrorKey", a = e[r] ? e[r] : h[t].errorMessage, n = l.get(a);
                return n || null;
            }
            return null;
        }, [
            h
        ]), C = WP(function() {
            return EE("adyen-checkout-phonePrefix");
        }, []), _ = (h.phoneNumber || h.phonePrefix) && !0;
        return nN("div", {
            className: "adyen-checkout-phone-input--new"
        }, nN("label", {
            htmlFor: b()
        }, nN("span", {
            className: DP({
                "adyen-checkout__label__text": !0,
                "adyen-checkout__label__text--error": _
            })
        }, e.phoneNumberKey ? l.get(e.phoneNumberKey) : l.get("telephoneNumber"))), nN(FE, {
            name: "phoneNumber",
            className: DP({
                "adyen-checkout-field": !0,
                "adyen-checkout-field--phone-input": !0
            }),
            inputWrapperModifiers: [
                "phone-input"
            ],
            isValid: f.phoneNumber,
            errorMessage: _,
            showValidIcon: !h.phonePrefix
        }, nN("div", {
            className: DP({
                "adyen-checkout__input": !0,
                "adyen-checkout__input--invalid": !!h.phoneNumber || !!h.phonePrefix,
                "adyen-checkout__input--valid": (!c || f.phonePrefix) && f.phoneNumber,
                "adyen-checkout-input": !0,
                "adyen-checkout-input-holder--phone-input": !0
            })
        }, c && nN(cz, {
            className: "adyen-checkout-dropdown adyen-checkout-dropdown--countrycode-selector",
            items: e.items,
            onChange: p("phonePrefix"),
            placeholder: l.get("infix"),
            selectedValue: m.phonePrefix,
            uniqueId: C
        }), u && nN("div", {
            className: "adyen-checkout-phone-number"
        }, nN("input", {
            id: b(),
            type: "tel",
            value: m.phoneNumber,
            onInput: p("phoneNumber", "input"),
            onBlur: p("phoneNumber", "blur"),
            placeholder: e.placeholders.phoneNumber || "123456789",
            className: "adyen-checkout__input adyen-checkout-input adyen-checkout-input--phone-number",
            autoCorrect: "off",
            "aria-required": !0,
            "aria-label": e.phoneNumberKey ? l.get(e.phoneNumberKey) : l.get("telephoneNumber"),
            "aria-invalid": !f.phoneNumber,
            "aria-describedby": wb(n = "".concat(b())).call(n, sE)
        })))), nN("div", {
            className: "adyen-checkout-phone-input__error-holder"
        }, c && k("phonePrefix") && nN("span", {
            className: "adyen-checkout__error-text",
            "aria-live": "polite",
            id: wb(o = "".concat(C)).call(o, sE)
        }, k("phonePrefix")), u && k("phoneNumber") && nN("span", {
            className: "adyen-checkout__error-text",
            "aria-live": "polite",
            id: wb(i = "".concat(b())).call(i, sE)
        }, k("phoneNumber"))));
    }
    function S$(e) {
        var t, r = sw(), a = r.i18n, n = r.loadingContext, o = qP(null), i = e.allowedCountries, l = void 0 === i ? [] : i, s = Vk(VP("ready"), 2), c = s[0], u = s[1];
        this.setStatus = u, this.showValidation = null == o || null === (t = o.current) || void 0 === t ? void 0 : t.triggerValidation;
        var d = function(e) {
            var t = e.allowedCountries, r = e.loadingContext, a = e.handleError, n = Vk(VP("loading"), 2), o = n[0], i = n[1], l = Vk(VP([]), 2), s = l[0], c = l[1];
            return HP(function() {
                OT("phonenumbers", r).then(function(e) {
                    var r = t.length ? xg(e).call(e, function(e) {
                        return kb(t).call(t, e.id);
                    }) : e, a = hC(r).call(r, function(e) {
                        var t, r = e.prefix, a = e.id;
                        return {
                            id: r,
                            name: wb(t = "".concat(r, " (")).call(t, a, ")"),
                            selectedOptionName: r
                        };
                    });
                    c(a || []), i("ready");
                }).catch(function(e) {
                    c([]), i("ready"), null == a || a(new LS("ERROR", e));
                });
            }, []), {
                phonePrefixes: s,
                loadingStatus: o
            };
        }({
            allowedCountries: l,
            loadingContext: n,
            handleError: e.onError
        }), p = d.loadingStatus, m = d.phonePrefixes;
        return nN(HK, {
            status: p
        }, nN("div", {
            className: "adyen-checkout__mb-way"
        }, nN(A$, M_({}, e, {
            items: m,
            ref: o,
            onChange: function(t) {
                var r = t.data, a = t.valid, n = t.errors, o = t.isValid;
                e.onChange({
                    data: r,
                    valid: a,
                    errors: n,
                    isValid: o
                });
            },
            data: e.data
        })), e.showPayButton && e.payButton({
            status: c,
            label: a.get("confirmPurchase")
        })));
    }
    A$.defaultProps = {
        phoneLabel: "telephoneNumber"
    }, S$.defaultProps = {
        onChange: function() {},
        phoneNumberKey: "mobileNumber",
        phoneNumberErrorKey: "mobileNumber.invalid"
    };
    var I$ = 2e3, E$ = 15, D$ = 6e4, R$ = 1e4, F$ = "mbway", x$ = "mbway.confirmPayment", T$ = "await.waitForConfirmation", z$ = !1, O$ = [
        "message"
    ];
    function j$(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function B$(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = j$(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = j$(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function M$(e) {
        var t, r = this, a = sw(), n = a.i18n, o = a.loadingContext, i = II(), l = Vk(VP(!1), 2), s = l[0], c = l[1], u = Vk(VP(!1), 2), d = u[0], p = u[1], m = Vk(VP(!0), 2), f = m[0], h = m[1], v = Vk(VP(!1), 2), y = v[0], g = v[1], b = Vk(VP(e.delay), 2), k = b[0], C = b[1], _ = Vk(VP(100), 2), N = _[0], P = _[1], w = Vk(VP(0), 2), A = w[0], S = w[1], I = Vk(VP(!1), 2), E = I[0], D = I[1], R = Vk(VP(null), 2), F = R[0], x = R[1], T = function() {
            var t = e.paymentData, a = e.clientKey, i = e.throttleInterval;
            y || (e.onActionHandled({
                componentType: e.type,
                actionDescription: "polling-started"
            }), g(!0)), EQ(t, a, o, i).then(xQ).catch(function(e) {
                var t = e.message, r = kg(e, O$);
                return {
                    type: "network-error",
                    props: B$(B$({}, t && {
                        message: n.get(t)
                    }), r)
                };
            }).then(function(t) {
                switch(t.type){
                    case "success":
                        !function(t) {
                            if (t.props.payload) {
                                c(!0);
                                var a = {
                                    data: {
                                        details: {
                                            payload: t.props.payload
                                        },
                                        paymentData: e.paymentData
                                    }
                                };
                                return e.onComplete(a, r);
                            }
                            p(!0), e.onError(new LS("ERROR", "successful result, but no payload in response"));
                        }(t);
                        break;
                    case "error":
                        !function(t) {
                            if (p(!0), t.props.payload) {
                                var a = {
                                    data: {
                                        details: {
                                            payload: t.props.payload
                                        },
                                        paymentData: e.paymentData
                                    }
                                };
                                return e.onComplete(a, r);
                            }
                            e.onError(new LS("ERROR", "error result with no payload in response"));
                        }(t);
                        break;
                    default:
                        h(!1);
                }
            });
        };
        KP(function() {
            return T(), function() {
                clearTimeout(F);
            };
        }, []), KP(function() {
            if (d) return clearTimeout(F);
            if (s) return clearTimeout(F);
            if (!f) x(NP(function() {
                T();
                var t = A + k;
                S(t), t >= e.throttleTime && !E && (C(e.throttleInterval), D(!0));
            }, k));
        }, [
            f,
            d,
            s,
            A
        ]);
        var z = function(e, t) {
            return nN("div", {
                className: "adyen-checkout__await adyen-checkout__await--result"
            }, nN("img", {
                className: "adyen-checkout__await__icon adyen-checkout__await__icon--result",
                src: i({
                    imageFolder: "components/"
                })(e),
                alt: n.get(t)
            }), nN("div", {
                className: "adyen-checkout__await__subtitle adyen-checkout__await__subtitle--result"
            }, n.get(t)));
        };
        if (d) return z("error", "error.subtitle.payment");
        if (s) return z("success", "creditCard.success");
        if (f) return nN("div", {
            className: "adyen-checkout__await"
        }, e.brandLogo && nN("img", {
            src: e.brandLogo,
            alt: e.type,
            className: "adyen-checkout__await__brand-logo"
        }), nN(RP, {
            inline: !1,
            size: "large"
        }));
        var O = n.get("wechatpay.timetopay").split("%@");
        return nN("div", {
            className: DP("adyen-checkout__await", "adyen-checkout__await--".concat(e.type), hC(t = e.classNameModifiers).call(t, function(e) {
                return "adyen-checkout__await--".concat(e);
            }))
        }, e.brandLogo && nN("img", {
            src: e.brandLogo,
            alt: e.type,
            className: "adyen-checkout__await__brand-logo"
        }), nN("div", {
            className: "adyen-checkout__await__subtitle"
        }, e.messageText), nN("div", {
            className: "adyen-checkout__await__indicator-holder"
        }, nN("div", {
            className: "adyen-checkout__await__indicator-spinner"
        }, nN(RP, {
            inline: !1,
            size: "medium"
        })), nN("div", {
            className: "adyen-checkout__await__indicator-text"
        }, e.awaitText)), e.showCountdownTimer && nN("div", {
            className: "adyen-checkout__await__countdown-holder"
        }, nN("div", {
            className: "adyen-checkout__await__progress"
        }, nN("span", {
            className: "adyen-checkout__await__percentage",
            style: {
                width: "".concat(N, "%")
            }
        })), nN("div", {
            className: "adyen-checkout__await__countdown"
        }, O[0], "\xa0", nN(IQ, {
            minutesFromNow: e.countdownTime,
            onTick: function(e) {
                P(e.percentage);
            },
            onCompleted: function() {
                p(!0), clearTimeout(F), e.onError(new LS("ERROR", "Payment Expired"));
            }
        }), "\xa0", O[1])), e.url && nN("div", {
            className: "adyen-checkout__await__app-link"
        }, nN(MB, null), nN(uw, {
            classNameModifiers: [
                "await"
            ],
            onClick: function() {
                return function(e) {
                    window.location.assign(e);
                }(e.url);
            },
            label: n.get("openApp")
        })));
    }
    function L$(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function V$(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = L$(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = L$(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function U$(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    M$.defaultProps = {
        countdownTime: 15,
        onError: function() {},
        onComplete: function() {},
        onActionHandled: function() {},
        delay: 2e3,
        throttleTime: 6e4,
        throttleInterval: 1e4,
        showCountdownTimer: !0,
        classNameModifiers: [],
        url: null
    };
    var K$ = function(e) {
        U_(r, e);
        var t = U$(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t = e.data, r = void 0 === t ? {} : t, a = e.placeholders, n = void 0 === a ? {} : a;
                    return V$(V$({}, e), {}, {
                        data: {
                            phoneNumber: r.telephoneNumber || r.phoneNumber,
                            phonePrefix: r.phonePrefix || "+351"
                        },
                        placeholders: {
                            phoneNumber: n.telephoneNumber || n.phoneNumber || "932123456"
                        }
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e;
                    return {
                        paymentMethod: V$({
                            type: r.type
                        }, (null === (e = this.state.data) || void 0 === e ? void 0 : e.phoneNumber) && {
                            telephoneNumber: this.state.data.phonePrefix + this.state.data.phoneNumber
                        })
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "displayName",
                get: function() {
                    return this.props.name;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.paymentData ? nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(_j, {
                        srPanel: this.props.modules.srPanel
                    }, nN(M$, {
                        ref: function(t) {
                            e.componentRef = t;
                        },
                        clientKey: this.props.clientKey,
                        paymentData: this.props.paymentData,
                        onError: this.props.onError,
                        onComplete: this.onComplete,
                        brandLogo: this.icon,
                        type: F$,
                        messageText: this.props.i18n.get(x$),
                        awaitText: this.props.i18n.get(T$),
                        showCountdownTimer: z$,
                        delay: I$,
                        countdownTime: E$,
                        throttleTime: D$,
                        throttleInterval: R$,
                        onActionHandled: this.props.onActionHandled
                    }))) : nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(S$, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(qS);
    function H$(e) {
        var t = this, r = sw().i18n, a = II(), n = _D({
            schema: [
                "blikCode"
            ],
            rules: {
                blikCode: {
                    validate: function(e) {
                        return 6 === (null == e ? void 0 : e.length);
                    },
                    errorMessage: "blik.invalid",
                    modes: [
                        "blur"
                    ]
                }
            },
            formatters: {
                blikCode: l$
            }
        }), o = n.handleChangeFor, i = n.triggerValidation, l = n.data, s = n.valid, c = n.errors, u = n.isValid;
        KP(function() {
            e.onChange({
                data: l,
                errors: c,
                valid: s,
                isValid: u
            }, t);
        }, [
            l,
            s,
            c,
            u
        ]);
        var d = Vk(VP("ready"), 2), p = d[0], m = d[1];
        return this.setStatus = m, this.showValidation = i, nN("div", {
            className: "adyen-checkout__blik"
        }, nN("p", {
            className: "adyen-checkout__blik__helper"
        }, r.get("blik.help")), nN(FE, {
            errorMessage: !!c.blikCode && r.get(c.blikCode.errorMessage),
            label: r.get("blik.code"),
            classNameModifiers: [
                "blikCode",
                "50"
            ],
            isValid: s.blikCode,
            dir: "ltr",
            name: "blikCode"
        }, nN(FD, {
            value: l.blikCode,
            name: "blikCode",
            spellcheck: !1,
            required: !0,
            autocorrect: "off",
            autocomplete: "off",
            onInput: o("blikCode", "input"),
            onBlur: o("blikCode", "blur"),
            placeholder: "123456",
            inputMode: "numeric",
            maxLength: 6
        })), e.showPayButton && e.payButton({
            status: p,
            icon: a({
                imageFolder: "components/"
            })("lock")
        }));
    }
    Ag(K$, "type", "mbway"), H$.defaultProps = {
        data: {
            blikCode: ""
        }
    };
    var q$ = 2e3, W$ = 15, G$ = 6e4, Y$ = 1e4, Q$ = "blik", Z$ = "blik.confirmPayment", J$ = "await.waitForConfirmation", $$ = !1;
    function X$(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function eX(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = X$(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = X$(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function tX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var rX = function(e) {
        U_(r, e);
        var t = tX(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatData",
                value: function() {
                    var e, t = !!this.props.storedPaymentMethodId;
                    return {
                        paymentMethod: eX(eX({
                            type: r.type
                        }, !t && {
                            blikCode: null === (e = this.state) || void 0 === e || null === (e = e.data) || void 0 === e ? void 0 : e.blikCode
                        }), t && {
                            storedPaymentMethodId: this.props.storedPaymentMethodId
                        })
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.props.storedPaymentMethodId || !!this.state.isValid;
                }
            },
            {
                key: "displayName",
                get: function() {
                    return this.props.storedPaymentMethodId && this.props.label ? this.props.label : this.props.name;
                }
            },
            {
                key: "additionalInfo",
                get: function() {
                    return this.props.storedPaymentMethodId && this.props.label ? this.props.name : null;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.paymentData ? nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(_j, {
                        srPanel: this.props.modules.srPanel
                    }, nN(M$, {
                        ref: function(t) {
                            e.componentRef = t;
                        },
                        clientKey: this.props.clientKey,
                        paymentData: this.props.paymentData,
                        onError: this.handleError,
                        onComplete: this.onComplete,
                        brandLogo: this.icon,
                        type: Q$,
                        messageText: this.props.i18n.get(Z$),
                        awaitText: this.props.i18n.get(J$),
                        showCountdownTimer: $$,
                        delay: q$,
                        countdownTime: W$,
                        throttleTime: G$,
                        throttleInterval: Y$,
                        onActionHandled: this.props.onActionHandled
                    }))) : nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.storedPaymentMethodId ? nN(dV, {
                        name: this.displayName,
                        amount: this.props.amount,
                        payButton: this.payButton,
                        onSubmit: this.submit,
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }) : nN(H$, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(qS);
    function aX(e) {
        var t = e.reference, r = e.totalAmount, a = e.paymentMethodType, n = sw().i18n, o = II();
        return nN(iG, {
            paymentMethodType: a,
            introduction: n.get("bankTransfer.instructions"),
            imageUrl: o()(a),
            amount: r && n.amount(r.value, r.currency),
            voucherDetails: [
                {
                    label: n.get("bankTransfer.beneficiary"),
                    value: e.beneficiary
                },
                {
                    label: n.get("bankTransfer.iban"),
                    value: e.iban
                },
                {
                    label: n.get("bankTransfer.bic"),
                    value: e.bic
                },
                {
                    label: n.get("bankTransfer.reference"),
                    value: t
                }
            ]
        });
    }
    function nX(e) {
        var t = sw().i18n, r = Vk(VP(!1), 2), a = r[0], n = r[1], o = _D({
            schema: [],
            defaultData: e.data,
            rules: {
                shopperEmail: HD.shopperEmail
            }
        }), i = o.handleChangeFor, l = o.triggerValidation, s = o.data, c = o.valid, u = o.errors, d = o.isValid, p = o.setSchema;
        return KP(function() {
            p(a ? [
                "shopperEmail"
            ] : []);
        }, [
            a
        ]), this.showValidation = l, KP(function() {
            e.onChange({
                data: s,
                errors: u,
                valid: c,
                isValid: d
            });
        }, [
            s,
            c,
            u,
            a,
            d
        ]), nN("div", {
            className: "adyen-checkout__bankTransfer"
        }, nN("p", {
            className: "adyen-checkout__bankTransfer__introduction"
        }, t.get("bankTransfer.introduction")), nN(gZ, {
            classNames: "adyen-checkout__bankTransfer__emailField",
            value: s.shopperEmail,
            errors: u.shopperEmail,
            onToggle: function() {
                return n(!a);
            },
            onInput: i("shopperEmail", "input"),
            onBlur: i("shopperEmail", "blur")
        }));
    }
    function oX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function iX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(rX, "type", "blik");
    var lX = function(e) {
        U_(r, e);
        var t = iX(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "state", {
                isValid: !a.props.showEmailAddress,
                data: {}
            }), Ag(L_(a), "handleRef", function(e) {
                a.componentRef = e;
            }), a;
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.state.data.shopperEmail;
                    return function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Sg(r = oX(Object(n), !0)).call(r, function(t) {
                                Ag(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Sg(a = oX(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        paymentMethod: {
                            type: r.type
                        }
                    }, e && {
                        shopperEmail: e
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    return this.props.reference ? nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(aX, M_({
                        ref: this.handleRef
                    }, this.props))) : nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.showEmailAddress && nN(nX, M_({
                        ref: this.handleRef
                    }, this.props, {
                        onChange: this.setState
                    })), this.props.showPayButton && nN(dV, M_({}, this.props, {
                        name: this.displayName,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(qS);
    Ag(lX, "type", "bankTransfer_IBAN"), Ag(lX, "defaultProps", {
        showPayButton: !0,
        showEmailAddress: !0
    });
    var sX = [
        "CA",
        "US"
    ];
    function cX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function uX(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = cX(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = cX(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function dX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var pX = function(e) {
        U_(r, e);
        var t = dX(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return uX(uX({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: sX,
                        personalDetailsRequiredFields: [
                            "firstName",
                            "lastName",
                            "telephoneNumber",
                            "shopperEmail"
                        ]
                    });
                }
            }
        ]), r;
    }(Aj);
    Ag(pX, "type", "affirm");
    var mX = {
        socialSecurityNumber: {
            validate: vK,
            errorMessage: "",
            modes: [
                "blur"
            ]
        },
        default: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "",
            modes: [
                "blur"
            ]
        }
    }, fX = {
        socialSecurityNumber: function(e) {
            return hK(e);
        }
    };
    function hX(e) {
        var t, r = e.name, a = e.data, n = e.personalDetailsRequired, o = e.showPayButton, i = void 0 !== o && o, l = e.onChange, s = e.payButton, c = sw().i18n, u = [
            "firstName",
            "lastName",
            "socialSecurityNumber"
        ], d = _D({
            schema: u,
            defaultData: a,
            rules: mX,
            formatters: fX
        }), p = d.handleChangeFor, m = d.triggerValidation, f = d.setSchema, h = d.data, v = d.valid, y = d.errors, g = d.isValid;
        KP(function() {
            var e, t = n ? wb(e = []).call(e, u) : [];
            f(t);
        }, [
            n
        ]);
        var b = Vk(VP("ready"), 2), k = b[0], C = b[1];
        this.setStatus = C, this.showValidation = function() {
            m();
        }, KP(function() {
            l({
                data: h,
                valid: v,
                errors: y,
                isValid: g
            });
        }, [
            l,
            h,
            v,
            y
        ]);
        var _ = n ? [] : [
            "standalone"
        ];
        return nN("div", {
            className: "adyen-checkout__pix-input__field",
            style: i || n ? null : {
                display: "none"
            }
        }, n && nN(bZ, {
            i18n: c,
            data: h,
            handleChangeFor: p,
            errors: y,
            valid: v
        }), i && s({
            status: k,
            label: wb(t = "".concat(c.get("continueTo"), " ")).call(t, r),
            classNameModifiers: _
        }));
    }
    function vX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function yX(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = vX(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = vX(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function gX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var bX = function(e) {
        U_(r, e);
        var t = gX(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    return yX({
                        copyBtn: !0,
                        introduction: "pix.instructions"
                    }, kI(H_(r.prototype), "formatProps", this).call(this, e));
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.state.data, t = void 0 === e ? {} : e, r = t.firstName, a = t.lastName, n = t.socialSecurityNumber, o = void 0 === n ? "" : n;
                    return yX(yX({
                        paymentMethod: {
                            type: this.props.type || this.constructor.type
                        }
                    }, r && a && {
                        shopperName: {
                            firstName: r,
                            lastName: a
                        }
                    }), o && {
                        socialSecurityNumber: fK(o)
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.paymentData ? this.renderQRCode() : nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(hX, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, {
                        showPayButton: this.props.showPayButton,
                        personalDetailsRequired: this.props.personalDetailsRequired,
                        name: this.displayName,
                        onChange: this.setState,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(LQ);
    Ag(bX, "type", "pix"), Ag(bX, "defaultProps", yX({
        showPayButton: !1,
        personalDetailsRequired: !1,
        countdownTime: 15,
        delay: 2e3
    }, LQ.defaultProps));
    var kX = /^(\d){1,8}$/, CX = /^(\d){6}$/, _X = {
        bankAccountNumber: {
            modes: [
                "blur",
                "input"
            ],
            validate: function(e) {
                return !!e && kX.test(e);
            }
        },
        bankLocationId: [
            {
                modes: [
                    "input"
                ],
                validate: function(e) {
                    return !!e && /^(\d){1,6}$/.test(e);
                }
            },
            {
                modes: [
                    "blur"
                ],
                validate: function(e) {
                    return !!e && CX.test(e);
                }
            }
        ],
        amountConsentCheckbox: {
            modes: [
                "blur"
            ],
            validate: function(e) {
                return !!e;
            }
        },
        accountConsentCheckbox: {
            modes: [
                "blur"
            ],
            validate: function(e) {
                return !!e;
            }
        },
        shopperEmail: HD.shopperEmail,
        default: {
            modes: [
                "blur"
            ],
            validate: function(e) {
                return !!e && e.length > 0;
            }
        }
    }, NX = {
        bankAccountNumber: l$,
        bankLocationId: l$
    }, PX = "enter-data", wX = "confirm-data";
    function AX(e) {
        var t, r, a, n = this, o = sw().i18n, i = II(), l = _D({
            schema: [
                "holderName",
                "bankAccountNumber",
                "bankLocationId",
                "shopperEmail",
                "amountConsentCheckbox",
                "accountConsentCheckbox"
            ],
            defaultData: e.data,
            formatters: NX,
            rules: _X
        }), s = l.handleChangeFor, c = l.triggerValidation, u = l.data, d = l.valid, p = l.errors, m = l.isValid, f = Vk(VP(PX), 2), h = f[0], v = f[1];
        this.setStatus = v, this.showValidation = c;
        return KP(function() {
            e.onChange({
                data: u,
                valid: d,
                errors: p,
                isValid: m
            });
        }, [
            u,
            d,
            p,
            m
        ]), nN("div", {
            className: DP({
                "adyen-checkout__bacs": !0,
                "adyen-checkout__bacs--confirm": h === wX || "loading" === h
            })
        }, e.showFormInstruction && nN(iO, null), h == wX && nN("div", {
            className: DP({
                "adyen-checkout__bacs--edit": !0,
                "adyen-checkout__bacs--edit-dropin": e.isDropin
            })
        }, nN(FD, {
            name: "bacsEdit",
            className: "adyen-checkout__bacs--edit-button",
            value: o.get("edit"),
            "aria-label": o.get("edit"),
            readonly: !0,
            onClick: function() {
                return n.setStatus(PX);
            }
        })), nN(FE, {
            className: DP({
                "adyen-checkout__bacs--holder-name": !0,
                "adyen-checkout__field--inactive": h === wX || "loading" === h
            }),
            label: o.get("bacs.accountHolderName"),
            errorMessage: !!p.holderName && o.get("bacs.accountHolderName.invalid"),
            isValid: d.holderName,
            name: "accountHolderName",
            i18n: o
        }, nN(FD, {
            name: "bacs.accountHolderName",
            className: "adyen-checkout__bacs-input--holder-name",
            placeholder: e.placeholders.holderName,
            value: u.holderName,
            "aria-invalid": !d.holderName,
            "aria-label": o.get("bacs.accountHolderName"),
            "aria-required": "true",
            required: !0,
            readonly: h === wX || "loading" === h,
            autocorrect: "off",
            onBlur: s("holderName", "blur"),
            onInput: s("holderName", "input")
        })), nN("div", {
            className: "adyen-checkout__bacs__num-id adyen-checkout__field-wrapper"
        }, nN(FE, {
            errorMessage: !!p.bankAccountNumber && o.get("bacs.accountNumber.invalid"),
            label: o.get("bacs.accountNumber"),
            className: DP({
                "adyen-checkout__bacs--bank-account-number": !0,
                "adyen-checkout__field--inactive": h === wX || "loading" === h
            }),
            classNameModifiers: [
                "col-70"
            ],
            isValid: d.bankAccountNumber,
            name: "bankAccountNumber",
            i18n: o
        }, nN(FD, {
            value: u.bankAccountNumber,
            className: "adyen-checkout__bacs-input--bank-account-number",
            placeholder: e.placeholders.bankAccountNumber,
            "aria-invalid": !d.bankAccountNumber,
            "aria-label": o.get("bacs.accountNumber"),
            "aria-required": "true",
            required: !0,
            readonly: h === wX || "loading" === h,
            autocorrect: "off",
            onBlur: s("bankAccountNumber", "blur"),
            onInput: s("bankAccountNumber", "input")
        })), nN(FE, {
            errorMessage: !!p.bankLocationId && o.get("bacs.bankLocationId.invalid"),
            label: o.get("bacs.bankLocationId"),
            className: DP({
                "adyen-checkout__bacs--bank-location-id": !0,
                "adyen-checkout__field--inactive": h === wX || "loading" === h
            }),
            classNameModifiers: [
                "col-30"
            ],
            isValid: d.bankLocationId,
            name: "bankLocationId",
            i18n: o
        }, nN(FD, {
            value: u.bankLocationId,
            className: "adyen-checkout__bacs-input--bank-location-id",
            placeholder: e.placeholders.bankLocationId,
            "aria-invalid": !d.bankLocationId,
            "aria-label": o.get("bacs.bankLocationId"),
            "aria-required": "true",
            required: !0,
            readonly: h === wX || "loading" === h,
            autocorrect: "off",
            onBlur: s("bankLocationId", "blur"),
            onInput: s("bankLocationId", "input")
        }))), nN(FE, {
            errorMessage: !!p.shopperEmail && o.get("shopperEmail.invalid"),
            label: o.get("shopperEmail"),
            className: DP({
                "adyen-checkout__bacs--shopper-email": !0,
                "adyen-checkout__field--inactive": h === wX || "loading" === h
            }),
            isValid: d.shopperEmail,
            name: "emailAddress",
            i18n: o
        }, nN(dR, {
            value: u.shopperEmail,
            name: "shopperEmail",
            className: "adyen-checkout__bacs-input--shopper-email",
            classNameModifiers: [
                "large"
            ],
            placeholder: e.placeholders.shopperEmail,
            spellcheck: !1,
            "aria-invalid": !d.shopperEmail,
            "aria-label": o.get("shopperEmail"),
            "aria-required": "true",
            required: !0,
            readonly: h === wX || "loading" === h,
            autocorrect: "off",
            onInput: s("shopperEmail", "input"),
            onBlur: s("shopperEmail", "blur")
        })), h === PX && nN(Lz, {
            classNameModifiers: [
                "amountConsentCheckbox"
            ],
            errorMessage: !!p.amountConsentCheckbox,
            label: o.get("bacs.consent.amount"),
            onChange: s("amountConsentCheckbox"),
            checked: !!u.amountConsentCheckbox,
            i18n: o
        }), h === PX && nN(Lz, {
            classNameModifiers: [
                "accountConsentCheckbox"
            ],
            errorMessage: !!p.accountConsentCheckbox,
            label: o.get("bacs.consent.account"),
            onChange: s("accountConsentCheckbox"),
            checked: !!u.accountConsentCheckbox,
            i18n: o
        }), e.showPayButton && e.payButton({
            status: h,
            label: h === PX ? o.get("continue") : wb(t = "".concat(o.get("bacs.confirm"), " ")).call(t, null !== (r = e.amount) && void 0 !== r && r.value && null !== (a = e.amount) && void 0 !== a && a.currency ? o.amount(e.amount.value, e.amount.currency) : ""),
            icon: i({
                imageFolder: "components/"
            })("lock"),
            onClick: function() {
                return m ? h === PX ? n.setStatus(wX) : h === wX ? e.onSubmit() : void 0 : n.showValidation();
            }
        }));
    }
    AX.defaultProps = {
        data: {},
        placeholders: {}
    };
    var SX = function(e) {
        var t = sw().i18n, r = II(), a = e.url, n = e.paymentMethodType;
        return nN(iG, {
            paymentMethodType: n,
            introduction: t.get("bacs.result.introduction"),
            imageUrl: r()(n),
            downloadUrl: a,
            downloadButtonText: t.get("download.pdf")
        });
    };
    function IX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function EX(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = IX(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = IX(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function DX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var RX = function(e) {
        U_(r, e);
        var t = DX(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "payButton", function(e) {
                return nN(hw, M_({
                    amount: a.props.amount,
                    onClick: a.submit
                }, e));
            }), a;
        }
        return wg(r, [
            {
                key: "formatData",
                value: function() {
                    var e, t, a, n;
                    return EX({
                        paymentMethod: EX(EX(EX({
                            type: r.type
                        }, (null === (e = this.state.data) || void 0 === e ? void 0 : e.holderName) && {
                            holderName: this.state.data.holderName
                        }), (null === (t = this.state.data) || void 0 === t ? void 0 : t.bankAccountNumber) && {
                            bankAccountNumber: this.state.data.bankAccountNumber
                        }), (null === (a = this.state.data) || void 0 === a ? void 0 : a.bankLocationId) && {
                            bankLocationId: this.state.data.bankLocationId
                        })
                    }, (null === (n = this.state.data) || void 0 === n ? void 0 : n.shopperEmail) && {
                        shopperEmail: this.state.data.shopperEmail
                    });
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.url ? nN(SX, {
                        ref: function(t) {
                            e.componentRef = t;
                        },
                        icon: this.icon,
                        url: this.props.url,
                        paymentMethodType: this.props.paymentMethodType
                    }) : nN(AX, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, {
                        onChange: this.setState,
                        payButton: this.payButton,
                        onSubmit: this.submit
                    })));
                }
            }
        ]), r;
    }(qS);
    function FX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(RX, "type", "directdebit_GB"), Ag(RX, "defaultProps", {
        showFormInstruction: !0
    });
    var xX = function(e) {
        U_(r, e);
        var t = FX(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "data",
                get: function() {
                    return this.state.data;
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "render",
                value: function() {
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(zz, M_({
                        setComponentRef: this.setComponentRef
                    }, this.props, {
                        onChange: this.setState
                    }, !1)));
                }
            }
        ]), r;
    }(qS);
    function TX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var zX = function(e) {
        U_(r, e);
        var t = TX(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "data",
                get: function() {
                    return this.state.data;
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "render",
                value: function() {
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.showFormInstruction && nN(iO, null), nN(vR, M_({
                        setComponentRef: this.setComponentRef
                    }, this.props, {
                        onChange: this.setState
                    }, !1)));
                }
            }
        ]), r;
    }(qS);
    Ag(zX, "defaultProps", {
        showFormInstruction: !0
    });
    var OX = "https://x.klarnacdn.net/kp/lib/v1/api.js", jX = [
        "sdkData",
        "paymentMethodType",
        "payButton"
    ];
    function BX(e) {
        var t = e.sdkData;
        e.paymentMethodType;
        var r = e.payButton, a = kg(e, jX), n = qP(null), o = Vk(VP("ready"), 2), i = o[0], l = o[1], s = function() {
            l("error"), a.onComplete({
                data: {
                    paymentData: a.paymentData,
                    details: {}
                }
            });
        };
        return KP(function() {
            window.klarnaAsyncCallback = function() {
                window.Klarna.Payments.init({
                    client_token: t.client_token
                }), window.Klarna.Payments.load({
                    container: n.current,
                    payment_method_category: t.payment_method_category
                }, function(e) {
                    !e.show_form || e.error ? s() : a.onLoaded();
                });
            };
            var e = new sB(OX);
            return e.load(), function() {
                e.remove();
            };
        }, []), "error" !== i && "success" !== i ? nN("div", {
            className: "adyen-checkout__klarna-widget"
        }, nN("div", {
            ref: n
        }), r({
            status: i,
            disabled: "loading" === i,
            onClick: function() {
                l("loading");
                try {
                    window.Klarna.Payments.authorize({
                        payment_method_category: t.payment_method_category
                    }, function(e) {
                        !0 === e.approved && !0 === e.show_form ? (l("success"), a.onComplete({
                            data: {
                                paymentData: a.paymentData,
                                details: {
                                    token: e.authorization_token,
                                    authorization_token: e.authorization_token
                                }
                            }
                        })) : e.approved || !0 !== e.show_form ? s() : (l("ready"), a.onError(e));
                    });
                } catch (e) {
                    s();
                }
            }
        })) : null;
    }
    function MX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function LX(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = MX(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = MX(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function VX(e) {
        var t, r = Vk(VP({
            sdkData: e.sdkData,
            paymentMethodType: e.paymentMethodType,
            paymentData: e.paymentData
        }), 2), a = r[0], n = r[1], o = Vk(VP("ready"), 2), i = o[0], l = o[1];
        return this.setAction = n, this.setStatus = l, a.sdkData ? nN(BX, {
            sdkData: a.sdkData,
            paymentMethodType: a.paymentMethodType,
            paymentData: a.paymentData,
            payButton: e.payButton,
            onComplete: e.onComplete,
            onError: e.onError,
            onLoaded: e.onLoaded
        }) : e.showPayButton ? e.payButton(LX(LX({}, e), {}, {
            status: i,
            disabled: "loading" === i,
            classNameModifiers: [
                "standalone"
            ],
            label: wb(t = "".concat(this.props.i18n.get("continueTo"), " ")).call(t, e.displayName)
        })) : null;
    }
    function UX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function KX(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = UX(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = UX(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function HX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var qX, WX = function(e) {
        U_(r, e);
        var t = HX(r);
        function r(e) {
            var a, n, o, i, l;
            return Cg(this, r), Ag(L_(l = t.call(this, e)), "payButton", function(e) {
                return nN(hw, M_({
                    amount: l.props.amount,
                    onClick: l.submit
                }, e));
            }), l.onComplete = Jg(a = l.onComplete).call(a, L_(l)), l.updateWithAction = Jg(n = l.updateWithAction).call(n, L_(l)), l.submit = Jg(o = l.submit).call(o, L_(l)), l.onLoaded = Jg(i = l.onLoaded).call(i, L_(l)), l;
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "formatData",
                value: function() {
                    return {
                        paymentMethod: KX({
                            type: this.type
                        }, this.props.useKlarnaWidget ? {
                            subtype: "sdk"
                        } : {})
                    };
                }
            },
            {
                key: "updateWithAction",
                value: function(e) {
                    if (e.paymentMethodType !== this.type) throw new Error("Invalid Action");
                    this.componentRef.setAction(e);
                }
            },
            {
                key: "onLoaded",
                value: function() {
                    this.setElementStatus("ready");
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(VX, M_({}, this.props, {
                        ref: function(t) {
                            e.componentRef = t;
                        },
                        displayName: this.displayName,
                        onComplete: function(t) {
                            return e.handleAdditionalDetails(t);
                        },
                        onError: this.props.onError,
                        payButton: this.payButton,
                        onLoaded: this.onLoaded
                    })));
                }
            }
        ]), r;
    }(qS);
    function GX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(WX, "type", "klarna"), Ag(WX, "defaultProps", {
        useKlarnaWidget: !1
    });
    var YX = function(e) {
        U_(r, e);
        var t = GX(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "payButton", function(e) {
                return nN(hw, M_({}, e, {
                    label: a.payButtonLabel(),
                    onClick: a.submit
                }));
            }), a;
        }
        return wg(r, [
            {
                key: "displayName",
                get: function() {
                    var e, t = this.props, r = t.i18n, a = t.name;
                    return t.storedPaymentMethodId ? wb(e = "".concat(a, " ")).call(e, r.get("twint.saved")) : a || this.constructor.type;
                }
            },
            {
                key: "payButtonLabel",
                value: function() {
                    var e, t = this.props, r = t.i18n, a = t.amount, n = t.storedPaymentMethodId, o = t.name;
                    return n ? pw(r, a) : wb(e = "".concat(r.get("continueTo"), " ")).call(e, o);
                }
            }
        ]), r;
    }(EW);
    qX = YX, Ag(YX, "type", "twint"), Ag(YX, "defaultProps", {
        type: qX.type,
        showPayButton: !0
    });
    var QX = function(e) {
        var t = e.i18n, r = e.sfpState, a = e.focusedElement, n = e.setFocusOn;
        return nN(FE, {
            label: t.get("creditCard.expiryDateField.title"),
            classNameModifiers: [
                "expireDate",
                "50"
            ],
            errorMessage: r.errors.encryptedExpiryDate && t.get(r.errors.encryptedExpiryDate),
            focused: "encryptedExpiryDate" === a,
            onFocusField: function() {
                return n("encryptedExpiryDate");
            },
            dir: "ltr",
            name: "encryptedExpiryDate",
            errorVisibleToScreenReader: !1
        }, nN(GK, {
            encryptedFieldType: "encryptedExpiryDate",
            className: DP("adyen-checkout__input", "adyen-checkout__input--small", "adyen-checkout__card__exp-date__input", [
                WK["adyen-checkout__input"]
            ], {
                "adyen-checkout__input--error": r.errors.encryptedExpiryDate,
                "adyen-checkout__input--focus": "encryptedExpiryDate" === a,
                "adyen-checkout__input--valid": !!r.valid.encryptedExpiryMonth && !!r.valid.encryptedExpiryYear
            })
        }));
    };
    function ZX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function JX(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = ZX(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = ZX(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var $X = function(e) {
        var t = e.setRootNode, r = JX(JX({}, e), {}, {
            label: e.i18n.get("creditCard.cvcField.title")
        });
        return nN("div", {
            ref: t
        }, nN(GZ, M_({}, e, {
            classNameModifiers: [
                "100"
            ]
        })), nN("div", {
            className: "adyen-checkout__field-wrapper"
        }, nN(QX, e), nN(YZ, M_({}, r, {
            classNameModifiers: [
                "50"
            ]
        }))));
    };
    function XX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function e0(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = XX(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = XX(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function t0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var r0 = function(e) {
        U_(r, e);
        var t = t0(r);
        function r(e) {
            return Cg(this, r), t.call(this, e0(e0({}, e), {}, {
                pinRequired: !0,
                expiryDateRequired: !0,
                fieldsLayoutComponent: $X
            }));
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return e0({
                        brand: e.type
                    }, e);
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e, t, r, a;
                    return {
                        paymentMethod: {
                            type: this.constructor.type,
                            brand: this.props.brand,
                            encryptedCardNumber: null === (e = this.state.data) || void 0 === e ? void 0 : e.encryptedCardNumber,
                            encryptedSecurityCode: null === (t = this.state.data) || void 0 === t ? void 0 : t.encryptedSecurityCode,
                            encryptedExpiryMonth: null === (r = this.state.data) || void 0 === r ? void 0 : r.encryptedExpiryMonth,
                            encryptedExpiryYear: null === (a = this.state.data) || void 0 === a ? void 0 : a.encryptedExpiryYear
                        }
                    };
                }
            }
        ]), r;
    }(tJ);
    function a0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function n0(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = a0(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = a0(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function o0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(r0, "type", "mealVoucher_FR");
    var i0, l0 = function(e) {
        U_(r, e);
        var t = o0(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return n0(n0({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    return n0(n0({}, kI(H_(r.prototype), "formatData", this).call(this)), {}, {
                        browserInfo: this.browserInfo
                    });
                }
            },
            {
                key: "browserInfo",
                get: function() {
                    return Mj();
                }
            }
        ]), r;
    }(hV);
    function s0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function c0(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = s0(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = s0(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function u0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(l0, "type", "onlinebanking_IN");
    var d0 = function(e) {
        U_(r, e);
        var t = u0(r);
        function r(e) {
            return Cg(this, r), t.call(this, c0(c0({}, e), {}, {
                termsAndConditions: r.termsAndConditions
            }));
        }
        return wg(r);
    }(hV);
    function p0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function m0(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = p0(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = p0(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function f0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    i0 = d0, Ag(d0, "type", "onlineBanking_PL"), Ag(d0, "disclaimerUrlsMap", {
        regulation: "https://www.przelewy24.pl/regulamin",
        obligation: "https://www.przelewy24.pl/obowiazek-informacyjny-rodo-platnicy"
    }), Ag(d0, "termsAndConditions", {
        translationKey: "onlineBankingPL.termsAndConditions",
        urls: [
            i0.disclaimerUrlsMap.regulation,
            i0.disclaimerUrlsMap.obligation
        ]
    });
    var h0 = function(e) {
        U_(r, e);
        var t = f0(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return m0(m0({}, kI(H_(r.prototype), "formatProps", this).call(this, m0(m0({}, e), {
                        visibility: {
                            bankAccount: "editable"
                        }
                    }))), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : pJ
                    });
                }
            }
        ]), r;
    }(Aj);
    Ag(h0, "type", "ratepay_directdebit");
    var v0 = {
        virtualPaymentAddress: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "",
            modes: [
                "blur"
            ]
        },
        default: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "",
            modes: [
                "blur"
            ]
        }
    }, y0 = function(e) {
        var t = _D({
            schema: [
                "virtualPaymentAddress"
            ],
            defaultData: e.data,
            rules: v0
        }), r = t.handleChangeFor, a = t.triggerValidation, n = t.data, o = t.valid, i = t.errors, l = t.isValid, s = qP({
            validateInput: null
        }), c = GP(function() {
            a();
        }, [
            a
        ]);
        return KP(function() {
            s.current.validateInput = c, e.onSetInputHandlers(s.current);
        }, [
            c,
            e.onSetInputHandlers
        ]), KP(function() {
            e.onChange({
                data: n,
                valid: o,
                errors: i,
                isValid: l
            });
        }, [
            n,
            o,
            i,
            l
        ]), nN(FE, {
            label: "Virtual Payment Address",
            errorMessage: !!i.virtualPaymentAddress,
            classNameModifiers: [
                "vpa"
            ],
            name: "virtualPaymentAddress"
        }, nN(FD, {
            name: "virtualPaymentAddress",
            autocorrect: "off",
            spellcheck: !1,
            disabled: e.disabled,
            value: n.virtualPaymentAddress,
            onInput: r("virtualPaymentAddress", "input"),
            onBlur: r("virtualPaymentAddress", "blur")
        }));
    };
    function g0(e) {
        var t, r = e.classNameModifiers, a = e.selectedValue, n = e.disabled, o = void 0 !== n && n, i = e.options, l = e.onChange;
        return i && 0 !== i.length ? nN("div", {
            className: DP.apply(void 0, wb(t = [
                "adyen-checkout__segmented-control",
                {
                    "adyen-checkout__segmented-control--disabled": o
                }
            ]).call(t, Uk(hC(r).call(r, function(e) {
                return "adyen-checkout__segmented-control--".concat(e);
            })))),
            role: "group"
        }, hC(i).call(i, function(e) {
            var t = e.label, r = e.value, n = e.htmlProps;
            return nN("button", M_({
                disabled: o,
                key: r,
                onClick: function(e) {
                    return l(r, e);
                },
                className: DP("adyen-checkout__segmented-control-segment", {
                    "adyen-checkout__segmented-control-segment--selected": a === r
                }),
                type: "button"
            }, n), t);
        })) : null;
    }
    var b0 = function(e) {
        return e.Vpa = "vpa", e.QrCode = "qrCode", e;
    }({}), k0 = {
        ButtonId: {
            VPA: "upi-button-".concat(b0.Vpa),
            QR: "upi-button-".concat(b0.QrCode)
        },
        AreaId: {
            VPA: "upi-area-".concat(b0.Vpa),
            QR: "upi-area-".concat(b0.QrCode)
        }
    };
    function C0(e) {
        var t = e.defaultMode, r = e.onChange, a = e.onUpdateMode, n = e.payButton, o = e.showPayButton, i = sw().i18n, l = II(), s = Vk(VP(null), 2), c = s[0], u = s[1], d = Vk(VP("ready"), 2), p = d[0], m = d[1], f = Vk(VP(t), 2), h = f[0], v = f[1];
        this.setStatus = function(e) {
            m(e);
        }, this.showValidation = function() {
            c.validateInput();
        };
        var y = GP(function(e) {
            u(e);
        }, []), g = GP(function(e) {
            v(e), a(e);
        }, [
            a
        ]);
        return nN(iN, null, nN("p", {
            className: "adyen-checkout_upi-mode-selection-text"
        }, i.get("upi.modeSelection")), nN(g0, {
            onChange: g,
            selectedValue: h,
            disabled: "loading" === p,
            classNameModifiers: [
                "upi-margin-bottom"
            ],
            options: [
                {
                    label: Aq() ? "VPA" : "Virtual Payment Address",
                    value: b0.Vpa,
                    htmlProps: {
                        id: k0.ButtonId.VPA,
                        "aria-expanded": h === b0.Vpa,
                        "aria-controls": k0.AreaId.VPA
                    }
                },
                {
                    label: "QR Code",
                    value: b0.QrCode,
                    htmlProps: {
                        id: k0.ButtonId.QR,
                        "aria-expanded": h === b0.QrCode,
                        "aria-controls": k0.AreaId.QR
                    }
                }
            ]
        }), h === b0.Vpa ? nN("div", {
            id: k0.AreaId.VPA,
            "aria-labelledby": k0.ButtonId.VPA,
            role: "region"
        }, nN(y0, {
            disabled: "loading" === p,
            onChange: r,
            onSetInputHandlers: y
        }), o && n({
            label: i.get("continue"),
            status: p
        })) : nN("div", {
            id: k0.AreaId.QR,
            "aria-labelledby": k0.ButtonId.QR,
            role: "region"
        }, o && n({
            label: i.get("generateQRCode"),
            icon: l({
                imageFolder: "components/"
            })("qr"),
            status: p
        })));
    }
    function _0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function N0(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = _0(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = _0(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function P0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var w0 = function(e) {
        return e.UpiCollect = "upi_collect", e.UpiQr = "upi_qr", e;
    }(w0 || {}), A0 = function(e) {
        U_(r, e);
        var t = P0(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "useQrCodeVariant", void 0), Ag(L_(a), "onUpdateMode", function(e) {
                e === b0.QrCode ? (a.useQrCodeVariant = !0, a.setState({
                    data: {},
                    valid: {},
                    errors: {},
                    isValid: !0
                })) : a.useQrCodeVariant = !1;
            }), a;
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return this.useQrCodeVariant || !!this.state.isValid;
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.state.data.virtualPaymentAddress;
                    return {
                        paymentMethod: N0({
                            type: this.useQrCodeVariant ? w0.UpiQr : w0.UpiCollect
                        }, e && !this.useQrCodeVariant && {
                            virtualPaymentAddress: e
                        })
                    };
                }
            },
            {
                key: "renderContent",
                value: function(e) {
                    var t = this;
                    switch(e){
                        case "qrCode":
                            return nN(OQ, M_({
                                ref: function(e) {
                                    t.componentRef = e;
                                }
                            }, this.props, {
                                qrCodeData: this.props.qrCodeData ? encodeURIComponent(this.props.qrCodeData) : null,
                                type: w0.UpiQr,
                                brandLogo: this.props.brandLogo || this.icon,
                                onComplete: this.onComplete,
                                introduction: this.props.i18n.get("upi.qrCodeWaitingMessage"),
                                countdownTime: 5,
                                onActionHandled: this.props.onActionHandled
                            }));
                        case "await":
                            return nN(M$, {
                                ref: function(e) {
                                    t.componentRef = e;
                                },
                                onError: this.props.onError,
                                clientKey: this.props.clientKey,
                                paymentData: this.props.paymentData,
                                onComplete: this.onComplete,
                                brandLogo: this.icon,
                                type: w0.UpiCollect,
                                messageText: this.props.i18n.get("upi.vpaWaitingMessage"),
                                awaitText: this.props.i18n.get("await.waitForConfirmation"),
                                showCountdownTimer: !0,
                                countdownTime: 5,
                                onActionHandled: this.props.onActionHandled
                            });
                        default:
                            return nN(C0, {
                                ref: function(e) {
                                    t.componentRef = e;
                                },
                                payButton: this.payButton,
                                onChange: this.setState,
                                onUpdateMode: this.onUpdateMode,
                                defaultMode: this.props.defaultMode,
                                showPayButton: this.props.showPayButton
                            });
                    }
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props.type;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(_j, {
                        srPanel: this.props.modules.srPanel
                    }, this.renderContent(e)));
                }
            }
        ]), r;
    }(qS);
    function S0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function I0(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = S0(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = S0(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function E0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(A0, "type", "upi"), Ag(A0, "defaultProps", {
        defaultMode: b0.Vpa
    });
    var D0 = function(e) {
        U_(r, e);
        var t = E0(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return I0(I0({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    return I0(I0({}, kI(H_(r.prototype), "formatData", this).call(this)), {}, {
                        browserInfo: this.browserInfo
                    });
                }
            },
            {
                key: "browserInfo",
                get: function() {
                    return Mj();
                }
            }
        ]), r;
    }(hV);
    function R0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function F0(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = R0(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = R0(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function x0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(D0, "type", "wallet_IN");
    var T0 = function(e) {
        U_(r, e);
        var t = x0(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return F0(F0({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1,
                        termsAndConditions: r.termsAndConditions
                    });
                }
            },
            {
                key: "icon",
                get: function() {
                    var e;
                    return null !== (e = this.props.icon) && void 0 !== e ? e : this.resources.getImage()("bankTransfer_IBAN");
                }
            }
        ]), r;
    }(hV);
    function z0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function O0(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = z0(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = z0(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function j0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(T0, "type", "onlineBanking_CZ"), Ag(T0, "termsAndConditions", {
        translationKey: "onlineBanking.termsAndConditions",
        urls: [
            "https://static.payu.com/sites/terms/files/payu_privacy_policy_cs.pdf"
        ]
    });
    var B0 = function(e) {
        U_(r, e);
        var t = j0(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return O0(O0({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1,
                        termsAndConditions: r.termsAndConditions
                    });
                }
            },
            {
                key: "icon",
                get: function() {
                    var e;
                    return null !== (e = this.props.icon) && void 0 !== e ? e : this.resources.getImage()("bankTransfer_IBAN");
                }
            }
        ]), r;
    }(hV);
    function M0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function L0(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = M0(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = M0(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function V0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(B0, "type", "onlineBanking_SK"), Ag(B0, "termsAndConditions", {
        translationKey: "onlineBanking.termsAndConditions",
        urls: [
            "https://static.payu.com/sites/terms/files/payu_privacy_policy_sk.pdf"
        ]
    });
    var U0 = function(e) {
        U_(r, e);
        var t = V0(r);
        function r(e) {
            return Cg(this, r), t.call(this, L0(L0({}, e), {}, {
                showPaymentMethodItemImages: !0
            }));
        }
        return wg(r);
    }(hV);
    Ag(U0, "type", "paybybank");
    function K0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function H0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var q0 = function(e) {
        U_(r, e);
        var t = H0(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Sg(r = K0(Object(n), !0)).call(r, function(t) {
                                Ag(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Sg(a = K0(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        delay: 2e3,
                        countdownTime: 1.5
                    }, kI(H_(r.prototype), "formatProps", this).call(this, e));
                }
            }
        ]), r;
    }(LQ);
    Ag(q0, "type", "promptpay");
    function W0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function G0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var Y0 = function(e) {
        U_(r, e);
        var t = G0(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Sg(r = W0(Object(n), !0)).call(r, function(t) {
                                Ag(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Sg(a = W0(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        delay: 2e3,
                        countdownTime: 1.5
                    }, kI(H_(r.prototype), "formatProps", this).call(this, e));
                }
            }
        ]), r;
    }(LQ);
    Ag(Y0, "type", "duitnow");
    var Q0 = {
        beneficiaryId: {
            validate: function(e) {
                return KD(e) || /^\d{11}$/.test(e);
            },
            errorMessage: "ancv.beneficiaryId.invalid",
            modes: [
                "blur"
            ]
        }
    };
    function Z0(e) {
        var t = this, r = e.showPayButton, a = e.payButton, n = e.onChange, o = e.onSubmit, i = sw().i18n, l = _D({
            schema: [
                "beneficiaryId"
            ],
            rules: Q0
        }), s = l.handleChangeFor, c = l.triggerValidation, u = l.data, d = l.valid, p = l.errors, m = l.isValid;
        KP(function() {
            n({
                data: u,
                errors: p,
                valid: d,
                isValid: m
            }, t);
        }, [
            u,
            d,
            p,
            m
        ]);
        var f = Vk(VP("ready"), 2), h = f[0], v = f[1];
        return this.setStatus = v, this.showValidation = c, nN(HK, null, nN("div", {
            className: "adyen-checkout__ancv"
        }, nN("p", {
            className: "adyen-checkout-form-instruction"
        }, i.get("ancv.form.instruction")), nN(FE, {
            errorMessage: !!p.beneficiaryId && i.get(p.beneficiaryId.errorMessage),
            label: i.get("ancv.input.label"),
            isValid: d.beneficiaryId,
            name: "beneficiaryId"
        }, nN(FD, {
            value: u.beneficiaryId,
            name: "beneficiaryId",
            spellcheck: !0,
            required: !0,
            onInput: s("beneficiaryId", "input"),
            onBlur: s("beneficiaryId", "blur")
        })), r && a({
            status: h,
            label: i.get("confirmPurchase"),
            onClick: o
        })));
    }
    Z0.defaultProps = {};
    var J0 = 6e4, $0 = 1e4, X0 = !1;
    function e1(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var t1 = function(e) {
        U_(r, e);
        var t = e1(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Ag(L_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "onOrderRequest", function(e) {
                return a.props.onOrderRequest ? new Ab(function(t, r) {
                    a.props.onOrderRequest(t, r, e);
                }) : a.props.session ? a.props.session.createOrder() : void 0;
            }), Ag(L_(a), "handleOrder", function(e) {
                var t = e.order;
                if (a.updateParent({
                    order: t
                }), a.props.session && a.props.onOrderCreated) return a.props.onOrderCreated(t);
            }), Ag(L_(a), "createOrder", function() {
                a.setStatus("loading"), a.props.order ? a.onSubmit() : a.onOrderRequest(a.data).then(function(e) {
                    return a.setState({
                        order: {
                            orderData: e.orderData,
                            pspReference: e.pspReference
                        }
                    }), a.onSubmit();
                }).catch(function(e) {
                    a.setStatus((null == e ? void 0 : e.message) || "error"), a.props.onError && a.handleError(new LS("ERROR", e));
                });
            }), Ag(L_(a), "payButton", function(e) {
                return nN(hw, e);
            }), a;
        }
        return wg(r, [
            {
                key: "formatData",
                value: function() {
                    var e;
                    return {
                        paymentMethod: {
                            type: r.type,
                            beneficiaryId: null === (e = this.state.data) || void 0 === e ? void 0 : e.beneficiaryId
                        }
                    };
                }
            },
            {
                key: "submit",
                value: function() {
                    if (!this.isValid) return this.showValidation(), !1;
                    this.createOrder();
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "displayName",
                get: function() {
                    return this.props.name;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.paymentData ? nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(_j, {
                        srPanel: this.props.modules.srPanel
                    }, nN(M$, {
                        ref: function(t) {
                            e.componentRef = t;
                        },
                        clientKey: this.props.clientKey,
                        paymentData: this.props.paymentData,
                        onError: this.props.onError,
                        onComplete: this.onComplete,
                        brandLogo: this.icon,
                        type: this.constructor.type,
                        messageText: this.props.i18n.get("ancv.confirmPayment"),
                        awaitText: this.props.i18n.get("await.waitForConfirmation"),
                        showCountdownTimer: X0,
                        throttleTime: J0,
                        throttleInterval: $0,
                        onActionHandled: this.props.onActionHandled
                    }))) : nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN(Z0, M_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, {
                        onSubmit: this.submit,
                        onChange: this.setState,
                        payButton: this.payButton,
                        showPayButton: this.props.showPayButton
                    })));
                }
            }
        ]), r;
    }(qS);
    function r1(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(t1, "type", "ancv");
    var a1 = function(e) {
        U_(r, e);
        var t = r1(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "displayName",
                get: function() {
                    return this.props.name || this.constructor.type;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return nN(pj, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, nN("div", {
                        className: "adyen-checkout-trustly"
                    }, nN("p", {
                        className: "adyen-checkout-trustly__descriptor"
                    }, this.props.i18n.get("trustly.descriptor")), nN("ul", {
                        className: "adyen-checkout-trustly__description-list"
                    }, nN("li", null, this.props.i18n.get("trustly.description1")), nN("li", null, this.props.i18n.get("trustly.description2")))), this.props.showPayButton && nN(dV, M_({}, this.props, {
                        name: this.displayName,
                        onSubmit: this.submit,
                        payButton: this.payButton,
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    })));
                }
            }
        ]), r;
    }(EW);
    function n1() {
        var e, t = sw().i18n, r = t.get("payme.instructions.steps"), a = t.get("payme.instructions.footnote");
        return nN("div", {
            className: "adyen-checkout-payme-instructions"
        }, nN("ol", {
            className: "adyen-checkout-payme-instructions__steps"
        }, hC(e = r.split("%@")).call(e, function(e, t) {
            return nN("li", {
                key: "instruction-".concat(t)
            }, e);
        })), nN("span", null, a));
    }
    function o1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function i1(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(a1, "type", "trustly");
    var l1 = function(e) {
        U_(r, e);
        var t = i1(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Sg(r = o1(Object(n), !0)).call(r, function(t) {
                                Ag(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Sg(a = o1(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        delay: r.defaultDelay,
                        countdownTime: r.defaultCountdown,
                        redirectIntroduction: "payme.openPayMeApp",
                        introduction: "payme.scanQrCode",
                        timeToPay: "payme.timeToPay",
                        buttonLabel: "payme.redirectButtonLabel",
                        instructions: n1
                    }, kI(H_(r.prototype), "formatProps", this).call(this, e));
                }
            }
        ]), r;
    }(LQ);
    function s1(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    Ag(l1, "type", "payme"), Ag(l1, "defaultCountdown", 10), Ag(l1, "defaultDelay", 2e3);
    var c1 = function(e) {
        U_(r, e);
        var t = s1(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r);
    }(hV);
    Ag(c1, "type", "ebanking_FI");
    var u1 = [
        "AT",
        "CH",
        "DE"
    ], d1 = [
        "NO",
        "SE",
        "FI",
        "DK",
        "DE",
        "AT",
        "CH",
        "NL",
        "BE"
    ], p1 = {
        default: {
            labels: Ag(Ag({}, wR, "deliveryAddress.firstName"), AR, "deliveryAddress.lastName"),
            schema: [
                PR,
                [
                    [
                        wR,
                        50
                    ],
                    [
                        AR,
                        50
                    ]
                ],
                [
                    [
                        bR,
                        70
                    ],
                    [
                        kR,
                        30
                    ]
                ],
                [
                    [
                        CR,
                        30
                    ],
                    [
                        _R,
                        70
                    ]
                ]
            ]
        }
    }, m1 = {
        at: {
            en: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/at_en",
            de: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/at_de"
        },
        ch: {
            en: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/ch_en",
            de: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/ch_de",
            fr: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/ch_fr"
        },
        de: {
            en: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/de_en",
            de: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/de_de"
        }
    };
    function f1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function h1(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = f1(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = f1(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function v1(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var y1 = function(e) {
        U_(r, e);
        var t = v1(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t;
                    return h1(h1({}, kI(H_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        billingAddressSpecification: h1(h1({}, e.billingAddressSpecification), {}, {
                            allowedCountries: e.countryCode ? [
                                e.countryCode
                            ] : u1
                        }),
                        deliveryAddressSpecification: h1(h1({}, e.deliveryAddressSpecification), {}, {
                            allowedCountries: d1
                        }),
                        consentCheckboxLabel: nN(Sj, {
                            url: Dj(e.countryCode, null === (t = e.i18n) || void 0 === t ? void 0 : t.locale, m1)
                        })
                    });
                }
            }
        ]), r;
    }(Aj);
    function g1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function b1(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = g1(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = g1(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    Ag(y1, "type", "riverty"), Ag(y1, "defaultProps", h1({
        personalDetailsRequiredFields: [
            "firstName",
            "lastName",
            "dateOfBirth",
            "shopperEmail",
            "telephoneNumber"
        ],
        deliveryAddressSpecification: p1
    }, Aj.defaultProps));
    var k1 = {
        address: xX,
        bankTransfer_IBAN: lX,
        donation: kW,
        dropin: n$,
        personal_details: zX,
        amex: Kq,
        bcmc: cW,
        card: Kq,
        diners: Kq,
        discover: Kq,
        jcb: Kq,
        kcp: Kq,
        maestro: Kq,
        mc: Kq,
        scheme: Kq,
        storedCard: Kq,
        securedfields: NY,
        threeDS2Challenge: rQ,
        threeDS2DeviceFingerprint: dQ,
        visa: Kq,
        ach: b$,
        directdebit_GB: RX,
        sepadirectdebit: SY,
        affirm: pX,
        afterpay: Tj,
        afterpay_default: Tj,
        afterpay_b2b: Bj,
        atome: OB,
        facilypay_3x: vG,
        facilypay_4x: kG,
        facilypay_6x: PG,
        facilypay_10x: IG,
        facilypay_12x: FG,
        ratepay: vJ,
        ratepay_directdebit: h0,
        riverty: y1,
        amazonpay: fB,
        applepay: SB,
        cashapp: tW,
        clicktopay: oW,
        googlepay: $W,
        paypal: aY,
        paywithgoogle: $W,
        qiwiwallet: hY,
        boletobancario: SZ,
        boletobancario_bancodobrasil: SZ,
        boletobancario_bradesco: SZ,
        boletobancario_hsbc: SZ,
        boletobancario_itau: SZ,
        boletobancario_santander: SZ,
        doku: hZ,
        doku_alfamart: hZ,
        doku_permata_lite_atm: hZ,
        doku_indomaret: hZ,
        doku_atm_mandiri_va: hZ,
        doku_sinarmas_va: hZ,
        doku_mandiri_va: hZ,
        doku_cimb_va: hZ,
        doku_danamon_va: hZ,
        doku_bri_va: hZ,
        doku_bni_va: hZ,
        doku_bca_va: hZ,
        doku_wallet: hZ,
        oxxo: FZ,
        primeiropay_boleto: SZ,
        billdesk_online: bV,
        billdesk_wallet: NV,
        dotpay: MZ,
        entercash: eG,
        eps: KZ,
        molpay_ebanking_fpx_MY: JQ,
        molpay_ebanking_TH: XQ,
        molpay_ebanking_VN: tZ,
        onlineBanking: MZ,
        onlineBanking_CZ: T0,
        onlinebanking_IN: l0,
        onlineBanking_PL: d0,
        onlineBanking_SK: B0,
        paybybank: U0,
        payu_IN_cashcard: lJ,
        payu_IN_nb: dJ,
        wallet_IN: D0,
        ebanking_FI: c1,
        dragonpay_ebanking: cZ,
        dragonpay_otc_banking: cZ,
        dragonpay_otc_non_banking: cZ,
        dragonpay_otc_philippines: cZ,
        econtext_atm: dG,
        econtext_online: dG,
        econtext_seven_eleven: dG,
        econtext_stores: dG,
        giropay: xW,
        multibanco: jZ,
        redirect: EW,
        twint: YX,
        vipps: aJ,
        trustly: a1,
        klarna: WX,
        klarna_b2b: WX,
        klarna_account: WX,
        klarna_paynow: WX,
        bcmc_mobile: QQ,
        bcmc_mobile_QR: QQ,
        pix: bX,
        swish: bJ,
        wechatpay: KQ,
        wechatpayQR: KQ,
        promptpay: q0,
        paynow: WQ,
        duitnow: Y0,
        payme: l1,
        blik: rX,
        mbway: K$,
        upi: A0,
        upi_qr: A0,
        upi_collect: A0,
        ancv: t1,
        giftcard: tJ,
        mealVoucher_FR_natixis: r0,
        mealVoucher_FR_sodexo: r0,
        mealVoucher_FR_groupeup: r0,
        default: null
    }, C1 = function(e, t) {
        var r, a = k1[e] || k1.default;
        return a ? new a(b1(b1({}, t), {}, {
            id: wb(r = "".concat(e, "-")).call(r, FN())
        })) : null;
    }, _1 = function(e) {
        var t = e;
        return "scheme" === e && (t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2] ? "storedCard" : "card"), (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {})[t] || {};
    };
    function N1(e) {
        return !this.length || Kk(this).call(this, e.type) > -1;
    }
    function P1(e) {
        return !this.length || Kk(this).call(this, e.type) < 0;
    }
    function w1(e) {
        var t;
        return !!e && !!e.supportedShopperInteractions && kb(t = e.supportedShopperInteractions).call(t, "Ecommerce");
    }
    var A1 = [
        "scheme",
        "blik",
        "twint",
        "ach",
        "cashapp"
    ];
    function S1(e) {
        return !!e && !!e.type && kb(A1).call(A1, e.type);
    }
    function I1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function E1(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = I1(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = I1(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var D1 = function(e) {
        return E1(E1({}, e), {}, {
            storedPaymentMethodId: e.id
        });
    }, R1 = function() {
        function e(t) {
            var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            Cg(this, e), Ag(this, "paymentMethods", []), Ag(this, "storedPaymentMethods", []), function(e) {
                var t, r;
                if ("string" == typeof e) throw new Error('paymentMethodsResponse was provided but of an incorrect type (should be an object but a string was provided).Try JSON.parse("{...}") your paymentMethodsResponse.');
                if (e instanceof Array) throw new Error("paymentMethodsResponse was provided but of an incorrect type (should be an object but an array was provided).Please check you are passing the whole response.");
                !e || null != e && null !== (t = e.paymentMethods) && void 0 !== t && t.length || null != e && null !== (r = e.storedPaymentMethods) && void 0 !== r && r.length || console.warn("paymentMethodsResponse was provided but no payment methods were found.");
            }(t), this.paymentMethods = t ? function(e, t) {
                var r, a = t.allowPaymentMethods, n = void 0 === a ? [] : a, o = t.removePaymentMethods, i = void 0 === o ? [] : o;
                return e ? xg(r = xg(e).call(e, N1, n)).call(r, P1, i) : [];
            }(t.paymentMethods, r) : [], this.storedPaymentMethods = t ? function(e, t) {
                var r, a, n, o, i = t.allowPaymentMethods, l = void 0 === i ? [] : i, s = t.removePaymentMethods, c = void 0 === s ? [] : s;
                return e ? hC(r = xg(a = xg(n = xg(o = xg(e).call(e, S1)).call(o, N1, l)).call(n, P1, c)).call(a, w1)).call(r, D1) : [];
            }(t.storedPaymentMethods, r) : [];
        }
        return wg(e, [
            {
                key: "mapCreatedComponentType",
                value: function(e) {
                    return "card" === e ? "scheme" : e;
                }
            },
            {
                key: "has",
                value: function(e) {
                    var t, r = this;
                    return Boolean(zb(t = this.paymentMethods).call(t, function(t) {
                        return t.type === r.mapCreatedComponentType(e);
                    }));
                }
            },
            {
                key: "find",
                value: function(e) {
                    var t, r = this;
                    return zb(t = this.paymentMethods).call(t, function(t) {
                        return t.type === r.mapCreatedComponentType(e);
                    });
                }
            }
        ]), e;
    }();
    function F1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function x1(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = F1(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = F1(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var T1 = function(e) {
        return function(t, r) {
            return C1(t.paymentMethodType, x1(x1(x1({}, r), t), {}, {
                onComplete: r.onAdditionalDetails,
                onError: r.onError,
                statusType: e
            }));
        };
    }, z1 = {
        redirect: function(e, t) {
            return C1("redirect", x1(x1(x1({}, t), e), {}, {
                statusType: "redirect"
            }));
        },
        threeDS2Fingerprint: function(e, t) {
            return C1("threeDS2DeviceFingerprint", x1(x1({
                createFromAction: t.createFromAction,
                token: e.token,
                paymentData: e.paymentData,
                onError: t.onError,
                showSpinner: !t.isDropin,
                isDropin: !!t.isDropin
            }, t), {}, {
                type: "IdentifyShopper",
                onComplete: t.onAdditionalDetails,
                statusType: "loading",
                useOriginalFlow: !0
            }));
        },
        threeDS2Challenge: function(e, t) {
            var r;
            return C1("threeDS2Challenge", x1(x1({}, t), {}, {
                token: e.token,
                paymentData: e.paymentData,
                onComplete: t.onAdditionalDetails,
                onError: t.onError,
                size: null !== (r = t.size) && void 0 !== r ? r : "02",
                isDropin: !!t.isDropin,
                type: "ChallengeShopper",
                statusType: "custom",
                useOriginalFlow: !0
            }));
        },
        threeDS2: function(e, t) {
            var r, a = "fingerprint" === e.subtype ? "threeDS2DeviceFingerprint" : "threeDS2Challenge", n = "fingerprint" === e.subtype ? e.paymentData : e.authorisationToken, o = x1({
                token: e.token,
                paymentData: n,
                onActionHandled: t.onActionHandled,
                onComplete: t.onAdditionalDetails,
                onError: t.onError,
                isDropin: !!t.isDropin,
                loadingContext: t.loadingContext,
                clientKey: t.clientKey,
                _parentInstance: t._parentInstance,
                paymentMethodType: t.paymentMethodType,
                challengeWindowSize: t.challengeWindowSize,
                modules: {
                    analytics: null === (r = t.modules) || void 0 === r ? void 0 : r.analytics
                }
            }, function(e, t) {
                if ("fingerprint" === e) {
                    var r = ZV(t.elementRef ? YY : QY).from(t);
                    return r.showSpinner = !t.isDropin, r.statusType = "loading", r;
                }
                return {
                    statusType: "custom",
                    i18n: t.i18n
                };
            }(e.subtype, t));
            return C1(a, o);
        },
        voucher: T1("custom"),
        qrCode: T1("custom"),
        await: T1("custom"),
        bankTransfer: T1("custom"),
        sdk: T1("custom")
    };
    function O1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    var j1 = function(e) {
        return function(t) {
            var r, a, n = function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r, a, n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Sg(r = O1(Object(n), !0)).call(r, function(t) {
                        Ag(e, t, n[t]);
                    }) : Jy ? ng(e, Jy(n)) : Sg(a = O1(Object(n))).call(a, function(t) {
                        og(e, t, Wy(n, t));
                    });
                }
                return e;
            }({
                version: "5.65.0",
                payload_version: 1,
                platform: "web",
                locale: e.locale
            }, t), o = hC(r = Ty(n)).call(r, function(e) {
                var t;
                return wb(t = "".concat(encodeURIComponent(e), "=")).call(t, encodeURIComponent(n[e]));
            }).join("&");
            (new Image).src = wb(a = "".concat(e.loadingContext, "images/analytics.png?")).call(a, o);
        };
    }, B1 = function() {
        function e() {
            Cg(this, e), Ag(this, "storage", void 0), this.storage = {};
        }
        return wg(e, [
            {
                key: "length",
                get: function() {
                    return Ty(this.storage).length;
                }
            },
            {
                key: "key",
                value: function(e) {
                    return Ty(this.storage)[e];
                }
            },
            {
                key: "getItem",
                value: function(e) {
                    return this.storage[e] || null;
                }
            },
            {
                key: "setItem",
                value: function(e, t) {
                    return this.storage[e] = t;
                }
            },
            {
                key: "removeItem",
                value: function(e) {
                    delete this.storage[e];
                }
            },
            {
                key: "clear",
                value: function() {
                    this.storage = {};
                }
            }
        ]), e;
    }(), M1 = function() {
        function e(t, r) {
            Cg(this, e), Ag(this, "prefix", "adyen-checkout__"), Ag(this, "key", void 0), Ag(this, "storage", void 0);
            try {
                if (this.storage = r ? window[r] : window.localStorage, !this.storage) throw new Error("storage does not exist");
            } catch (e) {
                this.storage = new B1;
            }
            this.key = this.prefix + t;
        }
        return wg(e, [
            {
                key: "get",
                value: function() {
                    try {
                        return JSON.parse(this.storage.getItem(this.key));
                    } catch (e) {
                        return null;
                    }
                }
            },
            {
                key: "set",
                value: function(e) {
                    this.storage.setItem(this.key, Mb(e));
                }
            },
            {
                key: "remove",
                value: function() {
                    this.storage.removeItem(this.key);
                }
            },
            {
                key: "clear",
                value: function() {
                    this.storage.clear();
                }
            },
            {
                key: "keyByIndex",
                value: function(e) {
                    return this.storage.key(e);
                }
            },
            {
                key: "length",
                get: function() {
                    return this.storage.length;
                }
            }
        ]), e;
    }();
    function L1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    var V1 = function(e) {
        var t, r, a = e.analyticsContext, n = e.clientKey, o = e.locale, i = e.analyticsPath, l = {
            errorLevel: "fatal",
            loadingContext: a,
            path: wb(t = "".concat(i, "?clientKey=")).call(t, n)
        };
        return function(e) {
            var t = function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r, a, n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Sg(r = L1(Object(n), !0)).call(r, function(t) {
                        Ag(e, t, n[t]);
                    }) : Jy ? ng(e, Jy(n)) : Sg(a = L1(Object(n))).call(a, function(t) {
                        og(e, t, Wy(n, t));
                    });
                }
                return e;
            }({
                version: "5.65.0",
                channel: "Web",
                platform: "Web",
                buildType: window.AdyenCheckout ? "umd" : "compiled",
                locale: o,
                referrer: window.location.href,
                screenWidth: window.screen.width
            }, e);
            if (r) return r;
            if (!n) return Ab.reject("no-client-key");
            var a = new M1("checkout-attempt-id", "sessionStorage"), i = a.get();
            return function(e) {
                if (null == e || !e.id) return !1;
                var t = SE() - 9e5;
                return e.timestamp > t;
            }(i) ? Ab.resolve(i.id) : r = zT(l, t).then(function(e) {
                if (null != e && e.checkoutAttemptId) return a.set({
                    id: e.checkoutAttemptId,
                    timestamp: SE()
                }), e.checkoutAttemptId;
            }).catch(function() {
                return Ab.reject('WARNING: Failed to retrieve "checkoutAttemptId". Consequently, analytics will not be available for this payment. The payment process, however, will not be affected.');
            });
        };
    }, U1 = function(e) {
        var t = e.analyticsContext, r = e.clientKey, a = e.analyticsPath, n = {
            channel: "Web",
            platform: "Web",
            info: [],
            errors: [],
            logs: []
        }, o = {
            add: function(e, t) {
                n[e].push(t);
            },
            run: function(e) {
                var o = function(e) {
                    var o, i;
                    return n.info.length || n.logs.length || n.errors.length ? zT({
                        errorLevel: "silent",
                        loadingContext: t,
                        path: wb(o = wb(i = "".concat(a, "/")).call(i, e, "?clientKey=")).call(o, r)
                    }, n).then(function() {}).catch(function() {
                        console.debug("### EventsQueue:::: send has failed");
                    }) : Ab.resolve(null);
                }(e);
                return n.info = [], n.errors = [], n.logs = [], o;
            },
            getQueue: function() {
                return n;
            }
        };
        return o;
    };
    function K1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function H1(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = K1(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = K1(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var q1 = function(e, t) {
        var r, a, n;
        return e === bE[cE] || "invalidFormatExpects" === e ? null !== (a = $N[wb(n = "".concat(e, ".")).call(n, t)]) && void 0 !== a ? a : e : null !== (r = $N[e]) && void 0 !== r ? r : e;
    }, W1 = function(e) {
        var t;
        return tC(t = Ty(e)).call(t, function(t, r) {
            return kb(eP).call(eP, r) && (t[r] = e[r]), t;
        }, {});
    };
    function G1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Y1(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = G1(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = G1(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function Q1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Z1(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = Q1(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = Q1(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var J1 = null, $1 = !1, X1 = null, e2 = function(e) {
        var t, r, a = e.loadingContext, n = e.locale, o = e.clientKey, i = e.analytics, l = e.amount, s = e.analyticsContext, c = Z1(Z1({}, {
            enabled: !0,
            telemetry: !0,
            checkoutAttemptId: null,
            analyticsData: {}
        }), i), u = j1({
            loadingContext: a,
            locale: n
        }), d = V1({
            analyticsContext: s,
            clientKey: o,
            locale: n,
            amount: l,
            analyticsPath: xN
        }), p = U1({
            analyticsContext: s,
            clientKey: o,
            analyticsPath: xN
        }), m = function() {
            return J1 ? p.run(J1) : Ab.resolve(null);
        }, f = {
            setUp: (t = Jd(Dy.mark(function e(t) {
                var r, a, n, o, i;
                return Dy.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            if (r = c.enabled, a = c.payload, n = c.telemetry, o = W1(c.analyticsData), !0 !== r) {
                                e.next = 15;
                                break;
                            }
                            if (!0 !== n || J1) {
                                e.next = 14;
                                break;
                            }
                            return e.prev = 4, e.next = 7, d(Z1(Z1(Z1({}, t), a && Z1({}, a)), Ty(o).length && Z1({}, o)));
                        case 7:
                            i = e.sent, J1 = i, e.next = 14;
                            break;
                        case 11:
                            e.prev = 11, e.t0 = e.catch(4), console.warn("Fetching checkoutAttemptId failed.".concat(e.t0 ? " Error=".concat(e.t0) : ""));
                        case 14:
                            $1 || (u(t), $1 = !0);
                        case 15:
                        case "end":
                            return e.stop();
                    }
                }, e, null, [
                    [
                        4,
                        11
                    ]
                ]);
            })), function(e) {
                return t.apply(this, arguments);
            }),
            getCheckoutAttemptId: function() {
                return J1;
            },
            getEventsQueue: function() {
                return p;
            },
            createAnalyticsEvent: function(e) {
                var t, r, a, n = e.event, o = function(e) {
                    return H1(H1(H1(H1(H1(H1(H1(H1(H1(H1({
                        timestamp: String(SE()),
                        component: e.component,
                        id: FN()
                    }, "error" === e.event && {
                        code: e.code,
                        errorType: e.errorType,
                        message: e.message
                    }), "log" === e.event && {
                        type: e.type,
                        message: e.message
                    }), "log" === e.event && (e.type === jN || e.type === RY) && {
                        subType: e.subtype
                    }), "log" === e.event && e.type === RY && {
                        result: e.result
                    }), "info" === e.event && {
                        type: e.type,
                        target: e.target
                    }), "info" === e.event && e.issuer && {
                        issuer: e.issuer
                    }), "info" === e.event && {
                        isExpress: e.isExpress,
                        expressPage: e.expressPage
                    }), "info" === e.event && e.isStoredPaymentMethod && {
                        isStoredPaymentMethod: e.isStoredPaymentMethod,
                        brand: e.brand
                    }), "info" === e.event && e.type === HN && {
                        validationErrorCode: q1(e.validationErrorCode, e.target),
                        validationErrorMessage: e.validationErrorMessage
                    }), e.metadata && {
                        metadata: e.metadata
                    });
                }(Z1({
                    event: n
                }, e.data));
                return r = o, a = (t = n) === ON ? t : "".concat(t, "s"), p.add("".concat(a), r), t === ON && (clearTimeout(X1), X1 = NP(m, 1e4)), t !== TN && t !== zN || (clearTimeout(X1), Rz(m)()), o;
            },
            getEnabled: function() {
                return c.enabled;
            },
            sendAnalytics: null
        };
        return f.sendAnalytics = (r = f, function(e, t) {
            var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, n = t.type, o = t.target;
            switch(n){
                case LN:
                    var i = t.isStoredPaymentMethod, l = t.brand, s = a.isExpress, c = a.expressPage, u = c && kb(XN).call(XN, c), d = Y1(Y1(Y1(Y1({
                        component: e,
                        type: n
                    }, "boolean" == typeof i && {
                        isStoredPaymentMethod: i
                    }), l && {
                        brand: l
                    }), "boolean" == typeof s && {
                        isExpress: s
                    }), !0 === s && u && {
                        expressPage: c
                    });
                    r.createAnalyticsEvent({
                        event: ON,
                        data: d
                    });
                    break;
                case GN:
                    var p = {
                        component: e,
                        type: n,
                        isStoredPaymentMethod: t.isStoredPaymentMethod,
                        brand: t.brand
                    };
                    r.createAnalyticsEvent({
                        event: ON,
                        data: p
                    });
                    break;
                case qN:
                case WN:
                case VN:
                case UN:
                case KN:
                    r.createAnalyticsEvent({
                        event: ON,
                        data: {
                            component: e,
                            type: n,
                            target: o
                        }
                    });
                    break;
                case MN:
                    var m = t.issuer;
                    r.createAnalyticsEvent({
                        event: ON,
                        data: {
                            component: e,
                            type: n,
                            target: o,
                            issuer: m
                        }
                    });
                    break;
                case HN:
                    var f = t.validationErrorCode, h = t.validationErrorMessage;
                    r.createAnalyticsEvent({
                        event: ON,
                        data: {
                            component: e,
                            type: n,
                            target: o,
                            validationErrorCode: f,
                            validationErrorMessage: h
                        }
                    });
                    break;
                case BN:
                    r.createAnalyticsEvent({
                        event: TN,
                        data: {
                            component: e,
                            type: n,
                            message: "Shopper clicked pay"
                        }
                    });
                    break;
                case jN:
                    var v = t.subtype, y = t.message;
                    r.createAnalyticsEvent({
                        event: TN,
                        data: {
                            component: e,
                            type: n,
                            subtype: v,
                            message: y
                        }
                    });
                    break;
                case RY:
                    var g = t.message, b = t.metadata, k = t.subtype, C = t.result;
                    r.createAnalyticsEvent({
                        event: TN,
                        data: {
                            component: e,
                            type: n,
                            message: g,
                            metadata: b,
                            subtype: k,
                            result: C
                        }
                    });
                    break;
                case DY:
                    var _ = t.message, N = t.code, P = t.errorType;
                    r.createAnalyticsEvent({
                        event: zN,
                        data: {
                            component: e,
                            type: n,
                            message: _,
                            code: N,
                            errorType: P
                        }
                    });
                    break;
                default:
                    r.createAnalyticsEvent(t);
            }
        }), f;
    };
    function t2(e) {
        var t;
        return tC(t = Ty(e)).call(t, function(t, r) {
            return kb(IT).call(IT, r) && (t[r] = e[r]), t;
        }, {});
    }
    var r2 = "v1";
    function a2(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function n2(e, t) {
        var r, a, n = wb(r = wb(a = "".concat(r2, "/sessions/")).call(a, t.id, "/payments?clientKey=")).call(r, t.clientKey), o = function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Sg(r = a2(Object(n), !0)).call(r, function(t) {
                    Ag(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Sg(a = a2(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({
            sessionData: t.data
        }, e);
        return zT({
            loadingContext: t.loadingContext,
            path: n,
            errorLevel: "fatal"
        }, o);
    }
    function o2(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function i2(e, t) {
        var r, a, n = wb(r = wb(a = "".concat(r2, "/sessions/")).call(a, t.id, "/paymentDetails?clientKey=")).call(r, t.clientKey), o = function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Sg(r = o2(Object(n), !0)).call(r, function(t) {
                    Ag(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Sg(a = o2(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({
            sessionData: t.data
        }, e);
        return zT({
            loadingContext: t.loadingContext,
            path: n,
            errorLevel: "fatal"
        }, o);
    }
    function l2(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function s2(e, t) {
        var r, a, n = wb(r = wb(a = "".concat(r2, "/sessions/")).call(a, e.id, "/setup?clientKey=")).call(r, e.clientKey), o = function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Sg(r = l2(Object(n), !0)).call(r, function(t) {
                    Ag(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Sg(a = l2(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({
            sessionData: e.data
        }, t.order ? {
            order: {
                orderData: t.order.orderData,
                pspReference: t.order.pspReference
            }
        } : {});
        return zT({
            loadingContext: e.loadingContext,
            path: n,
            errorLevel: "fatal",
            errorMessage: "ERROR: Invalid ClientKey"
        }, o);
    }
    function c2(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function u2(e, t) {
        var r, a, n = wb(r = wb(a = "".concat(r2, "/sessions/")).call(a, t.id, "/paymentMethodBalance?clientKey=")).call(r, t.clientKey), o = function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Sg(r = c2(Object(n), !0)).call(r, function(t) {
                    Ag(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Sg(a = c2(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({
            sessionData: t.data
        }, e);
        return zT({
            loadingContext: t.loadingContext,
            path: n,
            errorLevel: "fatal"
        }, o);
    }
    function d2(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function p2(e) {
        if (!e || !e.id) throw new Error("Invalid session");
        return function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Sg(r = d2(Object(n), !0)).call(r, function(t) {
                    Ag(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Sg(a = d2(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({
            id: e.id
        }, e.sessionData ? {
            sessionData: e.sessionData
        } : {});
    }
    function m2(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    var f2 = function() {
        function e(t, r, a) {
            Cg(this, e), Ag(this, "session", void 0), Ag(this, "storage", void 0), Ag(this, "clientKey", void 0), Ag(this, "loadingContext", void 0), Ag(this, "configuration", void 0);
            var n = p2(t);
            if (!r) throw new Error("No clientKey available");
            if (!a) throw new Error("No loadingContext available");
            this.storage = new M1("session", "localStorage"), this.clientKey = r, this.loadingContext = a, this.session = n, this.session.sessionData ? this.storeSession() : this.session = this.getStoredSession();
        }
        return wg(e, [
            {
                key: "id",
                get: function() {
                    return this.session.id;
                }
            },
            {
                key: "data",
                get: function() {
                    return this.session.sessionData;
                }
            },
            {
                key: "updateSessionData",
                value: function(e) {
                    this.session.sessionData = e, this.storeSession();
                }
            },
            {
                key: "setupSession",
                value: function(e) {
                    var t = this;
                    return s2(this, e).then(function(e) {
                        return e.configuration && (t.configuration = function(e) {
                            for(var t = 1; t < arguments.length; t++){
                                var r, a, n = null != arguments[t] ? arguments[t] : {};
                                t % 2 ? Sg(r = m2(Object(n), !0)).call(r, function(t) {
                                    Ag(e, t, n[t]);
                                }) : Jy ? ng(e, Jy(n)) : Sg(a = m2(Object(n))).call(a, function(t) {
                                    og(e, t, Wy(n, t));
                                });
                            }
                            return e;
                        }({}, e.configuration)), e.sessionData && t.updateSessionData(e.sessionData), e;
                    });
                }
            },
            {
                key: "submitPayment",
                value: function(e) {
                    var t = this;
                    return n2(e, this).then(function(e) {
                        return e.sessionData && t.updateSessionData(e.sessionData), e;
                    });
                }
            },
            {
                key: "submitDetails",
                value: function(e) {
                    var t = this;
                    return i2(e, this).then(function(e) {
                        return e.sessionData && t.updateSessionData(e.sessionData), e;
                    });
                }
            },
            {
                key: "checkBalance",
                value: function(e) {
                    var t = this;
                    return u2(e, this).then(function(e) {
                        return e.sessionData && t.updateSessionData(e.sessionData), e;
                    });
                }
            },
            {
                key: "createOrder",
                value: function() {
                    var e = this;
                    return (function(e) {
                        var t, r, a = wb(t = wb(r = "".concat(r2, "/sessions/")).call(r, e.id, "/orders?clientKey=")).call(t, e.clientKey), n = {
                            sessionData: e.data
                        };
                        return zT({
                            loadingContext: e.loadingContext,
                            path: a,
                            errorLevel: "fatal"
                        }, n);
                    })(this).then(function(t) {
                        return t.sessionData && e.updateSessionData(t.sessionData), t;
                    });
                }
            },
            {
                key: "cancelOrder",
                value: function(e) {
                    var t = this;
                    return (function(e, t) {
                        var r, a, n = wb(r = wb(a = "".concat(r2, "/sessions/")).call(a, t.id, "/orders/cancel?clientKey=")).call(r, t.clientKey), o = {
                            sessionData: t.data,
                            order: e
                        };
                        return zT({
                            loadingContext: t.loadingContext,
                            path: n,
                            errorLevel: "fatal"
                        }, o);
                    })(e.order, this).then(function(e) {
                        return e.sessionData && t.updateSessionData(e.sessionData), e;
                    });
                }
            },
            {
                key: "getStoredSession",
                value: function() {
                    var e = this.storage.get();
                    return this.id === (null == e ? void 0 : e.id) ? e : this.session;
                }
            },
            {
                key: "storeSession",
                value: function() {
                    this.storage.set({
                        id: this.session.id,
                        sessionData: this.session.sessionData
                    });
                }
            },
            {
                key: "removeStoredSession",
                value: function() {
                    this.storage.remove();
                }
            }
        ]), e;
    }();
    function h2(e) {
        var t = e.setComponentRef, r = qP({});
        Ty(r.current).length || null == t || t(r.current);
        var a = Vk(VP(null), 2), n = a[0], o = a[1];
        return r.current.setMessages = function(e) {
            o(e);
        }, n ? nN(iN, null, hC(n).call(n, function(e) {
            return nN("div", M_({
                key: e,
                className: "adyen-checkout-sr-panel__msg"
            }, !1), e);
        })) : null;
    }
    function v2(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function y2(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = v2(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = v2(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function g2(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !C_) return !1;
            if (C_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(C_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = H_(e);
            if (t) {
                var n = H_(this).constructor;
                r = C_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return K_(this, r);
        };
    }
    var b2 = function(e) {
        U_(r, e);
        var t = g2(r);
        function r(e) {
            var a, n;
            if (Cg(this, r), Ag(L_(n = t.call(this, e)), "srPanelContainer", null), Ag(L_(n), "id", void 0), Ag(L_(n), "showPanel", void 0), Ag(L_(n), "_enabled", void 0), Ag(L_(n), "_moveFocus", void 0), Ag(L_(n), "componentRef", void 0), Ag(L_(n), "setComponentRef", function(e) {
                n.componentRef = e;
            }), Ag(L_(n), "setMessages", function(e) {
                if (n.props.enabled) {
                    var t = null;
                    e && (t = PP(e) ? e : [
                        e
                    ]), n.componentRef.setMessages(t);
                }
            }), n.id = n.props.id, n.showPanel = !1, n._enabled = !1, n._moveFocus = null === (a = n.props.moveFocus) || void 0 === a || a, n.props.enabled) {
                if (n._enabled = !0, !document.querySelector(n.props.node)) throw new Error("Component could not mount. Root node was not found.");
                var o = document.getElementById(n.id);
                o && document.querySelector(n.props.node).removeChild(o), n.srPanelContainer = document.createElement("div"), n.srPanelContainer.className = "sr-panel-holder", n.srPanelContainer.id = n.id, document.querySelector(n.props.node).appendChild(n.srPanelContainer), n.mount(n.srPanelContainer);
            }
            return n;
        }
        return wg(r, [
            {
                key: "enabled",
                get: function() {
                    return this._enabled;
                }
            },
            {
                key: "moveFocus",
                get: function() {
                    return this._moveFocus;
                }
            },
            {
                key: "setAriaProps",
                value: function(e) {
                    for(var t = document.querySelector('[class^="adyen-checkout-sr-panel"]'), r = 0, a = sO(e); r < a.length; r++){
                        var n = Vk(a[r], 2), o = n[0], i = n[1];
                        t.setAttribute(o, i);
                    }
                    this.props = y2(y2({}, this.props), {}, {
                        ariaAttributes: y2(y2({}, this.props.ariaAttributes), e)
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    return this.props.enabled ? nN("div", M_({
                        className: this.showPanel ? "adyen-checkout-sr-panel" : "adyen-checkout-sr-panel--sr-only",
                        role: "log"
                    }, this.props.ariaAttributes, !1), nN(h2, {
                        setComponentRef: this.setComponentRef
                    })) : null;
                }
            }
        ]), r;
    }(oP);
    Ag(b2, "type", "srPanel"), Ag(b2, "defaultProps", {
        enabled: !0,
        node: "body",
        showPanel: !1,
        id: "ariaLiveSRPanel",
        ariaAttributes: {
            "aria-relevant": "all",
            "aria-live": "polite",
            "aria-atomic": "true"
        }
    });
    var k2 = [
        "amount",
        "shopperLocale",
        "paymentMethods"
    ];
    function C2(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = xg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function _2(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sg(r = C2(Object(n), !0)).call(r, function(t) {
                Ag(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Sg(a = C2(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var N2 = function() {
        function e(t) {
            var r, a, n, o, i, l, s = this;
            Cg(this, e), Ag(this, "session", void 0), Ag(this, "paymentMethodsResponse", void 0), Ag(this, "modules", void 0), Ag(this, "options", void 0), Ag(this, "components", []), Ag(this, "loadingContext", void 0), Ag(this, "cdnContext", void 0), Ag(this, "analyticsContext", void 0), Ag(this, "update", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return s.setOptions(e), s.initialize().then(function() {
                    var e;
                    return Sg(e = s.components).call(e, function(e) {
                        return e.update(s.getPropsForComponent(s.options));
                    }), s;
                });
            }), Ag(this, "remove", function(e) {
                var t;
                return s.components = xg(t = s.components).call(t, function(t) {
                    return t._id !== e._id;
                }), e.unmount(), s;
            }), Ag(this, "setOptions", function(e) {
                VS(null == e ? void 0 : e.paymentMethodsConfiguration, "scheme") && console.warn('WARNING: You cannot define a property "scheme" on the paymentMethodsConfiguration object - it should be defined as "card" otherwise it will be ignored'), VS(e, "installmentOptions") && console.warn("WARNING: you are setting installmentOptions directly in the top level configuration object. They should be set via the 'paymentMethodsConfiguration' object or directly on the 'card' component."), s.options = _2(_2({}, s.options), e);
            }), this.create = Jg(r = this.create).call(r, this), this.createFromAction = Jg(a = this.createFromAction).call(a, this), this.setOptions(t), this.loadingContext = function() {
                var e = arguments.length > 1 ? arguments[1] : void 0;
                return e || ({
                    test: "https://checkoutshopper-test.adyen.com/checkoutshopper/",
                    live: "https://checkoutshopper-live.adyen.com/checkoutshopper/",
                    "live-us": "https://checkoutshopper-live-us.adyen.com/checkoutshopper/",
                    "live-au": "https://checkoutshopper-live-au.adyen.com/checkoutshopper/",
                    "live-apse": "https://checkoutshopper-live-apse.adyen.com/checkoutshopper/",
                    "live-in": "https://checkoutshopper-live-in.adyen.com/checkoutshopper/"
                })[(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").toLowerCase()] || "https://checkoutshopper-live.adyen.com/checkoutshopper/";
            }(this.options.environment, null === (n = this.options.environmentUrls) || void 0 === n ? void 0 : n.api), this.cdnContext = function() {
                var e = arguments.length > 1 ? arguments[1] : void 0;
                return e || ({
                    beta: "https://cdf6519016.cdn.adyen.com/checkoutshopper/",
                    test: "https://checkoutshopper-test.adyen.com/checkoutshopper/",
                    live: "https://checkoutshopper-live.adyen.com/checkoutshopper/",
                    "live-us": "https://checkoutshopper-live-us.adyen.com/checkoutshopper/",
                    "live-au": "https://checkoutshopper-live-au.adyen.com/checkoutshopper/",
                    "live-apse": "https://checkoutshopper-live-apse.adyen.com/checkoutshopper/",
                    "live-in": "https://checkoutshopper-live-in.adyen.com/checkoutshopper/"
                })[(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").toLowerCase()] || rw;
            }(this.options.resourceEnvironment || this.options.environment, null === (o = this.options.environmentUrls) || void 0 === o ? void 0 : o.api), this.analyticsContext = function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "https://checkoutanalytics-live.adyen.com/checkoutanalytics/", t = {
                    test: "https://checkoutanalytics-test.adyen.com/checkoutanalytics/",
                    live: "https://checkoutanalytics-live.adyen.com/checkoutanalytics/",
                    "live-us": "https://checkoutanalytics-live-us.adyen.com/checkoutanalytics/",
                    "live-au": "https://checkoutanalytics-live-au.adyen.com/checkoutanalytics/",
                    "live-apse": "https://checkoutanalytics-live-apse.adyen.com/checkoutanalytics/",
                    "live-in": "https://checkoutanalytics-live-in.adyen.com/checkoutanalytics/"
                };
                return t[e] || t[e.toLowerCase()] || e;
            }(this.options.environment);
            var c, u = null === (i = this.options.clientKey) || void 0 === i ? void 0 : i.substr(0, 4);
            if (("test" === u || "live" === u) && !kb(l = this.loadingContext).call(l, u)) throw new Error(wb(c = "Error: you are using a '".concat(u, "' clientKey against the '")).call(c, this.options.environment, "' environment"));
            window.adyenWebVersion = e.version.version;
        }
        return wg(e, [
            {
                key: "initialize",
                value: function() {
                    var e = this;
                    return this.options.session ? (this.session = new f2(this.options.session, this.options.clientKey, this.loadingContext), this.session.setupSession(this.options).then(function(t) {
                        var r = t.amount, a = t.shopperLocale, n = t.paymentMethods, o = kg(t, k2);
                        return e.setOptions(_2(_2({}, o), {}, {
                            amount: e.options.order ? e.options.order.remainingAmount : r,
                            locale: e.options.locale || a
                        })), e.createPaymentMethodsList(n), e.createCoreModules(), e;
                    }).catch(function(t) {
                        return e.options.onError && e.options.onError(t), e;
                    })) : (this.createCoreModules(), this.createPaymentMethodsList(), Ab.resolve(this));
                }
            },
            {
                key: "submitDetails",
                value: function(e) {
                    var t = this;
                    if (this.options.onAdditionalDetails) return this.options.onAdditionalDetails(e);
                    this.session && this.session.submitDetails(e).then(function(e) {
                        var r, a;
                        null === (r = (a = t.options).onPaymentCompleted) || void 0 === r || r.call(a, e);
                    }).catch(function(e) {
                        var r, a;
                        null === (r = (a = t.options).onError) || void 0 === r || r.call(a, e);
                    });
                }
            },
            {
                key: "create",
                value: function(e, t) {
                    var r = this.getPropsForComponent(t);
                    return e ? this.handleCreate(e, r) : this.handleCreateError();
                }
            },
            {
                key: "createFromAction",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (!e || !e.type) {
                        if (VS(e, "action") && VS(e, "resultCode")) throw new Error('createFromAction::Invalid Action - the passed action object itself has an "action" property and a "resultCode": have you passed in the whole response object by mistake?');
                        throw new Error('createFromAction::Invalid Action - the passed action object does not have a "type" property');
                    }
                    if (e.type) {
                        var r, a = e.type === RY ? wb(r = "".concat(e.type)).call(r, e.subtype) : e.paymentMethodType;
                        this.modules.analytics.sendAnalytics(a, {
                            type: jN,
                            subtype: e.type,
                            message: "".concat(a, " action was handled by the SDK")
                        });
                        var n = _1(e.type, this.options.paymentMethodsConfiguration);
                        return function(e) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = z1[e.type];
                            if (r && "function" == typeof r) return r(e, t);
                            throw new Error("Invalid Action");
                        }(e, _2(_2(_2({}, t2(this.options)), n), this.getPropsForComponent(t)));
                    }
                    return this.handleCreateError();
                }
            },
            {
                key: "getPropsForComponent",
                value: function(e) {
                    return _2(_2(_2({
                        paymentMethods: this.paymentMethodsResponse.paymentMethods,
                        storedPaymentMethods: this.paymentMethodsResponse.storedPaymentMethods
                    }, "FI" === this.options.countryCode ? {
                        openFirstPaymentMethod: !1,
                        openFirstStoredPaymentMethod: !1
                    } : {}), e), {}, {
                        i18n: this.modules.i18n,
                        modules: this.modules,
                        session: this.session,
                        loadingContext: this.loadingContext,
                        cdnContext: this.cdnContext,
                        createFromAction: this.createFromAction,
                        _parentInstance: this
                    });
                }
            },
            {
                key: "handleCreate",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (e.prototype instanceof qS) {
                        var r, a = "dropin" !== t.type && !t.isDropin, n = a && !t.supportedShopperInteractions ? zb(r = this.paymentMethodsResponse).call(r, t.type) : {}, o = a ? _1(t.type, this.options.paymentMethodsConfiguration, !!t.storedPaymentMethodId) : {}, i = new e(_2(_2(_2(_2({}, t2(this.options)), n), o), t));
                        return t.isDropin || this.components.push(i), i;
                    }
                    if ("string" == typeof e && k1[e]) return "dropin" === e && VS(t, "paymentMethodsConfiguration") && console.warn("WARNING: You are setting a 'paymentMethodsConfiguration' object in the Dropin configuration options. This object will be ignored."), this.handleCreate(k1[e], _2({
                        type: e
                    }, t));
                    if ("string" == typeof e && this.paymentMethodsResponse.has(e)) return this.handleCreate(k1.redirect, _2({
                        type: e
                    }, t));
                    if ("object" === ig(e) && "string" == typeof e.type) {
                        var l = _1(e.type, this.options.paymentMethodsConfiguration, !!e.storedPaymentMethodId);
                        return this.handleCreate(e.type, _2(_2(_2({}, e), t), l));
                    }
                    return this.handleCreateError(e);
                }
            },
            {
                key: "handleCreateError",
                value: function(e) {
                    var t, r = e && e.name ? e.name : "The passed payment method", a = e ? wb(t = "".concat(r, " is not a valid Checkout Component. What was passed as a txVariant was: ")).call(t, Mb(e), ". Check if this payment method is configured in the Backoffice or if the txVariant is a valid one") : "No Payment Method component was passed";
                    throw new Error(a);
                }
            },
            {
                key: "createPaymentMethodsList",
                value: function(e) {
                    this.paymentMethodsResponse = new R1(this.options.paymentMethodsResponse || e, this.options);
                }
            },
            {
                key: "createCoreModules",
                value: function() {
                    this.modules || (this.modules = yk({
                        risk: new uI(_2(_2({}, this.options), {}, {
                            loadingContext: this.loadingContext
                        })),
                        analytics: e2({
                            loadingContext: this.loadingContext,
                            analyticsContext: this.analyticsContext,
                            clientKey: this.options.clientKey,
                            locale: this.options.locale,
                            analytics: this.options.analytics,
                            amount: this.options.amount
                        }),
                        resources: new iw(this.cdnContext),
                        i18n: new o_(this.options.locale, this.options.translations),
                        srPanel: new b2(this.options.srConfig)
                    }));
                }
            }
        ]), e;
    }();
    function P2() {
        return P2 = Jd(Dy.mark(function e(t) {
            var r;
            return Dy.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return r = new N2(t), e.next = 3, r.initialize();
                    case 3:
                        return e.abrupt("return", e.sent);
                    case 4:
                    case "end":
                        return e.stop();
                }
            }, e);
        })), P2.apply(this, arguments);
    }
    Ag(N2, "version", {
        version: "5.65.0",
        revision: "da5a0b8",
        branch: "HEAD",
        buildId: "@adyen/adyen-web-71676e6f-b683-4d8e-b6f6-bb379792cc3d"
    });
    var w2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "\u062F\u0641\u0639",
            "payButton.redirecting": "\u062C\u0627\u0631\u0650 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0648\u062C\u064A\u0647...",
            "payButton.with": "\u0627\u062F\u0641\u0639 %{value} \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 %{maskedData}",
            "payButton.saveDetails": "\u062D\u0641\u0638 \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644",
            close: "\u0625\u063A\u0644\u0627\u0642",
            storeDetails: "\u062D\u0641\u0638 \u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A\u064A \u0627\u0644\u0642\u0627\u062F\u0645\u0629",
            readMore: "\u0627\u0642\u0631\u0623 \u0627\u0644\u0645\u0632\u064A\u062F",
            "creditCard.holderName": "\u0627\u0644\u0627\u0633\u0645 \u0639\u0644\u0649 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "creditCard.holderName.placeholder": "\u062C\u0645\u064A\u0644 \u0633\u0639\u064A\u062F",
            "creditCard.holderName.invalid": "\u0623\u062F\u062E\u0644 \u0627\u0644\u0627\u0633\u0645 \u0643\u0645\u0627 \u0647\u0648 \u0645\u0648\u0636\u062D \u0639\u0644\u0649 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "creditCard.numberField.title": "\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "creditCard.numberField.placeholder": "3456 9012 5678 1234",
            "creditCard.expiryDateField.title": "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "creditCard.expiryDateField.placeholder": "\u0634\u0647\u0631/\u0633\u0646\u0629",
            "creditCard.expiryDateField.month": "\u0634\u0647\u0631",
            "creditCard.expiryDateField.month.placeholder": "\u0634\u0647\u0631",
            "creditCard.expiryDateField.year.placeholder": "\u0633\u0646\u0629",
            "creditCard.expiryDateField.year": "\u0633\u0646\u0629",
            "creditCard.cvcField.title": "\u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "\u0627\u062D\u062A\u0641\u0638 \u0628\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0644\u0644\u0645\u0631\u0629 \u0627\u0644\u0642\u0627\u062F\u0645\u0629",
            "creditCard.cvcField.placeholder.4digits": "4 \u0623\u0631\u0642\u0627\u0645",
            "creditCard.cvcField.placeholder.3digits": "3 \u0623\u0631\u0642\u0627\u0645",
            "creditCard.taxNumber.placeholder": "\u064A\u0648\u0645 \u0634\u0647\u0631 \u0633\u0646\u0629 / 0123456789",
            installments: "\u0639\u062F\u062F \u0627\u0644\u0623\u0642\u0633\u0627\u0637",
            installmentOption: "%{times} \xd7 %{partialValue}",
            installmentOptionMonths: "%{times} \u0623\u0634\u0647\u0631",
            "installments.oneTime": "\u0627\u0644\u062F\u0641\u0639 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629",
            "installments.installments": "\u0627\u0644\u062F\u0641\u0639 \u0639\u0644\u0649 \u0623\u0642\u0633\u0627\u0637",
            "installments.revolving": "\u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u062F\u0648\u0631\u064A",
            "sepaDirectDebit.ibanField.invalid": "\u0631\u0642\u0645 \u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "sepaDirectDebit.nameField.placeholder": "\u062C\u0645\u064A\u0644 \u0633\u0639\u064A\u062F",
            "sepa.ownerName": "\u0635\u0627\u062D\u0628 \u0627\u0644\u062D\u0633\u0627\u0628",
            "sepa.ibanNumber": "\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 (IBAN)",
            "error.title": "\u062E\u0637\u0623",
            "error.subtitle.redirect": "\u0641\u0634\u0644 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0648\u062C\u064A\u0647",
            "error.subtitle.payment": "\u0641\u0634\u0644 \u0627\u0644\u062F\u0641\u0639",
            "error.subtitle.refused": "\u062A\u0645 \u0631\u0641\u0636 \u0627\u0644\u062F\u0641\u0639",
            "error.message.unknown": "\u062D\u062F\u062B \u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641",
            "errorPanel.title": "\u0627\u0644\u0623\u062E\u0637\u0627\u0621 \u0627\u0644\u0645\u0648\u062C\u0648\u062F\u0629",
            "idealIssuer.selectField.title": "\u0627\u0644\u0628\u0646\u0643",
            "idealIssuer.selectField.placeholder": "\u062D\u062F\u062F \u0627\u0644\u0628\u0646\u0643 \u0627\u0644\u0630\u064A \u062A\u062A\u0639\u0627\u0645\u0644 \u0645\u0639\u0647",
            "creditCard.success": "\u0646\u062C\u062D \u0627\u0644\u062F\u0641\u0639",
            loading: "\u062C\u0627\u0631\u0650 \u0627\u0644\u062A\u062D\u0645\u064A\u0644...",
            continue: "\u0645\u062A\u0627\u0628\u0639\u0629",
            continueTo: "\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649",
            "wechatpay.timetopay": "\u0644\u062F\u064A\u0643 %@ \u0644\u0644\u062F\u0641\u0639",
            "sr.wechatpay.timetopay": "\u0644\u062F\u064A\u0643 %#\u062F\u0642\u0627\u0626\u0642%# %#\u062B\u0648\u0627\u0646%# \u0644\u0644\u062F\u0641\u0639",
            "wechatpay.scanqrcode": "\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629",
            personalDetails: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0634\u062E\u0635\u064A\u0629",
            companyDetails: "\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0634\u0631\u0643\u0629",
            "companyDetails.name": "\u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629",
            "companyDetails.registrationNumber": "\u0631\u0642\u0645 \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
            socialSecurityNumber: "\u0631\u0642\u0645 \u0627\u0644\u0636\u0645\u0627\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u064A",
            firstName: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644",
            "firstName.invalid": "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645\u0643 \u0627\u0644\u0623\u0648\u0644",
            infix: "\u0628\u0627\u062F\u0626\u0629",
            lastName: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u062E\u064A\u0631",
            "lastName.invalid": "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645\u0643 \u0627\u0644\u0623\u062E\u064A\u0631",
            mobileNumber: "\u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644",
            "mobileNumber.invalid": "\u0631\u0642\u0645 \u062C\u0648\u0627\u0644 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            city: "\u0627\u0644\u0645\u062F\u064A\u0646\u0629",
            postalCode: "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A",
            "postalCode.optional": "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
            countryCode: "\u0631\u0645\u0632 \u0627\u0644\u0628\u0644\u062F",
            telephoneNumber: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641",
            dateOfBirth: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
            shopperEmail: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
            gender: "\u0627\u0644\u0646\u0648\u0639",
            "gender.notselected": "\u062D\u062F\u062F \u0646\u0648\u0639\u0643",
            male: "\u0630\u0643\u0631",
            female: "\u0623\u0646\u062B\u0649",
            billingAddress: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
            street: "\u0627\u0644\u0634\u0627\u0631\u0639",
            stateOrProvince: "\u0627\u0644\u0648\u0644\u0627\u064A\u0629 \u0623\u0648 \u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629",
            country: "\u0627\u0644\u0628\u0644\u062F/\u0627\u0644\u0645\u0646\u0637\u0642\u0629",
            houseNumberOrName: "\u0631\u0642\u0645 \u0627\u0644\u0645\u0646\u0632\u0644",
            separateDeliveryAddress: "\u062D\u062F\u062F \u0639\u0646\u0648\u0627\u0646 \u062A\u0633\u0644\u064A\u0645 \u0645\u0646\u0641\u0635\u0644",
            deliveryAddress: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u062A\u0633\u0644\u064A\u0645",
            "deliveryAddress.firstName": "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644 \u0644\u0644\u0645\u0633\u062A\u0644\u0645",
            "deliveryAddress.lastName": "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u062E\u064A\u0631 \u0644\u0644\u0645\u0633\u062A\u0644\u0645",
            zipCode: "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A",
            apartmentSuite: "\u0627\u0644\u0634\u0642\u0629 / \u0627\u0644\u062C\u0646\u0627\u062D",
            provinceOrTerritory: "\u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629 \u0623\u0648 \u0627\u0644\u0625\u0642\u0644\u064A\u0645",
            cityTown: "\u0627\u0644\u0645\u062F\u064A\u0646\u0629 / \u0627\u0644\u0628\u0644\u062F\u0629",
            address: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
            "address.placeholder": "\u0627\u0628\u062D\u062B \u0639\u0646 \u0639\u0646\u0648\u0627\u0646\u0643",
            "address.errors.incomplete": "\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646\u064B\u0627 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629",
            "address.enterManually": "\u0623\u062F\u062E\u0644 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u064A\u062F\u0648\u064A\u064B\u0627",
            state: "\u0627\u0644\u0648\u0644\u0627\u064A\u0629",
            "field.title.optional": "(\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
            "creditCard.cvcField.title.optional": "\u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
            "issuerList.wallet.placeholder": "\u062D\u062F\u062F \u0645\u062D\u0641\u0638\u062A\u0643",
            privacyPolicy: "\u0633\u064A\u0627\u0633\u0629 \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629",
            "afterPay.agreement": "\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u066A @ \u0644\u0634\u0631\u0643\u0629 Riverty",
            paymentConditions: "\u0634\u0631\u0648\u0637 \u0627\u0644\u062F\u0641\u0639",
            openApp: "\u0641\u062A\u062D \u0627\u0644\u062A\u0637\u0628\u064A\u0642",
            "voucher.readInstructions": "\u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u0627\u062A",
            "voucher.introduction": "\u0634\u0643\u0631\u064B\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060C \u064A\u0631\u062C\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0642\u0633\u064A\u0645\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0644\u0625\u062A\u0645\u0627\u0645 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0641\u0639.",
            "voucher.expirationDate": "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "voucher.alternativeReference": "\u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u0628\u062F\u064A\u0644",
            "dragonpay.voucher.non.bank.selectField.placeholder": "\u062D\u062F\u062F \u0645\u0642\u062F\u0645 \u0627\u0644\u062E\u062F\u0645\u0629",
            "dragonpay.voucher.bank.selectField.placeholder": "\u062D\u062F\u062F \u0627\u0644\u0628\u0646\u0643 \u0627\u0644\u0630\u064A \u062A\u062A\u0639\u0627\u0645\u0644 \u0645\u0639\u0647",
            "voucher.paymentReferenceLabel": "\u0645\u0631\u062C\u0639 \u0627\u0644\u062F\u0641\u0639",
            "voucher.surcharge": "\u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 %@ \u0631\u0633\u0645\u064B\u0627 \u0625\u0636\u0627\u0641\u064A\u064B\u0627",
            "voucher.introduction.doku": "\u0634\u0643\u0631\u064B\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060C \u064A\u0631\u062C\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0644\u0625\u062A\u0645\u0627\u0645 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0641\u0639.",
            "voucher.shopperName": "\u0627\u0633\u0645 \u0627\u0644\u0645\u062A\u0633\u0648\u0642",
            "voucher.merchantName": "\u0627\u0644\u062A\u0627\u062C\u0631",
            "voucher.introduction.econtext": "\u0634\u0643\u0631\u064B\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060C \u064A\u0631\u062C\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0644\u0625\u062A\u0645\u0627\u0645 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0641\u0639.",
            "voucher.telephoneNumber": "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641",
            "voucher.shopperReference": "\u0645\u0631\u062C\u0639 \u0627\u0644\u0645\u062A\u0633\u0648\u0642",
            "voucher.collectionInstitutionNumber": "\u0631\u0642\u0645 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0643\u0644\u0641\u0629 \u0628\u0627\u0644\u062A\u062D\u0635\u064A\u0644",
            "voucher.econtext.telephoneNumber.invalid": "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0628\u0637\u0648\u0644 10 \u0623\u0648 11 \u0631\u0642\u0645\u064B\u0627",
            "boletobancario.btnLabel": "\u0625\u0646\u0634\u0627\u0621 \u0637\u0631\u064A\u0642\u0629 \u062F\u0641\u0639 Boleto",
            "boleto.sendCopyToEmail": "\u0625\u0631\u0633\u0627\u0644 \u0646\u0633\u062E\u0629 \u0625\u0644\u0649 \u0628\u0631\u064A\u062F\u064A \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
            "button.copy": "\u0646\u0633\u062E",
            "button.download": "\u062A\u0646\u0632\u064A\u0644",
            "boleto.socialSecurityNumber.invalid": "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 CPF/CNPJ \u0635\u0627\u0644\u062D\u064B\u0627",
            "creditCard.storedCard.description.ariaLabel": "\u062A\u0646\u062A\u0647\u064A \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u062E\u0632\u0646\u0629 \u0641\u064A %@",
            "voucher.entity": "\u0627\u0644\u0643\u064A\u0627\u0646",
            donateButton: "\u0627\u0644\u062A\u0628\u0631\u0639",
            notNowButton: "\u0644\u064A\u0633 \u0627\u0644\u0622\u0646",
            thanksForYourSupport: "\u0634\u0643\u0631\u064B\u0627 \u0639\u0644\u0649 \u062F\u0639\u0645\u0643!",
            "resultMessages.preauthorized": "\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644",
            preauthorizeWith: "\u062A\u0641\u0648\u064A\u0636 \u0645\u0633\u0628\u0642 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
            confirmPreauthorization: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062A\u0641\u0648\u064A\u0636 \u0627\u0644\u0645\u0633\u0628\u0642",
            confirmPurchase: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0634\u0631\u0627\u0621",
            applyGiftcard: "\u0627\u0633\u062A\u0631\u062F\u0627\u062F",
            giftcardBalance: "\u0631\u0635\u064A\u062F \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062F\u0627\u064A\u0627",
            deductedBalance: "\u0627\u0644\u0631\u0635\u064A\u062F \u0627\u0644\u0645\u062E\u0635\u0648\u0645",
            "creditCard.pin.title": "\u0631\u0642\u0645 \u0627\u0644\u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0634\u062E\u0635\u064A",
            "creditCard.encryptedPassword.label": "\u0623\u0648\u0644 \u0631\u0642\u0645\u0627\u0646 \u0645\u0646 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
            "creditCard.taxNumber": "\u062A\u0627\u0631\u064A\u062E \u0645\u064A\u0644\u0627\u062F \u062D\u0627\u0645\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0623\u0648 \u0631\u0642\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0634\u0631\u0643\u0629",
            "creditCard.taxNumber.label": "\u062A\u0627\u0631\u064A\u062E \u0645\u064A\u0644\u0627\u062F \u062D\u0627\u0645\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 (\u064A\u0648\u0645 \u0634\u0647\u0631 \u0633\u0646\u0629) \u0623\u0648 \u0631\u0642\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0634\u0631\u0643\u0629 (10 \u0623\u0631\u0642\u0627\u0645)",
            "creditCard.taxNumber.labelAlt": "\u0631\u0642\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0634\u0631\u0643\u0629 (10 \u0623\u0631\u0642\u0627\u0645)",
            "creditCard.taxNumber.invalid": "\u062A\u0627\u0631\u064A\u062E \u0645\u064A\u0644\u0627\u062F \u062D\u0627\u0645\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0623\u0648 \u0631\u0642\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0634\u0631\u0643\u0629 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "storedPaymentMethod.disable.button": "\u0625\u0632\u0627\u0644\u0629",
            "storedPaymentMethod.disable.confirmation": "\u0625\u0632\u0627\u0644\u0629 \u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0645\u062E\u0632\u0646\u0629",
            "storedPaymentMethod.disable.confirmButton": "\u0646\u0639\u0645\u060C \u0623\u0631\u063A\u0628 \u0641\u064A \u0625\u0632\u0627\u0644\u062A\u0647\u0627",
            "storedPaymentMethod.disable.cancelButton": "\u0625\u0644\u063A\u0627\u0621",
            "ach.bankAccount": "\u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064A",
            "ach.accountHolderNameField.title": "\u0627\u0633\u0645 \u0635\u0627\u062D\u0628 \u0627\u0644\u062D\u0633\u0627\u0628",
            "ach.accountHolderNameField.placeholder": "\u062C\u0645\u064A\u0644 \u0633\u0639\u064A\u062F",
            "ach.accountHolderNameField.invalid": "\u0627\u0633\u0645 \u0635\u0627\u062D\u0628 \u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "ach.accountNumberField.title": "\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628",
            "ach.accountNumberField.invalid": "\u0631\u0642\u0645 \u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "ach.accountLocationField.title": "\u0631\u0642\u0645 \u062A\u0648\u062C\u064A\u0647 ABA",
            "ach.accountLocationField.invalid": "\u0631\u0642\u0645 \u062A\u0648\u062C\u064A\u0647 ABA \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "ach.savedBankAccount": "\u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064A \u0627\u0644\u0645\u062D\u0641\u0648\u0638",
            "select.state": "\u062D\u062F\u062F \u0627\u0644\u0648\u0644\u0627\u064A\u0629",
            "select.stateOrProvince": "\u062D\u062F\u062F \u0627\u0644\u0648\u0644\u0627\u064A\u0629 \u0623\u0648 \u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629",
            "select.provinceOrTerritory": "\u062D\u062F\u062F \u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629 \u0623\u0648 \u0627\u0644\u0625\u0642\u0644\u064A\u0645",
            "select.country": "\u062D\u062F\u062F \u0627\u0644\u0628\u0644\u062F/\u0627\u0644\u0645\u0646\u0637\u0642\u0629",
            "select.noOptionsFound": "\u0644\u0627 \u062A\u0648\u062C\u062F \u062E\u064A\u0627\u0631\u0627\u062A",
            "select.filter.placeholder": "\u0628\u062D\u062B...",
            "telephoneNumber.invalid": "\u0631\u0642\u0645 \u0647\u0627\u062A\u0641 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            qrCodeOrApp: "\u0623\u0648",
            "paypal.processingPayment": "\u062C\u0627\u0631\u0650 \u0645\u0639\u0627\u0644\u062C\u0629 \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A...",
            generateQRCode: "\u0625\u0646\u0634\u0627\u0621 \u0631\u0645\u0632 \u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0633\u0631\u064A\u0639\u0629",
            "await.waitForConfirmation": "\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u062A\u0623\u0643\u064A\u062F",
            "mbway.confirmPayment": "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062F\u0641\u0639 \u0639\u0644\u0649 \u062A\u0637\u0628\u064A\u0642 MB WAY",
            "shopperEmail.invalid": "\u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "dateOfBirth.format": "\u064A\u0648\u0645/\u0634\u0647\u0631/\u0633\u0646\u0629",
            "dateOfBirth.invalid": "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0645\u064A\u0644\u0627\u062F \u0635\u062D\u064A\u062D \u064A\u0634\u064A\u0631 \u0625\u0644\u0649 \u0623\u0646 \u0639\u0645\u0631\u0643 \u0644\u0627 \u064A\u0642\u0644 \u0639\u0646 18 \u0639\u0627\u0645\u064B\u0627",
            "blik.confirmPayment": "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642\u0643 \u0627\u0644\u0628\u0646\u0643\u064A \u0644\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062F\u0641\u0639.",
            "blik.invalid": "\u0623\u062F\u062E\u0644 6 \u0623\u0631\u0642\u0627\u0645",
            "blik.code": "\u0631\u0645\u0632 \u0645\u0643\u0648\u0646 \u0645\u0646 6 \u0623\u0631\u0642\u0627\u0645",
            "blik.help": "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0627\u0644\u0631\u0645\u0632 \u0645\u0646 \u062A\u0637\u0628\u064A\u0642\u0643 \u0627\u0644\u0628\u0646\u0643\u064A.",
            "swish.pendingMessage": "\u0628\u0639\u062F \u0642\u064A\u0627\u0645\u0643 \u0628\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0636\u0648\u0626\u064A\u064B\u0627\u060C \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0638\u0644 \u0627\u0644\u062D\u0627\u0644\u0629 \u0645\u0639\u0644\u0642\u0629 \u0644\u0645\u062F\u0629 \u062A\u0635\u0644 \u0625\u0644\u0649 10 \u062F\u0642\u0627\u0626\u0642. \u0642\u062F \u062A\u0624\u062F\u064A \u0645\u062D\u0627\u0648\u0644\u0629 \u0627\u0644\u062F\u0641\u0639 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u062E\u0644\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u0648\u0642\u062A \u0625\u0644\u0649 \u0641\u0631\u0636 \u0631\u0633\u0648\u0645 \u0645\u062A\u0639\u062F\u062F\u0629.",
            "field.valid": "\u062D\u0642\u0644 \u0635\u062D\u064A\u062D",
            "field.invalid": "\u062D\u0642\u0644 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "error.va.gen.01": "\u062D\u0642\u0644 \u063A\u064A\u0631 \u0645\u0643\u062A\u0645\u0644",
            "error.va.gen.02": "\u062D\u0642\u0644 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "error.va.sf-cc-num.01": "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0628\u0637\u0627\u0642\u0629 \u0635\u062D\u064A\u062D",
            "error.va.sf-cc-num.02": "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "error.va.sf-cc-num.03": "\u0623\u062F\u062E\u0644 \u0639\u0644\u0627\u0645\u0629 \u062A\u062C\u0627\u0631\u064A\u0629 \u0644\u0628\u0637\u0627\u0642\u0629 \u0645\u062F\u0639\u0648\u0645\u0629",
            "error.va.sf-cc-num.04": "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0628\u0627\u0644\u0643\u0627\u0645\u0644",
            "error.va.sf-cc-dat.01": "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u0635\u062D\u064A\u062D",
            "error.va.sf-cc-dat.02": "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u0635\u062D\u064A\u062D",
            "error.va.sf-cc-dat.03": "\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0627\u0626\u062A\u0645\u0627\u0646 \u0639\u0644\u0649 \u0648\u0634\u0643 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "error.va.sf-cc-dat.04": "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "error.va.sf-cc-dat.05": "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0628\u0627\u0644\u0643\u0627\u0645\u0644",
            "error.va.sf-cc-mth.01": "\u0623\u062F\u062E\u0644 \u0634\u0647\u0631 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "error.va.sf-cc-yr.01": "\u0623\u062F\u062E\u0644 \u0633\u0646\u0629 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "error.va.sf-cc-yr.02": "\u0623\u062F\u062E\u0644 \u0633\u0646\u0629 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0628\u0627\u0644\u0643\u0627\u0645\u0644",
            "error.va.sf-cc-cvc.01": "\u0623\u062F\u062E\u0644 \u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646",
            "error.va.sf-cc-cvc.02": "\u0623\u062F\u062E\u0644 \u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646 \u0628\u0627\u0644\u0643\u0627\u0645\u0644",
            "error.va.sf-ach-num.01": "\u062D\u0642\u0644 \u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064A \u0641\u0627\u0631\u063A",
            "error.va.sf-ach-num.02": "\u0637\u0648\u0644 \u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064A \u062E\u0637\u0623",
            "error.va.sf-ach-loc.01": "\u062D\u0642\u0644 \u0631\u0642\u0645 \u0627\u0644\u062A\u0648\u062C\u064A\u0647 \u0627\u0644\u0628\u0646\u0643\u064A \u0641\u0627\u0631\u063A",
            "error.va.sf-ach-loc.02": "\u0637\u0648\u0644 \u0631\u0642\u0645 \u0627\u0644\u062A\u0648\u062C\u064A\u0647 \u0627\u0644\u0628\u0646\u0643\u064A \u062E\u0637\u0623",
            "error.va.sf-kcp-pwd.01": "\u062D\u0642\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0641\u0627\u0631\u063A",
            "error.va.sf-kcp-pwd.02": "\u0637\u0648\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u062E\u0637\u0623",
            "error.giftcard.no-balance": "\u0644\u0627 \u064A\u0648\u062C\u062F \u0631\u0635\u064A\u062F \u0628\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062F\u0627\u064A\u0627 \u0647\u0630\u0647",
            "error.giftcard.card-error": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u0633\u062C\u0644\u0627\u062A\u0646\u0627 \u0628\u0637\u0627\u0642\u0629 \u0647\u062F\u0627\u064A\u0627 \u062A\u062D\u0645\u0644 \u0647\u0630\u0627 \u0627\u0644\u0631\u0642\u0645",
            "error.giftcard.currency-error": "\u0644\u0627 \u062A\u0633\u0631\u064A \u0628\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0647\u062F\u0627\u064A\u0627 \u0625\u0644\u0627 \u0628\u0627\u0644\u0639\u0645\u0644\u0629 \u0627\u0644\u062A\u064A \u0635\u062F\u0631\u062A \u0628\u0647\u0627",
            "amazonpay.signout": "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C \u0645\u0646 \u0645\u0648\u0642\u0639 Amazon",
            "amazonpay.changePaymentDetails": "\u062A\u063A\u064A\u064A\u0631 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062F\u0641\u0639",
            "partialPayment.warning": "\u062A\u062D\u062F\u064A\u062F \u0637\u0631\u064A\u0642\u0629 \u062F\u0641\u0639 \u0623\u062E\u0631\u0649 \u0644\u062A\u0633\u062F\u064A\u062F \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u062A\u0628\u0642\u064A",
            "partialPayment.remainingBalance": "\u0633\u064A\u0628\u0644\u063A \u0627\u0644\u0631\u0635\u064A\u062F \u0627\u0644\u0645\u062A\u0628\u0642\u064A %{amount}",
            "bankTransfer.beneficiary": "\u0627\u0644\u0645\u0633\u062A\u0641\u064A\u062F",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "\u0643\u0648\u062F \u0627\u0644\u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0628\u0646\u0643\u064A",
            "bankTransfer.reference": "\u0627\u0644\u0645\u0631\u062C\u0639",
            "bankTransfer.introduction": "\u0642\u0645 \u0628\u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u0645\u062F\u0641\u0648\u0639\u0627\u062A \u062A\u062D\u0648\u064A\u0644 \u0628\u0646\u0643\u064A\u0629 \u062C\u062F\u064A\u062F\u0629. \u064A\u0645\u0643\u0646\u0643 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0648\u0627\u0631\u062F\u0629 \u0641\u064A \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0644\u0625\u062A\u0645\u0627\u0645 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0641\u0639.",
            "bankTransfer.instructions": "\u0634\u0643\u0631\u064B\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060C \u064A\u0631\u062C\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0644\u0625\u062A\u0645\u0627\u0645 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0641\u0639.",
            "bacs.accountHolderName": "\u0627\u0633\u0645 \u0635\u0627\u062D\u0628 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064A",
            "bacs.accountHolderName.invalid": "\u0627\u0633\u0645 \u0635\u0627\u062D\u0628 \u062D\u0633\u0627\u0628 \u0628\u0646\u0643\u064A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "bacs.accountNumber": "\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064A",
            "bacs.accountNumber.invalid": "\u0631\u0642\u0645 \u062D\u0633\u0627\u0628 \u0628\u0646\u0643\u064A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "bacs.bankLocationId": "\u0631\u0645\u0632 \u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0628\u0646\u0643",
            "bacs.bankLocationId.invalid": "\u0631\u0645\u0632 \u062A\u0639\u0631\u064A\u0641 \u0628\u0646\u0643 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "bacs.consent.amount": "\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u062E\u0635\u0645 \u0627\u0644\u0645\u0628\u0644\u063A \u0623\u0639\u0644\u0627\u0647 \u0645\u0646 \u062D\u0633\u0627\u0628\u064A \u0627\u0644\u0628\u0646\u0643\u064A.",
            "bacs.consent.account": "\u0623\u0624\u0643\u062F \u0623\u0646 \u0627\u0644\u062D\u0633\u0627\u0628 \u0628\u0627\u0633\u0645\u064A \u0648\u0623\u0646\u0627 \u0648\u062D\u062F\u064A \u0635\u0627\u062D\u0628 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0645\u0637\u0627\u0644\u0628 \u0628\u0627\u0644\u0625\u0630\u0646 \u0628\u0627\u0644\u062E\u0635\u0645 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628.",
            edit: "\u062A\u062D\u0631\u064A\u0631",
            "bacs.confirm": "\u062A\u0623\u0643\u064A\u062F \u0648\u062F\u0641\u0639",
            "bacs.result.introduction": "\u062A\u0646\u0632\u064A\u0644 \u062A\u0639\u0644\u064A\u0645\u0627\u062A \u0627\u0644\u062E\u0635\u0645 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 (\u062A\u0639\u0644\u064A\u0645\u0627\u062A / \u062A\u0641\u0648\u064A\u0636 DDI)",
            "download.pdf": "\u062A\u0646\u0632\u064A\u0644 \u0645\u0644\u0641 PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "creditCard.encryptedCardNumber.aria.label": "\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "creditCard.encryptedExpiryDate.aria.label": "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0634\u0647\u0631 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "creditCard.encryptedExpiryMonth.aria.label": "\u0634\u0647\u0631 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0633\u0646\u0629 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "creditCard.encryptedExpiryYear.aria.label": "\u0633\u0646\u0629 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646",
            "creditCard.encryptedSecurityCode.aria.label": "\u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646",
            "creditCard.encryptedPassword.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
            "creditCard.encryptedPassword.aria.label": "\u0623\u0648\u0644 \u0631\u0642\u0645\u0627\u0646 \u0645\u0646 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "giftcard.encryptedCardNumber.aria.label": "\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0634\u062E\u0635\u064A",
            "giftcard.encryptedSecurityCode.aria.label": "\u0631\u0642\u0645 \u0627\u0644\u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0634\u062E\u0635\u064A",
            giftcardTransactionLimit: "\u064A\u0633\u0645\u062D \u0641\u0642\u0637 \u0628\u062D\u062F \u0623\u0642\u0635\u0649 %{amount} \u0644\u0643\u0644 \u0645\u0639\u0627\u0645\u0644\u0629 \u0639\u0644\u0649 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062F\u0627\u064A\u0627 \u0647\u0630\u0647",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064A",
            "ach.encryptedBankAccountNumber.aria.label": "\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628",
            "ach.encryptedBankLocationId.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u062A\u0648\u062C\u064A\u0647 \u0627\u0644\u0628\u0646\u0643\u064A",
            "ach.encryptedBankLocationId.aria.label": "\u0631\u0642\u0645 \u062A\u0648\u062C\u064A\u0647 ABA",
            "pix.instructions": "\u0627\u0641\u062A\u062D \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0641\u062A\u0627\u062D PIX \u0627\u0644\u0645\u0633\u062C\u0644\u060C \u0648\u0627\u062E\u062A\u0631 \u0627\u0644\u062F\u0641\u0639 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 PIX \u0648\u0627\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0636\u0648\u0626\u064A\u064B\u0627 \u0623\u0648 \u0627\u0646\u0633\u062E \u0627\u0644\u0631\u0645\u0632 \u0648\u0627\u0644\u0635\u0642\u0647",
            "twint.saved": "\u0627\u0644\u0645\u062D\u0641\u0648\u0638\u0629",
            orPayWith: "\u0623\u0648 \u0627\u0644\u062F\u0641\u0639 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
            invalidFormatExpects: "\u062A\u0646\u0633\u064A\u0642 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D. \u0627\u0644\u062A\u0646\u0633\u064A\u0642 \u0627\u0644\u0645\u062A\u0648\u0642\u0639: %{format}",
            "upi.qrCodeWaitingMessage": "\u0627\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062A\u0637\u0628\u064A\u0642 UPI \u0627\u0644\u0630\u064A \u062A\u064F\u0641\u0636\u0644\u0647 \u0644\u0625\u062A\u0645\u0627\u0645 \u0627\u0644\u062F\u0641\u0639",
            "upi.vpaWaitingMessage": "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 UPI \u0644\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062F\u0641\u0639",
            "upi.modeSelection": "\u062D\u062F\u062F \u0643\u064A\u0641 \u062A\u0631\u063A\u0628 \u0641\u064A \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062A\u0637\u0628\u064A\u0642 UPI.",
            "onlineBanking.termsAndConditions": "\u0628\u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629\u060C \u0641\u0625\u0646\u0643 \u062A\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 %#\u0627\u0644\u0634\u0631\u0648\u0637 \u0648 \u0627\u0644\u0623\u062D\u0643\u0627\u0645%#",
            "onlineBankingPL.termsAndConditions": "\u0628\u0627\u0644\u0627\u0633\u062A\u0645\u0631\u0627\u0631\u060C \u0641\u0625\u0646\u0643 \u062A\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 %#\u0627\u0644\u0642\u0648\u0627\u0639\u062F%# \u0648%#\u0627\u0644\u0627\u0644\u062A\u0632\u0627\u0645\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A\u064A\u0629%# \u0644\u0645\u0624\u0633\u0633\u0629 Przelewy24",
            "ctp.loading.poweredByCtp": "\u0628\u062F\u0639\u0645 \u0645\u0646 Click to Pay",
            "ctp.loading.intro": "\u0646\u062A\u062D\u0642\u0642 \u0644\u0645\u0639\u0631\u0641\u0629 \u0645\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0644\u062F\u064A\u0643 \u0623\u064A \u0628\u0637\u0627\u0642\u0627\u062A \u0645\u062D\u0641\u0648\u0638\u0629 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 Click to Pay...",
            "ctp.login.title": "\u062A\u0627\u0628\u0639 \u0625\u0644\u0649 Click to Pay",
            "ctp.login.subtitle": "\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0627\u0644\u0645\u0642\u062A\u0631\u0646 \u0628\u0637\u0631\u064A\u0642\u0629 Click to Pay \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
            "ctp.login.inputLabel": "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
            "ctp.logout.notYou": "\u0644\u064A\u0633 \u0623\u0646\u062A\u061F",
            "ctp.logout.notYourCards": "\u0644\u064A\u0633\u062A \u0628\u0637\u0627\u0642\u0627\u062A\u0643\u061F",
            "ctp.logout.notYourCard": "\u0644\u064A\u0633\u062A \u0628\u0637\u0627\u0642\u062A\u0643\u061F",
            "ctp.logout.notYourProfile": "\u0644\u064A\u0633 \u0645\u0644\u0641\u0643 \u0627\u0644\u062A\u0639\u0631\u064A\u0641\u064A\u061F",
            "ctp.otp.fieldLabel": "\u0631\u0645\u0632 \u064A\u0633\u062A\u062E\u062F\u0645 \u0644\u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629",
            "ctp.otp.resendCode": "\u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0645\u0632",
            "ctp.otp.codeResent": "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0645\u0632",
            "ctp.otp.title": "\u062A\u0645\u062A\u0639 \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0628\u0637\u0627\u0642\u0627\u062A Click to Pay \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643",
            "ctp.otp.subtitle": "\u0623\u062F\u062E\u0644 \u0627\u0644\u0631\u0645\u0632 %@ \u0627\u0644\u0630\u064A \u0623\u0631\u0633\u0644\u0646\u0627\u0647 \u0625\u0644\u0649 \u066A@ \u0644\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0647\u0648\u064A\u062A\u0643.",
            "ctp.otp.saveCookiesCheckbox.label": "\u062A\u062E\u0637\u064A \u0627\u0644\u062A\u062D\u0642\u0642 \u0641\u064A \u0627\u0644\u0645\u0631\u0629 \u0627\u0644\u0642\u0627\u062F\u0645\u0629",
            "ctp.otp.saveCookiesCheckbox.information": "\u062D\u062F\u062F \u062D\u0641\u0638 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0639\u0644\u0649 \u062C\u0647\u0627\u0632\u0643 \u0648\u0645\u062A\u0635\u0641\u062D\u0643 \u0641\u064A \u0627\u0644\u0645\u062A\u0627\u062C\u0631 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0644\u0625\u062A\u0645\u0627\u0645 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0641\u0639 \u0628\u0634\u0643\u0644 \u0623\u0633\u0631\u0639. \u0644\u0627 \u064A\u0648\u0635\u0649 \u0628\u0647 \u0644\u0644\u0623\u062C\u0647\u0632\u0629 \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "\u062D\u062F\u062F \u062A\u0630\u0643\u0631\u0646\u064A \u0639\u0644\u0649 \u062C\u0647\u0627\u0632\u0643 \u0648\u0645\u062A\u0635\u0641\u062D\u0643.",
            "ctp.emptyProfile.message": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u0637\u0627\u0642\u0627\u062A \u0645\u0633\u062C\u0644\u0629 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062A\u0639\u0631\u064A\u0641\u064A \u0639\u0644\u0649 Click to Pay",
            "ctp.separatorText": "\u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645",
            "ctp.cards.title": "\u0623\u0643\u0645\u0644 \u0627\u0644\u062F\u0641\u0639 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0628\u0637\u0627\u0642\u0629 Click to Pay",
            "ctp.cards.subtitle": "\u062D\u062F\u062F \u0628\u0637\u0627\u0642\u0629 \u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627.",
            "ctp.cards.expiredCard": "\u0645\u0646\u062A\u0647\u064A \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629",
            "ctp.manualCardEntry": "\u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0628\u0637\u0627\u0642\u0629",
            "ctp.aria.infoModalButton": "\u0645\u0627 \u0627\u0644\u0645\u0642\u0635\u0648\u062F \u0628\u0628\u0637\u0627\u0642\u0629 Click to Pay\u061F",
            "ctp.infoPopup.title": "\u062A\u062A\u064A\u062D \u0628\u0637\u0627\u0642\u0627\u062A Click to Pay \u0633\u0647\u0648\u0644\u0629 \u0627\u0644\u0628\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0644\u0627\u062A\u0644\u0627\u0645\u0633\u064A\u0629 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
            "ctp.infoPopup.subtitle": "\u0637\u0631\u064A\u0642\u0629 \u062F\u0641\u0639 \u0633\u0631\u064A\u0639\u0629 \u0648\u0622\u0645\u0646\u0629 \u0645\u062F\u0639\u0648\u0645\u0629 \u0645\u0646 Mastercard \u0648Visa \u0648\u0628\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0623\u062E\u0631\u0649.",
            "ctp.infoPopup.benefit1": "\u062A\u0633\u062A\u062E\u062F\u0645 \u0628\u0637\u0627\u0642\u0627\u062A Click to Pay \u0627\u0644\u062A\u0634\u0641\u064A\u0631 \u0644\u0644\u062D\u0641\u0627\u0638 \u0639\u0644\u0649 \u0623\u0645\u0646 \u0645\u0639\u0644\u0648\u0645\u0627\u062A\u0643 \u0648\u0633\u0644\u0627\u0645\u062A\u0647\u0627",
            "ctp.infoPopup.benefit2": "\u0627\u0633\u062A\u062E\u062F\u0645\u0647\u0627 \u0644\u0644\u062F\u0641\u0639 \u0644\u0644\u062A\u062C\u0627\u0631 \u0641\u064A \u062C\u0645\u064A\u0639 \u0623\u0646\u062D\u0627\u0621 \u0627\u0644\u0639\u0627\u0644\u0645",
            "ctp.infoPopup.benefit3": "\u0642\u0645 \u0628\u0627\u0644\u0625\u0639\u062F\u0627\u062F \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0644\u0625\u062C\u0631\u0627\u0621 \u0645\u062F\u0641\u0648\u0639\u0627\u062A \u062F\u0648\u0646 \u062A\u0639\u0642\u064A\u062F\u0627\u062A \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0642\u0628\u0644",
            "ctp.errors.AUTH_INVALID": "\u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
            "ctp.errors.NOT_FOUND": "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u062D\u0633\u0627\u0628\u060C \u0623\u062F\u062E\u0644 \u0628\u0631\u064A\u062F\u064B\u0627 \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u064B\u0627 \u0635\u062D\u064A\u062D\u064B\u0627 \u0623\u0648 \u0627\u0633\u062A\u0645\u0631 \u0641\u064A \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0628\u0637\u0627\u0642\u0629",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "\u0627\u0644\u062A\u0646\u0633\u064A\u0642 \u063A\u064A\u0631 \u0645\u062F\u0639\u0648\u0645",
            "ctp.errors.FRAUD": "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0623\u0648 \u062A\u0639\u0637\u064A\u0644\u0647",
            "ctp.errors.CONSUMER_ID_MISSING": "\u0647\u0648\u064A\u0629 \u0627\u0644\u0645\u0633\u062A\u0647\u0644\u0643 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629 \u0641\u064A \u0627\u0644\u0637\u0644\u0628",
            "ctp.errors.ACCT_INACCESSIBLE": "\u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D \u062D\u0627\u0644\u064A\u064B\u0627\u060C \u0639\u0644\u0649 \u0633\u0628\u064A\u0644 \u0627\u0644\u0645\u062B\u0627\u0644\u060C \u0627\u0644\u062D\u0633\u0627\u0628 \u0645\u063A\u0644\u0642",
            "ctp.errors.CODE_INVALID": "\u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "ctp.errors.CODE_EXPIRED": "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0647\u0630\u0627 \u0627\u0644\u0631\u0645\u0632",
            "ctp.errors.RETRIES_EXCEEDED": "\u062A\u0645 \u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0639\u0645\u0644\u064A\u0627\u062A \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0644\u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629",
            "ctp.errors.OTP_SEND_FAILED": "\u062A\u0639\u0630\u0631 \u0625\u0631\u0633\u0627\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0644\u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0633\u062A\u0644\u0645",
            "ctp.errors.REQUEST_TIMEOUT": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627\u060C \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0628\u0637\u0627\u0642\u0629",
            "ctp.errors.UNKNOWN_ERROR": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627\u060C \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0628\u0637\u0627\u0642\u0629",
            "ctp.errors.SERVICE_ERROR": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627\u060C \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0628\u0637\u0627\u0642\u0629",
            "ctp.errors.SERVER_ERROR": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627\u060C \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0628\u0637\u0627\u0642\u0629",
            "ctp.errors.INVALID_PARAMETER": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627\u060C \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0628\u0637\u0627\u0642\u0629",
            "ctp.errors.AUTH_ERROR": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627\u060C \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0628\u0637\u0627\u0642\u0629",
            "paymentMethodsList.aria.label": "\u0627\u062E\u062A\u0631 \u0637\u0631\u064A\u0642\u0629 \u062F\u0641\u0639",
            "companyDetails.name.invalid": "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629",
            "companyDetails.registrationNumber.invalid": "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
            "consent.checkbox.invalid": "\u064A\u062C\u0628 \u0623\u0646 \u062A\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0634\u0631\u0648\u0637 \u0648\u0627\u0644\u0623\u062D\u0643\u0627\u0645",
            "form.instruction": "\u062C\u0645\u064A\u0639 \u0627\u0644\u062D\u0642\u0648\u0644 \u0645\u0637\u0644\u0648\u0628\u0629 \u0645\u0627 \u0644\u0645 \u064A\u062A\u0645 \u0648\u0636\u0639 \u0639\u0644\u0627\u0645\u0629 \u062E\u0644\u0627\u0641 \u0630\u0644\u0643.",
            "trustly.descriptor": "\u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0645\u0635\u0631\u0641\u064A \u0627\u0644\u0641\u0648\u0631\u064A",
            "trustly.description1": "\u0627\u062F\u0641\u0639 \u0645\u0628\u0627\u0634\u0631\u0629 \u0645\u0646 \u0623\u064A \u0645\u0646 \u062D\u0633\u0627\u0628\u0627\u062A\u0643 \u0627\u0644\u0645\u0635\u0631\u0641\u064A\u0629\u060C \u0645\u062F\u0639\u0648\u0645\u064B\u0627 \u0628\u0623\u0645\u0627\u0646 \u0639\u0644\u0649 \u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u0628\u0646\u0643",
            "trustly.description2": "\u0644\u0627 \u062A\u0648\u062C\u062F \u062D\u0627\u062C\u0629 \u0644\u0644\u0628\u0637\u0627\u0642\u0627\u062A \u0623\u0648 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642\u0627\u062A \u0623\u0648 \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
            "ancv.input.label": "\u062A\u0639\u0631\u064A\u0641 ANCV \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
            "ancv.confirmPayment": "\u0627\u0633\u062A\u062E\u062F\u0645 \u062A\u0637\u0628\u064A\u0642 ANCV \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0644\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062F\u0641\u0639.",
            "ancv.form.instruction": "\u064A\u0639\u062F \u062A\u0637\u0628\u064A\u0642 Cheque-Vacances \u0636\u0631\u0648\u0631\u064A\u064B\u0627 \u0644\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A.",
            "ancv.beneficiaryId.invalid": "\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0635\u062D\u064A\u062D\u064B\u0627 \u0623\u0648 \u0645\u0639\u0631\u0641 ANCV",
            "payme.openPayMeApp": "\u0623\u0643\u0645\u0644 \u0627\u0644\u062F\u0641\u0639 \u0641\u064A \u062A\u0637\u0628\u064A\u0642 PayMe \u0645\u0646 \u062E\u0644\u0627\u0644 \u0627\u0644\u0625\u0630\u0646 \u0628\u0627\u0644\u062F\u0641\u0639 \u0641\u064A \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0648\u0627\u0646\u062A\u0638\u0631 \u0627\u0644\u062A\u0623\u0643\u064A\u062F.",
            "payme.redirectButtonLabel": "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 PayMe",
            "payme.scanQrCode": "\u0623\u0643\u0645\u0644 \u0627\u0644\u062F\u0641\u0639 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629",
            "payme.timeToPay": "\u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0647\u0630\u0627 \u0635\u0627\u0644\u062D \u0644\u0640 %@",
            "payme.instructions.steps": "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 PayMe. %@\u0627\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0636\u0648\u0626\u064A\u064B\u0627 \u0644\u0644\u0625\u0630\u0646 \u0628\u0627\u0644\u062F\u0641\u0639. %@\u0623\u0643\u0645\u0644 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0641\u0639 \u0641\u064A \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0648\u0627\u0646\u062A\u0638\u0631 \u0627\u0644\u062A\u0623\u0643\u064A\u062F.",
            "payme.instructions.footnote": "\u064A\u0631\u062C\u0649 \u0639\u062F\u0645 \u0625\u063A\u0644\u0627\u0642 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0642\u0628\u0644 \u0625\u062A\u0645\u0627\u0645 \u0627\u0644\u062F\u0641\u0639"
        }
    }), A2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Zaplatit",
            "payButton.redirecting": "P\u0159esm\u011Brov\xe1n\xed...",
            "payButton.with": "Zaplatit %{value} pomoc\xed %{maskedData}",
            "payButton.saveDetails": "Ulo\u017Eit podrobnosti",
            close: "Zav\u0159\xedt",
            storeDetails: "Ulo\u017Eit pro\xa0p\u0159\xed\u0161t\xed platby",
            readMore: "P\u0159e\u010Dt\u011Bte si v\xedce",
            "creditCard.holderName": "Jm\xe9no na\xa0kart\u011B",
            "creditCard.holderName.placeholder": "Jan Nov\xe1k",
            "creditCard.holderName.invalid": "Zadejte jm\xe9no, jak je uvedeno na kart\u011B",
            "creditCard.numberField.title": "\u010C\xedslo karty",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Konec platnosti",
            "creditCard.expiryDateField.placeholder": "MM/RR",
            "creditCard.expiryDateField.month": "M\u011Bs\xedc",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "RR",
            "creditCard.expiryDateField.year": "Rok",
            "creditCard.cvcField.title": "Bezpe\u010Dnostn\xed k\xf3d",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Zapamatovat si pro\xa0p\u0159\xed\u0161t\u011B",
            "creditCard.cvcField.placeholder.4digits": "4 \u010D\xedslice",
            "creditCard.cvcField.placeholder.3digits": "3 \u010D\xedslice",
            "creditCard.taxNumber.placeholder": "RRMMDD / 0123456789",
            installments: "Po\u010Det spl\xe1tek",
            installmentOption: "%{times}\xd7 %{partialValue}",
            installmentOptionMonths: "%{times} m\u011Bs\xedc\u016F",
            "installments.oneTime": "Jednor\xe1zov\xe1 platba",
            "installments.installments": "Platba na\xa0spl\xe1tky",
            "installments.revolving": "Opakuj\xedc\xed se platba",
            "sepaDirectDebit.ibanField.invalid": "Neplatn\xe9 \u010D\xedslo \xfa\u010Dtu",
            "sepaDirectDebit.nameField.placeholder": "Jan Nov\xe1k",
            "sepa.ownerName": "Jm\xe9no dr\u017Eitele \xfa\u010Dtu",
            "sepa.ibanNumber": "\u010C\xedslo \xfa\u010Dtu (IBAN)",
            "error.title": "Chyba",
            "error.subtitle.redirect": "P\u0159esm\u011Brov\xe1n\xed selhalo",
            "error.subtitle.payment": "Platba selhala",
            "error.subtitle.refused": "Platba zam\xedtnuta",
            "error.message.unknown": "Do\u0161lo k\xa0nezn\xe1m\xe9 chyb\u011B",
            "errorPanel.title": "St\xe1vaj\xedc\xed chyby",
            "idealIssuer.selectField.title": "Banka",
            "idealIssuer.selectField.placeholder": "Vyberte svou banku",
            "creditCard.success": "Platba prob\u011Bhla \xfasp\u011B\u0161n\u011B",
            loading: "Na\u010D\xedt\xe1n\xed\u2026",
            continue: "Pokra\u010Dovat",
            continueTo: "Pokra\u010Dovat k",
            "wechatpay.timetopay": "Na zaplacen\xed v\xe1m zb\xfdv\xe1 %@",
            "sr.wechatpay.timetopay": "Na zaplacen\xed m\xe1te %#minut%# %#sekund%#",
            "wechatpay.scanqrcode": "Naskenovat QR k\xf3d",
            personalDetails: "Osobn\xed \xfadaje",
            companyDetails: "\xdadaje o\xa0spole\u010Dnosti",
            "companyDetails.name": "N\xe1zev spole\u010Dnosti",
            "companyDetails.registrationNumber": "Registra\u010Dn\xed \u010D\xedslo",
            socialSecurityNumber: "Rodn\xe9 \u010D\xedslo",
            firstName: "Jm\xe9no",
            "firstName.invalid": "Zadejte sv\xe9 k\u0159estn\xed jm\xe9no",
            infix: "Prefix",
            lastName: "P\u0159\xedjmen\xed",
            "lastName.invalid": "Zadejte sv\xe9 p\u0159\xedjmen\xed",
            mobileNumber: "\u010C\xedslo na mobil",
            "mobileNumber.invalid": "Neplatn\xe9 \u010D\xedslo mobiln\xedho telefonu",
            city: "M\u011Bsto",
            postalCode: "PS\u010C",
            "postalCode.optional": "Po\u0161tovn\xed sm\u011Brovac\xed \u010D\xedslo (nepovinn\xe9)",
            countryCode: "K\xf3d zem\u011B",
            telephoneNumber: "Telefonn\xed \u010D\xedslo",
            dateOfBirth: "Datum narozen\xed",
            shopperEmail: "E-mailov\xe1 adresa",
            gender: "Pohlav\xed",
            "gender.notselected": "Vyberte pohlav\xed",
            male: "Mu\u017E",
            female: "\u017Dena",
            billingAddress: "Faktura\u010Dn\xed adresa",
            street: "Ulice",
            stateOrProvince: "Kraj nebo okres",
            country: "Zem\u011B/region",
            houseNumberOrName: "\u010C\xedslo popisn\xe9",
            separateDeliveryAddress: "Zadat dodac\xed adresu odli\u0161nou od faktura\u010Dn\xed",
            deliveryAddress: "Dodac\xed adresa",
            "deliveryAddress.firstName": "Jm\xe9no p\u0159\xedjemce",
            "deliveryAddress.lastName": "P\u0159\xedjmen\xed p\u0159\xedjemce",
            zipCode: "PS\u010C",
            apartmentSuite: "Byt",
            provinceOrTerritory: "Provincie nebo teritorium",
            cityTown: "M\u011Bsto",
            address: "Adresa",
            "address.placeholder": "Najd\u011Bte svou adresu",
            "address.errors.incomplete": "Chcete-li pokra\u010Dovat, zadejte adresu",
            "address.enterManually": "Zadejte adresu ru\u010Dn\u011B",
            state: "St\xe1t",
            "field.title.optional": "(nepovinn\xe9)",
            "creditCard.cvcField.title.optional": "Bezpe\u010Dnostn\xed k\xf3d (voliteln\xfd)",
            "issuerList.wallet.placeholder": "Vyberte svou pen\u011B\u017Eenku",
            privacyPolicy: "Z\xe1sady ochrany osobn\xedch \xfadaj\u016F",
            "afterPay.agreement": "Souhlas\xedm s %@ of Riverty",
            paymentConditions: "platebn\xedmi podm\xednkami",
            openApp: "Otev\u0159ete aplikaci",
            "voucher.readInstructions": "P\u0159e\u010Dt\u011Bte si pokyny",
            "voucher.introduction": "D\u011Bkujeme za\xa0n\xe1kup. K\xa0dokon\u010Den\xed platby pou\u017Eijte pros\xedm n\xe1sleduj\xedc\xed kup\xf3n.",
            "voucher.expirationDate": "Datum konce platnosti",
            "voucher.alternativeReference": "N\xe1hradn\xed \u010D\xedslo",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Vyberte sv\xe9ho poskytovatele",
            "dragonpay.voucher.bank.selectField.placeholder": "Vyberte svou banku",
            "voucher.paymentReferenceLabel": "\u010C\xedslo platby",
            "voucher.surcharge": "V\u010Detn\u011B p\u0159ir\xe1\u017Eky %@",
            "voucher.introduction.doku": "D\u011Bkujeme za n\xe1kup. K dokon\u010Den\xed platby pou\u017Eijte pros\xedm n\xe1sleduj\xedc\xed informace.",
            "voucher.shopperName": "Jm\xe9no kupuj\xedc\xedho",
            "voucher.merchantName": "Obchodn\xedk",
            "voucher.introduction.econtext": "D\u011Bkujeme za n\xe1kup. K dokon\u010Den\xed platby pou\u017Eijte pros\xedm n\xe1sleduj\xedc\xed informace.",
            "voucher.telephoneNumber": "Telefonn\xed \u010D\xedslo",
            "voucher.shopperReference": "\u010C\xedslo kupuj\xedc\xedho",
            "voucher.collectionInstitutionNumber": "\u010C\xedslo inkasn\xed instituce",
            "voucher.econtext.telephoneNumber.invalid": "Telefonn\xed \u010D\xedslo mus\xed obsahovat 10 nebo 11 \u010D\xedslic.",
            "boletobancario.btnLabel": "Vygenerovat Boleto",
            "boleto.sendCopyToEmail": "Poslat mi kopii na e-mail",
            "button.copy": "Kop\xedrovat",
            "button.download": "St\xe1hnout",
            "boleto.socialSecurityNumber.invalid": "Zadejte platn\xe9 \u010D\xedslo CPF/CNPJ",
            "creditCard.storedCard.description.ariaLabel": "Ulo\u017Een\xe1 karta kon\u010D\xed na %@",
            "voucher.entity": "Subjekt",
            donateButton: "P\u0159isp\u011Bt",
            notNowButton: "Te\u010F ne",
            thanksForYourSupport: "D\u011Bkujeme v\xe1m za podporu!",
            "resultMessages.preauthorized": "Ulo\u017Een\xe9 podrobnosti",
            preauthorizeWith: "P\u0159edautorizovat pomoc\xed",
            confirmPreauthorization: "Potvrdit p\u0159edautorizaci",
            confirmPurchase: "Potvrdit n\xe1kup",
            applyGiftcard: "Uplatnit",
            giftcardBalance: "Z\u016Fstatek na d\xe1rkov\xe9 kart\u011B",
            deductedBalance: "Ode\u010Dten\xfd z\u016Fstatek",
            "creditCard.pin.title": "Pin",
            "creditCard.encryptedPassword.label": "Prvn\xed 2 \u010D\xedslice hesla karty",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Neplatn\xe9 heslo",
            "creditCard.taxNumber": "Datum narozen\xed dr\u017Eitele karty nebo registra\u010Dn\xed \u010D\xedslo spole\u010Dnosti",
            "creditCard.taxNumber.label": "Datum narozen\xed dr\u017Eitele karty (RRMMDD) nebo registra\u010Dn\xed \u010D\xedslo spole\u010Dnosti (10 \u010D\xedslic)",
            "creditCard.taxNumber.labelAlt": "Registra\u010Dn\xed \u010D\xedslo spole\u010Dnosti (10 \u010D\xedslic)",
            "creditCard.taxNumber.invalid": "Neplatn\xe9 datum narozen\xed dr\u017Eitele karty nebo registra\u010Dn\xed \u010D\xedslo spole\u010Dnosti",
            "storedPaymentMethod.disable.button": "Odebrat",
            "storedPaymentMethod.disable.confirmation": "Odebrat ulo\u017Een\xfd zp\u016Fsob platby",
            "storedPaymentMethod.disable.confirmButton": "Ano, odebrat",
            "storedPaymentMethod.disable.cancelButton": "Zru\u0161it",
            "ach.bankAccount": "Bankovn\xed \xfa\u010Det",
            "ach.accountHolderNameField.title": "Jm\xe9no dr\u017Eitele \xfa\u010Dtu",
            "ach.accountHolderNameField.placeholder": "Jan Nov\xe1k",
            "ach.accountHolderNameField.invalid": "Neplatn\xe9 jm\xe9no dr\u017Eitele \xfa\u010Dtu",
            "ach.accountNumberField.title": "\u010C\xedslo \xfa\u010Dtu",
            "ach.accountNumberField.invalid": "Neplatn\xe9 \u010D\xedslo \xfa\u010Dtu",
            "ach.accountLocationField.title": "Sm\u011Brovac\xed tranzitn\xed \u010D\xedslo ABA",
            "ach.accountLocationField.invalid": "Neplatn\xe9 sm\u011Brovac\xed tranzitn\xed \u010D\xedslo ABA",
            "ach.savedBankAccount": "Ulo\u017Een\xfd bankovn\xed \xfa\u010Det",
            "select.state": "Vyberte st\xe1t",
            "select.stateOrProvince": "Vyberte kraj nebo okres",
            "select.provinceOrTerritory": "Vyberte provincii nebo teritorium",
            "select.country": "Vyberte zemi/region",
            "select.noOptionsFound": "Nebyly nalezeny \u017E\xe1dn\xe9 mo\u017Enosti",
            "select.filter.placeholder": "Hledat...",
            "telephoneNumber.invalid": "Neplatn\xe9 telefonn\xed \u010D\xedslo",
            qrCodeOrApp: "nebo",
            "paypal.processingPayment": "Zpracov\xe1n\xed platby...",
            generateQRCode: "Vygenerovat QR k\xf3d",
            "await.waitForConfirmation": "\u010Cek\xe1 se na\xa0potvrzen\xed",
            "mbway.confirmPayment": "Potvr\u010Fte platbu v\xa0aplikaci MB WAY",
            "shopperEmail.invalid": "Neplatn\xe1 e-mailov\xe1 adresa",
            "dateOfBirth.format": "DD/MM/RRRR",
            "dateOfBirth.invalid": "Zadejte platn\xe9 datum narozen\xed, ze kter\xe9ho vypl\xfdv\xe1, \u017Ee je v\xe1m alespo\u0148 18 let",
            "blik.confirmPayment": "Spus\u0165te bankovn\xed aplikaci a potvr\u010Fte platbu.",
            "blik.invalid": "Zadejte 6 \u010D\xedsel",
            "blik.code": "\u0160estim\xedstn\xfd k\xf3d",
            "blik.help": "Z\xedskejte k\xf3d z bankovn\xed aplikace.",
            "swish.pendingMessage": "Po naskenov\xe1n\xed QR k\xf3du m\u016F\u017Ee trvat a\u017E 10 minut, ne\u017E se stav zm\u011Bn\xed. Pokud budete zkou\u0161et b\u011Bhem t\xe9to doby platbu opakovat, m\u016F\u017Ee b\xfdt \u010D\xe1stka zaplacena v\xedcekr\xe1t.",
            "field.valid": "Platn\xe9 pole",
            "field.invalid": "Pole nen\xed platn\xe9",
            "error.va.gen.01": "Ne\xfapln\xe9 pole",
            "error.va.gen.02": "Pole nen\xed platn\xe9",
            "error.va.sf-cc-num.01": "Zadejte platn\xe9 \u010D\xedslo karty",
            "error.va.sf-cc-num.02": "Zadejte \u010D\xedslo karty",
            "error.va.sf-cc-num.03": "Zadejte podporovanou zna\u010Dku karty",
            "error.va.sf-cc-num.04": "Zadejte cel\xe9 \u010D\xedslo karty",
            "error.va.sf-cc-dat.01": "Zadejte platn\xe9 datum vypr\u0161en\xed platnosti",
            "error.va.sf-cc-dat.02": "Zadejte platn\xe9 datum vypr\u0161en\xed platnosti",
            "error.va.sf-cc-dat.03": "Platnost kreditn\xed karty brzy vypr\u0161\xed",
            "error.va.sf-cc-dat.04": "Zadejte datum vypr\u0161en\xed platnosti",
            "error.va.sf-cc-dat.05": "Zadejte cel\xe9 datum vypr\u0161en\xed platnosti",
            "error.va.sf-cc-mth.01": "Zadejte m\u011Bs\xedc vypr\u0161en\xed platnosti",
            "error.va.sf-cc-yr.01": "Zadejte rok vypr\u0161en\xed platnosti",
            "error.va.sf-cc-yr.02": "Zadejte cel\xfd rok vypr\u0161en\xed platnosti",
            "error.va.sf-cc-cvc.01": "Zadejte bezpe\u010Dnostn\xed k\xf3d",
            "error.va.sf-cc-cvc.02": "Zadejte cel\xfd bezpe\u010Dnostn\xed k\xf3d",
            "error.va.sf-ach-num.01": "Pole \u010D\xedsla bankovn\xedho \xfa\u010Dtu je pr\xe1zdn\xe9",
            "error.va.sf-ach-num.02": "\u010C\xedslo bankovn\xedho \xfa\u010Dtu m\xe1 nespr\xe1vnou d\xe9lku",
            "error.va.sf-ach-loc.01": "Pole bankovn\xedho sm\u011Brovac\xedho \u010D\xedsla je pr\xe1zdn\xe9",
            "error.va.sf-ach-loc.02": "Bankovn\xed sm\u011Brovac\xed \u010D\xedslo m\xe1 nespr\xe1vnou d\xe9lku",
            "error.va.sf-kcp-pwd.01": "Pole hesla je pr\xe1zdn\xe9",
            "error.va.sf-kcp-pwd.02": "Heslo m\xe1 nespr\xe1vnou d\xe9lku",
            "error.giftcard.no-balance": "Na d\xe1rkov\xe9 kart\u011B je nulov\xfd z\u016Fstatek",
            "error.giftcard.card-error": "V\xa0na\u0161ich z\xe1znamech nen\xed \u017E\xe1dn\xe1 d\xe1rkov\xe1 karta s\xa0t\xedmto \u010D\xedslem",
            "error.giftcard.currency-error": "D\xe1rkov\xe9 karty jsou platn\xe9 jenom v\xa0m\u011Bn\u011B, ve kter\xe9 byly vystaven\xe9",
            "amazonpay.signout": "Odhl\xe1sit se z Amazonu",
            "amazonpay.changePaymentDetails": "Zm\u011Bnit \xfadaje o platb\u011B",
            "partialPayment.warning": "Zvolte jin\xfd zp\u016Fsob platby pro platbu zb\xfdvaj\xedc\xedch",
            "partialPayment.remainingBalance": "Zb\xfdvaj\xedc\xed z\u016Fstatek bude %{amount}",
            "bankTransfer.beneficiary": "P\u0159\xedjemce",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Odkaz",
            "bankTransfer.introduction": "Vytvo\u0159te novou platbu bankovn\xedm p\u0159evodem. K dokon\u010Den\xed t\xe9to platby m\u016F\u017Eete pou\u017E\xedt \xfadaje na n\xe1sleduj\xedc\xed obrazovce.",
            "bankTransfer.instructions": "D\u011Bkujeme za n\xe1kup. K dokon\u010Den\xed platby pou\u017Eijte pros\xedm n\xe1sleduj\xedc\xed informace.",
            "bacs.accountHolderName": "Jm\xe9no dr\u017Eitele bankovn\xedho \xfa\u010Dtu",
            "bacs.accountHolderName.invalid": "Neplatn\xe9 jm\xe9no dr\u017Eitele bankovn\xedho \xfa\u010Dtu",
            "bacs.accountNumber": "\u010C\xedslo bankovn\xedho \xfa\u010Dtu",
            "bacs.accountNumber.invalid": "Neplatn\xe9 \u010D\xedslo bankovn\xedho \xfa\u010Dtu",
            "bacs.bankLocationId": "K\xf3d Sort",
            "bacs.bankLocationId.invalid": "Neplatn\xfd k\xf3d Sort",
            "bacs.consent.amount": "Souhlas\xedm s\xa0t\xedm, \u017Ee mi bude n\xe1sleduj\xedc\xed \u010D\xe1stka ode\u010Dtena z\xa0bankovn\xedho \xfa\u010Dtu.",
            "bacs.consent.account": "Potvrzuji, \u017Ee \xfa\u010Det je veden na moje jm\xe9no a\xa0jsem jedin\xfdm disponentem, jeho\u017E podpis je nutn\xfd ke schv\xe1len\xed p\u0159\xedm\xe9ho inkasa.",
            edit: "Editovat",
            "bacs.confirm": "Potvrdit a\xa0zaplatit",
            "bacs.result.introduction": "St\xe1hn\u011Bte si pokyny k\xa0p\u0159\xedm\xe9mu inkasu (DDI / podpisov\xe9 pr\xe1vo)",
            "download.pdf": "St\xe1hnout PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe pro \u010D\xedslo karty",
            "creditCard.encryptedCardNumber.aria.label": "\u010C\xedslo karty",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe pro datum vypr\u0161en\xed platnosti",
            "creditCard.encryptedExpiryDate.aria.label": "Konec platnosti",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe pro m\u011Bs\xedc vypr\u0161en\xed platnosti",
            "creditCard.encryptedExpiryMonth.aria.label": "M\u011Bs\xedc konce platnosti",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe pro rok vypr\u0161en\xed platnosti",
            "creditCard.encryptedExpiryYear.aria.label": "Rok konce platnosti",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe pro bezpe\u010Dnostn\xed k\xf3d",
            "creditCard.encryptedSecurityCode.aria.label": "Bezpe\u010Dnostn\xed k\xf3d",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe pro heslo",
            "creditCard.encryptedPassword.aria.label": "Prvn\xed 2 \u010D\xedslice hesla karty",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe pro \u010D\xedslo karty",
            "giftcard.encryptedCardNumber.aria.label": "\u010C\xedslo karty",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe pro pin",
            "giftcard.encryptedSecurityCode.aria.label": "Pin",
            giftcardTransactionLimit: "Maxim\xe1ln\xed povolen\xe1 \u010D\xe1stka za jednu transakci touto d\xe1rkovou kartou je %{amount}.",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe pro \u010D\xedslo bankovn\xedho \xfa\u010Dtu",
            "ach.encryptedBankAccountNumber.aria.label": "\u010C\xedslo \xfa\u010Dtu",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe pro sm\u011Brovac\xed \u010D\xedslo banky",
            "ach.encryptedBankLocationId.aria.label": "Sm\u011Brovac\xed tranzitn\xed \u010D\xedslo ABA",
            "twint.saved": "ulo\u017Eeno",
            orPayWith: "nebo zapla\u0165te pomoc\xed",
            invalidFormatExpects: "Neplatn\xfd form\xe1t. O\u010Dek\xe1van\xfd form\xe1t: %{format}",
            "upi.qrCodeWaitingMessage": "Platbu dokon\u010Dete naskenov\xe1n\xedm QR k\xf3du ve\xa0sv\xe9 obl\xedben\xe9 platebn\xed UPI aplikaci",
            "upi.vpaWaitingMessage": "Otev\u0159ete platebn\xed aplikaci UPI a potvr\u010Fte platbu",
            "upi.modeSelection": "Vyberte si, jak chcete platebn\xed aplikaci UPI pou\u017E\xedvat.",
            "onlineBanking.termsAndConditions": "Pokra\u010Dov\xe1n\xedm souhlas\xedte se %#smluvn\xedmi podm\xednkami%#",
            "onlineBankingPL.termsAndConditions": "Pokra\u010Dov\xe1n\xedm souhlas\xedte s %#pravidly%# a %#informa\u010Dn\xed povinnost\xed%# spole\u010Dnosti Przelewy24.",
            "ctp.loading.poweredByCtp": "Prov\xe1d\u011Bno prost\u0159ednictv\xedm Click to Pay",
            "ctp.loading.intro": "Zji\u0161\u0165ujeme, zda m\xe1te ulo\u017Een\xe9 karty s funkc\xed Click to Pay...",
            "ctp.login.title": "Pokra\u010Dujte na Click to Pay",
            "ctp.login.subtitle": "Pro pokra\u010Dov\xe1n\xed zadejte e-mailovou adresu, kter\xe1 je p\u0159ipojena k \xfa\u010Dtu Click to Pay.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "Nejste to vy?",
            "ctp.logout.notYourCards": "Nejsou to va\u0161e karty?",
            "ctp.logout.notYourCard": "Nen\xed to va\u0161e karta?",
            "ctp.logout.notYourProfile": "Nen\xed to v\xe1\u0161 profil?",
            "ctp.otp.fieldLabel": "Jednor\xe1zov\xfd k\xf3d",
            "ctp.otp.resendCode": "Znovu odeslat k\xf3d",
            "ctp.otp.codeResent": "K\xf3d odesl\xe1n",
            "ctp.otp.title": "Z\xedskejte p\u0159\xedstup ke sv\xfdm kart\xe1m Click to Pay",
            "ctp.otp.subtitle": "Zadejte k\xf3d %@, kter\xfd jsme v\xe1m odeslali na %@ a ov\u011B\u0159te sami sebe.",
            "ctp.otp.saveCookiesCheckbox.label": "P\u0159\xed\u0161t\u011B p\u0159esko\u010Dte ov\u011B\u0159ov\xe1n\xed",
            "ctp.otp.saveCookiesCheckbox.information": "Zvolte, \u017Ee si je chcete zapamatovat ve sv\xe9m za\u0159\xedzen\xed a prohl\xed\u017Ee\u010Di v z\xfa\u010Dastn\u011Bn\xfdch obchodech, abyste se rychleji odhl\xe1sili. Nedoporu\u010Duje se pro sd\xedlen\xe1 za\u0159\xedzen\xed.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Vyberte, abyste si je zapamatovali ve sv\xe9m za\u0159\xedzen\xed a prohl\xed\u017Ee\u010Di",
            "ctp.emptyProfile.message": "V tomto profilu Click to Pay nejsou zaregistrov\xe1ny \u017E\xe1dn\xe9 karty",
            "ctp.separatorText": "nebo pou\u017Eijte",
            "ctp.cards.title": "Dokon\u010Dete platbu pomoc\xed Click to Pay",
            "ctp.cards.subtitle": "Vyberte kartu, kterou chcete pou\u017E\xedt.",
            "ctp.cards.expiredCard": "Platnost vypr\u0161ela",
            "ctp.manualCardEntry": "Ru\u010Dn\xed zad\xe1v\xe1n\xed karty",
            "ctp.aria.infoModalButton": "Co je Click to Pay",
            "ctp.infoPopup.title": "Click to Pay p\u0159in\xe1\u0161\xed jednoduchost bezkontaktn\xed platby, online",
            "ctp.infoPopup.subtitle": "Rychl\xfd a bezpe\u010Dn\xfd zp\u016Fsob platby podporovan\xfd kartami Mastercard, Visa a dal\u0161\xedmi platebn\xedmi kartami.",
            "ctp.infoPopup.benefit1": "Slu\u017Eba Click to Pay pou\u017E\xedv\xe1 \u0161ifrov\xe1n\xed, aby va\u0161e informace byly zabezpe\u010Den\xe9.",
            "ctp.infoPopup.benefit2": "Pou\u017E\xedvejte ji u obchodn\xedk\u016F po cel\xe9m sv\u011Bt\u011B",
            "ctp.infoPopup.benefit3": "Nastavte jednou pro bezprobl\xe9mov\xe9 platby v budoucnu",
            "ctp.errors.AUTH_INVALID": "Ov\u011B\u0159ov\xe1n\xed neplatn\xe9",
            "ctp.errors.NOT_FOUND": "Nebyl nalezen \u017E\xe1dn\xfd \xfa\u010Det, zadejte platn\xfd e-mail nebo pokra\u010Dujte ru\u010Dn\xedm zad\xe1n\xedm karty.",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Form\xe1t nen\xed podporov\xe1n",
            "ctp.errors.FRAUD": "U\u017Eivatelsk\xfd \xfa\u010Det byl uzam\u010Den nebo vypnut",
            "ctp.errors.CONSUMER_ID_MISSING": "V po\u017Eadavku chyb\xed identita spot\u0159ebitele",
            "ctp.errors.ACCT_INACCESSIBLE": "Tento \xfa\u010Det je moment\xe1ln\u011B nedostupn\xfd, nap\u0159. je uzam\u010Den",
            "ctp.errors.CODE_INVALID": "Nespr\xe1vn\xfd ov\u011B\u0159ovac\xed k\xf3d",
            "ctp.errors.CODE_EXPIRED": "Platnost tohoto k\xf3du vypr\u0161ela",
            "ctp.errors.RETRIES_EXCEEDED": "Limit pro po\u010Det opakov\xe1n\xed pro generov\xe1n\xed jednor\xe1zov\xe9ho hesla byl p\u0159ekro\u010Den",
            "ctp.errors.OTP_SEND_FAILED": "Jednor\xe1zov\xe9 heslo nebylo mo\u017En\xe9 odeslat p\u0159\xedjemci",
            "ctp.errors.REQUEST_TIMEOUT": "N\u011Bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010Dn\u011B",
            "ctp.errors.UNKNOWN_ERROR": "N\u011Bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010Dn\u011B",
            "ctp.errors.SERVICE_ERROR": "N\u011Bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010Dn\u011B",
            "ctp.errors.SERVER_ERROR": "N\u011Bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010Dn\u011B",
            "ctp.errors.INVALID_PARAMETER": "N\u011Bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010Dn\u011B",
            "ctp.errors.AUTH_ERROR": "N\u011Bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010Dn\u011B",
            "paymentMethodsList.aria.label": "Zvolte zp\u016Fsob platby",
            "companyDetails.name.invalid": "Zadejte n\xe1zev spole\u010Dnosti",
            "companyDetails.registrationNumber.invalid": "Zadejte registra\u010Dn\xed \u010D\xedslo",
            "consent.checkbox.invalid": "Mus\xedte souhlasit se smluvn\xedmi podm\xednkami",
            "form.instruction": "V\u0161echna pole jsou povinn\xe1, pokud nen\xed uvedeno jinak.",
            "ancv.input.label": "Va\u0161e identifikace ANCV",
            "ancv.confirmPayment": "Pro potvrzen\xed platby pou\u017Eijte aplikaci ANCV.",
            "ancv.form.instruction": "K potvrzen\xed t\xe9to platby je nutn\xe1 aplikace Cheque-Vacances.",
            "ancv.beneficiaryId.invalid": "Zadejte platnou e-mailovou adresu nebo ID ANCV",
            "payme.openPayMeApp": "Dokon\u010Dete platbu autorizac\xed v\xa0aplikaci PayMe a\xa0po\u010Dkejte na potvrzen\xed.",
            "payme.redirectButtonLabel": "Otev\u0159ete aplikaci PayMe",
            "payme.scanQrCode": "Dokon\u010Dete platbu pomoc\xed QR k\xf3du",
            "payme.timeToPay": "Tento QR k\xf3d je platn\xfd pro %@",
            "payme.instructions.steps": "Otev\u0159ete aplikaci PayMe.%@Autorizujte platbu naskenov\xe1n\xedm QR k\xf3du.%@Dokon\u010Dete platbu v\xa0aplikaci a\xa0po\u010Dkejte na potvrzen\xed.",
            "payme.instructions.footnote": "Nezav\xedrejte pros\xedm tuto str\xe1nku p\u0159ed dokon\u010Den\xedm platby."
        }
    }), S2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Betal",
            "payButton.redirecting": "Omdirigerer...",
            "payButton.with": "Betal %{value} med %{maskedData}",
            "payButton.saveDetails": "Gem oplysninger",
            close: "Luk",
            storeDetails: "Gem til min n\xe6ste betaling",
            readMore: "L\xe6s mere",
            "creditCard.holderName": "Navn p\xe5 kort",
            "creditCard.holderName.placeholder": "J. Hansen",
            "creditCard.holderName.invalid": "Indtast navn som vist p\xe5 kortet",
            "creditCard.numberField.title": "Kortnummer",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Udl\xf8bsdato",
            "creditCard.expiryDateField.placeholder": "MM/\xc5\xc5",
            "creditCard.expiryDateField.month": "M\xe5ned",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "\xc5\xc5",
            "creditCard.expiryDateField.year": "\xc5r",
            "creditCard.cvcField.title": "Sikkerhedskode",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Husk til n\xe6ste gang",
            "creditCard.cvcField.placeholder.4digits": "4 cifre",
            "creditCard.cvcField.placeholder.3digits": "3 cifre",
            "creditCard.taxNumber.placeholder": "\xc5\xc5MMDD/0123456789",
            installments: "Antal rater",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} m\xe5neder",
            "installments.oneTime": "Engangsbetaling",
            "installments.installments": "Afdragsbetaling",
            "installments.revolving": "L\xf8bende betaling",
            "sepaDirectDebit.ibanField.invalid": "Ugyldigt kontonummer",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "Kontohavernavn",
            "sepa.ibanNumber": "Kontonummer (IBAN)",
            "error.title": "Fejl",
            "error.subtitle.redirect": "Omdirigering fejlede",
            "error.subtitle.payment": "Betaling fejlede",
            "error.subtitle.refused": "Betaling afvist",
            "error.message.unknown": "Der opstod en ukendt fejl",
            "errorPanel.title": "Eksisterende fejl",
            "idealIssuer.selectField.title": "Bank",
            "idealIssuer.selectField.placeholder": "V\xe6lg din bank",
            "creditCard.success": "Betaling gennemf\xf8rt",
            loading: "Indl\xe6ser\u2026",
            continue: "Forts\xe6t",
            continueTo: "Forts\xe6t til",
            "wechatpay.timetopay": "Du har %@ at betale",
            "sr.wechatpay.timetopay": "Du har %#minutes%# %#seconds%# til at betale",
            "wechatpay.scanqrcode": "Scan QR-kode",
            personalDetails: "Personlige oplysninger",
            companyDetails: "Virksomhedsoplysninger",
            "companyDetails.name": "Virksomhedsnavn",
            "companyDetails.registrationNumber": "CVR-nummer",
            socialSecurityNumber: "CPR-nummer",
            firstName: "Fornavn",
            "firstName.invalid": "Indtast dit fornavn",
            infix: "Pr\xe6fiks",
            lastName: "Efternavn",
            "lastName.invalid": "Indtast dit efternavn",
            mobileNumber: "Mobilnummer",
            "mobileNumber.invalid": "Ugyldigt mobilnummer",
            city: "By",
            postalCode: "Postnummer",
            "postalCode.optional": "Postnummer (valgfrit)",
            countryCode: "Landekode",
            telephoneNumber: "Telefonnummer",
            dateOfBirth: "F\xf8dselsdato",
            shopperEmail: "E-mailadresse",
            gender: "K\xf8n",
            "gender.notselected": "V\xe6lg dit k\xf8n",
            male: "Mand",
            female: "Kvinde",
            billingAddress: "Faktureringsadresse",
            street: "Gade",
            stateOrProvince: "Region eller kommune",
            country: "Land/region",
            houseNumberOrName: "Husnummer",
            separateDeliveryAddress: "Angiv en separat leveringsadresse",
            deliveryAddress: "Leveringsadresse",
            "deliveryAddress.firstName": "Modtagers fornavn",
            "deliveryAddress.lastName": "Modtagers efternavn",
            zipCode: "Postnummer",
            apartmentSuite: "Lejlighed/suite",
            provinceOrTerritory: "Provins eller territorium",
            cityTown: "By",
            address: "Adresse",
            "address.placeholder": "Find din adresse",
            "address.errors.incomplete": "Indtast en adresse for at forts\xe6tte",
            "address.enterManually": "Indtast adresse manuelt",
            state: "Stat",
            "field.title.optional": "(valgfrit)",
            "creditCard.cvcField.title.optional": "Sikkerhedskode (valgfrit)",
            "issuerList.wallet.placeholder": "V\xe6lg tegnebog",
            privacyPolicy: "Politik om privatlivets fred",
            "afterPay.agreement": "Jeg accepterer %@ fra Riverty",
            paymentConditions: "betalingsbetingelser",
            openApp: "\xc5bn appen",
            "voucher.readInstructions": "L\xe6s anvisningerne",
            "voucher.introduction": "Tak for dit k\xf8b. Brug f\xf8lgende kupon til at gennemf\xf8re din betaling.",
            "voucher.expirationDate": "Udl\xf8bsdato",
            "voucher.alternativeReference": "Alternativ reference",
            "dragonpay.voucher.non.bank.selectField.placeholder": "V\xe6lg din udbyder",
            "dragonpay.voucher.bank.selectField.placeholder": "V\xe6lg din bank",
            "voucher.paymentReferenceLabel": "Betalingsreference",
            "voucher.surcharge": "Inkl. till\xe6gsbegyr p\xe5 %@",
            "voucher.introduction.doku": "Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.",
            "voucher.shopperName": "Kundenavn",
            "voucher.merchantName": "S\xe6lger",
            "voucher.introduction.econtext": "Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.",
            "voucher.telephoneNumber": "Telefonnummer",
            "voucher.shopperReference": "K\xf8bers reference",
            "voucher.collectionInstitutionNumber": "Id-nummer til opkr\xe6vningsinstitution",
            "voucher.econtext.telephoneNumber.invalid": "Telefonnummer skal best\xe5 af 10 eller 11 cifre",
            "boletobancario.btnLabel": "Gener\xe9r Boleto",
            "boleto.sendCopyToEmail": "Send en kopi til min e-mail",
            "button.copy": "Kopi\xe9r",
            "button.download": "Download",
            "boleto.socialSecurityNumber": "CPF / CNPJ",
            "boleto.socialSecurityNumber.invalid": "Indtast et gyldigt CPF/CNPJ-nummer",
            "creditCard.storedCard.description.ariaLabel": "Gemt kort ender p\xe5 %@",
            "voucher.entity": "Enhed",
            donateButton: "Giv et bidrag",
            notNowButton: "Ikke nu",
            thanksForYourSupport: "Tak for din st\xf8tte!",
            "resultMessages.preauthorized": "Oplysningerne er gemt",
            preauthorizeWith: "Forh\xe5ndsgodkend med",
            confirmPreauthorization: "Bekr\xe6ft forh\xe5ndsgodkendelse",
            confirmPurchase: "Bekr\xe6ft k\xf8b",
            applyGiftcard: "Indl\xf8s",
            giftcardBalance: "Saldo p\xe5 gavekort",
            deductedBalance: "Fratrukket saldo",
            "creditCard.pin.title": "Pinkode",
            "creditCard.encryptedPassword.label": "F\xf8rste 2 cifre i adgangskode til kort",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Ugyldig adgangskode",
            "creditCard.taxNumber": "Kortholders f\xf8dselsdag eller virksomhedsregistreringsnummer",
            "creditCard.taxNumber.label": "Kortholders f\xf8dselsdato (\xc5\xc5MMDD) eller virksomheds registreringsnummer (10 cifre)",
            "creditCard.taxNumber.labelAlt": "Virksomheds registreringsnummer (10 cifre)",
            "creditCard.taxNumber.invalid": "Ugyldig f\xf8dselsdato for kortholder eller virksomheds registreringsnummer",
            "storedPaymentMethod.disable.button": "Fjern",
            "storedPaymentMethod.disable.confirmation": "Fjern gemt betalingsm\xe5de",
            "storedPaymentMethod.disable.confirmButton": "Ja, fjern",
            "storedPaymentMethod.disable.cancelButton": "Annuller",
            "ach.bankAccount": "Bankkonto",
            "ach.accountHolderNameField.title": "Kontohavers navn",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "Ugyldigt kontohavernavn",
            "ach.accountNumberField.title": "Kontonummer",
            "ach.accountNumberField.invalid": "Ugyldigt kontonummer",
            "ach.accountLocationField.title": "ABA-registreringsnummer",
            "ach.accountLocationField.invalid": "Ugyldigt ABA-registreringsnummer",
            "ach.savedBankAccount": "Gemt bankkonto",
            "select.state": "V\xe6lg stat",
            "select.stateOrProvince": "V\xe6lg region eller kommune",
            "select.provinceOrTerritory": "V\xe6lg provins eller territorium",
            "select.country": "V\xe6lg land/region",
            "select.noOptionsFound": "Ingen muligheder fundet",
            "select.filter.placeholder": "S\xf8g...",
            "telephoneNumber.invalid": "Ugyldigt telefonnummer",
            qrCodeOrApp: "eller",
            "paypal.processingPayment": "Behandler betaling...",
            generateQRCode: "Gener\xe9r QR-kode",
            "await.waitForConfirmation": "Venter p\xe5 bekr\xe6ftelse",
            "mbway.confirmPayment": "Bekr\xe6ft din betaling p\xe5 appen MB WAY",
            "shopperEmail.invalid": "Ugyldig e-mailadresse",
            "dateOfBirth.format": "DD/MM/\xc5\xc5\xc5\xc5",
            "dateOfBirth.invalid": "Indtast en gyldig f\xf8dselsdato, der viser, at du er mindst 18 \xe5r gammel",
            "blik.confirmPayment": "\xc5bn din bankapp for at bekr\xe6fte betalingen.",
            "blik.invalid": "Indtast 6 tal",
            "blik.code": "6-cifret kode",
            "blik.help": "F\xe5 koden fra din bankapp.",
            "swish.pendingMessage": "Visning af status kan tage op til 10 minutter efter scanning. Et nyt fors\xf8g p\xe5 betaling inden for dette tidsrum kan muligvis medf\xf8re flere gebyrer.",
            "field.valid": "Gyldigt felt",
            "field.invalid": "Ugyldigt felt",
            "error.va.gen.01": "Felt ikke udfyldt",
            "error.va.gen.02": "Ugyldigt felt",
            "error.va.sf-cc-num.01": "Indtast et gyldigt kortnummer",
            "error.va.sf-cc-num.02": "Indtast kortnummeret",
            "error.va.sf-cc-num.03": "Indtast et underst\xf8ttet kort",
            "error.va.sf-cc-num.04": "Indtast det fulde kortnummer",
            "error.va.sf-cc-dat.01": "Indtast en gyldig udl\xf8bsdato",
            "error.va.sf-cc-dat.02": "Indtast en gyldig udl\xf8bsdato",
            "error.va.sf-cc-dat.03": "Kreditkort udl\xf8ber snart",
            "error.va.sf-cc-dat.04": "Indtast udl\xf8bsdatoen",
            "error.va.sf-cc-dat.05": "Indtast den fulde udl\xf8bsdato",
            "error.va.sf-cc-mth.01": "Indtast udl\xf8bsm\xe5neden",
            "error.va.sf-cc-yr.01": "Indtast udl\xf8bs\xe5ret",
            "error.va.sf-cc-yr.02": "Indtast det fulde udl\xf8bs\xe5r",
            "error.va.sf-cc-cvc.01": "Indtast sikkerhedskoden",
            "error.va.sf-cc-cvc.02": "Indtast den fulde sikkerhedskode",
            "error.va.sf-ach-num.01": "Feltet til bankkontonummer er tomt",
            "error.va.sf-ach-num.02": "Bankkontonummer har den forkerte l\xe6ngde",
            "error.va.sf-ach-loc.01": "Feltet til registreringsnummeret er tomt",
            "error.va.sf-ach-loc.02": "Registreringsnummeret har den forkerte l\xe6ngde",
            "error.va.sf-kcp-pwd.01": "Feltet til adgangskode er tomt",
            "error.va.sf-kcp-pwd.02": "Adgangskoden har den forkerte l\xe6ngde",
            "error.giftcard.no-balance": "Saldoen p\xe5 gavekortet er 0",
            "error.giftcard.card-error": "Vi har ikke et gavekort med dette nummer i vores optegnelser",
            "error.giftcard.currency-error": "Gavekort er kun gyldige i udstedelsesvalutaen",
            "amazonpay.signout": "Log ud af Amazon",
            "amazonpay.changePaymentDetails": "Skift betalingsoplysninger",
            "partialPayment.warning": "V\xe6lg en anden betalingsm\xe5de til betaling af restbel\xf8bet",
            "partialPayment.remainingBalance": "Restbel\xf8bet vil v\xe6re %{amount}",
            "bankTransfer.beneficiary": "Betalingsmodtager",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Reference",
            "bankTransfer.introduction": "Forts\xe6t med at oprette ny betalingsoverf\xf8rsel via bank. Du kan bruge oplysningerne p\xe5 den f\xf8lgende sk\xe6rm til at afslutte betalingen.",
            "bankTransfer.instructions": "Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.",
            "bacs.accountHolderName": "Bankkontohavers navn",
            "bacs.accountHolderName.invalid": "Ugyldigt navn p\xe5 bankkontohaver",
            "bacs.accountNumber": "Bankkontonummer",
            "bacs.accountNumber.invalid": "Ugyldigt bankkontonummer",
            "bacs.bankLocationId": "Registreringsnummer",
            "bacs.bankLocationId.invalid": "Ugyldigt registreringsnummer",
            "bacs.consent.amount": "Jeg accepterer, at bel\xf8bet ovenfor tr\xe6kkes p\xe5 min bankkonto.",
            "bacs.consent.account": "Jeg bekr\xe6fter, at kontoen er i mit navn, og at jeg er den eneste underskriver, der kr\xe6ves for at godkende direkte debitering af kontoen.",
            edit: "Rediger",
            "bacs.confirm": "Bekr\xe6ft, og betal",
            "bacs.result.introduction": "Download vejledningen til direkte debitering (fuldmagt til direkte debitering)",
            "download.pdf": "Download PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe til kortnummer",
            "creditCard.encryptedCardNumber.aria.label": "Kortnummer",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe til udl\xf8bsdato",
            "creditCard.encryptedExpiryDate.aria.label": "Udl\xf8bsdato",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe til udl\xf8bsm\xe5ned",
            "creditCard.encryptedExpiryMonth.aria.label": "Udl\xf8bsm\xe5ned",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe til udl\xf8bs\xe5r",
            "creditCard.encryptedExpiryYear.aria.label": "Udl\xf8bs\xe5r",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe til sikkerhedskode",
            "creditCard.encryptedSecurityCode.aria.label": "Sikkerhedskode",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe til adgangskode",
            "creditCard.encryptedPassword.aria.label": "F\xf8rste 2 cifre i adgangskode til kort",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe til kortnummer",
            "giftcard.encryptedCardNumber.aria.label": "Kortnummer",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe til pin",
            "giftcard.encryptedSecurityCode.aria.label": "Pinkode",
            giftcardTransactionLimit: "Maks. %{amount} tilladt pr. transaktion p\xe5 dette gavekort",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe til bankkontonummer",
            "ach.encryptedBankAccountNumber.aria.label": "Kontonummer",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe til bankroutingnummer",
            "ach.encryptedBankLocationId.aria.label": "ABA-registreringsnummer",
            "twint.saved": "gemt",
            orPayWith: "eller betal med",
            invalidFormatExpects: "Ugyldigt format. Forventet format: %{format}",
            "upi.qrCodeWaitingMessage": "Scan QR-koden via din foretrukne UPI-app for at gennemf\xf8re betalingen",
            "upi.vpaWaitingMessage": "\xc5bn din UPI-app for at bekr\xe6fte betalingen",
            "upi.modeSelection": "Foretag et valg om, hvordan du vil bruge UPI.",
            "onlineBanking.termsAndConditions": "Ved at forts\xe6tte accepterer du %#vilk\xe5r og betingelser%#",
            "onlineBankingPL.termsAndConditions": "Hvis du forts\xe6tter, accepterer du %#regulativer%# og %#informationspligten%# for Przelewy24",
            "ctp.loading.poweredByCtp": "Drevet af Click to Pay",
            "ctp.loading.intro": "Vi tjekker, om du har gemte kort med Click to Pay...",
            "ctp.login.title": "Forts\xe6t med Click to Pay",
            "ctp.login.subtitle": "Indtast den e-mailadresse, der er knyttet til Click to Pay, for at forts\xe6tte.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "Ikke dig?",
            "ctp.logout.notYourCards": "Ikke dine kort?",
            "ctp.logout.notYourCard": "Ikke dit kort?",
            "ctp.logout.notYourProfile": "Ikke din profil?",
            "ctp.otp.fieldLabel": "Engangskode",
            "ctp.otp.resendCode": "Send kode igen",
            "ctp.otp.codeResent": "Kode er sendt igen",
            "ctp.otp.title": "F\xe5 adgang til dine Click to Pay-kort",
            "ctp.otp.subtitle": "Indtast den kode, vi har sendt til %@ for at bekr\xe6fte, at det er dig.",
            "ctp.otp.saveCookiesCheckbox.label": "Spring bekr\xe6ftelse over n\xe6ste gang",
            "ctp.otp.saveCookiesCheckbox.information": "V\xe6lg dette for at blive husket p\xe5 din enhed og browser i deltagende butikker for hurtigere betaling. Anbefales ikke p\xe5 delte enheder.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "V\xe6lg dette for at blive husket p\xe5 din enhed og browser",
            "ctp.emptyProfile.message": "Ingen kort registreret i denne Click to Pay-profil",
            "ctp.separatorText": "eller brug",
            "ctp.cards.title": "Gennemf\xf8r betaling med Click to Pay",
            "ctp.cards.subtitle": "V\xe6lg et kort, der skal bruges.",
            "ctp.cards.expiredCard": "Udl\xf8bet",
            "ctp.manualCardEntry": "Manuel kortindtastning",
            "ctp.aria.infoModalButton": "Hvad er Click to Pay?",
            "ctp.infoPopup.title": "Med Click to Pay f\xe5r du letheden fra kontaktl\xf8s betaling, online",
            "ctp.infoPopup.subtitle": "En hurtig og sikker betalingsmetode, der underst\xf8ttes af Mastercard, Visa og andre betalingskort.",
            "ctp.infoPopup.benefit1": "Click to Pay bruger kryptering for at holde dine oplysninger sikre og beskyttede",
            "ctp.infoPopup.benefit2": "Brug det med forhandlere i hele verden",
            "ctp.infoPopup.benefit3": "Konfigurer \xe9n gang for betalinger uden problemer i fremtiden",
            "ctp.errors.AUTH_INVALID": "Ugyldig godkendelse",
            "ctp.errors.NOT_FOUND": "Ingen konto fundet, indtast en gyldig e-mail eller forts\xe6t med manuel kortindtastning",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Formatet er ikke underst\xf8ttet",
            "ctp.errors.FRAUD": "Brugerkontoen er l\xe5st eller deaktiveret",
            "ctp.errors.CONSUMER_ID_MISSING": "Forbrugeridentitet mangler i anmodningen",
            "ctp.errors.ACCT_INACCESSIBLE": "Denne konto er i \xf8jeblikket ikke tilg\xe6ngelig, f.eks. fordi den er l\xe5st",
            "ctp.errors.CODE_INVALID": "Forkert bekr\xe6ftelsekode",
            "ctp.errors.CODE_EXPIRED": "Denne kode er udl\xf8bet",
            "ctp.errors.RETRIES_EXCEEDED": "Gr\xe6nsen for antallet af fors\xf8g til generering af engangsadgangskode er overskredet",
            "ctp.errors.OTP_SEND_FAILED": "Engangsadgangskoden kunne ikke sendes til modtageren",
            "ctp.errors.REQUEST_TIMEOUT": "Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning",
            "ctp.errors.UNKNOWN_ERROR": "Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning",
            "ctp.errors.SERVICE_ERROR": "Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning",
            "ctp.errors.SERVER_ERROR": "Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning",
            "ctp.errors.INVALID_PARAMETER": "Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning",
            "ctp.errors.AUTH_ERROR": "Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning",
            "paymentMethodsList.aria.label": "V\xe6lg en betalingsmetode",
            "companyDetails.name.invalid": "Indtast virksomhedsnavnet",
            "companyDetails.registrationNumber.invalid": "Indtast registreringsnummeret",
            "consent.checkbox.invalid": "Du skal acceptere vilk\xe5r og betingelser",
            "form.instruction": "Alle felter er obligatoriske, medmindre andet er markeret.",
            "ancv.input.label": "Din ANCV-identifikation",
            "ancv.confirmPayment": "Brug din ANCV-applikation til at bekr\xe6fte betalingen.",
            "ancv.form.instruction": "Cheque-Vacances-applikationen er n\xf8dvendig for at validere denne betaling.",
            "ancv.beneficiaryId.invalid": "Indtast en gyldig e-mailadresse eller ANCV-id",
            "payme.openPayMeApp": "Gennemf\xf8r betalingen i PayMe-appen ved at godkende betalingen i appen og afvente bekr\xe6ftelsen.",
            "payme.redirectButtonLabel": "\xc5bn PayMe-appen",
            "payme.scanQrCode": "Gennemf\xf8r din betaling med QR-kode",
            "payme.timeToPay": "Denne QR-kode er gyldig i %@",
            "payme.instructions.steps": "\xc5bn PayMe-appen.%@Scan QR-koden for at godkende betalingen.%@Gennemf\xf8r betalingen i appen, og afvent bekr\xe6ftelse.",
            "payme.instructions.footnote": "Luk ikke denne side, f\xf8r betalingen er gennemf\xf8rt"
        }
    }), I2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Zahle",
            "payButton.redirecting": "Umleiten\u2026",
            "payButton.with": "%{value} mit %{maskedData} zahlen",
            "payButton.saveDetails": "Angaben speichern",
            close: "Schlie\xdfen",
            storeDetails: "F\xfcr zuk\xfcnftige Zahlvorg\xe4nge speichern",
            readMore: "Mehr lesen",
            "creditCard.holderName": "Name auf der Karte",
            "creditCard.holderName.placeholder": "A. M\xfcller",
            "creditCard.holderName.invalid": "Geben Sie den Namen wie auf der Karte gezeigt ein",
            "creditCard.numberField.title": "Kartennummer",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Ablaufdatum",
            "creditCard.expiryDateField.placeholder": "MM/JJ",
            "creditCard.expiryDateField.month": "Monat",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "JJ",
            "creditCard.expiryDateField.year": "Jahr",
            "creditCard.cvcField.title": "Sicherheitscode",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "F\xfcr das n\xe4chste Mal speichern",
            "creditCard.cvcField.placeholder.4digits": "4 Stellen",
            "creditCard.cvcField.placeholder.3digits": "3 Stellen",
            "creditCard.taxNumber.placeholder": "JJMMTT/0123456789",
            installments: "Anzahl der Raten",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} Monate",
            "installments.oneTime": "Einmalige Zahlung",
            "installments.installments": "Ratenzahlung",
            "installments.revolving": "Ratenzahlung",
            "sepaDirectDebit.ibanField.invalid": "Ung\xfcltige Kontonummer",
            "sepaDirectDebit.nameField.placeholder": "A. M\xfcller",
            "sepa.ownerName": "Name des Kontoinhabers",
            "sepa.ibanNumber": "Kontonummer (IBAN)",
            "error.title": "Fehler",
            "error.subtitle.redirect": "Weiterleitung fehlgeschlagen",
            "error.subtitle.payment": "Zahlung fehlgeschlagen",
            "error.subtitle.refused": "Zahlvorgang verweigert",
            "error.message.unknown": "Es ist ein unbekannter Fehler aufgetreten.",
            "errorPanel.title": "Bestehende Fehler",
            "idealIssuer.selectField.title": "Bank",
            "idealIssuer.selectField.placeholder": "Bank ausw\xe4hlen",
            "creditCard.success": "Zahlung erfolgreich",
            loading: "Laden\u2026",
            continue: "Weiter",
            continueTo: "Weiter zu",
            "wechatpay.timetopay": "Sie haben noch %@ um zu zahlen",
            "sr.wechatpay.timetopay": "Sie haben %#Minuten%# %#Sekunden%# Zeit, um zu bezahlen",
            "wechatpay.scanqrcode": "QR-Code scannen",
            personalDetails: "Pers\xf6nliche Angaben",
            companyDetails: "Unternehmensdaten",
            "companyDetails.name": "Unternehmensname",
            "companyDetails.registrationNumber": "Registrierungsnummer",
            socialSecurityNumber: "Sozialversicherungsnummer",
            firstName: "Vorname",
            "firstName.invalid": "Geben Sie Ihren Vornamen ein",
            infix: "Vorwahl",
            lastName: "Nachname",
            "lastName.invalid": "Geben Sie Ihren Nachnamen ein",
            mobileNumber: "Handynummer",
            "mobileNumber.invalid": "Ung\xfcltige Handynummer",
            city: "Stadt",
            postalCode: "Postleitzahl",
            "postalCode.optional": "Postleitzahl (optional)",
            countryCode: "Landesvorwahl",
            telephoneNumber: "Telefonnummer",
            dateOfBirth: "Geburtsdatum",
            shopperEmail: "E-Mail-Adresse",
            gender: "Geschlecht",
            "gender.notselected": "W\xe4hlen Sie Ihr Geschlecht",
            male: "M\xe4nnlich",
            female: "Weiblich",
            billingAddress: "Rechnungsadresse",
            street: "Stra\xdfe",
            stateOrProvince: "Bundesland",
            country: "Land/Region",
            houseNumberOrName: "Hausnummer",
            separateDeliveryAddress: "Abweichende Lieferadresse angeben",
            deliveryAddress: "Lieferadresse",
            "deliveryAddress.firstName": "Vorname des Empf\xe4ngers",
            "deliveryAddress.lastName": "Nachname des Empf\xe4ngers",
            zipCode: "PLZ",
            apartmentSuite: "Wohnung/Geschoss",
            provinceOrTerritory: "Provinz oder Territorium",
            cityTown: "Ort",
            address: "Stra\xdfe und Hausnummer",
            "address.placeholder": "Suchen Sie Ihre Adresse",
            "address.errors.incomplete": "Geben Sie eine Adresse ein, um fortzufahren",
            "address.enterManually": "Geben Sie die Adresse manuell ein",
            state: "Bundesstaat",
            "field.title.optional": "(optional)",
            "creditCard.cvcField.title.optional": "Sicherheitscode (optional)",
            "issuerList.wallet.placeholder": "Virtuelle Brieftasche ausw\xe4hlen",
            privacyPolicy: "Datenschutz",
            "afterPay.agreement": "Ich stimme den %@ von Riverty zu",
            paymentConditions: "Zahlungsbedingungen",
            openApp: "App \xf6ffnen",
            "voucher.readInstructions": "Anweisungen lesen",
            "voucher.introduction": "Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung des folgenden Gutscheins ab.",
            "voucher.expirationDate": "G\xfcltig bis",
            "voucher.alternativeReference": "Alternative Referenz",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Anbieter ausw\xe4hlen",
            "dragonpay.voucher.bank.selectField.placeholder": "Bank ausw\xe4hlen",
            "voucher.paymentReferenceLabel": "Zahlungsreferenz",
            "voucher.surcharge": "Inkl. % @Zuschlag",
            "voucher.introduction.doku": "Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.",
            "voucher.shopperName": "Name des K\xe4ufers",
            "voucher.merchantName": "H\xe4ndler",
            "voucher.introduction.econtext": "Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.",
            "voucher.telephoneNumber": "Telefonnummer",
            "voucher.shopperReference": "Kundenreferenz",
            "voucher.collectionInstitutionNumber": "Nummer der Zahlungsannahmestelle",
            "voucher.econtext.telephoneNumber.invalid": "Die Telefonnummer muss 10- oder 11-stellig sein",
            "boletobancario.btnLabel": "Boleto generieren",
            "boleto.sendCopyToEmail": "Eine Kopie an meine E-Mail-Adresse senden",
            "button.copy": "Kopieren",
            "button.download": "Herunterladen",
            "boleto.socialSecurityNumber.invalid": "Geben Sie eine g\xfcltige CPF-/CNPJ-Nummer ein",
            "creditCard.storedCard.description.ariaLabel": "Gespeicherte Karte endet auf %@",
            "voucher.entity": "Entit\xe4t",
            donateButton: "Spenden",
            notNowButton: "Nicht jetzt",
            thanksForYourSupport: "Danke f\xfcr Ihre Unterst\xfctzung!",
            "resultMessages.preauthorized": "Angaben gespeichert",
            preauthorizeWith: "Vorautorisieren mit",
            confirmPreauthorization: "Vorautorisierung best\xe4tigen",
            confirmPurchase: "Kauf best\xe4tigen",
            applyGiftcard: "Einl\xf6sen",
            giftcardBalance: "Saldo der Geschenkkarte",
            deductedBalance: "Abgezogener Betrag",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "Die ersten zwei Ziffern des Kartenpassworts",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Ung\xfcltiges Passwort",
            "creditCard.taxNumber": "Geburtsdatum des Karteninhabers oder der Unternehmensregistrierungsnummer",
            "creditCard.taxNumber.label": "Geburtsdatum des Karteninhabers (JJMMTT) oder Unternehmensregistrierungsnummer (10-stellig)",
            "creditCard.taxNumber.labelAlt": "Unternehmensregistrierungsnummer (10-stellig)",
            "creditCard.taxNumber.invalid": "Ung\xfcltiges Geburtsdatum des Karteninhabers oder ung\xfcltige Unternehmensregistrierungsnummer",
            "storedPaymentMethod.disable.button": "Entfernen",
            "storedPaymentMethod.disable.confirmation": "Gespeicherte Zahlungsmethode entfernen",
            "storedPaymentMethod.disable.confirmButton": "Ja, entfernen",
            "storedPaymentMethod.disable.cancelButton": "Abbrechen",
            "ach.bankAccount": "Bankkonto",
            "ach.accountHolderNameField.title": "Name des Kontoinhabers",
            "ach.accountHolderNameField.placeholder": "A. M\xfcller",
            "ach.accountHolderNameField.invalid": "Ung\xfcltiger Kontoinhabername",
            "ach.accountNumberField.title": "Kontonummer",
            "ach.accountNumberField.invalid": "Ung\xfcltige Kontonummer",
            "ach.accountLocationField.title": "ABA-Nummer",
            "ach.accountLocationField.invalid": "Ung\xfcltige ABA-Nummer",
            "ach.savedBankAccount": "Gespeichertes Bankkonto",
            "select.state": "Bundesstaat ausw\xe4hlen",
            "select.stateOrProvince": "Bundesland oder Provinz/Region ausw\xe4hlen",
            "select.provinceOrTerritory": "Provinz oder Territorium ausw\xe4hlen",
            "select.country": "Land/Region ausw\xe4hlen",
            "select.noOptionsFound": "Keine Optionen gefunden",
            "select.filter.placeholder": "Suche\u2026",
            "telephoneNumber.invalid": "Ung\xfcltige Telefonnummer",
            qrCodeOrApp: "oder",
            "paypal.processingPayment": "Zahlung wird verarbeitet\u2026",
            generateQRCode: "QR-Code generieren",
            "await.waitForConfirmation": "Warten auf Best\xe4tigung",
            "mbway.confirmPayment": "Best\xe4tigen Sie Ihre Zahlung in der MB WAY-App",
            "shopperEmail.invalid": "Ung\xfcltige E-Mail-Adresse",
            "dateOfBirth.format": "TT.MM.JJJJ",
            "dateOfBirth.invalid": "Geben Sie ein g\xfcltiges Geburtsdatum ein, das angibt, dass Sie mindestens 18 Jahre alt sind.",
            "blik.confirmPayment": "\xd6ffnen Sie Ihre Banking-App, um die Zahlung zu best\xe4tigen.",
            "blik.invalid": "6 Zahlen eingeben",
            "blik.code": "6-stelliger Code",
            "blik.help": "Rufen Sie den Code \xfcber Ihre Banking-App ab.",
            "swish.pendingMessage": "Es kann sein, dass der Status bis zu 10 Minuten nach dem Scan \u201Eausstehend\u201C lautet. Wenn Sie w\xe4hrenddessen einen neuen Zahlungsversuch unternehmen, kann es sein, dass Ihnen mehrere Betr\xe4ge in Rechnung gestellt werden.",
            "field.valid": "Feld g\xfcltig",
            "field.invalid": "Feld ung\xfcltig",
            "error.va.gen.01": "Feld nicht ausgef\xfcllt",
            "error.va.gen.02": "Feld ung\xfcltig",
            "error.va.sf-cc-num.01": "Geben Sie eine g\xfcltige Kartennummer ein",
            "error.va.sf-cc-num.02": "Geben Sie die Kartennummer ein",
            "error.va.sf-cc-num.03": "Geben Sie eine unterst\xfctzte Kartenmarke ein",
            "error.va.sf-cc-num.04": "Geben Sie die vollst\xe4ndige Kartennummer ein",
            "error.va.sf-cc-dat.01": "Geben Sie ein g\xfcltiges Ablaufdatum ein",
            "error.va.sf-cc-dat.02": "Geben Sie ein g\xfcltiges Ablaufdatum ein",
            "error.va.sf-cc-dat.03": "Kreditkarte l\xe4uft bald ab",
            "error.va.sf-cc-dat.04": "Geben Sie das Ablaufdatum ein",
            "error.va.sf-cc-dat.05": "Geben Sie das vollst\xe4ndige Ablaufdatum ein",
            "error.va.sf-cc-mth.01": "Geben Sie den Ablaufmonat ein",
            "error.va.sf-cc-yr.01": "Geben Sie das Ablaufjahr ein",
            "error.va.sf-cc-yr.02": "Geben Sie das vollst\xe4ndige Ablaufjahr ein",
            "error.va.sf-cc-cvc.01": "Geben Sie den Sicherheitscode ein",
            "error.va.sf-cc-cvc.02": "Geben Sie den vollst\xe4ndigen Sicherheitscode ein",
            "error.va.sf-ach-num.01": "Das Feld f\xfcr die Bankkontonummer ist leer",
            "error.va.sf-ach-num.02": "Die Bankkontonummer hat die falsche L\xe4nge",
            "error.va.sf-ach-loc.01": "Das Feld f\xfcr die Bankleitzahl ist leer",
            "error.va.sf-ach-loc.02": "Die Bankleitzahl hat die falsche L\xe4nge",
            "error.va.sf-kcp-pwd.01": "Das Passwortfeld ist leer",
            "error.va.sf-kcp-pwd.02": "Das Passwort hat die falsche L\xe4nge",
            "error.giftcard.no-balance": "Auf dieser Geschenkkarte ist kein Guthaben vorhanden",
            "error.giftcard.card-error": "Es gibt in unserem System keine Geschenkkarte mit dieser Nummer",
            "error.giftcard.currency-error": "Geschenkkarten sind nur in der W\xe4hrung g\xfcltig, in der sie ausgestellt wurden",
            "amazonpay.signout": "Von Amazon abmelden",
            "amazonpay.changePaymentDetails": "Zahlungsinformationen \xe4ndern",
            "partialPayment.warning": "W\xe4hlen Sie eine andere Zahlungsmethode zur Zahlung des Restbetrags",
            "partialPayment.remainingBalance": "Es verbleibt ein Restbetrag von %{amount}",
            "bankTransfer.beneficiary": "Empf\xe4nger",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Referenz",
            "bankTransfer.introduction": "Fortfahren, um eine neue Bank\xfcberweisungszahlung zu erstellen. Sie k\xf6nnen die Informationen auf dem n\xe4chsten Bildschirm verwenden, um diese Zahlung abzuschlie\xdfen.",
            "bankTransfer.instructions": "Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.",
            "bacs.accountHolderName": "Name des Bankkontoinhabers",
            "bacs.accountHolderName.invalid": "Ung\xfcltiger Bankkontoinhabername",
            "bacs.accountNumber": "Bankkontonummer",
            "bacs.accountNumber.invalid": "Ung\xfcltige Bankkontonummer",
            "bacs.bankLocationId": "Bankleitzahl",
            "bacs.bankLocationId.invalid": "Ung\xfcltige Bankleitzahl",
            "bacs.consent.amount": "Ich bin damit einverstanden, dass der oben genannte Betrag von meinem Bankkonto abgebucht wird.",
            "bacs.consent.account": "Ich best\xe4tige, dass das Konto unter meinem Namen l\xe4uft und ich der einzige erforderliche Unterzeichner bin, um die Lastschrift f\xfcr dieses Konto zu autorisieren.",
            edit: "Bearbeiten",
            "bacs.confirm": "Best\xe4tigen und bezahlen",
            "bacs.result.introduction": "Laden Sie Ihre Lastschriftanweisung (DDI/Einzugserm\xe4chtigung) herunter",
            "download.pdf": "PDF herunterladen",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe f\xfcr Kartennummer",
            "creditCard.encryptedCardNumber.aria.label": "Kartennummer",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe f\xfcr Ablaufdatum",
            "creditCard.encryptedExpiryDate.aria.label": "Ablaufdatum",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe f\xfcr Ablaufmonat",
            "creditCard.encryptedExpiryMonth.aria.label": "Monat des Ablaufdatums",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe f\xfcr Ablaufjahr",
            "creditCard.encryptedExpiryYear.aria.label": "Jahr des Ablaufdatums",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe f\xfcr Sicherheitscode",
            "creditCard.encryptedSecurityCode.aria.label": "Sicherheitscode",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe f\xfcr Passwort",
            "creditCard.encryptedPassword.aria.label": "Die ersten zwei Ziffern des Kartenpassworts",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe f\xfcr Kartennummer",
            "giftcard.encryptedCardNumber.aria.label": "Kartennummer",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe f\xfcr Stift",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "Der zul\xe4ssige H\xf6chstbetrag pro Transaktion f\xfcr diese Geschenkkarte ist %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe f\xfcr Bankkontonummer",
            "ach.encryptedBankAccountNumber.aria.label": "Kontonummer",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe f\xfcr Bankleitzahl",
            "ach.encryptedBankLocationId.aria.label": "ABA-Nummer",
            "twint.saved": "hinterlegt",
            orPayWith: "oder bezahlen Sie mit",
            invalidFormatExpects: "Ung\xfcltiges Format. Erwartetes Format: %{format}",
            "upi.qrCodeWaitingMessage": "Scannen Sie den QR-Code mit Ihrer bevorzugten UPI-App, um die Zahlung abzuschlie\xdfen.",
            "upi.vpaWaitingMessage": "\xd6ffnen Sie Ihre UPI-App, um die Zahlung zu best\xe4tigen.",
            "upi.modeSelection": "Legen Sie fest, wie Sie UPI nutzen m\xf6chten.",
            "onlineBanking.termsAndConditions": "Wenn Sie fortfahren, stimmen Sie den %#Allgemeinen Gesch\xe4ftsbedingungen%# zu",
            "onlineBankingPL.termsAndConditions": "Indem Sie fortfahren, stimmen Sie den %#Vorschriften%# und der %#Auskunftspflicht%# von Przelewy24 zu",
            "ctp.loading.poweredByCtp": "Unterst\xfctzt von Click to Pay",
            "ctp.loading.intro": "Wir \xfcberpr\xfcfen gerade, ob Sie bereits gespeicherte Click-to-Pay-Karten haben\u2026",
            "ctp.login.title": "Weiter zu Click to Pay",
            "ctp.login.subtitle": "Geben Sie die mit Click to Pay verbundene E-Mail-Adresse ein, um fortzufahren.",
            "ctp.login.inputLabel": "E-Mail-Adresse",
            "ctp.logout.notYou": "Sind das nicht Sie?",
            "ctp.logout.notYourCards": "Sind das nicht Ihre Karten?",
            "ctp.logout.notYourCard": "Das ist nicht Ihre Karte?",
            "ctp.logout.notYourProfile": "Das ist nicht Ihr Profil?",
            "ctp.otp.fieldLabel": "Einmaliger Code",
            "ctp.otp.resendCode": "Code erneut senden",
            "ctp.otp.codeResent": "Code erneut gesendet",
            "ctp.otp.title": "Zugriff auf Ihre Click-to-Pay-Karten",
            "ctp.otp.subtitle": "Geben Sie den Code ein, der von %@ an %@ gesendet wurde, um Ihre Identit\xe4t zu best\xe4tigen.",
            "ctp.otp.saveCookiesCheckbox.label": "Verifizierung beim n\xe4chsten Mal \xfcberspringen",
            "ctp.otp.saveCookiesCheckbox.information": "W\xe4hlen Sie diese Option, um bei teilnehmenden Gesch\xe4ften auf Ihrem Ger\xe4t und Browser gespeichert zu werden, um den Bestellvorgang zu beschleunigen. Nicht f\xfcr gemeinsam genutzte Ger\xe4te empfohlen.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "W\xe4hlen Sie diese Option aus, um auf Ihrem Ger\xe4t und Browser gespeichert zu werden",
            "ctp.emptyProfile.message": "In diesem Click-to-Pay-Profil sind keine Karten registriert",
            "ctp.separatorText": "oder verwenden",
            "ctp.cards.title": "Zahlung mit Click to Pay abschlie\xdfen",
            "ctp.cards.subtitle": "W\xe4hlen Sie die Karte aus, die Sie verwenden m\xf6chten.",
            "ctp.cards.expiredCard": "Abgelaufen",
            "ctp.manualCardEntry": "Manuelle Karteneingabe",
            "ctp.aria.infoModalButton": "Was ist Click to Pay?",
            "ctp.infoPopup.title": "Click to Pay ist so einfach wie kontaktloses Bezahlen, nur online",
            "ctp.infoPopup.subtitle": "Eine schnelle, sichere Zahlungsmethode mit Mastercard, Visa und anderen Zahlungskarten.",
            "ctp.infoPopup.benefit1": "Click to Pay nutzt Verschl\xfcsselung zum Schutz Ihrer Daten",
            "ctp.infoPopup.benefit2": "Verf\xfcgbar bei H\xe4ndlern auf der ganzen Welt",
            "ctp.infoPopup.benefit3": "Nach einmaliger Einrichtung bezahlen Sie in Zukunft mit nur einem Klick.",
            "ctp.errors.AUTH_INVALID": "Authentifizierung ung\xfcltig",
            "ctp.errors.NOT_FOUND": "Kein Konto gefunden, geben Sie eine g\xfcltige E-Mail-Adresse ein oder fahren Sie mit der manuellen Karteneingabe fort.",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Format wird nicht unterst\xfctzt",
            "ctp.errors.FRAUD": "Das Benutzerkonto wurde gesperrt oder deaktiviert",
            "ctp.errors.CONSUMER_ID_MISSING": "Die Identit\xe4t des Verbrauchers fehlt in der Anfrage",
            "ctp.errors.ACCT_INACCESSIBLE": "Dieses Konto ist derzeit nicht verf\xfcgbar; es kann z.\xa0B. gesperrt sein.",
            "ctp.errors.CODE_INVALID": "Falscher Verifizierungscode",
            "ctp.errors.CODE_EXPIRED": "Dieser Code ist abgelaufen",
            "ctp.errors.RETRIES_EXCEEDED": "Das Limit f\xfcr die Anzahl der Wiederholungen f\xfcr das Generieren von Einmalpassw\xf6rtern (OTPs) wurde \xfcberschritten",
            "ctp.errors.OTP_SEND_FAILED": "Das Einmalpasswort (OTP) konnte nicht an den Empf\xe4nger gesendet werden",
            "ctp.errors.REQUEST_TIMEOUT": "Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.",
            "ctp.errors.UNKNOWN_ERROR": "Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.",
            "ctp.errors.SERVICE_ERROR": "Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.",
            "ctp.errors.SERVER_ERROR": "Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.",
            "ctp.errors.INVALID_PARAMETER": "Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.",
            "ctp.errors.AUTH_ERROR": "Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.",
            "paymentMethodsList.aria.label": "W\xe4hlen Sie eine Zahlungsmethode aus",
            "companyDetails.name.invalid": "Geben Sie den Firmennamen ein",
            "companyDetails.registrationNumber.invalid": "Geben Sie die Registrierungsnummer ein",
            "consent.checkbox.invalid": "Sie m\xfcssen den Gesch\xe4ftsbedingungen zustimmen",
            "form.instruction": "Alle Felder sind Pflichtfelder, sofern nicht anders gekennzeichnet.",
            "ancv.input.label": "Ihre ANCV-Identifikation",
            "ancv.confirmPayment": "Best\xe4tigen Sie die Zahlung mit Ihrem ANCV-Antrag.",
            "ancv.form.instruction": "Zur Validierung dieser Zahlung ist der Antrag \u201ECheque-Vacances\u201C erforderlich.",
            "ancv.beneficiaryId.invalid": "Geben Sie eine g\xfcltige E-Mail-Adresse oder ANCV-ID ein",
            "payme.openPayMeApp": "Schlie\xdfen Sie Ihre Zahlung in der PayMe-App ab, indem Sie die Zahlung in der App autorisieren und auf die Best\xe4tigung warten.",
            "payme.redirectButtonLabel": "\xd6ffnen Sie die PayMe-App",
            "payme.scanQrCode": "Schlie\xdfen Sie Ihre Zahlung per QR-Code ab",
            "payme.timeToPay": "Dieser QR-Code gilt f\xfcr %@",
            "payme.instructions.steps": "\xd6ffnen Sie die PayMe-App.%@Scannen Sie den QR-Code, um die Zahlung zu autorisieren.%@Schlie\xdfen Sie die Zahlung in der App ab und warten Sie auf eine Best\xe4tigung.",
            "payme.instructions.footnote": "Bitte schlie\xdfen Sie diese Seite nicht, bevor die Zahlung abgeschlossen ist"
        }
    }), E2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE",
            "payButton.redirecting": "\u0391\u03BD\u03B1\u03BA\u03B1\u03C4\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7...",
            "payButton.with": "\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE %{value} \u03BC\u03B5 %{maskedData}",
            "payButton.saveDetails": "\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03C9\u03BD",
            close: "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF",
            storeDetails: "\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03BC\u03BF\u03C5",
            readMore: "\u0391\u03BD\u03AC\u03B3\u03BD\u03C9\u03C3\u03B7 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03C9\u03BD",
            "creditCard.holderName": "\u038C\u03BD\u03BF\u03BC\u03B1 \u03C3\u03C4\u03B7\u03BD \u03BA\u03AC\u03C1\u03C4\u03B1",
            "creditCard.holderName.placeholder": "\u0393. \u03A0\u03B1\u03C0\u03B1\u03B4\u03AC\u03BA\u03B7\u03C2",
            "creditCard.holderName.invalid": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03CC\u03C0\u03C9\u03C2 \u03B1\u03BD\u03B1\u03B3\u03C1\u03AC\u03C6\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C4\u03B7\u03BD \u03BA\u03AC\u03C1\u03C4\u03B1",
            "creditCard.numberField.title": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "creditCard.expiryDateField.placeholder": "\u039C\u039C/\u0395\u0395",
            "creditCard.expiryDateField.month": "\u039C\u03AE\u03BD\u03B1\u03C2",
            "creditCard.expiryDateField.month.placeholder": "\u039C\u039C",
            "creditCard.expiryDateField.year.placeholder": "\u0395\u0395",
            "creditCard.expiryDateField.year": "\u0388\u03C4\u03BF\u03C2",
            "creditCard.cvcField.title": "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03B1\u03C2",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "\u0391\u03C0\u03BF\u03BC\u03BD\u03B7\u03BC\u03CC\u03BD\u03B5\u03C5\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u03C6\u03BF\u03C1\u03AC",
            "creditCard.cvcField.placeholder.4digits": "4\u03C8\u03AE\u03C6\u03B9\u03BF\u03C2",
            "creditCard.cvcField.placeholder.3digits": "3\u03C8\u03AE\u03C6\u03B9\u03BF\u03C2",
            "creditCard.taxNumber.placeholder": "\u0395\u0395\u039C\u039C\u0397\u0397 / 0123456789",
            installments: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B4\u03CC\u03C3\u03B5\u03C9\u03BD",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} \u03BC\u03AE\u03BD\u03B5\u03C2",
            "installments.oneTime": "\u0395\u03C6\u03AC\u03C0\u03B1\u03BE \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE",
            "installments.installments": "\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03BC\u03B5 \u03B4\u03CC\u03C3\u03B5\u03B9\u03C2",
            "installments.revolving": "\u0391\u03BD\u03B1\u03BA\u03C5\u03BA\u03BB\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE",
            "sepaDirectDebit.ibanField.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "sepaDirectDebit.nameField.placeholder": "\u0393. \u03A0\u03B1\u03C0\u03B1\u03B4\u03AC\u03BA\u03B7\u03C2",
            "sepa.ownerName": "\u038C\u03BD\u03BF\u03BC\u03B1 \u03BA\u03B1\u03C4\u03CC\u03C7\u03BF\u03C5",
            "sepa.ibanNumber": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD (IBAN)",
            "error.title": "\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1",
            "error.subtitle.redirect": "\u0397 \u03B1\u03BD\u03B1\u03BA\u03B1\u03C4\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03B1\u03C0\u03AD\u03C4\u03C5\u03C7\u03B5",
            "error.subtitle.payment": "\u0397 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03B1\u03C0\u03AD\u03C4\u03C5\u03C7\u03B5",
            "error.subtitle.refused": "\u0397 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03B1\u03C0\u03BF\u03C1\u03C1\u03AF\u03C6\u03B8\u03B7\u03BA\u03B5",
            "error.message.unknown": "\u03A0\u03C1\u03BF\u03AD\u03BA\u03C5\u03C8\u03B5 \u03AC\u03B3\u03BD\u03C9\u03C3\u03C4\u03BF \u03C3\u03C6\u03AC\u03BB\u03BC\u03B1",
            "errorPanel.title": "\u03A5\u03C0\u03AC\u03C1\u03C7\u03BF\u03BD\u03C4\u03B1 \u03C3\u03C6\u03AC\u03BB\u03BC\u03B1\u03C4\u03B1",
            "idealIssuer.selectField.title": "\u03A4\u03C1\u03AC\u03C0\u03B5\u03B6\u03B1",
            "idealIssuer.selectField.placeholder": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C4\u03C1\u03AC\u03C0\u03B5\u03B6\u03AC \u03C3\u03B1\u03C2",
            "creditCard.success": "\u0397 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03CE\u03C2",
            loading: "\u03A6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7...",
            continue: "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1",
            continueTo: "\u039C\u03B5\u03C4\u03AC\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7\u03BD",
            "wechatpay.timetopay": "\u0388\u03C7\u03B5\u03C4\u03B5 \u03C3\u03C4\u03B7 \u03B4\u03B9\u03AC\u03B8\u03B5\u03C3\u03AE \u03C3\u03B1\u03C2 %@ \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE",
            "sr.wechatpay.timetopay": "\u0388\u03C7\u03B5\u03C4\u03B5 %#\u03BB\u03B5\u03C0\u03C4\u03AC%# %#\u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1%# \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5",
            "wechatpay.scanqrcode": "\u03A3\u03AC\u03C1\u03C9\u03C3\u03B7 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD QR",
            personalDetails: "\u03A0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03AC \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1",
            companyDetails: "\u03A3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2",
            "companyDetails.name": "\u038C\u03BD\u03BF\u03BC\u03B1 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2",
            "companyDetails.registrationNumber": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5",
            socialSecurityNumber: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C6\u03BF\u03C1\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03BF\u03CD \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5",
            firstName: "\u038C\u03BD\u03BF\u03BC\u03B1",
            "firstName.invalid": "\u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03CC\u03BD\u03BF\u03BC\u03AC \u03C3\u03B1\u03C2",
            infix: "\u03A0\u03C1\u03CC\u03B8\u03B5\u03BC\u03B1",
            lastName: "\u0395\u03C0\u03CE\u03BD\u03C5\u03BC\u03BF",
            "lastName.invalid": "\u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03B5\u03C0\u03CE\u03BD\u03C5\u03BC\u03CC \u03C3\u03B1\u03C2",
            mobileNumber: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BA\u03B9\u03BD\u03B7\u03C4\u03BF\u03CD",
            "mobileNumber.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BA\u03B9\u03BD\u03B7\u03C4\u03BF\u03CD",
            city: "\u03A0\u03CC\u03BB\u03B7",
            postalCode: "\u03A4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2",
            "postalCode.optional": "\u03A4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 (\u03C0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC)",
            countryCode: "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C7\u03CE\u03C1\u03B1\u03C2",
            telephoneNumber: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5",
            dateOfBirth: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B3\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2",
            shopperEmail: "\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email",
            gender: "\u03A6\u03CD\u03BB\u03BF",
            "gender.notselected": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03BF \u03C6\u03CD\u03BB\u03BF \u03C3\u03B1\u03C2",
            male: "\u0386\u03BD\u03C4\u03C1\u03B1\u03C2",
            female: "\u0393\u03C5\u03BD\u03B1\u03AF\u03BA\u03B1",
            billingAddress: "\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03C4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2",
            street: "\u039F\u03B4\u03CC\u03C2",
            stateOrProvince: "\u03A0\u03BF\u03BB\u03B9\u03C4\u03B5\u03AF\u03B1 \u03AE \u03B5\u03C0\u03B1\u03C1\u03C7\u03AF\u03B1",
            country: "\u03A7\u03CE\u03C1\u03B1/\u03A0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AE",
            houseNumberOrName: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BF\u03B9\u03BA\u03AF\u03B1\u03C2",
            separateDeliveryAddress: "\u039A\u03B1\u03B8\u03BF\u03C1\u03AF\u03C3\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03BE\u03B5\u03C7\u03C9\u03C1\u03B9\u03C3\u03C4\u03AE \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03C0\u03B1\u03C1\u03AC\u03B4\u03BF\u03C3\u03B7\u03C2",
            deliveryAddress: "\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03C0\u03B1\u03C1\u03AC\u03B4\u03BF\u03C3\u03B7\u03C2",
            "deliveryAddress.firstName": "\u038C\u03BD\u03BF\u03BC\u03B1 \u03C0\u03B1\u03C1\u03B1\u03BB\u03AE\u03C0\u03C4\u03B7",
            "deliveryAddress.lastName": "\u0395\u03C0\u03CE\u03BD\u03C5\u03BC\u03BF \u03C0\u03B1\u03C1\u03B1\u03BB\u03AE\u03C0\u03C4\u03B7",
            zipCode: "\u03A4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2 \u03BA\u03CE\u03B4\u03B9\u03BA\u03B1\u03C2",
            apartmentSuite: "\u0394\u03B9\u03B1\u03BC\u03AD\u03C1\u03B9\u03C3\u03BC\u03B1/\u0393\u03C1\u03B1\u03C6\u03B5\u03AF\u03BF",
            provinceOrTerritory: "\u0395\u03C0\u03B1\u03C1\u03C7\u03AF\u03B1 \u03AE \u03C0\u03B5\u03C1\u03B9\u03C6\u03AD\u03C1\u03B5\u03B9\u03B1",
            cityTown: "\u03A0\u03CC\u03BB\u03B7 / \u039A\u03BF\u03B9\u03BD\u03CC\u03C4\u03B7\u03C4\u03B1",
            address: "\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7",
            "address.placeholder": "\u0392\u03C1\u03B5\u03AF\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03AE \u03C3\u03B1\u03C2",
            "address.errors.incomplete": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5",
            "address.enterManually": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03BC\u03B7 \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B1",
            state: "\u03A0\u03BF\u03BB\u03B9\u03C4\u03B5\u03AF\u03B1",
            "field.title.optional": "(\u03C0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC)",
            "creditCard.cvcField.title.optional": "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03B1\u03C2 (\u03C0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC)",
            "issuerList.wallet.placeholder": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2",
            privacyPolicy: "\u03A0\u03BF\u03BB\u03B9\u03C4\u03B9\u03BA\u03AE \u03B1\u03C0\u03BF\u03C1\u03C1\u03AE\u03C4\u03BF\u03C5",
            "afterPay.agreement": "\u0391\u03C0\u03BF\u03B4\u03AD\u03C7\u03BF\u03BC\u03B1\u03B9 \u03C4\u03BF\u03C5\u03C2 %@ \u03C4\u03BF\u03C5 Riverty",
            paymentConditions: "\u03CC\u03C1\u03BF\u03C5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
            openApp: "\u0386\u03BD\u03BF\u03B9\u03B3\u03BC\u03B1 \u03C4\u03B7\u03C2 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE\u03C2",
            "voucher.readInstructions": "\u0394\u03B9\u03B1\u03B2\u03AC\u03C3\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03BF\u03B4\u03B7\u03B3\u03AF\u03B5\u03C2",
            "voucher.introduction": "\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B1\u03B3\u03BF\u03C1\u03AC. \u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9 \u03BA\u03BF\u03C5\u03C0\u03CC\u03BD\u03B9 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE.",
            "voucher.expirationDate": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "voucher.alternativeReference": "\u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03BA\u03C4\u03B9\u03BA\u03AE \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC",
            "dragonpay.voucher.non.bank.selectField.placeholder": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C0\u03AC\u03C1\u03BF\u03C7\u03CC \u03C3\u03B1\u03C2",
            "dragonpay.voucher.bank.selectField.placeholder": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C4\u03C1\u03AC\u03C0\u03B5\u03B6\u03AC \u03C3\u03B1\u03C2",
            "voucher.paymentReferenceLabel": "\u0391\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
            "voucher.surcharge": "\u03A0\u03B5\u03C1\u03B9\u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03B5\u03C4\u03B1\u03B9 \u03C0\u03C1\u03CC\u03C3\u03B8\u03B5\u03C4\u03B7 \u03C7\u03C1\u03AD\u03C9\u03C3\u03B7 %@",
            "voucher.introduction.doku": "\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B1\u03B3\u03BF\u03C1\u03AC. \u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE.",
            "voucher.shopperName": "\u038C\u03BD\u03BF\u03BC\u03B1 \u03B1\u03B3\u03BF\u03C1\u03B1\u03C3\u03C4\u03AE",
            "voucher.merchantName": "\u0388\u03BC\u03C0\u03BF\u03C1\u03BF\u03C2",
            "voucher.introduction.econtext": "\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B1\u03B3\u03BF\u03C1\u03AC. \u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE.",
            "voucher.telephoneNumber": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5",
            "voucher.shopperReference": "\u0391\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03B1\u03B3\u03BF\u03C1\u03B1\u03C3\u03C4\u03AE",
            "voucher.collectionInstitutionNumber": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C0\u03C1\u03B1\u03BA\u03C4\u03BF\u03C1\u03B5\u03AF\u03BF\u03C5 \u03B5\u03B9\u03C3\u03C0\u03C1\u03AC\u03BE\u03B5\u03C9\u03BD",
            "voucher.econtext.telephoneNumber.invalid": "\u039F \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9 10 \u03AE 11 \u03C8\u03B7\u03C6\u03AF\u03B1",
            "boletobancario.btnLabel": "\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 Boleto",
            "boleto.sendCopyToEmail": "\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03B1\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C6\u03BF\u03C5 \u03C3\u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03BC\u03BF\u03C5",
            "button.copy": "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE",
            "button.download": "\u039B\u03AE\u03C8\u03B7",
            "boleto.socialSecurityNumber.invalid": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5  \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC CPF/CNPJ",
            "creditCard.storedCard.description.ariaLabel": "\u0397 \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03C5\u03BC\u03AD\u03BD\u03B7 \u03BA\u03AC\u03C1\u03C4\u03B1 \u03C4\u03B5\u03BB\u03B5\u03B9\u03CE\u03BD\u03B5\u03B9 \u03C3\u03B5 %@",
            "voucher.entity": "\u039F\u03BD\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1",
            donateButton: "\u0394\u03C9\u03C1\u03B5\u03AC",
            notNowButton: "\u038C\u03C7\u03B9 \u03C4\u03CE\u03C1\u03B1",
            thanksForYourSupport: "\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C5\u03C0\u03BF\u03C3\u03C4\u03AE\u03C1\u03B9\u03BE\u03B7!",
            "resultMessages.preauthorized": "\u03A4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03CD\u03C4\u03B7\u03BA\u03B1\u03BD",
            preauthorizeWith: "\u03A0\u03C1\u03BF\u03B5\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03CC\u03C4\u03B7\u03C3\u03B7 \u03BC\u03B5",
            confirmPreauthorization: "\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03C0\u03C1\u03BF\u03B5\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03CC\u03C4\u03B7\u03C3\u03B7\u03C2",
            confirmPurchase: "\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03B1\u03B3\u03BF\u03C1\u03AC\u03C2",
            applyGiftcard: "\u0395\u03BE\u03B1\u03C1\u03B3\u03CD\u03C1\u03C9\u03C3\u03B7",
            giftcardBalance: "\u03A5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF \u03B4\u03C9\u03C1\u03BF\u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            deductedBalance: "\u03A5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF \u03C0\u03BF\u03C5 \u03B1\u03C6\u03B1\u03B9\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5",
            "creditCard.pin.title": "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 PIN",
            "creditCard.encryptedPassword.label": "\u03A4\u03B1 \u03C0\u03C1\u03CE\u03C4\u03B1 2 \u03C8\u03B7\u03C6\u03AF\u03B1 \u03C4\u03BF\u03C5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03C4\u03B7\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2",
            "creditCard.taxNumber": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B3\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2 \u03BA\u03B1\u03C4\u03CC\u03C7\u03BF\u03C5 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2 \u03AE \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03B9\u03CE\u03BD",
            "creditCard.taxNumber.label": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B3\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2 \u03BA\u03B1\u03C4\u03CC\u03C7\u03BF\u03C5 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2 (YYMMDD) \u03AE \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03B9\u03CE\u03BD (10 \u03C8\u03B7\u03C6\u03AF\u03B1)",
            "creditCard.taxNumber.labelAlt": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03B9\u03CE\u03BD (10 \u03C8\u03B7\u03C6\u03AF\u03B1)",
            "creditCard.taxNumber.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B3\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2 \u03BA\u03B1\u03C4\u03CC\u03C7\u03BF\u03C5 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2 \u03AE \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03B9\u03CE\u03BD",
            "storedPaymentMethod.disable.button": "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7",
            "storedPaymentMethod.disable.confirmation": "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03C5\u03BC\u03AD\u03BD\u03BF\u03C5 \u03C4\u03C1\u03CC\u03C0\u03BF\u03C5 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
            "storedPaymentMethod.disable.confirmButton": "\u039D\u03B1\u03B9, \u03B1\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7",
            "storedPaymentMethod.disable.cancelButton": "\u0386\u03BA\u03C5\u03C1\u03BF",
            "ach.bankAccount": "\u03A4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03CC\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2",
            "ach.accountHolderNameField.title": "\u038C\u03BD\u03BF\u03BC\u03B1 \u03BA\u03B1\u03C4\u03CC\u03C7\u03BF\u03C5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "ach.accountHolderNameField.placeholder": "\u0393. \u03A0\u03B1\u03C0\u03B1\u03B4\u03AC\u03BA\u03B7\u03C2",
            "ach.accountHolderNameField.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03BA\u03B1\u03C4\u03CC\u03C7\u03BF\u03C5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "ach.accountNumberField.title": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "ach.accountNumberField.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "ach.accountLocationField.title": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B4\u03C1\u03BF\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2 ABA",
            "ach.accountLocationField.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B4\u03C1\u03BF\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2 ABA",
            "ach.savedBankAccount": "\u0391\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03C5\u03BC\u03AD\u03BD\u03BF\u03C2 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03CC\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2",
            "select.state": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C0\u03BF\u03BB\u03B9\u03C4\u03B5\u03AF\u03B1",
            "select.stateOrProvince": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C0\u03BF\u03BB\u03B9\u03C4\u03B5\u03AF\u03B1 \u03AE \u03B5\u03C0\u03B1\u03C1\u03C7\u03AF\u03B1",
            "select.provinceOrTerritory": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B5\u03C0\u03B1\u03C1\u03C7\u03AF\u03B1 \u03AE \u03C0\u03B5\u03C1\u03B9\u03C6\u03AD\u03C1\u03B5\u03B9\u03B1",
            "select.country": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C7\u03CE\u03C1\u03B1/\u03C0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AE",
            "select.noOptionsFound": "\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2",
            "select.filter.placeholder": "\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7...",
            "telephoneNumber.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5",
            qrCodeOrApp: "\u03AE",
            "paypal.processingPayment": "\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2...",
            generateQRCode: "\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD QR",
            "await.waitForConfirmation": "\u0391\u03BD\u03B1\u03BC\u03BF\u03BD\u03AE \u03B3\u03B9\u03B1 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7\u2026",
            "mbway.confirmPayment": "\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C3\u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE MB WAY",
            "shopperEmail.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email",
            "dateOfBirth.format": "\u0397\u0397/\u039C\u039C/\u0395\u0395\u0395\u0395",
            "dateOfBirth.invalid": "\u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B3\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2 \u03C0\u03BF\u03C5 \u03C5\u03C0\u03BF\u03B4\u03B7\u03BB\u03CE\u03BD\u03B5\u03B9 \u03CC\u03C4\u03B9 \u03B5\u03AF\u03C3\u03C4\u03B5 \u03B7\u03BB\u03B9\u03BA\u03AF\u03B1\u03C2 \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD 18 \u03B5\u03C4\u03CE\u03BD",
            "blik.confirmPayment": "\u0391\u03BD\u03BF\u03AF\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE.",
            "blik.invalid": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 6 \u03C8\u03B7\u03C6\u03AF\u03B1",
            "blik.code": "6\u03C8\u03AE\u03C6\u03B9\u03BF\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2",
            "blik.help": "\u039B\u03AC\u03B2\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE\u03C2 \u03C3\u03B1\u03C2.",
            "swish.pendingMessage": "\u039C\u03B5\u03C4\u03AC \u03C4\u03B7 \u03C3\u03AC\u03C1\u03C9\u03C3\u03B7, \u03B7 \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03AE\u03C2 \u03B3\u03B9\u03B1 \u03AD\u03C9\u03C2 10 \u03BB\u03B5\u03C0\u03C4\u03AC. \u0397 \u03B1\u03C0\u03CC\u03C0\u03B5\u03B9\u03C1\u03B1 \u03B5\u03BA \u03BD\u03AD\u03BF\u03C5 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03B5\u03BD\u03C4\u03CC\u03C2 \u03B1\u03C5\u03C4\u03BF\u03CD \u03C4\u03BF\u03C5 \u03C7\u03C1\u03BF\u03BD\u03B9\u03BA\u03BF\u03CD \u03B4\u03B9\u03B1\u03C3\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2 \u03B5\u03BD\u03B4\u03AD\u03C7\u03B5\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03BA\u03B1\u03BB\u03AD\u03C3\u03B5\u03B9 \u03C0\u03C1\u03CC\u03C3\u03B8\u03B5\u03C4\u03B7 \u03C7\u03C1\u03AD\u03C9\u03C3\u03B7.",
            "field.valid": "\u03A4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF",
            "field.invalid": "\u03A4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF",
            "error.va.gen.01": "\u0395\u03BB\u03BB\u03B9\u03C0\u03AD\u03C2 \u03C0\u03B5\u03B4\u03AF\u03BF",
            "error.va.gen.02": "\u03A4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF",
            "error.va.sf-cc-num.01": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "error.va.sf-cc-num.02": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C4\u03B7\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "error.va.sf-cc-num.03": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03B9\u03B6\u03CC\u03BC\u03B5\u03BD\u03B7 \u03B5\u03C0\u03C9\u03BD\u03C5\u03BC\u03AF\u03B1 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "error.va.sf-cc-num.04": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C0\u03BB\u03AE\u03C1\u03B7 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C4\u03B7\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "error.va.sf-cc-dat.01": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "error.va.sf-cc-dat.02": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "error.va.sf-cc-dat.03": "\u0397 \u03C0\u03B9\u03C3\u03C4\u03C9\u03C4\u03B9\u03BA\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1 \u03C0\u03C1\u03CC\u03BA\u03B5\u03B9\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03BB\u03AE\u03BE\u03B5\u03B9 \u03C3\u03CD\u03BD\u03C4\u03BF\u03BC\u03B1",
            "error.va.sf-cc-dat.04": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "error.va.sf-cc-dat.05": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03AE\u03C1\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "error.va.sf-cc-mth.01": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BC\u03AE\u03BD\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "error.va.sf-cc-yr.01": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF \u03AD\u03C4\u03BF\u03C2 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "error.va.sf-cc-yr.02": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF \u03C0\u03BB\u03AE\u03C1\u03B5\u03C2 \u03AD\u03C4\u03BF\u03C2 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "error.va.sf-cc-cvc.01": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03B1\u03C2",
            "error.va.sf-cc-cvc.02": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C0\u03BB\u03AE\u03C1\u03B7 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03B1\u03C2",
            "error.va.sf-ach-num.01": "\u03A4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u03B1\u03C1\u03B9\u03B8\u03BC\u03BF\u03CD \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03B5\u03BD\u03CC",
            "error.va.sf-ach-num.02": "\u039F \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD \u03B4\u03B5\u03BD \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9 \u03C4\u03BF\u03BD \u03C3\u03C9\u03C3\u03C4\u03CC \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03C9\u03BD",
            "error.va.sf-ach-loc.01": "\u03A4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u03B1\u03C1\u03B9\u03B8\u03BC\u03BF\u03CD \u03B4\u03C1\u03BF\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2 \u03C4\u03C1\u03AC\u03C0\u03B5\u03B6\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03B5\u03BD\u03CC",
            "error.va.sf-ach-loc.02": "\u039F \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B4\u03C1\u03BF\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2 \u03C4\u03C1\u03AC\u03C0\u03B5\u03B6\u03B1\u03C2 \u03B4\u03B5\u03BD \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9 \u03C4\u03BF\u03BD \u03C3\u03C9\u03C3\u03C4\u03CC \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03C9\u03BD",
            "error.va.sf-kcp-pwd.01": "\u03A4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03B5\u03BD\u03CC",
            "error.va.sf-kcp-pwd.02": "\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03B4\u03B5\u03BD \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9 \u03C4\u03BF\u03BD \u03C3\u03C9\u03C3\u03C4\u03CC \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03C9\u03BD",
            "error.giftcard.no-balance": "\u0397 \u03C3\u03C5\u03B3\u03BA\u03B5\u03BA\u03C1\u03B9\u03BC\u03AD\u03BD\u03B7 \u03B4\u03C9\u03C1\u03BF\u03BA\u03AC\u03C1\u03C4\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03BC\u03B7\u03B4\u03B5\u03BD\u03B9\u03BA\u03CC \u03C5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF",
            "error.giftcard.card-error": "\u03A3\u03C4\u03B1 \u03B1\u03C1\u03C7\u03B5\u03AF\u03B1 \u03BC\u03B1\u03C2 \u03B4\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 \u03B4\u03C9\u03C1\u03BF\u03BA\u03AC\u03C1\u03C4\u03B1 \u03BC\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC",
            "error.giftcard.currency-error": "\u039F\u03B9 \u03B4\u03C9\u03C1\u03BF\u03BA\u03AC\u03C1\u03C4\u03B5\u03C2 \u03B9\u03C3\u03C7\u03CD\u03BF\u03C5\u03BD \u03BC\u03CC\u03BD\u03BF \u03B3\u03B9\u03B1 \u03C4\u03BF \u03BD\u03CC\u03BC\u03B9\u03C3\u03BC\u03B1 \u03C3\u03C4\u03BF \u03BF\u03C0\u03BF\u03AF\u03BF \u03B5\u03BA\u03B4\u03CC\u03B8\u03B7\u03BA\u03B1\u03BD",
            "amazonpay.signout": "\u0391\u03C0\u03BF\u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03B1\u03C0\u03CC \u03C4\u03BF Amazon",
            "amazonpay.changePaymentDetails": "\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03C9\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
            "partialPayment.warning": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03AD\u03BD\u03B1\u03BD \u03AC\u03BB\u03BB\u03BF \u03C4\u03C1\u03CC\u03C0\u03BF \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03B3\u03B9\u03B1 \u03BA\u03B1\u03C4\u03B1\u03B2\u03BF\u03BB\u03AE \u03C4\u03BF\u03C5 \u03B5\u03BD\u03B1\u03C0\u03BF\u03BC\u03B5\u03AF\u03BD\u03B1\u03BD\u03C4\u03BF\u03C2 \u03C0\u03BF\u03C3\u03BF\u03CD",
            "partialPayment.remainingBalance": "\u03A4\u03BF \u03C5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF \u03B8\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 %{amount}",
            "bankTransfer.beneficiary": "\u0394\u03B9\u03BA\u03B1\u03B9\u03BF\u03CD\u03C7\u03BF\u03C2",
            "bankTransfer.iban": "\u0399\u0392\u0391\u039D",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "\u0391\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC",
            "bankTransfer.introduction": "\u03A3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BD\u03AD\u03B1 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03BC\u03AD\u03C3\u03C9 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE\u03C2 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2. \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C3\u03C4\u03B7\u03BD \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B7 \u03BF\u03B8\u03CC\u03BD\u03B7 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE.",
            "bankTransfer.instructions": "\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B1\u03B3\u03BF\u03C1\u03AC. \u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE.",
            "bacs.accountHolderName": "\u038C\u03BD\u03BF\u03BC\u03B1 \u03B4\u03B9\u03BA\u03B1\u03B9\u03BF\u03CD\u03C7\u03BF\u03C5 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "bacs.accountHolderName.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03B4\u03B9\u03BA\u03B1\u03B9\u03BF\u03CD\u03C7\u03BF\u03C5 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "bacs.accountNumber": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "bacs.accountNumber.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "bacs.bankLocationId": "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C4\u03C1\u03AC\u03C0\u03B5\u03B6\u03B1\u03C2",
            "bacs.bankLocationId.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C4\u03C1\u03AC\u03C0\u03B5\u03B6\u03B1\u03C2",
            "bacs.consent.amount": "\u0391\u03C0\u03BF\u03B4\u03AD\u03C7\u03BF\u03BC\u03B1\u03B9 \u03CC\u03C4\u03B9 \u03C4\u03BF \u03C0\u03B9\u03BF \u03C0\u03AC\u03BD\u03C9 \u03C0\u03BF\u03C3\u03CC \u03B8\u03B1 \u03B1\u03C6\u03B1\u03B9\u03C1\u03B5\u03B8\u03B5\u03AF \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03CC \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03BC\u03BF\u03C5.",
            "bacs.consent.account": "\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03BD\u03C9 \u03CC\u03C4\u03B9 \u03BF \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C4\u03BF \u03CC\u03BD\u03BF\u03BC\u03AC \u03BC\u03BF\u03C5 \u03BA\u03B1\u03B9 \u03C0\u03C9\u03C2 \u03B5\u03AF\u03BC\u03B1\u03B9 \u03BF/\u03B7 \u03BC\u03BF\u03BD\u03B1\u03B4\u03B9\u03BA\u03CC\u03C2/\u03BC\u03BF\u03BD\u03B1\u03B4\u03B9\u03BA\u03AE \u03C5\u03C0\u03BF\u03B3\u03C1\u03AC\u03C6\u03C9\u03BD/\u03C5\u03C0\u03BF\u03B3\u03C1\u03AC\u03C6\u03BF\u03C5\u03C3\u03B1 \u03C0\u03BF\u03C5 \u03B1\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9 \u03B3\u03B9\u03B1 \u03B5\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03CC\u03C4\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u0386\u03BC\u03B5\u03C3\u03B7\u03C2 \u03A7\u03C1\u03AD\u03C9\u03C3\u03B7\u03C2 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC.",
            edit: "\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1",
            "bacs.confirm": "\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03BA\u03B1\u03B9 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE",
            "bacs.result.introduction": "\u039A\u03B1\u03C4\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u0395\u03BD\u03C4\u03BF\u03BB\u03AE \u0386\u03BC\u03B5\u03C3\u03B7\u03C2 \u03A7\u03C1\u03AD\u03C9\u03C3\u03B7\u03C2 (DDI/\u0395\u03BD\u03C4\u03BF\u03BB\u03AE)",
            "download.pdf": "\u039B\u03AE\u03C8\u03B7 PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "creditCard.encryptedCardNumber.aria.label": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "creditCard.encryptedExpiryDate.aria.label": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03BC\u03AE\u03BD\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "creditCard.encryptedExpiryMonth.aria.label": "\u039C\u03AE\u03BD\u03B1\u03C2 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03AD\u03C4\u03BF\u03C2 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "creditCard.encryptedExpiryYear.aria.label": "\u0388\u03C4\u03BF\u03C2 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03B1\u03C2",
            "creditCard.encryptedSecurityCode.aria.label": "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03B1\u03C2",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2",
            "creditCard.encryptedPassword.aria.label": "\u03A4\u03B1 \u03C0\u03C1\u03CE\u03C4\u03B1 2 \u03C8\u03B7\u03C6\u03AF\u03B1 \u03C4\u03BF\u03C5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03C4\u03B7\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "giftcard.encryptedCardNumber.aria.label": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 PIN",
            "giftcard.encryptedSecurityCode.aria.label": "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 PIN",
            giftcardTransactionLimit: "\u03A4\u03BF \u03BC\u03AD\u03B3\u03B9\u03C3\u03C4\u03BF \u03B5\u03C0\u03B9\u03C4\u03C1\u03B5\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF \u03C0\u03BF\u03C3\u03CC \u03B1\u03BD\u03AC \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03C3\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03B4\u03C9\u03C1\u03BF\u03BA\u03AC\u03C1\u03C4\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "ach.encryptedBankAccountNumber.aria.label": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C5\u03C0\u03BF\u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2 \u03C4\u03C1\u03AC\u03C0\u03B5\u03B6\u03B1\u03C2",
            "ach.encryptedBankLocationId.aria.label": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B4\u03C1\u03BF\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2 ABA",
            "twint.saved": "\u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03CD\u03C4\u03B7\u03BA\u03B5",
            orPayWith: "\u03AE \u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03BC\u03B5",
            invalidFormatExpects: "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03BC\u03BF\u03C1\u03C6\u03AE. \u0391\u03BD\u03B1\u03BC\u03B5\u03BD\u03CC\u03BC\u03B5\u03BD\u03B7 \u03BC\u03BF\u03C1\u03C6\u03AE: %{format}",
            "upi.qrCodeWaitingMessage": "\u03A3\u03B1\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC QR \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03C4\u03B9\u03BC\u03CE\u03BC\u03B5\u03BD\u03B7 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE UPI \u03B3\u03B9\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
            "upi.vpaWaitingMessage": "\u0391\u03BD\u03BF\u03AF\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE UPI \u03B3\u03B9\u03B1 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
            "upi.modeSelection": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03C1\u03CD\u03B8\u03BC\u03B9\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03BD \u03C4\u03C1\u03CC\u03C0\u03BF \u03C7\u03C1\u03AE\u03C3\u03B7\u03C2 \u03C4\u03BF\u03C5 UPI.",
            "onlineBanking.termsAndConditions": "\u0391\u03BD \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5, \u03C3\u03C5\u03BD\u03B5\u03C0\u03AC\u03B3\u03B5\u03C4\u03B1\u03B9 \u03CC\u03C4\u03B9 \u03B1\u03C0\u03BF\u03B4\u03AD\u03C7\u03B5\u03C3\u03C4\u03B5 \u03C4\u03BF\u03C5\u03C2 %#\u038C\u03C1\u03BF\u03C5\u03C2 \u03BA\u03B1\u03B9 \u03C0\u03C1\u03BF\u03CB\u03C0\u03BF\u03B8\u03AD\u03C3\u03B5\u03B9\u03C2%#",
            "onlineBankingPL.termsAndConditions": "\u03A3\u03C5\u03BD\u03B5\u03C7\u03AF\u03B6\u03BF\u03BD\u03C4\u03B1\u03C2, \u03C3\u03C5\u03BC\u03C6\u03C9\u03BD\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03BF\u03C5\u03C2 %#\u03BA\u03B1\u03BD\u03BF\u03BD\u03B9\u03C3\u03BC\u03BF\u03CD\u03C2%# \u03BA\u03B1\u03B9 \u03C4\u03B7\u03BD %#\u03C5\u03C0\u03BF\u03C7\u03C1\u03AD\u03C9\u03C3\u03B7 \u03B5\u03BD\u03B7\u03BC\u03AD\u03C1\u03C9\u03C3\u03B7\u03C2%# \u03C4\u03B7\u03C2 Przelewy24",
            "ctp.loading.poweredByCtp": "\u039C\u03B5 \u03C4\u03B7\u03BD \u03C5\u03C0\u03BF\u03C3\u03C4\u03AE\u03C1\u03B9\u03BE\u03B7 \u03C4\u03BF\u03C5 Click to Pay",
            "ctp.loading.intro": "\u0388\u03BB\u03B5\u03B3\u03C7\u03BF\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03C0\u03B9\u03C3\u03C4\u03C9\u03B8\u03B5\u03AF \u03B1\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03C5\u03BC\u03AD\u03BD\u03B5\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B5\u03C2 \u03BC\u03B5 Click to Pay...",
            "ctp.login.title": "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1 \u03C3\u03C4\u03BF Click to Pay",
            "ctp.login.subtitle": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03C0\u03BF\u03C5 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03B7 \u03BC\u03B5 \u03C4\u03BF Click to Pay \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5.",
            "ctp.login.inputLabel": "Email",
            "ctp.logout.notYou": "\u0394\u03B5\u03BD \u03B5\u03AF\u03C3\u03C4\u03B5 \u03B5\u03C3\u03B5\u03AF\u03C2 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03AC\u03C4\u03BF\u03BC\u03BF;",
            "ctp.logout.notYourCards": "\u0391\u03C5\u03C4\u03AD\u03C2 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BF\u03B9 \u03BA\u03AC\u03C1\u03C4\u03B5\u03C2 \u03C3\u03B1\u03C2;",
            "ctp.logout.notYourCard": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B7 \u03BA\u03AC\u03C1\u03C4\u03B1 \u03C3\u03B1\u03C2;",
            "ctp.logout.notYourProfile": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB \u03C3\u03B1\u03C2;",
            "ctp.otp.fieldLabel": "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03BC\u03B9\u03B1\u03C2 \u03C7\u03C1\u03AE\u03C3\u03B7\u03C2",
            "ctp.otp.resendCode": "\u0395\u03BA \u03BD\u03AD\u03BF\u03C5 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD",
            "ctp.otp.codeResent": "\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C3\u03C4\u03AC\u03BB\u03B8\u03B7\u03BA\u03B5 \u03B5\u03BA \u03BD\u03AD\u03BF\u03C5",
            "ctp.otp.title": "\u03A0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B9\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B5\u03C2 Click to Pay \u03C3\u03B1\u03C2",
            "ctp.otp.subtitle": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC %@ \u03C0\u03BF\u03C5 \u03C3\u03C4\u03AC\u03BB\u03B8\u03B7\u03BA\u03B5 \u03C3\u03C4\u03BF %@ \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03C0\u03B1\u03BB\u03B7\u03B8\u03B5\u03CD\u03C3\u03B5\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03B5\u03AF\u03C3\u03C4\u03B5 \u03B5\u03C3\u03B5\u03AF\u03C2.",
            "ctp.otp.saveCookiesCheckbox.label": "\u03A0\u03B1\u03C1\u03AC\u03B2\u03BB\u03B5\u03C8\u03B7 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C4\u03B7\u03BD \u03B5\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u03C6\u03BF\u03C1\u03AC",
            "ctp.otp.saveCookiesCheckbox.information": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03BC\u03BD\u03B7\u03BC\u03BF\u03BD\u03B5\u03CD\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C4\u03B7 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03BA\u03B1\u03B9 \u03C3\u03C4\u03BF \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03C0\u03B5\u03C1\u03B9\u03AE\u03B3\u03B7\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03C3\u03C4\u03B1 \u03C3\u03C5\u03BC\u03BC\u03B5\u03C4\u03AD\u03C7\u03BF\u03BD\u03C4\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AE\u03BC\u03B1\u03C4\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B1\u03C7\u03CD\u03C4\u03B5\u03C1\u03B7 \u03BF\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2. \u0394\u03B5\u03BD \u03C3\u03C5\u03BD\u03B9\u03C3\u03C4\u03AC\u03C4\u03B1\u03B9 \u03B3\u03B9\u03B1 \u03BA\u03BF\u03B9\u03BD\u03CC\u03C7\u03C1\u03B7\u03C3\u03C4\u03B5\u03C2 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AD\u03C2.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03BC\u03BD\u03B7\u03BC\u03BF\u03BD\u03B5\u03CD\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C4\u03B7 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03BA\u03B1\u03B9 \u03C3\u03C4\u03BF \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03C0\u03B5\u03C1\u03B9\u03AE\u03B3\u03B7\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2",
            "ctp.emptyProfile.message": "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03BA\u03B1\u03C4\u03B1\u03C7\u03C9\u03C1\u03B9\u03C3\u03BC\u03AD\u03BD\u03B5\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B5\u03C2 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB Click to Pay",
            "ctp.separatorText": "\u03AE \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF",
            "ctp.cards.title": "\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03BC\u03B5 \u03C4\u03BF Click to Pay",
            "ctp.cards.subtitle": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03BA\u03AC\u03C1\u03C4\u03B1 \u03C0\u03C1\u03BF\u03C2 \u03C7\u03C1\u03AE\u03C3\u03B7.",
            "ctp.cards.expiredCard": "\u0388\u03BB\u03B7\u03BE\u03B5",
            "ctp.manualCardEntry": "\u03A7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03BA\u03B1\u03C4\u03B1\u03C7\u03CE\u03C1\u03B9\u03C3\u03B7 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "ctp.aria.infoModalButton": "\u03A4\u03B9 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C4\u03BF Click to Pay",
            "ctp.infoPopup.title": "\u03A4\u03BF Click to Pay \u03C0\u03C1\u03BF\u03C3\u03C6\u03AD\u03C1\u03B5\u03B9 \u03C4\u03B7\u03BD \u03B5\u03C5\u03BA\u03BF\u03BB\u03AF\u03B1 \u03B1\u03BD\u03AD\u03C0\u03B1\u03C6\u03C9\u03BD \u03B4\u03B9\u03B1\u03B4\u03B9\u03BA\u03C4\u03C5\u03B1\u03BA\u03CE\u03BD",
            "ctp.infoPopup.subtitle": "\u0388\u03BD\u03B1\u03C2 \u03B3\u03C1\u03AE\u03B3\u03BF\u03C1\u03BF\u03C2, \u03B1\u03C3\u03C6\u03B1\u03BB\u03AE\u03C2 \u03C4\u03C1\u03CC\u03C0\u03BF\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03C0\u03BF\u03C5 \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B5\u03C2 Mastercard, Visa \u03BA\u03B1\u03B9 \u03AC\u03BB\u03BB\u03B5\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03CE\u03BD.",
            "ctp.infoPopup.benefit1": "\u03A4\u03BF Click to Pay \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03B5\u03AF \u03BA\u03C1\u03C5\u03C0\u03C4\u03BF\u03B3\u03C1\u03AC\u03C6\u03B7\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03C4\u03B7\u03C1\u03B5\u03AF \u03C4\u03B9\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03C3\u03B1\u03C2 \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03C2",
            "ctp.infoPopup.benefit2": "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1 \u03C3\u03B5 \u03B5\u03BC\u03C0\u03CC\u03C1\u03BF\u03C5\u03C2 \u03B1\u03BD\u03AC \u03C4\u03BF\u03BD \u03BA\u03CC\u03C3\u03BC\u03BF",
            "ctp.infoPopup.benefit3": "\u0395\u03CD\u03BA\u03BF\u03BB\u03B7 \u03B4\u03B9\u03B1\u03BC\u03CC\u03C1\u03C6\u03C9\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03AC\u03BD\u03B5\u03C4\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03C2 \u03B1\u03BD\u03AC \u03C0\u03AC\u03C3\u03B1 \u03C3\u03C4\u03B9\u03B3\u03BC\u03AE",
            "ctp.errors.AUTH_INVALID": "\u039F \u03AD\u03BB\u03B5\u03B3\u03C7\u03BF\u03C2 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03B4\u03B5\u03BD \u03AE\u03C4\u03B1\u03BD \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2",
            "ctp.errors.NOT_FOUND": "\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2, \u03B5\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03AE \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "\u0397 \u03BC\u03BF\u03C1\u03C6\u03AE \u03B4\u03B5\u03BD \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9",
            "ctp.errors.FRAUD": "\u039F \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7 \u03BA\u03BB\u03B5\u03B9\u03B4\u03CE\u03B8\u03B7\u03BA\u03B5 \u03AE \u03B1\u03C0\u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03AE\u03B8\u03B7\u03BA\u03B5",
            "ctp.errors.CONSUMER_ID_MISSING": "\u0397 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1 \u03BA\u03B1\u03C4\u03B1\u03BD\u03B1\u03BB\u03C9\u03C4\u03AE \u03BB\u03B5\u03AF\u03C0\u03B5\u03B9 \u03C3\u03C4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1",
            "ctp.errors.ACCT_INACCESSIBLE": "\u0391\u03C5\u03C4\u03CC\u03C2 \u03BF \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF\u03C2 \u03C4\u03CE\u03C1\u03B1, \u03C0.\u03C7. \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03BB\u03B5\u03B9\u03B4\u03C9\u03BC\u03AD\u03BD\u03BF\u03C2",
            "ctp.errors.CODE_INVALID": "\u039B\u03B1\u03BD\u03B8\u03B1\u03C3\u03BC\u03AD\u03BD\u03BF\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
            "ctp.errors.CODE_EXPIRED": "\u0391\u03C5\u03C4\u03CC\u03C2 \u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03BB\u03AE\u03BE\u03B5\u03B9",
            "ctp.errors.RETRIES_EXCEEDED": "\u03A3\u03B7\u03BC\u03B5\u03B9\u03CE\u03B8\u03B7\u03BA\u03B5 \u03C5\u03C0\u03AD\u03C1\u03B2\u03B1\u03C3\u03B7 \u03C4\u03BF\u03C5 \u03B1\u03C1\u03B9\u03B8\u03BC\u03BF\u03CD \u03BD\u03AD\u03C9\u03BD \u03B1\u03C0\u03BF\u03C0\u03B5\u03B9\u03C1\u03CE\u03BD \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1\u03C2 OTP",
            "ctp.errors.OTP_SEND_FAILED": "\u0394\u03B5\u03BD \u03AE\u03C4\u03B1\u03BD \u03B4\u03C5\u03BD\u03B1\u03C4\u03AE \u03B7 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03C4\u03BF\u03C5 OTP \u03C3\u03C4\u03BF\u03BD \u03C0\u03B1\u03C1\u03B1\u03BB\u03AE\u03C0\u03C4\u03B7",
            "ctp.errors.REQUEST_TIMEOUT": "\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1, \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03AE \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "ctp.errors.UNKNOWN_ERROR": "\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1, \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03AE \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "ctp.errors.SERVICE_ERROR": "\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1, \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03AE \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "ctp.errors.SERVER_ERROR": "\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1, \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03AE \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "ctp.errors.INVALID_PARAMETER": "\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1, \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03AE \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "ctp.errors.AUTH_ERROR": "\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1, \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03AE \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "paymentMethodsList.aria.label": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03AD\u03BD\u03B1\u03BD \u03C4\u03C1\u03CC\u03C0\u03BF \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
            "companyDetails.name.invalid": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03C4\u03B7\u03C2 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2",
            "companyDetails.registrationNumber.invalid": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5",
            "consent.checkbox.invalid": "\u03A0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C3\u03C5\u03BC\u03C6\u03C9\u03BD\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03BF\u03C5\u03C2 \u03CC\u03C1\u03BF\u03C5\u03C2 \u03BA\u03B1\u03B9 \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03CB\u03C0\u03BF\u03B8\u03AD\u03C3\u03B5\u03B9\u03C2",
            "form.instruction": "\u038C\u03BB\u03B1 \u03C4\u03B1 \u03C0\u03B5\u03B4\u03AF\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03BF\u03C7\u03C1\u03B5\u03C9\u03C4\u03B9\u03BA\u03AC, \u03B5\u03BA\u03C4\u03CC\u03C2 \u03B5\u03AC\u03BD \u03B5\u03C0\u03B9\u03C3\u03B7\u03BC\u03B1\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03B5\u03C4\u03B9\u03BA\u03AC.",
            "trustly.descriptor": "\u0386\u03BC\u03B5\u03C3\u03B7 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE",
            "trustly.description1": "\u03A0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03B1\u03C0\u03B5\u03C5\u03B8\u03B5\u03AF\u03B1\u03C2 \u03B1\u03C0\u03CC \u03BF\u03C0\u03BF\u03B9\u03BF\u03BD\u03B4\u03AE\u03C0\u03BF\u03C4\u03B5 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03CC \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2, \u03BC\u03B5 \u03B1\u03C3\u03C6\u03AC\u03BB\u03B5\u03B9\u03B1 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03B5\u03C0\u03B9\u03C0\u03AD\u03B4\u03BF\u03C5",
            "trustly.description2": "\u03A7\u03C9\u03C1\u03AF\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B5\u03C2, \u03C7\u03C9\u03C1\u03AF\u03C2 \u03BB\u03AE\u03C8\u03B7 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE\u03C2, \u03C7\u03C9\u03C1\u03AF\u03C2 \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE",
            "ancv.input.label": "\u0397 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03AC \u03C3\u03B1\u03C2 ANCV",
            "ancv.confirmPayment": "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE ANCV \u03B3\u03B9\u03B1 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2.",
            "ancv.form.instruction": "\u0397 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE Cheque-Vacances \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C0\u03B1\u03C1\u03B1\u03AF\u03C4\u03B7\u03C4\u03B7 \u03B3\u03B9\u03B1 \u03B5\u03C0\u03B9\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03B1\u03C5\u03C4\u03AE\u03C2.",
            "ancv.beneficiaryId.invalid": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03AE \u03B1\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC ANCV",
            "payme.openPayMeApp": "\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C3\u03B1\u03C2 \u03C3\u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE PayMe \u03B5\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03BF\u03C4\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C3\u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03BA\u03B1\u03B9 \u03C0\u03B5\u03C1\u03B9\u03BC\u03AD\u03BD\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7.",
            "payme.redirectButtonLabel": "\u0391\u03BD\u03BF\u03AF\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE PayMe",
            "payme.scanQrCode": "\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C3\u03B1\u03C2 \u03BC\u03B5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC QR",
            "payme.timeToPay": "\u0391\u03C5\u03C4\u03CC\u03C2 \u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 QR \u03B9\u03C3\u03C7\u03CD\u03B5\u03B9 \u03B3\u03B9\u03B1 %@",
            "payme.instructions.steps": "\u0391\u03BD\u03BF\u03AF\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE PayMe.%@\u03A3\u03BA\u03B1\u03BD\u03AC\u03C1\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC QR \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03BF\u03C4\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE.%@\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C3\u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03BA\u03B1\u03B9 \u03C0\u03B5\u03C1\u03B9\u03BC\u03AD\u03BD\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7.",
            "payme.instructions.footnote": "\u039C\u03B7\u03BD \u03BA\u03BB\u03B5\u03AF\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03C0\u03C1\u03BF\u03C4\u03BF\u03CD \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03C9\u03B8\u03B5\u03AF \u03B7 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE."
        }
    }), D2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Pagar",
            "payButton.redirecting": "Redirigiendo...",
            "payButton.with": "Pague %{value} con %{maskedData}",
            "payButton.saveDetails": "Guardar los detalles",
            close: "Cerrar",
            storeDetails: "Recordar para mi pr\xf3ximo pago",
            readMore: "Leer m\xe1s",
            "creditCard.holderName": "Nombre en la tarjeta",
            "creditCard.holderName.placeholder": "Juan P\xe9rez",
            "creditCard.holderName.invalid": "Introduzca el nombre como se muestra en la tarjeta",
            "creditCard.numberField.title": "N\xfamero de tarjeta",
            "creditCard.expiryDateField.title": "Fecha de expiraci\xf3n",
            "creditCard.expiryDateField.placeholder": "MM/AA",
            "creditCard.expiryDateField.month": "Mes",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "AA",
            "creditCard.expiryDateField.year": "A\xf1o",
            "creditCard.cvcField.title": "C\xf3digo de seguridad",
            "creditCard.storeDetailsButton": "Recordar para la pr\xf3xima vez",
            "creditCard.cvcField.placeholder.4digits": "4 d\xedgitos",
            "creditCard.cvcField.placeholder.3digits": "3 d\xedgitos",
            "creditCard.taxNumber.placeholder": "AAMMDD / 0123456789",
            installments: "N\xfamero de plazos",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times}\xa0meses",
            "installments.oneTime": "Pago \xfanico",
            "installments.installments": "Pago fraccionado",
            "installments.revolving": "Pago rotativo",
            "sepaDirectDebit.ibanField.invalid": "N\xfamero de cuenta no v\xe1lido",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "Nombre del titular de cuenta",
            "sepa.ibanNumber": "N\xfamero de cuenta (IBAN)",
            "error.title": "Error",
            "error.subtitle.redirect": "Redirecci\xf3n fallida",
            "error.subtitle.payment": "Pago fallido",
            "error.subtitle.refused": "Pago rechazado",
            "error.message.unknown": "Se ha producido un error desconocido",
            "errorPanel.title": "Errores existentes",
            "idealIssuer.selectField.title": "Banco",
            "idealIssuer.selectField.placeholder": "Seleccione su banco",
            "creditCard.success": "Pago realizado correctamente",
            loading: "Cargando...",
            continue: "Continuar",
            continueTo: "Continuar a",
            "wechatpay.timetopay": "Tiene %@ para pagar",
            "sr.wechatpay.timetopay": "Tiene %#minutos%# %#segundos%# para pagar",
            "wechatpay.scanqrcode": "Escanear c\xf3digo QR",
            personalDetails: "Datos personales",
            companyDetails: "Datos de la empresa",
            "companyDetails.name": "Nombre de la empresa",
            "companyDetails.registrationNumber": "N\xfamero de registro",
            socialSecurityNumber: "N\xfamero de seguridad social",
            firstName: "Nombre",
            "firstName.invalid": "Introduzca su nombre",
            infix: "Prefijo",
            lastName: "Apellidos",
            "lastName.invalid": "Introduzca su apellido",
            mobileNumber: "Tel\xe9fono m\xf3vil",
            "mobileNumber.invalid": "N\xfamero de m\xf3vil no v\xe1lido",
            city: "Ciudad",
            postalCode: "C\xf3digo postal",
            "postalCode.optional": "C\xf3digo postal (opcional)",
            countryCode: "Prefijo internacional",
            telephoneNumber: "N\xfamero de tel\xe9fono",
            dateOfBirth: "Fecha de nacimiento",
            shopperEmail: "Direcci\xf3n de correo electr\xf3nico",
            gender: "G\xe9nero",
            "gender.notselected": "Seleccione su g\xe9nero",
            male: "Masculino",
            female: "Femenino",
            billingAddress: "Direcci\xf3n de facturaci\xf3n",
            street: "Calle",
            stateOrProvince: "Provincia o estado",
            country: "Pa\xeds o regi\xf3n",
            houseNumberOrName: "N\xfamero de vivienda",
            separateDeliveryAddress: "Especificar otra direcci\xf3n de env\xedo",
            deliveryAddress: "Direcci\xf3n de env\xedo",
            "deliveryAddress.firstName": "Nombre del destinatario",
            "deliveryAddress.lastName": "Apellidos del destinatario",
            zipCode: "C\xf3digo postal",
            apartmentSuite: "Apartamento/suite",
            provinceOrTerritory: "Provincia o territorio",
            cityTown: "Ciudad/poblaci\xf3n",
            address: "Direcci\xf3n",
            "address.placeholder": "Encuentre su direcci\xf3n",
            "address.errors.incomplete": "Introduzca una direcci\xf3n para continuar",
            "address.enterManually": "Introduzca la direcci\xf3n manualmente",
            state: "Estado",
            "field.title.optional": "(opcional)",
            "creditCard.cvcField.title.optional": "C\xf3digo de seguridad (opcional)",
            "issuerList.wallet.placeholder": "Seleccione su monedero electr\xf3nico",
            privacyPolicy: "Pol\xedtica de privacidad",
            "afterPay.agreement": "S\xed, acepto las %@ de Riverty",
            paymentConditions: "condiciones de pago",
            openApp: "Abrir la aplicaci\xf3n",
            "voucher.readInstructions": "Leer instrucciones",
            "voucher.introduction": "Gracias por su compra. Use el siguiente cup\xf3n para completar su pago.",
            "voucher.expirationDate": "Fecha de caducidad",
            "voucher.alternativeReference": "Referencia alternativa",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Seleccione su proveedor",
            "dragonpay.voucher.bank.selectField.placeholder": "Seleccione su banco",
            "voucher.paymentReferenceLabel": "Referencia de pago",
            "voucher.surcharge": "Incluye recargo de %@",
            "voucher.introduction.doku": "Gracias por su compra. Use la informaci\xf3n siguiente para completar su pago.",
            "voucher.shopperName": "Nombre del comprador",
            "voucher.merchantName": "Vendedor",
            "voucher.introduction.econtext": "Gracias por su compra. Use la informaci\xf3n siguiente para completar su pago.",
            "voucher.telephoneNumber": "N\xfamero de tel\xe9fono",
            "voucher.shopperReference": "Referencia cliente",
            "voucher.collectionInstitutionNumber": "N\xfamero de instituci\xf3n de cobro",
            "voucher.econtext.telephoneNumber.invalid": "El n\xfamero de tel\xe9fono debe tener 10 u 11 d\xedgitos",
            "boletobancario.btnLabel": "Generar Boleto",
            "boleto.sendCopyToEmail": "Enviar copia a mi correo electr\xf3nico",
            "button.copy": "Copiar",
            "button.download": "Descargar",
            "boleto.socialSecurityNumber.invalid": "Introduzca un n\xfamero CPF/CNPJ v\xe1lido",
            "creditCard.storedCard.description.ariaLabel": "La tarjeta almacenada termina en %@",
            "voucher.entity": "Entidad",
            donateButton: "Donar",
            notNowButton: "Ahora no",
            thanksForYourSupport: "\xa1Gracias por su contribuci\xf3n!",
            "resultMessages.preauthorized": "Se han guardado los detalles",
            preauthorizeWith: "Preautorizar con",
            confirmPreauthorization: "Confirmar preautorizaci\xf3n",
            confirmPurchase: "Confirmar compra",
            applyGiftcard: "Canjear",
            giftcardBalance: "Saldo de la tarjeta regalo",
            deductedBalance: "Saldo deducido",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "Primeros 2 d\xedgitos de la contrase\xf1a de la tarjeta",
            "creditCard.encryptedPassword.invalid": "Contrase\xf1a incorrecta",
            "creditCard.taxNumber": "Fecha de nacimiento del titular o n\xfamero de registro comercial",
            "creditCard.taxNumber.label": "Fecha de nacimiento del titular de la tarjeta (AAMMDD) o n\xfamero de registro comercial (10 d\xedgitos)",
            "creditCard.taxNumber.labelAlt": "N\xfamero de registro comercial (10 d\xedgitos)",
            "creditCard.taxNumber.invalid": "Fecha de nacimiento del titular o n\xfamero de registro comercial incorrectos",
            "storedPaymentMethod.disable.button": "Eliminar",
            "storedPaymentMethod.disable.confirmation": "Eliminar m\xe9todo de pago almacenado",
            "storedPaymentMethod.disable.confirmButton": "S\xed, eliminar",
            "storedPaymentMethod.disable.cancelButton": "Cancelar",
            "ach.bankAccount": "Cuenta bancaria",
            "ach.accountHolderNameField.title": "Nombre del titular de la cuenta",
            "ach.accountHolderNameField.placeholder": "Juan P\xe9rez",
            "ach.accountHolderNameField.invalid": "El nombre del titular de la cuenta no es v\xe1lido",
            "ach.accountNumberField.title": "N\xfamero de cuenta",
            "ach.accountNumberField.invalid": "N\xfamero de cuenta no v\xe1lido",
            "ach.accountLocationField.title": "N\xfamero de ruta ABA",
            "ach.accountLocationField.invalid": "El n\xfamero de ruta ABA no es v\xe1lido",
            "ach.savedBankAccount": "Se ha guardado la cuenta bancaria",
            "select.state": "Seleccione el estado",
            "select.stateOrProvince": "Seleccione el estado o provincia",
            "select.provinceOrTerritory": "Seleccione la provincia o territorio",
            "select.country": "Seleccione el pa\xeds o la regi\xf3n",
            "select.noOptionsFound": "No se encontraron opciones",
            "select.filter.placeholder": "Buscar...",
            "telephoneNumber.invalid": "El n\xfamero de tel\xe9fono no es v\xe1lido",
            qrCodeOrApp: "o",
            "paypal.processingPayment": "Procesando pago...",
            generateQRCode: "Generar c\xf3digo QR",
            "await.waitForConfirmation": "Esperando confirmaci\xf3n",
            "mbway.confirmPayment": "Confirme su pago en la aplicaci\xf3n MB WAY",
            "shopperEmail.invalid": "La direcci\xf3n de correo electr\xf3nico no es v\xe1lida",
            "dateOfBirth.format": "DD/MM/AAAA",
            "dateOfBirth.invalid": "Introduzca una fecha de nacimiento v\xe1lida que indique que tiene al menos 18 a\xf1os",
            "blik.confirmPayment": "Abra la aplicaci\xf3n de su banco para confirmar el pago.",
            "blik.invalid": "Introduzca 6 d\xedgitos",
            "blik.code": "C\xf3digo de 6 d\xedgitos",
            "blik.help": "Consiga el c\xf3digo en la aplicaci\xf3n de su banco.",
            "swish.pendingMessage": "Tras escanearlo, su estado puede seguir en pendiente hasta 10\xa0minutos. Podr\xedan realizarse varios cargos si se intenta pagar de nuevo durante este periodo.",
            "field.valid": "Campo v\xe1lido",
            "field.invalid": "Campo no v\xe1lido",
            "error.va.gen.01": "Campo incompleto",
            "error.va.gen.02": "Campo no v\xe1lido",
            "error.va.sf-cc-num.01": "Introduzca un n\xfamero de tarjeta v\xe1lido",
            "error.va.sf-cc-num.02": "Introduzca el n\xfamero de tarjeta",
            "error.va.sf-cc-num.03": "Introduzca una marca de tarjeta admitida",
            "error.va.sf-cc-num.04": "Introduzca el n\xfamero de tarjeta completo",
            "error.va.sf-cc-dat.01": "Introduzca una fecha de caducidad v\xe1lida",
            "error.va.sf-cc-dat.02": "Introduzca una fecha de caducidad v\xe1lida",
            "error.va.sf-cc-dat.03": "La tarjeta de cr\xe9dito est\xe1 a punto de caducar",
            "error.va.sf-cc-dat.04": "Introduzca la fecha de caducidad",
            "error.va.sf-cc-dat.05": "Introduzca la fecha de caducidad completa",
            "error.va.sf-cc-mth.01": "Introduzca el mes de caducidad",
            "error.va.sf-cc-yr.01": "Introduzca el a\xf1o de caducidad",
            "error.va.sf-cc-yr.02": "Introduzca el a\xf1o de caducidad completo",
            "error.va.sf-cc-cvc.01": "Introduzca el c\xf3digo de seguridad",
            "error.va.sf-cc-cvc.02": "Introduzca el c\xf3digo de seguridad completo",
            "error.va.sf-ach-num.01": "El campo del n\xfamero de cuenta bancaria est\xe1 vac\xedo",
            "error.va.sf-ach-num.02": "El n\xfamero de cuenta bancaria no tiene la longitud correcta",
            "error.va.sf-ach-loc.01": "El campo del n\xfamero de ruta bancaria est\xe1 vac\xedo",
            "error.va.sf-ach-loc.02": "El n\xfamero de ruta bancaria no tiene la longitud correcta",
            "error.va.sf-kcp-pwd.01": "El campo de la contrase\xf1a est\xe1 vac\xedo",
            "error.va.sf-kcp-pwd.02": "La contrase\xf1a no tiene la longitud correcta",
            "error.giftcard.no-balance": "Esta tarjeta regalo no tiene saldo",
            "error.giftcard.card-error": "No tenemos ninguna tarjeta regalo con este n\xfamero en nuestros registros.",
            "error.giftcard.currency-error": "Las tarjetas regalo solo son v\xe1lidas en la moneda en que fueron emitidas",
            "amazonpay.signout": "Salir de Amazon",
            "amazonpay.changePaymentDetails": "Cambiar detalles de pago",
            "partialPayment.warning": "Seleccione otro m\xe9todo de pago para pagar la cantidad restante",
            "partialPayment.remainingBalance": "El saldo restante ser\xe1 %{amount}",
            "bankTransfer.beneficiary": "Beneficiario",
            "bankTransfer.reference": "referencia",
            "bankTransfer.introduction": "Contin\xfae para crear un nuevo pago mediante transferencia bancaria. Puede utilizar los detalles en la siguiente pantalla para finalizar este pago.",
            "bankTransfer.instructions": "Gracias por su compra. Use la siguiente informaci\xf3n para completar su pago.",
            "bacs.accountHolderName": "Nombre del titular de la cuenta bancaria",
            "bacs.accountHolderName.invalid": "El nombre del titular de la cuenta bancaria no es v\xe1lido",
            "bacs.accountNumber": "N\xfamero de cuenta bancaria",
            "bacs.accountNumber.invalid": "El n\xfamero de cuenta bancaria no es v\xe1lido",
            "bacs.bankLocationId": "C\xf3digo de sucursal",
            "bacs.bankLocationId.invalid": "El c\xf3digo de sucursal no es v\xe1lido",
            "bacs.consent.amount": "Estoy de acuerdo con que la cantidad anterior se deduzca de mi cuenta bancaria.",
            "bacs.consent.account": "Confirmo que la cuenta est\xe1 a mi nombre y soy el \xfanico firmante necesario para autorizar d\xe9bitos directos en esta cuenta.",
            edit: "Editar",
            "bacs.confirm": "Confirmar y pagar",
            "bacs.result.introduction": "Descargue su instrucci\xf3n de d\xe9bito directo (IDD/mandato)",
            "download.pdf": "Descargar PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Utilice Iframe para el n\xfamero de tarjeta",
            "creditCard.encryptedCardNumber.aria.label": "N\xfamero de tarjeta",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Utilice iframe para la fecha de caducidad",
            "creditCard.encryptedExpiryDate.aria.label": "Fecha de expiraci\xf3n",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Utilice iframe para el mes de caducidad",
            "creditCard.encryptedExpiryMonth.aria.label": "Mes de caducidad",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Utilice iframe para el a\xf1o de caducidad",
            "creditCard.encryptedExpiryYear.aria.label": "A\xf1o de caducidad",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Utilice iframe para el c\xf3digo de seguridad",
            "creditCard.encryptedSecurityCode.aria.label": "C\xf3digo de seguridad",
            "creditCard.encryptedPassword.aria.iframeTitle": "Utilice iframe para la contrase\xf1a",
            "creditCard.encryptedPassword.aria.label": "Primeros 2 d\xedgitos de la contrase\xf1a de la tarjeta",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Utilice iframe para el n\xfamero de tarjeta",
            "giftcard.encryptedCardNumber.aria.label": "N\xfamero de tarjeta",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Utilice iframe para el PIN",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "Se permite un m\xe1ximo de %{amount} por transacci\xf3n en esta tarjeta regalo",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Utilice iframe para el n\xfamero de cuenta bancaria",
            "ach.encryptedBankAccountNumber.aria.label": "N\xfamero de cuenta",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Utilice iframe para el n\xfamero de ruta bancaria",
            "ach.encryptedBankLocationId.aria.label": "N\xfamero de ruta ABA",
            "twint.saved": "guardado",
            orPayWith: "o pague con",
            invalidFormatExpects: "Formato no v\xe1lido. Formato correcto: %{format}",
            "upi.qrCodeWaitingMessage": "Escanee el c\xf3digo QR con la aplicaci\xf3n UPI que prefiera para completar el pago",
            "upi.vpaWaitingMessage": "Abra la aplicaci\xf3n UPI para confirmar el pago",
            "upi.modeSelection": "Seleccione c\xf3mo le gustar\xeda usar UPI.",
            "onlineBanking.termsAndConditions": "Al continuar, usted acepta los %#T\xe9rminos y condiciones%#",
            "onlineBankingPL.termsAndConditions": "Al continuar, acepta las %#regulaciones%# y la %#obligaci\xf3n de informaci\xf3n%# de Przelewy24",
            "ctp.loading.poweredByCtp": "Con tecnolog\xeda de Click to Pay",
            "ctp.loading.intro": "Estamos comprobando si tiene alguna tarjeta guardada con Click to Pay...",
            "ctp.login.title": "Contin\xfae con Click to Pay",
            "ctp.login.subtitle": "Introduzca la direcci\xf3n de correo electr\xf3nico que tiene conectada a Click to Pay para continuar.",
            "ctp.login.inputLabel": "Correo electr\xf3nico",
            "ctp.logout.notYou": "\xbfNo es usted?",
            "ctp.logout.notYourCards": "\xbfNo son sus tarjetas?",
            "ctp.logout.notYourCard": "\xbfNo es su tarjeta?",
            "ctp.logout.notYourProfile": "\xbfNo es su perfil?",
            "ctp.otp.fieldLabel": "C\xf3digo \xfanico",
            "ctp.otp.resendCode": "Reenviar c\xf3digo",
            "ctp.otp.codeResent": "C\xf3digo reenviado",
            "ctp.otp.title": "Acceda a sus tarjetas Click to Pay",
            "ctp.otp.subtitle": "Introduzca el c\xf3digo %@ que le hemos enviado a %@ para verificar que es usted.",
            "ctp.otp.saveCookiesCheckbox.label": "Omitir verificaci\xf3n la pr\xf3xima vez",
            "ctp.otp.saveCookiesCheckbox.information": "Seleccione esta opci\xf3n para recordarle en su dispositivo y navegador en las tiendas participantes para agilizar el proceso de pago. No lo recomendamos para dispositivos compartidos.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Seleccione esta opci\xf3n para recordarle en su dispositivo y navegador",
            "ctp.emptyProfile.message": "No hay tarjetas registradas en este perfil de Click to Pay",
            "ctp.separatorText": "o utilice",
            "ctp.cards.title": "Completar el pago con Click to Pay",
            "ctp.cards.subtitle": "Seleccione una tarjeta para usar.",
            "ctp.cards.expiredCard": "Caducada",
            "ctp.manualCardEntry": "Introducci\xf3n manual de tarjeta",
            "ctp.aria.infoModalButton": "Qu\xe9 es Click to Pay",
            "ctp.infoPopup.title": "Click to Pay ofrece la comodidad de la funci\xf3n sin contacto en internet",
            "ctp.infoPopup.subtitle": "Un m\xe9todo de pago r\xe1pido y seguro compatible con Mastercard, Visa y otras tarjetas de pago.",
            "ctp.infoPopup.benefit1": "Click to Pay utiliza cifrado para mantener su informaci\xf3n segura y protegida",
            "ctp.infoPopup.benefit2": "Util\xedcelo con vendedores de todo el mundo",
            "ctp.infoPopup.benefit3": "Config\xfarela una vez para realizar pagos sin complicaciones en el futuro",
            "ctp.errors.AUTH_INVALID": "Autenticaci\xf3n no v\xe1lida",
            "ctp.errors.NOT_FOUND": "No se ha encontrado ninguna cuenta, escriba un correo electr\xf3nico v\xe1lido o contin\xfae usando la escritura manual de la tarjeta",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Formato no compatible",
            "ctp.errors.FRAUD": "Se ha bloqueado o desactivado la cuenta de usuario",
            "ctp.errors.CONSUMER_ID_MISSING": "Falta la identidad del consumidor en la solicitud",
            "ctp.errors.ACCT_INACCESSIBLE": "Esta cuenta no est\xe1 disponible en este momento, por ejemplo, est\xe1 bloqueada",
            "ctp.errors.CODE_INVALID": "C\xf3digo de verificaci\xf3n incorrecto",
            "ctp.errors.CODE_EXPIRED": "Este c\xf3digo ha caducado",
            "ctp.errors.RETRIES_EXCEEDED": "Se ha excedido el l\xedmite de reintentos para la generaci\xf3n de una contrase\xf1a de un solo uso",
            "ctp.errors.OTP_SEND_FAILED": "No se ha podido enviar la contrase\xf1a de un solo uso al destinatario",
            "ctp.errors.REQUEST_TIMEOUT": "Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta",
            "ctp.errors.UNKNOWN_ERROR": "Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta",
            "ctp.errors.SERVICE_ERROR": "Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta",
            "ctp.errors.SERVER_ERROR": "Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta",
            "ctp.errors.INVALID_PARAMETER": "Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta",
            "ctp.errors.AUTH_ERROR": "Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta",
            "paymentMethodsList.aria.label": "Elija un m\xe9todo de pago",
            "companyDetails.name.invalid": "Introduzca el nombre de la empresa",
            "companyDetails.registrationNumber.invalid": "Introduzca el n\xfamero de registro",
            "consent.checkbox.invalid": "Debe aceptar los t\xe9rminos y condiciones",
            "form.instruction": "Todos los campos son obligatorios a menos que se indique lo contrario.",
            "ancv.input.label": "Su identificaci\xf3n de la ANCV",
            "ancv.confirmPayment": "Utilice su solicitud de la ANCV para confirmar el pago.",
            "ancv.form.instruction": "La aplicaci\xf3n de Cheque-Vacances es necesaria para validar este pago.",
            "ancv.beneficiaryId.invalid": "Introduzca una direcci\xf3n de correo electr\xf3nico v\xe1lida o un documento de identidad de la ANCV",
            "payme.openPayMeApp": "Completa tu pago en la aplicaci\xf3n PayMe autorizando el pago en la aplicaci\xf3n y espera por la confirmaci\xf3n.",
            "payme.redirectButtonLabel": "Abrir aplicaci\xf3n PayMe",
            "payme.scanQrCode": "Completa tu pago con c\xf3digo QR",
            "payme.timeToPay": "Este c\xf3digo QR es v\xe1lido para %@",
            "payme.instructions.steps": "Abre la aplicaci\xf3n PayMe.%@Escanea el c\xf3digo QR para autorizar el pago.%@Completa el pago en la aplicaci\xf3n y espera por la confirmaci\xf3n.",
            "payme.instructions.footnote": "No cierres esta p\xe1gina antes de que se complete el pago"
        }
    }), R2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Maksa",
            "payButton.redirecting": "Uudelleenohjataan...",
            "payButton.with": "Maksa %{value} k\xe4ytt\xe4en maksutapaa %{maskedData}",
            "payButton.saveDetails": "Tallenna tiedot",
            close: "Sulje",
            storeDetails: "Tallenna seuraavaa maksuani varten",
            readMore: "Lue lis\xe4\xe4",
            "creditCard.holderName": "Nimi kortilla",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "Sy\xf6t\xe4 nimi sellaisena kuin se on kortissa",
            "creditCard.numberField.title": "Kortin numero",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Voimassaolop\xe4iv\xe4m\xe4\xe4r\xe4",
            "creditCard.expiryDateField.placeholder": "KK / VV",
            "creditCard.expiryDateField.month": "Kuukausi",
            "creditCard.expiryDateField.month.placeholder": "KK",
            "creditCard.expiryDateField.year.placeholder": "VV",
            "creditCard.expiryDateField.year": "Vuosi",
            "creditCard.cvcField.title": "Turvakoodi",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Muista seuraavalla kerralla",
            "creditCard.cvcField.placeholder.4digits": "4 lukua",
            "creditCard.cvcField.placeholder.3digits": "3 lukua",
            "creditCard.taxNumber.placeholder": "VVKKPP / 0123456789",
            installments: "Asennusten m\xe4\xe4r\xe4",
            installmentOption: "% {kertaa} x% {osittainenarvo}",
            installmentOptionMonths: "% {kertaa} kuukautta",
            "installments.oneTime": "Kertamaksu",
            "installments.installments": "Er\xe4maksu",
            "installments.revolving": "Toistuva maksu",
            "sepaDirectDebit.ibanField.invalid": "V\xe4\xe4r\xe4 tilin numero",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "Haltijan nimi",
            "sepa.ibanNumber": "Tilinumero (IBAN)",
            "error.title": "Virhe",
            "error.subtitle.redirect": "Uuteen kohteeseen siirto ep\xe4onnistui",
            "error.subtitle.payment": "Maksu ep\xe4nnistui",
            "error.subtitle.refused": "Maksu hyl\xe4tty",
            "error.message.unknown": "Tapahtui tuntematon virhe",
            "errorPanel.title": "Olemassa olevat virheet",
            "idealIssuer.selectField.title": "Pankki",
            "idealIssuer.selectField.placeholder": "Valitse pankkisi",
            "creditCard.success": "Maksu onnistui",
            loading: "Ladataan...",
            continue: "Jatka",
            continueTo: "Jatka kohteeseen",
            "wechatpay.timetopay": "Sinulla on %@ maksettavana",
            "sr.wechatpay.timetopay": "Maksuaikaa on j\xe4ljell\xe4 %#minuuttia%# %#sekuntia%#",
            "wechatpay.scanqrcode": "Skannaa QR-koodi",
            personalDetails: "Henkil\xf6tiedot",
            companyDetails: "Yhti\xf6n tiedot",
            "companyDetails.name": "Yhti\xf6n nimi",
            "companyDetails.registrationNumber": "Rekisterinumero",
            socialSecurityNumber: "Sosiaaliturvatunnus",
            firstName: "Etunimi",
            "firstName.invalid": "Sy\xf6t\xe4 etunimesi",
            infix: "Etuliite",
            lastName: "Sukunimi",
            "lastName.invalid": "Sy\xf6t\xe4 sukunimesi",
            mobileNumber: "Matkapuhelinnumero",
            "mobileNumber.invalid": "Ei-kelvollinen matkapuhelinnumero",
            city: "Kaupunki",
            postalCode: "Postinumero",
            "postalCode.optional": "Postinumero (valinnainen)",
            countryCode: "Maakoodi",
            telephoneNumber: "Puhelinnumero",
            dateOfBirth: "Syntym\xe4aika",
            shopperEmail: "S\xe4hk\xf6postiosoite",
            gender: "Sukupuoli",
            "gender.notselected": "Valitse sukupuoli",
            male: "Mies",
            female: "Nainen",
            billingAddress: "Laskutusosoite",
            street: "Katu",
            stateOrProvince: "Osavaltio tai l\xe4\xe4ni",
            country: "Maa/alue",
            houseNumberOrName: "Talon numero",
            separateDeliveryAddress: "M\xe4\xe4rit\xe4 erillinen toimitusosoite",
            deliveryAddress: "Toimitusosoite",
            "deliveryAddress.firstName": "Vastaanottajan etunimi",
            "deliveryAddress.lastName": "Vastaanottajan sukunimi",
            zipCode: "Postinumero",
            apartmentSuite: "Huoneisto / sviitti",
            provinceOrTerritory: "Maakunta tai alue",
            cityTown: "Kaupunki / taajama",
            address: "Osoite",
            "address.placeholder": "L\xf6yd\xe4 osoitteesi",
            "address.errors.incomplete": "Sy\xf6t\xe4 osoite jatkaaksesi",
            "address.enterManually": "Sy\xf6t\xe4 osoite manuaalisesti",
            state: "Osavaltio",
            "field.title.optional": "(valinnainen)",
            "creditCard.cvcField.title.optional": "Turvakoodi (valinnainen)",
            "issuerList.wallet.placeholder": "Valitse lompakkosi",
            privacyPolicy: "Tietosuojamenettely",
            "afterPay.agreement": "Hyv\xe4ksyn Rivertyn %@",
            paymentConditions: "maksuehdot",
            openApp: "Avaa sovellus",
            "voucher.readInstructions": "Lue ohjeet",
            "voucher.introduction": "Kiitos hankinnastasi, k\xe4yt\xe4 seuraavaa kuponkia vied\xe4ksesi maksusi p\xe4\xe4t\xf6kseen.",
            "voucher.expirationDate": "Vanhenemisp\xe4iv\xe4m\xe4\xe4r\xe4",
            "voucher.alternativeReference": "Vaihtoehtoinen viite",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Valitse toimittajasi",
            "dragonpay.voucher.bank.selectField.placeholder": "Valitse pankkisi",
            "voucher.paymentReferenceLabel": "Maksun viite",
            "voucher.surcharge": "Sis. %@ lis\xe4maksun",
            "voucher.introduction.doku": "Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.",
            "voucher.shopperName": "Ostajan nimi",
            "voucher.merchantName": "Kauppias",
            "voucher.introduction.econtext": "Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.",
            "voucher.telephoneNumber": "Puhelinnumero",
            "voucher.shopperReference": "Ostajan viite",
            "voucher.collectionInstitutionNumber": "Ker\xe4\xe4v\xe4n laitoksen numero",
            "voucher.econtext.telephoneNumber.invalid": "Puhelinnumeron on oltava 10 tai 11 numeroa pitk\xe4",
            "boletobancario.btnLabel": "Luo Boleto",
            "boleto.sendCopyToEmail": "L\xe4het\xe4 kopio s\xe4hk\xf6postiini",
            "button.copy": "Kopio",
            "button.download": "Lataa",
            "boleto.socialSecurityNumber.invalid": "Anna kelvollinen CPF- tai CNPJ-numero.",
            "creditCard.storedCard.description.ariaLabel": "Tallennetun kortin viimeiset luvut ovat %@",
            "voucher.entity": "Kokonaisuus",
            donateButton: "Lahjoita",
            notNowButton: "Ei nyt",
            thanksForYourSupport: "Kiitos tuestasi!",
            "resultMessages.preauthorized": "Tiedot tallennettu",
            preauthorizeWith: "Ennkkolupa k\xe4ytt\xe4j\xe4n kanssa",
            confirmPreauthorization: "Vahvista ennakkolupa",
            confirmPurchase: "Vahvista hankinta",
            applyGiftcard: "Lunasta",
            giftcardBalance: "Lahjakortin saldo",
            deductedBalance: "V\xe4hennetty saldo",
            "creditCard.pin.title": "Pin-tunnus",
            "creditCard.encryptedPassword.label": "Kortin salasanan ensimm\xe4iset 2 lukua",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Kelpaamaton salasana",
            "creditCard.taxNumber": "Kortinhaltijan syntym\xe4p\xe4iv\xe4 (VVKKPP) tai yrityksen rekisterinumero",
            "creditCard.taxNumber.label": "Kortinhaltijan syntym\xe4p\xe4iv\xe4 (VVKKPP) tai yrityksen rekisterinumero (10 lukua)",
            "creditCard.taxNumber.labelAlt": "Yrityksen rekisterinumero (10 lukua)",
            "creditCard.taxNumber.invalid": "Kelpaamaton kortinhaltijan syntym\xe4p\xe4iv\xe4 (VVKKPP) tai yrityksen rekisterinumero",
            "storedPaymentMethod.disable.button": "Poista",
            "storedPaymentMethod.disable.confirmation": "Poista tallennettu maksutapa",
            "storedPaymentMethod.disable.confirmButton": "Kyll\xe4, poista",
            "storedPaymentMethod.disable.cancelButton": "Peruuta",
            "ach.bankAccount": "Pankkitili",
            "ach.accountHolderNameField.title": "Tilinhaltijan nimi",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "Ei-kelvollinen tilinhaltijan nimi",
            "ach.accountNumberField.title": "Tilinumero",
            "ach.accountNumberField.invalid": "V\xe4\xe4r\xe4 tilin numero",
            "ach.accountLocationField.title": "ABA-reititysnumero",
            "ach.accountLocationField.invalid": "Ei-kelvollinen ABA-reititysnumero",
            "ach.savedBankAccount": "Tallennettu pankkitili",
            "select.state": "Valitse osavaltio",
            "select.stateOrProvince": "Valitse osavaltio tai l\xe4\xe4ni",
            "select.provinceOrTerritory": "Valitse maakunta tai alue",
            "select.country": "Valitse maa/alue",
            "select.noOptionsFound": "Vaihtoehtoja ei l\xf6ytynyt",
            "select.filter.placeholder": "Hae...",
            "telephoneNumber.invalid": "Ei-kelvollinen puhelinnumero",
            qrCodeOrApp: "tai",
            "paypal.processingPayment": "Maksua k\xe4sitell\xe4\xe4n...",
            generateQRCode: "Tuota QR-koodi",
            "await.waitForConfirmation": "Odottaa vahvistusta",
            "mbway.confirmPayment": "Vahvista maksusi MB WAY -sovelluksella",
            "shopperEmail.invalid": "Ei-kelvollinen s\xe4hk\xf6postiosoite",
            "dateOfBirth.format": "PP/KK/VVVV",
            "dateOfBirth.invalid": "Anna kelvollinen syntym\xe4aika, joka osoittaa, ett\xe4 olet v\xe4hint\xe4\xe4n 18-vuotias",
            "blik.confirmPayment": "Avaa pankkisovelluksesi vahvistaaksesi maksun.",
            "blik.invalid": "Sy\xf6t\xe4 6 lukua",
            "blik.code": "6-numeroinen koodi",
            "blik.help": "Hanki koodi pankkisovelluksestasi.",
            "swish.pendingMessage": "Skannattuasi, tila voi odottaa jopa 10 minuuttia. Yritys maksaa uudelleen t\xe4ss\xe4 ajassa voi tuottaa moninkertaisia maksuja.",
            "field.valid": "Kentt\xe4 kelvollinen",
            "field.invalid": "Kentt\xe4 ei kelpaa",
            "error.va.gen.01": "T\xe4ydent\xe4m\xe4t\xf6n kentt\xe4",
            "error.va.gen.02": "Kentt\xe4 ei kelpaa",
            "error.va.sf-cc-num.01": "Sy\xf6t\xe4 kelvollinen kortin numero",
            "error.va.sf-cc-num.02": "Sy\xf6t\xe4 kortin numero",
            "error.va.sf-cc-num.03": "Sy\xf6t\xe4 tuettu korttimerkki",
            "error.va.sf-cc-num.04": "Sy\xf6t\xe4 kortin numero kokonaan",
            "error.va.sf-cc-dat.01": "Sy\xf6t\xe4 kelvollinen viimeinen voimassaolop\xe4iv\xe4",
            "error.va.sf-cc-dat.02": "Sy\xf6t\xe4 kelvollinen viimeinen voimassaolop\xe4iv\xe4",
            "error.va.sf-cc-dat.03": "Luottokortin voimassaolo p\xe4\xe4ttyy pian",
            "error.va.sf-cc-dat.04": "Sy\xf6t\xe4 viimeinen voimassaolop\xe4iv\xe4",
            "error.va.sf-cc-dat.05": "Sy\xf6t\xe4 viimeinen voimassaolop\xe4iv\xe4 kokonaan",
            "error.va.sf-cc-mth.01": "Sy\xf6t\xe4 viimeinen voimassaolokuukausi",
            "error.va.sf-cc-yr.01": "Sy\xf6t\xe4 viimeinen voimassaolovuosi",
            "error.va.sf-cc-yr.02": "Sy\xf6t\xe4 viimeinen voimassaolovuosi kokonaan",
            "error.va.sf-cc-cvc.01": "Sy\xf6t\xe4 turvakoodi",
            "error.va.sf-cc-cvc.02": "Sy\xf6t\xe4 turvakoodi kokonaan",
            "error.va.sf-ach-num.01": "Pankkitilin numero -kentt\xe4 on tyhj\xe4",
            "error.va.sf-ach-num.02": "Pankkitilin numero on v\xe4\xe4r\xe4n pituinen",
            "error.va.sf-ach-loc.01": "Pankin reititysnumeron kentt\xe4 on tyhj\xe4",
            "error.va.sf-ach-loc.02": "Pankin reititysnumero on v\xe4\xe4r\xe4n pituinen",
            "error.va.sf-kcp-pwd.01": "Salasanakentt\xe4 on tyhj\xe4",
            "error.va.sf-kcp-pwd.02": "Salasana on v\xe4\xe4r\xe4n pituinen",
            "error.giftcard.no-balance": "Lahjakortin saldo on nolla",
            "error.giftcard.card-error": "Asiakirjoissamme ei ole t\xe4m\xe4n numeron lahjakorttia",
            "error.giftcard.currency-error": "Gift cards are only valid in the currency they were issued in",
            "amazonpay.signout": "Kirjaudu ulos Amazonista",
            "amazonpay.changePaymentDetails": "Muuta maksutietoja",
            "partialPayment.warning": "Valitse toinen maksutapa j\xe4\xe4nn\xf6ksen maksamiseksi",
            "partialPayment.remainingBalance": "J\xe4ljell\xe4 oleva saldo on %{summa}",
            "bankTransfer.beneficiary": "Edunsaaja",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Viite",
            "bankTransfer.introduction": "Jatka uuden pankkisiirtomaksun luomista. Voit viimeistell\xe4 t\xe4m\xe4n maksun seuraavan n\xe4yt\xf6n tietojen avulla.",
            "bankTransfer.instructions": "Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.",
            "bacs.accountHolderName": "Tilinhaltijan nimi",
            "bacs.accountHolderName.invalid": "Ei-kelvollinen tilinhaltijan nimi",
            "bacs.accountNumber": "Pankkitilinumero",
            "bacs.accountNumber.invalid": "V\xe4\xe4r\xe4 tilin numero",
            "bacs.bankLocationId": "Lajittelukoodi",
            "bacs.bankLocationId.invalid": "Ei-kelvollinen lajittelukoodi",
            "bacs.consent.amount": "Hyv\xe4ksyn, ett\xe4 alla oleva summa veloitetaan pankkitililt\xe4ni.",
            "bacs.consent.account": "Vahvistan, ett\xe4 tili on nimess\xe4ni ja olen ainoa allekirjoittaja, joka vaaditaan valtuuttamaan suoraveloitus t\xe4ll\xe4 tilill\xe4.",
            edit: "Muokkaa",
            "bacs.confirm": "Vahvista ja maksa",
            "bacs.result.introduction": "Lataa suoraveloitusohjeet (DDI / Mandate)",
            "download.pdf": "Lataa PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe kortin numerolle",
            "creditCard.encryptedCardNumber.aria.label": "Kortin numero",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe viimeiselle voimassaolop\xe4iv\xe4lle",
            "creditCard.encryptedExpiryDate.aria.label": "Voimassaolop\xe4iv\xe4m\xe4\xe4r\xe4",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe viimeiselle voimassaolokuukaudelle",
            "creditCard.encryptedExpiryMonth.aria.label": "Vanhenemiskuukausi",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe viimeiselle voimassaolovuodelle",
            "creditCard.encryptedExpiryYear.aria.label": "Vanhenemisvuosi",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe turvakoodille",
            "creditCard.encryptedSecurityCode.aria.label": "Turvakoodi",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe salasanalle",
            "creditCard.encryptedPassword.aria.label": "Kortin salasanan ensimm\xe4iset 2 lukua",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe kortin numerolle",
            "giftcard.encryptedCardNumber.aria.label": "Kortin numero",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe pin-koodille",
            "giftcard.encryptedSecurityCode.aria.label": "Pin-tunnus",
            giftcardTransactionLimit: "Maks. % {summa} sallittu tapahtumaa kohti t\xe4ll\xe4 lahjakortilla",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe pankkitilinumeroa varten",
            "ach.encryptedBankAccountNumber.aria.label": "Tilinumero",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe pankin reititysnumeroa varten",
            "ach.encryptedBankLocationId.aria.label": "ABA-reititysnumero",
            "twint.saved": "tallennettu",
            orPayWith: "tai maksa",
            invalidFormatExpects: "Ei-kelvollinen muoto. Odotettu muoto: %{format}",
            "upi.qrCodeWaitingMessage": "Suorita maksu loppuun skannaamalla QR-koodi haluamallasi UPI-sovelluksella",
            "upi.vpaWaitingMessage": "Avaa UPI-sovellus vahvistaaksesi maksun",
            "upi.modeSelection": "Valitse, kuinka haluat k\xe4ytt\xe4\xe4 UPI-sovellusta.",
            "onlineBanking.termsAndConditions": "Jatkamalla hyv\xe4ksyt %#k\xe4ytt\xf6ehdot%#",
            "onlineBankingPL.termsAndConditions": "Jatkamalla hyv\xe4ksyt Przelewy24:n %#s\xe4\xe4nn\xf6t%# ja %#tiedonantovelvollisuuden%#",
            "ctp.loading.poweredByCtp": "Palvelun tarjoaa Click to Pay",
            "ctp.loading.intro": "Tarkistamme, onko sinulla tallennettuja Click to Pay -kortteja...",
            "ctp.login.title": "Jatka Click to Pay -palveluun",
            "ctp.login.subtitle": "Jatka antamalla Click to Pay -palveluun liitetty s\xe4hk\xf6postiosoite.",
            "ctp.login.inputLabel": "S\xe4hk\xf6posti",
            "ctp.logout.notYou": "Etk\xf6 t\xe4m\xe4 ole sin\xe4?",
            "ctp.logout.notYourCards": "Eik\xf6 t\xe4m\xe4 ole korttisi?",
            "ctp.logout.notYourCard": "Eik\xf6 t\xe4m\xe4 ole korttisi?",
            "ctp.logout.notYourProfile": "Eik\xf6 t\xe4m\xe4 ole profiilisi?",
            "ctp.otp.fieldLabel": "Kertakoodi",
            "ctp.otp.resendCode": "L\xe4het\xe4 koodi uudelleen",
            "ctp.otp.codeResent": "Koodi l\xe4hetetty uudelleen",
            "ctp.otp.title": "Hanki p\xe4\xe4sy Click to Pay -kortteihisi",
            "ctp.otp.subtitle": "Sy\xf6t\xe4 koodi, jonka %@ l\xe4hetti osoitteeseen %@ vahvistaaksesi, ett\xe4 kyseess\xe4 olet sin\xe4.",
            "ctp.otp.saveCookiesCheckbox.label": "Ohita vahvistus seuraavalla kerralla",
            "ctp.otp.saveCookiesCheckbox.information": "Valitse, ett\xe4 sinut muistetaan laitteellasi ja selaimessa osallistuvissa myym\xe4l\xf6iss\xe4, jotta voit maksaa nopeammin. Ei suositella jaetuilla laitteilla.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Valitse, jotta sinut muistetaan laitteellasi ja selaimessa",
            "ctp.emptyProfile.message": "T\xe4h\xe4n Click to Pay -profiiliin ei ole rekister\xf6ity kortteja",
            "ctp.separatorText": "tai k\xe4yt\xe4",
            "ctp.cards.title": "Suorita maksu Click to Paylla",
            "ctp.cards.subtitle": "Valitse k\xe4ytett\xe4v\xe4 kortti.",
            "ctp.cards.expiredCard": "Vanhentunut",
            "ctp.manualCardEntry": "Manuaalinen kortin sy\xf6tt\xf6",
            "ctp.aria.infoModalButton": "Mik\xe4 on Click to Pay",
            "ctp.infoPopup.title": "Click to Pay tuo l\xe4himaksujen helppouden verkkoon",
            "ctp.infoPopup.subtitle": "Nopea ja turvallinen maksutapa, jota tukevat Mastercard, Visa ja muut maksukortit.",
            "ctp.infoPopup.benefit1": "Click to Pay k\xe4ytt\xe4\xe4 salausta tietojesi turvaamiseen",
            "ctp.infoPopup.benefit2": "K\xe4yt\xe4 sit\xe4 kauppiailla kaikkialla maailmassa",
            "ctp.infoPopup.benefit3": "M\xe4\xe4rit\xe4 kerran, jotta voit maksaa vaivattomasti jatkossa",
            "ctp.errors.AUTH_INVALID": "Virheellinen todennus",
            "ctp.errors.NOT_FOUND": "Tili\xe4 ei l\xf6ytynyt. Anna kelvollinen s\xe4hk\xf6postiosoite tai jatka manuaalista kortin sy\xf6tt\xf6\xe4",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Muoto ei tuettu",
            "ctp.errors.FRAUD": "K\xe4ytt\xe4j\xe4tili oli lukittu tai poistettu k\xe4yt\xf6st\xe4",
            "ctp.errors.CONSUMER_ID_MISSING": "Pyynn\xf6st\xe4 puuttuu kuluttajan henkil\xf6llisyys",
            "ctp.errors.ACCT_INACCESSIBLE": "T\xe4m\xe4 tili ei ole t\xe4ll\xe4 hetkell\xe4 k\xe4ytett\xe4viss\xe4, se voi esimerkiksi olla lukittu",
            "ctp.errors.CODE_INVALID": "Virheellinen vahvistuskoodi",
            "ctp.errors.CODE_EXPIRED": "T\xe4m\xe4 koodi on vanhentunut",
            "ctp.errors.RETRIES_EXCEEDED": "Kertak\xe4ytt\xf6isen salasanan luomisen uusintayritysten m\xe4\xe4r\xe4 ylittyi",
            "ctp.errors.OTP_SEND_FAILED": "Kertak\xe4ytt\xf6ist\xe4 salasanaa ei voitu l\xe4hett\xe4\xe4 vastaanottajalle",
            "ctp.errors.REQUEST_TIMEOUT": "Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4",
            "ctp.errors.UNKNOWN_ERROR": "Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4",
            "ctp.errors.SERVICE_ERROR": "Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4",
            "ctp.errors.SERVER_ERROR": "Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4",
            "ctp.errors.INVALID_PARAMETER": "Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4",
            "ctp.errors.AUTH_ERROR": "Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4",
            "paymentMethodsList.aria.label": "Valitse maksutapa",
            "companyDetails.name.invalid": "Sy\xf6t\xe4 yrityksen nimi",
            "companyDetails.registrationNumber.invalid": "Sy\xf6t\xe4 rekisterinumero",
            "consent.checkbox.invalid": "Sinun on hyv\xe4ksytt\xe4v\xe4 k\xe4ytt\xf6ehdot",
            "form.instruction": "Kaikki kent\xe4t ovat pakollisia, ellei toisin ole merkitty.",
            "ancv.input.label": "ANCV-tunnuksesi",
            "ancv.confirmPayment": "Vahvista maksusi ANCV-sovelluksella.",
            "ancv.form.instruction": "T\xe4m\xe4n maksun vahvistaminen edellytt\xe4\xe4 Cheque-Vacances -sovelluksen.",
            "ancv.beneficiaryId.invalid": "Anna kelvollinen s\xe4hk\xf6postiosoite tai ANCV-tunnus",
            "payme.openPayMeApp": "Viimeistele maksu PayMe-sovelluksessa hyv\xe4ksym\xe4ll\xe4 maksu sovelluksessa, ja odota vahvistusta.",
            "payme.redirectButtonLabel": "Avaa PayMe-sovellus",
            "payme.scanQrCode": "Viimeistele maksusi QR-koodilla",
            "payme.timeToPay": "T\xe4m\xe4 QR-koodi on voimassa %@",
            "payme.instructions.steps": "Avaa PayMe-sovellus.%@Hyv\xe4ksy maksu skannaamalla QR-koodi.%@Viimeistele maksu sovelluksessa, ja odota vahvistusta.",
            "payme.instructions.footnote": "\xc4l\xe4 sulje t\xe4t\xe4 sivua ennen kuin maksu on suoritettu"
        }
    }), F2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Payer",
            "payButton.redirecting": "Redirection...",
            "payButton.with": "Payer %{value} avec %{maskedData}",
            "payButton.saveDetails": "Enregistrer les d\xe9tails",
            close: "Fermer",
            storeDetails: "Sauvegarder pour mon prochain paiement",
            readMore: "Lire la suite",
            "creditCard.holderName": "Nom sur la carte",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "Entrez le nom tel qu'il appara\xeet sur la carte",
            "creditCard.numberField.title": "Num\xe9ro de la carte",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Date d'expiration",
            "creditCard.expiryDateField.placeholder": "MM/AA",
            "creditCard.expiryDateField.month": "Mois",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "AA",
            "creditCard.expiryDateField.year": "Ann\xe9e",
            "creditCard.cvcField.title": "Code de s\xe9curit\xe9",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Enregistrer pour la prochaine fois",
            "creditCard.cvcField.placeholder.4digits": "4\xa0chiffres",
            "creditCard.cvcField.placeholder.3digits": "3\xa0chiffres",
            "creditCard.taxNumber.placeholder": "AAMMJJ / 0123456789",
            installments: "Nombre de versements",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times}\xa0mois",
            "installments.oneTime": "Paiement unique",
            "installments.installments": "Paiement \xe9chelonn\xe9",
            "installments.revolving": "Paiement en plusieurs fois",
            "sepaDirectDebit.ibanField.invalid": "Num\xe9ro de compte non valide",
            "sepaDirectDebit.nameField.placeholder": "N. Bernard",
            "sepa.ownerName": "Au nom de",
            "sepa.ibanNumber": "Num\xe9ro de compte (IBAN)",
            "error.title": "Erreur",
            "error.subtitle.redirect": "\xc9chec de la redirection",
            "error.subtitle.payment": "\xc9chec du paiement",
            "error.subtitle.refused": "Paiement refus\xe9",
            "error.message.unknown": "Une erreur inconnue s'est produite",
            "errorPanel.title": "Erreurs existantes",
            "idealIssuer.selectField.title": "Banque",
            "idealIssuer.selectField.placeholder": "S\xe9lectionnez votre banque",
            "creditCard.success": "Paiement r\xe9ussi",
            loading: "Chargement en cours...",
            continue: "Continuer",
            continueTo: "Poursuivre vers",
            "wechatpay.timetopay": "Vous avez %@ pour payer cette somme",
            "sr.wechatpay.timetopay": "Vous disposez de %#\xa0minutes%# et %#\xa0secondes%# pour effectuer le paiement",
            "wechatpay.scanqrcode": "Scanner le code QR",
            personalDetails: "Informations personnelles",
            companyDetails: "Coordonn\xe9es de l'entreprise",
            "companyDetails.name": "Nom de l'entreprise",
            "companyDetails.registrationNumber": "Num\xe9ro d'enregistrement",
            socialSecurityNumber: "Num\xe9ro de s\xe9curit\xe9 sociale",
            firstName: "Pr\xe9nom",
            "firstName.invalid": "Entrez votre pr\xe9nom",
            infix: "Pr\xe9fixe",
            lastName: "Nom de famille",
            "lastName.invalid": "Entrez votre nom",
            mobileNumber: "Num\xe9ro de portable",
            "mobileNumber.invalid": "Num\xe9ro de portable non valide",
            city: "Ville",
            postalCode: "Code postal",
            "postalCode.optional": "Code postal (facultatif)",
            countryCode: "Code pays",
            telephoneNumber: "Num\xe9ro de t\xe9l\xe9phone",
            dateOfBirth: "Date de naissance",
            shopperEmail: "Adresse e-mail",
            gender: "Sexe",
            "gender.notselected": "S\xe9lectionnez votre sexe",
            male: "Homme",
            female: "Femme",
            billingAddress: "Adresse de facturation",
            street: "Rue",
            stateOrProvince: "\xc9tat ou province",
            country: "Pays/R\xe9gion",
            houseNumberOrName: "Num\xe9ro de rue",
            separateDeliveryAddress: "Indiquer une adresse de livraison distincte",
            deliveryAddress: "Adresse de livraison",
            "deliveryAddress.firstName": "Pr\xe9nom du destinataire",
            "deliveryAddress.lastName": "Nom du destinataire",
            zipCode: "Code postal",
            apartmentSuite: "Appartement",
            provinceOrTerritory: "Province ou territoire",
            cityTown: "Ville",
            address: "Adresse",
            "address.placeholder": "Trouvez votre adresse",
            "address.errors.incomplete": "Saisissez une adresse pour continuer",
            "address.enterManually": "Saisissez l'adresse manuellement",
            state: "\xc9tat",
            "field.title.optional": "(facultatif)",
            "creditCard.cvcField.title.optional": "Code de s\xe9curit\xe9 (facultatif)",
            "issuerList.wallet.placeholder": "S\xe9lectionnez votre portefeuille",
            privacyPolicy: "Politique de confidentialit\xe9",
            "afterPay.agreement": "J'accepte les %@ de Riverty",
            paymentConditions: "conditions de paiement",
            openApp: "Ouvrir l'application",
            "voucher.readInstructions": "Lire les instructions",
            "voucher.introduction": "Merci pour votre achat, veuillez utiliser le coupon suivant pour finaliser votre paiement.",
            "voucher.expirationDate": "Date d'expiration",
            "voucher.alternativeReference": "Autre r\xe9f\xe9rence",
            "dragonpay.voucher.non.bank.selectField.placeholder": "S\xe9lectionnez votre fournisseur",
            "dragonpay.voucher.bank.selectField.placeholder": "S\xe9lectionnez votre banque",
            "voucher.paymentReferenceLabel": "R\xe9f\xe9rence du paiement",
            "voucher.surcharge": "Comprend une surcharge de %@",
            "voucher.introduction.doku": "Nous vous remercions de votre achat. Veuillez finaliser votre paiement \xe0 l'aide des informations suivantes.",
            "voucher.shopperName": "Nom de l'acheteur",
            "voucher.merchantName": "Marchand",
            "voucher.introduction.econtext": "Nous vous remercions de votre achat. Veuillez finaliser votre paiement \xe0 l'aide des informations suivantes.",
            "voucher.telephoneNumber": "Num\xe9ro de t\xe9l\xe9phone",
            "voucher.shopperReference": "R\xe9f\xe9rence client",
            "voucher.collectionInstitutionNumber": "Num\xe9ro du point de paiement",
            "voucher.econtext.telephoneNumber.invalid": "Le num\xe9ro de t\xe9l\xe9phone doit comporter 10 ou 11\xa0chiffres",
            "boletobancario.btnLabel": "G\xe9n\xe9rer un Boleto",
            "boleto.sendCopyToEmail": "Envoyer une copie \xe0 mon adresse e-mail",
            "button.copy": "Copier",
            "button.download": "T\xe9l\xe9charger",
            "boleto.socialSecurityNumber.invalid": "Saisissez un num\xe9ro CPF/CNPJ valide",
            "creditCard.storedCard.description.ariaLabel": "La carte enregistr\xe9e se termine en %@",
            "voucher.entity": "Entit\xe9",
            donateButton: "Faire un don",
            notNowButton: "Pas maintenant",
            thanksForYourSupport: "Merci de votre soutien\xa0!",
            "resultMessages.preauthorized": "D\xe9tails enregistr\xe9s",
            preauthorizeWith: "Pr\xe9-autoriser avec",
            confirmPreauthorization: "Confirmer la pr\xe9-autorisation",
            confirmPurchase: "Confirmer l'achat",
            applyGiftcard: "Utiliser",
            giftcardBalance: "Solde de la carte cadeau",
            deductedBalance: "Solde d\xe9duit",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "Les deux premiers chiffres du code de votre carte",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Code incorrect",
            "creditCard.taxNumber": "Date de naissance du porteur de carte ou num\xe9ro d'identification de l'entreprise",
            "creditCard.taxNumber.label": "Date de naissance du porteur de carte (au format AAMMJJ) ou num\xe9ro d'identification de l'entreprise (\xe0 10\xa0chiffres)",
            "creditCard.taxNumber.labelAlt": "Num\xe9ro d'identification de l'entreprise (\xe0 10\xa0chiffres)",
            "creditCard.taxNumber.invalid": "Date de naissance du porteur de carte ou num\xe9ro d'identification de l'entreprise incorrect(e)",
            "storedPaymentMethod.disable.button": "Supprimer",
            "storedPaymentMethod.disable.confirmation": "Supprimer le mode de paiement enregistr\xe9",
            "storedPaymentMethod.disable.confirmButton": "Oui, supprimer",
            "storedPaymentMethod.disable.cancelButton": "Annuler",
            "ach.bankAccount": "Compte bancaire",
            "ach.accountHolderNameField.title": "Nom du titulaire du compte",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "Nom du titulaire du compte incorrect",
            "ach.accountNumberField.title": "Num\xe9ro du compte",
            "ach.accountNumberField.invalid": "Num\xe9ro du compte incorrect",
            "ach.accountLocationField.title": "Code ABA",
            "ach.accountLocationField.invalid": "Code ABA incorrect",
            "ach.savedBankAccount": "Compte bancaire enregistr\xe9",
            "select.state": "S\xe9lectionnez l'\xc9tat",
            "select.stateOrProvince": "S\xe9lectionnez l'\xc9tat ou la province",
            "select.provinceOrTerritory": "S\xe9lectionnez la province ou le territoire",
            "select.country": "S\xe9lectionnez le pays/la r\xe9gion",
            "select.noOptionsFound": "Aucune option trouv\xe9e",
            "select.filter.placeholder": "Recherche...",
            "telephoneNumber.invalid": "Num\xe9ro de t\xe9l\xe9phone incorrect",
            qrCodeOrApp: "ou",
            "paypal.processingPayment": "Traitement du paiement en cours...",
            generateQRCode: "G\xe9n\xe9rer un code QR",
            "await.waitForConfirmation": "En attente de confirmation",
            "mbway.confirmPayment": "Confirmez votre paiement sur l'application MB WAY",
            "shopperEmail.invalid": "Adresse e-mail incorrecte",
            "dateOfBirth.format": "JJ/MM/AAAA",
            "dateOfBirth.invalid": "Saisissez une date de naissance valide indiquant que vous avez au moins 18\xa0ans",
            "blik.confirmPayment": "Ouvrez votre application bancaire pour confirmer le paiement.",
            "blik.invalid": "Saisissez les 6\xa0chiffres",
            "blik.code": "Code \xe0 6\xa0chiffres",
            "blik.help": "Ouvrez votre application bancaire pour obtenir le code.",
            "swish.pendingMessage": "Apr\xe8s avoir scann\xe9 le code QR, la mise \xe0 jour du statut de paiement peut prendre jusqu'\xe0 10\xa0minutes. Si vous effectuez une nouvelle tentative de paiement dans ce d\xe9lai, cela pourrait occasionner plusieurs d\xe9bits.",
            "field.valid": "Champ valide",
            "field.invalid": "Champ non valide",
            "error.va.gen.01": "Champ incomplet",
            "error.va.gen.02": "Champ non valide",
            "error.va.sf-cc-num.01": "Entrez un num\xe9ro de carte valide",
            "error.va.sf-cc-num.02": "Entrez le num\xe9ro de la carte",
            "error.va.sf-cc-num.03": "Entrez un \xe9metteur de carte pris en charge",
            "error.va.sf-cc-num.04": "Entrez le num\xe9ro de carte complet",
            "error.va.sf-cc-dat.01": "Entrez une date d'expiration valide",
            "error.va.sf-cc-dat.02": "Entrez une date d'expiration valide",
            "error.va.sf-cc-dat.03": "La carte de cr\xe9dit arrive \xe0 expiration",
            "error.va.sf-cc-dat.04": "Entrez la date d'expiration",
            "error.va.sf-cc-dat.05": "Entrez la date d'expiration compl\xe8te",
            "error.va.sf-cc-mth.01": "Entrez le mois d'expiration",
            "error.va.sf-cc-yr.01": "Entrez l'ann\xe9e d'expiration",
            "error.va.sf-cc-yr.02": "Entrez l'ann\xe9e d'expiration compl\xe8te",
            "error.va.sf-cc-cvc.01": "Entrez le code de s\xe9curit\xe9",
            "error.va.sf-cc-cvc.02": "Entrez le code de s\xe9curit\xe9 complet",
            "error.va.sf-ach-num.01": "Veuillez renseigner un num\xe9ro de compte bancaire",
            "error.va.sf-ach-num.02": "Longueur du num\xe9ro de compte bancaire incorrecte",
            "error.va.sf-ach-loc.01": "Veuillez renseigner un num\xe9ro de routage",
            "error.va.sf-ach-loc.02": "Longueur du num\xe9ro de routage incorrecte",
            "error.va.sf-kcp-pwd.01": "Veuillez renseigner un mot de passe",
            "error.va.sf-kcp-pwd.02": "Longueur du mot de passe incorrecte",
            "error.giftcard.no-balance": "Aucun solde n'est disponible sur cette carte cadeau",
            "error.giftcard.card-error": "Aucune carte cadeau ne correspond \xe0 ce num\xe9ro",
            "error.giftcard.currency-error": "Les cartes cadeaux sont valables uniquement dans la devise dans laquelle elles ont \xe9t\xe9 \xe9mises",
            "amazonpay.signout": "Se d\xe9connecter d'Amazon",
            "amazonpay.changePaymentDetails": "Modifier les informations de paiement",
            "partialPayment.warning": "S\xe9lectionnez un autre mode de paiement pour r\xe9gler le solde",
            "partialPayment.remainingBalance": "Le solde restant sera de %{amount}",
            "bankTransfer.beneficiary": "B\xe9n\xe9ficiaire",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "R\xe9f\xe9rence",
            "bankTransfer.introduction": "Continuez \xe0 cr\xe9er un nouveau paiement par virement bancaire. Utilisez les informations de l'\xe9cran suivant pour finaliser ce paiement.",
            "bankTransfer.instructions": "Merci pour votre achat\xa0! Veuillez utiliser les informations suivantes pour finaliser votre paiement.",
            "bacs.accountHolderName": "Nom du titulaire du compte bancaire",
            "bacs.accountHolderName.invalid": "Nom du titulaire du compte bancaire incorrect",
            "bacs.accountNumber": "Num\xe9ro du compte bancaire",
            "bacs.accountNumber.invalid": "Num\xe9ro du compte bancaire incorrect",
            "bacs.bankLocationId": "Code de tri (sort code)",
            "bacs.bankLocationId.invalid": "Code de tri (sort code) non valide",
            "bacs.consent.amount": "J'accepte que le montant ci-dessus soit d\xe9duit de mon compte bancaire.",
            "bacs.consent.account": "Je confirme \xeatre le titulaire du compte et qu'aucune autre signature que la mienne n'est requise pour autoriser un pr\xe9l\xe8vement sur ce compte.",
            edit: "Modifier",
            "bacs.confirm": "Confirmer et payer",
            "bacs.result.introduction": "T\xe9l\xe9chargez votre mandat de pr\xe9l\xe8vement (DDI)",
            "download.pdf": "T\xe9l\xe9charger le PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe pour le num\xe9ro de carte",
            "creditCard.encryptedCardNumber.aria.label": "Num\xe9ro de la carte",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe pour la date d'expiration",
            "creditCard.encryptedExpiryDate.aria.label": "Date d'expiration",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe pour le mois d'expiration",
            "creditCard.encryptedExpiryMonth.aria.label": "Mois d'expiration",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe pour l'ann\xe9e d'expiration",
            "creditCard.encryptedExpiryYear.aria.label": "Ann\xe9e d'expiration",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe pour le code de s\xe9curit\xe9",
            "creditCard.encryptedSecurityCode.aria.label": "Code de s\xe9curit\xe9",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe pour le mot de passe",
            "creditCard.encryptedPassword.aria.label": "Les deux premiers chiffres du code de votre carte",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe pour le num\xe9ro de carte",
            "giftcard.encryptedCardNumber.aria.label": "Num\xe9ro de la carte",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe pour le code secret",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "Montant maximum autoris\xe9 par transaction avec cette carte cadeau\xa0: %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe pour le num\xe9ro de compte bancaire",
            "ach.encryptedBankAccountNumber.aria.label": "Num\xe9ro du compte",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe pour le num\xe9ro de routage bancaire",
            "ach.encryptedBankLocationId.aria.label": "Code ABA",
            "twint.saved": "stock\xe9",
            orPayWith: "ou payez avec",
            invalidFormatExpects: "Format non valide. Format requis\xa0: %{format}",
            "upi.qrCodeWaitingMessage": "Scannez le code QR \xe0 l'aide de votre application UPI pr\xe9f\xe9r\xe9e pour effectuer le paiement",
            "upi.vpaWaitingMessage": "Ouvrez votre application UPI pour confirmer le paiement",
            "upi.modeSelection": "Choisissez la fa\xe7on dont vous souhaitez utiliser l'application UPI.",
            "onlineBanking.termsAndConditions": "En continuant, vous acceptez les %#conditions g\xe9n\xe9rales%#",
            "onlineBankingPL.termsAndConditions": "En continuant, vous acceptez les %#r\xe9glementations%# et l'%#obligation d'information%# de Przelewy24",
            "ctp.loading.poweredByCtp": "Avec la technologie Click to Pay",
            "ctp.loading.intro": "Nous v\xe9rifions si vous avez des cartes enregistr\xe9es avec Click to Pay...",
            "ctp.login.title": "Acc\xe9der \xe0 Click to Pay",
            "ctp.login.subtitle": "Saisissez l'adresse e-mail de votre profil Click to Pay pour continuer.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "Ce n'est pas votre compte\xa0?",
            "ctp.logout.notYourCards": "Ce ne sont pas vos cartes\xa0?",
            "ctp.logout.notYourCard": "Ce n'est pas votre carte\xa0?",
            "ctp.logout.notYourProfile": "Ce n'est pas votre profil\xa0?",
            "ctp.otp.fieldLabel": "Code \xe0 usage unique",
            "ctp.otp.resendCode": "Renvoyer le code",
            "ctp.otp.codeResent": "Code renvoy\xe9",
            "ctp.otp.title": "Acc\xe9dez \xe0 vos cartes Click to Pay",
            "ctp.otp.subtitle": "Saisissez le code %@ envoy\xe9 \xe0 %@ pour v\xe9rifier votre identit\xe9.",
            "ctp.otp.saveCookiesCheckbox.label": "Ignorer la v\xe9rification la prochaine fois",
            "ctp.otp.saveCookiesCheckbox.information": "S\xe9lectionnez cette option pour m\xe9moriser les informations sur votre appareil et votre navigateur afin d'acc\xe9l\xe9rer le paiement dans les magasins participants. Non recommand\xe9 pour les appareils partag\xe9s.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "S\xe9lectionner cette option pour m\xe9moriser les informations sur votre appareil et votre navigateur",
            "ctp.emptyProfile.message": "Aucune carte enregistr\xe9e dans ce profil Click to Pay",
            "ctp.separatorText": "ou utilisez",
            "ctp.cards.title": "Terminez le paiement avec Click to Pay",
            "ctp.cards.subtitle": "S\xe9lectionnez la carte \xe0 utiliser.",
            "ctp.cards.expiredCard": "Expir\xe9",
            "ctp.manualCardEntry": "Saisie manuelle de la carte",
            "ctp.aria.infoModalButton": "Qu'est-ce que Click to Pay\xa0?",
            "ctp.infoPopup.title": "Click to Pay offre la simplicit\xe9 du sans contact sur Internet",
            "ctp.infoPopup.subtitle": "Un mode de paiement rapide et s\xe9curis\xe9 compatible avec les cartes Mastercard, Visa et autres fournisseurs.",
            "ctp.infoPopup.benefit1": "Click to Pay utilise le chiffrement pour assurer la s\xe9curit\xe9 de vos informations",
            "ctp.infoPopup.benefit2": "Utilisez-le pour vos achats dans le monde entier",
            "ctp.infoPopup.benefit3": "Enregistrez votre carte une fois et simplifiez vos paiements pour toujours",
            "ctp.errors.AUTH_INVALID": "Authentification non valide",
            "ctp.errors.NOT_FOUND": "Aucun compte trouv\xe9, v\xe9rifiez l'adresse e-mail ou saisissez manuellement les informations de votre carte",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Format non pris en charge",
            "ctp.errors.FRAUD": "Le compte utilisateur a \xe9t\xe9 verrouill\xe9 ou d\xe9sactiv\xe9",
            "ctp.errors.CONSUMER_ID_MISSING": "L'identit\xe9 du client n'est pas indiqu\xe9e dans la demande",
            "ctp.errors.ACCT_INACCESSIBLE": "Ce compte n'est pas disponible actuellement car il est verrouill\xe9",
            "ctp.errors.CODE_INVALID": "Code de v\xe9rification incorrect",
            "ctp.errors.CODE_EXPIRED": "Ce code a expir\xe9",
            "ctp.errors.RETRIES_EXCEEDED": "La limite du nombre de tentatives pour la g\xe9n\xe9ration de l'OTP a \xe9t\xe9 d\xe9pass\xe9e",
            "ctp.errors.OTP_SEND_FAILED": "Impossible d'envoyer l'OTP au destinataire",
            "ctp.errors.REQUEST_TIMEOUT": "Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte",
            "ctp.errors.UNKNOWN_ERROR": "Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte",
            "ctp.errors.SERVICE_ERROR": "Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte",
            "ctp.errors.SERVER_ERROR": "Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte",
            "ctp.errors.INVALID_PARAMETER": "Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte",
            "ctp.errors.AUTH_ERROR": "Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte",
            "paymentMethodsList.aria.label": "Choisissez un mode de paiement",
            "companyDetails.name.invalid": "Entrez le nom de l'entreprise",
            "companyDetails.registrationNumber.invalid": "Entrez le num\xe9ro d'identification",
            "consent.checkbox.invalid": "Vous devez accepter les conditions g\xe9n\xe9rales",
            "form.instruction": "Tous les champs sont obligatoires, sauf indication contraire.",
            "trustly.descriptor": "Paiement bancaire instantan\xe9",
            "trustly.description1": "Payez directement \xe0 partir de n'importe lequel de vos comptes bancaires, avec une s\xe9curit\xe9 de niveau bancaire",
            "trustly.description2": "Aucune carte, aucun t\xe9l\xe9chargement d'application, aucune inscription",
            "ancv.input.label": "Votre identification ANCV",
            "ancv.confirmPayment": "Utilisez votre application ANCV pour confirmer le paiement.",
            "ancv.form.instruction": "L'application Ch\xe8que-Vacances est n\xe9cessaire pour valider ce paiement.",
            "ancv.beneficiaryId.invalid": "Saisissez une adresse e-mail ou un identifiant ANCV valide",
            "payme.openPayMeApp": "Finalisez votre paiement dans l'application PayMe en autorisant le paiement dans l'application, puis attendez la confirmation.",
            "payme.redirectButtonLabel": "Ouvrir l'application PayMe",
            "payme.scanQrCode": "Effectuez votre paiement avec un code\xa0QR",
            "payme.timeToPay": "Ce code QR est valide pendant %@",
            "payme.instructions.steps": "Ouvrez l'application PayMe.%@Scannez le code\xa0QR pour autoriser le paiement.%@Effectuez le paiement dans l'application et attendez la confirmation.",
            "payme.instructions.footnote": "Veuillez ne pas fermer cette page avant que le paiement ne soit termin\xe9."
        }
    }), x2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Platiti",
            "payButton.redirecting": "Preusmjeravanje...",
            "payButton.with": "Platite iznos od %{value} uporabom stavke %{maskedData}",
            "payButton.saveDetails": "Spremi pojedinosti",
            close: "Zatvori",
            storeDetails: "Pohrani za moje sljede\u0107e pla\u0107anje",
            readMore: "Op\u0161irnije",
            "creditCard.holderName": "Ime na kartici",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "Unesite ime kako je prikazano na kartici",
            "creditCard.numberField.title": "Broj kartice",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Datum isteka",
            "creditCard.expiryDateField.placeholder": "MM/GG",
            "creditCard.expiryDateField.month": "Mjesec",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "GG",
            "creditCard.expiryDateField.year": "Godina",
            "creditCard.cvcField.title": "Sigurnosni k\xf4d",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Zapamtiti za sljede\u0107i put",
            "creditCard.cvcField.placeholder.4digits": "4 znamenke",
            "creditCard.cvcField.placeholder.3digits": "3 znamenke",
            "creditCard.taxNumber.placeholder": "YYMMDD / 0123456789",
            installments: "Broj rata",
            installmentOption: "%{times} x %{partialValue}",
            installmentOptionMonths: "Mjeseci: %{times}",
            "installments.oneTime": "Jednokratno pla\u0107anje",
            "installments.installments": "Pla\u0107anje na rate",
            "installments.revolving": "Obnovljivo pla\u0107anje",
            "sepaDirectDebit.ibanField.invalid": "Neva\u017Ee\u0107i broj ra\u010Duna",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "Ime vlasnika",
            "sepa.ibanNumber": "Broj ra\u010Duna (IBAN)",
            "error.title": "Gre\u0161ka",
            "error.subtitle.redirect": "Preusmjeravanje nije uspjelo",
            "error.subtitle.payment": "Pla\u0107anje nije uspjelo",
            "error.subtitle.refused": "Pla\u0107anje odbijeno",
            "error.message.unknown": "Dogodila se nepoznata gre\u0161ka",
            "errorPanel.title": "Postoje\u0107e gre\u0161ke",
            "idealIssuer.selectField.title": "Banka",
            "idealIssuer.selectField.placeholder": "Odaberite banku",
            "creditCard.success": "Pla\u0107anje uspje\u0161no",
            loading: "U\u010Ditavanje\u2026",
            continue: "Nastavi",
            continueTo: "Nastavi na",
            "wechatpay.timetopay": "Imate %@ za pla\u0107anje",
            "sr.wechatpay.timetopay": "Imate %#minuta%# i %#sekundi%# za pla\u0107anje",
            "wechatpay.scanqrcode": "Skeniraj QR k\xf4d",
            personalDetails: "Osobni podatci",
            companyDetails: "Detalji tvrtke",
            "companyDetails.name": "Naziv tvrtke",
            "companyDetails.registrationNumber": "Mati\u010Dni broj",
            socialSecurityNumber: "Broj socijalnog osiguranja",
            firstName: "Ime",
            "firstName.invalid": "Unesite svoje ime",
            infix: "Prefiks",
            lastName: "Prezime",
            "lastName.invalid": "Unesite svoje prezime",
            mobileNumber: "Broj mobilnog telefona",
            "mobileNumber.invalid": "Neva\u017Ee\u0107i broj mobilnog telefona",
            city: "Grad",
            postalCode: "Po\u0161tanski broj",
            "postalCode.optional": "Po\u0161tanski broj (nije obvezno)",
            countryCode: "Pozivni broj dr\u017Eave",
            telephoneNumber: "Telefonski broj",
            dateOfBirth: "Datum ro\u0111enja",
            shopperEmail: "Adresa e-po\u0161te",
            gender: "Spol",
            "gender.notselected": "Odaberite svoj spol",
            male: "Mu\u0161karac",
            female: "\u017Dena",
            billingAddress: "Adresa za ra\u010Dun",
            street: "Ulica",
            stateOrProvince: "Dr\u017Eava ili pokrajina",
            country: "Zemlja/regija",
            houseNumberOrName: "Ku\u0107ni broj",
            separateDeliveryAddress: "Navedite zasebnu adresu za dostavu",
            deliveryAddress: "Adresa za dostavu",
            "deliveryAddress.firstName": "Ime primatelja",
            "deliveryAddress.lastName": "Prezime primatelja",
            zipCode: "Po\u0161tanski broj",
            apartmentSuite: "Stan/apartman",
            provinceOrTerritory: "Pokrajina ili teritorij",
            cityTown: "Grad",
            address: "Adresa",
            "address.placeholder": "Prona\u0111ite adresu",
            "address.errors.incomplete": "Unesite adresu za nastavak",
            "address.enterManually": "Ru\u010Dno unesite adresu",
            state: "Savezna dr\u017Eava",
            "field.title.optional": "(neobavezno)",
            "creditCard.cvcField.title.optional": "Sigurnosni k\xf4d (neobvezno)",
            "issuerList.wallet.placeholder": "Odaberite svoju nov\u010Danik",
            privacyPolicy: "Politika privatnosti",
            "afterPay.agreement": "Sla\u017Eem se s %@ Rivertyja",
            paymentConditions: "uvjetima pla\u0107anja",
            openApp: "Otvorite aplikaciju",
            "voucher.readInstructions": "Pro\u010Ditajte upute",
            "voucher.introduction": "Zahvaljujemo na kupnji, upotrijebite sljede\u0107i kupon za dovr\u0161etak pla\u0107anja.",
            "voucher.expirationDate": "Datum isteka",
            "voucher.alternativeReference": "Alternativna referenca",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Odaberite davatelja usluge",
            "dragonpay.voucher.bank.selectField.placeholder": "Odaberite banku",
            "voucher.paymentReferenceLabel": "Referenca za pla\u0107anje",
            "voucher.surcharge": "Uklju\u010Duje %@ nadoplate",
            "voucher.introduction.doku": "Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.",
            "voucher.shopperName": "Ime kupca",
            "voucher.merchantName": "Trgovac",
            "voucher.introduction.econtext": "Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.",
            "voucher.telephoneNumber": "Broj telefona",
            "voucher.shopperReference": "Referenca kupca",
            "voucher.collectionInstitutionNumber": "Broj ustanove za prikupljanje",
            "voucher.econtext.telephoneNumber.invalid": "Telefonski broj mora imati 10 ili 11 znamenki",
            "boletobancario.btnLabel": "Generiraj Boleto",
            "boleto.sendCopyToEmail": "Po\u0161alji kopiju na moju e-po\u0161tu",
            "button.copy": "Kopiraj",
            "button.download": "Preuzmi",
            "boleto.socialSecurityNumber.invalid": "Unesite valjani CPF/CNPJ broj",
            "creditCard.storedCard.description.ariaLabel": "Pohranjena kartica zavr\u0161ava na %@",
            "voucher.entity": "Entitet",
            donateButton: "Doniraj",
            notNowButton: "Ne sada",
            thanksForYourSupport: "Hvala na podr\u0161ci!",
            "resultMessages.preauthorized": "Spremljeni podatci",
            preauthorizeWith: "Prethodno odobri s",
            confirmPreauthorization: "Potvrdite prethodno odobrenje",
            confirmPurchase: "Potvrdite kupnju",
            applyGiftcard: "Iskoristite",
            giftcardBalance: "Stanje na poklon-kartici",
            deductedBalance: "Potro\u0161eni iznos",
            "creditCard.pin.title": "Pin",
            "creditCard.encryptedPassword.label": "Prve 2 znamenke lozinke kartice",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Lozinka je neto\u010Dna",
            "creditCard.taxNumber": "Datum ro\u0111enja vlasnika kartice ili registracijski broj tvrtke",
            "creditCard.taxNumber.label": "Datum ro\u0111enja vlasnika kartice (GGMMDD) ili registracijski broj tvrtke (10 znamenki)",
            "creditCard.taxNumber.labelAlt": "Registracijski broj tvrtke (10 znamenki)",
            "creditCard.taxNumber.invalid": "Neto\u010Dan datum ro\u0111enja vlasnika kartice (GGMMDD) ili registracijski broj tvrtke (10 znamenki)",
            "storedPaymentMethod.disable.button": "Ukloni",
            "storedPaymentMethod.disable.confirmation": "Uklonite pohranjeni na\u010Din pla\u0107anja",
            "storedPaymentMethod.disable.confirmButton": "Da, ukloni",
            "storedPaymentMethod.disable.cancelButton": "Otka\u017Ei",
            "ach.bankAccount": "Bankovni ra\u010Dun",
            "ach.accountHolderNameField.title": "Ime vlasnika ra\u010Duna",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "Neva\u017Ee\u0107e ime vlasnika ra\u010Duna",
            "ach.accountNumberField.title": "Broj ra\u010Duna",
            "ach.accountNumberField.invalid": "Neva\u017Ee\u0107i broj ra\u010Duna",
            "ach.accountLocationField.title": "ABA identifikacijski broj",
            "ach.accountLocationField.invalid": "Neva\u017Ee\u0107i ABA identifikacijski broj",
            "ach.savedBankAccount": "Spremljeni bankovni ra\u010Dun",
            "select.state": "Odaberite saveznu dr\u017Eavu",
            "select.stateOrProvince": "Odaberite dr\u017Eavu ili provinciju",
            "select.provinceOrTerritory": "Odaberite provinciju ili teritorij",
            "select.country": "Odaberite zemlju/regiju",
            "select.noOptionsFound": "Nije prona\u0111ena nijedna opcija",
            "select.filter.placeholder": "Tra\u017Ei...",
            "telephoneNumber.invalid": "Neva\u017Ee\u0107i telefonski broj",
            qrCodeOrApp: "ili",
            "paypal.processingPayment": "Obrada pla\u0107anja u tijeku...",
            generateQRCode: "Generirajte QR k\xf4d",
            "await.waitForConfirmation": "\u010Ceka se potvrda",
            "mbway.confirmPayment": "Potvrdite uplatu u aplikaciji MB WAY",
            "shopperEmail.invalid": "Neva\u017Ee\u0107a adresa e-po\u0161te",
            "dateOfBirth.format": "DD/MM/GGGG",
            "dateOfBirth.invalid": "Unesite va\u017Ee\u0107i datum ro\u0111enja koji pokazuje da imate najmanje 18 godina",
            "blik.confirmPayment": "Otvorite svoju bankovnu aplikaciju kako biste potvrdili pla\u0107anje.",
            "blik.invalid": "Unesite 6 znamenki",
            "blik.code": "6-znamenkasti k\xf4d",
            "blik.help": "Preuzmite k\xf4d iz bankovne aplikacije.",
            "swish.pendingMessage": "Nakon skeniranja status mo\u017Ee biti na \u010Dekanju do 10 minuta. Poku\u0161aj ponovnog pla\u0107anja u istom periodu mo\u017Ee rezultirati vi\u0161estrukim naplatama.",
            "field.valid": "Valjano polje",
            "field.invalid": "Neva\u017Ee\u0107e polje",
            "error.va.gen.01": "Nepotpuno polje",
            "error.va.gen.02": "Neva\u017Ee\u0107e polje",
            "error.va.sf-cc-num.01": "Unesite valjani broj kartice",
            "error.va.sf-cc-num.02": "Unesite broj kartice",
            "error.va.sf-cc-num.03": "Unesite podr\u017Eanu marku kartice",
            "error.va.sf-cc-num.04": "Unesite potpuni broj kartice",
            "error.va.sf-cc-dat.01": "Unesite valjani datum isteka",
            "error.va.sf-cc-dat.02": "Unesite valjani datum isteka",
            "error.va.sf-cc-dat.03": "Kreditna kartica uskoro istje\u010De",
            "error.va.sf-cc-dat.04": "Unesite datum isteka",
            "error.va.sf-cc-dat.05": "Unesite potpuni datum isteka",
            "error.va.sf-cc-mth.01": "Unesite mjesec isteka",
            "error.va.sf-cc-yr.01": "Unesite godinu isteka",
            "error.va.sf-cc-yr.02": "Unesite potpunu godinu isteka",
            "error.va.sf-cc-cvc.01": "Unesite sigurnosni k\xf4d",
            "error.va.sf-cc-cvc.02": "Unesite potpuni sigurnosni k\xf4d",
            "error.va.sf-ach-num.01": "Polje za broj bankovnog ra\u010Duna je prazno",
            "error.va.sf-ach-num.02": "Broj je bankovnog ra\u010Duna pogre\u0161ne duljine",
            "error.va.sf-ach-loc.01": "Polje je broja usmjeravanja prazno",
            "error.va.sf-ach-loc.02": "Broj je usmjeravanja pogre\u0161ne duljine",
            "error.va.sf-kcp-pwd.01": "Polje je lozinke prazno",
            "error.va.sf-kcp-pwd.02": "Lozinka je pogre\u0161ne duljine",
            "error.giftcard.no-balance": "Stanje na ovoj poklon-kartici iznosi nula",
            "error.giftcard.card-error": "U na\u0161oj evidenciji nemamo poklon-karticu s ovim brojem",
            "error.giftcard.currency-error": "Poklon-kartice vrijede samo u valuti u kojoj su izdane",
            "amazonpay.signout": "Odjava iz Amazona",
            "amazonpay.changePaymentDetails": "Promijenite pojedinosti o pla\u0107anju",
            "partialPayment.warning": "Odaberite drugi na\u010Din pla\u0107anja da biste platili preostali iznos",
            "partialPayment.remainingBalance": "Preostalo stanje na ra\u010Dunu iznosit \u0107e %{amount}",
            "bankTransfer.beneficiary": "Primatelj",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Referenca",
            "bankTransfer.introduction": "Nastavite da biste kreirali novu uplatu putem bankovne transakcije. Za finaliziranje ovog pla\u0107anja mo\u017Eete se koristiti pojedinostima na sljede\u0107em zaslonu.",
            "bankTransfer.instructions": "Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.",
            "bacs.accountHolderName": "Ime vlasnika bankovnog ra\u010Duna",
            "bacs.accountHolderName.invalid": "Neva\u017Ee\u0107e ime vlasnika bankovnog ra\u010Duna",
            "bacs.accountNumber": "Broj bankovnog ra\u010Duna",
            "bacs.accountNumber.invalid": "Neva\u017Ee\u0107i broj bankovnog ra\u010Duna",
            "bacs.bankLocationId": "Identifikacijski k\xf4d banke (UK)",
            "bacs.bankLocationId.invalid": "Neva\u017Ee\u0107i identifikacijski k\xf4d banke (UK)",
            "bacs.consent.amount": "Sla\u017Eem se da se gore navedeni iznos oduzme s mog bankovnog ra\u010Duna.",
            "bacs.consent.account": "Potvr\u0111ujem da je ra\u010Dun na moje ime i da sam jedini potpisnik potreban za autorizaciju izravnog tere\u0107enja na ovom ra\u010Dunu.",
            edit: "Uredi",
            "bacs.confirm": "Potvrdi i plati",
            "bacs.result.introduction": "Preuzmite upute za izravno tere\u0107enje (DDI / mandat)",
            "download.pdf": "Preuzmite PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe za broj kartice",
            "creditCard.encryptedCardNumber.aria.label": "Broj kartice",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe za datum isteka",
            "creditCard.encryptedExpiryDate.aria.label": "Datum isteka",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe za mjesec isteka",
            "creditCard.encryptedExpiryMonth.aria.label": "Mjesec isteka",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe za godinu isteka",
            "creditCard.encryptedExpiryYear.aria.label": "Godina isteka",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe za sigurnosni k\xf4d",
            "creditCard.encryptedSecurityCode.aria.label": "Sigurnosni k\xf4d",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe za lozinku",
            "creditCard.encryptedPassword.aria.label": "Prve 2 znamenke lozinke kartice",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe za broj kartice",
            "giftcard.encryptedCardNumber.aria.label": "Broj kartice",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe za pin",
            "giftcard.encryptedSecurityCode.aria.label": "Pin",
            giftcardTransactionLimit: "Na ovoj je poklon-kartici maks. dopu\u0161teno %{amount} po transakciji",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe za broj bankovnog ra\u010Duna",
            "ach.encryptedBankAccountNumber.aria.label": "Broj ra\u010Duna",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe za bankovni broj usmjeravanja",
            "ach.encryptedBankLocationId.aria.label": "ABA identifikacijski broj",
            "twint.saved": "spremljeno",
            orPayWith: "ili platite s",
            invalidFormatExpects: "Neva\u017Ee\u0107i format. O\u010Dekivani format: %{format}",
            "upi.qrCodeWaitingMessage": "Skenirajte QR k\xf4d pomo\u0107u \u017Eeljene UPI aplikacije kako biste dovr\u0161ili pla\u0107anje",
            "upi.vpaWaitingMessage": "Otvorite svoju UPI aplikaciju kako biste potvrdili pla\u0107anje",
            "upi.modeSelection": "Odaberite kako \u017Eelite koristiti UPI.",
            "onlineBanking.termsAndConditions": "Nastavkom prihva\u0107ate %#uvjete i odredbe%#",
            "onlineBankingPL.termsAndConditions": "Nastavljanjem prihva\u0107ate %#propise%# i %#obvezu informiranja%# tvrtke Przelewy24",
            "ctp.loading.poweredByCtp": "Pokre\u0107e se uslugom Click to Pay",
            "ctp.loading.intro": "Provjeravamo imate li spremljenih kartica u sklopu usluge Click to Pay...",
            "ctp.login.title": "Nastavite na uslugu Click to Pay",
            "ctp.login.subtitle": "Za nastavak upi\u0161ite adresu e-po\u0161te koja je povezana s uslugom Click to Pay.",
            "ctp.login.inputLabel": "E-po\u0161ta",
            "ctp.logout.notYou": "Niste vi?",
            "ctp.logout.notYourCards": "Nisu va\u0161e kartice?",
            "ctp.logout.notYourCard": "Nije va\u0161a kartica?",
            "ctp.logout.notYourProfile": "Nije va\u0161 profil?",
            "ctp.otp.fieldLabel": "Jednokratni k\xf4d",
            "ctp.otp.resendCode": "Ponovno po\u0161alji k\xf4d",
            "ctp.otp.codeResent": "K\xf4d je ponovno poslan",
            "ctp.otp.title": "Pristupite svojim karticama za uslugu Click to Pay",
            "ctp.otp.subtitle": "Upi\u0161ite k\xf4d %@ koji smo poslali na %@ da bismo potvrdili da ste to vi.",
            "ctp.otp.saveCookiesCheckbox.label": "Sljede\u0107i puta presko\u010Di provjeru",
            "ctp.otp.saveCookiesCheckbox.information": "Odaberite kako biste bili zapam\u0107eni na svom ure\u0111aju i pregledniku u uklju\u010Denim trgovinama za br\u017Eu naplatu. Ne preporu\u010Duje se za zajedni\u010Dke ure\u0111aje.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Odaberite ako \u017Eelite da vas se zapamti na va\u0161em ure\u0111aju i pregledniku",
            "ctp.emptyProfile.message": "Nema kartica registriranih u sklopu ovog profila usluge Click to Pay",
            "ctp.separatorText": "ili upotrijebite",
            "ctp.cards.title": "Dovr\u0161i pla\u0107anje uslugom Click to Pay",
            "ctp.cards.subtitle": "Odaberite karticu za upotrebu.",
            "ctp.cards.expiredCard": "Istekla",
            "ctp.manualCardEntry": "Ru\u010Dni upis kartice",
            "ctp.aria.infoModalButton": "\u0160to je usluga Click to Pay",
            "ctp.infoPopup.title": "Uslugom Click to Pay nudi se jednostavnost mre\u017Enog beskontaktnog pla\u0107anja",
            "ctp.infoPopup.subtitle": "Brza i sigurna metoda pla\u0107anja koja se podr\u017Eava platnim karticama Mastercard, Visa i drugim.",
            "ctp.infoPopup.benefit1": "Uslugom Click to Pay upotrebljava se \u0161ifriranje da bi va\u0161i podatci bili sigurni i za\u0161ti\u0107eni",
            "ctp.infoPopup.benefit2": "Upotrebljavajte je za trgovce diljem svijeta",
            "ctp.infoPopup.benefit3": "Postavljanje obavite samo jednom za nesmetana pla\u0107anja u budu\u0107nosti",
            "ctp.errors.AUTH_INVALID": "Neva\u017Ee\u0107a provjera autenti\u010Dnosti",
            "ctp.errors.NOT_FOUND": "Ra\u010Dun nije prona\u0111en, upi\u0161ite valjanu adresu e-po\u0161te ili nastavite s ru\u010Dnim upisom kartice",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Nepodr\u017Ean format",
            "ctp.errors.FRAUD": "Korisni\u010Dki je ra\u010Dun zaklju\u010Dan ili onemogu\u0107en",
            "ctp.errors.CONSUMER_ID_MISSING": "Identitet potro\u0161a\u010Da nedostaje u zahtjevu",
            "ctp.errors.ACCT_INACCESSIBLE": "Ovaj ra\u010Dun trenuta\u010Dno nije dostupan, npr. zaklju\u010Dan je",
            "ctp.errors.CODE_INVALID": "Neispravan kontrolni k\xf4d",
            "ctp.errors.CODE_EXPIRED": "Ovaj je k\xf4d istekao",
            "ctp.errors.RETRIES_EXCEEDED": "Prekora\u010Deno je ograni\u010Denje broja ponovnih poku\u0161aja za stvaranje jednokratne lozinke",
            "ctp.errors.OTP_SEND_FAILED": "Jednokratna se lozinka nije mogla poslati primatelju",
            "ctp.errors.REQUEST_TIMEOUT": "Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010Dni upis kartice",
            "ctp.errors.UNKNOWN_ERROR": "Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010Dni upis kartice",
            "ctp.errors.SERVICE_ERROR": "Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010Dni upis kartice",
            "ctp.errors.SERVER_ERROR": "Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010Dni upis kartice",
            "ctp.errors.INVALID_PARAMETER": "Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010Dni upis kartice",
            "ctp.errors.AUTH_ERROR": "Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010Dni upis kartice",
            "paymentMethodsList.aria.label": "Odaberi na\u010Din pla\u0107anja",
            "companyDetails.name.invalid": "Unesite naziv tvrtke",
            "companyDetails.registrationNumber.invalid": "Unesite registracijski broj",
            "consent.checkbox.invalid": "Morate se slo\u017Eiti s odredbama i uvjetima",
            "form.instruction": "Sva su polja obavezna, osim ako nije druga\u010Dije ozna\u010Deno.",
            "trustly.descriptor": "Trenuta\u010Dno bankovno pla\u0107anje",
            "trustly.description1": "Pla\u0107ajte izravno s bilo kojeg od svojih bankovnih ra\u010Duna, uz sigurnost na razini banke",
            "trustly.description2": "Bez kartica, bez preuzimanja aplikacija, bez registracije",
            "ancv.input.label": "Va\u0161a ANCV identifikacija",
            "ancv.confirmPayment": "Koristite svoju ANCV aplikaciju za potvrdu pla\u0107anja.",
            "ancv.form.instruction": "Za potvrdu ove uplate neophodna je aplikacija Cheque-Vacances.",
            "ancv.beneficiaryId.invalid": "Unesite valjanu adresu e-po\u0161te ili ANCV ID",
            "payme.openPayMeApp": "Dovr\u0161ite pla\u0107anje u aplikaciji PayMe: autorizirajte pla\u0107anje u aplikaciji i pri\u010Dekajte potvrdu.",
            "payme.redirectButtonLabel": "Otvaranje aplikacije PayMe",
            "payme.scanQrCode": "Dovr\u0161ite svoje pla\u0107anja QR kodom",
            "payme.timeToPay": "Ovaj QR k\xf4d vrijedi za %@",
            "payme.instructions.steps": "Otvorite aplikaciju PayMe.%@Skenirajte QR kod za autorizaciju pla\u0107anja.%@Dovr\u0161ite pla\u0107anje u aplikaciji i pri\u010Dekajte potvrdu.",
            "payme.instructions.footnote": "Ne zatvarajte ovu stranicu prije nego \u0161to se pla\u0107anje zavr\u0161i"
        }
    }), T2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Fizet\xe9s",
            "payButton.redirecting": "\xc1tir\xe1ny\xedt\xe1s...",
            "payButton.with": "%{value} fizet\xe9se a k\xf6vetkez\u0151vel: %{maskedData}",
            "payButton.saveDetails": "R\xe9szletek ment\xe9se",
            close: "Bez\xe1r\xe1s",
            storeDetails: "Ment\xe9s a k\xf6vetkez\u0151 fizet\xe9shez",
            readMore: "B\u0151vebben",
            "creditCard.holderName": "A k\xe1rty\xe1n szerepl\u0151 n\xe9v",
            "creditCard.holderName.placeholder": "Gipsz Jakab",
            "creditCard.holderName.invalid": "Adja meg a k\xe1rty\xe1n szerepl\u0151 nevet",
            "creditCard.numberField.title": "K\xe1rtyasz\xe1m",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Lej\xe1rati d\xe1tum",
            "creditCard.expiryDateField.placeholder": "HH/\xc9\xc9",
            "creditCard.expiryDateField.month": "H\xf3nap",
            "creditCard.expiryDateField.month.placeholder": "HH",
            "creditCard.expiryDateField.year.placeholder": "\xc9\xc9",
            "creditCard.expiryDateField.year": "\xc9v",
            "creditCard.cvcField.title": "Biztons\xe1gi k\xf3d",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Megjegyz\xe9s a k\xf6vetkez\u0151 alkalomra",
            "creditCard.cvcField.placeholder.4digits": "4 sz\xe1mjegy\u0171",
            "creditCard.cvcField.placeholder.3digits": "3 sz\xe1mjegy\u0171",
            "creditCard.taxNumber.placeholder": "\xc9\xc9HHNN / 0123456789",
            installments: "R\xe9szletek sz\xe1ma",
            installmentOption: "%{times} x %{partialValue}",
            installmentOptionMonths: "%{times} h\xf3nap",
            "installments.oneTime": "Egy\xf6sszeg\u0171 fizet\xe9s",
            "installments.installments": "R\xe9szletfizet\xe9s",
            "installments.revolving": "T\xf6bb\xf6sszeg\u0171 fizet\xe9s",
            "sepaDirectDebit.ibanField.invalid": "\xc9rv\xe9nytelen sz\xe1mlasz\xe1m",
            "sepaDirectDebit.nameField.placeholder": "Gipsz Jakab",
            "sepa.ownerName": "Sz\xe1mlatulajdonos neve",
            "sepa.ibanNumber": "Sz\xe1mlasz\xe1m (IBAN)",
            "error.title": "Hiba",
            "error.subtitle.redirect": "Sikertelen \xe1tir\xe1ny\xedt\xe1s",
            "error.subtitle.payment": "Sikertelen fizet\xe9s",
            "error.subtitle.refused": "A fizet\xe9s elutas\xedtva",
            "error.message.unknown": "Ismeretlen hiba t\xf6rt\xe9nt",
            "errorPanel.title": "Megl\xe9v\u0151 hib\xe1k",
            "idealIssuer.selectField.title": "Bank",
            "idealIssuer.selectField.placeholder": "Bank kiv\xe1laszt\xe1sa",
            "creditCard.success": "Sikeres fizet\xe9s",
            loading: "Bet\xf6lt\xe9s\u2026",
            continue: "Folytat\xe1s",
            continueTo: "Folytat\xe1s a k\xf6vetkez\u0151vel:",
            "wechatpay.timetopay": "Fizet\xe9shez rendelkez\xe9sre \xe1ll\xf3 id\u0151: %@",
            "sr.wechatpay.timetopay": "Fizet\xe9sre rendelkez\xe9sre \xe1ll\xf3 id\u0151: %#perc%# %#m\xe1sodperc%#",
            "wechatpay.scanqrcode": "QR-k\xf3d beolvas\xe1sa",
            personalDetails: "Szem\xe9lyes adatok",
            companyDetails: "C\xe9g adatai",
            "companyDetails.name": "C\xe9gn\xe9v",
            "companyDetails.registrationNumber": "C\xe9gjegyz\xe9ksz\xe1m",
            socialSecurityNumber: "Szem\xe9lyi igazolv\xe1ny sz\xe1ma",
            firstName: "Keresztn\xe9v",
            "firstName.invalid": "Adja meg a keresztnev\xe9t",
            infix: "El\u0151tag",
            lastName: "Vezet\xe9kn\xe9v",
            "lastName.invalid": "Adja meg a vezet\xe9knev\xe9t",
            mobileNumber: "Mobiltelefonsz\xe1m",
            "mobileNumber.invalid": "\xc9rv\xe9nytelen mobilsz\xe1m",
            city: "V\xe1ros",
            postalCode: "Ir\xe1ny\xedt\xf3sz\xe1m",
            "postalCode.optional": "Ir\xe1ny\xedt\xf3sz\xe1m (nem k\xf6telez\u0151)",
            countryCode: "Orsz\xe1gk\xf3d",
            telephoneNumber: "Telefonsz\xe1m",
            dateOfBirth: "Sz\xfclet\xe9si d\xe1tum",
            shopperEmail: "E-mail-c\xedm",
            gender: "Nem",
            "gender.notselected": "V\xe1lassza ki a nem\xe9t",
            male: "F\xe9rfi",
            female: "N\u0151",
            billingAddress: "Sz\xe1ml\xe1z\xe1si c\xedm",
            street: "Utca",
            stateOrProvince: "\xc1llam vagy tartom\xe1ny",
            country: "Orsz\xe1g/r\xe9gi\xf3",
            houseNumberOrName: "H\xe1zsz\xe1m",
            separateDeliveryAddress: "Elt\xe9r\u0151 sz\xe1ll\xedt\xe1si c\xedm megad\xe1sa",
            deliveryAddress: "Sz\xe1ll\xedt\xe1si c\xedm",
            "deliveryAddress.firstName": "C\xedmzett keresztneve",
            "deliveryAddress.lastName": "C\xedmzett vezet\xe9kneve",
            zipCode: "Ir\xe1ny\xedt\xf3sz\xe1m",
            apartmentSuite: "Lak\xe1s/ajt\xf3sz\xe1m",
            provinceOrTerritory: "Tartom\xe1ny vagy ter\xfclet",
            cityTown: "V\xe1ros",
            address: "C\xedm",
            "address.placeholder": "Keresse meg a c\xedm\xe9t",
            "address.errors.incomplete": "A folytat\xe1shoz \xedrjon be egy c\xedmet",
            "address.enterManually": "Manu\xe1lisan \xedrjon be egy c\xedmet",
            state: "\xc1llam",
            "field.title.optional": "(nem k\xf6telez\u0151)",
            "creditCard.cvcField.title.optional": "Biztons\xe1gi k\xf3d (nem k\xf6telez\u0151)",
            "issuerList.wallet.placeholder": "P\xe9nzt\xe1rca kiv\xe1laszt\xe1sa",
            privacyPolicy: "Adatv\xe9delmi szab\xe1lyzat",
            "afterPay.agreement": "Elfogadom a k\xf6vetkez\u0151t: Riverty %@",
            paymentConditions: "fizet\xe9si felt\xe9teleit",
            openApp: "Alkalmaz\xe1s megnyit\xe1sa",
            "voucher.readInstructions": "Olvassa el az utas\xedt\xe1sokat",
            "voucher.introduction": "K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 kupont.",
            "voucher.expirationDate": "Lej\xe1rati d\xe1tum",
            "voucher.alternativeReference": "Alternat\xedv hivatkoz\xe1s",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Szolg\xe1ltat\xf3 kiv\xe1laszt\xe1sa",
            "dragonpay.voucher.bank.selectField.placeholder": "Bank kiv\xe1laszt\xe1sa",
            "voucher.paymentReferenceLabel": "Fizet\xe9si referencia",
            "voucher.surcharge": "%@ p\xf3td\xedjat tartalmaz",
            "voucher.introduction.doku": "K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.",
            "voucher.shopperName": "V\xe1s\xe1rl\xf3 neve",
            "voucher.merchantName": "Keresked\u0151",
            "voucher.introduction.econtext": "K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.",
            "voucher.telephoneNumber": "Telefonsz\xe1m",
            "voucher.shopperReference": "V\xe1s\xe1rl\xf3i referencia",
            "voucher.collectionInstitutionNumber": "Beszed\u0151 c\xe9g sz\xe1ma",
            "voucher.econtext.telephoneNumber.invalid": "A telefonsz\xe1mnak 10 vagy 11 sz\xe1mjegyb\u0151l kell \xe1llnia",
            "boletobancario.btnLabel": "Boleto l\xe9trehoz\xe1sa",
            "boleto.sendCopyToEmail": "M\xe1solat k\xfcld\xe9se az e-mail-c\xedmemre",
            "button.copy": "M\xe1sol\xe1s",
            "button.download": "Let\xf6lt\xe9s",
            "boleto.socialSecurityNumber.invalid": "Adjon meg egy \xe9rv\xe9nyes CPF-/CNPJ-sz\xe1mot",
            "creditCard.storedCard.description.ariaLabel": "A t\xe1rolt k\xe1rtya sz\xe1m\xe1nak v\xe9gz\u0151d\xe9se: %@",
            "voucher.entity": "Entit\xe1s",
            donateButton: "Adom\xe1nyoz\xe1s",
            notNowButton: "Most nem",
            thanksForYourSupport: "K\xf6sz\xf6nj\xfck a t\xe1mogat\xe1s\xe1t!",
            "resultMessages.preauthorized": "R\xe9szletek mentve",
            preauthorizeWith: "El\u0151zetes meghatalmaz\xe1s a k\xf6vetkez\u0151vel:",
            confirmPreauthorization: "El\u0151zetes meghatalmaz\xe1s j\xf3v\xe1hagy\xe1sa",
            confirmPurchase: "Fizet\xe9s j\xf3v\xe1hagy\xe1sa",
            applyGiftcard: "Bev\xe1lt\xe1s",
            giftcardBalance: "Aj\xe1nd\xe9kk\xe1rtya egyenlege",
            deductedBalance: "Levont egyenleg",
            "creditCard.pin.title": "PIN-k\xf3d",
            "creditCard.encryptedPassword.label": "K\xe1rtya jelszav\xe1nak els\u0151 2 sz\xe1mjegye",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "\xc9rv\xe9nytelen jelsz\xf3",
            "creditCard.taxNumber": "K\xe1rtyatulajdonos sz\xfclet\xe9si d\xe1tuma vagy c\xe9gjegyz\xe9ksz\xe1m",
            "creditCard.taxNumber.label": "K\xe1rtyatulajdonos sz\xfclet\xe9si d\xe1tuma (\xc9\xc9HHNN) vagy c\xe9gjegyz\xe9ksz\xe1m (10 sz\xe1mjegy\u0171)",
            "creditCard.taxNumber.labelAlt": "C\xe9gjegyz\xe9ksz\xe1m (10 sz\xe1mjegy\u0171)",
            "creditCard.taxNumber.invalid": "A k\xe1rtyatulajdonos sz\xfclet\xe9si d\xe1tuma vagy a c\xe9gjegyz\xe9ksz\xe1m \xe9rv\xe9nytelen",
            "storedPaymentMethod.disable.button": "Elt\xe1vol\xedt\xe1s",
            "storedPaymentMethod.disable.confirmation": "T\xe1rolt fizet\xe9si m\xf3d elt\xe1vol\xedt\xe1sa",
            "storedPaymentMethod.disable.confirmButton": "Igen, elt\xe1vol\xedtom",
            "storedPaymentMethod.disable.cancelButton": "M\xe9gse",
            "ach.bankAccount": "Banksz\xe1mla",
            "ach.accountHolderNameField.title": "Sz\xe1mlatulajdonos neve",
            "ach.accountHolderNameField.placeholder": "Gipsz Jakab",
            "ach.accountHolderNameField.invalid": "A sz\xe1mlatulajdonos neve \xe9rv\xe9nytelen",
            "ach.accountNumberField.title": "Sz\xe1mlasz\xe1m",
            "ach.accountNumberField.invalid": "\xc9rv\xe9nytelen sz\xe1mlasz\xe1m",
            "ach.accountLocationField.title": "ABA-ir\xe1ny\xedt\xf3sz\xe1m",
            "ach.accountLocationField.invalid": "\xc9rv\xe9nytelen ABA-ir\xe1ny\xedt\xf3sz\xe1m",
            "ach.savedBankAccount": "Mentett banksz\xe1mla",
            "select.state": "\xc1llam kiv\xe1laszt\xe1sa",
            "select.stateOrProvince": "\xc1llam vagy tartom\xe1ny kiv\xe1laszt\xe1sa",
            "select.provinceOrTerritory": "Tartom\xe1ny vagy ter\xfclet kiv\xe1laszt\xe1sa",
            "select.country": "Orsz\xe1g/r\xe9gi\xf3 kiv\xe1laszt\xe1sa",
            "select.noOptionsFound": "Nincsenek tal\xe1latok",
            "select.filter.placeholder": "Keres\xe9s...",
            "telephoneNumber.invalid": "\xc9rv\xe9nytelen telefonsz\xe1m",
            qrCodeOrApp: "vagy",
            "paypal.processingPayment": "Fizet\xe9s feldolgoz\xe1sa\u2026",
            generateQRCode: "QR-k\xf3d l\xe9trehoz\xe1sa",
            "await.waitForConfirmation": "V\xe1rakoz\xe1s a j\xf3v\xe1hagy\xe1sra",
            "mbway.confirmPayment": "Fizet\xe9s j\xf3v\xe1hagy\xe1sa az MB WAY alkalmaz\xe1sban",
            "shopperEmail.invalid": "\xc9rv\xe9nytelen e-mail-c\xedm",
            "dateOfBirth.format": "NN/HH/\xc9\xc9\xc9\xc9",
            "dateOfBirth.invalid": "Adjon meg egy \xe9rv\xe9nyes sz\xfclet\xe9si d\xe1tumot, amelyb\u0151l kider\xfcl, hogy elm\xfalt 18 \xe9ves",
            "blik.confirmPayment": "A fizet\xe9s j\xf3v\xe1hagy\xe1s\xe1hoz nyissa meg a banki alkalmaz\xe1st.",
            "blik.invalid": "Adjon meg 6 sz\xe1mjegyet",
            "blik.code": "6 sz\xe1mjegy\u0171 k\xf3d",
            "blik.help": "K\xf3d lek\xe9r\xe9se a banki alkalmaz\xe1sb\xf3l.",
            "swish.pendingMessage": "A QR-k\xf3d beolvas\xe1s\xe1t k\xf6vet\u0151en az \xe1llapot ak\xe1r 10 percig is f\xfcgg\u0151ben lehet. Ha ek\xf6zben \xfajb\xf3l fizet\xe9st k\xeds\xe9rel meg, az t\xf6bbsz\xf6ri fizet\xe9st eredm\xe9nyezhet.",
            "field.valid": "\xc9rv\xe9nyes mez\u0151",
            "field.invalid": "\xc9rv\xe9nytelen mez\u0151",
            "error.va.gen.01": "Hi\xe1nyos mez\u0151",
            "error.va.gen.02": "\xc9rv\xe9nytelen mez\u0151",
            "error.va.sf-cc-num.01": "Adjon meg egy \xe9rv\xe9nyes k\xe1rtyasz\xe1mot",
            "error.va.sf-cc-num.02": "Adja meg a k\xe1rtya sz\xe1m\xe1t",
            "error.va.sf-cc-num.03": "Adjon meg egy elfogadott k\xe1rtyakibocs\xe1t\xf3t",
            "error.va.sf-cc-num.04": "Adja meg a teljes k\xe1rtyasz\xe1mot",
            "error.va.sf-cc-dat.01": "Adjon meg egy \xe9rv\xe9nyes lej\xe1rati d\xe1tumot",
            "error.va.sf-cc-dat.02": "Adjon meg egy \xe9rv\xe9nyes lej\xe1rati d\xe1tumot",
            "error.va.sf-cc-dat.03": "Hamarosan lej\xe1r\xf3 hitelk\xe1rtya",
            "error.va.sf-cc-dat.04": "Adja meg a lej\xe1rati d\xe1tumot",
            "error.va.sf-cc-dat.05": "Adja meg a teljes lej\xe1rati d\xe1tumot",
            "error.va.sf-cc-mth.01": "Adja meg a lej\xe1rati h\xf3napot",
            "error.va.sf-cc-yr.01": "Adja meg a lej\xe1rat \xe9vet",
            "error.va.sf-cc-yr.02": "Adja meg a teljes lej\xe1rati \xe9vet",
            "error.va.sf-cc-cvc.01": "Adja meg a biztons\xe1gi k\xf3dot",
            "error.va.sf-cc-cvc.02": "Adja meg a teljes biztons\xe1gi k\xf3dot",
            "error.va.sf-ach-num.01": "A banksz\xe1mlasz\xe1m mez\u0151je \xfcres",
            "error.va.sf-ach-num.02": "A banksz\xe1mlasz\xe1m nem megfelel\u0151 hossz\xfas\xe1g\xfa",
            "error.va.sf-ach-loc.01": "A bankazonos\xedt\xf3 k\xf3d mez\u0151je \xfcres",
            "error.va.sf-ach-loc.02": "A bankazonos\xedt\xf3 k\xf3d nem megfelel\u0151 hossz\xfas\xe1g\xfa",
            "error.va.sf-kcp-pwd.01": "A jelsz\xf3 mez\u0151je \xfcres",
            "error.va.sf-kcp-pwd.02": "A jelsz\xf3 nem megfelel\u0151 hossz\xfas\xe1g\xfa",
            "error.giftcard.no-balance": "Az aj\xe1nd\xe9kk\xe1rtya egyenlege nulla",
            "error.giftcard.card-error": "Nyilv\xe1ntart\xe1sunkban nem szerepel ilyen sz\xe1m\xfa aj\xe1nd\xe9kk\xe1rtya",
            "error.giftcard.currency-error": "Az aj\xe1nd\xe9kk\xe1rty\xe1k csak abban a p\xe9nznemben \xe9rv\xe9nyesek, amelyre ki\xe1ll\xedtott\xe1k azokat",
            "amazonpay.signout": "Kijelentkez\xe9s az Amazonr\xf3l",
            "amazonpay.changePaymentDetails": "Fizet\xe9si adatok m\xf3dos\xedt\xe1sa",
            "partialPayment.warning": "M\xe1sik fizet\xe9si m\xf3d v\xe1laszt\xe1sa a fennmarad\xf3 r\xe9sz fizet\xe9s\xe9hez",
            "partialPayment.remainingBalance": "A fennmarad\xf3 egyenleg %{amount} lesz",
            "bankTransfer.beneficiary": "Kedvezm\xe9nyezett",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Referencia",
            "bankTransfer.introduction": "Folytassa, hogy elind\xedtson egy \xfaj banki \xe1tutal\xe1sos fizet\xe9st. A fizet\xe9s v\xe9gleges\xedt\xe9s\xe9hez felhaszn\xe1lhatja a k\xf6vetkez\u0151 k\xe9perny\u0151n megjelen\u0151 adatokat.",
            "bankTransfer.instructions": "K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.",
            "bacs.accountHolderName": "Banksz\xe1mla-tulajdonos neve",
            "bacs.accountHolderName.invalid": "A banksz\xe1mla-tulajdonos neve \xe9rv\xe9nytelen",
            "bacs.accountNumber": "Banksz\xe1mlasz\xe1m",
            "bacs.accountNumber.invalid": "\xc9rv\xe9nytelen banksz\xe1mlasz\xe1m",
            "bacs.bankLocationId": "Banki azonos\xedt\xf3",
            "bacs.bankLocationId.invalid": "\xc9rv\xe9nytelen banki azonos\xedt\xf3",
            "bacs.consent.amount": "Elfogadom, hogy a fenti \xf6sszeget levonj\xe1k a banksz\xe1ml\xe1mr\xf3l.",
            "bacs.consent.account": "Meger\u0151s\xedtem, hogy a banksz\xe1mla az \xe9n nevemen van, \xe9s \xe9n vagyok a banksz\xe1ml\xe1t \xe9rint\u0151 beszed\xe9si megb\xedz\xe1s j\xf3v\xe1hagy\xe1s\xe1hoz sz\xfcks\xe9ges egyetlen al\xe1\xedr\xf3.",
            edit: "Szerkeszt\xe9s",
            "bacs.confirm": "Meger\u0151s\xedt\xe9s \xe9s fizet\xe9s",
            "bacs.result.introduction": "Beszed\xe9si megb\xedz\xe1si utas\xedt\xe1s (meghatalmaz\xe1s) let\xf6lt\xe9se",
            "download.pdf": "PDF let\xf6lt\xe9se",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe a k\xe1rtyasz\xe1mhoz",
            "creditCard.encryptedCardNumber.aria.label": "K\xe1rtyasz\xe1m",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe a lej\xe1rati d\xe1tumhoz",
            "creditCard.encryptedExpiryDate.aria.label": "Lej\xe1rati d\xe1tum",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe a lej\xe1rati h\xf3naphoz",
            "creditCard.encryptedExpiryMonth.aria.label": "Lej\xe1rati h\xf3nap",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe a lej\xe1rati \xe9vhez",
            "creditCard.encryptedExpiryYear.aria.label": "Lej\xe1rati \xe9v",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe a biztons\xe1gi k\xf3dhoz",
            "creditCard.encryptedSecurityCode.aria.label": "Biztons\xe1gi k\xf3d",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe a jelsz\xf3hoz",
            "creditCard.encryptedPassword.aria.label": "K\xe1rtya jelszav\xe1nak els\u0151 2 sz\xe1mjegye",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe a k\xe1rtyasz\xe1mhoz",
            "giftcard.encryptedCardNumber.aria.label": "K\xe1rtyasz\xe1m",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe a PIN-k\xf3dhoz",
            "giftcard.encryptedSecurityCode.aria.label": "PIN-k\xf3d",
            giftcardTransactionLimit: "Ezen az aj\xe1nd\xe9kk\xe1rty\xe1n a tranzakci\xf3nk\xe9nt enged\xe9lyezett maxim\xe1lis \xf6sszeg %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe a banksz\xe1mlasz\xe1mhoz",
            "ach.encryptedBankAccountNumber.aria.label": "Sz\xe1mlasz\xe1m",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe a bankazonos\xedt\xf3 k\xf3dhoz",
            "ach.encryptedBankLocationId.aria.label": "ABA-ir\xe1ny\xedt\xf3sz\xe1m",
            "twint.saved": "mentve",
            orPayWith: "vagy fizessen ezzel:",
            invalidFormatExpects: "\xc9rv\xe9nytelen form\xe1tum. V\xe1rt form\xe1tum: %{format}",
            "upi.qrCodeWaitingMessage": "A fizet\xe9s befejez\xe9s\xe9hez olvassa be a QR-k\xf3dot a k\xedv\xe1nt UPI-alkalmaz\xe1ssal",
            "upi.vpaWaitingMessage": "A fizet\xe9s meger\u0151s\xedt\xe9s\xe9hez nyissa meg UPI-alkalmaz\xe1st",
            "upi.modeSelection": "Jel\xf6lje meg, hogyan szeretn\xe9 haszn\xe1lni az UPI-t.",
            "onlineBanking.termsAndConditions": "A folytat\xe1ssal elfogadja az %#\xe1ltal\xe1nos szerz\u0151d\xe9si felt\xe9teleket%#",
            "onlineBankingPL.termsAndConditions": "A folytat\xe1ssal elfogadja a Przelewy24 %#szab\xe1lyait%# \xe9s %#t\xe1j\xe9koztat\xe1si k\xf6telezetts\xe9g\xe9t%#",
            "ctp.loading.poweredByCtp": "Szolg\xe1ltat\xf3: Click to Pay",
            "ctp.loading.intro": "Ellen\u0151rizz\xfck, hogy van-e mentett Click\xa0to\xa0Pay-k\xe1rty\xe1ja\u2026",
            "ctp.login.title": "Tov\xe1bb a Click to Pay fel\xfclet\xe9re",
            "ctp.login.subtitle": "A folytat\xe1shoz adja meg a Click to Payhez kapcsol\xf3d\xf3 e-mail-c\xedmet.",
            "ctp.login.inputLabel": "E-mail-c\xedm",
            "ctp.logout.notYou": "Nem \xd6n az?",
            "ctp.logout.notYourCards": "Nem az \xd6n k\xe1rty\xe1i?",
            "ctp.logout.notYourCard": "Nem az \xd6n k\xe1rty\xe1ja?",
            "ctp.logout.notYourProfile": "Nem az \xd6n profilja?",
            "ctp.otp.fieldLabel": "Egyszeri k\xf3d",
            "ctp.otp.resendCode": "K\xf3d \xfajrak\xfcld\xe9se",
            "ctp.otp.codeResent": "K\xf3d \xfajrak\xfcldve",
            "ctp.otp.title": "Hozz\xe1f\xe9r\xe9s a Click to Pay-k\xe1rty\xe1ihoz",
            "ctp.otp.subtitle": "\xcdrja be a k\xf3dot, amit a(z) %@ k\xfcld\xf6tt %@ r\xe9sz\xe9re ellen\u0151rz\xe9s c\xe9lj\xe1b\xf3l.",
            "ctp.otp.saveCookiesCheckbox.label": "Ellen\u0151rz\xe9s kihagy\xe1sa a k\xf6vetkez\u0151 alkalommal",
            "ctp.otp.saveCookiesCheckbox.information": "Jel\xf6lje be, hogy a r\xe9sztvev\u0151 \xfczletek a gyorsabb fizet\xe9s \xe9rdek\xe9ben eml\xe9kezzenek az eszk\xf6zre \xe9s a b\xf6ng\xe9sz\u0151re. Megosztott eszk\xf6z\xf6k eset\xe9n nem aj\xe1nlott.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Jel\xf6lje be, hogy a rendszer eml\xe9kezzen az eszk\xf6zre \xe9s a b\xf6ng\xe9sz\u0151re",
            "ctp.emptyProfile.message": "Ebben a Click to Pay-profilban nincs regisztr\xe1lt k\xe1rtya",
            "ctp.separatorText": "vagy haszn\xe1lja a k\xf6vetkez\u0151t",
            "ctp.cards.title": "Fizet\xe9s Click to Pay haszn\xe1lat\xe1val",
            "ctp.cards.subtitle": "V\xe1lassza ki a haszn\xe1lni k\xedv\xe1nt k\xe1rty\xe1t.",
            "ctp.cards.expiredCard": "Lej\xe1rt",
            "ctp.manualCardEntry": "K\xe1rtya adatainak k\xe9zi megad\xe1sa",
            "ctp.aria.infoModalButton": "Mi az a Click to Pay",
            "ctp.infoPopup.title": "A Click to Pay megk\xf6nny\xedti az \xe9rint\xe9s n\xe9lk\xfcli online fizet\xe9st",
            "ctp.infoPopup.subtitle": "A Mastercard, a Visa \xe9s m\xe1s fizet\xe9si k\xe1rty\xe1k \xe1ltal t\xe1mogatott gyors \xe9s biztons\xe1gos fizet\xe9si m\xf3d.",
            "ctp.infoPopup.benefit1": "A Click to Pay az adatok biztons\xe1ga \xe9rdek\xe9ben titkos\xedt\xe1st haszn\xe1l",
            "ctp.infoPopup.benefit2": "Vil\xe1gszerte haszn\xe1lhat\xf3 a keresked\u0151kn\xe9l",
            "ctp.infoPopup.benefit3": "Egyszer kell be\xe1ll\xedtani, hogy a j\xf6v\u0151ben probl\xe9mamentesen fizethessen",
            "ctp.errors.AUTH_INVALID": "\xc9rv\xe9nytelen hiteles\xedt\xe9s",
            "ctp.errors.NOT_FOUND": "Nem tal\xe1lhat\xf3 fi\xf3k, adjon meg egy \xe9rv\xe9nyes e-mail-c\xedmet, vagy folytassa a k\xe1rtyaadatok manu\xe1lis bevitel\xe9vel",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Nem t\xe1mogatott form\xe1tum",
            "ctp.errors.FRAUD": "A felhaszn\xe1l\xf3i fi\xf3k z\xe1rolva volt vagy le volt tiltva",
            "ctp.errors.CONSUMER_ID_MISSING": "A k\xe9r\xe9sb\u0151l hi\xe1nyzik az \xfcgyf\xe9l-azonos\xedt\xf3",
            "ctp.errors.ACCT_INACCESSIBLE": "A fi\xf3k jelenleg nem \xe9rhet\u0151 el, pl. az\xe9rt, mert z\xe1rolva van",
            "ctp.errors.CODE_INVALID": "Helytelen ellen\u0151rz\u0151 k\xf3d",
            "ctp.errors.CODE_EXPIRED": "A k\xf3d lej\xe1rt",
            "ctp.errors.RETRIES_EXCEEDED": "T\xfall\xe9pte az egyszeri jelsz\xf3 l\xe9trehoz\xe1s\xe1ra tett lehets\xe9ges pr\xf3b\xe1lkoz\xe1sok maxim\xe1lis sz\xe1m\xe1t",
            "ctp.errors.OTP_SEND_FAILED": "Az egyszeri jelsz\xf3t nem siker\xfclt elk\xfcldeni a c\xedmzettnek",
            "ctp.errors.REQUEST_TIMEOUT": "Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan vigye be a k\xe1rty\xe1t",
            "ctp.errors.UNKNOWN_ERROR": "Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan adja meg a k\xe1rtyaadatokat",
            "ctp.errors.SERVICE_ERROR": "Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan adja meg a k\xe1rtyaadatokat",
            "ctp.errors.SERVER_ERROR": "Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan adja meg a k\xe1rtyaadatokat",
            "ctp.errors.INVALID_PARAMETER": "Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan adja meg a k\xe1rtyaadatokat",
            "ctp.errors.AUTH_ERROR": "Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan adja meg a k\xe1rtyaadatokat",
            "paymentMethodsList.aria.label": "V\xe1lasszon fizet\xe9si m\xf3dot",
            "companyDetails.name.invalid": "Adja meg a c\xe9g nev\xe9t",
            "companyDetails.registrationNumber.invalid": "Adja meg a c\xe9gjegyz\xe9ksz\xe1mot",
            "consent.checkbox.invalid": "El kell fogadnia az \xe1ltal\xe1nos szerz\u0151d\xe9si felt\xe9teleket",
            "form.instruction": "Minden mez\u0151 kit\xf6lt\xe9se k\xf6telez\u0151, hacsak nincs m\xe1sk\xe9pp jel\xf6lve.",
            "trustly.descriptor": "Azonnali banki fizet\xe9s",
            "trustly.description1": "Fizessen k\xf6zvetlen\xfcl b\xe1rmelyik banksz\xe1ml\xe1j\xe1r\xf3l, banki szint\u0171 biztons\xe1g mellett",
            "trustly.description2": "Nincs sz\xfcks\xe9g k\xe1rty\xe1ra, alkalmaz\xe1s let\xf6lt\xe9s\xe9re \xe9s regisztr\xe1ci\xf3ra",
            "ancv.input.label": "Az \xd6n ANCV-azonos\xedt\xf3ja",
            "ancv.confirmPayment": "A fizet\xe9s meger\u0151s\xedt\xe9s\xe9hez haszn\xe1lja az ANCV alkalmaz\xe1st.",
            "ancv.form.instruction": "A fizet\xe9s \xe9rv\xe9nyes\xedt\xe9s\xe9hez a Cheque-Vacances alkalmaz\xe1s sz\xfcks\xe9ges.",
            "ancv.beneficiaryId.invalid": "Adjon meg egy \xe9rv\xe9nyes e-mail-c\xedmet vagy ANCV-azonos\xedt\xf3t",
            "payme.openPayMeApp": "A fizet\xe9snek a PayMe alkalmaz\xe1sban val\xf3 enged\xe9lyez\xe9s\xe9vel hajtsa v\xe9gre a fizet\xe9st, \xe9s v\xe1rja meg a visszaigazol\xe1st.",
            "payme.redirectButtonLabel": "PayMe alkalmaz\xe1s megnyit\xe1sa",
            "payme.scanQrCode": "Fizet\xe9s v\xe9grehajt\xe1sa QR-k\xf3ddal",
            "payme.timeToPay": "A QR-k\xf3d ennyi ideig \xe9rv\xe9nyes: %@",
            "payme.instructions.steps": "Nyissa meg a PayMe alkalmaz\xe1st.%@A fizet\xe9s enged\xe9lyez\xe9s\xe9hez olvassa be a QR-k\xf3dot.%@Hajtsa v\xe9gre a fizet\xe9st az alkalmaz\xe1sban, \xe9s v\xe1rja meg a visszaigazol\xe1st.",
            "payme.instructions.footnote": "A fizet\xe9s befejez\xe9se el\u0151tt ne z\xe1rja be ezt az oldalt"
        }
    }), z2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Paga",
            "payButton.redirecting": "Reindirizzamento...",
            "payButton.with": "Paga %{value} con %{maskedData}",
            "payButton.saveDetails": "Salva dettagli",
            close: "Chiudi",
            storeDetails: "Salva per il prossimo pagamento",
            readMore: "Leggi di pi\xf9",
            "creditCard.holderName": "Titolare carta",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "Immetti il nome riportato sulla carta",
            "creditCard.numberField.title": "Numero carta",
            "creditCard.expiryDateField.title": "Data di scadenza",
            "creditCard.expiryDateField.placeholder": "MM/AA",
            "creditCard.expiryDateField.month": "Mese",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "AA",
            "creditCard.expiryDateField.year": "Anno",
            "creditCard.cvcField.title": "Codice di sicurezza",
            "creditCard.storeDetailsButton": "Ricorda per la prossima volta",
            "creditCard.cvcField.placeholder.4digits": "4 cifre",
            "creditCard.cvcField.placeholder.3digits": "3 cifre",
            "creditCard.taxNumber.placeholder": "AAMMGG/0123456789",
            installments: "Numero di rate",
            installmentOption: "%{partialValue} x%{times}",
            installmentOptionMonths: "%{times} mesi",
            "installments.oneTime": "Pagamento una tantum",
            "installments.installments": "Pagamento rateale",
            "installments.revolving": "Pagamento ricorrente",
            "sepaDirectDebit.ibanField.invalid": "Numero di conto non valido",
            "sepaDirectDebit.nameField.placeholder": "A. Bianchi",
            "sepa.ownerName": "Nome Intestatario Conto",
            "sepa.ibanNumber": "Numero di conto (IBAN)",
            "error.title": "Errore",
            "error.subtitle.redirect": "Reindirizzamento non riuscito",
            "error.subtitle.payment": "Pagamento non riuscito",
            "error.subtitle.refused": "Pagamento respinto",
            "error.message.unknown": "Si \xe8 verificato un errore sconosciuto",
            "errorPanel.title": "Errori presenti",
            "idealIssuer.selectField.title": "Banca",
            "idealIssuer.selectField.placeholder": "Seleziona la banca",
            "creditCard.success": "Pagamento riuscito",
            loading: "Caricamento in corso...",
            continue: "Continua",
            continueTo: "Procedi verso",
            "wechatpay.timetopay": "Devi pagare %@",
            "sr.wechatpay.timetopay": "Hai %#minuti%# %#secondi%# per pagare",
            "wechatpay.scanqrcode": "Scansiona il codice QR",
            personalDetails: "Dati personali",
            companyDetails: "Informazioni dell'azienda",
            "companyDetails.name": "Ragione sociale",
            "companyDetails.registrationNumber": "Numero di registrazione",
            socialSecurityNumber: "Numero di previdenza sociale",
            firstName: "Nome",
            "firstName.invalid": "Immetti il tuo nome",
            infix: "Prefisso",
            lastName: "Cognome",
            "lastName.invalid": "Immetti il tuo cognome",
            mobileNumber: "Numero di cellulare",
            "mobileNumber.invalid": "Numero di cellulare non valido",
            city: "Citt\xe0",
            postalCode: "Codice postale",
            "postalCode.optional": "Codice postale (facoltativo)",
            countryCode: "Codice nazionale",
            telephoneNumber: "Numero di telefono",
            dateOfBirth: "Data di nascita",
            shopperEmail: "Indirizzo e-mail",
            gender: "Sesso",
            "gender.notselected": "Seleziona il tuo sesso",
            male: "Uomo",
            female: "Donna",
            billingAddress: "Indirizzo di fatturazione",
            street: "Via",
            stateOrProvince: "Stato o provincia",
            country: "Paese/Regione",
            houseNumberOrName: "Numero civico",
            separateDeliveryAddress: "Specifica un indirizzo di consegna alternativo",
            deliveryAddress: "Indirizzo di consegna",
            "deliveryAddress.firstName": "Nome del destinatario",
            "deliveryAddress.lastName": "Cognome del destinatario",
            zipCode: "CAP",
            apartmentSuite: "Appartamento/suite",
            provinceOrTerritory: "Provincia o territorio",
            cityTown: "Citt\xe0",
            address: "Indirizzo",
            "address.placeholder": "Trova il tuo indirizzo",
            "address.errors.incomplete": "Inserisci un indirizzo per continuare",
            "address.enterManually": "Inserisci l'indirizzo manualmente",
            state: "Stato",
            "field.title.optional": "(facoltativo)",
            "creditCard.cvcField.title.optional": "Codice di sicurezza (facoltativo)",
            "issuerList.wallet.placeholder": "Seleziona il tuo portafoglio",
            privacyPolicy: "Informativa sulla privacy",
            "afterPay.agreement": "Accetto i %@ di Riverty",
            paymentConditions: "termini di pagamento",
            openApp: "Apri l'app",
            "voucher.readInstructions": "Leggi le istruzioni",
            "voucher.introduction": "Grazie per il tuo acquisto, utilizza il seguente coupon per completare il pagamento.",
            "voucher.expirationDate": "Data di scadenza",
            "voucher.alternativeReference": "Riferimento alternativo",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Seleziona il tuo fornitore",
            "dragonpay.voucher.bank.selectField.placeholder": "Seleziona la banca",
            "voucher.paymentReferenceLabel": "Riferimento del pagamento",
            "voucher.surcharge": "Include un sovrapprezzo di %@",
            "voucher.introduction.doku": "Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.",
            "voucher.shopperName": "Nome dell'acquirente",
            "voucher.merchantName": "Esercente",
            "voucher.introduction.econtext": "Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.",
            "voucher.telephoneNumber": "Numero di telefono",
            "voucher.shopperReference": "Riferimento dell'acquirente",
            "voucher.collectionInstitutionNumber": "Codice identificativo del negozio",
            "voucher.econtext.telephoneNumber.invalid": "Il numero di telefono deve essere di 10 o 11 cifre",
            "boletobancario.btnLabel": "Genera Boleto",
            "boleto.sendCopyToEmail": "Invia una copia alla mia e-mail",
            "button.copy": "Copia",
            "button.download": "Scarica",
            "boleto.socialSecurityNumber.invalid": "Immetti un numero CPF/CNPJ valido",
            "creditCard.storedCard.description.ariaLabel": "La carta memorizzata termina in %@",
            "voucher.entity": "Entit\xe0",
            donateButton: "Dona",
            notNowButton: "Non ora",
            thanksForYourSupport: "Grazie per il tuo sostegno!",
            "resultMessages.preauthorized": "Dettagli salvati",
            preauthorizeWith: "Preautorizza con",
            confirmPreauthorization: "Conferma preautorizzazione",
            confirmPurchase: "Conferma acquisto",
            applyGiftcard: "Riscatta",
            giftcardBalance: "Saldo del buono",
            deductedBalance: "Importo detratto",
            "creditCard.pin.title": "Pin",
            "creditCard.encryptedPassword.label": "Prime 2 cifre della password della carta",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Password non valida",
            "creditCard.taxNumber": "Data di nascita del titolare della carta o numero di registrazione aziendale",
            "creditCard.taxNumber.label": "Data di nascita del titolare della carta (AAMMGG) o numero di registrazione aziendale (10 cifre)",
            "creditCard.taxNumber.labelAlt": "Numero di registrazione aziendale (10 cifre)",
            "creditCard.taxNumber.invalid": "Data di nascita del titolare della carta o numero di registrazione aziendale non validi",
            "storedPaymentMethod.disable.button": "Rimuovi",
            "storedPaymentMethod.disable.confirmation": "Rimuovi il metodo di pagamento archiviato",
            "storedPaymentMethod.disable.confirmButton": "S\xec, rimuoverli",
            "storedPaymentMethod.disable.cancelButton": "Cancella",
            "ach.bankAccount": "Conto bancario",
            "ach.accountHolderNameField.title": "Nome del titolare del conto",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "Nome del titolare del conto non valido",
            "ach.accountNumberField.title": "Numero di conto",
            "ach.accountNumberField.invalid": "Numero di conto non valido",
            "ach.accountLocationField.title": "Codice ABA",
            "ach.accountLocationField.invalid": "Codice ABA non valido",
            "ach.savedBankAccount": "Conto corrente salvato",
            "select.state": "Seleziona stato",
            "select.stateOrProvince": "Seleziona stato o provincia",
            "select.provinceOrTerritory": "Seleziona provincia o territorio",
            "select.country": "Seleziona paese/regione",
            "select.noOptionsFound": "Nessuna opzione trovata",
            "select.filter.placeholder": "Cerca...",
            "telephoneNumber.invalid": "Numero di telefono non valido",
            qrCodeOrApp: "o",
            "paypal.processingPayment": "Elaborazione del pagamento in corso...",
            generateQRCode: "Genera codice QR",
            "await.waitForConfirmation": "In attesa di conferma",
            "mbway.confirmPayment": "Conferma il pagamento con l'app MB WAY",
            "shopperEmail.invalid": "Indirizzo e-mail non valido",
            "dateOfBirth.format": "GG/MM/AAAA",
            "dateOfBirth.invalid": "Inserisci una data di nascita valida in cui risulti che hai almeno 18 anni.",
            "blik.confirmPayment": "Apri l'app della tua banca per confermare il pagamento.",
            "blik.invalid": "Inserisci 6 numeri",
            "blik.code": "Codice a 6 cifre",
            "blik.help": "Ottieni il codice dalla app della tua banca.",
            "swish.pendingMessage": "In seguito alla scansione, lo stato della transazione pu\xf2 rimanere in sospeso per un massimo di 10 minuti. Un nuovo tentativo di pagamento durante questo lasso di tempo pu\xf2 comportare pagamenti multipli.",
            "field.valid": "Campo valido",
            "field.invalid": "Campo non valido",
            "error.va.gen.01": "Campo incompleto",
            "error.va.gen.02": "Campo non valido",
            "error.va.sf-cc-num.01": "Immetti un numero di carta valido",
            "error.va.sf-cc-num.02": "Immetti il numero della carta",
            "error.va.sf-cc-num.03": "Immetti un marchio di carta supportato",
            "error.va.sf-cc-num.04": "Immetti il numero completo della carta",
            "error.va.sf-cc-dat.01": "Immetti una data di scadenza valida",
            "error.va.sf-cc-dat.02": "Immetti una data di scadenza valida",
            "error.va.sf-cc-dat.03": "Carta di credito in scadenza",
            "error.va.sf-cc-dat.04": "Immetti la data di scadenza",
            "error.va.sf-cc-dat.05": "Immetti la data di scadenza completa",
            "error.va.sf-cc-mth.01": "Immetti il mese di scadenza",
            "error.va.sf-cc-yr.01": "Immetti l'anno di scadenza",
            "error.va.sf-cc-yr.02": "Immetti l'anno di scadenza completo",
            "error.va.sf-cc-cvc.01": "Immetti il codice di sicurezza",
            "error.va.sf-cc-cvc.02": "Immetti il codice di sicurezza completo",
            "error.va.sf-ach-num.01": "Il campo Numero di conto corrente bancario \xe8 vuoto",
            "error.va.sf-ach-num.02": "La lunghezza del numero di conto corrente bancario non \xe8 corretta",
            "error.va.sf-ach-loc.01": "Il campo Numero di routing bancario \xe8 vuoto",
            "error.va.sf-ach-loc.02": "La lunghezza del numero di routing bancario non \xe8 corretta",
            "error.va.sf-kcp-pwd.01": "Il campo Password \xe8 vuoto",
            "error.va.sf-kcp-pwd.02": "La lunghezza della password non \xe8 corretta",
            "error.giftcard.no-balance": "Questo buono regalo ha un saldo pari a zero",
            "error.giftcard.card-error": "Non abbiamo alcun buono regalo con questo numero nei nostri archivi",
            "error.giftcard.currency-error": "I buono regalo sono validi solo nella valuta in cui sono state emessi",
            "amazonpay.signout": "Esci da Amazon",
            "amazonpay.changePaymentDetails": "Modifica i dettagli di pagamento",
            "partialPayment.warning": "Seleziona un altro metodo di pagamento per pagare l'importo rimanente",
            "partialPayment.remainingBalance": "Il saldo rimanente sar\xe0 di %{amount}",
            "bankTransfer.beneficiary": "Beneficiario",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Riferimento",
            "bankTransfer.introduction": "Continua per creare un nuovo pagamento tramite bonifico bancario. Puoi utilizzare i dettagli nella schermata seguente per completare l'operazione.",
            "bankTransfer.instructions": "Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.",
            "bacs.accountHolderName": "Nome del titolare del conto bancario",
            "bacs.accountHolderName.invalid": "Nome del titolare del conto bancario non valido",
            "bacs.accountNumber": "Numero di conto bancario",
            "bacs.accountNumber.invalid": "Numero di conto bancario non valido",
            "bacs.bankLocationId": "Sort code",
            "bacs.bankLocationId.invalid": "Sort code non valido",
            "bacs.consent.amount": "Accetto che l'importo sopra indicato venga detratto dal mio conto bancario.",
            "bacs.consent.account": "Confermo che il conto \xe8 intestato al sottoscritto e che sono l'unico firmatario a dover autorizzare l'addebito diretto su questo conto.",
            edit: "Modifica",
            "bacs.confirm": "Conferma e paga",
            "bacs.result.introduction": "Scarica le Istruzioni per l'addebito diretto (DDI / Mandato)",
            "download.pdf": "Scarica PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe per il numero di carta",
            "creditCard.encryptedCardNumber.aria.label": "Numero carta",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe per data di scadenza",
            "creditCard.encryptedExpiryDate.aria.label": "Data di scadenza",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe per il mese di scadenza",
            "creditCard.encryptedExpiryMonth.aria.label": "Mese di scadenza",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe per l'anno di scadenza",
            "creditCard.encryptedExpiryYear.aria.label": "Anno di scadenza",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe per il codice di sicurezza",
            "creditCard.encryptedSecurityCode.aria.label": "Codice di sicurezza",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe per la password",
            "creditCard.encryptedPassword.aria.label": "Prime 2 cifre della password della carta",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe per il numero di carta",
            "giftcard.encryptedCardNumber.aria.label": "Numero carta",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe per il pin",
            "giftcard.encryptedSecurityCode.aria.label": "Pin",
            giftcardTransactionLimit: "Importo massimo di %{amount} per transazione su questo buono regalo",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe per il numero di conto bancario",
            "ach.encryptedBankAccountNumber.aria.label": "Numero di conto",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe per il numero di routing bancario",
            "ach.encryptedBankLocationId.aria.label": "Codice ABA",
            "twint.saved": "memorizzato",
            orPayWith: "oppure paga con",
            invalidFormatExpects: "Formato non valido. Formato previsto: %{format}",
            "upi.qrCodeWaitingMessage": "Per completare il pagamento, scansiona il codice QR utilizzando la tua app UPI preferita",
            "upi.vpaWaitingMessage": "Apri l'app UPI per confermare il pagamento",
            "upi.modeSelection": "Scegli la modalit\xe0 di utilizzo di UPI.",
            "onlineBanking.termsAndConditions": "Facendo clic, accetti i %#termini e le condizioni%#",
            "onlineBankingPL.termsAndConditions": "Continuando accetti il %#regolamento%# e l'%#obbligo di informativa%# di Przelewy24",
            "ctp.loading.poweredByCtp": "Realizzato da Click to Pay",
            "ctp.loading.intro": "Stiamo verificando se hai delle carte salvate con Click to Pay...",
            "ctp.login.title": "Continua su Click to Pay",
            "ctp.login.subtitle": "Per continuare, inserisci l'indirizzo e-mail collegato a Click to Pay.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "Non sei tu?",
            "ctp.logout.notYourCards": "Non sono le tue carte?",
            "ctp.logout.notYourCard": "Non \xe8 la tua carta?",
            "ctp.logout.notYourProfile": "Non \xe8 il tuo profilo?",
            "ctp.otp.fieldLabel": "Codice monouso",
            "ctp.otp.resendCode": "Invia nuovamente il codice",
            "ctp.otp.codeResent": "Codice inviato",
            "ctp.otp.title": "Accedi alle tue carte Click to Pay",
            "ctp.otp.subtitle": "Inserisci il codice che %@ ha inviato a %@ per verificare la tua identit\xe0.",
            "ctp.otp.saveCookiesCheckbox.label": "Salta la verifica la prossima volta",
            "ctp.otp.saveCookiesCheckbox.information": "Scegli di essere ricordato sul dispositivo e il browser che utilizzi per velocizzare il pagamento nei negozi partecipanti. Non consigliato per dispositivi condivisi.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Seleziona per essere ricordato sul tuo dispositivo e sul browser",
            "ctp.emptyProfile.message": "Non esistono carte registrate in questo profilo Click to Pay",
            "ctp.separatorText": "o utilizza",
            "ctp.cards.title": "Completa il pagamento con Click to Pay",
            "ctp.cards.subtitle": "Seleziona una carta da utilizzare.",
            "ctp.cards.expiredCard": "Scaduta",
            "ctp.manualCardEntry": "Inserimento manuale della carta",
            "ctp.aria.infoModalButton": "Che cos'\xe8 Click to Pay",
            "ctp.infoPopup.title": "Click to Pay offre la facilit\xe0 del contactless online",
            "ctp.infoPopup.subtitle": "Un metodo di pagamento veloce e sicuro supportato da Mastercard, Visa e altre carte di pagamento.",
            "ctp.infoPopup.benefit1": "Click to Pay si avvale della crittografia per garantire la sicurezza delle tue informazioni",
            "ctp.infoPopup.benefit2": "Usa questo strumento con i commercianti di tutto il mondo",
            "ctp.infoPopup.benefit3": "Effettua una sola configurazione per avere la possibilit\xe0 di effettuare pagamenti pi\xf9 agevoli in futuro",
            "ctp.errors.AUTH_INVALID": "Autenticazione non valida",
            "ctp.errors.NOT_FOUND": "Nessun account trovato. Inserisci un'e-mail valida o procedi con l'inserimento manuale della carta.",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Formato non supportato",
            "ctp.errors.FRAUD": "L'account utente \xe8 stato bloccato o disattivato",
            "ctp.errors.CONSUMER_ID_MISSING": "L'identit\xe0 del consumatore non \xe8 presente nella richiesta",
            "ctp.errors.ACCT_INACCESSIBLE": "Questo account non \xe8 attualmente disponibile, ad esempio perch\xe9 \xe8 bloccato",
            "ctp.errors.CODE_INVALID": "Codice di verifica non corretto",
            "ctp.errors.CODE_EXPIRED": "Questo codice \xe8 scaduto",
            "ctp.errors.RETRIES_EXCEEDED": "\xc8 stato superato il limite di tentativi per la generazione del codice OTP",
            "ctp.errors.OTP_SEND_FAILED": "Impossibile inviare il codice OTP al destinatario",
            "ctp.errors.REQUEST_TIMEOUT": "Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta",
            "ctp.errors.UNKNOWN_ERROR": "Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta",
            "ctp.errors.SERVICE_ERROR": "Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta",
            "ctp.errors.SERVER_ERROR": "Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta",
            "ctp.errors.INVALID_PARAMETER": "Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta",
            "ctp.errors.AUTH_ERROR": "Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta",
            "paymentMethodsList.aria.label": "Scegli un metodo di pagamento",
            "companyDetails.name.invalid": "Immetti il nome dell'azienda",
            "companyDetails.registrationNumber.invalid": "Immetti il numero di registrazione",
            "consent.checkbox.invalid": "\xc8 necessario accettare i termini e le condizioni",
            "form.instruction": "Se non diversamente indicato, tutti i campi sono obbligatori.",
            "trustly.descriptor": "Pagamento bancario istantaneo",
            "trustly.description1": "Paga direttamente da uno qualsiasi dei tuoi conti bancari, garantito da una sicurezza di livello bancario",
            "trustly.description2": "Nessuna carta, nessun download di app, nessuna registrazione",
            "ancv.input.label": "Il tuo identificativo ANCV",
            "ancv.confirmPayment": "Utilizza la tua richiesta ANCV per confermare il pagamento.",
            "ancv.form.instruction": "Per confermare il pagamento \xe8 necessario utilizzare la richiesta Cheque-Vacances.",
            "ancv.beneficiaryId.invalid": "Inserisci un indirizzo e-mail o un identificativo ANCV valido",
            "payme.openPayMeApp": "Completa il pagamento nell'app PayMe concedendo l'autorizzazione e attendendo il messaggio di conferma.",
            "payme.redirectButtonLabel": "Apri l'app PayMe",
            "payme.scanQrCode": "Completa il pagamento con il codice QR",
            "payme.timeToPay": "Questo codice QR \xe8 valido per %@",
            "payme.instructions.steps": "Apri l'app PayMe.%@Scansiona il codice QR per autorizzare il pagamento.%@Completa il pagamento nell'app e attendi la conferma.",
            "payme.instructions.footnote": "Rimani su questa pagina fino a quando il pagamento sar\xe0 completato"
        }
    }), O2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "\u652F\u6255\u3046",
            "payButton.redirecting": "\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3057\u3066\u3044\u307E\u3059...",
            "payButton.with": "%{value}\u3092%{maskedData}\u3067\u652F\u6255\u3046",
            "payButton.saveDetails": "\u8A73\u7D30\u3092\u4FDD\u5B58",
            close: "\u7D42\u4E86",
            storeDetails: "\u6B21\u56DE\u306E\u304A\u652F\u6255\u3044\u306E\u305F\u3081\u8A73\u7D30\u3092\u4FDD\u5B58",
            readMore: "\u8A73\u7D30\u3092\u78BA\u8A8D",
            "creditCard.holderName": "\u30AB\u30FC\u30C9\u4E0A\u306E\u540D\u524D",
            "creditCard.holderName.placeholder": "Taro Yamada",
            "creditCard.holderName.invalid": "\u30AB\u30FC\u30C9\u306B\u8A18\u8F09\u3055\u308C\u3066\u3044\u308B\u540D\u524D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "creditCard.numberField.title": "\u30AB\u30FC\u30C9\u756A\u53F7",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "\u6709\u52B9\u671F\u9650",
            "creditCard.expiryDateField.placeholder": "MM/YY",
            "creditCard.expiryDateField.month": "\u6708",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "YY",
            "creditCard.expiryDateField.year": "\u5E74",
            "creditCard.cvcField.title": "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "\u6B21\u56DE\u306E\u305F\u3081\u306B\u4FDD\u5B58\u3057\u307E\u3059",
            "creditCard.cvcField.placeholder.4digits": "4\u6841",
            "creditCard.cvcField.placeholder.3digits": "3\u6841",
            "creditCard.taxNumber.placeholder": "\u5E74\u6708\u65E5\uFF08YYMMDD\uFF09/ 0123456789",
            installments: "\u5206\u5272\u56DE\u6570",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times}\u304B\u6708",
            "installments.oneTime": "\u4E00\u62EC\u6255\u3044",
            "installments.installments": "\u5206\u5272\u6255\u3044",
            "installments.revolving": "\u30EA\u30DC\u6255\u3044",
            "sepaDirectDebit.ibanField.invalid": "\u53E3\u5EA7\u756A\u53F7\u306E\u5165\u529B\u9593\u9055\u3044",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "\u540D\u7FA9",
            "sepa.ibanNumber": "\u53E3\u5EA7\u756A\u53F7 (IBAN)",
            "error.title": "\u30A8\u30E9\u30FC",
            "error.subtitle.redirect": "\u753B\u9762\u306E\u5207\u308A\u66FF\u3048\u5931\u6557\u306B\u3057\u307E\u3057\u305F",
            "error.subtitle.payment": "\u652F\u6255\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
            "error.subtitle.refused": "\u30AB\u30FC\u30C9\u4F1A\u793E\u3067\u53D6\u5F15\u304C\u627F\u8A8D\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
            "error.message.unknown": "\u4E0D\u660E\u306A\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
            "errorPanel.title": "\u65E2\u5B58\u306E\u30A8\u30E9\u30FC",
            "idealIssuer.selectField.title": "\u9280\u884C",
            "idealIssuer.selectField.placeholder": "\u9280\u884C\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "creditCard.success": "\u8A8D\u8A3C\u304C\u6210\u529F\u3057\u307E\u3057\u305F",
            loading: "\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...",
            continue: "\u7D9A\u3051\u308B",
            continueTo: "\u6B21\u3078\u9032\u3080\uFF1A",
            "wechatpay.timetopay": "%@\u3092\u304A\u652F\u6255\u3044\u4E0B\u3055\u3044\u3002",
            "sr.wechatpay.timetopay": "\u652F\u6255\u3044\u307E\u3067\u6B8B\u308A%#\u5206%# %#\u79D2%#",
            "wechatpay.scanqrcode": "QR \u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3059\u308B",
            personalDetails: "\u500B\u4EBA\u60C5\u5831",
            companyDetails: "\u4F1A\u793E\u60C5\u5831",
            "companyDetails.name": "\u4F1A\u793E\u540D",
            "companyDetails.registrationNumber": "\u767B\u9332\u756A\u53F7",
            socialSecurityNumber: "\u30BD\u30FC\u30B7\u30E3\u30EB\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30FC\u756A\u53F7",
            firstName: "\u540D",
            "firstName.invalid": "\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            infix: "\u656C\u79F0",
            lastName: "\u59D3",
            "lastName.invalid": "\u59D3\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            mobileNumber: "\u643A\u5E2F\u756A\u53F7",
            "mobileNumber.invalid": "\u7121\u52B9\u306A\u643A\u5E2F\u96FB\u8A71\u756A\u53F7",
            city: "\u5E02\u533A",
            postalCode: "\u90F5\u4FBF\u756A\u53F7",
            "postalCode.optional": "\u90F5\u4FBF\u756A\u53F7 (\u4EFB\u610F)",
            countryCode: "\u56FD\u30B3\u30FC\u30C9",
            telephoneNumber: "\u96FB\u8A71\u756A\u53F7",
            dateOfBirth: "\u751F\u5E74\u6708\u65E5",
            shopperEmail: "E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
            gender: "\u6027\u5225",
            "gender.notselected": "\u6027\u5225\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            male: "\u7537\u6027",
            female: "\u5973\u6027",
            billingAddress: "\u3054\u8ACB\u6C42\u4F4F\u6240",
            street: "\u756A\u5730",
            stateOrProvince: "\u90FD\u9053\u5E9C\u770C",
            country: "\u56FD/\u5730\u57DF",
            houseNumberOrName: "\u90E8\u5C4B\u756A\u53F7",
            separateDeliveryAddress: "\u5225\u306E\u914D\u9001\u5148\u4F4F\u6240\u3092\u6307\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044",
            deliveryAddress: "\u914D\u9001\u5148\u4F4F\u6240",
            "deliveryAddress.firstName": "\u53D7\u4FE1\u8005\u306E\u540D",
            "deliveryAddress.lastName": "\u53D7\u4FE1\u8005\u306E\u59D3",
            zipCode: "\u90F5\u4FBF\u756A\u53F7",
            apartmentSuite: "\u30A2\u30D1\u30FC\u30C8\u540D/\u90E8\u5C4B\u540D",
            provinceOrTerritory: "\u5DDE\u307E\u305F\u306F\u6E96\u5DDE",
            cityTown: "\u5E02\u533A\u753A\u6751",
            address: "\u4F4F\u6240",
            "address.placeholder": "\u4F4F\u6240\u3092\u691C\u7D22\u3057\u3066\u304F\u3060\u3055\u3044",
            "address.errors.incomplete": "\u7D9A\u884C\u3059\u308B\u306B\u306F\u3001\u4F4F\u6240\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "address.enterManually": "\u4F4F\u6240\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            state: "\u90FD\u9053\u5E9C\u770C",
            "field.title.optional": "\uFF08\u4EFB\u610F\uFF09",
            "creditCard.cvcField.title.optional": "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9\uFF08\u4EFB\u610F\uFF09",
            "issuerList.wallet.placeholder": "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            privacyPolicy: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC",
            "afterPay.agreement": "Riverty\u306E%@\u3067\u540C\u610F",
            paymentConditions: "\u652F\u6255\u6761\u4EF6",
            openApp: "\u30A2\u30D7\u30EA\u3092\u958B\u304F",
            "voucher.readInstructions": "\u624B\u9806\u3092\u53C2\u7167\u3057\u3066\u304F\u3060\u3055\u3044",
            "voucher.introduction": "\u304A\u8CB7\u3044\u4E0A\u3052\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u4EE5\u4E0B\u306E\u30AF\u30FC\u30DD\u30F3\u3092\u4F7F\u7528\u3057\u3066\u3001\u304A\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "voucher.expirationDate": "\u6709\u52B9\u671F\u9650",
            "voucher.alternativeReference": "\u5225\u306E\u53C2\u7167",
            "dragonpay.voucher.non.bank.selectField.placeholder": "\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "dragonpay.voucher.bank.selectField.placeholder": "\u9280\u884C\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "voucher.paymentReferenceLabel": "\u78BA\u8A8D\u756A\u53F7",
            "voucher.surcharge": "%@ \u306E\u8FFD\u52A0\u6599\u91D1\u3092\u542B\u3080",
            "voucher.introduction.doku": "\u304A\u8CB7\u3044\u4E0A\u3052\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u4EE5\u4E0B\u306E\u60C5\u5831\u3092\u4F7F\u7528\u3057\u3066\u3001\u304A\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "voucher.shopperName": "\u8CFC\u5165\u8005\u6C0F\u540D",
            "voucher.merchantName": "\u696D\u8005",
            "voucher.introduction.econtext": "\u304A\u8CB7\u3044\u4E0A\u3052\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u4EE5\u4E0B\u306E\u60C5\u5831\u3092\u4F7F\u7528\u3057\u3066\u3001\u304A\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "voucher.telephoneNumber": "\u96FB\u8A71\u756A\u53F7\uFF08\u304A\u5BA2\u69D8\u756A\u53F7\uFF09",
            "voucher.shopperReference": "\u8CFC\u5165\u8005\u5411\u3051\u53C2\u8003\u60C5\u5831",
            "voucher.collectionInstitutionNumber": "\u53CE\u7D0D\u6A5F\u95A2\u756A\u53F7",
            "voucher.econtext.telephoneNumber.invalid": "\u96FB\u8A71\u756A\u53F7\u306F10\u6841\u307E\u305F\u306F11\u6841\u306B\u3057\u3066\u304F\u3060\u3055\u3044",
            "boletobancario.btnLabel": "Boleto\u3092\u751F\u6210\u3059\u308B",
            "boleto.sendCopyToEmail": "\u81EA\u5206\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u30B3\u30D4\u30FC\u3092\u9001\u4FE1\u3059\u308B",
            "button.copy": "\u30B3\u30D4\u30FC",
            "button.download": "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
            "boleto.socialSecurityNumber.invalid": "\u6709\u52B9\u306ACPF/CNPJ\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "creditCard.storedCard.description.ariaLabel": "\u4FDD\u5B58\u3055\u308C\u305F\u30AB\u30FC\u30C9\u306F\uFF05@\u306B\u7D42\u4E86\u3057\u307E\u3059",
            "voucher.entity": "\u30A8\u30F3\u30C6\u30A3\u30C6\u30A3",
            donateButton: "\u5BC4\u4ED8\u3059\u308B",
            notNowButton: "\u4ECA\u306F\u3057\u306A\u3044",
            thanksForYourSupport: "\u3054\u652F\u63F4\u3044\u305F\u3060\u304D\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002",
            "resultMessages.preauthorized": "\u8A73\u7D30\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F",
            preauthorizeWith: "\u6B21\u3067\u4E8B\u524D\u8A8D\u8A3C\u3059\u308B\uFF1A",
            confirmPreauthorization: "\u4E8B\u524D\u627F\u8A8D\u3092\u78BA\u8A8D\u3059\u308B",
            confirmPurchase: "\u8CFC\u5165\u3092\u78BA\u8A8D\u3059\u308B",
            applyGiftcard: "\u5229\u7528\u3059\u308B",
            giftcardBalance: "\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u306E\u6B8B\u9AD8",
            deductedBalance: "\u5DEE\u3057\u5F15\u304D\u5F8C\u6B8B\u9AD8",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "\u30AB\u30FC\u30C9\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u6700\u521D\u306E2\u6841",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u7121\u52B9\u3067\u3059",
            "creditCard.taxNumber": "\u30AB\u30FC\u30C9\u6240\u6709\u8005\u306E\u751F\u5E74\u6708\u65E5\u307E\u305F\u306F\u6CD5\u4EBA\u767B\u9332\u756A\u53F7",
            "creditCard.taxNumber.label": "\u30AB\u30FC\u30C9\u6240\u6709\u8005\u306E\u751F\u5E74\u6708\u65E5\uFF08YYMMDD\uFF09\u307E\u305F\u306F\u6CD5\u4EBA\u767B\u9332\u756A\u53F7\uFF0810\u6841\uFF09",
            "creditCard.taxNumber.labelAlt": "\u6CD5\u4EBA\u767B\u9332\u756A\u53F7\uFF0810\u6841\uFF09",
            "creditCard.taxNumber.invalid": "\u30AB\u30FC\u30C9\u6240\u6709\u8005\u306E\u751F\u5E74\u6708\u65E5\u307E\u305F\u306F\u6CD5\u4EBA\u767B\u9332\u756A\u53F7\u304C\u7121\u52B9\u3067\u3059",
            "storedPaymentMethod.disable.button": "\u524A\u9664",
            "storedPaymentMethod.disable.confirmation": "\u4FDD\u5B58\u3055\u308C\u3066\u3044\u308B\u652F\u6255\u65B9\u6CD5\u3092\u524A\u9664\u3059\u308B",
            "storedPaymentMethod.disable.confirmButton": "\u306F\u3044\u3001\u524A\u9664\u3057\u307E\u3059",
            "storedPaymentMethod.disable.cancelButton": "\u30AD\u30E3\u30F3\u30BB\u30EB",
            "ach.bankAccount": "\u9280\u884C\u53E3\u5EA7",
            "ach.accountHolderNameField.title": "\u53E3\u5EA7\u540D\u7FA9",
            "ach.accountHolderNameField.placeholder": "Taro Yamada",
            "ach.accountHolderNameField.invalid": "\u7121\u52B9\u306A\u53E3\u5EA7\u540D\u7FA9",
            "ach.accountNumberField.title": "\u53E3\u5EA7\u756A\u53F7",
            "ach.accountNumberField.invalid": "\u53E3\u5EA7\u756A\u53F7\u306E\u5165\u529B\u9593\u9055\u3044",
            "ach.accountLocationField.title": "ABA\u30CA\u30F3\u30D0\u30FC",
            "ach.accountLocationField.invalid": "\u7121\u52B9\u306AABA\u30CA\u30F3\u30D0\u30FC",
            "ach.savedBankAccount": "\u4FDD\u5B58\u6E08\u307F\u306E\u9280\u884C\u53E3\u5EA7",
            "select.state": "\u90FD\u9053\u5E9C\u770C\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "select.stateOrProvince": "\u90FD\u9053\u5E9C\u770C\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "select.provinceOrTerritory": "\u5DDE\u307E\u305F\u306F\u6E96\u5DDE\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "select.country": "\u56FD/\u5730\u57DF\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "select.noOptionsFound": "\u30AA\u30D7\u30B7\u30E7\u30F3\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
            "select.filter.placeholder": "\u691C\u7D22...",
            "telephoneNumber.invalid": "\u7121\u52B9\u306A\u96FB\u8A71\u756A\u53F7",
            qrCodeOrApp: "\u307E\u305F\u306F",
            "paypal.processingPayment": "\u652F\u6255\u3044\u3092\u51E6\u7406\u3057\u3066\u3044\u307E\u3059...",
            generateQRCode: "QR\u30B3\u30FC\u30C9\u3092\u751F\u6210\u3059\u308B",
            "await.waitForConfirmation": "\u78BA\u8A8D\u3092\u5F85\u3063\u3066\u3044\u307E\u3059",
            "mbway.confirmPayment": "MB WAY\u30A2\u30D7\u30EA\u3067\u652F\u6255\u3092\u78BA\u8A8D\u3059\u308B",
            "shopperEmail.invalid": "E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u304C\u7121\u52B9\u3067\u3059",
            "dateOfBirth.format": "DD/MM/YYYY",
            "dateOfBirth.invalid": "18\u6B73\u4EE5\u4E0A\u3067\u3042\u308B\u3053\u3068\u3092\u793A\u3059\u6709\u52B9\u306A\u751F\u5E74\u6708\u65E5\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "blik.confirmPayment": "\u30D0\u30F3\u30AD\u30F3\u30B0\u30A2\u30D7\u30EA\u3092\u958B\u3044\u3066\u3001\u652F\u6255\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "blik.invalid": "6\u3064\u306E\u6570\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "blik.code": "6\u6841\u306E\u30B3\u30FC\u30C9",
            "blik.help": "\u30D0\u30F3\u30AD\u30F3\u30B0\u30A2\u30D7\u30EA\u304B\u3089\u30B3\u30FC\u30C9\u3092\u53D6\u5F97\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "swish.pendingMessage": "\u30B9\u30AD\u30E3\u30F3\u5F8C\u3001\u30B9\u30C6\u30FC\u30BF\u30B9\u306F\u6700\u592710\u5206\u9593\u4FDD\u7559\u72B6\u614B\u306B\u306A\u308A\u307E\u3059\u3002\u3053\u306E\u9593\u306B\u518D\u5EA6\u304A\u652F\u6255\u3044\u3044\u305F\u3060\u3053\u3046\u3068\u3059\u308B\u3068\u3001\u8907\u6570\u306E\u8ACB\u6C42\u304C\u767A\u751F\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002",
            "field.valid": "\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u6709\u52B9\u3067\u3059",
            "field.invalid": "\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u7121\u52B9\u3067\u3059",
            "error.va.gen.01": "\u4E0D\u5B8C\u5168\u306A\u30D5\u30A3\u30FC\u30EB\u30C9",
            "error.va.gen.02": "\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u7121\u52B9\u3067\u3059",
            "error.va.sf-cc-num.01": "\u6709\u52B9\u306A\u30AB\u30FC\u30C9\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-num.02": "\u30AB\u30FC\u30C9\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-num.03": "\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u308B\u30AB\u30FC\u30C9\u30D6\u30E9\u30F3\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-num.04": "\u5B8C\u5168\u306A\u30AB\u30FC\u30C9\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-dat.01": "\u6709\u52B9\u306A\u6709\u52B9\u671F\u9650\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-dat.02": "\u6709\u52B9\u306A\u6709\u52B9\u671F\u9650\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-dat.03": "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u304C\u8FD1\u3065\u3044\u3066\u3044\u307E\u3059",
            "error.va.sf-cc-dat.04": "\u6709\u52B9\u671F\u9650\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-dat.05": "\u5B8C\u5168\u306A\u6709\u52B9\u671F\u9650\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-mth.01": "\u6709\u52B9\u671F\u9650\u6708\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-yr.01": "\u6709\u52B9\u671F\u9650\u5E74\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-yr.02": "\u5B8C\u5168\u306A\u6709\u52B9\u671F\u9650\u5E74\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-cvc.01": "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-cvc.02": "\u5B8C\u5168\u306A\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-ach-num.01": "\u9280\u884C\u53E3\u5EA7\u756A\u53F7\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u7A7A\u3067\u3059",
            "error.va.sf-ach-num.02": "\u9280\u884C\u53E3\u5EA7\u756A\u53F7\u306E\u9577\u3055\u304C\u4E0D\u6B63\u3067\u3059",
            "error.va.sf-ach-loc.01": "\u9280\u884C\u652F\u5E97\u756A\u53F7\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u7A7A\u3067\u3059",
            "error.va.sf-ach-loc.02": "\u9280\u884C\u652F\u5E97\u756A\u53F7\u306E\u9577\u3055\u304C\u4E0D\u6B63\u3067\u3059",
            "error.va.sf-kcp-pwd.01": "\u30D1\u30B9\u30EF\u30FC\u30C9\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u7A7A\u3067\u3059",
            "error.va.sf-kcp-pwd.02": "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u9577\u3055\u304C\u4E0D\u6B63\u3067\u3059",
            "error.giftcard.no-balance": "\u3053\u306E\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u306E\u6B8B\u9AD8\u306F\u30BC\u30ED\u3067\u3059",
            "error.giftcard.card-error": "\u8A18\u9332\u3067\u306F\u3001\u3053\u306E\u756A\u53F7\u306E\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u306F\u3042\u308A\u307E\u305B\u3093",
            "error.giftcard.currency-error": "\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u306F\u3001\u767A\u884C\u3055\u308C\u305F\u901A\u8CA8\u3067\u306E\u307F\u6709\u52B9\u3067\u3059\u3002",
            "amazonpay.signout": "Amazon\u304B\u3089\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8\u3059\u308B",
            "amazonpay.changePaymentDetails": "\u652F\u6255\u660E\u7D30\u3092\u5909\u66F4\u3059\u308B",
            "partialPayment.warning": "\u6B8B\u91D1\u3092\u652F\u6255\u3046\u5225\u306E\u652F\u6255\u65B9\u6CD5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "partialPayment.remainingBalance": "\u6B8B\u308A\u306E\u6B8B\u9AD8\u306F%{amount}\u306B\u306A\u308A\u307E\u3059",
            "bankTransfer.beneficiary": "\u53D7\u76CA\u8005",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "\u53C2\u7167",
            "bankTransfer.introduction": "\u65B0\u3057\u3044\u9280\u884C\u632F\u8FBC\u306B\u3088\u308B\u304A\u652F\u6255\u306E\u4F5C\u6210\u3092\u7D9A\u884C\u3057\u307E\u3059\u3002\u6B21\u306E\u753B\u9762\u306E\u8A73\u7D30\u3092\u4F7F\u7528\u3057\u3066\u3001\u3053\u306E\u304A\u652F\u6255\u3044\u3092\u78BA\u5B9A\u3067\u304D\u307E\u3059\u3002",
            "bankTransfer.instructions": "\u304A\u8CB7\u3044\u4E0A\u3052\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u4EE5\u4E0B\u306E\u60C5\u5831\u3092\u4F7F\u7528\u3057\u3066\u3001\u304A\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "bacs.accountHolderName": "\u9280\u884C\u53E3\u5EA7\u540D\u7FA9",
            "bacs.accountHolderName.invalid": "\u9280\u884C\u53E3\u5EA7\u540D\u7FA9\u304C\u7121\u52B9\u3067\u3059",
            "bacs.accountNumber": "\u9280\u884C\u53E3\u5EA7\u756A\u53F7",
            "bacs.accountNumber.invalid": "\u9280\u884C\u53E3\u5EA7\u756A\u53F7\u304C\u7121\u52B9\u3067\u3059",
            "bacs.bankLocationId": "\u30BD\u30FC\u30C8\u30B3\u30FC\u30C9",
            "bacs.bankLocationId.invalid": "\u30BD\u30FC\u30C8\u30B3\u30FC\u30C9\u304C\u7121\u52B9\u3067\u3059",
            "bacs.consent.amount": "\u4E0A\u8A18\u306E\u91D1\u984D\u304C\u79C1\u306E\u9280\u884C\u53E3\u5EA7\u304B\u3089\u5F15\u304D\u843D\u3068\u3055\u308C\u308B\u3053\u3068\u306B\u540C\u610F\u3057\u307E\u3059\u3002",
            "bacs.consent.account": "\u53E3\u5EA7\u304C\u79C1\u306E\u540D\u7FA9\u3067\u3042\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u3053\u306E\u53E3\u5EA7\u304B\u3089\u306E\u81EA\u52D5\u5F15\u304D\u843D\u3068\u3057\u3092\u627F\u8A8D\u3059\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u552F\u4E00\u306E\u7F72\u540D\u8005\u3067\u3042\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u307E\u3059\u3002",
            edit: "\u7DE8\u96C6",
            "bacs.confirm": "\u78BA\u8A8D\u3057\u3066\u652F\u6255\u3046",
            "bacs.result.introduction": "\u81EA\u52D5\u5F15\u304D\u843D\u3068\u3057\u306E\u8AAC\u660E (DDI/\u59D4\u4EFB\u72B6) \u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B",
            "download.pdf": "PDF\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "\u30AB\u30FC\u30C9\u756A\u53F7\u306Eiframe",
            "creditCard.encryptedCardNumber.aria.label": "\u30AB\u30FC\u30C9\u756A\u53F7",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "\u6709\u52B9\u671F\u9650\u306Eiframe",
            "creditCard.encryptedExpiryDate.aria.label": "\u6709\u52B9\u671F\u9650",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "\u6709\u52B9\u671F\u9650\u6708\u306Eiframe",
            "creditCard.encryptedExpiryMonth.aria.label": "\u6709\u52B9\u671F\u9650\u6708",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "\u6709\u52B9\u671F\u9650\u5E74\u306Eiframe",
            "creditCard.encryptedExpiryYear.aria.label": "\u6709\u52B9\u671F\u9650\u5E74",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9\u306Eiframe",
            "creditCard.encryptedSecurityCode.aria.label": "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9",
            "creditCard.encryptedPassword.aria.iframeTitle": "\u30D1\u30B9\u30EF\u30FC\u30C9\u306Eiframe",
            "creditCard.encryptedPassword.aria.label": "\u30AB\u30FC\u30C9\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u6700\u521D\u306E2\u6841",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "\u30AB\u30FC\u30C9\u756A\u53F7\u306Eiframe",
            "giftcard.encryptedCardNumber.aria.label": "\u30AB\u30FC\u30C9\u756A\u53F7",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "PIN\u306Eiframe",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "\u3053\u306E\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u3067\u306E\u53D6\u5F15\u3054\u3068\u306B\u8A31\u53EF\u3055\u308C\u308B\u6700\u5927%{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "\u9280\u884C\u53E3\u5EA7\u756A\u53F7\u306Eiframe",
            "ach.encryptedBankAccountNumber.aria.label": "\u53E3\u5EA7\u756A\u53F7",
            "ach.encryptedBankLocationId.aria.iframeTitle": "\u9280\u884C\u652F\u5E97\u756A\u53F7\u306Eiframe",
            "ach.encryptedBankLocationId.aria.label": "ABA\u30CA\u30F3\u30D0\u30FC",
            "twint.saved": "\u3092\u4FDD\u5B58\u3057\u307E\u3057\u305F",
            orPayWith: "\u307E\u305F\u306F\u6B21\u306E\u65B9\u6CD5\u3067\u652F\u6255\u3046",
            invalidFormatExpects: "\u7121\u52B9\u306A\u5F62\u5F0F\u3067\u3059\u3002\u671F\u5F85\u3055\u308C\u308B\u5F62\u5F0F\uFF1A %{format}",
            "upi.qrCodeWaitingMessage": "\u304A\u597D\u307F\u306EUPI\u30A2\u30D7\u30EA\u3092\u4F7F\u7528\u3057\u3066QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3001\u652F\u6255\u3092\u5B8C\u4E86\u3057\u3066\u304F\u3060\u3055\u3044",
            "upi.vpaWaitingMessage": "UPI\u30A2\u30D7\u30EA\u3092\u958B\u3044\u3066\u3001\u652F\u6255\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044",
            "upi.modeSelection": "UPI\u306E\u4F7F\u7528\u65B9\u6CD5\u3092\u9078\u629E\u3057\u307E\u3059\u3002",
            "onlineBanking.termsAndConditions": "\u7D9A\u884C\u3059\u308B\u3068\u3001%#\u5229\u7528\u898F\u7D04%#\u306B\u540C\u610F\u3057\u305F\u3053\u3068\u306B\u306A\u308A\u307E\u3059",
            "onlineBankingPL.termsAndConditions": "\u7D9A\u884C\u3059\u308B\u3068\u3001Przelewy24\u306E%#\u898F\u5236%#\u3068%#\u60C5\u5831\u63D0\u4F9B\u7FA9\u52D9%#\u306B\u540C\u610F\u3057\u305F\u3053\u3068\u306B\u306A\u308A\u307E\u3059",
            "ctp.loading.poweredByCtp": "Click to Pay\u63D0\u4F9B",
            "ctp.loading.intro": "Click to Pay\u306B\u30AB\u30FC\u30C9\u304C\u4FDD\u5B58\u3055\u308C\u3066\u3044\u308B\u304B\u3069\u3046\u304B\u3092\u78BA\u8A8D\u3057\u3066\u3044\u307E\u3059...",
            "ctp.login.title": "Click to Pay\u306B\u9032\u3080",
            "ctp.login.subtitle": "\u7D9A\u884C\u3059\u308B\u306B\u306F\u3001Click to Pay\u306B\u9023\u643A\u3055\u308C\u3066\u3044\u308B\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ctp.login.inputLabel": "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
            "ctp.logout.notYou": "\u3054\u81EA\u5206\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u304B\uFF1F",
            "ctp.logout.notYourCards": "\u3054\u81EA\u5206\u306E\u30AB\u30FC\u30C9\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u304B\uFF1F",
            "ctp.logout.notYourCard": "\u3054\u81EA\u5206\u306E\u30AB\u30FC\u30C9\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u304B\uFF1F",
            "ctp.logout.notYourProfile": "\u3054\u81EA\u5206\u306E\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u304B\uFF1F",
            "ctp.otp.fieldLabel": "\u30EF\u30F3\u30BF\u30A4\u30E0\u30B3\u30FC\u30C9",
            "ctp.otp.resendCode": "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1\u3059\u308B",
            "ctp.otp.codeResent": "\u30B3\u30FC\u30C9\u304C\u518D\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F",
            "ctp.otp.title": "Click to Pay\u30AB\u30FC\u30C9\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B",
            "ctp.otp.subtitle": "%@\u304B\u3089%@\u306B\u9001\u4FE1\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u3001\u3054\u672C\u4EBA\u3067\u3042\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ctp.otp.saveCookiesCheckbox.label": "\u6B21\u56DE\u306F\u691C\u8A3C\u3092\u30B9\u30AD\u30C3\u30D7\u3059\u308B",
            "ctp.otp.saveCookiesCheckbox.information": "\u5BFE\u8C61\u5E97\u8217\u3067\u3001\u304A\u4F7F\u3044\u306E\u30C7\u30D0\u30A4\u30B9\u3068\u30D6\u30E9\u30A6\u30B6\u3067\u8A18\u61B6\u3055\u305B\u308B\u3088\u3046\u306B\u9078\u629E\u3059\u308B\u3068\u3001\u3088\u308A\u8FC5\u901F\u306A\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u304C\u53EF\u80FD\u306B\u306A\u308A\u307E\u3059\u3002\u5171\u6709\u30C7\u30D0\u30A4\u30B9\u3067\u306F\u63A8\u5968\u3055\u308C\u307E\u305B\u3093\u3002",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "\u9078\u629E\u3059\u308B\u3068\u3001\u304A\u4F7F\u3044\u306E\u30C7\u30D0\u30A4\u30B9\u3068\u30D6\u30E9\u30A6\u30B6\u306B\u8A18\u61B6\u3055\u308C\u307E\u3059",
            "ctp.emptyProfile.message": "\u3053\u306EClick to Pay\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u306B\u767B\u9332\u3055\u308C\u3066\u3044\u308B\u30AB\u30FC\u30C9\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
            "ctp.separatorText": "\u307E\u305F\u306F\u4EE5\u4E0B\u3092\u4F7F\u7528",
            "ctp.cards.title": "Click to Pay\u3067\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3059\u308B",
            "ctp.cards.subtitle": "\u4F7F\u7528\u3059\u308B\u30AB\u30FC\u30C9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ctp.cards.expiredCard": "\u671F\u9650\u5207\u308C",
            "ctp.manualCardEntry": "\u624B\u52D5\u30AB\u30FC\u30C9\u5165\u529B",
            "ctp.aria.infoModalButton": "Click to Pay\u3068\u306F",
            "ctp.infoPopup.title": "Click to Pay\u306F\u30AA\u30F3\u30E9\u30A4\u30F3\u3067\u975E\u63A5\u89E6\u578B\u30AB\u30FC\u30C9\u306E\u4F7F\u3044\u3084\u3059\u3055\u3092\u5B9F\u73FE\u3057\u307E\u3059",
            "ctp.infoPopup.subtitle": "Mastercard\u3001Visa\u3001\u305D\u306E\u4ED6\u306E\u652F\u6255\u30AB\u30FC\u30C9\u3067\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u308B\u9AD8\u901F\u3067\u5B89\u5168\u306A\u652F\u6255\u65B9\u6CD5\u3002",
            "ctp.infoPopup.benefit1": "Click to Pay\u306F\u6697\u53F7\u5316\u3092\u4F7F\u7528\u3057\u3066\u60C5\u5831\u3092\u5B89\u5168\u306B\u4FDD\u8B77\u3057\u307E\u3059",
            "ctp.infoPopup.benefit2": "\u4E16\u754C\u4E2D\u306E\u696D\u8005\u3067\u4F7F\u7528\u3067\u304D\u307E\u3059",
            "ctp.infoPopup.benefit3": "\u4E00\u5EA6\u8A2D\u5B9A\u3059\u308B\u3060\u3051\u3067\u3001\u4ECA\u5F8C\u306E\u652F\u6255\u3044\u304C\u7C21\u5358\u306B\u306A\u308A\u307E\u3059",
            "ctp.errors.AUTH_INVALID": "\u8A8D\u8A3C\u304C\u7121\u52B9\u3067\u3059",
            "ctp.errors.NOT_FOUND": "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002\u6709\u52B9\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3059\u308B\u304B\u3001\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u306A\u3044\u5F62\u5F0F\u3067\u3059",
            "ctp.errors.FRAUD": "\u30E6\u30FC\u30B6\u30FC\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3044\u308B\u304B\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u307E\u3059",
            "ctp.errors.CONSUMER_ID_MISSING": "\u30EA\u30AF\u30A8\u30B9\u30C8\u306B\u30B3\u30F3\u30B7\u30E5\u30FC\u30DE\u30FCID\u304C\u3042\u308A\u307E\u305B\u3093",
            "ctp.errors.ACCT_INACCESSIBLE": "\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3044\u308B\u306A\u3069\u306E\u7406\u7531\u306B\u3088\u308A\u3001\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u73FE\u5728\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002",
            "ctp.errors.CODE_INVALID": "\u78BA\u8A8D\u30B3\u30FC\u30C9\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093",
            "ctp.errors.CODE_EXPIRED": "\u3053\u306E\u30B3\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059",
            "ctp.errors.RETRIES_EXCEEDED": "\u30EF\u30F3\u30BF\u30A4\u30E0\u30D1\u30B9\u30EF\u30FC\u30C9\u751F\u6210\u306E\u30EA\u30C8\u30E9\u30A4\u56DE\u6570\u304C\u4E0A\u9650\u3092\u8D85\u3048\u307E\u3057\u305F",
            "ctp.errors.OTP_SEND_FAILED": "\u30EF\u30F3\u30BF\u30A4\u30E0\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u53D7\u4FE1\u8005\u306B\u9001\u4FE1\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
            "ctp.errors.REQUEST_TIMEOUT": "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ctp.errors.UNKNOWN_ERROR": "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ctp.errors.SERVICE_ERROR": "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ctp.errors.SERVER_ERROR": "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ctp.errors.INVALID_PARAMETER": "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ctp.errors.AUTH_ERROR": "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "paymentMethodsList.aria.label": "\u304A\u652F\u6255\u3044\u65B9\u6CD5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "companyDetails.name.invalid": "\u4F1A\u793E\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "companyDetails.registrationNumber.invalid": "\u767B\u9332\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "consent.checkbox.invalid": "\u5229\u7528\u898F\u7D04\u306B\u540C\u610F\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059",
            "form.instruction": "\u7279\u306B\u660E\u8A18\u3055\u308C\u3066\u3044\u306A\u3044\u9650\u308A\u3001\u3059\u3079\u3066\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306F\u5FC5\u9808\u3067\u3059\u3002",
            "trustly.descriptor": "\u5373\u6642\u9280\u884C\u652F\u6255",
            "trustly.description1": "\u3054\u5229\u7528\u306E\u9280\u884C\u53E3\u5EA7\u304B\u3089\u76F4\u63A5\u304A\u652F\u6255\u3044\u53EF\u80FD\uFF08\u9280\u884C\u30EC\u30D9\u30EB\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u3067\u4FDD\u8B77\u3055\u308C\u3066\u3044\u307E\u3059\uFF09",
            "trustly.description2": "\u30AB\u30FC\u30C9\u306A\u3057\u3001\u30A2\u30D7\u30EA\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u306A\u3057\u3001\u767B\u9332\u306A\u3057",
            "ancv.input.label": "ANCV ID",
            "ancv.confirmPayment": "ANCV\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u3001\u652F\u6255\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ancv.form.instruction": "\u3053\u306E\u652F\u6255\u3092\u691C\u8A3C\u3059\u308B\u306B\u306F\u3001Cheque-Vacances\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u304C\u5FC5\u8981\u3067\u3059\u3002",
            "ancv.beneficiaryId.invalid": "\u6709\u52B9\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u307E\u305F\u306FANCV ID\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "payme.openPayMeApp": "PayMe\u30A2\u30D7\u30EA\u3067\u627F\u8A8D\u3057\u3066\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3057\u3001\u78BA\u8A8D\u3092\u5F85\u3061\u307E\u3059\u3002",
            "payme.redirectButtonLabel": "PayMe\u30A2\u30D7\u30EA\u3092\u958B\u304F",
            "payme.scanQrCode": "QR\u30B3\u30FC\u30C9\u3067\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3059\u308B",
            "payme.timeToPay": "\u3053\u306EQR\u30B3\u30FC\u30C9\u306F%@\u6709\u52B9\u3067\u3059",
            "payme.instructions.steps": "PayMe\u30A2\u30D7\u30EA\u3092\u958B\u304D\u307E\u3059\u3002%@QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u652F\u6255\u3044\u3092\u627F\u8A8D\u3057\u307E\u3059\u3002%@\u30A2\u30D7\u30EA\u3067\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3057\u3001\u78BA\u8A8D\u3092\u5F85\u3061\u307E\u3059\u3002",
            "payme.instructions.footnote": "\u652F\u6255\u3044\u304C\u5B8C\u4E86\u3059\u308B\u307E\u3067\u3053\u306E\u30DA\u30FC\u30B8\u3092\u9589\u3058\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
        }
    }), j2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "\uACB0\uC81C",
            "payButton.redirecting": "\uB9AC\uB514\uB809\uC158 \uC911...",
            "payButton.with": "%{maskedData}(\uC73C)\uB85C %{value} \uACB0\uC81C",
            "payButton.saveDetails": "\uC138\uBD80 \uC815\uBCF4 \uC800\uC7A5",
            close: "\uB2EB\uAE30",
            storeDetails: "\uB2E4\uC74C \uACB0\uC81C\uB97C \uC704\uD574 \uC774 \uC218\uB2E8 \uC800\uC7A5",
            readMore: "\uC790\uC138\uD788 \uBCF4\uAE30",
            "creditCard.holderName": "\uCE74\uB4DC\uC0C1\uC758 \uC774\uB984",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "\uCE74\uB4DC\uC5D0 \uD45C\uC2DC\uB41C \uB300\uB85C \uC774\uB984\uC744 \uC785\uB825\uD569\uB2C8\uB2E4.",
            "creditCard.numberField.title": "\uCE74\uB4DC \uBC88\uD638",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "\uB9CC\uB8CC\uC77C",
            "creditCard.expiryDateField.placeholder": "MM/YY",
            "creditCard.expiryDateField.month": "\uC6D4",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "YY",
            "creditCard.expiryDateField.year": "\uC5F0\uB3C4",
            "creditCard.cvcField.title": "\uBCF4\uC548 \uCF54\uB4DC",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "\uB2E4\uC74C\uC744 \uC704\uD574 \uC800\uC7A5",
            "creditCard.cvcField.placeholder.4digits": "4\uC790\uB9AC",
            "creditCard.cvcField.placeholder.3digits": "3\uC790\uB9AC",
            "creditCard.taxNumber.placeholder": "YYMMDD / 0123456789",
            installments: "\uD560\uBD80 \uAC1C\uC6D4 \uC218",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times}\uAC1C\uC6D4",
            "installments.oneTime": "\uC77C\uC2DC\uBD88 \uACB0\uC81C",
            "installments.installments": "\uD560\uBD80 \uACB0\uC81C",
            "installments.revolving": "\uB9AC\uBCFC\uBE59 \uACB0\uC81C",
            "sepaDirectDebit.ibanField.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uACC4\uC88C \uBC88\uD638",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "\uC18C\uC720\uC790 \uC774\uB984",
            "sepa.ibanNumber": "\uACC4\uC88C \uBC88\uD638(IBAN)",
            "error.title": "\uC624\uB958",
            "error.subtitle.redirect": "\uB9AC\uB514\uB809\uC158 \uC2E4\uD328",
            "error.subtitle.payment": "\uACB0\uC81C \uC2E4\uD328",
            "error.subtitle.refused": "\uACB0\uC81C \uAC70\uBD80",
            "error.message.unknown": "\uC54C \uC218 \uC5C6\uB294 \uC624\uB958 \uBC1C\uC0DD",
            "errorPanel.title": "\uAE30\uC874 \uC624\uB958",
            "idealIssuer.selectField.title": "\uC740\uD589",
            "idealIssuer.selectField.placeholder": "\uC740\uD589 \uC120\uD0DD",
            "creditCard.success": "\uACB0\uC81C \uC131\uACF5",
            loading: "\uB85C\uB4DC \uC911\u2026",
            continue: "\uACC4\uC18D",
            continueTo: "\uB2E4\uC74C\uC73C\uB85C \uACC4\uC18D:",
            "wechatpay.timetopay": "\uB0A8\uC740 \uACB0\uC81C \uC2DC\uD55C: %@",
            "sr.wechatpay.timetopay": "%#\uBD84%# %#\uCD08%# \uB0B4\uB85C \uACB0\uC81C\uB97C \uC644\uB8CC\uD558\uC138\uC694.",
            "wechatpay.scanqrcode": "QR \uCF54\uB4DC \uC2A4\uCE94",
            personalDetails: "\uAC1C\uC778 \uC815\uBCF4",
            companyDetails: "\uD68C\uC0AC \uC815\uBCF4",
            "companyDetails.name": "\uD68C\uC0AC\uBA85",
            "companyDetails.registrationNumber": "\uB4F1\uB85D \uBC88\uD638",
            socialSecurityNumber: "\uC0AC\uD68C \uBCF4\uC7A5 \uBC88\uD638(\uC8FC\uBBFC\uB4F1\uB85D\uBC88\uD638)",
            firstName: "\uC774\uB984",
            "firstName.invalid": "\uC774\uB984\uC744 \uC785\uB825\uD558\uC138\uC694.",
            infix: "\uBA85\uCE6D",
            lastName: "\uC131",
            "lastName.invalid": "\uC131\uC744 \uC785\uB825\uD558\uC138\uC694.",
            mobileNumber: "\uD734\uB300\uD3F0 \uBC88\uD638",
            "mobileNumber.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uD734\uB300\uD3F0 \uBC88\uD638",
            city: "\uC2DC",
            postalCode: "\uC6B0\uD3B8\uBC88\uD638",
            "postalCode.optional": "\uC6B0\uD3B8\uBC88\uD638(\uC120\uD0DD \uC0AC\uD56D)",
            countryCode: "\uAD6D\uAC00 \uCF54\uB4DC",
            telephoneNumber: "\uC804\uD654\uBC88\uD638",
            dateOfBirth: "\uC0DD\uB144\uC6D4\uC77C",
            shopperEmail: "\uC774\uBA54\uC77C \uC8FC\uC18C",
            gender: "\uC131\uBCC4",
            "gender.notselected": "\uC131\uBCC4 \uC120\uD0DD",
            male: "\uB0A8\uC131",
            female: "\uC5EC\uC131",
            billingAddress: "\uCCAD\uAD6C\uC9C0 \uC8FC\uC18C",
            street: "\uB3C4\uB85C\uBA85",
            stateOrProvince: "\uC8FC/\uB3C4",
            country: "\uAD6D\uAC00/\uC9C0\uC5ED",
            houseNumberOrName: "\uC9D1 \uC804\uD654\uBC88\uD638",
            separateDeliveryAddress: "\uBC30\uC1A1 \uC8FC\uC18C \uBCC4\uB3C4 \uC9C0\uC815",
            deliveryAddress: "\uBC30\uC1A1 \uC8FC\uC18C",
            "deliveryAddress.firstName": "\uBC1B\uB294 \uC0AC\uB78C \uC774\uB984",
            "deliveryAddress.lastName": "\uBC1B\uB294 \uC0AC\uB78C \uC131",
            zipCode: "\uC6B0\uD3B8\uBC88\uD638",
            apartmentSuite: "\uC544\uD30C\uD2B8/\uAC74\uBB3C",
            provinceOrTerritory: "\uB3C4",
            cityTown: "\uC2DC/\uAD6C",
            address: "\uC8FC\uC18C",
            "address.placeholder": "\uC8FC\uC18C \uCC3E\uAE30",
            "address.errors.incomplete": "\uACC4\uC18D \uC9C4\uD589\uD558\uB824\uBA74 \uC8FC\uC18C \uC785\uB825",
            "address.enterManually": "\uC218\uB3D9\uC73C\uB85C \uC8FC\uC18C \uC785\uB825",
            state: "\uC8FC",
            "field.title.optional": "(\uC120\uD0DD \uC0AC\uD56D)",
            "creditCard.cvcField.title.optional": "\uBCF4\uC548 \uCF54\uB4DC(\uC120\uD0DD \uC0AC\uD56D)",
            "issuerList.wallet.placeholder": "\uC804\uC790 \uC9C0\uAC11 \uC120\uD0DD",
            privacyPolicy: "\uAC1C\uC778\uC815\uBCF4 \uBCF4\uD638\uC815\uCC45",
            "afterPay.agreement": "Riverty\uC758 %@\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4.",
            paymentConditions: "\uACB0\uC81C \uC870\uAC74",
            openApp: "\uC571 \uC5F4\uAE30",
            "voucher.readInstructions": "\uC548\uB0B4 \uC77D\uAE30",
            "voucher.introduction": "\uAD6C\uB9E4\uD574 \uC8FC\uC154\uC11C \uAC10\uC0AC\uD569\uB2C8\uB2E4. \uB2E4\uC74C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9\uD558\uC5EC \uACB0\uC81C\uB97C \uC644\uB8CC\uD558\uC2ED\uC2DC\uC624.",
            "voucher.expirationDate": "\uB9CC\uB8CC\uC77C",
            "voucher.alternativeReference": "\uB300\uCCB4 \uCC38\uC870\uBC88\uD638",
            "dragonpay.voucher.non.bank.selectField.placeholder": "\uC81C\uACF5 \uC5C5\uCCB4 \uC120\uD0DD",
            "dragonpay.voucher.bank.selectField.placeholder": "\uC740\uD589 \uC120\uD0DD",
            "voucher.paymentReferenceLabel": "\uACB0\uC81C \uCC38\uC870\uBC88\uD638",
            "voucher.surcharge": "%@ \uD560\uC99D\uB8CC \uD3EC\uD568",
            "voucher.introduction.doku": "\uAD6C\uB9E4\uD574 \uC8FC\uC154\uC11C \uAC10\uC0AC\uD569\uB2C8\uB2E4. \uB2E4\uC74C \uC815\uBCF4\uB97C \uC774\uC6A9\uD558\uC5EC \uACB0\uC81C\uB97C \uC644\uB8CC\uD558\uC2ED\uC2DC\uC624.",
            "voucher.shopperName": "\uAD6C\uB9E4\uC790 \uC774\uB984",
            "voucher.merchantName": "\uAC00\uB9F9\uC810",
            "voucher.introduction.econtext": "\uAD6C\uB9E4\uD574 \uC8FC\uC154\uC11C \uAC10\uC0AC\uD569\uB2C8\uB2E4. \uB2E4\uC74C \uC815\uBCF4\uB97C \uC774\uC6A9\uD558\uC5EC \uACB0\uC81C\uB97C \uC644\uB8CC\uD558\uC2ED\uC2DC\uC624.",
            "voucher.telephoneNumber": "\uC804\uD654\uBC88\uD638",
            "voucher.shopperReference": "\uAD6C\uB9E4\uC790 \uCC38\uC870\uBC88\uD638",
            "voucher.collectionInstitutionNumber": "\uC218\uAE08 \uAE30\uAD00 \uBC88\uD638",
            "voucher.econtext.telephoneNumber.invalid": "\uC804\uD654\uBC88\uD638\uB294 10\uC790\uB9AC \uB610\uB294 11\uC790\uB9AC \uC22B\uC790\uC5EC\uC57C \uD569\uB2C8\uB2E4",
            "boletobancario.btnLabel": "Boleto \uC0DD\uC131",
            "boleto.sendCopyToEmail": "\uB0B4 \uC774\uBA54\uC77C\uB85C \uC0AC\uBCF8 \uBCF4\uB0B4\uAE30",
            "button.copy": "\uBCF5\uC0AC",
            "button.download": "\uB2E4\uC6B4\uB85C\uB4DC",
            "boleto.socialSecurityNumber.invalid": "\uC62C\uBC14\uB978 CPF/CNPJ \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "creditCard.storedCard.description.ariaLabel": "\uC800\uC7A5\uB41C \uCE74\uB4DC\uB294 %@ \uD6C4 \uC885\uB8CC\uB429\uB2C8\uB2E4.",
            "voucher.entity": "\uBC1C\uAE09\uC0AC",
            donateButton: "\uAE30\uBD80\uD558\uAE30",
            notNowButton: "\uB2E4\uC74C\uC5D0 \uD558\uAE30",
            thanksForYourSupport: "\uB3C4\uC640\uC8FC\uC154\uC11C \uAC10\uC0AC\uD569\uB2C8\uB2E4!",
            "resultMessages.preauthorized": "\uC138\uBD80 \uC815\uBCF4 \uC800\uC7A5\uB428",
            preauthorizeWith: "\uC0AC\uC804 \uC2B9\uC778 \uBC29\uBC95:",
            confirmPreauthorization: "\uC0AC\uC804 \uC2B9\uC778 \uD655\uC778",
            confirmPurchase: "\uAD6C\uB9E4 \uD655\uC778",
            applyGiftcard: "\uAE30\uD504\uD2B8 \uCE74\uB4DC\uB85C \uACB0\uC81C",
            giftcardBalance: "\uAE30\uD504\uD2B8 \uCE74\uB4DC \uC794\uC561",
            deductedBalance: "\uACF5\uC81C \uC794\uC561",
            "creditCard.pin.title": "\uBE44\uBC00\uBC88\uD638",
            "creditCard.encryptedPassword.label": "\uCE74\uB4DC \uBE44\uBC00\uBC88\uD638 \uCCAB 2\uC790\uB9AC",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uBC88\uD638",
            "creditCard.taxNumber": "\uCE74\uB4DC \uC18C\uC720\uC790 \uC0DD\uB144\uC6D4\uC77C \uB610\uB294 \uBC95\uC778 \uB4F1\uB85D \uBC88\uD638",
            "creditCard.taxNumber.label": "\uCE74\uB4DC \uC18C\uC720\uC790 \uC0DD\uB144\uC6D4\uC77C(\uC608: 870130) \uB610\uB294 \uBC95\uC778 \uB4F1\uB85D \uBC88\uD638(10\uC790\uB9AC)",
            "creditCard.taxNumber.labelAlt": "\uBC95\uC778 \uB4F1\uB85D \uBC88\uD638(10\uC790\uB9AC)",
            "creditCard.taxNumber.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uCE74\uB4DC \uC18C\uC720\uC790 \uC0DD\uB144\uC6D4\uC77C \uB610\uB294 \uBC95\uC778 \uB4F1\uB85D \uBC88\uD638",
            "storedPaymentMethod.disable.button": "\uC0AD\uC81C",
            "storedPaymentMethod.disable.confirmation": "\uC800\uC7A5\uB41C \uACB0\uC81C \uC218\uB2E8 \uC0AD\uC81C",
            "storedPaymentMethod.disable.confirmButton": "\uC608, \uC0AD\uC81C\uD569\uB2C8\uB2E4",
            "storedPaymentMethod.disable.cancelButton": "\uCDE8\uC18C",
            "ach.bankAccount": "\uC740\uD589 \uACC4\uC88C",
            "ach.accountHolderNameField.title": "\uACC4\uC88C \uC18C\uC720\uC790 \uC774\uB984",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uACC4\uC88C \uC18C\uC720\uC790 \uC774\uB984",
            "ach.accountNumberField.title": "\uACC4\uC88C \uBC88\uD638",
            "ach.accountNumberField.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uACC4\uC88C \uBC88\uD638",
            "ach.accountLocationField.title": "ABA \uB77C\uC6B0\uD305 \uBC88\uD638",
            "ach.accountLocationField.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 ABA \uB77C\uC6B0\uD305 \uBC88\uD638",
            "ach.savedBankAccount": "\uC800\uC7A5\uB41C \uC740\uD589 \uACC4\uC88C",
            "select.state": "\uC8FC \uC120\uD0DD",
            "select.stateOrProvince": "\uC8FC/\uB3C4 \uC120\uD0DD",
            "select.provinceOrTerritory": "\uB3C4 \uC120\uD0DD",
            "select.country": "\uAD6D\uAC00/\uC9C0\uC5ED \uC120\uD0DD",
            "select.noOptionsFound": "\uAC80\uC0C9\uB41C \uC635\uC158 \uC5C6\uC74C",
            "select.filter.placeholder": "\uAC80\uC0C9...",
            "telephoneNumber.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC804\uD654\uBC88\uD638",
            qrCodeOrApp: "\uB610\uB294",
            "paypal.processingPayment": "\uACB0\uC81C \uCC98\uB9AC \uC911...",
            generateQRCode: "QR \uCF54\uB4DC \uC0DD\uC131",
            "await.waitForConfirmation": "\uD655\uC778 \uB300\uAE30\uC911",
            "mbway.confirmPayment": "MB WAY \uC571\uC5D0\uC11C \uACB0\uC81C\uB97C \uD655\uC778\uD558\uC2ED\uC2DC\uC624",
            "shopperEmail.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC774\uBA54\uC77C \uC8FC\uC18C",
            "dateOfBirth.format": "DD(\uC77C)/MM(\uC6D4)/YYYY(\uC5F0\uB3C4)",
            "dateOfBirth.invalid": "\uB9CC 18\uC138 \uC774\uC0C1\uC784\uC744 \uB098\uD0C0\uB0B4\uB294 \uC720\uD6A8\uD55C \uC0DD\uB144\uC6D4\uC77C\uC744 \uC785\uB825\uD569\uB2C8\uB2E4.",
            "blik.confirmPayment": "\uBC45\uD0B9 \uC571\uC744 \uC5F4\uC5B4\uC11C \uACB0\uC81C\uB97C \uD655\uC778\uD558\uC138\uC694.",
            "blik.invalid": "6\uC790\uB9AC \uC22B\uC790 \uC785\uB825",
            "blik.code": "6\uC790\uB9AC \uCF54\uB4DC",
            "blik.help": "\uBC45\uD0B9 \uC571\uC5D0\uC11C \uCF54\uB4DC\uB97C \uAC00\uC838\uC624\uC138\uC694.",
            "swish.pendingMessage": "\uC2A4\uCE94 \uD6C4 \uCD5C\uB300 10\uBD84 \uB3D9\uC548 \uC0C1\uD0DC\uAC00 \uBCF4\uB958\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4. 10\uBD84 \uB0B4\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD560 \uACBD\uC6B0 \uAE08\uC561\uC774 \uC5EC\uB7EC \uBC88 \uCCAD\uAD6C\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
            "field.valid": "\uD544\uB4DC\uAC00 \uC720\uD6A8\uD569\uB2C8\uB2E4",
            "field.invalid": "\uD544\uB4DC\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
            "error.va.gen.01": "\uBBF8\uC644\uB8CC \uD544\uB4DC",
            "error.va.gen.02": "\uD544\uB4DC\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
            "error.va.sf-cc-num.01": "\uC62C\uBC14\uB978 \uCE74\uB4DC \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-num.02": "\uCE74\uB4DC \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-num.03": "\uC9C0\uC6D0\uB418\uB294 \uCE74\uB4DC \uBE0C\uB79C\uB4DC\uB97C \uD558\uC138\uC694.",
            "error.va.sf-cc-num.04": "\uC804\uCCB4 \uCE74\uB4DC \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-dat.01": "\uC62C\uBC14\uB978 \uB9CC\uB8CC\uC77C\uC744 \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-dat.02": "\uC62C\uBC14\uB978 \uB9CC\uB8CC\uC77C\uC744 \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-dat.03": "\uC2E0\uC6A9 \uCE74\uB4DC\uAC00 \uACE7 \uB9CC\uB8CC\uB429\uB2C8\uB2E4.",
            "error.va.sf-cc-dat.04": "\uB9CC\uB8CC\uC77C\uC744 \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-dat.05": "\uC804\uCCB4 \uB9CC\uB8CC\uC77C\uC744 \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-mth.01": "\uB9CC\uB8CC \uC6D4\uC744 \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-yr.01": "\uB9CC\uB8CC \uC5F0\uB3C4\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-yr.02": "\uC804\uCCB4 \uB9CC\uB8CC \uC5F0\uB3C4\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-cvc.01": "\uBCF4\uC548 \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-cvc.02": "\uC804\uCCB4 \uBCF4\uC548 \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-ach-num.01": "\uACC4\uC88C \uBC88\uD638 \uC785\uB825\uB780\uC774 \uBE44\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
            "error.va.sf-ach-num.02": "\uACC4\uC88C \uBC88\uD638 \uAE38\uC774\uAC00 \uC815\uD655\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
            "error.va.sf-ach-loc.01": "\uC740\uD589 \uB77C\uC6B0\uD305 \uBC88\uD638 \uC785\uB825\uB780\uC774 \uBE44\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
            "error.va.sf-ach-loc.02": "\uC740\uD589 \uB77C\uC6B0\uD305 \uBC88\uD638 \uAE38\uC774\uAC00 \uC815\uD655\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
            "error.va.sf-kcp-pwd.01": "\uBE44\uBC00\uBC88\uD638 \uC785\uB825\uB780\uC774 \uBE44\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
            "error.va.sf-kcp-pwd.02": "\uBE44\uBC00\uBC88\uD638 \uAE38\uC774\uAC00 \uC798\uBABB\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
            "error.giftcard.no-balance": "\uC774 \uAE30\uD504\uD2B8 \uCE74\uB4DC\uC5D0\uB294 \uC794\uC561\uC774 \uC5C6\uC2B5\uB2C8\uB2E4",
            "error.giftcard.card-error": "\uC774 \uAE30\uD504\uD2B8 \uCE74\uB4DC \uBC88\uD638\uB294 \uB2F9\uC0AC\uC5D0 \uB4F1\uB85D\uB418\uC5B4 \uC788\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
            "error.giftcard.currency-error": "\uAE30\uD504\uD2B8 \uCE74\uB4DC\uB294 \uBC1C\uAE09\uB41C \uD1B5\uD654\uB85C\uB9CC \uC0AC\uC6A9\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4",
            "amazonpay.signout": "Amazon\uC5D0\uC11C \uB85C\uADF8\uC544\uC6C3",
            "amazonpay.changePaymentDetails": "\uACB0\uC81C \uC815\uBCF4 \uBCC0\uACBD",
            "partialPayment.warning": "\uB098\uBA38\uC9C0 \uBE44\uC6A9 \uC9C0\uBD88\uC5D0 \uC0AC\uC6A9\uD560 \uB2E4\uB978 \uACB0\uC81C \uC218\uB2E8 \uC120\uD0DD\uD558\uAE30",
            "partialPayment.remainingBalance": "\uB0A8\uC740 \uC794\uC561\uC740 %{amount}\uC785\uB2C8\uB2E4",
            "bankTransfer.beneficiary": "\uC218\uB839\uC778",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "\uCC38\uC870 \uBC88\uD638",
            "bankTransfer.introduction": "\uC0C8 \uACC4\uC88C \uC774\uCCB4 \uAC74\uC744 \uACC4\uC18D \uC9C4\uD589\uD569\uB2C8\uB2E4. \uB2E4\uC74C \uD654\uBA74\uC5D0 \uB098\uC624\uB294 \uC815\uBCF4\uB97C \uC774\uC6A9\uD574 \uC774\uCCB4\uB97C \uC644\uB8CC\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
            "bankTransfer.instructions": "\uAD6C\uB9E4\uD574 \uC8FC\uC154\uC11C \uAC10\uC0AC\uD569\uB2C8\uB2E4. \uB2E4\uC74C \uC815\uBCF4\uB97C \uC774\uC6A9\uD558\uC5EC \uACB0\uC81C\uB97C \uC644\uB8CC\uD558\uC2ED\uC2DC\uC624.",
            "bacs.accountHolderName": "\uC608\uAE08\uC8FC \uC774\uB984",
            "bacs.accountHolderName.invalid": "\uC608\uAE08\uC8FC \uC774\uB984\uC774 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
            "bacs.accountNumber": "\uACC4\uC88C \uBC88\uD638",
            "bacs.accountNumber.invalid": "\uACC4\uC88C \uBC88\uD638\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
            "bacs.bankLocationId": "\uC740\uD589 \uC2DD\uBCC4 \uCF54\uB4DC",
            "bacs.bankLocationId.invalid": "\uC740\uD589 \uC2DD\uBCC4 \uCF54\uB4DC\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
            "bacs.consent.amount": "\uACC4\uC88C\uC5D0\uC11C \uC704\uC758 \uAE08\uC561\uC744 \uC774\uCCB4\uD558\uB294 \uAC83\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4.",
            "bacs.consent.account": "\uBCF8\uC778\uC774 \uC774 \uACC4\uC88C\uC758 \uC608\uAE08\uC8FC\uC774\uBA70, \uC774 \uACC4\uC88C\uC5D0\uC11C\uC758 \uC790\uB3D9 \uC774\uCCB4\uB97C \uC2B9\uC778\uD558\uAE30 \uC704\uD574 \uD544\uC694\uD55C \uC720\uC77C\uD55C \uC11C\uBA85\uC778\uC785\uB2C8\uB2E4.",
            edit: "\uC218\uC815",
            "bacs.confirm": "\uD655\uC778 \uBC0F \uACB0\uC81C",
            "bacs.result.introduction": "\uC790\uB3D9 \uC774\uCCB4 \uC548\uB0B4(DDI/\uD544\uC218) \uB2E4\uC6B4\uB85C\uB4DC",
            "download.pdf": "PDF \uB2E4\uC6B4\uB85C\uB4DC",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "\uCE74\uB4DC \uBC88\uD638\uC6A9 Iframe",
            "creditCard.encryptedCardNumber.aria.label": "\uCE74\uB4DC \uBC88\uD638",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "\uB9CC\uB8CC \uB0A0\uC9DC\uC6A9 Iframe",
            "creditCard.encryptedExpiryDate.aria.label": "\uB9CC\uB8CC\uC77C",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "\uB9CC\uB8CC \uC6D4\uC6A9 Iframe",
            "creditCard.encryptedExpiryMonth.aria.label": "\uB9CC\uB8CC \uC6D4",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "\uB9CC\uB8CC \uC5F0\uB3C4\uC6A9 Iframe",
            "creditCard.encryptedExpiryYear.aria.label": "\uB9CC\uB8CC \uC5F0\uB3C4",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "\uBCF4\uC548 \uCF54\uB4DC\uC6A9 Iframe",
            "creditCard.encryptedSecurityCode.aria.label": "\uBCF4\uC548 \uCF54\uB4DC",
            "creditCard.encryptedPassword.aria.iframeTitle": "\uBE44\uBC00\uBC88\uD638\uC6A9 Iframe",
            "creditCard.encryptedPassword.aria.label": "\uCE74\uB4DC \uBE44\uBC00\uBC88\uD638 \uCCAB 2\uC790\uB9AC",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "\uCE74\uB4DC \uBC88\uD638\uC6A9 Iframe",
            "giftcard.encryptedCardNumber.aria.label": "\uCE74\uB4DC \uBC88\uD638",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "\uD540\uC6A9 Iframe",
            "giftcard.encryptedSecurityCode.aria.label": "\uBE44\uBC00\uBC88\uD638",
            giftcardTransactionLimit: "\uC774 \uAE30\uD504\uD2B8\uCE74\uB4DC\uB85C \uAC74\uB2F9 \uACB0\uC81C \uAC00\uB2A5\uD55C \uCD5C\uACE0 \uC561\uC218\uB294 %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "\uC740\uD589 \uACC4\uC88C \uBC88\uD638\uC6A9 Iframe",
            "ach.encryptedBankAccountNumber.aria.label": "\uACC4\uC88C \uBC88\uD638",
            "ach.encryptedBankLocationId.aria.iframeTitle": "\uC740\uD589 \uB77C\uC6B0\uD305 \uBC88\uD638\uC6A9 Iframe",
            "ach.encryptedBankLocationId.aria.label": "ABA \uB77C\uC6B0\uD305 \uBC88\uD638",
            "twint.saved": "\uC800\uC7A5\uB428",
            orPayWith: "\uAE30\uD0C0 \uACB0\uC81C \uC218\uB2E8:",
            invalidFormatExpects: "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uD615\uC2DD\uC785\uB2C8\uB2E4. \uC608\uC0C1 \uD615\uC2DD: %{format}",
            "upi.qrCodeWaitingMessage": "\uC990\uACA8 \uC4F0\uB294 UPI \uC571\uC73C\uB85C QR \uCF54\uB4DC\uB97C \uC2A4\uCE94\uD558\uC5EC \uACB0\uC81C\uD558\uC138\uC694",
            "upi.vpaWaitingMessage": "UPI \uC571\uC744 \uC5F4\uC5B4 \uACB0\uC81C\uB97C \uD655\uC778\uD558\uC138\uC694",
            "upi.modeSelection": "UPI\uB97C \uC0AC\uC6A9\uD560 \uBC29\uC2DD\uC744 \uC120\uD0DD\uD558\uC138\uC694.",
            "onlineBanking.termsAndConditions": "\uACC4\uC18D \uC9C4\uD589\uD558\uB294 \uACBD\uC6B0 %#\uC774\uC6A9\uC57D\uAD00%#\uC5D0 \uB3D9\uC758\uD558\uAC8C \uB429\uB2C8\uB2E4.",
            "onlineBankingPL.termsAndConditions": "\uACC4\uC18D \uC9C4\uD589\uD568\uC73C\uB85C\uC368 \uADC0\uD558\uB294 Przelewy24\uC758 %#\uADDC\uC815%# \uBC0F %#\uC815\uBCF4 \uC758\uBB34%#\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4.",
            "ctp.loading.poweredByCtp": "Click to Pay \uC81C\uACF5",
            "ctp.loading.intro": "Click to Pay\uB85C \uC800\uC7A5\uB41C \uCE74\uB4DC\uAC00 \uC788\uB294\uC9C0 \uD655\uC778 \uC911\uC785\uB2C8\uB2E4...",
            "ctp.login.title": "Click to Pay \uACC4\uC18D \uC9C4\uD589",
            "ctp.login.subtitle": "\uACC4\uC18D\uD558\uB824\uBA74 Click to Pay\uC5D0 \uC5F0\uACB0\uB41C \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "ctp.login.inputLabel": "\uC774\uBA54\uC77C",
            "ctp.logout.notYou": "\uBCF8\uC778\uC774 \uC544\uB2C8\uC2E0\uAC00\uC694?",
            "ctp.logout.notYourCards": "\uBCF8\uC778\uC758 \uCE74\uB4DC\uAC00 \uC544\uB2CC\uAC00\uC694?",
            "ctp.logout.notYourCard": "\uBCF8\uC778\uC758 \uCE74\uB4DC\uAC00 \uC544\uB2CC\uAC00\uC694?",
            "ctp.logout.notYourProfile": "\uBCF8\uC778\uC758 \uD504\uB85C\uD544\uC774 \uC544\uB2CC\uAC00\uC694?",
            "ctp.otp.fieldLabel": "\uC77C\uD68C\uC131 \uCF54\uB4DC",
            "ctp.otp.resendCode": "\uCF54\uB4DC \uC7AC\uC804\uC1A1",
            "ctp.otp.codeResent": "\uCF54\uB4DC \uC7AC\uC804\uC1A1\uB428",
            "ctp.otp.title": "Click to Pay \uCE74\uB4DC\uC5D0 \uC811\uADFC",
            "ctp.otp.subtitle": "%@\uB85C \uC804\uC1A1\uB41C %@ \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC5EC \uBCF8\uC778 \uC778\uC99D\uC744 \uC9C4\uD589\uD569\uB2C8\uB2E4.",
            "ctp.otp.saveCookiesCheckbox.label": "\uB2E4\uC74C \uBC88\uC5D0\uB294 \uC778\uC99D \uAC74\uB108\uB6F0\uAE30",
            "ctp.otp.saveCookiesCheckbox.information": "\uB354 \uBE60\uB978 \uACB0\uC81C\uB97C \uC704\uD574 \uC0AC\uC6A9\uC790 \uAE30\uAE30\uC640 \uCC38\uC5EC \uB9E4\uC7A5\uC758 \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uC815\uBCF4\uB97C \uAE30\uC5B5\uD558\uB3C4\uB85D \uC120\uD0DD\uD558\uC138\uC694. \uACF5\uC720 \uAE30\uAE30\uC5D0\uB294 \uAD8C\uC7A5\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "\uC7A5\uCE58\uC640 \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uAE30\uC5B5\uB418\uB3C4\uB85D \uC120\uD0DD\uD558\uAE30",
            "ctp.emptyProfile.message": "\uD574\uB2F9 Click to Pay \uD504\uB85C\uD544\uC5D0 \uB4F1\uB85D\uB41C \uCE74\uB4DC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4",
            "ctp.separatorText": "\uB610\uB294 \uC0AC\uC6A9",
            "ctp.cards.title": "Click to Pay\uB85C \uACB0\uC81C \uC644\uB8CC",
            "ctp.cards.subtitle": "\uC0AC\uC6A9\uD560 \uCE74\uB4DC\uB97C \uC120\uD0DD\uD558\uC138\uC694.",
            "ctp.cards.expiredCard": "\uB9CC\uB8CC\uB428",
            "ctp.manualCardEntry": "\uCE74\uB4DC \uC9C1\uC811 \uC785\uB825",
            "ctp.aria.infoModalButton": "Click to Pay\uB780?",
            "ctp.infoPopup.title": "Click to Pay\uB294 \uBE44\uC811\uCD09 \uACB0\uC81C\uC758 \uD3B8\uB9AC\uD568\uC744 \uC628\uB77C\uC778\uC73C\uB85C \uAC00\uC838\uC628 \uC11C\uBE44\uC2A4\uC785\uB2C8\uB2E4",
            "ctp.infoPopup.subtitle": "Mastercard, Visa, \uAE30\uD0C0 \uACB0\uC81C \uCE74\uB4DC\uB97C \uC9C0\uC6D0\uD558\uB294 \uBE60\uB974\uACE0 \uC548\uC804\uD55C \uACB0\uC81C \uC218\uB2E8\uC785\uB2C8\uB2E4.",
            "ctp.infoPopup.benefit1": "Click to Pay\uB294 \uC554\uD638\uD654\uB97C \uD1B5\uD574 \uC815\uBCF4\uB97C \uC548\uC804\uD558\uAC8C \uBCF4\uD638\uD569\uB2C8\uB2E4",
            "ctp.infoPopup.benefit2": "\uC804 \uC138\uACC4 \uAC00\uB9F9\uC810\uC5D0\uC11C \uC0AC\uC6A9\uD558\uC138\uC694",
            "ctp.infoPopup.benefit3": "\uD55C \uBC88\uB9CC \uC124\uC815\uD558\uBA74 \uC55E\uC73C\uB85C\uC758 \uACB0\uC81C\uAC00 \uAC04\uD3B8\uD574\uC9D1\uB2C8\uB2E4",
            "ctp.errors.AUTH_INVALID": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC778\uC99D\uC785\uB2C8\uB2E4",
            "ctp.errors.NOT_FOUND": "\uACC4\uC815\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC720\uD6A8\uD55C \uC774\uBA54\uC77C\uC744 \uC785\uB825\uD558\uAC70\uB098 \uCE74\uB4DC \uC815\uBCF4\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC5EC \uC9C4\uD589\uD558\uC138\uC694.",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "\uC9C0\uC6D0\uB418\uC9C0 \uC54A\uB294 \uD615\uC2DD\uC785\uB2C8\uB2E4",
            "ctp.errors.FRAUD": "\uC0AC\uC6A9\uC790 \uACC4\uC815\uC774 \uC7A0\uACA8 \uC788\uAC70\uB098 \uBE44\uD65C\uC131\uD654\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
            "ctp.errors.CONSUMER_ID_MISSING": "\uC694\uCCAD\uC5D0 \uC18C\uBE44\uC790 ID\uAC00 \uB204\uB77D\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
            "ctp.errors.ACCT_INACCESSIBLE": "\uC774 \uACC4\uC815\uC740 \uD604\uC7AC \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4(\uC608: \uC7A0\uACA8 \uC788\uC74C).",
            "ctp.errors.CODE_INVALID": "\uC798\uBABB\uB41C \uC778\uC99D \uCF54\uB4DC\uC785\uB2C8\uB2E4",
            "ctp.errors.CODE_EXPIRED": "\uB9CC\uB8CC\uB41C \uCF54\uB4DC\uC785\uB2C8\uB2E4",
            "ctp.errors.RETRIES_EXCEEDED": "OTP \uC0DD\uC131 \uC7AC\uC2DC\uB3C4 \uD69F\uC218 \uC81C\uD55C\uC744 \uCD08\uACFC\uD588\uC2B5\uB2C8\uB2E4",
            "ctp.errors.OTP_SEND_FAILED": "OTP\uB97C \uC218\uC2E0\uC778\uC5D0\uAC8C \uC804\uC1A1\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
            "ctp.errors.REQUEST_TIMEOUT": "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uAC70\uB098 \uCE74\uB4DC \uC815\uBCF4\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC138\uC694.",
            "ctp.errors.UNKNOWN_ERROR": "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uAC70\uB098 \uCE74\uB4DC \uC815\uBCF4\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC138\uC694.",
            "ctp.errors.SERVICE_ERROR": "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uAC70\uB098 \uCE74\uB4DC \uC815\uBCF4\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC138\uC694.",
            "ctp.errors.SERVER_ERROR": "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uAC70\uB098 \uCE74\uB4DC \uC815\uBCF4\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC138\uC694.",
            "ctp.errors.INVALID_PARAMETER": "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uAC70\uB098 \uCE74\uB4DC \uC815\uBCF4\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC138\uC694.",
            "ctp.errors.AUTH_ERROR": "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uAC70\uB098 \uCE74\uB4DC \uC815\uBCF4\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC138\uC694.",
            "paymentMethodsList.aria.label": "\uACB0\uC81C \uC218\uB2E8\uC744 \uC120\uD0DD\uD558\uC138\uC694",
            "companyDetails.name.invalid": "\uD68C\uC0AC \uC774\uB984\uC744 \uC785\uB825\uD558\uC138\uC694.",
            "companyDetails.registrationNumber.invalid": "\uB4F1\uB85D \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "consent.checkbox.invalid": "\uC774\uC6A9 \uC57D\uAD00\uC5D0 \uB3D9\uC758\uD574\uC57C \uD569\uB2C8\uB2E4.",
            "form.instruction": "\uBCC4\uB3C4\uB85C \uD45C\uC2DC\uB418\uC5B4 \uC788\uC9C0 \uC54A\uB294 \uD55C \uBAA8\uB4E0 \uD544\uB4DC\uB294 \uD544\uC218\uC785\uB2C8\uB2E4.",
            "trustly.descriptor": "\uC989\uC2DC \uC740\uD589 \uACB0\uC81C",
            "trustly.description1": "\uC740\uD589 \uC218\uC900\uC758 \uBCF4\uC548\uC774 \uC9C0\uC6D0\uB418\uB294 \uC740\uD589 \uACC4\uC88C\uC5D0\uC11C \uC9C1\uC811 \uACB0\uC81C\uD558\uC138\uC694.",
            "trustly.description2": "\uCE74\uB4DC, \uC571 \uB2E4\uC6B4\uB85C\uB4DC, \uB4F1\uB85D \uD544\uC694 \uC5C6\uC74C",
            "ancv.input.label": "\uB098\uC758 ANCV ID",
            "ancv.confirmPayment": "ANCV \uC560\uD50C\uB9AC\uCF00\uC774\uC158\uC744 \uC0AC\uC6A9\uD574 \uACB0\uC81C\uB97C \uD655\uC778\uD558\uC138\uC694.",
            "ancv.form.instruction": "\uC774 \uACB0\uC81C\uB97C \uC778\uC99D\uD558\uB824\uBA74 Cheque-Vacances \uC560\uD50C\uB9AC\uCF00\uC774\uC158\uC774 \uD544\uC694\uD569\uB2C8\uB2E4.",
            "ancv.beneficiaryId.invalid": "\uC720\uD6A8\uD55C \uC774\uBA54\uC77C \uC8FC\uC18C\uB098 ANCV ID\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "payme.openPayMeApp": "PayMe \uC571\uC5D0\uC11C \uACB0\uC81C\uB97C \uC2B9\uC778\uD558\uC5EC \uACB0\uC81C\uB97C \uC644\uB8CC\uD558\uACE0 \uD655\uC778\uC744 \uAE30\uB2E4\uB9BD\uB2C8\uB2E4.",
            "payme.redirectButtonLabel": "PayMe \uC571 \uC5F4\uAE30",
            "payme.scanQrCode": "QR \uCF54\uB4DC\uB85C \uACB0\uC81C \uC644\uB8CC",
            "payme.timeToPay": "\uC774 QR \uCF54\uB4DC\uB294 %@ \uB3D9\uC548 \uC720\uD6A8\uD569\uB2C8\uB2E4",
            "payme.instructions.steps": "PayMe \uC571\uC744 \uC5FD\uB2C8\uB2E4.%@QR \uCF54\uB4DC\uB97C \uC2A4\uCE94\uD558\uC5EC \uACB0\uC81C\uB97C \uC2B9\uC778\uD569\uB2C8\uB2E4.%@\uC571\uC5D0\uC11C \uACB0\uC81C\uB97C \uC644\uB8CC\uD558\uACE0 \uD655\uC778\uC744 \uAE30\uB2E4\uB9BD\uB2C8\uB2E4.",
            "payme.instructions.footnote": "\uACB0\uC81C\uAC00 \uC644\uB8CC\uB418\uAE30 \uC804\uC5D0 \uC774 \uD398\uC774\uC9C0\uB97C \uB2EB\uC9C0 \uB9C8\uC138\uC694."
        }
    }), B2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Betaal",
            "payButton.redirecting": "U wordt doorverwezen...",
            "payButton.with": "Betaal %{value} met %{maskedData}",
            "payButton.saveDetails": "Gegevens opslaan",
            close: "Sluiten",
            storeDetails: "Bewaar voor mijn volgende betaling",
            readMore: "Verder lezen",
            "creditCard.holderName": "Naam op kaart",
            "creditCard.holderName.placeholder": "J. Janssen",
            "creditCard.holderName.invalid": "Voer naam in zoals weergegeven op kaart",
            "creditCard.numberField.title": "Kaartnummer",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Vervaldatum",
            "creditCard.expiryDateField.placeholder": "MM/JJ",
            "creditCard.expiryDateField.month": "Maand",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "JJ",
            "creditCard.expiryDateField.year": "Jaar",
            "creditCard.cvcField.title": "Beveiligingscode",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Onthouden voor de volgende keer",
            "creditCard.cvcField.placeholder.4digits": "4 cijfers",
            "creditCard.cvcField.placeholder.3digits": "3 cijfers",
            "creditCard.taxNumber.placeholder": "JJMMDD / 0123456789",
            installments: "Aantal termijnen",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} maanden",
            "installments.oneTime": "Eenmalige betaling",
            "installments.installments": "Betaling termijnen",
            "installments.revolving": "Terugkerende betaling",
            "sepaDirectDebit.ibanField.invalid": "Ongeldig rekeningnummer",
            "sepaDirectDebit.nameField.placeholder": "J. Janssen",
            "sepa.ownerName": "Ten name van",
            "sepa.ibanNumber": "Rekeningnummer (IBAN)",
            "error.title": "Fout",
            "error.subtitle.redirect": "Doorsturen niet gelukt",
            "error.subtitle.payment": "Betaling is niet geslaagd",
            "error.subtitle.refused": "Betaling geweigerd",
            "error.message.unknown": "Er is een onbekende fout opgetreden",
            "errorPanel.title": "Bestaande fouten",
            "idealIssuer.selectField.title": "Bank",
            "idealIssuer.selectField.placeholder": "Selecteer uw bank",
            "creditCard.success": "Betaling geslaagd",
            loading: "Laden...",
            continue: "Doorgaan",
            continueTo: "Doorgaan naar",
            "wechatpay.timetopay": "U heeft %@ om te betalen",
            "sr.wechatpay.timetopay": "U hebt %#minuten%# %#seconden%# om te betalen",
            "wechatpay.scanqrcode": "QR-code scannen",
            personalDetails: "Persoonlijke gegevens",
            companyDetails: "Bedrijfsgegevens",
            "companyDetails.name": "Bedrijfsnaam",
            "companyDetails.registrationNumber": "Registratienummer",
            socialSecurityNumber: "Burgerservicenummer",
            firstName: "Voornaam",
            "firstName.invalid": "Voer je voornaam in",
            infix: "Voorvoegsel",
            lastName: "Achternaam",
            "lastName.invalid": "Voer je achternaam in",
            mobileNumber: "Telefoonnummer mobiel",
            "mobileNumber.invalid": "Ongeldig mobiel nummer",
            city: "Stad",
            postalCode: "Postcode",
            "postalCode.optional": "Postcode (optioneel)",
            countryCode: "Landcode",
            telephoneNumber: "Telefoonnummer",
            dateOfBirth: "Geboortedatum",
            shopperEmail: "E-mailadres",
            gender: "Geslacht",
            "gender.notselected": "Selecteer uw geslacht",
            male: "Man",
            female: "Vrouw",
            billingAddress: "Factuuradres",
            street: "Straatnaam",
            stateOrProvince: "Staat of provincie",
            country: "Land/regio",
            houseNumberOrName: "Huisnummer",
            separateDeliveryAddress: "Een afwijkend bezorgadres opgeven",
            deliveryAddress: "Bezorgadres",
            "deliveryAddress.firstName": "Voornaam ontvanger",
            "deliveryAddress.lastName": "Achternaam ontvanger",
            zipCode: "Postcode",
            apartmentSuite: "Appartement/Suite",
            provinceOrTerritory: "Provincie of territorium",
            cityTown: "Stad",
            address: "Adres",
            "address.placeholder": "Zoek uw adres",
            "address.errors.incomplete": "Voer een adres in om verder te gaan",
            "address.enterManually": "Voer het adres handmatig in",
            state: "Staat",
            "field.title.optional": "(optioneel)",
            "creditCard.cvcField.title.optional": "Beveiligingscode (optioneel)",
            "issuerList.wallet.placeholder": "Selecteer uw portemonnee",
            privacyPolicy: "Privacybeleid",
            "afterPay.agreement": "Ik ga akkoord met de %@ van Riverty",
            paymentConditions: "betalingsvoorwaarden",
            openApp: "Open de app",
            "voucher.readInstructions": "Instructies lezen",
            "voucher.introduction": "Bedankt voor uw aankoop. Gebruik deze coupon om uw betaling te voltooien.",
            "voucher.expirationDate": "Vervaldatum",
            "voucher.alternativeReference": "Alternatieve referentie",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Selecteer uw aanbieder",
            "dragonpay.voucher.bank.selectField.placeholder": "Selecteer uw bank",
            "voucher.paymentReferenceLabel": "Betalingsreferentie",
            "voucher.surcharge": "Inclusief %@ toeslag",
            "voucher.introduction.doku": "Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.",
            "voucher.shopperName": "Klantnaam",
            "voucher.merchantName": "Verkoper",
            "voucher.introduction.econtext": "Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.",
            "voucher.telephoneNumber": "Telefoonnummer",
            "voucher.shopperReference": "Klant referentie",
            "voucher.collectionInstitutionNumber": "Nummer ophaallocatie",
            "voucher.econtext.telephoneNumber.invalid": "Het telefoonnummer moet uit 10 of 11 cijfers bestaan",
            "boletobancario.btnLabel": "Boleto genereren",
            "boleto.sendCopyToEmail": "Stuur een kopie naar mijn e-mailadres",
            "button.copy": "Kopi\xebren",
            "button.download": "Downloaden",
            "boleto.socialSecurityNumber.invalid": "Voer een geldig CPF/CNPJ-nummer in",
            "creditCard.storedCard.description.ariaLabel": "Opgeslagen kaart eindigt op %@",
            "voucher.entity": "Entiteit",
            donateButton: "Doneren",
            notNowButton: "Niet nu",
            thanksForYourSupport: "Bedankt voor uw donatie!",
            "resultMessages.preauthorized": "Gegevens opgeslagen",
            preauthorizeWith: "Preautorisatie uitvoeren met",
            confirmPreauthorization: "Preautorisatie bevestigen",
            confirmPurchase: "Aankoop bevestigen",
            applyGiftcard: "Inwisselen",
            giftcardBalance: "Saldo cadeaukaart",
            deductedBalance: "Afgetrokken bedrag",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "Eerste twee cijfers van het wachtwoord van de kaart",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Ongeldig wachtwoord",
            "creditCard.taxNumber": "Geboortedatum of bedrijfsregistratienummer van kaarthouder",
            "creditCard.taxNumber.label": "Geboortedatum (JJ-MM-DD) of bedrijfsregistratienummer (10 cijfers) van kaarthouder",
            "creditCard.taxNumber.labelAlt": "Bedrijfsregistratienummer (10 cijfers)",
            "creditCard.taxNumber.invalid": "Geboortedatum of bedrijfsregistratienummer van kaarthouder is ongeldig",
            "storedPaymentMethod.disable.button": "Verwijderen",
            "storedPaymentMethod.disable.confirmation": "Opgeslagen betalingsmethode verwijderen",
            "storedPaymentMethod.disable.confirmButton": "Ja, verwijderen",
            "storedPaymentMethod.disable.cancelButton": "Annuleren",
            "ach.bankAccount": "Bankrekening",
            "ach.accountHolderNameField.title": "Naam rekeninghouder",
            "ach.accountHolderNameField.placeholder": "J. Janssen",
            "ach.accountHolderNameField.invalid": "Ongeldige naam rekeninghouder",
            "ach.accountNumberField.title": "Rekeningnummer",
            "ach.accountNumberField.invalid": "Ongeldig rekeningnummer",
            "ach.accountLocationField.title": "Routingnummer (ABA)",
            "ach.accountLocationField.invalid": "Ongeldig routingnummer (ABA)",
            "ach.savedBankAccount": "Opgeslagen bankrekening",
            "select.state": "Selecteer staat",
            "select.stateOrProvince": "Selecteer staat of provincie",
            "select.provinceOrTerritory": "Selecteer provincie of territorium",
            "select.country": "Selecteer land/regio",
            "select.noOptionsFound": "Geen opties gevonden",
            "select.filter.placeholder": "Zoeken...",
            "telephoneNumber.invalid": "Ongeldig telefoonnummer",
            qrCodeOrApp: "of",
            "paypal.processingPayment": "Betaling wordt verwerkt...",
            generateQRCode: "Genereer QR-code",
            "await.waitForConfirmation": "Wacht op bevestiging",
            "mbway.confirmPayment": "Bevestig uw betaling via de MB WAY-app",
            "shopperEmail.invalid": "Ongeldig e-mailadres",
            "dateOfBirth.format": "DD/MM/JJJJ",
            "dateOfBirth.invalid": "Voer een geldige geboortedatum in die aangeeft dat u ten minste 18 jaar oud bent",
            "blik.confirmPayment": "Open uw bankapp om de betaling te bevestigen.",
            "blik.invalid": "Voer 6 cijfers in",
            "blik.code": "6-cijferige code",
            "blik.help": "Haal de code op in uw bankapp.",
            "swish.pendingMessage": "Nadat u hebt gescand, kan de status maximaal 10 minuten in behandeling zijn. Als u binnen deze periode opnieuw probeert te betalen, kunnen er meerdere keren kosten in rekening worden gebracht.",
            "field.valid": "Geldig veld",
            "field.invalid": "Veld niet geldig",
            "error.va.gen.01": "Onvolledig veld",
            "error.va.gen.02": "Veld niet geldig",
            "error.va.sf-cc-num.01": "Voer een geldig kaartnummer in",
            "error.va.sf-cc-num.02": "Voer het kaartnummer in",
            "error.va.sf-cc-num.03": "Voer een ondersteund kaartmerk in",
            "error.va.sf-cc-num.04": "Voer het volledige kaartnummer in",
            "error.va.sf-cc-dat.01": "Voer een geldige vervaldatum in",
            "error.va.sf-cc-dat.02": "Voer een geldige vervaldatum in",
            "error.va.sf-cc-dat.03": "Creditcard vervalt bijna",
            "error.va.sf-cc-dat.04": "Voer de vervaldatum in",
            "error.va.sf-cc-dat.05": "Voer de volledige vervaldatum in",
            "error.va.sf-cc-mth.01": "Voer de vervalmaand in",
            "error.va.sf-cc-yr.01": "Voer het vervaljaar in",
            "error.va.sf-cc-yr.02": "Voer het volledige vervaljaar in",
            "error.va.sf-cc-cvc.01": "Voer de beveiligingscode in",
            "error.va.sf-cc-cvc.02": "Voer de volledige beveiligingscode in",
            "error.va.sf-ach-num.01": "Leeg veld voor bankrekeningnummer",
            "error.va.sf-ach-num.02": "Bankrekeningnummer heeft de verkeerde lengte",
            "error.va.sf-ach-loc.01": "Leeg veld voor swiftcode van de bank",
            "error.va.sf-ach-loc.02": "Swiftcode van de bank heeft de verkeerde lengte",
            "error.va.sf-kcp-pwd.01": "Leeg wachtwoordveld",
            "error.va.sf-kcp-pwd.02": "Wachtwoord heeft de verkeerde lengte",
            "error.giftcard.no-balance": "Deze cadeaukaart heeft geen saldo",
            "error.giftcard.card-error": "We hebben geen cadeaukaart met dit nummer in onze administratie",
            "error.giftcard.currency-error": "Cadeaukaarten zijn alleen geldig in de valuta waarin ze zijn uitgegeven",
            "amazonpay.signout": "Afmelden bij Amazon",
            "amazonpay.changePaymentDetails": "Betalingsgegevens wijzigen",
            "partialPayment.warning": "Selecteer een andere betaalmethode om het resterende deel te betalen",
            "partialPayment.remainingBalance": "Het resterende saldo is %{amount}",
            "bankTransfer.beneficiary": "Begunstigde",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Referentie",
            "bankTransfer.introduction": "Ga door om een nieuwe overschrijving aan te maken. U kunt de gegevens in het volgende scherm gebruiken om deze betaling af te ronden.",
            "bankTransfer.instructions": "Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.",
            "bacs.accountHolderName": "Naam bankrekeninghouder",
            "bacs.accountHolderName.invalid": "Ongeldige naam bankrekeninghouder",
            "bacs.accountNumber": "Bankrekeningnummer",
            "bacs.accountNumber.invalid": "Ongeldig bankrekeningnummer",
            "bacs.bankLocationId": "Bankcode",
            "bacs.bankLocationId.invalid": "Ongeldige bankcode",
            "bacs.consent.amount": "Ik ga ermee akkoord dat het bovengenoemde bedrag van mijn bankrekening wordt afgeschreven.",
            "bacs.consent.account": "Ik bevestig dat de rekening op mijn naam staat en dat ik de enige ondertekenaar ben die toestemming kan geven voor automatische incasso's vanaf deze rekening.",
            edit: "Bewerken",
            "bacs.confirm": "Bevestigen en betalen",
            "bacs.result.introduction": "Download uw machtiging automatische incasso",
            "download.pdf": "PDF downloaden",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe voor kaartnummer",
            "creditCard.encryptedCardNumber.aria.label": "Kaartnummer",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe voor vervaldatum",
            "creditCard.encryptedExpiryDate.aria.label": "Vervaldatum",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe voor vervalmaand",
            "creditCard.encryptedExpiryMonth.aria.label": "Vervalmaand",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe voor vervaljaar",
            "creditCard.encryptedExpiryYear.aria.label": "Vervaljaar",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe voor beveiligingscode",
            "creditCard.encryptedSecurityCode.aria.label": "Beveiligingscode",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe voor wachtwoord",
            "creditCard.encryptedPassword.aria.label": "Eerste twee cijfers van het wachtwoord van de kaart",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe voor kaartnummer",
            "giftcard.encryptedCardNumber.aria.label": "Kaartnummer",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe voor PIN",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "Max. %{amount} toegestaan per transactie met deze cadeaubon",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe voor bankrekeningnummer",
            "ach.encryptedBankAccountNumber.aria.label": "Rekeningnummer",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe voor bankroutingnummer",
            "ach.encryptedBankLocationId.aria.label": "Routingnummer (ABA)",
            "twint.saved": "opgeslagen",
            orPayWith: "of betaal met",
            invalidFormatExpects: "Ongeldige indeling. Verwachte indeling: %{format}",
            "upi.qrCodeWaitingMessage": "Scan de QR-code met je favoriete UPI-app om de betaling te voltooien",
            "upi.vpaWaitingMessage": "Open je UPI-app om de betaling te bevestigen",
            "upi.modeSelection": "Maak een selectie over hoe u UPI wilt gebruiken.",
            "onlineBanking.termsAndConditions": "Door verder te gaan gaat u akkoord met de %#algemene voorwaarden%#",
            "onlineBankingPL.termsAndConditions": "Door verder te gaan stemt u in met de %#richtlijnen%# en %#informatieverplichting%# van Przelewy24",
            "ctp.loading.poweredByCtp": "Mogelijk gemaakt door Click to Pay",
            "ctp.loading.intro": "We controleren of u opgeslagen kaarten heeft bij Click to Pay...",
            "ctp.login.title": "Ga verder naar Click to Pay",
            "ctp.login.subtitle": "Voer het aan Click to Pay gekoppelde e-mailadres in om verder te gaan.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "Bent u dit niet?",
            "ctp.logout.notYourCards": "Niet uw kaarten?",
            "ctp.logout.notYourCard": "Niet uw kaart?",
            "ctp.logout.notYourProfile": "Niet uw profiel?",
            "ctp.otp.fieldLabel": "Eenmalige code",
            "ctp.otp.resendCode": "Code opnieuw verzenden",
            "ctp.otp.codeResent": "Code opnieuw verzonden",
            "ctp.otp.title": "Ga naar uw Click to Pay-kaarten",
            "ctp.otp.subtitle": "Voer de code %@ in die naar %@ is gestuurd, zodat we kunnen verifi\xebren dat u het bent.",
            "ctp.otp.saveCookiesCheckbox.label": "Verificatie de volgende keer overslaan",
            "ctp.otp.saveCookiesCheckbox.information": "Selecteer om te worden onthouden op uw apparaat en in uw browser bij deelnemende winkels, zodat u sneller kunt afrekenen. Niet aanbevolen voor gedeelde apparaten.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Selecteer om onthouden te worden op uw apparaat en browser",
            "ctp.emptyProfile.message": "Geen kaarten geregistreerd voor dit Click to Pay-profiel",
            "ctp.separatorText": "of gebruik",
            "ctp.cards.title": "Voltooi de betaling met Click to Pay",
            "ctp.cards.subtitle": "Selecteer een kaart om te gebruiken.",
            "ctp.cards.expiredCard": "Verlopen",
            "ctp.manualCardEntry": "Handmatige kaartinvoer",
            "ctp.aria.infoModalButton": "Wat is Click to Pay?",
            "ctp.infoPopup.title": "Met Click to Pay betaalt u nu ook contactloos online",
            "ctp.infoPopup.subtitle": "Een snelle en veilige betaalmethode, ondersteund door Mastercard, Visa en andere betaalkaarten.",
            "ctp.infoPopup.benefit1": "Click to Pay maakt gebruik van versleuteling om uw informatie veilig te houden",
            "ctp.infoPopup.benefit2": "Gebruik het bij winkeliers over de hele wereld",
            "ctp.infoPopup.benefit3": "E\xe9n keer instellen voor probleemloze betalingen",
            "ctp.errors.AUTH_INVALID": "Authenticatie ongeldig",
            "ctp.errors.NOT_FOUND": "Geen account gevonden, voer een geldig e-mailadres in of ga door met het handmatig invoeren van kaarten",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Formaat wordt niet ondersteund",
            "ctp.errors.FRAUD": "Gebruikersaccount vergrendeld of uitgeschakeld",
            "ctp.errors.CONSUMER_ID_MISSING": "Identiteit van de consument ontbreekt in het verzoek",
            "ctp.errors.ACCT_INACCESSIBLE": "Dit account is momenteel niet beschikbaar, omdat het bijvoorbeeld is vergrendeld",
            "ctp.errors.CODE_INVALID": "Onjuiste verificatiecode",
            "ctp.errors.CODE_EXPIRED": "Deze code is verlopen",
            "ctp.errors.RETRIES_EXCEEDED": "De limiet voor het aantal pogingen voor het genereren van een OTP is overschreden",
            "ctp.errors.OTP_SEND_FAILED": "Het OTP kan niet naar de ontvanger worden verzonden",
            "ctp.errors.REQUEST_TIMEOUT": "Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer",
            "ctp.errors.UNKNOWN_ERROR": "Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer",
            "ctp.errors.SERVICE_ERROR": "Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer",
            "ctp.errors.SERVER_ERROR": "Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer",
            "ctp.errors.INVALID_PARAMETER": "Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer",
            "ctp.errors.AUTH_ERROR": "Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer",
            "paymentMethodsList.aria.label": "Kies een betaalmethode",
            "companyDetails.name.invalid": "Voer de bedrijfsnaam in",
            "companyDetails.registrationNumber.invalid": "Voer het registratienummer in",
            "consent.checkbox.invalid": "Je moet akkoord gaan met de algemene voorwaarden",
            "form.instruction": "Alle velden zijn verplicht, tenzij anders aangegeven.",
            "ancv.input.label": "Uw ANCV-identificatie",
            "ancv.confirmPayment": "Gebruik uw ANCV-toepassing om de betaling te bevestigen.",
            "ancv.form.instruction": "De Cheque-Vacances applicatie is nodig om deze betaling te valideren.",
            "ancv.beneficiaryId.invalid": "Voer een geldig e-mailadres of ANCV-id in",
            "payme.openPayMeApp": "Voltooi uw betaling door deze te autoriseren in de PayMe-app en de bevestiging af te wachten.",
            "payme.redirectButtonLabel": "Open de PayMe-app",
            "payme.scanQrCode": "Voltooi uw betaling met een QR-code",
            "payme.timeToPay": "Deze QR-code is %@ geldig",
            "payme.instructions.steps": "Open de PayMe-app.%@Scan de QR-code om de betaling te autoriseren.%@Voltooi de betaling in de app en wacht de bevestiging af.",
            "payme.instructions.footnote": "Sluit deze pagina niet voordat de betaling is voltooid"
        }
    }), M2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Betal",
            "payButton.redirecting": "Omdirigerer...",
            "payButton.with": "Betal %{value} med %{maskedData}",
            "payButton.saveDetails": "Lagre detaljer",
            close: "Lukk",
            storeDetails: "Lagre til min neste betaling",
            readMore: "Les mer",
            "creditCard.holderName": "Navn p\xe5 kortet",
            "creditCard.holderName.placeholder": "O. Nordmann",
            "creditCard.holderName.invalid": "Skriv inn navnet som vist p\xe5 kortet",
            "creditCard.numberField.title": "Kortnummer",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Utl\xf8psdato",
            "creditCard.expiryDateField.placeholder": "MM/\xc5\xc5",
            "creditCard.expiryDateField.month": "M\xe5ned",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "\xc5\xc5",
            "creditCard.expiryDateField.year": "\xc5r",
            "creditCard.cvcField.title": "Sikkerhetskode",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Husk til neste gang",
            "creditCard.cvcField.placeholder.4digits": "4 siffer",
            "creditCard.cvcField.placeholder.3digits": "3 siffer",
            "creditCard.taxNumber.placeholder": "YYMMDD / 0123456789",
            installments: "Antall avdrag",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} m\xe5neder",
            "installments.oneTime": "Engangsbetaling",
            "installments.installments": "Avdragsbetaling",
            "installments.revolving": "Gjentakende betaling",
            "sepaDirectDebit.ibanField.invalid": "Ugyldig kontonummer",
            "sepaDirectDebit.nameField.placeholder": "O. Nordmann",
            "sepa.ownerName": "Kortholders navn",
            "sepa.ibanNumber": "Kontonummer (IBAN)",
            "error.title": "Feil",
            "error.subtitle.redirect": "Videresending feilet",
            "error.subtitle.payment": "Betaling feilet",
            "error.subtitle.refused": "Betaling avvist",
            "error.message.unknown": "En ukjent feil oppstod",
            "errorPanel.title": "Eksisterende feil",
            "idealIssuer.selectField.title": "Bank",
            "idealIssuer.selectField.placeholder": "Velg din bank",
            "creditCard.success": "Betalingen var vellykket",
            loading: "Laster...",
            continue: "Fortsett",
            continueTo: "Fortsett til",
            "wechatpay.timetopay": "Du har %@ igjen til \xe5 betale",
            "sr.wechatpay.timetopay": "Du har %#minutter%# og %#sekunder%# p\xe5 deg til \xe5 betale",
            "wechatpay.scanqrcode": "Skann QR-kode",
            personalDetails: "Personopplysninger",
            companyDetails: "Firmadetaljer",
            "companyDetails.name": "Firmanavn",
            "companyDetails.registrationNumber": "Registreringsnummer",
            socialSecurityNumber: "Personnummer",
            firstName: "Fornavn",
            "firstName.invalid": "Skriv inn fornavnet ditt",
            infix: "Prefiks",
            lastName: "Etternavn",
            "lastName.invalid": "Skriv inn etternavnet ditt",
            mobileNumber: "Mobilnummer",
            "mobileNumber.invalid": "Ugyldig mobilnummer",
            city: "Poststed",
            postalCode: "Postnummer",
            "postalCode.optional": "Postnummer (valgfritt)",
            countryCode: "Landkode",
            telephoneNumber: "Telefonnummer",
            dateOfBirth: "F\xf8dselsdato",
            shopperEmail: "E-postadresse",
            gender: "Kj\xf8nn",
            "gender.notselected": "Velg kj\xf8nn",
            male: "Mann",
            female: "Kvinne",
            billingAddress: "Faktureringsadresse",
            street: "Gate",
            stateOrProvince: "Fylke",
            country: "Land/region",
            houseNumberOrName: "Husnummer",
            separateDeliveryAddress: "Spesifiser en separat leveringsadresse",
            deliveryAddress: "Leveringsadresse",
            "deliveryAddress.firstName": "Mottakerens fornavn",
            "deliveryAddress.lastName": "Mottakerens etternavn",
            zipCode: "Postnummer",
            apartmentSuite: "Leilighet/suite",
            provinceOrTerritory: "Provins eller territorium",
            cityTown: "By",
            address: "Adresse",
            "address.placeholder": "Finn adressen din",
            "address.errors.incomplete": "Skriv inn en adresse for \xe5 fortsette",
            "address.enterManually": "Skriv inn adressen manuelt",
            state: "Delstat",
            "field.title.optional": "(valgfritt)",
            "creditCard.cvcField.title.optional": "Sikkerhetskode (valgfritt)",
            "issuerList.wallet.placeholder": "Velg lommebok",
            privacyPolicy: "Retningslinjer for personvern",
            "afterPay.agreement": "Jeg godtar Rivertys %@",
            paymentConditions: "betalingsbetingelser",
            openApp: "\xc5pne appen",
            "voucher.readInstructions": "Les instruksjoner",
            "voucher.introduction": "Takk for ditt kj\xf8p. Vennligst bruk den f\xf8lgende kupongen til \xe5 fullf\xf8re betalingen.",
            "voucher.expirationDate": "Utl\xf8psdato",
            "voucher.alternativeReference": "Alternativ referanse",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Velg din leverand\xf8r",
            "dragonpay.voucher.bank.selectField.placeholder": "Velg din bank",
            "voucher.paymentReferenceLabel": "Betalingsreferanse",
            "voucher.surcharge": "Inkl. %@ tilleggsavgift",
            "voucher.introduction.doku": "Takk for ditt kj\xf8p, vennligst bruk den f\xf8lgende informasjonen for \xe5 fullf\xf8re betalingen.",
            "voucher.shopperName": "Kundenavn",
            "voucher.merchantName": "Forhandler",
            "voucher.introduction.econtext": "Takk for ditt kj\xf8p, vennligst bruk den f\xf8lgende informasjonen for \xe5 fullf\xf8re betalingen.",
            "voucher.telephoneNumber": "Telefonnummer",
            "voucher.shopperReference": "Kundereferanse",
            "voucher.collectionInstitutionNumber": "Innbetalingslokasjonsnummer",
            "voucher.econtext.telephoneNumber.invalid": "Telefonnummeret m\xe5 v\xe6re 10 eller 11 sifre langt",
            "boletobancario.btnLabel": "Generer Boleto",
            "boleto.sendCopyToEmail": "Send meg en kopi p\xe5 e-post",
            "button.copy": "Kopier",
            "button.download": "Last ned",
            "boleto.socialSecurityNumber.invalid": "Skriv inn et gyldig CPF/CNPJ-nummer",
            "creditCard.storedCard.description.ariaLabel": "Lagret kort slutter p\xe5 %@",
            "voucher.entity": "Enhet",
            donateButton: "Don\xe9r",
            notNowButton: "Ikke n\xe5",
            thanksForYourSupport: "Takk for din st\xf8tte!",
            "resultMessages.preauthorized": "Detaljer lagret",
            preauthorizeWith: "Forh\xe5ndsgodkjenn med",
            confirmPreauthorization: "Bekreft forh\xe5ndsgodkjenning",
            confirmPurchase: "Bekreft kj\xf8p",
            applyGiftcard: "L\xf8s inn",
            giftcardBalance: "Gavekortsaldo",
            deductedBalance: "Fratrukket bel\xf8p",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "F\xf8rste 2 sifre av kortpassord",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Ugyldig passord",
            "creditCard.taxNumber": "Kortholders f\xf8dselsdato eller bedriftsregistreringsnummer",
            "creditCard.taxNumber.label": "Kortholders f\xf8dselsdato (YYMMDD) eller bedriftsregistreringsnummer (10 siffer)",
            "creditCard.taxNumber.labelAlt": "Bedriftsregistreringsnummer (10 siffer)",
            "creditCard.taxNumber.invalid": "Ugyldig kortholders f\xf8dselsdato eller bedriftsregistreringsnummer",
            "storedPaymentMethod.disable.button": "Fjern",
            "storedPaymentMethod.disable.confirmation": "Fjern lagret betalingsmetode",
            "storedPaymentMethod.disable.confirmButton": "Ja, fjern",
            "storedPaymentMethod.disable.cancelButton": "Avbryt",
            "ach.bankAccount": "Bankkonto",
            "ach.accountHolderNameField.title": "Kontoholders navn",
            "ach.accountHolderNameField.placeholder": "O. Nordmann",
            "ach.accountHolderNameField.invalid": "Ugyldig navn p\xe5 kontoholder",
            "ach.accountNumberField.title": "Kontonummer",
            "ach.accountNumberField.invalid": "Ugyldig kontonummer",
            "ach.accountLocationField.title": "ABA-dirigeringsnummer",
            "ach.accountLocationField.invalid": "Ugyldig ABA-dirigeringsnummer",
            "ach.savedBankAccount": "Lagret bankkonto",
            "select.state": "Velg delstat",
            "select.stateOrProvince": "Velg delstat eller provins",
            "select.provinceOrTerritory": "Velg provins eller territorium",
            "select.country": "Velg land/region",
            "select.noOptionsFound": "Ingen alternativer funnet",
            "select.filter.placeholder": "S\xf8k\u2026",
            "telephoneNumber.invalid": "Ugyldig telefonnummer",
            qrCodeOrApp: "eller",
            "paypal.processingPayment": "Behandler betaling\u2026",
            generateQRCode: "Generer QR-kode",
            "await.waitForConfirmation": "Venter p\xe5 bekreftelse",
            "mbway.confirmPayment": "Bekreft betalingen din i MB WAY-appen",
            "shopperEmail.invalid": "Ugyldig e-postadresse",
            "dateOfBirth.format": "DD/MM/\xc5\xc5\xc5\xc5",
            "dateOfBirth.invalid": "Skriv inn en gyldig f\xf8dselsdato som viser at du er minst 18 \xe5r gammel",
            "blik.confirmPayment": "\xc5pne bank-appen din for \xe5 bekrefte betalingen.",
            "blik.invalid": "Tast inn 6 tall",
            "blik.code": "6-sifret kode",
            "blik.help": "Hent koden fra bank-appen din.",
            "swish.pendingMessage": "Etter at du har skannet koden kan det ta opptil 10 minutter f\xf8r betalingen vises som bekreftet. Fors\xf8k p\xe5 \xe5 betale igjen kan f\xf8re til flere innbetalinger.",
            "field.valid": "Feltet er gyldig",
            "field.invalid": "Feltet er ikke gyldig",
            "error.va.gen.01": "Ufullstendig felt",
            "error.va.gen.02": "Feltet er ikke gyldig",
            "error.va.sf-cc-num.01": "Angi et gyldig kortnummer",
            "error.va.sf-cc-num.02": "Angi kortnummeret",
            "error.va.sf-cc-num.03": "Angi et st\xf8ttet kortmerke",
            "error.va.sf-cc-num.04": "Angi hele kortnummeret",
            "error.va.sf-cc-dat.01": "Angi en gyldig utl\xf8psdato",
            "error.va.sf-cc-dat.02": "Angi en gyldig utl\xf8psdato",
            "error.va.sf-cc-dat.03": "Kredittkortet er i ferd med \xe5 utl\xf8pe",
            "error.va.sf-cc-dat.04": "Angi utl\xf8psdatoen",
            "error.va.sf-cc-dat.05": "Angi den fullstendige utl\xf8psdatoen",
            "error.va.sf-cc-mth.01": "Angi utl\xf8psm\xe5neden",
            "error.va.sf-cc-yr.01": "Angi utl\xf8ps\xe5ret",
            "error.va.sf-cc-yr.02": "Angi det fullstendige utl\xf8ps\xe5ret",
            "error.va.sf-cc-cvc.01": "Angi sikkerhetskoden",
            "error.va.sf-cc-cvc.02": "Angi den fullstendige sikkerhetskoden",
            "error.va.sf-ach-num.01": "Feltet for bankkontonummer er tomt",
            "error.va.sf-ach-num.02": "Bankkontonummeret har feil lengde",
            "error.va.sf-ach-loc.01": "Feltet for bankens routingnummer er tomt",
            "error.va.sf-ach-loc.02": "Bankens routingnummer har feil lengde",
            "error.va.sf-kcp-pwd.01": "Passordfeltet er tomt",
            "error.va.sf-kcp-pwd.02": "Passordet har feil lengde",
            "error.giftcard.no-balance": "Dette gavekortet har en saldo p\xe5 null",
            "error.giftcard.card-error": "Vi har ikke noe gavekort med dette nummeret i registrene v\xe5re",
            "error.giftcard.currency-error": "Gavekort er kun gyldige i den valutaen de ble utstedt i",
            "amazonpay.signout": "Logg ut av Amazon",
            "amazonpay.changePaymentDetails": "Endre betalingsdetaljer",
            "partialPayment.warning": "Velg en annen betalingsmetode for \xe5 betale det gjenv\xe6rende",
            "partialPayment.remainingBalance": "Gjenv\xe6rende saldo vil v\xe6re %{amount}",
            "bankTransfer.beneficiary": "Mottaker",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "referanse",
            "bankTransfer.introduction": "Fortsett for \xe5 opprette en ny betaling via bankoverf\xf8ring. Du kan bruke detaljene i det f\xf8lgende skjermbildet for \xe5 fullf\xf8re betalingen.",
            "bankTransfer.instructions": "Takk for kj\xf8pet. Vennligst benytt den f\xf8lgende informasjonen til \xe5 fullf\xf8re betalingen.",
            "bacs.accountHolderName": "Kontoholders navn",
            "bacs.accountHolderName.invalid": "Ugyldig kontoholdernavn",
            "bacs.accountNumber": "Bankkontonummer",
            "bacs.accountNumber.invalid": "Ugyldig bankkontonummer",
            "bacs.bankLocationId": "Sorteringskode",
            "bacs.bankLocationId.invalid": "Ugyldig sorteringskode",
            "bacs.consent.amount": "Jeg samtykker til at bel\xf8pet ovenfor blir trukket fra bankkontoen min.",
            "bacs.consent.account": "Jeg bekrefter at kontoen st\xe5r i mitt navn, og at jeg er den eneste signataren som kreves for \xe5 autorisere direktebelastningen p\xe5 denne kontoen.",
            edit: "Endre",
            "bacs.confirm": "Bekreft og betal",
            "bacs.result.introduction": "Last ned instruksjoner for direktebelastning (DDI/ mandat)",
            "download.pdf": "Last ned PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe for kortnummer",
            "creditCard.encryptedCardNumber.aria.label": "Kortnummer",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe for utl\xf8psdato",
            "creditCard.encryptedExpiryDate.aria.label": "Utl\xf8psdato",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe for utl\xf8psm\xe5ned",
            "creditCard.encryptedExpiryMonth.aria.label": "Utl\xf8psm\xe5ned",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe for utl\xf8ps\xe5r",
            "creditCard.encryptedExpiryYear.aria.label": "Utl\xf8ps\xe5r",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe for sikkerhetskode",
            "creditCard.encryptedSecurityCode.aria.label": "Sikkerhetskode",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe for passord",
            "creditCard.encryptedPassword.aria.label": "F\xf8rste 2 sifre av kortpassord",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe for kortnummer",
            "giftcard.encryptedCardNumber.aria.label": "Kortnummer",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe for PIN-kode",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "Maksimalt %{amount} per transaksjon er tillatt p\xe5 dette gavekortet",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe for bankkontonummer",
            "ach.encryptedBankAccountNumber.aria.label": "Kontonummer",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe for bankens routingnummer",
            "ach.encryptedBankLocationId.aria.label": "ABA-dirigeringsnummer",
            "twint.saved": "lagret",
            orPayWith: "eller betal med",
            invalidFormatExpects: "Ugyldig format. Forventet format: %{format}",
            "upi.qrCodeWaitingMessage": "Skann QR-koden ved \xe5 bruke din foretrukne UPI-app for \xe5 fullf\xf8re betalingen",
            "upi.vpaWaitingMessage": "\xc5pne UPI-appen for \xe5 bekrefte betalingen",
            "upi.modeSelection": "Velg hvordan du vil bruke UPI.",
            "onlineBanking.termsAndConditions": "Ved \xe5 fortsette godtar du %#terms and conditions%#",
            "onlineBankingPL.termsAndConditions": "Ved \xe5 fortsette godtar du %#reglene%# og %#informasjonsplikten%# til Przelewy24.",
            "ctp.loading.poweredByCtp": "Drevet av Click to Pay",
            "ctp.loading.intro": "Vi sjekker om du har noen lagrede kort med Click to Pay\u2026",
            "ctp.login.title": "Fortsett til Click to Pay",
            "ctp.login.subtitle": "Skriv inn e-postadressen som er tilknyttet Click to Pay, for \xe5 fortsette.",
            "ctp.login.inputLabel": "E-postadresse",
            "ctp.logout.notYou": "Ikke deg?",
            "ctp.logout.notYourCards": "Ikke dine kort?",
            "ctp.logout.notYourCard": "Ikke ditt kort?",
            "ctp.logout.notYourProfile": "Ikke din profil?",
            "ctp.otp.fieldLabel": "Engangskode",
            "ctp.otp.resendCode": "Send kode p\xe5 nytt",
            "ctp.otp.codeResent": "Kode er sendt p\xe5 nytt",
            "ctp.otp.title": "F\xe5 tilgang til Click to Pay-kortene dine",
            "ctp.otp.subtitle": "Tast inn koden vi sendte til %@, for \xe5 verifisere at det er deg.",
            "ctp.otp.saveCookiesCheckbox.label": "Hopp over verifisering neste gang",
            "ctp.otp.saveCookiesCheckbox.information": "Velg for \xe5 bli husket p\xe5 enheten og i nettleseren din i deltakende butikker for raskere betaling. Anbefales ikke for delte enheter.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Velg for \xe5 bli husket p\xe5 enheten og i nettleseren din",
            "ctp.emptyProfile.message": "Ingen kort er registrert i denne Click to Pay-profilen",
            "ctp.separatorText": "eller bruk",
            "ctp.cards.title": "Fullf\xf8r betalingen med Click to Pay",
            "ctp.cards.subtitle": "Velg et kort du vil bruke.",
            "ctp.cards.expiredCard": "Utl\xf8pt",
            "ctp.manualCardEntry": "Manuell inntasting av kort",
            "ctp.aria.infoModalButton": "Hva er Click to Pay",
            "ctp.infoPopup.title": "Click to Pay gj\xf8r kontaktl\xf8st mulig ogs\xe5 p\xe5 nettet",
            "ctp.infoPopup.subtitle": "En rask, sikker betalingsmetode st\xf8ttet av Mastercard, Visa og andre betalingskort.",
            "ctp.infoPopup.benefit1": "Click to Pay bruker kryptering for \xe5 holde informasjonen din sikker",
            "ctp.infoPopup.benefit2": "Bruk den hos forhandlere over hele verden",
            "ctp.infoPopup.benefit3": "Konfigurer \xe9n gang for lettvinte betalinger i fremtiden",
            "ctp.errors.AUTH_INVALID": "Autentiseringen er ugyldig",
            "ctp.errors.NOT_FOUND": "Vi finner ingen konto. Skriv inn en gyldig e-postadresse eller fortsett ved hjelp av manuell kortinntasting",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Formatet st\xf8ttes ikke",
            "ctp.errors.FRAUD": "Brukerkontoen er l\xe5st eller deaktivert",
            "ctp.errors.CONSUMER_ID_MISSING": "Forbrukerens identitet mangler i foresp\xf8rselen",
            "ctp.errors.ACCT_INACCESSIBLE": "Denne kontoen er for \xf8yeblikket ikke tilgjengelig, f.eks. kan den v\xe6re l\xe5st",
            "ctp.errors.CODE_INVALID": "Feil verifiseringskode",
            "ctp.errors.CODE_EXPIRED": "Denne koden er utl\xf8pt",
            "ctp.errors.RETRIES_EXCEEDED": "Grensen for antall fors\xf8k p\xe5 generering av engangspassord er overskredet",
            "ctp.errors.OTP_SEND_FAILED": "Engangspassordet kunne ikke sendes til mottakeren",
            "ctp.errors.REQUEST_TIMEOUT": "Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen",
            "ctp.errors.UNKNOWN_ERROR": "Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen",
            "ctp.errors.SERVICE_ERROR": "Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen",
            "ctp.errors.SERVER_ERROR": "Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen",
            "ctp.errors.INVALID_PARAMETER": "Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen",
            "ctp.errors.AUTH_ERROR": "Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen",
            "paymentMethodsList.aria.label": "Velg en betalingsmetode",
            "companyDetails.name.invalid": "Skriv inn firmanavnet",
            "companyDetails.registrationNumber.invalid": "Angi registreringsnummeret",
            "consent.checkbox.invalid": "Du m\xe5 godta vilk\xe5rene",
            "form.instruction": "Alle felt er obligatoriske med mindre annet er angitt.",
            "ancv.input.label": "ANCV-identifikasjonen din",
            "ancv.confirmPayment": "Bruk ANCV-appen for \xe5 bekrefte betalingen.",
            "ancv.form.instruction": "Cheque-Vacances-appen er n\xf8dvendig for \xe5 validere denne betalingen.",
            "ancv.beneficiaryId.invalid": "Oppgi en gyldig e-postadresse eller ANCV-ID",
            "payme.openPayMeApp": "Fullf\xf8r betalingen i PayMe-appen ved \xe5 godkjenne betalingen i appen og vente p\xe5 bekreftelse.",
            "payme.redirectButtonLabel": "\xc5pne PayMe-appen",
            "payme.scanQrCode": "Fullf\xf8r betalingen via QR-kode",
            "payme.timeToPay": "Denne QR-koden er gyldig i %@",
            "payme.instructions.steps": "\xc5pne PayMe-appen.%@Skann QR-koden for \xe5 autorisere betalingen.%@Fullf\xf8r betalingen i appen, og vent p\xe5 bekreftelsen.",
            "payme.instructions.footnote": "Ikke lukk denne siden f\xf8r betalingen er fullf\xf8rt"
        }
    }), L2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Zap\u0142a\u0107",
            "payButton.redirecting": "Przekierowywanie...",
            "payButton.with": "Zap\u0142a\u0107 %{value} za pomoc\u0105 %{maskedData}",
            "payButton.saveDetails": "Zapisz dane",
            close: "Zamknij",
            storeDetails: "Zapisz na potrzeby nast\u0119pnej p\u0142atno\u015Bci",
            readMore: "Czytaj wi\u0119cej",
            "creditCard.holderName": "Imi\u0119 i nazwisko na karcie",
            "creditCard.holderName.placeholder": "J. Kowalski",
            "creditCard.holderName.invalid": "Wpisz imi\u0119 i nazwisko w takim formacie, jak na karcie",
            "creditCard.numberField.title": "Numer karty ",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Data wa\u017Cno\u015Bci",
            "creditCard.expiryDateField.placeholder": "MM/RR",
            "creditCard.expiryDateField.month": "Miesi\u0105c",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "RR",
            "creditCard.expiryDateField.year": "Rok",
            "creditCard.cvcField.title": "Kod zabezpieczaj\u0105cy",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Zapami\u0119taj na przysz\u0142o\u015B\u0107",
            "creditCard.cvcField.placeholder.4digits": "4 cyfry",
            "creditCard.cvcField.placeholder.3digits": "3 cyfry",
            "creditCard.taxNumber.placeholder": "RRMMDD / 0123456789",
            installments: "Liczba rat",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} miesi\u0119cy",
            "installments.oneTime": "P\u0142atno\u015B\u0107 jednorazowa",
            "installments.installments": "P\u0142atno\u015B\u0107 ratalna",
            "installments.revolving": "P\u0142atno\u015B\u0107 odnawialna",
            "sepaDirectDebit.ibanField.invalid": "Nieprawid\u0142owy numer rachunku",
            "sepaDirectDebit.nameField.placeholder": "J. Kowalski",
            "sepa.ownerName": "Imi\u0119 i nazwisko posiadacza karty",
            "sepa.ibanNumber": "Numer rachunku (IBAN)",
            "error.title": "B\u0142\u0105d",
            "error.subtitle.redirect": "Przekierowanie nie powiod\u0142o si\u0119",
            "error.subtitle.payment": "P\u0142atno\u015B\u0107 nie powiod\u0142a si\u0119",
            "error.subtitle.refused": "P\u0142atno\u015B\u0107 zosta\u0142a odrzucona",
            "error.message.unknown": "Wyst\u0105pi\u0142 nieoczekiwany b\u0142\u0105d",
            "errorPanel.title": "Istniej\u0105ce b\u0142\u0119dy",
            "idealIssuer.selectField.title": "Bank",
            "idealIssuer.selectField.placeholder": "Wybierz sw\xf3j bank",
            "creditCard.success": "P\u0142atno\u015B\u0107 zako\u0144czona sukcesem",
            loading: "\u0141adowanie...",
            continue: "Kontynuuj",
            continueTo: "Przejd\u017A do",
            "wechatpay.timetopay": "Masz do zap\u0142acenia %@",
            "sr.wechatpay.timetopay": "Masz %#min%# %#s%#, aby zap\u0142aci\u0107",
            "wechatpay.scanqrcode": "Zeskanuj kod QR",
            personalDetails: "Dane osobowe",
            companyDetails: "Dane firmy",
            "companyDetails.name": "Nazwa firmy",
            "companyDetails.registrationNumber": "Numer w rejestrze",
            socialSecurityNumber: "Numer dowodu osobistego",
            firstName: "Imi\u0119",
            "firstName.invalid": "Wpisz imi\u0119",
            infix: "Prefiks",
            lastName: "Nazwisko",
            "lastName.invalid": "Wpisz nazwisko",
            mobileNumber: "Numer telefonu kom\xf3rkowego",
            "mobileNumber.invalid": "Nieprawid\u0142owy numer telefonu kom\xf3rkowego",
            city: "Miasto",
            postalCode: "Kod pocztowy",
            "postalCode.optional": "Kod pocztowy (opcjonalnie)",
            countryCode: "Kod kraju",
            telephoneNumber: "Numer telefonu",
            dateOfBirth: "Data urodzenia",
            shopperEmail: "Adres e-mail",
            gender: "P\u0142e\u0107",
            "gender.notselected": "Wybierz p\u0142e\u0107",
            male: "M\u0119\u017Cczyzna",
            female: "Kobieta",
            billingAddress: "Adres rozliczeniowy",
            street: "Ulica",
            stateOrProvince: "Wojew\xf3dztwo",
            country: "Kraj/Region",
            houseNumberOrName: "Numer domu i mieszkania",
            separateDeliveryAddress: "Podaj osobny adres dostawy",
            deliveryAddress: "Adres dostawy",
            "deliveryAddress.firstName": "Imi\u0119 odbiorcy",
            "deliveryAddress.lastName": "Nazwisko odbiorcy",
            zipCode: "Kod pocztowy",
            apartmentSuite: "Numer domu/mieszkania",
            provinceOrTerritory: "Region lub terytorium",
            cityTown: "Miejscowo\u015B\u0107",
            address: "Adres",
            "address.placeholder": "Znajd\u017A sw\xf3j adres",
            "address.errors.incomplete": "Wprowad\u017A adres, aby kontynuowa\u0107",
            "address.enterManually": "Wprowad\u017A adres r\u0119cznie",
            state: "Stan",
            "field.title.optional": "(opcjonalnie)",
            "creditCard.cvcField.title.optional": "Kod zabezpieczaj\u0105cy (opcjonalnie)",
            "issuerList.wallet.placeholder": "Wybierz sw\xf3j portfel",
            privacyPolicy: "Polityka prywatno\u015Bci.",
            "afterPay.agreement": "Zgadzam si\u0119 z %@ Riverty",
            paymentConditions: "warunki p\u0142atno\u015Bci",
            openApp: "Otw\xf3rz aplikacj\u0119",
            "voucher.readInstructions": "Przeczytaj instrukcje",
            "voucher.introduction": "Dzi\u0119kujemy za zakup, doko\u0144cz p\u0142atno\u015B\u0107 przy u\u017Cyciu tego kuponu.",
            "voucher.expirationDate": "Data wa\u017Cno\u015Bci",
            "voucher.alternativeReference": "Dodatkowy numer referencyjny",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Wybierz dostawc\u0119",
            "dragonpay.voucher.bank.selectField.placeholder": "Wybierz sw\xf3j bank",
            "voucher.paymentReferenceLabel": "Nr referencyjny p\u0142atno\u015Bci",
            "voucher.surcharge": "Zawiera %@ op\u0142aty dodatkowej",
            "voucher.introduction.doku": "Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015B\u0107 przy u\u017Cyciu poni\u017Cszych informacji.",
            "voucher.shopperName": "Imi\u0119 i nazwisko klienta",
            "voucher.merchantName": "Sprzedaj\u0105cy",
            "voucher.introduction.econtext": "Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015B\u0107 przy u\u017Cyciu poni\u017Cszych informacji.",
            "voucher.telephoneNumber": "Numer telefonu",
            "voucher.shopperReference": "Dane referencyjne kupuj\u0105cych",
            "voucher.collectionInstitutionNumber": "Numer instytucji pobieraj\u0105cej op\u0142at\u0119",
            "voucher.econtext.telephoneNumber.invalid": "Numer telefonu musi mie\u0107 10 lub 11 cyfr",
            "boletobancario.btnLabel": "Wygeneruj p\u0142atno\u015B\u0107 Boleto",
            "boleto.sendCopyToEmail": "Wy\u015Blij kopi\u0119 na m\xf3j e-mail",
            "button.copy": "Kopiuj",
            "button.download": "Pobierz",
            "boleto.socialSecurityNumber.invalid": "Wprowad\u017A prawid\u0142owy numer CPF/CNPJ",
            "creditCard.storedCard.description.ariaLabel": "Zapisana karta ko\u0144czy si\u0119 na % @",
            "voucher.entity": "Pozycja",
            donateButton: "Przeka\u017C darowizn\u0119",
            notNowButton: "Nie teraz",
            thanksForYourSupport: "Dzi\u0119kujemy za wsparcie!",
            "resultMessages.preauthorized": "Zapisano dane",
            preauthorizeWith: "Autoryzuj wst\u0119pnie za pomoc\u0105:",
            confirmPreauthorization: "Potwierd\u017A autoryzacj\u0119 wst\u0119pn\u0105",
            confirmPurchase: "Potwierd\u017A zakup",
            applyGiftcard: "Wykorzystaj",
            giftcardBalance: "Saldo karty podarunkowej",
            deductedBalance: "Saldo potr\u0105cone",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "Pierwsze 2 cyfry has\u0142a karty",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Nieprawid\u0142owe has\u0142o",
            "creditCard.taxNumber": "Data urodzenia posiadacza karty lub firmowy numer rejestracyjny",
            "creditCard.taxNumber.label": "Data urodzenia posiadacza karty (RRMMDD) lub firmowy numer rejestracyjny (10 cyfr)",
            "creditCard.taxNumber.labelAlt": "Firmowy numer rejestracyjny (10 cyfr)",
            "creditCard.taxNumber.invalid": "Nieprawid\u0142owa data urodzenia posiadacza karty lub nieprawid\u0142owy firmowy numer rejestracyjny",
            "storedPaymentMethod.disable.button": "Usu\u0144",
            "storedPaymentMethod.disable.confirmation": "Usu\u0144 zapisan\u0105 metod\u0119 p\u0142atno\u015Bci",
            "storedPaymentMethod.disable.confirmButton": "Tak, usu\u0144",
            "storedPaymentMethod.disable.cancelButton": "Anuluj",
            "ach.bankAccount": "Rachunek bankowy",
            "ach.accountHolderNameField.title": "Imi\u0119 i nazwisko posiadacza rachunku",
            "ach.accountHolderNameField.placeholder": "J. Kowalski",
            "ach.accountHolderNameField.invalid": "Nieprawid\u0142owe imi\u0119 i nazwisko posiadacza rachunku",
            "ach.accountNumberField.title": "Numer rachunku",
            "ach.accountNumberField.invalid": "Nieprawid\u0142owy numer rachunku",
            "ach.accountLocationField.title": "Kod bankowy ABA Routing Number",
            "ach.accountLocationField.invalid": "Nieprawid\u0142owy kod bankowy ABA Routing Number",
            "ach.savedBankAccount": "Zapisane konto bankowe",
            "select.state": "Wybierz stan",
            "select.stateOrProvince": "Wybierz stan/wojew\xf3dztwo",
            "select.provinceOrTerritory": "Wybierz region/terytorium",
            "select.country": "Wybierz kraj/region",
            "select.noOptionsFound": "Nie znaleziono opcji",
            "select.filter.placeholder": "Szukaj...",
            "telephoneNumber.invalid": "Nieprawid\u0142owy numer telefonu",
            qrCodeOrApp: "lub",
            "paypal.processingPayment": "Przetwarzanie p\u0142atno\u015Bci...",
            generateQRCode: "Wygeneruj kod QR",
            "await.waitForConfirmation": "Oczekiwanie na potwierdzenie",
            "mbway.confirmPayment": "Potwierd\u017A p\u0142atno\u015B\u0107 w aplikacji MB WAY",
            "shopperEmail.invalid": "Niepoprawny adres email",
            "dateOfBirth.format": "DD/MM/RRRR",
            "dateOfBirth.invalid": "Podaj prawid\u0142ow\u0105 dat\u0119 urodzenia, \u015Bwiadcz\u0105c\u0105 o przekroczeniu 18 roku \u017Cycia.",
            "blik.confirmPayment": "Otw\xf3rz aplikacj\u0119 bankow\u0105, aby potwierdzi\u0107 p\u0142atno\u015B\u0107.",
            "blik.invalid": "Wpisz 6 cyfr",
            "blik.code": "6-cyfrowy kod",
            "blik.help": "Uzyskaj kod ze swojej aplikacji bankowej.",
            "swish.pendingMessage": "Po zeskanowaniu transakcja mo\u017Ce mie\u0107 status \u201EOczekuj\u0105ca\u201D do 10 minut. Pr\xf3ba ponownego dokonania p\u0142atno\u015Bci w tym czasie mo\u017Ce spowodowa\u0107 wielokrotne naliczenie op\u0142aty.",
            "field.valid": "Pole prawid\u0142owe",
            "field.invalid": "Dane w polu s\u0105 nieprawid\u0142owe",
            "error.va.gen.01": "Niekompletne dane w polu",
            "error.va.gen.02": "Dane w polu s\u0105 nieprawid\u0142owe",
            "error.va.sf-cc-num.01": "Wprowad\u017A prawid\u0142owy numer karty",
            "error.va.sf-cc-num.02": "Wprowad\u017A numer karty",
            "error.va.sf-cc-num.03": "Wprowad\u017A obs\u0142ugiwan\u0105 mark\u0119 karty",
            "error.va.sf-cc-num.04": "Wprowad\u017A pe\u0142ny numer karty",
            "error.va.sf-cc-dat.01": "Wprowad\u017A prawid\u0142ow\u0105 dat\u0119 wa\u017Cno\u015Bci",
            "error.va.sf-cc-dat.02": "Wprowad\u017A prawid\u0142ow\u0105 dat\u0119 wa\u017Cno\u015Bci",
            "error.va.sf-cc-dat.03": "Karta kredytowa wkr\xf3tce straci wa\u017Cno\u015B\u0107",
            "error.va.sf-cc-dat.04": "Wprowad\u017A dat\u0119 wa\u017Cno\u015Bci",
            "error.va.sf-cc-dat.05": "Wprowad\u017A pe\u0142n\u0105 dat\u0119 wa\u017Cno\u015Bci",
            "error.va.sf-cc-mth.01": "Wprowad\u017A miesi\u0105c daty wa\u017Cno\u015Bci",
            "error.va.sf-cc-yr.01": "Wprowad\u017A rok daty wa\u017Cno\u015Bci",
            "error.va.sf-cc-yr.02": "Wprowad\u017A pe\u0142ny rok daty wa\u017Cno\u015Bci",
            "error.va.sf-cc-cvc.01": "Wprowad\u017A kod zabezpieczaj\u0105cy",
            "error.va.sf-cc-cvc.02": "Wprowad\u017A pe\u0142ny kod zabezpieczaj\u0105cy",
            "error.va.sf-ach-num.01": "Pole Numer rachunku jest puste",
            "error.va.sf-ach-num.02": "Numer rachunku ma nieprawid\u0142ow\u0105 d\u0142ugo\u015B\u0107",
            "error.va.sf-ach-loc.01": "Pole Numer rozliczeniowy banku jest puste",
            "error.va.sf-ach-loc.02": "Numer rozliczeniowy banku ma nieprawid\u0142ow\u0105 d\u0142ugo\u015B\u0107",
            "error.va.sf-kcp-pwd.01": "Pole Has\u0142o jest puste",
            "error.va.sf-kcp-pwd.02": "Has\u0142o ma nieprawid\u0142ow\u0105 d\u0142ugo\u015B\u0107",
            "error.giftcard.no-balance": "Saldo karty podarunkowej jest puste",
            "error.giftcard.card-error": "W naszych rejestrach nie ma karty podarunkowej o tym numerze",
            "error.giftcard.currency-error": "Karty podarunkowe s\u0105 wa\u017Cne tylko w walucie, w kt\xf3rej zosta\u0142y wydane",
            "amazonpay.signout": "Wyloguj si\u0119 z Amazon",
            "amazonpay.changePaymentDetails": "Zmie\u0144 szczeg\xf3\u0142y p\u0142atno\u015Bci",
            "partialPayment.warning": "Wybierz inn\u0105 metod\u0119 p\u0142atno\u015Bci, aby zap\u0142aci\u0107 pozosta\u0142\u0105 kwot\u0119",
            "partialPayment.remainingBalance": "Pozosta\u0142e saldo wynosi %{kwota}",
            "bankTransfer.beneficiary": "Beneficjent",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Ref. sprze.",
            "bankTransfer.introduction": "Kontynuuj tworzenie nowej p\u0142atno\u015Bci przelewem bankowym. Mo\u017Cesz u\u017Cy\u0107 szczeg\xf3\u0142\xf3w na nast\u0119pnym ekranie, aby sfinalizowa\u0107 t\u0119 p\u0142atno\u015B\u0107.",
            "bankTransfer.instructions": "Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015B\u0107 przy u\u017Cyciu poni\u017Cszych informacji.",
            "bacs.accountHolderName": "Imi\u0119 i nazwisko posiadacza rachunku",
            "bacs.accountHolderName.invalid": "Nieprawid\u0142owe imi\u0119 i nazwisko posiadacza rachunku",
            "bacs.accountNumber": "Numer rachunku",
            "bacs.accountNumber.invalid": "Nieprawid\u0142owy numer rachunku",
            "bacs.bankLocationId": "Numer rozliczeniowy SORT",
            "bacs.bankLocationId.invalid": "Nieprawid\u0142owy numer rozliczeniowy SORT",
            "bacs.consent.amount": "Wyra\u017Cam zgod\u0119 na pobranie powy\u017Cszej kwoty z mojego rachunku bankowego.",
            "bacs.consent.account": "Potwierdzam, \u017Ce konto jest zarejestrowane na moje nazwisko i jestem jedynym sygnatariuszem wymaganym do autoryzacji polecenia zap\u0142aty na tym koncie.",
            edit: "Edytuj",
            "bacs.confirm": "Potwierd\u017A i zap\u0142a\u0107",
            "bacs.result.introduction": "Pobierz dyspozycj\u0119 polecenia zap\u0142aty (DDI/upowa\u017Cnienie)",
            "download.pdf": "Pobierz PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Element Iframe dla numeru karty",
            "creditCard.encryptedCardNumber.aria.label": "Numer karty ",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Element Iframe dla daty wa\u017Cno\u015Bci",
            "creditCard.encryptedExpiryDate.aria.label": "Data wa\u017Cno\u015Bci",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Element Iframe dla miesi\u0105ca daty wa\u017Cno\u015Bci",
            "creditCard.encryptedExpiryMonth.aria.label": "Data wa\u017Cno\u015Bci - miesi\u0105c",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Element Iframe dla roku daty wa\u017Cno\u015Bci",
            "creditCard.encryptedExpiryYear.aria.label": "Data wa\u017Cno\u015Bci - rok",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Element Iframe dla kodu zabezpieczaj\u0105cego",
            "creditCard.encryptedSecurityCode.aria.label": "Kod zabezpieczaj\u0105cy",
            "creditCard.encryptedPassword.aria.iframeTitle": "Element Iframe dla has\u0142a",
            "creditCard.encryptedPassword.aria.label": "Pierwsze 2 cyfry has\u0142a karty",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Element Iframe dla numeru karty",
            "giftcard.encryptedCardNumber.aria.label": "Numer karty ",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Element Iframe dla kodu PIN",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "Maks. dozwolona kwota (%{amount}) na transakcj\u0119 t\u0105 kart\u0105 upominkow\u0105",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Element Iframe dla numeru konta bankowego",
            "ach.encryptedBankAccountNumber.aria.label": "Numer rachunku",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Element Iframe dla numeru rozliczeniowego banku",
            "ach.encryptedBankLocationId.aria.label": "Kod bankowy ABA Routing Number",
            "twint.saved": "zapisano",
            orPayWith: "lub zap\u0142a\u0107",
            invalidFormatExpects: "Niepoprawny format. Oczekiwany format: %{format}",
            "upi.qrCodeWaitingMessage": "Zeskanuj kod QR za pomoc\u0105 preferowanej aplikacji UPI, aby doko\u0144czy\u0107 p\u0142atno\u015B\u0107",
            "upi.vpaWaitingMessage": "Otw\xf3rz aplikacj\u0119 UPI, aby potwierdzi\u0107 p\u0142atno\u015B\u0107",
            "upi.modeSelection": "Dokonaj wyboru sposobu korzystania z UPI.",
            "onlineBanking.termsAndConditions": "Kontynuuj\u0105c, zgadzasz si\u0119 z %#Warunkami \u015Bwiadczenia us\u0142ug%#.",
            "onlineBankingPL.termsAndConditions": "Kontynuuj\u0105c, akceptujesz %#przepisy%# oraz %#obowi\u0105zek informacyjny%# firmy Przelewy24",
            "ctp.loading.poweredByCtp": "Dzia\u0142a w oparciu o us\u0142ug\u0119 Click to Pay",
            "ctp.loading.intro": "Sprawdzamy, czy masz zapisane karty Click to Pay...",
            "ctp.login.title": "Przejd\u017A do Click to Pay",
            "ctp.login.subtitle": "Wprowad\u017A adres e-mail po\u0142\u0105czony z Click to Pay, aby kontynuowa\u0107.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "To nie Ty?",
            "ctp.logout.notYourCards": "To nie Twoje karty?",
            "ctp.logout.notYourCard": "To nie Twoja karta?",
            "ctp.logout.notYourProfile": "To nie Tw\xf3j profil?",
            "ctp.otp.fieldLabel": "Kod jednorazowy",
            "ctp.otp.resendCode": "Ponowne wys\u0142anie kodu",
            "ctp.otp.codeResent": "Wys\u0142ano kod ponownie",
            "ctp.otp.title": "Przejd\u017A do kart Click to Pay",
            "ctp.otp.subtitle": "Wprowad\u017A kod %@ wys\u0142any na adres %@, aby potwierdzi\u0107 swoj\u0105 to\u017Csamo\u015B\u0107.",
            "ctp.otp.saveCookiesCheckbox.label": "Nast\u0119pnym razem pomi\u0144 weryfikacj\u0119",
            "ctp.otp.saveCookiesCheckbox.information": "Wybierz opcj\u0119 zapami\u0119tywania na urz\u0105dzeniu i w przegl\u0105darce w sklepach uczestnicz\u0105cych w programie, aby przyspieszy\u0107 realizacj\u0119 transakcji. Niezalecane dla wsp\xf3\u0142u\u017Cytkowanych urz\u0105dze\u0144.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Wybierz, aby zapami\u0119ta\u0107 dane logowania na Twoim urz\u0105dzeniu i przegl\u0105darce",
            "ctp.emptyProfile.message": "W tym profilu Click to Pay nie zarejestrowano \u017Cadnych kart",
            "ctp.separatorText": "lub przypadk\xf3w jej u\u017Cycia",
            "ctp.cards.title": "Doko\u0144cz p\u0142atno\u015B\u0107 za pomoc\u0105 funkcji Click to Pay",
            "ctp.cards.subtitle": "Wybierz kart\u0119, kt\xf3rej chcesz u\u017Cy\u0107.",
            "ctp.cards.expiredCard": "Okres wa\u017Cno\u015Bci min\u0105\u0142",
            "ctp.manualCardEntry": "R\u0119czne wprowadzanie kart",
            "ctp.aria.infoModalButton": "Co to jest Click to Pay",
            "ctp.infoPopup.title": "Click to Pay zapewnia wygod\u0119 p\u0142atno\u015Bci zbli\u017Ceniowych w Internecie",
            "ctp.infoPopup.subtitle": "Szybka i bezpieczna metoda p\u0142atno\u015Bci obs\u0142ugiwana przez karty p\u0142atnicze Mastercard, Visa i inne.",
            "ctp.infoPopup.benefit1": "Click to Pay zabezpiecza Twoje informacje za pomoc\u0105 szyfrowania",
            "ctp.infoPopup.benefit2": "U\u017Cywaj tej funkcji u sprzedawc\xf3w na ca\u0142ym \u015Bwiecie",
            "ctp.infoPopup.benefit3": "Skonfiguruj raz i p\u0142a\u0107 bezproblemowo w przysz\u0142o\u015Bci",
            "ctp.errors.AUTH_INVALID": "Nieprawid\u0142owe dane uwierzytelniaj\u0105ce",
            "ctp.errors.NOT_FOUND": "Nie znaleziono konta, wprowad\u017A prawid\u0142owy adres e-mail lub kontynuuj, r\u0119cznie wprowadzaj\u0105c kart\u0119",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Format nie jest obs\u0142ugiwany",
            "ctp.errors.FRAUD": "Konto u\u017Cytkownika zosta\u0142o zablokowane lub wy\u0142\u0105czone",
            "ctp.errors.CONSUMER_ID_MISSING": "We wniosku brakuje danych dotycz\u0105cych to\u017Csamo\u015Bci konsumenta",
            "ctp.errors.ACCT_INACCESSIBLE": "To konto jest obecnie niedost\u0119pne, np. jest zablokowane",
            "ctp.errors.CODE_INVALID": "Nieprawid\u0142owy kod weryfikacyjny",
            "ctp.errors.CODE_EXPIRED": "Kod wygas\u0142",
            "ctp.errors.RETRIES_EXCEEDED": "Przekroczono limit pr\xf3b generowania has\u0142a jednorazowego",
            "ctp.errors.OTP_SEND_FAILED": "Nie uda\u0142o si\u0119 wys\u0142a\u0107 has\u0142a jednorazowego do odbiorcy",
            "ctp.errors.REQUEST_TIMEOUT": "Co\u015B posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty",
            "ctp.errors.UNKNOWN_ERROR": "Co\u015B posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty",
            "ctp.errors.SERVICE_ERROR": "Co\u015B posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty",
            "ctp.errors.SERVER_ERROR": "Co\u015B posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty",
            "ctp.errors.INVALID_PARAMETER": "Co\u015B posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty",
            "ctp.errors.AUTH_ERROR": "Co\u015B posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty",
            "paymentMethodsList.aria.label": "Wybierz metod\u0119 p\u0142atno\u015Bci",
            "companyDetails.name.invalid": "Wpisz nazw\u0119 firmy",
            "companyDetails.registrationNumber.invalid": "Wprowad\u017A numer w rejestrze",
            "consent.checkbox.invalid": "Musisz zaakceptowa\u0107 Warunki i postanowienia",
            "form.instruction": "Wszystkie pola s\u0105 wymagane, chyba \u017Ce zaznaczono inaczej.",
            "trustly.descriptor": "B\u0142yskawiczna p\u0142atno\u015B\u0107 bankowa",
            "trustly.description1": "P\u0142a\u0107 bezpo\u015Brednio z dowolnego rachunku bankowego, korzystaj\u0105c z zabezpiecze\u0144 na poziomie bankowym",
            "trustly.description2": "Bez kart, bez pobierania aplikacji, bez rejestracji",
            "ancv.input.label": "Tw\xf3j identyfikator ANCV",
            "ancv.confirmPayment": "U\u017Cyj aplikacji ANCV, aby potwierdzi\u0107 p\u0142atno\u015B\u0107.",
            "ancv.form.instruction": "Do zatwierdzenia tej p\u0142atno\u015Bci konieczna jest aplikacja Cheque-Vacances.",
            "ancv.beneficiaryId.invalid": "Wprowad\u017A poprawny adres e-mail lub identyfikator ANCV",
            "payme.openPayMeApp": "Doko\u0144cz p\u0142atno\u015B\u0107 w aplikacji PayMe, autoryzuj\u0105c p\u0142atno\u015B\u0107 w aplikacji, i poczekaj na potwierdzenie.",
            "payme.redirectButtonLabel": "Otw\xf3rz aplikacj\u0119 PayMe",
            "payme.scanQrCode": "Doko\u0144cz p\u0142atno\u015B\u0107 za pomoc\u0105 kodu QR",
            "payme.timeToPay": "Okres wa\u017Cno\u015Bci kodu QR: %@",
            "payme.instructions.steps": "Otw\xf3rz aplikacj\u0119 PayMe.%@Zeskanuj kod QR, aby autoryzowa\u0107 p\u0142atno\u015B\u0107.%@Doko\u0144cz p\u0142atno\u015B\u0107 w aplikacji i poczekaj na potwierdzenie.",
            "payme.instructions.footnote": "Nie zamykaj tej strony, dop\xf3ki p\u0142atno\u015B\u0107 nie zostanie zako\u0144czona"
        }
    }), V2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Pagar",
            "payButton.redirecting": "Redirecionando...",
            "payButton.with": "Pague %{value} com %{maskedData}",
            "payButton.saveDetails": "Salvar informa\xe7\xf5es",
            close: "Fechar",
            storeDetails: "Salvar para meu pr\xf3ximo pagamento",
            readMore: "Leia mais",
            "creditCard.holderName": "Nome no cart\xe3o",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "Digite o nome conforme mostrado no cart\xe3o",
            "creditCard.numberField.title": "N\xfamero do cart\xe3o",
            "creditCard.expiryDateField.title": "Data de validade",
            "creditCard.expiryDateField.placeholder": "MM/AA",
            "creditCard.expiryDateField.month": "M\xeas",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "AA",
            "creditCard.expiryDateField.year": "Ano",
            "creditCard.cvcField.title": "C\xf3digo de seguran\xe7a",
            "creditCard.storeDetailsButton": "Lembrar para a pr\xf3xima vez",
            "creditCard.cvcField.placeholder.4digits": "4 d\xedgitos",
            "creditCard.cvcField.placeholder.3digits": "3 d\xedgitos",
            "creditCard.taxNumber.placeholder": "AAAMMDD / 0123456789",
            installments: "Op\xe7\xf5es de Parcelamento",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} meses",
            "installments.oneTime": "Pagamento \xe0 vista",
            "installments.installments": "Pagamento parcelado",
            "installments.revolving": "Pagamento rotativo",
            "sepaDirectDebit.ibanField.invalid": "N\xfamero de conta inv\xe1lido",
            "sepaDirectDebit.nameField.placeholder": "J. Silva",
            "sepa.ownerName": "Nome do titular da conta banc\xe1ria",
            "sepa.ibanNumber": "N\xfamero de conta (NIB)",
            "error.title": "Erro",
            "error.subtitle.redirect": "Falha no redirecionamento",
            "error.subtitle.payment": "Falha no pagamento",
            "error.subtitle.refused": "Pagamento recusado",
            "error.message.unknown": "Ocorreu um erro desconhecido",
            "errorPanel.title": "Erros existentes",
            "idealIssuer.selectField.title": "Banco",
            "idealIssuer.selectField.placeholder": "Selecione seu banco",
            "creditCard.success": "Pagamento bem-sucedido",
            loading: "Carregando...",
            continue: "Continuar",
            continueTo: "Continuar para",
            "wechatpay.timetopay": "Voc\xea tem %@ para pagar",
            "sr.wechatpay.timetopay": "Voc\xea tem %#minutos%# e %#segundos%# para pagar",
            "wechatpay.scanqrcode": "Escanear c\xf3digo QR",
            personalDetails: "Informa\xe7\xf5es pessoais",
            companyDetails: "Dados da empresa",
            "companyDetails.name": "Nome da empresa",
            "companyDetails.registrationNumber": "N\xfamero de registro",
            socialSecurityNumber: "CPF",
            firstName: "Nome",
            "firstName.invalid": "Digite seu nome",
            infix: "Prefixo",
            lastName: "Sobrenome",
            "lastName.invalid": "Digite seu sobrenome",
            mobileNumber: "Celular",
            "mobileNumber.invalid": "N\xfamero de celular inv\xe1lido",
            city: "Cidade",
            postalCode: "CEP",
            "postalCode.optional": "C\xf3digo postal (opcional)",
            countryCode: "C\xf3digo do pa\xeds",
            telephoneNumber: "N\xfamero de telefone",
            dateOfBirth: "Data de nascimento",
            shopperEmail: "Endere\xe7o de e-mail",
            gender: "G\xeanero",
            "gender.notselected": "Selecione seu g\xeanero",
            male: "Masculino",
            female: "Feminino",
            billingAddress: "Endere\xe7o de cobran\xe7a",
            street: "Rua",
            stateOrProvince: "Estado ou prov\xedncia",
            country: "Pa\xeds/regi\xe3o",
            houseNumberOrName: "N\xfamero da casa",
            separateDeliveryAddress: "Especificar um endere\xe7o de entrega separado",
            deliveryAddress: "Endere\xe7o de entrega",
            "deliveryAddress.firstName": "Nome do destinat\xe1rio",
            "deliveryAddress.lastName": "Sobrenome do destinat\xe1rio",
            zipCode: "C\xf3digo postal",
            apartmentSuite: "Apartamento/Conjunto",
            provinceOrTerritory: "Prov\xedncia ou territ\xf3rio",
            cityTown: "Cidade",
            address: "Endere\xe7o",
            "address.placeholder": "Encontre seu endere\xe7o",
            "address.errors.incomplete": "Insira um endere\xe7o para continuar",
            "address.enterManually": "Inserir endere\xe7o manualmente",
            state: "Estado",
            "field.title.optional": "(opcional)",
            "creditCard.cvcField.title.optional": "C\xf3digo de seguran\xe7a (opcional)",
            "issuerList.wallet.placeholder": "Selecione uma carteira",
            privacyPolicy: "Pol\xedtica de Privacidade",
            "afterPay.agreement": "Concordo com o %@ da Riverty",
            paymentConditions: "condi\xe7\xf5es de pagamento",
            openApp: "Abrir o aplicativo",
            "voucher.readInstructions": "Leia as instru\xe7\xf5es",
            "voucher.introduction": "Obrigado pela sua compra, use o cupom a seguir para concluir o seu pagamento.",
            "voucher.expirationDate": "Data de validade",
            "voucher.alternativeReference": "Refer\xeancia alternativa",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Selecione o seu fornecedor",
            "dragonpay.voucher.bank.selectField.placeholder": "Selecione seu banco",
            "voucher.paymentReferenceLabel": "Refer\xeancia de pagamento",
            "voucher.surcharge": "Inclui %@ de sobretaxa",
            "voucher.introduction.doku": "Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.",
            "voucher.shopperName": "Nome do consumidor",
            "voucher.merchantName": "Comerciante online",
            "voucher.introduction.econtext": "Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.",
            "voucher.telephoneNumber": "N\xfamero de telefone",
            "voucher.shopperReference": "Refer\xeancia do consumidor",
            "voucher.collectionInstitutionNumber": "N\xfamero da institui\xe7\xe3o de cobran\xe7a",
            "voucher.econtext.telephoneNumber.invalid": "O n\xfamero de telefone deve ter 10 ou 11 d\xedgitos",
            "boletobancario.btnLabel": "Gerar Boleto",
            "boleto.sendCopyToEmail": "Enviar uma c\xf3pia por e-mail",
            "button.copy": "Copiar",
            "button.download": "Baixar",
            "boleto.socialSecurityNumber.invalid": "Digite um n\xfamero de CPF/CNPJ v\xe1lido",
            "creditCard.storedCard.description.ariaLabel": "O cart\xe3o armazenado termina em %@",
            "voucher.entity": "Entidade",
            donateButton: "Doar",
            notNowButton: "Agora n\xe3o",
            thanksForYourSupport: "Obrigado pelo apoio!",
            "resultMessages.preauthorized": "Informa\xe7\xf5es salvas",
            preauthorizeWith: "Pr\xe9-autorizar com",
            confirmPreauthorization: "Confirmar pr\xe9-autoriza\xe7\xe3o",
            confirmPurchase: "Confirmar compra",
            applyGiftcard: "Resgatar",
            giftcardBalance: "Saldo do vale-presente",
            deductedBalance: "Saldo debitado",
            "creditCard.pin.title": "Pin",
            "creditCard.encryptedPassword.label": "Primeiros dois d\xedgitos da senha do cart\xe3o",
            "creditCard.encryptedPassword.invalid": "Senha inv\xe1lida",
            "creditCard.taxNumber": "Data de nascimento do titular do cart\xe3o ou n\xfamero de registro corporativo",
            "creditCard.taxNumber.label": "Data de nascimento do titular do cart\xe3o (AAMMDD) ou n\xfamero de registro corporativo (10 d\xedgitos)",
            "creditCard.taxNumber.labelAlt": "N\xfamero de registro corporativo (10 d\xedgitos)",
            "creditCard.taxNumber.invalid": "Data de nascimento do titular do cart\xe3o ou n\xfamero de registro corporativo inv\xe1lidos",
            "storedPaymentMethod.disable.button": "Remover",
            "storedPaymentMethod.disable.confirmation": "Remover m\xe9todo de pagamento armazenado",
            "storedPaymentMethod.disable.confirmButton": "Sim, remover",
            "storedPaymentMethod.disable.cancelButton": "Cancelar",
            "ach.bankAccount": "Conta banc\xe1ria",
            "ach.accountHolderNameField.title": "Nome do titular da conta",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "Nome do titular da conta inv\xe1lido",
            "ach.accountNumberField.title": "N\xfamero da conta",
            "ach.accountNumberField.invalid": "N\xfamero de conta inv\xe1lido",
            "ach.accountLocationField.title": "N\xfamero de roteamento ABA",
            "ach.accountLocationField.invalid": "N\xfamero de roteamento ABA inv\xe1lido",
            "ach.savedBankAccount": "Conta banc\xe1ria cadastrada",
            "select.state": "Selecionar estado",
            "select.stateOrProvince": "Selecione estado ou prov\xedncia",
            "select.provinceOrTerritory": "Selecionar prov\xedncia ou territ\xf3rio",
            "select.country": "Selecione o pa\xeds/regi\xe3o",
            "select.noOptionsFound": "Nenhuma op\xe7\xe3o encontrada",
            "select.filter.placeholder": "Pesquisar...",
            "telephoneNumber.invalid": "N\xfamero de telefone inv\xe1lido",
            qrCodeOrApp: "ou",
            "paypal.processingPayment": "Processando pagamento...",
            generateQRCode: "Gerar c\xf3digo QR",
            "await.waitForConfirmation": "Aguardando confirma\xe7\xe3o",
            "mbway.confirmPayment": "Confirme seu pagamento no aplicativo MB WAY",
            "shopperEmail.invalid": "Endere\xe7o de e-mail inv\xe1lido",
            "dateOfBirth.format": "DD/MM/AAAA",
            "dateOfBirth.invalid": "Insira uma data de nascimento v\xe1lida que indique que voc\xea tem pelo menos 18 anos",
            "blik.confirmPayment": "Abra o aplicativo do seu banco para confirmar o pagamento.",
            "blik.invalid": "Digite 6 n\xfameros",
            "blik.code": "C\xf3digo de 6 d\xedgitos",
            "blik.help": "Obtenha o c\xf3digo no aplicativo do seu banco.",
            "swish.pendingMessage": "Depois de escanear o QR, o status pode ficar pendente por at\xe9 10 minutos. N\xe3o tente refazer o pagamento antes desse per\xedodo para evitar cobran\xe7a duplicada.",
            "field.valid": "Campo v\xe1lido",
            "field.invalid": "Campo inv\xe1lido",
            "error.va.gen.01": "Campo incompleto",
            "error.va.gen.02": "Campo inv\xe1lido",
            "error.va.sf-cc-num.01": "Digite um n\xfamero de cart\xe3o v\xe1lido",
            "error.va.sf-cc-num.02": "Digite o n\xfamero do cart\xe3o",
            "error.va.sf-cc-num.03": "Digite uma bandeira de cart\xe3o aceita",
            "error.va.sf-cc-num.04": "Digite o n\xfamero completo do cart\xe3o",
            "error.va.sf-cc-dat.01": "Digite uma data v\xe1lida",
            "error.va.sf-cc-dat.02": "Digite uma data v\xe1lida",
            "error.va.sf-cc-dat.03": "Cart\xe3o de cr\xe9dito prestes a vencer",
            "error.va.sf-cc-dat.04": "Digite a data de validade",
            "error.va.sf-cc-dat.05": "Digite a data de validade completa",
            "error.va.sf-cc-mth.01": "Digite o m\xeas de validade",
            "error.va.sf-cc-yr.01": "Digite o ano de validade",
            "error.va.sf-cc-yr.02": "Digite o ano de validade completo",
            "error.va.sf-cc-cvc.01": "Digite o c\xf3digo de seguran\xe7a",
            "error.va.sf-cc-cvc.02": "Digite o c\xf3digo de seguran\xe7a completo",
            "error.va.sf-ach-num.01": "O campo do n\xfamero da conta banc\xe1ria est\xe1 vazio",
            "error.va.sf-ach-num.02": "O n\xfamero da conta banc\xe1ria tem o comprimento errado",
            "error.va.sf-ach-loc.01": "O campo do n\xfamero de identifica\xe7\xe3o do banco est\xe1 vazio",
            "error.va.sf-ach-loc.02": "O n\xfamero de identifica\xe7\xe3o do banco tem o comprimento errado",
            "error.va.sf-kcp-pwd.01": "O campo da senha est\xe1 vazio",
            "error.va.sf-kcp-pwd.02": "A senha tem o comprimento errado",
            "error.giftcard.no-balance": "Este vale-presente tem saldo zero",
            "error.giftcard.card-error": "N\xe3o existe um vale-presente com esse n\xfamero em nossos registros",
            "error.giftcard.currency-error": "Os vales-presente s\xe3o v\xe1lidos somente na moeda em que foram emitidos",
            "amazonpay.signout": "Sair do Amazon",
            "amazonpay.changePaymentDetails": "Alterar dados de pagamento",
            "partialPayment.warning": "Selecione outro m\xe9todo de pagamento para pagar o restante",
            "partialPayment.remainingBalance": "O saldo restante ser\xe1 %{amount}",
            "bankTransfer.beneficiary": "Benefici\xe1rio",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Refer\xeancia",
            "bankTransfer.introduction": "Continue criando o novo pagamento por transfer\xeancia banc\xe1ria. Use as informa\xe7\xf5es na tela a seguir para conclu\xed-lo.",
            "bankTransfer.instructions": "Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.",
            "bacs.accountHolderName": "Nome do titular da conta banc\xe1ria",
            "bacs.accountHolderName.invalid": "Nome do titular da conta banc\xe1ria inv\xe1lido",
            "bacs.accountNumber": "N\xfamero da conta banc\xe1ria",
            "bacs.accountNumber.invalid": "N\xfamero da conta banc\xe1ria inv\xe1lido",
            "bacs.bankLocationId": "C\xf3digo de classifica\xe7\xe3o",
            "bacs.bankLocationId.invalid": "C\xf3digo de classifica\xe7\xe3o inv\xe1lido",
            "bacs.consent.amount": "Concordo que o valor acima seja deduzido da minha conta banc\xe1ria.",
            "bacs.consent.account": "Confirmo que a conta est\xe1 em meu nome e que sou o \xfanico signat\xe1rio que deve autorizar o d\xe9bito direto nessa conta.",
            edit: "Editar",
            "bacs.confirm": "Confirmar e pagar",
            "bacs.result.introduction": "Baixar instru\xe7\xe3o de d\xe9bito direto (DDI)",
            "download.pdf": "Baixar PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe para n\xfamero do cart\xe3o",
            "creditCard.encryptedCardNumber.aria.label": "N\xfamero do cart\xe3o",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe para data de validade",
            "creditCard.encryptedExpiryDate.aria.label": "Data de validade",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe para m\xeas de validade",
            "creditCard.encryptedExpiryMonth.aria.label": "M\xeas de vencimento",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe para ano de validade",
            "creditCard.encryptedExpiryYear.aria.label": "Ano de vencimento",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe para c\xf3digo de seguran\xe7a",
            "creditCard.encryptedSecurityCode.aria.label": "C\xf3digo de seguran\xe7a",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe para senha",
            "creditCard.encryptedPassword.aria.label": "Primeiros dois d\xedgitos da senha do cart\xe3o",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe para n\xfamero do cart\xe3o",
            "giftcard.encryptedCardNumber.aria.label": "N\xfamero do cart\xe3o",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe para pin",
            "giftcard.encryptedSecurityCode.aria.label": "Pin",
            giftcardTransactionLimit: "M\xe1ximo de %{amount} permitido por transa\xe7\xe3o neste cart\xe3o-presente",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe para n\xfamero da conta banc\xe1ria",
            "ach.encryptedBankAccountNumber.aria.label": "N\xfamero da conta",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe para n\xfamero de identifica\xe7\xe3o do banco",
            "ach.encryptedBankLocationId.aria.label": "N\xfamero de roteamento ABA",
            "pix.instructions": "Abra o app com sua chave PIX cadastrada, escolha Pagar com Pix e escaneie o QR Code ou copie e cole o c\xf3digo",
            "twint.saved": "salvo",
            orPayWith: "ou pague com",
            invalidFormatExpects: "Formato inv\xe1lido. Formato esperado: %{format}",
            "upi.qrCodeWaitingMessage": "Escaneie o QR code com o aplicativo UPI de sua prefer\xeancia para concluir o pagamento",
            "upi.vpaWaitingMessage": "Abra o aplicativo UPI para confirmar o pagamento",
            "upi.modeSelection": "Selecione como voc\xea gostaria de usar o UPI.",
            "onlineBanking.termsAndConditions": "Ao continuar, voc\xea concorda com os %#termos e condi\xe7\xf5es%#",
            "onlineBankingPL.termsAndConditions": "Ao continuar, voc\xea concorda com as %#condi\xe7\xf5es%# e as %#informa\xe7\xf5es obrigat\xf3rias%# da Przelewy24",
            "ctp.loading.poweredByCtp": "Desenvolvido por Click to Pay",
            "ctp.loading.intro": "Estamos verificando se voc\xea tem algum cart\xe3o salvo no Click to Pay...",
            "ctp.login.title": "Continuar para o Click to Pay",
            "ctp.login.subtitle": "Digite o endere\xe7o de e-mail associado ao Click to Pay para continuar.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "N\xe3o \xe9 voc\xea?",
            "ctp.logout.notYourCards": "N\xe3o \xe9 o seu cart\xe3o?",
            "ctp.logout.notYourCard": "N\xe3o \xe9 o seu cart\xe3o?",
            "ctp.logout.notYourProfile": "N\xe3o \xe9 o seu perfil?",
            "ctp.otp.fieldLabel": "C\xf3digo de acesso \xfanico",
            "ctp.otp.resendCode": "Reenviar c\xf3digo",
            "ctp.otp.codeResent": "C\xf3digo reenviado",
            "ctp.otp.title": "Acesse seus cart\xf5es Click to Pay",
            "ctp.otp.subtitle": "Digite o c\xf3digo %@ enviado para %@ para confirmar que \xe9 voc\xea.",
            "ctp.otp.saveCookiesCheckbox.label": "Ignorar verifica\xe7\xe3o da pr\xf3xima vez",
            "ctp.otp.saveCookiesCheckbox.information": "Selecione esta op\xe7\xe3o para ser lembrado no seu dispositivo e navegador, agilizando o pagamento nas lojas participantes. N\xe3o recomendado para dispositivos compartilhados.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Selecione para ser lembrado em seu dispositivo e navegador",
            "ctp.emptyProfile.message": "N\xe3o h\xe1 nenhum cart\xe3o cadastrado neste perfil do Click to Pay",
            "ctp.separatorText": "ou use",
            "ctp.cards.title": "Concluir o pagamento com o Click to Pay",
            "ctp.cards.subtitle": "Selecione um cart\xe3o para usar.",
            "ctp.cards.expiredCard": "Vencido",
            "ctp.manualCardEntry": "Entrada manual do cart\xe3o",
            "ctp.aria.infoModalButton": "O que \xe9 Click to Pay",
            "ctp.infoPopup.title": "O Click to Pay traz a facilidade do pagamento online sem contato",
            "ctp.infoPopup.subtitle": "Um m\xe9todo de pagamento r\xe1pido e seguro, compat\xedvel com Mastercard, Visa e outros cart\xf5es.",
            "ctp.infoPopup.benefit1": "O Click to Pay usa criptografia para manter suas informa\xe7\xf5es seguras e protegidas",
            "ctp.infoPopup.benefit2": "Use com comerciantes no mundo todo",
            "ctp.infoPopup.benefit3": "Configure apenas uma vez e simplifique seus pagamentos no futuro",
            "ctp.errors.AUTH_INVALID": "Autentica\xe7\xe3o inv\xe1lida",
            "ctp.errors.NOT_FOUND": "Nenhuma conta foi encontrada. Informe um e-mail v\xe1lido ou continue inserindo os dados do cart\xe3o manualmente",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Formato n\xe3o compat\xedvel",
            "ctp.errors.FRAUD": "A conta do usu\xe1rio foi bloqueada ou desativada",
            "ctp.errors.CONSUMER_ID_MISSING": "A identidade do consumidor est\xe1 ausente na solicita\xe7\xe3o",
            "ctp.errors.ACCT_INACCESSIBLE": "Esta conta n\xe3o est\xe1 dispon\xedvel no momento. Ela pode estar bloqueada, por exemplo",
            "ctp.errors.CODE_INVALID": "C\xf3digo de verifica\xe7\xe3o incorreto",
            "ctp.errors.CODE_EXPIRED": "Esse c\xf3digo expirou",
            "ctp.errors.RETRIES_EXCEEDED": "O limite de tentativas para gerar a senha de uso \xfanico foi excedido",
            "ctp.errors.OTP_SEND_FAILED": "N\xe3o foi poss\xedvel enviar a senha de uso \xfanico ao destinat\xe1rio",
            "ctp.errors.REQUEST_TIMEOUT": "Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente",
            "ctp.errors.UNKNOWN_ERROR": "Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente",
            "ctp.errors.SERVICE_ERROR": "Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente",
            "ctp.errors.SERVER_ERROR": "Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente",
            "ctp.errors.INVALID_PARAMETER": "Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente",
            "ctp.errors.AUTH_ERROR": "Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente",
            "paymentMethodsList.aria.label": "Escolha um m\xe9todo de pagamento",
            "companyDetails.name.invalid": "Digite o nome da empresa",
            "companyDetails.registrationNumber.invalid": "Digite o n\xfamero de registro",
            "consent.checkbox.invalid": "Voc\xea precisa concordar com os termos e condi\xe7\xf5es",
            "form.instruction": "Todos os campos s\xe3o obrigat\xf3rios, a menos que marcados em contr\xe1rio.",
            "trustly.descriptor": "Pagamento instant\xe2neo",
            "trustly.description1": "Pague diretamente de qualquer conta, com a seguran\xe7a do seu banco",
            "trustly.description2": "Sem cart\xe3o, sem download de aplicativo, sem cadastro",
            "ancv.input.label": "Sua identifica\xe7\xe3o da ANCV",
            "ancv.confirmPayment": "Use o aplicativo da ANCV para confirmar o pagamento.",
            "ancv.form.instruction": "\xc9 necess\xe1rio ter o aplicativo da Cheque-Vacances para validar este pagamento.",
            "ancv.beneficiaryId.invalid": "Insira um endere\xe7o de e-mail v\xe1lido ou uma ID da ANCV",
            "payme.openPayMeApp": "Para concluir o pagamento no PayMe, autorize-o no aplicativo e aguarde a confirma\xe7\xe3o.",
            "payme.redirectButtonLabel": "Abrir o aplicativo PayMe",
            "payme.scanQrCode": "Concluir o pagamento com um c\xf3digo QR",
            "payme.timeToPay": "Este QR code \xe9 v\xe1lido para %@",
            "payme.instructions.steps": "Abra o aplicativo PayMe.%@Escaneie o QR code para autorizar o pagamento.%@Conclua o pagamento no aplicativo e aguarde a confirma\xe7\xe3o.",
            "payme.instructions.footnote": "N\xe3o feche esta p\xe1gina antes de concluir o pagamento"
        }
    }), U2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Pagar",
            "payButton.redirecting": "Redirecionar...",
            "payButton.with": "Pagar %{value} com %{maskedData}",
            "payButton.saveDetails": "Guardar detalhes",
            close: "Fechar",
            storeDetails: "Guardar para o meu pr\xf3ximo pagamento",
            readMore: "Ler mais",
            "creditCard.holderName": "Nome no cart\xe3o",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "Introduzir o nome como mostrado no cart\xe3o",
            "creditCard.numberField.title": "N\xfamero de cart\xe3o",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Data de validade",
            "creditCard.expiryDateField.placeholder": "MM/AA",
            "creditCard.expiryDateField.month": "M\xeas",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "AA",
            "creditCard.expiryDateField.year": "Ano",
            "creditCard.cvcField.title": "C\xf3digo de seguran\xe7a",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Lembre-se para a pr\xf3xima vez",
            "creditCard.cvcField.placeholder.4digits": "4 d\xedgitos",
            "creditCard.cvcField.placeholder.3digits": "3 d\xedgitos",
            "creditCard.taxNumber.placeholder": "AAMMDD / 0123456789",
            installments: "N\xfamero de presta\xe7\xf5es",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} meses",
            "installments.oneTime": "Pagamento \xfanico",
            "installments.installments": "Pagamento em presta\xe7\xf5es",
            "installments.revolving": "Pagamento rotativo",
            "sepaDirectDebit.ibanField.invalid": "N\xfamero de conta inv\xe1lido",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "Nome do Titular",
            "sepa.ibanNumber": "N\xfamero da conta (IBAN)",
            "error.title": "Erro",
            "error.subtitle.redirect": "Falha ao redirecionar",
            "error.subtitle.payment": "O pagamento falhou",
            "error.subtitle.refused": "Pagamento recusado",
            "error.message.unknown": "Ocorreu um erro desconhecido",
            "errorPanel.title": "Erros existentes",
            "idealIssuer.selectField.title": "Banco",
            "idealIssuer.selectField.placeholder": "Selecione o seu banco",
            "creditCard.success": "Pagamento bem-sucedido",
            loading: "A carregar",
            continue: "Continuar",
            continueTo: "Continuar para",
            "wechatpay.timetopay": "Tem %@ para pagar",
            "sr.wechatpay.timetopay": "Tem %#minutos%# %#segundos%# para pagar",
            "wechatpay.scanqrcode": "Digitalizar c\xf3digo QR",
            personalDetails: "Detalhes pessoais",
            companyDetails: "Detalhes da empresa",
            "companyDetails.name": "Nome da empresa",
            "companyDetails.registrationNumber": "N\xfamero de registo",
            socialSecurityNumber: "N\xfamero de previd\xeancia social",
            firstName: "Nome pr\xf3prio",
            "firstName.invalid": "Introduza o seu nome pr\xf3prio",
            infix: "Prefixo",
            lastName: "Apelido",
            "lastName.invalid": "Introduza o seu apelido",
            mobileNumber: "N\xfamero de telem\xf3vel",
            "mobileNumber.invalid": "N\xfamero de telem\xf3vel inv\xe1lido",
            city: "Cidade",
            postalCode: "C\xf3digo postal",
            "postalCode.optional": "C\xf3digo postal (opcional)",
            countryCode: "C\xf3digo do pa\xeds",
            telephoneNumber: "N\xfamero de telefone",
            dateOfBirth: "Data de nascimento",
            shopperEmail: "Endere\xe7o de correio eletr\xf3nico",
            gender: "G\xe9nero",
            "gender.notselected": "Selecione o seu g\xe9nero",
            male: "Homem",
            female: "Feminino",
            billingAddress: "Morada de cobran\xe7a",
            street: "Rua",
            stateOrProvince: "Estado ou prov\xedncia",
            country: "Pa\xeds/regi\xe3o",
            houseNumberOrName: "N\xfamero de porta",
            separateDeliveryAddress: "Especifique uma morada de entrega separada",
            deliveryAddress: "Morada de entrega",
            "deliveryAddress.firstName": "Nome pr\xf3prio do destinat\xe1rio",
            "deliveryAddress.lastName": "Apelido do destinat\xe1rio",
            zipCode: "C\xf3digo postal",
            apartmentSuite: "Apartamento/Suite",
            provinceOrTerritory: "Prov\xedncia ou Territ\xf3rio",
            cityTown: "Cidade/cidade",
            address: "Morada",
            "address.placeholder": "Encontre o seu endere\xe7o",
            "address.errors.incomplete": "Introduza um endere\xe7o para continuar",
            "address.enterManually": "Introduza o endere\xe7o manualmente",
            state: "Estado",
            "field.title.optional": "(opcional)",
            "creditCard.cvcField.title.optional": "C\xf3digo de seguran\xe7a (opcional)",
            "issuerList.wallet.placeholder": "Selecione a sua carteira",
            privacyPolicy: "Pol\xedtica de Privacidade",
            "afterPay.agreement": "Concordo com o %@ da Riverty",
            paymentConditions: "condi\xe7\xf5es de pagamento",
            openApp: "Abra a aplica\xe7\xe3o",
            "voucher.readInstructions": "Ler instru\xe7\xf5es",
            "voucher.introduction": "Obrigado pela sua compra, utilize o seguinte cup\xe3o para completar o seu pagamento.",
            "voucher.expirationDate": "Data de validade",
            "voucher.alternativeReference": "Refer\xeancia alternativa",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Selecione seu fornecedor",
            "dragonpay.voucher.bank.selectField.placeholder": "Selecione o seu banco",
            "voucher.paymentReferenceLabel": "Refer\xeancia de pagamento",
            "voucher.surcharge": "Incl. %@ sobretaxa",
            "voucher.introduction.doku": "Obrigado pela sua compra, use as seguintes informa\xe7\xf5es para concluir o seu pagamento.",
            "voucher.shopperName": "Nome do comprador",
            "voucher.merchantName": "Comerciante",
            "voucher.introduction.econtext": "Obrigado pela sua compra, use as seguintes informa\xe7\xf5es para concluir o seu pagamento.",
            "voucher.telephoneNumber": "N\xfamero de telefone",
            "voucher.shopperReference": "Refer\xeancia do consumidor",
            "voucher.collectionInstitutionNumber": "N\xfamero da institui\xe7\xe3o de recolha",
            "voucher.econtext.telephoneNumber.invalid": "O n\xfamero de telefone deve ter 10 ou 11 d\xedgitos",
            "boletobancario.btnLabel": "Gerar comprovativo",
            "boleto.sendCopyToEmail": "Enviar uma c\xf3pia para o meu e-mail",
            "button.copy": "Copiar",
            "button.download": "Download",
            "boleto.socialSecurityNumber": "CPF/CNPJ",
            "boleto.socialSecurityNumber.invalid": "Introduza um n\xfamero de CPF/CNPJ v\xe1lido",
            "creditCard.storedCard.description.ariaLabel": "O cart\xe3o armazenado termina em %@",
            "voucher.entity": "Entidade",
            donateButton: "Doar",
            notNowButton: "Agora n\xe3o",
            thanksForYourSupport: "Obrigado pelo seu apoio!",
            "resultMessages.preauthorized": "Detalhes guardados",
            preauthorizeWith: "Pr\xe9-autorizar com",
            confirmPreauthorization: "Confirmar pr\xe9-autoriza\xe7\xe3o",
            confirmPurchase: "Confirmar compra",
            applyGiftcard: "Resgatar",
            giftcardBalance: "Saldo do cart\xe3o-presente",
            deductedBalance: "Saldo deduzido",
            "creditCard.pin.title": "Pin",
            "creditCard.encryptedPassword.label": "Primeiros 2 d\xedgitos da palavra-passe do cart\xe3o",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Palavra-passe inv\xe1lida",
            "creditCard.taxNumber": "Data de nascimento do titular do cart\xe3o ou n\xfamero de registo da Empresa",
            "creditCard.taxNumber.label": "Data de nascimento do titular do cart\xe3o (AAMMDD) ou n\xfamero de registo da Empresa (10 d\xedgitos)",
            "creditCard.taxNumber.labelAlt": "N\xfamero de registo da empresa (10 d\xedgitos)",
            "creditCard.taxNumber.invalid": "Data de nascimento do titular do cart\xe3o ou n\xfamero de registo empresarial inv\xe1lido",
            "storedPaymentMethod.disable.button": "Remover",
            "storedPaymentMethod.disable.confirmation": "Remover m\xe9todo de pagamento guardado",
            "storedPaymentMethod.disable.confirmButton": "Sim, remover",
            "storedPaymentMethod.disable.cancelButton": "Cancelar",
            "ach.bankAccount": "Conta banc\xe1ria",
            "ach.accountHolderNameField.title": "Nome do titular da conta",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "Nome do titular da conta inv\xe1lido",
            "ach.accountNumberField.title": "N\xfamero da conta",
            "ach.accountNumberField.invalid": "N\xfamero de conta inv\xe1lido",
            "ach.accountLocationField.title": "N\xfamero de encaminhamento da ABA",
            "ach.accountLocationField.invalid": "N\xfamero de encaminhamento ABA inv\xe1lido",
            "ach.savedBankAccount": "Conta banc\xe1ria guardada",
            "select.state": "Selecione estado",
            "select.stateOrProvince": "Selecione estado ou prov\xedncia",
            "select.provinceOrTerritory": "Selecionar prov\xedncia ou territ\xf3rio",
            "select.country": "Selecionar pa\xeds/regi\xe3o",
            "select.noOptionsFound": "Nenhuma op\xe7\xe3o encontrada",
            "select.filter.placeholder": "Pesquisar...",
            "telephoneNumber.invalid": "N\xfamero de telefone inv\xe1lido",
            qrCodeOrApp: "ou",
            "paypal.processingPayment": "A processar pagamento...",
            generateQRCode: "Gerar c\xf3digo QR",
            "await.waitForConfirmation": "A aguardar confirma\xe7\xe3o",
            "mbway.confirmPayment": "Confirme o seu pagamento na aplica\xe7\xe3o MB WAY",
            "shopperEmail.invalid": "Endere\xe7o de e-mail inv\xe1lido",
            "dateOfBirth.format": "DD/MM/AAAA",
            "dateOfBirth.invalid": "Insira uma data de nascimento v\xe1lida que indique que tem pelo menos 18 anos",
            "blik.confirmPayment": "Abra a sua aplica\xe7\xe3o banc\xe1ria para confirmar o pagamento.",
            "blik.invalid": "Digite 6 n\xfameros",
            "blik.code": "C\xf3digo de 6 d\xedgitos",
            "blik.help": "Obtenha o c\xf3digo da sua aplica\xe7\xe3o banc\xe1ria.",
            "swish.pendingMessage": "Ap\xf3s a leitura, o estado pode estar pendente por at\xe9 10 minutos. Tentar pagar novamente dentro desse prazo pode resultar em v\xe1rias cobran\xe7as.",
            "field.valid": "Campo v\xe1lido",
            "field.invalid": "Campo inv\xe1lido",
            "error.va.gen.01": "Campo incompleto",
            "error.va.gen.02": "Campo inv\xe1lido",
            "error.va.sf-cc-num.01": "Introduza um n\xfamero de cart\xe3o v\xe1lido",
            "error.va.sf-cc-num.02": "Introduza o n\xfamero do cart\xe3o",
            "error.va.sf-cc-num.03": "Introduza uma marca de cart\xe3o suportada",
            "error.va.sf-cc-num.04": "Introduza o n\xfamero do cart\xe3o completo",
            "error.va.sf-cc-dat.01": "Introduza uma data de validade v\xe1lida",
            "error.va.sf-cc-dat.02": "Introduza uma data de validade v\xe1lida",
            "error.va.sf-cc-dat.03": "Cart\xe3o de cr\xe9dito prestes a expirar",
            "error.va.sf-cc-dat.04": "Introduza a data de validade",
            "error.va.sf-cc-dat.05": "Introduza a data de validade completa",
            "error.va.sf-cc-mth.01": "Introduza o m\xeas de validade",
            "error.va.sf-cc-yr.01": "Introduza o ano de validade",
            "error.va.sf-cc-yr.02": "Introduza o ano de validade completa",
            "error.va.sf-cc-cvc.01": "Introduza o c\xf3digo de seguran\xe7a",
            "error.va.sf-cc-cvc.02": "Introduza o c\xf3digo de seguran\xe7a completo",
            "error.va.sf-ach-num.01": "O campo de n\xfamero da conta banc\xe1ria est\xe1 vazio",
            "error.va.sf-ach-num.02": "O n\xfamero da conta banc\xe1ria tem o comprimento errado",
            "error.va.sf-ach-loc.01": "O campo do n\xfamero de encaminhamento banc\xe1rio est\xe1 vazio",
            "error.va.sf-ach-loc.02": "O n\xfamero de identifica\xe7\xe3o banc\xe1ria tem o comprimento errado",
            "error.va.sf-kcp-pwd.01": "O campo de palavra-passe est\xe1 vazio",
            "error.va.sf-kcp-pwd.02": "A palavra-passe tem o comprimento errado",
            "error.giftcard.no-balance": "Este cart\xe3o oferta tem saldo zero",
            "error.giftcard.card-error": "Nos nossos registos n\xe3o temos qualquer cart\xe3o oferta com este n\xfamero",
            "error.giftcard.currency-error": "Os cart\xf5es oferta s\xf3 s\xe3o v\xe1lidos na moeda em que foram emitidos",
            "amazonpay.signout": "Sair da Amazon",
            "amazonpay.changePaymentDetails": "Alterar detalhes de pagamento",
            "partialPayment.warning": "Selecione outro m\xe9todo de pagamento para pagar o restante",
            "partialPayment.remainingBalance": "O saldo restante ser\xe1 de %{amount}",
            "bankTransfer.beneficiary": "Benefici\xe1rio(a)",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Refer\xeancia",
            "bankTransfer.introduction": "Continue para criar um novo pagamento de transfer\xeancia banc\xe1ria. Pode usar os detalhes no ecr\xe3 a seguir para finalizar este pagamento.",
            "bankTransfer.instructions": "Obrigado pela sua compra, use as seguintes informa\xe7\xf5es para concluir o seu pagamento.",
            "bacs.accountHolderName": "Nome do titular da conta banc\xe1ria",
            "bacs.accountHolderName.invalid": "Nome do titular da conta banc\xe1ria inv\xe1lido",
            "bacs.accountNumber": "N\xfamero da conta banc\xe1ria",
            "bacs.accountNumber.invalid": "N\xfamero de conta banc\xe1ria inv\xe1lido",
            "bacs.bankLocationId": "C\xf3digo de classifica\xe7\xe3o",
            "bacs.bankLocationId.invalid": "C\xf3digo de classifica\xe7\xe3o inv\xe1lido",
            "bacs.consent.amount": "Concordo que o valor acima seja deduzido da minha conta banc\xe1ria.",
            "bacs.consent.account": "Confirmo que a conta est\xe1 em meu nome e sou o \xfanico signat\xe1rio necess\xe1rio para autorizar o d\xe9bito autom\xe1tico nesta conta.",
            edit: "Editar",
            "bacs.confirm": "Confirmar e pagar",
            "bacs.result.introduction": "Descarregue a sua Instru\xe7\xe3o de D\xe9bito Direto (DDI / Mandato)",
            "download.pdf": "Descarregar PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe para o n\xfamero do cart\xe3o",
            "creditCard.encryptedCardNumber.aria.label": "N\xfamero de cart\xe3o",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe para data de validade",
            "creditCard.encryptedExpiryDate.aria.label": "Data de validade",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe para o m\xeas de validade",
            "creditCard.encryptedExpiryMonth.aria.label": "M\xeas de validade",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe para o ano de validade",
            "creditCard.encryptedExpiryYear.aria.label": "Ano de validade",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe para c\xf3digo de seguran\xe7a",
            "creditCard.encryptedSecurityCode.aria.label": "C\xf3digo de seguran\xe7a",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe para palavra-passe",
            "creditCard.encryptedPassword.aria.label": "Primeiros 2 d\xedgitos da palavra-passe do cart\xe3o",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe para o n\xfamero do cart\xe3o",
            "giftcard.encryptedCardNumber.aria.label": "N\xfamero de cart\xe3o",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe para pin",
            "giftcard.encryptedSecurityCode.aria.label": "Pin",
            giftcardTransactionLimit: "M\xe1ximo de %{amount} permitido por transa\xe7\xe3o neste cart\xe3o presente",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe para n\xfamero de conta banc\xe1ria",
            "ach.encryptedBankAccountNumber.aria.label": "N\xfamero da conta",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe para n\xfamero de identifica\xe7\xe3o banc\xe1ria",
            "ach.encryptedBankLocationId.aria.label": "N\xfamero de encaminhamento da ABA",
            "pix.instructions": "Abra a aplica\xe7\xe3o com a chave registada PIX, escolha Pagar com PIX e digitalize o QR Code ou copie e cole o c\xf3digo",
            "twint.saved": "salvou",
            orPayWith: "ou pague com",
            invalidFormatExpects: "Formato inv\xe1lido. Formato esperado: %{format}",
            "upi.qrCodeWaitingMessage": "Digitalize o c\xf3digo QR usando a sua aplica\xe7\xe3o UPI preferida para concluir o pagamento",
            "upi.vpaWaitingMessage": "Abra a aplica\xe7\xe3o UPI para confirmar o pagamento",
            "upi.modeSelection": "Fa\xe7a uma sele\xe7\xe3o de como gostaria de usar a UPI.",
            "onlineBanking.termsAndConditions": "Ao continuar, concorda com os %#termos e condi\xe7\xf5es%#",
            "onlineBankingPL.termsAndConditions": "Ao continuar, concorda com o %#regulamento%# e a %#obriga\xe7\xe3o de informa\xe7\xe3o%# da Przelewy24",
            "ctp.loading.poweredByCtp": "Fornecido pelo Click to Pay",
            "ctp.loading.intro": "Estamos a verificar se tem algum cart\xe3o Click to Pay guardado...",
            "ctp.login.title": "Continuar para o Click to Pay",
            "ctp.login.subtitle": "Introduza o endere\xe7o de e-mail associado ao Click to Pay para continuar.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "N\xe3o \xe9 voc\xea?",
            "ctp.logout.notYourCards": "N\xe3o s\xe3o os seus cart\xf5es?",
            "ctp.logout.notYourCard": "N\xe3o \xe9 o seu cart\xe3o?",
            "ctp.logout.notYourProfile": "N\xe3o \xe9 o seu perfil?",
            "ctp.otp.fieldLabel": "C\xf3digo \xfanico",
            "ctp.otp.resendCode": "Reenviar c\xf3digo",
            "ctp.otp.codeResent": "C\xf3digo reenviado",
            "ctp.otp.title": "Aceda aos seus cart\xf5es Click to Pay",
            "ctp.otp.subtitle": "Introduza o c\xf3digo %@ enviado para %@ para verificar se \xe9 voc\xea.",
            "ctp.otp.saveCookiesCheckbox.label": "Saltar verifica\xe7\xe3o da pr\xf3xima vez",
            "ctp.otp.saveCookiesCheckbox.information": "Selecione para ser memorizado no seu dispositivo e navegador nas lojas participantes, para uma finaliza\xe7\xe3o de compra mais r\xe1pida. N\xe3o recomendado para dispositivos partilhados.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Selecione para ser memorizado no seu dispositivo e navegador",
            "ctp.emptyProfile.message": "Nenhum cart\xe3o registado neste perfil Click to Pay",
            "ctp.separatorText": "ou utilize",
            "ctp.cards.title": "Pagamento completo com Click to Pay",
            "ctp.cards.subtitle": "Selecione um cart\xe3o para usar.",
            "ctp.cards.expiredCard": "Expirado",
            "ctp.manualCardEntry": "Introdu\xe7\xe3o manual do cart\xe3o",
            "ctp.aria.infoModalButton": "O que \xe9 Click to Pay",
            "ctp.infoPopup.title": "O Click to Pay traz a facilidade do contactless online",
            "ctp.infoPopup.subtitle": "Um m\xe9todo de pagamento r\xe1pido e seguro suportado pela Mastercard, Visa e outros cart\xf5es de pagamento.",
            "ctp.infoPopup.benefit1": "Click to Pay utiliza encripta\xe7\xe3o para manter as suas informa\xe7\xf5es seguras",
            "ctp.infoPopup.benefit2": "Use-o com comerciantes em todo o mundo",
            "ctp.infoPopup.benefit3": "Configure uma vez para pagamentos sem complica\xe7\xf5es no futuro",
            "ctp.errors.AUTH_INVALID": "Autentica\xe7\xe3o inv\xe1lida",
            "ctp.errors.NOT_FOUND": "Nenhuma conta encontrada, insira um e-mail v\xe1lido ou continue usando a entrada manual do cart\xe3o",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Formato n\xe3o suportado",
            "ctp.errors.FRAUD": "A conta de utilizador foi bloqueada ou desativada",
            "ctp.errors.CONSUMER_ID_MISSING": "A identidade do consumidor est\xe1 em falta no pedido",
            "ctp.errors.ACCT_INACCESSIBLE": "Esta conta n\xe3o est\xe1 atualmente dispon\xedvel, por exemplo, est\xe1 bloqueada",
            "ctp.errors.CODE_INVALID": "C\xf3digo de verifica\xe7\xe3o incorreto",
            "ctp.errors.CODE_EXPIRED": "Este c\xf3digo expirou",
            "ctp.errors.RETRIES_EXCEEDED": "Ultrapassou o limite para o n\xfamero de tentativas para a gera\xe7\xe3o OTP.",
            "ctp.errors.OTP_SEND_FAILED": "N\xe3o foi poss\xedvel enviar a OTP ao destinat\xe1rio",
            "ctp.errors.REQUEST_TIMEOUT": "Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual",
            "ctp.errors.UNKNOWN_ERROR": "Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual",
            "ctp.errors.SERVICE_ERROR": "Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual",
            "ctp.errors.SERVER_ERROR": "Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual",
            "ctp.errors.INVALID_PARAMETER": "Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual",
            "ctp.errors.AUTH_ERROR": "Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual",
            "paymentMethodsList.aria.label": "Escolha um m\xe9todo de pagamento",
            "companyDetails.name.invalid": "Insira o nome da empresa",
            "companyDetails.registrationNumber.invalid": "Insira o n\xfamero de registo",
            "consent.checkbox.invalid": "Tem de aceitar os termos e condi\xe7\xf5es",
            "form.instruction": "Todos os campos s\xe3o obrigat\xf3rios, a menos que assinalados em contr\xe1rio.",
            "trustly.descriptor": "Pagamento banc\xe1rio instant\xe2neo",
            "trustly.description1": "Pague diretamente a partir de qualquer uma das suas contas banc\xe1rias, com a seguran\xe7a de um banco",
            "trustly.description2": "Sem cart\xf5es, sem transferir aplica\xe7\xf5es, sem registo",
            "ancv.input.label": "A sua identifica\xe7\xe3o de ANCV",
            "ancv.confirmPayment": "Use a sua aplica\xe7\xe3o ANCV para confirmar o pagamento.",
            "ancv.form.instruction": "A app Cheque-Vacances \xe9 necess\xe1ria para validar este pagamento.",
            "ancv.beneficiaryId.invalid": "Insira um endere\xe7o de e-mail ou ID v\xe1lido de ANCV",
            "payme.openPayMeApp": "Conclua o seu pagamento na app PayMe autorizando o pagamento na app e aguardando a confirma\xe7\xe3o.",
            "payme.redirectButtonLabel": "Abrir a app PayMe",
            "payme.scanQrCode": "Conclua o seu pagamento por c\xf3digo QR",
            "payme.timeToPay": "Este c\xf3digo QR \xe9 v\xe1lido para %@",
            "payme.instructions.steps": "Abra a app PayMe.%@Leia o c\xf3digo QR para autorizar o pagamento.%@Conclua o pagamento na app e aguarde a confirma\xe7\xe3o.",
            "payme.instructions.footnote": "N\xe3o feche esta p\xe1gina antes de concluir o pagamento"
        }
    }), K2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Pl\u0103ti\u021Bi",
            "payButton.redirecting": "Se redirec\u021Bioneaz\u0103...",
            "payButton.with": "Pl\u0103ti\u021Bi %{value} cu %{maskedData}",
            "payButton.saveDetails": "Salva\u021Bi detaliile",
            close: "\xcenchidere",
            storeDetails: "Salveaz\u0103 pentru urm\u0103toarea mea plat\u0103",
            readMore: "Citi\u021Bi mai mult",
            "creditCard.holderName": "Numele de pe card",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "Completa\u021Bi numele dup\u0103 cum figureaz\u0103 pe card",
            "creditCard.numberField.title": "Num\u0103r card",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Data expir\u0103rii",
            "creditCard.expiryDateField.placeholder": "LL/AA",
            "creditCard.expiryDateField.month": "Lun\u0103",
            "creditCard.expiryDateField.month.placeholder": "LL",
            "creditCard.expiryDateField.year.placeholder": "AA",
            "creditCard.expiryDateField.year": "An",
            "creditCard.cvcField.title": "Cod de securitate",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Re\u021Bine pentru data viitoare",
            "creditCard.cvcField.placeholder.4digits": "4 cifre",
            "creditCard.cvcField.placeholder.3digits": "3 cifre",
            "creditCard.taxNumber.placeholder": "AALLZZ / 0123456789",
            installments: "Num\u0103r de rate",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} luni",
            "installments.oneTime": "Plat\u0103 unic\u0103",
            "installments.installments": "Plat\u0103 \xeen rate",
            "installments.revolving": "Plat\u0103 recurent\u0103",
            "sepaDirectDebit.ibanField.invalid": "Num\u0103rul de cont este incorect",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "Nume posesor",
            "sepa.ibanNumber": "Num\u0103r cont (IBAN)",
            "error.title": "Eroare",
            "error.subtitle.redirect": "Redirec\u021Bionare e\u0219uat\u0103",
            "error.subtitle.payment": "Plat\u0103 e\u0219uat\u0103",
            "error.subtitle.refused": "Plat\u0103 refuzat\u0103",
            "error.message.unknown": "S-a produs o eroare necunoscut\u0103",
            "errorPanel.title": "Erori existente",
            "idealIssuer.selectField.title": "Banc\u0103",
            "idealIssuer.selectField.placeholder": "Selecta\u021Bi-v\u0103 banca",
            "creditCard.success": "Plat\u0103 reu\u0219it\u0103",
            loading: "Se \xeencarc\u0103...",
            continue: "Continuare",
            continueTo: "Continua\u021Bi c\u0103tre",
            "wechatpay.timetopay": "Trebuie s\u0103 achita\u021Bi %@",
            "sr.wechatpay.timetopay": "Ave\u021Bi la dispozi\u021Bie %#minute%# %#secunde%# pentru a pl\u0103ti",
            "wechatpay.scanqrcode": "Scana\u021Bi codul QR",
            personalDetails: "Informa\u021Bii personale",
            companyDetails: "Informa\u021Bii societate",
            "companyDetails.name": "Denumirea societ\u0103\u021Bii",
            "companyDetails.registrationNumber": "Num\u0103r de \xeenregistrare",
            socialSecurityNumber: "Cod numeric personal",
            firstName: "Prenume",
            "firstName.invalid": "Completa\u021Bi prenumele dvs.",
            infix: "Titulatur\u0103",
            lastName: "Nume de familie",
            "lastName.invalid": "Completa\u021Bi numele dvs. de familie",
            mobileNumber: "Num\u0103r de mobil",
            "mobileNumber.invalid": "Num\u0103r de telefon mobil incorect",
            city: "Ora\u0219",
            postalCode: "Cod po\u0219tal",
            "postalCode.optional": "Cod po\u0219tal (op\u021Bional)",
            countryCode: "Codul \u021B\u0103rii",
            telephoneNumber: "Num\u0103r de telefon",
            dateOfBirth: "Data na\u0219terii",
            shopperEmail: "Adres\u0103 de e-mail",
            gender: "Gen",
            "gender.notselected": "Selecta\u021Bi sexul dvs.",
            male: "B\u0103rbat",
            female: "Femeie",
            billingAddress: "Adresa de facturare",
            street: "Strada",
            stateOrProvince: "Jude\u021B sau provincie",
            country: "\u021Aar\u0103/regiune",
            houseNumberOrName: "Num\u0103r",
            separateDeliveryAddress: "Specifica\u021Bi o adres\u0103 de livrare separat\u0103",
            deliveryAddress: "Adres\u0103 de livrare",
            "deliveryAddress.firstName": "Prenumele destinatarului",
            "deliveryAddress.lastName": "Numele de familie al destinatarului",
            zipCode: "Cod po\u0219tal",
            apartmentSuite: "Apartament",
            provinceOrTerritory: "Provincie sau teritoriu",
            cityTown: "Ora\u0219/localitate",
            address: "Adres\u0103",
            "address.placeholder": "G\u0103si\u021Bi-v\u0103 adresa",
            "address.errors.incomplete": "Pentru a continua, introduce\u021Bi o adres\u0103",
            "address.enterManually": "Introduce\u021Bi adresa manual",
            state: "Stat",
            "field.title.optional": "(op\u021Bional)",
            "creditCard.cvcField.title.optional": "Cod de securitate (op\u021Bional)",
            "issuerList.wallet.placeholder": "Selecta\u021Bi-v\u0103 portofelul",
            privacyPolicy: "Politica de confiden\u021Bialitate",
            "afterPay.agreement": "Sunt de acord cu %@ apar\u021Bin\xe2nd Riverty",
            paymentConditions: "condi\u021Bii de plat\u0103",
            openApp: "Deschide\u021Bi aplica\u021Bia",
            "voucher.readInstructions": "Citi\u021Bi instruc\u021Biunile",
            "voucher.introduction": "V\u0103 mul\u021Bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021Bi urm\u0103torul cupon pentru a v\u0103 finaliza plata.",
            "voucher.expirationDate": "Data de expirare",
            "voucher.alternativeReference": "Referin\u021B\u0103 alternativ\u0103",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Selecta\u021Bi furnizorul dvs.",
            "dragonpay.voucher.bank.selectField.placeholder": "Selecta\u021Bi banca dvs.",
            "voucher.paymentReferenceLabel": "Referin\u021Ba pl\u0103\u021Bii",
            "voucher.surcharge": "Include suprataxa de %@",
            "voucher.introduction.doku": "V\u0103 mul\u021Bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021Bi urm\u0103toarele informa\u021Bii pentru a v\u0103 finaliza plata.",
            "voucher.shopperName": "Nume cump\u0103r\u0103tor",
            "voucher.merchantName": "Comerciant",
            "voucher.introduction.econtext": "V\u0103 mul\u021Bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021Bi urm\u0103toarele informa\u021Bii pentru a v\u0103 finaliza plata.",
            "voucher.telephoneNumber": "Num\u0103r de telefon",
            "voucher.shopperReference": "Referin\u021B\u0103 cump\u0103r\u0103tor",
            "voucher.collectionInstitutionNumber": "Num\u0103r institu\u021Bie de colectare",
            "voucher.econtext.telephoneNumber.invalid": "Num\u0103rul de telefon trebuie s\u0103 aib\u0103 10 sau 11 cifre",
            "boletobancario.btnLabel": "Generare Boleto",
            "boleto.sendCopyToEmail": "Trimite o copie la adresa mea de e-mail",
            "button.copy": "Copiere",
            "button.download": "Desc\u0103rcare",
            "boleto.socialSecurityNumber.invalid": "Completa\u021Bi un num\u0103r CPF/CNPJ valabil",
            "creditCard.storedCard.description.ariaLabel": "Cardul memorat se termin\u0103 \xeen %@",
            "voucher.entity": "Entitate",
            donateButton: "Dona\u021Bi",
            notNowButton: "Nu acum",
            thanksForYourSupport: "V\u0103 mul\u021Bumim pentru sprijin!",
            "resultMessages.preauthorized": "Detalii salvate",
            preauthorizeWith: "Preautorizare cu",
            confirmPreauthorization: "Confirma\u021Bi preautorizarea",
            confirmPurchase: "Confirma\u021Bi achizi\u021Bia",
            applyGiftcard: "Valorificare",
            giftcardBalance: "Soldul de pe cardul cadou",
            deductedBalance: "Sold sc\u0103zut",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "Primele 2 cifre ale parolei aferente cardului",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Parol\u0103 incorect\u0103",
            "creditCard.taxNumber": "Data de na\u0219tere a posesorului de card sau codul unic de \xeenregistrare al societ\u0103\u021Bii",
            "creditCard.taxNumber.label": "Data de na\u0219tere a posesorului de card (AALLZZ) sau num\u0103rul de \xeenregistrare al societ\u0103\u021Bii (10 cifre).",
            "creditCard.taxNumber.labelAlt": "Num\u0103rul de \xeenregistrare al societ\u0103\u021Bii (10 cifre)",
            "creditCard.taxNumber.invalid": "Data de na\u0219tere a posesorului de card sau num\u0103rul de \xeenregistrare al societ\u0103\u021Bii este incorect",
            "storedPaymentMethod.disable.button": "\u0218tergere",
            "storedPaymentMethod.disable.confirmation": "\u0218terge\u021Bi metoda de plat\u0103 memorat\u0103",
            "storedPaymentMethod.disable.confirmButton": "Da, \u0219terge",
            "storedPaymentMethod.disable.cancelButton": "Anulare",
            "ach.bankAccount": "Cont bancar",
            "ach.accountHolderNameField.title": "Numele titularului de cont",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "Numele titularului de cont este incorect",
            "ach.accountNumberField.title": "Num\u0103r de cont",
            "ach.accountNumberField.invalid": "Num\u0103rul de cont este incorect",
            "ach.accountLocationField.title": "Num\u0103r de direc\u021Bionare ABA",
            "ach.accountLocationField.invalid": "Num\u0103r de direc\u021Bionare ABA incorect",
            "ach.savedBankAccount": "Cont bancar salvat",
            "select.state": "Selecta\u021Bi statul",
            "select.stateOrProvince": "Selecta\u021Bi jude\u021Bul sau provincia",
            "select.provinceOrTerritory": "Selecta\u021Bi provincia sau teritoriul",
            "select.country": "Selecta\u021Bi \u021Bara/regiunea",
            "select.noOptionsFound": "Nu s-a g\u0103sit nicio op\u021Biune",
            "select.filter.placeholder": "C\u0103utare...",
            "telephoneNumber.invalid": "Num\u0103r de telefon incorect",
            qrCodeOrApp: "sau",
            "paypal.processingPayment": "Se prelucreaz\u0103 plata...",
            generateQRCode: "Genera\u021Bi codul QR",
            "await.waitForConfirmation": "Se a\u0219teapt\u0103 confirmarea",
            "mbway.confirmPayment": "Confirma\u021Bi plata \xeen aplica\u021Bia MB WAY",
            "shopperEmail.invalid": "Adres\u0103 de e-mail incorect\u0103",
            "dateOfBirth.format": "ZZ/LL/AAAA",
            "dateOfBirth.invalid": "Completa\u021Bi o dat\u0103 de na\u0219tere valabil\u0103 care s\u0103 indice c\u0103 ave\u021Bi cel pu\u021Bin 18 ani.",
            "blik.confirmPayment": "Deschide\u021Bi aplica\u021Bia dvs. de banking pentru a confirma plata.",
            "blik.invalid": "Introduce\u021Bi 6 cifre",
            "blik.code": "Cod din 6 cifre",
            "blik.help": "Ob\u021Bine\u021Bi codul din aplica\u021Bia dvs. de banking.",
            "swish.pendingMessage": "Dup\u0103 ce scana\u021Bi, starea poate fi \u201E\xeen a\u0219teptare\u201D timp de maximum 10 minute. \xcencerc\u0103rile de a pl\u0103ti din nou \xeen acest r\u0103stimp pot genera prelev\u0103ri multiple de fonduri.",
            "field.valid": "C\xe2mp valid",
            "field.invalid": "C\xe2mp incorect",
            "error.va.gen.01": "C\xe2mp incomplet",
            "error.va.gen.02": "C\xe2mp incorect",
            "error.va.sf-cc-num.01": "Completa\u021Bi un num\u0103r valabil de card",
            "error.va.sf-cc-num.02": "Completa\u021Bi num\u0103rul cardului",
            "error.va.sf-cc-num.03": "Completa\u021Bi un brand de card acceptat",
            "error.va.sf-cc-num.04": "Completa\u021Bi num\u0103rul complet al cardului",
            "error.va.sf-cc-dat.01": "Completa\u021Bi o dat\u0103 de expirare valabil\u0103",
            "error.va.sf-cc-dat.02": "Completa\u021Bi o dat\u0103 de expirare valabil\u0103",
            "error.va.sf-cc-dat.03": "Card de credit pe cale s\u0103 expire",
            "error.va.sf-cc-dat.04": "Completa\u021Bi data de expirare",
            "error.va.sf-cc-dat.05": "Completa\u021Bi data de expirare complet\u0103",
            "error.va.sf-cc-mth.01": "Completa\u021Bi luna de expirare",
            "error.va.sf-cc-yr.01": "Completa\u021Bi anul de expirare",
            "error.va.sf-cc-yr.02": "Completa\u021Bi anul de expirare complet",
            "error.va.sf-cc-cvc.01": "Completa\u021Bi codul de securitate",
            "error.va.sf-cc-cvc.02": "Completa\u021Bi codul de securitate complet",
            "error.va.sf-ach-num.01": "C\xe2mpul pentru num\u0103rul de cont bancar este necompletat",
            "error.va.sf-ach-num.02": "Num\u0103rul contului bancar are lungimea gre\u0219it\u0103",
            "error.va.sf-ach-loc.01": "C\xe2mpul pentru num\u0103rul de rutare al b\u0103ncii este necompletat",
            "error.va.sf-ach-loc.02": "Num\u0103rul de rutare al b\u0103ncii are lungimea gre\u0219it\u0103",
            "error.va.sf-kcp-pwd.01": "C\xe2mpul pentru parol\u0103 este necompletat",
            "error.va.sf-kcp-pwd.02": "Parola are lungimea gre\u0219it\u0103",
            "error.giftcard.no-balance": "Acest card cadou are soldul zero",
            "error.giftcard.card-error": "\xcen eviden\u021Bele noastre nu figureaz\u0103 niciun card cadou cu acest num\u0103r",
            "error.giftcard.currency-error": "Cardurile cadou sunt valabile numai \xeen moneda \xeen care au fost emise",
            "amazonpay.signout": "Deconecta\u021Bi-v\u0103 de pe platforma Amazon",
            "amazonpay.changePaymentDetails": "Modifica\u021Bi detaliile de plat\u0103",
            "partialPayment.warning": "Pentru a achita suma r\u0103mas\u0103, selecta\u021Bi o alt\u0103 metod\u0103 de plat\u0103",
            "partialPayment.remainingBalance": "Soldul r\u0103mas va fi de %{amount}",
            "bankTransfer.beneficiary": "Beneficiar",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Referin\u0163\u0103",
            "bankTransfer.introduction": "Continua\u021Bi s\u0103 crea\u021Bi o nou\u0103 plat\u0103 prin transfer bancar. Pute\u021Bi utiliza detaliile din ecranul urm\u0103tor pentru a finaliza aceast\u0103 plat\u0103.",
            "bankTransfer.instructions": "V\u0103 mul\u021Bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021Bi urm\u0103toarele informa\u021Bii pentru a v\u0103 finaliza plata.",
            "bacs.accountHolderName": "Numele titularului contului bancar",
            "bacs.accountHolderName.invalid": "Numele titularului contului bancar este incorect",
            "bacs.accountNumber": "Num\u0103rul contului bancar",
            "bacs.accountNumber.invalid": "Num\u0103rul contului bancar este incorect",
            "bacs.bankLocationId": "Cod de identificare bancar\u0103",
            "bacs.bankLocationId.invalid": "Cod de identificare bancar\u0103 incorect",
            "bacs.consent.amount": "Sunt de acord ca suma men\u021Bionat\u0103 mai sus s\u0103 fie dedus\u0103 din contul meu bancar.",
            "bacs.consent.account": "Confirm c\u0103 sunt titularul acestui cont \u0219i c\u0103 sunt singurul semnatar necesar pentru autorizarea debitului direct pentru acest cont.",
            edit: "Editare",
            "bacs.confirm": "Confirma\u021Bi \u0219i pl\u0103ti\u021Bi",
            "bacs.result.introduction": "Desc\u0103rca\u021Bi instruc\u021Biunile de debitare direct\u0103 (DDI/mandat)",
            "download.pdf": "Desc\u0103rca\u021Bi PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe pentru num\u0103rul cardului",
            "creditCard.encryptedCardNumber.aria.label": "Num\u0103r card",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe pentru data de expirare",
            "creditCard.encryptedExpiryDate.aria.label": "Data expir\u0103rii",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe pentru luna de expirare",
            "creditCard.encryptedExpiryMonth.aria.label": "Luna de expirare",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe pentru anul de expirare",
            "creditCard.encryptedExpiryYear.aria.label": "Anul de expirare",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe pentru codul de securitate",
            "creditCard.encryptedSecurityCode.aria.label": "Cod de securitate",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe pentru parol\u0103",
            "creditCard.encryptedPassword.aria.label": "Primele 2 cifre ale parolei aferente cardului",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe pentru num\u0103rul cardului",
            "giftcard.encryptedCardNumber.aria.label": "Num\u0103r card",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe pentru PIN",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "Pentru acest card cadou, suma maxim\u0103 permis\u0103 per tranzac\u021Bie este de %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe pentru num\u0103rul de cont bancar",
            "ach.encryptedBankAccountNumber.aria.label": "Num\u0103r de cont",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe pentru num\u0103rul de identificare bancar\u0103",
            "ach.encryptedBankLocationId.aria.label": "Num\u0103r de direc\u021Bionare ABA",
            "twint.saved": "salvat",
            orPayWith: "sau pl\u0103ti\u021Bi cu",
            invalidFormatExpects: "Format nevalid. Format solicitat: %{format}",
            "upi.qrCodeWaitingMessage": "Scana\u021Bi codul QR folosind aplica\u021Bia UPI preferat\u0103 pentru a finaliza plata",
            "upi.vpaWaitingMessage": "Deschide\u021Bi aplica\u021Bia UPI pentru a confirma plata",
            "upi.modeSelection": "Selecta\u021Bi modul \xeen care dori\u021Bi s\u0103 utiliza\u021Bi UPI.",
            "onlineBanking.termsAndConditions": "Continu\xe2nd, sunte\u021Bi de acord cu %#terms and conditions%#",
            "onlineBankingPL.termsAndConditions": "Continu\xe2nd, sunte\u021Bi de acord cu %#reglement\u0103rile%# \u0219i cu %#obliga\u021Bia de informare%# a Przelewy24",
            "ctp.loading.poweredByCtp": "Sus\u021Binut de Click to Pay",
            "ctp.loading.intro": "Verific\u0103m dac\u0103 ave\u021Bi vreun card salvat cu Click to Pay...",
            "ctp.login.title": "Continua\u021Bi c\u0103tre Click to Pay",
            "ctp.login.subtitle": "Introduce\u021Bi adresa de e-mail care este conectat\u0103 la Click to Pay pentru a continua.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "Nu sunte\u021Bi dvs.?",
            "ctp.logout.notYourCards": "Nu sunt cardurile dvs.?",
            "ctp.logout.notYourCard": "Nu este cardul dvs.?",
            "ctp.logout.notYourProfile": "Nu este profilul dvs.?",
            "ctp.otp.fieldLabel": "Cod unic",
            "ctp.otp.resendCode": "Retrimite\u021Bi codul",
            "ctp.otp.codeResent": "Cod retrimis",
            "ctp.otp.title": "Accesa\u021Bi-v\u0103 cardurile Click to Pay",
            "ctp.otp.subtitle": "Introduce\u021Bi codul %@ pe care l-am trimis la %@ pentru a confirma c\u0103 sunte\u021Bi dvs.",
            "ctp.otp.saveCookiesCheckbox.label": "Omite\u021Bi verificarea data viitoare",
            "ctp.otp.saveCookiesCheckbox.information": "Selecta\u021Bi pentru a fi re\u021Binut pe dispozitiv \u0219i \xeen browserul dvs. la magazinele participante pentru o plat\u0103 mai rapid\u0103. Nerecomandat pentru dispozitivele partajate.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Selecta\u021Bi pentru a fi memorat pe dispozitiv \u0219i browser",
            "ctp.emptyProfile.message": "Niciun card \xeenregistrat \xeen acest profil Click to Pay",
            "ctp.separatorText": "sau folosi\u021Bi",
            "ctp.cards.title": "Finaliza\u021Bi plata cu Click to Pay",
            "ctp.cards.subtitle": "Selecta\u021Bi un card pe care s\u0103 \xeel utiliza\u021Bi.",
            "ctp.cards.expiredCard": "Expirat",
            "ctp.manualCardEntry": "Introducere manual\u0103 a cardului",
            "ctp.aria.infoModalButton": "Ce este Click to Pay",
            "ctp.infoPopup.title": "Click to Pay v\u0103 ofer\u0103 facilit\u0103\u021Bile contactless, online",
            "ctp.infoPopup.subtitle": "O metod\u0103 de plat\u0103 rapid\u0103 \u0219i sigur\u0103, compatibil\u0103 cu Mastercard, Visa \u0219i alte carduri de plat\u0103.",
            "ctp.infoPopup.benefit1": "Click to Pay folose\u0219te criptarea pentru a v\u0103 p\u0103stra informa\u021Biile \xeen siguran\u021B\u0103",
            "ctp.infoPopup.benefit2": "Utiliza\u021Bi-l la comercian\u021Bii din \xeentreaga lume",
            "ctp.infoPopup.benefit3": "Configura\u021Bi o dat\u0103 pentru a pl\u0103ti f\u0103r\u0103 probleme \xeen viitor",
            "ctp.errors.AUTH_INVALID": "Autentificare incorect\u0103",
            "ctp.errors.NOT_FOUND": "Nu s-a g\u0103sit niciun cont; introduce\u021Bi o adres\u0103 de e-mail valabil\u0103 sau continua\u021Bi complet\xe2nd manual cardul",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Format neacceptat",
            "ctp.errors.FRAUD": "Contul de utilizator a fost blocat sau dezactivat",
            "ctp.errors.CONSUMER_ID_MISSING": "Identitatea consumatorului lipse\u0219te din solicitare",
            "ctp.errors.ACCT_INACCESSIBLE": "Acest cont nu este disponibil \xeen prezent, de exemplu, este blocat.",
            "ctp.errors.CODE_INVALID": "Cod de verificare incorect",
            "ctp.errors.CODE_EXPIRED": "Acest cod a expirat",
            "ctp.errors.RETRIES_EXCEEDED": "A fost dep\u0103\u0219it\u0103 limita num\u0103rului de \xeencerc\u0103ri pentru generarea parolei unice",
            "ctp.errors.OTP_SEND_FAILED": "Parola unic\u0103 nu a putut fi trimis\u0103 destinatarului",
            "ctp.errors.REQUEST_TIMEOUT": "Ceva nu a mers bine, \xeencerca\u021Bi din nou sau introduce\u021Bi manual cardul",
            "ctp.errors.UNKNOWN_ERROR": "Ceva nu a mers bine, \xeencerca\u021Bi din nou sau introduce\u021Bi manual cardul",
            "ctp.errors.SERVICE_ERROR": "Ceva nu a mers bine, \xeencerca\u021Bi din nou sau introduce\u021Bi manual cardul",
            "ctp.errors.SERVER_ERROR": "Ceva nu a mers bine, \xeencerca\u021Bi din nou sau introduce\u021Bi manual cardul",
            "ctp.errors.INVALID_PARAMETER": "Ceva nu a mers bine, \xeencerca\u021Bi din nou sau introduce\u021Bi manual cardul",
            "ctp.errors.AUTH_ERROR": "Ceva nu a mers bine, \xeencerca\u021Bi din nou sau introduce\u021Bi manual cardul",
            "paymentMethodsList.aria.label": "Alege\u021Bi o metod\u0103 de plat\u0103",
            "companyDetails.name.invalid": "Completa\u021Bi numele societ\u0103\u021Bii",
            "companyDetails.registrationNumber.invalid": "Completa\u021Bi num\u0103rul de \xeenregistrare",
            "consent.checkbox.invalid": "Trebuie s\u0103 fi\u021Bi de acord cu termenii \u0219i condi\u021Biile",
            "form.instruction": "Toate c\xe2mpurile sunt obligatorii, numai dac\u0103 nu este marcat altfel.",
            "trustly.descriptor": "Plat\u0103 bancar\u0103 instantanee",
            "trustly.description1": "Pl\u0103ti\u021Bi direct din oricare dintre conturile dvs. bancare, cu sprijinul unei securit\u0103\u021Bi de nivel bancar",
            "trustly.description2": "F\u0103r\u0103 carduri, f\u0103r\u0103 desc\u0103rc\u0103ri de aplica\u021Bii, f\u0103r\u0103 \xeenregistrare",
            "ancv.input.label": "Identificarea dvs. ANCV",
            "ancv.confirmPayment": "Utiliza\u021Bi aplica\u021Bia ANCV pentru a confirma plata.",
            "ancv.form.instruction": "Aplica\u021Bia Cheque-Vacances este necesar\u0103 pentru a valida aceast\u0103 plat\u0103.",
            "ancv.beneficiaryId.invalid": "Completa\u021Bi o adres\u0103 de e-mail sau un ID ANCV valabil",
            "payme.openPayMeApp": "Finaliza\u021Bi plata \xeen aplica\u021Bia PayMe, autoriz\xe2nd plata \xeen aplica\u021Bie, \u0219i a\u0219tepta\u021Bi confirmarea.",
            "payme.redirectButtonLabel": "Deschide\u021Bi aplica\u021Bia PayMe",
            "payme.scanQrCode": "Finaliza\u021Bi plata folosind codul QR",
            "payme.timeToPay": "Acest cod QR este valabil pentru %@",
            "payme.instructions.steps": "Deschide\u021Bi aplica\u021Bia PayMe.%@Scana\u021Bi codul QR pentru a autoriza plata.%@Finaliza\u021Bi plata \xeen aplica\u021Bie \u0219i a\u0219tepta\u021Bi confirmarea.",
            "payme.instructions.footnote": "Nu \xeenchide\u021Bi aceast\u0103 pagin\u0103 \xeenainte de finalizarea pl\u0103\u021Bii."
        }
    }), H2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "\u0417\u0430\u043F\u043B\u0430\u0442\u0438\u0442\u044C",
            "payButton.redirecting": "\u041F\u0435\u0440\u0435\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435...",
            "payButton.with": "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C %{value} %{maskedData}",
            "payButton.saveDetails": "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
            close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
            storeDetails: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0434\u043B\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0433\u043E \u043F\u043B\u0430\u0442\u0435\u0436\u0430",
            readMore: "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435",
            "creditCard.holderName": "\u0418\u043C\u044F \u043D\u0430 \u043A\u0430\u0440\u0442\u0435",
            "creditCard.holderName.placeholder": "\u0418. \u041F\u0435\u0442\u0440\u043E\u0432",
            "creditCard.holderName.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043C\u044F, \u043A\u0430\u043A \u043E\u043D\u043E \u0443\u043A\u0430\u0437\u0430\u043D\u043E \u043D\u0430 \u043A\u0430\u0440\u0442\u0435",
            "creditCard.numberField.title": "\u041D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "\u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "creditCard.expiryDateField.placeholder": "\u041C\u041C/\u0413\u0413",
            "creditCard.expiryDateField.month": "\u041C\u0435\u0441\u044F\u0446",
            "creditCard.expiryDateField.month.placeholder": "\u041C\u041C",
            "creditCard.expiryDateField.year.placeholder": "\u0413\u0413",
            "creditCard.expiryDateField.year": "\u0413\u043E\u0434",
            "creditCard.cvcField.title": "\u0417\u0430\u0449\u0438\u0442\u043D\u044B\u0439 \u043A\u043E\u0434",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "\u0417\u0430\u043F\u043E\u043C\u043D\u0438\u0442\u044C \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0440\u0430\u0437",
            "creditCard.cvcField.placeholder.4digits": "4 \u0446\u0438\u0444\u0440\u044B",
            "creditCard.cvcField.placeholder.3digits": "3 \u0446\u0438\u0444\u0440\u044B",
            "creditCard.taxNumber.placeholder": "\u0413\u0413\u041C\u041C\u0414\u0414 / 0123456789",
            installments: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439",
            installmentOption: "%{times}\xd7 %{partialValue}",
            installmentOptionMonths: "%{times} \u043C\u0435\u0441.",
            "installments.oneTime": "\u041E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u044B\u0439 \u043F\u043B\u0430\u0442\u0435\u0436",
            "installments.installments": "\u0420\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0430",
            "installments.revolving": "\u041F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0449\u0430\u044F\u0441\u044F \u043E\u043F\u043B\u0430\u0442\u0430",
            "sepaDirectDebit.ibanField.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0441\u0447\u0435\u0442\u0430",
            "sepaDirectDebit.nameField.placeholder": "\u0418. \u041F\u0435\u0442\u0440\u043E\u0432",
            "sepa.ownerName": "\u0418\u043C\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430",
            "sepa.ibanNumber": "\u041D\u043E\u043C\u0435\u0440 \u0441\u0447\u0435\u0442\u0430 (IBAN)",
            "error.title": "\u041E\u0448\u0438\u0431\u043A\u0430",
            "error.subtitle.redirect": "\u0421\u0431\u043E\u0439 \u043F\u0435\u0440\u0435\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F",
            "error.subtitle.payment": "\u0421\u0431\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u044B",
            "error.subtitle.refused": "\u041E\u043F\u043B\u0430\u0442\u0430 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430",
            "error.message.unknown": "\u0412\u043E\u0437\u043D\u0438\u043A\u043B\u0430 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430",
            "errorPanel.title": "\u0418\u043C\u0435\u044E\u0449\u0438\u0435\u0441\u044F \u043E\u0448\u0438\u0431\u043A\u0438",
            "idealIssuer.selectField.title": "\u0411\u0430\u043D\u043A",
            "idealIssuer.selectField.placeholder": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u0430\u043D\u043A",
            "creditCard.success": "\u041F\u043B\u0430\u0442\u0435\u0436 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D",
            loading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
            continue: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C",
            continueTo: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A",
            "wechatpay.timetopay": "\u0423 \u0432\u0430\u0441 %@ \u043D\u0430 \u043E\u043F\u043B\u0430\u0442\u0443",
            "sr.wechatpay.timetopay": "\u0423 \u0432\u0430\u0441 \u0435\u0441\u0442\u044C %#\u043C\u0438\u043D.%# %#\u0441\u0435\u043A.%# \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u044B",
            "wechatpay.scanqrcode": "\u0421\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C QR-\u043A\u043E\u0434",
            personalDetails: "\u041B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435",
            companyDetails: "\u0414\u0430\u043D\u043D\u044B\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438",
            "companyDetails.name": "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438",
            "companyDetails.registrationNumber": "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440",
            socialSecurityNumber: "\u041D\u043E\u043C\u0435\u0440 \u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u044F \u0438\u043B\u0438 \u0418\u041D\u041D",
            firstName: "\u0418\u043C\u044F",
            "firstName.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043C\u044F",
            infix: "\u041F\u0440\u0438\u0441\u0442\u0430\u0432\u043A\u0430",
            lastName: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F",
            "lastName.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0444\u0430\u043C\u0438\u043B\u0438\u044E",
            mobileNumber: "\u041C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0439 \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
            "mobileNumber.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u043D\u043E\u043C\u0435\u0440 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E",
            city: "\u0413\u043E\u0440\u043E\u0434",
            postalCode: "\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0438\u043D\u0434\u0435\u043A\u0441",
            "postalCode.optional": "\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0438\u043D\u0434\u0435\u043A\u0441 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
            countryCode: "\u041A\u043E\u0434 \u0441\u0442\u0440\u0430\u043D\u044B",
            telephoneNumber: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
            dateOfBirth: "\u0414\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F",
            shopperEmail: "\u0410\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B",
            gender: "\u041F\u043E\u043B",
            "gender.notselected": "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u043F\u043E\u043B",
            male: "\u041C\u0443\u0436\u0447\u0438\u043D\u0430",
            female: "\u0416\u0435\u043D\u0449\u0438\u043D\u0430",
            billingAddress: "\u041F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441",
            street: "\u0423\u043B\u0438\u0446\u0430",
            stateOrProvince: "\u0420\u0435\u0433\u0438\u043E\u043D",
            country: "\u0421\u0442\u0440\u0430\u043D\u0430/\u0440\u0435\u0433\u0438\u043E\u043D",
            houseNumberOrName: "\u041D\u043E\u043C\u0435\u0440 \u0434\u043E\u043C\u0430",
            separateDeliveryAddress: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
            deliveryAddress: "\u0410\u0434\u0440\u0435\u0441 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
            "deliveryAddress.firstName": "\u0418\u043C\u044F \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F",
            "deliveryAddress.lastName": "\u0424\u0430\u043C\u0438\u043B\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F",
            zipCode: "\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0438\u043D\u0434\u0435\u043A\u0441",
            apartmentSuite: "\u041A\u0432\u0430\u0440\u0442\u0438\u0440\u0430 / \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0435",
            provinceOrTerritory: "\u041F\u0440\u043E\u0432\u0438\u043D\u0446\u0438\u044F \u0438\u043B\u0438 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F",
            cityTown: "\u0413\u043E\u0440\u043E\u0434",
            address: "\u0410\u0434\u0440\u0435\u0441",
            "address.placeholder": "\u041D\u0430\u0439\u0442\u0438 \u0441\u0432\u043E\u0439 \u0430\u0434\u0440\u0435\u0441",
            "address.errors.incomplete": "\u0414\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u0443\u043A\u0430\u0436\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441",
            "address.enterManually": "\u0412\u0432\u0435\u0441\u0442\u0438 \u0430\u0434\u0440\u0435\u0441 \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            state: "\u0428\u0442\u0430\u0442",
            "field.title.optional": "(\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
            "creditCard.cvcField.title.optional": "\u0417\u0430\u0449\u0438\u0442\u043D\u044B\u0439 \u043A\u043E\u0434 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
            "issuerList.wallet.placeholder": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
            privacyPolicy: "\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438",
            "afterPay.agreement": "\u042F \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u044E %@ Riverty",
            paymentConditions: "\u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B",
            openApp: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
            "voucher.readInstructions": "\u041F\u0440\u043E\u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438",
            "voucher.introduction": "\u0411\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0437\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0443. \u0414\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u043A\u0443\u043F\u043E\u043D.",
            "voucher.expirationDate": "\u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "voucher.alternativeReference": "\u0414\u0440\u0443\u0433\u043E\u0439 \u043A\u043E\u0434",
            "dragonpay.voucher.non.bank.selectField.placeholder": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0432\u043E\u0435\u0433\u043E \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430",
            "dragonpay.voucher.bank.selectField.placeholder": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u0430\u043D\u043A",
            "voucher.paymentReferenceLabel": "\u041A\u043E\u0434 \u043E\u043F\u043B\u0430\u0442\u044B",
            "voucher.surcharge": "\u0412\u043A\u043B. \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u044E %@",
            "voucher.introduction.doku": "\u0411\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0437\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0443. \u0414\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u044F.",
            "voucher.shopperName": "\u0418\u043C\u044F \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F",
            "voucher.merchantName": "\u041F\u0440\u043E\u0434\u0430\u0432\u0435\u0446",
            "voucher.introduction.econtext": "\u0411\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0437\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0443. \u0414\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u044F.",
            "voucher.telephoneNumber": "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
            "voucher.shopperReference": "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F",
            "voucher.collectionInstitutionNumber": "\u041D\u043E\u043C\u0435\u0440 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F \u0441\u0440\u0435\u0434\u0441\u0442\u0432",
            "voucher.econtext.telephoneNumber.invalid": "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0434\u043B\u0438\u043D\u043E\u0439 10 \u0438\u043B\u0438 11 \u0446\u0438\u0444\u0440",
            "boletobancario.btnLabel": "\u0421\u043E\u0437\u0434\u0430\u0442\u044C Boleto",
            "boleto.sendCopyToEmail": "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043C\u043D\u0435 \u043A\u043E\u043F\u0438\u044E \u043D\u0430 \u044D\u043B. \u043F\u043E\u0447\u0442\u0443",
            "button.copy": "\u041A\u043E\u043F\u0438\u044F",
            "button.download": "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C",
            "boleto.socialSecurityNumber.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 CPF/CNPJ",
            "creditCard.storedCard.description.ariaLabel": "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430 \u0437\u0430\u043A\u0430\u043D\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u043D\u0430 %@",
            "voucher.entity": "\u041E\u0431\u044A\u0435\u043A\u0442",
            donateButton: "\u041F\u043E\u0436\u0435\u0440\u0442\u0432\u043E\u0432\u0430\u0442\u044C",
            notNowButton: "\u041F\u043E\u0437\u0436\u0435",
            thanksForYourSupport: "\u0411\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0437\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443!",
            "resultMessages.preauthorized": "\u0414\u0430\u043D\u043D\u044B\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u044B",
            preauthorizeWith: "\u041F\u0440\u0435\u0434\u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F \u0432",
            confirmPreauthorization: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u043F\u0440\u0435\u0434\u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044E",
            confirmPurchase: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u043F\u043E\u043A\u0443\u043F\u043A\u0443",
            applyGiftcard: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C",
            giftcardBalance: "\u0411\u0430\u043B\u0430\u043D\u0441 \u043F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u044B",
            deductedBalance: "\u0411\u0430\u043B\u0430\u043D\u0441 \u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0439",
            "creditCard.pin.title": "PIN-\u043A\u043E\u0434",
            "creditCard.encryptedPassword.label": "\u041F\u0435\u0440\u0432\u044B\u0435 2 \u0446\u0438\u0444\u0440\u044B \u043F\u0430\u0440\u043E\u043B\u044F \u043A\u0430\u0440\u0442\u044B",
            "creditCard.encryptedPassword.invalid": "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
            "creditCard.taxNumber": "\u0414\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u043A\u0430\u0440\u0442\u044B \u0438\u043B\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u044F",
            "creditCard.taxNumber.label": "\u0414\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u043A\u0430\u0440\u0442\u044B (\u0413\u0413\u041C\u041C\u0414\u0414) \u0438\u043B\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u044F (10 \u0446\u0438\u0444\u0440)",
            "creditCard.taxNumber.labelAlt": "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u044F (10 \u0446\u0438\u0444\u0440)",
            "creditCard.taxNumber.invalid": "\u041D\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u0434\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u043A\u0430\u0440\u0442\u044B \u0438\u043B\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u044F",
            "storedPaymentMethod.disable.button": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
            "storedPaymentMethod.disable.confirmation": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B",
            "storedPaymentMethod.disable.confirmButton": "\u0414\u0430, \u0443\u0434\u0430\u043B\u0438\u0442\u044C",
            "storedPaymentMethod.disable.cancelButton": "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C",
            "ach.bankAccount": "\u0411\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0439 \u0441\u0447\u0435\u0442",
            "ach.accountHolderNameField.title": "\u0418\u043C\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u043A\u0430\u0440\u0442\u044B",
            "ach.accountHolderNameField.placeholder": "\u0418. \u041F\u0435\u0442\u0440\u043E\u0432",
            "ach.accountHolderNameField.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0438\u043C\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u043A\u0430\u0440\u0442\u044B",
            "ach.accountNumberField.title": "\u041D\u043E\u043C\u0435\u0440 \u0441\u0447\u0435\u0442\u0430",
            "ach.accountNumberField.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0441\u0447\u0435\u0442\u0430",
            "ach.accountLocationField.title": "\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 ABA",
            "ach.accountLocationField.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 ABA",
            "ach.savedBankAccount": "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0439 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0439 \u0441\u0447\u0435\u0442",
            "select.state": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0442\u0430\u0442",
            "select.stateOrProvince": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0442\u0430\u0442 \u0438\u043B\u0438 \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
            "select.provinceOrTerritory": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u0440\u043E\u0432\u0438\u043D\u0446\u0438\u044E \u0438\u043B\u0438 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044E",
            "select.country": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0443/\u0440\u0435\u0433\u0438\u043E\u043D",
            "select.noOptionsFound": "\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0432 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E",
            "select.filter.placeholder": "\u041F\u043E\u0438\u0441\u043A\u2026",
            "telephoneNumber.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
            qrCodeOrApp: "\u0438\u043B\u0438",
            "paypal.processingPayment": "\u041F\u043B\u0430\u0442\u0435\u0436 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F\u2026",
            generateQRCode: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C QR-\u043A\u043E\u0434",
            "await.waitForConfirmation": "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F",
            "mbway.confirmPayment": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043E\u043F\u043B\u0430\u0442\u0443 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 MB WAY",
            "shopperEmail.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B",
            "dateOfBirth.format": "\u0414\u0414/\u041C\u041C/\u0413\u0413\u0413\u0413",
            "dateOfBirth.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0443\u044E \u0434\u0430\u0442\u0443 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F. \u0412\u0430\u043C \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 18 \u043B\u0435\u0442.",
            "blik.confirmPayment": "\u0414\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u043E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430.",
            "blik.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 6 \u0446\u0438\u0444\u0440",
            "blik.code": "6-\u0437\u043D\u0430\u0447\u043D\u044B\u0439 \u043A\u043E\u0434",
            "blik.help": "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u043A\u043E\u0434 \u0438\u0437 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u0431\u0430\u043D\u043A\u0430.",
            "swish.pendingMessage": "\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043E\u043F\u043B\u0430\u0442\u044B \u043F\u043E\u0441\u043B\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043C\u043E\u0436\u0435\u0442 \u0437\u0430\u043D\u044F\u0442\u044C 10 \u043C\u0438\u043D\u0443\u0442. \u041F\u043E\u043F\u044B\u0442\u043A\u0430 \u043F\u0440\u043E\u0432\u0435\u0441\u0442\u0438 \u043E\u043F\u043B\u0430\u0442\u0443 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0433\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u0438\u0432\u0435\u0441\u0442\u0438 \u043A \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u043C \u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F\u043C \u0441\u043E \u0441\u0447\u0435\u0442\u0430.",
            "field.valid": "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435",
            "field.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435",
            "error.va.gen.01": "\u041D\u0435\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u043E\u0435 \u043F\u043E\u043B\u0435",
            "error.va.gen.02": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435",
            "error.va.sf-cc-num.01": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u044B",
            "error.va.sf-cc-num.02": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B",
            "error.va.sf-cc-num.03": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043C\u0443\u044E \u043C\u0430\u0440\u043A\u0443 \u043A\u0430\u0440\u0442\u044B",
            "error.va.sf-cc-num.04": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E",
            "error.va.sf-cc-dat.01": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0443\u044E \u0434\u0430\u0442\u0443 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "error.va.sf-cc-dat.02": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0443\u044E \u0434\u0430\u0442\u0443 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "error.va.sf-cc-dat.03": "\u0421\u043A\u043E\u0440\u043E \u0438\u0441\u0442\u0435\u043A\u0430\u0435\u0442 \u0441\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043A\u0440\u0435\u0434\u0438\u0442\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u044B",
            "error.va.sf-cc-dat.04": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0440\u043E\u043A \u0433\u043E\u0434\u043D\u043E\u0441\u0442\u0438",
            "error.va.sf-cc-dat.05": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E\u043B\u043D\u0443\u044E \u0434\u0430\u0442\u0443 \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "error.va.sf-cc-mth.01": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043C\u0435\u0441\u044F\u0446 \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "error.va.sf-cc-yr.01": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0433\u043E\u0434 \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "error.va.sf-cc-yr.02": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0433\u043E\u0434 \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E",
            "error.va.sf-cc-cvc.01": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0437\u0430\u0449\u0438\u0442\u043D\u044B\u0439 \u043A\u043E\u0434",
            "error.va.sf-cc-cvc.02": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0437\u0430\u0449\u0438\u0442\u043D\u044B\u0439 \u043A\u043E\u0434 \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E",
            "error.va.sf-ach-num.01": "\u041F\u043E\u043B\u0435 \u043D\u043E\u043C\u0435\u0440\u0430 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430 \u043D\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E",
            "error.va.sf-ach-num.02": "\u041D\u043E\u043C\u0435\u0440 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430 \u0438\u043C\u0435\u0435\u0442 \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0443\u044E \u0434\u043B\u0438\u043D\u0443",
            "error.va.sf-ach-loc.01": "\u041F\u043E\u043B\u0435 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u043D\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 \u0431\u0430\u043D\u043A\u0430 \u043D\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E",
            "error.va.sf-ach-loc.02": "\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0431\u0430\u043D\u043A\u0430 \u0438\u043C\u0435\u0435\u0442 \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0443\u044E \u0434\u043B\u0438\u043D\u0443",
            "error.va.sf-kcp-pwd.01": "\u041F\u043E\u043B\u0435 \u043F\u0430\u0440\u043E\u043B\u044F \u043D\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E",
            "error.va.sf-kcp-pwd.02": "\u041F\u0430\u0440\u043E\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0443\u044E \u0434\u043B\u0438\u043D\u0443",
            "error.giftcard.no-balance": "\u041D\u0430 \u044D\u0442\u043E\u0439 \u043F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435 \u043D\u0435\u0442 \u0441\u0440\u0435\u0434\u0441\u0442\u0432",
            "error.giftcard.card-error": "\u0423 \u043D\u0430\u0441 \u043D\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u043A\u0430\u0440\u0442\u0430 \u0441 \u0442\u0430\u043A\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u043E\u043C",
            "error.giftcard.currency-error": "\u041F\u0440\u0438\u043D\u0438\u043C\u0430\u044E\u0442\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u044B\u0435 \u043A\u0430\u0440\u0442\u044B \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0439 \u0432\u0430\u043B\u044E\u0442\u044B",
            "amazonpay.signout": "\u0412\u044B\u0439\u0442\u0438 \u0438\u0437 Amazon",
            "amazonpay.changePaymentDetails": "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u0435",
            "partialPayment.warning": "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B \u043E\u0441\u0442\u0430\u0442\u043A\u0430",
            "partialPayment.remainingBalance": "\u041E\u0441\u0442\u0430\u0442\u043E\u043A \u043D\u0430 \u0431\u0430\u043B\u0430\u043D\u0441\u0435 \u0441\u043E\u0441\u0442\u0430\u0432\u0438\u0442 %{amount}",
            "bankTransfer.beneficiary": "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044C",
            "bankTransfer.reference": "\u0421\u0441\u044B\u043B\u043A\u0430",
            "bankTransfer.introduction": "\u0414\u043B\u044F \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u043D\u043E\u0432\u043E\u0433\u043E \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u043F\u0435\u0440\u0435\u0439\u0434\u0438\u0442\u0435 \u0434\u0430\u043B\u0435\u0435. \u0414\u043B\u044F \u043E\u043A\u043E\u043D\u0447\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u044D\u043A\u0440\u0430\u043D\u0435.",
            "bankTransfer.instructions": "\u0411\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0437\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0443. \u0414\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u044F.",
            "bacs.accountHolderName": "\u0418\u043C\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430",
            "bacs.accountHolderName.invalid": "\u041D\u0435\u0432\u0435\u0440\u043D\u043E\u0435 \u0438\u043C\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430",
            "bacs.accountNumber": "\u041D\u043E\u043C\u0435\u0440 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430",
            "bacs.accountNumber.invalid": "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430",
            "bacs.bankLocationId": "\u041A\u043E\u0434 \u0431\u0430\u043D\u043A\u0430",
            "bacs.bankLocationId.invalid": "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043A\u043E\u0434 \u0431\u0430\u043D\u043A\u0430",
            "bacs.consent.amount": "\u0412\u044B\u0440\u0430\u0436\u0430\u044E \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0432\u044B\u0448\u0435\u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0439 \u0441\u0443\u043C\u043C\u044B \u0441 \u043C\u043E\u0435\u0433\u043E \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430.",
            "bacs.consent.account": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E, \u0447\u0442\u043E \u0441\u0447\u0435\u0442 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D \u043D\u0430 \u043C\u043E\u0435 \u0438\u043C\u044F \u0438 \u0447\u0442\u043E \u044F \u2013 \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0435 \u043B\u0438\u0446\u043E, \u0438\u043C\u0435\u044E\u0449\u0435\u0435 \u043F\u0440\u0430\u0432\u043E \u043F\u043E\u0434\u043F\u0438\u0441\u0438, \u0440\u0430\u0437\u0440\u0435\u0448\u0430\u044E\u0449\u0435\u0439 \u043F\u0440\u044F\u043C\u043E\u0435 \u0434\u0435\u0431\u0435\u0442\u043E\u0432\u0430\u043D\u0438\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0441\u043E \u0441\u0447\u0435\u0442\u0430.",
            edit: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C",
            "bacs.confirm": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0438 \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u044C",
            "bacs.result.introduction": "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u043F\u043E\u0440\u044F\u0436\u0435\u043D\u0438\u0435 \u043F\u0440\u044F\u043C\u043E\u0433\u043E \u0434\u0435\u0431\u0435\u0442\u043E\u0432\u0430\u043D\u0438\u044F (DDI / \u043F\u043E\u0440\u0443\u0447\u0435\u043D\u0438\u0435)",
            "download.pdf": "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u043D\u043E\u043C\u0435\u0440\u0430 \u043A\u0430\u0440\u0442\u044B",
            "creditCard.encryptedCardNumber.aria.label": "\u041D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u0434\u0430\u0442\u044B \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "creditCard.encryptedExpiryDate.aria.label": "\u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u043C\u0435\u0441\u044F\u0446\u0430 \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "creditCard.encryptedExpiryMonth.aria.label": "\u041C\u0435\u0441\u044F\u0446 \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u0433\u043E\u0434\u0430 \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "creditCard.encryptedExpiryYear.aria.label": "\u0413\u043E\u0434 \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u0437\u0430\u0449\u0438\u0442\u043D\u043E\u0433\u043E \u043A\u043E\u0434\u0430",
            "creditCard.encryptedSecurityCode.aria.label": "\u0417\u0430\u0449\u0438\u0442\u043D\u044B\u0439 \u043A\u043E\u0434",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u043F\u0430\u0440\u043E\u043B\u044F",
            "creditCard.encryptedPassword.aria.label": "\u041F\u0435\u0440\u0432\u044B\u0435 2 \u0446\u0438\u0444\u0440\u044B \u043F\u0430\u0440\u043E\u043B\u044F \u043A\u0430\u0440\u0442\u044B",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u043D\u043E\u043C\u0435\u0440\u0430 \u043A\u0430\u0440\u0442\u044B",
            "giftcard.encryptedCardNumber.aria.label": "\u041D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe \u0434\u043B\u044F PIN-\u043A\u043E\u0434\u0430",
            "giftcard.encryptedSecurityCode.aria.label": "PIN-\u043A\u043E\u0434",
            giftcardTransactionLimit: "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u043F\u043E \u044D\u0442\u043E\u0439 \u043F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435: %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u043D\u043E\u043C\u0435\u0440\u0430 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430",
            "ach.encryptedBankAccountNumber.aria.label": "\u041D\u043E\u043C\u0435\u0440 \u0441\u0447\u0435\u0442\u0430",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u043D\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 \u0431\u0430\u043D\u043A\u0430",
            "ach.encryptedBankLocationId.aria.label": "\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 ABA",
            "twint.saved": "\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E",
            orPayWith: "\u0438\u043B\u0438 \u0437\u0430\u043F\u043B\u0430\u0442\u0438\u0442\u0435 \u0447\u0435\u0440\u0435\u0437",
            invalidFormatExpects: "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442. \u041E\u0436\u0438\u0434\u0430\u0435\u043C\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442: %{format}",
            "upi.qrCodeWaitingMessage": "\u0414\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 QR-\u043A\u043E\u0434 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043F\u0440\u0435\u0434\u043F\u043E\u0447\u0438\u0442\u0430\u0435\u043C\u043E\u0433\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F UPI",
            "upi.vpaWaitingMessage": "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 UPI \u0434\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u0430",
            "upi.modeSelection": "\u0423\u043A\u0430\u0436\u0438\u0442\u0435, \u043A\u0430\u043A \u0432\u044B \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442\u0435\u0441\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C UPI.",
            "onlineBanking.termsAndConditions": "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u044F, \u0432\u044B \u0442\u0435\u043C \u0441\u0430\u043C\u044B\u043C \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u0441 %#\u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438%#",
            "onlineBankingPL.termsAndConditions": "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u044F, \u0432\u044B \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u0441 %#\u043F\u0440\u0430\u0432\u0438\u043B\u0430\u043C\u0438%# \u0438 %#\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430\u043C\u0438 \u0432 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u0434\u0430\u043D\u043D\u044B\u0445%# Przelewy24",
            "ctp.loading.poweredByCtp": "\u041D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0435 Click to Pay",
            "ctp.loading.intro": "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043D\u0430\u043B\u0438\u0447\u0438\u044F \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0445 \u043A\u0430\u0440\u0442 Click to Pay\u2026",
            "ctp.login.title": "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 Click to Pay",
            "ctp.login.subtitle": "\u0414\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0439 \u0441 Click to Pay.",
            "ctp.login.inputLabel": "\u042D\u043B. \u043F\u043E\u0447\u0442\u0430",
            "ctp.logout.notYou": "\u042D\u0442\u043E \u043D\u0435 \u0432\u044B?",
            "ctp.logout.notYourCards": "\u041D\u0435 \u0432\u0430\u0448\u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0435 \u043A\u0430\u0440\u0442\u044B?",
            "ctp.logout.notYourCard": "\u041D\u0435 \u0432\u0430\u0448\u0430 \u043A\u0430\u0440\u0442\u0430?",
            "ctp.logout.notYourProfile": "\u041D\u0435 \u0432\u0430\u0448 \u043F\u0440\u043E\u0444\u0438\u043B\u044C?",
            "ctp.otp.fieldLabel": "\u041E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u044B\u0439 \u043A\u043E\u0434",
            "ctp.otp.resendCode": "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
            "ctp.otp.codeResent": "\u041A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
            "ctp.otp.title": "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0432\u043E\u0438\u043C \u043A\u0430\u0440\u0442\u0430\u043C Click to Pay",
            "ctp.otp.subtitle": "\u0414\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0441\u0432\u043E\u0435\u0439 \u043B\u0438\u0447\u043D\u043E\u0441\u0442\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 %@, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0439 %@.",
            "ctp.otp.saveCookiesCheckbox.label": "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0440\u0430\u0437",
            "ctp.otp.saveCookiesCheckbox.information": "\u0427\u0442\u043E\u0431\u044B \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430\u0445 \u0437\u0430\u043F\u043E\u043C\u043D\u0438\u043B\u0438 \u0432\u0430\u0448\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0438 \u0431\u0440\u0430\u0443\u0437\u0435\u0440, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u044D\u0442\u0443 \u043E\u043F\u0446\u0438\u044E. \u042D\u0442\u043E \u043F\u043E\u0437\u0432\u043E\u043B\u0438\u0442 \u0431\u044B\u0441\u0442\u0440\u0435\u0435 \u043E\u0444\u043E\u0440\u043C\u043B\u044F\u0442\u044C \u0437\u0430\u043A\u0430\u0437\u044B. \u041D\u0435 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0442\u0441\u044F \u043D\u0430 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430\u0445 \u0441\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u043E\u0433\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u043F\u043E\u043C\u043D\u0438\u043B\u0438 \u0432\u0430\u0448\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0438 \u0431\u0440\u0430\u0443\u0437\u0435\u0440",
            "ctp.emptyProfile.message": "\u0412 \u0434\u0430\u043D\u043D\u043E\u043C \u043F\u0440\u043E\u0444\u0438\u043B\u0435 Click to Pay \u043D\u0435\u0442 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u043A\u0430\u0440\u0442",
            "ctp.separatorText": "\u0438\u043B\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435",
            "ctp.cards.title": "\u041E\u0444\u043E\u0440\u043C\u0438\u0442\u0435 \u043E\u043F\u043B\u0430\u0442\u0443 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E Click to Pay",
            "ctp.cards.subtitle": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u0430\u0440\u0442\u0443.",
            "ctp.cards.expiredCard": "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u0430",
            "ctp.manualCardEntry": "\u0412\u0432\u043E\u0434 \u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u0430\u0440\u0442\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            "ctp.aria.infoModalButton": "\u0427\u0442\u043E \u0442\u0430\u043A\u043E\u0435 Click to Pay",
            "ctp.infoPopup.title": "Click to Pay \u2013 \u0443\u0434\u043E\u0431\u043D\u0430\u044F \u0431\u0435\u0441\u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0430\u044F \u043E\u043F\u043B\u0430\u0442\u0430 \u043E\u043D\u043B\u0430\u0439\u043D",
            "ctp.infoPopup.subtitle": "\u0411\u044B\u0441\u0442\u0440\u044B\u0439 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B, \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043C\u044B\u0439 Mastercard, Visa \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u043C\u0438 \u043A\u0430\u0440\u0442\u0430\u043C\u0438.",
            "ctp.infoPopup.benefit1": "\u0414\u043B\u044F \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0432\u0430\u0448\u0438\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 Click to Pay \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442 \u0448\u0438\u0444\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
            "ctp.infoPopup.benefit2": "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0435\u0433\u043E \u0432 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430\u0445 \u043F\u043E \u0432\u0441\u0435\u043C\u0443 \u043C\u0438\u0440\u0443",
            "ctp.infoPopup.benefit3": "\u0411\u0435\u0441\u043F\u0440\u043E\u0431\u043B\u0435\u043C\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0432 \u0431\u0443\u0434\u0443\u0449\u0435\u043C \u2014 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u043E\u0434\u0438\u043D \u0440\u0430\u0437",
            "ctp.errors.AUTH_INVALID": "\u0410\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0430",
            "ctp.errors.NOT_FOUND": "\u0423\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430. \u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B \u0438\u043B\u0438 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435 \u0432\u0432\u043E\u0434 \u043A\u0430\u0440\u0442\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "\u0424\u043E\u0440\u043C\u0430\u0442 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F",
            "ctp.errors.FRAUD": "\u0423\u0447. \u0437\u0430\u043F\u0438\u0441\u044C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0438\u043B\u0438 \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u0430",
            "ctp.errors.CONSUMER_ID_MISSING": "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u044F \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u0432 \u0437\u0430\u043F\u0440\u043E\u0441\u0435",
            "ctp.errors.ACCT_INACCESSIBLE": "\u042D\u0442\u0430 \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C \u0441\u0435\u0439\u0447\u0430\u0441 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 (\u043E\u043D\u0430 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430)",
            "ctp.errors.CODE_INVALID": "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F",
            "ctp.errors.CODE_EXPIRED": "\u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043A\u043E\u0434\u0430 \u0438\u0441\u0442\u0435\u043A",
            "ctp.errors.RETRIES_EXCEEDED": "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D \u043B\u0438\u043C\u0438\u0442 \u043F\u043E\u043F\u044B\u0442\u043E\u043A \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u043E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u043E\u0433\u043E \u043F\u0430\u0440\u043E\u043B\u044F",
            "ctp.errors.OTP_SEND_FAILED": "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044E \u043E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
            "ctp.errors.REQUEST_TIMEOUT": "\u0412\u043E\u0437\u043D\u0438\u043A \u0441\u0431\u043E\u0439. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u0438\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            "ctp.errors.UNKNOWN_ERROR": "\u0412\u043E\u0437\u043D\u0438\u043A \u0441\u0431\u043E\u0439. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u0438\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            "ctp.errors.SERVICE_ERROR": "\u0412\u043E\u0437\u043D\u0438\u043A \u0441\u0431\u043E\u0439. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u0438\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            "ctp.errors.SERVER_ERROR": "\u0412\u043E\u0437\u043D\u0438\u043A \u0441\u0431\u043E\u0439. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u0438\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            "ctp.errors.INVALID_PARAMETER": "\u0412\u043E\u0437\u043D\u0438\u043A \u0441\u0431\u043E\u0439. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u0438\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            "ctp.errors.AUTH_ERROR": "\u0412\u043E\u0437\u043D\u0438\u043A \u0441\u0431\u043E\u0439. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u0438\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            "paymentMethodsList.aria.label": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B",
            "companyDetails.name.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438",
            "companyDetails.registrationNumber.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440",
            "consent.checkbox.invalid": "\u0422\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0432\u044B\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438",
            "form.instruction": "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F, \u0435\u0441\u043B\u0438 \u043D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u043E \u0438\u043D\u043E\u0435.",
            "trustly.descriptor": "\u041C\u0433\u043D\u043E\u0432\u0435\u043D\u043D\u044B\u0439 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0439 \u043F\u043B\u0430\u0442\u0435\u0436",
            "trustly.description1": "\u041F\u043B\u0430\u0442\u0438\u0442\u0435 \u043D\u0435\u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u043E \u0441\u043E \u0441\u0432\u043E\u0435\u0433\u043E \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430 \u043F\u043E\u0434 \u0442\u0430\u043A\u043E\u0439 \u0436\u0435 \u043D\u0430\u0434\u0435\u0436\u043D\u043E\u0439 \u0437\u0430\u0449\u0438\u0442\u043E\u0439, \u043A\u0430\u043A \u0432 \u0431\u0430\u043D\u043A\u0430\u0445",
            "trustly.description2": "\u0411\u0435\u0437 \u043A\u0430\u0440\u0442, \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438",
            "ancv.input.label": "\u0412\u0430\u0448 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 ANCV",
            "ancv.confirmPayment": "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 ANCV \u0434\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u0430.",
            "ancv.form.instruction": "\u0414\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0433\u043E \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Cheque-Vacances.",
            "ancv.beneficiaryId.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0438\u043B\u0438 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 ANCV",
            "payme.openPayMeApp": "\u0414\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0440\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u0435 \u0435\u0435 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 PayMe \u0438 \u0434\u043E\u0436\u0434\u0438\u0442\u0435\u0441\u044C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F.",
            "payme.redirectButtonLabel": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 PayMe",
            "payme.scanQrCode": "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u043F\u043B\u0430\u0442\u0435\u0436 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E QR-\u043A\u043E\u0434\u0430",
            "payme.timeToPay": "\u0414\u0430\u043D\u043D\u044B\u0439 QR-\u043A\u043E\u0434 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u0435\u043D \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 %@",
            "payme.instructions.steps": "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 PayMe.%@\u041E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 QR-\u043A\u043E\u0434, \u0447\u0442\u043E\u0431\u044B \u0440\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u043F\u043B\u0430\u0442\u0435\u0436.%@\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0435 \u043F\u043B\u0430\u0442\u0435\u0436 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u0438 \u0434\u043E\u0436\u0434\u0438\u0442\u0435\u0441\u044C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F.",
            "payme.instructions.footnote": "\u041D\u0435 \u0437\u0430\u043A\u0440\u044B\u0432\u0430\u0439\u0442\u0435 \u044D\u0442\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0434\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u0430"
        }
    }), q2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Zaplati\u0165",
            "payButton.redirecting": "Prebieha presmerovanie...",
            "payButton.with": "Zaplati\u0165 %{value} pomocou %{maskedData}",
            "payButton.saveDetails": "Ulo\u017Ei\u0165 \xfadaje",
            close: "Zavrie\u0165",
            storeDetails: "Ulo\u017Ei\u0165 pre moju \u010Fal\u0161iu platbu",
            readMore: "Pre\u010D\xedtajte si viac",
            "creditCard.holderName": "Meno na karte",
            "creditCard.holderName.placeholder": "J. Nov\xe1k",
            "creditCard.holderName.invalid": "Zadajte meno tak, ako je uveden\xe9 na karte",
            "creditCard.numberField.title": "\u010C\xedslo karty",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Koniec platnosti",
            "creditCard.expiryDateField.placeholder": "MM/RR",
            "creditCard.expiryDateField.month": "Mesiac",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "RR",
            "creditCard.expiryDateField.year": "Rok",
            "creditCard.cvcField.title": "Bezpe\u010Dnostn\xfd k\xf3d",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Zapam\xe4ta\u0165 na bud\xface pou\u017Eitie",
            "creditCard.cvcField.placeholder.4digits": "4 \u010D\xedslice",
            "creditCard.cvcField.placeholder.3digits": "3 \u010D\xedslice",
            "creditCard.taxNumber.placeholder": "RRMMDD/0123456789",
            installments: "Po\u010Det spl\xe1tok",
            installmentOption: "% {times} x % {partialValue}",
            installmentOptionMonths: "%{times} mesiace/-ov",
            "installments.oneTime": "Jednorazov\xe1 platba",
            "installments.installments": "Platba po spl\xe1tkach",
            "installments.revolving": "Revolvingov\xe1 platba",
            "sepaDirectDebit.ibanField.invalid": "Neplatn\xe9 \u010D\xedslo \xfa\u010Dtu",
            "sepaDirectDebit.nameField.placeholder": "J. Nov\xe1k",
            "sepa.ownerName": "Meno dr\u017Eite\u013Ea",
            "sepa.ibanNumber": "\u010C\xedslo \xfa\u010Dtu (IBAN)",
            "error.title": "Chyba",
            "error.subtitle.redirect": "Nepodarilo sa presmerova\u0165",
            "error.subtitle.payment": "Platba zlyhala",
            "error.subtitle.refused": "Platba bola zamietnut\xe1",
            "error.message.unknown": "Vyskytla sa nezn\xe1ma chyba",
            "errorPanel.title": "Existuj\xface chyby",
            "idealIssuer.selectField.title": "Banka",
            "idealIssuer.selectField.placeholder": "Vyberte svoju banku",
            "creditCard.success": "Platba bola \xfaspe\u0161n\xe1",
            loading: "Na\u010D\xedtava sa\u2026",
            continue: "Pokra\u010Dova\u0165",
            continueTo: "Pokra\u010Dova\u0165 do",
            "wechatpay.timetopay": "Na zaplatenie m\xe1te %@",
            "sr.wechatpay.timetopay": "Na zaplatenie m\xe1te %#min. %# %#sek.%#",
            "wechatpay.scanqrcode": "Naskenujte QR k\xf3d",
            personalDetails: "Osobn\xe9 \xfadaje",
            companyDetails: "\xdadaje o spolo\u010Dnosti",
            "companyDetails.name": "N\xe1zov spolo\u010Dnosti",
            "companyDetails.registrationNumber": "Identifika\u010Dn\xe9 \u010D\xedslo",
            socialSecurityNumber: "Rodn\xe9 \u010D\xedslo",
            firstName: "Krstn\xe9 meno",
            "firstName.invalid": "Zadajte svoje meno",
            infix: "Predpona k priezvisku (ak existuje)",
            lastName: "Priezvisko",
            "lastName.invalid": "Zadajte svoje priezvisko",
            mobileNumber: "Mobiln\xe9 telef\xf3nne \u010D\xedslo",
            "mobileNumber.invalid": "Neplatn\xe9 \u010D\xedslo na mobil",
            city: "Mesto",
            postalCode: "PS\u010C",
            "postalCode.optional": "Po\u0161tov\xe9 smerovacie \u010D\xedslo (nepovinn\xe9)",
            countryCode: "K\xf3d krajiny",
            telephoneNumber: "Telef\xf3nne \u010D\xedslo",
            dateOfBirth: "D\xe1tum narodenia",
            shopperEmail: "E-mailov\xe1 adresa",
            gender: "Pohlavie",
            "gender.notselected": "Vyberte rod, s ktor\xfdm sa stoto\u017E\u0148ujete",
            male: "Mu\u017E",
            female: "\u017Dena",
            billingAddress: "Faktura\u010Dn\xe1 adresa",
            street: "Ulica",
            stateOrProvince: "Kraj",
            country: "Krajina/regi\xf3n",
            houseNumberOrName: "\u010C\xedslo domu",
            separateDeliveryAddress: "Zadajte samostatn\xfa dodaciu adresu",
            deliveryAddress: "Dodacia adresa",
            "deliveryAddress.firstName": "Krstn\xe9 meno pr\xedjemcu",
            "deliveryAddress.lastName": "Priezvisko pr\xedjemcu",
            zipCode: "PS\u010C",
            apartmentSuite: "Byt/apartm\xe1n",
            provinceOrTerritory: "Okres alebo \xfazemie",
            cityTown: "Mesto/obec",
            address: "Adresa",
            "address.placeholder": "Vyh\u013Eadajte svoju adresu",
            "address.errors.incomplete": "Ak chcete pokra\u010Dova\u0165, zadajte adresu",
            "address.enterManually": "Manu\xe1lne zadajte adresu",
            state: "\u0160t\xe1t",
            "field.title.optional": "(volite\u013En\xe9)",
            "creditCard.cvcField.title.optional": "Bezpe\u010Dnostn\xfd k\xf3d (volite\u013En\xfd)",
            "issuerList.wallet.placeholder": "Vyberte si pe\u0148a\u017Eenku",
            privacyPolicy: "Z\xe1sady ochrany osobn\xfdch \xfadajov",
            "afterPay.agreement": "S\xfahlas\xedm, \u017Ee budem dodr\u017Eiava\u0165 %@ spolo\u010Dnosti Riverty",
            paymentConditions: "podmienkami platby",
            openApp: "Otvorte aplik\xe1ciu",
            "voucher.readInstructions": "Pre\u010D\xedtajte si pokyny",
            "voucher.introduction": "\u010Eakujeme v\xe1m za n\xe1kup; na dokon\u010Denie platby pou\u017Eite nasleduj\xfaci kup\xf3n.",
            "voucher.expirationDate": "D\xe1tum vypr\u0161ania platnosti",
            "voucher.alternativeReference": "Alternat\xedvny odkaz",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Vyberte si poskytovate\u013Ea",
            "dragonpay.voucher.bank.selectField.placeholder": "Vyberte svoju banku",
            "voucher.paymentReferenceLabel": "Platobn\xe1 referencia",
            "voucher.surcharge": "Vr\xe1tane poplatku vo v\xfd\u0161ke %@",
            "voucher.introduction.doku": "\u010Eakujeme v\xe1m za n\xe1kup. Na dokon\u010Denie platby pou\u017Eite nasleduj\xface inform\xe1cie.",
            "voucher.shopperName": "Meno kupuj\xfaceho",
            "voucher.merchantName": "Predajca",
            "voucher.introduction.econtext": "\u010Eakujeme v\xe1m za n\xe1kup. Na dokon\u010Denie platby pou\u017Eite nasleduj\xface inform\xe1cie.",
            "voucher.telephoneNumber": "Telef\xf3nne \u010D\xedslo",
            "voucher.shopperReference": "Referencia kupuj\xfaceho",
            "voucher.collectionInstitutionNumber": "\u010C\xedslo inkasnej in\u0161tit\xfacie",
            "voucher.econtext.telephoneNumber.invalid": "Telef\xf3nne \u010D\xedslo mus\xed ma\u0165 10 alebo 11 \u010D\xedslic",
            "boletobancario.btnLabel": "Generova\u0165 Boleto",
            "boleto.sendCopyToEmail": "Zasla\u0165 k\xf3piu na m\xf4j e-mail",
            "button.copy": "Kop\xedrova\u0165",
            "button.download": "Stiahnu\u0165",
            "boleto.socialSecurityNumber.invalid": "Zadajte platn\xe9 \u010D\xedslo CPF/CNPJ",
            "creditCard.storedCard.description.ariaLabel": "Platnos\u0165 ulo\u017Eenej karty kon\u010D\xed o %@",
            "voucher.entity": "Subjekt",
            donateButton: "Prispie\u0165",
            notNowButton: "Teraz nie",
            thanksForYourSupport: "\u010Eakujeme za podporu!",
            "resultMessages.preauthorized": "\xdadaje boli ulo\u017Een\xe9",
            preauthorizeWith: "Predbe\u017Ene autorizova\u0165 pomocou",
            confirmPreauthorization: "Potvr\u010Fte predbe\u017En\xfa autoriz\xe1ciu",
            confirmPurchase: "Potvr\u010Fte n\xe1kup",
            applyGiftcard: "Uplatni\u0165",
            giftcardBalance: "Zostatok na dar\u010Dekovej karte",
            deductedBalance: "Zn\xed\u017Een\xfd zostatok",
            "creditCard.pin.title": "K\xf3d PIN",
            "creditCard.encryptedPassword.label": "Prv\xe9 2 \u010D\xedslice hesla karty",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Neplan\xe9 heslo",
            "creditCard.taxNumber": "D\xe1tum narodenia dr\u017Eite\u013Ea karty alebo identifika\u010Dn\xe9 \u010D\xedslo organiz\xe1cie",
            "creditCard.taxNumber.label": "D\xe1tum narodenia dr\u017Eite\u013Ea karty (RRRMMDD) alebo identifika\u010Dn\xe9 \u010D\xedslo organiz\xe1cie (10 \u010D\xedslic)",
            "creditCard.taxNumber.labelAlt": "Identifika\u010Dn\xe9 \u010D\xedslo organiz\xe1cie (10 \u010D\xedslic)",
            "creditCard.taxNumber.invalid": "Neplatn\xfd d\xe1tum narodenia dr\u017Eite\u013Ea karty alebo identifika\u010Dn\xe9 \u010D\xedslo organiz\xe1cie",
            "storedPaymentMethod.disable.button": "Odstr\xe1ni\u0165",
            "storedPaymentMethod.disable.confirmation": "Odstr\xe1ni\u0165 ulo\u017Een\xfd sp\xf4sob platby",
            "storedPaymentMethod.disable.confirmButton": "\xc1no, odstr\xe1ni\u0165",
            "storedPaymentMethod.disable.cancelButton": "Zru\u0161i\u0165",
            "ach.bankAccount": "Bankov\xfd \xfa\u010Det",
            "ach.accountHolderNameField.title": "Meno majite\u013Ea \xfa\u010Dtu",
            "ach.accountHolderNameField.placeholder": "J. Nov\xe1k",
            "ach.accountHolderNameField.invalid": "Neplatn\xe9 meno majite\u013Ea \xfa\u010Dtu",
            "ach.accountNumberField.title": "\u010C\xedslo \xfa\u010Dtu",
            "ach.accountNumberField.invalid": "Neplatn\xe9 \u010D\xedslo \xfa\u010Dtu",
            "ach.accountLocationField.title": "Smerovacie \u010D\xedslo ABA",
            "ach.accountLocationField.invalid": "Neplatn\xe9 smerovacie \u010D\xedslo ABA",
            "ach.savedBankAccount": "Ulo\u017Een\xfd bankov\xfd \xfa\u010Det",
            "select.state": "Vyberte kraj",
            "select.stateOrProvince": "Vyberte kraj alebo okres",
            "select.provinceOrTerritory": "Vyberte okres alebo \xfazemie",
            "select.country": "Vyberte krajinu/regi\xf3n",
            "select.noOptionsFound": "Neboli n\xe1jden\xe9 \u017Eiadne mo\u017Enosti",
            "select.filter.placeholder": "Vyh\u013Ead\xe1vanie...",
            "telephoneNumber.invalid": "Neplatn\xe9 telef\xf3nne \u010D\xedslo",
            qrCodeOrApp: "alebo",
            "paypal.processingPayment": "Platba sa sprac\xfava.",
            generateQRCode: "Generova\u0165 QR k\xf3d",
            "await.waitForConfirmation": "\u010Cak\xe1 sa na potvrdenie",
            "mbway.confirmPayment": "Potvr\u010Fte svoju platbu v aplik\xe1cii MB WAY",
            "shopperEmail.invalid": "Neplatn\xe1 emailov\xe1 adresa",
            "dateOfBirth.format": "DD/MM/RRRR",
            "dateOfBirth.invalid": "Zadajte platn\xfd d\xe1tum narodenia, ktor\xfd uv\xe1dza, \u017Ee m\xe1te aspo\u0148 18 rokov",
            "blik.confirmPayment": "Otvorte svoju bankov\xfa aplik\xe1ciu a potvr\u010Fte platbu.",
            "blik.invalid": "Zadajte 6 \u010D\xedslic",
            "blik.code": "6-cifern\xfd k\xf3d",
            "blik.help": "Z\xedskajte k\xf3d zo svojej bankovej aplik\xe1cie.",
            "swish.pendingMessage": "Po nasn\xedman\xed m\xf4\u017Ee spracovanie trva\u0165 a\u017E 10 min\xfat. Pokus o op\xe4tovn\xe9 zaplatenie v tejto lehote m\xf4\u017Ee vies\u0165 k nieko\u013Ek\xfdm poplatkom.",
            "field.valid": "Pole je platn\xe9",
            "field.invalid": "Pole je neplatn\xe9",
            "error.va.gen.01": "Ne\xfapln\xe9 pole",
            "error.va.gen.02": "Pole je neplatn\xe9",
            "error.va.sf-cc-num.01": "Zadajte \u010D\xedslo platnej karty",
            "error.va.sf-cc-num.02": "Zadajte \u010D\xedslo karty",
            "error.va.sf-cc-num.03": "Zadajte podporovan\xfa zna\u010Dku karty",
            "error.va.sf-cc-num.04": "Zadajte cel\xe9 \u010D\xedslo karty",
            "error.va.sf-cc-dat.01": "Zadajte platn\xfd d\xe1tum vypr\u0161ania platnosti",
            "error.va.sf-cc-dat.02": "Zadajte platn\xfd d\xe1tum vypr\u0161ania platnosti",
            "error.va.sf-cc-dat.03": "Platnos\u0165 kreditnej karty \u010Doskoro vypr\u0161\xed",
            "error.va.sf-cc-dat.04": "Zadajte de\u0148 vypr\u0161ania platnosti",
            "error.va.sf-cc-dat.05": "Zadajte cel\xfd d\xe1tum vypr\u0161ania platnosti",
            "error.va.sf-cc-mth.01": "Zadajte mesiac vypr\u0161ania platnosti",
            "error.va.sf-cc-yr.01": "Zadajte rok vypr\u0161ania platnosti",
            "error.va.sf-cc-yr.02": "Zadajte cel\xfd rok vypr\u0161ania platnosti",
            "error.va.sf-cc-cvc.01": "Zadajte bezpe\u010Dnostn\xfd k\xf3d",
            "error.va.sf-cc-cvc.02": "Zadajte cel\xfd bezpe\u010Dnostn\xfd k\xf3d",
            "error.va.sf-ach-num.01": "Pole na zadanie \u010D\xedsla bankov\xe9ho \xfa\u010Dtu je pr\xe1zdne",
            "error.va.sf-ach-num.02": "\u010C\xedslo bankov\xe9ho \xfa\u010Dtu m\xe1 nespr\xe1vnu d\u013A\u017Eku",
            "error.va.sf-ach-loc.01": "Pole na zadanie smerov\xe9ho \u010D\xedsla banky je pr\xe1zdne",
            "error.va.sf-ach-loc.02": "Smerov\xe9 \u010D\xedslo banky m\xe1 nespr\xe1vnu d\u013A\u017Eku",
            "error.va.sf-kcp-pwd.01": "Pole na zadanie hesla je pr\xe1zdne",
            "error.va.sf-kcp-pwd.02": "Heslo m\xe1 nespr\xe1vnu d\u013A\u017Eku",
            "error.giftcard.no-balance": "T\xe1to dar\u010Dekov\xe1 karta m\xe1 nulov\xfd zostatok",
            "error.giftcard.card-error": "V na\u0161ich z\xe1znamoch nem\xe1me \u017Eiadnu dar\u010Dekov\xfa kartu s t\xfdmto \u010D\xedslom",
            "error.giftcard.currency-error": "Dar\u010Dekov\xe9 karty s\xfa platn\xe9 iba v mene, v ktorej boli vydan\xe9",
            "amazonpay.signout": "Odhl\xe1si\u0165 sa z Amazonu",
            "amazonpay.changePaymentDetails": "Zmeni\u0165 podrobnosti o platbe",
            "partialPayment.warning": "Ak chcete zaplati\u0165 zostatok, vyberte in\xfd sp\xf4sob platby",
            "partialPayment.remainingBalance": "Zvy\u0161n\xfd zostatok bude %{amount}",
            "bankTransfer.beneficiary": "Pr\xedjemca",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Referencie",
            "bankTransfer.introduction": "Pokra\u010Dujte vo vytv\xe1ran\xed novej platby bankov\xfdm prevodom. T\xfato platbu m\xf4\u017Eete dokon\u010Di\u0165 pomocou inform\xe1ci\xed na nasleduj\xfacej obrazovke.",
            "bankTransfer.instructions": "\u010Eakujeme v\xe1m za n\xe1kup. Na dokon\u010Denie platby pou\u017Eite nasleduj\xface inform\xe1cie.",
            "bacs.accountHolderName": "Meno majite\u013Ea bankov\xe9ho \xfa\u010Dtu",
            "bacs.accountHolderName.invalid": "Neplatn\xe9 meno majite\u013Ea bankov\xe9ho \xfa\u010Dtu",
            "bacs.accountNumber": "\u010C\xedslo bankov\xe9ho \xfa\u010Dtu",
            "bacs.accountNumber.invalid": "Neplatn\xe9 \u010D\xedslo bankov\xe9ho \xfa\u010Dtu",
            "bacs.bankLocationId": "Variabiln\xfd symbol",
            "bacs.bankLocationId.invalid": "Neplatn\xfd variabiln\xfd symbol",
            "bacs.consent.amount": "S\xfahlas\xedm s t\xfdm, \u017Ee ni\u017E\u0161ie uveden\xe1 \u010Diastka bude odp\xedsan\xe1 z m\xf4jho bankov\xe9ho \xfa\u010Dtu.",
            "bacs.consent.account": "Potvrdzujem, \u017Ee \xfa\u010Det je na moje meno a som jedin\xfd podpisovate\u013E, ktor\xfd je povinn\xfd autorizova\u0165 inkaso v tomto \xfa\u010Dte.",
            edit: "Upravi\u0165",
            "bacs.confirm": "Potvrdi\u0165 a zaplati\u0165",
            "bacs.result.introduction": "Stiahnite si pokyny k inkasu (DDI/Mand\xe1t)",
            "download.pdf": "Stiahnu\u0165 vo form\xe1te PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe pre \u010D\xedslo karty",
            "creditCard.encryptedCardNumber.aria.label": "\u010C\xedslo karty",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe pre de\u0148 vypr\u0161ania platnosti",
            "creditCard.encryptedExpiryDate.aria.label": "Koniec platnosti",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe pre mesiac vypr\u0161ania platnosti",
            "creditCard.encryptedExpiryMonth.aria.label": "Mesiac skon\u010Denia platnosti",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe pre rok vypr\u0161ania platnosti",
            "creditCard.encryptedExpiryYear.aria.label": "Rok skon\u010Denia platnosti",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe pre bezpe\u010Dnostn\xfd k\xf3d",
            "creditCard.encryptedSecurityCode.aria.label": "Bezpe\u010Dnostn\xfd k\xf3d",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe pre heslo",
            "creditCard.encryptedPassword.aria.label": "Prv\xe9 2 \u010D\xedslice hesla karty",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe pre \u010D\xedslo karty",
            "giftcard.encryptedCardNumber.aria.label": "\u010C\xedslo karty",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe pre PIN",
            "giftcard.encryptedSecurityCode.aria.label": "K\xf3d PIN",
            giftcardTransactionLimit: "Pre transakciu s touto dar\u010Dekovou kartou je povolen\xe9 maximum %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe pre \u010D\xedslo bankov\xe9ho \xfa\u010Dtu",
            "ach.encryptedBankAccountNumber.aria.label": "\u010C\xedslo \xfa\u010Dtu",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe pre smerovacie \u010D\xedslo banky",
            "ach.encryptedBankLocationId.aria.label": "Smerovacie \u010D\xedslo ABA",
            "twint.saved": "ulo\u017Een\xe9",
            orPayWith: "alebo zaplati\u0165 pomocou",
            invalidFormatExpects: "Neplatn\xfd form\xe1t. O\u010Dak\xe1van\xfd form\xe1t: %{format}",
            "upi.qrCodeWaitingMessage": "Naskenujte QR k\xf3d pomocou preferovanej aplik\xe1cie UPI a dokon\u010Dite platbu",
            "upi.vpaWaitingMessage": "Otvorte aplik\xe1ciu UPI a potvr\u010Fte platbu",
            "upi.modeSelection": "Vyberte si, ako by ste chceli pou\u017E\xedva\u0165 UPI.",
            "onlineBanking.termsAndConditions": "Pokra\u010Dovan\xedm s\xfahlas\xedte so %#zmluvn\xfdmi podmienkami%#",
            "onlineBankingPL.termsAndConditions": "Pokra\u010Dovan\xedm s\xfahlas\xedte, \u017Ee budete dodr\u017Eiava\u0165 %#regulations%# a %#information obligation%# spolo\u010Dnosti Przelewy24",
            "ctp.loading.poweredByCtp": "Vyu\u017E\xedva technol\xf3giu Click to Pay",
            "ctp.loading.intro": "Zis\u0165ujeme, \u010Di m\xe1te ulo\u017Een\xe9 nejak\xe9 karty v\xa0slu\u017Ebe Click to Pay...",
            "ctp.login.title": "Pokra\u010Dova\u0165 do slu\u017Eby Click to Pay",
            "ctp.login.subtitle": "Na pokra\u010Dovanie zadajte e-mailov\xfa adresu, ktor\xe1 je pripojen\xe1 k slu\u017Ebe Click to Pay.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "Nie ste to vy?",
            "ctp.logout.notYourCards": "Nie s\xfa to va\u0161e karty?",
            "ctp.logout.notYourCard": "Nie je to va\u0161a karta?",
            "ctp.logout.notYourProfile": "Nie je to v\xe1\u0161 profil?",
            "ctp.otp.fieldLabel": "Jednorazov\xfd k\xf3d",
            "ctp.otp.resendCode": "Znova odosla\u0165 k\xf3d",
            "ctp.otp.codeResent": "K\xf3d bol znova odoslan\xfd",
            "ctp.otp.title": "Z\xedskajte pr\xedstup k va\u0161im kart\xe1m v\xa0slu\u017Ebe Click to Pay",
            "ctp.otp.subtitle": "Zadajte k\xf3d %@, ktor\xfd sme poslali na adresu %@, aby sme overili, \u017Ee ste to vy.",
            "ctp.otp.saveCookiesCheckbox.label": "Nabud\xface presko\u010Di\u0165 overovanie",
            "ctp.otp.saveCookiesCheckbox.information": "Vyberte t\xfato mo\u017Enos\u0165 na zapam\xe4tanie v zariaden\xed a prehliada\u010Di v z\xfa\u010Dastnen\xfdch obchodoch, \u010D\xedm ur\xfdchlite platbu. Neodpor\xfa\u010Da sa pre zdie\u013Ean\xe9 zariadenia.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Vyberte t\xfato mo\u017Enos\u0165 na zapam\xe4tanie v\xa0zariaden\xed a\xa0prehliada\u010Di",
            "ctp.emptyProfile.message": "V\xa0tomto profile Click to Pay nie s\xfa registrovan\xe9 \u017Eiadne karty",
            "ctp.separatorText": "alebo pou\u017Eite",
            "ctp.cards.title": "Dokon\u010Dite platbu v\xa0slu\u017Ebe Click to Pay",
            "ctp.cards.subtitle": "Vyberte kartu, ktor\xfa chcete pou\u017Ei\u0165.",
            "ctp.cards.expiredCard": "Platnos\u0165 uplynula",
            "ctp.manualCardEntry": "Manu\xe1lne zadanie karty",
            "ctp.aria.infoModalButton": "\u010Co znamen\xe1 Click to Pay",
            "ctp.infoPopup.title": "Click to Pay prin\xe1\u0161a jednoduchos\u0165 bezkontaktn\xfdch platieb online",
            "ctp.infoPopup.subtitle": "R\xfdchly a\xa0bezpe\u010Dn\xfd sp\xf4sob platby podporovan\xfd platobn\xfdmi kartami Mastercard, Visa a\xa0\u010Fal\u0161\xedmi.",
            "ctp.infoPopup.benefit1": "Click to Pay pou\u017E\xedva \u0161ifrovanie, aby boli va\u0161e \xfadaje v\xa0bezpe\u010D\xed",
            "ctp.infoPopup.benefit2": "Pou\u017E\xedvajte ju u\xa0obchodn\xedkov po celom svete",
            "ctp.infoPopup.benefit3": "Jedno nastavenie pre pohodln\xe9 platby v\xa0bud\xfacnosti",
            "ctp.errors.AUTH_INVALID": "Overenie bolo neplatn\xe9",
            "ctp.errors.NOT_FOUND": "Nena\u0161iel sa \u017Eiadny \xfa\u010Det. Zadajte platn\xfd e-mail alebo pokra\u010Dujte manu\xe1lnym zadan\xedm karty.",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Form\xe1t nie je podporovan\xfd",
            "ctp.errors.FRAUD": "Pou\u017E\xedvate\u013Esk\xfd \xfa\u010Det bol uzamknut\xfd alebo zak\xe1zan\xfd",
            "ctp.errors.CONSUMER_ID_MISSING": "V \u017Eiadosti ch\xfdba identita spotrebite\u013Ea",
            "ctp.errors.ACCT_INACCESSIBLE": "Tento \xfa\u010Det je moment\xe1lne nedostupn\xfd (napr. je zamknut\xfd)",
            "ctp.errors.CODE_INVALID": "Nespr\xe1vny overovac\xed k\xf3d",
            "ctp.errors.CODE_EXPIRED": "Platnos\u0165 tohto k\xf3du uplynula",
            "ctp.errors.RETRIES_EXCEEDED": "Limit po\u010Dtu opakovan\xed pre generovanie jednorazov\xe9ho hesla bol prekro\u010Den\xfd",
            "ctp.errors.OTP_SEND_FAILED": "Jednorazov\xe9 heslo nebolo mo\u017En\xe9 odosla\u0165 pr\xedjemcovi",
            "ctp.errors.REQUEST_TIMEOUT": "Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010Dne.",
            "ctp.errors.UNKNOWN_ERROR": "Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010Dne.",
            "ctp.errors.SERVICE_ERROR": "Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010Dne.",
            "ctp.errors.SERVER_ERROR": "Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010Dne.",
            "ctp.errors.INVALID_PARAMETER": "Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010Dne.",
            "ctp.errors.AUTH_ERROR": "Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010Dne.",
            "paymentMethodsList.aria.label": "V\xfdber sp\xf4sobu platby",
            "companyDetails.name.invalid": "Zadajte n\xe1zov spolo\u010Dnosti",
            "companyDetails.registrationNumber.invalid": "Zadajte registra\u010Dn\xe9 \u010D\xedslo",
            "consent.checkbox.invalid": "Mus\xedte s\xfahlasi\u0165 s obchodn\xfdmi podmienkami",
            "form.instruction": "V\u0161etky polia s\xfa povinn\xe9, ak nie je ozna\u010Den\xe9 inak.",
            "trustly.descriptor": "Okam\u017Eit\xe1 bankov\xe1 platba",
            "trustly.description1": "Platba priamo z ktor\xe9hoko\u013Evek bankov\xe9ho \xfa\u010Dtu so zabezpe\u010Den\xedm na \xfarovni banky",
            "trustly.description2": "\u017Diadne karty, \u017Eiadne s\u0165ahovanie aplik\xe1ci\xed, \u017Eiadna registr\xe1cia",
            "ancv.input.label": "Va\u0161a identifik\xe1cia ANCV",
            "ancv.confirmPayment": "Na potvrdenie platby pou\u017Eite svoju aplik\xe1ciu ANCV.",
            "ancv.form.instruction": "Na potvrdenie tejto platby je potrebn\xe1 aplik\xe1cia Cheque-Vacances.",
            "ancv.beneficiaryId.invalid": "Zadajte platn\xfa e-mailov\xfa adresu alebo ANCV ID",
            "payme.openPayMeApp": "Dokon\u010Dite platbu v aplik\xe1cii PayMe tak, \u017Ee v aplik\xe1cii autorizujete platbu a po\u010Dk\xe1te na potvrdenie.",
            "payme.redirectButtonLabel": "Otvori\u0165 aplik\xe1ciu PayMe",
            "payme.scanQrCode": "Dokon\u010Dite platbu pomocou k\xf3du QR",
            "payme.timeToPay": "Tento k\xf3d QR plat\xed %@",
            "payme.instructions.steps": "Otvorte aplik\xe1ciu PayMe.%@Autorizujte platbu naskenovan\xedm QR k\xf3du.%@Dokon\u010Dite platbu v aplik\xe1cii a po\u010Dkajte na potvrdenie.",
            "payme.instructions.footnote": "Nezatv\xe1rajte t\xfato str\xe1nku pred dokon\u010Den\xedm platby"
        }
    }), W2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Pla\u010Dilo",
            "payButton.redirecting": "Preusmerjanje...",
            "payButton.with": "Pla\u010Dajte %{value} z %{maskedData}",
            "payButton.saveDetails": "Shrani podrobnosti",
            close: "Zapri",
            storeDetails: "Shrani za moje naslednje pla\u010Dilo",
            readMore: "Preberi ve\u010D",
            "creditCard.holderName": "Ime na kartici",
            "creditCard.holderName.placeholder": "J. Novak",
            "creditCard.holderName.invalid": "Vnesite ime, kot je prikazano na kartici",
            "creditCard.numberField.title": "\u0160tevilka kartice",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Datum veljavnosti",
            "creditCard.expiryDateField.placeholder": "MM/LL",
            "creditCard.expiryDateField.month": "Mesec",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "LL",
            "creditCard.expiryDateField.year": "Leto",
            "creditCard.cvcField.title": "Varnostna koda",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Zapomni si za prihodnji\u010D",
            "creditCard.cvcField.placeholder.4digits": "4 \u0161tevke",
            "creditCard.cvcField.placeholder.3digits": "3 \u0161tevke",
            "creditCard.taxNumber.placeholder": "LLMMDD / 0123456789",
            installments: "\u0160tevilo obrokov",
            installmentOption: "%{times} \xd7 %{partialValue}",
            installmentOptionMonths: "\u0160t. mesecev: %{times}",
            "installments.oneTime": "Enkratno pla\u010Dilo",
            "installments.installments": "Obro\u010Dno pla\u010Dilo",
            "installments.revolving": "Revolving pla\u010Dilo",
            "sepaDirectDebit.ibanField.invalid": "Neveljavna \u0161tevilka ra\u010Duna",
            "sepaDirectDebit.nameField.placeholder": "J. Novak",
            "sepa.ownerName": "Ime imetnika",
            "sepa.ibanNumber": "\u0160tevilka ra\u010Duna (IBAN)",
            "error.title": "Napaka",
            "error.subtitle.redirect": "Preusmeritev ni uspela",
            "error.subtitle.payment": "Pla\u010Dilo ni uspelo",
            "error.subtitle.refused": "Pla\u010Dilo je bilo zavrnjeno",
            "error.message.unknown": "Pri\u0161lo je do neznane napake",
            "errorPanel.title": "Obstoje\u010De napake",
            "idealIssuer.selectField.title": "Banka",
            "idealIssuer.selectField.placeholder": "Izberite svojo banko",
            "creditCard.success": "Pla\u010Dilo je bilo uspe\u0161no",
            loading: "Nalaganje\u2026",
            continue: "Nadaljuj",
            continueTo: "Nadaljujte na",
            "wechatpay.timetopay": "Pla\u010Dati morate %@",
            "sr.wechatpay.timetopay": "\u010Casa za pla\u010Dilo imate %#min.%# %#s.%#",
            "wechatpay.scanqrcode": "Opti\u010Dno preberite kodo QR",
            personalDetails: "Osebni podatki",
            companyDetails: "Podrobnosti o podjetju",
            "companyDetails.name": "Ime podjetja",
            "companyDetails.registrationNumber": "Mati\u010Dna \u0161tevilka podjetja",
            socialSecurityNumber: "\u0160tevilka socialnega zavarovanja",
            firstName: "Ime",
            "firstName.invalid": "Vnesite svoje ime",
            infix: "Naziv",
            lastName: "Priimek",
            "lastName.invalid": "Vnesite svoj priimek",
            mobileNumber: "\u0160tevilka mobilnega telefona",
            "mobileNumber.invalid": "Neveljavna \u0161tevilka mobilnega telefona",
            city: "Mesto",
            postalCode: "Po\u0161tna \u0161tevilka",
            "postalCode.optional": "Po\u0161tna \u0161tevilka (neobvezno)",
            countryCode: "Koda dr\u017Eave",
            telephoneNumber: "Telefonska \u0161tevilka",
            dateOfBirth: "Datum rojstva",
            shopperEmail: "Elektronski naslov",
            gender: "Spol",
            "gender.notselected": "Izberite svoj spol",
            male: "Mo\u0161ki",
            female: "\u017Denski",
            billingAddress: "Naslov za ra\u010Dun",
            street: "Ulica",
            stateOrProvince: "Dr\u017Eava ali provinca",
            country: "Dr\u017Eava/regija",
            houseNumberOrName: "Hi\u0161na \u0161tevilka",
            separateDeliveryAddress: "Navedite lo\u010Den naslov za dostavo",
            deliveryAddress: "Naslov za dostavo",
            "deliveryAddress.firstName": "Ime prejemnika",
            "deliveryAddress.lastName": "Priimek prejemnika",
            zipCode: "Po\u0161tna \u0161tevilka",
            apartmentSuite: "\u0160t. apartmaja/stanovanja",
            provinceOrTerritory: "Obmo\u010Dje ali ozemlje",
            cityTown: "Mesto",
            address: "Naslov",
            "address.placeholder": "Poi\u0161\u010Dite svoj naslov",
            "address.errors.incomplete": "Za nadaljevanje vnesite naslov",
            "address.enterManually": "Naslov vnesite ro\u010Dno",
            state: "Dr\u017Eava",
            "field.title.optional": "(izbirno)",
            "creditCard.cvcField.title.optional": "Varnostna koda (neobvezno)",
            "issuerList.wallet.placeholder": "Izberite svojo denarnico",
            privacyPolicy: "Pravilnik o zasebnosti",
            "afterPay.agreement": "Strinjam se s %@ ponudnika Riverty",
            paymentConditions: "pla\u010Dilnimi pogoji",
            openApp: "Odprite aplikacijo",
            "voucher.readInstructions": "Preberite navodila",
            "voucher.introduction": "Zahvaljujemo se vam za nakup. Za dokon\u010Danje pla\u010Dila uporabite naslednji kupon.",
            "voucher.expirationDate": "Datum poteka veljavnosti",
            "voucher.alternativeReference": "Druga referen\u010Dna \u0161tevilka",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Izberite svojega ponudnika",
            "dragonpay.voucher.bank.selectField.placeholder": "Izberite svojo banko",
            "voucher.paymentReferenceLabel": "Referen\u010Dna \u0161tevilka pla\u010Dila",
            "voucher.surcharge": "Vklj. %@ dopla\u010Dila",
            "voucher.introduction.doku": "Zahvaljujemo se vam za nakup. Za dokon\u010Danje pla\u010Dila uporabite naslednji kupon.",
            "voucher.shopperName": "Ime kupca",
            "voucher.merchantName": "Trgovec",
            "voucher.introduction.econtext": "Zahvaljujemo se vam za nakup. Za dokon\u010Danje pla\u010Dila uporabite naslednji kupon.",
            "voucher.telephoneNumber": "Telefonska \u0161tevilka",
            "voucher.shopperReference": "Referen\u010Dna \u0161tevilka kupca",
            "voucher.collectionInstitutionNumber": "\u0160tevilka ustanove za zbiranje",
            "voucher.econtext.telephoneNumber.invalid": "Telefonska \u0161tevilka mora vsebovati 10 ali 11 \u0161tevk",
            "boletobancario.btnLabel": "Ustvari Boleto",
            "boleto.sendCopyToEmail": "Po\u0161lji kopijo na moj elektronski naslov",
            "button.copy": "Kopiraj",
            "button.download": "Prenesi",
            "boleto.socialSecurityNumber.invalid": "Vnesite veljavno \u0161tevilko CPF/CNPJ",
            "creditCard.storedCard.description.ariaLabel": "Shranjena kartica se kon\u010Da na %@",
            "voucher.entity": "Entiteta",
            donateButton: "Donirajte",
            notNowButton: "Ne zdaj",
            thanksForYourSupport: "Zahvaljujemo se vam za podporo!",
            "resultMessages.preauthorized": "Podrobnosti so shranjene",
            preauthorizeWith: "Predhodna odobritev s/z:",
            confirmPreauthorization: "Potrdi predhodno odobritev",
            confirmPurchase: "Potrditev nakupa",
            applyGiftcard: "Unov\u010Di",
            giftcardBalance: "Stanje na darilni kartici",
            deductedBalance: "Odbiti znesek",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "Prvi dve \u0161tevki gesla za kartico",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Neveljavno geslo",
            "creditCard.taxNumber": "Datum rojstva imetnika kartice ali mati\u010Dna \u0161tevilka podjetja",
            "creditCard.taxNumber.label": "Datum rojstva imetnika kartice (LLMMDD) ali registracijska \u0161tevilka podjetja (10 \u0161tevk)",
            "creditCard.taxNumber.labelAlt": "Mati\u010Dna \u0161tevilka podjetja (10 \u0161tevk)",
            "creditCard.taxNumber.invalid": "Neveljaven datum rojstva imetnika kartice ali mati\u010Dna \u0161tevilka podjetja",
            "storedPaymentMethod.disable.button": "Odstrani",
            "storedPaymentMethod.disable.confirmation": "Odstrani shranjen na\u010Din pla\u010Dila",
            "storedPaymentMethod.disable.confirmButton": "Da, odstrani",
            "storedPaymentMethod.disable.cancelButton": "Prekli\u010Di",
            "ach.bankAccount": "Ban\u010Dni ra\u010Dun",
            "ach.accountHolderNameField.title": "Ime imetnika ra\u010Duna",
            "ach.accountHolderNameField.placeholder": "J. Novak",
            "ach.accountHolderNameField.invalid": "Neveljavno ime imetnika ra\u010Duna",
            "ach.accountNumberField.title": "\u0160tevilka ra\u010Duna",
            "ach.accountNumberField.invalid": "Neveljavna \u0161tevilka ra\u010Duna",
            "ach.accountLocationField.title": "Koda banke ABA",
            "ach.accountLocationField.invalid": "Neveljavna koda banke ABA",
            "ach.savedBankAccount": "Shranjen ban\u010Dni ra\u010Dun",
            "select.state": "Izberite dr\u017Eavo",
            "select.stateOrProvince": "Izberite dr\u017Eavo ali provinco",
            "select.provinceOrTerritory": "Izberite obmo\u010Dje ali ozemlje",
            "select.country": "Izberite dr\u017Eavo/regijo",
            "select.noOptionsFound": "Ni najdenih mo\u017Enosti",
            "select.filter.placeholder": "Iskanje...",
            "telephoneNumber.invalid": "Neveljavna telefonska \u0161tevilka",
            qrCodeOrApp: "ali",
            "paypal.processingPayment": "Obdelava pla\u010Dila...",
            generateQRCode: "Ustvari kodo QR",
            "await.waitForConfirmation": "\u010Cakanje na potrditev",
            "mbway.confirmPayment": "Potrdite svoje pla\u010Dilo v aplikaciji MB WAY",
            "shopperEmail.invalid": "Neveljaven elektronski naslov",
            "dateOfBirth.format": "DD/MM/LLLL",
            "dateOfBirth.invalid": "Vnesite veljaven datum rojstva, ki ka\u017Ee, da ste stari vsaj 18 let.",
            "blik.confirmPayment": "Za potrditev pla\u010Dila odprite svojo ban\u010Dno aplikacijo.",
            "blik.invalid": "Vnesite 6 \u0161tevilk",
            "blik.code": "6-mestna koda",
            "blik.help": "Pridobite kodo iz ban\u010Dne aplikacije.",
            "swish.pendingMessage": "Ko opti\u010Dno preberete, lahko \u010Dakanje traja do 10 minut. Poskus ponovnega pla\u010Dila v tem \u010Dasu lahko povzro\u010Di ve\u010D odtegljajev.",
            "field.valid": "Polje je veljavno",
            "field.invalid": "Polje ni veljavno",
            "error.va.gen.01": "Nepopolno polje",
            "error.va.gen.02": "Polje ni veljavno",
            "error.va.sf-cc-num.01": "Vnesite veljavno \u0161tevilko kartice",
            "error.va.sf-cc-num.02": "Vnesite \u0161tevilko kartice",
            "error.va.sf-cc-num.03": "Vnesite podprto blagovno znamko kartice",
            "error.va.sf-cc-num.04": "Vnesite celotno \u0161tevilko kartice",
            "error.va.sf-cc-dat.01": "Vnesite veljavni datum poteka veljavnosti",
            "error.va.sf-cc-dat.02": "Vnesite veljavni datum poteka veljavnosti",
            "error.va.sf-cc-dat.03": "Kreditna kartica bo kmalu potekla",
            "error.va.sf-cc-dat.04": "Vnesite datum poteka veljavnosti",
            "error.va.sf-cc-dat.05": "Vnesite celoten datum poteka veljavnosti",
            "error.va.sf-cc-mth.01": "Vnesite mesec poteka veljavnosti",
            "error.va.sf-cc-yr.01": "Vnesite leto poteka veljavnosti",
            "error.va.sf-cc-yr.02": "Vnesite celotno leto poteka veljavnosti",
            "error.va.sf-cc-cvc.01": "Vnesite varnostno kodo",
            "error.va.sf-cc-cvc.02": "Vnesite celotno varnostno kodo",
            "error.va.sf-ach-num.01": "Polje s \u0161tevilko ban\u010Dnega ra\u010Duna je prazno",
            "error.va.sf-ach-num.02": "\u0160tevilka ban\u010Dnega ra\u010Duna je napa\u010Dne dol\u017Eine",
            "error.va.sf-ach-loc.01": "Polje z ban\u010Dno usmerjevalno \u0161tevilko je prazno",
            "error.va.sf-ach-loc.02": "Ban\u010Dna usmerjevalna \u0161tevilka je napa\u010Dne dol\u017Eine",
            "error.va.sf-kcp-pwd.01": "Polje z geslom je prazno",
            "error.va.sf-kcp-pwd.02": "Geslo je napa\u010Dne dol\u017Eine",
            "error.giftcard.no-balance": "Na tej darilni kartici ni sredstev",
            "error.giftcard.card-error": "V na\u0161i evidenci nimamo darilne kartice s to \u0161tevilko",
            "error.giftcard.currency-error": "Darilne kartice so veljavne samo za valuto, za katero so bile izdane",
            "amazonpay.signout": "Odjava iz Amazona",
            "amazonpay.changePaymentDetails": "Sprememba podrobnosti pla\u010Dila",
            "partialPayment.warning": "Izberite drugo vrsto pla\u010Dila za pla\u010Dilo ostanka",
            "partialPayment.remainingBalance": "Preostalo stanje bo %{amount}",
            "bankTransfer.beneficiary": "Upravi\u010Denec",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Referenca",
            "bankTransfer.introduction": "Nadaljujte ustvarjanje novega pla\u010Dila z ban\u010Dnim nakazilom. Za dokon\u010Danje tega pla\u010Dila lahko uporabite podatke na naslednjem zaslonu.",
            "bankTransfer.instructions": "Zahvaljujemo se vam za nakup. Za dokon\u010Danje pla\u010Dila uporabite naslednji kupon.",
            "bacs.accountHolderName": "Ime imetnika ban\u010Dnega ra\u010Duna",
            "bacs.accountHolderName.invalid": "Neveljavno ime imetnika ra\u010Duna",
            "bacs.accountNumber": "\u0160tevilka ban\u010Dnega ra\u010Duna",
            "bacs.accountNumber.invalid": "Neveljavna \u0161tevilka ban\u010Dnega ra\u010Duna",
            "bacs.bankLocationId": "\u0160tevilka banke",
            "bacs.bankLocationId.invalid": "Neveljavna \u0161tevilka banke",
            "bacs.consent.amount": "Sogla\u0161am s tem, da bo zgornji znesek odtegnjen z mojega ban\u010Dnega ra\u010Duna.",
            "bacs.consent.account": "Potrjujem, da je ra\u010Dun ustvarjen v mojem imenu in sem edini podpisnik za odobritev neposredne bremenitve za ta ra\u010Dun.",
            edit: "Uredi",
            "bacs.confirm": "Potrdi in pla\u010Daj",
            "bacs.result.introduction": "Prenesite navodila za neposredno bremenitev (DDI/mandat)",
            "download.pdf": "Prenos datoteke PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe za \u0161tevilko kartice",
            "creditCard.encryptedCardNumber.aria.label": "\u0160tevilka kartice",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe za datum poteka veljavnosti",
            "creditCard.encryptedExpiryDate.aria.label": "Datum veljavnosti",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe za mesec poteka veljavnosti",
            "creditCard.encryptedExpiryMonth.aria.label": "Mesec poteka",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe za leto poteka veljavnosti",
            "creditCard.encryptedExpiryYear.aria.label": "Leto poteka",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe za varnostno kodo",
            "creditCard.encryptedSecurityCode.aria.label": "Varnostna koda",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe za geslo",
            "creditCard.encryptedPassword.aria.label": "Prvi dve \u0161tevki gesla za kartico",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe za \u0161tevilko kartice",
            "giftcard.encryptedCardNumber.aria.label": "\u0160tevilka kartice",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe za kodo PIN",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "Za posamezno transakcijo na tej darilni kartici je dovoljeno najve\u010D %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe za \u0161tevilko ban\u010Dnega ra\u010Duna",
            "ach.encryptedBankAccountNumber.aria.label": "\u0160tevilka ra\u010Duna",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe za usmerjevalno \u0161tevilko banke",
            "ach.encryptedBankLocationId.aria.label": "Koda banke ABA",
            "twint.saved": "shranjeno",
            orPayWith: "ali pla\u010Dajte s/z",
            invalidFormatExpects: "Neveljavna oblika zapisa. Pri\u010Dakovana oblika zapisa: %{format}",
            "upi.qrCodeWaitingMessage": "Za dokon\u010Danje pla\u010Dila opti\u010Dno preberite kodo QR z \u017Eeleno aplikacijo UPI",
            "upi.vpaWaitingMessage": "Za potrditev pla\u010Dila odprite svojo aplikacijo UPI",
            "upi.modeSelection": "Izberite, kako \u017Eelite uporabljati aplikacijo UPI.",
            "onlineBanking.termsAndConditions": "Z nadaljevanjem se strinjate s %#pogoji%#",
            "onlineBankingPL.termsAndConditions": "Z nadaljevanjem se strinjate s %#predpisi%# in %#obveznostjo obve\u0161\u010Danja%# dru\u017Ebe Przelewy24",
            "ctp.loading.poweredByCtp": "Omogo\u010Da storitev Click to Pay",
            "ctp.loading.intro": "Preverjamo, ali imate shranjene kartice v storitvi Click to Pay...",
            "ctp.login.title": "Nadaljuj na storitev Click to Pay",
            "ctp.login.subtitle": "Za nadaljevanje vnesite e-po\u0161tni naslov, ki je povezan s storitvijo Click to Pay.",
            "ctp.login.inputLabel": "E-po\u0161ta",
            "ctp.logout.notYou": "To niste vi?",
            "ctp.logout.notYourCards": "To niso va\u0161e kartice?",
            "ctp.logout.notYourCard": "To ni va\u0161a kartica?",
            "ctp.logout.notYourProfile": "To ni va\u0161 profil?",
            "ctp.otp.fieldLabel": "Enkratna koda",
            "ctp.otp.resendCode": "Znova po\u0161lji kodo",
            "ctp.otp.codeResent": "Koda je bila znova poslana",
            "ctp.otp.title": "Dostop do va\u0161ih kartic Click to Pay",
            "ctp.otp.subtitle": "Vnesite kodo %@, ki smo jo poslali na %@, da potrdite, da ste to res vi.",
            "ctp.otp.saveCookiesCheckbox.label": "Naslednji\u010D presko\u010Di preverjanje",
            "ctp.otp.saveCookiesCheckbox.information": "Izberite \u010De \u017Eelite, da se v va\u0161i napravi in brskalniku v sodelujo\u010Dih trgovinah va\u0161i podatki shranijo za hitrej\u0161i zaklju\u010Dek zakupa. Ni priporo\u010Dljivo za naprave v skupni rabi.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Izberite, \u010De \u017Eelite, da se v va\u0161i napravi in brskalniku shranijo va\u0161i podatki",
            "ctp.emptyProfile.message": "V tem profilu Click to Pay ni registriranih nobenih kartic",
            "ctp.separatorText": "ali uporabite",
            "ctp.cards.title": "Dokon\u010Dajte pla\u010Dilo s storitvijo Click to Pay",
            "ctp.cards.subtitle": "Izberite kartico, ki jo \u017Eelite uporabiti.",
            "ctp.cards.expiredCard": "Veljavnost potekla",
            "ctp.manualCardEntry": "Ro\u010Dni vnos kartice",
            "ctp.aria.infoModalButton": "Kaj je storitev Click to Pay",
            "ctp.infoPopup.title": "Storitev Click to Pay prina\u0161a enostavnost brezsti\u010Dnega pla\u010Devanja v spletno okolje",
            "ctp.infoPopup.subtitle": "Hiter in varen na\u010Din pla\u010Dila, ki ga podpirajo Mastercard, Visa in druge pla\u010Dilne kartice.",
            "ctp.infoPopup.benefit1": "Storitev Click to Pay s \u0161ifriranjem poskrbi, da so va\u0161i podatki varni in za\u0161\u010Diteni",
            "ctp.infoPopup.benefit2": "Uporabljate jo lahko pri prodajalcih po vsem svetu",
            "ctp.infoPopup.benefit3": "Enkratna nastavitev za brezskrbno pla\u010Devanje v prihodnje",
            "ctp.errors.AUTH_INVALID": "Preverjanje pristnosti ni veljavno",
            "ctp.errors.NOT_FOUND": "Ra\u010Duna ni bilo mogo\u010De najti, vnesite veljaven e-po\u0161tni naslov ali nadaljujte z uporabo ro\u010Dnega vnosa kartice",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Oblika zapisa ni podprta",
            "ctp.errors.FRAUD": "Uporabni\u0161ki ra\u010Dun je bil zaklenjen ali onemogo\u010Den",
            "ctp.errors.CONSUMER_ID_MISSING": "V zahtevi manjka identiteta potro\u0161nika",
            "ctp.errors.ACCT_INACCESSIBLE": "Ta ra\u010Dun trenutno ni na voljo, npr. morda je zaklenjen",
            "ctp.errors.CODE_INVALID": "Koda za preverjanje ni pravilna",
            "ctp.errors.CODE_EXPIRED": "Ta koda je potekla",
            "ctp.errors.RETRIES_EXCEEDED": "Omejitev \u0161tevila ponovnih poskusov za generiranje gesla OTP je bila prese\u017Eena",
            "ctp.errors.OTP_SEND_FAILED": "Gesla OTP ni bilo mogo\u010De poslati prejemniku",
            "ctp.errors.REQUEST_TIMEOUT": "Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010Dni vnos kartice",
            "ctp.errors.UNKNOWN_ERROR": "Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010Dni vnos kartice",
            "ctp.errors.SERVICE_ERROR": "Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010Dni vnos kartice",
            "ctp.errors.SERVER_ERROR": "Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010Dni vnos kartice",
            "ctp.errors.INVALID_PARAMETER": "Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010Dni vnos kartice",
            "ctp.errors.AUTH_ERROR": "Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010Dni vnos kartice",
            "paymentMethodsList.aria.label": "Izberite na\u010Din pla\u010Dila",
            "companyDetails.name.invalid": "Vnesite ime podjetja",
            "companyDetails.registrationNumber.invalid": "Vnesite registracijsko \u0161tevilko",
            "consent.checkbox.invalid": "Strinjati se morate s pogoji in dolo\u010Dili",
            "form.instruction": "Vsa polja so obvezna, razen \u010De ni ozna\u010Deno druga\u010De.",
            "trustly.descriptor": "Takoj\u0161nje ban\u010Dno nakazilo",
            "trustly.description1": "Pla\u010Dajte neposredno s svojega poljubnega ban\u010Dnega ra\u010Duna, pri \u010Demer je varnost zagotovljena na ravni banke.",
            "trustly.description2": "Brez kartic, brez prenosa aplikacije, brez registracije",
            "ancv.input.label": "Va\u0161a identifikacija ANCV",
            "ancv.confirmPayment": "Za potrditev pla\u010Dila uporabite aplikacijo ANCV.",
            "ancv.form.instruction": "Za potrditev tega pla\u010Dila je potrebna aplikacija Cheque-Vacances.",
            "ancv.beneficiaryId.invalid": "Vnesite veljaven e-po\u0161tni naslov ali ANCV ID",
            "payme.openPayMeApp": "Pla\u010Dilo dokon\u010Dajte v aplikaciji PayMe tako, da ga odobrite v aplikaciji in po\u010Dakate na potrditev.",
            "payme.redirectButtonLabel": "Odprite aplikacijo PayMe",
            "payme.scanQrCode": "Izvedite pla\u010Dilo s kodo QR",
            "payme.timeToPay": "Ta koda QR velja za %@",
            "payme.instructions.steps": "Odprite aplikacijo PayMe.%@Skenirajte kodo QR, da odobrite pla\u010Dilo.%@Zaklju\u010Dite pla\u010Dilo v aplikaciji in po\u010Dakajte na potrditev.",
            "payme.instructions.footnote": "Ne zapirajte te strani, preden je pla\u010Dilo zaklju\u010Deno."
        }
    }), G2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Betala",
            "payButton.redirecting": "Omdirigerar\u2026",
            "payButton.with": "Betala %{value} med %{maskedData}",
            "payButton.saveDetails": "Spara information",
            close: "St\xe4ng",
            storeDetails: "Spara till min n\xe4sta betalning",
            readMore: "L\xe4s mer",
            "creditCard.holderName": "Namn p\xe5 kort",
            "creditCard.holderName.placeholder": "A. Andersson",
            "creditCard.holderName.invalid": "Ange namnet som det st\xe5r p\xe5 kortet",
            "creditCard.numberField.title": "Kortnummer",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Utg\xe5ngsdatum",
            "creditCard.expiryDateField.placeholder": "MM/\xc5\xc5",
            "creditCard.expiryDateField.month": "M\xe5nad",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "\xc5\xc5",
            "creditCard.expiryDateField.year": "\xc5r",
            "creditCard.cvcField.title": "S\xe4kerhetskod",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Spara kortuppgifter",
            "creditCard.cvcField.placeholder.4digits": "4 siffror",
            "creditCard.cvcField.placeholder.3digits": "3 siffror",
            "creditCard.taxNumber.placeholder": "\xc5\xc5MMDD / 0123456789",
            installments: "Antal delbetalningar",
            installmentOption: "%{times} x %{partialValue}",
            installmentOptionMonths: "%{times} m\xe5nader",
            "installments.oneTime": "Eng\xe5ngsbetalning",
            "installments.installments": "Delbetalningar",
            "installments.revolving": "Uppdelad betalning",
            "sepaDirectDebit.ibanField.invalid": "Ogiltigt kontonummer",
            "sepaDirectDebit.nameField.placeholder": "A. Andersson",
            "sepa.ownerName": "K\xe4nt av kontoinnehavaren",
            "sepa.ibanNumber": "Kontonummer (IBAN)",
            "error.title": "Fel",
            "error.subtitle.redirect": "Omdirigering misslyckades",
            "error.subtitle.payment": "Betalning misslyckades",
            "error.subtitle.refused": "Betalning avvisad",
            "error.message.unknown": "Ett ok\xe4nt fel uppstod",
            "errorPanel.title": "Befintliga fel",
            "idealIssuer.selectField.title": "Bank",
            "idealIssuer.selectField.placeholder": "V\xe4lj din bank",
            "creditCard.success": "Betalning lyckades",
            loading: "Laddar\u2026",
            continue: "Forts\xe4tt",
            continueTo: "Forts\xe4tt till",
            "wechatpay.timetopay": "Du har %@ att betala",
            "sr.wechatpay.timetopay": "Du har %#minuter%# och %#sekunder%# p\xe5 dig att betala",
            "wechatpay.scanqrcode": "Skanna QR-kod",
            personalDetails: "Personuppgifter",
            companyDetails: "F\xf6retagsinformation",
            "companyDetails.name": "F\xf6retagsnamn",
            "companyDetails.registrationNumber": "Registreringsnummer",
            socialSecurityNumber: "Personnummer",
            firstName: "F\xf6rnamn",
            "firstName.invalid": "Ange ditt f\xf6rnamn",
            infix: "Prefix",
            lastName: "Efternamn",
            "lastName.invalid": "Ange ditt efternamn",
            mobileNumber: "Mobilnummer",
            "mobileNumber.invalid": "Ogiltigt mobilnummer",
            city: "Stad",
            postalCode: "Postnummer",
            "postalCode.optional": "Postnummer (valfritt)",
            countryCode: "Landskod",
            telephoneNumber: "Telefonnummer",
            dateOfBirth: "F\xf6delsedatum",
            shopperEmail: "E-postadress",
            gender: "K\xf6n",
            "gender.notselected": "V\xe4lj k\xf6n",
            male: "Man",
            female: "Kvinna",
            billingAddress: "Faktureringsadress",
            street: "Gatuadress",
            stateOrProvince: "Delstat eller region",
            country: "Land/region",
            houseNumberOrName: "Husnummer",
            separateDeliveryAddress: "Ange en separat leveransadress",
            deliveryAddress: "Leveransadress",
            "deliveryAddress.firstName": "Mottagarens f\xf6rnamn",
            "deliveryAddress.lastName": "Mottagarens efternamn",
            zipCode: "Postnummer",
            apartmentSuite: "L\xe4genhetsnummer",
            provinceOrTerritory: "Provins eller territorium",
            cityTown: "Ort",
            address: "Adress",
            "address.placeholder": "Hitta din adress",
            "address.errors.incomplete": "Ange en adress f\xf6r att forts\xe4tta",
            "address.enterManually": "Ange adress manuellt",
            state: "Delstat",
            "field.title.optional": "(valfritt)",
            "creditCard.cvcField.title.optional": "S\xe4kerhetskod (valfritt)",
            "issuerList.wallet.placeholder": "V\xe4j din pl\xe5nbok",
            privacyPolicy: "Sekretesspolicy",
            "afterPay.agreement": "Jag godk\xe4nner Rivertys %@",
            paymentConditions: "betalvillkor",
            openApp: "\xd6ppna appen",
            "voucher.readInstructions": "L\xe4s instruktionerna",
            "voucher.introduction": "Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande kupong f\xf6r att slutf\xf6ra din betalning.",
            "voucher.expirationDate": "Utg\xe5ngsdatum",
            "voucher.alternativeReference": "Alternativ referens",
            "dragonpay.voucher.non.bank.selectField.placeholder": "V\xe4lj din leverant\xf6r",
            "dragonpay.voucher.bank.selectField.placeholder": "V\xe4lj din bank",
            "voucher.paymentReferenceLabel": "Betalreferens",
            "voucher.surcharge": "Inklusive %@ i avgift",
            "voucher.introduction.doku": "Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.",
            "voucher.shopperName": "Konsumentens namn",
            "voucher.merchantName": "Handlare",
            "voucher.introduction.econtext": "Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.",
            "voucher.telephoneNumber": "Telefonnummer",
            "voucher.shopperReference": "K\xf6parreferens",
            "voucher.collectionInstitutionNumber": "Nummer p\xe5 upph\xe4mtningsplats",
            "voucher.econtext.telephoneNumber.invalid": "Telefonnumret m\xe5ste inneh\xe5lla 10 eller 11 siffror",
            "boletobancario.btnLabel": "Generera Boleto",
            "boleto.sendCopyToEmail": "Skicka en kopia till min e-post",
            "button.copy": "Kopiera",
            "button.download": "Ladda ner",
            "boleto.socialSecurityNumber.invalid": "Ange ett giltigt CPF-/CNPJ-nummer",
            "creditCard.storedCard.description.ariaLabel": "Sparat kort slutar p\xe5 %@",
            "voucher.entity": "Enhet",
            donateButton: "Donera",
            notNowButton: "Inte nu",
            thanksForYourSupport: "Tack f\xf6r ditt st\xf6d!",
            "resultMessages.preauthorized": "Information sparad",
            preauthorizeWith: "F\xf6rauktorisera med",
            confirmPreauthorization: "Bekr\xe4fta f\xf6rauktorisering",
            confirmPurchase: "Bekr\xe4fta k\xf6p",
            applyGiftcard: "L\xf6s in",
            giftcardBalance: "Presentkortssaldo",
            deductedBalance: "Avdraget saldo",
            "creditCard.pin.title": "PIN-kod",
            "creditCard.encryptedPassword.label": "De tv\xe5 f\xf6rsta siffrorna i kortets l\xf6senord",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Ogiltigt l\xf6senord",
            "creditCard.taxNumber": "Kortinnehavarens f\xf6delsedatum eller f\xf6retagets organisationsnummer",
            "creditCard.taxNumber.label": "Kortinnehavarens f\xf6delsedatum (\xc5\xc5MMDD) eller f\xf6retagets organisationsnummer (10 siffror)",
            "creditCard.taxNumber.labelAlt": "F\xf6retagets organisationsnummer (10 siffror)",
            "creditCard.taxNumber.invalid": "Ogiltigt f\xf6delsedatum eller organisationsnummer",
            "storedPaymentMethod.disable.button": "Ta bort",
            "storedPaymentMethod.disable.confirmation": "Ta bort sparat betalningss\xe4tt",
            "storedPaymentMethod.disable.confirmButton": "Ja, ta bort",
            "storedPaymentMethod.disable.cancelButton": "Avbryt",
            "ach.bankAccount": "Bankkonto",
            "ach.accountHolderNameField.title": "Kontoinnehavarens namn",
            "ach.accountHolderNameField.placeholder": "A. Andersson",
            "ach.accountHolderNameField.invalid": "Kontoinnehavarens namn \xe4r ogiltigt",
            "ach.accountNumberField.title": "Kontonummer",
            "ach.accountNumberField.invalid": "Ogiltigt kontonummer",
            "ach.accountLocationField.title": "ABA-nummer",
            "ach.accountLocationField.invalid": "Ogiltigt ABA-nummer",
            "ach.savedBankAccount": "Sparat bankkonto",
            "select.state": "V\xe4lj delstat",
            "select.stateOrProvince": "V\xe4lj delstat eller provins",
            "select.provinceOrTerritory": "V\xe4lj provins eller territorium",
            "select.country": "V\xe4lj land/region",
            "select.noOptionsFound": "Inga alternativ hittades",
            "select.filter.placeholder": "S\xf6k efter\u2026",
            "telephoneNumber.invalid": "Ogiltigt telefonnummer",
            qrCodeOrApp: "eller",
            "paypal.processingPayment": "Behandlar betalning\u2026",
            generateQRCode: "Generera QR-kod",
            "await.waitForConfirmation": "V\xe4ntar p\xe5 bekr\xe4ftelse",
            "mbway.confirmPayment": "Bekr\xe4fta din betalning i appen MB WAY",
            "shopperEmail.invalid": "Ogiltig e-postadress",
            "dateOfBirth.format": "DD/MM/\xc5\xc5\xc5\xc5",
            "dateOfBirth.invalid": "Ange ett giltigt f\xf6delsedatum som visar att du \xe4r minst 18 \xe5r gammal",
            "blik.confirmPayment": "\xd6ppna din bankapp f\xf6r att bekr\xe4fta betalningen.",
            "blik.invalid": "Ange 6 siffror",
            "blik.code": "Sexsiffrig kod",
            "blik.help": "H\xe4mta koden fr\xe5n din bankapp.",
            "swish.pendingMessage": "N\xe4r du har skannat kan statusen vara v\xe4ntande i upp till tio minuter. Att f\xf6rs\xf6ka betala igen inom denna tid kan leda till flera debiteringar.",
            "field.valid": "F\xe4ltet \xe4r giltigt",
            "field.invalid": "F\xe4ltet ogiltigt",
            "error.va.gen.01": "Ofullst\xe4ndigt f\xe4lt",
            "error.va.gen.02": "F\xe4ltet ogiltigt",
            "error.va.sf-cc-num.01": "Ange ett giltigt kortnummer",
            "error.va.sf-cc-num.02": "Ange kortnumret",
            "error.va.sf-cc-num.03": "Ange ett kortm\xe4rke som st\xf6ds",
            "error.va.sf-cc-num.04": "Ange det fullst\xe4ndiga kortnumret",
            "error.va.sf-cc-dat.01": "Ange ett giltigt utg\xe5ngsdatum",
            "error.va.sf-cc-dat.02": "Ange ett giltigt utg\xe5ngsdatum",
            "error.va.sf-cc-dat.03": "Kreditkortet g\xe5r snart ut",
            "error.va.sf-cc-dat.04": "Ange utg\xe5ngsdatumet",
            "error.va.sf-cc-dat.05": "Ange det fullst\xe4ndiga utg\xe5ngsdatumet",
            "error.va.sf-cc-mth.01": "Ange utg\xe5ngsm\xe5naden",
            "error.va.sf-cc-yr.01": "Ange utg\xe5ngs\xe5ret",
            "error.va.sf-cc-yr.02": "Ange det fullst\xe4ndiga utg\xe5ngs\xe5ret",
            "error.va.sf-cc-cvc.01": "Ange s\xe4kerhetskoden",
            "error.va.sf-cc-cvc.02": "Ange den fullst\xe4ndiga s\xe4kerhetskoden",
            "error.va.sf-ach-num.01": "F\xe4ltet f\xf6r bankkontonummer \xe4r tomt",
            "error.va.sf-ach-num.02": "Bankkontonumret har fel l\xe4ngd",
            "error.va.sf-ach-loc.01": "F\xe4ltet f\xf6r clearingnummer \xe4r tomt",
            "error.va.sf-ach-loc.02": "Clearingnumret har fel l\xe4ngd",
            "error.va.sf-kcp-pwd.01": "F\xe4ltet f\xf6r l\xf6senord \xe4r tomt",
            "error.va.sf-kcp-pwd.02": "L\xf6senordet har fel l\xe4ngd",
            "error.giftcard.no-balance": "Saldot f\xf6r detta presentkort \xe4r noll",
            "error.giftcard.card-error": "Vi har inte registrerat n\xe5got presentkort med det numret",
            "error.giftcard.currency-error": "Presentkort \xe4r endast giltiga i den valuta som de utf\xe4rdades i",
            "amazonpay.signout": "Logga ut fr\xe5n Amazon",
            "amazonpay.changePaymentDetails": "\xc4ndra betalningsuppgifter",
            "partialPayment.warning": "V\xe4lj ett annat betalningss\xe4tt f\xf6r att betala det \xe5terst\xe5ende",
            "partialPayment.remainingBalance": "\xc5terst\xe5ende saldo blir %{amount}",
            "bankTransfer.beneficiary": "Mottagare",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "referens",
            "bankTransfer.introduction": "Forts\xe4tt f\xf6r att skapa en ny bank\xf6verf\xf6ring. Du kan anv\xe4nda informationen p\xe5 f\xf6ljande sk\xe4rm f\xf6r att slutf\xf6ra denna betalning.",
            "bankTransfer.instructions": "Tack f\xf6r ditt k\xf6p! Anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.",
            "bacs.accountHolderName": "Bankkontoinnehavarens namn",
            "bacs.accountHolderName.invalid": "Ogiltigt namn p\xe5 bankkontoinnehavare",
            "bacs.accountNumber": "Bankkontonummer",
            "bacs.accountNumber.invalid": "Ogiltigt bankkontonummer",
            "bacs.bankLocationId": "Clearingnummer",
            "bacs.bankLocationId.invalid": "Ogiltigt clearingnummer",
            "bacs.consent.amount": "Jag godk\xe4nner att ovanst\xe5ende belopp dras fr\xe5n mitt bankkonto.",
            "bacs.consent.account": "Jag bekr\xe4ftar att jag \xe4r kontoinnehavare och att jag \xe4r den enda person vars godk\xe4nnande kr\xe4vs f\xf6r att auktorisera autogiro fr\xe5n detta konto.",
            edit: "Redigera",
            "bacs.confirm": "Bekr\xe4fta och betala",
            "bacs.result.introduction": "Ladda ner din instruktion f\xf6r autogiro/direktdebitering (DDI / Mandate)",
            "download.pdf": "Ladda ner PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe f\xf6r kortnummer",
            "creditCard.encryptedCardNumber.aria.label": "Kortnummer",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe f\xf6r utg\xe5ngsdatum",
            "creditCard.encryptedExpiryDate.aria.label": "Utg\xe5ngsdatum",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe f\xf6r utg\xe5ngsm\xe5nad",
            "creditCard.encryptedExpiryMonth.aria.label": "Utg\xe5ngsm\xe5nad",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe f\xf6r utg\xe5ngs\xe5r",
            "creditCard.encryptedExpiryYear.aria.label": "Utg\xe5ngs\xe5r",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe f\xf6r s\xe4kerhetskod",
            "creditCard.encryptedSecurityCode.aria.label": "S\xe4kerhetskod",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe f\xf6r l\xf6senord",
            "creditCard.encryptedPassword.aria.label": "De tv\xe5 f\xf6rsta siffrorna i kortets l\xf6senord",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe f\xf6r kortnummer",
            "giftcard.encryptedCardNumber.aria.label": "Kortnummer",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe f\xf6r PIN",
            "giftcard.encryptedSecurityCode.aria.label": "PIN-kod",
            giftcardTransactionLimit: "Maximalt %{amount} per transaktion \xe4r till\xe5tet p\xe5 detta presentkort",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe f\xf6r bankkontonummer",
            "ach.encryptedBankAccountNumber.aria.label": "Kontonummer",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe f\xf6r clearingnummer",
            "ach.encryptedBankLocationId.aria.label": "ABA-nummer",
            "twint.saved": "sparat",
            orPayWith: "eller betala med",
            invalidFormatExpects: "Ogiltigt format. F\xf6rv\xe4ntat format: %{format}",
            "upi.qrCodeWaitingMessage": "Skanna QR-koden med valfri UPI-app f\xf6r att slutf\xf6ra betalningen",
            "upi.vpaWaitingMessage": "\xd6ppna din UPI-app f\xf6r att bekr\xe4fta betalningen",
            "upi.modeSelection": "V\xe4lj hur du vill anv\xe4nda UPI.",
            "onlineBanking.termsAndConditions": "Genom att forts\xe4tta godk\xe4nner du %#villkoren%#",
            "onlineBankingPL.termsAndConditions": "Genom att forts\xe4tta godk\xe4nner du Przelewy24s %#regler%# och %#informationsplikt%#.",
            "ctp.loading.poweredByCtp": "Drivs av Click to Pay",
            "ctp.loading.intro": "Vi kontrollerar om du har n\xe5gra sparade kort med Click to Pay...",
            "ctp.login.title": "Forts\xe4tt till Click to Pay",
            "ctp.login.subtitle": "Ange den e-postadress som \xe4r ansluten till Click to Pay f\xf6r att forts\xe4tta.",
            "ctp.login.inputLabel": "E-postadress",
            "ctp.logout.notYou": "Inte du?",
            "ctp.logout.notYourCards": "Inte dina kort?",
            "ctp.logout.notYourCard": "Inte ditt kort?",
            "ctp.logout.notYourProfile": "Inte din profil?",
            "ctp.otp.fieldLabel": "Eng\xe5ngskod",
            "ctp.otp.resendCode": "Skicka koden igen",
            "ctp.otp.codeResent": "Koden skickad igen",
            "ctp.otp.title": "F\xe5 tillg\xe5ng till dina Click to Pay-kort",
            "ctp.otp.subtitle": "Ange koden som %@ skickade till %@ f\xf6r att verifiera att det \xe4r du.",
            "ctp.otp.saveCookiesCheckbox.label": "Hoppa \xf6ver verifieringen n\xe4sta g\xe5ng",
            "ctp.otp.saveCookiesCheckbox.information": "V\xe4lj att bli ih\xe5gkommen p\xe5 din enhet och webbl\xe4sare i deltagande butiker f\xf6r snabbare utcheckning. Rekommenderas inte f\xf6r delade enheter.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "V\xe4lj att bli ih\xe5gkommen p\xe5 din enhet och i din webbl\xe4sare",
            "ctp.emptyProfile.message": "Inga kort registrerade i denna Click to Pay-profil",
            "ctp.separatorText": "eller anv\xe4nd",
            "ctp.cards.title": "Slutf\xf6r betalningen med Click to Pay",
            "ctp.cards.subtitle": "V\xe4lj ett kort att anv\xe4nda.",
            "ctp.cards.expiredCard": "Utg\xe5ngna",
            "ctp.manualCardEntry": "Manuell kortinmatning",
            "ctp.aria.infoModalButton": "Vad \xe4r Click to Pay?",
            "ctp.infoPopup.title": "Click to Pay \u2013 lika enkelt som kontaktl\xf6s betalning, fast online",
            "ctp.infoPopup.subtitle": "En snabb och s\xe4ker betalningsmetod som st\xf6ds av Mastercard, Visa och andra betalkort.",
            "ctp.infoPopup.benefit1": "Click to Pay anv\xe4nder kryptering f\xf6r att h\xe5lla din information s\xe4ker och trygg",
            "ctp.infoPopup.benefit2": "Anv\xe4nd den hos handlare \xf6ver hela v\xe4rlden",
            "ctp.infoPopup.benefit3": "Konfigurera en g\xe5ng f\xf6r problemfria betalningar i framtiden",
            "ctp.errors.AUTH_INVALID": "Autentisering ogiltig",
            "ctp.errors.NOT_FOUND": "Inget konto hittades, ange en giltig e-postadress eller forts\xe4tt med manuell kortinmatning",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Formatet st\xf6ds inte",
            "ctp.errors.FRAUD": "Anv\xe4ndarkontot var l\xe5st eller inaktiverat",
            "ctp.errors.CONSUMER_ID_MISSING": "Konsumentidentitet saknas i beg\xe4ran",
            "ctp.errors.ACCT_INACCESSIBLE": "Det h\xe4r kontot \xe4r f\xf6r n\xe4rvarande inte tillg\xe4ngligt, det kanske \xe4r l\xe5st",
            "ctp.errors.CODE_INVALID": "Felaktig verifieringskod",
            "ctp.errors.CODE_EXPIRED": "Denna kod har g\xe5tt ut",
            "ctp.errors.RETRIES_EXCEEDED": "Gr\xe4nsen f\xf6r antalet f\xf6rs\xf6k till OTP-generering har \xf6verskridits",
            "ctp.errors.OTP_SEND_FAILED": "OTP kunde inte skickas till mottagaren",
            "ctp.errors.REQUEST_TIMEOUT": "N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd den manuella kortinmatningen",
            "ctp.errors.UNKNOWN_ERROR": "N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd manuell kortinmatning",
            "ctp.errors.SERVICE_ERROR": "N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd manuell kortinmatning",
            "ctp.errors.SERVER_ERROR": "N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd manuell kortinmatning",
            "ctp.errors.INVALID_PARAMETER": "N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd manuell kortinmatning",
            "ctp.errors.AUTH_ERROR": "N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd manuell kortinmatning",
            "paymentMethodsList.aria.label": "V\xe4lj en betalningsmetod",
            "companyDetails.name.invalid": "Ange f\xf6retagsnamnet",
            "companyDetails.registrationNumber.invalid": "Ange registreringsnumret",
            "consent.checkbox.invalid": "Du m\xe5ste godk\xe4nna villkoren",
            "form.instruction": "Alla f\xe4lt \xe4r obligatoriska om inte n\xe5got annat anges.",
            "trustly.descriptor": "Omedelbar bankbetalning",
            "ancv.input.label": "Din ANCV-identifiering",
            "ancv.confirmPayment": "Bekr\xe4fta betalningen i din ANCV-app.",
            "ancv.form.instruction": "Appen Cheque-Vacances kr\xe4vs f\xf6r att validera denna betalning.",
            "ancv.beneficiaryId.invalid": "Ange en giltig e-postadress eller ANCV-ID",
            "payme.openPayMeApp": "Slutf\xf6r din betalning i PayMe-appen genom att godk\xe4nna betalningen i appen och v\xe4nta p\xe5 bekr\xe4ftelse.",
            "payme.redirectButtonLabel": "\xd6ppna PayMe-appen",
            "payme.scanQrCode": "Slutf\xf6r din betalning med QR-kod",
            "payme.timeToPay": "Denna QR-kod \xe4r giltig i %@",
            "payme.instructions.steps": "\xd6ppna PayMe-appen.%@Skanna QR-koden f\xf6r att godk\xe4nna betalningen.%@Slutf\xf6r betalningen i appen och v\xe4nta p\xe5 bekr\xe4ftelse.",
            "payme.instructions.footnote": "St\xe4ng inte denna sida innan betalningen \xe4r slutf\xf6rd"
        }
    }), Y2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "\u652F\u4ED8",
            "payButton.redirecting": "\u6B63\u5728\u91CD\u5B9A\u5411...",
            "payButton.with": "\u4F7F\u7528 %{maskedData} \u652F\u4ED8 %{value}",
            "payButton.saveDetails": "\u4FDD\u5B58\u8BE6\u60C5",
            close: "\u5173\u95ED",
            storeDetails: "\u4FDD\u5B58\u4EE5\u4FBF\u4E0B\u6B21\u652F\u4ED8\u4F7F\u7528",
            readMore: "\u9605\u8BFB\u66F4\u591A",
            "creditCard.holderName": "\u5361\u7247\u4E0A\u7684\u59D3\u540D",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "\u8F93\u5165\u5361\u7247\u4E0A\u663E\u793A\u7684\u59D3\u540D",
            "creditCard.numberField.title": "\u5361\u53F7",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "\u6709\u6548\u671F",
            "creditCard.expiryDateField.placeholder": "\u6708\u6708/\u5E74\u5E74",
            "creditCard.expiryDateField.month": "\u6708",
            "creditCard.expiryDateField.month.placeholder": "\u6708\u6708",
            "creditCard.expiryDateField.year.placeholder": "\u5E74\u5E74",
            "creditCard.expiryDateField.year": "\u5E74",
            "creditCard.cvcField.title": "\u5B89\u5168\u7801",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "\u8BB0\u4F4F\u4EE5\u4FBF\u4E0B\u6B21\u4F7F\u7528",
            "creditCard.cvcField.placeholder.4digits": "4 \u4F4D\u6570",
            "creditCard.cvcField.placeholder.3digits": "3 \u4F4D\u6570",
            "creditCard.taxNumber.placeholder": "\u5E74\u6708\u65E5 / 0123456789",
            installments: "\u5206\u671F\u4ED8\u6B3E\u671F\u6570",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} \u4E2A\u6708",
            "installments.oneTime": "\u5168\u6B3E\u652F\u4ED8",
            "installments.installments": "\u5206\u671F\u652F\u4ED8",
            "installments.revolving": "\u5FAA\u73AF\u652F\u4ED8",
            "sepaDirectDebit.ibanField.invalid": "\u65E0\u6548\u7684\u8D26\u53F7",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "\u6301\u5361\u4EBA\u59D3\u540D",
            "sepa.ibanNumber": "\u8D26\u53F7 (IBAN)",
            "error.title": "\u9519\u8BEF",
            "error.subtitle.redirect": "\u91CD\u5B9A\u5411\u5931\u8D25",
            "error.subtitle.payment": "\u652F\u4ED8\u5931\u8D25",
            "error.subtitle.refused": "\u652F\u4ED8\u88AB\u62D2",
            "error.message.unknown": "\u53D1\u751F\u672A\u77E5\u9519\u8BEF",
            "errorPanel.title": "\u73B0\u6709\u9519\u8BEF",
            "idealIssuer.selectField.title": "\u94F6\u884C",
            "idealIssuer.selectField.placeholder": "\u9009\u62E9\u60A8\u7684\u94F6\u884C",
            "creditCard.success": "\u652F\u4ED8\u6210\u529F",
            loading: "\u6B63\u5728\u52A0\u8F7D...",
            continue: "\u7EE7\u7EED",
            continueTo: "\u7EE7\u7EED\u81F3",
            "wechatpay.timetopay": "\u60A8\u9700\u8981\u652F\u4ED8 %@",
            "sr.wechatpay.timetopay": "\u60A8\u6709 %#\u5206%# %#\u79D2%# \u53EF\u4EE5\u652F\u4ED8",
            "wechatpay.scanqrcode": "\u626B\u63CF\u4E8C\u7EF4\u7801",
            personalDetails: "\u4E2A\u4EBA\u8BE6\u7EC6\u4FE1\u606F",
            companyDetails: "\u516C\u53F8\u8BE6\u60C5",
            "companyDetails.name": "\u516C\u53F8\u540D\u79F0",
            "companyDetails.registrationNumber": "\u6CE8\u518C\u53F7",
            socialSecurityNumber: "\u793E\u4F1A\u4FDD\u9669\u53F7\u7801",
            firstName: "\u540D\u5B57",
            "firstName.invalid": "\u8F93\u5165\u60A8\u7684\u540D\u5B57",
            infix: "\u524D\u7F00",
            lastName: "\u59D3\u6C0F",
            "lastName.invalid": "\u8F93\u5165\u60A8\u7684\u59D3\u6C0F",
            mobileNumber: "\u624B\u673A\u53F7",
            "mobileNumber.invalid": "\u65E0\u6548\u7684\u624B\u673A\u53F7\u7801",
            city: "\u57CE\u5E02",
            postalCode: "\u90AE\u653F\u7F16\u7801",
            "postalCode.optional": "\u90AE\u653F\u7F16\u7801\uFF08\u53EF\u9009\uFF09",
            countryCode: "\u56FD\u5BB6\u4EE3\u7801",
            telephoneNumber: "\u7535\u8BDD\u53F7\u7801",
            dateOfBirth: "\u51FA\u751F\u65E5\u671F",
            shopperEmail: "\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
            gender: "\u6027\u522B",
            "gender.notselected": "\u9009\u62E9\u60A8\u7684\u6027\u522B",
            male: "\u7537",
            female: "\u5973",
            billingAddress: "\u8D26\u5355\u5730\u5740",
            street: "\u8857\u9053",
            stateOrProvince: "\u5DDE\u6216\u7701",
            country: "\u56FD\u5BB6/\u5730\u533A",
            houseNumberOrName: "\u95E8\u724C\u53F7",
            separateDeliveryAddress: "\u6307\u5B9A\u4E00\u4E2A\u5355\u72EC\u7684\u5BC4\u9001\u5730\u5740",
            deliveryAddress: "\u5BC4\u9001\u5730\u5740",
            "deliveryAddress.firstName": "\u6536\u4EF6\u4EBA\u540D\u5B57",
            "deliveryAddress.lastName": "\u6536\u4EF6\u4EBA\u59D3\u6C0F",
            zipCode: "\u90AE\u653F\u7F16\u7801",
            apartmentSuite: "\u516C\u5BD3 / \u5957\u623F",
            provinceOrTerritory: "\u7701\u6216\u5730\u533A",
            cityTown: "\u5E02 / \u9547",
            address: "\u5730\u5740",
            "address.placeholder": "\u67E5\u627E\u60A8\u7684\u5730\u5740",
            "address.errors.incomplete": "\u8F93\u5165\u5730\u5740\u4EE5\u7EE7\u7EED",
            "address.enterManually": "\u624B\u52A8\u8F93\u5165\u5730\u5740",
            state: "\u5DDE",
            "field.title.optional": "\uFF08\u53EF\u9009\uFF09",
            "creditCard.cvcField.title.optional": "\u5B89\u5168\u7801\uFF08\u53EF\u9009\uFF09",
            "issuerList.wallet.placeholder": "\u9009\u62E9\u60A8\u7684\u94B1\u5305",
            privacyPolicy: "\u9690\u79C1\u653F\u7B56",
            "afterPay.agreement": "\u6211\u540C\u610F Riverty \u7684 %@",
            paymentConditions: "\u652F\u4ED8\u6761\u4EF6",
            openApp: "\u6253\u5F00\u5E94\u7528",
            "voucher.readInstructions": "\u9605\u8BFB\u8BF4\u660E",
            "voucher.introduction": "\u611F\u8C22\u60A8\u7684\u8D2D\u4E70\uFF0C\u8BF7\u4F7F\u7528\u4EE5\u4E0B\u4F18\u60E0\u5238\u5B8C\u6210\u652F\u4ED8\u3002",
            "voucher.expirationDate": "\u6709\u6548\u671F",
            "voucher.alternativeReference": "\u5907\u9009\u4EE3\u7801",
            "dragonpay.voucher.non.bank.selectField.placeholder": "\u9009\u62E9\u60A8\u7684\u63D0\u4F9B\u5546",
            "dragonpay.voucher.bank.selectField.placeholder": "\u9009\u62E9\u60A8\u7684\u94F6\u884C",
            "voucher.paymentReferenceLabel": "\u4EA4\u6613\u53F7",
            "voucher.surcharge": "\u5305\u62EC %@ \u7684\u9644\u52A0\u8D39",
            "voucher.introduction.doku": "\u611F\u8C22\u60A8\u7684\u8D2D\u4E70\uFF0C\u8BF7\u4F7F\u7528\u4EE5\u4E0B\u4FE1\u606F\u5B8C\u6210\u652F\u4ED8\u3002",
            "voucher.shopperName": "\u987E\u5BA2\u59D3\u540D",
            "voucher.merchantName": "\u5546\u6237",
            "voucher.introduction.econtext": "\u611F\u8C22\u60A8\u7684\u8D2D\u4E70\uFF0C\u8BF7\u4F7F\u7528\u4EE5\u4E0B\u4FE1\u606F\u5B8C\u6210\u652F\u4ED8\u3002",
            "voucher.telephoneNumber": "\u7535\u8BDD\u53F7\u7801",
            "voucher.shopperReference": "\u987E\u5BA2\u53C2\u8003",
            "voucher.collectionInstitutionNumber": "\u6536\u6B3E\u673A\u6784\u7F16\u53F7",
            "voucher.econtext.telephoneNumber.invalid": "\u7535\u8BDD\u53F7\u7801\u5FC5\u987B\u4E3A 10 \u6216 11 \u4F4D\u6570\u5B57",
            "boletobancario.btnLabel": "\u751F\u6210 Boleto",
            "boleto.sendCopyToEmail": "\u5C06\u526F\u672C\u53D1\u9001\u5230\u6211\u7684\u7535\u5B50\u90AE\u7BB1",
            "button.copy": "\u590D\u5236",
            "button.download": "\u4E0B\u8F7D",
            "boleto.socialSecurityNumber.invalid": "\u8F93\u5165\u6709\u6548\u7684 CPF/CNPJ \u53F7\u7801",
            "creditCard.storedCard.description.ariaLabel": "\u5B58\u50A8\u7684\u5361\u7247\u4EE5 \uFF05@ \u7ED3\u5C3E",
            "voucher.entity": "\u5B9E\u4F53",
            donateButton: "\u6350\u8D60",
            notNowButton: "\u6682\u4E0D",
            thanksForYourSupport: "\u611F\u8C22\u60A8\u7684\u652F\u6301\uFF01",
            "resultMessages.preauthorized": "\u8BE6\u60C5\u5DF2\u4FDD\u5B58",
            preauthorizeWith: "\u9884\u5148\u6388\u6743",
            confirmPreauthorization: "\u786E\u8BA4\u9884\u5148\u6388\u6743",
            confirmPurchase: "\u786E\u8BA4\u8D2D\u4E70",
            applyGiftcard: "\u5151\u6362",
            giftcardBalance: "\u793C\u54C1\u5361\u4F59\u989D",
            deductedBalance: "\u6263\u51CF\u4F59\u989D",
            "creditCard.pin.title": "Pin",
            "creditCard.encryptedPassword.label": "\u5361\u7247\u5BC6\u7801\u7684\u524D 2 \u4F4D\u6570",
            "creditCard.encryptedPassword.invalid": "\u65E0\u6548\u7684\u5BC6\u7801",
            "creditCard.taxNumber": "\u6301\u5361\u4EBA\u751F\u65E5\u6216\u516C\u53F8\u6CE8\u518C\u53F7",
            "creditCard.taxNumber.label": "\u6301\u5361\u4EBA\u751F\u65E5 (YYMMDD) \u6216\u516C\u53F8\u6CE8\u518C\u53F7\uFF0810 \u4F4D\u6570\uFF09",
            "creditCard.taxNumber.labelAlt": "\u516C\u53F8\u6CE8\u518C\u53F7\uFF0810 \u4F4D\u6570\uFF09",
            "creditCard.taxNumber.invalid": "\u65E0\u6548\u7684\u6301\u5361\u4EBA\u751F\u65E5\u6216\u516C\u53F8\u6CE8\u518C\u53F7",
            "storedPaymentMethod.disable.button": "\u5220\u9664",
            "storedPaymentMethod.disable.confirmation": "\u5220\u9664\u5B58\u50A8\u7684\u652F\u4ED8\u65B9\u5F0F",
            "storedPaymentMethod.disable.confirmButton": "\u662F\uFF0C\u5220\u9664",
            "storedPaymentMethod.disable.cancelButton": "\u53D6\u6D88",
            "ach.bankAccount": "\u94F6\u884C\u8D26\u6237",
            "ach.accountHolderNameField.title": "\u8D26\u6237\u6301\u6709\u4EBA\u59D3\u540D",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "\u65E0\u6548\u7684\u8D26\u6237\u6301\u6709\u4EBA\u59D3\u540D",
            "ach.accountNumberField.title": "\u8D26\u53F7",
            "ach.accountNumberField.invalid": "\u65E0\u6548\u7684\u8D26\u53F7",
            "ach.accountLocationField.title": "ABA \u8DEF\u7531\u7535\u6C47\u7F16\u7801",
            "ach.accountLocationField.invalid": "\u65E0\u6548\u7684 ABA \u8DEF\u7531\u7535\u6C47\u7F16\u7801",
            "ach.savedBankAccount": "\u5DF2\u4FDD\u5B58\u7684\u94F6\u884C\u8D26\u6237",
            "select.state": "\u9009\u62E9\u5DDE",
            "select.stateOrProvince": "\u9009\u62E9\u5DDE\u6216\u7701",
            "select.provinceOrTerritory": "\u9009\u62E9\u7701\u6216\u5730\u533A",
            "select.country": "\u9009\u62E9\u56FD\u5BB6/\u5730\u533A",
            "select.noOptionsFound": "\u672A\u627E\u5230\u4EFB\u4F55\u9009\u9879",
            "select.filter.placeholder": "\u641C\u7D22\u2026\u2026",
            "telephoneNumber.invalid": "\u65E0\u6548\u7684\u7535\u8BDD\u53F7\u7801",
            qrCodeOrApp: "\u6216\u8005",
            "paypal.processingPayment": "\u6B63\u5728\u5904\u7406\u4ED8\u6B3E...",
            generateQRCode: "\u751F\u6210\u4E8C\u7EF4\u7801",
            "await.waitForConfirmation": "\u7B49\u5F85\u786E\u8BA4",
            "mbway.confirmPayment": "\u5728 MB WAY \u5E94\u7528\u4E0A\u786E\u8BA4\u60A8\u7684\u4ED8\u6B3E",
            "shopperEmail.invalid": "\u65E0\u6548\u7684\u90AE\u4EF6\u5730\u5740",
            "dateOfBirth.format": "DD/MM/YYYY",
            "dateOfBirth.invalid": "\u8BF7\u8F93\u5165\u6709\u6548\u51FA\u751F\u65E5\u671F\uFF0C\u8868\u660E\u60A8\u5DF2\u5E74\u6EE1 18 \u5C81",
            "blik.confirmPayment": "\u6253\u5F00\u60A8\u7684\u94F6\u884C\u5E94\u7528\u4EE5\u786E\u8BA4\u652F\u4ED8\u3002",
            "blik.invalid": "\u8F93\u5165 6 \u4F4D\u6570",
            "blik.code": "6 \u4F4D\u6570\u4EE3\u7801",
            "blik.help": "\u4ECE\u60A8\u7684\u94F6\u884C\u5E94\u7528\u4E2D\u83B7\u53D6\u4EE3\u7801\u3002",
            "swish.pendingMessage": "\u626B\u63CF\u540E\uFF0C\u72B6\u6001\u53EF\u80FD\u4F1A\u4FDD\u6301\u6700\u591A 10 \u5206\u949F\u3002\u5728\u6B64\u65F6\u95F4\u5185\u518D\u6B21\u5C1D\u8BD5\u4ED8\u6B3E\u53EF\u80FD\u4F1A\u5BFC\u81F4\u591A\u6B21\u6536\u8D39\u3002",
            "field.valid": "\u5B57\u6BB5\u6709\u6548",
            "field.invalid": "\u65E0\u6548\u5B57\u6BB5",
            "error.va.gen.01": "\u4E0D\u5B8C\u6574\u5B57\u6BB5",
            "error.va.gen.02": "\u65E0\u6548\u5B57\u6BB5",
            "error.va.sf-cc-num.01": "\u8F93\u5165\u6709\u6548\u5361\u53F7",
            "error.va.sf-cc-num.02": "\u8F93\u5165\u5361\u53F7",
            "error.va.sf-cc-num.03": "\u8F93\u5165\u652F\u6301\u7684\u5361\u7247\u54C1\u724C",
            "error.va.sf-cc-num.04": "\u8F93\u5165\u5B8C\u6574\u5361\u53F7",
            "error.va.sf-cc-dat.01": "\u8F93\u5165\u6709\u6548\u5230\u671F\u65E5",
            "error.va.sf-cc-dat.02": "\u8F93\u5165\u6709\u6548\u5230\u671F\u65E5\u671F",
            "error.va.sf-cc-dat.03": "\u4FE1\u7528\u5361\u5373\u5C06\u8FC7\u671F",
            "error.va.sf-cc-dat.04": "\u8F93\u5165\u5230\u671F\u65E5\u671F",
            "error.va.sf-cc-dat.05": "\u8F93\u5165\u5B8C\u6574\u5230\u671F\u65E5\u671F",
            "error.va.sf-cc-mth.01": "\u8F93\u5165\u5230\u671F\u6708\u4EFD",
            "error.va.sf-cc-yr.01": "\u8F93\u5165\u5230\u671F\u5E74\u4EFD",
            "error.va.sf-cc-yr.02": "\u8F93\u5165\u5B8C\u6574\u5230\u671F\u5E74\u4EFD",
            "error.va.sf-cc-cvc.01": "\u8F93\u5165\u5B89\u5168\u7801",
            "error.va.sf-cc-cvc.02": "\u8F93\u5165\u5B8C\u6574\u5B89\u5168\u7801",
            "error.va.sf-ach-num.01": "\u94F6\u884C\u8D26\u53F7\u5B57\u6BB5\u4E3A\u7A7A",
            "error.va.sf-ach-num.02": "\u94F6\u884C\u8D26\u53F7\u957F\u5EA6\u4E0D\u6B63\u786E",
            "error.va.sf-ach-loc.01": "\u94F6\u884C\u8DEF\u7531\u53F7\u7801\u5B57\u6BB5\u4E3A\u7A7A",
            "error.va.sf-ach-loc.02": "\u94F6\u884C\u8DEF\u7531\u53F7\u7801\u957F\u5EA6\u4E0D\u6B63\u786E",
            "error.va.sf-kcp-pwd.01": "\u5BC6\u7801\u5B57\u6BB5\u4E3A\u7A7A",
            "error.va.sf-kcp-pwd.02": "\u5BC6\u7801\u957F\u5EA6\u4E0D\u6B63\u786E",
            "error.giftcard.no-balance": "\u793C\u54C1\u5361\u4F59\u989D\u4E3A\u96F6",
            "error.giftcard.card-error": "\u6211\u4EEC\u7684\u6570\u636E\u5E93\u4E2D\u6CA1\u6709\u8FD9\u4E2A\u53F7\u7801\u7684\u793C\u54C1\u5361",
            "error.giftcard.currency-error": "\u793C\u54C1\u5361\u4EC5\u4EE5\u5176\u53D1\u884C\u7684\u8D27\u5E01\u4E3A\u6709\u6548\u8D27\u5E01",
            "amazonpay.signout": "\u9000\u51FA Amazon",
            "amazonpay.changePaymentDetails": "\u66F4\u6539\u652F\u4ED8\u8BE6\u60C5",
            "partialPayment.warning": "\u8BF7\u9009\u62E9\u5176\u4ED6\u652F\u4ED8\u65B9\u5F0F\u652F\u4ED8\u5269\u4F59\u6B3E\u9879",
            "partialPayment.remainingBalance": "\u5269\u4F59\u989D\u5EA6\u4E3A %{amount}",
            "bankTransfer.beneficiary": "\u6536\u6B3E\u4EBA",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "\u4E2D\u56FD\u5DE5\u5546\u94F6\u884C",
            "bankTransfer.reference": "\u53C2\u8003",
            "bankTransfer.introduction": "\u7EE7\u7EED\u65B0\u5EFA\u94F6\u884C\u8F6C\u8D26\u4ED8\u6B3E\u3002\u60A8\u53EF\u4EE5\u4F7F\u7528\u4EE5\u4E0B\u5C4F\u5E55\u4E2D\u7684\u8BE6\u7EC6\u4FE1\u606F\u6765\u5B8C\u6210\u8FD9\u7B14\u4ED8\u6B3E\u3002",
            "bankTransfer.instructions": "\u611F\u8C22\u60A8\u7684\u8D2D\u4E70\uFF0C\u8BF7\u4F7F\u7528\u4EE5\u4E0B\u4FE1\u606F\u5B8C\u6210\u652F\u4ED8\u3002",
            "bacs.accountHolderName": "\u94F6\u884C\u8D26\u6237\u6301\u6709\u4EBA\u59D3\u540D",
            "bacs.accountHolderName.invalid": "\u65E0\u6548\u7684\u94F6\u884C\u8D26\u6237\u6301\u6709\u4EBA\u59D3\u540D",
            "bacs.accountNumber": "\u94F6\u884C\u8D26\u53F7",
            "bacs.accountNumber.invalid": "\u65E0\u6548\u7684\u94F6\u884C\u8D26\u53F7",
            "bacs.bankLocationId": "\u5206\u7C7B\u4EE3\u7801",
            "bacs.bankLocationId.invalid": "\u65E0\u6548\u7684\u5206\u7C7B\u4EE3\u7801",
            "bacs.consent.amount": "\u6211\u540C\u610F\u4ECE\u94F6\u884C\u8D26\u6237\u4E2D\u6263\u9664\u4E0A\u8FF0\u91D1\u989D\u3002",
            "bacs.consent.account": "\u6211\u786E\u8BA4\u8BE5\u8D26\u6237\u4E3A\u6211\u540D\u4E0B\u7684\u8D26\u6237\uFF0C\u5E76\u4E14\u6211\u662F\u6388\u6743\u8BE5\u8D26\u6237\u76F4\u63A5\u501F\u8BB0\u7684\u552F\u4E00\u7B7E\u7F72\u4EBA\u3002",
            edit: "\u7F16\u8F91",
            "bacs.confirm": "\u786E\u8BA4\u5E76\u652F\u4ED8",
            "bacs.result.introduction": "\u4E0B\u8F7D\u60A8\u7684\u76F4\u63A5\u501F\u8BB0\u6307\u793A\uFF08DDI/\u59D4\u6258\uFF09",
            "download.pdf": "\u4E0B\u8F7D PDF \u6587\u4EF6",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "\u5361\u53F7 Iframe",
            "creditCard.encryptedCardNumber.aria.label": "\u5361\u53F7",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "\u5230\u671F\u65E5\u671F Iframe",
            "creditCard.encryptedExpiryDate.aria.label": "\u6709\u6548\u671F",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "\u5230\u671F\u6708\u4EFD Iframe",
            "creditCard.encryptedExpiryMonth.aria.label": "\u8FC7\u671F\u6708\u4EFD",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "\u5230\u671F\u5E74\u4EFD Iframe",
            "creditCard.encryptedExpiryYear.aria.label": "\u8FC7\u671F\u5E74\u4EFD",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "\u5B89\u5168\u7801 Iframe",
            "creditCard.encryptedSecurityCode.aria.label": "\u5B89\u5168\u7801",
            "creditCard.encryptedPassword.aria.iframeTitle": "\u5BC6\u7801 Iframe",
            "creditCard.encryptedPassword.aria.label": "\u5361\u7247\u5BC6\u7801\u7684\u524D 2 \u4F4D\u6570",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "\u5361\u53F7 Iframe",
            "giftcard.encryptedCardNumber.aria.label": "\u5361\u53F7",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "PIN \u7801 Iframe",
            "giftcard.encryptedSecurityCode.aria.label": "Pin",
            giftcardTransactionLimit: "\u6B64\u793C\u54C1\u5361\u4E0A\u6BCF\u7B14\u4EA4\u6613\u5141\u8BB8\u7684\u6700\u5927\u91D1\u989D\u4E3A %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "\u94F6\u884C\u8D26\u53F7 Iframe",
            "ach.encryptedBankAccountNumber.aria.label": "\u8D26\u53F7",
            "ach.encryptedBankLocationId.aria.iframeTitle": "\u94F6\u884C\u8DEF\u7531\u7535\u6C47\u7F16\u7801 Iframe",
            "ach.encryptedBankLocationId.aria.label": "ABA \u8DEF\u7531\u7535\u6C47\u7F16\u7801",
            "twint.saved": "\u5DF2\u4FDD\u5B58",
            orPayWith: "\u6216\u4F7F\u7528\u4EE5\u4E0B\u65B9\u5F0F\u652F\u4ED8",
            invalidFormatExpects: "\u65E0\u6548\u7684\u683C\u5F0F\u3002\u9884\u671F\u683C\u5F0F\uFF1A%{format}",
            "upi.qrCodeWaitingMessage": "\u4F7F\u7528\u60A8\u9996\u9009\u7684 UPI \u5E94\u7528\u626B\u63CF\u4E8C\u7EF4\u7801\u4EE5\u5B8C\u6210\u4ED8\u6B3E",
            "upi.vpaWaitingMessage": "\u6253\u5F00\u60A8\u7684 UPI \u5E94\u7528\u4EE5\u786E\u8BA4\u4ED8\u6B3E",
            "upi.modeSelection": "\u8BF7\u9009\u62E9\u60A8\u5E0C\u671B\u5982\u4F55\u4F7F\u7528 UPI\u3002",
            "onlineBanking.termsAndConditions": "\u7EE7\u7EED\uFF0C\u5373\u8868\u793A\u60A8\u540C\u610F%#\u6761\u6B3E\u548C\u7EC6\u5219%#",
            "onlineBankingPL.termsAndConditions": "\u7EE7\u7EED\u5373\u8868\u793A\u60A8\u540C\u610F Przelewy24 \u7684%#\u6761\u4F8B%#\u548C%#\u4FE1\u606F\u4E49\u52A1%#",
            "ctp.loading.poweredByCtp": "\u7531 Click to Pay \u63D0\u4F9B\u6280\u672F\u652F\u6301",
            "ctp.loading.intro": "\u6211\u4EEC\u6B63\u5728\u68C0\u67E5\u60A8\u662F\u5426\u62E5\u6709\u4EFB\u4F55\u901A\u8FC7 Click to Pay \u4FDD\u5B58\u7684\u5361\u7247\u2026",
            "ctp.login.title": "\u7EE7\u7EED\u4F7F\u7528 Click to Pay \u529F\u80FD",
            "ctp.login.subtitle": "\u8F93\u5165\u5173\u8054\u81F3 Click to Pay \u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u4EE5\u7EE7\u7EED\u3002",
            "ctp.login.inputLabel": "\u7535\u5B50\u90AE\u4EF6",
            "ctp.logout.notYou": "\u4E0D\u662F\u60A8\u672C\u4EBA\uFF1F",
            "ctp.logout.notYourCards": "\u4E0D\u662F\u60A8\u7684\u5361\uFF1F",
            "ctp.logout.notYourCard": "\u4E0D\u662F\u60A8\u7684\u5361\u7247\uFF1F",
            "ctp.logout.notYourProfile": "\u4E0D\u662F\u60A8\u7684\u4E2A\u4EBA\u8D44\u6599\uFF1F",
            "ctp.otp.fieldLabel": "\u4E00\u6B21\u6027\u4EE3\u7801",
            "ctp.otp.resendCode": "\u91CD\u65B0\u53D1\u9001\u4EE3\u7801",
            "ctp.otp.codeResent": "\u4EE3\u7801\u5DF2\u91CD\u65B0\u53D1\u9001",
            "ctp.otp.title": "\u8BBF\u95EE\u60A8\u7684 Click to Pay \u5361",
            "ctp.otp.subtitle": "\u8BF7\u8F93\u5165\u6211\u4EEC\u53D1\u9001\u81F3 %@ \u7684\u4EE3\u7801 (%@)\uFF0C\u4EE5\u9A8C\u8BC1\u662F\u60A8\u672C\u4EBA\u3002",
            "ctp.otp.saveCookiesCheckbox.label": "\u4E0B\u6B21\u8DF3\u8FC7\u9A8C\u8BC1",
            "ctp.otp.saveCookiesCheckbox.information": "\u5728\u60A8\u7684\u8BBE\u5907\u548C\u6D4F\u89C8\u5668\u4E0A\uFF0C\u5728\u53C2\u4E0E\u6D3B\u52A8\u7684\u5E97\u94FA\u4E2D\u9009\u62E9\u8BB0\u4F4F\u8BE5\u9009\u9879\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u7ED3\u8D26\u3002\u4E0D\u5EFA\u8BAE\u7528\u4E8E\u5171\u4EAB\u8BBE\u5907\u3002",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "\u9009\u62E9\u5728\u60A8\u7684\u8BBE\u5907\u548C\u6D4F\u89C8\u5668\u4E0A\u8BB0\u4F4F",
            "ctp.emptyProfile.message": "\u6B64 Click to Pay \u4E2A\u4EBA\u8D44\u6599\u4E2D\u5C1A\u672A\u6CE8\u518C\u4EFB\u4F55\u5361\u7247",
            "ctp.separatorText": "\u6216\u4F7F\u7528",
            "ctp.cards.title": "\u501F\u52A9 Click to Pay \u5B8C\u6210\u4ED8\u6B3E",
            "ctp.cards.subtitle": "\u9009\u62E9\u8981\u4F7F\u7528\u7684\u5361\u7247\u3002",
            "ctp.cards.expiredCard": "\u5DF2\u8FC7\u671F",
            "ctp.manualCardEntry": "\u624B\u52A8\u5361\u7247\u5F55\u5165",
            "ctp.aria.infoModalButton": "\u4EC0\u4E48\u662F Click to Pay",
            "ctp.infoPopup.title": "Click to Pay \u5E26\u6765\u975E\u63A5\u89E6\u5F0F\u7684\u5728\u7EBF\u4FBF\u6377\u4F53\u9A8C",
            "ctp.infoPopup.subtitle": "Mastercard\u3001Visa \u548C\u5176\u4ED6\u652F\u4ED8\u5361\u652F\u6301\u7684\u5FEB\u901F\u3001\u5B89\u5168\u7684\u652F\u4ED8\u65B9\u5F0F\u3002",
            "ctp.infoPopup.benefit1": "Click to Pay \u4F7F\u7528\u52A0\u5BC6\u6280\u672F\uFF0C\u786E\u4FDD\u60A8\u7684\u4FE1\u606F\u5B89\u5168",
            "ctp.infoPopup.benefit2": "\u4E0E\u5168\u7403\u5546\u6237\u4E00\u8D77\u4F7F\u7528",
            "ctp.infoPopup.benefit3": "\u8BBE\u7F6E\u4E00\u6B21\uFF0C\u652F\u4ED8\u65E0\u5FE7",
            "ctp.errors.AUTH_INVALID": "\u8EAB\u4EFD\u9A8C\u8BC1\u65E0\u6548",
            "ctp.errors.NOT_FOUND": "\u672A\u627E\u5230\u5E10\u6237\uFF0C\u8BF7\u8F93\u5165\u6709\u6548\u7684\u7535\u5B50\u90AE\u4EF6\u6216\u7EE7\u7EED\u4F7F\u7528\u624B\u52A8\u5361\u7247\u8F93\u5165",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "\u4E0D\u652F\u6301\u683C\u5F0F",
            "ctp.errors.FRAUD": "\u7528\u6237\u8D26\u6237\u5DF2\u9501\u5B9A\u6216\u7981\u7528",
            "ctp.errors.CONSUMER_ID_MISSING": "\u8BF7\u6C42\u4E2D\u7F3A\u5C11\u4F7F\u7528\u8005\u6807\u8BC6",
            "ctp.errors.ACCT_INACCESSIBLE": "\u6B64\u5E10\u6237\u5F53\u524D\u4E0D\u53EF\u7528\uFF08\u4F8B\u5982\uFF0C\u5DF2\u9501\u5B9A\uFF09",
            "ctp.errors.CODE_INVALID": "\u9A8C\u8BC1\u7801\u4E0D\u6B63\u786E",
            "ctp.errors.CODE_EXPIRED": "\u6B64\u4EE3\u7801\u5DF2\u8FC7\u671F",
            "ctp.errors.RETRIES_EXCEEDED": "\u5DF2\u8D85\u51FA OTP \u751F\u6210\u7684\u91CD\u8BD5\u6B21\u6570\u9650\u5236",
            "ctp.errors.OTP_SEND_FAILED": "OTP \u65E0\u6CD5\u53D1\u9001\u81F3\u6536\u4EF6\u4EBA",
            "ctp.errors.REQUEST_TIMEOUT": "\u53D1\u751F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u8BD5\u6216\u4F7F\u7528\u624B\u52A8\u5361\u7247\u8F93\u5165",
            "ctp.errors.UNKNOWN_ERROR": "\u53D1\u751F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u8BD5\u6216\u4F7F\u7528\u624B\u52A8\u5361\u7247\u8F93\u5165",
            "ctp.errors.SERVICE_ERROR": "\u53D1\u751F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u8BD5\u6216\u4F7F\u7528\u624B\u52A8\u5361\u7247\u8F93\u5165",
            "ctp.errors.SERVER_ERROR": "\u53D1\u751F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u8BD5\u6216\u4F7F\u7528\u624B\u52A8\u5361\u7247\u8F93\u5165",
            "ctp.errors.INVALID_PARAMETER": "\u53D1\u751F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u8BD5\u6216\u4F7F\u7528\u624B\u52A8\u5361\u7247\u8F93\u5165",
            "ctp.errors.AUTH_ERROR": "\u53D1\u751F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u8BD5\u6216\u4F7F\u7528\u624B\u52A8\u5361\u7247\u8F93\u5165",
            "paymentMethodsList.aria.label": "\u9009\u62E9\u652F\u4ED8\u65B9\u5F0F",
            "companyDetails.name.invalid": "\u8F93\u5165\u516C\u53F8\u540D\u79F0",
            "companyDetails.registrationNumber.invalid": "\u8F93\u5165\u6CE8\u518C\u53F7",
            "consent.checkbox.invalid": "\u60A8\u5FC5\u987B\u540C\u610F\u6761\u6B3E\u548C\u7EC6\u5219",
            "form.instruction": "\u9664\u975E\u53E6\u6709\u6807\u8BB0\uFF0C\u5426\u5219\u6240\u6709\u5B57\u6BB5\u5747\u4E3A\u5FC5\u586B\u9879\u3002",
            "trustly.descriptor": "\u5373\u65F6\u94F6\u884C\u4ED8\u6B3E",
            "trustly.description1": "\u76F4\u63A5\u4ECE\u60A8\u7684\u4EFB\u4F55\u94F6\u884C\u8D26\u6237\u4ED8\u6B3E\uFF0C\u5E76\u914D\u5907\u94F6\u884C\u7EA7\u5B89\u5168\u4FDD\u969C",
            "trustly.description2": "\u65E0\u9700\u5361\u7247\uFF0C\u65E0\u9700\u4E0B\u8F7D\u5E94\u7528\uFF0C\u65E0\u9700\u6CE8\u518C",
            "ancv.input.label": "\u60A8\u7684 ANCV \u8EAB\u4EFD\u8BC1\u660E",
            "ancv.confirmPayment": "\u4F7F\u7528\u60A8\u7684 ANCV \u5E94\u7528\u4EE5\u786E\u8BA4\u4ED8\u6B3E\u3002",
            "ancv.form.instruction": "\u8981\u9A8C\u8BC1\u8FD9\u7B14\u4ED8\u6B3E\uFF0C\u5FC5\u987B\u4F7F\u7528 Checke-Vacances \u5E94\u7528\u3002",
            "ancv.beneficiaryId.invalid": "\u8F93\u5165\u6709\u6548\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u6216 ANCV ID",
            "payme.openPayMeApp": "\u5728 PayMe \u5E94\u7528\u4E2D\u6388\u6743\u4ED8\u6B3E\u5E76\u7B49\u5F85\u786E\u8BA4\uFF0C\u5373\u53EF\u5B8C\u6210\u60A8\u5728\u8BE5\u5E94\u7528\u4E2D\u7684\u4ED8\u6B3E\u3002",
            "payme.redirectButtonLabel": "\u6253\u5F00 PayMe \u5E94\u7528",
            "payme.scanQrCode": "\u901A\u8FC7\u4E8C\u7EF4\u7801\u5B8C\u6210\u4ED8\u6B3E",
            "payme.timeToPay": "\u6B64\u4E8C\u7EF4\u7801\u6709\u6548\u671F\u4E3A %@",
            "payme.instructions.steps": "\u6253\u5F00 PayMe \u5E94\u7528\u3002%@\u626B\u63CF\u4E8C\u7EF4\u7801\u5373\u53EF\u6388\u6743\u4ED8\u6B3E\u3002%@\u5728\u5E94\u7528\u4E2D\u5B8C\u6210\u652F\u4ED8\u5E76\u7B49\u5F85\u786E\u8BA4\u3002",
            "payme.instructions.footnote": "\u4ED8\u6B3E\u5B8C\u6210\u524D\uFF0C\u8BF7\u52FF\u5173\u95ED\u6B64\u9875\u9762"
        }
    }), Q2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "\u652F\u4ED8",
            "payButton.redirecting": "\u91CD\u65B0\u5C0E\u5411\u4E2D......",
            "payButton.with": "\u7528 %{maskedData} \u652F\u4ED8 %{value}",
            "payButton.saveDetails": "\u5132\u5B58\u8A73\u7D30\u8CC7\u6599",
            close: "\u95DC\u9589",
            storeDetails: "\u5132\u5B58\u4EE5\u4F9B\u4E0B\u6B21\u4ED8\u6B3E\u4F7F\u7528",
            readMore: "\u95B1\u8B80\u5168\u6587",
            "creditCard.holderName": "\u4FE1\u7528\u5361\u4E0A\u7684\u59D3\u540D",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "\u8F38\u5165\u5361\u4E0A\u6240\u793A\u7684\u59D3\u540D",
            "creditCard.numberField.title": "\u4FE1\u7528\u5361\u865F\u78BC",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "\u5230\u671F\u65E5\u671F",
            "creditCard.expiryDateField.placeholder": "MM/YY",
            "creditCard.expiryDateField.month": "\u6708\u4EFD",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "YY",
            "creditCard.expiryDateField.year": "\u5E74\u4EFD",
            "creditCard.cvcField.title": "\u5B89\u5168\u78BC",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "\u8A18\u4F4F\u4F9B\u4E0B\u6B21\u4F7F\u7528",
            "creditCard.cvcField.placeholder.4digits": "4 \u4F4D\u6578",
            "creditCard.cvcField.placeholder.3digits": "3 \u4F4D\u6578",
            "creditCard.taxNumber.placeholder": "\u5E74\u6708\u65E5\uFF0F0123456789",
            installments: "\u5206\u671F\u4ED8\u6B3E\u7684\u671F\u6578",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} \u500B\u6708",
            "installments.oneTime": "\u4E00\u6B21\u6027\u4ED8\u6B3E",
            "installments.installments": "\u5206\u671F\u4ED8\u6B3E",
            "installments.revolving": "\u5EF6\u671F\u4ED8\u6B3E",
            "sepaDirectDebit.ibanField.invalid": "\u5E33\u6236\u865F\u78BC\u7121\u6548",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "\u6301\u6709\u4EBA\u540D\u7A31",
            "sepa.ibanNumber": "\u5E33\u6236\u865F\u78BC (IBAN)",
            "error.title": "\u932F\u8AA4",
            "error.subtitle.redirect": "\u7121\u6CD5\u91CD\u65B0\u5C0E\u5411",
            "error.subtitle.payment": "\u4ED8\u6B3E\u5931\u6557",
            "error.subtitle.refused": "\u4ED8\u6B3E\u906D\u62D2\u7D55",
            "error.message.unknown": "\u767C\u751F\u672A\u77E5\u932F\u8AA4",
            "errorPanel.title": "\u73FE\u6709\u932F\u8AA4",
            "idealIssuer.selectField.title": "\u9280\u884C",
            "idealIssuer.selectField.placeholder": "\u9078\u53D6\u60A8\u7684\u9280\u884C",
            "creditCard.success": "\u4ED8\u6B3E\u6210\u529F",
            loading: "\u6B63\u5728\u8F09\u5165...",
            continue: "\u7E7C\u7E8C",
            continueTo: "\u7E7C\u7E8C\u524D\u5F80",
            "wechatpay.timetopay": "\u60A8\u6709 %@ \u53EF\u4EE5\u652F\u4ED8",
            "sr.wechatpay.timetopay": "\u60A8\u4ED8\u6B3E\u7684\u6642\u9593\u9084\u5269 %#\u5206%# %#\u79D2%#",
            "wechatpay.scanqrcode": "\u6383\u63CF QR \u4EE3\u78BC",
            personalDetails: "\u500B\u4EBA\u8A73\u7D30\u8CC7\u6599",
            companyDetails: "\u516C\u53F8\u8A73\u60C5",
            "companyDetails.name": "\u516C\u53F8\u540D\u7A31",
            "companyDetails.registrationNumber": "\u8A3B\u518A\u865F\u78BC",
            socialSecurityNumber: "\u793E\u6703\u5B89\u5168\u78BC",
            firstName: "\u540D\u5B57",
            "firstName.invalid": "\u8F38\u5165\u60A8\u7684\u540D\u5B57",
            infix: "\u524D\u7DB4",
            lastName: "\u59D3\u6C0F",
            "lastName.invalid": "\u8F38\u5165\u60A8\u7684\u59D3\u6C0F",
            mobileNumber: "\u884C\u52D5\u96FB\u8A71\u865F\u78BC",
            "mobileNumber.invalid": "\u624B\u6A5F\u865F\u78BC\u7121\u6548",
            city: "\u57CE\u5E02",
            postalCode: "\u90F5\u905E\u5340\u865F",
            "postalCode.optional": "\u90F5\u905E\u5340\u865F\uFF08\u9078\u7528\uFF09",
            countryCode: "\u570B\u5BB6\u4EE3\u78BC",
            telephoneNumber: "\u96FB\u8A71\u865F\u78BC",
            dateOfBirth: "\u51FA\u751F\u65E5\u671F",
            shopperEmail: "\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
            gender: "\u6027\u5225",
            "gender.notselected": "\u9078\u64C7\u60A8\u7684\u6027\u5225",
            male: "\u7537",
            female: "\u5973",
            billingAddress: "\u5E33\u55AE\u5730\u5740",
            street: "\u8857\u9053",
            stateOrProvince: "\u5DDE/\u7E23/\u5E02",
            country: "\u570B\u5BB6\uFF0F\u5730\u5340",
            houseNumberOrName: "\u9580\u724C\u865F",
            separateDeliveryAddress: "\u6307\u5B9A\u53E6\u4E00\u500B\u6D3E\u9001\u5730\u5740",
            deliveryAddress: "\u6D3E\u9001\u5730\u5740",
            "deliveryAddress.firstName": "\u6536\u4EF6\u8005\u540D\u5B57",
            "deliveryAddress.lastName": "\u6536\u4EF6\u8005\u59D3\u6C0F",
            zipCode: "\u90F5\u905E\u5340\u865F",
            apartmentSuite: "\u516C\u5BD3\uFF0F\u5957\u623F",
            provinceOrTerritory: "\u7701\u6216\u5730\u5340",
            cityTown: "\u5E02\uFF0F\u93AE",
            address: "\u5730\u5740",
            "address.placeholder": "\u67E5\u627E\u60A8\u7684\u5730\u5740",
            "address.errors.incomplete": "\u8F38\u5165\u5730\u5740\u4EE5\u7E7C\u7E8C",
            "address.enterManually": "\u624B\u52D5\u8F38\u5165\u5730\u5740",
            state: "\u5DDE",
            "field.title.optional": "\uFF08\u9078\u7528\uFF09",
            "creditCard.cvcField.title.optional": "\u5B89\u5168\u78BC\uFF08\u9078\u586B\uFF09",
            "issuerList.wallet.placeholder": "\u9078\u53D6\u60A8\u7684\u96FB\u5B50\u9322\u5305",
            privacyPolicy: "\u96B1\u79C1\u6B0A\u653F\u7B56",
            "afterPay.agreement": "\u6211\u540C\u610F Riverty \u7684%@",
            paymentConditions: "\u4ED8\u6B3E\u7D30\u5247",
            openApp: "\u958B\u555F\u61C9\u7528\u7A0B\u5F0F",
            "voucher.readInstructions": "\u95B1\u89BD\u8AAA\u660E",
            "voucher.introduction": "\u591A\u8B1D\u60E0\u9867\uFF0C\u8ACB\u4F7F\u7528\u4EE5\u4E0B\u512A\u60E0\u5238\u5B8C\u6210\u4ED8\u6B3E\u3002",
            "voucher.expirationDate": "\u5230\u671F\u65E5\u671F",
            "voucher.alternativeReference": "\u5099\u9078\u53C3\u7167",
            "dragonpay.voucher.non.bank.selectField.placeholder": "\u9078\u64C7\u60A8\u7684\u4F9B\u61C9\u5546",
            "dragonpay.voucher.bank.selectField.placeholder": "\u9078\u53D6\u60A8\u7684\u9280\u884C",
            "voucher.paymentReferenceLabel": "\u4ED8\u6B3E\u53C3\u7167\u865F\u78BC",
            "voucher.surcharge": "\u5305\u542B %@ \u9644\u52A0\u8CBB",
            "voucher.introduction.doku": "\u591A\u8B1D\u60E0\u9867\uFF0C\u8ACB\u4F7F\u7528\u4EE5\u4E0B\u8CC7\u8A0A\u5B8C\u6210\u4ED8\u6B3E\u3002",
            "voucher.shopperName": "\u8CFC\u7269\u8005\u59D3\u540D",
            "voucher.merchantName": "\u5546\u5BB6",
            "voucher.introduction.econtext": "\u591A\u8B1D\u60E0\u9867\uFF0C\u8ACB\u4F7F\u7528\u4EE5\u4E0B\u8CC7\u8A0A\u5B8C\u6210\u4ED8\u6B3E\u3002",
            "voucher.telephoneNumber": "\u96FB\u8A71\u865F\u78BC",
            "voucher.shopperReference": "\u8CFC\u7269\u8005\u53C3\u8003",
            "voucher.collectionInstitutionNumber": "\u6536\u6B3E\u6A5F\u69CB\u7DE8\u865F",
            "voucher.econtext.telephoneNumber.invalid": "\u96FB\u8A71\u865F\u78BC\u7684\u9577\u5EA6\u5FC5\u9808\u70BA 10 \u6216 11 \u4F4D\u6578",
            "boletobancario.btnLabel": "\u7522\u751F Boleto",
            "boleto.sendCopyToEmail": "\u5C07\u8907\u672C\u50B3\u9001\u81F3\u6211\u7684\u96FB\u5B50\u90F5\u4EF6",
            "button.copy": "\u8907\u88FD",
            "button.download": "\u4E0B\u8F09",
            "boleto.socialSecurityNumber.invalid": "\u8F38\u5165\u6709\u6548\u7684 CPF/CNPJ \u865F\u78BC",
            "creditCard.storedCard.description.ariaLabel": "\u5DF2\u5132\u5B58\u4EE5 %@ \u7D50\u5C3E\u7684\u4FE1\u7528\u5361",
            "voucher.entity": "\u5BE6\u9AD4",
            donateButton: "\u6350\u8D08",
            notNowButton: "\u7A0D\u5F8C\u518D\u8AAA",
            thanksForYourSupport: "\u611F\u8B1D\u60A8\u7684\u652F\u6301\uFF01",
            "resultMessages.preauthorized": "\u5DF2\u5132\u5B58\u8A73\u7D30\u8CC7\u6599",
            preauthorizeWith: "\u900F\u904E\u4EE5\u4E0B\u65B9\u5F0F\u9032\u884C\u9810\u5148\u6388\u6B0A\uFF1A",
            confirmPreauthorization: "\u78BA\u8A8D\u9810\u5148\u6388\u6B0A",
            confirmPurchase: "\u78BA\u8A8D\u8CFC\u8CB7",
            applyGiftcard: "\u514C\u63DB",
            giftcardBalance: "\u79AE\u54C1\u5361\u9918\u984D",
            deductedBalance: "\u6263\u9664\u9918\u984D",
            "creditCard.pin.title": "\u6578\u5B57\u5BC6\u78BC",
            "creditCard.encryptedPassword.label": "\u5361\u5BC6\u78BC\u7684\u524D 2 \u4F4D\u6578\u5B57",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "\u5BC6\u78BC\u7121\u6548",
            "creditCard.taxNumber": "\u6301\u5361\u4EBA\u751F\u65E5\u6216\u516C\u53F8\u8A3B\u518A\u865F\u78BC",
            "creditCard.taxNumber.label": "\u6301\u5361\u4EBA\u751F\u65E5\uFF08\u5E74\u6708\u65E5\uFF09\u6216\u516C\u53F8\u8A3B\u518A\u865F\u78BC\uFF0810 \u4F4D\u6578\uFF09",
            "creditCard.taxNumber.labelAlt": "\u516C\u53F8\u8A3B\u518A\u865F\u78BC\uFF0810 \u4F4D\u6578\uFF09",
            "creditCard.taxNumber.invalid": "\u6301\u5361\u4EBA\u751F\u65E5\u6216\u516C\u53F8\u8A3B\u518A\u865F\u78BC\u7121\u6548",
            "storedPaymentMethod.disable.button": "\u79FB\u9664",
            "storedPaymentMethod.disable.confirmation": "\u79FB\u9664\u5DF2\u5132\u5B58\u4ED8\u6B3E\u65B9\u5F0F",
            "storedPaymentMethod.disable.confirmButton": "\u662F\uFF0C\u8ACB\u79FB\u9664",
            "storedPaymentMethod.disable.cancelButton": "\u53D6\u6D88",
            "ach.bankAccount": "\u9280\u884C\u5E33\u6236",
            "ach.accountHolderNameField.title": "\u5E33\u6236\u6301\u6709\u4EBA\u59D3\u540D",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "\u5E33\u6236\u6301\u6709\u4EBA\u59D3\u540D\u7121\u6548",
            "ach.accountNumberField.title": "\u5E33\u6236\u865F\u78BC",
            "ach.accountNumberField.invalid": "\u5E33\u6236\u865F\u78BC\u7121\u6548",
            "ach.accountLocationField.title": "ABA \u532F\u6B3E\u8DEF\u5F91\u7DE8\u865F",
            "ach.accountLocationField.invalid": "ABA \u532F\u6B3E\u8DEF\u5F91\u7DE8\u865F\u7121\u6548",
            "ach.savedBankAccount": "\u5132\u5B58\u7684\u9280\u884C\u5E33\u6236",
            "select.state": "\u9078\u53D6\u5DDE",
            "select.stateOrProvince": "\u9078\u64C7\u5DDE\u6216\u7701",
            "select.provinceOrTerritory": "\u9078\u53D6\u7701\u6216\u5730\u5340",
            "select.country": "\u9078\u53D6\u570B\u5BB6\uFF0F\u5730\u5340",
            "select.noOptionsFound": "\u627E\u4E0D\u5230\u4EFB\u4F55\u9078\u9805",
            "select.filter.placeholder": "\u641C\u5C0B\u2026\u2026",
            "telephoneNumber.invalid": "\u96FB\u8A71\u865F\u78BC\u7121\u6548",
            qrCodeOrApp: "\u6216",
            "paypal.processingPayment": "\u6B63\u5728\u8655\u7406\u4ED8\u6B3E\u2026\u2026",
            generateQRCode: "\u7522\u751F QR \u4EE3\u78BC",
            "await.waitForConfirmation": "\u6B63\u5728\u7B49\u5019\u78BA\u8A8D",
            "mbway.confirmPayment": "\u5728 MB WAY \u61C9\u7528\u7A0B\u5F0F\u4E0A\u78BA\u8A8D\u60A8\u7684\u4ED8\u6B3E",
            "shopperEmail.invalid": "\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u7121\u6548",
            "dateOfBirth.format": "\u65E5\uFF0F\u6708\uFF0F\u5E74",
            "dateOfBirth.invalid": "\u8F38\u5165\u8868\u660E\u60A8\u81F3\u5C11\u5E74\u6EFF 18 \u6B72\u7684\u6709\u6548\u51FA\u751F\u65E5\u671F",
            "blik.confirmPayment": "\u958B\u555F\u60A8\u7684\u9280\u884C\u61C9\u7528\u7A0B\u5F0F\u4EE5\u78BA\u8A8D\u4ED8\u6B3E\u3002",
            "blik.invalid": "\u8F38\u5165 6 \u500B\u6578\u5B57",
            "blik.code": "6 \u4F4D\u6578\u4EE3\u78BC",
            "blik.help": "\u5F9E\u60A8\u7684\u9280\u884C\u61C9\u7528\u7A0B\u5F0F\u4E2D\u7372\u53D6\u4EE3\u78BC\u3002",
            "swish.pendingMessage": "\u6383\u63CF\u5F8C\uFF0C\u8A72\u5F85\u5B8C\u6210\u72C0\u614B\u53EF\u80FD\u6301\u7E8C\u9577\u9054 10 \u5206\u9418\u3002\u8A66\u5716\u5728\u9019\u6BB5\u6642\u9593\u5167\u518D\u6B21\u4ED8\u6B3E\u53EF\u80FD\u6703\u5C0E\u81F4\u591A\u91CD\u6536\u8CBB\u3002",
            "field.valid": "\u6B04\u4F4D\u6709\u6548",
            "field.invalid": "\u6B04\u4F4D\u7121\u6548",
            "error.va.gen.01": "\u4E0D\u5B8C\u6574\u6B04\u4F4D",
            "error.va.gen.02": "\u6B04\u4F4D\u7121\u6548",
            "error.va.sf-cc-num.01": "\u8ACB\u8F38\u5165\u6709\u6548\u7684\u5361\u865F",
            "error.va.sf-cc-num.02": "\u8F38\u5165\u5361\u865F",
            "error.va.sf-cc-num.03": "\u8F38\u5165\u652F\u63F4\u7684\u5361\u54C1\u724C",
            "error.va.sf-cc-num.04": "\u8F38\u5165\u5B8C\u6574\u7684\u5361\u865F",
            "error.va.sf-cc-dat.01": "\u8F38\u5165\u6709\u6548\u7684\u5230\u671F\u65E5",
            "error.va.sf-cc-dat.02": "\u8F38\u5165\u6709\u6548\u7684\u5230\u671F\u65E5",
            "error.va.sf-cc-dat.03": "\u4FE1\u7528\u5361\u5373\u5C07\u5230\u671F",
            "error.va.sf-cc-dat.04": "\u8F38\u5165\u5230\u671F\u65E5",
            "error.va.sf-cc-dat.05": "\u8F38\u5165\u5B8C\u6574\u7684\u5230\u671F\u65E5",
            "error.va.sf-cc-mth.01": "\u8F38\u5165\u5230\u671F\u6708\u4EFD",
            "error.va.sf-cc-yr.01": "\u8F38\u5165\u5230\u671F\u5E74\u4EFD",
            "error.va.sf-cc-yr.02": "\u8F38\u5165\u5B8C\u6574\u7684\u5230\u671F\u5E74\u4EFD",
            "error.va.sf-cc-cvc.01": "\u8F38\u5165\u5B89\u5168\u78BC",
            "error.va.sf-cc-cvc.02": "\u8F38\u5165\u5B8C\u6574\u7684\u5B89\u5168\u78BC",
            "error.va.sf-ach-num.01": "\u9280\u884C\u5E33\u6236\u865F\u78BC\u6B04\u4F4D\u73FE\u70BA\u7A7A\u767D",
            "error.va.sf-ach-num.02": "\u9280\u884C\u5E33\u6236\u865F\u78BC\u9577\u5EA6\u6709\u8AA4",
            "error.va.sf-ach-loc.01": "\u9280\u884C\u532F\u6B3E\u8DEF\u5F91\u7DE8\u865F\u6B04\u4F4D\u73FE\u70BA\u7A7A\u767D",
            "error.va.sf-ach-loc.02": "\u9280\u884C\u532F\u6B3E\u8DEF\u5F91\u7DE8\u865F\u9577\u5EA6\u6709\u8AA4",
            "error.va.sf-kcp-pwd.01": "\u5BC6\u78BC\u6B04\u4F4D\u73FE\u70BA\u7A7A\u767D",
            "error.va.sf-kcp-pwd.02": "\u5BC6\u78BC\u9577\u5EA6\u6709\u8AA4",
            "error.giftcard.no-balance": "\u6B64\u79AE\u54C1\u5361\u7684\u9918\u984D\u70BA\u96F6",
            "error.giftcard.card-error": "\u6211\u5011\u7684\u8A18\u9304\u4E2D\u4E26\u6C92\u6709\u9019\u500B\u865F\u78BC\u7684\u79AE\u54C1\u5361",
            "error.giftcard.currency-error": "\u79AE\u54C1\u5361\u53EA\u80FD\u4EE5\u5176\u7C3D\u767C\u6642\u6240\u4F7F\u7528\u7684\u8CA8\u5E63\u9032\u884C\u7D50\u7B97",
            "amazonpay.signout": "\u5F9E Amazon \u767B\u51FA",
            "amazonpay.changePaymentDetails": "\u8B8A\u66F4\u4ED8\u6B3E\u660E\u7D30",
            "partialPayment.warning": "\u9078\u53D6\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u4F86\u652F\u4ED8\u9918\u984D",
            "partialPayment.remainingBalance": "\u9918\u984D\u5C07\u70BA %{amount}",
            "bankTransfer.beneficiary": "\u53D7\u6B3E\u4EBA",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "\u53C3\u7167",
            "bankTransfer.introduction": "\u7E7C\u7E8C\u5EFA\u7ACB\u65B0\u7684\u9280\u884C\u8F49\u5E33\u4ED8\u6B3E\u3002\u60A8\u53EF\u4EE5\u4F7F\u7528\u4EE5\u4E0B\u87A2\u5E55\u4E2D\u7684\u8A73\u7D30\u8CC7\u8A0A\u4F86\u5B8C\u6210\u6B64\u9805\u4ED8\u6B3E\u3002",
            "bankTransfer.instructions": "\u591A\u8B1D\u60E0\u9867\uFF0C\u8ACB\u4F7F\u7528\u4EE5\u4E0B\u8CC7\u8A0A\u5B8C\u6210\u4ED8\u6B3E\u3002",
            "bacs.accountHolderName": "\u9280\u884C\u5E33\u6236\u6301\u6709\u4EBA\u59D3\u540D",
            "bacs.accountHolderName.invalid": "\u9280\u884C\u5E33\u6236\u6301\u6709\u4EBA\u59D3\u540D\u7121\u6548",
            "bacs.accountNumber": "\u9280\u884C\u5E33\u6236\u865F\u78BC",
            "bacs.accountNumber.invalid": "\u9280\u884C\u5E33\u6236\u865F\u78BC\u7121\u6548",
            "bacs.bankLocationId": "\u9280\u884C\u4EE3\u78BC",
            "bacs.bankLocationId.invalid": "\u9280\u884C\u4EE3\u78BC\u7121\u6548",
            "bacs.consent.amount": "\u6211\u540C\u610F\u5F9E\u6211\u7684\u9280\u884C\u5E33\u6236\u6263\u9664\u4E0A\u8FF0\u91D1\u984D\u3002",
            "bacs.consent.account": "\u6211\u78BA\u8A8D\u8A72\u5E33\u6236\u4EE5\u6211\u7684\u540D\u7FA9\u958B\u8A2D\uFF0C\u4E26\u4E14\u6211\u662F\u6388\u6B0A\u5F9E\u8A72\u5E33\u6236\u76F4\u63A5\u6263\u6B3E\u7684\u552F\u4E00\u7C3D\u7F72\u4EBA\u3002",
            edit: "\u7DE8\u8F2F",
            "bacs.confirm": "\u78BA\u8A8D\u4E26\u652F\u4ED8",
            "bacs.result.introduction": "\u4E0B\u8F09\u60A8\u7684\u76F4\u63A5\u6263\u6B3E\u6307\u793A\uFF08DDI\uFF0F\u6388\u6B0A\uFF09",
            "download.pdf": "\u4E0B\u8F09 PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "\u5361\u865F\u7684 IFrame",
            "creditCard.encryptedCardNumber.aria.label": "\u4FE1\u7528\u5361\u865F\u78BC",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "\u5230\u671F\u65E5\u7684 IFrame",
            "creditCard.encryptedExpiryDate.aria.label": "\u5230\u671F\u65E5\u671F",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "\u5230\u671F\u6708\u4EFD\u7684 IFrame",
            "creditCard.encryptedExpiryMonth.aria.label": "\u5230\u671F\u6708\u4EFD",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "\u5230\u671F\u5E74\u4EFD\u7684 IFrame",
            "creditCard.encryptedExpiryYear.aria.label": "\u5230\u671F\u5E74\u4EFD",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "\u5B89\u5168\u78BC\u7684 IFrame",
            "creditCard.encryptedSecurityCode.aria.label": "\u5B89\u5168\u78BC",
            "creditCard.encryptedPassword.aria.iframeTitle": "\u5BC6\u78BC\u7684 IFrame",
            "creditCard.encryptedPassword.aria.label": "\u5361\u5BC6\u78BC\u7684\u524D 2 \u4F4D\u6578\u5B57",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "\u5361\u865F\u7684 IFrame",
            "giftcard.encryptedCardNumber.aria.label": "\u4FE1\u7528\u5361\u865F\u78BC",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "PIN \u78BC\u7684 IFrame",
            "giftcard.encryptedSecurityCode.aria.label": "\u6578\u5B57\u5BC6\u78BC",
            giftcardTransactionLimit: "\u6B64\u79AE\u54C1\u5361\u6BCF\u7B46\u4EA4\u6613\u7684\u91D1\u984D\u4E0A\u9650\u70BA %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "\u9280\u884C\u5E33\u6236\u865F\u78BC\u7684 IFrame",
            "ach.encryptedBankAccountNumber.aria.label": "\u5E33\u6236\u865F\u78BC",
            "ach.encryptedBankLocationId.aria.iframeTitle": "\u9280\u884C\u532F\u6B3E\u8DEF\u5F91\u7DE8\u865F\u7684 IFrame",
            "ach.encryptedBankLocationId.aria.label": "ABA \u532F\u6B3E\u8DEF\u5F91\u7DE8\u865F",
            "twint.saved": "\u5132\u5B58\u7684",
            orPayWith: "\u6216\u900F\u904E\u4EE5\u4E0B\u65B9\u5F0F\u652F\u4ED8\uFF1A",
            invalidFormatExpects: "\u683C\u5F0F\u7121\u6548\u3002\u683C\u5F0F\u5FC5\u9808\u70BA\uFF1A%{format}",
            "upi.qrCodeWaitingMessage": "\u4F7F\u7528\u60A8\u504F\u597D\u7684 UPI \u61C9\u7528\u7A0B\u5F0F\u6383\u63CF QR \u4EE3\u78BC\u4EE5\u5B8C\u6210\u4ED8\u6B3E",
            "upi.vpaWaitingMessage": "\u958B\u555F\u60A8\u7684 UPI \u61C9\u7528\u7A0B\u5F0F\u4EE5\u78BA\u8A8D\u4ED8\u6B3E",
            "upi.modeSelection": "\u9078\u64C7\u6240\u9700\u7684 UPI \u4F7F\u7528\u65B9\u5F0F\u3002",
            "onlineBanking.termsAndConditions": "\u7E7C\u7E8C\u64CD\u4F5C\u5373\u8868\u793A\u60A8\u540C\u610F%#\u689D\u6B3E\u53CA\u7D30\u5247%#",
            "onlineBankingPL.termsAndConditions": "\u7E7C\u7E8C\u64CD\u4F5C\u5373\u8868\u793A\u60A8\u540C\u610F Przelewy24 \u7684%#\u6CD5\u898F%#\u548C%#\u8CC7\u8A0A\u8CAC\u4EFB%#",
            "ctp.loading.poweredByCtp": "\u7531 Click to Pay \u63D0\u4F9B\u6280\u8853\u652F\u63F4",
            "ctp.loading.intro": "\u6211\u5011\u6B63\u5728\u6AA2\u67E5\u60A8\u662F\u5426\u6709\u4EFB\u4F55\u4F9B Click to Pay \u4F7F\u7528\u7684\u5DF2\u5132\u5B58\u5361\u2026\u2026",
            "ctp.login.title": "\u7E7C\u7E8C\u4F7F\u7528 Click to Pay",
            "ctp.login.subtitle": "\u8F38\u5165\u9023\u63A5\u5230 Click to Pay \u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u4EE5\u7E7C\u7E8C\u3002",
            "ctp.login.inputLabel": "\u96FB\u5B50\u90F5\u4EF6",
            "ctp.logout.notYou": "\u4E0D\u662F\u60A8\u672C\u4EBA\uFF1F",
            "ctp.logout.notYourCards": "\u4E0D\u662F\u60A8\u7684\u5361\uFF1F",
            "ctp.logout.notYourCard": "\u4E0D\u662F\u60A8\u7684\u5361\uFF1F",
            "ctp.logout.notYourProfile": "\u4E0D\u662F\u60A8\u7684\u500B\u4EBA\u8CC7\u6599\uFF1F",
            "ctp.otp.fieldLabel": "\u4E00\u6B21\u6027\u9A57\u8B49\u78BC",
            "ctp.otp.resendCode": "\u91CD\u65B0\u50B3\u9001\u9A57\u8B49\u78BC",
            "ctp.otp.codeResent": "\u5DF2\u91CD\u65B0\u50B3\u9001\u9A57\u8B49\u78BC",
            "ctp.otp.title": "\u5B58\u53D6\u60A8\u7684 Click to Pay \u5361",
            "ctp.otp.subtitle": "\u8ACB\u8F38\u5165\u6211\u5011\u50B3\u9001\u81F3 %@ \u7684\u9A57\u8B49\u78BC %@\uFF0C\u4EE5\u9A57\u8B49\u662F\u60A8\u672C\u4EBA\u3002",
            "ctp.otp.saveCookiesCheckbox.label": "\u4E0B\u6B21\u7565\u904E\u9A57\u8B49",
            "ctp.otp.saveCookiesCheckbox.information": "\u9078\u64C7\u5728\u88DD\u7F6E\u548C\u700F\u89BD\u5668\u4E2D\u8A18\u4F4F\u53C3\u8207\u5546\u5E97\u7684\u9A57\u8B49\u8CC7\u8A0A\uFF0C\u4EE5\u52A0\u5FEB\u7D50\u5E33\u901F\u5EA6\u3002\u4E0D\u5EFA\u8B70\u5728\u5171\u4EAB\u88DD\u7F6E\u4E0A\u9078\u53D6\u8A72\u8A2D\u5B9A\u3002",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "\u9078\u64C7\u5728\u88DD\u7F6E\u548C\u700F\u89BD\u5668\u4E2D\u8A18\u4F4F",
            "ctp.emptyProfile.message": "\u6B64 Click to Pay \u500B\u4EBA\u8CC7\u6599\u4E2D\u672A\u8A3B\u518A\u4EFB\u4F55\u5361",
            "ctp.separatorText": "\u6216\u4F7F\u7528",
            "ctp.cards.title": "\u4F7F\u7528 Click to Pay \u5B8C\u6210\u4ED8\u6B3E",
            "ctp.cards.subtitle": "\u9078\u53D6\u8981\u4F7F\u7528\u7684\u5361\u3002",
            "ctp.cards.expiredCard": "\u5DF2\u904E\u671F",
            "ctp.manualCardEntry": "\u624B\u52D5\u5361\u8F38\u5165",
            "ctp.aria.infoModalButton": "\u4EC0\u9EBC\u662F Click to Pay",
            "ctp.infoPopup.title": "Click to Pay \u63D0\u4F9B\u4FBF\u6377\u7684\u7DDA\u4E0A\u975E\u63A5\u89F8\u5F0F\u652F\u4ED8\u65B9\u5F0F",
            "ctp.infoPopup.subtitle": "Mastercard\u3001Visa \u548C\u5176\u4ED6\u652F\u4ED8\u5361\u652F\u63F4\u7684\u5B89\u5168\u5FEB\u6377\u652F\u4ED8\u65B9\u5F0F\u3002",
            "ctp.infoPopup.benefit1": "Click to Pay \u4F7F\u7528\u52A0\u5BC6\u6280\u8853\uFF0C\u78BA\u4FDD\u60A8\u7684\u8CC7\u6599\u5B89\u5168\u7121\u865E",
            "ctp.infoPopup.benefit2": "\u8207\u5168\u7403\u5546\u5BB6\u4E00\u8D77\u4F7F\u7528",
            "ctp.infoPopup.benefit3": "\u53EA\u9700\u8A2D\u5B9A\u4E00\u6B21\uFF0C\u5373\u53EF\u8F15\u9B06\u652F\u4ED8",
            "ctp.errors.AUTH_INVALID": "\u9A57\u8B49\u7121\u6548",
            "ctp.errors.NOT_FOUND": "\u627E\u4E0D\u5230\u5E33\u6236\uFF0C\u8ACB\u8F38\u5165\u6709\u6548\u7684\u96FB\u5B50\u90F5\u4EF6\u6216\u7E7C\u7E8C\u624B\u52D5\u8F38\u5165\u5361\u8CC7\u6599",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "\u4E0D\u652F\u63F4\u6B64\u683C\u5F0F",
            "ctp.errors.FRAUD": "\u4F7F\u7528\u8005\u5E33\u6236\u5DF2\u9396\u5B9A\u6216\u505C\u7528",
            "ctp.errors.CONSUMER_ID_MISSING": "\u8ACB\u6C42\u4E2D\u907A\u6F0F\u53D6\u7528\u8005\u8EAB\u4EFD\u8B58\u5225",
            "ctp.errors.ACCT_INACCESSIBLE": "\u76EE\u524D\u7121\u6CD5\u4F7F\u7528\u6B64\u5E33\u6236\uFF0C\u4F8B\u5982\u5DF2\u9396\u5B9A",
            "ctp.errors.CODE_INVALID": "\u9A57\u8B49\u78BC\u6709\u8AA4",
            "ctp.errors.CODE_EXPIRED": "\u6B64\u9A57\u8B49\u78BC\u5DF2\u904E\u671F",
            "ctp.errors.RETRIES_EXCEEDED": "\u8D85\u51FA\u4E86\u7522\u751F OTP \u7684\u91CD\u8A66\u6B21\u6578\u4E0A\u9650",
            "ctp.errors.OTP_SEND_FAILED": "OTP \u7121\u6CD5\u50B3\u9001\u7D66\u6536\u4EF6\u8005",
            "ctp.errors.REQUEST_TIMEOUT": "\u51FA\u4E86\u4E00\u4E9B\u554F\u984C\uFF0C\u8ACB\u91CD\u8A66\u6216\u624B\u52D5\u8F38\u5165\u5361\u8CC7\u6599",
            "ctp.errors.UNKNOWN_ERROR": "\u51FA\u4E86\u4E00\u4E9B\u554F\u984C\uFF0C\u8ACB\u91CD\u8A66\u6216\u624B\u52D5\u8F38\u5165\u5361\u8CC7\u6599",
            "ctp.errors.SERVICE_ERROR": "\u51FA\u4E86\u4E00\u4E9B\u554F\u984C\uFF0C\u8ACB\u91CD\u8A66\u6216\u624B\u52D5\u8F38\u5165\u5361\u8CC7\u6599",
            "ctp.errors.SERVER_ERROR": "\u51FA\u4E86\u4E00\u4E9B\u554F\u984C\uFF0C\u8ACB\u91CD\u8A66\u6216\u624B\u52D5\u8F38\u5165\u5361\u8CC7\u6599",
            "ctp.errors.INVALID_PARAMETER": "\u51FA\u4E86\u4E00\u4E9B\u554F\u984C\uFF0C\u8ACB\u91CD\u8A66\u6216\u624B\u52D5\u8F38\u5165\u5361\u8CC7\u6599",
            "ctp.errors.AUTH_ERROR": "\u51FA\u4E86\u4E00\u4E9B\u554F\u984C\uFF0C\u8ACB\u91CD\u8A66\u6216\u624B\u52D5\u8F38\u5165\u5361\u8CC7\u6599",
            "paymentMethodsList.aria.label": "\u9078\u64C7\u4ED8\u6B3E\u65B9\u5F0F",
            "companyDetails.name.invalid": "\u8F38\u5165\u516C\u53F8\u540D\u7A31",
            "companyDetails.registrationNumber.invalid": "\u8F38\u5165\u8A3B\u518A\u865F\u78BC",
            "consent.checkbox.invalid": "\u60A8\u5FC5\u9808\u540C\u610F\u76F8\u95DC\u689D\u6B3E\u53CA\u7D30\u5247",
            "form.instruction": "\u9664\u975E\u53E6\u6709\u6A19\u793A\uFF0C\u5426\u5247\u5FC5\u9808\u586B\u5BEB\u6240\u6709\u6B04\u4F4D\u3002",
            "trustly.descriptor": "\u5373\u6642\u9280\u884C\u4ED8\u6B3E",
            "trustly.description1": "\u76F4\u63A5\u5F9E\u4EFB\u4F55\u9280\u884C\u5E33\u6236\u4ED8\u6B3E\uFF0C\u4E26\u7372\u5F97\u9280\u884C\u7D1A\u5225\u5B89\u5168\u4FDD\u969C",
            "trustly.description2": "\u7121\u9700\u5361\uFF0C\u7121\u9700\u4E0B\u8F09\u61C9\u7528\u7A0B\u5F0F\uFF0C\u7121\u9700\u8A3B\u518A",
            "ancv.input.label": "\u60A8\u7684 ANCV \u8EAB\u5206\u8B58\u5225",
            "ancv.confirmPayment": "\u4F7F\u7528\u60A8\u7684 ANCV \u61C9\u7528\u7A0B\u5F0F\u78BA\u8A8D\u4ED8\u6B3E\u3002",
            "ancv.form.instruction": "\u5FC5\u9808\u7533\u8ACB Cheque-Vacances \u624D\u80FD\u9A57\u8B49\u6B64\u4ED8\u6B3E\u3002",
            "ancv.beneficiaryId.invalid": "\u8F38\u5165\u6709\u6548\u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u6216 ANCV ID",
            "payme.openPayMeApp": "\u5728 PayMe \u61C9\u7528\u7A0B\u5F0F\u4E2D\u6388\u6B0A\u4ED8\u6B3E\uFF0C\u5B8C\u6210\u4ED8\u6B3E\u4E26\u7B49\u5F85\u78BA\u8A8D\u3002",
            "payme.redirectButtonLabel": "\u958B\u555F PayMe \u61C9\u7528\u7A0B\u5F0F",
            "payme.scanQrCode": "\u4F7F\u7528 QR \u4EE3\u78BC\u5B8C\u6210\u4ED8\u6B3E",
            "payme.timeToPay": "\u6B64 QR \u4EE3\u78BC\u5C0D %@ \u6709\u6548",
            "payme.instructions.steps": "\u958B\u555F PayMe \u61C9\u7528\u7A0B\u5F0F\u3002%@\u6383\u63CF QR \u4EE3\u78BC\u6388\u6B0A\u4ED8\u6B3E\u3002%@\u5728\u61C9\u7528\u7A0B\u5F0F\u4E2D\u5B8C\u6210\u4ED8\u6B3E\u4E26\u7B49\u5F85\u78BA\u8A8D\u3002",
            "payme.instructions.footnote": "\u5B8C\u6210\u4ED8\u6B3E\u524D\uFF0C\u8ACB\u52FF\u95DC\u9589\u6B64\u9801\u9762"
        }
    });
    return function(e) {
        return P2.apply(this, arguments);
    };
});



const $891ca3d8b99e7989$var$utils = {
    addParamsToBody: (data)=>{
        return Object.fromEntries(Object.entries(data).filter(([key, value])=>value !== null));
    },
    convertToCents: (value)=>{
        return $891ca3d8b99e7989$var$utils.roundToPrecision(parseFloat(value) * 100, 0);
    },
    roundToPrecision: (num, precision)=>{
        let factor = Math.pow(10, precision);
        return Math.round(num * factor) / factor;
    }
};
var $891ca3d8b99e7989$export$2e2bcd8739ae039 = $891ca3d8b99e7989$var$utils;





const $4d933cf7e127f21f$var$api = {
    get: async (endPoint, data = {}, secure = true)=>{
        try {
            const url = (0, $e73bf42412feb220$export$2e2bcd8739ae039).apiRoot + endPoint;
            const method = "GET";
            let headers = {
                Accept: "application/json"
            };
            // if (secure === true) {
            //     headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
            // }
            const body = data;
            return await $4d933cf7e127f21f$var$request(url, method, headers, body);
        } catch (err) {
            return false;
        }
    },
    post: async (endPoint, data = {}, secure = true)=>{
        try {
            const url = (0, $e73bf42412feb220$export$2e2bcd8739ae039).apiRoot + endPoint;
            const method = "POST";
            let headers = {
                Accept: "application/json"
            };
            // if (secure === true) {
            //     headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
            // }
            const body = data;
            return await $4d933cf7e127f21f$var$request(url, method, headers, body);
        } catch (err) {
            return false;
        }
    }
};
const $4d933cf7e127f21f$var$request = async (url, method, headers, body, timeout = 5000)=>{
    try {
        let result = await (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).request({
            url: url,
            method: method,
            timeout: timeout,
            headers: headers,
            body: body
        });
        if (result.success === true) return result.data;
        else return false;
    } catch (error) {
        return false;
    }
};
var $4d933cf7e127f21f$export$2e2bcd8739ae039 = $4d933cf7e127f21f$var$api;




const $40a99fda3a39bb0c$var$paymentSession = {
    initSession: (data)=>{
        if (data.locale) (0, $e73bf42412feb220$export$2e2bcd8739ae039).locale = data.locale;
        (0, $e73bf42412feb220$export$2e2bcd8739ae039).paymentSession = {
            sessionId: data.sessionId,
            currency: data.currency,
            amount: parseFloat(data.amount),
            signature: data.signature,
            clientId: data.clientId,
            administrationId: data.administrationId,
            locationId: data.locationId,
            eventId: data.eventId,
            reference: data.reference ?? null,
            returnUrl: data.returnUrl ?? null,
            adyenStoreId: data.adyenStoreId ?? null,
            callbackUrl: data.callbackUrl ?? null
        };
    },
    loadConfig: async ()=>{
        const body = (0, $891ca3d8b99e7989$export$2e2bcd8739ae039).addParamsToBody({
            ...(0, $e73bf42412feb220$export$2e2bcd8739ae039).paymentSession,
            locale: (0, $e73bf42412feb220$export$2e2bcd8739ae039).locale
        });
        const result = await (0, $4d933cf7e127f21f$export$2e2bcd8739ae039).post("/configs", body);
        if (!result) return;
        if (result.session.open === false) {
            if ((0, $e73bf42412feb220$export$2e2bcd8739ae039).paymentSession.returnUrl) {
                window.location.href = (0, $e73bf42412feb220$export$2e2bcd8739ae039).paymentSession.returnUrl;
                return;
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).route.set("/closed");
        }
        (0, $e73bf42412feb220$export$2e2bcd8739ae039).adyen.paymentMethods = result.adyen?.paymentMethods ?? [];
        (0, $e73bf42412feb220$export$2e2bcd8739ae039).adyen.countryCodes = result.adyen?.countryCodes ?? {};
        return {
            open: result.session.open,
            status: result.session.status,
            hasPayment: result.session?.hasPayment ?? false
        };
    },
    createPayment: async (paymentMethod, adyenBrowserInfo)=>{
        const body = {
            psp: "adyen",
            adyenPaymentMethod: paymentMethod,
            adyenBrowserInfo: adyenBrowserInfo,
            session: (0, $891ca3d8b99e7989$export$2e2bcd8739ae039).addParamsToBody((0, $e73bf42412feb220$export$2e2bcd8739ae039).paymentSession),
            domain: window.location.host
        };
        const result = await (0, $4d933cf7e127f21f$export$2e2bcd8739ae039).post("/payments/sessions", body);
        if (!result) return {
            success: false
        };
        return {
            success: true,
            data: result
        };
    },
    cancelSession: async ()=>{
        const body = (0, $891ca3d8b99e7989$export$2e2bcd8739ae039).addParamsToBody((0, $e73bf42412feb220$export$2e2bcd8739ae039).paymentSession);
        const result = await (0, $4d933cf7e127f21f$export$2e2bcd8739ae039).post("/payments/sessions/cancel", body);
        if ((0, $e73bf42412feb220$export$2e2bcd8739ae039).paymentSession.returnUrl) {
            window.location.href = (0, $e73bf42412feb220$export$2e2bcd8739ae039).paymentSession.returnUrl;
            return;
        } else (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).route.set("/closed");
        return result;
    },
    getSessionDetails: async (adyenData)=>{
        const details = await (0, $4d933cf7e127f21f$export$2e2bcd8739ae039).post("/payments/sessions/details", {
            sessionId: (0, $e73bf42412feb220$export$2e2bcd8739ae039).paymentSession.sessionId,
            adyenData: adyenData
        });
        if (!details) return false;
        return {
            success: true,
            data: details.adyen
        };
    },
    showConfirmation: async ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).route.set("/confirmation", (0, $891ca3d8b99e7989$export$2e2bcd8739ae039).addParamsToBody({
            sessionId: (0, $e73bf42412feb220$export$2e2bcd8739ae039).paymentSession.sessionId,
            returnUrl: (0, $e73bf42412feb220$export$2e2bcd8739ae039).paymentSession.returnUrl
        }));
    },
    getStatus: async ()=>{
        const response = await (0, $4d933cf7e127f21f$export$2e2bcd8739ae039).get(`/payments/${(0, $e73bf42412feb220$export$2e2bcd8739ae039).paymentSession.sessionId}/status`);
        if (response.success === false || response.status === "open") return {
            success: false
        };
        return {
            success: true,
            data: response
        };
    }
};
var $40a99fda3a39bb0c$export$2e2bcd8739ae039 = $40a99fda3a39bb0c$var$paymentSession;


const $cbffc049bdfa560f$var$vwAdyenDropin = {
    dropin: null,
    config: {},
    oninit: async ()=>{
        const paymentAmount = {
            value: (0, $891ca3d8b99e7989$export$2e2bcd8739ae039).convertToCents((0, $e73bf42412feb220$export$2e2bcd8739ae039).paymentSession.amount),
            currency: (0, $e73bf42412feb220$export$2e2bcd8739ae039).paymentSession.currency
        };
        $cbffc049bdfa560f$var$vwAdyenDropin.config = {
            darkMode: true,
            paymentMethodsResponse: {
                paymentMethods: (0, $e73bf42412feb220$export$2e2bcd8739ae039).adyen.paymentMethods
            },
            clientKey: (0, $e73bf42412feb220$export$2e2bcd8739ae039).adyen.clientKey,
            locale: (0, $e73bf42412feb220$export$2e2bcd8739ae039).paymentSession.locale ?? (0, $e73bf42412feb220$export$2e2bcd8739ae039).locale,
            environment: (0, $e73bf42412feb220$export$2e2bcd8739ae039).live ? "live" : "test",
            analytics: {
                enabled: false
            },
            amount: paymentAmount,
            paymentMethodsConfiguration: {
                googlepay: {
                    environment: (0, $e73bf42412feb220$export$2e2bcd8739ae039).live ? "PRODUCTION" : "TEST",
                    countryCode: (0, $e73bf42412feb220$export$2e2bcd8739ae039).adyen.countryCodes?.googlepay ?? (0, $e73bf42412feb220$export$2e2bcd8739ae039).adyen.countryCodes.default,
                    amount: paymentAmount
                },
                applepay: {
                    amount: paymentAmount,
                    countryCode: (0, $e73bf42412feb220$export$2e2bcd8739ae039).adyen.countryCodes?.applepay ?? (0, $e73bf42412feb220$export$2e2bcd8739ae039).adyen.countryCodes.default
                }
            },
            onSubmit: async (state, dropin)=>{
                const result = await (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).createPayment(state.data.paymentMethod, state.data.browserInfo);
                if (result.success === false) {
                    await (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).validateSession();
                    $cbffc049bdfa560f$var$vwAdyenDropin.dropin.unmount();
                    $cbffc049bdfa560f$var$vwAdyenDropin.dropin.mount("#dropin-container");
                    //todo: add notification
                    alert("Failed to create payment session try again");
                    return;
                }
                if (result.data.adyen?.action) {
                    dropin.handleAction(result.data.adyen.action);
                    return;
                }
                (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).showConfirmation();
            },
            onAuthorized: async (state, dropin)=>{
                const result = await (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).getSessionDetails(state.data);
                if (result === false) await (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).validateSession();
                else if (result.data.adyen?.action) {
                    dropin.handleAction(result.data.adyen.action);
                    return;
                }
                (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).showConfirmation();
            },
            onAdditionalDetails: async (state, dropin)=>{
                const result = await (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).getSessionDetails(state.data);
                if (result === false) await (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).validateSession();
                else if (result.data.adyen?.action) {
                    dropin.handleAction(result.data.adyen.action);
                    return;
                }
                (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).showConfirmation();
            }
        };
        const checkout = await (0, (/*@__PURE__*/$parcel$interopDefault($c098f254fa0fe6fa$exports)))($cbffc049bdfa560f$var$vwAdyenDropin.config);
        $cbffc049bdfa560f$var$vwAdyenDropin.dropin = checkout.create("dropin", {
            openFirstPaymentMethod: true
        }).mount("#dropin-container");
    },
    view: ()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
            id: "dropin-container"
        });
    }
};
var $cbffc049bdfa560f$export$2e2bcd8739ae039 = $cbffc049bdfa560f$var$vwAdyenDropin;





const $ace718b76fa13897$var$Loading = (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).trust(`
  <svg aria-hidden="true" class= "loading" viewBox = "0 0 100 101" fill = "none" xmlns = "http://www.w3.org/2000/svg" >
    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
  </svg> `);
var $ace718b76fa13897$export$2e2bcd8739ae039 = $ace718b76fa13897$var$Loading;




const $af5f0afc0c815e9a$var$christmasSled = {
    name: "vwChristmasSled",
    view: ()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
            style: "display: flex; justify-content: center; align-items: center; overflow: hidden; width: 100vw; padding-bottom: 50px "
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
            class: "sleigh-santa",
            style: "display: block"
        }, [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                class: "santa santa--sleigh"
            }, [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                    class: "santa__hat"
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "santa__hat-part"
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "santa__hat-part"
                    })
                ]),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                    class: "santa__face"
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "santa__eyebrows santa__eyebrows--right"
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "santa__eyebrows santa__eyebrows--left"
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "santa__eye santa__eye--right"
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "santa__eye santa__eye--left"
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "santa__nose"
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "santa__cheek santa__cheek--right"
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "santa__cheek santa__cheek--left"
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "santa__beard"
                    }, [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                            class: "santa__beard-part"
                        }),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                            class: "santa__beard-part"
                        }),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                            class: "santa__beard-part"
                        })
                    ]),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "santa__mouth"
                    })
                ]),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                    class: "santa__body"
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "santa__body-top"
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "santa__hand santa__hand--left"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "santa__hand-inner"
                    })),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "santa__hand santa__hand--right"
                    })
                ])
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                class: "sleigh-feet"
            }),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                class: "lead"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                class: "lead-inner"
            })),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                class: "lead lead--back"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                class: "lead-inner"
            })),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                class: "reindeer"
            }, [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                    class: "reindeer__face"
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "reindeer__ear"
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "reindeer__horn reindeer__horn--right"
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "reindeer__horn reindeer__horn--left"
                    })
                ]),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                    class: "reindeer__body"
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "reindeer__foot reindeer__foot--front"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "reindeer__foot-inner"
                    })),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "reindeer__foot reindeer__foot--front reindeer__foot--inside"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "reindeer__foot-inner"
                    })),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "reindeer__foot reindeer__foot--back"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "reindeer__foot-inner"
                    })),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "reindeer__foot reindeer__foot--back reindeer__foot--inside"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "reindeer__foot-inner"
                    })),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "reindeer__tail"
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "reindeer__spots"
                    })
                ])
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                class: "particles"
            })
        ]));
    }
};
var $af5f0afc0c815e9a$export$2e2bcd8739ae039 = $af5f0afc0c815e9a$var$christmasSled;


const $31dd108a4526e49f$var$vwPaymentSession = {
    loading: true,
    config: {},
    hasPayment: false,
    requestDuplicatePaymentPermission: false,
    oninit: async ({ attrs: attrs })=>{
        // Initialize the payment session
        (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).initSession(attrs);
        // Get and load the payment session config
        const configResult = await (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).loadConfig();
        $31dd108a4526e49f$var$vwPaymentSession.hasPayment = configResult.hasPayment;
        $31dd108a4526e49f$var$vwPaymentSession.loading = false;
    },
    view: ({ attrs: attrs })=>{
        const { amount: amount, currency: currency } = attrs;
        const formatAmount = (amount)=>{
            const locale = (0, $e73bf42412feb220$export$2e2bcd8739ae039).locale.replace("_", "-");
            return Number(amount).toLocaleString(locale, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
            });
        };
        if ($31dd108a4526e49f$var$vwPaymentSession.loading) return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
            class: `container`,
            style: {
                overflow: "hidden",
                display: "grid",
                placeItems: "center"
            }
        }, [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($883ca2d90835a400$exports))).IMAGE_ECOM_PAY,
                class: "logo",
                alt: "Ecom Pay Logo",
                style: {
                    width: "6rem",
                    "object-fit": "contain"
                }
            }),
            (0, $ace718b76fa13897$export$2e2bcd8739ae039)
        ]);
        if ($31dd108a4526e49f$var$vwPaymentSession.hasPayment === true && $31dd108a4526e49f$var$vwPaymentSession.requestDuplicatePaymentPermission === false) return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
            class: "container"
        }, [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                class: "card"
            }, [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                    class: "card__upper"
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "card__upper__content"
                    }, [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("h3", "This session already has a payment."),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button", {
                            class: "btn",
                            onclick: ()=>{
                                $31dd108a4526e49f$var$vwPaymentSession.requestDuplicatePaymentPermission = true;
                            }
                        }, "Try again")
                    ])
                ]),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                    class: "card__lower"
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "card__lower__content"
                    }, [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("p", "Payment by"),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($883ca2d90835a400$exports))).IMAGE_ECOM_PAY,
                            class: "logo",
                            alt: "Ecom Pay Logo",
                            style: {
                                height: "50px",
                                "object-fit": "contain"
                            }
                        })
                    ])
                ])
            ])
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
            class: "container"
        }, [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                class: "card"
            }, [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                    class: "card__decoration"
                }, [
                    (0, $e73bf42412feb220$export$2e2bcd8739ae039).theme === (0, (/*@__PURE__*/$parcel$interopDefault($883ca2d90835a400$exports))).THEME_CHIRSTMAS ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($883ca2d90835a400$exports))).IMAGE_CHRISTMAS_GARLAND,
                        alt: "Ecom Pay Logo",
                        style: {
                            height: "60px",
                            "object-fit": "contain"
                        }
                    }) : null
                ]),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                    class: "card__upper"
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "amount-label"
                    }, "Amount to pay"),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "card__upper__title"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).trust((0, (/*@__PURE__*/$parcel$interopDefault($883ca2d90835a400$exports)))[`CURRENCY_CODE_${currency}`] + formatAmount(amount)))
                ]),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                    class: "card__lower"
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $cbffc049bdfa560f$export$2e2bcd8739ae039)),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "or-divider"
                    }, [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("span", "or")
                    ]),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button", {
                        class: "btn btn--danger ",
                        onclick: ()=>{
                            (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).cancelSession();
                        }
                    }, "Cancel Payment"),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "card__lower__content"
                    }, [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", [
                            (0, $e73bf42412feb220$export$2e2bcd8739ae039).theme === (0, (/*@__PURE__*/$parcel$interopDefault($883ca2d90835a400$exports))).THEME_CHIRSTMAS ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $af5f0afc0c815e9a$export$2e2bcd8739ae039)) : null,
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                                class: "payment-by"
                            }, [
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("span", "Payment by"),
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($883ca2d90835a400$exports))).IMAGE_ECOM_PAY,
                                    alt: "Ecom Pay Logo"
                                })
                            ])
                        ])
                    ])
                ])
            ])
        ]);
    }
};
var $31dd108a4526e49f$export$2e2bcd8739ae039 = $31dd108a4526e49f$var$vwPaymentSession;





const $0516e25c081ae7f1$var$vwAdyenConfirmation = {
    checkCount: 0,
    oninit: async ({ attrs: { redirectResult: redirectResult, sessionComplete: sessionComplete = ()=>{}, sessionPending: sessionPending = ()=>{} } })=>{
        const checkStatus = async ()=>{
            const paymentCompleteCheck = await (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).getSessionDetails({
                details: {
                    redirectResult: redirectResult
                }
            });
            if (paymentCompleteCheck.success === false || paymentCompleteCheck.data.resultCode === "Pending") {
                $0516e25c081ae7f1$var$vwAdyenConfirmation.checkCount++;
                if ($0516e25c081ae7f1$var$vwAdyenConfirmation.checkCount === 3) {
                    sessionPending();
                    return;
                }
                setTimeout(checkStatus, $0516e25c081ae7f1$var$vwAdyenConfirmation.checkCount * 5000);
            } else sessionComplete();
        };
        await checkStatus();
    },
    view: ({ attrs: { redirectResult: redirectResult, sessionComplete: sessionComplete = ()=>{} } })=>{
        return $0516e25c081ae7f1$var$vwAdyenConfirmation.checkCount == 3 ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
            class: "card__upper__content"
        }, [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("p", "Failed to load payment"),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button", {
                class: "btn",
                onclick: async ()=>{
                    const paymentCompleteCheck = await (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).getSessionDetails({
                        details: {
                            redirectResult: redirectResult
                        }
                    });
                    if (paymentCompleteCheck) sessionComplete();
                }
            }, "Refresh")
        ]) : "";
    }
};
var $0516e25c081ae7f1$export$2e2bcd8739ae039 = $0516e25c081ae7f1$var$vwAdyenConfirmation;




let $be62a30a6989b4e8$var$result;
const $be62a30a6989b4e8$var$vwEcomConfirmation = {
    oninit: async ({ attrs: { sessionId: sessionId, sessionComplete: sessionComplete = ()=>{} } })=>{
        $be62a30a6989b4e8$var$result = false;
        const checkStatus = async ()=>{
            const statusResult = await (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).getStatus(sessionId);
            if (statusResult.success == false) setTimeout(checkStatus, 2000);
            else {
                $be62a30a6989b4e8$var$result = statusResult.data.status;
                sessionComplete();
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
        };
        await checkStatus();
    },
    view: ()=>{
        return $be62a30a6989b4e8$var$result ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", $be62a30a6989b4e8$var$result) : null;
    }
};
var $be62a30a6989b4e8$export$2e2bcd8739ae039 = $be62a30a6989b4e8$var$vwEcomConfirmation;





const $e87ae94b146f439d$var$vwConfirmation = {
    loading: true,
    sessionCompleted: false,
    view: ({ attrs: { sessionId: sessionId, returnUrl: returnUrl = false, redirectResult: redirectResult = false } })=>{
        let component;
        (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).initSession({
            sessionId: sessionId
        });
        if ($e87ae94b146f439d$var$vwConfirmation.sessionCompleted === false && redirectResult) component = (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $0516e25c081ae7f1$export$2e2bcd8739ae039), {
            redirectResult: redirectResult,
            sessionComplete: ()=>{
                if (returnUrl) {
                    window.location.href = returnUrl;
                    return;
                }
                $e87ae94b146f439d$var$vwConfirmation.sessionCompleted = true;
                $e87ae94b146f439d$var$vwConfirmation.loading = false;
                (0, $40a99fda3a39bb0c$export$2e2bcd8739ae039).showConfirmation();
            },
            sessionPending: ()=>{
                $e87ae94b146f439d$var$vwConfirmation.loading = false;
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
            }
        });
        else if (returnUrl) window.location.href = returnUrl;
        else component = (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $be62a30a6989b4e8$export$2e2bcd8739ae039), {
            sessionComplete: ()=>{
                $e87ae94b146f439d$var$vwConfirmation.loading = false;
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
            }
        });
        return [
            $e87ae94b146f439d$var$vwConfirmation.loading === true ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                class: `container container--loading`
            }, [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($883ca2d90835a400$exports))).IMAGE_ECOM_PAY,
                    class: "loading__logo",
                    alt: "elockers"
                }),
                (0, $ace718b76fa13897$export$2e2bcd8739ae039)
            ]) : "",
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                class: "container",
                style: `display: ${$e87ae94b146f439d$var$vwConfirmation.loading === true ? "none" : "flex"}`
            }, [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                    class: "card"
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "card__upper"
                    }, component),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "card__lower"
                    }, [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                            class: "card__lower__content"
                        }, [
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                                class: "payment-by"
                            }, [
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("span", "Payment by"),
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($883ca2d90835a400$exports))).IMAGE_ECOM_PAY,
                                    alt: "Ecom Pay Logo"
                                })
                            ])
                        ])
                    ])
                ])
            ])
        ];
    }
};
var $e87ae94b146f439d$export$2e2bcd8739ae039 = $e87ae94b146f439d$var$vwConfirmation;





const $41c79ddda63a5424$var$vwClosed = {
    view: ()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
            class: "container"
        }, [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                class: "card"
            }, [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                    class: "card__decoration"
                }, [
                    (0, $e73bf42412feb220$export$2e2bcd8739ae039).theme === (0, (/*@__PURE__*/$parcel$interopDefault($883ca2d90835a400$exports))).THEME_CHIRSTMAS ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($883ca2d90835a400$exports))).IMAGE_CHRISTMAS_GARLAND,
                        alt: "Christmas Hat",
                        style: {
                            height: "60px",
                            "object-fit": "contain"
                        }
                    }) : (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($883ca2d90835a400$exports))).IMAGE_ECOM_PAY,
                        class: "logo",
                        alt: "Ecom Pay Logo",
                        style: {
                            height: "60px",
                            "object-fit": "contain",
                            marginTop: "20px"
                        }
                    })
                ]),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                    class: "card__upper"
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "card__upper__content"
                    }, [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("h2", "Closed"),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("p", "The payment session has been closed.")
                    ])
                ]),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                    class: "card__lower"
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                        class: "card__lower__content"
                    }, [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div", {
                            class: "payment-by"
                        }, [
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("span", "Payment by"),
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($883ca2d90835a400$exports))).IMAGE_ECOM_PAY,
                                alt: "Ecom Pay Logo"
                            })
                        ])
                    ])
                ])
            ])
        ]);
    }
};
var $41c79ddda63a5424$export$2e2bcd8739ae039 = $41c79ddda63a5424$var$vwClosed;


const $8b488dbcce1c14ef$var$routes = {
    "/": {
        render: (attrs)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $31dd108a4526e49f$export$2e2bcd8739ae039), attrs.attrs);
        }
    },
    "/confirmation": {
        render: (attrs)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $e87ae94b146f439d$export$2e2bcd8739ae039), attrs.attrs);
        }
    },
    "/closed": {
        render: ()=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $41c79ddda63a5424$export$2e2bcd8739ae039));
        }
    }
};
var $8b488dbcce1c14ef$export$2e2bcd8739ae039 = $8b488dbcce1c14ef$var$routes;



const $35da740d59af89ba$var$start = async ()=>{
    (0, $e73bf42412feb220$export$2e2bcd8739ae039).init();
    const root = document.getElementById("root");
    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).route(root, "/", (0, $8b488dbcce1c14ef$export$2e2bcd8739ae039));
};
window.addEventListener("DOMContentLoaded", $35da740d59af89ba$var$start);


//# sourceMappingURL=index.ead13b92.js.map
